(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireda9c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireda9c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iJ8Ef", function(module, exports) {

$parcel$export(module.exports, "sendMessageToServer", () => $da23234ddbad84a7$export$90097fc3fe5942fb);
$parcel$export(module.exports, "sendProjectActionToServer", () => $da23234ddbad84a7$export$b66251d5e3c6e643);
$parcel$export(module.exports, "joinProjectInServer", () => $da23234ddbad84a7$export$a2f1969cf7632225);
$parcel$export(module.exports, "subscribeToAvailableProjects", () => $da23234ddbad84a7$export$e27e67ce83bde534);

var $a1MyJ = parcelRequire("a1MyJ");

var $9xysn = parcelRequire("9xysn");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $5ICqB = parcelRequire("5ICqB");

var $9Rnnc = parcelRequire("9Rnnc");

var $bLRr9 = parcelRequire("bLRr9");

var $lsfK2 = parcelRequire("lsfK2");
const $da23234ddbad84a7$var$globalMessageThrottleTime = 150; // 150ms
// Initialize socket
const $da23234ddbad84a7$var$wsServerURL = '' // Nothing for same domain where the page is loaded
;
const $da23234ddbad84a7$var$socket = (0, $a1MyJ.io)($da23234ddbad84a7$var$wsServerURL, {
    autoConnect: false,
    reconnection: true,
    path: appPrefix + '/socket.io'
});
$da23234ddbad84a7$var$socket.on('connect', function() {
    console.debug('Connected to WS server! ID: ' + $da23234ddbad84a7$var$socket.id);
});
$da23234ddbad84a7$var$socket.on('disconnect', function(reason) {
    console.debug('Disconnected from WS server! Reason: ' + reason);
});
const $da23234ddbad84a7$export$7a2e8524c94bb976 = ()=>{
    if ((0, $9xysn.getCurrentProject)().localMode) return "local";
    return $da23234ddbad84a7$var$socket.id;
};
const $da23234ddbad84a7$var$throttledFunctionsMap = {};
const $da23234ddbad84a7$var$getThrottledFuctionKey = (name, data)=>{
    if (name !== 'project_action') // Never throttle step sequencer clock messages, midi messages, etc. Only project actions
    return undefined;
    const sliceAction = data.type.replace("project/", "");
    if (!sliceAction.toLowerCase().includes("parameter")) return undefined;
    // sometimes the parameter identifiers are with 'parameter' and other times with 'name'.
    // todo: consolidate with parameterName
    let key = sliceAction;
    key += data.payload.name + "_";
    key += data.payload.parameter + "_";
    return key;
};
const $da23234ddbad84a7$export$90097fc3fe5942fb = (name, data)=>{
    data.project_id = (0, $9xysn.getCurrentProject)().getID();
    // for messages that are not project changes (and thus not provoked by the middleware in the store)
    // where things already updated, we want to simulate that we got the message from the server, both if the project is local and
    // if the project is remote
    data.origin_socket_id = null;
    if (name !== "project_action") $da23234ddbad84a7$export$53f044030389c542(name, data);
    if (data.isLocal) return;
    if ((0, $9xysn.getCurrentProject)().localMode) return;
    // and now we actually send to the server
    data.origin_socket_id = $da23234ddbad84a7$export$7a2e8524c94bb976();
    const throttledFunctionKey = $da23234ddbad84a7$var$getThrottledFuctionKey(name, data);
    if (throttledFunctionKey === undefined) // No throttle
    $da23234ddbad84a7$var$socket.emit(name, data);
    else {
        if (!$da23234ddbad84a7$var$throttledFunctionsMap.hasOwnProperty(throttledFunctionKey)) // If no throttled function exists, create it
        $da23234ddbad84a7$var$throttledFunctionsMap[throttledFunctionKey] = (0, (/*@__PURE__*/$parcel$interopDefault($9Rnnc)))((name, data)=>$da23234ddbad84a7$var$socket.emit(name, data), $da23234ddbad84a7$var$globalMessageThrottleTime);
        // Call the throttled version of the funcion
        $da23234ddbad84a7$var$throttledFunctionsMap[throttledFunctionKey](name, data);
    }
};
const $da23234ddbad84a7$export$b66251d5e3c6e643 = (action)=>$da23234ddbad84a7$export$90097fc3fe5942fb("project_action", action);
const $da23234ddbad84a7$export$a2f1969cf7632225 = (projectID, callback)=>{
    $da23234ddbad84a7$var$socket.connect();
    $da23234ddbad84a7$var$socket.on('connect', function() {
        console.debug('Joining project', projectID);
        $da23234ddbad84a7$var$socket.emit('join_project', {
            project_id: projectID
        });
    // This will trigger set_project_data from the server
    });
    $da23234ddbad84a7$var$socket.on('set_project_data', function(data) {
        $da23234ddbad84a7$var$receivedUpdatesCounter = 0;
        callback(data);
    });
};
const $da23234ddbad84a7$var$requestProjectData = (projectID)=>{
    // This will make the server send a "set_project_data" message, therefore "joinProjectInServer" 
    // should have been called before so there is a handler
    console.debug('Requesting project data...');
    $da23234ddbad84a7$var$socket.emit('request_project_data', {
        project_id: projectID
    });
};
// Version of requestProjectData which is not going to be called more than once every 5 seconds
const $da23234ddbad84a7$var$debouncedRequestProjectData = (0, (/*@__PURE__*/$parcel$interopDefault($bLRr9)))((projectID)=>$da23234ddbad84a7$var$requestProjectData(projectID), 5000, {
    leading: true,
    trailing: false
});
const $da23234ddbad84a7$export$e27e67ce83bde534 = (callback)=>{
    $da23234ddbad84a7$var$socket.connect();
    $da23234ddbad84a7$var$socket.on('connect', function() {
        $da23234ddbad84a7$var$socket.emit('subscribe_to_available_projects', {});
    });
    $da23234ddbad84a7$var$socket.on('set_available_projects', function(data) {
        callback(data);
    });
};
// Event handlers for messages received from the server
let $da23234ddbad84a7$var$receivedUpdatesCounter = 0;
const $da23234ddbad84a7$export$53f044030389c542 = (name, data)=>{
    if (data.hasOwnProperty('update_count')) {
        // If the message is numerated, check that the update number is the expected one
        if ($da23234ddbad84a7$var$receivedUpdatesCounter === 0) $da23234ddbad84a7$var$receivedUpdatesCounter = data.update_count;
        else {
            if ($da23234ddbad84a7$var$receivedUpdatesCounter + 1 != data.update_count) {
                // We received an update with an unexpected count, state might be
                // out of sync. Request a full project update.
                console.debug('Received update with unexpected count!');
                $da23234ddbad84a7$var$debouncedRequestProjectData((0, $9xysn.getCurrentProject)().getID());
            }
            $da23234ddbad84a7$var$receivedUpdatesCounter = data.update_count;
        }
    }
    const didThisSendIt = data.origin_socket_id === $da23234ddbad84a7$export$7a2e8524c94bb976();
    if (name === 'message') console.debug(data, {
        didThisSendIt: didThisSendIt
    });
    else if (name === 'update_master_sequencer_current_step') (0, $Lbl7Y.getAudioGraphInstance)().receiveRemoteTransportCurrentStep(data.current_step);
    if (didThisSendIt) return; // we don't want to react to changes that we already sent
    // except for receiveRemoteTransportCurrentStep apparently?
    if (name === 'project_action') (0, $5ICqB.default).dispatch({
        ...data,
        isLocal: true
    });
    if (name === 'midi_event') (0, $lsfK2.midiHandler).receiveMidiEventFromServer(data.instrument_id, data.midi_event_data);
};
$da23234ddbad84a7$var$socket.on('message', function(message) {
    $da23234ddbad84a7$export$53f044030389c542('message', message);
});
$da23234ddbad84a7$var$socket.on('project_action', function(data) {
    $da23234ddbad84a7$export$53f044030389c542('project_action', data);
});
$da23234ddbad84a7$var$socket.on('midi_event', function(data) {
    $da23234ddbad84a7$export$53f044030389c542('midi_event', data);
});

});
parcelRegister("a1MyJ", function(module, exports) {

$parcel$export(module.exports, "io", () => $74cfaa375dcbd11d$export$841407ceb083bd74);

var $2cWim = parcelRequire("2cWim");

var $boUwv = parcelRequire("boUwv");

var $4Fqfl = parcelRequire("4Fqfl");

var $3rB5U = parcelRequire("3rB5U");
/**
 * Managers cache.
 */ const $74cfaa375dcbd11d$var$cache = {};
function $74cfaa375dcbd11d$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $2cWim.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $74cfaa375dcbd11d$var$cache[id] && path in $74cfaa375dcbd11d$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $boUwv.Manager)(source, opts);
    else {
        if (!$74cfaa375dcbd11d$var$cache[id]) $74cfaa375dcbd11d$var$cache[id] = new (0, $boUwv.Manager)(source, opts);
        io = $74cfaa375dcbd11d$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($74cfaa375dcbd11d$export$841407ceb083bd74, {
    Manager: $boUwv.Manager,
    Socket: $4Fqfl.Socket,
    io: $74cfaa375dcbd11d$export$841407ceb083bd74,
    connect: $74cfaa375dcbd11d$export$841407ceb083bd74
});

});
parcelRegister("2cWim", function(module, exports) {

$parcel$export(module.exports, "url", () => $19b9ebf5d418a7eb$export$128fa18b7194ef);
parcelRequire("dogT5");
var $3ouq6 = parcelRequire("3ouq6");
function $19b9ebf5d418a7eb$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $3ouq6.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("dogT5", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("jA40S")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("lHkM7")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("3ouq6")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("hLycV")).nextTick);

var $jA40S = parcelRequire("jA40S");

var $cY3W5 = parcelRequire("cY3W5");

var $2CGbU = parcelRequire("2CGbU");

var $lHkM7 = parcelRequire("lHkM7");

var $3ouq6 = parcelRequire("3ouq6");

var $hLycV = parcelRequire("hLycV");
const $9bfa9dc3bdf2a3df$export$a51d6b395ff4c65a = (0, $jA40S.Socket).protocol;

});
parcelRegister("jA40S", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $e4147e052f16e9bd$export$4798917dbf149b79);

var $2CGbU = parcelRequire("2CGbU");

var $lHkM7 = parcelRequire("lHkM7");

var $2LY0G = parcelRequire("2LY0G");

var $3ouq6 = parcelRequire("3ouq6");

var $kyZqU = parcelRequire("kyZqU");

var $6FTwX = parcelRequire("6FTwX");

var $hLycV = parcelRequire("hLycV");
class $e4147e052f16e9bd$export$4798917dbf149b79 extends (0, $kyZqU.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $hLycV.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $3ouq6.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $3ouq6.parse)(opts.host).host;
        (0, $lHkM7.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2LY0G.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $6FTwX.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $2CGbU.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $e4147e052f16e9bd$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $e4147e052f16e9bd$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $e4147e052f16e9bd$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $e4147e052f16e9bd$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $lHkM7.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $e4147e052f16e9bd$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$e4147e052f16e9bd$export$4798917dbf149b79.protocol = (0, $6FTwX.protocol);

});
parcelRegister("2CGbU", function(module, exports) {

$parcel$export(module.exports, "transports", () => $1e8fdbaba1cca440$export$46dec00755c1153b);

var $kBJ0d = parcelRequire("kBJ0d");

var $2qC3h = parcelRequire("2qC3h");

var $1Jh1T = parcelRequire("1Jh1T");
const $1e8fdbaba1cca440$export$46dec00755c1153b = {
    websocket: (0, $2qC3h.WS),
    webtransport: (0, $1Jh1T.WT),
    polling: (0, $kBJ0d.Polling)
};

});
parcelRegister("kBJ0d", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $f00a2be7170d46e1$export$265ee5eefd4c309b);

var $cY3W5 = parcelRequire("cY3W5");

var $faNAL = parcelRequire("faNAL");

var $6FTwX = parcelRequire("6FTwX");

var $1fCKK = parcelRequire("1fCKK");

var $kyZqU = parcelRequire("kyZqU");

var $lHkM7 = parcelRequire("lHkM7");

var $3ayXT = parcelRequire("3ayXT");
function $f00a2be7170d46e1$var$empty() {}
const $f00a2be7170d46e1$var$hasXHR2 = function() {
    const xhr = new (0, $1fCKK.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $f00a2be7170d46e1$export$265ee5eefd4c309b extends (0, $cY3W5.Transport) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $f00a2be7170d46e1$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $1fCKK.createCookieJar)();
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $6FTwX.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $6FTwX.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $faNAL.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $f00a2be7170d46e1$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $f00a2be7170d46e1$export$7fa6c5b6f8193917 extends (0, $kyZqU.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $lHkM7.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $lHkM7.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $1fCKK.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $f00a2be7170d46e1$export$7fa6c5b6f8193917.requestsCount++;
            $f00a2be7170d46e1$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $f00a2be7170d46e1$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $f00a2be7170d46e1$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
$f00a2be7170d46e1$export$7fa6c5b6f8193917.requestsCount = 0;
$f00a2be7170d46e1$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $f00a2be7170d46e1$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $3ayXT.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $f00a2be7170d46e1$var$unloadHandler, false);
    }
}
function $f00a2be7170d46e1$var$unloadHandler() {
    for(let i in $f00a2be7170d46e1$export$7fa6c5b6f8193917.requests)if ($f00a2be7170d46e1$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $f00a2be7170d46e1$export$7fa6c5b6f8193917.requests[i].abort();
}

});
parcelRegister("cY3W5", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $970e2439289df85f$export$86495b081fef8e52);
parcelRequire("6FTwX");
var $aGAdY = parcelRequire("aGAdY");

var $kyZqU = parcelRequire("kyZqU");

var $lHkM7 = parcelRequire("lHkM7");

var $2LY0G = parcelRequire("2LY0G");
class $970e2439289df85f$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $970e2439289df85f$export$86495b081fef8e52 extends (0, $kyZqU.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $lHkM7.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $970e2439289df85f$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $aGAdY.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2LY0G.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("6FTwX", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $4dc1a5a6e008a7e7$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $4dc1a5a6e008a7e7$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $4dc1a5a6e008a7e7$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $4dc1a5a6e008a7e7$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $4dc1a5a6e008a7e7$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("7oczN")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("aGAdY")).decodePacket);

var $7oczN = parcelRequire("7oczN");

var $aGAdY = parcelRequire("aGAdY");

var $aDSJ2 = parcelRequire("aDSJ2");
const $4dc1a5a6e008a7e7$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $4dc1a5a6e008a7e7$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $7oczN.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($4dc1a5a6e008a7e7$var$SEPARATOR));
        });
    });
};
const $4dc1a5a6e008a7e7$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($4dc1a5a6e008a7e7$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $aGAdY.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $4dc1a5a6e008a7e7$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $7oczN.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $4dc1a5a6e008a7e7$var$TEXT_DECODER;
function $4dc1a5a6e008a7e7$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $4dc1a5a6e008a7e7$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $4dc1a5a6e008a7e7$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$4dc1a5a6e008a7e7$var$TEXT_DECODER) $4dc1a5a6e008a7e7$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($4dc1a5a6e008a7e7$var$totalLength(chunks) < 1) break;
                    const header = $4dc1a5a6e008a7e7$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($4dc1a5a6e008a7e7$var$totalLength(chunks) < 2) break;
                    const headerArray = $4dc1a5a6e008a7e7$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($4dc1a5a6e008a7e7$var$totalLength(chunks) < 8) break;
                    const headerArray = $4dc1a5a6e008a7e7$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $aDSJ2.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($4dc1a5a6e008a7e7$var$totalLength(chunks) < expectedLength) break;
                    const data = $4dc1a5a6e008a7e7$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $aGAdY.decodePacket)(isBinary ? data : $4dc1a5a6e008a7e7$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $aDSJ2.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $4dc1a5a6e008a7e7$export$a51d6b395ff4c65a = 4;

});
parcelRegister("7oczN", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $561487b8227635b6$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $561487b8227635b6$export$ec0c9b9013ee0ef5);

var $aDSJ2 = parcelRequire("aDSJ2");
const $561487b8227635b6$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $561487b8227635b6$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $561487b8227635b6$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $561487b8227635b6$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($561487b8227635b6$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $561487b8227635b6$var$encodeBlobAsBase64(data, callback);
    } else if ($561487b8227635b6$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $561487b8227635b6$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $561487b8227635b6$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $aDSJ2.PACKET_TYPES)[type] + (data || ""));
};
const $561487b8227635b6$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $561487b8227635b6$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $561487b8227635b6$var$TEXT_ENCODER;
function $561487b8227635b6$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($561487b8227635b6$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($561487b8227635b6$var$toArray).then(callback);
    else if ($561487b8227635b6$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $561487b8227635b6$var$isView(packet.data))) return callback($561487b8227635b6$var$toArray(packet.data));
    $561487b8227635b6$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$561487b8227635b6$var$TEXT_ENCODER) $561487b8227635b6$var$TEXT_ENCODER = new TextEncoder();
        callback($561487b8227635b6$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("aDSJ2", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $7bf7ff34ad415631$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $7bf7ff34ad415631$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $7bf7ff34ad415631$export$c718b5840781f8a7);
const $7bf7ff34ad415631$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$7bf7ff34ad415631$export$c169aefb7330cccb["open"] = "0";
$7bf7ff34ad415631$export$c169aefb7330cccb["close"] = "1";
$7bf7ff34ad415631$export$c169aefb7330cccb["ping"] = "2";
$7bf7ff34ad415631$export$c169aefb7330cccb["pong"] = "3";
$7bf7ff34ad415631$export$c169aefb7330cccb["message"] = "4";
$7bf7ff34ad415631$export$c169aefb7330cccb["upgrade"] = "5";
$7bf7ff34ad415631$export$c169aefb7330cccb["noop"] = "6";
const $7bf7ff34ad415631$export$47791e8004edd485 = Object.create(null);
Object.keys($7bf7ff34ad415631$export$c169aefb7330cccb).forEach((key)=>{
    $7bf7ff34ad415631$export$47791e8004edd485[$7bf7ff34ad415631$export$c169aefb7330cccb[key]] = key;
});
const $7bf7ff34ad415631$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("aGAdY", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $7c79ed06fd95f9ff$export$4647901878f33f31);

var $aDSJ2 = parcelRequire("aDSJ2");

var $bHtfc = parcelRequire("bHtfc");
const $7c79ed06fd95f9ff$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $7c79ed06fd95f9ff$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $7c79ed06fd95f9ff$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $7c79ed06fd95f9ff$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $aDSJ2.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $aDSJ2.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $aDSJ2.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $aDSJ2.PACKET_TYPES_REVERSE)[type]
    };
};
const $7c79ed06fd95f9ff$var$decodeBase64Packet = (data, binaryType)=>{
    if ($7c79ed06fd95f9ff$var$withNativeArrayBuffer) {
        const decoded = (0, $bHtfc.decode)(data);
        return $7c79ed06fd95f9ff$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $7c79ed06fd95f9ff$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("bHtfc", function(module, exports) {

$parcel$export(module.exports, "decode", () => $884a652736e4e341$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $884a652736e4e341$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $884a652736e4e341$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $884a652736e4e341$var$chars.length; i++)$884a652736e4e341$var$lookup[$884a652736e4e341$var$chars.charCodeAt(i)] = i;
const $884a652736e4e341$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $884a652736e4e341$var$chars[bytes[i] >> 2];
        base64 += $884a652736e4e341$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $884a652736e4e341$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $884a652736e4e341$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $884a652736e4e341$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $884a652736e4e341$var$lookup[base64.charCodeAt(i)];
        encoded2 = $884a652736e4e341$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $884a652736e4e341$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $884a652736e4e341$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("kyZqU", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $457c1af18044583a$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $457c1af18044583a$export$4293555f241ae35a(obj) {
    if (obj) return $457c1af18044583a$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $457c1af18044583a$var$mixin(obj) {
    for(var key in $457c1af18044583a$export$4293555f241ae35a.prototype)obj[key] = $457c1af18044583a$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.on = $457c1af18044583a$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.off = $457c1af18044583a$export$4293555f241ae35a.prototype.removeListener = $457c1af18044583a$export$4293555f241ae35a.prototype.removeAllListeners = $457c1af18044583a$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$457c1af18044583a$export$4293555f241ae35a.prototype.emitReserved = $457c1af18044583a$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $457c1af18044583a$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("lHkM7", function(module, exports) {

$parcel$export(module.exports, "pick", () => $fcbdbaa3cd961e27$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $fcbdbaa3cd961e27$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $fcbdbaa3cd961e27$export$a48f0734ac7c2329);

var $3ayXT = parcelRequire("3ayXT");
function $fcbdbaa3cd961e27$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $fcbdbaa3cd961e27$var$NATIVE_SET_TIMEOUT = (0, $3ayXT.globalThisShim).setTimeout;
const $fcbdbaa3cd961e27$var$NATIVE_CLEAR_TIMEOUT = (0, $3ayXT.globalThisShim).clearTimeout;
function $fcbdbaa3cd961e27$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $fcbdbaa3cd961e27$var$NATIVE_SET_TIMEOUT.bind((0, $3ayXT.globalThisShim));
        obj.clearTimeoutFn = $fcbdbaa3cd961e27$var$NATIVE_CLEAR_TIMEOUT.bind((0, $3ayXT.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $3ayXT.globalThisShim).setTimeout.bind((0, $3ayXT.globalThisShim));
        obj.clearTimeoutFn = (0, $3ayXT.globalThisShim).clearTimeout.bind((0, $3ayXT.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $fcbdbaa3cd961e27$var$BASE64_OVERHEAD = 1.33;
function $fcbdbaa3cd961e27$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $fcbdbaa3cd961e27$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $fcbdbaa3cd961e27$var$BASE64_OVERHEAD);
}
function $fcbdbaa3cd961e27$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

});
parcelRegister("3ayXT", function(module, exports) {

$parcel$export(module.exports, "globalThisShim", () => $24ed6d94f3b59450$export$394f9358f6231289);
const $24ed6d94f3b59450$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();

});


parcelRegister("2LY0G", function(module, exports) {

$parcel$export(module.exports, "encode", () => $204e8548e3057537$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $204e8548e3057537$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $204e8548e3057537$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $204e8548e3057537$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});


parcelRegister("faNAL", function(module, exports) {

$parcel$export(module.exports, "yeast", () => $b0be4220a43aac53$export$5bb64b92cb4135a);
// imported from https://github.com/unshiftio/yeast
'use strict';
const $b0be4220a43aac53$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $b0be4220a43aac53$var$length = 64, $b0be4220a43aac53$var$map = {};
let $b0be4220a43aac53$var$seed = 0, $b0be4220a43aac53$var$i = 0, $b0be4220a43aac53$var$prev;
function $b0be4220a43aac53$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $b0be4220a43aac53$var$alphabet[num % $b0be4220a43aac53$var$length] + encoded;
        num = Math.floor(num / $b0be4220a43aac53$var$length);
    }while (num > 0);
    return encoded;
}
function $b0be4220a43aac53$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($b0be4220a43aac53$var$i = 0; $b0be4220a43aac53$var$i < str.length; $b0be4220a43aac53$var$i++)decoded = decoded * $b0be4220a43aac53$var$length + $b0be4220a43aac53$var$map[str.charAt($b0be4220a43aac53$var$i)];
    return decoded;
}
function $b0be4220a43aac53$export$5bb64b92cb4135a() {
    const now = $b0be4220a43aac53$export$c564cdbbe6da493(+new Date());
    if (now !== $b0be4220a43aac53$var$prev) return $b0be4220a43aac53$var$seed = 0, $b0be4220a43aac53$var$prev = now;
    return now + '.' + $b0be4220a43aac53$export$c564cdbbe6da493($b0be4220a43aac53$var$seed++);
}
//
// Map each character to its index.
//
for(; $b0be4220a43aac53$var$i < $b0be4220a43aac53$var$length; $b0be4220a43aac53$var$i++)$b0be4220a43aac53$var$map[$b0be4220a43aac53$var$alphabet[$b0be4220a43aac53$var$i]] = $b0be4220a43aac53$var$i;

});

parcelRegister("1fCKK", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $0e9540b6c40bc56b$export$a2d42eb087c10497);
$parcel$export(module.exports, "createCookieJar", () => $0e9540b6c40bc56b$export$19413efcf2fac759);
// browser shim for xmlhttprequest module

var $i1bma = parcelRequire("i1bma");

var $3ayXT = parcelRequire("3ayXT");
function $0e9540b6c40bc56b$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $i1bma.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $3ayXT.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $0e9540b6c40bc56b$export$19413efcf2fac759() {}

});
parcelRegister("i1bma", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $d1e121273de60dfc$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $d1e121273de60dfc$var$value = false;
try {
    $d1e121273de60dfc$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $d1e121273de60dfc$export$5235bbd4a1ef06e = $d1e121273de60dfc$var$value;

});



parcelRegister("2qC3h", function(module, exports) {

$parcel$export(module.exports, "WS", () => $1c4b86cb67229007$export$911baa0677ac404c);

var $cY3W5 = parcelRequire("cY3W5");

var $faNAL = parcelRequire("faNAL");

var $lHkM7 = parcelRequire("lHkM7");

var $hLycV = parcelRequire("hLycV");
parcelRequire("6FTwX");
var $7oczN = parcelRequire("7oczN");

var $N0o3H = parcelRequire("N0o3H");
var $1c4b86cb67229007$require$Buffer = $N0o3H.Buffer;
// detect ReactNative environment
const $1c4b86cb67229007$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $1c4b86cb67229007$export$911baa0677ac404c extends (0, $cY3W5.Transport) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $1c4b86cb67229007$var$isReactNative ? {} : (0, $lHkM7.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $hLycV.usingBrowserWebSocket) && !$1c4b86cb67229007$var$isReactNative ? protocols ? new (0, $hLycV.WebSocket)(uri, protocols) : new (0, $hLycV.WebSocket)(uri) : new (0, $hLycV.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $7oczN.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $hLycV.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $1c4b86cb67229007$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $hLycV.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $hLycV.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $faNAL.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $hLycV.WebSocket);
    }
}

});
parcelRegister("hLycV", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $cef15c53d6c0c24e$export$bdd553fddd433dcb);
$parcel$export(module.exports, "WebSocket", () => $cef15c53d6c0c24e$export$3909fb301d3dc8c9);
$parcel$export(module.exports, "usingBrowserWebSocket", () => $cef15c53d6c0c24e$export$3407ba5dfb7a683d);
$parcel$export(module.exports, "defaultBinaryType", () => $cef15c53d6c0c24e$export$790dcbc41e2d75d5);

var $3ayXT = parcelRequire("3ayXT");
const $cef15c53d6c0c24e$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $cef15c53d6c0c24e$export$3909fb301d3dc8c9 = (0, $3ayXT.globalThisShim).WebSocket || (0, $3ayXT.globalThisShim).MozWebSocket;
const $cef15c53d6c0c24e$export$3407ba5dfb7a683d = true;
const $cef15c53d6c0c24e$export$790dcbc41e2d75d5 = "arraybuffer";

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("1Jh1T", function(module, exports) {

$parcel$export(module.exports, "WT", () => $1427341a4db03b46$export$961c930859384407);

var $cY3W5 = parcelRequire("cY3W5");

var $hLycV = parcelRequire("hLycV");

var $6FTwX = parcelRequire("6FTwX");
class $1427341a4db03b46$export$961c930859384407 extends (0, $cY3W5.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $6FTwX.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $6FTwX.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $hLycV.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("3ouq6", function(module, exports) {

$parcel$export(module.exports, "parse", () => $278b35c341751f73$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $278b35c341751f73$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $278b35c341751f73$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $278b35c341751f73$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $278b35c341751f73$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$278b35c341751f73$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $278b35c341751f73$var$pathNames(uri, uri['path']);
    uri.queryKey = $278b35c341751f73$var$queryKey(uri, uri['query']);
    return uri;
}
function $278b35c341751f73$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $278b35c341751f73$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});




parcelRegister("boUwv", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $84cdc7ed694072f2$export$d0d38e7dec7a1a61);
parcelRequire("dogT5");
var $lHkM7 = parcelRequire("lHkM7");
var $hLycV = parcelRequire("hLycV");
var $jA40S = parcelRequire("jA40S");

var $4Fqfl = parcelRequire("4Fqfl");

var $3rB5U = parcelRequire("3rB5U");

var $jJTe7 = parcelRequire("jJTe7");

var $RmU0w = parcelRequire("RmU0w");

var $kyZqU = parcelRequire("kyZqU");
class $84cdc7ed694072f2$export$d0d38e7dec7a1a61 extends (0, $kyZqU.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $lHkM7.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $RmU0w.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $3rB5U;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $jA40S.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $jJTe7.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $jJTe7.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $jJTe7.on)(socket, "ping", this.onping.bind(this)), (0, $jJTe7.on)(socket, "data", this.ondata.bind(this)), (0, $jJTe7.on)(socket, "error", this.onerror.bind(this)), (0, $jJTe7.on)(socket, "close", this.onclose.bind(this)), (0, $jJTe7.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $hLycV.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $4Fqfl.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("4Fqfl", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $365f59c6fb02b648$export$4798917dbf149b79);

var $3rB5U = parcelRequire("3rB5U");

var $jJTe7 = parcelRequire("jJTe7");

var $kyZqU = parcelRequire("kyZqU");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $365f59c6fb02b648$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $365f59c6fb02b648$export$4798917dbf149b79 extends (0, $kyZqU.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $jJTe7.on)(io, "open", this.onopen.bind(this)),
            (0, $jJTe7.on)(io, "packet", this.onpacket.bind(this)),
            (0, $jJTe7.on)(io, "error", this.onerror.bind(this)),
            (0, $jJTe7.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($365f59c6fb02b648$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $3rB5U.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $3rB5U.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $3rB5U.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $3rB5U.PacketType).EVENT:
            case (0, $3rB5U.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $3rB5U.PacketType).ACK:
            case (0, $3rB5U.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $3rB5U.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $3rB5U.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $3rB5U.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $3rB5U.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("3rB5U", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $2820aaddc1388453$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $2820aaddc1388453$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $2820aaddc1388453$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $2820aaddc1388453$export$f9de6ca0bc043724);

var $kyZqU = parcelRequire("kyZqU");

var $l43mz = parcelRequire("l43mz");

var $bxb6x = parcelRequire("bxb6x");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $2820aaddc1388453$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $2820aaddc1388453$export$a51d6b395ff4c65a = 5;
var $2820aaddc1388453$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($2820aaddc1388453$export$84d4095e16c6fc19 || ($2820aaddc1388453$export$84d4095e16c6fc19 = {}));
class $2820aaddc1388453$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $2820aaddc1388453$export$84d4095e16c6fc19.EVENT || obj.type === $2820aaddc1388453$export$84d4095e16c6fc19.ACK) {
            if ((0, $bxb6x.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $2820aaddc1388453$export$84d4095e16c6fc19.EVENT ? $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_EVENT : $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $l43mz.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $2820aaddc1388453$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $2820aaddc1388453$export$f9de6ca0bc043724 extends (0, $kyZqU.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $2820aaddc1388453$export$84d4095e16c6fc19.EVENT : $2820aaddc1388453$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $2820aaddc1388453$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $bxb6x.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($2820aaddc1388453$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($2820aaddc1388453$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $2820aaddc1388453$export$84d4095e16c6fc19.CONNECT:
                return $2820aaddc1388453$var$isObject(payload);
            case $2820aaddc1388453$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $2820aaddc1388453$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $2820aaddc1388453$var$isObject(payload);
            case $2820aaddc1388453$export$84d4095e16c6fc19.EVENT:
            case $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $2820aaddc1388453$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $2820aaddc1388453$export$84d4095e16c6fc19.ACK:
            case $2820aaddc1388453$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $2820aaddc1388453$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $l43mz.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("l43mz", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $f55c94805f898ea3$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $f55c94805f898ea3$export$a00da3b1ec037a04);

var $bxb6x = parcelRequire("bxb6x");
function $f55c94805f898ea3$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $f55c94805f898ea3$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $f55c94805f898ea3$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $bxb6x.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $f55c94805f898ea3$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $f55c94805f898ea3$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $f55c94805f898ea3$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $f55c94805f898ea3$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $f55c94805f898ea3$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $f55c94805f898ea3$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $f55c94805f898ea3$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("bxb6x", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $865b63e01200baa4$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $865b63e01200baa4$export$5234c529abdb5610);
const $865b63e01200baa4$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $865b63e01200baa4$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $865b63e01200baa4$var$toString = Object.prototype.toString;
const $865b63e01200baa4$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $865b63e01200baa4$var$toString.call(Blob) === "[object BlobConstructor]";
const $865b63e01200baa4$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $865b63e01200baa4$var$toString.call(File) === "[object FileConstructor]";
function $865b63e01200baa4$export$37488ff1135b1696(obj) {
    return $865b63e01200baa4$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $865b63e01200baa4$var$isView(obj)) || $865b63e01200baa4$var$withNativeBlob && obj instanceof Blob || $865b63e01200baa4$var$withNativeFile && obj instanceof File;
}
function $865b63e01200baa4$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($865b63e01200baa4$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($865b63e01200baa4$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $865b63e01200baa4$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $865b63e01200baa4$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("jJTe7", function(module, exports) {

$parcel$export(module.exports, "on", () => $e5ed0f2d13e2ffa5$export$af631764ddc44097);
function $e5ed0f2d13e2ffa5$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("RmU0w", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $0a06b747f4081c6f$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $0a06b747f4081c6f$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $0a06b747f4081c6f$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $0a06b747f4081c6f$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $0a06b747f4081c6f$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $0a06b747f4081c6f$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $0a06b747f4081c6f$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("9xysn", function(module, exports) {

$parcel$export(module.exports, "getCurrentProject", () => $6f21ec7bc689900b$export$e1bf094f1cd3bec8);
$parcel$export(module.exports, "setCurrentProject", () => $6f21ec7bc689900b$export$840216be79ec098f);
$parcel$export(module.exports, "instrumentsDisponibles", () => $6f21ec7bc689900b$export$588cd0790237f04);
$parcel$export(module.exports, "getTipusInstrumentsDisponiblesList", () => $6f21ec7bc689900b$export$12c26af8e05c9180);
$parcel$export(module.exports, "registerInstrumentDisponible", () => $6f21ec7bc689900b$export$bde31987863b15c2);
$parcel$export(module.exports, "shouldSaveProjectAfterLoad", () => $6f21ec7bc689900b$export$3d4e70c1fe0f75db);
$parcel$export(module.exports, "isLocalMode", () => $6f21ec7bc689900b$export$6b4717b1bea1ea38);
$parcel$export(module.exports, "Project", () => $6f21ec7bc689900b$export$b6032183171af19f);

var $iJ8Ef = parcelRequire("iJ8Ef");
parcelRequire("Lbl7Y");

var $5ICqB = parcelRequire("5ICqB");

var $enQqi = parcelRequire("enQqi");

var $95CQM = parcelRequire("95CQM");
var $6f21ec7bc689900b$var$currentProject = undefined;
const $6f21ec7bc689900b$export$e1bf094f1cd3bec8 = ()=>{
    return $6f21ec7bc689900b$var$currentProject;
};
const $6f21ec7bc689900b$export$840216be79ec098f = (project)=>{
    $6f21ec7bc689900b$var$currentProject = project;
};
const $6f21ec7bc689900b$export$588cd0790237f04 = {};
const $6f21ec7bc689900b$export$12c26af8e05c9180 = ()=>{
    const tipusDisponobles = Object.keys($6f21ec7bc689900b$export$588cd0790237f04);
    // Sort by the display name of the instrument
    tipusDisponobles.sort((a, b)=>{
        const nomA = $6f21ec7bc689900b$export$588cd0790237f04[a].metadata.tipusDisplay;
        const nomB = $6f21ec7bc689900b$export$588cd0790237f04[b].metadata.tipusDisplay;
        return nomA.localeCompare(nomB);
    });
    return tipusDisponobles;
};
const $6f21ec7bc689900b$export$bde31987863b15c2 = (instrumentClass)=>{
    const tipusInstrument = instrumentClass.metadata.tipus;
    $6f21ec7bc689900b$export$588cd0790237f04[tipusInstrument] = instrumentClass;
};
let $6f21ec7bc689900b$var$saveProjectAfterLoad = false;
const $6f21ec7bc689900b$export$3d4e70c1fe0f75db = ()=>{
    return $6f21ec7bc689900b$var$saveProjectAfterLoad;
};
const $6f21ec7bc689900b$export$6b4717b1bea1ea38 = ()=>{
    return $6f21ec7bc689900b$var$localMode;
};
let $6f21ec7bc689900b$var$localMode = false;
class $6f21ec7bc689900b$export$b6032183171af19f {
    constructor(data, local = false, token){
        $6f21ec7bc689900b$var$localMode = local;
        this.saveToServerEnabled = true;
        this.adminMode = false;
        if (token !== undefined) this.adminMode = token === data.token;
        this.continuousControlThrottleTime = 50 // This is mostly for the UI, we also throttle parameter change messages being sent to the server in the server coms file
        ;
        // Crea objectes per cada instrument i guardal's al projecte. todo: no
        this.instruments = {};
        Object.entries(data.instruments).forEach(([instrumentID, instrumentData])=>this.afegeixInstrument(instrumentID, instrumentData));
    }
    get state() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectProject));
    }
    getID() {
        return this.state.metadata.id;
    }
    getNom() {
        return this.state.metadata.name;
    }
    getConnectedUsers() {
        return this.state.metadata.connected_users;
    }
    // todo: ?
    getInstrument(instrumentID) {
        return this.instruments[instrumentID];
    }
    // state logic and audio are not separated enough. clunky workaround
    makeDummyInstrument(instrumentID) {
        const tipus = (0, $95CQM.staticSelect)((0, $5ICqB.selectInstruments))[instrumentID].tipus;
        return new $6f21ec7bc689900b$export$588cd0790237f04[tipus](instrumentID);
    }
    // todo: ?
    getInstrumentsOfType(instrumentType) {
        return Object.values(this.instruments).filter((instrument)=>instrument.metadata.tipus === instrumentType);
    }
    saveDataInServer() {
        (0, $iJ8Ef.sendMessageToServer)('save_project_data', {
            project_data: (0, $enQqi.getProjectDataObject)()
        });
    }
    saveDataInServerUsingPostRequest(callback) {
        // In local mode we don't have an active web sockets connection, therefore to save the project we can use a post request
        const url = appPrefix + '/save_project_data';
        fetch(url, {
            method: "POST",
            body: JSON.stringify({
                project_id: this.getID(),
                project_data: (0, $enQqi.getProjectDataObject)()
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            callback(data);
        }).catch((error)=>{
            console.error(error);
        });
    }
    // todo: ?
    async afegeixInstrument(instrumentID, instrumentState) {
        // Crea l'objecte de l'instrument i l'afegeix al projecte
        const InstrumentClass = $6f21ec7bc689900b$export$588cd0790237f04[instrumentState.tipus];
        this.instruments[instrumentID] = new InstrumentClass(instrumentID);
    }
    // todo: ?
    eliminaInstrument(instrumentID) {
        delete this.instruments[instrumentID];
    }
    updateMetadata(name, value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.updateMetadata)({
            name: name,
            value: value
        }));
    }
}

});
parcelRegister("Lbl7Y", function(module, exports) {

$parcel$export(module.exports, "getAudioGraphInstance", () => $08dd2fbe37cead66$export$7c8985e4a2357236);

var $56MRX = parcelRequire("56MRX");
var $g8ux3 = parcelRequire("g8ux3");
var $1Uvh8 = parcelRequire("1Uvh8");
var $iilfj = parcelRequire("iilfj");
var $kCoIg = parcelRequire("kCoIg");

var $9xysn = parcelRequire("9xysn");

var $lsfK2 = parcelRequire("lsfK2");

var $5ICqB = parcelRequire("5ICqB");

var $1qR2T = parcelRequire("1qR2T");
parcelRequire("5vTj9");

var $duZNX = parcelRequire("duZNX");

var $29BVo = parcelRequire("29BVo");

var $lejHD = parcelRequire("lejHD");

var $enQqi = parcelRequire("enQqi");

var $SPbsj = parcelRequire("SPbsj");

var $95CQM = parcelRequire("95CQM");
parcelRequire("abvlt");

var $kxUqn = parcelRequire("kxUqn");
class $08dd2fbe37cead66$var$PatchedAudioWorkletNode extends (0, $kxUqn.AudioWorkletNode) {
    get parameters() {
        return super.parameters._map;
    }
}
window.AudioWorkletNode = $08dd2fbe37cead66$var$PatchedAudioWorkletNode;
window.GainNode = (0, $kxUqn.GainNode);
const $08dd2fbe37cead66$export$7c8985e4a2357236 = ()=>{
    return $08dd2fbe37cead66$var$audioGraph;
};
const $08dd2fbe37cead66$var$createRecorderNode = async ()=>{
    await $1Uvh8.getContext().addAudioWorkletModule(appPrefix + "/static/dist/worklets/recorder.js");
    const node = $1Uvh8.getContext().createAudioWorkletNode('recorder-worklet');
    node.port.onmessage = (evt)=>{
        console.debug("Received recording of duration", evt.data.recordingLength);
        const audioBlob = new Blob([
            evt.data.dataView
        ], {
            type: 'audio/wav'
        });
        const url = URL.createObjectURL(audioBlob);
        const anchor = document.createElement("a");
        anchor.download = (0, $enQqi.downloadedAudioRecordingFilename)();
        anchor.href = url;
        anchor.click();
    };
    node.startRecording = ()=>{
        node.port.postMessage({
            eventType: 'startRecording'
        });
    };
    node.stopRecording = ()=>{
        node.port.postMessage({
            eventType: 'stopRecording',
            sampleRate: $1Uvh8.getContext().sampleRate
        });
    };
    return node;
};
class $08dd2fbe37cead66$export$9c3d1c13578c940f {
    constructor(){
        this.remoteTransportCurrentStep = -1; // Aquest parametre no el posem a l'store perquè no volem que es propagui a la UI
        this.returns = {};
        $1Uvh8.getContext().dispose();
        $1Uvh8.getContext().rawContext.close(); // close the initial audio context that tone creates
        this.wamHostGroupIds = {};
    }
    get parametersDescription() {
        return {
            ...(0, $5ICqB.PROJECT_PARAMS_DESCRIPTION),
            ...(0, $5ICqB.AUDIO_PARAMS_DESCRIPTION)
        };
    }
    getParameterDescription(parameterName) {
        return this.parametersDescription[parameterName];
    }
    setParameterValue(nomParametre, valor) {
        const methodName = `set${nomParametre.charAt(0).toUpperCase() + nomParametre.slice(1)}`;
        this[methodName](valor);
    }
    usesAudioEngine() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectUsesAudioEngine));
    }
    async turnAudioOn() {
        await this.startAudioContext();
        if (!this.isGraphBuilt()) await this.buildAudioGraph();
    }
    turnAudioOff() {
        if (this.isGraphBuilt()) this.disposeGraph();
        this.clearWamHostGroupIds();
        if ($1Uvh8.getContext().rawContext.state !== "closed") {
            $1Uvh8.getContext().dispose();
            $1Uvh8.getContext().rawContext.close();
        }
    }
    restartAudio() {
        this.turnAudioOff();
        this.turnAudioOn();
    }
    disposeGraph() {
        console.info("Disposing audio graph");
        this.#setIsGraphBuilt(false);
        this.masterChannel.dispose();
        this.metronome.dispose();
        this.mainSequencer.dispose();
        Object.values(this.returns).forEach((returnNode)=>returnNode.dispose());
        (0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs)).forEach((instrumentID)=>this.removeInstrumentFromAudioGraph(instrumentID));
    }
    isPlaying() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectIsPlaying));
    }
    isRecording() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectIsRecordingProject));
    }
    setIsRecording(value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: 'isRecordingProject',
            value: value
        }));
    }
    isRecordArmed() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectIsRecordArmed));
    }
    setIsRecordArmed(value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: 'isRecordArmed',
            value: value
        }));
    }
    startRecordingProject() {
        if (!this.isGraphBuilt()) return;
        if (this.isRecording()) return;
        if (this.isRecordArmed()) return;
        if (this.isPlaying()) {
            this.projectRecorderNode.startRecording();
            this.setIsRecording(true);
        } else this.setIsRecordArmed(true);
    }
    stopRecordingProject() {
        if (!this.isGraphBuilt()) return;
        if (!this.isRecording()) return;
        this.projectRecorderNode.stopRecording();
        this.setIsRecording(false);
        this.setIsRecordArmed(false);
    }
    getMasterSpectrumSize() {
        if (!this.masterChannel) return undefined;
        return this.masterChannel.spectrumSize;
    }
    getMasterSpectrumData() {
        if (!this.masterChannel) return undefined;
        return this.masterChannel.spectrumData;
    }
    getBpm() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectBpm));
    }
    applyBpm(bpm) {
        if (!this.isGraphBuilt()) return;
        $56MRX.getTransport().bpm.rampTo(bpm);
    }
    getSwing() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectSwing));
    }
    getCompas() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectCompas));
    }
    getTonality() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectTonality));
    }
    isGraphBuilt() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectIsGraphBuilt));
    }
    #setIsGraphBuilt(value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setAudioParameter)({
            name: 'isGraphBuilt',
            value: value
        }));
    }
    isTransportSyncMaster() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectTransportSync)) === 'send';
    }
    setTransportSync(value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: 'sync',
            value: value
        }));
    }
    isTransportSyncFollower() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectTransportSync)) === 'receive';
    }
    setTransportCurrentStep(currentStep) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: 'currentStep',
            value: currentStep
        }));
    }
    getTransportCurrentStep() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectTransportCurrentStep));
    }
    getCurrentLevelFxReturn(nomFx) {
        if (!this.isGraphBuilt()) return -60;
        if (nomFx === 'reverbA') return this.returns.reverbA.getCurrentLevel();
        if (nomFx === 'reverbB') return this.returns.reverbB.getCurrentLevel();
        if (nomFx === 'delayA') return this.returns.delayA.getCurrentLevel();
        if (nomFx === 'delayB') return this.returns.delayB.getCurrentLevel();
        return -60;
    }
    getCurrentMasterLevels() {
        if (!this.isGraphBuilt()) return [
            -60,
            -60
        ];
        return this.masterChannel.getCurrentLevels();
    }
    //Creem un metronom
    initMetronome() {
        this.metronome = new $kCoIg.NoiseSynth({
            volume: -6,
            envelope: {
                attack: 0.001,
                decay: 0.1,
                sustain: 0
            }
        }).toDestination();
    }
    // Creem els returns
    initReturns() {
        const reverbA = new (0, $duZNX.ReverbReturn)().connect(this.masterChannel);
        const reverbB = new (0, $duZNX.ReverbReturn)().connect(this.masterChannel);
        const delayA = new (0, $29BVo.DelayReturn)().connect(this.masterChannel);
        const delayB = new (0, $29BVo.DelayReturn)().connect(this.masterChannel);
        this.returns = {
            reverbA: reverbA,
            reverbB: reverbB,
            delayA: delayA,
            delayB: delayB
        };
    }
    get16BeatTime() {
        return 60 / (this.getBpm() * 4);
    }
    setIsMetronomeEnabled(value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: 'isMetronomeEnabled',
            value: value
        }));
    }
    isMetronomeEnabled() {
        return (0, $95CQM.staticSelect)((0, $5ICqB.selectIsMetronomeEnabled));
    }
    async addInstrument(instrumentID, value) {
        await this.#addInstrumentToAudioGraph(instrumentID);
    }
    removeInstrument(instrumentID) {
        this.#removeInstrumentFromAudioGraph(instrumentID);
    }
    async #addInstrumentToAudioGraph(instrumentID) {
        if (!this.isGraphBuilt()) return;
        const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
        await instrument.buildInstrumentAudioGraph();
        instrument.bus.connect(this.masterChannel);
        // Carrega parameter values a l'audio graph
        instrument.applyStateToAudioGraph();
    }
    #removeInstrumentFromAudioGraph(instrumentID) {
        if (!this.isGraphBuilt()) return;
        (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).dispose();
    }
    async buildAudioGraph() {
        console.debug("Building audio graph");
        this.#setIsGraphBuilt(false);
        this.setTransportCurrentStep(-1);
        // Setteja el bpm al valor guardat
        $56MRX.getTransport().bpm.value = this.getBpm();
        this.masterChannel = new (0, $lejHD.MasterChannel)().toDestination();
        this.masterChannel.gain = (0, $95CQM.staticSelect)((0, $5ICqB.createMasterChannelParameterSelector)("gain"));
        this.masterChannel.pan = (0, $95CQM.staticSelect)((0, $5ICqB.createMasterChannelParameterSelector)("pan"));
        // Crea el node "loop" principal per marcar passos a les instruments que segueixen el sequenciador
        this.mainSequencer = new $iilfj.Loop((time)=>{
            if (this.isPlaying()) this.onMainSequencerStep(time);
        }, "16n").start(0);
        // Inicialitzem els returns
        this.initReturns();
        //Inicialitzem metronom
        this.initMetronome();
        // Marca el graph com a construït
        this.#setIsGraphBuilt(true);
        // Afegir instruments a l'audio graph no és part del 'nucli' de l'audio graph. Els instruments al llarg del projecte es poden afegir
        // i treure, i a més, els instruments necessiten saber si el 'nucli' de l'audio graph està construit (isGraphBuilt) per poder
        // ajustar els seus paràmetres
        await Promise.all((0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs)).map((instrumentID)=>this.#addInstrumentToAudioGraph(instrumentID)));
        // Carrega els paràmetres dels efectes generals
        Object.entries((0, $95CQM.staticSelect)((0, $5ICqB.selectReturns))).forEach(([returnName, { parameters: parameters }])=>{
            Object.entries(parameters).forEach(([parameterName, value])=>this.returns[returnName][parameterName] = value);
        });
    }
    clearWamHostGroupIds = ()=>{
        // TODO: this clear the list of "saved" hosts, but does not destroy the hosts themselves. It might not
        // bee too relevant as users will not be switching audio engine on/off all the time, but would be nice to
        // see how to properly destroy them.
        this.wamHostGroupIds = {};
    };
    async initializeWamHost(hostIdGRUF) {
        // Initializes a host for WAM plugins
        // Each host can have a chain of plugins, and if MIDI is sent to a plugin in the chain, it will be cascaded to the rest of plugins in the chain.
        // For that reason it might be convenient to have different hosts for different chains of plugins and this can be done using the "hostIdGRUF" parameter.
        // If this method is called multiple times with the same hostIdGRUF, it will return the coresponding WAM hostGroupId without re-initializing.
        // hostGroupId is later used in initWamInstance to specify in which host a WAM plugin should be initialized.
        if (this.wamHostGroupIds[hostIdGRUF]) return this.wamHostGroupIds[hostIdGRUF];
        const [hostGroupId] = await (0, $1qR2T.initializeWamHost)($1Uvh8.getContext().rawContext);
        this.wamHostGroupIds[hostIdGRUF] = hostGroupId;
        return hostGroupId;
    }
    async initWamInstance(wamUrl, hostIdGRUF = 'default') {
        // Loads a specific wam plugin from a URL
        const { default: WAM } = await (0, $SPbsj.importModuleFromExternalUrl)(wamUrl);
        // Initialize WAM host for this plugin (or reuses an alreay initialized host with the same hostIdGRUF), and initialize the instance of the WAM plugin in that host
        const wamHostGroupId = await this.initializeWamHost(hostIdGRUF);
        return await WAM.createInstance(wamHostGroupId, $1Uvh8.getContext().rawContext);
    }
    async startAudioContext() {
        // Optimize global tone context for playback (mightier latency and use less CPU (?))
        let latencyHintParam = undefined;
        const paramName = "latencyHint";
        var queryString = location.search;
        let params = new URLSearchParams(queryString);
        if (params.has(paramName)) latencyHintParam = params.get(paramName);
        let latencyHintValue = latencyHintParam !== undefined ? latencyHintParam : "interactive";
        if (!isNaN(latencyHintValue)) latencyHintValue = parseFloat(latencyHintValue) // In case latency hint is passed as a number in seconds
        ;
        console.debug("Starting audio context with latency hint: ", latencyHintValue);
        const context = new $g8ux3.Context(new $56MRX.context.rawContext.constructor({
            latencyHint: latencyHintValue,
            sampleRate: (0, $95CQM.staticSelect)((0, $5ICqB.selectSampleRate))
        }));
        $1Uvh8.setContext(context);
        await $1Uvh8.start();
        console.debug("Tonejs and audio context started");
        this.projectRecorderNode = await $08dd2fbe37cead66$var$createRecorderNode();
        $56MRX.getDestination().connect(this.projectRecorderNode);
        console.debug("Recorded node initialized");
    }
    async transportStart() {
        if (!this.isGraphBuilt()) return;
        let transportCurrentStep = 0;
        if (this.isTransportSyncFollower()) transportCurrentStep = this.remoteTransportCurrentStep;
        else if ((0, $95CQM.staticSelect)((0, $5ICqB.selectPlaybackMode)) !== "followInstruments") transportCurrentStep = (0, $95CQM.staticSelect)((0, $5ICqB.selectPlayStartMarkerStep));
        this.setTransportCurrentStep(transportCurrentStep);
        // Comença a gravar si estava record armed
        if (this.isRecordArmed()) {
            this.projectRecorderNode.startRecording();
            this.setIsRecordArmed(false);
            this.setIsRecording(true);
        }
        // Trigueja el transport start a totes les instruments i el transport general
        this.didTransportJustStart = true;
        $56MRX.getTransport().start();
    }
    transportStop() {
        if (!this.isGraphBuilt()) return;
        $56MRX.getTransport().stop();
        // Cridem "onTransportStop" de totes les instruments per assegurar que s'aturen tots els sons
        (0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs)).forEach((instrumentID)=>{
            const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
            instrument.onTransportStop();
        });
        // Atura la gravació si estava gravant
        if (this.isRecording()) this.stopRecordingProject();
        this.setTransportCurrentStep(-1);
    }
    onMainSequencerStep(time) {
        let currentStep = this.getTransportCurrentStep();
        if (this.didTransportJustStart) // we don't advance a step in the first iteration
        // because the step we want was previously set
        this.didTransportJustStart = false;
        else {
            currentStep += 1;
            this.setTransportCurrentStep(currentStep);
        }
        const beatInBar = Math.floor(currentStep / 4) % 4;
        const subdivisionInBeat = currentStep % 4;
        const playbackMode = (0, $95CQM.staticSelect)((0, $5ICqB.selectPlaybackMode));
        // First, dequeue slots if needed. instrument.onSequencerStep needs the updated clip information
        if (playbackMode === "followLauncher") {
            if (beatInBar === 0 && subdivisionInBeat === 0) (0, $5ICqB.default).dispatch((0, $5ICqB.dequeueSlots)({}));
            if (!this.isPlaying()) return; // could be that with the slot dequeuing, there are no more slots and transport stop is called
        } else if (playbackMode === "followArrangement") {
            const { sceneID: sceneID, step: currentSceneStep } = (0, $95CQM.staticSelect)((0, $5ICqB.selectCurrentSceneIDAndStep));
            if (sceneID == null) {
                (0, $5ICqB.default).dispatch((0, $5ICqB.transportStop)({}));
                return;
            }
            if (currentSceneStep === 0 || this.lastLaunchedScene !== sceneID) {
                (0, $5ICqB.default).dispatch((0, $5ICqB.launchScene)({
                    sceneID: sceneID
                }));
                this.lastLaunchedScene = sceneID; // per si les duracions de les escenes canvien!
            }
            currentStep = currentSceneStep;
        }
        // Trigueja el step del sequenciador a totes les instruments
        // amb el referent de temps actual i el beat general. Les instruments s'encarreguen
        // de transformar el número de beat global a la seva duració interna
        (0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs)).forEach((instrumentID)=>{
            const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
            instrument.onSequencerStep(currentStep, time);
        });
        if (this.isMetronomeEnabled()) {
            if (subdivisionInBeat === 0) this.metronome.triggerAttackRelease("16n", time);
        }
    }
    panic(instrumentID) {
        if (!this.isGraphBuilt()) return;
        if (instrumentID === undefined) // Stop any notes/sounds being played in all stations, clear "caches" of current notes being played
        (0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs)).forEach((instrumentID)=>{
            const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
            instrument.onStopAllSounds();
        });
        else {
            // Stop any notes/sounds being played in the specified station, clear "caches" of current notes being played
            const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
            instrument.onStopAllSounds();
        }
        (0, $lsfK2.midiHandler).clearNotes();
    }
    updateProjectParameter(name, value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setProjectParameter)({
            name: name,
            value: value
        }));
    }
    updateAudioParameter(name, value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setAudioParameter)({
            name: name,
            value: value
        }));
    }
    updateTransportParameter(name, value) {
        (0, $5ICqB.default).dispatch((0, $5ICqB.setTransportParameter)({
            name: name,
            value: value
        }));
    }
    receiveRemoteTransportCurrentStep(currentStep) {
        this.remoteTransportCurrentStep = currentStep;
        if (this.isTransportSyncFollower() && !this.isPlaying()) this.setTransportCurrentStep(currentStep);
    }
}
const $08dd2fbe37cead66$var$audioGraph = new $08dd2fbe37cead66$export$9c3d1c13578c940f();

});
parcelRegister("56MRX", function(module, exports) {
$parcel$export(module.exports, "Analyser", () => (parcelRequire("kzedo")).Analyser);
$parcel$export(module.exports, "BiquadFilter", () => (parcelRequire("Lvs5H")).BiquadFilter);
$parcel$export(module.exports, "Channel", () => (parcelRequire("1x3k0")).Channel);
$parcel$export(module.exports, "connect", () => (parcelRequire("fDBOr")).connect);
$parcel$export(module.exports, "Context", () => (parcelRequire("g8ux3")).Context);
$parcel$export(module.exports, "dbToGain", () => (parcelRequire("bmU6v")).dbToGain);
$parcel$export(module.exports, "Distortion", () => (parcelRequire("1ZLI2")).Distortion);
$parcel$export(module.exports, "DuoSynth", () => (parcelRequire("dDgqq")).DuoSynth);
$parcel$export(module.exports, "FeedbackDelay", () => (parcelRequire("gtyBS")).FeedbackDelay);
$parcel$export(module.exports, "Filter", () => (parcelRequire("82Hwq")).Filter);
$parcel$export(module.exports, "Frequency", () => (parcelRequire("aZf7A")).Frequency);
$parcel$export(module.exports, "Gain", () => (parcelRequire("bdbZZ")).Gain);
$parcel$export(module.exports, "gainToDb", () => (parcelRequire("bmU6v")).gainToDb);
$parcel$export(module.exports, "intervalToFrequencyRatio", () => (parcelRequire("bmU6v")).intervalToFrequencyRatio);
$parcel$export(module.exports, "isString", () => (parcelRequire("lQ01C")).isString);
$parcel$export(module.exports, "LFO", () => (parcelRequire("lNxm0")).LFO);
$parcel$export(module.exports, "Limiter", () => (parcelRequire("2AuBL")).Limiter);
$parcel$export(module.exports, "Loop", () => (parcelRequire("iilfj")).Loop);
$parcel$export(module.exports, "Meter", () => (parcelRequire("lUFsy")).Meter);
$parcel$export(module.exports, "Midi", () => (parcelRequire("3xSib")).Midi);
$parcel$export(module.exports, "MonoSynth", () => (parcelRequire("kNUCa")).MonoSynth);
$parcel$export(module.exports, "MultibandSplit", () => (parcelRequire("jT0OW")).MultibandSplit);
$parcel$export(module.exports, "NoiseSynth", () => (parcelRequire("kCoIg")).NoiseSynth);
$parcel$export(module.exports, "optionsFromArguments", () => (parcelRequire("l4RVz")).optionsFromArguments);
$parcel$export(module.exports, "Panner", () => (parcelRequire("32Bfc")).Panner);
$parcel$export(module.exports, "PitchShift", () => (parcelRequire("e3S5U")).PitchShift);
$parcel$export(module.exports, "Player", () => (parcelRequire("ihNA0")).Player);
$parcel$export(module.exports, "PolySynth", () => (parcelRequire("ksj9M")).PolySynth);
$parcel$export(module.exports, "Reverb", () => (parcelRequire("7FIGc")).Reverb);
$parcel$export(module.exports, "Sampler", () => (parcelRequire("7u8Jf")).Sampler);
$parcel$export(module.exports, "ToneAudioBuffers", () => (parcelRequire("iace4")).ToneAudioBuffers);
$parcel$export(module.exports, "ToneAudioNode", () => (parcelRequire("fDBOr")).ToneAudioNode);
$parcel$export(module.exports, "ToneBufferSource", () => (parcelRequire("a0u4l")).ToneBufferSource);
$parcel$export(module.exports, "Volume", () => (parcelRequire("dTGN1")).Volume);

$parcel$export(module.exports, "now", () => $3b836baf91a8906b$export$461939dd4422153);
$parcel$export(module.exports, "getTransport", () => $3b836baf91a8906b$export$867d8b939ab7f43e);
$parcel$export(module.exports, "getDestination", () => $3b836baf91a8906b$export$be071a6ef30bc5f7);
$parcel$export(module.exports, "context", () => $3b836baf91a8906b$export$a078c61943f9dbbe);
$parcel$export(module.exports, "Buffer", () => $3b836baf91a8906b$export$a143d493d941bafc);
$parcel$export(module.exports, "getContext", () => (parcelRequire("1Uvh8")).getContext);
$parcel$export(module.exports, "setContext", () => (parcelRequire("1Uvh8")).setContext);
$parcel$export(module.exports, "start", () => (parcelRequire("1Uvh8")).start);

var $1Uvh8 = parcelRequire("1Uvh8");
parcelRequire("iiMGd");
parcelRequire("cygwg");

var $9j0vm = parcelRequire("9j0vm");

var $lQat4 = parcelRequire("lQat4");

var $iace4 = parcelRequire("iace4");

var $a0u4l = parcelRequire("a0u4l");
function $3b836baf91a8906b$export$461939dd4422153() {
    return (0, $1Uvh8.getContext)().now();
}
function $3b836baf91a8906b$export$7aea7eb3d7f025ec() {
    return (0, $1Uvh8.getContext)().immediate();
}
const $3b836baf91a8906b$export$86495b081fef8e52 = (0, $1Uvh8.getContext)().transport;
function $3b836baf91a8906b$export$867d8b939ab7f43e() {
    return (0, $1Uvh8.getContext)().transport;
}
const $3b836baf91a8906b$export$5c4bdf44e1e9cea1 = (0, $1Uvh8.getContext)().destination;
const $3b836baf91a8906b$export$44fd2db2d162647d = (0, $1Uvh8.getContext)().destination;
function $3b836baf91a8906b$export$be071a6ef30bc5f7() {
    return (0, $1Uvh8.getContext)().destination;
}
const $3b836baf91a8906b$export$c92b1d5f43586026 = (0, $1Uvh8.getContext)().listener;
function $3b836baf91a8906b$export$12abb5141c6fdc9c() {
    return (0, $1Uvh8.getContext)().listener;
}
const $3b836baf91a8906b$export$dca20402ebea5ece = (0, $1Uvh8.getContext)().draw;
function $3b836baf91a8906b$export$dc345928c36e8deb() {
    return (0, $1Uvh8.getContext)().draw;
}
const $3b836baf91a8906b$export$a078c61943f9dbbe = (0, $1Uvh8.getContext)();
function $3b836baf91a8906b$export$b40fc69c4a2927a1() {
    return (0, $9j0vm.ToneAudioBuffer).loaded();
}
const $3b836baf91a8906b$export$a143d493d941bafc = (0, $9j0vm.ToneAudioBuffer);
const $3b836baf91a8906b$export$2a73594b5be3a068 = (0, $iace4.ToneAudioBuffers);
const $3b836baf91a8906b$export$54a46af252275b4d = (0, $a0u4l.ToneBufferSource);

});
parcelRegister("1Uvh8", function(module, exports) {

$parcel$export(module.exports, "getContext", () => $164348078158f6f2$export$31553aaa555c1514);
$parcel$export(module.exports, "setContext", () => $164348078158f6f2$export$2f04de43fe27971a);
$parcel$export(module.exports, "start", () => $164348078158f6f2$export$b3571188c770cc5a);

var $cygwg = parcelRequire("cygwg");

var $lQat4 = parcelRequire("lQat4");

var $g8ux3 = parcelRequire("g8ux3");

var $1uOAh = parcelRequire("1uOAh");

var $iHery = parcelRequire("iHery");

var $9rnZW = parcelRequire("9rnZW");
/**
 * This dummy context is used to avoid throwing immediate errors when importing in Node.js
 */ const $164348078158f6f2$var$dummyContext = new (0, $1uOAh.DummyContext)();
/**
 * The global audio context which is getable and assignable through
 * getContext and setContext
 */ let $164348078158f6f2$var$globalContext = $164348078158f6f2$var$dummyContext;
function $164348078158f6f2$export$31553aaa555c1514() {
    if ($164348078158f6f2$var$globalContext === $164348078158f6f2$var$dummyContext && (0, $lQat4.hasAudioContext)) $164348078158f6f2$export$2f04de43fe27971a(new (0, $g8ux3.Context)());
    return $164348078158f6f2$var$globalContext;
}
function $164348078158f6f2$export$2f04de43fe27971a(context) {
    if ((0, $9rnZW.isAudioContext)(context)) $164348078158f6f2$var$globalContext = new (0, $g8ux3.Context)(context);
    else if ((0, $9rnZW.isOfflineAudioContext)(context)) $164348078158f6f2$var$globalContext = new (0, $iHery.OfflineContext)(context);
    else $164348078158f6f2$var$globalContext = context;
}
function $164348078158f6f2$export$b3571188c770cc5a() {
    return $164348078158f6f2$var$globalContext.resume();
}
/**
 * Log Tone.js + version in the console.
 */ if ((0, $lQat4.theWindow) && !(0, $lQat4.theWindow).TONE_SILENCE_LOGGING) {
    let prefix = "v";
    if ((0, $cygwg.version) === "dev") prefix = "";
    const printString = ` * Tone.js ${prefix}${(0, $cygwg.version)} * `;
    // eslint-disable-next-line no-console
    console.log(`%c${printString}`, "background: #000; color: #fff");
}

});
parcelRegister("cygwg", function(module, exports) {

$parcel$export(module.exports, "version", () => $923579645cbcc698$export$83d89fbfd8236492);
const $923579645cbcc698$export$83d89fbfd8236492 = "14.7.77";

});

parcelRegister("lQat4", function(module, exports) {

$parcel$export(module.exports, "createAudioContext", () => $fe6692fabef4a674$export$9e09b0a77eebe103);
$parcel$export(module.exports, "createOfflineAudioContext", () => $fe6692fabef4a674$export$b7df220975ff4035);
$parcel$export(module.exports, "theWindow", () => $fe6692fabef4a674$export$a3ddad83b7a6ba2);
$parcel$export(module.exports, "hasAudioContext", () => $fe6692fabef4a674$export$50898d6dff7e65a3);
$parcel$export(module.exports, "createAudioWorkletNode", () => $fe6692fabef4a674$export$f2cca0e3f6d50e11);

var $kxUqn = parcelRequire("kxUqn");

var $6Utwn = parcelRequire("6Utwn");

var $lQ01C = parcelRequire("lQ01C");
function $fe6692fabef4a674$export$9e09b0a77eebe103(options) {
    return new (0, $kxUqn.AudioContext)(options);
}
function $fe6692fabef4a674$export$b7df220975ff4035(channels, length, sampleRate) {
    return new (0, $kxUqn.OfflineAudioContext)(channels, length, sampleRate);
}
const $fe6692fabef4a674$export$a3ddad83b7a6ba2 = typeof self === "object" ? self : null;
const $fe6692fabef4a674$export$50898d6dff7e65a3 = $fe6692fabef4a674$export$a3ddad83b7a6ba2 && ($fe6692fabef4a674$export$a3ddad83b7a6ba2.hasOwnProperty("AudioContext") || $fe6692fabef4a674$export$a3ddad83b7a6ba2.hasOwnProperty("webkitAudioContext"));
function $fe6692fabef4a674$export$f2cca0e3f6d50e11(context, name, options) {
    (0, $6Utwn.assert)((0, $lQ01C.isDefined)((0, $kxUqn.AudioWorkletNode)), "This node only works in a secure context (https or localhost)");
    // @ts-ignore
    return new (0, $kxUqn.AudioWorkletNode)(context, name, options);
}

});
parcelRegister("kxUqn", function(module, exports) {

$parcel$export(module.exports, "GainNode", () => $ef52a87194a4fc85$export$db147ea22bd7e3ce);
$parcel$export(module.exports, "AudioContext", () => $ef52a87194a4fc85$export$fcbc63750ec2a81f);
$parcel$export(module.exports, "AudioWorkletNode", () => $ef52a87194a4fc85$export$bc6715221481535);
$parcel$export(module.exports, "OfflineAudioContext", () => $ef52a87194a4fc85$export$5ab5c649a10df7db);
$parcel$export(module.exports, "isAnyAudioContext", () => $ef52a87194a4fc85$export$e55e427bf52f793d);
$parcel$export(module.exports, "isAnyAudioNode", () => $ef52a87194a4fc85$export$61ea8ea4691b9a32);
$parcel$export(module.exports, "isAnyAudioParam", () => $ef52a87194a4fc85$export$254dcc24b342c8c2);
$parcel$export(module.exports, "isAnyOfflineAudioContext", () => $ef52a87194a4fc85$export$e78994f7990ad5d3);

var $hOQY6 = parcelRequire("hOQY6");

var $VuCGR = parcelRequire("VuCGR");

var $d2N7B = parcelRequire("d2N7B");

var $i8HIp = parcelRequire("i8HIp");

var $a2tPB = parcelRequire("a2tPB");

var $40Hzv = parcelRequire("40Hzv");

var $cTGW1 = parcelRequire("cTGW1");

var $eRtkD = parcelRequire("eRtkD");

var $iknOE = parcelRequire("iknOE");

var $b579J = parcelRequire("b579J");

var $6sAjJ = parcelRequire("6sAjJ");

var $dC3Eg = parcelRequire("dC3Eg");

var $4ylI4 = parcelRequire("4ylI4");

var $50AfV = parcelRequire("50AfV");

var $ctmdr = parcelRequire("ctmdr");

var $lxNbI = parcelRequire("lxNbI");

var $3rjFY = parcelRequire("3rjFY");

var $17YZP = parcelRequire("17YZP");

var $8QBXD = parcelRequire("8QBXD");

var $3rvEZ = parcelRequire("3rvEZ");

var $gSUC5 = parcelRequire("gSUC5");

var $79abV = parcelRequire("79abV");

var $a93CL = parcelRequire("a93CL");

var $8yjbp = parcelRequire("8yjbp");

var $1xttk = parcelRequire("1xttk");

var $ja40t = parcelRequire("ja40t");

var $1KxM9 = parcelRequire("1KxM9");

var $at74R = parcelRequire("at74R");

var $1BQb0 = parcelRequire("1BQb0");

var $lhgou = parcelRequire("lhgou");

var $hBsOy = parcelRequire("hBsOy");

var $7z0Yz = parcelRequire("7z0Yz");

var $jU4NY = parcelRequire("jU4NY");

var $5pRJO = parcelRequire("5pRJO");

var $gbvfd = parcelRequire("gbvfd");

var $e6Pgs = parcelRequire("e6Pgs");

var $i4thH = parcelRequire("i4thH");

var $eNeFn = parcelRequire("eNeFn");

var $5B7u4 = parcelRequire("5B7u4");

var $bapQr = parcelRequire("bapQr");

var $cmh9R = parcelRequire("cmh9R");

var $7EdX6 = parcelRequire("7EdX6");

var $5esAO = parcelRequire("5esAO");

var $fTZUy = parcelRequire("fTZUy");

var $hBhN5 = parcelRequire("hBhN5");

var $hgn2W = parcelRequire("hgn2W");

var $dNMGX = parcelRequire("dNMGX");

var $erHzM = parcelRequire("erHzM");

var $dDWai = parcelRequire("dDWai");

var $lvVTt = parcelRequire("lvVTt");

var $knTGA = parcelRequire("knTGA");

var $3kywS = parcelRequire("3kywS");

var $2tXK8 = parcelRequire("2tXK8");

var $8YAdg = parcelRequire("8YAdg");

var $c1nXz = parcelRequire("c1nXz");

var $8Az4B = parcelRequire("8Az4B");

var $6HEHv = parcelRequire("6HEHv");

var $25YIS = parcelRequire("25YIS");

var $pSyXE = parcelRequire("pSyXE");

var $7eDuD = parcelRequire("7eDuD");

var $iINpc = parcelRequire("iINpc");

var $5HjFx = parcelRequire("5HjFx");

var $aanxM = parcelRequire("aanxM");

var $jP1v0 = parcelRequire("jP1v0");

var $huLlV = parcelRequire("huLlV");

var $8fnKQ = parcelRequire("8fnKQ");

var $dhmx6 = parcelRequire("dhmx6");

var $GOU9g = parcelRequire("GOU9g");

var $8Wiqm = parcelRequire("8Wiqm");

var $90REg = parcelRequire("90REg");

var $lcODi = parcelRequire("lcODi");

var $6LIKY = parcelRequire("6LIKY");

var $2meOO = parcelRequire("2meOO");

var $7yfCk = parcelRequire("7yfCk");

var $ctUWa = parcelRequire("ctUWa");

var $dT9fA = parcelRequire("dT9fA");

var $9Vj4x = parcelRequire("9Vj4x");

var $kOhPO = parcelRequire("kOhPO");

var $c9S8f = parcelRequire("c9S8f");

var $jecjI = parcelRequire("jecjI");

var $ddkZL = parcelRequire("ddkZL");

var $9Vg5r = parcelRequire("9Vg5r");

var $bfUi1 = parcelRequire("bfUi1");

var $12TK4 = parcelRequire("12TK4");

var $cLoIk = parcelRequire("cLoIk");

var $6pgET = parcelRequire("6pgET");

var $dL2WA = parcelRequire("dL2WA");

var $ddFUI = parcelRequire("ddFUI");

var $lC4rh = parcelRequire("lC4rh");

var $8S7ub = parcelRequire("8S7ub");

var $lhsPn = parcelRequire("lhsPn");

var $OOytR = parcelRequire("OOytR");

var $jneAG = parcelRequire("jneAG");

var $9ycsu = parcelRequire("9ycsu");

var $bcRpN = parcelRequire("bcRpN");

var $h5DkH = parcelRequire("h5DkH");

var $59JPD = parcelRequire("59JPD");

var $Yxv0j = parcelRequire("Yxv0j");

var $dPTmN = parcelRequire("dPTmN");

var $85FbK = parcelRequire("85FbK");

var $8AhrS = parcelRequire("8AhrS");

var $c59vA = parcelRequire("c59vA");

var $l5Ydn = parcelRequire("l5Ydn");

var $kH7K1 = parcelRequire("kH7K1");

var $iwg3Z = parcelRequire("iwg3Z");

var $eqU4Z = parcelRequire("eqU4Z");

var $9EasH = parcelRequire("9EasH");

var $1iyoI = parcelRequire("1iyoI");

var $fsgHl = parcelRequire("fsgHl");

var $2IweL = parcelRequire("2IweL");

var $93ZjL = parcelRequire("93ZjL");

var $aqiBQ = parcelRequire("aqiBQ");

var $54cQo = parcelRequire("54cQo");

var $7Mr4p = parcelRequire("7Mr4p");

var $dCMVF = parcelRequire("dCMVF");

var $3S0ml = parcelRequire("3S0ml");

var $6M9HG = parcelRequire("6M9HG");

var $8BXEl = parcelRequire("8BXEl");

var $5dTI0 = parcelRequire("5dTI0");

var $fSrsH = parcelRequire("fSrsH");

var $4JxZu = parcelRequire("4JxZu");

var $1rkne = parcelRequire("1rkne");

var $gcGjK = parcelRequire("gcGjK");

var $avKWH = parcelRequire("avKWH");

var $aOLPL = parcelRequire("aOLPL");

var $2Xpjk = parcelRequire("2Xpjk");

var $1u2fI = parcelRequire("1u2fI");

var $ch2aF = parcelRequire("ch2aF");

var $1KjDM = parcelRequire("1KjDM");

var $fTCQm = parcelRequire("fTCQm");

var $1Jt2R = parcelRequire("1Jt2R");

var $33XCT = parcelRequire("33XCT");

var $9v59y = parcelRequire("9v59y");

var $2yiIV = parcelRequire("2yiIV");

var $a8EHb = parcelRequire("a8EHb");

var $6ykSy = parcelRequire("6ykSy");

var $jiZoz = parcelRequire("jiZoz");

var $7n0kH = parcelRequire("7n0kH");

var $2qNtl = parcelRequire("2qNtl");

var $23gcm = parcelRequire("23gcm");

var $5dA3Y = parcelRequire("5dA3Y");

var $cGlbF = parcelRequire("cGlbF");

var $9Vu0K = parcelRequire("9Vu0K");

var $dm3GZ = parcelRequire("dm3GZ");

var $boP90 = parcelRequire("boP90");

var $7R2vO = parcelRequire("7R2vO");

var $70Bin = parcelRequire("70Bin");

var $gg7IJ = parcelRequire("gg7IJ");

var $7vJJE = parcelRequire("7vJJE");

var $kLLxn = parcelRequire("kLLxn");

var $cAjwK = parcelRequire("cAjwK");

var $emUIu = parcelRequire("emUIu");

var $71zf0 = parcelRequire("71zf0");

var $bCo2C = parcelRequire("bCo2C");

var $gtvtQ = parcelRequire("gtvtQ");

var $7CCTQ = parcelRequire("7CCTQ");

var $hqy8F = parcelRequire("hqy8F");

var $bw7LY = parcelRequire("bw7LY");

var $l4IjU = parcelRequire("l4IjU");

var $5jZnB = parcelRequire("5jZnB");

var $8zCWh = parcelRequire("8zCWh");

var $ht7NN = parcelRequire("ht7NN");

var $7joNS = parcelRequire("7joNS");

var $64Vwm = parcelRequire("64Vwm");

var $1ieU6 = parcelRequire("1ieU6");

var $kBpIy = parcelRequire("kBpIy");

var $kMIy9 = parcelRequire("kMIy9");

var $3TZtj = parcelRequire("3TZtj");

var $aO4oU = parcelRequire("aO4oU");

var $aLu63 = parcelRequire("aLu63");

var $iAqIi = parcelRequire("iAqIi");

var $bvS5t = parcelRequire("bvS5t");

var $eSkbj = parcelRequire("eSkbj");

var $dnCRy = parcelRequire("dnCRy");

var $8sbmW = parcelRequire("8sbmW");

var $1TFz4 = parcelRequire("1TFz4");

var $8pz9Z = parcelRequire("8pz9Z");

var $1Lq6V = parcelRequire("1Lq6V");

var $g8bwb = parcelRequire("g8bwb");

var $9wzDL = parcelRequire("9wzDL");

var $gBkDC = parcelRequire("gBkDC");

var $81KbS = parcelRequire("81KbS");

var $M07bQ = parcelRequire("M07bQ");

var $dFPCW = parcelRequire("dFPCW");

var $jWIYf = parcelRequire("jWIYf");

var $dl7Fu = parcelRequire("dl7Fu");

var $4tJKf = parcelRequire("4tJKf");

var $7FbIt = parcelRequire("7FbIt");

var $6as03 = parcelRequire("6as03");

var $fPjha = parcelRequire("fPjha");

var $lR5Oy = parcelRequire("lR5Oy");

var $aDnGz = parcelRequire("aDnGz");

var $lmHG7 = parcelRequire("lmHG7");

var $a2LmX = parcelRequire("a2LmX");

var $fJusW = parcelRequire("fJusW");

var $7GhDt = parcelRequire("7GhDt");

var $kE4Bl = parcelRequire("kE4Bl");

var $4mEra = parcelRequire("4mEra");

var $kMO8J = parcelRequire("kMO8J");

var $4f1Kq = parcelRequire("4f1Kq");
parcelRequire("i6mQe");
parcelRequire("eP9uV");
const $ef52a87194a4fc85$var$addActiveInputConnectionToAudioNode = (0, $d2N7B.createAddActiveInputConnectionToAudioNode)((0, $1TFz4.insertElementInSet));
const $ef52a87194a4fc85$var$addPassiveInputConnectionToAudioNode = (0, $eRtkD.createAddPassiveInputConnectionToAudioNode)((0, $1TFz4.insertElementInSet));
const $ef52a87194a4fc85$var$deleteActiveInputConnectionToAudioNode = (0, $dNMGX.createDeleteActiveInputConnectionToAudioNode)((0, $81KbS.pickElementFromSet));
const $ef52a87194a4fc85$var$audioNodeTailTimeStore = new WeakMap();
const $ef52a87194a4fc85$var$getAudioNodeTailTime = (0, $5HjFx.createGetAudioNodeTailTime)($ef52a87194a4fc85$var$audioNodeTailTimeStore);
const $ef52a87194a4fc85$var$cacheTestResult = (0, $at74R.createCacheTestResult)(new Map(), new WeakMap());
const $ef52a87194a4fc85$var$window = (0, $8zCWh.createWindow)();
const $ef52a87194a4fc85$var$createNativeAnalyserNode = (0, $jneAG.createNativeAnalyserNodeFactory)($ef52a87194a4fc85$var$cacheTestResult, (0, $lcODi.createIndexSizeError));
const $ef52a87194a4fc85$var$getAudioNodeRenderer = (0, $iINpc.createGetAudioNodeRenderer)((0, $aO4oU.getAudioNodeConnections));
const $ef52a87194a4fc85$var$renderInputsOfAudioNode = (0, $2yiIV.createRenderInputsOfAudioNode)((0, $aO4oU.getAudioNodeConnections), $ef52a87194a4fc85$var$getAudioNodeRenderer, (0, $g8bwb.isPartOfACycle));
const $ef52a87194a4fc85$var$createAnalyserNodeRenderer = (0, $dC3Eg.createAnalyserNodeRendererFactory)($ef52a87194a4fc85$var$createNativeAnalyserNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$var$getNativeContext = (0, $huLlV.createGetNativeContext)((0, $kBpIy.CONTEXT_STORE));
const $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor = (0, $3S0ml.createNativeOfflineAudioContextConstructor)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$isNativeOfflineAudioContext = (0, $9Vg5r.createIsNativeOfflineAudioContext)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor);
const $ef52a87194a4fc85$var$audioParamAudioNodeStore = new WeakMap();
const $ef52a87194a4fc85$var$eventTargetConstructor = (0, $c1nXz.createEventTargetConstructor)((0, $4f1Kq.wrapEventListener));
const $ef52a87194a4fc85$var$nativeAudioContextConstructor = (0, $h5DkH.createNativeAudioContextConstructor)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$isNativeAudioContext = (0, $kOhPO.createIsNativeAudioContext)($ef52a87194a4fc85$var$nativeAudioContextConstructor);
const $ef52a87194a4fc85$var$isNativeAudioNode = (0, $c9S8f.createIsNativeAudioNode)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$isNativeAudioParam = (0, $jecjI.createIsNativeAudioParam)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor = (0, $Yxv0j.createNativeAudioWorkletNodeConstructor)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$audioNodeConstructor = (0, $3rvEZ.createAudioNodeConstructor)((0, $i8HIp.createAddAudioNodeConnections)((0, $kBpIy.AUDIO_NODE_CONNECTIONS_STORE)), (0, $cTGW1.createAddConnectionToAudioNode)($ef52a87194a4fc85$var$addActiveInputConnectionToAudioNode, $ef52a87194a4fc85$var$addPassiveInputConnectionToAudioNode, (0, $kMIy9.connectNativeAudioNodeToNativeAudioNode), $ef52a87194a4fc85$var$deleteActiveInputConnectionToAudioNode, (0, $3TZtj.disconnectNativeAudioNodeFromNativeAudioNode), (0, $aO4oU.getAudioNodeConnections), $ef52a87194a4fc85$var$getAudioNodeTailTime, (0, $iAqIi.getEventListenersOfAudioNode), (0, $eSkbj.getNativeAudioNode), (0, $1TFz4.insertElementInSet), (0, $8pz9Z.isActiveAudioNode), (0, $g8bwb.isPartOfACycle), (0, $9wzDL.isPassiveAudioNode)), $ef52a87194a4fc85$var$cacheTestResult, (0, $90REg.createIncrementCycleCounterFactory)((0, $kBpIy.CYCLE_COUNTERS), (0, $3TZtj.disconnectNativeAudioNodeFromNativeAudioNode), (0, $aO4oU.getAudioNodeConnections), (0, $eSkbj.getNativeAudioNode), (0, $dnCRy.getNativeAudioParam), (0, $8pz9Z.isActiveAudioNode)), (0, $lcODi.createIndexSizeError), (0, $6LIKY.createInvalidAccessError), (0, $2Xpjk.createNotSupportedError), (0, $fTZUy.createDecrementCycleCounter)((0, $kMIy9.connectNativeAudioNodeToNativeAudioNode), (0, $kBpIy.CYCLE_COUNTERS), (0, $aO4oU.getAudioNodeConnections), (0, $eSkbj.getNativeAudioNode), (0, $dnCRy.getNativeAudioParam), $ef52a87194a4fc85$var$getNativeContext, (0, $8pz9Z.isActiveAudioNode), $ef52a87194a4fc85$var$isNativeOfflineAudioContext), (0, $dDWai.createDetectCycles)($ef52a87194a4fc85$var$audioParamAudioNodeStore, (0, $aO4oU.getAudioNodeConnections), (0, $8sbmW.getValueForKey)), $ef52a87194a4fc85$var$eventTargetConstructor, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeAudioContext, $ef52a87194a4fc85$var$isNativeAudioNode, $ef52a87194a4fc85$var$isNativeAudioParam, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor);
const $ef52a87194a4fc85$export$ed204192bbbabcef = (0, $6sAjJ.createAnalyserNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAnalyserNodeRenderer, (0, $lcODi.createIndexSizeError), $ef52a87194a4fc85$var$createNativeAnalyserNode, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$audioBufferStore = new WeakSet();
const $ef52a87194a4fc85$var$nativeAudioBufferConstructor = (0, $9ycsu.createNativeAudioBufferConstructor)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$convertNumberToUnsignedLong = (0, $eNeFn.createConvertNumberToUnsignedLong)(new Uint32Array(1));
const $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethods = (0, $ht7NN.createWrapAudioBufferCopyChannelMethods)($ef52a87194a4fc85$var$convertNumberToUnsignedLong, (0, $lcODi.createIndexSizeError));
const $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethodsOutOfBounds = (0, $7joNS.createWrapAudioBufferCopyChannelMethodsOutOfBounds)($ef52a87194a4fc85$var$convertNumberToUnsignedLong);
const $ef52a87194a4fc85$export$2dbca7d91f7769d7 = (0, $4ylI4.createAudioBufferConstructor)($ef52a87194a4fc85$var$audioBufferStore, $ef52a87194a4fc85$var$cacheTestResult, (0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$nativeAudioBufferConstructor, $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor, (0, $cGlbF.createTestAudioBufferConstructorSupport)($ef52a87194a4fc85$var$nativeAudioBufferConstructor), $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethods, $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $ef52a87194a4fc85$var$addSilentConnection = (0, $iknOE.createAddSilentConnection)((0, $fsgHl.createNativeGainNode));
const $ef52a87194a4fc85$var$renderInputsOfAudioParam = (0, $a8EHb.createRenderInputsOfAudioParam)($ef52a87194a4fc85$var$getAudioNodeRenderer, (0, $aLu63.getAudioParamConnections), (0, $g8bwb.isPartOfACycle));
const $ef52a87194a4fc85$var$connectAudioParam = (0, $jU4NY.createConnectAudioParam)($ef52a87194a4fc85$var$renderInputsOfAudioParam);
const $ef52a87194a4fc85$var$createNativeAudioBufferSourceNode = (0, $bcRpN.createNativeAudioBufferSourceNodeFactory)($ef52a87194a4fc85$var$addSilentConnection, $ef52a87194a4fc85$var$cacheTestResult, (0, $7FbIt.testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport), (0, $6as03.testAudioBufferSourceNodeStartMethodOffsetClampingSupport), (0, $fPjha.testAudioBufferSourceNodeStopMethodNullifiedBufferSupport), (0, $lR5Oy.testAudioScheduledSourceNodeStartMethodNegativeParametersSupport), (0, $aDnGz.testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport), (0, $lmHG7.testAudioScheduledSourceNodeStopMethodNegativeParametersSupport), (0, $4mEra.wrapAudioBufferSourceNodeStartMethodOffsetClamping), (0, $64Vwm.createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer)((0, $gBkDC.overwriteAccessors)), (0, $kMO8J.wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls));
const $ef52a87194a4fc85$var$renderAutomation = (0, $9v59y.createRenderAutomation)((0, $aanxM.createGetAudioParamRenderer)((0, $aLu63.getAudioParamConnections)), $ef52a87194a4fc85$var$renderInputsOfAudioParam);
const $ef52a87194a4fc85$var$createAudioBufferSourceNodeRenderer = (0, $ctmdr.createAudioBufferSourceNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeAudioBufferSourceNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$var$createAudioParam = (0, $gSUC5.createAudioParamFactory)((0, $a2tPB.createAddAudioParamConnections)((0, $kBpIy.AUDIO_PARAM_CONNECTIONS_STORE)), $ef52a87194a4fc85$var$audioParamAudioNodeStore, (0, $kBpIy.AUDIO_PARAM_STORE), (0, $79abV.createAudioParamRenderer), (0, $hOQY6.createCancelAndHoldAutomationEvent), (0, $hOQY6.createCancelScheduledValuesAutomationEvent), (0, $hOQY6.createExponentialRampToValueAutomationEvent), (0, $hOQY6.createLinearRampToValueAutomationEvent), (0, $hOQY6.createSetTargetAutomationEvent), (0, $hOQY6.createSetValueAutomationEvent), (0, $hOQY6.createSetValueCurveAutomationEvent), $ef52a87194a4fc85$var$nativeAudioContextConstructor, (0, $dl7Fu.setValueAtTimeUntilPossible));
const $ef52a87194a4fc85$export$c1b1480edd16e065 = (0, $50AfV.createAudioBufferSourceNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioBufferSourceNodeRenderer, $ef52a87194a4fc85$var$createAudioParam, (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeAudioBufferSourceNode, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, (0, $4f1Kq.wrapEventListener));
const $ef52a87194a4fc85$var$audioDestinationNodeConstructor = (0, $3rjFY.createAudioDestinationNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, (0, $17YZP.createAudioDestinationNodeRenderer), (0, $lcODi.createIndexSizeError), (0, $2meOO.createInvalidStateError), (0, $59JPD.createNativeAudioDestinationNodeFactory)((0, $fsgHl.createNativeGainNode), (0, $gBkDC.overwriteAccessors)), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$var$createBiquadFilterNodeRenderer = (0, $1KxM9.createBiquadFilterNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, (0, $8AhrS.createNativeBiquadFilterNode), (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$var$setAudioNodeTailTime = (0, $7n0kH.createSetAudioNodeTailTime)($ef52a87194a4fc85$var$audioNodeTailTimeStore);
const $ef52a87194a4fc85$export$f068340fbfd684eb = (0, $ja40t.createBiquadFilterNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createBiquadFilterNodeRenderer, (0, $6LIKY.createInvalidAccessError), (0, $8AhrS.createNativeBiquadFilterNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$monitorConnections = (0, $OOytR.createMonitorConnections)((0, $1TFz4.insertElementInSet), $ef52a87194a4fc85$var$isNativeAudioNode);
const $ef52a87194a4fc85$var$wrapChannelMergerNode = (0, $1ieU6.createWrapChannelMergerNode)((0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativeChannelMergerNode = (0, $c59vA.createNativeChannelMergerNodeFactory)($ef52a87194a4fc85$var$nativeAudioContextConstructor, $ef52a87194a4fc85$var$wrapChannelMergerNode);
const $ef52a87194a4fc85$var$createChannelMergerNodeRenderer = (0, $lhgou.createChannelMergerNodeRendererFactory)($ef52a87194a4fc85$var$createNativeChannelMergerNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$7488bfd772ec10fc = (0, $1BQb0.createChannelMergerNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createChannelMergerNodeRenderer, $ef52a87194a4fc85$var$createNativeChannelMergerNode, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$createChannelSplitterNodeRenderer = (0, $7z0Yz.createChannelSplitterNodeRendererFactory)((0, $l5Ydn.createNativeChannelSplitterNode), (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$6f860927b3cf75c1 = (0, $hBsOy.createChannelSplitterNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createChannelSplitterNodeRenderer, (0, $l5Ydn.createNativeChannelSplitterNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, (0, $dFPCW.sanitizeChannelSplitterOptions));
const $ef52a87194a4fc85$var$createNativeConstantSourceNodeFaker = (0, $iwg3Z.createNativeConstantSourceNodeFakerFactory)($ef52a87194a4fc85$var$addSilentConnection, $ef52a87194a4fc85$var$createNativeAudioBufferSourceNode, (0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativeConstantSourceNode = (0, $kH7K1.createNativeConstantSourceNodeFactory)($ef52a87194a4fc85$var$addSilentConnection, $ef52a87194a4fc85$var$cacheTestResult, $ef52a87194a4fc85$var$createNativeConstantSourceNodeFaker, (0, $lR5Oy.testAudioScheduledSourceNodeStartMethodNegativeParametersSupport), (0, $lmHG7.testAudioScheduledSourceNodeStopMethodNegativeParametersSupport));
const $ef52a87194a4fc85$var$createConstantSourceNodeRenderer = (0, $i4thH.createConstantSourceNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeConstantSourceNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$d394f3dc072b3480 = (0, $e6Pgs.createConstantSourceNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createConstantSourceNodeRenderer, $ef52a87194a4fc85$var$createNativeConstantSourceNode, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, (0, $4f1Kq.wrapEventListener));
const $ef52a87194a4fc85$var$createNativeConvolverNode = (0, $eqU4Z.createNativeConvolverNodeFactory)((0, $2Xpjk.createNotSupportedError), (0, $gBkDC.overwriteAccessors));
const $ef52a87194a4fc85$var$createConvolverNodeRenderer = (0, $bapQr.createConvolverNodeRendererFactory)($ef52a87194a4fc85$var$createNativeConvolverNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$20cfee6cb9c5d644 = (0, $5B7u4.createConvolverNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createConvolverNodeRenderer, $ef52a87194a4fc85$var$createNativeConvolverNode, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$createDelayNodeRenderer = (0, $hgn2W.createDelayNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, (0, $9EasH.createNativeDelayNode), (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$ce8664483cc583db = (0, $hBhN5.createDelayNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createDelayNodeRenderer, (0, $9EasH.createNativeDelayNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$createNativeDynamicsCompressorNode = (0, $1iyoI.createNativeDynamicsCompressorNodeFactory)((0, $2Xpjk.createNotSupportedError));
const $ef52a87194a4fc85$var$createDynamicsCompressorNodeRenderer = (0, $3kywS.createDynamicsCompressorNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeDynamicsCompressorNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$c74a663d797d02ba = (0, $knTGA.createDynamicsCompressorNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createDynamicsCompressorNodeRenderer, $ef52a87194a4fc85$var$createNativeDynamicsCompressorNode, (0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$createGainNodeRenderer = (0, $pSyXE.createGainNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, (0, $fsgHl.createNativeGainNode), (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$db147ea22bd7e3ce = (0, $25YIS.createGainNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createGainNodeRenderer, (0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$createNativeIIRFilterNodeFaker = (0, $93ZjL.createNativeIIRFilterNodeFakerFactory)((0, $6LIKY.createInvalidAccessError), (0, $2meOO.createInvalidStateError), (0, $4JxZu.createNativeScriptProcessorNode), (0, $2Xpjk.createNotSupportedError));
const $ef52a87194a4fc85$var$renderNativeOfflineAudioContext = (0, $6ykSy.createRenderNativeOfflineAudioContext)($ef52a87194a4fc85$var$cacheTestResult, (0, $fsgHl.createNativeGainNode), (0, $4JxZu.createNativeScriptProcessorNode), (0, $7CCTQ.createTestOfflineAudioContextCurrentTimeSupport)((0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor));
const $ef52a87194a4fc85$var$createIIRFilterNodeRenderer = (0, $8Wiqm.createIIRFilterNodeRendererFactory)($ef52a87194a4fc85$var$createNativeAudioBufferSourceNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor, $ef52a87194a4fc85$var$renderInputsOfAudioNode, $ef52a87194a4fc85$var$renderNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$createNativeIIRFilterNode = (0, $2IweL.createNativeIIRFilterNodeFactory)($ef52a87194a4fc85$var$createNativeIIRFilterNodeFaker);
const $ef52a87194a4fc85$export$81c00f34825a7708 = (0, $GOU9g.createIIRFilterNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createNativeIIRFilterNode, $ef52a87194a4fc85$var$createIIRFilterNodeRenderer, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$createAudioListener = (0, $8QBXD.createAudioListenerFactory)($ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createNativeChannelMergerNode, $ef52a87194a4fc85$var$createNativeConstantSourceNode, (0, $4JxZu.createNativeScriptProcessorNode), (0, $2Xpjk.createNotSupportedError), (0, $bvS5t.getFirstSample), $ef52a87194a4fc85$var$isNativeOfflineAudioContext, (0, $gBkDC.overwriteAccessors));
const $ef52a87194a4fc85$var$unrenderedAudioWorkletNodeStore = new WeakMap();
const $ef52a87194a4fc85$var$minimalBaseAudioContextConstructor = (0, $8S7ub.createMinimalBaseAudioContextConstructor)($ef52a87194a4fc85$var$audioDestinationNodeConstructor, $ef52a87194a4fc85$var$createAudioListener, $ef52a87194a4fc85$var$eventTargetConstructor, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$unrenderedAudioWorkletNodeStore, (0, $4f1Kq.wrapEventListener));
const $ef52a87194a4fc85$var$createNativeOscillatorNode = (0, $6M9HG.createNativeOscillatorNodeFactory)($ef52a87194a4fc85$var$addSilentConnection, $ef52a87194a4fc85$var$cacheTestResult, (0, $lR5Oy.testAudioScheduledSourceNodeStartMethodNegativeParametersSupport), (0, $aDnGz.testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport), (0, $lmHG7.testAudioScheduledSourceNodeStopMethodNegativeParametersSupport), (0, $kMO8J.wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls));
const $ef52a87194a4fc85$var$createOscillatorNodeRenderer = (0, $1KjDM.createOscillatorNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeOscillatorNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$f44e83cdc55961f2 = (0, $ch2aF.createOscillatorNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createNativeOscillatorNode, $ef52a87194a4fc85$var$createOscillatorNodeRenderer, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, (0, $4f1Kq.wrapEventListener));
const $ef52a87194a4fc85$var$createConnectedNativeAudioBufferSourceNode = (0, $gbvfd.createConnectedNativeAudioBufferSourceNodeFactory)($ef52a87194a4fc85$var$createNativeAudioBufferSourceNode);
const $ef52a87194a4fc85$var$createNativeWaveShaperNodeFaker = (0, $aOLPL.createNativeWaveShaperNodeFakerFactory)($ef52a87194a4fc85$var$createConnectedNativeAudioBufferSourceNode, (0, $2meOO.createInvalidStateError), (0, $fsgHl.createNativeGainNode), (0, $1Lq6V.isDCCurve), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativeWaveShaperNode = (0, $avKWH.createNativeWaveShaperNodeFactory)($ef52a87194a4fc85$var$createConnectedNativeAudioBufferSourceNode, (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeWaveShaperNodeFaker, (0, $1Lq6V.isDCCurve), $ef52a87194a4fc85$var$monitorConnections, $ef52a87194a4fc85$var$nativeAudioContextConstructor, (0, $gBkDC.overwriteAccessors));
const $ef52a87194a4fc85$var$createNativePannerNodeFaker = (0, $5dTI0.createNativePannerNodeFakerFactory)((0, $kMIy9.connectNativeAudioNodeToNativeAudioNode), (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeChannelMergerNode, (0, $fsgHl.createNativeGainNode), (0, $4JxZu.createNativeScriptProcessorNode), $ef52a87194a4fc85$var$createNativeWaveShaperNode, (0, $2Xpjk.createNotSupportedError), (0, $3TZtj.disconnectNativeAudioNodeFromNativeAudioNode), (0, $bvS5t.getFirstSample), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativePannerNode = (0, $8BXEl.createNativePannerNodeFactory)($ef52a87194a4fc85$var$createNativePannerNodeFaker);
const $ef52a87194a4fc85$var$createPannerNodeRenderer = (0, $1Jt2R.createPannerNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeChannelMergerNode, $ef52a87194a4fc85$var$createNativeConstantSourceNode, (0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$createNativePannerNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor, $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode, $ef52a87194a4fc85$var$renderNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$dafa2f26c98332af = (0, $fTCQm.createPannerNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createNativePannerNode, $ef52a87194a4fc85$var$createPannerNodeRenderer, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$createNativePeriodicWave = (0, $fSrsH.createNativePeriodicWaveFactory)((0, $lcODi.createIndexSizeError));
const $ef52a87194a4fc85$export$6b71e63ac9d62aa3 = (0, $33XCT.createPeriodicWaveConstructor)($ef52a87194a4fc85$var$createNativePeriodicWave, $ef52a87194a4fc85$var$getNativeContext, new WeakSet(), (0, $jWIYf.sanitizePeriodicWaveOptions));
const $ef52a87194a4fc85$var$nativeStereoPannerNodeFakerFactory = (0, $gcGjK.createNativeStereoPannerNodeFakerFactory)($ef52a87194a4fc85$var$createNativeChannelMergerNode, (0, $l5Ydn.createNativeChannelSplitterNode), (0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$createNativeWaveShaperNode, (0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativeStereoPannerNode = (0, $1rkne.createNativeStereoPannerNodeFactory)($ef52a87194a4fc85$var$nativeStereoPannerNodeFakerFactory, (0, $2Xpjk.createNotSupportedError));
const $ef52a87194a4fc85$var$createStereoPannerNodeRenderer = (0, $5dA3Y.createStereoPannerNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$createNativeStereoPannerNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$4ee0e4c1628c69a6 = (0, $23gcm.createStereoPannerNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createNativeStereoPannerNode, $ef52a87194a4fc85$var$createStereoPannerNodeRenderer, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$createWaveShaperNodeRenderer = (0, $5jZnB.createWaveShaperNodeRendererFactory)($ef52a87194a4fc85$var$createNativeWaveShaperNode, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$renderInputsOfAudioNode);
const $ef52a87194a4fc85$export$400071720810ca26 = (0, $l4IjU.createWaveShaperNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeWaveShaperNode, $ef52a87194a4fc85$var$createWaveShaperNodeRenderer, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$setAudioNodeTailTime);
const $ef52a87194a4fc85$var$isSecureContext = (0, $bfUi1.createIsSecureContext)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$exposeCurrentFrameAndCurrentTime = (0, $8Az4B.createExposeCurrentFrameAndCurrentTime)($ef52a87194a4fc85$var$window);
const $ef52a87194a4fc85$var$backupOfflineAudioContextStore = new WeakMap();
const $ef52a87194a4fc85$var$getOrCreateBackupOfflineAudioContext = (0, $8fnKQ.createGetOrCreateBackupOfflineAudioContext)($ef52a87194a4fc85$var$backupOfflineAudioContextStore, $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor);
const $ef52a87194a4fc85$export$f820757b6d3df312 = $ef52a87194a4fc85$var$isSecureContext ? (0, $40Hzv.createAddAudioWorkletModule)($ef52a87194a4fc85$var$cacheTestResult, (0, $2Xpjk.createNotSupportedError), (0, $8YAdg.createEvaluateSource)($ef52a87194a4fc85$var$window), $ef52a87194a4fc85$var$exposeCurrentFrameAndCurrentTime, (0, $6HEHv.createFetchSource)((0, $VuCGR.createAbortError)), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$getOrCreateBackupOfflineAudioContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor, new WeakMap(), new WeakMap(), (0, $7vJJE.createTestAudioWorkletProcessorPostMessageSupport)($ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor, $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), // @todo window is guaranteed to be defined because isSecureContext checks that as well.
$ef52a87194a4fc85$var$window) : undefined;
const $ef52a87194a4fc85$var$isNativeContext = (0, $ddkZL.createIsNativeContext)($ef52a87194a4fc85$var$isNativeAudioContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$1fbfb80f24dc90ea = (0, $5esAO.createDecodeAudioData)($ef52a87194a4fc85$var$audioBufferStore, $ef52a87194a4fc85$var$cacheTestResult, (0, $7EdX6.createDataCloneError), (0, $2tXK8.createEncodingError), new WeakSet(), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeContext, (0, $4tJKf.testAudioBufferCopyChannelMethodsOutOfBoundsSupport), (0, $7GhDt.testPromiseSupport), $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethods, $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $ef52a87194a4fc85$var$baseAudioContextConstructor = (0, $1xttk.createBaseAudioContextConstructor)($ef52a87194a4fc85$export$f820757b6d3df312, $ef52a87194a4fc85$export$ed204192bbbabcef, $ef52a87194a4fc85$export$2dbca7d91f7769d7, $ef52a87194a4fc85$export$c1b1480edd16e065, $ef52a87194a4fc85$export$f068340fbfd684eb, $ef52a87194a4fc85$export$7488bfd772ec10fc, $ef52a87194a4fc85$export$6f860927b3cf75c1, $ef52a87194a4fc85$export$d394f3dc072b3480, $ef52a87194a4fc85$export$20cfee6cb9c5d644, $ef52a87194a4fc85$export$1fbfb80f24dc90ea, $ef52a87194a4fc85$export$ce8664483cc583db, $ef52a87194a4fc85$export$c74a663d797d02ba, $ef52a87194a4fc85$export$db147ea22bd7e3ce, $ef52a87194a4fc85$export$81c00f34825a7708, $ef52a87194a4fc85$var$minimalBaseAudioContextConstructor, $ef52a87194a4fc85$export$f44e83cdc55961f2, $ef52a87194a4fc85$export$dafa2f26c98332af, $ef52a87194a4fc85$export$6b71e63ac9d62aa3, $ef52a87194a4fc85$export$4ee0e4c1628c69a6, $ef52a87194a4fc85$export$400071720810ca26);
const $ef52a87194a4fc85$export$cbdfd9619c90296e = (0, $cLoIk.createMediaElementAudioSourceNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, (0, $aqiBQ.createNativeMediaElementAudioSourceNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$3ebbc22363b821ba = (0, $6pgET.createMediaStreamAudioDestinationNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, (0, $54cQo.createNativeMediaStreamAudioDestinationNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$57f554392102e4c0 = (0, $dL2WA.createMediaStreamAudioSourceNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, (0, $7Mr4p.createNativeMediaStreamAudioSourceNode), $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$createNativeMediaStreamTrackAudioSourceNode = (0, $dCMVF.createNativeMediaStreamTrackAudioSourceNodeFactory)((0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$b6c8ffccaed2d826 = (0, $ddFUI.createMediaStreamTrackAudioSourceNodeConstructor)($ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createNativeMediaStreamTrackAudioSourceNode, $ef52a87194a4fc85$var$getNativeContext);
const $ef52a87194a4fc85$export$fcbc63750ec2a81f = (0, $lxNbI.createAudioContextConstructor)($ef52a87194a4fc85$var$baseAudioContextConstructor, (0, $2meOO.createInvalidStateError), (0, $2Xpjk.createNotSupportedError), (0, $bw7LY.createUnknownError), $ef52a87194a4fc85$export$cbdfd9619c90296e, $ef52a87194a4fc85$export$3ebbc22363b821ba, $ef52a87194a4fc85$export$57f554392102e4c0, $ef52a87194a4fc85$export$b6c8ffccaed2d826, $ef52a87194a4fc85$var$nativeAudioContextConstructor);
const $ef52a87194a4fc85$var$getUnrenderedAudioWorkletNodes = (0, $dhmx6.createGetUnrenderedAudioWorkletNodes)($ef52a87194a4fc85$var$unrenderedAudioWorkletNodeStore);
const $ef52a87194a4fc85$var$addUnrenderedAudioWorkletNode = (0, $b579J.createAddUnrenderedAudioWorkletNode)($ef52a87194a4fc85$var$getUnrenderedAudioWorkletNodes);
const $ef52a87194a4fc85$var$connectMultipleOutputs = (0, $5pRJO.createConnectMultipleOutputs)((0, $lcODi.createIndexSizeError));
const $ef52a87194a4fc85$var$deleteUnrenderedAudioWorkletNode = (0, $erHzM.createDeleteUnrenderedAudioWorkletNode)($ef52a87194a4fc85$var$getUnrenderedAudioWorkletNodes);
const $ef52a87194a4fc85$var$disconnectMultipleOutputs = (0, $lvVTt.createDisconnectMultipleOutputs)((0, $lcODi.createIndexSizeError));
const $ef52a87194a4fc85$var$activeAudioWorkletNodeInputsStore = new WeakMap();
const $ef52a87194a4fc85$var$getActiveAudioWorkletNodeInputs = (0, $7eDuD.createGetActiveAudioWorkletNodeInputs)($ef52a87194a4fc85$var$activeAudioWorkletNodeInputsStore, (0, $8sbmW.getValueForKey));
const $ef52a87194a4fc85$var$createNativeAudioWorkletNodeFaker = (0, $85FbK.createNativeAudioWorkletNodeFakerFactory)($ef52a87194a4fc85$var$connectMultipleOutputs, (0, $lcODi.createIndexSizeError), (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeChannelMergerNode, (0, $l5Ydn.createNativeChannelSplitterNode), $ef52a87194a4fc85$var$createNativeConstantSourceNode, (0, $fsgHl.createNativeGainNode), (0, $4JxZu.createNativeScriptProcessorNode), (0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$disconnectMultipleOutputs, $ef52a87194a4fc85$var$exposeCurrentFrameAndCurrentTime, $ef52a87194a4fc85$var$getActiveAudioWorkletNodeInputs, $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createNativeAudioWorkletNode = (0, $dPTmN.createNativeAudioWorkletNodeFactory)((0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeAudioWorkletNodeFaker, (0, $fsgHl.createNativeGainNode), (0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$monitorConnections);
const $ef52a87194a4fc85$var$createAudioWorkletNodeRenderer = (0, $8yjbp.createAudioWorkletNodeRendererFactory)($ef52a87194a4fc85$var$connectAudioParam, $ef52a87194a4fc85$var$connectMultipleOutputs, $ef52a87194a4fc85$var$createNativeAudioBufferSourceNode, $ef52a87194a4fc85$var$createNativeChannelMergerNode, (0, $l5Ydn.createNativeChannelSplitterNode), $ef52a87194a4fc85$var$createNativeConstantSourceNode, (0, $fsgHl.createNativeGainNode), $ef52a87194a4fc85$var$deleteUnrenderedAudioWorkletNode, $ef52a87194a4fc85$var$disconnectMultipleOutputs, $ef52a87194a4fc85$var$exposeCurrentFrameAndCurrentTime, (0, $eSkbj.getNativeAudioNode), $ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor, $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor, $ef52a87194a4fc85$var$renderAutomation, $ef52a87194a4fc85$var$renderInputsOfAudioNode, $ef52a87194a4fc85$var$renderNativeOfflineAudioContext);
const $ef52a87194a4fc85$var$getBackupOfflineAudioContext = (0, $jP1v0.createGetBackupOfflineAudioContext)($ef52a87194a4fc85$var$backupOfflineAudioContextStore);
const $ef52a87194a4fc85$var$setActiveAudioWorkletNodeInputs = (0, $jiZoz.createSetActiveAudioWorkletNodeInputs)($ef52a87194a4fc85$var$activeAudioWorkletNodeInputsStore);
// The AudioWorkletNode constructor is only available in a SecureContext.
const $ef52a87194a4fc85$export$bc6715221481535 = $ef52a87194a4fc85$var$isSecureContext ? (0, $a93CL.createAudioWorkletNodeConstructor)($ef52a87194a4fc85$var$addUnrenderedAudioWorkletNode, $ef52a87194a4fc85$var$audioNodeConstructor, $ef52a87194a4fc85$var$createAudioParam, $ef52a87194a4fc85$var$createAudioWorkletNodeRenderer, $ef52a87194a4fc85$var$createNativeAudioWorkletNode, (0, $aO4oU.getAudioNodeConnections), $ef52a87194a4fc85$var$getBackupOfflineAudioContext, $ef52a87194a4fc85$var$getNativeContext, $ef52a87194a4fc85$var$isNativeOfflineAudioContext, $ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor, (0, $M07bQ.sanitizeAudioWorkletNodeOptions), $ef52a87194a4fc85$var$setActiveAudioWorkletNodeInputs, (0, $a2LmX.testAudioWorkletNodeOptionsClonability), (0, $4f1Kq.wrapEventListener)) : undefined;
const $ef52a87194a4fc85$export$898a44341df73d6e = (0, $lC4rh.createMinimalAudioContextConstructor)((0, $2meOO.createInvalidStateError), (0, $2Xpjk.createNotSupportedError), (0, $bw7LY.createUnknownError), $ef52a87194a4fc85$var$minimalBaseAudioContextConstructor, $ef52a87194a4fc85$var$nativeAudioContextConstructor);
const $ef52a87194a4fc85$var$createNativeOfflineAudioContext = (0, $cmh9R.createCreateNativeOfflineAudioContext)((0, $2Xpjk.createNotSupportedError), $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor);
const $ef52a87194a4fc85$var$startRendering = (0, $2qNtl.createStartRendering)($ef52a87194a4fc85$var$audioBufferStore, $ef52a87194a4fc85$var$cacheTestResult, $ef52a87194a4fc85$var$getAudioNodeRenderer, $ef52a87194a4fc85$var$getUnrenderedAudioWorkletNodes, $ef52a87194a4fc85$var$renderNativeOfflineAudioContext, (0, $4tJKf.testAudioBufferCopyChannelMethodsOutOfBoundsSupport), $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethods, $ef52a87194a4fc85$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $ef52a87194a4fc85$export$a6f995d32126fe2e = (0, $lhsPn.createMinimalOfflineAudioContextConstructor)($ef52a87194a4fc85$var$cacheTestResult, (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeOfflineAudioContext, $ef52a87194a4fc85$var$minimalBaseAudioContextConstructor, $ef52a87194a4fc85$var$startRendering);
const $ef52a87194a4fc85$export$5ab5c649a10df7db = (0, $1u2fI.createOfflineAudioContextConstructor)($ef52a87194a4fc85$var$baseAudioContextConstructor, $ef52a87194a4fc85$var$cacheTestResult, (0, $2meOO.createInvalidStateError), $ef52a87194a4fc85$var$createNativeOfflineAudioContext, $ef52a87194a4fc85$var$startRendering);
const $ef52a87194a4fc85$export$e55e427bf52f793d = (0, $7yfCk.createIsAnyAudioContext)((0, $kBpIy.CONTEXT_STORE), $ef52a87194a4fc85$var$isNativeAudioContext);
const $ef52a87194a4fc85$export$61ea8ea4691b9a32 = (0, $ctUWa.createIsAnyAudioNode)((0, $kBpIy.AUDIO_NODE_STORE), $ef52a87194a4fc85$var$isNativeAudioNode);
const $ef52a87194a4fc85$export$254dcc24b342c8c2 = (0, $dT9fA.createIsAnyAudioParam)((0, $kBpIy.AUDIO_PARAM_STORE), $ef52a87194a4fc85$var$isNativeAudioParam);
const $ef52a87194a4fc85$export$e78994f7990ad5d3 = (0, $9Vj4x.createIsAnyOfflineAudioContext)((0, $kBpIy.CONTEXT_STORE), $ef52a87194a4fc85$var$isNativeOfflineAudioContext);
const $ef52a87194a4fc85$export$48c17662a6902497 = ()=>(0, $12TK4.createIsSupportedPromise)($ef52a87194a4fc85$var$cacheTestResult, (0, $9Vu0K.createTestAudioBufferCopyChannelMethodsSubarraySupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $dm3GZ.createTestAudioContextCloseMethodSupport)($ef52a87194a4fc85$var$nativeAudioContextConstructor), (0, $boP90.createTestAudioContextDecodeAudioDataMethodTypeErrorSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $7R2vO.createTestAudioContextOptionsSupport)($ef52a87194a4fc85$var$nativeAudioContextConstructor), (0, $70Bin.createTestAudioNodeConnectMethodSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $gg7IJ.createTestAudioWorkletProcessorNoOutputsSupport)($ef52a87194a4fc85$var$nativeAudioWorkletNodeConstructor, $ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $kLLxn.createTestChannelMergerNodeChannelCountSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $cAjwK.createTestConstantSourceNodeAccurateSchedulingSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $emUIu.createTestConvolverNodeBufferReassignabilitySupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $71zf0.createTestConvolverNodeChannelCountSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $fJusW.testDomExceptionConstructorSupport), (0, $bCo2C.createTestIsSecureContextSupport)($ef52a87194a4fc85$var$window), (0, $gtvtQ.createTestMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport)($ef52a87194a4fc85$var$nativeAudioContextConstructor), (0, $hqy8F.createTestStereoPannerNodeDefaultValueSupport)($ef52a87194a4fc85$var$nativeOfflineAudioContextConstructor), (0, $kE4Bl.testTransferablesSupport));

});
parcelRegister("hOQY6", function(module, exports) {



(function(global, factory) {
    factory(module.exports, (parcelRequire("9gsbX")), (parcelRequire("iDCuG")), (parcelRequire("fAqwD")));
})(module.exports, function(exports1, _slicedToArray, _classCallCheck, _createClass) {
    'use strict';
    var createExtendedExponentialRampToValueAutomationEvent = function createExtendedExponentialRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createExtendedLinearRampToValueAutomationEvent = function createExtendedLinearRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetValueAutomationEvent = function createSetValueAutomationEvent(value, startTime) {
        return {
            startTime: startTime,
            type: 'setValue',
            value: value
        };
    };
    var createSetValueCurveAutomationEvent = function createSetValueCurveAutomationEvent(values, startTime, duration) {
        return {
            duration: duration,
            startTime: startTime,
            type: 'setValueCurve',
            values: values
        };
    };
    var getTargetValueAtTime = function getTargetValueAtTime(time, valueAtStartTime, _ref) {
        var startTime = _ref.startTime, target = _ref.target, timeConstant = _ref.timeConstant;
        return target + (valueAtStartTime - target) * Math.exp((startTime - time) / timeConstant);
    };
    var isExponentialRampToValueAutomationEvent = function isExponentialRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'exponentialRampToValue';
    };
    var isLinearRampToValueAutomationEvent = function isLinearRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'linearRampToValue';
    };
    var isAnyRampToValueAutomationEvent = function isAnyRampToValueAutomationEvent(automationEvent) {
        return isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent);
    };
    var isSetValueAutomationEvent = function isSetValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValue';
    };
    var isSetValueCurveAutomationEvent = function isSetValueCurveAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValueCurve';
    };
    var getValueOfAutomationEventAtIndexAtTime = function getValueOfAutomationEventAtIndexAtTime(automationEvents, index, time, defaultValue) {
        var automationEvent = automationEvents[index];
        return automationEvent === undefined ? defaultValue : isAnyRampToValueAutomationEvent(automationEvent) || isSetValueAutomationEvent(automationEvent) ? automationEvent.value : isSetValueCurveAutomationEvent(automationEvent) ? automationEvent.values[automationEvent.values.length - 1] : getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, automationEvent.startTime, defaultValue), automationEvent);
    };
    var getEndTimeAndValueOfPreviousAutomationEvent = function getEndTimeAndValueOfPreviousAutomationEvent(automationEvents, index, currentAutomationEvent, nextAutomationEvent, defaultValue) {
        return currentAutomationEvent === undefined ? [
            nextAutomationEvent.insertTime,
            defaultValue
        ] : isAnyRampToValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.endTime,
            currentAutomationEvent.value
        ] : isSetValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime,
            currentAutomationEvent.value
        ] : isSetValueCurveAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime + currentAutomationEvent.duration,
            currentAutomationEvent.values[currentAutomationEvent.values.length - 1]
        ] : [
            currentAutomationEvent.startTime,
            getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, currentAutomationEvent.startTime, defaultValue)
        ];
    };
    var isCancelAndHoldAutomationEvent = function isCancelAndHoldAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelAndHold';
    };
    var isCancelScheduledValuesAutomationEvent = function isCancelScheduledValuesAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelScheduledValues';
    };
    var getEventTime = function getEventTime(automationEvent) {
        if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) return automationEvent.cancelTime;
        if (isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent)) return automationEvent.endTime;
        return automationEvent.startTime;
    };
    var getExponentialRampValueAtTime = function getExponentialRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        if (valueAtStartTime === value) return value;
        if (0 < valueAtStartTime && 0 < value || valueAtStartTime < 0 && value < 0) return valueAtStartTime * Math.pow(value / valueAtStartTime, (time - startTime) / (endTime - startTime));
        return 0;
    };
    var getLinearRampValueAtTime = function getLinearRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        return valueAtStartTime + (time - startTime) / (endTime - startTime) * (value - valueAtStartTime);
    };
    var interpolateValue = function interpolateValue(values, theoreticIndex) {
        var lowerIndex = Math.floor(theoreticIndex);
        var upperIndex = Math.ceil(theoreticIndex);
        if (lowerIndex === upperIndex) return values[lowerIndex];
        return (1 - (theoreticIndex - lowerIndex)) * values[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * values[upperIndex];
    };
    var getValueCurveValueAtTime = function getValueCurveValueAtTime(time, _ref) {
        var duration = _ref.duration, startTime = _ref.startTime, values = _ref.values;
        var theoreticIndex = (time - startTime) / duration * (values.length - 1);
        return interpolateValue(values, theoreticIndex);
    };
    var isSetTargetAutomationEvent = function isSetTargetAutomationEvent(automationEvent) {
        return automationEvent.type === 'setTarget';
    };
    var AutomationEventList = /*#__PURE__*/ function(_Symbol$iterator) {
        function AutomationEventList(defaultValue) {
            _classCallCheck(this, AutomationEventList);
            this._automationEvents = [];
            this._currenTime = 0;
            this._defaultValue = defaultValue;
        }
        _createClass(AutomationEventList, [
            {
                key: _Symbol$iterator,
                value: function value() {
                    return this._automationEvents[Symbol.iterator]();
                }
            },
            {
                key: "add",
                value: function add(automationEvent) {
                    var eventTime = getEventTime(automationEvent);
                    if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
                        var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            if (isCancelScheduledValuesAutomationEvent(automationEvent) && isSetValueCurveAutomationEvent(currentAutomationEvent)) return currentAutomationEvent.startTime + currentAutomationEvent.duration >= eventTime;
                            return getEventTime(currentAutomationEvent) >= eventTime;
                        });
                        var removedAutomationEvent = this._automationEvents[index];
                        if (index !== -1) this._automationEvents = this._automationEvents.slice(0, index);
                        if (isCancelAndHoldAutomationEvent(automationEvent)) {
                            var lastAutomationEvent = this._automationEvents[this._automationEvents.length - 1];
                            if (removedAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(removedAutomationEvent)) {
                                if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) throw new Error('The internal list is malformed.');
                                var startTime = lastAutomationEvent === undefined ? removedAutomationEvent.insertTime : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.startTime + lastAutomationEvent.duration : getEventTime(lastAutomationEvent);
                                var startValue = lastAutomationEvent === undefined ? this._defaultValue : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.values[lastAutomationEvent.values.length - 1] : lastAutomationEvent.value;
                                var value = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? getExponentialRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent) : getLinearRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent);
                                var truncatedAutomationEvent = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? createExtendedExponentialRampToValueAutomationEvent(value, eventTime, this._currenTime) : createExtendedLinearRampToValueAutomationEvent(value, eventTime, this._currenTime);
                                this._automationEvents.push(truncatedAutomationEvent);
                            }
                            if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) this._automationEvents.push(createSetValueAutomationEvent(this.getValue(eventTime), eventTime));
                            if (lastAutomationEvent !== undefined && isSetValueCurveAutomationEvent(lastAutomationEvent) && lastAutomationEvent.startTime + lastAutomationEvent.duration > eventTime) {
                                var duration = eventTime - lastAutomationEvent.startTime;
                                var ratio = (lastAutomationEvent.values.length - 1) / lastAutomationEvent.duration;
                                var length = Math.max(2, 1 + Math.ceil(duration * ratio));
                                var fraction = duration / (length - 1) * ratio;
                                var values = lastAutomationEvent.values.slice(0, length);
                                if (fraction < 1) for(var i = 1; i < length; i += 1){
                                    var factor = fraction * i % 1;
                                    values[i] = lastAutomationEvent.values[i - 1] * (1 - factor) + lastAutomationEvent.values[i] * factor;
                                }
                                this._automationEvents[this._automationEvents.length - 1] = createSetValueCurveAutomationEvent(values, lastAutomationEvent.startTime, duration);
                            }
                        }
                    } else {
                        var _index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            return getEventTime(currentAutomationEvent) > eventTime;
                        });
                        var previousAutomationEvent = _index === -1 ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[_index - 1];
                        if (previousAutomationEvent !== undefined && isSetValueCurveAutomationEvent(previousAutomationEvent) && getEventTime(previousAutomationEvent) + previousAutomationEvent.duration > eventTime) return false;
                        var persistentAutomationEvent = isExponentialRampToValueAutomationEvent(automationEvent) ? createExtendedExponentialRampToValueAutomationEvent(automationEvent.value, automationEvent.endTime, this._currenTime) : isLinearRampToValueAutomationEvent(automationEvent) ? createExtendedLinearRampToValueAutomationEvent(automationEvent.value, eventTime, this._currenTime) : automationEvent;
                        if (_index === -1) this._automationEvents.push(persistentAutomationEvent);
                        else {
                            if (isSetValueCurveAutomationEvent(automationEvent) && eventTime + automationEvent.duration > getEventTime(this._automationEvents[_index])) return false;
                            this._automationEvents.splice(_index, 0, persistentAutomationEvent);
                        }
                    }
                    return true;
                }
            },
            {
                key: "flush",
                value: function flush(time) {
                    var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                        return getEventTime(currentAutomationEvent) > time;
                    });
                    if (index > 1) {
                        var remainingAutomationEvents = this._automationEvents.slice(index - 1);
                        var firstRemainingAutomationEvent = remainingAutomationEvents[0];
                        if (isSetTargetAutomationEvent(firstRemainingAutomationEvent)) remainingAutomationEvents.unshift(createSetValueAutomationEvent(getValueOfAutomationEventAtIndexAtTime(this._automationEvents, index - 2, firstRemainingAutomationEvent.startTime, this._defaultValue), firstRemainingAutomationEvent.startTime));
                        this._automationEvents = remainingAutomationEvents;
                    }
                }
            },
            {
                key: "getValue",
                value: function getValue(time) {
                    if (this._automationEvents.length === 0) return this._defaultValue;
                    var indexOfNextEvent = this._automationEvents.findIndex(function(automationEvent) {
                        return getEventTime(automationEvent) > time;
                    });
                    var nextAutomationEvent = this._automationEvents[indexOfNextEvent];
                    var indexOfCurrentEvent = (indexOfNextEvent === -1 ? this._automationEvents.length : indexOfNextEvent) - 1;
                    var currentAutomationEvent = this._automationEvents[indexOfCurrentEvent];
                    if (currentAutomationEvent !== undefined && isSetTargetAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || nextAutomationEvent.insertTime > time)) return getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(this._automationEvents, indexOfCurrentEvent - 1, currentAutomationEvent.startTime, this._defaultValue), currentAutomationEvent);
                    if (currentAutomationEvent !== undefined && isSetValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (currentAutomationEvent !== undefined && isSetValueCurveAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || currentAutomationEvent.startTime + currentAutomationEvent.duration > time)) {
                        if (time < currentAutomationEvent.startTime + currentAutomationEvent.duration) return getValueCurveValueAtTime(time, currentAutomationEvent);
                        return currentAutomationEvent.values[currentAutomationEvent.values.length - 1];
                    }
                    if (currentAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (nextAutomationEvent !== undefined && isExponentialRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf2 = _slicedToArray(_getEndTimeAndValueOf, 2), startTime = _getEndTimeAndValueOf2[0], value = _getEndTimeAndValueOf2[1];
                        return getExponentialRampValueAtTime(time, startTime, value, nextAutomationEvent);
                    }
                    if (nextAutomationEvent !== undefined && isLinearRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf3 = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf4 = _slicedToArray(_getEndTimeAndValueOf3, 2), _startTime = _getEndTimeAndValueOf4[0], _value = _getEndTimeAndValueOf4[1];
                        return getLinearRampValueAtTime(time, _startTime, _value, nextAutomationEvent);
                    }
                    return this._defaultValue;
                }
            }
        ]);
        return AutomationEventList;
    }(Symbol.iterator);
    var createCancelAndHoldAutomationEvent = function createCancelAndHoldAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelAndHold'
        };
    };
    var createCancelScheduledValuesAutomationEvent = function createCancelScheduledValuesAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelScheduledValues'
        };
    };
    var createExponentialRampToValueAutomationEvent = function createExponentialRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createLinearRampToValueAutomationEvent = function createLinearRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetTargetAutomationEvent = function createSetTargetAutomationEvent(target, startTime, timeConstant) {
        return {
            startTime: startTime,
            target: target,
            timeConstant: timeConstant,
            type: 'setTarget'
        };
    };
    exports1.AutomationEventList = AutomationEventList;
    exports1.createCancelAndHoldAutomationEvent = createCancelAndHoldAutomationEvent;
    exports1.createCancelScheduledValuesAutomationEvent = createCancelScheduledValuesAutomationEvent;
    exports1.createExponentialRampToValueAutomationEvent = createExponentialRampToValueAutomationEvent;
    exports1.createLinearRampToValueAutomationEvent = createLinearRampToValueAutomationEvent;
    exports1.createSetTargetAutomationEvent = createSetTargetAutomationEvent;
    exports1.createSetValueAutomationEvent = createSetValueAutomationEvent;
    exports1.createSetValueCurveAutomationEvent = createSetValueCurveAutomationEvent;
});

});
parcelRegister("9gsbX", function(module, exports) {

var $7aIce = parcelRequire("7aIce");

var $iT2rD = parcelRequire("iT2rD");

var $5k3iG = parcelRequire("5k3iG");

var $hiBQt = parcelRequire("hiBQt");
function $6beb79f9435ab463$var$_slicedToArray(arr, i) {
    return $7aIce(arr) || $iT2rD(arr, i) || $5k3iG(arr, i) || $hiBQt();
}
module.exports = $6beb79f9435ab463$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7aIce", function(module, exports) {
function $538bc00736e27731$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $538bc00736e27731$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iT2rD", function(module, exports) {
function $dbff428584a951fa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $dbff428584a951fa$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5k3iG", function(module, exports) {

var $OpJR1 = parcelRequire("OpJR1");
function $3e01616426bc0774$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $OpJR1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $OpJR1(o, minLen);
}
module.exports = $3e01616426bc0774$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("OpJR1", function(module, exports) {
function $0978a2c5ded8b830$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $0978a2c5ded8b830$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hiBQt", function(module, exports) {
function $c9817962d0cbc0dc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c9817962d0cbc0dc$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iDCuG", function(module, exports) {
function $d919ba9c303fb5f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d919ba9c303fb5f5$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fAqwD", function(module, exports) {

var $68oWB = parcelRequire("68oWB");
function $b58ecb379a8496e7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $68oWB(descriptor.key), descriptor);
    }
}
function $b58ecb379a8496e7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b58ecb379a8496e7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b58ecb379a8496e7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $b58ecb379a8496e7$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("68oWB", function(module, exports) {

var $cJNrf = parcelRequire("cJNrf");
var $4776d6d9c6c13a61$var$_typeof = $cJNrf.default;

var $eE63w = parcelRequire("eE63w");
function $4776d6d9c6c13a61$var$toPropertyKey(t) {
    var i = $eE63w(t, "string");
    return "symbol" == $4776d6d9c6c13a61$var$_typeof(i) ? i : String(i);
}
module.exports = $4776d6d9c6c13a61$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cJNrf", function(module, exports) {
function $9460096fea0e4bc3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9460096fea0e4bc3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9460096fea0e4bc3$var$_typeof(o);
}
module.exports = $9460096fea0e4bc3$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eE63w", function(module, exports) {

var $cJNrf = parcelRequire("cJNrf");
var $aa997fae0d2a4cc6$var$_typeof = $cJNrf.default;
function $aa997fae0d2a4cc6$var$toPrimitive(t, r) {
    if ("object" != $aa997fae0d2a4cc6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aa997fae0d2a4cc6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $aa997fae0d2a4cc6$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("VuCGR", function(module, exports) {

$parcel$export(module.exports, "createAbortError", () => $0acd14154931584f$export$aff31bd5258e9fd4);
const $0acd14154931584f$export$aff31bd5258e9fd4 = ()=>new DOMException('', 'AbortError');

});

parcelRegister("d2N7B", function(module, exports) {

$parcel$export(module.exports, "createAddActiveInputConnectionToAudioNode", () => $97f190c7bb5328af$export$43d20cccdc976834);
const $97f190c7bb5328af$export$43d20cccdc976834 = (insertElementInSet)=>{
    return (activeInputs, source, [output, input, eventListener], ignoreDuplicates)=>{
        insertElementInSet(activeInputs[input], [
            source,
            output,
            eventListener
        ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
    };
};

});

parcelRegister("i8HIp", function(module, exports) {

$parcel$export(module.exports, "createAddAudioNodeConnections", () => $d34ae25003b3f249$export$7ff07578cebde522);
const $d34ae25003b3f249$export$7ff07578cebde522 = (audioNodeConnectionsStore)=>{
    return (audioNode, audioNodeRenderer, nativeAudioNode)=>{
        const activeInputs = [];
        for(let i = 0; i < nativeAudioNode.numberOfInputs; i += 1)activeInputs.push(new Set());
        audioNodeConnectionsStore.set(audioNode, {
            activeInputs: activeInputs,
            outputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioNodeRenderer
        });
    };
};

});

parcelRegister("a2tPB", function(module, exports) {

$parcel$export(module.exports, "createAddAudioParamConnections", () => $74f13b25d99ceb4e$export$25226f7a087f88c3);
const $74f13b25d99ceb4e$export$25226f7a087f88c3 = (audioParamConnectionsStore)=>{
    return (audioParam, audioParamRenderer)=>{
        audioParamConnectionsStore.set(audioParam, {
            activeInputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioParamRenderer
        });
    };
};

});

parcelRegister("40Hzv", function(module, exports) {

$parcel$export(module.exports, "createAddAudioWorkletModule", () => $2eb8f5efabc0f459$export$16c6049a33c70efa);

var $kBpIy = parcelRequire("kBpIy");

var $hnFVx = parcelRequire("hnFVx");

var $4Ecrg = parcelRequire("4Ecrg");
const $2eb8f5efabc0f459$var$verifyParameterDescriptors = (parameterDescriptors)=>{
    if (parameterDescriptors !== undefined && !Array.isArray(parameterDescriptors)) throw new TypeError('The parameterDescriptors property of given value for processorCtor is not an array.');
};
const $2eb8f5efabc0f459$var$verifyProcessorCtor = (processorCtor)=>{
    if (!(0, $hnFVx.isConstructible)(processorCtor)) throw new TypeError('The given value for processorCtor should be a constructor.');
    if (processorCtor.prototype === null || typeof processorCtor.prototype !== 'object') throw new TypeError('The given value for processorCtor should have a prototype.');
};
const $2eb8f5efabc0f459$export$16c6049a33c70efa = (cacheTestResult, createNotSupportedError, evaluateSource, exposeCurrentFrameAndCurrentTime, fetchSource, getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, ongoingRequests, resolvedRequests, testAudioWorkletProcessorPostMessageSupport, window)=>{
    let index = 0;
    return (context, moduleURL, options = {
        credentials: 'omit'
    })=>{
        const resolvedRequestsOfContext = resolvedRequests.get(context);
        if (resolvedRequestsOfContext !== undefined && resolvedRequestsOfContext.has(moduleURL)) return Promise.resolve();
        const ongoingRequestsOfContext = ongoingRequests.get(context);
        if (ongoingRequestsOfContext !== undefined) {
            const promiseOfOngoingRequest = ongoingRequestsOfContext.get(moduleURL);
            if (promiseOfOngoingRequest !== undefined) return promiseOfOngoingRequest;
        }
        const nativeContext = getNativeContext(context);
        // Bug #59: Safari does not implement the audioWorklet property.
        const promise = nativeContext.audioWorklet === undefined ? fetchSource(moduleURL).then(([source, absoluteUrl])=>{
            const [importStatements, sourceWithoutImportStatements] = (0, $4Ecrg.splitImportStatements)(source, absoluteUrl);
            /*
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * ${ importStatements };
                 * ((a, b) => {
                 *     (a[b] = a[b] || [ ]).push(
                 *         (AudioWorkletProcessor, global, registerProcessor, sampleRate, self, window) => {
                 *             ${ sourceWithoutImportStatements }
                 *         }
                 *     );
                 * })(window, '_AWGS');
                 * ```
                 */ // tslint:disable-next-line:max-line-length
            const wrappedSource = `${importStatements};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${sourceWithoutImportStatements}
})})(window,'_AWGS')`;
            // @todo Evaluating the given source code is a possible security problem.
            return evaluateSource(wrappedSource);
        }).then(()=>{
            const evaluateAudioWorkletGlobalScope = window._AWGS.pop();
            if (evaluateAudioWorkletGlobalScope === undefined) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            throw new SyntaxError();
            exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>evaluateAudioWorkletGlobalScope(class AudioWorkletProcessor {
                }, undefined, (name, processorCtor)=>{
                    if (name.trim() === '') throw createNotSupportedError();
                    const nodeNameToProcessorConstructorMap = (0, $kBpIy.NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS).get(nativeContext);
                    if (nodeNameToProcessorConstructorMap !== undefined) {
                        if (nodeNameToProcessorConstructorMap.has(name)) throw createNotSupportedError();
                        $2eb8f5efabc0f459$var$verifyProcessorCtor(processorCtor);
                        $2eb8f5efabc0f459$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        nodeNameToProcessorConstructorMap.set(name, processorCtor);
                    } else {
                        $2eb8f5efabc0f459$var$verifyProcessorCtor(processorCtor);
                        $2eb8f5efabc0f459$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        (0, $kBpIy.NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS).set(nativeContext, new Map([
                            [
                                name,
                                processorCtor
                            ]
                        ]));
                    }
                }, nativeContext.sampleRate, undefined, undefined));
        }) : Promise.all([
            fetchSource(moduleURL),
            Promise.resolve(cacheTestResult(testAudioWorkletProcessorPostMessageSupport, testAudioWorkletProcessorPostMessageSupport))
        ]).then(([[source, absoluteUrl], isSupportingPostMessage])=>{
            const currentIndex = index + 1;
            index = currentIndex;
            const [importStatements, sourceWithoutImportStatements] = (0, $4Ecrg.splitImportStatements)(source, absoluteUrl);
            /*
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * This is the unminified version of the code used below.
                 *
                 * ```js
                 * class extends AudioWorkletProcessor {
                 *
                 *     __buffers = new WeakSet();
                 *
                 *     constructor () {
                 *         super();
                 *
                 *         this.port.postMessage = ((postMessage) => {
                 *             return (message, transferables) => {
                 *                 const filteredTransferables = (transferables)
                 *                     ? transferables.filter((transferable) => !this.__buffers.has(transferable))
                 *                     : transferables;
                 *
                 *                 return postMessage.call(this.port, message, filteredTransferables);
                 *              };
                 *         })(this.port.postMessage);
                 *     }
                 * }
                 * ```
                 */ const patchedAudioWorkletProcessor = isSupportingPostMessage ? 'AudioWorkletProcessor' : 'class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}';
            /*
                 * Bug #170: Chrome and Edge do call process() with an array with empty channelData for each input if no input is connected.
                 *
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * Bug #190: Safari doesn't throw an error when loading an unparsable module.
                 *
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * `${ importStatements };
                 * ((AudioWorkletProcessor, registerProcessor) => {${ sourceWithoutImportStatements }
                 * })(
                 *     ${ patchedAudioWorkletProcessor },
                 *     (name, processorCtor) => registerProcessor(name, class extends processorCtor {
                 *
                 *         __collectBuffers = (array) => {
                 *             array.forEach((element) => this.__buffers.add(element.buffer));
                 *         };
                 *
                 *         process (inputs, outputs, parameters) {
                 *             inputs.forEach(this.__collectBuffers);
                 *             outputs.forEach(this.__collectBuffers);
                 *             this.__collectBuffers(Object.values(parameters));
                 *
                 *             return super.process(
                 *                 (inputs.map((input) => input.some((channelData) => channelData.length === 0)) ? [ ] : input),
                 *                 outputs,
                 *                 parameters
                 *             );
                 *         }
                 *
                 *     })
                 * );
                 *
                 * registerProcessor(`__sac${currentIndex}`, class extends AudioWorkletProcessor{
                 *
                 *     process () {
                 *         return false;
                 *     }
                 *
                 * })`
                 * ```
                 */ const memberDefinition = isSupportingPostMessage ? '' : '__c = (a) => a.forEach(e=>this.__b.add(e.buffer));';
            const bufferRegistration = isSupportingPostMessage ? '' : 'i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));';
            const wrappedSource = `${importStatements};((AudioWorkletProcessor,registerProcessor)=>{${sourceWithoutImportStatements}
})(${patchedAudioWorkletProcessor},(n,p)=>registerProcessor(n,class extends p{${memberDefinition}process(i,o,p){${bufferRegistration}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${currentIndex}',class extends AudioWorkletProcessor{process(){return !1}})`;
            const blob = new Blob([
                wrappedSource
            ], {
                type: 'application/javascript; charset=utf-8'
            });
            const url = URL.createObjectURL(blob);
            return nativeContext.audioWorklet.addModule(url, options).then(()=>{
                if (isNativeOfflineAudioContext(nativeContext)) return nativeContext;
                // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
                const backupOfflineAudioContext = getOrCreateBackupOfflineAudioContext(nativeContext);
                return backupOfflineAudioContext.audioWorklet.addModule(url, options).then(()=>backupOfflineAudioContext);
            }).then((nativeContextOrBackupOfflineAudioContext)=>{
                if (nativeAudioWorkletNodeConstructor === null) throw new SyntaxError();
                try {
                    // Bug #190: Safari doesn't throw an error when loading an unparsable module.
                    new nativeAudioWorkletNodeConstructor(nativeContextOrBackupOfflineAudioContext, `__sac${currentIndex}`); // tslint:disable-line:no-unused-expression
                } catch  {
                    throw new SyntaxError();
                }
            }).finally(()=>URL.revokeObjectURL(url));
        });
        if (ongoingRequestsOfContext === undefined) ongoingRequests.set(context, new Map([
            [
                moduleURL,
                promise
            ]
        ]));
        else ongoingRequestsOfContext.set(moduleURL, promise);
        promise.then(()=>{
            const updatedResolvedRequestsOfContext = resolvedRequests.get(context);
            if (updatedResolvedRequestsOfContext === undefined) resolvedRequests.set(context, new Set([
                moduleURL
            ]));
            else updatedResolvedRequestsOfContext.add(moduleURL);
        }).finally(()=>{
            const updatedOngoingRequestsOfContext = ongoingRequests.get(context);
            if (updatedOngoingRequestsOfContext !== undefined) updatedOngoingRequestsOfContext.delete(moduleURL);
        });
        return promise;
    };
};

});
parcelRegister("kBpIy", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_AUDIO_NODE_STORE", () => $effb36555e3146fc$export$2b500979aea0913f);
$parcel$export(module.exports, "AUDIO_NODE_CONNECTIONS_STORE", () => $effb36555e3146fc$export$61ca80a8c8c6d728);
$parcel$export(module.exports, "AUDIO_NODE_STORE", () => $effb36555e3146fc$export$864a3cfb55580d0c);
$parcel$export(module.exports, "AUDIO_PARAM_CONNECTIONS_STORE", () => $effb36555e3146fc$export$c5d3ff1f46a0185a);
$parcel$export(module.exports, "AUDIO_PARAM_STORE", () => $effb36555e3146fc$export$55484e3055c7a9e2);
$parcel$export(module.exports, "CONTEXT_STORE", () => $effb36555e3146fc$export$7d17302229276f06);
$parcel$export(module.exports, "EVENT_LISTENERS", () => $effb36555e3146fc$export$c998cfefa4fd5136);
$parcel$export(module.exports, "CYCLE_COUNTERS", () => $effb36555e3146fc$export$cf686a6a3e402092);
$parcel$export(module.exports, "NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS", () => $effb36555e3146fc$export$b9bea39f06f96914);
$parcel$export(module.exports, "NODE_TO_PROCESSOR_MAPS", () => $effb36555e3146fc$export$16d7878f7e059d67);
const $effb36555e3146fc$export$2b500979aea0913f = new WeakSet();
const $effb36555e3146fc$export$61ca80a8c8c6d728 = new WeakMap();
const $effb36555e3146fc$export$864a3cfb55580d0c = new WeakMap();
const $effb36555e3146fc$export$c5d3ff1f46a0185a = new WeakMap();
const $effb36555e3146fc$export$55484e3055c7a9e2 = new WeakMap();
const $effb36555e3146fc$export$7d17302229276f06 = new WeakMap();
const $effb36555e3146fc$export$c998cfefa4fd5136 = new WeakMap();
const $effb36555e3146fc$export$cf686a6a3e402092 = new WeakMap();
const $effb36555e3146fc$export$b9bea39f06f96914 = new WeakMap();
const $effb36555e3146fc$export$16d7878f7e059d67 = new WeakMap();

});

parcelRegister("hnFVx", function(module, exports) {

$parcel$export(module.exports, "isConstructible", () => $ca751b7bc31290cf$export$df064419399503e9);
const $ca751b7bc31290cf$var$handler = {
    construct () {
        return $ca751b7bc31290cf$var$handler;
    }
};
const $ca751b7bc31290cf$export$df064419399503e9 = (constructible)=>{
    try {
        const proxy = new Proxy(constructible, $ca751b7bc31290cf$var$handler);
        new proxy(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("4Ecrg", function(module, exports) {

$parcel$export(module.exports, "splitImportStatements", () => $36248bebb04260a0$export$949058cf055dbb57);
/*
 * This massive regex tries to cover all the following cases.
 *
 * import './path';
 * import defaultImport from './path';
 * import { namedImport } from './path';
 * import { namedImport as renamendImport } from './path';
 * import * as namespaceImport from './path';
 * import defaultImport, { namedImport } from './path';
 * import defaultImport, { namedImport as renamendImport } from './path';
 * import defaultImport, * as namespaceImport from './path';
 */ const $36248bebb04260a0$var$IMPORT_STATEMENT_REGEX = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/; // tslint:disable-line:max-line-length
const $36248bebb04260a0$export$949058cf055dbb57 = (source, url)=>{
    const importStatements = [];
    let sourceWithoutImportStatements = source.replace(/^[\s]+/, '');
    let result = sourceWithoutImportStatements.match($36248bebb04260a0$var$IMPORT_STATEMENT_REGEX);
    while(result !== null){
        const unresolvedUrl = result[1].slice(1, -1);
        const importStatementWithResolvedUrl = result[0].replace(/([\s]+)?;?$/, '').replace(unresolvedUrl, new URL(unresolvedUrl, url).toString());
        importStatements.push(importStatementWithResolvedUrl);
        sourceWithoutImportStatements = sourceWithoutImportStatements.slice(result[0].length).replace(/^[\s]+/, '');
        result = sourceWithoutImportStatements.match($36248bebb04260a0$var$IMPORT_STATEMENT_REGEX);
    }
    return [
        importStatements.join(';'),
        sourceWithoutImportStatements
    ];
};

});


parcelRegister("cTGW1", function(module, exports) {

$parcel$export(module.exports, "createAddConnectionToAudioNode", () => $963bed0be1e2325e$export$1776cf0d295db1d7);

var $1B14g = parcelRequire("1B14g");

var $hL1bO = parcelRequire("hL1bO");

var $ls87f = parcelRequire("ls87f");
const $963bed0be1e2325e$export$1776cf0d295db1d7 = (addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode)=>{
    const tailTimeTimeoutIds = new WeakMap();
    return (source, destination, output, input, isOffline)=>{
        const { activeInputs: activeInputs, passiveInputs: passiveInputs } = getAudioNodeConnections(destination);
        const { outputs: outputs } = getAudioNodeConnections(source);
        const eventListeners = getEventListenersOfAudioNode(source);
        const eventListener = (isActive)=>{
            const nativeDestinationAudioNode = getNativeAudioNode(destination);
            const nativeSourceAudioNode = getNativeAudioNode(source);
            if (isActive) {
                const partialConnection = (0, $1B14g.deletePassiveInputConnectionToAudioNode)(passiveInputs, source, output, input);
                addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                if (isPassiveAudioNode(destination)) (0, $hL1bO.setInternalStateToActive)(destination);
            } else {
                const partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);
                addPassiveInputConnectionToAudioNode(passiveInputs, input, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                const tailTime = getAudioNodeTailTime(destination);
                if (tailTime === 0) {
                    if (isActiveAudioNode(destination)) (0, $ls87f.setInternalStateToPassiveWhenNecessary)(destination, activeInputs);
                } else {
                    const tailTimeTimeoutId = tailTimeTimeoutIds.get(destination);
                    if (tailTimeTimeoutId !== undefined) clearTimeout(tailTimeTimeoutId);
                    tailTimeTimeoutIds.set(destination, setTimeout(()=>{
                        if (isActiveAudioNode(destination)) (0, $ls87f.setInternalStateToPassiveWhenNecessary)(destination, activeInputs);
                    }, tailTime * 1000));
                }
            }
        };
        if (insertElementInSet(outputs, [
            destination,
            output,
            input
        ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input, true)) {
            eventListeners.add(eventListener);
            if (isActiveAudioNode(source)) addActiveInputConnectionToAudioNode(activeInputs, source, [
                output,
                input,
                eventListener
            ], true);
            else addPassiveInputConnectionToAudioNode(passiveInputs, input, [
                source,
                output,
                eventListener
            ], true);
            return true;
        }
        return false;
    };
};

});
parcelRegister("1B14g", function(module, exports) {

$parcel$export(module.exports, "deletePassiveInputConnectionToAudioNode", () => $129a1333e878df51$export$26ec3ebc965d6cfd);

var $8sbmW = parcelRequire("8sbmW");

var $81KbS = parcelRequire("81KbS");
const $129a1333e878df51$export$26ec3ebc965d6cfd = (passiveInputs, source, output, input)=>{
    const passiveInputConnections = (0, $8sbmW.getValueForKey)(passiveInputs, source);
    const matchingConnection = (0, $81KbS.pickElementFromSet)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};

});
parcelRegister("8sbmW", function(module, exports) {

$parcel$export(module.exports, "getValueForKey", () => $6279c1eccee91d3d$export$520987e3ff3ffad3);
const $6279c1eccee91d3d$export$520987e3ff3ffad3 = (map, key)=>{
    const value = map.get(key);
    if (value === undefined) throw new Error('A value with the given key could not be found.');
    return value;
};

});

parcelRegister("81KbS", function(module, exports) {

$parcel$export(module.exports, "pickElementFromSet", () => $5d823f3b46794cc3$export$3f1b331b43a0e659);
const $5d823f3b46794cc3$export$3f1b331b43a0e659 = (set, predicate)=>{
    const matchingElements = Array.from(set).filter(predicate);
    if (matchingElements.length > 1) throw Error('More than one element was found.');
    if (matchingElements.length === 0) throw Error('No element was found.');
    const [matchingElement] = matchingElements;
    set.delete(matchingElement);
    return matchingElement;
};

});


parcelRegister("hL1bO", function(module, exports) {

$parcel$export(module.exports, "setInternalStateToActive", () => $ced7bfafece11d57$export$88a47afdc0e8539c);

var $kBpIy = parcelRequire("kBpIy");

var $iAqIi = parcelRequire("iAqIi");
const $ced7bfafece11d57$export$88a47afdc0e8539c = (audioNode)=>{
    if ((0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).has(audioNode)) throw new Error('The AudioNode is already stored.');
    (0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).add(audioNode);
    (0, $iAqIi.getEventListenersOfAudioNode)(audioNode).forEach((eventListener)=>eventListener(true));
};

});
parcelRegister("iAqIi", function(module, exports) {

$parcel$export(module.exports, "getEventListenersOfAudioNode", () => $d8804f8726b8ef0c$export$caac7ea54cb93b25);

var $kBpIy = parcelRequire("kBpIy");

var $8sbmW = parcelRequire("8sbmW");
const $d8804f8726b8ef0c$export$caac7ea54cb93b25 = (audioNode)=>{
    return (0, $8sbmW.getValueForKey)((0, $kBpIy.EVENT_LISTENERS), audioNode);
};

});


parcelRegister("ls87f", function(module, exports) {

$parcel$export(module.exports, "setInternalStateToPassiveWhenNecessary", () => $f9e2821f359d66a6$export$c74023ca160dc207);

var $8VulU = parcelRequire("8VulU");

var $jqEMr = parcelRequire("jqEMr");
const $f9e2821f359d66a6$export$c74023ca160dc207 = (audioNode, activeInputs)=>{
    if (!(0, $8VulU.isAudioWorkletNode)(audioNode) && activeInputs.every((connections)=>connections.size === 0)) (0, $jqEMr.setInternalStateToPassive)(audioNode);
};

});
parcelRegister("8VulU", function(module, exports) {

$parcel$export(module.exports, "isAudioWorkletNode", () => $67fb30ee615c6b5b$export$1293b9fc79a24682);
const $67fb30ee615c6b5b$export$1293b9fc79a24682 = (audioNode)=>{
    return 'port' in audioNode;
};

});

parcelRegister("jqEMr", function(module, exports) {

$parcel$export(module.exports, "setInternalStateToPassive", () => $e250142334e72f81$export$7c0830f3a5100dec);

var $kBpIy = parcelRequire("kBpIy");

var $iAqIi = parcelRequire("iAqIi");
const $e250142334e72f81$export$7c0830f3a5100dec = (audioNode)=>{
    if (!(0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).has(audioNode)) throw new Error('The AudioNode is not stored.');
    (0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).delete(audioNode);
    (0, $iAqIi.getEventListenersOfAudioNode)(audioNode).forEach((eventListener)=>eventListener(false));
};

});



parcelRegister("eRtkD", function(module, exports) {

$parcel$export(module.exports, "createAddPassiveInputConnectionToAudioNode", () => $ad1cc4a1643b9c2c$export$67aa4e90be3a506b);
const $ad1cc4a1643b9c2c$export$67aa4e90be3a506b = (insertElementInSet)=>{
    return (passiveInputs, input, [source, output, eventListener], ignoreDuplicates)=>{
        const passiveInputConnections = passiveInputs.get(source);
        if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
            [
                output,
                input,
                eventListener
            ]
        ]));
        else insertElementInSet(passiveInputConnections, [
            output,
            input,
            eventListener
        ], (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
    };
};

});

parcelRegister("iknOE", function(module, exports) {

$parcel$export(module.exports, "createAddSilentConnection", () => $d57c91976c82249c$export$c6991e18a29704b9);
const $d57c91976c82249c$export$c6991e18a29704b9 = (createNativeGainNode)=>{
    return (nativeContext, nativeAudioScheduledSourceNode)=>{
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnect = ()=>{
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnect);
            nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        nativeAudioScheduledSourceNode.addEventListener('ended', disconnect);
    };
};

});

parcelRegister("b579J", function(module, exports) {

$parcel$export(module.exports, "createAddUnrenderedAudioWorkletNode", () => $8115b66071be4ebe$export$fd0136b1517d036f);
const $8115b66071be4ebe$export$fd0136b1517d036f = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
    };
};

});

parcelRegister("6sAjJ", function(module, exports) {

$parcel$export(module.exports, "createAnalyserNodeConstructor", () => $4b41877a310166bb$export$569b2da15d7fe153);
const $4b41877a310166bb$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    fftSize: 2048,
    maxDecibels: -30,
    minDecibels: -100,
    smoothingTimeConstant: 0.8
};
const $4b41877a310166bb$export$569b2da15d7fe153 = (audionNodeConstructor, createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class AnalyserNode extends audionNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$4b41877a310166bb$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
            const analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
            super(context, false, nativeAnalyserNode, analyserNodeRenderer);
            this._nativeAnalyserNode = nativeAnalyserNode;
        }
        get fftSize() {
            return this._nativeAnalyserNode.fftSize;
        }
        set fftSize(value) {
            this._nativeAnalyserNode.fftSize = value;
        }
        get frequencyBinCount() {
            return this._nativeAnalyserNode.frequencyBinCount;
        }
        get maxDecibels() {
            return this._nativeAnalyserNode.maxDecibels;
        }
        set maxDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const maxDecibels = this._nativeAnalyserNode.maxDecibels;
            this._nativeAnalyserNode.maxDecibels = value;
            if (!(value > this._nativeAnalyserNode.minDecibels)) {
                this._nativeAnalyserNode.maxDecibels = maxDecibels;
                throw createIndexSizeError();
            }
        }
        get minDecibels() {
            return this._nativeAnalyserNode.minDecibels;
        }
        set minDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const minDecibels = this._nativeAnalyserNode.minDecibels;
            this._nativeAnalyserNode.minDecibels = value;
            if (!(this._nativeAnalyserNode.maxDecibels > value)) {
                this._nativeAnalyserNode.minDecibels = minDecibels;
                throw createIndexSizeError();
            }
        }
        get smoothingTimeConstant() {
            return this._nativeAnalyserNode.smoothingTimeConstant;
        }
        set smoothingTimeConstant(value) {
            this._nativeAnalyserNode.smoothingTimeConstant = value;
        }
        getByteFrequencyData(array) {
            this._nativeAnalyserNode.getByteFrequencyData(array);
        }
        getByteTimeDomainData(array) {
            this._nativeAnalyserNode.getByteTimeDomainData(array);
        }
        getFloatFrequencyData(array) {
            this._nativeAnalyserNode.getFloatFrequencyData(array);
        }
        getFloatTimeDomainData(array) {
            this._nativeAnalyserNode.getFloatTimeDomainData(array);
        }
    };
};

});

parcelRegister("dC3Eg", function(module, exports) {

$parcel$export(module.exports, "createAnalyserNodeRendererFactory", () => $9e91a7735948a014$export$5fe3f5c2d995fe20);

var $37LPX = parcelRequire("37LPX");
const $9e91a7735948a014$export$5fe3f5c2d995fe20 = (createNativeAnalyserNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAnalyserNodes = new WeakMap();
        const createAnalyserNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAnalyserNode = getNativeAudioNode(proxy);
            // If the initially used nativeAnalyserNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAnalyserNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeAnalyserNode, nativeOfflineAudioContext);
            if (!nativeAnalyserNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAnalyserNode.channelCount,
                    channelCountMode: nativeAnalyserNode.channelCountMode,
                    channelInterpretation: nativeAnalyserNode.channelInterpretation,
                    fftSize: nativeAnalyserNode.fftSize,
                    maxDecibels: nativeAnalyserNode.maxDecibels,
                    minDecibels: nativeAnalyserNode.minDecibels,
                    smoothingTimeConstant: nativeAnalyserNode.smoothingTimeConstant
                };
                nativeAnalyserNode = createNativeAnalyserNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAnalyserNodes.set(nativeOfflineAudioContext, nativeAnalyserNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAnalyserNode);
            return nativeAnalyserNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAnalyserNode = renderedNativeAnalyserNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAnalyserNode !== undefined) return Promise.resolve(renderedNativeAnalyserNode);
                return createAnalyserNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});
parcelRegister("37LPX", function(module, exports) {

$parcel$export(module.exports, "isOwnedByContext", () => $246721f541528d02$export$4bd7a4bf54ca80bc);
const $246721f541528d02$export$4bd7a4bf54ca80bc = (nativeAudioNode, nativeContext)=>{
    return nativeAudioNode.context === nativeContext;
};

});


parcelRegister("4ylI4", function(module, exports) {

$parcel$export(module.exports, "createAudioBufferConstructor", () => $350b2d82a70cfa14$export$c8b88126795b7df2);

var $4tJKf = parcelRequire("4tJKf");

var $8Znor = parcelRequire("8Znor");
const $350b2d82a70cfa14$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $350b2d82a70cfa14$export$c8b88126795b7df2 = (audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    let nativeOfflineAudioContext = null;
    return class AudioBuffer {
        constructor(options){
            if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$350b2d82a70cfa14$var$DEFAULT_OPTIONS,
                ...options
            };
            if (nativeOfflineAudioContext === null) nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
            /*
             * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
             * factory function. But since Firefox also supports the constructor everything should be fine.
             */ const audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate);
            // Bug #99: Safari does not throw an error when the numberOfChannels is zero.
            if (audioBuffer.numberOfChannels === 0) throw createNotSupportedError();
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $8Znor.wrapAudioBufferGetChannelDataMethod)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult((0, $4tJKf.testAudioBufferCopyChannelMethodsOutOfBoundsSupport), ()=>(0, $4tJKf.testAudioBufferCopyChannelMethodsOutOfBoundsSupport)(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            /*
             * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
             * (Offline)AudioContexts.
             */ return audioBuffer;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
        }
    };
};

});
parcelRegister("4tJKf", function(module, exports) {

$parcel$export(module.exports, "testAudioBufferCopyChannelMethodsOutOfBoundsSupport", () => $342d5ad6d708ee3d$export$54e424f510c54ced);
const $342d5ad6d708ee3d$export$54e424f510c54ced = (nativeAudioBuffer)=>{
    try {
        nativeAudioBuffer.copyToChannel(new Float32Array(1), 0, -1);
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("8Znor", function(module, exports) {

$parcel$export(module.exports, "wrapAudioBufferGetChannelDataMethod", () => $68b62aa30bb53a2e$export$df65309cf6249598);

var $lcODi = parcelRequire("lcODi");
const $68b62aa30bb53a2e$export$df65309cf6249598 = (audioBuffer)=>{
    audioBuffer.getChannelData = ((getChannelData)=>{
        return (channel)=>{
            try {
                return getChannelData.call(audioBuffer, channel);
            } catch (err) {
                if (err.code === 12) throw (0, $lcODi.createIndexSizeError)();
                throw err;
            }
        };
    })(audioBuffer.getChannelData);
};

});
parcelRegister("lcODi", function(module, exports) {

$parcel$export(module.exports, "createIndexSizeError", () => $f701fe933d8d78fb$export$926e4aa3eed6ec13);
const $f701fe933d8d78fb$export$926e4aa3eed6ec13 = ()=>new DOMException('', 'IndexSizeError');

});



parcelRegister("50AfV", function(module, exports) {

$parcel$export(module.exports, "createAudioBufferSourceNodeConstructor", () => $3a5913817f4018fd$export$6857b764b4428518);

var $lQo9t = parcelRequire("lQo9t");

var $8pz9Z = parcelRequire("8pz9Z");

var $hL1bO = parcelRequire("hL1bO");

var $jqEMr = parcelRequire("jqEMr");
const $3a5913817f4018fd$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    // Bug #149: Safari does not yet support the detune AudioParam.
    loop: false,
    loopEnd: 0,
    loopStart: 0,
    playbackRate: 1
};
const $3a5913817f4018fd$export$6857b764b4428518 = (audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class AudioBufferSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$3a5913817f4018fd$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
            super(context, false, nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer);
            this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
            this._isBufferNullified = false;
            this._isBufferSet = mergedOptions.buffer !== null;
            this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
            this._onended = null;
            // Bug #73: Safari does not export the correct values for maxValue and minValue.
            this._playbackRate = createAudioParam(this, isOffline, nativeAudioBufferSourceNode.playbackRate, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeAudioBufferSourceNode.buffer;
        }
        set buffer(value) {
            this._nativeAudioBufferSourceNode.buffer = value;
            // Bug #72: Only Chrome & Edge do not allow to reassign the buffer yet.
            if (value !== null) {
                if (this._isBufferSet) throw createInvalidStateError();
                this._isBufferSet = true;
            }
        }
        get loop() {
            return this._nativeAudioBufferSourceNode.loop;
        }
        set loop(value) {
            this._nativeAudioBufferSourceNode.loop = value;
        }
        get loopEnd() {
            return this._nativeAudioBufferSourceNode.loopEnd;
        }
        set loopEnd(value) {
            this._nativeAudioBufferSourceNode.loopEnd = value;
        }
        get loopStart() {
            return this._nativeAudioBufferSourceNode.loopStart;
        }
        set loopStart(value) {
            this._nativeAudioBufferSourceNode.loopStart = value;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioBufferSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get playbackRate() {
            return this._playbackRate;
        }
        start(when = 0, offset = 0, duration) {
            this._nativeAudioBufferSourceNode.start(when, offset, duration);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.start = duration === undefined ? [
                when,
                offset
            ] : [
                when,
                offset,
                duration
            ];
            if (this.context.state !== 'closed') {
                (0, $hL1bO.setInternalStateToActive)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeAudioBufferSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $8pz9Z.isActiveAudioNode)(this)) (0, $jqEMr.setInternalStateToPassive)(this);
                };
                this._nativeAudioBufferSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeAudioBufferSourceNode.stop(when);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.stop = when;
        }
    };
};

});
parcelRegister("lQo9t", function(module, exports) {

$parcel$export(module.exports, "MOST_NEGATIVE_SINGLE_FLOAT", () => $fe713059c5a7fcdd$export$ced6a5c63b103b52);
$parcel$export(module.exports, "MOST_POSITIVE_SINGLE_FLOAT", () => $fe713059c5a7fcdd$export$ab43bedd17d6a167);
const $fe713059c5a7fcdd$export$ced6a5c63b103b52 = -340282346638528860000000000000000000000;
const $fe713059c5a7fcdd$export$ab43bedd17d6a167 = -$fe713059c5a7fcdd$export$ced6a5c63b103b52;

});

parcelRegister("8pz9Z", function(module, exports) {

$parcel$export(module.exports, "isActiveAudioNode", () => $61fbee95edcddc4d$export$e44f0fc8e83fb084);

var $kBpIy = parcelRequire("kBpIy");
const $61fbee95edcddc4d$export$e44f0fc8e83fb084 = (audioNode)=>(0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).has(audioNode);

});


parcelRegister("ctmdr", function(module, exports) {

$parcel$export(module.exports, "createAudioBufferSourceNodeRendererFactory", () => $91496d13a5b5eefb$export$82721be5d1bb22c5);

var $37LPX = parcelRequire("37LPX");
const $91496d13a5b5eefb$export$82721be5d1bb22c5 = (connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioBufferSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createAudioBufferSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeAudioBufferSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeAudioBufferSourceNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeAudioBufferSourceNode, nativeOfflineAudioContext);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeAudioBufferSourceNode.buffer,
                    channelCount: nativeAudioBufferSourceNode.channelCount,
                    channelCountMode: nativeAudioBufferSourceNode.channelCountMode,
                    channelInterpretation: nativeAudioBufferSourceNode.channelInterpretation,
                    // Bug #149: Safari does not yet support the detune AudioParam.
                    loop: nativeAudioBufferSourceNode.loop,
                    loopEnd: nativeAudioBufferSourceNode.loopEnd,
                    loopStart: nativeAudioBufferSourceNode.loopStart,
                    playbackRate: nativeAudioBufferSourceNode.playbackRate.value
                };
                nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeAudioBufferSourceNode.start(...start);
                if (stop !== null) nativeAudioBufferSourceNode.stop(stop);
            }
            renderedNativeAudioBufferSourceNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) // Bug #149: Safari does not yet support the detune AudioParam.
            await renderAutomation(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            else // Bug #149: Safari does not yet support the detune AudioParam.
            await connectAudioParam(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            return nativeAudioBufferSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioBufferSourceNode = renderedNativeAudioBufferSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioBufferSourceNode !== undefined) return Promise.resolve(renderedNativeAudioBufferSourceNode);
                return createAudioBufferSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("lxNbI", function(module, exports) {

$parcel$export(module.exports, "createAudioContextConstructor", () => $faf2d5bc03af7093$export$c6fe175def53ff71);

var $kOlfI = parcelRequire("kOlfI");

var $8fmkE = parcelRequire("8fmkE");
const $faf2d5bc03af7093$export$c6fe175def53ff71 = (baseAudioContextConstructor, createInvalidStateError, createNotSupportedError, createUnknownError, mediaElementAudioSourceNodeConstructor, mediaStreamAudioDestinationNodeConstructor, mediaStreamAudioSourceNodeConstructor, mediaStreamTrackAudioSourceNodeConstructor, nativeAudioContextConstructor)=>{
    return class AudioContext extends baseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $8fmkE.isValidLatencyHint)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $kOlfI.deactivateAudioGraph)(this);
            });
        }
        createMediaElementSource(mediaElement) {
            return new mediaElementAudioSourceNodeConstructor(this, {
                mediaElement: mediaElement
            });
        }
        createMediaStreamDestination() {
            return new mediaStreamAudioDestinationNodeConstructor(this);
        }
        createMediaStreamSource(mediaStream) {
            return new mediaStreamAudioSourceNodeConstructor(this, {
                mediaStream: mediaStream
            });
        }
        createMediaStreamTrackSource(mediaStreamTrack) {
            return new mediaStreamTrackAudioSourceNodeConstructor(this, {
                mediaStreamTrack: mediaStreamTrack
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};

});
parcelRegister("kOlfI", function(module, exports) {

$parcel$export(module.exports, "deactivateAudioGraph", () => $f268f67750beec56$export$cbd606bc629ea938);

var $ktyih = parcelRequire("ktyih");
const $f268f67750beec56$export$cbd606bc629ea938 = (context)=>{
    (0, $ktyih.deactivateActiveAudioNodeInputConnections)(context.destination, []);
};

});
parcelRegister("ktyih", function(module, exports) {

$parcel$export(module.exports, "deactivateActiveAudioNodeInputConnections", () => $ee811e19b5d1008d$export$e16f533d410eeca0);

var $cUEAO = parcelRequire("cUEAO");

var $8VulU = parcelRequire("8VulU");

var $3YKSu = parcelRequire("3YKSu");

var $1cshg = parcelRequire("1cshg");

var $93fn7 = parcelRequire("93fn7");

var $a2EGU = parcelRequire("a2EGU");

var $2QicK = parcelRequire("2QicK");

var $aO4oU = parcelRequire("aO4oU");

var $aLu63 = parcelRequire("aLu63");

var $8pz9Z = parcelRequire("8pz9Z");

var $jqEMr = parcelRequire("jqEMr");
const $ee811e19b5d1008d$export$e16f533d410eeca0 = (audioNode, trace)=>{
    const { activeInputs: activeInputs } = (0, $aO4oU.getAudioNodeConnections)(audioNode);
    activeInputs.forEach((connections)=>connections.forEach(([source])=>{
            if (!trace.includes(audioNode)) $ee811e19b5d1008d$export$e16f533d410eeca0(source, [
                ...trace,
                audioNode
            ]);
        }));
    const audioParams = (0, $cUEAO.isAudioBufferSourceNode)(audioNode) ? [
        // Bug #149: Safari does not yet support the detune AudioParam.
        audioNode.playbackRate
    ] : (0, $8VulU.isAudioWorkletNode)(audioNode) ? Array.from(audioNode.parameters.values()) : (0, $3YKSu.isBiquadFilterNode)(audioNode) ? [
        audioNode.Q,
        audioNode.detune,
        audioNode.frequency,
        audioNode.gain
    ] : (0, $1cshg.isConstantSourceNode)(audioNode) ? [
        audioNode.offset
    ] : (0, $93fn7.isGainNode)(audioNode) ? [
        audioNode.gain
    ] : (0, $a2EGU.isOscillatorNode)(audioNode) ? [
        audioNode.detune,
        audioNode.frequency
    ] : (0, $2QicK.isStereoPannerNode)(audioNode) ? [
        audioNode.pan
    ] : [];
    for (const audioParam of audioParams){
        const audioParamConnections = (0, $aLu63.getAudioParamConnections)(audioParam);
        if (audioParamConnections !== undefined) audioParamConnections.activeInputs.forEach(([source])=>$ee811e19b5d1008d$export$e16f533d410eeca0(source, trace));
    }
    if ((0, $8pz9Z.isActiveAudioNode)(audioNode)) (0, $jqEMr.setInternalStateToPassive)(audioNode);
};

});
parcelRegister("cUEAO", function(module, exports) {

$parcel$export(module.exports, "isAudioBufferSourceNode", () => $966a33d94d19bd24$export$b030d1cb39b66ce3);
const $966a33d94d19bd24$export$b030d1cb39b66ce3 = (audioNode)=>{
    return 'playbackRate' in audioNode;
};

});

parcelRegister("3YKSu", function(module, exports) {

$parcel$export(module.exports, "isBiquadFilterNode", () => $2e5b56a3c6a166a9$export$8bbceb3e2d3b886a);
const $2e5b56a3c6a166a9$export$8bbceb3e2d3b886a = (audioNode)=>{
    return 'frequency' in audioNode && 'gain' in audioNode;
};

});

parcelRegister("1cshg", function(module, exports) {

$parcel$export(module.exports, "isConstantSourceNode", () => $0dfcd8bc86f296d5$export$2b5f11f35c31b1bf);
const $0dfcd8bc86f296d5$export$2b5f11f35c31b1bf = (audioNode)=>{
    return 'offset' in audioNode;
};

});

parcelRegister("93fn7", function(module, exports) {

$parcel$export(module.exports, "isGainNode", () => $6970516c430cae3a$export$c124c0514d4f41ab);
const $6970516c430cae3a$export$c124c0514d4f41ab = (audioNode)=>{
    return !('frequency' in audioNode) && 'gain' in audioNode;
};

});

parcelRegister("a2EGU", function(module, exports) {

$parcel$export(module.exports, "isOscillatorNode", () => $74f9a7b0d642bdc6$export$97bb3ed4238ea897);
const $74f9a7b0d642bdc6$export$97bb3ed4238ea897 = (audioNode)=>{
    return 'detune' in audioNode && 'frequency' in audioNode;
};

});

parcelRegister("2QicK", function(module, exports) {

$parcel$export(module.exports, "isStereoPannerNode", () => $211e8f2c1edf2709$export$79ba82be14a0b006);
const $211e8f2c1edf2709$export$79ba82be14a0b006 = (audioNode)=>{
    return 'pan' in audioNode;
};

});

parcelRegister("aO4oU", function(module, exports) {

$parcel$export(module.exports, "getAudioNodeConnections", () => $7de1fcd02076614a$export$6b29eee2af836dfc);

var $kBpIy = parcelRequire("kBpIy");

var $8sbmW = parcelRequire("8sbmW");
const $7de1fcd02076614a$export$6b29eee2af836dfc = (audioNode)=>{
    return (0, $8sbmW.getValueForKey)((0, $kBpIy.AUDIO_NODE_CONNECTIONS_STORE), audioNode);
};

});

parcelRegister("aLu63", function(module, exports) {

$parcel$export(module.exports, "getAudioParamConnections", () => $7d65a3b9033c1579$export$1b11f454bf19657);

var $kBpIy = parcelRequire("kBpIy");

var $8sbmW = parcelRequire("8sbmW");
const $7d65a3b9033c1579$export$1b11f454bf19657 = (audioParam)=>{
    return (0, $8sbmW.getValueForKey)((0, $kBpIy.AUDIO_PARAM_CONNECTIONS_STORE), audioParam);
};

});



parcelRegister("8fmkE", function(module, exports) {

$parcel$export(module.exports, "isValidLatencyHint", () => $60110c1d486fa9d1$export$82d5f0e102842fbe);
const $60110c1d486fa9d1$export$82d5f0e102842fbe = (latencyHint)=>{
    return latencyHint === undefined || typeof latencyHint === 'number' || typeof latencyHint === 'string' && (latencyHint === 'balanced' || latencyHint === 'interactive' || latencyHint === 'playback');
};

});


parcelRegister("3rjFY", function(module, exports) {

$parcel$export(module.exports, "createAudioDestinationNodeConstructor", () => $281327f32261b32d$export$cbbb0c3ba3f5dd5b);
const $281327f32261b32d$export$cbbb0c3ba3f5dd5b = (audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode)=>{
    return class AudioDestinationNode extends audioNodeConstructor {
        constructor(context, channelCount){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
            const audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
            super(context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
            this._isNodeOfNativeOfflineAudioContext = isOffline;
            this._nativeAudioDestinationNode = nativeAudioDestinationNode;
        }
        get channelCount() {
            return this._nativeAudioDestinationNode.channelCount;
        }
        set channelCount(value) {
            // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
            // Bug #54: Firefox does throw an IndexSizeError.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
            if (value > this._nativeAudioDestinationNode.maxChannelCount) throw createIndexSizeError();
            this._nativeAudioDestinationNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioDestinationNode.channelCountMode;
        }
        set channelCountMode(value) {
            // Bug #53: No browser does throw an exception yet.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            this._nativeAudioDestinationNode.channelCountMode = value;
        }
        get maxChannelCount() {
            return this._nativeAudioDestinationNode.maxChannelCount;
        }
    };
};

});

parcelRegister("17YZP", function(module, exports) {

$parcel$export(module.exports, "createAudioDestinationNodeRenderer", () => $0d25c272e753e7bf$export$d44f3f5d4e42ced2);
const $0d25c272e753e7bf$export$d44f3f5d4e42ced2 = (renderInputsOfAudioNode)=>{
    const renderedNativeAudioDestinationNodes = new WeakMap();
    const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
        renderedNativeAudioDestinationNodes.set(nativeOfflineAudioContext, nativeAudioDestinationNode);
        await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
        return nativeAudioDestinationNode;
    };
    return {
        render (proxy, nativeOfflineAudioContext) {
            const renderedNativeAudioDestinationNode = renderedNativeAudioDestinationNodes.get(nativeOfflineAudioContext);
            if (renderedNativeAudioDestinationNode !== undefined) return Promise.resolve(renderedNativeAudioDestinationNode);
            return createAudioDestinationNode(proxy, nativeOfflineAudioContext);
        }
    };
};

});

parcelRegister("8QBXD", function(module, exports) {

$parcel$export(module.exports, "createAudioListenerFactory", () => $6710a04e94c34c59$export$3e70692c55bd5b52);

var $lQo9t = parcelRequire("lQo9t");
const $6710a04e94c34c59$export$3e70692c55bd5b52 = (createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors)=>{
    return (context, nativeContext)=>{
        const nativeListener = nativeContext.listener;
        // Bug #117: Only Chrome & Edge support the new interface already.
        const createFakeAudioParams = ()=>{
            const buffer = new Float32Array(1);
            const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'speakers',
                numberOfInputs: 9
            });
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            let isScriptProcessorNodeCreated = false;
            let lastOrientation = [
                0,
                0,
                -1,
                0,
                1,
                0
            ];
            let lastPosition = [
                0,
                0,
                0
            ];
            const createScriptProcessorNode = ()=>{
                if (isScriptProcessorNodeCreated) return;
                isScriptProcessorNodeCreated = true;
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 9, 0);
                // tslint:disable-next-line:deprecation
                scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
                    const orientation = [
                        getFirstSample(inputBuffer, buffer, 0),
                        getFirstSample(inputBuffer, buffer, 1),
                        getFirstSample(inputBuffer, buffer, 2),
                        getFirstSample(inputBuffer, buffer, 3),
                        getFirstSample(inputBuffer, buffer, 4),
                        getFirstSample(inputBuffer, buffer, 5)
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index])) {
                        nativeListener.setOrientation(...orientation); // tslint:disable-line:deprecation
                        lastOrientation = orientation;
                    }
                    const positon = [
                        getFirstSample(inputBuffer, buffer, 6),
                        getFirstSample(inputBuffer, buffer, 7),
                        getFirstSample(inputBuffer, buffer, 8)
                    ];
                    if (positon.some((value, index)=>value !== lastPosition[index])) {
                        nativeListener.setPosition(...positon); // tslint:disable-line:deprecation
                        lastPosition = positon;
                    }
                };
                channelMergerNode.connect(scriptProcessorNode);
            };
            const createSetOrientation = (index)=>(value)=>{
                    if (value !== lastOrientation[index]) {
                        lastOrientation[index] = value;
                        nativeListener.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
                    }
                };
            const createSetPosition = (index)=>(value)=>{
                    if (value !== lastPosition[index]) {
                        lastPosition[index] = value;
                        nativeListener.setPosition(...lastPosition); // tslint:disable-line:deprecation
                    }
                };
            const createFakeAudioParam = (input, initialValue, setValue)=>{
                const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    offset: initialValue
                });
                constantSourceNode.connect(channelMergerNode, 0, input);
                // @todo This should be stopped when the context is closed.
                constantSourceNode.start();
                Object.defineProperty(constantSourceNode.offset, 'defaultValue', {
                    get () {
                        return initialValue;
                    }
                });
                /*
                 * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and
                 * minValue for GainNodes.
                 */ const audioParam = createAudioParam({
                    context: context
                }, isOffline, constantSourceNode.offset, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
                overwriteAccessors(audioParam, 'value', (get)=>()=>get.call(audioParam), (set)=>(value)=>{
                        try {
                            set.call(audioParam, value);
                        } catch (err) {
                            if (err.code !== 9) throw err;
                        }
                        createScriptProcessorNode();
                        if (isOffline) // Bug #117: Using setOrientation() and setPosition() doesn't work with an OfflineAudioContext.
                        setValue(value);
                    });
                audioParam.cancelAndHoldAtTime = ((cancelAndHoldAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelAndHoldAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelAndHoldAtTime);
                audioParam.cancelScheduledValues = ((cancelScheduledValues)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelScheduledValues.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelScheduledValues);
                audioParam.exponentialRampToValueAtTime = ((exponentialRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = exponentialRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.exponentialRampToValueAtTime);
                audioParam.linearRampToValueAtTime = ((linearRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = linearRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.linearRampToValueAtTime);
                audioParam.setTargetAtTime = ((setTargetAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setTargetAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setTargetAtTime);
                audioParam.setValueAtTime = ((setValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueAtTime);
                audioParam.setValueCurveAtTime = ((setValueCurveAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueCurveAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueCurveAtTime);
                return audioParam;
            };
            return {
                forwardX: createFakeAudioParam(0, 0, createSetOrientation(0)),
                forwardY: createFakeAudioParam(1, 0, createSetOrientation(1)),
                forwardZ: createFakeAudioParam(2, -1, createSetOrientation(2)),
                positionX: createFakeAudioParam(6, 0, createSetPosition(0)),
                positionY: createFakeAudioParam(7, 0, createSetPosition(1)),
                positionZ: createFakeAudioParam(8, 0, createSetPosition(2)),
                upX: createFakeAudioParam(3, 0, createSetOrientation(3)),
                upY: createFakeAudioParam(4, 1, createSetOrientation(4)),
                upZ: createFakeAudioParam(5, 0, createSetOrientation(5))
            };
        };
        const { forwardX: forwardX, forwardY: forwardY, forwardZ: forwardZ, positionX: positionX, positionY: positionY, positionZ: positionZ, upX: upX, upY: upY, upZ: upZ } = nativeListener.forwardX === undefined ? createFakeAudioParams() : nativeListener;
        return {
            get forwardX () {
                return forwardX;
            },
            get forwardY () {
                return forwardY;
            },
            get forwardZ () {
                return forwardZ;
            },
            get positionX () {
                return positionX;
            },
            get positionY () {
                return positionY;
            },
            get positionZ () {
                return positionZ;
            },
            get upX () {
                return upX;
            },
            get upY () {
                return upY;
            },
            get upZ () {
                return upZ;
            }
        };
    };
};

});

parcelRegister("3rvEZ", function(module, exports) {

$parcel$export(module.exports, "createAudioNodeConstructor", () => $281c73c42b5e37d8$export$20e3fa4f981cb01d);

var $kBpIy = parcelRequire("kBpIy");

var $afpuu = parcelRequire("afpuu");

var $9wk5I = parcelRequire("9wk5I");

var $8n3zC = parcelRequire("8n3zC");

var $9xjkL = parcelRequire("9xjkL");

var $kMIy9 = parcelRequire("kMIy9");

var $kIvPl = parcelRequire("kIvPl");

var $bF9j3 = parcelRequire("bF9j3");

var $gyb9b = parcelRequire("gyb9b");

var $1B14g = parcelRequire("1B14g");

var $9sdhu = parcelRequire("9sdhu");

var $3TZtj = parcelRequire("3TZtj");

var $aO4oU = parcelRequire("aO4oU");

var $aLu63 = parcelRequire("aLu63");

var $iAqIi = parcelRequire("iAqIi");

var $eSkbj = parcelRequire("eSkbj");

var $dnCRy = parcelRequire("dnCRy");

var $1TFz4 = parcelRequire("1TFz4");

var $8pz9Z = parcelRequire("8pz9Z");

var $g8bwb = parcelRequire("g8bwb");

var $9wzDL = parcelRequire("9wzDL");

var $hL1bO = parcelRequire("hL1bO");

var $ls87f = parcelRequire("ls87f");

var $047Qy = parcelRequire("047Qy");

var $5Ec4C = parcelRequire("5Ec4C");

var $60fE7 = parcelRequire("60fE7");
const $281c73c42b5e37d8$var$addConnectionToAudioParamOfAudioContext = (source, destination, output, isOffline)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $aLu63.getAudioParamConnections)(destination);
    const { outputs: outputs } = (0, $aO4oU.getAudioNodeConnections)(source);
    const eventListeners = (0, $iAqIi.getEventListenersOfAudioNode)(source);
    const eventListener = (isActive)=>{
        const nativeAudioNode = (0, $eSkbj.getNativeAudioNode)(source);
        const nativeAudioParam = (0, $dnCRy.getNativeAudioParam)(destination);
        if (isActive) {
            const partialConnection = (0, $9sdhu.deletePassiveInputConnectionToAudioParam)(passiveInputs, source, output);
            (0, $8n3zC.addActiveInputConnectionToAudioParam)(activeInputs, source, partialConnection, false);
            if (!isOffline && !(0, $g8bwb.isPartOfACycle)(source)) nativeAudioNode.connect(nativeAudioParam, output);
        } else {
            const partialConnection = (0, $bF9j3.deleteActiveInputConnectionToAudioParam)(activeInputs, source, output);
            (0, $9xjkL.addPassiveInputConnectionToAudioParam)(passiveInputs, partialConnection, false);
            if (!isOffline && !(0, $g8bwb.isPartOfACycle)(source)) nativeAudioNode.disconnect(nativeAudioParam, output);
        }
    };
    if ((0, $1TFz4.insertElementInSet)(outputs, [
        destination,
        output
    ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output, true)) {
        eventListeners.add(eventListener);
        if ((0, $8pz9Z.isActiveAudioNode)(source)) (0, $8n3zC.addActiveInputConnectionToAudioParam)(activeInputs, source, [
            output,
            eventListener
        ], true);
        else (0, $9xjkL.addPassiveInputConnectionToAudioParam)(passiveInputs, [
            source,
            output,
            eventListener
        ], true);
        return true;
    }
    return false;
};
const $281c73c42b5e37d8$var$deleteInputConnectionOfAudioNode = (source, destination, output, input)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $aO4oU.getAudioNodeConnections)(destination);
    const activeInputConnection = (0, $kIvPl.deleteActiveInputConnection)(activeInputs[input], source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $1B14g.deletePassiveInputConnectionToAudioNode)(passiveInputs, source, output, input);
        return [
            passiveInputConnection[2],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $281c73c42b5e37d8$var$deleteInputConnectionOfAudioParam = (source, destination, output)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $aLu63.getAudioParamConnections)(destination);
    const activeInputConnection = (0, $kIvPl.deleteActiveInputConnection)(activeInputs, source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $9sdhu.deletePassiveInputConnectionToAudioParam)(passiveInputs, source, output);
        return [
            passiveInputConnection[1],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $281c73c42b5e37d8$var$deleteInputsOfAudioNode = (source, isOffline, destination, output, input)=>{
    const [listener, isActive] = $281c73c42b5e37d8$var$deleteInputConnectionOfAudioNode(source, destination, output, input);
    if (listener !== null) {
        (0, $gyb9b.deleteEventListenerOfAudioNode)(source, listener);
        if (isActive && !isOffline && !(0, $g8bwb.isPartOfACycle)(source)) (0, $3TZtj.disconnectNativeAudioNodeFromNativeAudioNode)((0, $eSkbj.getNativeAudioNode)(source), (0, $eSkbj.getNativeAudioNode)(destination), output, input);
    }
    if ((0, $8pz9Z.isActiveAudioNode)(destination)) {
        const { activeInputs: activeInputs } = (0, $aO4oU.getAudioNodeConnections)(destination);
        (0, $ls87f.setInternalStateToPassiveWhenNecessary)(destination, activeInputs);
    }
};
const $281c73c42b5e37d8$var$deleteInputsOfAudioParam = (source, isOffline, destination, output)=>{
    const [listener, isActive] = $281c73c42b5e37d8$var$deleteInputConnectionOfAudioParam(source, destination, output);
    if (listener !== null) {
        (0, $gyb9b.deleteEventListenerOfAudioNode)(source, listener);
        if (isActive && !isOffline && !(0, $g8bwb.isPartOfACycle)(source)) (0, $eSkbj.getNativeAudioNode)(source).disconnect((0, $dnCRy.getNativeAudioParam)(destination), output);
    }
};
const $281c73c42b5e37d8$var$deleteAnyConnection = (source, isOffline)=>{
    const audioNodeConnectionsOfSource = (0, $aO4oU.getAudioNodeConnections)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs){
        if ((0, $9wk5I.isAudioNodeOutputConnection)(outputConnection)) $281c73c42b5e37d8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $281c73c42b5e37d8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
    }
    audioNodeConnectionsOfSource.outputs.clear();
    return destinations;
};
const $281c73c42b5e37d8$var$deleteConnectionAtOutput = (source, isOffline, output)=>{
    const audioNodeConnectionsOfSource = (0, $aO4oU.getAudioNodeConnections)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs)if (outputConnection[1] === output) {
        if ((0, $9wk5I.isAudioNodeOutputConnection)(outputConnection)) $281c73c42b5e37d8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $281c73c42b5e37d8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    }
    return destinations;
};
const $281c73c42b5e37d8$var$deleteConnectionToDestination = (source, isOffline, destination, output, input)=>{
    const audioNodeConnectionsOfSource = (0, $aO4oU.getAudioNodeConnections)(source);
    return Array.from(audioNodeConnectionsOfSource.outputs).filter((outputConnection)=>outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input)).map((outputConnection)=>{
        if ((0, $9wk5I.isAudioNodeOutputConnection)(outputConnection)) $281c73c42b5e37d8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $281c73c42b5e37d8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
        return outputConnection[0];
    });
};
const $281c73c42b5e37d8$export$20e3fa4f981cb01d = (addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return class AudioNode extends eventTargetConstructor {
        constructor(context, isActive, nativeAudioNode, audioNodeRenderer){
            super(nativeAudioNode);
            this._context = context;
            this._nativeAudioNode = nativeAudioNode;
            const nativeContext = getNativeContext(context);
            // Bug #12: Safari does not support to disconnect a specific destination.
            if (isNativeAudioContext(nativeContext) && true !== cacheTestResult((0, $047Qy.testAudioNodeDisconnectMethodSupport), ()=>{
                return (0, $047Qy.testAudioNodeDisconnectMethodSupport)(nativeContext, nativeAudioWorkletNodeConstructor);
            })) (0, $60fE7.wrapAudioNodeDisconnectMethod)(nativeAudioNode);
            (0, $kBpIy.AUDIO_NODE_STORE).set(this, nativeAudioNode);
            (0, $kBpIy.EVENT_LISTENERS).set(this, new Set());
            if (context.state !== 'closed' && isActive) (0, $hL1bO.setInternalStateToActive)(this);
            addAudioNodeConnections(this, audioNodeRenderer, nativeAudioNode);
        }
        get channelCount() {
            return this._nativeAudioNode.channelCount;
        }
        set channelCount(value) {
            this._nativeAudioNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioNode.channelCountMode;
        }
        set channelCountMode(value) {
            this._nativeAudioNode.channelCountMode = value;
        }
        get channelInterpretation() {
            return this._nativeAudioNode.channelInterpretation;
        }
        set channelInterpretation(value) {
            this._nativeAudioNode.channelInterpretation = value;
        }
        get context() {
            return this._context;
        }
        get numberOfInputs() {
            return this._nativeAudioNode.numberOfInputs;
        }
        get numberOfOutputs() {
            return this._nativeAudioNode.numberOfOutputs;
        }
        // tslint:disable-next-line:invalid-void
        connect(destination, output = 0, input = 0) {
            // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
            if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) throw createIndexSizeError();
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) throw createInvalidAccessError();
            if ((0, $afpuu.isAudioNode)(destination)) {
                const nativeDestinationAudioNode = (0, $eSkbj.getNativeAudioNode)(destination);
                try {
                    const connection = (0, $kMIy9.connectNativeAudioNodeToNativeAudioNode)(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
                    const isPassive = (0, $9wzDL.isPassiveAudioNode)(this);
                    if (isOffline || isPassive) this._nativeAudioNode.disconnect(...connection);
                    if (this.context.state !== 'closed' && !isPassive && (0, $9wzDL.isPassiveAudioNode)(destination)) (0, $hL1bO.setInternalStateToActive)(destination);
                } catch (err) {
                    // Bug #41: Safari does not throw the correct exception so far.
                    if (err.code === 12) throw createInvalidAccessError();
                    throw err;
                }
                const isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline);
                // Bug #164: Only Firefox detects cycles so far.
                if (isNewConnectionToAudioNode) {
                    const cycles = detectCycles([
                        this
                    ], destination);
                    (0, $5Ec4C.visitEachAudioNodeOnce)(cycles, createIncrementCycleCounter(isOffline));
                }
                return destination;
            }
            const nativeAudioParam = (0, $dnCRy.getNativeAudioParam)(destination);
            /*
             * Bug #73, #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
             * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
             * Safari. In addition to that the maxValue property is used to only detect the affected versions below v14.0.2.
             */ if (nativeAudioParam.name === 'playbackRate' && nativeAudioParam.maxValue === 1024) throw createNotSupportedError();
            try {
                this._nativeAudioNode.connect(nativeAudioParam, output);
                if (isOffline || (0, $9wzDL.isPassiveAudioNode)(this)) this._nativeAudioNode.disconnect(nativeAudioParam, output);
            } catch (err) {
                // Bug #58: Safari doesn't throw an InvalidAccessError yet.
                if (err.code === 12) throw createInvalidAccessError();
                throw err;
            }
            const isNewConnectionToAudioParam = $281c73c42b5e37d8$var$addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline);
            // Bug #164: Only Firefox detects cycles so far.
            if (isNewConnectionToAudioParam) {
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $5Ec4C.visitEachAudioNodeOnce)(cycles, createIncrementCycleCounter(isOffline));
            }
        }
        disconnect(destinationOrOutput, output, input) {
            let destinations;
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (destinationOrOutput === undefined) destinations = $281c73c42b5e37d8$var$deleteAnyConnection(this, isOffline);
            else if (typeof destinationOrOutput === 'number') {
                if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) throw createIndexSizeError();
                destinations = $281c73c42b5e37d8$var$deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
            } else {
                if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) throw createIndexSizeError();
                if ((0, $afpuu.isAudioNode)(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) throw createIndexSizeError();
                destinations = $281c73c42b5e37d8$var$deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);
                if (destinations.length === 0) throw createInvalidAccessError();
            }
            // Bug #164: Only Firefox detects cycles so far.
            for (const destination of destinations){
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $5Ec4C.visitEachAudioNodeOnce)(cycles, decrementCycleCounter);
            }
        }
    };
};

});
parcelRegister("afpuu", function(module, exports) {

$parcel$export(module.exports, "isAudioNode", () => $775f140be81451f7$export$85cd8e93eb858e81);
const $775f140be81451f7$export$85cd8e93eb858e81 = (audioNodeOrAudioParam)=>{
    return 'context' in audioNodeOrAudioParam;
};

});

parcelRegister("9wk5I", function(module, exports) {

$parcel$export(module.exports, "isAudioNodeOutputConnection", () => $6ee6afe6b4c5f4ca$export$419d66ef3a96a878);

var $afpuu = parcelRequire("afpuu");
const $6ee6afe6b4c5f4ca$export$419d66ef3a96a878 = (outputConnection)=>{
    return (0, $afpuu.isAudioNode)(outputConnection[0]);
};

});

parcelRegister("8n3zC", function(module, exports) {

$parcel$export(module.exports, "addActiveInputConnectionToAudioParam", () => $61833e579344b84b$export$3dfe9f7f712d42df);

var $1TFz4 = parcelRequire("1TFz4");
const $61833e579344b84b$export$3dfe9f7f712d42df = (activeInputs, source, [output, eventListener], ignoreDuplicates)=>{
    (0, $1TFz4.insertElementInSet)(activeInputs, [
        source,
        output,
        eventListener
    ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
};

});
parcelRegister("1TFz4", function(module, exports) {

$parcel$export(module.exports, "insertElementInSet", () => $161b2b5dcd020566$export$64505511c8abc942);
const $161b2b5dcd020566$export$64505511c8abc942 = (set, element, predicate, ignoreDuplicates)=>{
    for (const lmnt of set)if (predicate(lmnt)) {
        if (ignoreDuplicates) return false;
        throw Error('The set contains at least one similar element.');
    }
    set.add(element);
    return true;
};

});


parcelRegister("9xjkL", function(module, exports) {

$parcel$export(module.exports, "addPassiveInputConnectionToAudioParam", () => $6f16316f45b163f3$export$2a7c0e6916aa50e4);

var $1TFz4 = parcelRequire("1TFz4");
const $6f16316f45b163f3$export$2a7c0e6916aa50e4 = (passiveInputs, [source, output, eventListener], ignoreDuplicates)=>{
    const passiveInputConnections = passiveInputs.get(source);
    if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
        [
            output,
            eventListener
        ]
    ]));
    else (0, $1TFz4.insertElementInSet)(passiveInputConnections, [
        output,
        eventListener
    ], (passiveInputConnection)=>passiveInputConnection[0] === output, ignoreDuplicates);
};

});

parcelRegister("kMIy9", function(module, exports) {

$parcel$export(module.exports, "connectNativeAudioNodeToNativeAudioNode", () => $f21ad8fe77bb07bf$export$b92162b3199b4461);

var $eCSga = parcelRequire("eCSga");
const $f21ad8fe77bb07bf$export$b92162b3199b4461 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $eCSga.isNativeAudioNodeFaker)(nativeDestinationAudioNode)) {
        const fakeNativeDestinationAudioNode = nativeDestinationAudioNode.inputs[input];
        nativeSourceAudioNode.connect(fakeNativeDestinationAudioNode, output, 0);
        return [
            fakeNativeDestinationAudioNode,
            output,
            0
        ];
    }
    nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
    return [
        nativeDestinationAudioNode,
        output,
        input
    ];
};

});
parcelRegister("eCSga", function(module, exports) {

$parcel$export(module.exports, "isNativeAudioNodeFaker", () => $aa5eb42820849990$export$ac2aef07f705aa48);
const $aa5eb42820849990$export$ac2aef07f705aa48 = (nativeAudioNodeOrNativeAudioNodeFaker)=>{
    return 'inputs' in nativeAudioNodeOrNativeAudioNodeFaker;
};

});


parcelRegister("kIvPl", function(module, exports) {

$parcel$export(module.exports, "deleteActiveInputConnection", () => $f1509ae807d999ce$export$6cc4c86d6b87a4b8);
const $f1509ae807d999ce$export$6cc4c86d6b87a4b8 = (activeInputConnections, source, output)=>{
    for (const activeInputConnection of activeInputConnections)if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
    }
    return null;
};

});

parcelRegister("bF9j3", function(module, exports) {

$parcel$export(module.exports, "deleteActiveInputConnectionToAudioParam", () => $87dabe1c01c1b488$export$dc5a8616367736a9);

var $81KbS = parcelRequire("81KbS");
const $87dabe1c01c1b488$export$dc5a8616367736a9 = (activeInputs, source, output)=>{
    return (0, $81KbS.pickElementFromSet)(activeInputs, (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
};

});

parcelRegister("gyb9b", function(module, exports) {

$parcel$export(module.exports, "deleteEventListenerOfAudioNode", () => $c0c877ec276d13f5$export$b5a32c2e2eac4137);

var $iAqIi = parcelRequire("iAqIi");
const $c0c877ec276d13f5$export$b5a32c2e2eac4137 = (audioNode, eventListener)=>{
    const eventListeners = (0, $iAqIi.getEventListenersOfAudioNode)(audioNode);
    if (!eventListeners.delete(eventListener)) throw new Error('Missing the expected event listener.');
};

});

parcelRegister("9sdhu", function(module, exports) {

$parcel$export(module.exports, "deletePassiveInputConnectionToAudioParam", () => $6e2107f0aa4973e6$export$368aa16ce008e2f4);

var $8sbmW = parcelRequire("8sbmW");

var $81KbS = parcelRequire("81KbS");
const $6e2107f0aa4973e6$export$368aa16ce008e2f4 = (passiveInputs, source, output)=>{
    const passiveInputConnections = (0, $8sbmW.getValueForKey)(passiveInputs, source);
    const matchingConnection = (0, $81KbS.pickElementFromSet)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};

});

parcelRegister("3TZtj", function(module, exports) {

$parcel$export(module.exports, "disconnectNativeAudioNodeFromNativeAudioNode", () => $2d763130a5cbb902$export$a19b495df4b88921);

var $eCSga = parcelRequire("eCSga");
const $2d763130a5cbb902$export$a19b495df4b88921 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $eCSga.isNativeAudioNodeFaker)(nativeDestinationAudioNode)) nativeSourceAudioNode.disconnect(nativeDestinationAudioNode.inputs[input], output, 0);
    else nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
};

});

parcelRegister("eSkbj", function(module, exports) {

$parcel$export(module.exports, "getNativeAudioNode", () => $ad45c37233cd457d$export$e719c0d45ea16d08);

var $kBpIy = parcelRequire("kBpIy");

var $8sbmW = parcelRequire("8sbmW");
const $ad45c37233cd457d$export$e719c0d45ea16d08 = (audioNode)=>{
    return (0, $8sbmW.getValueForKey)((0, $kBpIy.AUDIO_NODE_STORE), audioNode);
};

});

parcelRegister("dnCRy", function(module, exports) {

$parcel$export(module.exports, "getNativeAudioParam", () => $9bdb91a8592ab9f9$export$fad3d843b2a56ffb);

var $kBpIy = parcelRequire("kBpIy");

var $8sbmW = parcelRequire("8sbmW");
const $9bdb91a8592ab9f9$export$fad3d843b2a56ffb = (audioParam)=>{
    return (0, $8sbmW.getValueForKey)((0, $kBpIy.AUDIO_PARAM_STORE), audioParam);
};

});

parcelRegister("g8bwb", function(module, exports) {

$parcel$export(module.exports, "isPartOfACycle", () => $bbe653f677819097$export$8658a39a04a404d5);

var $kBpIy = parcelRequire("kBpIy");
const $bbe653f677819097$export$8658a39a04a404d5 = (audioNode)=>{
    return (0, $kBpIy.CYCLE_COUNTERS).has(audioNode);
};

});

parcelRegister("9wzDL", function(module, exports) {

$parcel$export(module.exports, "isPassiveAudioNode", () => $6ef2bfaa0b2bdc47$export$79a7cb9fa56970e);

var $kBpIy = parcelRequire("kBpIy");
const $6ef2bfaa0b2bdc47$export$79a7cb9fa56970e = (audioNode)=>{
    return !(0, $kBpIy.ACTIVE_AUDIO_NODE_STORE).has(audioNode);
};

});

parcelRegister("047Qy", function(module, exports) {

$parcel$export(module.exports, "testAudioNodeDisconnectMethodSupport", () => $00c6760498165ddb$export$f938a299860627);
const $00c6760498165ddb$export$f938a299860627 = (nativeAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return new Promise((resolve)=>{
        /*
         * This bug existed in Safari up until v14.0.2. Since AudioWorklets were not supported in Safari until v14.1 the presence of the
         * constructor for an AudioWorkletNode can be used here to skip the test.
         */ if (nativeAudioWorkletNodeConstructor !== null) resolve(true);
        else {
            const analyzer = nativeAudioContext.createScriptProcessor(256, 1, 1); // tslint:disable-line deprecation
            const dummy = nativeAudioContext.createGain();
            // Bug #95: Safari does not play one sample buffers.
            const ones = nativeAudioContext.createBuffer(1, 2, 44100);
            const channelData = ones.getChannelData(0);
            channelData[0] = 1;
            channelData[1] = 1;
            const source = nativeAudioContext.createBufferSource();
            source.buffer = ones;
            source.loop = true;
            source.connect(analyzer).connect(nativeAudioContext.destination);
            source.connect(dummy);
            source.disconnect(dummy);
            // tslint:disable-next-line:deprecation
            analyzer.onaudioprocess = (event)=>{
                const chnnlDt = event.inputBuffer.getChannelData(0); // tslint:disable-line deprecation
                if (Array.prototype.some.call(chnnlDt, (sample)=>sample === 1)) resolve(true);
                else resolve(false);
                source.stop();
                analyzer.onaudioprocess = null; // tslint:disable-line:deprecation
                source.disconnect(analyzer);
                analyzer.disconnect(nativeAudioContext.destination);
            };
            source.start();
        }
    });
};

});

parcelRegister("5Ec4C", function(module, exports) {

$parcel$export(module.exports, "visitEachAudioNodeOnce", () => $41ca0db6dbf14e89$export$f8092aa3a6fcf50f);
const $41ca0db6dbf14e89$export$f8092aa3a6fcf50f = (cycles, visitor)=>{
    const counts = new Map();
    for (const cycle of cycles)for (const audioNode of cycle){
        const count = counts.get(audioNode);
        counts.set(audioNode, count === undefined ? 1 : count + 1);
    }
    counts.forEach((count, audioNode)=>visitor(audioNode, count));
};

});

parcelRegister("60fE7", function(module, exports) {

$parcel$export(module.exports, "wrapAudioNodeDisconnectMethod", () => $45eee126c9cecc49$export$d4ca24d0078a887f);

var $r5aQ5 = parcelRequire("r5aQ5");
const $45eee126c9cecc49$export$d4ca24d0078a887f = (nativeAudioNode)=>{
    const connections = new Map();
    nativeAudioNode.connect = ((connect)=>{
        // tslint:disable-next-line:invalid-void no-inferrable-types
        return (destination, output = 0, input = 0)=>{
            const returnValue = (0, $r5aQ5.isNativeAudioNode)(destination) ? connect(destination, output, input) : connect(destination, output);
            // Save the new connection only if the calls to connect above didn't throw an error.
            const connectionsToDestination = connections.get(destination);
            if (connectionsToDestination === undefined) connections.set(destination, [
                {
                    input: input,
                    output: output
                }
            ]);
            else if (connectionsToDestination.every((connection)=>connection.input !== input || connection.output !== output)) connectionsToDestination.push({
                input: input,
                output: output
            });
            return returnValue;
        };
    })(nativeAudioNode.connect.bind(nativeAudioNode));
    nativeAudioNode.disconnect = ((disconnect)=>{
        return (destinationOrOutput, output, input)=>{
            disconnect.apply(nativeAudioNode);
            if (destinationOrOutput === undefined) connections.clear();
            else if (typeof destinationOrOutput === 'number') for (const [destination, connectionsToDestination] of connections){
                const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== destinationOrOutput);
                if (filteredConnections.length === 0) connections.delete(destination);
                else connections.set(destination, filteredConnections);
            }
            else if (connections.has(destinationOrOutput)) {
                if (output === undefined) connections.delete(destinationOrOutput);
                else {
                    const connectionsToDestination = connections.get(destinationOrOutput);
                    if (connectionsToDestination !== undefined) {
                        const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== output && (connection.input !== input || input === undefined));
                        if (filteredConnections.length === 0) connections.delete(destinationOrOutput);
                        else connections.set(destinationOrOutput, filteredConnections);
                    }
                }
            }
            for (const [destination, connectionsToDestination] of connections)connectionsToDestination.forEach((connection)=>{
                if ((0, $r5aQ5.isNativeAudioNode)(destination)) nativeAudioNode.connect(destination, connection.output, connection.input);
                else nativeAudioNode.connect(destination, connection.output);
            });
        };
    })(nativeAudioNode.disconnect);
};

});
parcelRegister("r5aQ5", function(module, exports) {

$parcel$export(module.exports, "isNativeAudioNode", () => $0516892523b8e559$export$d647358384f164e0);
const $0516892523b8e559$export$d647358384f164e0 = (nativeAudioNodeOrAudioParam)=>{
    return 'context' in nativeAudioNodeOrAudioParam;
};

});



parcelRegister("gSUC5", function(module, exports) {

$parcel$export(module.exports, "createAudioParamFactory", () => $c4ad9ab3e05357f3$export$25d3edb077748cfc);

var $hOQY6 = parcelRequire("hOQY6");
const $c4ad9ab3e05357f3$export$25d3edb077748cfc = (addAudioParamConnections, audioParamAudioNodeStore, audioParamStore, createAudioParamRenderer, createCancelAndHoldAutomationEvent, createCancelScheduledValuesAutomationEvent, createExponentialRampToValueAutomationEvent, createLinearRampToValueAutomationEvent, createSetTargetAutomationEvent, createSetValueAutomationEvent, createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible)=>{
    return (audioNode, isAudioParamOfOfflineAudioContext, nativeAudioParam, maxValue = null, minValue = null)=>{
        // Bug #196 Only Safari sets the defaultValue to the initial value.
        const defaultValue = nativeAudioParam.value;
        const automationEventList = new (0, $hOQY6.AutomationEventList)(defaultValue);
        const audioParamRenderer = isAudioParamOfOfflineAudioContext ? createAudioParamRenderer(automationEventList) : null;
        const audioParam = {
            get defaultValue () {
                return defaultValue;
            },
            get maxValue () {
                return maxValue === null ? nativeAudioParam.maxValue : maxValue;
            },
            get minValue () {
                return minValue === null ? nativeAudioParam.minValue : minValue;
            },
            get value () {
                return nativeAudioParam.value;
            },
            set value (value){
                nativeAudioParam.value = value;
                // Bug #98: Firefox & Safari do not yet treat the value setter like a call to setValueAtTime().
                audioParam.setValueAtTime(value, audioNode.context.currentTime);
            },
            cancelAndHoldAtTime (cancelTime) {
                // Bug #28: Firefox & Safari do not yet implement cancelAndHoldAtTime().
                if (typeof nativeAudioParam.cancelAndHoldAtTime === 'function') {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    nativeAudioParam.cancelAndHoldAtTime(cancelTime);
                } else {
                    const previousLastEvent = Array.from(automationEventList).pop();
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    const currentLastEvent = Array.from(automationEventList).pop();
                    nativeAudioParam.cancelScheduledValues(cancelTime);
                    if (previousLastEvent !== currentLastEvent && currentLastEvent !== undefined) {
                        if (currentLastEvent.type === 'exponentialRampToValue') nativeAudioParam.exponentialRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'linearRampToValue') nativeAudioParam.linearRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'setValue') nativeAudioParam.setValueAtTime(currentLastEvent.value, currentLastEvent.startTime);
                        else if (currentLastEvent.type === 'setValueCurve') nativeAudioParam.setValueCurveAtTime(currentLastEvent.values, currentLastEvent.startTime, currentLastEvent.duration);
                    }
                }
                return audioParam;
            },
            cancelScheduledValues (cancelTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createCancelScheduledValuesAutomationEvent(cancelTime));
                nativeAudioParam.cancelScheduledValues(cancelTime);
                return audioParam;
            },
            exponentialRampToValueAtTime (value1, endTime) {
                // Bug #45: Safari does not throw an error yet.
                if (value1 === 0) throw new RangeError();
                // Bug #187: Safari does not throw an error yet.
                if (!Number.isFinite(endTime) || endTime < 0) throw new RangeError();
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #194: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createExponentialRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.exponentialRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            linearRampToValueAtTime (value1, endTime) {
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #195: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createLinearRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.linearRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            setTargetAtTime (target, startTime, timeConstant) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetTargetAutomationEvent(target, startTime, timeConstant));
                nativeAudioParam.setTargetAtTime(target, startTime, timeConstant);
                return audioParam;
            },
            setValueAtTime (value1, startTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetValueAutomationEvent(value1, startTime));
                nativeAudioParam.setValueAtTime(value1, startTime);
                return audioParam;
            },
            setValueCurveAtTime (values, startTime, duration) {
                // Bug 183: Safari only accepts a Float32Array.
                const convertedValues = values instanceof Float32Array ? values : new Float32Array(values);
                /*
                 * Bug #152: Safari does not correctly interpolate the values of the curve.
                 * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the
                 * existence of the webkitAudioContext is used as a workaround here.
                 */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') {
                    const endTime = startTime + duration;
                    const sampleRate = audioNode.context.sampleRate;
                    const firstSample = Math.ceil(startTime * sampleRate);
                    const lastSample = Math.floor(endTime * sampleRate);
                    const numberOfInterpolatedValues = lastSample - firstSample;
                    const interpolatedValues = new Float32Array(numberOfInterpolatedValues);
                    for(let i = 0; i < numberOfInterpolatedValues; i += 1){
                        const theoreticIndex = (convertedValues.length - 1) / duration * ((firstSample + i) / sampleRate - startTime);
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        interpolatedValues[i] = lowerIndex === upperIndex ? convertedValues[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * convertedValues[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * convertedValues[upperIndex];
                    }
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(interpolatedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(interpolatedValues, startTime, duration);
                    const timeOfLastSample = lastSample / sampleRate;
                    if (timeOfLastSample < endTime) setValueAtTimeUntilPossible(audioParam, interpolatedValues[interpolatedValues.length - 1], timeOfLastSample);
                    setValueAtTimeUntilPossible(audioParam, convertedValues[convertedValues.length - 1], endTime);
                } else {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(convertedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(convertedValues, startTime, duration);
                }
                return audioParam;
            }
        };
        audioParamStore.set(audioParam, nativeAudioParam);
        audioParamAudioNodeStore.set(audioParam, audioNode);
        addAudioParamConnections(audioParam, audioParamRenderer);
        return audioParam;
    };
};

});

parcelRegister("79abV", function(module, exports) {

$parcel$export(module.exports, "createAudioParamRenderer", () => $53414772b9cc5a2a$export$8858f507eb103ac6);
const $53414772b9cc5a2a$export$8858f507eb103ac6 = (automationEventList)=>{
    return {
        replay (audioParam) {
            for (const automationEvent of automationEventList){
                if (automationEvent.type === 'exponentialRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.exponentialRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'linearRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.linearRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'setTarget') {
                    const { startTime: startTime, target: target, timeConstant: timeConstant } = automationEvent;
                    audioParam.setTargetAtTime(target, startTime, timeConstant);
                } else if (automationEvent.type === 'setValue') {
                    const { startTime: startTime, value: value } = automationEvent;
                    audioParam.setValueAtTime(value, startTime);
                } else if (automationEvent.type === 'setValueCurve') {
                    const { duration: duration, startTime: startTime, values: values } = automationEvent;
                    audioParam.setValueCurveAtTime(values, startTime, duration);
                } else throw new Error("Can't apply an unknown automation.");
            }
        }
    };
};

});

parcelRegister("a93CL", function(module, exports) {

$parcel$export(module.exports, "createAudioWorkletNodeConstructor", () => $762d8e57091605bb$export$48302d37fa2cf062);

var $kBpIy = parcelRequire("kBpIy");

var $9lofq = parcelRequire("9lofq");
const $762d8e57091605bb$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 1,
    numberOfOutputs: 1,
    parameterData: {},
    processorOptions: {}
};
const $762d8e57091605bb$export$48302d37fa2cf062 = (addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener)=>{
    return class AudioWorkletNode extends audioNodeConstructor {
        constructor(context, name, options){
            var _a;
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = sanitizeAudioWorkletNodeOptions({
                ...$762d8e57091605bb$var$DEFAULT_OPTIONS,
                ...options
            });
            // Bug #191: Safari doesn't throw an error if the options aren't clonable.
            testAudioWorkletNodeOptionsClonability(mergedOptions);
            const nodeNameToProcessorConstructorMap = (0, $kBpIy.NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS).get(nativeContext);
            const processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name);
            // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
            const nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== 'closed' ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
            const nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
            const audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
            /*
             * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
             * returns false.
             */ super(context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
            const parameters = [];
            nativeAudioWorkletNode.parameters.forEach((nativeAudioParam, nm)=>{
                const audioParam = createAudioParam(this, isOffline, nativeAudioParam);
                parameters.push([
                    nm,
                    audioParam
                ]);
            });
            this._nativeAudioWorkletNode = nativeAudioWorkletNode;
            this._onprocessorerror = null;
            this._parameters = new (0, $9lofq.ReadOnlyMap)(parameters);
            /*
             * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
             * the destination.
             */ if (isOffline) addUnrenderedAudioWorkletNode(nativeContext, this);
            const { activeInputs: activeInputs } = getAudioNodeConnections(this);
            setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
        }
        get onprocessorerror() {
            return this._onprocessorerror;
        }
        set onprocessorerror(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
            const nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
            this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
        }
        get parameters() {
            if (this._parameters === null) // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            return this._nativeAudioWorkletNode.parameters;
            return this._parameters;
        }
        get port() {
            return this._nativeAudioWorkletNode.port;
        }
    };
};

});
parcelRegister("9lofq", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyMap", () => $6cd8e257e1c32737$export$5da0cf80a3ca75d6);
class $6cd8e257e1c32737$export$5da0cf80a3ca75d6 {
    constructor(parameters){
        this._map = new Map(parameters);
    }
    get size() {
        return this._map.size;
    }
    entries() {
        return this._map.entries();
    }
    forEach(callback, thisArg = null) {
        return this._map.forEach((value, key)=>callback.call(thisArg, value, key, this));
    }
    get(name) {
        return this._map.get(name);
    }
    has(name) {
        return this._map.has(name);
    }
    keys() {
        return this._map.keys();
    }
    values() {
        return this._map.values();
    }
}

});


parcelRegister("8yjbp", function(module, exports) {

$parcel$export(module.exports, "createAudioWorkletNodeRendererFactory", () => $63a0610e38c28374$export$3a898af5d2b29a5b);

var $8U52d = parcelRequire("8U52d");

var $3x1mb = parcelRequire("3x1mb");

var $1Zg3Q = parcelRequire("1Zg3Q");

var $aO4oU = parcelRequire("aO4oU");

var $iE8wl = parcelRequire("iE8wl");

var $37LPX = parcelRequire("37LPX");
const $63a0610e38c28374$var$processBuffer = async (proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime)=>{
    // Ceil the length to the next full render quantum.
    // Bug #17: Safari does not yet expose the length.
    const length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
    const numberOfInputChannels = options.channelCount * options.numberOfInputs;
    const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
    const processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);
    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
    const audioNodeConnections = (0, $aO4oU.getAudioNodeConnections)(proxy);
    const audioWorkletProcessor = await (0, $iE8wl.getAudioWorkletProcessor)(nativeOfflineAudioContext, proxy);
    const inputs = (0, $1Zg3Q.createNestedArrays)(options.numberOfInputs, options.channelCount);
    const outputs = (0, $1Zg3Q.createNestedArrays)(options.numberOfOutputs, outputChannelCount);
    const parameters = Array.from(proxy.parameters.keys()).reduce((prmtrs, name)=>({
            ...prmtrs,
            [name]: new Float32Array(128)
        }), {});
    for(let i = 0; i < length; i += 128){
        if (options.numberOfInputs > 0 && renderedBuffer !== null) {
            for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $8U52d.copyFromChannel)(renderedBuffer, inputs[j], k, k, i);
        }
        if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
            (0, $8U52d.copyFromChannel)(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
        });
        for(let j = 0; j < options.numberOfInputs; j += 1){
            for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
            if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
        }
        try {
            const potentiallyEmptyInputs = inputs.map((input, index)=>{
                if (audioNodeConnections.activeInputs[index].size === 0) return [];
                return input;
            });
            const activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
            if (processedBuffer !== null) for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $3x1mb.copyToChannel)(processedBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                outputChannelSplitterNodeOutput += outputChannelCount[j];
            }
            if (!activeSourceFlag) break;
        } catch (error) {
            proxy.dispatchEvent(new ErrorEvent('processorerror', {
                colno: error.colno,
                filename: error.filename,
                lineno: error.lineno,
                message: error.message
            }));
            break;
        }
    }
    return processedBuffer;
};
const $63a0610e38c28374$export$3a898af5d2b29a5b = (connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (name, options, processorConstructor)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let processedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioWorkletNode = getNativeAudioNode(proxy);
            let nativeOutputNodes = null;
            const nativeAudioWorkletNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeAudioWorkletNode, nativeOfflineAudioContext);
            const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
            // Bug #61: Only Chrome, Edge & Firefox have an implementation of the AudioWorkletNode yet.
            if (nativeAudioWorkletNodeConstructor === null) {
                const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
                const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                    channelCount: Math.max(1, numberOfOutputChannels),
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    numberOfOutputs: Math.max(1, numberOfOutputChannels)
                });
                const outputChannelMergerNodes = [];
                for(let i = 0; i < proxy.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'speakers',
                    numberOfInputs: outputChannelCount[i]
                }));
                const outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                });
                outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
                outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
                nativeOutputNodes = [
                    outputChannelSplitterNode,
                    outputChannelMergerNodes,
                    outputGainNode
                ];
            } else if (!nativeAudioWorkletNodeIsOwnedByContext) nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);
            if (nativeOutputNodes !== null) {
                if (processedBufferPromise === null) {
                    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    const numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                    const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
                    const numberOfChannels = numberOfInputChannels + numberOfParameters;
                    const renderBuffer = async ()=>{
                        const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
                        // Bug #17: Safari does not yet expose the length.
                        Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                        const gainNodes = [];
                        const inputChannelSplitterNodes = [];
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: options.channelCountMode,
                                channelInterpretation: options.channelInterpretation,
                                gain: 1
                            }));
                            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                numberOfOutputs: options.channelCount
                            }));
                        }
                        const constantSourceNodes = await Promise.all(Array.from(proxy.parameters.values()).map(async (audioParam)=>{
                            const constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: audioParam.value
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset);
                            return constantSourceNode;
                        }));
                        const inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                            channelCount: 1,
                            channelCountMode: 'explicit',
                            channelInterpretation: 'speakers',
                            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
                        });
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes[i].connect(inputChannelSplitterNodes[i]);
                            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
                        }
                        for (const [index, constantSourceNode] of constantSourceNodes.entries()){
                            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
                            constantSourceNode.start(0);
                        }
                        inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                        await Promise.all(gainNodes.map((gainNode)=>renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode)));
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    };
                    processedBufferPromise = $63a0610e38c28374$var$processBuffer(proxy, numberOfChannels === 0 ? null : await renderBuffer(), nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime);
                }
                const processedBuffer = await processedBufferPromise;
                const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                    buffer: null,
                    channelCount: 2,
                    channelCountMode: 'max',
                    channelInterpretation: 'speakers',
                    loop: false,
                    loopEnd: 0,
                    loopStart: 0,
                    playbackRate: 1
                });
                const [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode] = nativeOutputNodes;
                if (processedBuffer !== null) {
                    audioBufferSourceNode.buffer = processedBuffer;
                    audioBufferSourceNode.start(0);
                }
                audioBufferSourceNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < proxy.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
                return outputGainNode;
            }
            if (!nativeAudioWorkletNodeIsOwnedByContext) for (const [nm, audioParam] of proxy.parameters.entries())await renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            else for (const [nm, audioParam] of proxy.parameters.entries())await connectAudioParam(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode);
            return nativeAudioWorkletNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
                const renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});
parcelRegister("8U52d", function(module, exports) {

$parcel$export(module.exports, "copyFromChannel", () => $01ac3fd4b09b476b$export$e3c6e435bf217093);
function $01ac3fd4b09b476b$export$e3c6e435bf217093(audioBuffer, // @todo There is currently no way to define something like { [ key: number | string ]: Float32Array }
parent, key, channelNumber, bufferOffset) {
    if (typeof audioBuffer.copyFromChannel === 'function') {
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = new Float32Array(128);
        audioBuffer.copyFromChannel(parent[key], channelNumber, bufferOffset);
    // Bug #5: Safari does not support copyFromChannel().
    } else {
        const channelData = audioBuffer.getChannelData(channelNumber);
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = channelData.slice(bufferOffset, bufferOffset + 128);
        else {
            const slicedInput = new Float32Array(channelData.buffer, bufferOffset * Float32Array.BYTES_PER_ELEMENT, 128);
            parent[key].set(slicedInput);
        }
    }
}

});

parcelRegister("3x1mb", function(module, exports) {

$parcel$export(module.exports, "copyToChannel", () => $2925819d51ea8729$export$6bb6d131144bd753);
const $2925819d51ea8729$export$6bb6d131144bd753 = (audioBuffer, parent, key, channelNumber, bufferOffset)=>{
    if (typeof audioBuffer.copyToChannel === 'function') // The byteLength will be 0 when the ArrayBuffer was transferred.
    {
        if (parent[key].byteLength !== 0) audioBuffer.copyToChannel(parent[key], channelNumber, bufferOffset);
    } else // The byteLength will be 0 when the ArrayBuffer was transferred.
    if (parent[key].byteLength !== 0) audioBuffer.getChannelData(channelNumber).set(parent[key], bufferOffset);
};

});

parcelRegister("1Zg3Q", function(module, exports) {

$parcel$export(module.exports, "createNestedArrays", () => $1727f25ac07dab1e$export$495a31436d188d6d);
const $1727f25ac07dab1e$export$495a31436d188d6d = (x, y)=>{
    const arrays = [];
    for(let i = 0; i < x; i += 1){
        const array = [];
        const length = typeof y === 'number' ? y : y[i];
        for(let j = 0; j < length; j += 1)array.push(new Float32Array(128));
        arrays.push(array);
    }
    return arrays;
};

});

parcelRegister("iE8wl", function(module, exports) {

$parcel$export(module.exports, "getAudioWorkletProcessor", () => $d932926d6f3cd8ea$export$d948bbdb8f0d97d7);

var $kBpIy = parcelRequire("kBpIy");

var $eSkbj = parcelRequire("eSkbj");

var $8sbmW = parcelRequire("8sbmW");
const $d932926d6f3cd8ea$export$d948bbdb8f0d97d7 = (nativeOfflineAudioContext, proxy)=>{
    const nodeToProcessorMap = (0, $8sbmW.getValueForKey)((0, $kBpIy.NODE_TO_PROCESSOR_MAPS), nativeOfflineAudioContext);
    const nativeAudioWorkletNode = (0, $eSkbj.getNativeAudioNode)(proxy);
    return (0, $8sbmW.getValueForKey)(nodeToProcessorMap, nativeAudioWorkletNode);
};

});


parcelRegister("1xttk", function(module, exports) {

$parcel$export(module.exports, "createBaseAudioContextConstructor", () => $11efbc113f5ca266$export$7824d6f4713e1e35);
const $11efbc113f5ca266$export$7824d6f4713e1e35 = (addAudioWorkletModule, analyserNodeConstructor, audioBufferConstructor, audioBufferSourceNodeConstructor, biquadFilterNodeConstructor, channelMergerNodeConstructor, channelSplitterNodeConstructor, constantSourceNodeConstructor, convolverNodeConstructor, decodeAudioData, delayNodeConstructor, dynamicsCompressorNodeConstructor, gainNodeConstructor, iIRFilterNodeConstructor, minimalBaseAudioContextConstructor, oscillatorNodeConstructor, pannerNodeConstructor, periodicWaveConstructor, stereoPannerNodeConstructor, waveShaperNodeConstructor)=>{
    return class BaseAudioContext extends minimalBaseAudioContextConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext, numberOfChannels);
            this._nativeContext = _nativeContext;
            this._audioWorklet = addAudioWorkletModule === undefined ? undefined : {
                addModule: (moduleURL, options)=>{
                    return addAudioWorkletModule(this, moduleURL, options);
                }
            };
        }
        get audioWorklet() {
            return this._audioWorklet;
        }
        createAnalyser() {
            return new analyserNodeConstructor(this);
        }
        createBiquadFilter() {
            return new biquadFilterNodeConstructor(this);
        }
        createBuffer(numberOfChannels, length, sampleRate) {
            return new audioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            });
        }
        createBufferSource() {
            return new audioBufferSourceNodeConstructor(this);
        }
        createChannelMerger(numberOfInputs = 6) {
            return new channelMergerNodeConstructor(this, {
                numberOfInputs: numberOfInputs
            });
        }
        createChannelSplitter(numberOfOutputs = 6) {
            return new channelSplitterNodeConstructor(this, {
                numberOfOutputs: numberOfOutputs
            });
        }
        createConstantSource() {
            return new constantSourceNodeConstructor(this);
        }
        createConvolver() {
            return new convolverNodeConstructor(this);
        }
        createDelay(maxDelayTime = 1) {
            return new delayNodeConstructor(this, {
                maxDelayTime: maxDelayTime
            });
        }
        createDynamicsCompressor() {
            return new dynamicsCompressorNodeConstructor(this);
        }
        createGain() {
            return new gainNodeConstructor(this);
        }
        createIIRFilter(feedforward, feedback) {
            return new iIRFilterNodeConstructor(this, {
                feedback: feedback,
                feedforward: feedforward
            });
        }
        createOscillator() {
            return new oscillatorNodeConstructor(this);
        }
        createPanner() {
            return new pannerNodeConstructor(this);
        }
        createPeriodicWave(real, imag, constraints = {
            disableNormalization: false
        }) {
            return new periodicWaveConstructor(this, {
                ...constraints,
                imag: imag,
                real: real
            });
        }
        createStereoPanner() {
            return new stereoPannerNodeConstructor(this);
        }
        createWaveShaper() {
            return new waveShaperNodeConstructor(this);
        }
        decodeAudioData(audioData, successCallback, errorCallback) {
            return decodeAudioData(this._nativeContext, audioData).then((audioBuffer)=>{
                if (typeof successCallback === 'function') successCallback(audioBuffer);
                return audioBuffer;
            }, (err)=>{
                if (typeof errorCallback === 'function') errorCallback(err);
                throw err;
            });
        }
    };
};

});

parcelRegister("ja40t", function(module, exports) {

$parcel$export(module.exports, "createBiquadFilterNodeConstructor", () => $df320f1c62677022$export$aa421daabad177b5);

var $lQo9t = parcelRequire("lQo9t");
const $df320f1c62677022$var$DEFAULT_OPTIONS = {
    Q: 1,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 350,
    gain: 0,
    type: 'lowpass'
};
const $df320f1c62677022$export$aa421daabad177b5 = (audioNodeConstructor, createAudioParam, createBiquadFilterNodeRenderer, createInvalidAccessError, createNativeBiquadFilterNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class BiquadFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$df320f1c62677022$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const biquadFilterNodeRenderer = isOffline ? createBiquadFilterNodeRenderer() : null;
            super(context, false, nativeBiquadFilterNode, biquadFilterNodeRenderer);
            // Bug #80: Safari does not export the correct values for maxValue and minValue.
            this._Q = createAudioParam(this, isOffline, nativeBiquadFilterNode.Q, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            // Bug #78: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeBiquadFilterNode.detune, 1200 * Math.log2((0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT)), -1200 * Math.log2((0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT)));
            // Bug #77: Firefox & Safari do not export the correct value for minValue.
            this._frequency = createAudioParam(this, isOffline, nativeBiquadFilterNode.frequency, context.sampleRate / 2, 0);
            // Bug #79: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeBiquadFilterNode.gain, 40 * Math.log10((0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT)), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._nativeBiquadFilterNode = nativeBiquadFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get gain() {
            return this._gain;
        }
        get Q() {
            return this._Q;
        }
        get type() {
            return this._nativeBiquadFilterNode.type;
        }
        set type(value) {
            this._nativeBiquadFilterNode.type = value;
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            // Bug #189: Safari does throw an InvalidStateError.
            try {
                this._nativeBiquadFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
            } catch (err) {
                if (err.code === 11) throw createInvalidAccessError();
                throw err;
            }
            // Bug #68: Safari does not throw an error if the parameters differ in their length.
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
        }
    };
};

});

parcelRegister("1KxM9", function(module, exports) {

$parcel$export(module.exports, "createBiquadFilterNodeRendererFactory", () => $1464497206b448ef$export$1532cc6682032d84);

var $37LPX = parcelRequire("37LPX");
const $1464497206b448ef$export$1532cc6682032d84 = (connectAudioParam, createNativeBiquadFilterNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeBiquadFilterNodes = new WeakMap();
        const createBiquadFilterNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeBiquadFilterNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeBiquadFilterNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeBiquadFilterNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeBiquadFilterNode, nativeOfflineAudioContext);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                const options = {
                    Q: nativeBiquadFilterNode.Q.value,
                    channelCount: nativeBiquadFilterNode.channelCount,
                    channelCountMode: nativeBiquadFilterNode.channelCountMode,
                    channelInterpretation: nativeBiquadFilterNode.channelInterpretation,
                    detune: nativeBiquadFilterNode.detune.value,
                    frequency: nativeBiquadFilterNode.frequency.value,
                    gain: nativeBiquadFilterNode.gain.value,
                    type: nativeBiquadFilterNode.type
                };
                nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeBiquadFilterNodes.set(nativeOfflineAudioContext, nativeBiquadFilterNode);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeBiquadFilterNode);
            return nativeBiquadFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeBiquadFilterNode = renderedNativeBiquadFilterNodes.get(nativeOfflineAudioContext);
                if (renderedNativeBiquadFilterNode !== undefined) return Promise.resolve(renderedNativeBiquadFilterNode);
                return createBiquadFilterNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("at74R", function(module, exports) {

$parcel$export(module.exports, "createCacheTestResult", () => $79f21a43d63650ae$export$e72d622686b5f6c7);
const $79f21a43d63650ae$export$e72d622686b5f6c7 = (ongoingTests, testResults)=>{
    return (tester, test)=>{
        const cachedTestResult = testResults.get(tester);
        if (cachedTestResult !== undefined) return cachedTestResult;
        const ongoingTest = ongoingTests.get(tester);
        if (ongoingTest !== undefined) return ongoingTest;
        try {
            const synchronousTestResult = test();
            if (synchronousTestResult instanceof Promise) {
                ongoingTests.set(tester, synchronousTestResult);
                return synchronousTestResult.catch(()=>false).then((finalTestResult)=>{
                    ongoingTests.delete(tester);
                    testResults.set(tester, finalTestResult);
                    return finalTestResult;
                });
            }
            testResults.set(tester, synchronousTestResult);
            return synchronousTestResult;
        } catch  {
            testResults.set(tester, false);
            return false;
        }
    };
};

});

parcelRegister("1BQb0", function(module, exports) {

$parcel$export(module.exports, "createChannelMergerNodeConstructor", () => $12c1b8551e7a6a38$export$a65a5a400135d27);
const $12c1b8551e7a6a38$var$DEFAULT_OPTIONS = {
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 6
};
const $12c1b8551e7a6a38$export$a65a5a400135d27 = (audioNodeConstructor, createChannelMergerNodeRenderer, createNativeChannelMergerNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class ChannelMergerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$12c1b8551e7a6a38$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeChannelMergerNode = createNativeChannelMergerNode(nativeContext, mergedOptions);
            const channelMergerNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelMergerNodeRenderer() : null;
            super(context, false, nativeChannelMergerNode, channelMergerNodeRenderer);
        }
    };
};

});

parcelRegister("lhgou", function(module, exports) {

$parcel$export(module.exports, "createChannelMergerNodeRendererFactory", () => $f7d7e7004bac5829$export$79056cbe2b10cae5);

var $37LPX = parcelRequire("37LPX");
const $f7d7e7004bac5829$export$79056cbe2b10cae5 = (createNativeChannelMergerNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfInputs: nativeAudioNode.numberOfInputs
                };
                nativeAudioNode = createNativeChannelMergerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("hBsOy", function(module, exports) {

$parcel$export(module.exports, "createChannelSplitterNodeConstructor", () => $cd0c3e543fe148a7$export$ce9d996cafa605b);
const $cd0c3e543fe148a7$var$DEFAULT_OPTIONS = {
    channelCount: 6,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    numberOfOutputs: 6
};
const $cd0c3e543fe148a7$export$ce9d996cafa605b = (audioNodeConstructor, createChannelSplitterNodeRenderer, createNativeChannelSplitterNode, getNativeContext, isNativeOfflineAudioContext, sanitizeChannelSplitterOptions)=>{
    return class ChannelSplitterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizeChannelSplitterOptions({
                ...$cd0c3e543fe148a7$var$DEFAULT_OPTIONS,
                ...options
            });
            const nativeChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, mergedOptions);
            const channelSplitterNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelSplitterNodeRenderer() : null;
            super(context, false, nativeChannelSplitterNode, channelSplitterNodeRenderer);
        }
    };
};

});

parcelRegister("7z0Yz", function(module, exports) {

$parcel$export(module.exports, "createChannelSplitterNodeRendererFactory", () => $581c8f1d803f5a1f$export$d815cad16abde9c3);

var $37LPX = parcelRequire("37LPX");
const $581c8f1d803f5a1f$export$d815cad16abde9c3 = (createNativeChannelSplitterNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfOutputs: nativeAudioNode.numberOfOutputs
                };
                nativeAudioNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("jU4NY", function(module, exports) {

$parcel$export(module.exports, "createConnectAudioParam", () => $e7d6f9720bda7644$export$1e69fdca2ad79f10);
const $e7d6f9720bda7644$export$1e69fdca2ad79f10 = (renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};

});

parcelRegister("5pRJO", function(module, exports) {

$parcel$export(module.exports, "createConnectMultipleOutputs", () => $3f18f8cdb7bfa145$export$5f708e50316bf1a);

var $r5aQ5 = parcelRequire("r5aQ5");
const $3f18f8cdb7bfa145$export$5f708e50316bf1a = (createIndexSizeError)=>{
    return (outputAudioNodes, destination, output = 0, input = 0)=>{
        const outputAudioNode = outputAudioNodes[output];
        if (outputAudioNode === undefined) throw createIndexSizeError();
        if ((0, $r5aQ5.isNativeAudioNode)(destination)) return outputAudioNode.connect(destination, 0, input);
        return outputAudioNode.connect(destination, 0);
    };
};

});

parcelRegister("gbvfd", function(module, exports) {

$parcel$export(module.exports, "createConnectedNativeAudioBufferSourceNodeFactory", () => $bc85e8e57c58c260$export$e82b2b63ea82dc82);
const $bc85e8e57c58c260$export$e82b2b63ea82dc82 = (createNativeAudioBufferSourceNode)=>{
    return (nativeContext, nativeAudioNode)=>{
        const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const nativeAudioBuffer = nativeContext.createBuffer(1, 2, 44100);
        nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
        nativeAudioBufferSourceNode.loop = true;
        nativeAudioBufferSourceNode.connect(nativeAudioNode);
        nativeAudioBufferSourceNode.start();
        return ()=>{
            nativeAudioBufferSourceNode.stop();
            nativeAudioBufferSourceNode.disconnect(nativeAudioNode);
        };
    };
};

});

parcelRegister("e6Pgs", function(module, exports) {

$parcel$export(module.exports, "createConstantSourceNodeConstructor", () => $a459644cd4d78404$export$a02a9a6200996500);

var $lQo9t = parcelRequire("lQo9t");

var $8pz9Z = parcelRequire("8pz9Z");

var $hL1bO = parcelRequire("hL1bO");

var $jqEMr = parcelRequire("jqEMr");
const $a459644cd4d78404$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    offset: 1
};
const $a459644cd4d78404$export$a02a9a6200996500 = (audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class ConstantSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$a459644cd4d78404$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
            super(context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
            this._constantSourceNodeRenderer = constantSourceNodeRenderer;
            this._nativeConstantSourceNode = nativeConstantSourceNode;
            /*
             * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
             * for GainNodes.
             */ this._offset = createAudioParam(this, isOffline, nativeConstantSourceNode.offset, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._onended = null;
        }
        get offset() {
            return this._offset;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeConstantSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeConstantSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        start(when = 0) {
            this._nativeConstantSourceNode.start(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $hL1bO.setInternalStateToActive)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeConstantSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $8pz9Z.isActiveAudioNode)(this)) (0, $jqEMr.setInternalStateToPassive)(this);
                };
                this._nativeConstantSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeConstantSourceNode.stop(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.stop = when;
        }
    };
};

});

parcelRegister("i4thH", function(module, exports) {

$parcel$export(module.exports, "createConstantSourceNodeRendererFactory", () => $d27f50fd0ab5fac7$export$bc541a3c87b45a7d);

var $37LPX = parcelRequire("37LPX");
const $d27f50fd0ab5fac7$export$bc541a3c87b45a7d = (connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConstantSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createConstantSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConstantSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeConstantSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeConstantSourceNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeConstantSourceNode, nativeOfflineAudioContext);
            if (!nativeConstantSourceNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeConstantSourceNode.channelCount,
                    channelCountMode: nativeConstantSourceNode.channelCountMode,
                    channelInterpretation: nativeConstantSourceNode.channelInterpretation,
                    offset: nativeConstantSourceNode.offset.value
                };
                nativeConstantSourceNode = createNativeConstantSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeConstantSourceNode.start(start);
                if (stop !== null) nativeConstantSourceNode.stop(stop);
            }
            renderedNativeConstantSourceNodes.set(nativeOfflineAudioContext, nativeConstantSourceNode);
            if (!nativeConstantSourceNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConstantSourceNode);
            return nativeConstantSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConstantSourceNode = renderedNativeConstantSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConstantSourceNode !== undefined) return Promise.resolve(renderedNativeConstantSourceNode);
                return createConstantSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("eNeFn", function(module, exports) {

$parcel$export(module.exports, "createConvertNumberToUnsignedLong", () => $ac5104b6494b5aac$export$540e228106d2c471);
const $ac5104b6494b5aac$export$540e228106d2c471 = (unit32Array)=>{
    return (value)=>{
        unit32Array[0] = value;
        return unit32Array[0];
    };
};

});

parcelRegister("5B7u4", function(module, exports) {

$parcel$export(module.exports, "createConvolverNodeConstructor", () => $413636a3b0de4e57$export$4894173a4b4ee485);
const $413636a3b0de4e57$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    disableNormalization: false
};
const $413636a3b0de4e57$export$4894173a4b4ee485 = (audioNodeConstructor, createConvolverNodeRenderer, createNativeConvolverNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class ConvolverNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$413636a3b0de4e57$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConvolverNode = createNativeConvolverNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const convolverNodeRenderer = isOffline ? createConvolverNodeRenderer() : null;
            super(context, false, nativeConvolverNode, convolverNodeRenderer);
            this._isBufferNullified = false;
            this._nativeConvolverNode = nativeConvolverNode;
            if (mergedOptions.buffer !== null) setAudioNodeTailTime(this, mergedOptions.buffer.duration);
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeConvolverNode.buffer;
        }
        set buffer(value) {
            this._nativeConvolverNode.buffer = value;
            // Bug #115: Safari does not allow to set the buffer to null.
            if (value === null && this._nativeConvolverNode.buffer !== null) {
                const nativeContext = this._nativeConvolverNode.context;
                this._nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
                this._isBufferNullified = true;
                setAudioNodeTailTime(this, 0);
            } else {
                this._isBufferNullified = false;
                setAudioNodeTailTime(this, this._nativeConvolverNode.buffer === null ? 0 : this._nativeConvolverNode.buffer.duration);
            }
        }
        get normalize() {
            return this._nativeConvolverNode.normalize;
        }
        set normalize(value) {
            this._nativeConvolverNode.normalize = value;
        }
    };
};

});

parcelRegister("bapQr", function(module, exports) {

$parcel$export(module.exports, "createConvolverNodeRendererFactory", () => $8214ad22b45c90e7$export$5b278ccdb1a6393);

var $eCSga = parcelRequire("eCSga");

var $37LPX = parcelRequire("37LPX");
const $8214ad22b45c90e7$export$5b278ccdb1a6393 = (createNativeConvolverNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConvolverNodes = new WeakMap();
        const createConvolverNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConvolverNode = getNativeAudioNode(proxy);
            // If the initially used nativeConvolverNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeConvolverNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeConvolverNode, nativeOfflineAudioContext);
            if (!nativeConvolverNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeConvolverNode.buffer,
                    channelCount: nativeConvolverNode.channelCount,
                    channelCountMode: nativeConvolverNode.channelCountMode,
                    channelInterpretation: nativeConvolverNode.channelInterpretation,
                    disableNormalization: !nativeConvolverNode.normalize
                };
                nativeConvolverNode = createNativeConvolverNode(nativeOfflineAudioContext, options);
            }
            renderedNativeConvolverNodes.set(nativeOfflineAudioContext, nativeConvolverNode);
            if ((0, $eCSga.isNativeAudioNodeFaker)(nativeConvolverNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode);
            return nativeConvolverNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConvolverNode = renderedNativeConvolverNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConvolverNode !== undefined) return Promise.resolve(renderedNativeConvolverNode);
                return createConvolverNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("cmh9R", function(module, exports) {

$parcel$export(module.exports, "createCreateNativeOfflineAudioContext", () => $8ff4d955cfe3e434$export$ab44e304a31eb0ae);
const $8ff4d955cfe3e434$export$ab44e304a31eb0ae = (createNotSupportedError, nativeOfflineAudioContextConstructor)=>{
    return (numberOfChannels, length, sampleRate)=>{
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        try {
            return new nativeOfflineAudioContextConstructor(numberOfChannels, length, sampleRate);
        } catch (err) {
            // Bug #143, #144 & #146: Safari throws a SyntaxError when numberOfChannels, length or sampleRate are invalid.
            if (err.name === 'SyntaxError') throw createNotSupportedError();
            throw err;
        }
    };
};

});

parcelRegister("7EdX6", function(module, exports) {

$parcel$export(module.exports, "createDataCloneError", () => $59171770082500d7$export$fc1a599a84ca01a8);
const $59171770082500d7$export$fc1a599a84ca01a8 = ()=>new DOMException('', 'DataCloneError');

});

parcelRegister("5esAO", function(module, exports) {

$parcel$export(module.exports, "createDecodeAudioData", () => $3cf4707a1e421afd$export$d83e4a6039bccfb);

var $cGHZO = parcelRequire("cGHZO");

var $8Znor = parcelRequire("8Znor");
const $3cf4707a1e421afd$export$d83e4a6039bccfb = (audioBufferStore, cacheTestResult, createDataCloneError, createEncodingError, detachedArrayBuffers, getNativeContext, isNativeContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, testPromiseSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (anyContext, audioData)=>{
        const nativeContext = isNativeContext(anyContext) ? anyContext : getNativeContext(anyContext);
        // Bug #43: Only Chrome and Edge do throw a DataCloneError.
        if (detachedArrayBuffers.has(audioData)) {
            const err = createDataCloneError();
            return Promise.reject(err);
        }
        // The audioData parameter maybe of a type which can't be added to a WeakSet.
        try {
            detachedArrayBuffers.add(audioData);
        } catch  {
        // Ignore errors.
        }
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult(testPromiseSupport, ()=>testPromiseSupport(nativeContext))) return nativeContext.decodeAudioData(audioData).then((audioBuffer)=>{
            // Bug #133: Safari does neuter the ArrayBuffer.
            (0, $cGHZO.detachArrayBuffer)(audioData).catch(()=>{
            // Ignore errors.
            });
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
        // Bug #21: Safari does not return a Promise yet.
        return new Promise((resolve, reject)=>{
            const complete = async ()=>{
                // Bug #133: Safari does neuter the ArrayBuffer.
                try {
                    await (0, $cGHZO.detachArrayBuffer)(audioData);
                } catch  {
                // Ignore errors.
                }
            };
            const fail = (err)=>{
                reject(err);
                complete();
            };
            // Bug #26: Safari throws a synchronous error.
            try {
                // Bug #1: Safari requires a successCallback.
                nativeContext.decodeAudioData(audioData, (audioBuffer)=>{
                    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
                    // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
                    if (typeof audioBuffer.copyFromChannel !== 'function') {
                        wrapAudioBufferCopyChannelMethods(audioBuffer);
                        (0, $8Znor.wrapAudioBufferGetChannelDataMethod)(audioBuffer);
                    }
                    audioBufferStore.add(audioBuffer);
                    complete().then(()=>resolve(audioBuffer));
                }, (err)=>{
                    // Bug #4: Safari returns null instead of an error.
                    if (err === null) fail(createEncodingError());
                    else fail(err);
                });
            } catch (err) {
                fail(err);
            }
        });
    };
};

});
parcelRegister("cGHZO", function(module, exports) {

$parcel$export(module.exports, "detachArrayBuffer", () => $93cb88fc03fb839e$export$2d33e41548107ad3);
const $93cb88fc03fb839e$export$2d33e41548107ad3 = (arrayBuffer)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    return new Promise((resolve)=>{
        const closeAndResolve = ()=>{
            port2.onmessage = null;
            port1.close();
            port2.close();
            resolve();
        };
        port2.onmessage = ()=>closeAndResolve();
        try {
            port1.postMessage(arrayBuffer, [
                arrayBuffer
            ]);
        } catch  {
        // Ignore errors.
        } finally{
            closeAndResolve();
        }
    });
};

});


parcelRegister("fTZUy", function(module, exports) {

$parcel$export(module.exports, "createDecrementCycleCounter", () => $b93c0456c9b27086$export$93f58f9268fde9f6);

var $9wk5I = parcelRequire("9wk5I");
const $b93c0456c9b27086$export$93f58f9268fde9f6 = (connectNativeAudioNodeToNativeAudioNode, cycleCounters, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext)=>{
    return (audioNode, count)=>{
        const cycleCounter = cycleCounters.get(audioNode);
        if (cycleCounter === undefined) throw new Error('Missing the expected cycle count.');
        const nativeContext = getNativeContext(audioNode.context);
        const isOffline = isNativeOfflineAudioContext(nativeContext);
        if (cycleCounter === count) {
            cycleCounters.delete(audioNode);
            if (!isOffline && isActiveAudioNode(audioNode)) {
                const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                const { outputs: outputs } = getAudioNodeConnections(audioNode);
                for (const output of outputs)if ((0, $9wk5I.isAudioNodeOutputConnection)(output)) {
                    const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                    connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                } else {
                    const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                    nativeSourceAudioNode.connect(nativeDestinationAudioParam, output[1]);
                }
            }
        } else cycleCounters.set(audioNode, cycleCounter - count);
    };
};

});

parcelRegister("hBhN5", function(module, exports) {

$parcel$export(module.exports, "createDelayNodeConstructor", () => $cd03b1390305ca4f$export$b89a0215c1c607e3);
const $cd03b1390305ca4f$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    delayTime: 0,
    maxDelayTime: 1
};
const $cd03b1390305ca4f$export$b89a0215c1c607e3 = (audioNodeConstructor, createAudioParam, createDelayNodeRenderer, createNativeDelayNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DelayNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$cd03b1390305ca4f$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
            super(context, false, nativeDelayNode, delayNodeRenderer);
            this._delayTime = createAudioParam(this, isOffline, nativeDelayNode.delayTime);
            setAudioNodeTailTime(this, mergedOptions.maxDelayTime);
        }
        get delayTime() {
            return this._delayTime;
        }
    };
};

});

parcelRegister("hgn2W", function(module, exports) {

$parcel$export(module.exports, "createDelayNodeRendererFactory", () => $c915ced682ac9e7d$export$d03c2308083a28e5);

var $37LPX = parcelRequire("37LPX");
const $c915ced682ac9e7d$export$d03c2308083a28e5 = (connectAudioParam, createNativeDelayNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return (maxDelayTime)=>{
        const renderedNativeDelayNodes = new WeakMap();
        const createDelayNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDelayNode = getNativeAudioNode(proxy);
            // If the initially used nativeDelayNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeDelayNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeDelayNode, nativeOfflineAudioContext);
            if (!nativeDelayNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeDelayNode.channelCount,
                    channelCountMode: nativeDelayNode.channelCountMode,
                    channelInterpretation: nativeDelayNode.channelInterpretation,
                    delayTime: nativeDelayNode.delayTime.value,
                    maxDelayTime: maxDelayTime
                };
                nativeDelayNode = createNativeDelayNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDelayNodes.set(nativeOfflineAudioContext, nativeDelayNode);
            if (!nativeDelayNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDelayNode);
            return nativeDelayNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDelayNode = renderedNativeDelayNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDelayNode !== undefined) return Promise.resolve(renderedNativeDelayNode);
                return createDelayNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("dNMGX", function(module, exports) {

$parcel$export(module.exports, "createDeleteActiveInputConnectionToAudioNode", () => $a0c59f29261586bf$export$1f7c0152b9e322ae);
const $a0c59f29261586bf$export$1f7c0152b9e322ae = (pickElementFromSet)=>{
    return (activeInputs, source, output, input)=>{
        return pickElementFromSet(activeInputs[input], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
    };
};

});

parcelRegister("erHzM", function(module, exports) {

$parcel$export(module.exports, "createDeleteUnrenderedAudioWorkletNode", () => $a8456396536e6d92$export$92df121abbf21dca);
const $a8456396536e6d92$export$92df121abbf21dca = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).delete(audioWorkletNode);
    };
};

});

parcelRegister("dDWai", function(module, exports) {

$parcel$export(module.exports, "createDetectCycles", () => $9eec093fdc4099b9$export$b4f8d2824d9887dc);

var $afpuu = parcelRequire("afpuu");

var $k5vd1 = parcelRequire("k5vd1");
const $9eec093fdc4099b9$export$b4f8d2824d9887dc = (audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey)=>{
    return function detectCycles(chain, nextLink) {
        const audioNode = (0, $afpuu.isAudioNode)(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);
        if ((0, $k5vd1.isDelayNode)(audioNode)) return [];
        if (chain[0] === audioNode) return [
            chain
        ];
        if (chain.includes(audioNode)) return [];
        const { outputs: outputs } = getAudioNodeConnections(audioNode);
        return Array.from(outputs).map((outputConnection)=>detectCycles([
                ...chain,
                audioNode
            ], outputConnection[0])).reduce((mergedCycles, nestedCycles)=>mergedCycles.concat(nestedCycles), []);
    };
};

});
parcelRegister("k5vd1", function(module, exports) {

$parcel$export(module.exports, "isDelayNode", () => $e9fc7bbc4ffa8b7b$export$c283d436eafbd9b2);
const $e9fc7bbc4ffa8b7b$export$c283d436eafbd9b2 = (audioNode)=>{
    return 'delayTime' in audioNode;
};

});


parcelRegister("lvVTt", function(module, exports) {

$parcel$export(module.exports, "createDisconnectMultipleOutputs", () => $fa9966b68f575247$export$78a992fad11cd00e);

var $r5aQ5 = parcelRequire("r5aQ5");
const $fa9966b68f575247$var$getOutputAudioNodeAtIndex = (createIndexSizeError, outputAudioNodes, output)=>{
    const outputAudioNode = outputAudioNodes[output];
    if (outputAudioNode === undefined) throw createIndexSizeError();
    return outputAudioNode;
};
const $fa9966b68f575247$export$78a992fad11cd00e = (createIndexSizeError)=>{
    return (outputAudioNodes, destinationOrOutput, output, input = 0)=>{
        if (destinationOrOutput === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect());
        if (typeof destinationOrOutput === 'number') return $fa9966b68f575247$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, destinationOrOutput).disconnect();
        if ((0, $r5aQ5.isNativeAudioNode)(destinationOrOutput)) {
            if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
            if (input === undefined) return $fa9966b68f575247$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
            return $fa9966b68f575247$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0, input);
        }
        if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
        return $fa9966b68f575247$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
    };
};

});

parcelRegister("knTGA", function(module, exports) {

$parcel$export(module.exports, "createDynamicsCompressorNodeConstructor", () => $ed7126b0ce17e016$export$60ec6725c2d45fc8);
const $ed7126b0ce17e016$var$DEFAULT_OPTIONS = {
    attack: 0.003,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24
};
const $ed7126b0ce17e016$export$60ec6725c2d45fc8 = (audioNodeConstructor, createAudioParam, createDynamicsCompressorNodeRenderer, createNativeDynamicsCompressorNode, createNotSupportedError, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DynamicsCompressorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$ed7126b0ce17e016$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const dynamicsCompressorNodeRenderer = isOffline ? createDynamicsCompressorNodeRenderer() : null;
            super(context, false, nativeDynamicsCompressorNode, dynamicsCompressorNodeRenderer);
            this._attack = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.attack);
            this._knee = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.knee);
            this._nativeDynamicsCompressorNode = nativeDynamicsCompressorNode;
            this._ratio = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.ratio);
            this._release = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.release);
            this._threshold = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.threshold);
            setAudioNodeTailTime(this, 0.006);
        }
        get attack() {
            return this._attack;
        }
        // Bug #108: Safari allows a channelCount of three and above which is why the getter and setter needs to be overwritten here.
        get channelCount() {
            return this._nativeDynamicsCompressorNode.channelCount;
        }
        set channelCount(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCount;
            this._nativeDynamicsCompressorNode.channelCount = value;
            if (value > 2) {
                this._nativeDynamicsCompressorNode.channelCount = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        /*
         * Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max' yet which is why the getter and setter needs to be
         * overwritten here.
         */ get channelCountMode() {
            return this._nativeDynamicsCompressorNode.channelCountMode;
        }
        set channelCountMode(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCountMode;
            this._nativeDynamicsCompressorNode.channelCountMode = value;
            if (value === 'max') {
                this._nativeDynamicsCompressorNode.channelCountMode = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        get knee() {
            return this._knee;
        }
        get ratio() {
            return this._ratio;
        }
        get reduction() {
            // Bug #111: Safari returns an AudioParam instead of a number.
            if (typeof this._nativeDynamicsCompressorNode.reduction.value === 'number') return this._nativeDynamicsCompressorNode.reduction.value;
            return this._nativeDynamicsCompressorNode.reduction;
        }
        get release() {
            return this._release;
        }
        get threshold() {
            return this._threshold;
        }
    };
};

});

parcelRegister("3kywS", function(module, exports) {

$parcel$export(module.exports, "createDynamicsCompressorNodeRendererFactory", () => $26ce062abcb98ffd$export$1b1e82cc3f0a2c8);

var $37LPX = parcelRequire("37LPX");
const $26ce062abcb98ffd$export$1b1e82cc3f0a2c8 = (connectAudioParam, createNativeDynamicsCompressorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeDynamicsCompressorNodes = new WeakMap();
        const createDynamicsCompressorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDynamicsCompressorNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeDynamicsCompressorNode was not constructed on the same OfflineAudioContext it needs to be
             * created again.
             */ const nativeDynamicsCompressorNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeDynamicsCompressorNode, nativeOfflineAudioContext);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                const options = {
                    attack: nativeDynamicsCompressorNode.attack.value,
                    channelCount: nativeDynamicsCompressorNode.channelCount,
                    channelCountMode: nativeDynamicsCompressorNode.channelCountMode,
                    channelInterpretation: nativeDynamicsCompressorNode.channelInterpretation,
                    knee: nativeDynamicsCompressorNode.knee.value,
                    ratio: nativeDynamicsCompressorNode.ratio.value,
                    release: nativeDynamicsCompressorNode.release.value,
                    threshold: nativeDynamicsCompressorNode.threshold.value
                };
                nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDynamicsCompressorNodes.set(nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await renderAutomation(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await renderAutomation(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await renderAutomation(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await renderAutomation(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await connectAudioParam(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await connectAudioParam(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await connectAudioParam(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await connectAudioParam(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            return nativeDynamicsCompressorNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDynamicsCompressorNode = renderedNativeDynamicsCompressorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDynamicsCompressorNode !== undefined) return Promise.resolve(renderedNativeDynamicsCompressorNode);
                return createDynamicsCompressorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("2tXK8", function(module, exports) {

$parcel$export(module.exports, "createEncodingError", () => $1ceca1edff9ee13e$export$6372d3d9069bc778);
const $1ceca1edff9ee13e$export$6372d3d9069bc778 = ()=>new DOMException('', 'EncodingError');

});

parcelRegister("8YAdg", function(module, exports) {

$parcel$export(module.exports, "createEvaluateSource", () => $6890047c6fc5e38b$export$43b563d089dd1d8);
const $6890047c6fc5e38b$export$43b563d089dd1d8 = (window)=>{
    return (source)=>new Promise((resolve, reject)=>{
            if (window === null) {
                // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                reject(new SyntaxError());
                return;
            }
            const head = window.document.head;
            if (head === null) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            reject(new SyntaxError());
            else {
                const script = window.document.createElement('script');
                // @todo Safari doesn't like URLs with a type of 'application/javascript; charset=utf-8'.
                const blob = new Blob([
                    source
                ], {
                    type: 'application/javascript'
                });
                const url = URL.createObjectURL(blob);
                const originalOnErrorHandler = window.onerror;
                const removeErrorEventListenerAndRevokeUrl = ()=>{
                    window.onerror = originalOnErrorHandler;
                    URL.revokeObjectURL(url);
                };
                window.onerror = (message, src, lineno, colno, error)=>{
                    // @todo Edge thinks the source is the one of the html document.
                    if (src === url || src === window.location.href && lineno === 1 && colno === 1) {
                        removeErrorEventListenerAndRevokeUrl();
                        reject(error);
                        return false;
                    }
                    if (originalOnErrorHandler !== null) return originalOnErrorHandler(message, src, lineno, colno, error);
                };
                script.onerror = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                    reject(new SyntaxError());
                };
                script.onload = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    resolve();
                };
                script.src = url;
                script.type = 'module';
                head.appendChild(script);
            }
        });
};

});

parcelRegister("c1nXz", function(module, exports) {

$parcel$export(module.exports, "createEventTargetConstructor", () => $8c0829f5436e81b2$export$a512af3fc2ab91f2);
const $8c0829f5436e81b2$export$a512af3fc2ab91f2 = (wrapEventListener)=>{
    return class EventTarget {
        constructor(_nativeEventTarget){
            this._nativeEventTarget = _nativeEventTarget;
            this._listeners = new WeakMap();
        }
        addEventListener(type, listener, options) {
            if (listener !== null) {
                let wrappedEventListener = this._listeners.get(listener);
                if (wrappedEventListener === undefined) {
                    wrappedEventListener = wrapEventListener(this, listener);
                    if (typeof listener === 'function') this._listeners.set(listener, wrappedEventListener);
                }
                this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
            }
        }
        dispatchEvent(event) {
            return this._nativeEventTarget.dispatchEvent(event);
        }
        removeEventListener(type, listener, options) {
            const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);
            this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
        }
    };
};

});

parcelRegister("8Az4B", function(module, exports) {

$parcel$export(module.exports, "createExposeCurrentFrameAndCurrentTime", () => $640ce45bee31b93d$export$c43b8ab5e8913cbb);
const $640ce45bee31b93d$export$c43b8ab5e8913cbb = (window)=>{
    return (currentTime, sampleRate, fn)=>{
        Object.defineProperties(window, {
            currentFrame: {
                configurable: true,
                get () {
                    return Math.round(currentTime * sampleRate);
                }
            },
            currentTime: {
                configurable: true,
                get () {
                    return currentTime;
                }
            }
        });
        try {
            return fn();
        } finally{
            if (window !== null) {
                delete window.currentFrame;
                delete window.currentTime;
            }
        }
    };
};

});

parcelRegister("6HEHv", function(module, exports) {

$parcel$export(module.exports, "createFetchSource", () => $4e16548bb8166d63$export$c7282a393375a8ca);
const $4e16548bb8166d63$export$c7282a393375a8ca = (createAbortError)=>{
    return async (url)=>{
        try {
            const response = await fetch(url);
            if (response.ok) return [
                await response.text(),
                response.url
            ];
        } catch  {
        // Ignore errors.
        } // tslint:disable-line:no-empty
        throw createAbortError();
    };
};

});

parcelRegister("25YIS", function(module, exports) {

$parcel$export(module.exports, "createGainNodeConstructor", () => $186b26aef2c2b838$export$7b37b693b55bf5d7);

var $lQo9t = parcelRequire("lQo9t");
const $186b26aef2c2b838$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    gain: 1
};
const $186b26aef2c2b838$export$7b37b693b55bf5d7 = (audioNodeConstructor, createAudioParam, createGainNodeRenderer, createNativeGainNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class GainNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$186b26aef2c2b838$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
            super(context, false, nativeGainNode, gainNodeRenderer);
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeGainNode.gain, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
        }
        get gain() {
            return this._gain;
        }
    };
};

});

parcelRegister("pSyXE", function(module, exports) {

$parcel$export(module.exports, "createGainNodeRendererFactory", () => $04dca8f7b722237a$export$7312404e5bea9cd);

var $37LPX = parcelRequire("37LPX");
const $04dca8f7b722237a$export$7312404e5bea9cd = (connectAudioParam, createNativeGainNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeGainNodes = new WeakMap();
        const createGainNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = getNativeAudioNode(proxy);
            // If the initially used nativeGainNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeGainNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeGainNode, nativeOfflineAudioContext);
            if (!nativeGainNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeGainNode.channelCount,
                    channelCountMode: nativeGainNode.channelCountMode,
                    channelInterpretation: nativeGainNode.channelInterpretation,
                    gain: nativeGainNode.gain.value
                };
                nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, options);
            }
            renderedNativeGainNodes.set(nativeOfflineAudioContext, nativeGainNode);
            if (!nativeGainNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeGainNode);
            return nativeGainNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNode = renderedNativeGainNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNode !== undefined) return Promise.resolve(renderedNativeGainNode);
                return createGainNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("7eDuD", function(module, exports) {

$parcel$export(module.exports, "createGetActiveAudioWorkletNodeInputs", () => $544879b7971bfc2a$export$8b01844840684f8d);
const $544879b7971bfc2a$export$8b01844840684f8d = (activeAudioWorkletNodeInputsStore, getValueForKey)=>{
    return (nativeAudioWorkletNode)=>getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
};

});

parcelRegister("iINpc", function(module, exports) {

$parcel$export(module.exports, "createGetAudioNodeRenderer", () => $da12a8ed00202a1e$export$97bb1acefff8970e);
const $da12a8ed00202a1e$export$97bb1acefff8970e = (getAudioNodeConnections)=>{
    return (audioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        if (audioNodeConnections.renderer === null) throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
        return audioNodeConnections.renderer;
    };
};

});

parcelRegister("5HjFx", function(module, exports) {

$parcel$export(module.exports, "createGetAudioNodeTailTime", () => $426039bbcb8d6b15$export$4abc3abd061bc2cc);
const $426039bbcb8d6b15$export$4abc3abd061bc2cc = (audioNodeTailTimeStore)=>{
    return (audioNode)=>{
        var _a;
        return (_a = audioNodeTailTimeStore.get(audioNode)) !== null && _a !== void 0 ? _a : 0;
    };
};

});

parcelRegister("aanxM", function(module, exports) {

$parcel$export(module.exports, "createGetAudioParamRenderer", () => $766d19e2509a082c$export$1653dd3e76bcb1b0);
const $766d19e2509a082c$export$1653dd3e76bcb1b0 = (getAudioParamConnections)=>{
    return (audioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        if (audioParamConnections.renderer === null) throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
        return audioParamConnections.renderer;
    };
};

});

parcelRegister("jP1v0", function(module, exports) {

$parcel$export(module.exports, "createGetBackupOfflineAudioContext", () => $e6e3f173e0e083d2$export$afecf147821b5609);
const $e6e3f173e0e083d2$export$afecf147821b5609 = (backupOfflineAudioContextStore)=>{
    return (nativeContext)=>{
        return backupOfflineAudioContextStore.get(nativeContext);
    };
};

});

parcelRegister("huLlV", function(module, exports) {

$parcel$export(module.exports, "createGetNativeContext", () => $cbc9f83fb9edbc94$export$797a319a8065fb37);

var $2meOO = parcelRequire("2meOO");
const $cbc9f83fb9edbc94$export$797a319a8065fb37 = (contextStore)=>{
    return (context)=>{
        const nativeContext = contextStore.get(context);
        if (nativeContext === undefined) throw (0, $2meOO.createInvalidStateError)();
        return nativeContext;
    };
};

});
parcelRegister("2meOO", function(module, exports) {

$parcel$export(module.exports, "createInvalidStateError", () => $1b79217e8b0da0af$export$5a1c4cd5830ea09b);
const $1b79217e8b0da0af$export$5a1c4cd5830ea09b = ()=>new DOMException('', 'InvalidStateError');

});


parcelRegister("8fnKQ", function(module, exports) {

$parcel$export(module.exports, "createGetOrCreateBackupOfflineAudioContext", () => $6012269c82009d97$export$70df0ae42e1340c8);
const $6012269c82009d97$export$70df0ae42e1340c8 = (backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor)=>{
    return (nativeContext)=>{
        let backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);
        if (backupOfflineAudioContext !== undefined) return backupOfflineAudioContext;
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
        return backupOfflineAudioContext;
    };
};

});

parcelRegister("dhmx6", function(module, exports) {

$parcel$export(module.exports, "createGetUnrenderedAudioWorkletNodes", () => $9aae576fb2b9e912$export$43ef7eb1ae3d2f40);
const $9aae576fb2b9e912$export$43ef7eb1ae3d2f40 = (unrenderedAudioWorkletNodeStore)=>{
    return (nativeContext)=>{
        const unrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore.get(nativeContext);
        if (unrenderedAudioWorkletNodes === undefined) throw new Error('The context has no set of AudioWorkletNodes.');
        return unrenderedAudioWorkletNodes;
    };
};

});

parcelRegister("GOU9g", function(module, exports) {

$parcel$export(module.exports, "createIIRFilterNodeConstructor", () => $080b68f4b7d8f3e2$export$a22f1eb785a05608);

var $aCJRp = parcelRequire("aCJRp");
const $080b68f4b7d8f3e2$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers'
};
const $080b68f4b7d8f3e2$export$a22f1eb785a05608 = (audioNodeConstructor, createNativeIIRFilterNode, createIIRFilterNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class IIRFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = {
                ...$080b68f4b7d8f3e2$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeIIRFilterNode = createNativeIIRFilterNode(nativeContext, isOffline ? null : context.baseLatency, mergedOptions);
            const iirFilterNodeRenderer = isOffline ? createIIRFilterNodeRenderer(mergedOptions.feedback, mergedOptions.feedforward) : null;
            super(context, false, nativeIIRFilterNode, iirFilterNodeRenderer);
            // Bug #23 & #24: FirefoxDeveloper does not throw an InvalidAccessError.
            // @todo Write a test which allows other browsers to remain unpatched.
            (0, $aCJRp.wrapIIRFilterNodeGetFrequencyResponseMethod)(nativeIIRFilterNode);
            this._nativeIIRFilterNode = nativeIIRFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            return this._nativeIIRFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
        }
    };
};

});
parcelRegister("aCJRp", function(module, exports) {

$parcel$export(module.exports, "wrapIIRFilterNodeGetFrequencyResponseMethod", () => $7bc106e77423ad7a$export$8170ec2d1debbbdd);

var $6LIKY = parcelRequire("6LIKY");
const $7bc106e77423ad7a$export$8170ec2d1debbbdd = (nativeIIRFilterNode)=>{
    nativeIIRFilterNode.getFrequencyResponse = ((getFrequencyResponse)=>{
        return (frequencyHz, magResponse, phaseResponse)=>{
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw (0, $6LIKY.createInvalidAccessError)();
            return getFrequencyResponse.call(nativeIIRFilterNode, frequencyHz, magResponse, phaseResponse);
        };
    })(nativeIIRFilterNode.getFrequencyResponse);
};

});
parcelRegister("6LIKY", function(module, exports) {

$parcel$export(module.exports, "createInvalidAccessError", () => $4ed9d99a7cae0ec0$export$254c536c2ca9b917);
const $4ed9d99a7cae0ec0$export$254c536c2ca9b917 = ()=>new DOMException('', 'InvalidAccessError');

});



parcelRegister("8Wiqm", function(module, exports) {

$parcel$export(module.exports, "createIIRFilterNodeRendererFactory", () => $6822082a0e4a1dcb$export$329316f0ca6cf17e);

var $3QfiN = parcelRequire("3QfiN");

var $37LPX = parcelRequire("37LPX");
const $6822082a0e4a1dcb$var$filterFullBuffer = (renderedBuffer, nativeOfflineAudioContext, feedback, feedforward)=>{
    const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
    const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
    const feedbackLength = convertedFeedback.length;
    const feedforwardLength = convertedFeedforward.length;
    const minLength = Math.min(feedbackLength, feedforwardLength);
    if (convertedFeedback[0] !== 1) {
        for(let i = 0; i < feedbackLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
        for(let i = 1; i < feedforwardLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
    }
    const bufferLength = 32;
    const xBuffer = new Float32Array(bufferLength);
    const yBuffer = new Float32Array(bufferLength);
    const filteredBuffer = nativeOfflineAudioContext.createBuffer(renderedBuffer.numberOfChannels, renderedBuffer.length, renderedBuffer.sampleRate);
    const numberOfChannels = renderedBuffer.numberOfChannels;
    for(let i = 0; i < numberOfChannels; i += 1){
        const input = renderedBuffer.getChannelData(i);
        const output = filteredBuffer.getChannelData(i);
        xBuffer.fill(0);
        yBuffer.fill(0);
        (0, $3QfiN.filterBuffer)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffer, yBuffer, 0, bufferLength, input, output);
    }
    return filteredBuffer;
};
const $6822082a0e4a1dcb$export$329316f0ca6cf17e = (createNativeAudioBufferSourceNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (feedback, feedforward)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let filteredBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = null;
            let nativeIIRFilterNode = getNativeAudioNode(proxy);
            // If the initially used nativeIIRFilterNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeIIRFilterNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeIIRFilterNode, nativeOfflineAudioContext);
            // Bug #9: Safari does not support IIRFilterNodes.
            if (nativeOfflineAudioContext.createIIRFilter === undefined) nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                buffer: null,
                channelCount: 2,
                channelCountMode: 'max',
                channelInterpretation: 'speakers',
                loop: false,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            });
            else if (!nativeIIRFilterNodeIsOwnedByContext) // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
            nativeIIRFilterNode = nativeOfflineAudioContext.createIIRFilter(feedforward, feedback);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode === null ? nativeIIRFilterNode : nativeAudioBufferSourceNode);
            if (nativeAudioBufferSourceNode !== null) {
                if (filteredBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(// Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    proxy.context.destination.channelCount, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    filteredBufferPromise = (async ()=>{
                        await renderInputsOfAudioNode(proxy, partialOfflineAudioContext, partialOfflineAudioContext.destination);
                        const renderedBuffer = await renderNativeOfflineAudioContext(partialOfflineAudioContext);
                        return $6822082a0e4a1dcb$var$filterFullBuffer(renderedBuffer, nativeOfflineAudioContext, feedback, feedforward);
                    })();
                }
                const filteredBuffer = await filteredBufferPromise;
                nativeAudioBufferSourceNode.buffer = filteredBuffer;
                nativeAudioBufferSourceNode.start(0);
                return nativeAudioBufferSourceNode;
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeIIRFilterNode);
            return nativeIIRFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});
parcelRegister("3QfiN", function(module, exports) {

$parcel$export(module.exports, "filterBuffer", () => $2cc2191810686115$export$7fa1177e7d2178dd);
// This implementation as shamelessly inspired by source code of
// tslint:disable-next-line:max-line-length
// {@link https://chromium.googlesource.com/chromium/src.git/+/master/third_party/WebKit/Source/platform/audio/IIRFilter.cpp|Chromium's IIRFilter}.
const $2cc2191810686115$export$7fa1177e7d2178dd = (feedback, feedbackLength, feedforward, feedforwardLength, minLength, xBuffer, yBuffer, bufferIndex, bufferLength, input, output)=>{
    const inputLength = input.length;
    let i = bufferIndex;
    for(let j = 0; j < inputLength; j += 1){
        let y = feedforward[0] * input[j];
        for(let k = 1; k < minLength; k += 1){
            const x = i - k & bufferLength - 1; // tslint:disable-line:no-bitwise
            y += feedforward[k] * xBuffer[x];
            y -= feedback[k] * yBuffer[x];
        }
        for(let k = minLength; k < feedforwardLength; k += 1)y += feedforward[k] * xBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        for(let k = minLength; k < feedbackLength; k += 1)y -= feedback[k] * yBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        xBuffer[i] = input[j];
        yBuffer[i] = y;
        i = i + 1 & bufferLength - 1; // tslint:disable-line:no-bitwise
        output[j] = y;
    }
    return i;
};

});


parcelRegister("90REg", function(module, exports) {

$parcel$export(module.exports, "createIncrementCycleCounterFactory", () => $68fdba94017628c3$export$e306a463e9286bbd);

var $9wk5I = parcelRequire("9wk5I");
const $68fdba94017628c3$export$e306a463e9286bbd = (cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode)=>{
    return (isOffline)=>{
        return (audioNode, count)=>{
            const cycleCounter = cycleCounters.get(audioNode);
            if (cycleCounter === undefined) {
                if (!isOffline && isActiveAudioNode(audioNode)) {
                    const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                    const { outputs: outputs } = getAudioNodeConnections(audioNode);
                    for (const output of outputs)if ((0, $9wk5I.isAudioNodeOutputConnection)(output)) {
                        const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                        disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                    } else {
                        const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                        nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
                    }
                }
                cycleCounters.set(audioNode, count);
            } else cycleCounters.set(audioNode, cycleCounter + count);
        };
    };
};

});

parcelRegister("7yfCk", function(module, exports) {

$parcel$export(module.exports, "createIsAnyAudioContext", () => $57f7d2a5062976b6$export$7030a6f3318876b);
const $57f7d2a5062976b6$export$7030a6f3318876b = (contextStore, isNativeAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeAudioContext(nativeContext) || isNativeAudioContext(anything);
    };
};

});

parcelRegister("ctUWa", function(module, exports) {

$parcel$export(module.exports, "createIsAnyAudioNode", () => $91645bfeb06469ae$export$150a35c855945f9d);
const $91645bfeb06469ae$export$150a35c855945f9d = (audioNodeStore, isNativeAudioNode)=>{
    return (anything)=>audioNodeStore.has(anything) || isNativeAudioNode(anything);
};

});

parcelRegister("dT9fA", function(module, exports) {

$parcel$export(module.exports, "createIsAnyAudioParam", () => $a1c7965a2f27aaeb$export$41505fc8888255a0);
const $a1c7965a2f27aaeb$export$41505fc8888255a0 = (audioParamStore, isNativeAudioParam)=>{
    return (anything)=>audioParamStore.has(anything) || isNativeAudioParam(anything);
};

});

parcelRegister("9Vj4x", function(module, exports) {

$parcel$export(module.exports, "createIsAnyOfflineAudioContext", () => $73983b42513a8cf1$export$845691ce8ebc2907);
const $73983b42513a8cf1$export$845691ce8ebc2907 = (contextStore, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeOfflineAudioContext(nativeContext) || isNativeOfflineAudioContext(anything);
    };
};

});

parcelRegister("kOhPO", function(module, exports) {

$parcel$export(module.exports, "createIsNativeAudioContext", () => $f2664fc6d528f5ae$export$5d44272df169092e);
const $f2664fc6d528f5ae$export$5d44272df169092e = (nativeAudioContextConstructor)=>{
    return (anything)=>{
        return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
    };
};

});

parcelRegister("c9S8f", function(module, exports) {

$parcel$export(module.exports, "createIsNativeAudioNode", () => $8da050cdf49a312b$export$96f2bb6e8a5795ea);
const $8da050cdf49a312b$export$96f2bb6e8a5795ea = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioNode === 'function' && anything instanceof window.AudioNode;
    };
};

});

parcelRegister("jecjI", function(module, exports) {

$parcel$export(module.exports, "createIsNativeAudioParam", () => $dff8e1020cb04dc9$export$7c3a44537acaf24e);
const $dff8e1020cb04dc9$export$7c3a44537acaf24e = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioParam === 'function' && anything instanceof window.AudioParam;
    };
};

});

parcelRegister("ddkZL", function(module, exports) {

$parcel$export(module.exports, "createIsNativeContext", () => $99ecc6717e95258d$export$a7c969701e5471d0);
const $99ecc6717e95258d$export$a7c969701e5471d0 = (isNativeAudioContext, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        return isNativeAudioContext(anything) || isNativeOfflineAudioContext(anything);
    };
};

});

parcelRegister("9Vg5r", function(module, exports) {

$parcel$export(module.exports, "createIsNativeOfflineAudioContext", () => $7395ea732025d388$export$722bd4bab77df75a);
const $7395ea732025d388$export$722bd4bab77df75a = (nativeOfflineAudioContextConstructor)=>{
    return (anything)=>{
        return nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor;
    };
};

});

parcelRegister("bfUi1", function(module, exports) {

$parcel$export(module.exports, "createIsSecureContext", () => $831cc2662e1c3a25$export$2e9a7e6b17a9abae);
const $831cc2662e1c3a25$export$2e9a7e6b17a9abae = (window)=>window !== null && window.isSecureContext;

});

parcelRegister("12TK4", function(module, exports) {

$parcel$export(module.exports, "createIsSupportedPromise", () => $0c31379577d650a9$export$a245ecb43f54c4de);
const $0c31379577d650a9$export$a245ecb43f54c4de = async (cacheTestResult, testAudioBufferCopyChannelMethodsSubarraySupport, testAudioContextCloseMethodSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextOptionsSupport, testAudioNodeConnectMethodSupport, testAudioWorkletProcessorNoOutputsSupport, testChannelMergerNodeChannelCountSupport, testConstantSourceNodeAccurateSchedulingSupport, testConvolverNodeBufferReassignabilitySupport, testConvolverNodeChannelCountSupport, testDomExceptionContrucorSupport, testIsSecureContextSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testStereoPannerNodeDefaultValueSupport, testTransferablesSupport)=>{
    if (cacheTestResult(testAudioBufferCopyChannelMethodsSubarraySupport, testAudioBufferCopyChannelMethodsSubarraySupport) && cacheTestResult(testAudioContextCloseMethodSupport, testAudioContextCloseMethodSupport) && cacheTestResult(testAudioContextOptionsSupport, testAudioContextOptionsSupport) && cacheTestResult(testAudioNodeConnectMethodSupport, testAudioNodeConnectMethodSupport) && cacheTestResult(testChannelMergerNodeChannelCountSupport, testChannelMergerNodeChannelCountSupport) && cacheTestResult(testConstantSourceNodeAccurateSchedulingSupport, testConstantSourceNodeAccurateSchedulingSupport) && cacheTestResult(testConvolverNodeBufferReassignabilitySupport, testConvolverNodeBufferReassignabilitySupport) && cacheTestResult(testConvolverNodeChannelCountSupport, testConvolverNodeChannelCountSupport) && cacheTestResult(testDomExceptionContrucorSupport, testDomExceptionContrucorSupport) && cacheTestResult(testIsSecureContextSupport, testIsSecureContextSupport) && cacheTestResult(testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport)) {
        const results = await Promise.all([
            cacheTestResult(testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport),
            cacheTestResult(testAudioWorkletProcessorNoOutputsSupport, testAudioWorkletProcessorNoOutputsSupport),
            cacheTestResult(testStereoPannerNodeDefaultValueSupport, testStereoPannerNodeDefaultValueSupport),
            cacheTestResult(testTransferablesSupport, testTransferablesSupport)
        ]);
        return results.every((result)=>result);
    }
    return false;
};

});

parcelRegister("cLoIk", function(module, exports) {

$parcel$export(module.exports, "createMediaElementAudioSourceNodeConstructor", () => $94ad0b810dbcffdc$export$d24d3af0853fd021);
const $94ad0b810dbcffdc$export$d24d3af0853fd021 = (audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaElementAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options);
            // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw TypeError();
            super(context, true, nativeMediaElementAudioSourceNode, null);
            this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
        }
        get mediaElement() {
            return this._nativeMediaElementAudioSourceNode.mediaElement;
        }
    };
};

});

parcelRegister("6pgET", function(module, exports) {

$parcel$export(module.exports, "createMediaStreamAudioDestinationNodeConstructor", () => $4aa1ffe71b61a26e$export$5d3ee2470cd2874);
const $4aa1ffe71b61a26e$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers'
};
const $4aa1ffe71b61a26e$export$5d3ee2470cd2874 = (audioNodeConstructor, createNativeMediaStreamAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioDestinationNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            // Bug #173: Safari allows to create a MediaStreamAudioDestinationNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            const mergedOptions = {
                ...$4aa1ffe71b61a26e$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeMediaStreamAudioDestinationNode = createNativeMediaStreamAudioDestinationNode(nativeContext, mergedOptions);
            super(context, false, nativeMediaStreamAudioDestinationNode, null);
            this._nativeMediaStreamAudioDestinationNode = nativeMediaStreamAudioDestinationNode;
        }
        get stream() {
            return this._nativeMediaStreamAudioDestinationNode.stream;
        }
    };
};

});

parcelRegister("dL2WA", function(module, exports) {

$parcel$export(module.exports, "createMediaStreamAudioSourceNodeConstructor", () => $a041f2baeae08c8d$export$a42e10687df73a9d);
const $a041f2baeae08c8d$export$a42e10687df73a9d = (audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, options);
            // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            super(context, true, nativeMediaStreamAudioSourceNode, null);
            this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
        }
        get mediaStream() {
            return this._nativeMediaStreamAudioSourceNode.mediaStream;
        }
    };
};

});

parcelRegister("ddFUI", function(module, exports) {

$parcel$export(module.exports, "createMediaStreamTrackAudioSourceNodeConstructor", () => $99fd00749ec63f6c$export$24f27d34fdf823bc);
const $99fd00749ec63f6c$export$24f27d34fdf823bc = (audioNodeConstructor, createNativeMediaStreamTrackAudioSourceNode, getNativeContext)=>{
    return class MediaStreamTrackAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
            super(context, true, nativeMediaStreamTrackAudioSourceNode, null);
        }
    };
};

});

parcelRegister("lC4rh", function(module, exports) {

$parcel$export(module.exports, "createMinimalAudioContextConstructor", () => $fbc097141f8e818a$export$8a5e66f668b2e9e8);

var $kOlfI = parcelRequire("kOlfI");

var $8fmkE = parcelRequire("8fmkE");
const $fbc097141f8e818a$export$8a5e66f668b2e9e8 = (createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor)=>{
    return class MinimalAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $8fmkE.isValidLatencyHint)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $kOlfI.deactivateAudioGraph)(this);
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};

});

parcelRegister("8S7ub", function(module, exports) {

$parcel$export(module.exports, "createMinimalBaseAudioContextConstructor", () => $67592c6b3b6ca8b5$export$3f49d9c870ba2692);

var $kBpIy = parcelRequire("kBpIy");
const $67592c6b3b6ca8b5$export$3f49d9c870ba2692 = (audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener)=>{
    return class MinimalBaseAudioContext extends eventTargetConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext);
            this._nativeContext = _nativeContext;
            (0, $kBpIy.CONTEXT_STORE).set(this, _nativeContext);
            if (isNativeOfflineAudioContext(_nativeContext)) unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
            this._destination = new audioDestinationNodeConstructor(this, numberOfChannels);
            this._listener = createAudioListener(this, _nativeContext);
            this._onstatechange = null;
        }
        get currentTime() {
            return this._nativeContext.currentTime;
        }
        get destination() {
            return this._destination;
        }
        get listener() {
            return this._listener;
        }
        get onstatechange() {
            return this._onstatechange;
        }
        set onstatechange(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeContext.onstatechange = wrappedListener;
            const nativeOnStateChange = this._nativeContext.onstatechange;
            this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
        }
        get sampleRate() {
            return this._nativeContext.sampleRate;
        }
        get state() {
            return this._nativeContext.state;
        }
    };
};

});

parcelRegister("lhsPn", function(module, exports) {

$parcel$export(module.exports, "createMinimalOfflineAudioContextConstructor", () => $03ff8242544d4492$export$3d487af37fe7f521);

var $kOlfI = parcelRequire("kOlfI");

var $7GhDt = parcelRequire("7GhDt");
const $03ff8242544d4492$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $03ff8242544d4492$export$3d487af37fe7f521 = (cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, startRendering)=>{
    return class MinimalOfflineAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options){
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$03ff8242544d4492$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $7GhDt.testPromiseSupport), ()=>(0, $7GhDt.testPromiseSupport)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $kOlfI.deactivateAudioGraph)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};

});
parcelRegister("7GhDt", function(module, exports) {

$parcel$export(module.exports, "testPromiseSupport", () => $597a22bc19e67434$export$9ec44223b1284cd4);
const $597a22bc19e67434$export$9ec44223b1284cd4 = (nativeContext)=>{
    // This 12 numbers represent the 48 bytes of an empty WAVE file with a single sample.
    const uint32Array = new Uint32Array([
        1179011410,
        40,
        1163280727,
        544501094,
        16,
        131073,
        44100,
        176400,
        1048580,
        1635017060,
        4,
        0
    ]);
    try {
        // Bug #1: Safari requires a successCallback.
        const promise = nativeContext.decodeAudioData(uint32Array.buffer, ()=>{
        // Ignore the success callback.
        });
        if (promise === undefined) return false;
        promise.catch(()=>{
        // Ignore rejected errors.
        });
        return true;
    } catch  {
    // Ignore errors.
    }
    return false;
};

});


parcelRegister("OOytR", function(module, exports) {

$parcel$export(module.exports, "createMonitorConnections", () => $098be2d2d98384cf$export$9f33b5a0b80f2717);
const $098be2d2d98384cf$export$9f33b5a0b80f2717 = (insertElementInSet, isNativeAudioNode)=>{
    return (nativeAudioNode, whenConnected, whenDisconnected)=>{
        const connections = new Set();
        nativeAudioNode.connect = ((connect)=>{
            // tslint:disable-next-line:invalid-void no-inferrable-types
            return (destination, output = 0, input = 0)=>{
                const wasDisconnected = connections.size === 0;
                if (isNativeAudioNode(destination)) {
                    // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    connect.call(nativeAudioNode, destination, output, input);
                    insertElementInSet(connections, [
                        destination,
                        output,
                        input
                    ], (connection)=>connection[0] === destination && connection[1] === output && connection[2] === input, true);
                    if (wasDisconnected) whenConnected();
                    return destination;
                }
                connect.call(nativeAudioNode, destination, output);
                insertElementInSet(connections, [
                    destination,
                    output
                ], (connection)=>connection[0] === destination && connection[1] === output, true);
                if (wasDisconnected) whenConnected();
                return;
            };
        })(nativeAudioNode.connect);
        nativeAudioNode.disconnect = ((disconnect)=>{
            return (destinationOrOutput, output, input)=>{
                const wasConnected = connections.size > 0;
                if (destinationOrOutput === undefined) {
                    disconnect.apply(nativeAudioNode);
                    connections.clear();
                } else if (typeof destinationOrOutput === 'number') {
                    // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput);
                    for (const connection of connections)if (connection[1] === destinationOrOutput) connections.delete(connection);
                } else {
                    if (isNativeAudioNode(destinationOrOutput)) // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
                    else // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output);
                    for (const connection of connections)if (connection[0] === destinationOrOutput && (output === undefined || connection[1] === output) && (input === undefined || connection[2] === input)) connections.delete(connection);
                }
                const isDisconnected = connections.size === 0;
                if (wasConnected && isDisconnected) whenDisconnected();
            };
        })(nativeAudioNode.disconnect);
        return nativeAudioNode;
    };
};

});

parcelRegister("jneAG", function(module, exports) {

$parcel$export(module.exports, "createNativeAnalyserNodeFactory", () => $e1ab7bbb4a36a448$export$36e704ad7c903a26);

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");

var $4sMiC = parcelRequire("4sMiC");

var $fJQYL = parcelRequire("fJQYL");
const $e1ab7bbb4a36a448$export$36e704ad7c903a26 = (cacheTestResult, createIndexSizeError)=>{
    return (nativeContext, options)=>{
        const nativeAnalyserNode = nativeContext.createAnalyser();
        // Bug #37: Firefox does not create an AnalyserNode with the default properties.
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeAnalyserNode, options);
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        if (!(options.maxDecibels > options.minDecibels)) throw createIndexSizeError();
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAnalyserNode, options, 'fftSize');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAnalyserNode, options, 'maxDecibels');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAnalyserNode, options, 'minDecibels');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAnalyserNode, options, 'smoothingTimeConstant');
        // Bug #36: Safari does not support getFloatTimeDomainData() yet.
        if (!cacheTestResult((0, $4sMiC.testAnalyserNodeGetFloatTimeDomainDataMethodSupport), ()=>(0, $4sMiC.testAnalyserNodeGetFloatTimeDomainDataMethodSupport)(nativeAnalyserNode))) (0, $fJQYL.wrapAnalyserNodeGetFloatTimeDomainDataMethod)(nativeAnalyserNode);
        return nativeAnalyserNode;
    };
};

});
parcelRegister("kC0ys", function(module, exports) {

$parcel$export(module.exports, "assignNativeAudioNodeOption", () => $f017c96b7c358c59$export$26855c8d5a8f5839);
const $f017c96b7c358c59$export$26855c8d5a8f5839 = (nativeAudioNode, options, option)=>{
    const value = options[option];
    if (value !== undefined && value !== nativeAudioNode[option]) nativeAudioNode[option] = value;
};

});

parcelRegister("fb5On", function(module, exports) {

$parcel$export(module.exports, "assignNativeAudioNodeOptions", () => $b0cc642a23f731d6$export$a741a487b656b6ff);

var $kC0ys = parcelRequire("kC0ys");
const $b0cc642a23f731d6$export$a741a487b656b6ff = (nativeAudioNode, options)=>{
    (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioNode, options, 'channelCount');
    (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioNode, options, 'channelCountMode');
    (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioNode, options, 'channelInterpretation');
};

});

parcelRegister("4sMiC", function(module, exports) {

$parcel$export(module.exports, "testAnalyserNodeGetFloatTimeDomainDataMethodSupport", () => $33ff3e2b0fc3b1a7$export$1cb15f891b4f5e5e);
const $33ff3e2b0fc3b1a7$export$1cb15f891b4f5e5e = (nativeAnalyserNode)=>{
    return typeof nativeAnalyserNode.getFloatTimeDomainData === 'function';
};

});

parcelRegister("fJQYL", function(module, exports) {

$parcel$export(module.exports, "wrapAnalyserNodeGetFloatTimeDomainDataMethod", () => $b7542787dbbb2296$export$df32660d042dab2e);
const $b7542787dbbb2296$export$df32660d042dab2e = (nativeAnalyserNode)=>{
    nativeAnalyserNode.getFloatTimeDomainData = (array)=>{
        const byteTimeDomainData = new Uint8Array(array.length);
        nativeAnalyserNode.getByteTimeDomainData(byteTimeDomainData);
        const length = Math.max(byteTimeDomainData.length, nativeAnalyserNode.fftSize);
        for(let i = 0; i < length; i += 1)array[i] = (byteTimeDomainData[i] - 128) * 0.0078125;
        return array;
    };
};

});


parcelRegister("9ycsu", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioBufferConstructor", () => $6f40f4030b22ea82$export$1ddb6a79e564be96);
const $6f40f4030b22ea82$export$1ddb6a79e564be96 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioBuffer')) return window.AudioBuffer;
    return null;
};

});

parcelRegister("bcRpN", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioBufferSourceNodeFactory", () => $828a3fcba7b38214$export$4f48c993f264b207);

var $1YLL1 = parcelRequire("1YLL1");

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");

var $mewNd = parcelRequire("mewNd");

var $5mW9o = parcelRequire("5mW9o");

var $527MF = parcelRequire("527MF");
const $828a3fcba7b38214$export$4f48c993f264b207 = (addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClampling, wrapAudioBufferSourceNodeStopMethodNullifiedBuffer, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeAudioBufferSourceNode, options);
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeAudioBufferSourceNode, options, 'playbackRate');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioBufferSourceNode, options, 'buffer');
        // Bug #149: Safari does not yet support the detune AudioParam.
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioBufferSourceNode, options, 'loop');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioBufferSourceNode, options, 'loopEnd');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeAudioBufferSourceNode, options, 'loopStart');
        // Bug #69: Safari does allow calls to start() of an already scheduled AudioBufferSourceNode.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, ()=>testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport(nativeContext))) (0, $mewNd.wrapAudioBufferSourceNodeStartMethodConsecutiveCalls)(nativeAudioBufferSourceNode);
        // Bug #154 & #155: Safari does not handle offsets which are equal to or greater than the duration of the buffer.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodOffsetClampingSupport, ()=>testAudioBufferSourceNodeStartMethodOffsetClampingSupport(nativeContext))) wrapAudioBufferSourceNodeStartMethodOffsetClampling(nativeAudioBufferSourceNode);
        // Bug #162: Safari does throw an error when stop() is called on an AudioBufferSourceNode which has no buffer assigned to it.
        if (!cacheTestResult(testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, ()=>testAudioBufferSourceNodeStopMethodNullifiedBufferSupport(nativeContext))) wrapAudioBufferSourceNodeStopMethodNullifiedBuffer(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $5mW9o.wrapAudioScheduledSourceNodeStartMethodNegativeParameters)(nativeAudioBufferSourceNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $527MF.wrapAudioScheduledSourceNodeStopMethodNegativeParameters)(nativeAudioBufferSourceNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeAudioBufferSourceNode);
        return nativeAudioBufferSourceNode;
    };
};

});
parcelRegister("1YLL1", function(module, exports) {

$parcel$export(module.exports, "assignNativeAudioNodeAudioParamValue", () => $171070ac8cb6ec14$export$4778de978774ec4f);
const $171070ac8cb6ec14$export$4778de978774ec4f = (nativeAudioNode, options, audioParam)=>{
    const value = options[audioParam];
    if (value !== undefined && value !== nativeAudioNode[audioParam].value) nativeAudioNode[audioParam].value = value;
};

});

parcelRegister("mewNd", function(module, exports) {

$parcel$export(module.exports, "wrapAudioBufferSourceNodeStartMethodConsecutiveCalls", () => $042d53215ac3bb95$export$6b4321a414ed55c5);

var $2meOO = parcelRequire("2meOO");
const $042d53215ac3bb95$export$6b4321a414ed55c5 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        let isScheduled = false;
        return (when = 0, offset = 0, duration)=>{
            if (isScheduled) throw (0, $2meOO.createInvalidStateError)();
            start.call(nativeAudioBufferSourceNode, when, offset, duration);
            isScheduled = true;
        };
    })(nativeAudioBufferSourceNode.start);
};

});

parcelRegister("5mW9o", function(module, exports) {

$parcel$export(module.exports, "wrapAudioScheduledSourceNodeStartMethodNegativeParameters", () => $3e8c1d4b772e3642$export$987b3a4087e6578c);
const $3e8c1d4b772e3642$export$987b3a4087e6578c = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            if (typeof duration === 'number' && duration < 0 || offset < 0 || when < 0) throw new RangeError("The parameters can't be negative.");
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            start.call(nativeAudioScheduledSourceNode, when, offset, duration);
        };
    })(nativeAudioScheduledSourceNode.start);
};

});

parcelRegister("527MF", function(module, exports) {

$parcel$export(module.exports, "wrapAudioScheduledSourceNodeStopMethodNegativeParameters", () => $3aa32d659095f34f$export$7adf5b1e83aad45);
const $3aa32d659095f34f$export$7adf5b1e83aad45 = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        return (when = 0)=>{
            if (when < 0) throw new RangeError("The parameter can't be negative.");
            stop.call(nativeAudioScheduledSourceNode, when);
        };
    })(nativeAudioScheduledSourceNode.stop);
};

});


parcelRegister("h5DkH", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioContextConstructor", () => $c71169f7dd89c8c3$export$3a22fc4046f7b4ec);
const $c71169f7dd89c8c3$export$3a22fc4046f7b4ec = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioContext')) return window.AudioContext;
    return window.hasOwnProperty('webkitAudioContext') ? window.webkitAudioContext : null;
};

});

parcelRegister("59JPD", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioDestinationNodeFactory", () => $3c11584648bfb465$export$d3097038f258fce);
const $3c11584648bfb465$export$d3097038f258fce = (createNativeGainNode, overwriteAccessors)=>{
    return (nativeContext, channelCount, isNodeOfNativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeContext.destination;
        // Bug #132: Safari does not have the correct channelCount.
        if (nativeAudioDestinationNode.channelCount !== channelCount) try {
            nativeAudioDestinationNode.channelCount = channelCount;
        } catch  {
        // Bug #169: Safari throws an error on each attempt to change the channelCount.
        }
        // Bug #83: Safari does not have the correct channelCountMode.
        if (isNodeOfNativeOfflineAudioContext && nativeAudioDestinationNode.channelCountMode !== 'explicit') nativeAudioDestinationNode.channelCountMode = 'explicit';
        // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
        if (nativeAudioDestinationNode.maxChannelCount === 0) Object.defineProperty(nativeAudioDestinationNode, 'maxChannelCount', {
            value: channelCount
        });
        // Bug #168: No browser does yet have an AudioDestinationNode with an output.
        const gainNode = createNativeGainNode(nativeContext, {
            channelCount: channelCount,
            channelCountMode: nativeAudioDestinationNode.channelCountMode,
            channelInterpretation: nativeAudioDestinationNode.channelInterpretation,
            gain: 1
        });
        overwriteAccessors(gainNode, 'channelCount', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                try {
                    nativeAudioDestinationNode.channelCount = value;
                } catch (err) {
                    // Bug #169: Safari throws an error on each attempt to change the channelCount.
                    if (value > nativeAudioDestinationNode.maxChannelCount) throw err;
                }
            });
        overwriteAccessors(gainNode, 'channelCountMode', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelCountMode = value;
            });
        overwriteAccessors(gainNode, 'channelInterpretation', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelInterpretation = value;
            });
        Object.defineProperty(gainNode, 'maxChannelCount', {
            get: ()=>nativeAudioDestinationNode.maxChannelCount
        });
        // @todo This should be disconnected when the context is closed.
        gainNode.connect(nativeAudioDestinationNode);
        return gainNode;
    };
};

});

parcelRegister("Yxv0j", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioWorkletNodeConstructor", () => $0b5f96ed71e6fb3a$export$b0ef4818c07d1453);
const $0b5f96ed71e6fb3a$export$b0ef4818c07d1453 = (window)=>{
    if (window === null) return null;
    return window.hasOwnProperty('AudioWorkletNode') ? window.AudioWorkletNode : null;
};

});

parcelRegister("dPTmN", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioWorkletNodeFactory", () => $a12afc6e6cd05f16$export$a6399b47836cd044);

var $jmcVf = parcelRequire("jmcVf");
const $a12afc6e6cd05f16$export$a6399b47836cd044 = (createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections)=>{
    return (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options)=>{
        if (nativeAudioWorkletNodeConstructor !== null) try {
            const nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
            const patchedEventListeners = new Map();
            let onprocessorerror = null;
            Object.defineProperties(nativeAudioWorkletNode, {
                /*
                     * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
                     * browsers have no native implementation to achieve a consistent behavior.
                     */ channelCount: {
                    get: ()=>options.channelCount,
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                channelCountMode: {
                    get: ()=>'explicit',
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
                onprocessorerror: {
                    get: ()=>onprocessorerror,
                    set: (value)=>{
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.removeEventListener('processorerror', onprocessorerror);
                        onprocessorerror = typeof value === 'function' ? value : null;
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.addEventListener('processorerror', onprocessorerror);
                    }
                }
            });
            nativeAudioWorkletNode.addEventListener = ((addEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                        if (unpatchedEventListener !== null) {
                            const patchedEventListener = patchedEventListeners.get(args[1]);
                            if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                            else {
                                args[1] = (event)=>{
                                    // Bug #178: Chrome and Edge do fire an event of type error.
                                    if (event.type === 'error') {
                                        Object.defineProperties(event, {
                                            type: {
                                                value: 'processorerror'
                                            }
                                        });
                                        unpatchedEventListener(event);
                                    } else unpatchedEventListener(new ErrorEvent(args[0], {
                                        ...event
                                    }));
                                };
                                patchedEventListeners.set(unpatchedEventListener, args[1]);
                            }
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    addEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return addEventListener.call(nativeAudioWorkletNode, ...args);
                };
            })(nativeAudioWorkletNode.addEventListener);
            nativeAudioWorkletNode.removeEventListener = ((removeEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) {
                            patchedEventListeners.delete(args[1]);
                            args[1] = patchedEventListener;
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    removeEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
                };
            })(nativeAudioWorkletNode.removeEventListener);
            /*
                 * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
                 * has an output.
                 */ if (options.numberOfOutputs !== 0) {
                const nativeGainNode = createNativeGainNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    gain: 0
                });
                nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);
                const whenConnected = ()=>nativeGainNode.disconnect();
                const whenDisconnected = ()=>nativeGainNode.connect(nativeContext.destination);
                // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.
                return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
            }
            return nativeAudioWorkletNode;
        } catch (err) {
            // Bug #60: Chrome & Edge throw an InvalidStateError instead of a NotSupportedError.
            if (err.code === 11) throw createNotSupportedError();
            throw err;
        }
        // Bug #61: Only Chrome & Edge have an implementation of the AudioWorkletNode yet.
        if (processorConstructor === undefined) throw createNotSupportedError();
        (0, $jmcVf.testClonabilityOfAudioWorkletNodeOptions)(options);
        return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
    };
};

});
parcelRegister("jmcVf", function(module, exports) {

$parcel$export(module.exports, "testClonabilityOfAudioWorkletNodeOptions", () => $e17a187f01dad40f$export$8bad4bda0c154746);
const $e17a187f01dad40f$export$8bad4bda0c154746 = (audioWorkletNodeOptions)=>{
    const { port1: port1 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
    }
};

});


parcelRegister("85FbK", function(module, exports) {

$parcel$export(module.exports, "createNativeAudioWorkletNodeFakerFactory", () => $5e3ebd86c8681fba$export$ea40f9f600f0adcb);

var $lQo9t = parcelRequire("lQo9t");

var $2pPEb = parcelRequire("2pPEb");

var $8U52d = parcelRequire("8U52d");

var $3x1mb = parcelRequire("3x1mb");

var $c3TTP = parcelRequire("c3TTP");

var $1Zg3Q = parcelRequire("1Zg3Q");

var $9lofq = parcelRequire("9lofq");
const $5e3ebd86c8681fba$export$ea40f9f600f0adcb = (connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections)=>{
    return (nativeContext, baseLatency, processorConstructor, options)=>{
        if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) throw createNotSupportedError();
        const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
        // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.
        if (outputChannelCount.some((channelCount)=>channelCount < 1)) throw createNotSupportedError();
        if (outputChannelCount.length !== options.numberOfOutputs) throw createIndexSizeError();
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (options.channelCountMode !== 'explicit') throw createNotSupportedError();
        const numberOfInputChannels = options.channelCount * options.numberOfInputs;
        const numberOfOutputChannels = outputChannelCount.reduce((sum, value1)=>sum + value1, 0);
        const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) throw createNotSupportedError();
        const messageChannel = new MessageChannel();
        const gainNodes = [];
        const inputChannelSplitterNodes = [];
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes.push(createNativeGainNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: options.channelCountMode,
                channelInterpretation: options.channelInterpretation,
                gain: 1
            }));
            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                numberOfOutputs: options.channelCount
            }));
        }
        const constantSourceNodes = [];
        if (processorConstructor.parameterDescriptors !== undefined) for (const { defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, name: name } of processorConstructor.parameterDescriptors){
            const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
            });
            Object.defineProperties(constantSourceNode.offset, {
                defaultValue: {
                    get: ()=>defaultValue === undefined ? 0 : defaultValue
                },
                maxValue: {
                    get: ()=>maxValue === undefined ? (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT) : maxValue
                },
                minValue: {
                    get: ()=>minValue === undefined ? (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT) : minValue
                }
            });
            constantSourceNodes.push(constantSourceNode);
        }
        const inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
        });
        const bufferSize = (0, $2pPEb.computeBufferSize)(baseLatency, nativeContext.sampleRate);
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        Math.max(1, numberOfOutputChannels));
        const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: Math.max(1, numberOfOutputChannels),
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: Math.max(1, numberOfOutputChannels)
        });
        const outputChannelMergerNodes = [];
        for(let i = 0; i < options.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: outputChannelCount[i]
        }));
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes[i].connect(inputChannelSplitterNodes[i]);
            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
        }
        const parameterMap = new (0, $9lofq.ReadOnlyMap)(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(({ name: name }, index)=>{
            const constantSourceNode = constantSourceNodes[index];
            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
            constantSourceNode.start(0);
            return [
                name,
                constantSourceNode.offset
            ];
        }));
        inputChannelMergerNode.connect(scriptProcessorNode);
        let channelInterpretation = options.channelInterpretation;
        let onprocessorerror = null;
        // Bug #87: Expose at least one output to make this node connectable.
        const outputAudioNodes = options.numberOfOutputs === 0 ? [
            scriptProcessorNode
        ] : outputChannelMergerNodes;
        const nativeAudioWorkletNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return options.channelCount;
            },
            set channelCount (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelCountMode () {
                return options.channelCountMode;
            },
            set channelCountMode (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelInterpretation () {
                return channelInterpretation;
            },
            set channelInterpretation (value){
                for (const gainNode of gainNodes)gainNode.channelInterpretation = value;
                channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return gainNodes;
            },
            get numberOfInputs () {
                return options.numberOfInputs;
            },
            get numberOfOutputs () {
                return options.numberOfOutputs;
            },
            get onprocessorerror () {
                return onprocessorerror;
            },
            set onprocessorerror (value){
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.removeEventListener('processorerror', onprocessorerror);
                onprocessorerror = typeof value === 'function' ? value : null;
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.addEventListener('processorerror', onprocessorerror);
            },
            get parameters () {
                return parameterMap;
            },
            get port () {
                return messageChannel.port2;
            },
            addEventListener (...args) {
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            connect: connectMultipleOutputs.bind(null, outputAudioNodes),
            disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        const patchedEventListeners = new Map();
        messageChannel.port1.addEventListener = ((addEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                    if (unpatchedEventListener !== null) {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                        else {
                            args[1] = (event)=>{
                                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>unpatchedEventListener(event));
                            };
                            patchedEventListeners.set(unpatchedEventListener, args[1]);
                        }
                    }
                }
                return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.addEventListener);
        messageChannel.port1.removeEventListener = ((removeEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const patchedEventListener = patchedEventListeners.get(args[1]);
                    if (patchedEventListener !== undefined) {
                        patchedEventListeners.delete(args[1]);
                        args[1] = patchedEventListener;
                    }
                }
                return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.removeEventListener);
        let onmessage = null;
        Object.defineProperty(messageChannel.port1, 'onmessage', {
            get: ()=>onmessage,
            set: (value1)=>{
                if (typeof onmessage === 'function') messageChannel.port1.removeEventListener('message', onmessage);
                onmessage = typeof value1 === 'function' ? value1 : null;
                if (typeof onmessage === 'function') {
                    messageChannel.port1.addEventListener('message', onmessage);
                    messageChannel.port1.start();
                }
            }
        });
        processorConstructor.prototype.port = messageChannel.port1;
        let audioWorkletProcessor = null;
        const audioWorkletProcessorPromise = (0, $c3TTP.createAudioWorkletProcessor)(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
        audioWorkletProcessorPromise.then((dWrkltPrcssr)=>audioWorkletProcessor = dWrkltPrcssr);
        const inputs = (0, $1Zg3Q.createNestedArrays)(options.numberOfInputs, options.channelCount);
        const outputs = (0, $1Zg3Q.createNestedArrays)(options.numberOfOutputs, outputChannelCount);
        const parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce((prmtrs, { name: name })=>({
                ...prmtrs,
                [name]: new Float32Array(128)
            }), {});
        let isActive = true;
        const disconnectOutputsGraph = ()=>{
            if (options.numberOfOutputs > 0) scriptProcessorNode.disconnect(outputChannelSplitterNode);
            for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                const outputChannelMergerNode = outputChannelMergerNodes[i];
                for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                outputChannelSplitterNodeOutput += outputChannelCount[i];
            }
        };
        const activeInputIndexes = new Map();
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer, outputBuffer: outputBuffer })=>{
            if (audioWorkletProcessor !== null) {
                const activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);
                for(let i = 0; i < bufferSize; i += 128){
                    for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $8U52d.copyFromChannel)(inputBuffer, inputs[j], k, k, i);
                    if (processorConstructor.parameterDescriptors !== undefined) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
                        (0, $8U52d.copyFromChannel)(inputBuffer, parameters, name, numberOfInputChannels + index, i);
                    });
                    for(let j = 0; j < options.numberOfInputs; j += 1){
                        for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
                        if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
                    }
                    try {
                        const potentiallyEmptyInputs = inputs.map((input, index)=>{
                            const activeInput = activeInputs[index];
                            if (activeInput.size > 0) {
                                activeInputIndexes.set(index, bufferSize / 128);
                                return input;
                            }
                            const count = activeInputIndexes.get(index);
                            if (count === undefined) return [];
                            if (input.every((channelData)=>channelData.every((sample)=>sample === 0))) {
                                if (count === 1) activeInputIndexes.delete(index);
                                else activeInputIndexes.set(index, count - 1);
                            }
                            return input;
                        });
                        const activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + i / nativeContext.sampleRate, nativeContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
                        isActive = activeSourceFlag;
                        for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                            for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $3x1mb.copyToChannel)(outputBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                            outputChannelSplitterNodeOutput += outputChannelCount[j];
                        }
                    } catch (error) {
                        isActive = false;
                        nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent('processorerror', {
                            colno: error.colno,
                            filename: error.filename,
                            lineno: error.lineno,
                            message: error.message
                        }));
                    }
                    if (!isActive) {
                        for(let j = 0; j < options.numberOfInputs; j += 1){
                            gainNodes[j].disconnect(inputChannelSplitterNodes[j]);
                            for(let k = 0; k < options.channelCount; k += 1)inputChannelSplitterNodes[i].disconnect(inputChannelMergerNode, k, j * options.channelCount + k);
                        }
                        if (processorConstructor.parameterDescriptors !== undefined) {
                            const length = processorConstructor.parameterDescriptors.length;
                            for(let j = 0; j < length; j += 1){
                                const constantSourceNode = constantSourceNodes[j];
                                constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + j);
                                constantSourceNode.stop();
                            }
                        }
                        inputChannelMergerNode.disconnect(scriptProcessorNode);
                        scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                        if (isConnected) disconnectOutputsGraph();
                        else disconnectFakeGraph();
                        break;
                    }
                }
            }
        };
        let isConnected = false;
        // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        const connectFakeGraph = ()=>scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnectFakeGraph = ()=>{
            scriptProcessorNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        const whenConnected = ()=>{
            if (isActive) {
                disconnectFakeGraph();
                if (options.numberOfOutputs > 0) scriptProcessorNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
            }
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            if (isActive) {
                connectFakeGraph();
                disconnectOutputsGraph();
            }
            isConnected = false;
        };
        connectFakeGraph();
        return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
    };
};

});
parcelRegister("2pPEb", function(module, exports) {

$parcel$export(module.exports, "computeBufferSize", () => $1c25fa999dc9e625$export$c3c4ba87244c2bf4);
const $1c25fa999dc9e625$export$c3c4ba87244c2bf4 = (baseLatency, sampleRate)=>{
    if (baseLatency === null) return 512;
    return Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(baseLatency * sampleRate)))));
};

});

parcelRegister("c3TTP", function(module, exports) {

$parcel$export(module.exports, "createAudioWorkletProcessor", () => $8c81204dc9a5b9b1$export$5200a42feb14a7b7);

var $kBpIy = parcelRequire("kBpIy");

var $k3WZm = parcelRequire("k3WZm");
const $8c81204dc9a5b9b1$export$5200a42feb14a7b7 = (nativeContext, nativeAudioWorkletNode, processorConstructor, audioWorkletNodeOptions)=>{
    let nodeToProcessorMap = (0, $kBpIy.NODE_TO_PROCESSOR_MAPS).get(nativeContext);
    if (nodeToProcessorMap === undefined) {
        nodeToProcessorMap = new WeakMap();
        (0, $kBpIy.NODE_TO_PROCESSOR_MAPS).set(nativeContext, nodeToProcessorMap);
    }
    const audioWorkletProcessorPromise = (0, $k3WZm.createAudioWorkletProcessorPromise)(processorConstructor, audioWorkletNodeOptions);
    nodeToProcessorMap.set(nativeAudioWorkletNode, audioWorkletProcessorPromise);
    return audioWorkletProcessorPromise;
};

});
parcelRegister("k3WZm", function(module, exports) {

$parcel$export(module.exports, "createAudioWorkletProcessorPromise", () => $e9b1d863733c758e$export$62410a657c3adf1d);

var $4s6GC = parcelRequire("4s6GC");
const $e9b1d863733c758e$export$62410a657c3adf1d = async (processorConstructor, audioWorkletNodeOptions)=>{
    const clonedAudioWorkletNodeOptions = await (0, $4s6GC.cloneAudioWorkletNodeOptions)(audioWorkletNodeOptions);
    return new processorConstructor(clonedAudioWorkletNodeOptions);
};

});
parcelRegister("4s6GC", function(module, exports) {

$parcel$export(module.exports, "cloneAudioWorkletNodeOptions", () => $33def6b983b52159$export$45f6aa3433a4eb0);
const $33def6b983b52159$export$45f6aa3433a4eb0 = (audioWorkletNodeOptions)=>{
    return new Promise((resolve, reject)=>{
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>{
            port1.close();
            port2.close();
            resolve(data);
        };
        port1.onmessageerror = ({ data: data })=>{
            port1.close();
            port2.close();
            reject(data);
        };
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port2.postMessage(audioWorkletNodeOptions);
    });
};

});




parcelRegister("8AhrS", function(module, exports) {

$parcel$export(module.exports, "createNativeBiquadFilterNode", () => $63ff38710bfce218$export$97e69c8dbd260f85);

var $1YLL1 = parcelRequire("1YLL1");

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");
const $63ff38710bfce218$export$97e69c8dbd260f85 = (nativeContext, options)=>{
    const nativeBiquadFilterNode = nativeContext.createBiquadFilter();
    (0, $fb5On.assignNativeAudioNodeOptions)(nativeBiquadFilterNode, options);
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeBiquadFilterNode, options, 'Q');
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeBiquadFilterNode, options, 'detune');
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeBiquadFilterNode, options, 'frequency');
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeBiquadFilterNode, options, 'gain');
    (0, $kC0ys.assignNativeAudioNodeOption)(nativeBiquadFilterNode, options, 'type');
    return nativeBiquadFilterNode;
};

});

parcelRegister("c59vA", function(module, exports) {

$parcel$export(module.exports, "createNativeChannelMergerNodeFactory", () => $8cbd53d42caee487$export$99fe194415d94151);

var $fb5On = parcelRequire("fb5On");
const $8cbd53d42caee487$export$99fe194415d94151 = (nativeAudioContextConstructor, wrapChannelMergerNode)=>{
    return (nativeContext, options)=>{
        const nativeChannelMergerNode = nativeContext.createChannelMerger(options.numberOfInputs);
        /*
         * Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') wrapChannelMergerNode(nativeContext, nativeChannelMergerNode);
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeChannelMergerNode, options);
        return nativeChannelMergerNode;
    };
};

});

parcelRegister("l5Ydn", function(module, exports) {

$parcel$export(module.exports, "createNativeChannelSplitterNode", () => $f5b8c5fbc802b926$export$17649533bf213707);

var $fb5On = parcelRequire("fb5On");

var $fdkqy = parcelRequire("fdkqy");
const $f5b8c5fbc802b926$export$17649533bf213707 = (nativeContext, options)=>{
    const nativeChannelSplitterNode = nativeContext.createChannelSplitter(options.numberOfOutputs);
    // Bug #96: Safari does not have the correct channelCount.
    // Bug #29: Safari does not have the correct channelCountMode.
    // Bug #31: Safari does not have the correct channelInterpretation.
    (0, $fb5On.assignNativeAudioNodeOptions)(nativeChannelSplitterNode, options);
    // Bug #29, #30, #31, #32, #96 & #97: Only Chrome, Edge & Firefox partially support the spec yet.
    (0, $fdkqy.wrapChannelSplitterNode)(nativeChannelSplitterNode);
    return nativeChannelSplitterNode;
};

});
parcelRegister("fdkqy", function(module, exports) {

$parcel$export(module.exports, "wrapChannelSplitterNode", () => $b137ea5bb66c9816$export$62f6b3ab91fa4589);

var $2meOO = parcelRequire("2meOO");
const $b137ea5bb66c9816$export$62f6b3ab91fa4589 = (channelSplitterNode)=>{
    const channelCount = channelSplitterNode.numberOfOutputs;
    // Bug #97: Safari does not throw an error when attempting to change the channelCount to something other than its initial value.
    Object.defineProperty(channelSplitterNode, 'channelCount', {
        get: ()=>channelCount,
        set: (value)=>{
            if (value !== channelCount) throw (0, $2meOO.createInvalidStateError)();
        }
    });
    // Bug #30: Safari does not throw an error when attempting to change the channelCountMode to something other than explicit.
    Object.defineProperty(channelSplitterNode, 'channelCountMode', {
        get: ()=>'explicit',
        set: (value)=>{
            if (value !== 'explicit') throw (0, $2meOO.createInvalidStateError)();
        }
    });
    // Bug #32: Safari does not throw an error when attempting to change the channelInterpretation to something other than discrete.
    Object.defineProperty(channelSplitterNode, 'channelInterpretation', {
        get: ()=>'discrete',
        set: (value)=>{
            if (value !== 'discrete') throw (0, $2meOO.createInvalidStateError)();
        }
    });
};

});


parcelRegister("kH7K1", function(module, exports) {

$parcel$export(module.exports, "createNativeConstantSourceNodeFactory", () => $f10dd40bba530742$export$2dd44f7bb3dd8089);

var $1YLL1 = parcelRequire("1YLL1");

var $fb5On = parcelRequire("fb5On");

var $5mW9o = parcelRequire("5mW9o");

var $527MF = parcelRequire("527MF");
const $f10dd40bba530742$export$2dd44f7bb3dd8089 = (addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport)=>{
    return (nativeContext, options)=>{
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeContext.createConstantSource === undefined) return createNativeConstantSourceNodeFaker(nativeContext, options);
        const nativeConstantSourceNode = nativeContext.createConstantSource();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeConstantSourceNode, options);
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeConstantSourceNode, options, 'offset');
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $5mW9o.wrapAudioScheduledSourceNodeStartMethodNegativeParameters)(nativeConstantSourceNode);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $527MF.wrapAudioScheduledSourceNodeStopMethodNegativeParameters)(nativeConstantSourceNode);
        // Bug #175: Safari will not fire an ended event if the ConstantSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeConstantSourceNode);
        return nativeConstantSourceNode;
    };
};

});

parcelRegister("iwg3Z", function(module, exports) {

$parcel$export(module.exports, "createNativeConstantSourceNodeFakerFactory", () => $d7b7acfeeab65daa$export$360749cf3d02285a);

var $jVGFG = parcelRequire("jVGFG");
const $d7b7acfeeab65daa$export$360749cf3d02285a = (addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections)=>{
    return (nativeContext, { offset: offset, ...audioNodeOptions })=>{
        const audioBuffer = nativeContext.createBuffer(1, 2, 44100);
        const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const gainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: offset
        });
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        const channelData = audioBuffer.getChannelData(0);
        // Bug #95: Safari does not play or loop one sample buffers.
        channelData[0] = 1;
        channelData[1] = 1;
        audioBufferSourceNode.buffer = audioBuffer;
        audioBufferSourceNode.loop = true;
        const nativeConstantSourceNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return gainNode.channelCount;
            },
            set channelCount (value){
                gainNode.channelCount = value;
            },
            get channelCountMode () {
                return gainNode.channelCountMode;
            },
            set channelCountMode (value){
                gainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return gainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                gainNode.channelInterpretation = value;
            },
            get context () {
                return gainNode.context;
            },
            get inputs () {
                return [];
            },
            get numberOfInputs () {
                return audioBufferSourceNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return gainNode.numberOfOutputs;
            },
            get offset () {
                return gainNode.gain;
            },
            get onended () {
                return audioBufferSourceNode.onended;
            },
            set onended (value){
                audioBufferSourceNode.onended = value;
            },
            addEventListener (...args) {
                return audioBufferSourceNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return audioBufferSourceNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return audioBufferSourceNode.removeEventListener(args[0], args[1], args[2]);
            },
            start (when = 0) {
                audioBufferSourceNode.start.call(audioBufferSourceNode, when);
            },
            stop (when = 0) {
                audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
            }
        };
        const whenConnected = ()=>audioBufferSourceNode.connect(gainNode);
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(gainNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, audioBufferSourceNode);
        return monitorConnections((0, $jVGFG.interceptConnections)(nativeConstantSourceNodeFaker, gainNode), whenConnected, whenDisconnected);
    };
};

});
parcelRegister("jVGFG", function(module, exports) {

$parcel$export(module.exports, "interceptConnections", () => $03be85f2e3af3c35$export$19c8a106f82dff14);
const $03be85f2e3af3c35$export$19c8a106f82dff14 = (original, interceptor)=>{
    original.connect = interceptor.connect.bind(interceptor);
    original.disconnect = interceptor.disconnect.bind(interceptor);
    return original;
};

});


parcelRegister("eqU4Z", function(module, exports) {

$parcel$export(module.exports, "createNativeConvolverNodeFactory", () => $a81efea15afe76e8$export$afdcf89d13ff62e);

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");
const $a81efea15afe76e8$export$afdcf89d13ff62e = (createNotSupportedError, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeConvolverNode = nativeContext.createConvolver();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeConvolverNode, options);
        // The normalize property needs to be set before setting the buffer.
        if (options.disableNormalization === nativeConvolverNode.normalize) nativeConvolverNode.normalize = !options.disableNormalization;
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeConvolverNode, options, 'buffer');
        // Bug #113: Safari does allow to set the channelCount to a value larger than 2.
        if (options.channelCount > 2) throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCount', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value > 2) throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        // Bug #114: Safari allows to set the channelCountMode to 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCountMode', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value === 'max') throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        return nativeConvolverNode;
    };
};

});

parcelRegister("9EasH", function(module, exports) {

$parcel$export(module.exports, "createNativeDelayNode", () => $705ff702323b9f03$export$f7dd6d407a2109ef);

var $1YLL1 = parcelRequire("1YLL1");

var $fb5On = parcelRequire("fb5On");
const $705ff702323b9f03$export$f7dd6d407a2109ef = (nativeContext, options)=>{
    const nativeDelayNode = nativeContext.createDelay(options.maxDelayTime);
    (0, $fb5On.assignNativeAudioNodeOptions)(nativeDelayNode, options);
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDelayNode, options, 'delayTime');
    return nativeDelayNode;
};

});

parcelRegister("1iyoI", function(module, exports) {

$parcel$export(module.exports, "createNativeDynamicsCompressorNodeFactory", () => $0f222786f6776836$export$f19d90a0cd4a2ecc);

var $1YLL1 = parcelRequire("1YLL1");

var $fb5On = parcelRequire("fb5On");
const $0f222786f6776836$export$f19d90a0cd4a2ecc = (createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const nativeDynamicsCompressorNode = nativeContext.createDynamicsCompressor();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeDynamicsCompressorNode, options);
        // Bug #108: Safari allows a channelCount of three and above.
        if (options.channelCount > 2) throw createNotSupportedError();
        // Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDynamicsCompressorNode, options, 'attack');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDynamicsCompressorNode, options, 'knee');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDynamicsCompressorNode, options, 'ratio');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDynamicsCompressorNode, options, 'release');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeDynamicsCompressorNode, options, 'threshold');
        return nativeDynamicsCompressorNode;
    };
};

});

parcelRegister("fsgHl", function(module, exports) {

$parcel$export(module.exports, "createNativeGainNode", () => $b4066c6ee23f6721$export$7cf909169b9c4d6f);

var $1YLL1 = parcelRequire("1YLL1");

var $fb5On = parcelRequire("fb5On");
const $b4066c6ee23f6721$export$7cf909169b9c4d6f = (nativeContext, options)=>{
    const nativeGainNode = nativeContext.createGain();
    (0, $fb5On.assignNativeAudioNodeOptions)(nativeGainNode, options);
    (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeGainNode, options, 'gain');
    return nativeGainNode;
};

});

parcelRegister("2IweL", function(module, exports) {

$parcel$export(module.exports, "createNativeIIRFilterNodeFactory", () => $1fa8b273c597a198$export$3c1aed24ed6efd9d);

var $fb5On = parcelRequire("fb5On");
const $1fa8b273c597a198$export$3c1aed24ed6efd9d = (createNativeIIRFilterNodeFaker)=>{
    return (nativeContext, baseLatency, options)=>{
        // Bug #9: Safari does not support IIRFilterNodes.
        if (nativeContext.createIIRFilter === undefined) return createNativeIIRFilterNodeFaker(nativeContext, baseLatency, options);
        // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
        const nativeIIRFilterNode = nativeContext.createIIRFilter(options.feedforward, options.feedback);
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeIIRFilterNode, options);
        return nativeIIRFilterNode;
    };
};

});

parcelRegister("93ZjL", function(module, exports) {

$parcel$export(module.exports, "createNativeIIRFilterNodeFakerFactory", () => $6993f54f47c5fa0c$export$49dca6a724f463b);

var $2pPEb = parcelRequire("2pPEb");

var $3QfiN = parcelRequire("3QfiN");

var $jVGFG = parcelRequire("jVGFG");
function $6993f54f47c5fa0c$var$divide(a, b) {
    const denominator = b[0] * b[0] + b[1] * b[1];
    return [
        (a[0] * b[0] + a[1] * b[1]) / denominator,
        (a[1] * b[0] - a[0] * b[1]) / denominator
    ];
}
function $6993f54f47c5fa0c$var$multiply(a, b) {
    return [
        a[0] * b[0] - a[1] * b[1],
        a[0] * b[1] + a[1] * b[0]
    ];
}
function $6993f54f47c5fa0c$var$evaluatePolynomial(coefficient, z) {
    let result = [
        0,
        0
    ];
    for(let i = coefficient.length - 1; i >= 0; i -= 1){
        result = $6993f54f47c5fa0c$var$multiply(result, z);
        result[0] += coefficient[i];
    }
    return result;
}
const $6993f54f47c5fa0c$export$49dca6a724f463b = (createInvalidAccessError, createInvalidStateError, createNativeScriptProcessorNode, createNotSupportedError)=>{
    return (nativeContext, baseLatency, { channelCount: channelCount, channelCountMode: channelCountMode, channelInterpretation: channelInterpretation, feedback: feedback, feedforward: feedforward })=>{
        const bufferSize = (0, $2pPEb.computeBufferSize)(baseLatency, nativeContext.sampleRate);
        const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
        const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
        const feedbackLength = convertedFeedback.length;
        const feedforwardLength = convertedFeedforward.length;
        const minLength = Math.min(feedbackLength, feedforwardLength);
        if (feedbackLength === 0 || feedbackLength > 20) throw createNotSupportedError();
        if (convertedFeedback[0] === 0) throw createInvalidStateError();
        if (feedforwardLength === 0 || feedforwardLength > 20) throw createNotSupportedError();
        if (convertedFeedforward[0] === 0) throw createInvalidStateError();
        if (convertedFeedback[0] !== 1) {
            for(let i = 0; i < feedforwardLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
            for(let i = 1; i < feedbackLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
        }
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, channelCount, channelCount);
        scriptProcessorNode.channelCount = channelCount;
        scriptProcessorNode.channelCountMode = channelCountMode;
        scriptProcessorNode.channelInterpretation = channelInterpretation;
        const bufferLength = 32;
        const bufferIndexes = [];
        const xBuffers = [];
        const yBuffers = [];
        for(let i = 0; i < channelCount; i += 1){
            bufferIndexes.push(0);
            const xBuffer = new Float32Array(bufferLength);
            const yBuffer = new Float32Array(bufferLength);
            xBuffer.fill(0);
            yBuffer.fill(0);
            xBuffers.push(xBuffer);
            yBuffers.push(yBuffer);
        }
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = (event)=>{
            const inputBuffer = event.inputBuffer;
            const outputBuffer = event.outputBuffer;
            const numberOfChannels = inputBuffer.numberOfChannels;
            for(let i = 0; i < numberOfChannels; i += 1){
                const input = inputBuffer.getChannelData(i);
                const output = outputBuffer.getChannelData(i);
                bufferIndexes[i] = (0, $3QfiN.filterBuffer)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffers[i], yBuffers[i], bufferIndexes[i], bufferLength, input, output);
            }
        };
        const nyquist = nativeContext.sampleRate / 2;
        const nativeIIRFilterNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return scriptProcessorNode.channelCount;
            },
            set channelCount (value){
                scriptProcessorNode.channelCount = value;
            },
            get channelCountMode () {
                return scriptProcessorNode.channelCountMode;
            },
            set channelCountMode (value){
                scriptProcessorNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return scriptProcessorNode.channelInterpretation;
            },
            set channelInterpretation (value){
                scriptProcessorNode.channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return [
                    scriptProcessorNode
                ];
            },
            get numberOfInputs () {
                return scriptProcessorNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return scriptProcessorNode.numberOfOutputs;
            },
            addEventListener (...args) {
                // @todo Dissallow adding an audioprocess listener.
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            getFrequencyResponse (frequencyHz, magResponse, phaseResponse) {
                if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
                const length = frequencyHz.length;
                for(let i = 0; i < length; i += 1){
                    const omega = -Math.PI * (frequencyHz[i] / nyquist);
                    const z = [
                        Math.cos(omega),
                        Math.sin(omega)
                    ];
                    const numerator = $6993f54f47c5fa0c$var$evaluatePolynomial(convertedFeedforward, z);
                    const denominator = $6993f54f47c5fa0c$var$evaluatePolynomial(convertedFeedback, z);
                    const response = $6993f54f47c5fa0c$var$divide(numerator, denominator);
                    magResponse[i] = Math.sqrt(response[0] * response[0] + response[1] * response[1]);
                    phaseResponse[i] = Math.atan2(response[1], response[0]);
                }
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        return (0, $jVGFG.interceptConnections)(nativeIIRFilterNodeFaker, scriptProcessorNode);
    };
};

});

parcelRegister("aqiBQ", function(module, exports) {

$parcel$export(module.exports, "createNativeMediaElementAudioSourceNode", () => $01f555c03480f99f$export$2b1682bf41b4d16b);
const $01f555c03480f99f$export$2b1682bf41b4d16b = (nativeAudioContext, options)=>{
    return nativeAudioContext.createMediaElementSource(options.mediaElement);
};

});

parcelRegister("54cQo", function(module, exports) {

$parcel$export(module.exports, "createNativeMediaStreamAudioDestinationNode", () => $3b074a0c75b6976f$export$acb51039efa3405d);

var $fb5On = parcelRequire("fb5On");
const $3b074a0c75b6976f$export$acb51039efa3405d = (nativeAudioContext, options)=>{
    const nativeMediaStreamAudioDestinationNode = nativeAudioContext.createMediaStreamDestination();
    (0, $fb5On.assignNativeAudioNodeOptions)(nativeMediaStreamAudioDestinationNode, options);
    // Bug #174: Safari does expose a wrong numberOfOutputs.
    if (nativeMediaStreamAudioDestinationNode.numberOfOutputs === 1) Object.defineProperty(nativeMediaStreamAudioDestinationNode, 'numberOfOutputs', {
        get: ()=>0
    });
    return nativeMediaStreamAudioDestinationNode;
};

});

parcelRegister("7Mr4p", function(module, exports) {

$parcel$export(module.exports, "createNativeMediaStreamAudioSourceNode", () => $5aa203a3c41410fa$export$ad3e497ef44fc577);
const $5aa203a3c41410fa$export$ad3e497ef44fc577 = (nativeAudioContext, { mediaStream: mediaStream })=>{
    const audioStreamTracks = mediaStream.getAudioTracks();
    /*
     * Bug #151: Safari does not use the audio track as input anymore if it gets removed from the mediaStream after construction.
     * Bug #159: Safari picks the first audio track if the MediaStream has more than one audio track.
     */ audioStreamTracks.sort((a, b)=>a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    const filteredAudioStreamTracks = audioStreamTracks.slice(0, 1);
    const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(new MediaStream(filteredAudioStreamTracks));
    /*
     * Bug #151 & #159: The given mediaStream gets reconstructed before it gets passed to the native node which is why the accessor needs
     * to be overwritten as it would otherwise expose the reconstructed version.
     */ Object.defineProperty(nativeMediaStreamAudioSourceNode, 'mediaStream', {
        value: mediaStream
    });
    return nativeMediaStreamAudioSourceNode;
};

});

parcelRegister("dCMVF", function(module, exports) {

$parcel$export(module.exports, "createNativeMediaStreamTrackAudioSourceNodeFactory", () => $9eb4c74b4037d1b4$export$87e46bc6eb8ed6ac);
const $9eb4c74b4037d1b4$export$87e46bc6eb8ed6ac = (createInvalidStateError, isNativeOfflineAudioContext)=>{
    return (nativeAudioContext, { mediaStreamTrack: mediaStreamTrack })=>{
        // Bug #121: Only Firefox does yet support the MediaStreamTrackAudioSourceNode.
        if (typeof nativeAudioContext.createMediaStreamTrackSource === 'function') return nativeAudioContext.createMediaStreamTrackSource(mediaStreamTrack);
        const mediaStream = new MediaStream([
            mediaStreamTrack
        ]);
        const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(mediaStream);
        // Bug #120: Firefox does not throw an error if the mediaStream has no audio track.
        if (mediaStreamTrack.kind !== 'audio') throw createInvalidStateError();
        // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
        if (isNativeOfflineAudioContext(nativeAudioContext)) throw new TypeError();
        return nativeMediaStreamAudioSourceNode;
    };
};

});

parcelRegister("3S0ml", function(module, exports) {

$parcel$export(module.exports, "createNativeOfflineAudioContextConstructor", () => $2d16b19fb7f93a4c$export$e628a2a5fd5b78b9);
const $2d16b19fb7f93a4c$export$e628a2a5fd5b78b9 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('OfflineAudioContext')) return window.OfflineAudioContext;
    return window.hasOwnProperty('webkitOfflineAudioContext') ? window.webkitOfflineAudioContext : null;
};

});

parcelRegister("6M9HG", function(module, exports) {

$parcel$export(module.exports, "createNativeOscillatorNodeFactory", () => $4eeec0b283433029$export$a40e02c218ae01d3);

var $1YLL1 = parcelRequire("1YLL1");

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");

var $5mW9o = parcelRequire("5mW9o");

var $527MF = parcelRequire("527MF");
const $4eeec0b283433029$export$a40e02c218ae01d3 = (addSilentConnection, cacheTestResult, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeOscillatorNode = nativeContext.createOscillator();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeOscillatorNode, options);
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeOscillatorNode, options, 'detune');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeOscillatorNode, options, 'frequency');
        if (options.periodicWave !== undefined) nativeOscillatorNode.setPeriodicWave(options.periodicWave);
        else (0, $kC0ys.assignNativeAudioNodeOption)(nativeOscillatorNode, options, 'type');
        // Bug #44: Only Chrome & Edge throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $5mW9o.wrapAudioScheduledSourceNodeStartMethodNegativeParameters)(nativeOscillatorNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeOscillatorNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $527MF.wrapAudioScheduledSourceNodeStopMethodNegativeParameters)(nativeOscillatorNode);
        // Bug #175: Safari will not fire an ended event if the OscillatorNode is unconnected.
        addSilentConnection(nativeContext, nativeOscillatorNode);
        return nativeOscillatorNode;
    };
};

});

parcelRegister("8BXEl", function(module, exports) {

$parcel$export(module.exports, "createNativePannerNodeFactory", () => $64500c98ed63d35c$export$8e3c89af72a58833);

var $1YLL1 = parcelRequire("1YLL1");

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");
const $64500c98ed63d35c$export$8e3c89af72a58833 = (createNativePannerNodeFaker)=>{
    return (nativeContext, options)=>{
        const nativePannerNode = nativeContext.createPanner();
        // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
        if (nativePannerNode.orientationX === undefined) return createNativePannerNodeFaker(nativeContext, options);
        (0, $fb5On.assignNativeAudioNodeOptions)(nativePannerNode, options);
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'orientationX');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'orientationY');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'orientationZ');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'positionX');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'positionY');
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativePannerNode, options, 'positionZ');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'coneInnerAngle');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'coneOuterAngle');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'coneOuterGain');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'distanceModel');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'maxDistance');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'panningModel');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'refDistance');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativePannerNode, options, 'rolloffFactor');
        return nativePannerNode;
    };
};

});

parcelRegister("5dTI0", function(module, exports) {

$parcel$export(module.exports, "createNativePannerNodeFakerFactory", () => $3cd9613ca35b5937$export$f04468477689c1b4);

var $fb5On = parcelRequire("fb5On");

var $jVGFG = parcelRequire("jVGFG");
const $3cd9613ca35b5937$export$f04468477689c1b4 = (connectNativeAudioNodeToNativeAudioNode, createInvalidStateError, createNativeChannelMergerNode, createNativeGainNode, createNativeScriptProcessorNode, createNativeWaveShaperNode, createNotSupportedError, disconnectNativeAudioNodeFromNativeAudioNode, getFirstSample, monitorConnections)=>{
    return (nativeContext, { coneInnerAngle: coneInnerAngle, coneOuterAngle: coneOuterAngle, coneOuterGain: coneOuterGain, distanceModel: distanceModel, maxDistance: maxDistance, orientationX: orientationX, orientationY: orientationY, orientationZ: orientationZ, panningModel: panningModel, positionX: positionX, positionY: positionY, positionZ: positionZ, refDistance: refDistance, rolloffFactor: rolloffFactor, ...audioNodeOptions })=>{
        const pannerNode = nativeContext.createPanner();
        // Bug #125: Safari does not throw an error yet.
        if (audioNodeOptions.channelCount > 2) throw createNotSupportedError();
        // Bug #126: Safari does not throw an error yet.
        if (audioNodeOptions.channelCountMode === 'max') throw createNotSupportedError();
        (0, $fb5On.assignNativeAudioNodeOptions)(pannerNode, audioNodeOptions);
        const SINGLE_CHANNEL_OPTIONS = {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete'
        };
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            channelInterpretation: 'speakers',
            numberOfInputs: 6
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const orientationXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 1
        });
        const orientationYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const orientationZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 6, 1);
        const waveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            curve: new Float32Array([
                1,
                1
            ]),
            oversample: 'none'
        });
        let lastOrientation = [
            orientationX,
            orientationY,
            orientationZ
        ];
        let lastPosition = [
            positionX,
            positionY,
            positionZ
        ];
        const buffer = new Float32Array(1);
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
            const orientation = [
                getFirstSample(inputBuffer, buffer, 0),
                getFirstSample(inputBuffer, buffer, 1),
                getFirstSample(inputBuffer, buffer, 2)
            ];
            if (orientation.some((value1, index)=>value1 !== lastOrientation[index])) {
                pannerNode.setOrientation(...orientation); // tslint:disable-line:deprecation
                lastOrientation = orientation;
            }
            const positon = [
                getFirstSample(inputBuffer, buffer, 3),
                getFirstSample(inputBuffer, buffer, 4),
                getFirstSample(inputBuffer, buffer, 5)
            ];
            if (positon.some((value1, index)=>value1 !== lastPosition[index])) {
                pannerNode.setPosition(...positon); // tslint:disable-line:deprecation
                lastPosition = positon;
            }
        };
        Object.defineProperty(orientationYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(orientationZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionXGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        const nativePannerNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return pannerNode.channelCount;
            },
            set channelCount (value){
                // Bug #125: Safari does not throw an error yet.
                if (value > 2) throw createNotSupportedError();
                inputGainNode.channelCount = value;
                pannerNode.channelCount = value;
            },
            get channelCountMode () {
                return pannerNode.channelCountMode;
            },
            set channelCountMode (value){
                // Bug #126: Safari does not throw an error yet.
                if (value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
                pannerNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return pannerNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                pannerNode.channelInterpretation = value;
            },
            get coneInnerAngle () {
                return pannerNode.coneInnerAngle;
            },
            set coneInnerAngle (value){
                pannerNode.coneInnerAngle = value;
            },
            get coneOuterAngle () {
                return pannerNode.coneOuterAngle;
            },
            set coneOuterAngle (value){
                pannerNode.coneOuterAngle = value;
            },
            get coneOuterGain () {
                return pannerNode.coneOuterGain;
            },
            set coneOuterGain (value){
                // Bug #127: Safari does not throw an InvalidStateError yet.
                if (value < 0 || value > 1) throw createInvalidStateError();
                pannerNode.coneOuterGain = value;
            },
            get context () {
                return pannerNode.context;
            },
            get distanceModel () {
                return pannerNode.distanceModel;
            },
            set distanceModel (value){
                pannerNode.distanceModel = value;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get maxDistance () {
                return pannerNode.maxDistance;
            },
            set maxDistance (value){
                // Bug #128: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.maxDistance = value;
            },
            get numberOfInputs () {
                return pannerNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return pannerNode.numberOfOutputs;
            },
            get orientationX () {
                return orientationXGainNode.gain;
            },
            get orientationY () {
                return orientationYGainNode.gain;
            },
            get orientationZ () {
                return orientationZGainNode.gain;
            },
            get panningModel () {
                return pannerNode.panningModel;
            },
            set panningModel (value){
                pannerNode.panningModel = value;
            },
            get positionX () {
                return positionXGainNode.gain;
            },
            get positionY () {
                return positionYGainNode.gain;
            },
            get positionZ () {
                return positionZGainNode.gain;
            },
            get refDistance () {
                return pannerNode.refDistance;
            },
            set refDistance (value){
                // Bug #129: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.refDistance = value;
            },
            get rolloffFactor () {
                return pannerNode.rolloffFactor;
            },
            set rolloffFactor (value){
                // Bug #130: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.rolloffFactor = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (coneInnerAngle !== nativePannerNodeFaker.coneInnerAngle) nativePannerNodeFaker.coneInnerAngle = coneInnerAngle;
        if (coneOuterAngle !== nativePannerNodeFaker.coneOuterAngle) nativePannerNodeFaker.coneOuterAngle = coneOuterAngle;
        if (coneOuterGain !== nativePannerNodeFaker.coneOuterGain) nativePannerNodeFaker.coneOuterGain = coneOuterGain;
        if (distanceModel !== nativePannerNodeFaker.distanceModel) nativePannerNodeFaker.distanceModel = distanceModel;
        if (maxDistance !== nativePannerNodeFaker.maxDistance) nativePannerNodeFaker.maxDistance = maxDistance;
        if (orientationX !== nativePannerNodeFaker.orientationX.value) nativePannerNodeFaker.orientationX.value = orientationX;
        if (orientationY !== nativePannerNodeFaker.orientationY.value) nativePannerNodeFaker.orientationY.value = orientationY;
        if (orientationZ !== nativePannerNodeFaker.orientationZ.value) nativePannerNodeFaker.orientationZ.value = orientationZ;
        if (panningModel !== nativePannerNodeFaker.panningModel) nativePannerNodeFaker.panningModel = panningModel;
        if (positionX !== nativePannerNodeFaker.positionX.value) nativePannerNodeFaker.positionX.value = positionX;
        if (positionY !== nativePannerNodeFaker.positionY.value) nativePannerNodeFaker.positionY.value = positionY;
        if (positionZ !== nativePannerNodeFaker.positionZ.value) nativePannerNodeFaker.positionZ.value = positionZ;
        if (refDistance !== nativePannerNodeFaker.refDistance) nativePannerNodeFaker.refDistance = refDistance;
        if (rolloffFactor !== nativePannerNodeFaker.rolloffFactor) nativePannerNodeFaker.rolloffFactor = rolloffFactor;
        if (lastOrientation[0] !== 1 || lastOrientation[1] !== 0 || lastOrientation[2] !== 0) pannerNode.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
        if (lastPosition[0] !== 0 || lastPosition[1] !== 0 || lastPosition[2] !== 0) pannerNode.setPosition(...lastPosition); // tslint:disable-line:deprecation
        const whenConnected = ()=>{
            inputGainNode.connect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            connectNativeAudioNodeToNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.connect(orientationXGainNode).connect(channelMergerNode, 0, 0);
            waveShaperNode.connect(orientationYGainNode).connect(channelMergerNode, 0, 1);
            waveShaperNode.connect(orientationZGainNode).connect(channelMergerNode, 0, 2);
            waveShaperNode.connect(positionXGainNode).connect(channelMergerNode, 0, 3);
            waveShaperNode.connect(positionYGainNode).connect(channelMergerNode, 0, 4);
            waveShaperNode.connect(positionZGainNode).connect(channelMergerNode, 0, 5);
            channelMergerNode.connect(scriptProcessorNode).connect(nativeContext.destination);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            disconnectNativeAudioNodeFromNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.disconnect(orientationXGainNode);
            orientationXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationYGainNode);
            orientationYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationZGainNode);
            orientationZGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionXGainNode);
            positionXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionYGainNode);
            positionYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionZGainNode);
            positionZGainNode.disconnect(channelMergerNode);
            channelMergerNode.disconnect(scriptProcessorNode);
            scriptProcessorNode.disconnect(nativeContext.destination);
        };
        return monitorConnections((0, $jVGFG.interceptConnections)(nativePannerNodeFaker, pannerNode), whenConnected, whenDisconnected);
    };
};

});

parcelRegister("fSrsH", function(module, exports) {

$parcel$export(module.exports, "createNativePeriodicWaveFactory", () => $b8f13389cdbf5a32$export$3f519524c23feca0);
const $b8f13389cdbf5a32$export$3f519524c23feca0 = (createIndexSizeError)=>{
    return (nativeContext, { disableNormalization: disableNormalization, imag: imag, real: real })=>{
        // Bug #180: Safari does not allow to use ordinary arrays.
        const convertedImag = imag instanceof Float32Array ? imag : new Float32Array(imag);
        const convertedReal = real instanceof Float32Array ? real : new Float32Array(real);
        const nativePeriodicWave = nativeContext.createPeriodicWave(convertedReal, convertedImag, {
            disableNormalization: disableNormalization
        });
        // Bug #181: Safari does not throw an IndexSizeError so far if the given arrays have less than two values.
        if (Array.from(imag).length < 2) throw createIndexSizeError();
        return nativePeriodicWave;
    };
};

});

parcelRegister("4JxZu", function(module, exports) {

$parcel$export(module.exports, "createNativeScriptProcessorNode", () => $3725bb403f197398$export$9f784f497a6d6acb);
const $3725bb403f197398$export$9f784f497a6d6acb = (nativeContext, bufferSize, numberOfInputChannels, numberOfOutputChannels)=>{
    return nativeContext.createScriptProcessor(bufferSize, numberOfInputChannels, numberOfOutputChannels); // tslint:disable-line deprecation
};

});

parcelRegister("1rkne", function(module, exports) {

$parcel$export(module.exports, "createNativeStereoPannerNodeFactory", () => $10c81dd6b56f5b8d$export$247580dcf7d2f2c4);

var $1YLL1 = parcelRequire("1YLL1");

var $fb5On = parcelRequire("fb5On");
const $10c81dd6b56f5b8d$export$247580dcf7d2f2c4 = (createNativeStereoPannerNodeFaker, createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const channelCountMode = options.channelCountMode;
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ if (channelCountMode === 'clamped-max') throw createNotSupportedError();
        // Bug #105: Safari does not support the StereoPannerNode.
        if (nativeContext.createStereoPanner === undefined) return createNativeStereoPannerNodeFaker(nativeContext, options);
        const nativeStereoPannerNode = nativeContext.createStereoPanner();
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeStereoPannerNode, options);
        (0, $1YLL1.assignNativeAudioNodeAudioParamValue)(nativeStereoPannerNode, options, 'pan');
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ Object.defineProperty(nativeStereoPannerNode, 'channelCountMode', {
            get: ()=>channelCountMode,
            set: (value)=>{
                if (value !== channelCountMode) throw createNotSupportedError();
            }
        });
        return nativeStereoPannerNode;
    };
};

});

parcelRegister("gcGjK", function(module, exports) {

$parcel$export(module.exports, "createNativeStereoPannerNodeFakerFactory", () => $bcbe97af7b28e6bb$export$5fe2a787c06b2d34);

var $jVGFG = parcelRequire("jVGFG");
const $bcbe97af7b28e6bb$export$5fe2a787c06b2d34 = (createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeGainNode, createNativeWaveShaperNode, createNotSupportedError, monitorConnections)=>{
    // The curve has a size of 14bit plus 1 value to have an exact representation for zero. This value has been determined experimentally.
    const CURVE_SIZE = 16385;
    const DC_CURVE = new Float32Array([
        1,
        1
    ]);
    const HALF_PI = Math.PI / 2;
    const SINGLE_CHANNEL_OPTIONS = {
        channelCount: 1,
        channelCountMode: 'explicit',
        channelInterpretation: 'discrete'
    };
    const SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS = {
        ...SINGLE_CHANNEL_OPTIONS,
        oversample: 'none'
    };
    const buildInternalGraphForMono = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightWaveShaperCurve = new Float32Array(CURVE_SIZE);
        for(let i = 0; i < CURVE_SIZE; i += 1){
            const x = i / (CURVE_SIZE - 1) * HALF_PI;
            leftWaveShaperCurve[i] = Math.cos(x);
            rightWaveShaperCurve[i] = Math.sin(x);
        }
        const leftGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(leftGainNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.connect(rightGainNode);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.connect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.connect(leftGainNode.gain);
                rightWaveShaperNode.connect(rightGainNode.gain);
                leftGainNode.connect(channelMergerNode, 0, 0);
                rightGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(leftGainNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.disconnect(rightGainNode);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.disconnect(leftGainNode.gain);
                rightWaveShaperNode.disconnect(rightGainNode.gain);
                leftGainNode.disconnect(channelMergerNode, 0, 0);
                rightGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraphForStereo = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const leftInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const centerIndex = Math.floor(CURVE_SIZE / 2);
        for(let i = 0; i < CURVE_SIZE; i += 1)if (i > centerIndex) {
            const x = (i - centerIndex) / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            leftInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
            rightInputForLeftOutputWaveShaperCurve[i] = 0;
            rightInputForRightOutputWaveShaperCurve[i] = 1;
        } else {
            const x = i / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = 1;
            leftInputForRightOutputWaveShaperCurve[i] = 0;
            rightInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            rightInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
        }
        const channelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: 2,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: 2
        });
        const leftInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForLeftOutputWaveShaperCurve
        });
        const leftInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForRightOutputWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForLeftOutputWaveShaperCurve
        });
        const rightInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForRightOutputWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(channelSplitterNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.connect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.connect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.connect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.connect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.connect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.connect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.connect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.connect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(channelSplitterNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.disconnect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.disconnect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.disconnect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.disconnect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.disconnect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.disconnect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.disconnect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.disconnect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraph = (nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode)=>{
        if (channelCount === 1) return buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        if (channelCount === 2) return buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        throw createNotSupportedError();
    };
    return (nativeContext, { channelCount: channelCount, channelCountMode: channelCountMode, pan: pan, ...audioNodeOptions })=>{
        if (channelCountMode === 'max') throw createNotSupportedError();
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: 1,
            channelCountMode: channelCountMode,
            numberOfInputs: 2
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: channelCount,
            channelCountMode: channelCountMode,
            gain: 1
        });
        const panGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: pan
        });
        let { connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode);
        Object.defineProperty(panGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(panGainNode.gain, 'maxValue', {
            get: ()=>1
        });
        Object.defineProperty(panGainNode.gain, 'minValue', {
            get: ()=>-1
        });
        const nativeStereoPannerNodeFakerFactory = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return inputGainNode.channelCount;
            },
            set channelCount (value){
                if (inputGainNode.channelCount !== value) {
                    if (isConnected) disconnectGraph();
                    ({ connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, value, inputGainNode, panGainNode, channelMergerNode));
                    if (isConnected) connectGraph();
                }
                inputGainNode.channelCount = value;
            },
            get channelCountMode () {
                return inputGainNode.channelCountMode;
            },
            set channelCountMode (value){
                if (value === 'clamped-max' || value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return inputGainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
            },
            get context () {
                return inputGainNode.context;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return inputGainNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return inputGainNode.numberOfOutputs;
            },
            get pan () {
                return panGainNode.gain;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        let isConnected = false;
        const whenConnected = ()=>{
            connectGraph();
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            disconnectGraph();
            isConnected = false;
        };
        return monitorConnections((0, $jVGFG.interceptConnections)(nativeStereoPannerNodeFakerFactory, channelMergerNode), whenConnected, whenDisconnected);
    };
};

});

parcelRegister("avKWH", function(module, exports) {

$parcel$export(module.exports, "createNativeWaveShaperNodeFactory", () => $7a71371b099424c7$export$75168c4c8ce320c4);

var $kC0ys = parcelRequire("kC0ys");

var $fb5On = parcelRequire("fb5On");
const $7a71371b099424c7$export$75168c4c8ce320c4 = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeWaveShaperNodeFaker, isDCCurve, monitorConnections, nativeAudioContextConstructor, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeWaveShaperNode = nativeContext.createWaveShaper();
        /*
         * Bug #119: Safari does not correctly map the values.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here. Testing for the automationRate property is necessary because this workaround
         * isn't necessary anymore since v14.0.2 of Safari.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext' && nativeContext.createGain().gain.automationRate === undefined) return createNativeWaveShaperNodeFaker(nativeContext, options);
        (0, $fb5On.assignNativeAudioNodeOptions)(nativeWaveShaperNode, options);
        const curve = options.curve === null || options.curve instanceof Float32Array ? options.curve : new Float32Array(options.curve);
        // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
        if (curve !== null && curve.length < 2) throw createInvalidStateError();
        // Only values of type Float32Array can be assigned to the curve property.
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeWaveShaperNode, {
            curve: curve
        }, 'curve');
        (0, $kC0ys.assignNativeAudioNodeOption)(nativeWaveShaperNode, options, 'oversample');
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        overwriteAccessors(nativeWaveShaperNode, 'curve', (get)=>()=>get.call(nativeWaveShaperNode), (set)=>(value)=>{
                set.call(nativeWaveShaperNode, value);
                if (isConnected) {
                    if (isDCCurve(value) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
                    else if (!isDCCurve(value) && disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
                return value;
            });
        const whenConnected = ()=>{
            isConnected = true;
            if (isDCCurve(nativeWaveShaperNode.curve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
        };
        const whenDisconnected = ()=>{
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections(nativeWaveShaperNode, whenConnected, whenDisconnected);
    };
};

});

parcelRegister("aOLPL", function(module, exports) {

$parcel$export(module.exports, "createNativeWaveShaperNodeFakerFactory", () => $7e03adbbd6918c53$export$f5f0b26abc22907e);

var $fb5On = parcelRequire("fb5On");

var $jVGFG = parcelRequire("jVGFG");
const $7e03adbbd6918c53$export$f5f0b26abc22907e = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeGainNode, isDCCurve, monitorConnections)=>{
    return (nativeContext, { curve: curve, oversample: oversample, ...audioNodeOptions })=>{
        const negativeWaveShaperNode = nativeContext.createWaveShaper();
        const positiveWaveShaperNode = nativeContext.createWaveShaper();
        (0, $fb5On.assignNativeAudioNodeOptions)(negativeWaveShaperNode, audioNodeOptions);
        (0, $fb5On.assignNativeAudioNodeOptions)(positiveWaveShaperNode, audioNodeOptions);
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const invertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        const outputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const revertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        let unmodifiedCurve = null;
        const nativeWaveShaperNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return negativeWaveShaperNode.channelCount;
            },
            set channelCount (value){
                inputGainNode.channelCount = value;
                invertGainNode.channelCount = value;
                negativeWaveShaperNode.channelCount = value;
                outputGainNode.channelCount = value;
                positiveWaveShaperNode.channelCount = value;
                revertGainNode.channelCount = value;
            },
            get channelCountMode () {
                return negativeWaveShaperNode.channelCountMode;
            },
            set channelCountMode (value){
                inputGainNode.channelCountMode = value;
                invertGainNode.channelCountMode = value;
                negativeWaveShaperNode.channelCountMode = value;
                outputGainNode.channelCountMode = value;
                positiveWaveShaperNode.channelCountMode = value;
                revertGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return negativeWaveShaperNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                invertGainNode.channelInterpretation = value;
                negativeWaveShaperNode.channelInterpretation = value;
                outputGainNode.channelInterpretation = value;
                positiveWaveShaperNode.channelInterpretation = value;
                revertGainNode.channelInterpretation = value;
            },
            get context () {
                return negativeWaveShaperNode.context;
            },
            get curve () {
                return unmodifiedCurve;
            },
            set curve (value){
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                if (value !== null && value.length < 2) throw createInvalidStateError();
                if (value === null) {
                    negativeWaveShaperNode.curve = value;
                    positiveWaveShaperNode.curve = value;
                } else {
                    const curveLength = value.length;
                    const negativeCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    const positiveCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    negativeCurve[0] = value[0];
                    positiveCurve[0] = -value[curveLength - 1];
                    const length = Math.ceil((curveLength + 1) / 2);
                    const centerIndex = (curveLength + 1) / 2 - 1;
                    for(let i = 1; i < length; i += 1){
                        const theoreticIndex = i / length * centerIndex;
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        negativeCurve[i] = lowerIndex === upperIndex ? value[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * value[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * value[upperIndex];
                        positiveCurve[i] = lowerIndex === upperIndex ? -value[curveLength - 1 - lowerIndex] : -((1 - (theoreticIndex - lowerIndex)) * value[curveLength - 1 - lowerIndex]) - (1 - (upperIndex - theoreticIndex)) * value[curveLength - 1 - upperIndex];
                    }
                    negativeCurve[length] = curveLength % 2 === 1 ? value[length - 1] : (value[length - 2] + value[length - 1]) / 2;
                    negativeWaveShaperNode.curve = negativeCurve;
                    positiveWaveShaperNode.curve = positiveCurve;
                }
                unmodifiedCurve = value;
                if (isConnected) {
                    if (isDCCurve(unmodifiedCurve) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
                    else if (disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return negativeWaveShaperNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return negativeWaveShaperNode.numberOfOutputs;
            },
            get oversample () {
                return negativeWaveShaperNode.oversample;
            },
            set oversample (value){
                negativeWaveShaperNode.oversample = value;
                positiveWaveShaperNode.oversample = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (curve !== null) // Only values of type Float32Array can be assigned to the curve property.
        nativeWaveShaperNodeFaker.curve = curve instanceof Float32Array ? curve : new Float32Array(curve);
        if (oversample !== nativeWaveShaperNodeFaker.oversample) nativeWaveShaperNodeFaker.oversample = oversample;
        const whenConnected = ()=>{
            inputGainNode.connect(negativeWaveShaperNode).connect(outputGainNode);
            inputGainNode.connect(invertGainNode).connect(positiveWaveShaperNode).connect(revertGainNode).connect(outputGainNode);
            isConnected = true;
            if (isDCCurve(unmodifiedCurve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(negativeWaveShaperNode);
            negativeWaveShaperNode.disconnect(outputGainNode);
            inputGainNode.disconnect(invertGainNode);
            invertGainNode.disconnect(positiveWaveShaperNode);
            positiveWaveShaperNode.disconnect(revertGainNode);
            revertGainNode.disconnect(outputGainNode);
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections((0, $jVGFG.interceptConnections)(nativeWaveShaperNodeFaker, outputGainNode), whenConnected, whenDisconnected);
    };
};

});

parcelRegister("2Xpjk", function(module, exports) {

$parcel$export(module.exports, "createNotSupportedError", () => $2274b9a18e9fb227$export$dbebdb13622d486c);
const $2274b9a18e9fb227$export$dbebdb13622d486c = ()=>new DOMException('', 'NotSupportedError');

});

parcelRegister("1u2fI", function(module, exports) {

$parcel$export(module.exports, "createOfflineAudioContextConstructor", () => $114a5710f5f11074$export$a9b5caf52b398870);

var $kOlfI = parcelRequire("kOlfI");

var $7GhDt = parcelRequire("7GhDt");
const $114a5710f5f11074$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $114a5710f5f11074$export$a9b5caf52b398870 = (baseAudioContextConstructor, cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, startRendering)=>{
    return class OfflineAudioContext extends baseAudioContextConstructor {
        constructor(a, b, c){
            let options;
            if (typeof a === 'number' && b !== undefined && c !== undefined) options = {
                length: b,
                numberOfChannels: a,
                sampleRate: c
            };
            else if (typeof a === 'object') options = a;
            else throw new Error('The given parameters are not valid.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$114a5710f5f11074$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $7GhDt.testPromiseSupport), ()=>(0, $7GhDt.testPromiseSupport)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $kOlfI.deactivateAudioGraph)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};

});

parcelRegister("ch2aF", function(module, exports) {

$parcel$export(module.exports, "createOscillatorNodeConstructor", () => $8ef8c1b24d817605$export$c1c3584074b042b3);

var $8pz9Z = parcelRequire("8pz9Z");

var $hL1bO = parcelRequire("hL1bO");

var $jqEMr = parcelRequire("jqEMr");
const $8ef8c1b24d817605$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 440,
    periodicWave: undefined,
    type: 'sine'
};
const $8ef8c1b24d817605$export$c1c3584074b042b3 = (audioNodeConstructor, createAudioParam, createNativeOscillatorNode, createOscillatorNodeRenderer, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class OscillatorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$8ef8c1b24d817605$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
            const nyquist = context.sampleRate / 2;
            super(context, false, nativeOscillatorNode, oscillatorNodeRenderer);
            // Bug #81: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeOscillatorNode.detune, 153600, -153600);
            // Bug #76: Safari does not export the correct values for maxValue and minValue.
            this._frequency = createAudioParam(this, isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
            this._nativeOscillatorNode = nativeOscillatorNode;
            this._onended = null;
            this._oscillatorNodeRenderer = oscillatorNodeRenderer;
            if (this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeOscillatorNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeOscillatorNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get type() {
            return this._nativeOscillatorNode.type;
        }
        set type(value) {
            this._nativeOscillatorNode.type = value;
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = null;
        }
        setPeriodicWave(periodicWave) {
            this._nativeOscillatorNode.setPeriodicWave(periodicWave);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = periodicWave;
        }
        start(when = 0) {
            this._nativeOscillatorNode.start(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $hL1bO.setInternalStateToActive)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeOscillatorNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $8pz9Z.isActiveAudioNode)(this)) (0, $jqEMr.setInternalStateToPassive)(this);
                };
                this._nativeOscillatorNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeOscillatorNode.stop(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.stop = when;
        }
    };
};

});

parcelRegister("1KjDM", function(module, exports) {

$parcel$export(module.exports, "createOscillatorNodeRendererFactory", () => $1459529000d8fb01$export$99143538b3590be5);

var $37LPX = parcelRequire("37LPX");
const $1459529000d8fb01$export$99143538b3590be5 = (connectAudioParam, createNativeOscillatorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeOscillatorNodes = new WeakMap();
        let periodicWave = null;
        let start = null;
        let stop = null;
        const createOscillatorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeOscillatorNode = getNativeAudioNode(proxy);
            // If the initially used nativeOscillatorNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeOscillatorNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeOscillatorNode, nativeOfflineAudioContext);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeOscillatorNode.channelCount,
                    channelCountMode: nativeOscillatorNode.channelCountMode,
                    channelInterpretation: nativeOscillatorNode.channelInterpretation,
                    detune: nativeOscillatorNode.detune.value,
                    frequency: nativeOscillatorNode.frequency.value,
                    periodicWave: periodicWave === null ? undefined : periodicWave,
                    type: nativeOscillatorNode.type
                };
                nativeOscillatorNode = createNativeOscillatorNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeOscillatorNode.start(start);
                if (stop !== null) nativeOscillatorNode.stop(stop);
            }
            renderedNativeOscillatorNodes.set(nativeOfflineAudioContext, nativeOscillatorNode);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeOscillatorNode);
            return nativeOscillatorNode;
        };
        return {
            set periodicWave (value){
                periodicWave = value;
            },
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeOscillatorNode = renderedNativeOscillatorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeOscillatorNode !== undefined) return Promise.resolve(renderedNativeOscillatorNode);
                return createOscillatorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("fTCQm", function(module, exports) {

$parcel$export(module.exports, "createPannerNodeConstructor", () => $b92a1f96ee2d0c8e$export$91b046021cf98bac);

var $lQo9t = parcelRequire("lQo9t");
const $b92a1f96ee2d0c8e$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    coneInnerAngle: 360,
    coneOuterAngle: 360,
    coneOuterGain: 0,
    distanceModel: 'inverse',
    maxDistance: 10000,
    orientationX: 1,
    orientationY: 0,
    orientationZ: 0,
    panningModel: 'equalpower',
    positionX: 0,
    positionY: 0,
    positionZ: 0,
    refDistance: 1,
    rolloffFactor: 1
};
const $b92a1f96ee2d0c8e$export$91b046021cf98bac = (audioNodeConstructor, createAudioParam, createNativePannerNode, createPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class PannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$b92a1f96ee2d0c8e$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativePannerNode = createNativePannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const pannerNodeRenderer = isOffline ? createPannerNodeRenderer() : null;
            super(context, false, nativePannerNode, pannerNodeRenderer);
            this._nativePannerNode = nativePannerNode;
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._orientationX = createAudioParam(this, isOffline, nativePannerNode.orientationX, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._orientationY = createAudioParam(this, isOffline, nativePannerNode.orientationY, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._orientationZ = createAudioParam(this, isOffline, nativePannerNode.orientationZ, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._positionX = createAudioParam(this, isOffline, nativePannerNode.positionX, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._positionY = createAudioParam(this, isOffline, nativePannerNode.positionY, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            this._positionZ = createAudioParam(this, isOffline, nativePannerNode.positionZ, (0, $lQo9t.MOST_POSITIVE_SINGLE_FLOAT), (0, $lQo9t.MOST_NEGATIVE_SINGLE_FLOAT));
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get coneInnerAngle() {
            return this._nativePannerNode.coneInnerAngle;
        }
        set coneInnerAngle(value) {
            this._nativePannerNode.coneInnerAngle = value;
        }
        get coneOuterAngle() {
            return this._nativePannerNode.coneOuterAngle;
        }
        set coneOuterAngle(value) {
            this._nativePannerNode.coneOuterAngle = value;
        }
        get coneOuterGain() {
            return this._nativePannerNode.coneOuterGain;
        }
        set coneOuterGain(value) {
            this._nativePannerNode.coneOuterGain = value;
        }
        get distanceModel() {
            return this._nativePannerNode.distanceModel;
        }
        set distanceModel(value) {
            this._nativePannerNode.distanceModel = value;
        }
        get maxDistance() {
            return this._nativePannerNode.maxDistance;
        }
        set maxDistance(value) {
            this._nativePannerNode.maxDistance = value;
        }
        get orientationX() {
            return this._orientationX;
        }
        get orientationY() {
            return this._orientationY;
        }
        get orientationZ() {
            return this._orientationZ;
        }
        get panningModel() {
            return this._nativePannerNode.panningModel;
        }
        set panningModel(value) {
            this._nativePannerNode.panningModel = value;
        }
        get positionX() {
            return this._positionX;
        }
        get positionY() {
            return this._positionY;
        }
        get positionZ() {
            return this._positionZ;
        }
        get refDistance() {
            return this._nativePannerNode.refDistance;
        }
        set refDistance(value) {
            this._nativePannerNode.refDistance = value;
        }
        get rolloffFactor() {
            return this._nativePannerNode.rolloffFactor;
        }
        set rolloffFactor(value) {
            this._nativePannerNode.rolloffFactor = value;
        }
    };
};

});

parcelRegister("1Jt2R", function(module, exports) {

$parcel$export(module.exports, "createPannerNodeRendererFactory", () => $1430862c372b762c$export$ccd091498494025);

var $eCSga = parcelRequire("eCSga");

var $37LPX = parcelRequire("37LPX");
const $1430862c372b762c$export$ccd091498494025 = (connectAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeGainNode, createNativePannerNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        let renderedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = null;
            let nativePannerNode = getNativeAudioNode(proxy);
            const commonAudioNodeOptions = {
                channelCount: nativePannerNode.channelCount,
                channelCountMode: nativePannerNode.channelCountMode,
                channelInterpretation: nativePannerNode.channelInterpretation
            };
            const commonNativePannerNodeOptions = {
                ...commonAudioNodeOptions,
                coneInnerAngle: nativePannerNode.coneInnerAngle,
                coneOuterAngle: nativePannerNode.coneOuterAngle,
                coneOuterGain: nativePannerNode.coneOuterGain,
                distanceModel: nativePannerNode.distanceModel,
                maxDistance: nativePannerNode.maxDistance,
                panningModel: nativePannerNode.panningModel,
                refDistance: nativePannerNode.refDistance,
                rolloffFactor: nativePannerNode.rolloffFactor
            };
            // If the initially used nativePannerNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativePannerNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativePannerNode, nativeOfflineAudioContext);
            // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
            if ('bufferSize' in nativePannerNode) nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                ...commonAudioNodeOptions,
                gain: 1
            });
            else if (!nativePannerNodeIsOwnedByContext) {
                const options = {
                    ...commonNativePannerNodeOptions,
                    orientationX: nativePannerNode.orientationX.value,
                    orientationY: nativePannerNode.orientationY.value,
                    orientationZ: nativePannerNode.orientationZ.value,
                    positionX: nativePannerNode.positionX.value,
                    positionY: nativePannerNode.positionY.value,
                    positionZ: nativePannerNode.positionZ.value
                };
                nativePannerNode = createNativePannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeGainNode === null ? nativePannerNode : nativeGainNode);
            if (nativeGainNode !== null) {
                if (renderedBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(6, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    const nativeChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                        channelCount: 1,
                        channelCountMode: 'explicit',
                        channelInterpretation: 'speakers',
                        numberOfInputs: 6
                    });
                    nativeChannelMergerNode.connect(partialOfflineAudioContext.destination);
                    renderedBufferPromise = (async ()=>{
                        const nativeConstantSourceNodes = await Promise.all([
                            proxy.orientationX,
                            proxy.orientationY,
                            proxy.orientationZ,
                            proxy.positionX,
                            proxy.positionY,
                            proxy.positionZ
                        ].map(async (audioParam, index)=>{
                            const nativeConstantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: index === 0 ? 1 : 0
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, nativeConstantSourceNode.offset);
                            return nativeConstantSourceNode;
                        }));
                        for(let i = 0; i < 6; i += 1){
                            nativeConstantSourceNodes[i].connect(nativeChannelMergerNode, 0, i);
                            nativeConstantSourceNodes[i].start(0);
                        }
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    })();
                }
                const renderedBuffer = await renderedBufferPromise;
                const inputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, inputGainNode);
                const channelDatas = [];
                for(let i = 0; i < renderedBuffer.numberOfChannels; i += 1)channelDatas.push(renderedBuffer.getChannelData(i));
                let lastOrientation = [
                    channelDatas[0][0],
                    channelDatas[1][0],
                    channelDatas[2][0]
                ];
                let lastPosition = [
                    channelDatas[3][0],
                    channelDatas[4][0],
                    channelDatas[5][0]
                ];
                let gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                let partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                    ...commonNativePannerNodeOptions,
                    orientationX: lastOrientation[0],
                    orientationY: lastOrientation[1],
                    orientationZ: lastOrientation[2],
                    positionX: lastPosition[0],
                    positionY: lastPosition[1],
                    positionZ: lastPosition[2]
                });
                inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                partialPannerNode.connect(nativeGainNode);
                for(let i = 128; i < renderedBuffer.length; i += 128){
                    const orientation = [
                        channelDatas[0][i],
                        channelDatas[1][i],
                        channelDatas[2][i]
                    ];
                    const positon = [
                        channelDatas[3][i],
                        channelDatas[4][i],
                        channelDatas[5][i]
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index]) || positon.some((value, index)=>value !== lastPosition[index])) {
                        lastOrientation = orientation;
                        lastPosition = positon;
                        const currentTime = i / nativeOfflineAudioContext.sampleRate;
                        gateGainNode.gain.setValueAtTime(0, currentTime);
                        gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                            ...commonAudioNodeOptions,
                            gain: 0
                        });
                        partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                            ...commonNativePannerNodeOptions,
                            orientationX: lastOrientation[0],
                            orientationY: lastOrientation[1],
                            orientationZ: lastOrientation[2],
                            positionX: lastPosition[0],
                            positionY: lastPosition[1],
                            positionZ: lastPosition[2]
                        });
                        gateGainNode.gain.setValueAtTime(1, currentTime);
                        inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                        partialPannerNode.connect(nativeGainNode);
                    }
                }
                return nativeGainNode;
            }
            if (!nativePannerNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            }
            if ((0, $eCSga.isNativeAudioNodeFaker)(nativePannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode);
            return nativePannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNodeOrNativePannerNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNodeOrNativePannerNode !== undefined) return Promise.resolve(renderedNativeGainNodeOrNativePannerNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("33XCT", function(module, exports) {

$parcel$export(module.exports, "createPeriodicWaveConstructor", () => $23afe77a20806fc5$export$10e47cfa48a5069d);
const $23afe77a20806fc5$var$DEFAULT_OPTIONS = {
    disableNormalization: false
};
const $23afe77a20806fc5$export$10e47cfa48a5069d = (createNativePeriodicWave, getNativeContext, periodicWaveStore, sanitizePeriodicWaveOptions)=>{
    return class PeriodicWave {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizePeriodicWaveOptions({
                ...$23afe77a20806fc5$var$DEFAULT_OPTIONS,
                ...options
            });
            const periodicWave = createNativePeriodicWave(nativeContext, mergedOptions);
            periodicWaveStore.add(periodicWave);
            // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
            return periodicWave;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === PeriodicWave.prototype || periodicWaveStore.has(instance);
        }
    };
};

});

parcelRegister("9v59y", function(module, exports) {

$parcel$export(module.exports, "createRenderAutomation", () => $6eab01995ea98811$export$889eef7d338963f6);
const $6eab01995ea98811$export$889eef7d338963f6 = (getAudioParamRenderer, renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        const audioParamRenderer = getAudioParamRenderer(audioParam);
        audioParamRenderer.replay(nativeAudioParam);
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};

});

parcelRegister("2yiIV", function(module, exports) {

$parcel$export(module.exports, "createRenderInputsOfAudioNode", () => $1dbd47dc3f829610$export$cff0938ddf51f6f4);
const $1dbd47dc3f829610$export$cff0938ddf51f6f4 = (getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle)=>{
    return async (audioNode, nativeOfflineAudioContext, nativeAudioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        await Promise.all(audioNodeConnections.activeInputs.map((connections, input)=>Array.from(connections).map(async ([source, output])=>{
                const audioNodeRenderer = getAudioNodeRenderer(source);
                const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
                const destination = audioNode.context.destination;
                if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) renderedNativeAudioNode.connect(nativeAudioNode, output, input);
            })).reduce((allRenderingPromises, renderingPromises)=>[
                ...allRenderingPromises,
                ...renderingPromises
            ], []));
    };
};

});

parcelRegister("a8EHb", function(module, exports) {

$parcel$export(module.exports, "createRenderInputsOfAudioParam", () => $761a380411013e67$export$82cd58acb1062198);
const $761a380411013e67$export$82cd58acb1062198 = (getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle)=>{
    return async (audioParam, nativeOfflineAudioContext, nativeAudioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        await Promise.all(Array.from(audioParamConnections.activeInputs).map(async ([source, output])=>{
            const audioNodeRenderer = getAudioNodeRenderer(source);
            const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
            if (!isPartOfACycle(source)) renderedNativeAudioNode.connect(nativeAudioParam, output);
        }));
    };
};

});

parcelRegister("6ykSy", function(module, exports) {

$parcel$export(module.exports, "createRenderNativeOfflineAudioContext", () => $4c561d287aa15bc1$export$feb8d4a8e403af48);

var $7GhDt = parcelRequire("7GhDt");
const $4c561d287aa15bc1$export$feb8d4a8e403af48 = (cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, testOfflineAudioContextCurrentTimeSupport)=>{
    return (nativeOfflineAudioContext)=>{
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult((0, $7GhDt.testPromiseSupport), ()=>(0, $7GhDt.testPromiseSupport)(nativeOfflineAudioContext))) // Bug #158: Chrome and Edge do not advance currentTime if it is not accessed while rendering the audio.
        return Promise.resolve(cacheTestResult(testOfflineAudioContextCurrentTimeSupport, testOfflineAudioContextCurrentTimeSupport)).then((isOfflineAudioContextCurrentTimeSupported)=>{
            if (!isOfflineAudioContextCurrentTimeSupported) {
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeOfflineAudioContext, 512, 0, 1);
                nativeOfflineAudioContext.oncomplete = ()=>{
                    scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                    scriptProcessorNode.disconnect();
                };
                scriptProcessorNode.onaudioprocess = ()=>nativeOfflineAudioContext.currentTime; // tslint:disable-line:deprecation
                scriptProcessorNode.connect(nativeOfflineAudioContext.destination);
            }
            return nativeOfflineAudioContext.startRendering();
        });
        return new Promise((resolve)=>{
            // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
            const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                gain: 0
            });
            nativeOfflineAudioContext.oncomplete = (event)=>{
                gainNode.disconnect();
                resolve(event.renderedBuffer);
            };
            gainNode.connect(nativeOfflineAudioContext.destination);
            nativeOfflineAudioContext.startRendering();
        });
    };
};

});

parcelRegister("jiZoz", function(module, exports) {

$parcel$export(module.exports, "createSetActiveAudioWorkletNodeInputs", () => $e0df529b2bc27718$export$17328c9508de4388);
const $e0df529b2bc27718$export$17328c9508de4388 = (activeAudioWorkletNodeInputsStore)=>{
    return (nativeAudioWorkletNode, activeInputs)=>{
        activeAudioWorkletNodeInputsStore.set(nativeAudioWorkletNode, activeInputs);
    };
};

});

parcelRegister("7n0kH", function(module, exports) {

$parcel$export(module.exports, "createSetAudioNodeTailTime", () => $55daf079da43b2d7$export$c5e78cc8035d00aa);
const $55daf079da43b2d7$export$c5e78cc8035d00aa = (audioNodeTailTimeStore)=>{
    return (audioNode, tailTime)=>audioNodeTailTimeStore.set(audioNode, tailTime);
};

});

parcelRegister("2qNtl", function(module, exports) {

$parcel$export(module.exports, "createStartRendering", () => $1c5462a9af9943f4$export$a04cd80dfb1b8309);

var $8Znor = parcelRequire("8Znor");
const $1c5462a9af9943f4$export$a04cd80dfb1b8309 = (audioBufferStore, cacheTestResult, getAudioNodeRenderer, getUnrenderedAudioWorkletNodes, renderNativeOfflineAudioContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (destination, nativeOfflineAudioContext)=>getAudioNodeRenderer(destination).render(destination, nativeOfflineAudioContext)/*
         * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to the
         * destination.
         */ .then(()=>Promise.all(Array.from(getUnrenderedAudioWorkletNodes(nativeOfflineAudioContext)).map((audioWorkletNode)=>getAudioNodeRenderer(audioWorkletNode).render(audioWorkletNode, nativeOfflineAudioContext)))).then(()=>renderNativeOfflineAudioContext(nativeOfflineAudioContext)).then((audioBuffer)=>{
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $8Znor.wrapAudioBufferGetChannelDataMethod)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
};

});

parcelRegister("23gcm", function(module, exports) {

$parcel$export(module.exports, "createStereoPannerNodeConstructor", () => $17e86d3cfefe6ef3$export$9b005b0c35721c84);
const $17e86d3cfefe6ef3$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    /*
     * Bug #105: The channelCountMode should be 'clamped-max' according to the spec but is set to 'explicit' to achieve consistent
     * behavior.
     */ channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    pan: 0
};
const $17e86d3cfefe6ef3$export$9b005b0c35721c84 = (audioNodeConstructor, createAudioParam, createNativeStereoPannerNode, createStereoPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext)=>{
    return class StereoPannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$17e86d3cfefe6ef3$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeStereoPannerNode = createNativeStereoPannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const stereoPannerNodeRenderer = isOffline ? createStereoPannerNodeRenderer() : null;
            super(context, false, nativeStereoPannerNode, stereoPannerNodeRenderer);
            this._pan = createAudioParam(this, isOffline, nativeStereoPannerNode.pan);
        }
        get pan() {
            return this._pan;
        }
    };
};

});

parcelRegister("5dA3Y", function(module, exports) {

$parcel$export(module.exports, "createStereoPannerNodeRendererFactory", () => $3cca2402dbf2ba5a$export$3ba9002bd6b539cf);

var $eCSga = parcelRequire("eCSga");

var $37LPX = parcelRequire("37LPX");
const $3cca2402dbf2ba5a$export$3ba9002bd6b539cf = (connectAudioParam, createNativeStereoPannerNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeStereoPannerNodes = new WeakMap();
        const createStereoPannerNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeStereoPannerNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeStereoPannerNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeStereoPannerNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeStereoPannerNode, nativeOfflineAudioContext);
            if (!nativeStereoPannerNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeStereoPannerNode.channelCount,
                    channelCountMode: nativeStereoPannerNode.channelCountMode,
                    channelInterpretation: nativeStereoPannerNode.channelInterpretation,
                    pan: nativeStereoPannerNode.pan.value
                };
                nativeStereoPannerNode = createNativeStereoPannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeStereoPannerNodes.set(nativeOfflineAudioContext, nativeStereoPannerNode);
            if (!nativeStereoPannerNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            if ((0, $eCSga.isNativeAudioNodeFaker)(nativeStereoPannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode);
            return nativeStereoPannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeStereoPannerNode = renderedNativeStereoPannerNodes.get(nativeOfflineAudioContext);
                if (renderedNativeStereoPannerNode !== undefined) return Promise.resolve(renderedNativeStereoPannerNode);
                return createStereoPannerNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("cGlbF", function(module, exports) {

$parcel$export(module.exports, "createTestAudioBufferConstructorSupport", () => $93b9d79b554e50a1$export$5bddcff46df9c642);
// Bug #33: Safari exposes an AudioBuffer but it can't be used as a constructor.
const $93b9d79b554e50a1$export$5bddcff46df9c642 = (nativeAudioBufferConstructor)=>{
    return ()=>{
        if (nativeAudioBufferConstructor === null) return false;
        try {
            new nativeAudioBufferConstructor({
                length: 1,
                sampleRate: 44100
            }); // tslint:disable-line:no-unused-expression
        } catch  {
            return false;
        }
        return true;
    };
};

});

parcelRegister("9Vu0K", function(module, exports) {

$parcel$export(module.exports, "createTestAudioBufferCopyChannelMethodsSubarraySupport", () => $73a0b77c2e5c72c2$export$1995b5466f5c2709);
/*
 * Firefox up to version 67 didn't fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those methods
 * is enough to know if the other one is supported as well.
 */ const $73a0b77c2e5c72c2$export$1995b5466f5c2709 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeAudioBuffer = nativeOfflineAudioContext.createBuffer(1, 1, 44100);
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        if (nativeAudioBuffer.copyToChannel === undefined) return true;
        const source = new Float32Array(2);
        try {
            nativeAudioBuffer.copyFromChannel(source, 0, 0);
        } catch  {
            return false;
        }
        return true;
    };
};

});

parcelRegister("dm3GZ", function(module, exports) {

$parcel$export(module.exports, "createTestAudioContextCloseMethodSupport", () => $9b9031a592d2d9b7$export$34981ee6aafdf532);
const $9b9031a592d2d9b7$export$34981ee6aafdf532 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        // Try to check the prototype before constructing the AudioContext.
        if (nativeAudioContextConstructor.prototype !== undefined && nativeAudioContextConstructor.prototype.close !== undefined) return true;
        const audioContext = new nativeAudioContextConstructor();
        const isAudioContextClosable = audioContext.close !== undefined;
        try {
            audioContext.close();
        } catch  {
        // Ignore errors.
        }
        return isAudioContextClosable;
    };
};

});

parcelRegister("boP90", function(module, exports) {

$parcel$export(module.exports, "createTestAudioContextDecodeAudioDataMethodTypeErrorSupport", () => $84c99bcc05cda1e3$export$622ba23aa6b35822);
/**
 * Edge up to version 14, Firefox up to version 52, Safari up to version 9 and maybe other browsers
 * did not refuse to decode invalid parameters with a TypeError.
 */ const $84c99bcc05cda1e3$export$622ba23aa6b35822 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            let isPending = true;
            const resolvePromise = (err)=>{
                if (isPending) {
                    isPending = false;
                    offlineAudioContext.startRendering();
                    resolve(err instanceof TypeError);
                }
            };
            let promise;
            // Bug #26: Safari throws a synchronous error.
            try {
                promise = offlineAudioContext// Bug #1: Safari requires a successCallback.
                .decodeAudioData(null, ()=>{
                // Ignore the success callback.
                }, resolvePromise);
            } catch (err) {
                resolvePromise(err);
            }
            // Bug #21: Safari does not support promises yet.
            if (promise !== undefined) // Bug #6: Chrome, Edge and Firefox do not call the errorCallback.
            promise.catch(resolvePromise);
        });
    };
};

});

parcelRegister("7R2vO", function(module, exports) {

$parcel$export(module.exports, "createTestAudioContextOptionsSupport", () => $5b7f6e7ca175acb7$export$2f44088abd2df2e);
const $5b7f6e7ca175acb7$export$2f44088abd2df2e = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        let audioContext;
        try {
            audioContext = new nativeAudioContextConstructor({
                latencyHint: 'balanced'
            });
        } catch  {
            return false;
        }
        audioContext.close();
        return true;
    };
};

});

parcelRegister("70Bin", function(module, exports) {

$parcel$export(module.exports, "createTestAudioNodeConnectMethodSupport", () => $51a576941a96c385$export$f77a3bce7e4efd81);
// Safari up to version 12.0 (but not v12.1) didn't return the destination in case it was an AudioNode.
const $51a576941a96c385$export$f77a3bce7e4efd81 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeGainNode = nativeOfflineAudioContext.createGain();
        const isSupported = nativeGainNode.connect(nativeGainNode) === nativeGainNode;
        nativeGainNode.disconnect(nativeGainNode);
        return isSupported;
    };
};

});

parcelRegister("gg7IJ", function(module, exports) {

$parcel$export(module.exports, "createTestAudioWorkletProcessorNoOutputsSupport", () => $bd6421180b65cf0c$export$ce5ba80a98dc0ba7);
/**
 * Chrome version 66 and 67 did not call the process() function of an AudioWorkletProcessor if it had no outputs. AudioWorklet support was
 * enabled by default in version 66.
 */ const $bd6421180b65cf0c$export$ce5ba80a98dc0ba7 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        const messageChannel = new MessageChannel();
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isCallingProcess = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            await new Promise((resolve)=>{
                audioWorkletNode.port.onmessage = ()=>resolve();
                audioWorkletNode.port.postMessage(messageChannel.port2, [
                    messageChannel.port2
                ]);
            });
            audioWorkletNode.port.onmessage = ()=>isCallingProcess = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            isCallingProcess = await new Promise((resolve)=>{
                messageChannel.port1.onmessage = ({ data: data })=>resolve(data === 1);
                messageChannel.port1.postMessage(0);
            });
        } catch  {
        // Ignore errors.
        } finally{
            messageChannel.port1.close();
            URL.revokeObjectURL(url);
        }
        return isCallingProcess;
    };
};

});

parcelRegister("7vJJE", function(module, exports) {

$parcel$export(module.exports, "createTestAudioWorkletProcessorPostMessageSupport", () => $577ee7bc7301d671$export$19b2cf184a7cfba8);
// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
const $577ee7bc7301d671$export$19b2cf184a7cfba8 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isEmittingMessageEvents = false;
        let isEmittingProcessorErrorEvents = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            audioWorkletNode.port.onmessage = ()=>isEmittingMessageEvents = true;
            audioWorkletNode.onprocessorerror = ()=>isEmittingProcessorErrorEvents = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            // Bug #197: Safari does not deliver the messages before the promise returned by startRendering() resolves.
            await new Promise((resolve)=>setTimeout(resolve));
        } catch  {
        // Ignore errors.
        } finally{
            URL.revokeObjectURL(url);
        }
        return isEmittingMessageEvents && !isEmittingProcessorErrorEvents;
    };
};

});

parcelRegister("kLLxn", function(module, exports) {

$parcel$export(module.exports, "createTestChannelMergerNodeChannelCountSupport", () => $f1ed1257046221c8$export$a04037cfe0b977fa);
/**
 * Firefox up to version 69 did not throw an error when setting a different channelCount or channelCountMode.
 */ const $f1ed1257046221c8$export$a04037cfe0b977fa = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeChannelMergerNode = offlineAudioContext.createChannelMerger();
        /**
         * Bug #15: Safari does not return the default properties. It still needs to be patched. This test is supposed to test the support
         * in other browsers.
         */ if (nativeChannelMergerNode.channelCountMode === 'max') return true;
        try {
            nativeChannelMergerNode.channelCount = 2;
        } catch  {
            return true;
        }
        return false;
    };
};

});

parcelRegister("cAjwK", function(module, exports) {

$parcel$export(module.exports, "createTestConstantSourceNodeAccurateSchedulingSupport", () => $9297fe825b49561a$export$63ae3ec177f0ed66);
const $9297fe825b49561a$export$63ae3ec177f0ed66 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return true;
        const nativeConstantSourceNode = nativeOfflineAudioContext.createConstantSource();
        /*
         * @todo This is using bug #75 to detect bug #70. That works because both bugs were unique to
         * the implementation of Firefox right now, but it could probably be done in a better way.
         */ return nativeConstantSourceNode.offset.maxValue !== Number.POSITIVE_INFINITY;
    };
};

});

parcelRegister("emUIu", function(module, exports) {

$parcel$export(module.exports, "createTestConvolverNodeBufferReassignabilitySupport", () => $a75f1d7a6d85a84d$export$b6f3c4027f959b95);
// Opera up to version 57 did not allow to reassign the buffer of a ConvolverNode.
const $a75f1d7a6d85a84d$export$b6f3c4027f959b95 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        try {
            nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        } catch  {
            return false;
        }
        return true;
    };
};

});

parcelRegister("71zf0", function(module, exports) {

$parcel$export(module.exports, "createTestConvolverNodeChannelCountSupport", () => $51d3f686666dd540$export$d1bddb88e5c21d26);
// Chrome up to version v80, Edge up to version v80 and Opera up to version v67 did not allow to set the channelCount property of a ConvolverNode to 1. They also did not allow to set the channelCountMode to 'explicit'.
const $51d3f686666dd540$export$d1bddb88e5c21d26 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        try {
            nativeConvolverNode.channelCount = 1;
        } catch  {
            return false;
        }
        return true;
    };
};

});

parcelRegister("bCo2C", function(module, exports) {

$parcel$export(module.exports, "createTestIsSecureContextSupport", () => $8755e469bf0df565$export$41669e689e17d4f0);
const $8755e469bf0df565$export$41669e689e17d4f0 = (window)=>{
    return ()=>window !== null && window.hasOwnProperty('isSecureContext');
};

});

parcelRegister("gtvtQ", function(module, exports) {

$parcel$export(module.exports, "createTestMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport", () => $bfe7c61e71e94074$export$416bb3b14425e126);
// Firefox up to version 68 did not throw an error when creating a MediaStreamAudioSourceNode with a mediaStream that had no audio track.
const $bfe7c61e71e94074$export$416bb3b14425e126 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        const audioContext = new nativeAudioContextConstructor();
        try {
            audioContext.createMediaStreamSource(new MediaStream());
            return false;
        } catch (err) {
            return true;
        } finally{
            audioContext.close();
        }
    };
};

});

parcelRegister("7CCTQ", function(module, exports) {

$parcel$export(module.exports, "createTestOfflineAudioContextCurrentTimeSupport", () => $58ca41aa04290b3a$export$6db7e9dd49157213);
const $58ca41aa04290b3a$export$6db7e9dd49157213 = (createNativeGainNode, nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
        const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            nativeOfflineAudioContext.oncomplete = ()=>{
                gainNode.disconnect();
                resolve(nativeOfflineAudioContext.currentTime !== 0);
            };
            nativeOfflineAudioContext.startRendering();
        });
    };
};

});

parcelRegister("hqy8F", function(module, exports) {

$parcel$export(module.exports, "createTestStereoPannerNodeDefaultValueSupport", () => $caff58a2942665d2$export$5ea70af76c7a03fc);
/**
 * Firefox up to version 62 did not kick off the processing of the StereoPannerNode if the value of pan was zero.
 */ const $caff58a2942665d2$export$5ea70af76c7a03fc = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        /*
         * Bug #105: Safari does not support the StereoPannerNode. Therefore the returned value should normally be false but the faker does
         * support the tested behaviour.
         */ if (nativeOfflineAudioContext.createStereoPanner === undefined) return Promise.resolve(true);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return Promise.resolve(true);
        const constantSourceNode = nativeOfflineAudioContext.createConstantSource();
        const stereoPanner = nativeOfflineAudioContext.createStereoPanner();
        constantSourceNode.channelCount = 1;
        constantSourceNode.offset.value = 1;
        stereoPanner.channelCount = 1;
        constantSourceNode.start();
        constantSourceNode.connect(stereoPanner).connect(nativeOfflineAudioContext.destination);
        return nativeOfflineAudioContext.startRendering().then((buffer)=>buffer.getChannelData(0)[0] !== 1);
    };
};

});

parcelRegister("bw7LY", function(module, exports) {

$parcel$export(module.exports, "createUnknownError", () => $8628b6607066dea1$export$988fb803bae63f80);
const $8628b6607066dea1$export$988fb803bae63f80 = ()=>new DOMException('', 'UnknownError');

});

parcelRegister("l4IjU", function(module, exports) {

$parcel$export(module.exports, "createWaveShaperNodeConstructor", () => $f57c59bc55113041$export$3a30e911e17b1cf5);
const $f57c59bc55113041$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    curve: null,
    oversample: 'none'
};
const $f57c59bc55113041$export$3a30e911e17b1cf5 = (audioNodeConstructor, createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class WaveShaperNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$f57c59bc55113041$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null;
            // @todo Add a mechanism to only switch a WaveShaperNode to active while it is connected.
            super(context, true, nativeWaveShaperNode, waveShaperNodeRenderer);
            this._isCurveNullified = false;
            this._nativeWaveShaperNode = nativeWaveShaperNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get curve() {
            if (this._isCurveNullified) return null;
            return this._nativeWaveShaperNode.curve;
        }
        set curve(value) {
            // Bug #103: Safari does not allow to set the curve to null.
            if (value === null) {
                this._isCurveNullified = true;
                this._nativeWaveShaperNode.curve = new Float32Array([
                    0,
                    0
                ]);
            } else {
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
                if (value.length < 2) throw createInvalidStateError();
                this._isCurveNullified = false;
                this._nativeWaveShaperNode.curve = value;
            }
        }
        get oversample() {
            return this._nativeWaveShaperNode.oversample;
        }
        set oversample(value) {
            this._nativeWaveShaperNode.oversample = value;
        }
    };
};

});

parcelRegister("5jZnB", function(module, exports) {

$parcel$export(module.exports, "createWaveShaperNodeRendererFactory", () => $3dfe56cdc1b202d2$export$9709a48a5037d121);

var $eCSga = parcelRequire("eCSga");

var $37LPX = parcelRequire("37LPX");
const $3dfe56cdc1b202d2$export$9709a48a5037d121 = (createNativeWaveShaperNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeWaveShaperNodes = new WeakMap();
        const createWaveShaperNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeWaveShaperNode = getNativeAudioNode(proxy);
            // If the initially used nativeWaveShaperNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeWaveShaperNodeIsOwnedByContext = (0, $37LPX.isOwnedByContext)(nativeWaveShaperNode, nativeOfflineAudioContext);
            if (!nativeWaveShaperNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeWaveShaperNode.channelCount,
                    channelCountMode: nativeWaveShaperNode.channelCountMode,
                    channelInterpretation: nativeWaveShaperNode.channelInterpretation,
                    curve: nativeWaveShaperNode.curve,
                    oversample: nativeWaveShaperNode.oversample
                };
                nativeWaveShaperNode = createNativeWaveShaperNode(nativeOfflineAudioContext, options);
            }
            renderedNativeWaveShaperNodes.set(nativeOfflineAudioContext, nativeWaveShaperNode);
            if ((0, $eCSga.isNativeAudioNodeFaker)(nativeWaveShaperNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode);
            return nativeWaveShaperNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeWaveShaperNode = renderedNativeWaveShaperNodes.get(nativeOfflineAudioContext);
                if (renderedNativeWaveShaperNode !== undefined) return Promise.resolve(renderedNativeWaveShaperNode);
                return createWaveShaperNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};

});

parcelRegister("8zCWh", function(module, exports) {

$parcel$export(module.exports, "createWindow", () => $63dfcc1a166d18c6$export$ba255020126e276e);
const $63dfcc1a166d18c6$export$ba255020126e276e = ()=>typeof window === 'undefined' ? null : window;

});

parcelRegister("ht7NN", function(module, exports) {

$parcel$export(module.exports, "createWrapAudioBufferCopyChannelMethods", () => $cb7b3273f5831b36$export$dbf1ce6ba2b4bc6a);
const $cb7b3273f5831b36$export$dbf1ce6ba2b4bc6a = (convertNumberToUnsignedLong, createIndexSizeError)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const destinationLength = destination.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < destinationLength; i += 1)destination[i] = channelData[i + bufferOffset];
        };
        audioBuffer.copyToChannel = (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const sourceLength = source.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < sourceLength; i += 1)channelData[i + bufferOffset] = source[i];
        };
    };
};

});

parcelRegister("7joNS", function(module, exports) {

$parcel$export(module.exports, "createWrapAudioBufferCopyChannelMethodsOutOfBounds", () => $552d8c37c2a3db0b$export$bff9a41e76b37a6e);
const $552d8c37c2a3db0b$export$bff9a41e76b37a6e = (convertNumberToUnsignedLong)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = ((copyFromChannel)=>{
            return (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyFromChannel.call(audioBuffer, destination, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyFromChannel);
        audioBuffer.copyToChannel = ((copyToChannel)=>{
            return (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyToChannel.call(audioBuffer, source, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyToChannel);
    };
};

});

parcelRegister("64Vwm", function(module, exports) {

$parcel$export(module.exports, "createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer", () => $46cfbc4113cd3ae4$export$3c1722ed0f0ed532);
const $46cfbc4113cd3ae4$export$3c1722ed0f0ed532 = (overwriteAccessors)=>{
    return (nativeAudioBufferSourceNode, nativeContext)=>{
        const nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);
        if (nativeAudioBufferSourceNode.buffer === null) nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
        overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', (get)=>()=>{
                const value = get.call(nativeAudioBufferSourceNode);
                return value === nullifiedBuffer ? null : value;
            }, (set)=>(value)=>{
                return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
            });
    };
};

});

parcelRegister("1ieU6", function(module, exports) {

$parcel$export(module.exports, "createWrapChannelMergerNode", () => $0f13087d7ff0faed$export$162785cfa8a63221);
const $0f13087d7ff0faed$export$162785cfa8a63221 = (createInvalidStateError, monitorConnections)=>{
    return (nativeContext, channelMergerNode)=>{
        // Bug #15: Safari does not return the default properties.
        channelMergerNode.channelCount = 1;
        channelMergerNode.channelCountMode = 'explicit';
        // Bug #16: Safari does not throw an error when setting a different channelCount or channelCountMode.
        Object.defineProperty(channelMergerNode, 'channelCount', {
            get: ()=>1,
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        Object.defineProperty(channelMergerNode, 'channelCountMode', {
            get: ()=>'explicit',
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
        const audioBufferSourceNode = nativeContext.createBufferSource();
        const whenConnected = ()=>{
            const length = channelMergerNode.numberOfInputs;
            for(let i = 0; i < length; i += 1)audioBufferSourceNode.connect(channelMergerNode, 0, i);
        };
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(channelMergerNode);
        monitorConnections(channelMergerNode, whenConnected, whenDisconnected);
    };
};

});

parcelRegister("bvS5t", function(module, exports) {

$parcel$export(module.exports, "getFirstSample", () => $861c8b949312ec8e$export$4ec0c13c358eb2b5);
const $861c8b949312ec8e$export$4ec0c13c358eb2b5 = (audioBuffer, buffer, channelNumber)=>{
    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
    if (audioBuffer.copyFromChannel === undefined) return audioBuffer.getChannelData(channelNumber)[0];
    audioBuffer.copyFromChannel(buffer, channelNumber);
    return buffer[0];
};

});

parcelRegister("1Lq6V", function(module, exports) {

$parcel$export(module.exports, "isDCCurve", () => $148e6f4828b12768$export$b32eba1f356dc699);
const $148e6f4828b12768$export$b32eba1f356dc699 = (curve)=>{
    if (curve === null) return false;
    const length = curve.length;
    if (length % 2 !== 0) return curve[Math.floor(length / 2)] !== 0;
    return curve[length / 2 - 1] + curve[length / 2] !== 0;
};

});

parcelRegister("gBkDC", function(module, exports) {

$parcel$export(module.exports, "overwriteAccessors", () => $c1601c567660a994$export$f25ed0e1b53c5d37);
const $c1601c567660a994$export$f25ed0e1b53c5d37 = (object, property, createGetter, createSetter)=>{
    let prototype = object;
    while(!prototype.hasOwnProperty(property))prototype = Object.getPrototypeOf(prototype);
    const { get: get, set: set } = Object.getOwnPropertyDescriptor(prototype, property);
    Object.defineProperty(object, property, {
        get: createGetter(get),
        set: createSetter(set)
    });
};

});

parcelRegister("M07bQ", function(module, exports) {

$parcel$export(module.exports, "sanitizeAudioWorkletNodeOptions", () => $090492a3e3c13d97$export$9a47aefcb4b02450);
const $090492a3e3c13d97$export$9a47aefcb4b02450 = (options)=>{
    return {
        ...options,
        outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ? /*
                   * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
                   * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
                   * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
                   */ [
            options.channelCount
        ] : Array.from({
            length: options.numberOfOutputs
        }, ()=>1)
    };
};

});

parcelRegister("dFPCW", function(module, exports) {

$parcel$export(module.exports, "sanitizeChannelSplitterOptions", () => $9f4726bfebdec920$export$6edb0bde597f2c9a);
const $9f4726bfebdec920$export$6edb0bde597f2c9a = (options)=>{
    return {
        ...options,
        channelCount: options.numberOfOutputs
    };
};

});

parcelRegister("jWIYf", function(module, exports) {

$parcel$export(module.exports, "sanitizePeriodicWaveOptions", () => $e85651600bf72bc4$export$833c872c8eda5015);
const $e85651600bf72bc4$export$833c872c8eda5015 = (options)=>{
    const { imag: imag, real: real } = options;
    if (imag === undefined) {
        if (real === undefined) return {
            ...options,
            imag: [
                0,
                0
            ],
            real: [
                0,
                0
            ]
        };
        return {
            ...options,
            imag: Array.from(real, ()=>0),
            real: real
        };
    }
    if (real === undefined) return {
        ...options,
        imag: imag,
        real: Array.from(imag, ()=>0)
    };
    return {
        ...options,
        imag: imag,
        real: real
    };
};

});

parcelRegister("dl7Fu", function(module, exports) {

$parcel$export(module.exports, "setValueAtTimeUntilPossible", () => $9b632f4003c8502a$export$652ab3e522965552);
const $9b632f4003c8502a$export$652ab3e522965552 = (audioParam, value, startTime)=>{
    try {
        audioParam.setValueAtTime(value, startTime);
    } catch (err) {
        if (err.code !== 9) throw err;
        $9b632f4003c8502a$export$652ab3e522965552(audioParam, value, startTime + 1e-7);
    }
};

});

parcelRegister("7FbIt", function(module, exports) {

$parcel$export(module.exports, "testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport", () => $5945735ede0e18d0$export$3211ed65c5b8326b);
const $5945735ede0e18d0$export$3211ed65c5b8326b = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.start();
    } catch  {
        return true;
    }
    return false;
};

});

parcelRegister("6as03", function(module, exports) {

$parcel$export(module.exports, "testAudioBufferSourceNodeStartMethodOffsetClampingSupport", () => $47d96573f1aa53c5$export$74929efb99360b7a);
const $47d96573f1aa53c5$export$74929efb99360b7a = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    try {
        nativeAudioBufferSourceNode.start(0, 1);
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("fPjha", function(module, exports) {

$parcel$export(module.exports, "testAudioBufferSourceNodeStopMethodNullifiedBufferSupport", () => $b85a923979896fa8$export$c29f4eec5460fc70);
const $b85a923979896fa8$export$c29f4eec5460fc70 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.stop();
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("lR5Oy", function(module, exports) {

$parcel$export(module.exports, "testAudioScheduledSourceNodeStartMethodNegativeParametersSupport", () => $fe930ed59422b7ab$export$9be334adb9176c59);
const $fe930ed59422b7ab$export$9be334adb9176c59 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.start(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};

});

parcelRegister("aDnGz", function(module, exports) {

$parcel$export(module.exports, "testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport", () => $7bdfeb5b7522184d$export$a7f1019c14a08879);
const $7bdfeb5b7522184d$export$a7f1019c14a08879 = (nativeContext)=>{
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.start();
    nativeAudioBufferSourceNode.stop();
    try {
        nativeAudioBufferSourceNode.stop();
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("lmHG7", function(module, exports) {

$parcel$export(module.exports, "testAudioScheduledSourceNodeStopMethodNegativeParametersSupport", () => $f8dd88a221bfda04$export$67a72517a9facc5);
const $f8dd88a221bfda04$export$67a72517a9facc5 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.stop(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};

});

parcelRegister("a2LmX", function(module, exports) {

$parcel$export(module.exports, "testAudioWorkletNodeOptionsClonability", () => $74fed5d4d848aa19$export$a40748749fc273c5);
const $74fed5d4d848aa19$export$a40748749fc273c5 = (audioWorkletNodeOptions)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
        port2.close();
    }
};

});

parcelRegister("fJusW", function(module, exports) {

$parcel$export(module.exports, "testDomExceptionConstructorSupport", () => $b742b0d686c85241$export$1310f0b96d9d8115);
/*
 * Bug #122: Edge up to version v18 did not allow to construct a DOMException'. It also had a couple more bugs but since this is easy to
 * test it's used here as a placeholder.
 *
 * Bug #27: Edge up to version v18 did reject an invalid arrayBuffer passed to decodeAudioData() with a DOMException.
 *
 * Bug #50: Edge up to version v18 did not allow to create AudioNodes on a closed context.
 *
 * Bug #57: Edge up to version v18 did not throw an error when assigning the type of an OscillatorNode to 'custom'.
 *
 * Bug #63: Edge up to version v18 did not expose the mediaElement property of a MediaElementAudioSourceNode.
 *
 * Bug #64: Edge up to version v18 did not support the MediaStreamAudioDestinationNode.
 *
 * Bug #71: Edge up to version v18 did not allow to set the buffer of an AudioBufferSourceNode to null.
 *
 * Bug #93: Edge up to version v18 did set the sampleRate of an AudioContext to zero when it was closed.
 *
 * Bug #101: Edge up to version v18 refused to execute decodeAudioData() on a closed context.
 *
 * Bug #106: Edge up to version v18 did not expose the maxValue and minValue properties of the pan AudioParam of a StereoPannerNode.
 *
 * Bug #110: Edge up to version v18 did not expose the maxValue and minValue properties of the attack, knee, ratio, release and threshold AudioParams of a DynamicsCompressorNode.
 *
 * Bug #123: Edge up to version v18 did not support HRTF as the panningModel for a PannerNode.
 *
 * Bug #145: Edge up to version v18 did throw an IndexSizeError when an OfflineAudioContext was created with a sampleRate of zero.
 *
 * Bug #161: Edge up to version v18 did not expose the maxValue and minValue properties of the delayTime AudioParam of a DelayNode.
 */ const $b742b0d686c85241$export$1310f0b96d9d8115 = ()=>{
    try {
        new DOMException(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("kE4Bl", function(module, exports) {

$parcel$export(module.exports, "testTransferablesSupport", () => $f07b1cc7a98c5c5a$export$4f6e0d4bb1ead9ce);
// Safari at version 11 did not support transferables.
const $f07b1cc7a98c5c5a$export$4f6e0d4bb1ead9ce = ()=>new Promise((resolve)=>{
        const arrayBuffer = new ArrayBuffer(0);
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>resolve(data !== null);
        port2.postMessage(arrayBuffer, [
            arrayBuffer
        ]);
    });

});

parcelRegister("4mEra", function(module, exports) {

$parcel$export(module.exports, "wrapAudioBufferSourceNodeStartMethodOffsetClamping", () => $32d89574b2cdf3d4$export$c3eb87c85305df2);
const $32d89574b2cdf3d4$export$c3eb87c85305df2 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            const buffer = nativeAudioBufferSourceNode.buffer;
            // Bug #154: Safari does not clamp the offset if it is equal to or greater than the duration of the buffer.
            const clampedOffset = buffer === null ? offset : Math.min(buffer.duration, offset);
            // Bug #155: Safari does not handle the offset correctly if it would cause the buffer to be not be played at all.
            if (buffer !== null && clampedOffset > buffer.duration - 0.5 / nativeAudioBufferSourceNode.context.sampleRate) start.call(nativeAudioBufferSourceNode, when, 0, 0);
            else start.call(nativeAudioBufferSourceNode, when, clampedOffset, duration);
        };
    })(nativeAudioBufferSourceNode.start);
};

});

parcelRegister("kMO8J", function(module, exports) {

$parcel$export(module.exports, "wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls", () => $f21f2f129b64bc61$export$587074127be31245);

var $jVGFG = parcelRequire("jVGFG");
const $f21f2f129b64bc61$export$587074127be31245 = (nativeAudioScheduledSourceNode, nativeContext)=>{
    const nativeGainNode = nativeContext.createGain();
    nativeAudioScheduledSourceNode.connect(nativeGainNode);
    const disconnectGainNode = ((disconnect)=>{
        return ()=>{
            // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
            disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnectGainNode);
        };
    })(nativeAudioScheduledSourceNode.disconnect);
    nativeAudioScheduledSourceNode.addEventListener('ended', disconnectGainNode);
    (0, $jVGFG.interceptConnections)(nativeAudioScheduledSourceNode, nativeGainNode);
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        let isStopped = false;
        return (when = 0)=>{
            if (isStopped) try {
                stop.call(nativeAudioScheduledSourceNode, when);
            } catch  {
                nativeGainNode.gain.setValueAtTime(0, when);
            }
            else {
                stop.call(nativeAudioScheduledSourceNode, when);
                isStopped = true;
            }
        };
    })(nativeAudioScheduledSourceNode.stop);
};

});

parcelRegister("4f1Kq", function(module, exports) {

$parcel$export(module.exports, "wrapEventListener", () => $3169eb39a2de8df8$export$63f14ca2e716ed28);
const $3169eb39a2de8df8$export$63f14ca2e716ed28 = (target, eventListener)=>{
    return (event)=>{
        const descriptor = {
            value: target
        };
        Object.defineProperties(event, {
            currentTarget: descriptor,
            target: descriptor
        });
        if (typeof eventListener === 'function') return eventListener.call(target, event);
        return eventListener.handleEvent.call(target, event);
    };
};

});

parcelRegister("i6mQe", function(module, exports) {
parcelRequire("e5lgf");
parcelRequire("aIVVS");
parcelRequire("jdFLj");
parcelRequire("hzFYM");
parcelRequire("doceu");
parcelRequire("aqC8W");
parcelRequire("W511l");
parcelRequire("3x6gE");
parcelRequire("2FJCu");
parcelRequire("98707");
parcelRequire("3AEpT");
parcelRequire("jQ4ck");
parcelRequire("aFfOu");
parcelRequire("aMlyu");
parcelRequire("4AafV");
parcelRequire("7D7mt");
parcelRequire("6oLuG");
parcelRequire("bKywQ");
parcelRequire("hKXQx");
parcelRequire("lMGZO");
parcelRequire("5xBog");
parcelRequire("9DR2E");
parcelRequire("8tfh2");
parcelRequire("43iDN");
parcelRequire("7tQw8");
parcelRequire("5VIW0");
parcelRequire("fhbTe");
parcelRequire("g6G8y");
parcelRequire("jmvR1");
parcelRequire("ar37N");
parcelRequire("eCHGO");
parcelRequire("iaaBv");
parcelRequire("fIXlR");
parcelRequire("e68Oa");
parcelRequire("6YKc8");
parcelRequire("3lR73");
parcelRequire("cmmoY");
parcelRequire("74L2q");
parcelRequire("2HuSE");
parcelRequire("fy3gW");
parcelRequire("64uks");
parcelRequire("6yPNk");
parcelRequire("4kWHk");
parcelRequire("btbe6");
parcelRequire("g84y8");
parcelRequire("iTwTd");
parcelRequire("g7P98");
parcelRequire("76xYH");
parcelRequire("9SoDb");
parcelRequire("e8RWm");
parcelRequire("5Ci80");
parcelRequire("iP1Ng");
parcelRequire("jIsoQ");
parcelRequire("iVX6V");
parcelRequire("1449w");
parcelRequire("6gmpw");
parcelRequire("98zLi");
parcelRequire("44iEc");
parcelRequire("1sKYH");
parcelRequire("9m5oX");
parcelRequire("3Qhie");
parcelRequire("jwFyQ");
parcelRequire("ebwyw");
parcelRequire("bAWd2");
parcelRequire("bBC4J");
parcelRequire("8x5TC");
parcelRequire("fxqmY");
parcelRequire("8sAMG");
parcelRequire("aK8zd");
parcelRequire("lrD08");
parcelRequire("2KVjS");
parcelRequire("6LFVn");
parcelRequire("hSEy9");
parcelRequire("9Og57");
parcelRequire("fEDJR");
parcelRequire("jekJ8");
parcelRequire("9VQC1");
parcelRequire("CrQRy");
parcelRequire("5er4m");
parcelRequire("4oTc1");
parcelRequire("1eanf");
parcelRequire("fT00d");
parcelRequire("3btt2");
parcelRequire("j8tDD");

});
parcelRegister("e5lgf", function(module, exports) {

});

parcelRegister("aIVVS", function(module, exports) {

});

parcelRegister("jdFLj", function(module, exports) {

});

parcelRegister("hzFYM", function(module, exports) {

});

parcelRegister("doceu", function(module, exports) {

});

parcelRegister("aqC8W", function(module, exports) {

});

parcelRegister("W511l", function(module, exports) {

});

parcelRegister("3x6gE", function(module, exports) {

});

parcelRegister("2FJCu", function(module, exports) {

});

parcelRegister("98707", function(module, exports) {

});

parcelRegister("3AEpT", function(module, exports) {

});

parcelRegister("jQ4ck", function(module, exports) {

});

parcelRegister("aFfOu", function(module, exports) {

});

parcelRegister("aMlyu", function(module, exports) {

});

parcelRegister("4AafV", function(module, exports) {

});

parcelRegister("7D7mt", function(module, exports) {

});

parcelRegister("6oLuG", function(module, exports) {

});

parcelRegister("bKywQ", function(module, exports) {

});

parcelRegister("hKXQx", function(module, exports) {

});

parcelRegister("lMGZO", function(module, exports) {

});

parcelRegister("5xBog", function(module, exports) {

});

parcelRegister("9DR2E", function(module, exports) {

});

parcelRegister("8tfh2", function(module, exports) {

});

parcelRegister("43iDN", function(module, exports) {

});

parcelRegister("7tQw8", function(module, exports) {

});

parcelRegister("5VIW0", function(module, exports) {

});

parcelRegister("fhbTe", function(module, exports) {

});

parcelRegister("g6G8y", function(module, exports) {

});

parcelRegister("jmvR1", function(module, exports) {

});

parcelRegister("ar37N", function(module, exports) {

});

parcelRegister("eCHGO", function(module, exports) {

});

parcelRegister("iaaBv", function(module, exports) {

});

parcelRegister("fIXlR", function(module, exports) {

});

parcelRegister("e68Oa", function(module, exports) {

});

parcelRegister("6YKc8", function(module, exports) {

});

parcelRegister("3lR73", function(module, exports) {

});

parcelRegister("cmmoY", function(module, exports) {

});

parcelRegister("74L2q", function(module, exports) {

});

parcelRegister("2HuSE", function(module, exports) {

});

parcelRegister("fy3gW", function(module, exports) {

});

parcelRegister("64uks", function(module, exports) {

});

parcelRegister("6yPNk", function(module, exports) {

});

parcelRegister("4kWHk", function(module, exports) {

});

parcelRegister("btbe6", function(module, exports) {

});

parcelRegister("g84y8", function(module, exports) {

});

parcelRegister("iTwTd", function(module, exports) {

});

parcelRegister("g7P98", function(module, exports) {

});

parcelRegister("76xYH", function(module, exports) {

});

parcelRegister("9SoDb", function(module, exports) {

});

parcelRegister("e8RWm", function(module, exports) {

});

parcelRegister("5Ci80", function(module, exports) {

});

parcelRegister("iP1Ng", function(module, exports) {

});

parcelRegister("jIsoQ", function(module, exports) {

});

parcelRegister("iVX6V", function(module, exports) {

});

parcelRegister("1449w", function(module, exports) {

});

parcelRegister("6gmpw", function(module, exports) {

});

parcelRegister("98zLi", function(module, exports) {

});

parcelRegister("44iEc", function(module, exports) {

});

parcelRegister("1sKYH", function(module, exports) {

});

parcelRegister("9m5oX", function(module, exports) {

});

parcelRegister("3Qhie", function(module, exports) {

});

parcelRegister("jwFyQ", function(module, exports) {

});

parcelRegister("ebwyw", function(module, exports) {

});

parcelRegister("bAWd2", function(module, exports) {

});

parcelRegister("bBC4J", function(module, exports) {

});

parcelRegister("8x5TC", function(module, exports) {

});

parcelRegister("fxqmY", function(module, exports) {

});

parcelRegister("8sAMG", function(module, exports) {

});

parcelRegister("aK8zd", function(module, exports) {

});

parcelRegister("lrD08", function(module, exports) {

});

parcelRegister("2KVjS", function(module, exports) {

});

parcelRegister("6LFVn", function(module, exports) {

});

parcelRegister("hSEy9", function(module, exports) {

});

parcelRegister("9Og57", function(module, exports) {

});

parcelRegister("fEDJR", function(module, exports) {

});

parcelRegister("jekJ8", function(module, exports) {

});

parcelRegister("9VQC1", function(module, exports) {

});

parcelRegister("CrQRy", function(module, exports) {

});

parcelRegister("5er4m", function(module, exports) {

});

parcelRegister("4oTc1", function(module, exports) {

});

parcelRegister("1eanf", function(module, exports) {

});

parcelRegister("fT00d", function(module, exports) {

});

parcelRegister("3btt2", function(module, exports) {

});

parcelRegister("j8tDD", function(module, exports) {
// @todo This is currently named IWorkletOptions and not IAudioWorkletOptions because it defines the options of a generic Worklet.

});


parcelRegister("eP9uV", function(module, exports) {
parcelRequire("jH2qS");
parcelRequire("9XZHX");
parcelRequire("bhhxH");
parcelRequire("cFqXt");
parcelRequire("5rA3c");
parcelRequire("99VuD");
parcelRequire("dVqOE");
parcelRequire("9psFk");
parcelRequire("gqKq5");
parcelRequire("iIKZ3");
parcelRequire("asCGt");
parcelRequire("9qNKY");
parcelRequire("3vaXm");
parcelRequire("9bsCt");
parcelRequire("g1i6v");
parcelRequire("4Dv11");
parcelRequire("92iax");
parcelRequire("bpiGJ");
parcelRequire("CV9RY");
parcelRequire("3RdqH");
parcelRequire("2zkxm");
parcelRequire("bqFe1");
parcelRequire("987DI");
parcelRequire("j6Li2");
parcelRequire("cRG5q");
parcelRequire("i5k4U");
parcelRequire("wUReS");
parcelRequire("buAfm");
parcelRequire("2FRH2");
parcelRequire("9bnNV");
parcelRequire("1M90i");
parcelRequire("2ukRQ");
parcelRequire("knEgF");
parcelRequire("68kYk");
parcelRequire("aNYFi");
parcelRequire("kVyQv");
parcelRequire("dqOhM");
parcelRequire("eJiXe");
parcelRequire("e7MB6");
parcelRequire("4uKvd");
parcelRequire("bNkT9");
parcelRequire("dpGyu");
parcelRequire("jcX27");
parcelRequire("flCt3");
parcelRequire("5pMtz");
parcelRequire("eJf4A");
parcelRequire("43C5l");
parcelRequire("i7tt4");
parcelRequire("auKg1");
parcelRequire("l3Exb");
parcelRequire("42IcB");
parcelRequire("ebAlG");
parcelRequire("49nHf");
parcelRequire("1mang");
parcelRequire("ad3UN");
parcelRequire("fV6vo");
parcelRequire("39qVL");
parcelRequire("68Lxi");
parcelRequire("hH1Lu");
parcelRequire("318Un");
parcelRequire("abL9J");
parcelRequire("l83we");
parcelRequire("8AVjZ");
parcelRequire("lgQ8r");
parcelRequire("beS38");
parcelRequire("hiwYw");
parcelRequire("hvR1K");
parcelRequire("83p58");
parcelRequire("aFpix");
parcelRequire("6uhOO");
parcelRequire("hgMut");
parcelRequire("8ZxIx");
parcelRequire("Ijcxs");
parcelRequire("2FlSP");
parcelRequire("ge2rx");
parcelRequire("3USPJ");
parcelRequire("5X7VW");
parcelRequire("7Y44j");
parcelRequire("1GKhf");
parcelRequire("agUKi");
parcelRequire("jlUH7");
parcelRequire("51KMF");
parcelRequire("5B1lT");
parcelRequire("a9UIV");
parcelRequire("4at4X");
parcelRequire("5OZzH");
parcelRequire("c6dGa");
parcelRequire("1MtGV");
parcelRequire("d4MW5");
parcelRequire("3gPbx");
parcelRequire("80I7Q");
parcelRequire("66YVP");
parcelRequire("b1Sux");
parcelRequire("3Q3Tc");
parcelRequire("qIySV");
parcelRequire("8f2g3");
parcelRequire("cJnTf");
parcelRequire("1a82q");
parcelRequire("c056I");
parcelRequire("fKg7b");
parcelRequire("gGBwf");
parcelRequire("ksGOz");
parcelRequire("jaIOd");
parcelRequire("3rndX");
parcelRequire("l9WV1");
parcelRequire("f3g8d");
parcelRequire("fswg2");
parcelRequire("7t1yP");
parcelRequire("eeIOd");
parcelRequire("aAikE");
parcelRequire("ftIXZ");
parcelRequire("keAqM");
parcelRequire("e0osb");
parcelRequire("kv9L8");
parcelRequire("4TR0a");
parcelRequire("6i0bJ");
parcelRequire("8xcIb");
parcelRequire("jIWFH");
parcelRequire("82ymc");
parcelRequire("2KtuS");
parcelRequire("1LB3S");
parcelRequire("b27UR");
parcelRequire("04JK6");
parcelRequire("i0AL4");
parcelRequire("g1DgE");
parcelRequire("8fw3Y");
parcelRequire("9Vexl");
parcelRequire("g9vqv");
parcelRequire("9dVPz");
parcelRequire("aCasH");
parcelRequire("jdzdC");
parcelRequire("aKHB0");
parcelRequire("lskog");
parcelRequire("bKlTh");
parcelRequire("64q98");
parcelRequire("hvVdX");
parcelRequire("6nMH6");
parcelRequire("9f1fQ");
parcelRequire("cSnNG");
parcelRequire("eCfhx");
parcelRequire("kBlc9");
parcelRequire("25tei");
parcelRequire("dryJV");
parcelRequire("5SNkP");
parcelRequire("6HaqY");
parcelRequire("9pAoQ");
parcelRequire("2FFy4");
parcelRequire("lAQAy");
parcelRequire("1BUk6");
parcelRequire("8M5n2");
parcelRequire("66zH2");
parcelRequire("cJmzv");
parcelRequire("4GCES");
parcelRequire("2QgHi");
parcelRequire("bck6u");
parcelRequire("kCgzp");
parcelRequire("44Elr");
parcelRequire("9nswf");
parcelRequire("6OoGg");
parcelRequire("6O8VE");
parcelRequire("hI19I");
parcelRequire("9Yzig");
parcelRequire("aJuAC");
parcelRequire("89aft");
parcelRequire("7DYx8");
parcelRequire("2JmFG");
parcelRequire("jEUu5");
parcelRequire("3mKdY");
parcelRequire("h7yXs");
parcelRequire("iisFm");
parcelRequire("2ulv2");
parcelRequire("7I6ip");
parcelRequire("iHQIx");
parcelRequire("fwEk4");
parcelRequire("3GYz8");
parcelRequire("37sxX");
parcelRequire("bzrNL");
parcelRequire("1Ilac");
parcelRequire("6Dqyf");
parcelRequire("f0jmu");
parcelRequire("3RlSy");
parcelRequire("jxw4p");
parcelRequire("iES0s");
parcelRequire("9JaEA");
parcelRequire("jw48e");
parcelRequire("3RTBV");
parcelRequire("8XgCp");
parcelRequire("iPYv5");
parcelRequire("5anXm");
parcelRequire("5IZr0");
parcelRequire("8zKU0");
parcelRequire("99jHf");
parcelRequire("gIZCx");
parcelRequire("axvDE");
parcelRequire("jrpks");
parcelRequire("TAvo6");
parcelRequire("82GNz");
parcelRequire("eUMLt");
parcelRequire("jTWwr");
parcelRequire("jdQAE");
parcelRequire("d3pbF");
parcelRequire("luHdw");
parcelRequire("avyrJ");
parcelRequire("kZBc7");
parcelRequire("aQbs0");
parcelRequire("7fLme");
parcelRequire("C4i8d");
parcelRequire("jNrq6");
parcelRequire("i5QtG");
parcelRequire("cOBo5");
parcelRequire("RM0pQ");
parcelRequire("7c0x5");
parcelRequire("5aeXS");
parcelRequire("k4j6h");
parcelRequire("bVEOD");
parcelRequire("eRl2b");
parcelRequire("ayNcb");
parcelRequire("7EmKr");
parcelRequire("jfjTW");
parcelRequire("dH8Rv");
parcelRequire("5DOHX");
parcelRequire("ebW9a");
parcelRequire("hBirc");
parcelRequire("b3jM7");
parcelRequire("gTpqe");
parcelRequire("57yRF");
parcelRequire("cD6k5");
parcelRequire("bTt3U");
parcelRequire("aSRMQ");
parcelRequire("clPWm");
parcelRequire("9Zy5Z");
parcelRequire("lcjKH");
parcelRequire("egjVt");
parcelRequire("jbWsj");
parcelRequire("dmkUJ");
parcelRequire("ee7nY");
parcelRequire("lcSIn");
parcelRequire("5wayl");
parcelRequire("ibQvU");
parcelRequire("kEN8k");
parcelRequire("kK203");
parcelRequire("ftcqV");
parcelRequire("gLKkZ");
parcelRequire("kyhSf");
parcelRequire("8J12v");
parcelRequire("7HOBW");
parcelRequire("cjKdF");
parcelRequire("7GfvB");
parcelRequire("alXu0");
parcelRequire("32p3D");
parcelRequire("aCj6Y");
parcelRequire("1kKxS");
parcelRequire("3ICKR");
parcelRequire("h1EnR");
parcelRequire("hPXXO");
parcelRequire("kuaZS");
parcelRequire("6ixbD");
parcelRequire("4w4YF");
parcelRequire("18kkp");
parcelRequire("cs2BU");
parcelRequire("jSCfu");
parcelRequire("1TPo7");
parcelRequire("fmHnY");
parcelRequire("km6sY");
parcelRequire("lsXlo");
parcelRequire("970QT");
parcelRequire("5maXH");
parcelRequire("8IziU");
parcelRequire("3oulg");
parcelRequire("2Ch6t");
parcelRequire("hED3H");
parcelRequire("4J2ot");
parcelRequire("lf28F");
parcelRequire("jR3Vb");
parcelRequire("3rhio");
parcelRequire("9q82l");
parcelRequire("eyTcb");
parcelRequire("kt9CP");
parcelRequire("qRI6O");
parcelRequire("lE5Fy");
parcelRequire("ji4mM");
parcelRequire("87wuj");
parcelRequire("5tSJR");
parcelRequire("8B6ZQ");
parcelRequire("8LLSD");
parcelRequire("5v5Vb");
parcelRequire("6WmI1");
parcelRequire("dShHY");
parcelRequire("hvEfG");
parcelRequire("5zt1a");
parcelRequire("8PkGn");
parcelRequire("9wNWO");
parcelRequire("1Ditc");
parcelRequire("6fb32");
parcelRequire("crCrY");
parcelRequire("eGCNt");
parcelRequire("p5heA");
parcelRequire("2W0w0");
parcelRequire("2Zezr");
parcelRequire("2FuoV");
parcelRequire("5pgpw");
parcelRequire("fgceC");
parcelRequire("eAvrq");
parcelRequire("cEMBU");
parcelRequire("8d8xx");
parcelRequire("9Fad1");
parcelRequire("5odIC");
parcelRequire("2L1h8");
parcelRequire("4y0OL");
parcelRequire("2kM2d");
parcelRequire("gOg8q");
parcelRequire("4OCs4");
parcelRequire("6b7nC");
parcelRequire("7QAkA");
parcelRequire("2z5lG");
parcelRequire("cgxJN");
parcelRequire("1Mtgi");
parcelRequire("3kD97");
parcelRequire("9kYLZ");
parcelRequire("59GMS");
parcelRequire("2DJqx");
parcelRequire("lDdBi");
parcelRequire("fm9LJ");
parcelRequire("6kV0e");
parcelRequire("dDDdX");
parcelRequire("dximP");
parcelRequire("epoM3");
parcelRequire("BUBrA");
parcelRequire("26sgD");
parcelRequire("gM5lR");
parcelRequire("hj8wC");
parcelRequire("irgAv");
parcelRequire("aHXB9");
parcelRequire("8P5BM");
parcelRequire("5YtwK");
parcelRequire("4NCzl");
parcelRequire("jC6Yh");
parcelRequire("1qYIs");
parcelRequire("ldipM");
parcelRequire("b61sd");
parcelRequire("4emCu");
parcelRequire("9yrk9");
parcelRequire("1VuSt");
parcelRequire("dokni");
parcelRequire("gLr5k");
parcelRequire("grxu9");
parcelRequire("1xHf4");
parcelRequire("iJsIY");
parcelRequire("dnHfq");
parcelRequire("3h3i4");
parcelRequire("luphg");
parcelRequire("gMGCJ");
parcelRequire("joINZ");
parcelRequire("emUqt");
parcelRequire("aotWh");
parcelRequire("fD8Ez");
parcelRequire("51T64");
parcelRequire("kOERj");
parcelRequire("7dfaN");
parcelRequire("55Qj0");
parcelRequire("ftaV5");
parcelRequire("g3FLT");
parcelRequire("jt9uO");
parcelRequire("d6t2j");
parcelRequire("71ghR");
parcelRequire("ggOuN");
parcelRequire("kddsc");
parcelRequire("fzR8D");
parcelRequire("11w5D");
parcelRequire("jeqlJ");
parcelRequire("i3eUQ");
parcelRequire("24C7e");
parcelRequire("aHqha");
parcelRequire("4E09e");
parcelRequire("8RTMp");
parcelRequire("9hXqr");
parcelRequire("503Eu");
parcelRequire("2AD2K");
parcelRequire("67v5z");
parcelRequire("5saok");
parcelRequire("9TEjt");
parcelRequire("83Ctb");
parcelRequire("a3AN5");
parcelRequire("buH7x");
parcelRequire("efM0S");
parcelRequire("3zruX");
parcelRequire("aVhpZ");
parcelRequire("kvpCZ");
parcelRequire("8wOWY");
parcelRequire("2DLzD");
parcelRequire("3sdtw");
parcelRequire("ahLsH");
parcelRequire("3E9VF");
parcelRequire("5j36M");
parcelRequire("dgmle");

});
parcelRegister("jH2qS", function(module, exports) {

});

parcelRegister("9XZHX", function(module, exports) {

});

parcelRegister("bhhxH", function(module, exports) {

});

parcelRegister("cFqXt", function(module, exports) {

});

parcelRegister("5rA3c", function(module, exports) {

});

parcelRegister("99VuD", function(module, exports) {

});

parcelRegister("dVqOE", function(module, exports) {

});

parcelRegister("9psFk", function(module, exports) {

});

parcelRegister("gqKq5", function(module, exports) {

});

parcelRegister("iIKZ3", function(module, exports) {

});

parcelRegister("asCGt", function(module, exports) {

});

parcelRegister("9qNKY", function(module, exports) {

});

parcelRegister("3vaXm", function(module, exports) {

});

parcelRegister("9bsCt", function(module, exports) {

});

parcelRegister("g1i6v", function(module, exports) {

});

parcelRegister("4Dv11", function(module, exports) {

});

parcelRegister("92iax", function(module, exports) {

});

parcelRegister("bpiGJ", function(module, exports) {

});

parcelRegister("CV9RY", function(module, exports) {

});

parcelRegister("3RdqH", function(module, exports) {

});

parcelRegister("2zkxm", function(module, exports) {

});

parcelRegister("bqFe1", function(module, exports) {

});

parcelRegister("987DI", function(module, exports) {

});

parcelRegister("j6Li2", function(module, exports) {

});

parcelRegister("cRG5q", function(module, exports) {

});

parcelRegister("i5k4U", function(module, exports) {

});

parcelRegister("wUReS", function(module, exports) {

});

parcelRegister("buAfm", function(module, exports) {

});

parcelRegister("2FRH2", function(module, exports) {

});

parcelRegister("9bnNV", function(module, exports) {

});

parcelRegister("1M90i", function(module, exports) {

});

parcelRegister("2ukRQ", function(module, exports) {

});

parcelRegister("knEgF", function(module, exports) {

});

parcelRegister("68kYk", function(module, exports) {

});

parcelRegister("aNYFi", function(module, exports) {

});

parcelRegister("kVyQv", function(module, exports) {

});

parcelRegister("dqOhM", function(module, exports) {

});

parcelRegister("eJiXe", function(module, exports) {

});

parcelRegister("e7MB6", function(module, exports) {

});

parcelRegister("4uKvd", function(module, exports) {

});

parcelRegister("bNkT9", function(module, exports) {

});

parcelRegister("dpGyu", function(module, exports) {

});

parcelRegister("jcX27", function(module, exports) {

});

parcelRegister("flCt3", function(module, exports) {

});

parcelRegister("5pMtz", function(module, exports) {

});

parcelRegister("eJf4A", function(module, exports) {

});

parcelRegister("43C5l", function(module, exports) {

});

parcelRegister("i7tt4", function(module, exports) {

});

parcelRegister("auKg1", function(module, exports) {

});

parcelRegister("l3Exb", function(module, exports) {

});

parcelRegister("42IcB", function(module, exports) {

});

parcelRegister("ebAlG", function(module, exports) {

});

parcelRegister("49nHf", function(module, exports) {

});

parcelRegister("1mang", function(module, exports) {

});

parcelRegister("ad3UN", function(module, exports) {

});

parcelRegister("fV6vo", function(module, exports) {

});

parcelRegister("39qVL", function(module, exports) {

});

parcelRegister("68Lxi", function(module, exports) {

});

parcelRegister("hH1Lu", function(module, exports) {

});

parcelRegister("318Un", function(module, exports) {

});

parcelRegister("abL9J", function(module, exports) {

});

parcelRegister("l83we", function(module, exports) {

});

parcelRegister("8AVjZ", function(module, exports) {

});

parcelRegister("lgQ8r", function(module, exports) {

});

parcelRegister("beS38", function(module, exports) {

});

parcelRegister("hiwYw", function(module, exports) {

});

parcelRegister("hvR1K", function(module, exports) {

});

parcelRegister("83p58", function(module, exports) {

});

parcelRegister("aFpix", function(module, exports) {

});

parcelRegister("6uhOO", function(module, exports) {

});

parcelRegister("hgMut", function(module, exports) {

});

parcelRegister("8ZxIx", function(module, exports) {

});

parcelRegister("Ijcxs", function(module, exports) {

});

parcelRegister("2FlSP", function(module, exports) {

});

parcelRegister("ge2rx", function(module, exports) {

});

parcelRegister("3USPJ", function(module, exports) {

});

parcelRegister("5X7VW", function(module, exports) {

});

parcelRegister("7Y44j", function(module, exports) {

});

parcelRegister("1GKhf", function(module, exports) {

});

parcelRegister("agUKi", function(module, exports) {

});

parcelRegister("jlUH7", function(module, exports) {

});

parcelRegister("51KMF", function(module, exports) {

});

parcelRegister("5B1lT", function(module, exports) {

});

parcelRegister("a9UIV", function(module, exports) {

});

parcelRegister("4at4X", function(module, exports) {

});

parcelRegister("5OZzH", function(module, exports) {

});

parcelRegister("c6dGa", function(module, exports) {

});

parcelRegister("1MtGV", function(module, exports) {

});

parcelRegister("d4MW5", function(module, exports) {

});

parcelRegister("3gPbx", function(module, exports) {

});

parcelRegister("80I7Q", function(module, exports) {

});

parcelRegister("66YVP", function(module, exports) {

});

parcelRegister("b1Sux", function(module, exports) {

});

parcelRegister("3Q3Tc", function(module, exports) {

});

parcelRegister("qIySV", function(module, exports) {

});

parcelRegister("8f2g3", function(module, exports) {

});

parcelRegister("cJnTf", function(module, exports) {

});

parcelRegister("1a82q", function(module, exports) {

});

parcelRegister("c056I", function(module, exports) {

});

parcelRegister("fKg7b", function(module, exports) {

});

parcelRegister("gGBwf", function(module, exports) {

});

parcelRegister("ksGOz", function(module, exports) {

});

parcelRegister("jaIOd", function(module, exports) {

});

parcelRegister("3rndX", function(module, exports) {

});

parcelRegister("l9WV1", function(module, exports) {

});

parcelRegister("f3g8d", function(module, exports) {

});

parcelRegister("fswg2", function(module, exports) {

});

parcelRegister("7t1yP", function(module, exports) {

});

parcelRegister("eeIOd", function(module, exports) {

});

parcelRegister("aAikE", function(module, exports) {

});

parcelRegister("ftIXZ", function(module, exports) {

});

parcelRegister("keAqM", function(module, exports) {

});

parcelRegister("e0osb", function(module, exports) {

});

parcelRegister("kv9L8", function(module, exports) {

});

parcelRegister("4TR0a", function(module, exports) {

});

parcelRegister("6i0bJ", function(module, exports) {

});

parcelRegister("8xcIb", function(module, exports) {

});

parcelRegister("jIWFH", function(module, exports) {

});

parcelRegister("82ymc", function(module, exports) {

});

parcelRegister("2KtuS", function(module, exports) {

});

parcelRegister("1LB3S", function(module, exports) {

});

parcelRegister("b27UR", function(module, exports) {

});

parcelRegister("04JK6", function(module, exports) {

});

parcelRegister("i0AL4", function(module, exports) {

});

parcelRegister("g1DgE", function(module, exports) {

});

parcelRegister("8fw3Y", function(module, exports) {

});

parcelRegister("9Vexl", function(module, exports) {

});

parcelRegister("g9vqv", function(module, exports) {

});

parcelRegister("9dVPz", function(module, exports) {

});

parcelRegister("aCasH", function(module, exports) {

});

parcelRegister("jdzdC", function(module, exports) {

});

parcelRegister("aKHB0", function(module, exports) {

});

parcelRegister("lskog", function(module, exports) {

});

parcelRegister("bKlTh", function(module, exports) {

});

parcelRegister("64q98", function(module, exports) {

});

parcelRegister("hvVdX", function(module, exports) {

});

parcelRegister("6nMH6", function(module, exports) {

});

parcelRegister("9f1fQ", function(module, exports) {

});

parcelRegister("cSnNG", function(module, exports) {

});

parcelRegister("eCfhx", function(module, exports) {

});

parcelRegister("kBlc9", function(module, exports) {

});

parcelRegister("25tei", function(module, exports) {

});

parcelRegister("dryJV", function(module, exports) {

});

parcelRegister("5SNkP", function(module, exports) {

});

parcelRegister("6HaqY", function(module, exports) {

});

parcelRegister("9pAoQ", function(module, exports) {

});

parcelRegister("2FFy4", function(module, exports) {

});

parcelRegister("lAQAy", function(module, exports) {

});

parcelRegister("1BUk6", function(module, exports) {

});

parcelRegister("8M5n2", function(module, exports) {

});

parcelRegister("66zH2", function(module, exports) {

});

parcelRegister("cJmzv", function(module, exports) {

});

parcelRegister("4GCES", function(module, exports) {

});

parcelRegister("2QgHi", function(module, exports) {

});

parcelRegister("bck6u", function(module, exports) {

});

parcelRegister("kCgzp", function(module, exports) {

});

parcelRegister("44Elr", function(module, exports) {

});

parcelRegister("9nswf", function(module, exports) {

});

parcelRegister("6OoGg", function(module, exports) {

});

parcelRegister("6O8VE", function(module, exports) {

});

parcelRegister("hI19I", function(module, exports) {

});

parcelRegister("9Yzig", function(module, exports) {

});

parcelRegister("aJuAC", function(module, exports) {

});

parcelRegister("89aft", function(module, exports) {

});

parcelRegister("7DYx8", function(module, exports) {

});

parcelRegister("2JmFG", function(module, exports) {

});

parcelRegister("jEUu5", function(module, exports) {

});

parcelRegister("3mKdY", function(module, exports) {

});

parcelRegister("h7yXs", function(module, exports) {

});

parcelRegister("iisFm", function(module, exports) {

});

parcelRegister("2ulv2", function(module, exports) {

});

parcelRegister("7I6ip", function(module, exports) {

});

parcelRegister("iHQIx", function(module, exports) {

});

parcelRegister("fwEk4", function(module, exports) {

});

parcelRegister("3GYz8", function(module, exports) {

});

parcelRegister("37sxX", function(module, exports) {

});

parcelRegister("bzrNL", function(module, exports) {

});

parcelRegister("1Ilac", function(module, exports) {

});

parcelRegister("6Dqyf", function(module, exports) {

});

parcelRegister("f0jmu", function(module, exports) {

});

parcelRegister("3RlSy", function(module, exports) {

});

parcelRegister("jxw4p", function(module, exports) {

});

parcelRegister("iES0s", function(module, exports) {

});

parcelRegister("9JaEA", function(module, exports) {

});

parcelRegister("jw48e", function(module, exports) {

});

parcelRegister("3RTBV", function(module, exports) {

});

parcelRegister("8XgCp", function(module, exports) {

});

parcelRegister("iPYv5", function(module, exports) {

});

parcelRegister("5anXm", function(module, exports) {

});

parcelRegister("5IZr0", function(module, exports) {

});

parcelRegister("8zKU0", function(module, exports) {

});

parcelRegister("99jHf", function(module, exports) {

});

parcelRegister("gIZCx", function(module, exports) {

});

parcelRegister("axvDE", function(module, exports) {

});

parcelRegister("jrpks", function(module, exports) {

});

parcelRegister("TAvo6", function(module, exports) {

});

parcelRegister("82GNz", function(module, exports) {

});

parcelRegister("eUMLt", function(module, exports) {

});

parcelRegister("jTWwr", function(module, exports) {

});

parcelRegister("jdQAE", function(module, exports) {

});

parcelRegister("d3pbF", function(module, exports) {

});

parcelRegister("luHdw", function(module, exports) {

});

parcelRegister("avyrJ", function(module, exports) {

});

parcelRegister("kZBc7", function(module, exports) {

});

parcelRegister("aQbs0", function(module, exports) {

});

parcelRegister("7fLme", function(module, exports) {

});

parcelRegister("C4i8d", function(module, exports) {

});

parcelRegister("jNrq6", function(module, exports) {

});

parcelRegister("i5QtG", function(module, exports) {

});

parcelRegister("cOBo5", function(module, exports) {

});

parcelRegister("RM0pQ", function(module, exports) {

});

parcelRegister("7c0x5", function(module, exports) {

});

parcelRegister("5aeXS", function(module, exports) {

});

parcelRegister("k4j6h", function(module, exports) {

});

parcelRegister("bVEOD", function(module, exports) {

});

parcelRegister("eRl2b", function(module, exports) {

});

parcelRegister("ayNcb", function(module, exports) {

});

parcelRegister("7EmKr", function(module, exports) {

});

parcelRegister("jfjTW", function(module, exports) {

});

parcelRegister("dH8Rv", function(module, exports) {

});

parcelRegister("5DOHX", function(module, exports) {

});

parcelRegister("ebW9a", function(module, exports) {

});

parcelRegister("hBirc", function(module, exports) {

});

parcelRegister("b3jM7", function(module, exports) {

});

parcelRegister("gTpqe", function(module, exports) {

});

parcelRegister("57yRF", function(module, exports) {

});

parcelRegister("cD6k5", function(module, exports) {

});

parcelRegister("bTt3U", function(module, exports) {

});

parcelRegister("aSRMQ", function(module, exports) {

});

parcelRegister("clPWm", function(module, exports) {

});

parcelRegister("9Zy5Z", function(module, exports) {

});

parcelRegister("lcjKH", function(module, exports) {

});

parcelRegister("egjVt", function(module, exports) {

});

parcelRegister("jbWsj", function(module, exports) {

});

parcelRegister("dmkUJ", function(module, exports) {

});

parcelRegister("ee7nY", function(module, exports) {

});

parcelRegister("lcSIn", function(module, exports) {

});

parcelRegister("5wayl", function(module, exports) {

});

parcelRegister("ibQvU", function(module, exports) {

});

parcelRegister("kEN8k", function(module, exports) {

});

parcelRegister("kK203", function(module, exports) {

});

parcelRegister("ftcqV", function(module, exports) {

});

parcelRegister("gLKkZ", function(module, exports) {

});

parcelRegister("kyhSf", function(module, exports) {

});

parcelRegister("8J12v", function(module, exports) {

});

parcelRegister("7HOBW", function(module, exports) {

});

parcelRegister("cjKdF", function(module, exports) {

});

parcelRegister("7GfvB", function(module, exports) {

});

parcelRegister("alXu0", function(module, exports) {

});

parcelRegister("32p3D", function(module, exports) {

});

parcelRegister("aCj6Y", function(module, exports) {

});

parcelRegister("1kKxS", function(module, exports) {

});

parcelRegister("3ICKR", function(module, exports) {

});

parcelRegister("h1EnR", function(module, exports) {

});

parcelRegister("hPXXO", function(module, exports) {

});

parcelRegister("kuaZS", function(module, exports) {

});

parcelRegister("6ixbD", function(module, exports) {

});

parcelRegister("4w4YF", function(module, exports) {

});

parcelRegister("18kkp", function(module, exports) {

});

parcelRegister("cs2BU", function(module, exports) {

});

parcelRegister("jSCfu", function(module, exports) {

});

parcelRegister("1TPo7", function(module, exports) {

});

parcelRegister("fmHnY", function(module, exports) {

});

parcelRegister("km6sY", function(module, exports) {

});

parcelRegister("lsXlo", function(module, exports) {

});

parcelRegister("970QT", function(module, exports) {

});

parcelRegister("5maXH", function(module, exports) {

});

parcelRegister("8IziU", function(module, exports) {

});

parcelRegister("3oulg", function(module, exports) {

});

parcelRegister("2Ch6t", function(module, exports) {

});

parcelRegister("hED3H", function(module, exports) {

});

parcelRegister("4J2ot", function(module, exports) {

});

parcelRegister("lf28F", function(module, exports) {

});

parcelRegister("jR3Vb", function(module, exports) {

});

parcelRegister("3rhio", function(module, exports) {

});

parcelRegister("9q82l", function(module, exports) {

});

parcelRegister("eyTcb", function(module, exports) {

});

parcelRegister("kt9CP", function(module, exports) {

});

parcelRegister("qRI6O", function(module, exports) {

});

parcelRegister("lE5Fy", function(module, exports) {

});

parcelRegister("ji4mM", function(module, exports) {

});

parcelRegister("87wuj", function(module, exports) {

});

parcelRegister("5tSJR", function(module, exports) {

});

parcelRegister("8B6ZQ", function(module, exports) {

});

parcelRegister("8LLSD", function(module, exports) {

});

parcelRegister("5v5Vb", function(module, exports) {

});

parcelRegister("6WmI1", function(module, exports) {

});

parcelRegister("dShHY", function(module, exports) {

});

parcelRegister("hvEfG", function(module, exports) {

});

parcelRegister("5zt1a", function(module, exports) {

});

parcelRegister("8PkGn", function(module, exports) {

});

parcelRegister("9wNWO", function(module, exports) {

});

parcelRegister("1Ditc", function(module, exports) {

});

parcelRegister("6fb32", function(module, exports) {

});

parcelRegister("crCrY", function(module, exports) {

});

parcelRegister("eGCNt", function(module, exports) {

});

parcelRegister("p5heA", function(module, exports) {

});

parcelRegister("2W0w0", function(module, exports) {

});

parcelRegister("2Zezr", function(module, exports) {

});

parcelRegister("2FuoV", function(module, exports) {

});

parcelRegister("5pgpw", function(module, exports) {

});

parcelRegister("fgceC", function(module, exports) {

});

parcelRegister("eAvrq", function(module, exports) {

});

parcelRegister("cEMBU", function(module, exports) {

});

parcelRegister("8d8xx", function(module, exports) {

});

parcelRegister("9Fad1", function(module, exports) {

});

parcelRegister("5odIC", function(module, exports) {

});

parcelRegister("2L1h8", function(module, exports) {

});

parcelRegister("4y0OL", function(module, exports) {

});

parcelRegister("2kM2d", function(module, exports) {

});

parcelRegister("gOg8q", function(module, exports) {

});

parcelRegister("4OCs4", function(module, exports) {

});

parcelRegister("6b7nC", function(module, exports) {

});

parcelRegister("7QAkA", function(module, exports) {

});

parcelRegister("2z5lG", function(module, exports) {

});

parcelRegister("cgxJN", function(module, exports) {

});

parcelRegister("1Mtgi", function(module, exports) {

});

parcelRegister("3kD97", function(module, exports) {

});

parcelRegister("9kYLZ", function(module, exports) {

});

parcelRegister("59GMS", function(module, exports) {

});

parcelRegister("2DJqx", function(module, exports) {

});

parcelRegister("lDdBi", function(module, exports) {

});

parcelRegister("fm9LJ", function(module, exports) {

});

parcelRegister("6kV0e", function(module, exports) {

});

parcelRegister("dDDdX", function(module, exports) {

});

parcelRegister("dximP", function(module, exports) {

});

parcelRegister("epoM3", function(module, exports) {

});

parcelRegister("BUBrA", function(module, exports) {

});

parcelRegister("26sgD", function(module, exports) {

});

parcelRegister("gM5lR", function(module, exports) {

});

parcelRegister("hj8wC", function(module, exports) {

});

parcelRegister("irgAv", function(module, exports) {

});

parcelRegister("aHXB9", function(module, exports) {

});

parcelRegister("8P5BM", function(module, exports) {

});

parcelRegister("5YtwK", function(module, exports) {

});

parcelRegister("4NCzl", function(module, exports) {

});

parcelRegister("jC6Yh", function(module, exports) {

});

parcelRegister("1qYIs", function(module, exports) {

});

parcelRegister("ldipM", function(module, exports) {

});

parcelRegister("b61sd", function(module, exports) {

});

parcelRegister("4emCu", function(module, exports) {

});

parcelRegister("9yrk9", function(module, exports) {

});

parcelRegister("1VuSt", function(module, exports) {

});

parcelRegister("dokni", function(module, exports) {

});

parcelRegister("gLr5k", function(module, exports) {

});

parcelRegister("grxu9", function(module, exports) {

});

parcelRegister("1xHf4", function(module, exports) {

});

parcelRegister("iJsIY", function(module, exports) {

});

parcelRegister("dnHfq", function(module, exports) {

});

parcelRegister("3h3i4", function(module, exports) {

});

parcelRegister("luphg", function(module, exports) {

});

parcelRegister("gMGCJ", function(module, exports) {

});

parcelRegister("joINZ", function(module, exports) {

});

parcelRegister("emUqt", function(module, exports) {

});

parcelRegister("aotWh", function(module, exports) {

});

parcelRegister("fD8Ez", function(module, exports) {

});

parcelRegister("51T64", function(module, exports) {

});

parcelRegister("kOERj", function(module, exports) {

});

parcelRegister("7dfaN", function(module, exports) {

});

parcelRegister("55Qj0", function(module, exports) {

});

parcelRegister("ftaV5", function(module, exports) {

});

parcelRegister("g3FLT", function(module, exports) {

});

parcelRegister("jt9uO", function(module, exports) {

});

parcelRegister("d6t2j", function(module, exports) {

});

parcelRegister("71ghR", function(module, exports) {

});

parcelRegister("ggOuN", function(module, exports) {

});

parcelRegister("kddsc", function(module, exports) {

});

parcelRegister("fzR8D", function(module, exports) {

});

parcelRegister("11w5D", function(module, exports) {

});

parcelRegister("jeqlJ", function(module, exports) {

});

parcelRegister("i3eUQ", function(module, exports) {

});

parcelRegister("24C7e", function(module, exports) {

});

parcelRegister("aHqha", function(module, exports) {

});

parcelRegister("4E09e", function(module, exports) {

});

parcelRegister("8RTMp", function(module, exports) {

});

parcelRegister("9hXqr", function(module, exports) {

});

parcelRegister("503Eu", function(module, exports) {

});

parcelRegister("2AD2K", function(module, exports) {

});

parcelRegister("67v5z", function(module, exports) {

});

parcelRegister("5saok", function(module, exports) {

});

parcelRegister("9TEjt", function(module, exports) {

});

parcelRegister("83Ctb", function(module, exports) {

});

parcelRegister("a3AN5", function(module, exports) {

});

parcelRegister("buH7x", function(module, exports) {

});

parcelRegister("efM0S", function(module, exports) {

});

parcelRegister("3zruX", function(module, exports) {

});

parcelRegister("aVhpZ", function(module, exports) {

});

parcelRegister("kvpCZ", function(module, exports) {

});

parcelRegister("8wOWY", function(module, exports) {

});

parcelRegister("2DLzD", function(module, exports) {

});

parcelRegister("3sdtw", function(module, exports) {

});

parcelRegister("ahLsH", function(module, exports) {

});

parcelRegister("3E9VF", function(module, exports) {

});

parcelRegister("5j36M", function(module, exports) {

});

parcelRegister("dgmle", function(module, exports) {

});



parcelRegister("6Utwn", function(module, exports) {

$parcel$export(module.exports, "assert", () => $507edf519a0251a8$export$a7a9523472993e97);
$parcel$export(module.exports, "assertRange", () => $507edf519a0251a8$export$6698b6d148bc9b0c);
$parcel$export(module.exports, "assertContextRunning", () => $507edf519a0251a8$export$8ef1ce44f93c2687);
$parcel$export(module.exports, "warn", () => $507edf519a0251a8$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "log", () => $507edf519a0251a8$export$bef1f36f5486a6a3);
/**
 * Assert that the statement is true, otherwise invoke the error.
 * @param statement
 * @param error The message which is passed into an Error
 */ function $507edf519a0251a8$export$a7a9523472993e97(statement, error) {
    if (!statement) throw new Error(error);
}
function $507edf519a0251a8$export$6698b6d148bc9b0c(value, gte, lte = Infinity) {
    if (!(gte <= value && value <= lte)) throw new RangeError(`Value must be within [${gte}, ${lte}], got: ${value}`);
}
function $507edf519a0251a8$export$8ef1ce44f93c2687(context) {
    // add a warning if the context is not started
    if (!context.isOffline && context.state !== "running") $507edf519a0251a8$export$c106dd0671a0fc2d("The AudioContext is \"suspended\". Invoke Tone.start() from a user action to start the audio.");
}
/**
 * The default logger is the console
 */ let $507edf519a0251a8$var$defaultLogger = console;
function $507edf519a0251a8$export$3abbd92f765bee58(logger) {
    $507edf519a0251a8$var$defaultLogger = logger;
}
function $507edf519a0251a8$export$bef1f36f5486a6a3(...args) {
    $507edf519a0251a8$var$defaultLogger.log(...args);
}
function $507edf519a0251a8$export$c106dd0671a0fc2d(...args) {
    $507edf519a0251a8$var$defaultLogger.warn(...args);
}

});

parcelRegister("lQ01C", function(module, exports) {

$parcel$export(module.exports, "isUndef", () => $fe5e794b6f6ae3e4$export$eb605f91c5895a5b);
$parcel$export(module.exports, "isDefined", () => $fe5e794b6f6ae3e4$export$4e62c701997796c1);
$parcel$export(module.exports, "isFunction", () => $fe5e794b6f6ae3e4$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isNumber", () => $fe5e794b6f6ae3e4$export$7e4aa119212bc614);
$parcel$export(module.exports, "isObject", () => $fe5e794b6f6ae3e4$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isBoolean", () => $fe5e794b6f6ae3e4$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isArray", () => $fe5e794b6f6ae3e4$export$43bee75e5e14138e);
$parcel$export(module.exports, "isString", () => $fe5e794b6f6ae3e4$export$844ec244b1367d54);
$parcel$export(module.exports, "isNote", () => $fe5e794b6f6ae3e4$export$4dcca4501f2037f9);
/**
 * Test if the arg is undefined
 */ function $fe5e794b6f6ae3e4$export$eb605f91c5895a5b(arg) {
    return typeof arg === "undefined";
}
function $fe5e794b6f6ae3e4$export$4e62c701997796c1(arg) {
    return !$fe5e794b6f6ae3e4$export$eb605f91c5895a5b(arg);
}
function $fe5e794b6f6ae3e4$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $fe5e794b6f6ae3e4$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $fe5e794b6f6ae3e4$export$a6cdc56e425d0d0a(arg) {
    return Object.prototype.toString.call(arg) === "[object Object]" && arg.constructor === Object;
}
function $fe5e794b6f6ae3e4$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $fe5e794b6f6ae3e4$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $fe5e794b6f6ae3e4$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $fe5e794b6f6ae3e4$export$4dcca4501f2037f9(arg) {
    return $fe5e794b6f6ae3e4$export$844ec244b1367d54(arg) && /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(arg);
}

});


parcelRegister("g8ux3", function(module, exports) {

$parcel$export(module.exports, "Context", () => $bbf513c4272e59dd$export$841858b892ce1f4c);

var $gztBd = parcelRequire("gztBd");

var $bAvN3 = parcelRequire("bAvN3");

var $9rnZW = parcelRequire("9rnZW");

var $l4RVz = parcelRequire("l4RVz");

var $kjPdm = parcelRequire("kjPdm");

var $lQ01C = parcelRequire("lQ01C");

var $lQat4 = parcelRequire("lQat4");

var $7M63q = parcelRequire("7M63q");

var $65zZ5 = parcelRequire("65zZ5");

var $6Utwn = parcelRequire("6Utwn");
class $bbf513c4272e59dd$export$841858b892ce1f4c extends (0, $65zZ5.BaseContext) {
    constructor(){
        super();
        this.name = "Context";
        /**
         * An object containing all of the constants AudioBufferSourceNodes
         */ this._constants = new Map();
        /**
         * All of the setTimeout events.
         */ this._timeouts = new (0, $kjPdm.Timeline)();
        /**
         * The timeout id counter
         */ this._timeoutIds = 0;
        /**
         * Private indicator if the context has been initialized
         */ this._initialized = false;
        /**
         * Indicates if the context is an OfflineAudioContext or an AudioContext
         */ this.isOffline = false;
        //--------------------------------------------
        // AUDIO WORKLET
        //--------------------------------------------
        /**
         * Maps a module name to promise of the addModule method
         */ this._workletModules = new Map();
        const options = (0, $l4RVz.optionsFromArguments)($bbf513c4272e59dd$export$841858b892ce1f4c.getDefaults(), arguments, [
            "context"
        ]);
        if (options.context) this._context = options.context;
        else this._context = (0, $lQat4.createAudioContext)({
            latencyHint: options.latencyHint
        });
        this._ticker = new (0, $bAvN3.Ticker)(this.emit.bind(this, "tick"), options.clockSource, options.updateInterval);
        this.on("tick", this._timeoutLoop.bind(this));
        // fwd events from the context
        this._context.onstatechange = ()=>{
            this.emit("statechange", this.state);
        };
        this._setLatencyHint(options.latencyHint);
        this.lookAhead = options.lookAhead;
    }
    static getDefaults() {
        return {
            clockSource: "worker",
            latencyHint: "interactive",
            lookAhead: 0.1,
            updateInterval: 0.05
        };
    }
    /**
     * Finish setting up the context. **You usually do not need to do this manually.**
     */ initialize() {
        if (!this._initialized) {
            // add any additional modules
            (0, $7M63q.initializeContext)(this);
            this._initialized = true;
        }
        return this;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return this._context.createAnalyser();
    }
    createOscillator() {
        return this._context.createOscillator();
    }
    createBufferSource() {
        return this._context.createBufferSource();
    }
    createBiquadFilter() {
        return this._context.createBiquadFilter();
    }
    createBuffer(numberOfChannels, length, sampleRate) {
        return this._context.createBuffer(numberOfChannels, length, sampleRate);
    }
    createChannelMerger(numberOfInputs) {
        return this._context.createChannelMerger(numberOfInputs);
    }
    createChannelSplitter(numberOfOutputs) {
        return this._context.createChannelSplitter(numberOfOutputs);
    }
    createConstantSource() {
        return this._context.createConstantSource();
    }
    createConvolver() {
        return this._context.createConvolver();
    }
    createDelay(maxDelayTime) {
        return this._context.createDelay(maxDelayTime);
    }
    createDynamicsCompressor() {
        return this._context.createDynamicsCompressor();
    }
    createGain() {
        return this._context.createGain();
    }
    createIIRFilter(feedForward, feedback) {
        // @ts-ignore
        return this._context.createIIRFilter(feedForward, feedback);
    }
    createPanner() {
        return this._context.createPanner();
    }
    createPeriodicWave(real, imag, constraints) {
        return this._context.createPeriodicWave(real, imag, constraints);
    }
    createStereoPanner() {
        return this._context.createStereoPanner();
    }
    createWaveShaper() {
        return this._context.createWaveShaper();
    }
    createMediaStreamSource(stream) {
        (0, $6Utwn.assert)((0, $9rnZW.isAudioContext)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamSource(stream);
    }
    createMediaElementSource(element) {
        (0, $6Utwn.assert)((0, $9rnZW.isAudioContext)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaElementSource(element);
    }
    createMediaStreamDestination() {
        (0, $6Utwn.assert)((0, $9rnZW.isAudioContext)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamDestination();
    }
    decodeAudioData(audioData) {
        return this._context.decodeAudioData(audioData);
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get currentTime() {
        return this._context.currentTime;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get state() {
        return this._context.state;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get sampleRate() {
        return this._context.sampleRate;
    }
    /**
     * The listener
     */ get listener() {
        this.initialize();
        return this._listener;
    }
    set listener(l) {
        (0, $6Utwn.assert)(!this._initialized, "The listener cannot be set after initialization.");
        this._listener = l;
    }
    /**
     * There is only one Transport per Context. It is created on initialization.
     */ get transport() {
        this.initialize();
        return this._transport;
    }
    set transport(t) {
        (0, $6Utwn.assert)(!this._initialized, "The transport cannot be set after initialization.");
        this._transport = t;
    }
    /**
     * This is the Draw object for the context which is useful for synchronizing the draw frame with the Tone.js clock.
     */ get draw() {
        this.initialize();
        return this._draw;
    }
    set draw(d) {
        (0, $6Utwn.assert)(!this._initialized, "Draw cannot be set after initialization.");
        this._draw = d;
    }
    /**
     * A reference to the Context's destination node.
     */ get destination() {
        this.initialize();
        return this._destination;
    }
    set destination(d) {
        (0, $6Utwn.assert)(!this._initialized, "The destination cannot be set after initialization.");
        this._destination = d;
    }
    /**
     * Create an audio worklet node from a name and options. The module
     * must first be loaded using [[addAudioWorkletModule]].
     */ createAudioWorkletNode(name, options) {
        return (0, $lQat4.createAudioWorkletNode)(this.rawContext, name, options);
    }
    /**
     * Add an AudioWorkletProcessor module
     * @param url The url of the module
     * @param name The name of the module
     */ addAudioWorkletModule(url, name) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            (0, $6Utwn.assert)((0, $lQ01C.isDefined)(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)");
            if (!this._workletModules.has(name)) this._workletModules.set(name, this.rawContext.audioWorklet.addModule(url));
            yield this._workletModules.get(name);
        });
    }
    /**
     * Returns a promise which resolves when all of the worklets have been loaded on this context
     */ workletsAreReady() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const promises = [];
            this._workletModules.forEach((promise)=>promises.push(promise));
            yield Promise.all(promises);
        });
    }
    //---------------------------
    // TICKER
    //---------------------------
    /**
     * How often the interval callback is invoked.
     * This number corresponds to how responsive the scheduling
     * can be. context.updateInterval + context.lookAhead gives you the
     * total latency between scheduling an event and hearing it.
     */ get updateInterval() {
        return this._ticker.updateInterval;
    }
    set updateInterval(interval) {
        this._ticker.updateInterval = interval;
    }
    /**
     * What the source of the clock is, either "worker" (default),
     * "timeout", or "offline" (none).
     */ get clockSource() {
        return this._ticker.type;
    }
    set clockSource(type) {
        this._ticker.type = type;
    }
    /**
     * The type of playback, which affects tradeoffs between audio
     * output latency and responsiveness.
     * In addition to setting the value in seconds, the latencyHint also
     * accepts the strings "interactive" (prioritizes low latency),
     * "playback" (prioritizes sustained playback), "balanced" (balances
     * latency and performance).
     * @example
     * // prioritize sustained playback
     * const context = new Tone.Context({ latencyHint: "playback" });
     * // set this context as the global Context
     * Tone.setContext(context);
     * // the global context is gettable with Tone.getContext()
     * console.log(Tone.getContext().latencyHint);
     */ get latencyHint() {
        return this._latencyHint;
    }
    /**
     * Update the lookAhead and updateInterval based on the latencyHint
     */ _setLatencyHint(hint) {
        let lookAheadValue = 0;
        this._latencyHint = hint;
        if ((0, $lQ01C.isString)(hint)) switch(hint){
            case "interactive":
                lookAheadValue = 0.1;
                break;
            case "playback":
                lookAheadValue = 0.5;
                break;
            case "balanced":
                lookAheadValue = 0.25;
                break;
        }
        this.lookAhead = lookAheadValue;
        this.updateInterval = lookAheadValue / 2;
    }
    /**
     * The unwrapped AudioContext or OfflineAudioContext
     */ get rawContext() {
        return this._context;
    }
    /**
     * The current audio context time plus a short [[lookAhead]].
     */ now() {
        return this._context.currentTime + this.lookAhead;
    }
    /**
     * The current audio context time without the [[lookAhead]].
     * In most cases it is better to use [[now]] instead of [[immediate]] since
     * with [[now]] the [[lookAhead]] is applied equally to _all_ components including internal components,
     * to making sure that everything is scheduled in sync. Mixing [[now]] and [[immediate]]
     * can cause some timing issues. If no lookAhead is desired, you can set the [[lookAhead]] to `0`.
     */ immediate() {
        return this._context.currentTime;
    }
    /**
     * Starts the audio context from a suspended state. This is required
     * to initially start the AudioContext. See [[Tone.start]]
     */ resume() {
        if ((0, $9rnZW.isAudioContext)(this._context)) return this._context.resume();
        else return Promise.resolve();
    }
    /**
     * Close the context. Once closed, the context can no longer be used and
     * any AudioNodes created from the context will be silent.
     */ close() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            if ((0, $9rnZW.isAudioContext)(this._context)) yield this._context.close();
            if (this._initialized) (0, $7M63q.closeContext)(this);
        });
    }
    /**
     * **Internal** Generate a looped buffer at some constant value.
     */ getConstant(val) {
        if (this._constants.has(val)) return this._constants.get(val);
        else {
            const buffer = this._context.createBuffer(1, 128, this._context.sampleRate);
            const arr = buffer.getChannelData(0);
            for(let i = 0; i < arr.length; i++)arr[i] = val;
            const constant = this._context.createBufferSource();
            constant.channelCount = 1;
            constant.channelCountMode = "explicit";
            constant.buffer = buffer;
            constant.loop = true;
            constant.start(0);
            this._constants.set(val, constant);
            return constant;
        }
    }
    /**
     * Clean up. Also closes the audio context.
     */ dispose() {
        super.dispose();
        this._ticker.dispose();
        this._timeouts.dispose();
        Object.keys(this._constants).map((val)=>this._constants[val].disconnect());
        return this;
    }
    //---------------------------
    // TIMEOUTS
    //---------------------------
    /**
     * The private loop which keeps track of the context scheduled timeouts
     * Is invoked from the clock source
     */ _timeoutLoop() {
        const now = this.now();
        let firstEvent = this._timeouts.peek();
        while(this._timeouts.length && firstEvent && firstEvent.time <= now){
            // invoke the callback
            firstEvent.callback();
            // shift the first event off
            this._timeouts.shift();
            // get the next one
            firstEvent = this._timeouts.peek();
        }
    }
    /**
     * A setTimeout which is guaranteed by the clock source.
     * Also runs in the offline context.
     * @param  fn       The callback to invoke
     * @param  timeout  The timeout in seconds
     * @returns ID to use when invoking Context.clearTimeout
     */ setTimeout(fn, timeout) {
        this._timeoutIds++;
        const now = this.now();
        this._timeouts.add({
            callback: fn,
            id: this._timeoutIds,
            time: now + timeout
        });
        return this._timeoutIds;
    }
    /**
     * Clears a previously scheduled timeout with Tone.context.setTimeout
     * @param  id  The ID returned from setTimeout
     */ clearTimeout(id) {
        this._timeouts.forEach((event)=>{
            if (event.id === id) this._timeouts.remove(event);
        });
        return this;
    }
    /**
     * Clear the function scheduled by [[setInterval]]
     */ clearInterval(id) {
        return this.clearTimeout(id);
    }
    /**
     * Adds a repeating event to the context's callback clock
     */ setInterval(fn, interval) {
        const id = ++this._timeoutIds;
        const intervalFn = ()=>{
            const now = this.now();
            this._timeouts.add({
                callback: ()=>{
                    // invoke the callback
                    fn();
                    // invoke the event to repeat it
                    intervalFn();
                },
                id: id,
                time: now + interval
            });
        };
        // kick it off
        intervalFn();
        return id;
    }
}

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $c106e002a49a00cb$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $c106e002a49a00cb$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92
};

});

parcelRegister("bAvN3", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $86fbb75d9937264b$export$39c54bcc89dcee11);
/**
 * A class which provides a reliable callback using either
 * a Web Worker, or if that isn't supported, falls back to setTimeout.
 */ class $86fbb75d9937264b$export$39c54bcc89dcee11 {
    constructor(callback, type, updateInterval){
        this._callback = callback;
        this._type = type;
        this._updateInterval = updateInterval;
        // create the clock source for the first time
        this._createClock();
    }
    /**
     * Generate a web worker
     */ _createWorker() {
        const blob = new Blob([
            /* javascript */ `
			// the initial timeout time
			let timeoutTime =  ${(this._updateInterval * 1000).toFixed(1)};
			// onmessage callback
			self.onmessage = function(msg){
				timeoutTime = parseInt(msg.data);
			};
			// the tick function which posts a message
			// and schedules a new tick
			function tick(){
				setTimeout(tick, timeoutTime);
				self.postMessage('tick');
			}
			// call tick initially
			tick();
			`
        ], {
            type: "text/javascript"
        });
        const blobUrl = URL.createObjectURL(blob);
        const worker = new Worker(blobUrl);
        worker.onmessage = this._callback.bind(this);
        this._worker = worker;
    }
    /**
     * Create a timeout loop
     */ _createTimeout() {
        this._timeout = setTimeout(()=>{
            this._createTimeout();
            this._callback();
        }, this._updateInterval * 1000);
    }
    /**
     * Create the clock source.
     */ _createClock() {
        if (this._type === "worker") try {
            this._createWorker();
        } catch (e) {
            // workers not supported, fallback to timeout
            this._type = "timeout";
            this._createClock();
        }
        else if (this._type === "timeout") this._createTimeout();
    }
    /**
     * Clean up the current clock source
     */ _disposeClock() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = 0;
        }
        if (this._worker) {
            this._worker.terminate();
            this._worker.onmessage = null;
        }
    }
    /**
     * The rate in seconds the ticker will update
     */ get updateInterval() {
        return this._updateInterval;
    }
    set updateInterval(interval) {
        this._updateInterval = Math.max(interval, 128 / 44100);
        if (this._type === "worker") this._worker.postMessage(Math.max(interval * 1000, 1));
    }
    /**
     * The type of the ticker, either a worker or a timeout
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._disposeClock();
        this._type = type;
        this._createClock();
    }
    /**
     * Clean up
     */ dispose() {
        this._disposeClock();
    }
}

});

parcelRegister("9rnZW", function(module, exports) {

$parcel$export(module.exports, "isAudioParam", () => $6df94034711ac8e8$export$1abe4e52803657f3);
$parcel$export(module.exports, "isAudioNode", () => $6df94034711ac8e8$export$85cd8e93eb858e81);
$parcel$export(module.exports, "isOfflineAudioContext", () => $6df94034711ac8e8$export$539f87c8e5511243);
$parcel$export(module.exports, "isAudioContext", () => $6df94034711ac8e8$export$c46cbd835dc15c90);
$parcel$export(module.exports, "isAudioBuffer", () => $6df94034711ac8e8$export$3cc2454c233bdc32);

var $kxUqn = parcelRequire("kxUqn");
function $6df94034711ac8e8$export$1abe4e52803657f3(arg) {
    return (0, $kxUqn.isAnyAudioParam)(arg);
}
function $6df94034711ac8e8$export$85cd8e93eb858e81(arg) {
    return (0, $kxUqn.isAnyAudioNode)(arg);
}
function $6df94034711ac8e8$export$539f87c8e5511243(arg) {
    return (0, $kxUqn.isAnyOfflineAudioContext)(arg);
}
function $6df94034711ac8e8$export$c46cbd835dc15c90(arg) {
    return (0, $kxUqn.isAnyAudioContext)(arg);
}
function $6df94034711ac8e8$export$3cc2454c233bdc32(arg) {
    return arg instanceof AudioBuffer;
}

});

parcelRegister("l4RVz", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $f583cd93a1d69211$export$6969335ea1e4e77c);
$parcel$export(module.exports, "deepEquals", () => $f583cd93a1d69211$export$73ce4178444047a5);
$parcel$export(module.exports, "optionsFromArguments", () => $f583cd93a1d69211$export$71d3255081da70a3);
$parcel$export(module.exports, "getDefaultsFromInstance", () => $f583cd93a1d69211$export$4b8c3341c9aef2b8);
$parcel$export(module.exports, "defaultArg", () => $f583cd93a1d69211$export$37721a79838ca038);
$parcel$export(module.exports, "omitFromObject", () => $f583cd93a1d69211$export$e35a36a1f3b5e86b);

var $9rnZW = parcelRequire("9rnZW");

var $lQ01C = parcelRequire("lQ01C");
/**
 * Some objects should not be merged
 */ function $f583cd93a1d69211$var$noCopy(key, arg) {
    return key === "value" || (0, $9rnZW.isAudioParam)(arg) || (0, $9rnZW.isAudioNode)(arg) || (0, $9rnZW.isAudioBuffer)(arg);
}
function $f583cd93a1d69211$export$6969335ea1e4e77c(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if ((0, $lQ01C.isObject)(target) && (0, $lQ01C.isObject)(source)) for(const key in source){
        if ($f583cd93a1d69211$var$noCopy(key, source[key])) target[key] = source[key];
        else if ((0, $lQ01C.isObject)(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            $f583cd93a1d69211$export$6969335ea1e4e77c(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    // @ts-ignore
    return $f583cd93a1d69211$export$6969335ea1e4e77c(target, ...sources);
}
function $f583cd93a1d69211$export$73ce4178444047a5(arrayA, arrayB) {
    return arrayA.length === arrayB.length && arrayA.every((element, index)=>arrayB[index] === element);
}
function $f583cd93a1d69211$export$71d3255081da70a3(defaults, argsArray, keys = [], objKey) {
    const opts = {};
    const args = Array.from(argsArray);
    // if the first argument is an object and has an object key
    if ((0, $lQ01C.isObject)(args[0]) && objKey && !Reflect.has(args[0], objKey)) {
        // if it's not part of the defaults
        const partOfDefaults = Object.keys(args[0]).some((key)=>Reflect.has(defaults, key));
        if (!partOfDefaults) {
            // merge that key
            $f583cd93a1d69211$export$6969335ea1e4e77c(opts, {
                [objKey]: args[0]
            });
            // remove the obj key from the keys
            keys.splice(keys.indexOf(objKey), 1);
            // shift the first argument off
            args.shift();
        }
    }
    if (args.length === 1 && (0, $lQ01C.isObject)(args[0])) $f583cd93a1d69211$export$6969335ea1e4e77c(opts, args[0]);
    else {
        for(let i = 0; i < keys.length; i++)if ((0, $lQ01C.isDefined)(args[i])) opts[keys[i]] = args[i];
    }
    return $f583cd93a1d69211$export$6969335ea1e4e77c(defaults, opts);
}
function $f583cd93a1d69211$export$4b8c3341c9aef2b8(instance) {
    return instance.constructor.getDefaults();
}
function $f583cd93a1d69211$export$37721a79838ca038(given, fallback) {
    if ((0, $lQ01C.isUndef)(given)) return fallback;
    else return given;
}
function $f583cd93a1d69211$export$e35a36a1f3b5e86b(obj, omit) {
    omit.forEach((prop)=>{
        if (Reflect.has(obj, prop)) delete obj[prop];
    });
    return obj;
}

});

parcelRegister("kjPdm", function(module, exports) {

$parcel$export(module.exports, "Timeline", () => $ecad4f1f79aebaed$export$e6a97ba2cae5bb94);

var $jiVAa = parcelRequire("jiVAa");

var $l4RVz = parcelRequire("l4RVz");

var $6Utwn = parcelRequire("6Utwn");

var $j4WGs = parcelRequire("j4WGs");
class $ecad4f1f79aebaed$export$e6a97ba2cae5bb94 extends (0, $jiVAa.Tone) {
    constructor(){
        super();
        this.name = "Timeline";
        /**
         * The array of scheduled timeline events
         */ this._timeline = [];
        const options = (0, $l4RVz.optionsFromArguments)($ecad4f1f79aebaed$export$e6a97ba2cae5bb94.getDefaults(), arguments, [
            "memory"
        ]);
        this.memory = options.memory;
        this.increasing = options.increasing;
    }
    static getDefaults() {
        return {
            memory: Infinity,
            increasing: false
        };
    }
    /**
     * The number of items in the timeline.
     */ get length() {
        return this._timeline.length;
    }
    /**
     * Insert an event object onto the timeline. Events must have a "time" attribute.
     * @param event  The event object to insert into the timeline.
     */ add(event) {
        // the event needs to have a time attribute
        (0, $6Utwn.assert)(Reflect.has(event, "time"), "Timeline: events must have a time attribute");
        event.time = event.time.valueOf();
        if (this.increasing && this.length) {
            const lastValue = this._timeline[this.length - 1];
            (0, $6Utwn.assert)((0, $j4WGs.GTE)(event.time, lastValue.time), "The time must be greater than or equal to the last scheduled time");
            this._timeline.push(event);
        } else {
            const index = this._search(event.time);
            this._timeline.splice(index + 1, 0, event);
        }
        // if the length is more than the memory, remove the previous ones
        if (this.length > this.memory) {
            const diff = this.length - this.memory;
            this._timeline.splice(0, diff);
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  {Object}  event  The event object to remove from the list.
     * @returns {Timeline} this
     */ remove(event) {
        const index = this._timeline.indexOf(event);
        if (index !== -1) this._timeline.splice(index, 1);
        return this;
    }
    /**
     * Get the nearest event whose time is less than or equal to the given time.
     * @param  time  The time to query.
     */ get(time, param = "time") {
        const index = this._search(time, param);
        if (index !== -1) return this._timeline[index];
        else return null;
    }
    /**
     * Return the first event in the timeline without removing it
     * @returns {Object} The first event object
     */ peek() {
        return this._timeline[0];
    }
    /**
     * Return the first event in the timeline and remove it
     */ shift() {
        return this._timeline.shift();
    }
    /**
     * Get the event which is scheduled after the given time.
     * @param  time  The time to query.
     */ getAfter(time, param = "time") {
        const index = this._search(time, param);
        if (index + 1 < this._timeline.length) return this._timeline[index + 1];
        else return null;
    }
    /**
     * Get the event before the event at the given time.
     * @param  time  The time to query.
     */ getBefore(time) {
        const len = this._timeline.length;
        // if it's after the last item, return the last item
        if (len > 0 && this._timeline[len - 1].time < time) return this._timeline[len - 1];
        const index = this._search(time);
        if (index - 1 >= 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Cancel events at and after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        if (this._timeline.length > 1) {
            let index = this._search(after);
            if (index >= 0) {
                if ((0, $j4WGs.EQ)(this._timeline[index].time, after)) {
                    // get the first item with that time
                    for(let i = index; i >= 0; i--){
                        if ((0, $j4WGs.EQ)(this._timeline[i].time, after)) index = i;
                        else break;
                    }
                    this._timeline = this._timeline.slice(0, index);
                } else this._timeline = this._timeline.slice(0, index + 1);
            } else this._timeline = [];
        } else if (this._timeline.length === 1) // the first item's time
        {
            if ((0, $j4WGs.GTE)(this._timeline[0].time, after)) this._timeline = [];
        }
        return this;
    }
    /**
     * Cancel events before or equal to the given time.
     * @param  time  The time to cancel before.
     */ cancelBefore(time) {
        const index = this._search(time);
        if (index >= 0) this._timeline = this._timeline.slice(index + 1);
        return this;
    }
    /**
     * Returns the previous event if there is one. null otherwise
     * @param  event The event to find the previous one of
     * @return The event right before the given event
     */ previousEvent(event) {
        const index = this._timeline.indexOf(event);
        if (index > 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Does a binary search on the timeline array and returns the
     * nearest event index whose time is after or equal to the given time.
     * If a time is searched before the first index in the timeline, -1 is returned.
     * If the time is after the end, the index of the last item is returned.
     */ _search(time, param = "time") {
        if (this._timeline.length === 0) return -1;
        let beginning = 0;
        const len = this._timeline.length;
        let end = len;
        if (len > 0 && this._timeline[len - 1][param] <= time) return len - 1;
        while(beginning < end){
            // calculate the midpoint for roughly equal partition
            let midPoint = Math.floor(beginning + (end - beginning) / 2);
            const event = this._timeline[midPoint];
            const nextEvent = this._timeline[midPoint + 1];
            if ((0, $j4WGs.EQ)(event[param], time)) {
                // choose the last one that has the same time
                for(let i = midPoint; i < this._timeline.length; i++){
                    const testEvent = this._timeline[i];
                    if ((0, $j4WGs.EQ)(testEvent[param], time)) midPoint = i;
                    else break;
                }
                return midPoint;
            } else if ((0, $j4WGs.LT)(event[param], time) && (0, $j4WGs.GT)(nextEvent[param], time)) return midPoint;
            else if ((0, $j4WGs.GT)(event[param], time)) // search lower
            end = midPoint;
            else // search upper
            beginning = midPoint + 1;
        }
        return -1;
    }
    /**
     * Internal iterator. Applies extra safety checks for
     * removing items from the array.
     */ _iterate(callback, lowerBound = 0, upperBound = this._timeline.length - 1) {
        this._timeline.slice(lowerBound, upperBound + 1).forEach(callback);
    }
    /**
     * Iterate over everything in the array
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        this._iterate(callback);
        return this;
    }
    /**
     * Iterate over everything in the array at or before the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachBefore(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array after the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAfter(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const lowerBound = this._search(time);
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array between the startTime and endTime.
     * The timerange is inclusive of the startTime, but exclusive of the endTime.
     * range = [startTime, endTime).
     * @param  startTime The time to check if items are before
     * @param  endTime The end of the test interval.
     * @param  callback The callback to invoke with every item
     */ forEachBetween(startTime, endTime, callback) {
        let lowerBound = this._search(startTime);
        let upperBound = this._search(endTime);
        if (lowerBound !== -1 && upperBound !== -1) {
            if (this._timeline[lowerBound].time !== startTime) lowerBound += 1;
            // exclusive of the end time
            if (this._timeline[upperBound].time === endTime) upperBound -= 1;
            this._iterate(callback, lowerBound, upperBound);
        } else if (lowerBound === -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array at or after the given time. Similar to
     * forEachAfter, but includes the item(s) at the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        let lowerBound = this._search(time);
        // work backwards until the event time is less than time
        while(lowerBound >= 0 && this._timeline[lowerBound].time >= time)lowerBound--;
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array at the given time
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1 && (0, $j4WGs.EQ)(this._timeline[upperBound].time, time)) {
            let lowerBound = upperBound;
            for(let i = upperBound; i >= 0; i--){
                if ((0, $j4WGs.EQ)(this._timeline[i].time, time)) lowerBound = i;
                else break;
            }
            this._iterate((event)=>{
                callback(event);
            }, lowerBound, upperBound);
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._timeline = [];
        return this;
    }
}

});
parcelRegister("jiVAa", function(module, exports) {

$parcel$export(module.exports, "Tone", () => $e0dc5d6bc4de3a6a$export$12b11dc969d02fed);
/**
 * Tone.js
 * @author Yotam Mann
 * @license http://opensource.org/licenses/MIT MIT License
 * @copyright 2014-2019 Yotam Mann
 */ 
var $cygwg = parcelRequire("cygwg");

var $lQat4 = parcelRequire("lQat4");

var $6Utwn = parcelRequire("6Utwn");
class $e0dc5d6bc4de3a6a$export$12b11dc969d02fed {
    constructor(){
        //-------------------------------------
        // 	DEBUGGING
        //-------------------------------------
        /**
         * Set this debug flag to log all events that happen in this class.
         */ this.debug = false;
        //-------------------------------------
        // 	DISPOSING
        //-------------------------------------
        /**
         * Indicates if the instance was disposed
         */ this._wasDisposed = false;
    }
    /**
     * Returns all of the default options belonging to the class.
     */ static getDefaults() {
        return {};
    }
    /**
     * Prints the outputs to the console log for debugging purposes.
     * Prints the contents only if either the object has a property
     * called `debug` set to true, or a variable called TONE_DEBUG_CLASS
     * is set to the name of the class.
     * @example
     * const osc = new Tone.Oscillator();
     * // prints all logs originating from this oscillator
     * osc.debug = true;
     * // calls to start/stop will print in the console
     * osc.start();
     */ log(...args) {
        // if the object is either set to debug = true
        // or if there is a string on the Tone.global.with the class name
        if (this.debug || (0, $lQat4.theWindow) && this.toString() === (0, $lQat4.theWindow).TONE_DEBUG_CLASS) (0, $6Utwn.log)(this, ...args);
    }
    /**
     * disconnect and dispose.
     */ dispose() {
        this._wasDisposed = true;
        return this;
    }
    /**
     * Indicates if the instance was disposed. 'Disposing' an
     * instance means that all of the Web Audio nodes that were
     * created for the instance are disconnected and freed for garbage collection.
     */ get disposed() {
        return this._wasDisposed;
    }
    /**
     * Convert the class to a string
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.toString());
     */ toString() {
        return this.name;
    }
}
/**
 * The version number semver
 */ $e0dc5d6bc4de3a6a$export$12b11dc969d02fed.version = (0, $cygwg.version);

});

parcelRegister("j4WGs", function(module, exports) {

$parcel$export(module.exports, "GT", () => $de3be9698602b5c7$export$b023c82b48e70453);
$parcel$export(module.exports, "GTE", () => $de3be9698602b5c7$export$c846515610eb2c50);
$parcel$export(module.exports, "EQ", () => $de3be9698602b5c7$export$1c0a5d05eb3f6e18);
$parcel$export(module.exports, "LT", () => $de3be9698602b5c7$export$7158f0ceb70f54c7);
$parcel$export(module.exports, "clamp", () => $de3be9698602b5c7$export$7d15b64cf5a3a4c4);
/**
 * The threshold for correctness for operators. Less than one sample even
 * at very high sampling rates (e.g. `1e-6 < 1 / 192000`).
 */ const $de3be9698602b5c7$var$EPSILON = 1e-6;
function $de3be9698602b5c7$export$b023c82b48e70453(a, b) {
    return a > b + $de3be9698602b5c7$var$EPSILON;
}
function $de3be9698602b5c7$export$c846515610eb2c50(a, b) {
    return $de3be9698602b5c7$export$b023c82b48e70453(a, b) || $de3be9698602b5c7$export$1c0a5d05eb3f6e18(a, b);
}
function $de3be9698602b5c7$export$7158f0ceb70f54c7(a, b) {
    return a + $de3be9698602b5c7$var$EPSILON < b;
}
function $de3be9698602b5c7$export$1c0a5d05eb3f6e18(a, b) {
    return Math.abs(a - b) < $de3be9698602b5c7$var$EPSILON;
}
function $de3be9698602b5c7$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(Math.min(value, max), min);
}

});


parcelRegister("7M63q", function(module, exports) {

$parcel$export(module.exports, "onContextInit", () => $5a91b654bcda4036$export$cdd816203a02e74e);
$parcel$export(module.exports, "initializeContext", () => $5a91b654bcda4036$export$881f7fb71351b304);
$parcel$export(module.exports, "onContextClose", () => $5a91b654bcda4036$export$7e1ecadd06ae8222);
$parcel$export(module.exports, "closeContext", () => $5a91b654bcda4036$export$c7e36f690049420f);
//-------------------------------------
// INITIALIZING NEW CONTEXT
//-------------------------------------
/**
 * Array of callbacks to invoke when a new context is created
 */ const $5a91b654bcda4036$var$notifyNewContext = [];
function $5a91b654bcda4036$export$cdd816203a02e74e(cb) {
    $5a91b654bcda4036$var$notifyNewContext.push(cb);
}
function $5a91b654bcda4036$export$881f7fb71351b304(ctx) {
    // add any additional modules
    $5a91b654bcda4036$var$notifyNewContext.forEach((cb)=>cb(ctx));
}
/**
 * Array of callbacks to invoke when a new context is created
 */ const $5a91b654bcda4036$var$notifyCloseContext = [];
function $5a91b654bcda4036$export$7e1ecadd06ae8222(cb) {
    $5a91b654bcda4036$var$notifyCloseContext.push(cb);
}
function $5a91b654bcda4036$export$c7e36f690049420f(ctx) {
    // add any additional modules
    $5a91b654bcda4036$var$notifyCloseContext.forEach((cb)=>cb(ctx));
}

});

parcelRegister("65zZ5", function(module, exports) {

$parcel$export(module.exports, "BaseContext", () => $46ef1f6ba0b0713e$export$8138604c41bf2253);

var $cwPvC = parcelRequire("cwPvC");
class $46ef1f6ba0b0713e$export$8138604c41bf2253 extends (0, $cwPvC.Emitter) {
    constructor(){
        super(...arguments);
        this.isOffline = false;
    }
    /*
     * This is a placeholder so that JSON.stringify does not throw an error
     * This matches what JSON.stringify(audioContext) returns on a native
     * audioContext instance.
     */ toJSON() {
        return {};
    }
}

});
parcelRegister("cwPvC", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $91f06dd251573773$export$4293555f241ae35a);

var $jiVAa = parcelRequire("jiVAa");

var $lQ01C = parcelRequire("lQ01C");
class $91f06dd251573773$export$4293555f241ae35a extends (0, $jiVAa.Tone) {
    constructor(){
        super(...arguments);
        this.name = "Emitter";
    }
    /**
     * Bind a callback to a specific event.
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ on(event, callback) {
        // split the event
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $lQ01C.isUndef)(this._events)) this._events = {};
            if (!this._events.hasOwnProperty(eventName)) this._events[eventName] = [];
            this._events[eventName].push(callback);
        });
        return this;
    }
    /**
     * Bind a callback which is only invoked once
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ once(event, callback) {
        const boundCallback = (...args)=>{
            // invoke the callback
            callback(...args);
            // remove the event
            this.off(event, boundCallback);
        };
        this.on(event, boundCallback);
        return this;
    }
    /**
     * Remove the event listener.
     * @param  event     The event to stop listening to.
     * @param  callback  The callback which was bound to the event with Emitter.on.
     *                   If no callback is given, all callbacks events are removed.
     */ off(event, callback) {
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $lQ01C.isUndef)(this._events)) this._events = {};
            if (this._events.hasOwnProperty(event)) {
                if ((0, $lQ01C.isUndef)(callback)) this._events[event] = [];
                else {
                    const eventList = this._events[event];
                    for(let i = eventList.length - 1; i >= 0; i--)if (eventList[i] === callback) eventList.splice(i, 1);
                }
            }
        });
        return this;
    }
    /**
     * Invoke all of the callbacks bound to the event
     * with any arguments passed in.
     * @param  event  The name of the event.
     * @param args The arguments to pass to the functions listening.
     */ emit(event, ...args) {
        if (this._events) {
            if (this._events.hasOwnProperty(event)) {
                const eventList = this._events[event].slice(0);
                for(let i = 0, len = eventList.length; i < len; i++)eventList[i].apply(this, args);
            }
        }
        return this;
    }
    /**
     * Add Emitter functions (on/off/emit) to the object
     */ static mixin(constr) {
        // instance._events = {};
        [
            "on",
            "once",
            "off",
            "emit"
        ].forEach((name)=>{
            const property = Object.getOwnPropertyDescriptor($91f06dd251573773$export$4293555f241ae35a.prototype, name);
            Object.defineProperty(constr.prototype, name, property);
        });
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._events = undefined;
        return this;
    }
}

});



parcelRegister("1uOAh", function(module, exports) {

$parcel$export(module.exports, "DummyContext", () => $116fd4bcb20cfc63$export$bc5f2fd86e1bc223);

var $gztBd = parcelRequire("gztBd");

var $65zZ5 = parcelRequire("65zZ5");
class $116fd4bcb20cfc63$export$bc5f2fd86e1bc223 extends (0, $65zZ5.BaseContext) {
    constructor(){
        super(...arguments);
        this.lookAhead = 0;
        this.latencyHint = 0;
        this.isOffline = false;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return {};
    }
    createOscillator() {
        return {};
    }
    createBufferSource() {
        return {};
    }
    createBiquadFilter() {
        return {};
    }
    createBuffer(_numberOfChannels, _length, _sampleRate) {
        return {};
    }
    createChannelMerger(_numberOfInputs) {
        return {};
    }
    createChannelSplitter(_numberOfOutputs) {
        return {};
    }
    createConstantSource() {
        return {};
    }
    createConvolver() {
        return {};
    }
    createDelay(_maxDelayTime) {
        return {};
    }
    createDynamicsCompressor() {
        return {};
    }
    createGain() {
        return {};
    }
    createIIRFilter(_feedForward, _feedback) {
        return {};
    }
    createPanner() {
        return {};
    }
    createPeriodicWave(_real, _imag, _constraints) {
        return {};
    }
    createStereoPanner() {
        return {};
    }
    createWaveShaper() {
        return {};
    }
    createMediaStreamSource(_stream) {
        return {};
    }
    createMediaElementSource(_element) {
        return {};
    }
    createMediaStreamDestination() {
        return {};
    }
    decodeAudioData(_audioData) {
        return Promise.resolve({});
    }
    //---------------------------
    // TONE AUDIO CONTEXT METHODS
    //---------------------------
    createAudioWorkletNode(_name, _options) {
        return {};
    }
    get rawContext() {
        return {};
    }
    addAudioWorkletModule(_url, _name) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return Promise.resolve();
        });
    }
    resume() {
        return Promise.resolve();
    }
    setTimeout(_fn, _timeout) {
        return 0;
    }
    clearTimeout(_id) {
        return this;
    }
    setInterval(_fn, _interval) {
        return 0;
    }
    clearInterval(_id) {
        return this;
    }
    getConstant(_val) {
        return {};
    }
    get currentTime() {
        return 0;
    }
    get state() {
        return {};
    }
    get sampleRate() {
        return 0;
    }
    get listener() {
        return {};
    }
    get transport() {
        return {};
    }
    get draw() {
        return {};
    }
    set draw(_d) {}
    get destination() {
        return {};
    }
    set destination(_d) {}
    now() {
        return 0;
    }
    immediate() {
        return 0;
    }
}

});

parcelRegister("iHery", function(module, exports) {

$parcel$export(module.exports, "OfflineContext", () => $d9c7724f9ad8d557$export$46814dd5412c611c);

var $gztBd = parcelRequire("gztBd");

var $lQat4 = parcelRequire("lQat4");

var $g8ux3 = parcelRequire("g8ux3");

var $9rnZW = parcelRequire("9rnZW");

var $9j0vm = parcelRequire("9j0vm");
class $d9c7724f9ad8d557$export$46814dd5412c611c extends (0, $g8ux3.Context) {
    constructor(){
        super({
            clockSource: "offline",
            context: (0, $9rnZW.isOfflineAudioContext)(arguments[0]) ? arguments[0] : (0, $lQat4.createOfflineAudioContext)(arguments[0], arguments[1] * arguments[2], arguments[2]),
            lookAhead: 0,
            updateInterval: (0, $9rnZW.isOfflineAudioContext)(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
        });
        this.name = "OfflineContext";
        /**
         * An artificial clock source
         */ this._currentTime = 0;
        this.isOffline = true;
        this._duration = (0, $9rnZW.isOfflineAudioContext)(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
    }
    /**
     * Override the now method to point to the internal clock time
     */ now() {
        return this._currentTime;
    }
    /**
     * Same as this.now()
     */ get currentTime() {
        return this._currentTime;
    }
    /**
     * Render just the clock portion of the audio context.
     */ _renderClock(asynchronous) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            let index = 0;
            while(this._duration - this._currentTime >= 0){
                // invoke all the callbacks on that time
                this.emit("tick");
                // increment the clock in block-sized chunks
                this._currentTime += 128 / this.sampleRate;
                // yield once a second of audio
                index++;
                const yieldEvery = Math.floor(this.sampleRate / 128);
                if (asynchronous && index % yieldEvery === 0) yield new Promise((done)=>setTimeout(done, 1));
            }
        });
    }
    /**
     * Render the output of the OfflineContext
     * @param asynchronous If the clock should be rendered asynchronously, which will not block the main thread, but be slightly slower.
     */ render(asynchronous = true) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            yield this.workletsAreReady();
            yield this._renderClock(asynchronous);
            const buffer = yield this._context.startRendering();
            return new (0, $9j0vm.ToneAudioBuffer)(buffer);
        });
    }
    /**
     * Close the context
     */ close() {
        return Promise.resolve();
    }
}

});
parcelRegister("9j0vm", function(module, exports) {

$parcel$export(module.exports, "ToneAudioBuffer", () => $6c6647a9ac9188cf$export$424a335715b38178);

var $gztBd = parcelRequire("gztBd");

var $1Uvh8 = parcelRequire("1Uvh8");

var $jiVAa = parcelRequire("jiVAa");

var $9rnZW = parcelRequire("9rnZW");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $6Utwn = parcelRequire("6Utwn");
class $6c6647a9ac9188cf$export$424a335715b38178 extends (0, $jiVAa.Tone) {
    constructor(){
        super();
        this.name = "ToneAudioBuffer";
        /**
         * Callback when the buffer is loaded.
         */ this.onload = (0, $AD7W4.noOp);
        const options = (0, $l4RVz.optionsFromArguments)($6c6647a9ac9188cf$export$424a335715b38178.getDefaults(), arguments, [
            "url",
            "onload",
            "onerror"
        ]);
        this.reverse = options.reverse;
        this.onload = options.onload;
        if (options.url && (0, $9rnZW.isAudioBuffer)(options.url) || options.url instanceof $6c6647a9ac9188cf$export$424a335715b38178) this.set(options.url);
        else if ((0, $lQ01C.isString)(options.url)) // initiate the download
        this.load(options.url).catch(options.onerror);
    }
    static getDefaults() {
        return {
            onerror: (0, $AD7W4.noOp),
            onload: (0, $AD7W4.noOp),
            reverse: false
        };
    }
    /**
     * The sample rate of the AudioBuffer
     */ get sampleRate() {
        if (this._buffer) return this._buffer.sampleRate;
        else return (0, $1Uvh8.getContext)().sampleRate;
    }
    /**
     * Pass in an AudioBuffer or ToneAudioBuffer to set the value of this buffer.
     */ set(buffer) {
        if (buffer instanceof $6c6647a9ac9188cf$export$424a335715b38178) {
            // if it's loaded, set it
            if (buffer.loaded) this._buffer = buffer.get();
            else // otherwise when it's loaded, invoke it's callback
            buffer.onload = ()=>{
                this.set(buffer);
                this.onload(this);
            };
        } else this._buffer = buffer;
        // reverse it initially
        if (this._reversed) this._reverse();
        return this;
    }
    /**
     * The audio buffer stored in the object.
     */ get() {
        return this._buffer;
    }
    /**
     * Makes an fetch request for the selected url then decodes the file as an audio buffer.
     * Invokes the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     * @returns A Promise which resolves with this ToneAudioBuffer
     */ load(url) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const doneLoading = $6c6647a9ac9188cf$export$424a335715b38178.load(url).then((audioBuffer)=>{
                this.set(audioBuffer);
                // invoke the onload method
                this.onload(this);
            });
            $6c6647a9ac9188cf$export$424a335715b38178.downloads.push(doneLoading);
            try {
                yield doneLoading;
            } finally{
                // remove the downloaded file
                const index = $6c6647a9ac9188cf$export$424a335715b38178.downloads.indexOf(doneLoading);
                $6c6647a9ac9188cf$export$424a335715b38178.downloads.splice(index, 1);
            }
            return this;
        });
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._buffer = undefined;
        return this;
    }
    /**
     * Set the audio buffer from the array.
     * To create a multichannel AudioBuffer, pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     */ fromArray(array) {
        const isMultidimensional = (0, $lQ01C.isArray)(array) && array[0].length > 0;
        const channels = isMultidimensional ? array.length : 1;
        const len = isMultidimensional ? array[0].length : array.length;
        const context = (0, $1Uvh8.getContext)();
        const buffer = context.createBuffer(channels, len, context.sampleRate);
        const multiChannelArray = !isMultidimensional && channels === 1 ? [
            array
        ] : array;
        for(let c = 0; c < channels; c++)buffer.copyToChannel(multiChannelArray[c], c);
        this._buffer = buffer;
        return this;
    }
    /**
     * Sums multiple channels into 1 channel
     * @param chanNum Optionally only copy a single channel from the array.
     */ toMono(chanNum) {
        if ((0, $lQ01C.isNumber)(chanNum)) this.fromArray(this.toArray(chanNum));
        else {
            let outputArray = new Float32Array(this.length);
            const numChannels = this.numberOfChannels;
            for(let channel = 0; channel < numChannels; channel++){
                const channelArray = this.toArray(channel);
                for(let i = 0; i < channelArray.length; i++)outputArray[i] += channelArray[i];
            }
            // divide by the number of channels
            outputArray = outputArray.map((sample)=>sample / numChannels);
            this.fromArray(outputArray);
        }
        return this;
    }
    /**
     * Get the buffer as an array. Single channel buffers will return a 1-dimensional
     * Float32Array, and multichannel buffers will return multidimensional arrays.
     * @param channel Optionally only copy a single channel from the array.
     */ toArray(channel) {
        if ((0, $lQ01C.isNumber)(channel)) return this.getChannelData(channel);
        else if (this.numberOfChannels === 1) return this.toArray(0);
        else {
            const ret = [];
            for(let c = 0; c < this.numberOfChannels; c++)ret[c] = this.getChannelData(c);
            return ret;
        }
    }
    /**
     * Returns the Float32Array representing the PCM audio data for the specific channel.
     * @param  channel  The channel number to return
     * @return The audio as a TypedArray
     */ getChannelData(channel) {
        if (this._buffer) return this._buffer.getChannelData(channel);
        else return new Float32Array(0);
    }
    /**
     * Cut a subsection of the array and return a buffer of the
     * subsection. Does not modify the original buffer
     * @param start The time to start the slice
     * @param end The end time to slice. If none is given will default to the end of the buffer
     */ slice(start, end = this.duration) {
        const startSamples = Math.floor(start * this.sampleRate);
        const endSamples = Math.floor(end * this.sampleRate);
        (0, $6Utwn.assert)(startSamples < endSamples, "The start time must be less than the end time");
        const length = endSamples - startSamples;
        const retBuffer = (0, $1Uvh8.getContext)().createBuffer(this.numberOfChannels, length, this.sampleRate);
        for(let channel = 0; channel < this.numberOfChannels; channel++)retBuffer.copyToChannel(this.getChannelData(channel).subarray(startSamples, endSamples), channel);
        return new $6c6647a9ac9188cf$export$424a335715b38178(retBuffer);
    }
    /**
     * Reverse the buffer.
     */ _reverse() {
        if (this.loaded) for(let i = 0; i < this.numberOfChannels; i++)this.getChannelData(i).reverse();
        return this;
    }
    /**
     * If the buffer is loaded or not
     */ get loaded() {
        return this.length > 0;
    }
    /**
     * The duration of the buffer in seconds.
     */ get duration() {
        if (this._buffer) return this._buffer.duration;
        else return 0;
    }
    /**
     * The length of the buffer in samples
     */ get length() {
        if (this._buffer) return this._buffer.length;
        else return 0;
    }
    /**
     * The number of discrete audio channels. Returns 0 if no buffer is loaded.
     */ get numberOfChannels() {
        if (this._buffer) return this._buffer.numberOfChannels;
        else return 0;
    }
    /**
     * Reverse the buffer.
     */ get reverse() {
        return this._reversed;
    }
    set reverse(rev) {
        if (this._reversed !== rev) {
            this._reversed = rev;
            this._reverse();
        }
    }
    /**
     * Create a ToneAudioBuffer from the array. To create a multichannel AudioBuffer,
     * pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     * @return A ToneAudioBuffer created from the array
     */ static fromArray(array) {
        return new $6c6647a9ac9188cf$export$424a335715b38178().fromArray(array);
    }
    /**
     * Creates a ToneAudioBuffer from a URL, returns a promise which resolves to a ToneAudioBuffer
     * @param  url The url to load.
     * @return A promise which resolves to a ToneAudioBuffer
     */ static fromUrl(url) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const buffer = new $6c6647a9ac9188cf$export$424a335715b38178();
            return yield buffer.load(url);
        });
    }
    /**
     * Loads a url using fetch and returns the AudioBuffer.
     */ static load(url) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            // test if the url contains multiple extensions
            const matches = url.match(/\[([^\]\[]+\|.+)\]$/);
            if (matches) {
                const extensions = matches[1].split("|");
                let extension = extensions[0];
                for (const ext of extensions)if ($6c6647a9ac9188cf$export$424a335715b38178.supportsType(ext)) {
                    extension = ext;
                    break;
                }
                url = url.replace(matches[0], extension);
            }
            // make sure there is a slash between the baseUrl and the url
            const baseUrl = $6c6647a9ac9188cf$export$424a335715b38178.baseUrl === "" || $6c6647a9ac9188cf$export$424a335715b38178.baseUrl.endsWith("/") ? $6c6647a9ac9188cf$export$424a335715b38178.baseUrl : $6c6647a9ac9188cf$export$424a335715b38178.baseUrl + "/";
            const response = yield fetch(baseUrl + url);
            if (!response.ok) throw new Error(`could not load url: ${url}`);
            const arrayBuffer = yield response.arrayBuffer();
            const audioBuffer = yield (0, $1Uvh8.getContext)().decodeAudioData(arrayBuffer);
            return audioBuffer;
        });
    }
    /**
     * Checks a url's extension to see if the current browser can play that file type.
     * @param url The url/extension to test
     * @return If the file extension can be played
     * @static
     * @example
     * Tone.ToneAudioBuffer.supportsType("wav"); // returns true
     * Tone.ToneAudioBuffer.supportsType("path/to/file.wav"); // returns true
     */ static supportsType(url) {
        const extensions = url.split(".");
        const extension = extensions[extensions.length - 1];
        const response = document.createElement("audio").canPlayType("audio/" + extension);
        return response !== "";
    }
    /**
     * Returns a Promise which resolves when all of the buffers have loaded
     */ static loaded() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            // this makes sure that the function is always async
            yield Promise.resolve();
            while($6c6647a9ac9188cf$export$424a335715b38178.downloads.length)yield $6c6647a9ac9188cf$export$424a335715b38178.downloads[0];
        });
    }
}
//-------------------------------------
// STATIC METHODS
//-------------------------------------
/**
 * A path which is prefixed before every url.
 */ $6c6647a9ac9188cf$export$424a335715b38178.baseUrl = "";
/**
 * All of the downloads
 */ $6c6647a9ac9188cf$export$424a335715b38178.downloads = [];

});
parcelRegister("AD7W4", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $06e1b6b6b0672803$export$b2cbc93d4da94977);
$parcel$export(module.exports, "writable", () => $06e1b6b6b0672803$export$e6d3eada50a007b1);
$parcel$export(module.exports, "noOp", () => $06e1b6b6b0672803$export$b50b6e108474309b);

var $lQ01C = parcelRequire("lQ01C");
function $06e1b6b6b0672803$export$b2cbc93d4da94977(target, property) {
    if ((0, $lQ01C.isArray)(property)) property.forEach((str)=>$06e1b6b6b0672803$export$b2cbc93d4da94977(target, str));
    else Object.defineProperty(target, property, {
        enumerable: true,
        writable: false
    });
}
function $06e1b6b6b0672803$export$e6d3eada50a007b1(target, property) {
    if ((0, $lQ01C.isArray)(property)) property.forEach((str)=>$06e1b6b6b0672803$export$e6d3eada50a007b1(target, str));
    else Object.defineProperty(target, property, {
        writable: true
    });
}
const $06e1b6b6b0672803$export$b50b6e108474309b = ()=>{
// no operation here!
};

});




parcelRegister("iiMGd", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("fDBOr")).connect);
$parcel$export(module.exports, "Context", () => (parcelRequire("g8ux3")).Context);
$parcel$export(module.exports, "dbToGain", () => (parcelRequire("bmU6v")).dbToGain);
$parcel$export(module.exports, "Frequency", () => (parcelRequire("aZf7A")).Frequency);
$parcel$export(module.exports, "Gain", () => (parcelRequire("bdbZZ")).Gain);
$parcel$export(module.exports, "gainToDb", () => (parcelRequire("bmU6v")).gainToDb);
$parcel$export(module.exports, "intervalToFrequencyRatio", () => (parcelRequire("bmU6v")).intervalToFrequencyRatio);
$parcel$export(module.exports, "isString", () => (parcelRequire("lQ01C")).isString);
$parcel$export(module.exports, "Midi", () => (parcelRequire("3xSib")).Midi);
$parcel$export(module.exports, "optionsFromArguments", () => (parcelRequire("l4RVz")).optionsFromArguments);
$parcel$export(module.exports, "ToneAudioBuffers", () => (parcelRequire("iace4")).ToneAudioBuffers);
$parcel$export(module.exports, "ToneAudioNode", () => (parcelRequire("fDBOr")).ToneAudioNode);
$parcel$export(module.exports, "LFO", () => (parcelRequire("lNxm0")).LFO);
$parcel$export(module.exports, "Player", () => (parcelRequire("ihNA0")).Player);
$parcel$export(module.exports, "ToneBufferSource", () => (parcelRequire("a0u4l")).ToneBufferSource);
$parcel$export(module.exports, "DuoSynth", () => (parcelRequire("dDgqq")).DuoSynth);
$parcel$export(module.exports, "MonoSynth", () => (parcelRequire("kNUCa")).MonoSynth);
$parcel$export(module.exports, "NoiseSynth", () => (parcelRequire("kCoIg")).NoiseSynth);
$parcel$export(module.exports, "PolySynth", () => (parcelRequire("ksj9M")).PolySynth);
$parcel$export(module.exports, "Sampler", () => (parcelRequire("7u8Jf")).Sampler);
$parcel$export(module.exports, "Loop", () => (parcelRequire("iilfj")).Loop);
$parcel$export(module.exports, "Distortion", () => (parcelRequire("1ZLI2")).Distortion);
$parcel$export(module.exports, "FeedbackDelay", () => (parcelRequire("gtyBS")).FeedbackDelay);
$parcel$export(module.exports, "PitchShift", () => (parcelRequire("e3S5U")).PitchShift);
$parcel$export(module.exports, "Reverb", () => (parcelRequire("7FIGc")).Reverb);
$parcel$export(module.exports, "Analyser", () => (parcelRequire("kzedo")).Analyser);
$parcel$export(module.exports, "BiquadFilter", () => (parcelRequire("Lvs5H")).BiquadFilter);
$parcel$export(module.exports, "Channel", () => (parcelRequire("1x3k0")).Channel);
$parcel$export(module.exports, "Filter", () => (parcelRequire("82Hwq")).Filter);
$parcel$export(module.exports, "Limiter", () => (parcelRequire("2AuBL")).Limiter);
$parcel$export(module.exports, "Meter", () => (parcelRequire("lUFsy")).Meter);
$parcel$export(module.exports, "MultibandSplit", () => (parcelRequire("jT0OW")).MultibandSplit);
$parcel$export(module.exports, "Panner", () => (parcelRequire("32Bfc")).Panner);
$parcel$export(module.exports, "Volume", () => (parcelRequire("dTGN1")).Volume);
parcelRequire("2QzBp");
parcelRequire("fpcpv");
parcelRequire("gRGwA");
parcelRequire("1PYwV");
parcelRequire("dvGZu");
parcelRequire("6WaTy");
parcelRequire("esw2V");

});
parcelRegister("2QzBp", function(module, exports) {
$parcel$export(module.exports, "Context", () => (parcelRequire("g8ux3")).Context);
$parcel$export(module.exports, "Gain", () => (parcelRequire("bdbZZ")).Gain);
$parcel$export(module.exports, "ToneAudioBuffers", () => (parcelRequire("iace4")).ToneAudioBuffers);
$parcel$export(module.exports, "connect", () => (parcelRequire("fDBOr")).connect);
$parcel$export(module.exports, "ToneAudioNode", () => (parcelRequire("fDBOr")).ToneAudioNode);
$parcel$export(module.exports, "Frequency", () => (parcelRequire("aZf7A")).Frequency);
$parcel$export(module.exports, "Midi", () => (parcelRequire("3xSib")).Midi);
$parcel$export(module.exports, "isString", () => (parcelRequire("lQ01C")).isString);

$parcel$export(module.exports, "dbToGain", () => (parcelRequire("bmU6v")).dbToGain);
$parcel$export(module.exports, "gainToDb", () => (parcelRequire("bmU6v")).gainToDb);
$parcel$export(module.exports, "intervalToFrequencyRatio", () => (parcelRequire("bmU6v")).intervalToFrequencyRatio);
$parcel$export(module.exports, "optionsFromArguments", () => (parcelRequire("l4RVz")).optionsFromArguments);
parcelRequire("c60dh");
parcelRequire("g8ux3");
parcelRequire("65zZ5");
parcelRequire("eQyMC");
parcelRequire("bdbZZ");
parcelRequire("lCjr4");
parcelRequire("iHery");
parcelRequire("lQP4J");
parcelRequire("9j0vm");
parcelRequire("iace4");
parcelRequire("fDBOr");
parcelRequire("aZf7A");
parcelRequire("3xSib");
parcelRequire("ihY3q");
parcelRequire("a5kVC");
parcelRequire("31EKY");
parcelRequire("1K86j");
parcelRequire("cwPvC");
parcelRequire("83d8Z");
parcelRequire("4nQXi");
parcelRequire("kjPdm");
parcelRequire("lQ01C");

var $bmU6v = parcelRequire("bmU6v");

var $l4RVz = parcelRequire("l4RVz");

var $cC8ra = parcelRequire("cC8ra");

var $6Utwn = parcelRequire("6Utwn");

});
parcelRegister("c60dh", function(module, exports) {

$parcel$export(module.exports, "Clock", () => $8ce635ebcc921f39$export$9735c82c4bae3302);

var $lXP1H = parcelRequire("lXP1H");

var $l4RVz = parcelRequire("l4RVz");

var $cwPvC = parcelRequire("cwPvC");

var $AD7W4 = parcelRequire("AD7W4");

var $4nQXi = parcelRequire("4nQXi");

var $eDK9c = parcelRequire("eDK9c");

var $6Utwn = parcelRequire("6Utwn");
class $8ce635ebcc921f39$export$9735c82c4bae3302 extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($8ce635ebcc921f39$export$9735c82c4bae3302.getDefaults(), arguments, [
            "callback",
            "frequency"
        ]));
        this.name = "Clock";
        /**
         * The callback function to invoke at the scheduled tick.
         */ this.callback = (0, $AD7W4.noOp);
        /**
         * The last time the loop callback was invoked
         */ this._lastUpdate = 0;
        /**
         * Keep track of the playback state
         */ this._state = new (0, $4nQXi.StateTimeline)("stopped");
        /**
         * Context bound reference to the _loop method
         * This is necessary to remove the event in the end.
         */ this._boundLoop = this._loop.bind(this);
        const options = (0, $l4RVz.optionsFromArguments)($8ce635ebcc921f39$export$9735c82c4bae3302.getDefaults(), arguments, [
            "callback",
            "frequency"
        ]);
        this.callback = options.callback;
        this._tickSource = new (0, $eDK9c.TickSource)({
            context: this.context,
            frequency: options.frequency,
            units: options.units
        });
        this._lastUpdate = 0;
        this.frequency = this._tickSource.frequency;
        (0, $AD7W4.readOnly)(this, "frequency");
        // add an initial state
        this._state.setStateAtTime("stopped", 0);
        // bind a callback to the worker thread
        this.context.on("tick", this._boundLoop);
    }
    static getDefaults() {
        return Object.assign((0, $lXP1H.ToneWithContext).getDefaults(), {
            callback: (0, $AD7W4.noOp),
            frequency: 1,
            units: "hertz"
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this._state.getValueAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset  Where the tick counter starts counting from.
     */ start(time, offset) {
        // make sure the context is running
        (0, $6Utwn.assertContextRunning)(this.context);
        // start the loop
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            this._tickSource.start(computedTime, offset);
            if (computedTime < this._lastUpdate) this.emit("start", computedTime, offset);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     * @example
     * const clock = new Tone.Clock(time => {
     * 	console.log(time);
     * }, 1);
     * clock.start();
     * // stop the clock after 10 seconds
     * clock.stop("+10");
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        this.log("stop", computedTime);
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this._tickSource.stop(computedTime);
        if (computedTime < this._lastUpdate) this.emit("stop", computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") {
            this._state.setStateAtTime("paused", computedTime);
            this._tickSource.pause(computedTime);
            if (computedTime < this._lastUpdate) this.emit("pause", computedTime);
        }
        return this;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked.
     */ get ticks() {
        return Math.ceil(this.getTicksAtTime(this.now()));
    }
    set ticks(t) {
        this._tickSource.ticks = t;
    }
    /**
     * The time since ticks=0 that the Clock has been running. Accounts for tempo curves
     */ get seconds() {
        return this._tickSource.seconds;
    }
    set seconds(s) {
        this._tickSource.seconds = s;
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._tickSource.getSecondsAtTime(time);
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        this._tickSource.setTicksAtTime(ticks, time);
        return this;
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        return this._tickSource.getTimeOfTick(tick, before);
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return this._tickSource.getTicksAtTime(time);
    }
    /**
     * Get the time of the next tick
     * @param  offset The tick number.
     */ nextTickTime(offset, when) {
        const computedTime = this.toSeconds(when);
        const currentTick = this.getTicksAtTime(computedTime);
        return this._tickSource.getTimeOfTick(currentTick + offset, computedTime);
    }
    /**
     * The scheduling loop.
     */ _loop() {
        const startTime = this._lastUpdate;
        const endTime = this.now();
        this._lastUpdate = endTime;
        this.log("loop", startTime, endTime);
        if (startTime !== endTime) {
            // the state change events
            this._state.forEachBetween(startTime, endTime, (e)=>{
                switch(e.state){
                    case "started":
                        const offset = this._tickSource.getTicksAtTime(e.time);
                        this.emit("start", e.time, offset);
                        break;
                    case "stopped":
                        if (e.time !== 0) this.emit("stop", e.time);
                        break;
                    case "paused":
                        this.emit("pause", e.time);
                        break;
                }
            });
            // the tick callbacks
            this._tickSource.forEachTickBetween(startTime, endTime, (time, ticks)=>{
                this.callback(time, ticks);
            });
        }
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     * @example
     * const clock = new Tone.Clock();
     * clock.start("+0.1");
     * clock.getStateAtTime("+0.1"); // returns "started"
     */ getStateAtTime(time) {
        const computedTime = this.toSeconds(time);
        return this._state.getValueAtTime(computedTime);
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.context.off("tick", this._boundLoop);
        this._tickSource.dispose();
        this._state.dispose();
        return this;
    }
}
(0, $cwPvC.Emitter).mixin($8ce635ebcc921f39$export$9735c82c4bae3302);

});
parcelRegister("lXP1H", function(module, exports) {

$parcel$export(module.exports, "ToneWithContext", () => $ffd6b06ea7b819d7$export$4eb0ca57400aa172);

var $1Uvh8 = parcelRequire("1Uvh8");

var $jiVAa = parcelRequire("jiVAa");

var $aZf7A = parcelRequire("aZf7A");

var $ihY3q = parcelRequire("ihY3q");

var $31EKY = parcelRequire("31EKY");

var $l4RVz = parcelRequire("l4RVz");

var $lQ01C = parcelRequire("lQ01C");
class $ffd6b06ea7b819d7$export$4eb0ca57400aa172 extends (0, $jiVAa.Tone) {
    constructor(){
        super();
        const options = (0, $l4RVz.optionsFromArguments)($ffd6b06ea7b819d7$export$4eb0ca57400aa172.getDefaults(), arguments, [
            "context"
        ]);
        if (this.defaultContext) this.context = this.defaultContext;
        else this.context = options.context;
    }
    static getDefaults() {
        return {
            context: (0, $1Uvh8.getContext)()
        };
    }
    /**
     * Return the current time of the Context clock plus the lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.now());
     * }, 100);
     */ now() {
        return this.context.currentTime + this.context.lookAhead;
    }
    /**
     * Return the current time of the Context clock without any lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.immediate());
     * }, 100);
     */ immediate() {
        return this.context.currentTime;
    }
    /**
     * The duration in seconds of one sample.
     * @example
     * console.log(Tone.Transport.sampleTime);
     */ get sampleTime() {
        return 1 / this.context.sampleRate;
    }
    /**
     * The number of seconds of 1 processing block (128 samples)
     * @example
     * console.log(Tone.Destination.blockTime);
     */ get blockTime() {
        return 128 / this.context.sampleRate;
    }
    /**
     * Convert the incoming time to seconds.
     * This is calculated against the current [[Tone.Transport]] bpm
     * @example
     * const gain = new Tone.Gain();
     * setInterval(() => console.log(gain.toSeconds("4n")), 100);
     * // ramp the tempo to 60 bpm over 30 seconds
     * Tone.getTransport().bpm.rampTo(60, 30);
     */ toSeconds(time) {
        return new (0, $ihY3q.TimeClass)(this.context, time).toSeconds();
    }
    /**
     * Convert the input to a frequency number
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toFrequency("4n"));
     */ toFrequency(freq) {
        return new (0, $aZf7A.FrequencyClass)(this.context, freq).toFrequency();
    }
    /**
     * Convert the input time into ticks
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toTicks("4n"));
     */ toTicks(time) {
        return new (0, $31EKY.TransportTimeClass)(this.context, time).toTicks();
    }
    //-------------------------------------
    // 	GET/SET
    //-------------------------------------
    /**
     * Get a subset of the properties which are in the partial props
     */ _getPartialProperties(props) {
        const options = this.get();
        // remove attributes from the prop that are not in the partial
        Object.keys(options).forEach((name)=>{
            if ((0, $lQ01C.isUndef)(props[name])) delete options[name];
        });
        return options;
    }
    /**
     * Get the object's attributes.
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.get());
     */ get() {
        const defaults = (0, $l4RVz.getDefaultsFromInstance)(this);
        Object.keys(defaults).forEach((attribute)=>{
            if (Reflect.has(this, attribute)) {
                const member = this[attribute];
                if ((0, $lQ01C.isDefined)(member) && (0, $lQ01C.isDefined)(member.value) && (0, $lQ01C.isDefined)(member.setValueAtTime)) defaults[attribute] = member.value;
                else if (member instanceof $ffd6b06ea7b819d7$export$4eb0ca57400aa172) defaults[attribute] = member._getPartialProperties(defaults[attribute]);
                else if ((0, $lQ01C.isArray)(member) || (0, $lQ01C.isNumber)(member) || (0, $lQ01C.isString)(member) || (0, $lQ01C.isBoolean)(member)) defaults[attribute] = member;
                else // remove all undefined and unserializable attributes
                delete defaults[attribute];
            }
        });
        return defaults;
    }
    /**
     * Set multiple properties at once with an object.
     * @example
     * const filter = new Tone.Filter().toDestination();
     * // set values using an object
     * filter.set({
     * 	frequency: "C6",
     * 	type: "highpass"
     * });
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/Analogsynth_octaves_highmid.mp3").connect(filter);
     * player.autostart = true;
     */ set(props) {
        Object.keys(props).forEach((attribute)=>{
            if (Reflect.has(this, attribute) && (0, $lQ01C.isDefined)(this[attribute])) {
                if (this[attribute] && (0, $lQ01C.isDefined)(this[attribute].value) && (0, $lQ01C.isDefined)(this[attribute].setValueAtTime)) // small optimization
                {
                    if (this[attribute].value !== props[attribute]) this[attribute].value = props[attribute];
                } else if (this[attribute] instanceof $ffd6b06ea7b819d7$export$4eb0ca57400aa172) this[attribute].set(props[attribute]);
                else this[attribute] = props[attribute];
            }
        });
        return this;
    }
}

});
parcelRegister("aZf7A", function(module, exports) {

$parcel$export(module.exports, "FrequencyClass", () => $7ffb54b0361d5df6$export$38b56155c8552868);
$parcel$export(module.exports, "Frequency", () => $7ffb54b0361d5df6$export$44c95d3770756ed2);

var $1Uvh8 = parcelRequire("1Uvh8");

var $bmU6v = parcelRequire("bmU6v");

var $ihY3q = parcelRequire("ihY3q");
class $7ffb54b0361d5df6$export$38b56155c8552868 extends (0, $ihY3q.TimeClass) {
    constructor(){
        super(...arguments);
        this.name = "Frequency";
        this.defaultUnits = "hz";
    }
    /**
     * The [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
     * to generate all the other pitch values from notes. A4's values in Hertz.
     */ static get A4() {
        return (0, $bmU6v.getA4)();
    }
    static set A4(freq) {
        (0, $bmU6v.setA4)(freq);
    }
    //-------------------------------------
    // 	AUGMENT BASE EXPRESSIONS
    //-------------------------------------
    _getExpressions() {
        return Object.assign({}, super._getExpressions(), {
            midi: {
                regexp: /^(\d+(?:\.\d+)?midi)/,
                method (value) {
                    if (this.defaultUnits === "midi") return value;
                    else return $7ffb54b0361d5df6$export$38b56155c8552868.mtof(value);
                }
            },
            note: {
                regexp: /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i,
                method (pitch, octave) {
                    const index = $7ffb54b0361d5df6$var$noteToScaleIndex[pitch.toLowerCase()];
                    const noteNumber = index + (parseInt(octave, 10) + 1) * 12;
                    if (this.defaultUnits === "midi") return noteNumber;
                    else return $7ffb54b0361d5df6$export$38b56155c8552868.mtof(noteNumber);
                }
            },
            tr: {
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                method (m, q, s) {
                    let total = 1;
                    if (m && m !== "0") total *= this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total *= this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total *= this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                }
            }
        });
    }
    //-------------------------------------
    // 	EXPRESSIONS
    //-------------------------------------
    /**
     * Transposes the frequency by the given number of semitones.
     * @return  A new transposed frequency
     * @example
     * Tone.Frequency("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $7ffb54b0361d5df6$export$38b56155c8552868(this.context, this.valueOf() * (0, $bmU6v.intervalToFrequencyRatio)(interval));
    }
    /**
     * Takes an array of semitone intervals and returns
     * an array of frequencies transposed by those intervals.
     * @return  Returns an array of Frequencies
     * @example
     * Tone.Frequency("A4").harmonize([0, 3, 7]); // ["A4", "C5", "E5"]
     */ harmonize(intervals) {
        return intervals.map((interval)=>{
            return this.transpose(interval);
        });
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Frequency("C4").toMidi(); // 60
     */ toMidi() {
        return (0, $bmU6v.ftom)(this.valueOf());
    }
    /**
     * Return the value of the frequency in Scientific Pitch Notation
     * @example
     * Tone.Frequency(69, "midi").toNote(); // "A4"
     */ toNote() {
        const freq = this.toFrequency();
        const log = Math.log2(freq / $7ffb54b0361d5df6$export$38b56155c8552868.A4);
        let noteNumber = Math.round(12 * log) + 57;
        const octave = Math.floor(noteNumber / 12);
        if (octave < 0) noteNumber += -12 * octave;
        const noteName = $7ffb54b0361d5df6$var$scaleIndexToNote[noteNumber % 12];
        return noteName + octave.toString();
    }
    /**
     * Return the duration of one cycle in seconds.
     */ toSeconds() {
        return 1 / super.toSeconds();
    }
    /**
     * Return the duration of one cycle in ticks
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return Math.floor(quarters * this._getPPQ());
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS HELPERS
    //-------------------------------------
    /**
     * With no arguments, return 0
     */ _noArg() {
        return 0;
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return freq;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return 1 / (ticks * 60 / (this._getBpm() * this._getPPQ()));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 1 / super._beatsToUnits(beats);
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return 1 / seconds;
    }
    /**
     * Convert a MIDI note to frequency value.
     * @param  midi The midi number to convert.
     * @return The corresponding frequency value
     */ static mtof(midi) {
        return (0, $bmU6v.mtof)(midi);
    }
    /**
     * Convert a frequency value to a MIDI note.
     * @param frequency The value to frequency value to convert.
     */ static ftom(frequency) {
        return (0, $bmU6v.ftom)(frequency);
    }
}
//-------------------------------------
// 	FREQUENCY CONVERSIONS
//-------------------------------------
/**
 * Note to scale index.
 * @hidden
 */ const $7ffb54b0361d5df6$var$noteToScaleIndex = {
    cbb: -2,
    cb: -1,
    c: 0,
    "c#": 1,
    cx: 2,
    dbb: 0,
    db: 1,
    d: 2,
    "d#": 3,
    dx: 4,
    ebb: 2,
    eb: 3,
    e: 4,
    "e#": 5,
    ex: 6,
    fbb: 3,
    fb: 4,
    f: 5,
    "f#": 6,
    fx: 7,
    gbb: 5,
    gb: 6,
    g: 7,
    "g#": 8,
    gx: 9,
    abb: 7,
    ab: 8,
    a: 9,
    "a#": 10,
    ax: 11,
    bbb: 9,
    bb: 10,
    b: 11,
    "b#": 12,
    bx: 13
};
/**
 * scale index to note (sharps)
 * @hidden
 */ const $7ffb54b0361d5df6$var$scaleIndexToNote = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
function $7ffb54b0361d5df6$export$44c95d3770756ed2(value, units) {
    return new $7ffb54b0361d5df6$export$38b56155c8552868((0, $1Uvh8.getContext)(), value, units);
}

});
parcelRegister("bmU6v", function(module, exports) {

$parcel$export(module.exports, "dbToGain", () => $846d44d7e5d296e8$export$33ed28de027e9482);
$parcel$export(module.exports, "gainToDb", () => $846d44d7e5d296e8$export$6af3969727ca2a60);
$parcel$export(module.exports, "intervalToFrequencyRatio", () => $846d44d7e5d296e8$export$5d18fe46719f6008);
$parcel$export(module.exports, "getA4", () => $846d44d7e5d296e8$export$9f4826388a169ebd);
$parcel$export(module.exports, "setA4", () => $846d44d7e5d296e8$export$2a0f2ad6a5f8e4fe);
$parcel$export(module.exports, "ftom", () => $846d44d7e5d296e8$export$5cf9d9f9506eec5);
$parcel$export(module.exports, "ftomf", () => $846d44d7e5d296e8$export$12513e46625518e4);
$parcel$export(module.exports, "mtof", () => $846d44d7e5d296e8$export$45a6434f7c391dc);
/**
 * Equal power gain scale. Good for cross-fading.
 * @param  percent (0-1)
 */ function $846d44d7e5d296e8$export$bfc35d599238ec59(percent) {
    const piFactor = 0.5 * Math.PI;
    return Math.sin(percent * piFactor);
}
function $846d44d7e5d296e8$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}
function $846d44d7e5d296e8$export$6af3969727ca2a60(gain) {
    return 20 * (Math.log(gain) / Math.LN10);
}
function $846d44d7e5d296e8$export$5d18fe46719f6008(interval) {
    return Math.pow(2, interval / 12);
}
/**
 * The Global [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
 * to generate all the other pitch values from notes. A4's values in Hertz.
 */ let $846d44d7e5d296e8$var$A4 = 440;
function $846d44d7e5d296e8$export$9f4826388a169ebd() {
    return $846d44d7e5d296e8$var$A4;
}
function $846d44d7e5d296e8$export$2a0f2ad6a5f8e4fe(freq) {
    $846d44d7e5d296e8$var$A4 = freq;
}
function $846d44d7e5d296e8$export$5cf9d9f9506eec5(frequency) {
    return Math.round($846d44d7e5d296e8$export$12513e46625518e4(frequency));
}
function $846d44d7e5d296e8$export$12513e46625518e4(frequency) {
    return 69 + 12 * Math.log2(frequency / $846d44d7e5d296e8$var$A4);
}
function $846d44d7e5d296e8$export$45a6434f7c391dc(midi) {
    return $846d44d7e5d296e8$var$A4 * Math.pow(2, (midi - 69) / 12);
}

});

parcelRegister("ihY3q", function(module, exports) {

$parcel$export(module.exports, "TimeClass", () => $d508661131b29fdb$export$52b3039dca93a306);

var $1Uvh8 = parcelRequire("1Uvh8");

var $bmU6v = parcelRequire("bmU6v");

var $a0TKY = parcelRequire("a0TKY");
class $d508661131b29fdb$export$52b3039dca93a306 extends (0, $a0TKY.TimeBaseClass) {
    constructor(){
        super(...arguments);
        this.name = "TimeClass";
    }
    _getExpressions() {
        return Object.assign(super._getExpressions(), {
            now: {
                method: (capture)=>{
                    return this._now() + new this.constructor(this.context, capture).valueOf();
                },
                regexp: /^\+(.+)/
            },
            quantize: {
                method: (capture)=>{
                    const quantTo = new $d508661131b29fdb$export$52b3039dca93a306(this.context, capture).valueOf();
                    return this._secondsToUnits(this.context.transport.nextSubdivision(quantTo));
                },
                regexp: /^@(.+)/
            }
        });
    }
    /**
     * Quantize the time by the given subdivision. Optionally add a
     * percentage which will move the time value towards the ideal
     * quantized value by that percentage.
     * @param  subdiv    The subdivision to quantize to
     * @param  percent  Move the time value towards the quantized value by a percentage.
     * @example
     * Tone.Time(21).quantize(2); // returns 22
     * Tone.Time(0.6).quantize("4n", 0.5); // returns 0.55
     */ quantize(subdiv, percent = 1) {
        const subdivision = new this.constructor(this.context, subdiv).valueOf();
        const value = this.valueOf();
        const multiple = Math.round(value / subdivision);
        const ideal = multiple * subdivision;
        const diff = ideal - value;
        return value + diff * percent;
    }
    //-------------------------------------
    // CONVERSIONS
    //-------------------------------------
    /**
     * Convert a Time to Notation. The notation values are will be the
     * closest representation between 1m to 128th note.
     * @return {Notation}
     * @example
     * // if the Transport is at 120bpm:
     * Tone.Time(2).toNotation(); // returns "1m"
     */ toNotation() {
        const time = this.toSeconds();
        const testNotations = [
            "1m"
        ];
        for(let power = 1; power < 9; power++){
            const subdiv = Math.pow(2, power);
            testNotations.push(subdiv + "n.");
            testNotations.push(subdiv + "n");
            testNotations.push(subdiv + "t");
        }
        testNotations.push("0");
        // find the closets notation representation
        let closest = testNotations[0];
        let closestSeconds = new $d508661131b29fdb$export$52b3039dca93a306(this.context, testNotations[0]).toSeconds();
        testNotations.forEach((notation)=>{
            const notationSeconds = new $d508661131b29fdb$export$52b3039dca93a306(this.context, notation).toSeconds();
            if (Math.abs(notationSeconds - time) < Math.abs(closestSeconds - time)) {
                closest = notation;
                closestSeconds = notationSeconds;
            }
        });
        return closest;
    }
    /**
     * Return the time encoded as Bars:Beats:Sixteenths.
     */ toBarsBeatsSixteenths() {
        const quarterTime = this._beatsToUnits(1);
        let quarters = this.valueOf() / quarterTime;
        quarters = parseFloat(quarters.toFixed(4));
        const measures = Math.floor(quarters / this._getTimeSignature());
        let sixteenths = quarters % 1 * 4;
        quarters = Math.floor(quarters) % this._getTimeSignature();
        const sixteenthString = sixteenths.toString();
        if (sixteenthString.length > 3) // the additional parseFloat removes insignificant trailing zeroes
        sixteenths = parseFloat(parseFloat(sixteenthString).toFixed(3));
        const progress = [
            measures,
            quarters,
            sixteenths
        ];
        return progress.join(":");
    }
    /**
     * Return the time in ticks.
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return Math.round(quarters * this._getPPQ());
    }
    /**
     * Return the time in seconds.
     */ toSeconds() {
        return this.valueOf();
    }
    /**
     * Return the value as a midi note.
     */ toMidi() {
        return (0, $bmU6v.ftom)(this.toFrequency());
    }
    _now() {
        return this.context.now();
    }
}
function $d508661131b29fdb$export$680ea196effce5f(value, units) {
    return new $d508661131b29fdb$export$52b3039dca93a306((0, $1Uvh8.getContext)(), value, units);
}

});
parcelRegister("a0TKY", function(module, exports) {

$parcel$export(module.exports, "TimeBaseClass", () => $74a5278d9dc77e1a$export$23b5656976f56273);

var $jiVAa = parcelRequire("jiVAa");

var $lQ01C = parcelRequire("lQ01C");
class $74a5278d9dc77e1a$export$23b5656976f56273 extends (0, $jiVAa.Tone) {
    /**
     * @param context The context associated with the time value. Used to compute
     * Transport and context-relative timing.
     * @param  value  The time value as a number, string or object
     * @param  units  Unit values
     */ constructor(context, value, units){
        super();
        /**
         * The default units
         */ this.defaultUnits = "s";
        this._val = value;
        this._units = units;
        this.context = context;
        this._expressions = this._getExpressions();
    }
    /**
     * All of the time encoding expressions
     */ _getExpressions() {
        return {
            hz: {
                method: (value)=>{
                    return this._frequencyToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)hz$/i
            },
            i: {
                method: (value)=>{
                    return this._ticksToUnits(parseInt(value, 10));
                },
                regexp: /^(\d+)i$/i
            },
            m: {
                method: (value)=>{
                    return this._beatsToUnits(parseInt(value, 10) * this._getTimeSignature());
                },
                regexp: /^(\d+)m$/i
            },
            n: {
                method: (value, dot)=>{
                    const numericValue = parseInt(value, 10);
                    const scalar = dot === "." ? 1.5 : 1;
                    if (numericValue === 1) return this._beatsToUnits(this._getTimeSignature()) * scalar;
                    else return this._beatsToUnits(4 / numericValue) * scalar;
                },
                regexp: /^(\d+)n(\.?)$/i
            },
            number: {
                method: (value)=>{
                    return this._expressions[this.defaultUnits].method.call(this, value);
                },
                regexp: /^(\d+(?:\.\d+)?)$/
            },
            s: {
                method: (value)=>{
                    return this._secondsToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)s$/
            },
            samples: {
                method: (value)=>{
                    return parseInt(value, 10) / this.context.sampleRate;
                },
                regexp: /^(\d+)samples$/
            },
            t: {
                method: (value)=>{
                    const numericValue = parseInt(value, 10);
                    return this._beatsToUnits(8 / (Math.floor(numericValue) * 3));
                },
                regexp: /^(\d+)t$/i
            },
            tr: {
                method: (m, q, s)=>{
                    let total = 0;
                    if (m && m !== "0") total += this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total += this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total += this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                },
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/
            }
        };
    }
    //-------------------------------------
    // 	VALUE OF
    //-------------------------------------
    /**
     * Evaluate the time value. Returns the time in seconds.
     */ valueOf() {
        if (this._val instanceof $74a5278d9dc77e1a$export$23b5656976f56273) this.fromType(this._val);
        if ((0, $lQ01C.isUndef)(this._val)) return this._noArg();
        else if ((0, $lQ01C.isString)(this._val) && (0, $lQ01C.isUndef)(this._units)) {
            for(const units in this._expressions)if (this._expressions[units].regexp.test(this._val.trim())) {
                this._units = units;
                break;
            }
        } else if ((0, $lQ01C.isObject)(this._val)) {
            let total = 0;
            for(const typeName in this._val)if ((0, $lQ01C.isDefined)(this._val[typeName])) {
                const quantity = this._val[typeName];
                // @ts-ignore
                const time = new this.constructor(this.context, typeName).valueOf() * quantity;
                total += time;
            }
            return total;
        }
        if ((0, $lQ01C.isDefined)(this._units)) {
            const expr = this._expressions[this._units];
            const matching = this._val.toString().trim().match(expr.regexp);
            if (matching) return expr.method.apply(this, matching.slice(1));
            else return expr.method.call(this, this._val);
        } else if ((0, $lQ01C.isString)(this._val)) return parseFloat(this._val);
        else return this._val;
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return 1 / freq;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 60 / this._getBpm() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return seconds;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks * this._beatsToUnits(1) / this._getPPQ();
    }
    /**
     * With no arguments, return 'now'
     */ _noArg() {
        return this._now();
    }
    //-------------------------------------
    // 	TEMPO CONVERSIONS
    //-------------------------------------
    /**
     * Return the bpm
     */ _getBpm() {
        return this.context.transport.bpm.value;
    }
    /**
     * Return the timeSignature
     */ _getTimeSignature() {
        return this.context.transport.timeSignature;
    }
    /**
     * Return the PPQ or 192 if Transport is not available
     */ _getPPQ() {
        return this.context.transport.PPQ;
    }
    //-------------------------------------
    // 	CONVERSION INTERFACE
    //-------------------------------------
    /**
     * Coerce a time type into this units type.
     * @param type Any time type units
     */ fromType(type) {
        this._units = undefined;
        switch(this.defaultUnits){
            case "s":
                this._val = type.toSeconds();
                break;
            case "i":
                this._val = type.toTicks();
                break;
            case "hz":
                this._val = type.toFrequency();
                break;
            case "midi":
                this._val = type.toMidi();
                break;
        }
        return this;
    }
    /**
     * Return the value in hertz
     */ toFrequency() {
        return 1 / this.toSeconds();
    }
    /**
     * Return the time in samples
     */ toSamples() {
        return this.toSeconds() * this.context.sampleRate;
    }
    /**
     * Return the time in milliseconds.
     */ toMilliseconds() {
        return this.toSeconds() * 1000;
    }
}

});



parcelRegister("31EKY", function(module, exports) {

$parcel$export(module.exports, "TransportTimeClass", () => $2341147dfe61932a$export$c824041178a9697);

var $1Uvh8 = parcelRequire("1Uvh8");

var $ihY3q = parcelRequire("ihY3q");
class $2341147dfe61932a$export$c824041178a9697 extends (0, $ihY3q.TimeClass) {
    constructor(){
        super(...arguments);
        this.name = "TransportTime";
    }
    /**
     * Return the current time in whichever context is relevant
     */ _now() {
        return this.context.transport.seconds;
    }
}
function $2341147dfe61932a$export$c5a05eab537a3f95(value, units) {
    return new $2341147dfe61932a$export$c824041178a9697((0, $1Uvh8.getContext)(), value, units);
}

});


parcelRegister("4nQXi", function(module, exports) {

$parcel$export(module.exports, "StateTimeline", () => $3312633ba3e28dfb$export$89221a927ffadcaf);

var $kjPdm = parcelRequire("kjPdm");

var $6Utwn = parcelRequire("6Utwn");
class $3312633ba3e28dfb$export$89221a927ffadcaf extends (0, $kjPdm.Timeline) {
    constructor(initial = "stopped"){
        super();
        this.name = "StateTimeline";
        this._initial = initial;
        this.setStateAtTime(this._initial, 0);
    }
    /**
     * Returns the scheduled state scheduled before or at
     * the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     */ getValueAtTime(time) {
        const event = this.get(time);
        if (event !== null) return event.state;
        else return this._initial;
    }
    /**
     * Add a state to the timeline.
     * @param  state The name of the state to set.
     * @param  time  The time to query.
     * @param options Any additional options that are needed in the timeline.
     */ setStateAtTime(state, time, options) {
        (0, $6Utwn.assertRange)(time, 0);
        this.add(Object.assign({}, options, {
            state: state,
            time: time
        }));
        return this;
    }
    /**
     * Return the event before the time with the given state
     * @param  state The state to look for
     * @param  time  When to check before
     * @return  The event with the given state before the time
     */ getLastState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        for(let i = index; i >= 0; i--){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
    /**
     * Return the event after the time with the given state
     * @param  state The state to look for
     * @param  time  When to check from
     * @return  The event with the given state after the time
     */ getNextState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        if (index !== -1) for(let i = index; i < this._timeline.length; i++){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
}

});

parcelRegister("eDK9c", function(module, exports) {

$parcel$export(module.exports, "TickSource", () => $aa88812224633a70$export$617abaa845df50f1);

var $lXP1H = parcelRequire("lXP1H");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $4nQXi = parcelRequire("4nQXi");

var $kjPdm = parcelRequire("kjPdm");

var $lQ01C = parcelRequire("lQ01C");

var $bkZNL = parcelRequire("bkZNL");

var $j4WGs = parcelRequire("j4WGs");
class $aa88812224633a70$export$617abaa845df50f1 extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($aa88812224633a70$export$617abaa845df50f1.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "TickSource";
        /**
         * The state timeline
         */ this._state = new (0, $4nQXi.StateTimeline)();
        /**
         * The offset values of the ticks
         */ this._tickOffset = new (0, $kjPdm.Timeline)();
        const options = (0, $l4RVz.optionsFromArguments)($aa88812224633a70$export$617abaa845df50f1.getDefaults(), arguments, [
            "frequency"
        ]);
        this.frequency = new (0, $bkZNL.TickSignal)({
            context: this.context,
            units: options.units,
            value: options.frequency
        });
        (0, $AD7W4.readOnly)(this, "frequency");
        // set the initial state
        this._state.setStateAtTime("stopped", 0);
        // add the first event
        this.setTicksAtTime(0, 0);
    }
    static getDefaults() {
        return Object.assign({
            frequency: 1,
            units: "hertz"
        }, (0, $lXP1H.ToneWithContext).getDefaults());
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset The number of ticks to start the source at
     */ start(time, offset) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            if ((0, $lQ01C.isDefined)(offset)) this.setTicksAtTime(offset, computedTime);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        // cancel the previous stop
        if (this._state.getValueAtTime(computedTime) === "stopped") {
            const event = this._state.get(computedTime);
            if (event && event.time > 0) {
                this._tickOffset.cancel(event.time);
                this._state.cancel(event.time);
            }
        }
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this.setTicksAtTime(0, computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") this._state.setStateAtTime("paused", computedTime);
        return this;
    }
    /**
     * Cancel start/stop/pause and setTickAtTime events scheduled after the given time.
     * @param time When to clear the events after
     */ cancel(time) {
        time = this.toSeconds(time);
        this._state.cancel(time);
        this._tickOffset.cancel(time);
        return this;
    }
    /**
     * Get the elapsed ticks at the given time
     * @param  time  When to get the tick value
     * @return The number of ticks
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", computedTime);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: computedTime
        };
        this._state.add(tmpEvent);
        // keep track of the previous offset event
        let lastState = stopEvent;
        let elapsedTicks = 0;
        // iterate through all the events since the last stop
        this._state.forEachBetween(stopEvent.time, computedTime + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedTicks = offsetEvent.ticks;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") elapsedTicks += this.frequency.getTicksAtTime(e.time) - this.frequency.getTicksAtTime(periodStartTime);
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // return the ticks
        return elapsedTicks;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked. Returns -1 when stopped.
     */ get ticks() {
        return this.getTicksAtTime(this.now());
    }
    set ticks(t) {
        this.setTicksAtTime(t, this.now());
    }
    /**
     * The time since ticks=0 that the TickSource has been running. Accounts
     * for tempo curves
     */ get seconds() {
        return this.getSecondsAtTime(this.now());
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this.frequency.timeToTicks(s, now);
        this.setTicksAtTime(ticks, now);
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        time = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", time);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: time
        };
        this._state.add(tmpEvent);
        // keep track of the previous offset event
        let lastState = stopEvent;
        let elapsedSeconds = 0;
        // iterate through all the events since the last stop
        this._state.forEachBetween(stopEvent.time, time + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedSeconds = offsetEvent.seconds;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") elapsedSeconds += e.time - periodStartTime;
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // return the ticks
        return elapsedSeconds;
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        time = this.toSeconds(time);
        this._tickOffset.cancel(time);
        this._tickOffset.add({
            seconds: this.frequency.getDurationOfTicks(ticks, time),
            ticks: ticks,
            time: time
        });
        return this;
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     */ getStateAtTime(time) {
        time = this.toSeconds(time);
        return this._state.getValueAtTime(time);
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        const offset = this._tickOffset.get(before);
        const event = this._state.get(before);
        const startTime = Math.max(offset.time, event.time);
        const absoluteTicks = this.frequency.getTicksAtTime(startTime) + tick - offset.ticks;
        return this.frequency.getTimeOfTick(absoluteTicks);
    }
    /**
     * Invoke the callback event at all scheduled ticks between the
     * start time and the end time
     * @param  startTime  The beginning of the search range
     * @param  endTime    The end of the search range
     * @param  callback   The callback to invoke with each tick
     */ forEachTickBetween(startTime, endTime, callback) {
        // only iterate through the sections where it is "started"
        let lastStateEvent = this._state.get(startTime);
        this._state.forEachBetween(startTime, endTime, (event)=>{
            if (lastStateEvent && lastStateEvent.state === "started" && event.state !== "started") this.forEachTickBetween(Math.max(lastStateEvent.time, startTime), event.time - this.sampleTime, callback);
            lastStateEvent = event;
        });
        let error = null;
        if (lastStateEvent && lastStateEvent.state === "started") {
            const maxStartTime = Math.max(lastStateEvent.time, startTime);
            // figure out the difference between the frequency ticks and the
            const startTicks = this.frequency.getTicksAtTime(maxStartTime);
            const ticksAtStart = this.frequency.getTicksAtTime(lastStateEvent.time);
            const diff = startTicks - ticksAtStart;
            let offset = Math.ceil(diff) - diff;
            // guard against floating point issues
            offset = (0, $j4WGs.EQ)(offset, 1) ? 0 : offset;
            let nextTickTime = this.frequency.getTimeOfTick(startTicks + offset);
            while(nextTickTime < endTime){
                try {
                    callback(nextTickTime, Math.round(this.getTicksAtTime(nextTickTime)));
                } catch (e) {
                    error = e;
                    break;
                }
                nextTickTime += this.frequency.getDurationOfTicks(1, nextTickTime);
            }
        }
        if (error) throw error;
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._state.dispose();
        this._tickOffset.dispose();
        this.frequency.dispose();
        return this;
    }
}

});
parcelRegister("bkZNL", function(module, exports) {

$parcel$export(module.exports, "TickSignal", () => $841180815ff343cc$export$f1be63c3ef84bc34);

var $eCi69 = parcelRequire("eCi69");

var $l4RVz = parcelRequire("l4RVz");

var $aSqCS = parcelRequire("aSqCS");
class $841180815ff343cc$export$f1be63c3ef84bc34 extends (0, $eCi69.Signal) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($841180815ff343cc$export$f1be63c3ef84bc34.getDefaults(), arguments, [
            "value"
        ]));
        this.name = "TickSignal";
        const options = (0, $l4RVz.optionsFromArguments)($841180815ff343cc$export$f1be63c3ef84bc34.getDefaults(), arguments, [
            "value"
        ]);
        this.input = this._param = new (0, $aSqCS.TickParam)({
            context: this.context,
            convert: options.convert,
            multiplier: options.multiplier,
            param: this._constantSource.offset,
            units: options.units,
            value: options.value
        });
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    ticksToTime(ticks, when) {
        return this._param.ticksToTime(ticks, when);
    }
    timeToTicks(duration, when) {
        return this._param.timeToTicks(duration, when);
    }
    getTimeOfTick(tick) {
        return this._param.getTimeOfTick(tick);
    }
    getDurationOfTicks(ticks, time) {
        return this._param.getDurationOfTicks(ticks, time);
    }
    getTicksAtTime(time) {
        return this._param.getTicksAtTime(time);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._param.multiplier;
    }
    set multiplier(m) {
        this._param.multiplier = m;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        return this;
    }
}

});
parcelRegister("eCi69", function(module, exports) {

$parcel$export(module.exports, "Signal", () => $aa42a735e8dc479f$export$8210dfe1863c478);
$parcel$export(module.exports, "connectSignal", () => $aa42a735e8dc479f$export$c8174dc07173cff0);

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $9rnZW = parcelRequire("9rnZW");

var $l4RVz = parcelRequire("l4RVz");

var $2Q9k6 = parcelRequire("2Q9k6");
class $aa42a735e8dc479f$export$8210dfe1863c478 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($aa42a735e8dc479f$export$8210dfe1863c478.getDefaults(), arguments, [
            "value",
            "units"
        ]));
        this.name = "Signal";
        /**
         * Indicates if the value should be overridden on connection.
         */ this.override = true;
        const options = (0, $l4RVz.optionsFromArguments)($aa42a735e8dc479f$export$8210dfe1863c478.getDefaults(), arguments, [
            "value",
            "units"
        ]);
        this.output = this._constantSource = new (0, $2Q9k6.ToneConstantSource)({
            context: this.context,
            convert: options.convert,
            offset: options.value,
            units: options.units,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this._constantSource.start(0);
        this.input = this._param = this._constantSource.offset;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            convert: true,
            units: "number",
            value: 0
        });
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        // start it only when connected to something
        $aa42a735e8dc479f$export$c8174dc07173cff0(this, destination, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        this._constantSource.dispose();
        return this;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // just a proxy for the ConstantSourceNode's offset AudioParam
    // all docs are generated from AbstractParam.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        this._param.setValueAtTime(value, time);
        return this;
    }
    getValueAtTime(time) {
        return this._param.getValueAtTime(time);
    }
    setRampPoint(time) {
        this._param.setRampPoint(time);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        this._param.linearRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        this._param.exponentialRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        this._param.exponentialRampTo(value, rampTime, startTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        this._param.linearRampTo(value, rampTime, startTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        this._param.targetRampTo(value, rampTime, startTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        this._param.exponentialApproachValueAtTime(value, time, rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        this._param.setTargetAtTime(value, startTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        this._param.setValueCurveAtTime(values, startTime, duration, scaling);
        return this;
    }
    cancelScheduledValues(time) {
        this._param.cancelScheduledValues(time);
        return this;
    }
    cancelAndHoldAtTime(time) {
        this._param.cancelAndHoldAtTime(time);
        return this;
    }
    rampTo(value, rampTime, startTime) {
        this._param.rampTo(value, rampTime, startTime);
        return this;
    }
    get value() {
        return this._param.value;
    }
    set value(value) {
        this._param.value = value;
    }
    get convert() {
        return this._param.convert;
    }
    set convert(convert) {
        this._param.convert = convert;
    }
    get units() {
        return this._param.units;
    }
    get overridden() {
        return this._param.overridden;
    }
    set overridden(overridden) {
        this._param.overridden = overridden;
    }
    get maxValue() {
        return this._param.maxValue;
    }
    get minValue() {
        return this._param.minValue;
    }
    /**
     * See [[Param.apply]].
     */ apply(param) {
        this._param.apply(param);
        return this;
    }
}
function $aa42a735e8dc479f$export$c8174dc07173cff0(signal, destination, outputNum, inputNum) {
    if (destination instanceof (0, $lQP4J.Param) || (0, $9rnZW.isAudioParam)(destination) || destination instanceof $aa42a735e8dc479f$export$8210dfe1863c478 && destination.override) {
        // cancel changes
        destination.cancelScheduledValues(0);
        // reset the value
        destination.setValueAtTime(0, 0);
        // mark the value as overridden
        if (destination instanceof $aa42a735e8dc479f$export$8210dfe1863c478) destination.overridden = true;
    }
    (0, $fDBOr.connect)(signal, destination, outputNum, inputNum);
}

});
parcelRegister("lQP4J", function(module, exports) {

$parcel$export(module.exports, "Param", () => $fe8612c948d7741e$export$1ca45c9a47aec42c);

var $bmU6v = parcelRequire("bmU6v");

var $9rnZW = parcelRequire("9rnZW");

var $l4RVz = parcelRequire("l4RVz");

var $kjPdm = parcelRequire("kjPdm");

var $lQ01C = parcelRequire("lQ01C");

var $lXP1H = parcelRequire("lXP1H");

var $j4WGs = parcelRequire("j4WGs");

var $6Utwn = parcelRequire("6Utwn");
class $fe8612c948d7741e$export$1ca45c9a47aec42c extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($fe8612c948d7741e$export$1ca45c9a47aec42c.getDefaults(), arguments, [
            "param",
            "units",
            "convert"
        ]));
        this.name = "Param";
        this.overridden = false;
        /**
         * The minimum output value
         */ this._minOutput = 1e-7;
        const options = (0, $l4RVz.optionsFromArguments)($fe8612c948d7741e$export$1ca45c9a47aec42c.getDefaults(), arguments, [
            "param",
            "units",
            "convert"
        ]);
        (0, $6Utwn.assert)((0, $lQ01C.isDefined)(options.param) && ((0, $9rnZW.isAudioParam)(options.param) || options.param instanceof $fe8612c948d7741e$export$1ca45c9a47aec42c), "param must be an AudioParam");
        while(!(0, $9rnZW.isAudioParam)(options.param))options.param = options.param._param;
        this._swappable = (0, $lQ01C.isDefined)(options.swappable) ? options.swappable : false;
        if (this._swappable) {
            this.input = this.context.createGain();
            // initialize
            this._param = options.param;
            this.input.connect(this._param);
        } else this._param = this.input = options.param;
        this._events = new (0, $kjPdm.Timeline)(1000);
        this._initialValue = this._param.defaultValue;
        this.units = options.units;
        this.convert = options.convert;
        this._minValue = options.minValue;
        this._maxValue = options.maxValue;
        // if the value is defined, set it immediately
        if ((0, $lQ01C.isDefined)(options.value) && options.value !== this._toType(this._initialValue)) this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $lXP1H.ToneWithContext).getDefaults(), {
            convert: true,
            units: "number"
        });
    }
    get value() {
        const now = this.now();
        return this.getValueAtTime(now);
    }
    set value(value) {
        this.cancelScheduledValues(this.now());
        this.setValueAtTime(value, this.now());
    }
    get minValue() {
        // if it's not the default minValue, return it
        if ((0, $lQ01C.isDefined)(this._minValue)) return this._minValue;
        else if (this.units === "time" || this.units === "frequency" || this.units === "normalRange" || this.units === "positive" || this.units === "transportTime" || this.units === "ticks" || this.units === "bpm" || this.units === "hertz" || this.units === "samples") return 0;
        else if (this.units === "audioRange") return -1;
        else if (this.units === "decibels") return -Infinity;
        else return this._param.minValue;
    }
    get maxValue() {
        if ((0, $lQ01C.isDefined)(this._maxValue)) return this._maxValue;
        else if (this.units === "normalRange" || this.units === "audioRange") return 1;
        else return this._param.maxValue;
    }
    /**
     * Type guard based on the unit name
     */ _is(arg, type) {
        return this.units === type;
    }
    /**
     * Make sure the value is always in the defined range
     */ _assertRange(value) {
        if ((0, $lQ01C.isDefined)(this.maxValue) && (0, $lQ01C.isDefined)(this.minValue)) (0, $6Utwn.assertRange)(value, this._fromType(this.minValue), this._fromType(this.maxValue));
        return value;
    }
    /**
     * Convert the given value from the type specified by Param.units
     * into the destination value (such as Gain or Frequency).
     */ _fromType(val) {
        if (this.convert && !this.overridden) {
            if (this._is(val, "time")) return this.toSeconds(val);
            else if (this._is(val, "decibels")) return (0, $bmU6v.dbToGain)(val);
            else if (this._is(val, "frequency")) return this.toFrequency(val);
            else return val;
        } else if (this.overridden) // if it's overridden, should only schedule 0s
        return 0;
        else return val;
    }
    /**
     * Convert the parameters value into the units specified by Param.units.
     */ _toType(val) {
        if (this.convert && this.units === "decibels") return (0, $bmU6v.gainToDb)(val);
        else return val;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // all docs are generated from ParamInterface.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        const numericValue = this._fromType(value);
        (0, $6Utwn.assert)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(time)}`);
        this._assertRange(numericValue);
        this.log(this.units, "setValueAtTime", value, computedTime);
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: numericValue
        });
        this._param.setValueAtTime(numericValue, computedTime);
        return this;
    }
    getValueAtTime(time) {
        const computedTime = Math.max(this.toSeconds(time), 0);
        const after = this._events.getAfter(computedTime);
        const before = this._events.get(computedTime);
        let value = this._initialValue;
        // if it was set by
        if (before === null) value = this._initialValue;
        else if (before.type === "setTargetAtTime" && (after === null || after.type === "setValueAtTime")) {
            const previous = this._events.getBefore(before.time);
            let previousVal;
            if (previous === null) previousVal = this._initialValue;
            else previousVal = previous.value;
            if (before.type === "setTargetAtTime") value = this._exponentialApproach(before.time, previousVal, before.value, before.constant, computedTime);
        } else if (after === null) value = before.value;
        else if (after.type === "linearRampToValueAtTime" || after.type === "exponentialRampToValueAtTime") {
            let beforeValue = before.value;
            if (before.type === "setTargetAtTime") {
                const previous = this._events.getBefore(before.time);
                if (previous === null) beforeValue = this._initialValue;
                else beforeValue = previous.value;
            }
            if (after.type === "linearRampToValueAtTime") value = this._linearInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
            else value = this._exponentialInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
        } else value = before.value;
        return this._toType(value);
    }
    setRampPoint(time) {
        time = this.toSeconds(time);
        let currentVal = this.getValueAtTime(time);
        this.cancelAndHoldAtTime(time);
        if (this._fromType(currentVal) === 0) currentVal = this._toType(this._minOutput);
        this.setValueAtTime(currentVal, time);
        return this;
    }
    linearRampToValueAtTime(value, endTime) {
        const numericValue = this._fromType(value);
        const computedTime = this.toSeconds(endTime);
        (0, $6Utwn.assert)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to linearRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        this._assertRange(numericValue);
        this._events.add({
            time: computedTime,
            type: "linearRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "linearRampToValueAtTime", value, computedTime);
        this._param.linearRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, endTime) {
        let numericValue = this._fromType(value);
        // the value can't be 0
        numericValue = (0, $j4WGs.EQ)(numericValue, 0) ? this._minOutput : numericValue;
        this._assertRange(numericValue);
        const computedTime = this.toSeconds(endTime);
        (0, $6Utwn.assert)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to exponentialRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        // store the event
        this._events.add({
            time: computedTime,
            type: "exponentialRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "exponentialRampToValueAtTime", value, computedTime);
        this._param.exponentialRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.linearRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialApproachValueAtTime(value, startTime, rampTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        time = this.toSeconds(time);
        rampTime = this.toSeconds(rampTime);
        const timeConstant = Math.log(rampTime + 1) / Math.log(200);
        this.setTargetAtTime(value, time, timeConstant);
        // at 90% start a linear ramp to the final value
        this.cancelAndHoldAtTime(time + rampTime * 0.9);
        this.linearRampToValueAtTime(value, time + rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const numericValue = this._fromType(value);
        // The value will never be able to approach without timeConstant > 0.
        (0, $6Utwn.assert)(isFinite(timeConstant) && timeConstant > 0, "timeConstant must be a number greater than 0");
        const computedTime = this.toSeconds(startTime);
        this._assertRange(numericValue);
        (0, $6Utwn.assert)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setTargetAtTime: ${JSON.stringify(value)}, ${JSON.stringify(startTime)}`);
        this._events.add({
            constant: timeConstant,
            time: computedTime,
            type: "setTargetAtTime",
            value: numericValue
        });
        this.log(this.units, "setTargetAtTime", value, computedTime, timeConstant);
        this._param.setTargetAtTime(numericValue, computedTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling = 1) {
        duration = this.toSeconds(duration);
        startTime = this.toSeconds(startTime);
        const startingValue = this._fromType(values[0]) * scaling;
        this.setValueAtTime(this._toType(startingValue), startTime);
        const segTime = duration / (values.length - 1);
        for(let i = 1; i < values.length; i++){
            const numericValue = this._fromType(values[i]) * scaling;
            this.linearRampToValueAtTime(this._toType(numericValue), startTime + i * segTime);
        }
        return this;
    }
    cancelScheduledValues(time) {
        const computedTime = this.toSeconds(time);
        (0, $6Utwn.assert)(isFinite(computedTime), `Invalid argument to cancelScheduledValues: ${JSON.stringify(time)}`);
        this._events.cancel(computedTime);
        this._param.cancelScheduledValues(computedTime);
        this.log(this.units, "cancelScheduledValues", computedTime);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = this.toSeconds(time);
        const valueAtTime = this._fromType(this.getValueAtTime(computedTime));
        // remove the schedule events
        (0, $6Utwn.assert)(isFinite(computedTime), `Invalid argument to cancelAndHoldAtTime: ${JSON.stringify(time)}`);
        this.log(this.units, "cancelAndHoldAtTime", computedTime, "value=" + valueAtTime);
        // if there is an event at the given computedTime
        // and that even is not a "set"
        const before = this._events.get(computedTime);
        const after = this._events.getAfter(computedTime);
        if (before && (0, $j4WGs.EQ)(before.time, computedTime)) {
            // remove everything after
            if (after) {
                this._param.cancelScheduledValues(after.time);
                this._events.cancel(after.time);
            } else {
                this._param.cancelAndHoldAtTime(computedTime);
                this._events.cancel(computedTime + this.sampleTime);
            }
        } else if (after) {
            this._param.cancelScheduledValues(after.time);
            // cancel the next event(s)
            this._events.cancel(after.time);
            if (after.type === "linearRampToValueAtTime") this.linearRampToValueAtTime(this._toType(valueAtTime), computedTime);
            else if (after.type === "exponentialRampToValueAtTime") this.exponentialRampToValueAtTime(this._toType(valueAtTime), computedTime);
        }
        // set the value at the given time
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: valueAtTime
        });
        this._param.setValueAtTime(valueAtTime, computedTime);
        return this;
    }
    rampTo(value, rampTime = 0.1, startTime) {
        if (this.units === "frequency" || this.units === "bpm" || this.units === "decibels") this.exponentialRampTo(value, rampTime, startTime);
        else this.linearRampTo(value, rampTime, startTime);
        return this;
    }
    /**
     * Apply all of the previously scheduled events to the passed in Param or AudioParam.
     * The applied values will start at the context's current time and schedule
     * all of the events which are scheduled on this Param onto the passed in param.
     */ apply(param) {
        const now = this.context.currentTime;
        // set the param's value at the current time and schedule everything else
        param.setValueAtTime(this.getValueAtTime(now), now);
        // if the previous event was a curve, then set the rest of it
        const previousEvent = this._events.get(now);
        if (previousEvent && previousEvent.type === "setTargetAtTime") {
            // approx it until the next event with linear ramps
            const nextEvent = this._events.getAfter(previousEvent.time);
            // or for 2 seconds if there is no event
            const endTime = nextEvent ? nextEvent.time : now + 2;
            const subdivisions = (endTime - now) / 10;
            for(let i = now; i < endTime; i += subdivisions)param.linearRampToValueAtTime(this.getValueAtTime(i), i);
        }
        this._events.forEachAfter(this.context.currentTime, (event)=>{
            if (event.type === "cancelScheduledValues") param.cancelScheduledValues(event.time);
            else if (event.type === "setTargetAtTime") param.setTargetAtTime(event.value, event.time, event.constant);
            else param[event.type](event.value, event.time);
        });
        return this;
    }
    /**
     * Replace the Param's internal AudioParam. Will apply scheduled curves
     * onto the parameter and replace the connections.
     */ setParam(param) {
        (0, $6Utwn.assert)(this._swappable, "The Param must be assigned as 'swappable' in the constructor");
        const input = this.input;
        input.disconnect(this._param);
        this.apply(param);
        this._param = param;
        input.connect(this._param);
        return this;
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        return this;
    }
    get defaultValue() {
        return this._toType(this._param.defaultValue);
    }
    //-------------------------------------
    // 	AUTOMATION CURVE CALCULATIONS
    // 	MIT License, copyright (c) 2014 Jordan Santell
    //-------------------------------------
    // Calculates the the value along the curve produced by setTargetAtTime
    _exponentialApproach(t0, v0, v1, timeConstant, t) {
        return v1 + (v0 - v1) * Math.exp(-(t - t0) / timeConstant);
    }
    // Calculates the the value along the curve produced by linearRampToValueAtTime
    _linearInterpolate(t0, v0, t1, v1, t) {
        return v0 + (v1 - v0) * ((t - t0) / (t1 - t0));
    }
    // Calculates the the value along the curve produced by exponentialRampToValueAtTime
    _exponentialInterpolate(t0, v0, t1, v1, t) {
        return v0 * Math.pow(v1 / v0, (t - t0) / (t1 - t0));
    }
}

});

parcelRegister("fDBOr", function(module, exports) {

$parcel$export(module.exports, "ToneAudioNode", () => $b627d45131c427f0$export$14a6d069f26d1d33);
$parcel$export(module.exports, "connect", () => $b627d45131c427f0$export$64605811ab45167f);
$parcel$export(module.exports, "disconnect", () => $b627d45131c427f0$export$37dfea93db2e14ed);
$parcel$export(module.exports, "connectSeries", () => $b627d45131c427f0$export$933c3b67552fb559);

var $9rnZW = parcelRequire("9rnZW");

var $lQ01C = parcelRequire("lQ01C");

var $lQP4J = parcelRequire("lQP4J");

var $lXP1H = parcelRequire("lXP1H");

var $6Utwn = parcelRequire("6Utwn");
class $b627d45131c427f0$export$14a6d069f26d1d33 extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super(...arguments);
        /**
         * The name of the class
         */ this.name = "ToneAudioNode";
        /**
         * List all of the node that must be set to match the ChannelProperties
         */ this._internalChannels = [];
    }
    /**
     * The number of inputs feeding into the AudioNode.
     * For source nodes, this will be 0.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfInputs);
     */ get numberOfInputs() {
        if ((0, $lQ01C.isDefined)(this.input)) {
            if ((0, $9rnZW.isAudioParam)(this.input) || this.input instanceof (0, $lQP4J.Param)) return 1;
            else return this.input.numberOfInputs;
        } else return 0;
    }
    /**
     * The number of outputs of the AudioNode.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfOutputs);
     */ get numberOfOutputs() {
        if ((0, $lQ01C.isDefined)(this.output)) return this.output.numberOfOutputs;
        else return 0;
    }
    //-------------------------------------
    // AUDIO PROPERTIES
    //-------------------------------------
    /**
     * Used to decide which nodes to get/set properties on
     */ _isAudioNode(node) {
        return (0, $lQ01C.isDefined)(node) && (node instanceof $b627d45131c427f0$export$14a6d069f26d1d33 || (0, $9rnZW.isAudioNode)(node));
    }
    /**
     * Get all of the audio nodes (either internal or input/output) which together
     * make up how the class node responds to channel input/output
     */ _getInternalNodes() {
        const nodeList = this._internalChannels.slice(0);
        if (this._isAudioNode(this.input)) nodeList.push(this.input);
        if (this._isAudioNode(this.output)) {
            if (this.input !== this.output) nodeList.push(this.output);
        }
        return nodeList;
    }
    /**
     * Set the audio options for this node such as channelInterpretation
     * channelCount, etc.
     * @param options
     */ _setChannelProperties(options) {
        const nodeList = this._getInternalNodes();
        nodeList.forEach((node)=>{
            node.channelCount = options.channelCount;
            node.channelCountMode = options.channelCountMode;
            node.channelInterpretation = options.channelInterpretation;
        });
    }
    /**
     * Get the current audio options for this node such as channelInterpretation
     * channelCount, etc.
     */ _getChannelProperties() {
        const nodeList = this._getInternalNodes();
        (0, $6Utwn.assert)(nodeList.length > 0, "ToneAudioNode does not have any internal nodes");
        // use the first node to get properties
        // they should all be the same
        const node = nodeList[0];
        return {
            channelCount: node.channelCount,
            channelCountMode: node.channelCountMode,
            channelInterpretation: node.channelInterpretation
        };
    }
    /**
     * channelCount is the number of channels used when up-mixing and down-mixing
     * connections to any inputs to the node. The default value is 2 except for
     * specific nodes where its value is specially determined.
     */ get channelCount() {
        return this._getChannelProperties().channelCount;
    }
    set channelCount(channelCount) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCount: channelCount
        }));
    }
    /**
     * channelCountMode determines how channels will be counted when up-mixing and
     * down-mixing connections to any inputs to the node.
     * The default value is "max". This attribute has no effect for nodes with no inputs.
     * * "max" - computedNumberOfChannels is the maximum of the number of channels of all connections to an input. In this mode channelCount is ignored.
     * * "clamped-max" - computedNumberOfChannels is determined as for "max" and then clamped to a maximum value of the given channelCount.
     * * "explicit" - computedNumberOfChannels is the exact value as specified by the channelCount.
     */ get channelCountMode() {
        return this._getChannelProperties().channelCountMode;
    }
    set channelCountMode(channelCountMode) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCountMode: channelCountMode
        }));
    }
    /**
     * channelInterpretation determines how individual channels will be treated
     * when up-mixing and down-mixing connections to any inputs to the node.
     * The default value is "speakers".
     */ get channelInterpretation() {
        return this._getChannelProperties().channelInterpretation;
    }
    set channelInterpretation(channelInterpretation) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelInterpretation: channelInterpretation
        }));
    }
    //-------------------------------------
    // CONNECTIONS
    //-------------------------------------
    /**
     * connect the output of a ToneAudioNode to an AudioParam, AudioNode, or ToneAudioNode
     * @param destination The output to connect to
     * @param outputNum The output to connect from
     * @param inputNum The input to connect to
     */ connect(destination, outputNum = 0, inputNum = 0) {
        $b627d45131c427f0$export$64605811ab45167f(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * @example
     * const osc = new Tone.Oscillator("C2").start();
     * osc.toDestination();
     */ toDestination() {
        this.connect(this.context.destination);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * See [[toDestination]]
     * @deprecated
     */ toMaster() {
        (0, $6Utwn.warn)("toMaster() has been renamed toDestination()");
        return this.toDestination();
    }
    /**
     * disconnect the output
     */ disconnect(destination, outputNum = 0, inputNum = 0) {
        $b627d45131c427f0$export$37dfea93db2e14ed(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output of this node to the rest of the nodes in series.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/handdrum-loop.mp3");
     * player.autostart = true;
     * const filter = new Tone.AutoFilter(4).start();
     * const distortion = new Tone.Distortion(0.5);
     * // connect the player to the filter, distortion and then to the master output
     * player.chain(filter, distortion, Tone.Destination);
     */ chain(...nodes) {
        $b627d45131c427f0$export$933c3b67552fb559(this, ...nodes);
        return this;
    }
    /**
     * connect the output of this node to the rest of the nodes in parallel.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/conga-rhythm.mp3");
     * player.autostart = true;
     * const pitchShift = new Tone.PitchShift(4).toDestination();
     * const filter = new Tone.Filter("G5").toDestination();
     * // connect a node to the pitch shift and filter in parallel
     * player.fan(pitchShift, filter);
     */ fan(...nodes) {
        nodes.forEach((node)=>this.connect(node));
        return this;
    }
    /**
     * Dispose and disconnect
     */ dispose() {
        super.dispose();
        if ((0, $lQ01C.isDefined)(this.input)) {
            if (this.input instanceof $b627d45131c427f0$export$14a6d069f26d1d33) this.input.dispose();
            else if ((0, $9rnZW.isAudioNode)(this.input)) this.input.disconnect();
        }
        if ((0, $lQ01C.isDefined)(this.output)) {
            if (this.output instanceof $b627d45131c427f0$export$14a6d069f26d1d33) this.output.dispose();
            else if ((0, $9rnZW.isAudioNode)(this.output)) this.output.disconnect();
        }
        this._internalChannels = [];
        return this;
    }
}
function $b627d45131c427f0$export$933c3b67552fb559(...nodes) {
    const first = nodes.shift();
    nodes.reduce((prev, current)=>{
        if (prev instanceof $b627d45131c427f0$export$14a6d069f26d1d33) prev.connect(current);
        else if ((0, $9rnZW.isAudioNode)(prev)) $b627d45131c427f0$export$64605811ab45167f(prev, current);
        return current;
    }, first);
}
function $b627d45131c427f0$export$64605811ab45167f(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    (0, $6Utwn.assert)((0, $lQ01C.isDefined)(srcNode), "Cannot connect from undefined node");
    (0, $6Utwn.assert)((0, $lQ01C.isDefined)(dstNode), "Cannot connect to undefined node");
    if (dstNode instanceof $b627d45131c427f0$export$14a6d069f26d1d33 || (0, $9rnZW.isAudioNode)(dstNode)) (0, $6Utwn.assert)(dstNode.numberOfInputs > 0, "Cannot connect to node with no inputs");
    (0, $6Utwn.assert)(srcNode.numberOfOutputs > 0, "Cannot connect from node with no outputs");
    // resolve the input of the dstNode
    while(dstNode instanceof $b627d45131c427f0$export$14a6d069f26d1d33 || dstNode instanceof (0, $lQP4J.Param))if ((0, $lQ01C.isDefined)(dstNode.input)) dstNode = dstNode.input;
    while(srcNode instanceof $b627d45131c427f0$export$14a6d069f26d1d33)if ((0, $lQ01C.isDefined)(srcNode.output)) srcNode = srcNode.output;
    // make the connection
    if ((0, $9rnZW.isAudioParam)(dstNode)) srcNode.connect(dstNode, outputNumber);
    else srcNode.connect(dstNode, outputNumber, inputNumber);
}
function $b627d45131c427f0$export$37dfea93db2e14ed(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    // resolve the destination node
    if ((0, $lQ01C.isDefined)(dstNode)) while(dstNode instanceof $b627d45131c427f0$export$14a6d069f26d1d33)dstNode = dstNode.input;
    // resolve the src node
    while(!(0, $9rnZW.isAudioNode)(srcNode))if ((0, $lQ01C.isDefined)(srcNode.output)) srcNode = srcNode.output;
    if ((0, $9rnZW.isAudioParam)(dstNode)) srcNode.disconnect(dstNode, outputNumber);
    else if ((0, $9rnZW.isAudioNode)(dstNode)) srcNode.disconnect(dstNode, outputNumber, inputNumber);
    else srcNode.disconnect();
}

});

parcelRegister("2Q9k6", function(module, exports) {

$parcel$export(module.exports, "ToneConstantSource", () => $2117ab7c39a88a57$export$717f1ef4ba8fd295);

var $fDBOr = parcelRequire("fDBOr");

var $lQP4J = parcelRequire("lQP4J");

var $l4RVz = parcelRequire("l4RVz");

var $5lK3u = parcelRequire("5lK3u");
class $2117ab7c39a88a57$export$717f1ef4ba8fd295 extends (0, $5lK3u.OneShotSource) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($2117ab7c39a88a57$export$717f1ef4ba8fd295.getDefaults(), arguments, [
            "offset"
        ]));
        this.name = "ToneConstantSource";
        /**
         * The signal generator
         */ this._source = this.context.createConstantSource();
        const options = (0, $l4RVz.optionsFromArguments)($2117ab7c39a88a57$export$717f1ef4ba8fd295.getDefaults(), arguments, [
            "offset"
        ]);
        (0, $fDBOr.connect)(this._source, this._gainNode);
        this.offset = new (0, $lQP4J.Param)({
            context: this.context,
            convert: options.convert,
            param: this._source.offset,
            units: options.units,
            value: options.offset,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
    }
    static getDefaults() {
        return Object.assign((0, $5lK3u.OneShotSource).getDefaults(), {
            convert: true,
            offset: 1,
            units: "number"
        });
    }
    /**
     * Start the source node at the given time
     * @param  time When to start the source
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._source.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._source.stop(time);
    }
    dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._source.disconnect();
        this.offset.dispose();
        return this;
    }
}

});
parcelRegister("5lK3u", function(module, exports) {

$parcel$export(module.exports, "OneShotSource", () => $3e52a38ce2a3cf44$export$27749f88ede4d2a3);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $AD7W4 = parcelRequire("AD7W4");

var $6Utwn = parcelRequire("6Utwn");
class $3e52a38ce2a3cf44$export$27749f88ede4d2a3 extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        /**
         * The callback to invoke after the
         * source is done playing.
         */ this.onended = (0, $AD7W4.noOp);
        /**
         * The start time
         */ this._startTime = -1;
        /**
         * The stop time
         */ this._stopTime = -1;
        /**
         * The id of the timeout
         */ this._timeout = -1;
        /**
         * The public output node
         */ this.output = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        /**
         * The output gain node.
         */ this._gainNode = this.output;
        /**
         * Get the playback state at the given time
         */ this.getStateAtTime = function(time) {
            const computedTime = this.toSeconds(time);
            if (this._startTime !== -1 && computedTime >= this._startTime && (this._stopTime === -1 || computedTime <= this._stopTime)) return "started";
            else return "stopped";
        };
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
        this._curve = options.curve;
        this.onended = options.onended;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            curve: "linear",
            fadeIn: 0,
            fadeOut: 0,
            onended: (0, $AD7W4.noOp)
        });
    }
    /**
     * Start the source at the given time
     * @param  time When to start the source
     */ _startGain(time, gain = 1) {
        (0, $6Utwn.assert)(this._startTime === -1, "Source cannot be started more than once");
        // apply a fade in envelope
        const fadeInTime = this.toSeconds(this._fadeIn);
        // record the start time
        this._startTime = time + fadeInTime;
        this._startTime = Math.max(this._startTime, this.context.currentTime);
        // schedule the envelope
        if (fadeInTime > 0) {
            this._gainNode.gain.setValueAtTime(0, time);
            if (this._curve === "linear") this._gainNode.gain.linearRampToValueAtTime(gain, time + fadeInTime);
            else this._gainNode.gain.exponentialApproachValueAtTime(gain, time, fadeInTime);
        } else this._gainNode.gain.setValueAtTime(gain, time);
        return this;
    }
    /**
     * Stop the source node at the given time.
     * @param time When to stop the source
     */ stop(time) {
        this.log("stop", time);
        this._stopGain(this.toSeconds(time));
        return this;
    }
    /**
     * Stop the source at the given time
     * @param  time When to stop the source
     */ _stopGain(time) {
        (0, $6Utwn.assert)(this._startTime !== -1, "'start' must be called before 'stop'");
        // cancel the previous stop
        this.cancelStop();
        // the fadeOut time
        const fadeOutTime = this.toSeconds(this._fadeOut);
        // schedule the stop callback
        this._stopTime = this.toSeconds(time) + fadeOutTime;
        this._stopTime = Math.max(this._stopTime, this.context.currentTime);
        if (fadeOutTime > 0) {
            // start the fade out curve at the given time
            if (this._curve === "linear") this._gainNode.gain.linearRampTo(0, fadeOutTime, time);
            else this._gainNode.gain.targetRampTo(0, fadeOutTime, time);
        } else {
            // stop any ongoing ramps, and set the value to 0
            this._gainNode.gain.cancelAndHoldAtTime(time);
            this._gainNode.gain.setValueAtTime(0, time);
        }
        this.context.clearTimeout(this._timeout);
        this._timeout = this.context.setTimeout(()=>{
            // allow additional time for the exponential curve to fully decay
            const additionalTail = this._curve === "exponential" ? fadeOutTime * 2 : 0;
            this._stopSource(this.now() + additionalTail);
            this._onended();
        }, this._stopTime - this.context.currentTime);
        return this;
    }
    /**
     * Invoke the onended callback
     */ _onended() {
        if (this.onended !== (0, $AD7W4.noOp)) {
            this.onended(this);
            // overwrite onended to make sure it only is called once
            this.onended = (0, $AD7W4.noOp);
            // dispose when it's ended to free up for garbage collection only in the online context
            if (!this.context.isOffline) {
                const disposeCallback = ()=>this.dispose();
                // @ts-ignore
                if (typeof window.requestIdleCallback !== "undefined") // @ts-ignore
                window.requestIdleCallback(disposeCallback);
                else setTimeout(disposeCallback, 1000);
            }
        }
    }
    /**
     * Get the playback state at the current time
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Cancel a scheduled stop event
     */ cancelStop() {
        this.log("cancelStop");
        (0, $6Utwn.assert)(this._startTime !== -1, "Source is not started");
        // cancel the stop envelope
        this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime);
        this.context.clearTimeout(this._timeout);
        this._stopTime = -1;
        return this;
    }
    dispose() {
        super.dispose();
        this._gainNode.disconnect();
        return this;
    }
}

});
parcelRegister("bdbZZ", function(module, exports) {

$parcel$export(module.exports, "Gain", () => $829a37565709f41d$export$acd19d919666900d);

var $lQP4J = parcelRequire("lQP4J");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $fDBOr = parcelRequire("fDBOr");
class $829a37565709f41d$export$acd19d919666900d extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($829a37565709f41d$export$acd19d919666900d.getDefaults(), arguments, [
            "gain",
            "units"
        ]));
        this.name = "Gain";
        /**
         * The wrapped GainNode.
         */ this._gainNode = this.context.createGain();
        // input = output
        this.input = this._gainNode;
        this.output = this._gainNode;
        const options = (0, $l4RVz.optionsFromArguments)($829a37565709f41d$export$acd19d919666900d.getDefaults(), arguments, [
            "gain",
            "units"
        ]);
        this.gain = new (0, $lQP4J.Param)({
            context: this.context,
            convert: options.convert,
            param: this._gainNode.gain,
            units: options.units,
            value: options.gain,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        (0, $AD7W4.readOnly)(this, "gain");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            convert: true,
            gain: 1,
            units: "gain"
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._gainNode.disconnect();
        this.gain.dispose();
        return this;
    }
}

});




parcelRegister("aSqCS", function(module, exports) {

$parcel$export(module.exports, "TickParam", () => $7eb399e774ccc6c5$export$7d6cb743a95f18af);

var $lQP4J = parcelRequire("lQP4J");

var $l4RVz = parcelRequire("l4RVz");

var $kjPdm = parcelRequire("kjPdm");

var $lQ01C = parcelRequire("lQ01C");
class $7eb399e774ccc6c5$export$7d6cb743a95f18af extends (0, $lQP4J.Param) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($7eb399e774ccc6c5$export$7d6cb743a95f18af.getDefaults(), arguments, [
            "value"
        ]));
        this.name = "TickParam";
        /**
         * The timeline which tracks all of the automations.
         */ this._events = new (0, $kjPdm.Timeline)(Infinity);
        /**
         * The internal holder for the multiplier value
         */ this._multiplier = 1;
        const options = (0, $l4RVz.optionsFromArguments)($7eb399e774ccc6c5$export$7d6cb743a95f18af.getDefaults(), arguments, [
            "value"
        ]);
        // set the multiplier
        this._multiplier = options.multiplier;
        // clear the ticks from the beginning
        this._events.cancel(0);
        // set an initial event
        this._events.add({
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: this._fromType(options.value)
        });
        this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $lQP4J.Param).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    setTargetAtTime(value, time, constant) {
        // approximate it with multiple linear ramps
        time = this.toSeconds(time);
        this.setRampPoint(time);
        const computedValue = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        const segments = Math.round(Math.max(1 / constant, 1));
        for(let i = 0; i <= segments; i++){
            const segTime = constant * i + time;
            const rampVal = this._exponentialApproach(prevEvent.time, prevEvent.value, computedValue, constant, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.setValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.linearRampToValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        // aproximate it with multiple linear ramps
        time = this.toSeconds(time);
        const computedVal = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        // approx 10 segments per second
        const segments = Math.round(Math.max((time - prevEvent.time) * 10, 1));
        const segmentDur = (time - prevEvent.time) / segments;
        for(let i = 0; i <= segments; i++){
            const segTime = segmentDur * i + prevEvent.time;
            const rampVal = this._exponentialInterpolate(prevEvent.time, prevEvent.value, time, computedVal, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  event The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ _getTicksUntilEvent(event, time) {
        if (event === null) event = {
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: 0
        };
        else if ((0, $lQ01C.isUndef)(event.ticks)) {
            const previousEvent = this._events.previousEvent(event);
            event.ticks = this._getTicksUntilEvent(previousEvent, event.time);
        }
        const val0 = this._fromType(this.getValueAtTime(event.time));
        let val1 = this._fromType(this.getValueAtTime(time));
        // if it's right on the line, take the previous value
        const onTheLineEvent = this._events.get(time);
        if (onTheLineEvent && onTheLineEvent.time === time && onTheLineEvent.type === "setValueAtTime") val1 = this._fromType(this.getValueAtTime(time - this.sampleTime));
        return 0.5 * (time - event.time) * (val0 + val1) + event.ticks;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  time The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const event = this._events.get(computedTime);
        return Math.max(this._getTicksUntilEvent(event, computedTime), 0);
    }
    /**
     * Return the elapsed time of the number of ticks from the given time
     * @param ticks The number of ticks to calculate
     * @param  time The time to get the next tick from
     * @return The duration of the number of ticks from the given time in seconds
     */ getDurationOfTicks(ticks, time) {
        const computedTime = this.toSeconds(time);
        const currentTick = this.getTicksAtTime(time);
        return this.getTimeOfTick(currentTick + ticks) - computedTime;
    }
    /**
     * Given a tick, returns the time that tick occurs at.
     * @return The time that the tick occurs.
     */ getTimeOfTick(tick) {
        const before = this._events.get(tick, "ticks");
        const after = this._events.getAfter(tick, "ticks");
        if (before && before.ticks === tick) return before.time;
        else if (before && after && after.type === "linearRampToValueAtTime" && before.value !== after.value) {
            const val0 = this._fromType(this.getValueAtTime(before.time));
            const val1 = this._fromType(this.getValueAtTime(after.time));
            const delta = (val1 - val0) / (after.time - before.time);
            const k = Math.sqrt(Math.pow(val0, 2) - 2 * delta * (before.ticks - tick));
            const sol1 = (-val0 + k) / delta;
            const sol2 = (-val0 - k) / delta;
            return (sol1 > 0 ? sol1 : sol2) + before.time;
        } else if (before) {
            if (before.value === 0) return Infinity;
            else return before.time + (tick - before.ticks) / before.value;
        } else return tick / this._initialValue;
    }
    /**
     * Convert some number of ticks their the duration in seconds accounting
     * for any automation curves starting at the given time.
     * @param  ticks The number of ticks to convert to seconds.
     * @param  when  When along the automation timeline to convert the ticks.
     * @return The duration in seconds of the ticks.
     */ ticksToTime(ticks, when) {
        return this.getDurationOfTicks(ticks, when);
    }
    /**
     * The inverse of [[ticksToTime]]. Convert a duration in
     * seconds to the corresponding number of ticks accounting for any
     * automation curves starting at the given time.
     * @param  duration The time interval to convert to ticks.
     * @param  when When along the automation timeline to convert the ticks.
     * @return The duration in ticks.
     */ timeToTicks(duration, when) {
        const computedTime = this.toSeconds(when);
        const computedDuration = this.toSeconds(duration);
        const startTicks = this.getTicksAtTime(computedTime);
        const endTicks = this.getTicksAtTime(computedTime + computedDuration);
        return endTicks - startTicks;
    }
    /**
     * Convert from the type when the unit value is BPM
     */ _fromType(val) {
        if (this.units === "bpm" && this.multiplier) return 1 / (60 / val / this.multiplier);
        else return super._fromType(val);
    }
    /**
     * Special case of type conversion where the units === "bpm"
     */ _toType(val) {
        if (this.units === "bpm" && this.multiplier) return val / this.multiplier * 60;
        else return super._toType(val);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._multiplier;
    }
    set multiplier(m) {
        // get and reset the current value with the new multiplier
        // might be necessary to clear all the previous values
        const currentVal = this.value;
        this._multiplier = m;
        this.cancelScheduledValues(0);
        this.setValueAtTime(currentVal, 0);
    }
}

});




parcelRegister("eQyMC", function(module, exports) {

$parcel$export(module.exports, "Delay", () => $acf0e7412a6bb053$export$7419ff430885d61c);

var $lQP4J = parcelRequire("lQP4J");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $fDBOr = parcelRequire("fDBOr");
class $acf0e7412a6bb053$export$7419ff430885d61c extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($acf0e7412a6bb053$export$7419ff430885d61c.getDefaults(), arguments, [
            "delayTime",
            "maxDelay"
        ]));
        this.name = "Delay";
        const options = (0, $l4RVz.optionsFromArguments)($acf0e7412a6bb053$export$7419ff430885d61c.getDefaults(), arguments, [
            "delayTime",
            "maxDelay"
        ]);
        const maxDelayInSeconds = this.toSeconds(options.maxDelay);
        this._maxDelay = Math.max(maxDelayInSeconds, this.toSeconds(options.delayTime));
        this._delayNode = this.input = this.output = this.context.createDelay(maxDelayInSeconds);
        this.delayTime = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._delayNode.delayTime,
            units: "time",
            value: options.delayTime,
            minValue: 0,
            maxValue: this.maxDelay
        });
        (0, $AD7W4.readOnly)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            delayTime: 0,
            maxDelay: 1
        });
    }
    /**
     * The maximum delay time. This cannot be changed after
     * the value is passed into the constructor.
     */ get maxDelay() {
        return this._maxDelay;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._delayNode.disconnect();
        this.delayTime.dispose();
        return this;
    }
}

});

parcelRegister("lCjr4", function(module, exports) {

var $gztBd = parcelRequire("gztBd");

var $1Uvh8 = parcelRequire("1Uvh8");

var $iHery = parcelRequire("iHery");

var $9j0vm = parcelRequire("9j0vm");
function $fbcc39146dbb204a$export$a273407dc53e3f0a(callback, duration, channels = 2, sampleRate = (0, $1Uvh8.getContext)().sampleRate) {
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
        // set the OfflineAudioContext based on the current context
        const originalContext = (0, $1Uvh8.getContext)();
        const context = new (0, $iHery.OfflineContext)(channels, duration, sampleRate);
        (0, $1Uvh8.setContext)(context);
        // invoke the callback/scheduling
        yield callback(context);
        // then render the audio
        const bufferPromise = context.render();
        // return the original AudioContext
        (0, $1Uvh8.setContext)(originalContext);
        // await the rendering
        const buffer = yield bufferPromise;
        // return the audio
        return new (0, $9j0vm.ToneAudioBuffer)(buffer);
    });
}

});

parcelRegister("iace4", function(module, exports) {

$parcel$export(module.exports, "ToneAudioBuffers", () => $d392a4fac265b3e2$export$7232b969b571e570);

var $jiVAa = parcelRequire("jiVAa");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $9j0vm = parcelRequire("9j0vm");

var $6Utwn = parcelRequire("6Utwn");
class $d392a4fac265b3e2$export$7232b969b571e570 extends (0, $jiVAa.Tone) {
    constructor(){
        super();
        this.name = "ToneAudioBuffers";
        /**
         * All of the buffers
         */ this._buffers = new Map();
        /**
         * Keep track of the number of loaded buffers
         */ this._loadingCount = 0;
        const options = (0, $l4RVz.optionsFromArguments)($d392a4fac265b3e2$export$7232b969b571e570.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        this.baseUrl = options.baseUrl;
        // add each one
        Object.keys(options.urls).forEach((name)=>{
            this._loadingCount++;
            const url = options.urls[name];
            this.add(name, url, this._bufferLoaded.bind(this, options.onload), options.onerror);
        });
    }
    static getDefaults() {
        return {
            baseUrl: "",
            onerror: (0, $AD7W4.noOp),
            onload: (0, $AD7W4.noOp),
            urls: {}
        };
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param  name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name.toString());
    }
    /**
     * Get a buffer by name. If an array was loaded,
     * then use the array index.
     * @param  name  The key or index of the buffer.
     */ get(name) {
        (0, $6Utwn.assert)(this.has(name), `ToneAudioBuffers has no buffer named: ${name}`);
        return this._buffers.get(name.toString());
    }
    /**
     * A buffer was loaded. decrement the counter.
     */ _bufferLoaded(callback) {
        this._loadingCount--;
        if (this._loadingCount === 0 && callback) callback();
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return Array.from(this._buffers).every(([_, buffer])=>buffer.loaded);
    }
    /**
     * Add a buffer by name and url to the Buffers
     * @param  name      A unique name to give the buffer
     * @param  url  Either the url of the bufer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     * @param  onerror  Invoked if the buffer can't be loaded
     */ add(name, url, callback = (0, $AD7W4.noOp), onerror = (0, $AD7W4.noOp)) {
        if ((0, $lQ01C.isString)(url)) this._buffers.set(name.toString(), new (0, $9j0vm.ToneAudioBuffer)(this.baseUrl + url, callback, onerror));
        else this._buffers.set(name.toString(), new (0, $9j0vm.ToneAudioBuffer)(url, callback, onerror));
        return this;
    }
    dispose() {
        super.dispose();
        this._buffers.forEach((buffer)=>buffer.dispose());
        this._buffers.clear();
        return this;
    }
}

});

parcelRegister("3xSib", function(module, exports) {

$parcel$export(module.exports, "MidiClass", () => $294e917533247e57$export$266cef4b055bf7de);
$parcel$export(module.exports, "Midi", () => $294e917533247e57$export$ed87582254f87fd5);

var $1Uvh8 = parcelRequire("1Uvh8");

var $bmU6v = parcelRequire("bmU6v");

var $aZf7A = parcelRequire("aZf7A");
class $294e917533247e57$export$266cef4b055bf7de extends (0, $aZf7A.FrequencyClass) {
    constructor(){
        super(...arguments);
        this.name = "MidiClass";
        this.defaultUnits = "midi";
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return (0, $bmU6v.ftom)(super._frequencyToUnits(freq));
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return (0, $bmU6v.ftom)(super._ticksToUnits(ticks));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return (0, $bmU6v.ftom)(super._beatsToUnits(beats));
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return (0, $bmU6v.ftom)(super._secondsToUnits(seconds));
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toMidi(); // 60
     */ toMidi() {
        return this.valueOf();
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toFrequency(); // 261.6255653005986
     */ toFrequency() {
        return (0, $bmU6v.mtof)(this.toMidi());
    }
    /**
     * Transposes the frequency by the given number of semitones.
     * @return A new transposed MidiClass
     * @example
     * Tone.Midi("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $294e917533247e57$export$266cef4b055bf7de(this.context, this.toMidi() + interval);
    }
}
function $294e917533247e57$export$ed87582254f87fd5(value, units) {
    return new $294e917533247e57$export$266cef4b055bf7de((0, $1Uvh8.getContext)(), value, units);
}

});

parcelRegister("a5kVC", function(module, exports) {

$parcel$export(module.exports, "TicksClass", () => $757a9af31495245a$export$fe3569694b9f5728);

var $1Uvh8 = parcelRequire("1Uvh8");

var $31EKY = parcelRequire("31EKY");
class $757a9af31495245a$export$fe3569694b9f5728 extends (0, $31EKY.TransportTimeClass) {
    constructor(){
        super(...arguments);
        this.name = "Ticks";
        this.defaultUnits = "i";
    }
    /**
     * Get the current time in the given units
     */ _now() {
        return this.context.transport.ticks;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return this._getPPQ() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return Math.floor(seconds / (60 / this._getBpm()) * this._getPPQ());
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks;
    }
    /**
     * Return the time in ticks
     */ toTicks() {
        return this.valueOf();
    }
    /**
     * Return the time in seconds
     */ toSeconds() {
        return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
    }
}
function $757a9af31495245a$export$27c7467594ef87bd(value, units) {
    return new $757a9af31495245a$export$fe3569694b9f5728((0, $1Uvh8.getContext)(), value, units);
}

});

parcelRegister("1K86j", function(module, exports) {

var $lXP1H = parcelRequire("lXP1H");

var $kjPdm = parcelRequire("kjPdm");

var $7M63q = parcelRequire("7M63q");
class $14505efb3ffa5941$export$dca20402ebea5ece extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super(...arguments);
        this.name = "Draw";
        /**
         * The duration after which events are not invoked.
         */ this.expiration = 0.25;
        /**
         * The amount of time before the scheduled time
         * that the callback can be invoked. Default is
         * half the time of an animation frame (0.008 seconds).
         */ this.anticipation = 0.008;
        /**
         * All of the events.
         */ this._events = new (0, $kjPdm.Timeline)();
        /**
         * The draw loop
         */ this._boundDrawLoop = this._drawLoop.bind(this);
        /**
         * The animation frame id
         */ this._animationFrame = -1;
    }
    /**
     * Schedule a function at the given time to be invoked
     * on the nearest animation frame.
     * @param  callback  Callback is invoked at the given time.
     * @param  time      The time relative to the AudioContext time to invoke the callback.
     * @example
     * Tone.Transport.scheduleRepeat(time => {
     * 	Tone.Draw.schedule(() => console.log(time), time);
     * }, 1);
     * Tone.Transport.start();
     */ schedule(callback, time) {
        this._events.add({
            callback: callback,
            time: this.toSeconds(time)
        });
        // start the draw loop on the first event
        if (this._events.length === 1) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
        return this;
    }
    /**
     * Cancel events scheduled after the given time
     * @param  after  Time after which scheduled events will be removed from the scheduling timeline.
     */ cancel(after) {
        this._events.cancel(this.toSeconds(after));
        return this;
    }
    /**
     * The draw loop
     */ _drawLoop() {
        const now = this.context.currentTime;
        while(this._events.length && this._events.peek().time - this.anticipation <= now){
            const event = this._events.shift();
            if (event && now - event.time <= this.expiration) event.callback();
        }
        if (this._events.length > 0) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        cancelAnimationFrame(this._animationFrame);
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $7M63q.onContextInit)((context)=>{
    context.draw = new $14505efb3ffa5941$export$dca20402ebea5ece({
        context: context
    });
});
(0, $7M63q.onContextClose)((context)=>{
    context.draw.dispose();
});

});

parcelRegister("83d8Z", function(module, exports) {

$parcel$export(module.exports, "IntervalTimeline", () => $5dc8ccac6137d999$export$5a615b1a895bd9ec);

var $jiVAa = parcelRequire("jiVAa");

var $lQ01C = parcelRequire("lQ01C");

var $6Utwn = parcelRequire("6Utwn");
class $5dc8ccac6137d999$export$5a615b1a895bd9ec extends (0, $jiVAa.Tone) {
    constructor(){
        super(...arguments);
        this.name = "IntervalTimeline";
        /**
         * The root node of the inteval tree
         */ this._root = null;
        /**
         * Keep track of the length of the timeline.
         */ this._length = 0;
    }
    /**
     * The event to add to the timeline. All events must
     * have a time and duration value
     * @param  event  The event to add to the timeline
     */ add(event) {
        (0, $6Utwn.assert)((0, $lQ01C.isDefined)(event.time), "Events must have a time property");
        (0, $6Utwn.assert)((0, $lQ01C.isDefined)(event.duration), "Events must have a duration parameter");
        event.time = event.time.valueOf();
        let node = new $5dc8ccac6137d999$var$IntervalNode(event.time, event.time + event.duration, event);
        if (this._root === null) this._root = node;
        else this._root.insert(node);
        this._length++;
        // Restructure tree to be balanced
        while(node !== null){
            node.updateHeight();
            node.updateMax();
            this._rebalance(node);
            node = node.parent;
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  event  The event to remove from the timeline
     */ remove(event) {
        if (this._root !== null) {
            const results = [];
            this._root.search(event.time, results);
            for (const node of results)if (node.event === event) {
                this._removeNode(node);
                this._length--;
                break;
            }
        }
        return this;
    }
    /**
     * The number of items in the timeline.
     * @readOnly
     */ get length() {
        return this._length;
    }
    /**
     * Remove events whose time time is after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        this.forEachFrom(after, (event)=>this.remove(event));
        return this;
    }
    /**
     * Set the root node as the given node
     */ _setRoot(node) {
        this._root = node;
        if (this._root !== null) this._root.parent = null;
    }
    /**
     * Replace the references to the node in the node's parent
     * with the replacement node.
     */ _replaceNodeInParent(node, replacement) {
        if (node.parent !== null) {
            if (node.isLeftChild()) node.parent.left = replacement;
            else node.parent.right = replacement;
            this._rebalance(node.parent);
        } else this._setRoot(replacement);
    }
    /**
     * Remove the node from the tree and replace it with
     * a successor which follows the schema.
     */ _removeNode(node) {
        if (node.left === null && node.right === null) this._replaceNodeInParent(node, null);
        else if (node.right === null) this._replaceNodeInParent(node, node.left);
        else if (node.left === null) this._replaceNodeInParent(node, node.right);
        else {
            const balance = node.getBalance();
            let replacement;
            let temp = null;
            if (balance > 0) {
                if (node.left.right === null) {
                    replacement = node.left;
                    replacement.right = node.right;
                    temp = replacement;
                } else {
                    replacement = node.left.right;
                    while(replacement.right !== null)replacement = replacement.right;
                    if (replacement.parent) {
                        replacement.parent.right = replacement.left;
                        temp = replacement.parent;
                        replacement.left = node.left;
                        replacement.right = node.right;
                    }
                }
            } else if (node.right.left === null) {
                replacement = node.right;
                replacement.left = node.left;
                temp = replacement;
            } else {
                replacement = node.right.left;
                while(replacement.left !== null)replacement = replacement.left;
                if (replacement.parent) {
                    replacement.parent.left = replacement.right;
                    temp = replacement.parent;
                    replacement.left = node.left;
                    replacement.right = node.right;
                }
            }
            if (node.parent !== null) {
                if (node.isLeftChild()) node.parent.left = replacement;
                else node.parent.right = replacement;
            } else this._setRoot(replacement);
            if (temp) this._rebalance(temp);
        }
        node.dispose();
    }
    /**
     * Rotate the tree to the left
     */ _rotateLeft(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.right the new root of this sub tree (instead of node)
        const pivotNode = node.right;
        if (pivotNode) {
            node.right = pivotNode.left;
            pivotNode.left = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Rotate the tree to the right
     */ _rotateRight(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.left the new root of this sub tree (instead of node)
        const pivotNode = node.left;
        if (pivotNode) {
            node.left = pivotNode.right;
            pivotNode.right = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Balance the BST
     */ _rebalance(node) {
        const balance = node.getBalance();
        if (balance > 1 && node.left) {
            if (node.left.getBalance() < 0) this._rotateLeft(node.left);
            else this._rotateRight(node);
        } else if (balance < -1 && node.right) {
            if (node.right.getBalance() > 0) this._rotateRight(node.right);
            else this._rotateLeft(node);
        }
    }
    /**
     * Get an event whose time and duration span the give time. Will
     * return the match whose "time" value is closest to the given time.
     * @return  The event which spans the desired time
     */ get(time) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            if (results.length > 0) {
                let max = results[0];
                for(let i = 1; i < results.length; i++)if (results[i].low > max.low) max = results[i];
                return max.event;
            }
        }
        return null;
    }
    /**
     * Iterate over everything in the timeline.
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        if (this._root !== null) {
            const allNodes = [];
            this._root.traverse((node)=>allNodes.push(node));
            allNodes.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the given time
     * overlaps with the time and duration time of the event.
     * @param  time The time to check if items are overlapping
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the time is greater
     * than or equal to the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.searchAfter(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        if (this._root !== null) this._root.traverse((node)=>node.dispose());
        this._root = null;
        return this;
    }
}
//-------------------------------------
// 	INTERVAL NODE HELPER
//-------------------------------------
/**
 * Represents a node in the binary search tree, with the addition
 * of a "high" value which keeps track of the highest value of
 * its children.
 * References:
 * https://brooknovak.wordpress.com/2013/12/07/augmented-interval-tree-in-c/
 * http://www.mif.vu.lt/~valdas/ALGORITMAI/LITERATURA/Cormen/Cormen.pdf
 * @param low
 * @param high
 */ class $5dc8ccac6137d999$var$IntervalNode {
    constructor(low, high, event){
        // the nodes to the left
        this._left = null;
        // the nodes to the right
        this._right = null;
        // the parent node
        this.parent = null;
        // the number of child nodes
        this.height = 0;
        this.event = event;
        // the low value
        this.low = low;
        // the high value
        this.high = high;
        // the high value for this and all child nodes
        this.max = this.high;
    }
    /**
     * Insert a node into the correct spot in the tree
     */ insert(node) {
        if (node.low <= this.low) {
            if (this.left === null) this.left = node;
            else this.left.insert(node);
        } else if (this.right === null) this.right = node;
        else this.right.insert(node);
    }
    /**
     * Search the tree for nodes which overlap
     * with the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ search(point, results) {
        // If p is to the right of the rightmost point of any interval
        // in this node and all children, there won't be any matches.
        if (point > this.max) return;
        // Search left children
        if (this.left !== null) this.left.search(point, results);
        // Check this node
        if (this.low <= point && this.high > point) results.push(this);
        // If p is to the left of the time of this interval,
        // then it can't be in any child to the right.
        if (this.low > point) return;
        // Search right children
        if (this.right !== null) this.right.search(point, results);
    }
    /**
     * Search the tree for nodes which are less
     * than the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ searchAfter(point, results) {
        // Check this node
        if (this.low >= point) {
            results.push(this);
            if (this.left !== null) this.left.searchAfter(point, results);
        }
        // search the right side
        if (this.right !== null) this.right.searchAfter(point, results);
    }
    /**
     * Invoke the callback on this element and both it's branches
     * @param  {Function}  callback
     */ traverse(callback) {
        callback(this);
        if (this.left !== null) this.left.traverse(callback);
        if (this.right !== null) this.right.traverse(callback);
    }
    /**
     * Update the height of the node
     */ updateHeight() {
        if (this.left !== null && this.right !== null) this.height = Math.max(this.left.height, this.right.height) + 1;
        else if (this.right !== null) this.height = this.right.height + 1;
        else if (this.left !== null) this.height = this.left.height + 1;
        else this.height = 0;
    }
    /**
     * Update the height of the node
     */ updateMax() {
        this.max = this.high;
        if (this.left !== null) this.max = Math.max(this.max, this.left.max);
        if (this.right !== null) this.max = Math.max(this.max, this.right.max);
    }
    /**
     * The balance is how the leafs are distributed on the node
     * @return  Negative numbers are balanced to the right
     */ getBalance() {
        let balance = 0;
        if (this.left !== null && this.right !== null) balance = this.left.height - this.right.height;
        else if (this.left !== null) balance = this.left.height + 1;
        else if (this.right !== null) balance = -(this.right.height + 1);
        return balance;
    }
    /**
     * @returns true if this node is the left child of its parent
     */ isLeftChild() {
        return this.parent !== null && this.parent.left === this;
    }
    /**
     * get/set the left node
     */ get left() {
        return this._left;
    }
    set left(node) {
        this._left = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * get/set the right node
     */ get right() {
        return this._right;
    }
    set right(node) {
        this._right = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * null out references.
     */ dispose() {
        this.parent = null;
        this._left = null;
        this._right = null;
        this.event = null;
    }
}

});

parcelRegister("cC8ra", function(module, exports) {
parcelRequire("fGjwC");

});
parcelRegister("fGjwC", function(module, exports) {
// this file contains all of the valid note names for all pitches between C-4 and C11

});



parcelRegister("fpcpv", function(module, exports) {
$parcel$export(module.exports, "LFO", () => (parcelRequire("lNxm0")).LFO);
$parcel$export(module.exports, "ToneBufferSource", () => (parcelRequire("a0u4l")).ToneBufferSource);
$parcel$export(module.exports, "Player", () => (parcelRequire("ihNA0")).Player);
parcelRequire("5yVwk");
parcelRequire("jn7iu");
parcelRequire("1I557");
parcelRequire("gSu6i");
parcelRequire("8xh0e");
parcelRequire("hMSJB");
parcelRequire("4n6Sl");
parcelRequire("j5zUu");
parcelRequire("5Abaq");
parcelRequire("kcGXj");
parcelRequire("lNxm0");
parcelRequire("a0u4l");
parcelRequire("ihNA0");
parcelRequire("jxOmj");
parcelRequire("3rWzZ");

});
parcelRegister("5yVwk", function(module, exports) {

$parcel$export(module.exports, "Noise", () => $40ccbf128e7c7d83$export$484d33a0500a4ce1);

var $9j0vm = parcelRequire("9j0vm");

var $l4RVz = parcelRequire("l4RVz");

var $6Utwn = parcelRequire("6Utwn");

var $21sLj = parcelRequire("21sLj");

var $a0u4l = parcelRequire("a0u4l");
class $40ccbf128e7c7d83$export$484d33a0500a4ce1 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($40ccbf128e7c7d83$export$484d33a0500a4ce1.getDefaults(), arguments, [
            "type"
        ]));
        this.name = "Noise";
        /**
         * Private reference to the source
         */ this._source = null;
        const options = (0, $l4RVz.optionsFromArguments)($40ccbf128e7c7d83$export$484d33a0500a4ce1.getDefaults(), arguments, [
            "type"
        ]);
        this._playbackRate = options.playbackRate;
        this.type = options.type;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            fadeIn: 0,
            fadeOut: 0,
            playbackRate: 1,
            type: "white"
        });
    }
    /**
     * The type of the noise. Can be "white", "brown", or "pink".
     * @example
     * const noise = new Tone.Noise().toDestination().start();
     * noise.type = "brown";
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $6Utwn.assert)(type in $40ccbf128e7c7d83$var$_noiseBuffers, "Noise: invalid type: " + type);
        if (this._type !== type) {
            this._type = type;
            // if it's playing, stop and restart it
            if (this.state === "started") {
                const now = this.now();
                this._stop(now);
                this._start(now);
            }
        }
    }
    /**
     * The playback rate of the noise. Affects
     * the "frequency" of the noise.
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        if (this._source) this._source.playbackRate.value = rate;
    }
    /**
     * internal start method
     */ _start(time) {
        const buffer = $40ccbf128e7c7d83$var$_noiseBuffers[this._type];
        this._source = new (0, $a0u4l.ToneBufferSource)({
            url: buffer,
            context: this.context,
            fadeIn: this._fadeIn,
            fadeOut: this._fadeOut,
            loop: true,
            onended: ()=>this.onstop(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        this._source.start(this.toSeconds(time), Math.random() * (buffer.duration - 0.001));
    }
    /**
     * internal stop method
     */ _stop(time) {
        if (this._source) {
            this._source.stop(this.toSeconds(time));
            this._source = null;
        }
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(time) {
        this._fadeIn = time;
        if (this._source) this._source.fadeIn = this._fadeIn;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(time) {
        this._fadeOut = time;
        if (this._source) this._source.fadeOut = this._fadeOut;
    }
    _restart(time) {
        // TODO could be optimized by cancelling the buffer source 'stop'
        this._stop(time);
        this._start(time);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this._source) this._source.disconnect();
        return this;
    }
}
//--------------------
// THE NOISE BUFFERS
//--------------------
// Noise buffer stats
const $40ccbf128e7c7d83$var$BUFFER_LENGTH = 220500;
const $40ccbf128e7c7d83$var$NUM_CHANNELS = 2;
/**
 * Cache the noise buffers
 */ const $40ccbf128e7c7d83$var$_noiseCache = {
    brown: null,
    pink: null,
    white: null
};
/**
 * The noise arrays. Generated on initialization.
 * borrowed heavily from https://github.com/zacharydenton/noise.js
 * (c) 2013 Zach Denton (MIT)
 */ const $40ccbf128e7c7d83$var$_noiseBuffers = {
    get brown () {
        if (!$40ccbf128e7c7d83$var$_noiseCache.brown) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $40ccbf128e7c7d83$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($40ccbf128e7c7d83$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let lastOut = 0.0;
                for(let i = 0; i < $40ccbf128e7c7d83$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    channel[i] = (lastOut + 0.02 * white) / 1.02;
                    lastOut = channel[i];
                    channel[i] *= 3.5; // (roughly) compensate for gain
                }
            }
            $40ccbf128e7c7d83$var$_noiseCache.brown = new (0, $9j0vm.ToneAudioBuffer)().fromArray(buffer);
        }
        return $40ccbf128e7c7d83$var$_noiseCache.brown;
    },
    get pink () {
        if (!$40ccbf128e7c7d83$var$_noiseCache.pink) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $40ccbf128e7c7d83$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($40ccbf128e7c7d83$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let b0, b1, b2, b3, b4, b5, b6;
                b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;
                for(let i = 0; i < $40ccbf128e7c7d83$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    b0 = 0.99886 * b0 + white * 0.0555179;
                    b1 = 0.99332 * b1 + white * 0.0750759;
                    b2 = 0.96900 * b2 + white * 0.1538520;
                    b3 = 0.86650 * b3 + white * 0.3104856;
                    b4 = 0.55000 * b4 + white * 0.5329522;
                    b5 = -0.7616 * b5 - white * 0.0168980;
                    channel[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
                    channel[i] *= 0.11; // (roughly) compensate for gain
                    b6 = white * 0.115926;
                }
            }
            $40ccbf128e7c7d83$var$_noiseCache.pink = new (0, $9j0vm.ToneAudioBuffer)().fromArray(buffer);
        }
        return $40ccbf128e7c7d83$var$_noiseCache.pink;
    },
    get white () {
        if (!$40ccbf128e7c7d83$var$_noiseCache.white) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $40ccbf128e7c7d83$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($40ccbf128e7c7d83$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                for(let i = 0; i < $40ccbf128e7c7d83$var$BUFFER_LENGTH; i++)channel[i] = Math.random() * 2 - 1;
            }
            $40ccbf128e7c7d83$var$_noiseCache.white = new (0, $9j0vm.ToneAudioBuffer)().fromArray(buffer);
        }
        return $40ccbf128e7c7d83$var$_noiseCache.white;
    }
};

});
parcelRegister("21sLj", function(module, exports) {

$parcel$export(module.exports, "Source", () => $1791fc528a0e3ffd$export$1d2df86270c81ecb);

var $dTGN1 = parcelRequire("dTGN1");
parcelRequire("fulvH");
parcelRequire("9UqGS");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $4nQXi = parcelRequire("4nQXi");

var $lQ01C = parcelRequire("lQ01C");

var $6Utwn = parcelRequire("6Utwn");

var $j4WGs = parcelRequire("j4WGs");
class $1791fc528a0e3ffd$export$1d2df86270c81ecb extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        /**
         * Sources have no inputs
         */ this.input = undefined;
        /**
         * Keep track of the scheduled state.
         */ this._state = new (0, $4nQXi.StateTimeline)("stopped");
        /**
         * The synced `start` callback function from the transport
         */ this._synced = false;
        /**
         * Keep track of all of the scheduled event ids
         */ this._scheduled = [];
        /**
         * Placeholder functions for syncing/unsyncing to transport
         */ this._syncedStart = (0, $AD7W4.noOp);
        this._syncedStop = (0, $AD7W4.noOp);
        this._state.memory = 100;
        this._state.increasing = true;
        this._volume = this.output = new (0, $dTGN1.Volume)({
            context: this.context,
            mute: options.mute,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $AD7W4.readOnly)(this, "volume");
        this.onstop = options.onstop;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mute: false,
            onstop: (0, $AD7W4.noOp),
            volume: 0
        });
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/ahntone_c3.mp3", () => {
     * 	player.start();
     * 	console.log(player.state);
     * }).toDestination();
     */ get state() {
        if (this._synced) {
            if (this.context.transport.state === "started") return this._state.getValueAtTime(this.context.transport.seconds);
            else return "stopped";
        } else return this._state.getValueAtTime(this.now());
    }
    /**
     * Mute the output.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // mute the output
     * osc.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * Ensure that the scheduled time is not before the current time.
     * Should only be used when scheduled unsynced.
     */ _clampToCurrentTime(time) {
        if (this._synced) return time;
        else return Math.max(time, this.context.currentTime);
    }
    /**
     * Start the source at the specified time. If no time is given,
     * start the source now.
     * @param  time When the source should be started.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start("+0.5"); // starts the source 0.5 seconds from now
     */ start(time, offset, duration) {
        let computedTime = (0, $lQ01C.isUndef)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        // if it's started, stop it and restart it
        if (!this._synced && this._state.getValueAtTime(computedTime) === "started") {
            // time should be strictly greater than the previous start time
            (0, $6Utwn.assert)((0, $j4WGs.GT)(computedTime, this._state.get(computedTime).time), "Start time must be strictly greater than previous start time");
            this._state.cancel(computedTime);
            this._state.setStateAtTime("started", computedTime);
            this.log("restart", computedTime);
            this.restart(computedTime, offset, duration);
        } else {
            this.log("start", computedTime);
            this._state.setStateAtTime("started", computedTime);
            if (this._synced) {
                // add the offset time to the event
                const event = this._state.get(computedTime);
                if (event) {
                    event.offset = this.toSeconds((0, $l4RVz.defaultArg)(offset, 0));
                    event.duration = duration ? this.toSeconds(duration) : undefined;
                }
                const sched = this.context.transport.schedule((t)=>{
                    this._start(t, offset, duration);
                }, computedTime);
                this._scheduled.push(sched);
                // if the transport is already started
                // and the time is greater than where the transport is
                if (this.context.transport.state === "started" && this.context.transport.getSecondsAtTime(this.immediate()) > computedTime) this._syncedStart(this.now(), this.context.transport.seconds);
            } else {
                (0, $6Utwn.assertContextRunning)(this.context);
                this._start(computedTime, offset, duration);
            }
        }
        return this;
    }
    /**
     * Stop the source at the specified time. If no time is given,
     * stop the source now.
     * @param  time When the source should be stopped.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start();
     * source.stop("+0.5"); // stops the source 0.5 seconds from now
     */ stop(time) {
        let computedTime = (0, $lQ01C.isUndef)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        if (this._state.getValueAtTime(computedTime) === "started" || (0, $lQ01C.isDefined)(this._state.getNextState("started", computedTime))) {
            this.log("stop", computedTime);
            if (!this._synced) this._stop(computedTime);
            else {
                const sched = this.context.transport.schedule(this._stop.bind(this), computedTime);
                this._scheduled.push(sched);
            }
            this._state.cancel(computedTime);
            this._state.setStateAtTime("stopped", computedTime);
        }
        return this;
    }
    /**
     * Restart the source.
     */ restart(time, offset, duration) {
        time = this.toSeconds(time);
        if (this._state.getValueAtTime(time) === "started") {
            this._state.cancel(time);
            this._restart(time, offset, duration);
        }
        return this;
    }
    /**
     * Sync the source to the Transport so that all subsequent
     * calls to `start` and `stop` are synced to the TransportTime
     * instead of the AudioContext time.
     *
     * @example
     * const osc = new Tone.Oscillator().toDestination();
     * // sync the source so that it plays between 0 and 0.3 on the Transport's timeline
     * osc.sync().start(0).stop(0.3);
     * // start the transport.
     * Tone.Transport.start();
     * // set it to loop once a second
     * Tone.Transport.loop = true;
     * Tone.Transport.loopEnd = 1;
     */ sync() {
        if (!this._synced) {
            this._synced = true;
            this._syncedStart = (time, offset)=>{
                if (offset > 0) {
                    // get the playback state at that time
                    const stateEvent = this._state.get(offset);
                    // listen for start events which may occur in the middle of the sync'ed time
                    if (stateEvent && stateEvent.state === "started" && stateEvent.time !== offset) {
                        // get the offset
                        const startOffset = offset - this.toSeconds(stateEvent.time);
                        let duration;
                        if (stateEvent.duration) duration = this.toSeconds(stateEvent.duration) - startOffset;
                        this._start(time, this.toSeconds(stateEvent.offset) + startOffset, duration);
                    }
                }
            };
            this._syncedStop = (time)=>{
                const seconds = this.context.transport.getSecondsAtTime(Math.max(time - this.sampleTime, 0));
                if (this._state.getValueAtTime(seconds) === "started") this._stop(time);
            };
            this.context.transport.on("start", this._syncedStart);
            this.context.transport.on("loopStart", this._syncedStart);
            this.context.transport.on("stop", this._syncedStop);
            this.context.transport.on("pause", this._syncedStop);
            this.context.transport.on("loopEnd", this._syncedStop);
        }
        return this;
    }
    /**
     * Unsync the source to the Transport. See Source.sync
     */ unsync() {
        if (this._synced) {
            this.context.transport.off("stop", this._syncedStop);
            this.context.transport.off("pause", this._syncedStop);
            this.context.transport.off("loopEnd", this._syncedStop);
            this.context.transport.off("start", this._syncedStart);
            this.context.transport.off("loopStart", this._syncedStart);
        }
        this._synced = false;
        // clear all of the scheduled ids
        this._scheduled.forEach((id)=>this.context.transport.clear(id));
        this._scheduled = [];
        this._state.cancel(0);
        // stop it also
        this._stop(0);
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.onstop = (0, $AD7W4.noOp);
        this.unsync();
        this._volume.dispose();
        this._state.dispose();
        return this;
    }
}

});
parcelRegister("dTGN1", function(module, exports) {

$parcel$export(module.exports, "Volume", () => $a1e19a93ca4040e6$export$dde279e52d625429);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $a1e19a93ca4040e6$export$dde279e52d625429 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($a1e19a93ca4040e6$export$dde279e52d625429.getDefaults(), arguments, [
            "volume"
        ]));
        this.name = "Volume";
        const options = (0, $l4RVz.optionsFromArguments)($a1e19a93ca4040e6$export$dde279e52d625429.getDefaults(), arguments, [
            "volume"
        ]);
        this.input = this.output = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.volume,
            units: "decibels"
        });
        this.volume = this.output.gain;
        (0, $AD7W4.readOnly)(this, "volume");
        this._unmutedVolume = options.volume;
        // set the mute initially
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const vol = new Tone.Volume(-12).toDestination();
     * const osc = new Tone.Oscillator().connect(vol).start();
     * // mute the output
     * vol.mute = true;
     */ get mute() {
        return this.volume.value === -Infinity;
    }
    set mute(mute) {
        if (!this.mute && mute) {
            this._unmutedVolume = this.volume.value;
            // maybe it should ramp here?
            this.volume.value = -Infinity;
        } else if (this.mute && !mute) this.volume.value = this._unmutedVolume;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.input.dispose();
        this.volume.dispose();
        return this;
    }
}

});

parcelRegister("fulvH", function(module, exports) {

var $dTGN1 = parcelRequire("dTGN1");

var $l4RVz = parcelRequire("l4RVz");

var $7M63q = parcelRequire("7M63q");

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");
class $b46a57dde494dccd$export$5c4bdf44e1e9cea1 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($b46a57dde494dccd$export$5c4bdf44e1e9cea1.getDefaults(), arguments));
        this.name = "Destination";
        this.input = new (0, $dTGN1.Volume)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The volume of the master output in decibels. -Infinity is silent, and 0 is no change.
         * @example
         * const osc = new Tone.Oscillator().toDestination();
         * osc.start();
         * // ramp the volume down to silent over 10 seconds
         * Tone.getDestination().volume.rampTo(-Infinity, 10);
         */ this.volume = this.input.volume;
        const options = (0, $l4RVz.optionsFromArguments)($b46a57dde494dccd$export$5c4bdf44e1e9cea1.getDefaults(), arguments);
        (0, $fDBOr.connectSeries)(this.input, this.output, this.context.rawContext.destination);
        this.mute = options.mute;
        this._internalChannels = [
            this.input,
            this.context.rawContext.destination,
            this.output
        ];
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const oscillator = new Tone.Oscillator().start().toDestination();
     * setTimeout(() => {
     * 	// mute the output
     * 	Tone.Destination.mute = true;
     * }, 1000);
     */ get mute() {
        return this.input.mute;
    }
    set mute(mute) {
        this.input.mute = mute;
    }
    /**
     * Add a master effects chain. NOTE: this will disconnect any nodes which were previously
     * chained in the master effects chain.
     * @param args All arguments will be connected in a row and the Master will be routed through it.
     * @example
     * // route all audio through a filter and compressor
     * const lowpass = new Tone.Filter(800, "lowpass");
     * const compressor = new Tone.Compressor(-18);
     * Tone.Destination.chain(lowpass, compressor);
     */ chain(...args) {
        this.input.disconnect();
        args.unshift(this.input);
        args.push(this.output);
        (0, $fDBOr.connectSeries)(...args);
        return this;
    }
    /**
     * The maximum number of channels the system can output
     * @example
     * console.log(Tone.Destination.maxChannelCount);
     */ get maxChannelCount() {
        return this.context.rawContext.destination.maxChannelCount;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.volume.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $7M63q.onContextInit)((context)=>{
    context.destination = new $b46a57dde494dccd$export$5c4bdf44e1e9cea1({
        context: context
    });
});
(0, $7M63q.onContextClose)((context)=>{
    context.destination.dispose();
});

});

parcelRegister("9UqGS", function(module, exports) {

var $ihY3q = parcelRequire("ihY3q");

var $C1UDY = parcelRequire("C1UDY");

var $7M63q = parcelRequire("7M63q");

var $bdbZZ = parcelRequire("bdbZZ");

var $lXP1H = parcelRequire("lXP1H");

var $a5kVC = parcelRequire("a5kVC");

var $31EKY = parcelRequire("31EKY");

var $l4RVz = parcelRequire("l4RVz");

var $cwPvC = parcelRequire("cwPvC");

var $AD7W4 = parcelRequire("AD7W4");

var $83d8Z = parcelRequire("83d8Z");

var $kjPdm = parcelRequire("kjPdm");

var $lQ01C = parcelRequire("lQ01C");

var $c60dh = parcelRequire("c60dh");

var $7Jh4G = parcelRequire("7Jh4G");

var $eTmMo = parcelRequire("eTmMo");
class $736e0c35766d064d$export$86495b081fef8e52 extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($736e0c35766d064d$export$86495b081fef8e52.getDefaults(), arguments));
        this.name = "Transport";
        //-------------------------------------
        // 	LOOPING
        //-------------------------------------
        /**
         * If the transport loops or not.
         */ this._loop = new (0, $C1UDY.TimelineValue)(false);
        /**
         * The loop start position in ticks
         */ this._loopStart = 0;
        /**
         * The loop end position in ticks
         */ this._loopEnd = 0;
        //-------------------------------------
        // 	TIMELINE EVENTS
        //-------------------------------------
        /**
         * All the events in an object to keep track by ID
         */ this._scheduledEvents = {};
        /**
         * The scheduled events.
         */ this._timeline = new (0, $kjPdm.Timeline)();
        /**
         * Repeated events
         */ this._repeatedEvents = new (0, $83d8Z.IntervalTimeline)();
        /**
         * All of the synced Signals
         */ this._syncedSignals = [];
        /**
         * The swing amount
         */ this._swingAmount = 0;
        const options = (0, $l4RVz.optionsFromArguments)($736e0c35766d064d$export$86495b081fef8e52.getDefaults(), arguments);
        // CLOCK/TEMPO
        this._ppq = options.ppq;
        this._clock = new (0, $c60dh.Clock)({
            callback: this._processTick.bind(this),
            context: this.context,
            frequency: 0,
            units: "bpm"
        });
        this._bindClockEvents();
        this.bpm = this._clock.frequency;
        this._clock.frequency.multiplier = options.ppq;
        this.bpm.setValueAtTime(options.bpm, 0);
        (0, $AD7W4.readOnly)(this, "bpm");
        this._timeSignature = options.timeSignature;
        // SWING
        this._swingTicks = options.ppq / 2; // 8n
    }
    static getDefaults() {
        return Object.assign((0, $lXP1H.ToneWithContext).getDefaults(), {
            bpm: 120,
            loopEnd: "4m",
            loopStart: 0,
            ppq: 192,
            swing: 0,
            swingSubdivision: "8n",
            timeSignature: 4
        });
    }
    //-------------------------------------
    // 	TICKS
    //-------------------------------------
    /**
     * called on every tick
     * @param  tickTime clock relative tick time
     */ _processTick(tickTime, ticks) {
        // do the loop test
        if (this._loop.get(tickTime)) {
            if (ticks >= this._loopEnd) {
                this.emit("loopEnd", tickTime);
                this._clock.setTicksAtTime(this._loopStart, tickTime);
                ticks = this._loopStart;
                this.emit("loopStart", tickTime, this._clock.getSecondsAtTime(tickTime));
                this.emit("loop", tickTime);
            }
        }
        // handle swing
        if (this._swingAmount > 0 && ticks % this._ppq !== 0 && // not on a downbeat
        ticks % (this._swingTicks * 2) !== 0) {
            // add some swing
            const progress = ticks % (this._swingTicks * 2) / (this._swingTicks * 2);
            const amount = Math.sin(progress * Math.PI) * this._swingAmount;
            tickTime += new (0, $a5kVC.TicksClass)(this.context, this._swingTicks * 2 / 3).toSeconds() * amount;
        }
        // invoke the timeline events scheduled on this tick
        this._timeline.forEachAtTime(ticks, (event)=>event.invoke(tickTime));
    }
    //-------------------------------------
    // 	SCHEDULABLE EVENTS
    //-------------------------------------
    /**
     * Schedule an event along the timeline.
     * @param callback The callback to be invoked at the time.
     * @param time The time to invoke the callback at.
     * @return The id of the event which can be used for canceling the event.
     * @example
     * // schedule an event on the 16th measure
     * Tone.Transport.schedule((time) => {
     * 	// invoked on measure 16
     * 	console.log("measure 16!");
     * }, "16:0:0");
     */ schedule(callback, time) {
        const event = new (0, $7Jh4G.TransportEvent)(this, {
            callback: callback,
            time: new (0, $31EKY.TransportTimeClass)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Schedule a repeated event along the timeline. The event will fire
     * at the `interval` starting at the `startTime` and for the specified
     * `duration`.
     * @param  callback   The callback to invoke.
     * @param  interval   The duration between successive callbacks. Must be a positive number.
     * @param  startTime  When along the timeline the events should start being invoked.
     * @param  duration How long the event should repeat.
     * @return  The ID of the scheduled event. Use this to cancel the event.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // a callback invoked every eighth note after the first measure
     * Tone.Transport.scheduleRepeat((time) => {
     * 	osc.start(time).stop(time + 0.1);
     * }, "8n", "1m");
     */ scheduleRepeat(callback, interval, startTime, duration = Infinity) {
        const event = new (0, $eTmMo.TransportRepeatEvent)(this, {
            callback: callback,
            duration: new (0, $ihY3q.TimeClass)(this.context, duration).toTicks(),
            interval: new (0, $ihY3q.TimeClass)(this.context, interval).toTicks(),
            time: new (0, $31EKY.TransportTimeClass)(this.context, startTime).toTicks()
        });
        // kick it off if the Transport is started
        // @ts-ignore
        return this._addEvent(event, this._repeatedEvents);
    }
    /**
     * Schedule an event that will be removed after it is invoked.
     * @param callback The callback to invoke once.
     * @param time The time the callback should be invoked.
     * @returns The ID of the scheduled event.
     */ scheduleOnce(callback, time) {
        const event = new (0, $7Jh4G.TransportEvent)(this, {
            callback: callback,
            once: true,
            time: new (0, $31EKY.TransportTimeClass)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Clear the passed in event id from the timeline
     * @param eventId The id of the event.
     */ clear(eventId) {
        if (this._scheduledEvents.hasOwnProperty(eventId)) {
            const item = this._scheduledEvents[eventId.toString()];
            item.timeline.remove(item.event);
            item.event.dispose();
            delete this._scheduledEvents[eventId.toString()];
        }
        return this;
    }
    /**
     * Add an event to the correct timeline. Keep track of the
     * timeline it was added to.
     * @returns the event id which was just added
     */ _addEvent(event, timeline) {
        this._scheduledEvents[event.id.toString()] = {
            event: event,
            timeline: timeline
        };
        timeline.add(event);
        return event.id;
    }
    /**
     * Remove scheduled events from the timeline after
     * the given time. Repeated events will be removed
     * if their startTime is after the given time
     * @param after Clear all events after this time.
     */ cancel(after = 0) {
        const computedAfter = this.toTicks(after);
        this._timeline.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        this._repeatedEvents.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        return this;
    }
    //-------------------------------------
    // 	START/STOP/PAUSE
    //-------------------------------------
    /**
     * Bind start/stop/pause events from the clock and emit them.
     */ _bindClockEvents() {
        this._clock.on("start", (time, offset)=>{
            offset = new (0, $a5kVC.TicksClass)(this.context, offset).toSeconds();
            this.emit("start", time, offset);
        });
        this._clock.on("stop", (time)=>{
            this.emit("stop", time);
        });
        this._clock.on("pause", (time)=>{
            this.emit("pause", time);
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped", or "paused"
     */ get state() {
        return this._clock.getStateAtTime(this.now());
    }
    /**
     * Start the transport and all sources synced to the transport.
     * @param  time The time when the transport should start.
     * @param  offset The timeline offset to start the transport.
     * @example
     * // start the transport in one second starting at beginning of the 5th measure.
     * Tone.Transport.start("+1", "4:0:0");
     */ start(time, offset) {
        let offsetTicks;
        if ((0, $lQ01C.isDefined)(offset)) offsetTicks = this.toTicks(offset);
        // start the clock
        this._clock.start(time, offsetTicks);
        return this;
    }
    /**
     * Stop the transport and all sources synced to the transport.
     * @param time The time when the transport should stop.
     * @example
     * Tone.Transport.stop();
     */ stop(time) {
        this._clock.stop(time);
        return this;
    }
    /**
     * Pause the transport and all sources synced to the transport.
     */ pause(time) {
        this._clock.pause(time);
        return this;
    }
    /**
     * Toggle the current state of the transport. If it is
     * started, it will stop it, otherwise it will start the Transport.
     * @param  time The time of the event
     */ toggle(time) {
        time = this.toSeconds(time);
        if (this._clock.getStateAtTime(time) !== "started") this.start(time);
        else this.stop(time);
        return this;
    }
    //-------------------------------------
    // 	SETTERS/GETTERS
    //-------------------------------------
    /**
     * The time signature as just the numerator over 4.
     * For example 4/4 would be just 4 and 6/8 would be 3.
     * @example
     * // common time
     * Tone.Transport.timeSignature = 4;
     * // 7/8
     * Tone.Transport.timeSignature = [7, 8];
     * // this will be reduced to a single number
     * Tone.Transport.timeSignature; // returns 3.5
     */ get timeSignature() {
        return this._timeSignature;
    }
    set timeSignature(timeSig) {
        if ((0, $lQ01C.isArray)(timeSig)) timeSig = timeSig[0] / timeSig[1] * 4;
        this._timeSignature = timeSig;
    }
    /**
     * When the Transport.loop = true, this is the starting position of the loop.
     */ get loopStart() {
        return new (0, $ihY3q.TimeClass)(this.context, this._loopStart, "i").toSeconds();
    }
    set loopStart(startPosition) {
        this._loopStart = this.toTicks(startPosition);
    }
    /**
     * When the Transport.loop = true, this is the ending position of the loop.
     */ get loopEnd() {
        return new (0, $ihY3q.TimeClass)(this.context, this._loopEnd, "i").toSeconds();
    }
    set loopEnd(endPosition) {
        this._loopEnd = this.toTicks(endPosition);
    }
    /**
     * If the transport loops or not.
     */ get loop() {
        return this._loop.get(this.now());
    }
    set loop(loop) {
        this._loop.set(loop, this.now());
    }
    /**
     * Set the loop start and stop at the same time.
     * @example
     * // loop over the first measure
     * Tone.Transport.setLoopPoints(0, "1m");
     * Tone.Transport.loop = true;
     */ setLoopPoints(startPosition, endPosition) {
        this.loopStart = startPosition;
        this.loopEnd = endPosition;
        return this;
    }
    /**
     * The swing value. Between 0-1 where 1 equal to the note + half the subdivision.
     */ get swing() {
        return this._swingAmount;
    }
    set swing(amount) {
        // scale the values to a normal range
        this._swingAmount = amount;
    }
    /**
     * Set the subdivision which the swing will be applied to.
     * The default value is an 8th note. Value must be less
     * than a quarter note.
     */ get swingSubdivision() {
        return new (0, $a5kVC.TicksClass)(this.context, this._swingTicks).toNotation();
    }
    set swingSubdivision(subdivision) {
        this._swingTicks = this.toTicks(subdivision);
    }
    /**
     * The Transport's position in Bars:Beats:Sixteenths.
     * Setting the value will jump to that position right away.
     */ get position() {
        const now = this.now();
        const ticks = this._clock.getTicksAtTime(now);
        return new (0, $a5kVC.TicksClass)(this.context, ticks).toBarsBeatsSixteenths();
    }
    set position(progress) {
        const ticks = this.toTicks(progress);
        this.ticks = ticks;
    }
    /**
     * The Transport's position in seconds
     * Setting the value will jump to that position right away.
     */ get seconds() {
        return this._clock.seconds;
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this._clock.frequency.timeToTicks(s, now);
        this.ticks = ticks;
    }
    /**
     * The Transport's loop position as a normalized value. Always
     * returns 0 if the transport if loop is not true.
     */ get progress() {
        if (this.loop) {
            const now = this.now();
            const ticks = this._clock.getTicksAtTime(now);
            return (ticks - this._loopStart) / (this._loopEnd - this._loopStart);
        } else return 0;
    }
    /**
     * The transports current tick position.
     */ get ticks() {
        return this._clock.ticks;
    }
    set ticks(t) {
        if (this._clock.ticks !== t) {
            const now = this.now();
            // stop everything synced to the transport
            if (this.state === "started") {
                const ticks = this._clock.getTicksAtTime(now);
                // schedule to start on the next tick, #573
                const remainingTick = this._clock.frequency.getDurationOfTicks(Math.ceil(ticks) - ticks, now);
                const time = now + remainingTick;
                this.emit("stop", time);
                this._clock.setTicksAtTime(t, time);
                // restart it with the new time
                this.emit("start", time, this._clock.getSecondsAtTime(time));
            } else this._clock.setTicksAtTime(t, now);
        }
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return Math.round(this._clock.getTicksAtTime(time));
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._clock.getSecondsAtTime(time);
    }
    /**
     * Pulses Per Quarter note. This is the smallest resolution
     * the Transport timing supports. This should be set once
     * on initialization and not set again. Changing this value
     * after other objects have been created can cause problems.
     */ get PPQ() {
        return this._clock.frequency.multiplier;
    }
    set PPQ(ppq) {
        this._clock.frequency.multiplier = ppq;
    }
    //-------------------------------------
    // 	SYNCING
    //-------------------------------------
    /**
     * Returns the time aligned to the next subdivision
     * of the Transport. If the Transport is not started,
     * it will return 0.
     * Note: this will not work precisely during tempo ramps.
     * @param  subdivision  The subdivision to quantize to
     * @return  The context time of the next subdivision.
     * @example
     * // the transport must be started, otherwise returns 0
     * Tone.Transport.start();
     * Tone.Transport.nextSubdivision("4n");
     */ nextSubdivision(subdivision) {
        subdivision = this.toTicks(subdivision);
        if (this.state !== "started") // if the transport's not started, return 0
        return 0;
        else {
            const now = this.now();
            // the remainder of the current ticks and the subdivision
            const transportPos = this.getTicksAtTime(now);
            const remainingTicks = subdivision - transportPos % subdivision;
            return this._clock.nextTickTime(remainingTicks, now);
        }
    }
    /**
     * Attaches the signal to the tempo control signal so that
     * any changes in the tempo will change the signal in the same
     * ratio.
     *
     * @param signal
     * @param ratio Optionally pass in the ratio between the two signals.
     * 			Otherwise it will be computed based on their current values.
     */ syncSignal(signal, ratio) {
        if (!ratio) {
            // get the sync ratio
            const now = this.now();
            if (signal.getValueAtTime(now) !== 0) {
                const bpm = this.bpm.getValueAtTime(now);
                const computedFreq = 1 / (60 / bpm / this.PPQ);
                ratio = signal.getValueAtTime(now) / computedFreq;
            } else ratio = 0;
        }
        const ratioSignal = new (0, $bdbZZ.Gain)(ratio);
        // @ts-ignore
        this.bpm.connect(ratioSignal);
        // @ts-ignore
        ratioSignal.connect(signal._param);
        this._syncedSignals.push({
            initial: signal.value,
            ratio: ratioSignal,
            signal: signal
        });
        signal.value = 0;
        return this;
    }
    /**
     * Unsyncs a previously synced signal from the transport's control.
     * See Transport.syncSignal.
     */ unsyncSignal(signal) {
        for(let i = this._syncedSignals.length - 1; i >= 0; i--){
            const syncedSignal = this._syncedSignals[i];
            if (syncedSignal.signal === signal) {
                syncedSignal.ratio.dispose();
                syncedSignal.signal.value = syncedSignal.initial;
                this._syncedSignals.splice(i, 1);
            }
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._clock.dispose();
        (0, $AD7W4.writable)(this, "bpm");
        this._timeline.dispose();
        this._repeatedEvents.dispose();
        return this;
    }
}
(0, $cwPvC.Emitter).mixin($736e0c35766d064d$export$86495b081fef8e52);
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $7M63q.onContextInit)((context)=>{
    context.transport = new $736e0c35766d064d$export$86495b081fef8e52({
        context: context
    });
});
(0, $7M63q.onContextClose)((context)=>{
    context.transport.dispose();
});

});
parcelRegister("C1UDY", function(module, exports) {

$parcel$export(module.exports, "TimelineValue", () => $072508876535cf14$export$562790db7cca758d);

var $kjPdm = parcelRequire("kjPdm");

var $jiVAa = parcelRequire("jiVAa");
class $072508876535cf14$export$562790db7cca758d extends (0, $jiVAa.Tone) {
    /**
     * @param initialValue The value to return if there is no scheduled values
     */ constructor(initialValue){
        super();
        this.name = "TimelineValue";
        /**
         * The timeline which stores the values
         */ this._timeline = new (0, $kjPdm.Timeline)({
            memory: 10
        });
        this._initialValue = initialValue;
    }
    /**
     * Set the value at the given time
     */ set(value, time) {
        this._timeline.add({
            value: value,
            time: time
        });
        return this;
    }
    /**
     * Get the value at the given time
     */ get(time) {
        const event = this._timeline.get(time);
        if (event) return event.value;
        else return this._initialValue;
    }
}

});

parcelRegister("7Jh4G", function(module, exports) {

$parcel$export(module.exports, "TransportEvent", () => $5a09fb012b86c0ed$export$bbddcd8b4881600f);

var $AD7W4 = parcelRequire("AD7W4");
class $5a09fb012b86c0ed$export$bbddcd8b4881600f {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        /**
         * The unique id of the event
         */ this.id = $5a09fb012b86c0ed$export$bbddcd8b4881600f._eventId++;
        const options = Object.assign($5a09fb012b86c0ed$export$bbddcd8b4881600f.getDefaults(), opts);
        this.transport = transport;
        this.callback = options.callback;
        this._once = options.once;
        this.time = options.time;
    }
    static getDefaults() {
        return {
            callback: (0, $AD7W4.noOp),
            once: false,
            time: 0
        };
    }
    /**
     * Invoke the event callback.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        if (this.callback) {
            this.callback(time);
            if (this._once) this.transport.clear(this.id);
        }
    }
    /**
     * Clean up
     */ dispose() {
        this.callback = undefined;
        return this;
    }
}
/**
 * Current ID counter
 */ $5a09fb012b86c0ed$export$bbddcd8b4881600f._eventId = 0;

});

parcelRegister("eTmMo", function(module, exports) {

$parcel$export(module.exports, "TransportRepeatEvent", () => $ad77df42adf55049$export$8473d2e877b20cae);

var $a5kVC = parcelRequire("a5kVC");

var $7Jh4G = parcelRequire("7Jh4G");
class $ad77df42adf55049$export$8473d2e877b20cae extends (0, $7Jh4G.TransportEvent) {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        super(transport, opts);
        /**
         * The ID of the current timeline event
         */ this._currentId = -1;
        /**
         * The ID of the next timeline event
         */ this._nextId = -1;
        /**
         * The time of the next event
         */ this._nextTick = this.time;
        /**
         * a reference to the bound start method
         */ this._boundRestart = this._restart.bind(this);
        const options = Object.assign($ad77df42adf55049$export$8473d2e877b20cae.getDefaults(), opts);
        this.duration = new (0, $a5kVC.TicksClass)(transport.context, options.duration).valueOf();
        this._interval = new (0, $a5kVC.TicksClass)(transport.context, options.interval).valueOf();
        this._nextTick = options.time;
        this.transport.on("start", this._boundRestart);
        this.transport.on("loopStart", this._boundRestart);
        this.context = this.transport.context;
        this._restart();
    }
    static getDefaults() {
        return Object.assign({}, (0, $7Jh4G.TransportEvent).getDefaults(), {
            duration: Infinity,
            interval: 1,
            once: false
        });
    }
    /**
     * Invoke the callback. Returns the tick time which
     * the next event should be scheduled at.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        // create more events if necessary
        this._createEvents(time);
        // call the super class
        super.invoke(time);
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */ _createEvents(time) {
        // schedule the next event
        const ticks = this.transport.getTicksAtTime(time);
        if (ticks >= this.time && ticks >= this._nextTick && this._nextTick + this._interval < this.time + this.duration) {
            this._nextTick += this._interval;
            this._currentId = this._nextId;
            this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $a5kVC.TicksClass)(this.context, this._nextTick).toSeconds());
        }
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */ _restart(time) {
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        this._nextTick = this.time;
        const ticks = this.transport.getTicksAtTime(time);
        if (ticks > this.time) this._nextTick = this.time + Math.ceil((ticks - this.time) / this._interval) * this._interval;
        this._currentId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $a5kVC.TicksClass)(this.context, this._nextTick).toSeconds());
        this._nextTick += this._interval;
        this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $a5kVC.TicksClass)(this.context, this._nextTick).toSeconds());
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        this.transport.off("start", this._boundRestart);
        this.transport.off("loopStart", this._boundRestart);
        return this;
    }
}

});



parcelRegister("a0u4l", function(module, exports) {

$parcel$export(module.exports, "ToneBufferSource", () => $74913a93128eec52$export$30cbf4ba14db4fdd);

var $fDBOr = parcelRequire("fDBOr");

var $lQP4J = parcelRequire("lQP4J");

var $9j0vm = parcelRequire("9j0vm");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $6Utwn = parcelRequire("6Utwn");

var $5lK3u = parcelRequire("5lK3u");

var $j4WGs = parcelRequire("j4WGs");
class $74913a93128eec52$export$30cbf4ba14db4fdd extends (0, $5lK3u.OneShotSource) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($74913a93128eec52$export$30cbf4ba14db4fdd.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "ToneBufferSource";
        /**
         * The oscillator
         */ this._source = this.context.createBufferSource();
        this._internalChannels = [
            this._source
        ];
        /**
         * indicators if the source has started/stopped
         */ this._sourceStarted = false;
        this._sourceStopped = false;
        const options = (0, $l4RVz.optionsFromArguments)($74913a93128eec52$export$30cbf4ba14db4fdd.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        (0, $fDBOr.connect)(this._source, this._gainNode);
        this._source.onended = ()=>this._stopSource();
        /**
         * The playbackRate of the buffer
         */ this.playbackRate = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._source.playbackRate,
            units: "positive",
            value: options.playbackRate
        });
        // set some values initially
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this._buffer = new (0, $9j0vm.ToneAudioBuffer)(options.url, options.onload, options.onerror);
        this._internalChannels.push(this._source);
    }
    static getDefaults() {
        return Object.assign((0, $5lK3u.OneShotSource).getDefaults(), {
            url: new (0, $9j0vm.ToneAudioBuffer)(),
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $AD7W4.noOp),
            onerror: (0, $AD7W4.noOp),
            playbackRate: 1
        });
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(t) {
        this._fadeIn = t;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(t) {
        this._fadeOut = t;
    }
    /**
     * The curve applied to the fades, either "linear" or "exponential"
     */ get curve() {
        return this._curve;
    }
    set curve(t) {
        this._curve = t;
    }
    /**
     * Start the buffer
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     * @param  gain  The gain to play the buffer back at.
     */ start(time, offset, duration, gain = 1) {
        (0, $6Utwn.assert)(this.buffer.loaded, "buffer is either not set or not loaded");
        const computedTime = this.toSeconds(time);
        // apply the gain envelope
        this._startGain(computedTime, gain);
        // if it's a loop the default offset is the loopstart point
        if (this.loop) offset = (0, $l4RVz.defaultArg)(offset, this.loopStart);
        else // otherwise the default offset is 0
        offset = (0, $l4RVz.defaultArg)(offset, 0);
        // make sure the offset is not less than 0
        let computedOffset = Math.max(this.toSeconds(offset), 0);
        // start the buffer source
        if (this.loop) {
            // modify the offset if it's greater than the loop time
            const loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
            const loopStart = this.toSeconds(this.loopStart);
            const loopDuration = loopEnd - loopStart;
            // move the offset back
            if ((0, $j4WGs.GTE)(computedOffset, loopEnd)) computedOffset = (computedOffset - loopStart) % loopDuration + loopStart;
            // when the offset is very close to the duration, set it to 0
            if ((0, $j4WGs.EQ)(computedOffset, this.buffer.duration)) computedOffset = 0;
        }
        // this.buffer.loaded would have return false if the AudioBuffer was undefined
        this._source.buffer = this.buffer.get();
        this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
        if ((0, $j4WGs.LT)(computedOffset, this.buffer.duration)) {
            this._sourceStarted = true;
            this._source.start(computedTime, computedOffset);
        }
        // if a duration is given, schedule a stop
        if ((0, $lQ01C.isDefined)(duration)) {
            let computedDur = this.toSeconds(duration);
            // make sure it's never negative
            computedDur = Math.max(computedDur, 0);
            this.stop(computedTime + computedDur);
        }
        return this;
    }
    _stopSource(time) {
        if (!this._sourceStopped && this._sourceStarted) {
            this._sourceStopped = true;
            this._source.stop(this.toSeconds(time));
            this._onended();
        }
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._source.loopStart;
    }
    set loopStart(loopStart) {
        this._source.loopStart = this.toSeconds(loopStart);
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._source.loopEnd;
    }
    set loopEnd(loopEnd) {
        this._source.loopEnd = this.toSeconds(loopEnd);
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     */ get loop() {
        return this._source.loop;
    }
    set loop(loop) {
        this._source.loop = loop;
        if (this._sourceStarted) this.cancelStop();
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._source.onended = null;
        this._source.disconnect();
        this._buffer.dispose();
        this.playbackRate.dispose();
        return this;
    }
}

});


parcelRegister("jn7iu", function(module, exports) {

var $gztBd = parcelRequire("gztBd");

var $fDBOr = parcelRequire("fDBOr");

var $dTGN1 = parcelRequire("dTGN1");

var $l4RVz = parcelRequire("l4RVz");

var $6Utwn = parcelRequire("6Utwn");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");
class $e1a5d36438de38b8$export$187d60d76727d102 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e1a5d36438de38b8$export$187d60d76727d102.getDefaults(), arguments, [
            "volume"
        ]));
        this.name = "UserMedia";
        const options = (0, $l4RVz.optionsFromArguments)($e1a5d36438de38b8$export$187d60d76727d102.getDefaults(), arguments, [
            "volume"
        ]);
        this._volume = this.output = new (0, $dTGN1.Volume)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $AD7W4.readOnly)(this, "volume");
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Open the media stream. If a string is passed in, it is assumed
     * to be the label or id of the stream, if a number is passed in,
     * it is the input number of the stream.
     * @param  labelOrId The label or id of the audio input media device.
     *                   With no argument, the default stream is opened.
     * @return The promise is resolved when the stream is open.
     */ open(labelOrId) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            (0, $6Utwn.assert)($e1a5d36438de38b8$export$187d60d76727d102.supported, "UserMedia is not supported");
            // close the previous stream
            if (this.state === "started") this.close();
            const devices = yield $e1a5d36438de38b8$export$187d60d76727d102.enumerateDevices();
            if ((0, $lQ01C.isNumber)(labelOrId)) this._device = devices[labelOrId];
            else {
                this._device = devices.find((device)=>{
                    return device.label === labelOrId || device.deviceId === labelOrId;
                });
                // didn't find a matching device
                if (!this._device && devices.length > 0) this._device = devices[0];
                (0, $6Utwn.assert)((0, $lQ01C.isDefined)(this._device), `No matching device ${labelOrId}`);
            }
            // do getUserMedia
            const constraints = {
                audio: {
                    echoCancellation: false,
                    sampleRate: this.context.sampleRate,
                    noiseSuppression: false,
                    mozNoiseSuppression: false
                }
            };
            if (this._device) // @ts-ignore
            constraints.audio.deviceId = this._device.deviceId;
            const stream = yield navigator.mediaDevices.getUserMedia(constraints);
            // start a new source only if the previous one is closed
            if (!this._stream) {
                this._stream = stream;
                // Wrap a MediaStreamSourceNode around the live input stream.
                const mediaStreamNode = this.context.createMediaStreamSource(stream);
                // Connect the MediaStreamSourceNode to a gate gain node
                (0, $fDBOr.connect)(mediaStreamNode, this.output);
                this._mediaStream = mediaStreamNode;
            }
            return this;
        });
    }
    /**
     * Close the media stream
     */ close() {
        if (this._stream && this._mediaStream) {
            this._stream.getAudioTracks().forEach((track)=>{
                track.stop();
            });
            this._stream = undefined;
            // remove the old media stream
            this._mediaStream.disconnect();
            this._mediaStream = undefined;
        }
        this._device = undefined;
        return this;
    }
    /**
     * Returns a promise which resolves with the list of audio input devices available.
     * @return The promise that is resolved with the devices
     * @example
     * Tone.UserMedia.enumerateDevices().then((devices) => {
     * 	// print the device labels
     * 	console.log(devices.map(device => device.label));
     * });
     */ static enumerateDevices() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const allDevices = yield navigator.mediaDevices.enumerateDevices();
            return allDevices.filter((device)=>{
                return device.kind === "audioinput";
            });
        });
    }
    /**
     * Returns the playback state of the source, "started" when the microphone is open
     * and "stopped" when the mic is closed.
     */ get state() {
        return this._stream && this._stream.active ? "started" : "stopped";
    }
    /**
     * Returns an identifier for the represented device that is
     * persisted across sessions. It is un-guessable by other applications and
     * unique to the origin of the calling application. It is reset when the
     * user clears cookies (for Private Browsing, a different identifier is
     * used that is not persisted across sessions). Returns undefined when the
     * device is not open.
     */ get deviceId() {
        if (this._device) return this._device.deviceId;
        else return undefined;
    }
    /**
     * Returns a group identifier. Two devices have the
     * same group identifier if they belong to the same physical device.
     * Returns null  when the device is not open.
     */ get groupId() {
        if (this._device) return this._device.groupId;
        else return undefined;
    }
    /**
     * Returns a label describing this device (for example "Built-in Microphone").
     * Returns undefined when the device is not open or label is not available
     * because of permissions.
     */ get label() {
        if (this._device) return this._device.label;
        else return undefined;
    }
    /**
     * Mute the output.
     * @example
     * const mic = new Tone.UserMedia();
     * mic.open().then(() => {
     * 	// promise resolves when input is available
     * });
     * // mute the output
     * mic.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this.close();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
    /**
     * If getUserMedia is supported by the browser.
     */ static get supported() {
        return (0, $lQ01C.isDefined)(navigator.mediaDevices) && (0, $lQ01C.isDefined)(navigator.mediaDevices.getUserMedia);
    }
}

});

parcelRegister("1I557", function(module, exports) {

$parcel$export(module.exports, "Oscillator", () => $13edd793f9de6e37$export$c01c5c7b81696d70);

var $gztBd = parcelRequire("gztBd");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $eCi69 = parcelRequire("eCi69");

var $21sLj = parcelRequire("21sLj");

var $exR5B = parcelRequire("exR5B");

var $kcGXj = parcelRequire("kcGXj");

var $6Utwn = parcelRequire("6Utwn");

var $j4WGs = parcelRequire("j4WGs");
class $13edd793f9de6e37$export$c01c5c7b81696d70 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($13edd793f9de6e37$export$c01c5c7b81696d70.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "Oscillator";
        /**
         * the main oscillator
         */ this._oscillator = null;
        const options = (0, $l4RVz.optionsFromArguments)($13edd793f9de6e37$export$c01c5c7b81696d70.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        (0, $AD7W4.readOnly)(this, "frequency");
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $AD7W4.readOnly)(this, "detune");
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        this._type = options.type;
        if (options.partialCount && options.type !== "custom") this._type = this.baseType + options.partialCount.toString();
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            detune: 0,
            frequency: 440,
            partialCount: 0,
            partials: [],
            phase: 0,
            type: "sine"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        const computedTime = this.toSeconds(time);
        // new oscillator with previous values
        const oscillator = new (0, $kcGXj.ToneOscillatorNode)({
            context: this.context,
            onended: ()=>this.onstop(this)
        });
        this._oscillator = oscillator;
        if (this._wave) this._oscillator.setPeriodicWave(this._wave);
        else this._oscillator.type = this._type;
        // connect the control signal to the oscillator frequency & detune
        this._oscillator.connect(this.output);
        this.frequency.connect(this._oscillator.frequency);
        this.detune.connect(this._oscillator.detune);
        // start the oscillator
        this._oscillator.start(computedTime);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        if (this._oscillator) this._oscillator.stop(computedTime);
    }
    /**
     * Restart the oscillator. Does not stop the oscillator, but instead
     * just cancels any scheduled 'stop' from being invoked.
     */ _restart(time) {
        const computedTime = this.toSeconds(time);
        this.log("restart", computedTime);
        if (this._oscillator) this._oscillator.cancelStop();
        this._state.cancel(computedTime);
        return this;
    }
    /**
     * Sync the signal to the Transport's bpm. Any changes to the transports bpm,
     * will also affect the oscillators frequency.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * osc.frequency.value = 440;
     * // the ratio between the bpm and the frequency will be maintained
     * osc.syncFrequency();
     * // double the tempo
     * Tone.Transport.bpm.value *= 2;
     * // the frequency of the oscillator is doubled to 880
     */ syncFrequency() {
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the oscillator's frequency from the Transport.
     * See Oscillator.syncFrequency
     */ unsyncFrequency() {
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * Get a cached periodic wave. Avoids having to recompute
     * the oscillator values when they have already been computed
     * with the same values.
     */ _getCachedPeriodicWave() {
        if (this._type === "custom") {
            const oscProps = $13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.phase === this._phase && (0, $l4RVz.deepEquals)(description.partials, this._partials);
            });
            return oscProps;
        } else {
            const oscProps = $13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.type === this._type && description.phase === this._phase;
            });
            this._partialCount = oscProps ? oscProps.partialCount : this._partialCount;
            return oscProps;
        }
    }
    get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        const isBasicType = [
            "sine",
            "square",
            "sawtooth",
            "triangle"
        ].indexOf(type) !== -1;
        if (this._phase === 0 && isBasicType) {
            this._wave = undefined;
            this._partialCount = 0;
            // just go with the basic approach
            if (this._oscillator !== null) // already tested that it's a basic type
            this._oscillator.type = type;
        } else {
            // first check if the value is cached
            const cache = this._getCachedPeriodicWave();
            if ((0, $lQ01C.isDefined)(cache)) {
                const { partials: partials, wave: wave } = cache;
                this._wave = wave;
                this._partials = partials;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
            } else {
                const [real, imag] = this._getRealImaginary(type, this._phase);
                const periodicWave = this.context.createPeriodicWave(real, imag);
                this._wave = periodicWave;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
                // set the cache
                $13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache.push({
                    imag: imag,
                    partialCount: this._partialCount,
                    partials: this._partials,
                    phase: this._phase,
                    real: real,
                    type: this._type,
                    wave: this._wave
                });
                if ($13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache.length > 100) $13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache.shift();
            }
        }
    }
    get baseType() {
        return this._type.replace(this.partialCount.toString(), "");
    }
    set baseType(baseType) {
        if (this.partialCount && this._type !== "custom" && baseType !== "custom") this.type = baseType + this.partialCount;
        else this.type = baseType;
    }
    get partialCount() {
        return this._partialCount;
    }
    set partialCount(p) {
        (0, $6Utwn.assertRange)(p, 0);
        let type = this._type;
        const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);
        if (partial) type = partial[1];
        if (this._type !== "custom") {
            if (p === 0) this.type = type;
            else this.type = type + p.toString();
        } else {
            // extend or shorten the partials array
            const fullPartials = new Float32Array(p);
            // copy over the partials array
            this._partials.forEach((v, i)=>fullPartials[i] = v);
            this._partials = Array.from(fullPartials);
            this.type = this._type;
        }
    }
    /**
     * Returns the real and imaginary components based
     * on the oscillator type.
     * @returns [real: Float32Array, imaginary: Float32Array]
     */ _getRealImaginary(type, phase) {
        const fftSize = 4096;
        let periodicWaveSize = fftSize / 2;
        const real = new Float32Array(periodicWaveSize);
        const imag = new Float32Array(periodicWaveSize);
        let partialCount = 1;
        if (type === "custom") {
            partialCount = this._partials.length + 1;
            this._partialCount = this._partials.length;
            periodicWaveSize = partialCount;
            // if the partial count is 0, don't bother doing any computation
            if (this._partials.length === 0) return [
                real,
                imag
            ];
        } else {
            const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(type);
            if (partial) {
                partialCount = parseInt(partial[2], 10) + 1;
                this._partialCount = parseInt(partial[2], 10);
                type = partial[1];
                partialCount = Math.max(partialCount, 2);
                periodicWaveSize = partialCount;
            } else this._partialCount = 0;
            this._partials = [];
        }
        for(let n = 1; n < periodicWaveSize; ++n){
            const piFactor = 2 / (n * Math.PI);
            let b;
            switch(type){
                case "sine":
                    b = n <= partialCount ? 1 : 0;
                    this._partials[n - 1] = b;
                    break;
                case "square":
                    b = n & 1 ? 2 * piFactor : 0;
                    this._partials[n - 1] = b;
                    break;
                case "sawtooth":
                    b = piFactor * (n & 1 ? 1 : -1);
                    this._partials[n - 1] = b;
                    break;
                case "triangle":
                    if (n & 1) b = 2 * (piFactor * piFactor) * (n - 1 >> 1 & 1 ? -1 : 1);
                    else b = 0;
                    this._partials[n - 1] = b;
                    break;
                case "custom":
                    b = this._partials[n - 1];
                    break;
                default:
                    throw new TypeError("Oscillator: invalid type: " + type);
            }
            if (b !== 0) {
                real[n] = -b * Math.sin(phase * n);
                imag[n] = b * Math.cos(phase * n);
            } else {
                real[n] = 0;
                imag[n] = 0;
            }
        }
        return [
            real,
            imag
        ];
    }
    /**
     * Compute the inverse FFT for a given phase.
     */ _inverseFFT(real, imag, phase) {
        let sum = 0;
        const len = real.length;
        for(let i = 0; i < len; i++)sum += real[i] * Math.cos(i * phase) + imag[i] * Math.sin(i * phase);
        return sum;
    }
    /**
     * Returns the initial value of the oscillator when stopped.
     * E.g. a "sine" oscillator with phase = 90 would return an initial value of -1.
     */ getInitialValue() {
        const [real, imag] = this._getRealImaginary(this._type, 0);
        let maxValue = 0;
        const twoPi = Math.PI * 2;
        const testPositions = 32;
        // check for peaks in 16 places
        for(let i = 0; i < testPositions; i++)maxValue = Math.max(this._inverseFFT(real, imag, i / testPositions * twoPi), maxValue);
        return (0, $j4WGs.clamp)(-this._inverseFFT(real, imag, this._phase) / maxValue, -1, 1);
    }
    get partials() {
        return this._partials.slice(0, this.partialCount);
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) this.type = "custom";
    }
    get phase() {
        return this._phase * (180 / Math.PI);
    }
    set phase(phase) {
        this._phase = phase * Math.PI / 180;
        // reset the type
        this.type = this._type;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    dispose() {
        super.dispose();
        if (this._oscillator !== null) this._oscillator.dispose();
        this._wave = undefined;
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}
/**
 * Cache the periodic waves to avoid having to redo computations
 */ $13edd793f9de6e37$export$c01c5c7b81696d70._periodicWaveCache = [];

});
parcelRegister("exR5B", function(module, exports) {

$parcel$export(module.exports, "generateWaveform", () => $a96d542e02c91a83$export$c5486db94e413392);

var $gztBd = parcelRequire("gztBd");

var $iHery = parcelRequire("iHery");
function $a96d542e02c91a83$export$c5486db94e413392(instance, length) {
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
        const duration = length / instance.context.sampleRate;
        const context = new (0, $iHery.OfflineContext)(1, duration, instance.context.sampleRate);
        const clone = new instance.constructor(Object.assign(instance.get(), {
            // should do 2 iterations
            frequency: 2 / duration,
            // zero out the detune
            detune: 0,
            context: context
        })).toDestination();
        clone.start(0);
        const buffer = yield context.render();
        return buffer.getChannelData(0);
    });
}

});

parcelRegister("kcGXj", function(module, exports) {

$parcel$export(module.exports, "ToneOscillatorNode", () => $eb563fc0172a8c3c$export$284532b021137a4a);

var $fDBOr = parcelRequire("fDBOr");

var $lQP4J = parcelRequire("lQP4J");

var $l4RVz = parcelRequire("l4RVz");

var $5lK3u = parcelRequire("5lK3u");

var $AD7W4 = parcelRequire("AD7W4");
class $eb563fc0172a8c3c$export$284532b021137a4a extends (0, $5lK3u.OneShotSource) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($eb563fc0172a8c3c$export$284532b021137a4a.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "ToneOscillatorNode";
        /**
         * The oscillator
         */ this._oscillator = this.context.createOscillator();
        this._internalChannels = [
            this._oscillator
        ];
        const options = (0, $l4RVz.optionsFromArguments)($eb563fc0172a8c3c$export$284532b021137a4a.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        (0, $fDBOr.connect)(this._oscillator, this._gainNode);
        this.type = options.type;
        this.frequency = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._oscillator.frequency,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._oscillator.detune,
            units: "cents",
            value: options.detune
        });
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $5lK3u.OneShotSource).getDefaults(), {
            detune: 0,
            frequency: 440,
            type: "sine"
        });
    }
    /**
     * Start the oscillator node at the given time
     * @param  time When to start the oscillator
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._oscillator.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._oscillator.stop(time);
    }
    /**
     * Sets an arbitrary custom periodic waveform given a PeriodicWave.
     * @param  periodicWave PeriodicWave should be created with context.createPeriodicWave
     */ setPeriodicWave(periodicWave) {
        this._oscillator.setPeriodicWave(periodicWave);
        return this;
    }
    /**
     * The oscillator type. Either 'sine', 'sawtooth', 'square', or 'triangle'
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._oscillator.disconnect();
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}

});


parcelRegister("gSu6i", function(module, exports) {

$parcel$export(module.exports, "AMOscillator", () => $c49909d7872c304d$export$782fe1d3ba34f8d6);

var $gztBd = parcelRequire("gztBd");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $fdlW4 = parcelRequire("fdlW4");

var $QU03h = parcelRequire("QU03h");

var $21sLj = parcelRequire("21sLj");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");
class $c49909d7872c304d$export$782fe1d3ba34f8d6 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($c49909d7872c304d$export$782fe1d3ba34f8d6.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]));
        this.name = "AMOscillator";
        /**
         * convert the -1,1 output to 0,1
         */ this._modulationScale = new (0, $fdlW4.AudioToGain)({
            context: this.context
        });
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        const options = (0, $l4RVz.optionsFromArguments)($c49909d7872c304d$export$782fe1d3ba34f8d6.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        this._carrier = new (0, $1I557.Oscillator)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.frequency = this._carrier.frequency, this.detune = this._carrier.detune;
        this._modulator = new (0, $1I557.Oscillator)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $QU03h.Multiply)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        // connections
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1I557.Oscillator).getDefaults(), {
            harmonicity: 1,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
    }
    /**
     * The type of the carrier oscillator
     */ get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this._modulationScale.dispose();
        return this;
    }
}

});
parcelRegister("fdlW4", function(module, exports) {

$parcel$export(module.exports, "AudioToGain", () => $b13915e051b480d3$export$2e6ea0941c39f845);

var $jlPaH = parcelRequire("jlPaH");

var $jAeMP = parcelRequire("jAeMP");
class $b13915e051b480d3$export$2e6ea0941c39f845 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(...arguments);
        this.name = "AudioToGain";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            mapping: (x)=>(x + 1) / 2
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._norm;
        /**
         * The GainRange output [0, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}

});
parcelRegister("jlPaH", function(module, exports) {

$parcel$export(module.exports, "SignalOperator", () => $e167ac1c1c8c1cea$export$5d271ddbaaaa6dbe);

var $l4RVz = parcelRequire("l4RVz");

var $fDBOr = parcelRequire("fDBOr");

var $eCi69 = parcelRequire("eCi69");
class $e167ac1c1c8c1cea$export$5d271ddbaaaa6dbe extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($e167ac1c1c8c1cea$export$5d271ddbaaaa6dbe.getDefaults(), arguments, [
            "context"
        ])));
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        (0, $eCi69.connectSignal)(this, destination, outputNum, inputNum);
        return this;
    }
}

});

parcelRegister("jAeMP", function(module, exports) {

$parcel$export(module.exports, "WaveShaper", () => $e41cd968e56d6203$export$4d933d013693e78);

var $l4RVz = parcelRequire("l4RVz");

var $lQ01C = parcelRequire("lQ01C");

var $6Utwn = parcelRequire("6Utwn");

var $eCi69 = parcelRequire("eCi69");

var $jlPaH = parcelRequire("jlPaH");
class $e41cd968e56d6203$export$4d933d013693e78 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($e41cd968e56d6203$export$4d933d013693e78.getDefaults(), arguments, [
            "mapping",
            "length"
        ])));
        this.name = "WaveShaper";
        /**
         * the waveshaper node
         */ this._shaper = this.context.createWaveShaper();
        /**
         * The input to the waveshaper node.
         */ this.input = this._shaper;
        /**
         * The output from the waveshaper node
         */ this.output = this._shaper;
        const options = (0, $l4RVz.optionsFromArguments)($e41cd968e56d6203$export$4d933d013693e78.getDefaults(), arguments, [
            "mapping",
            "length"
        ]);
        if ((0, $lQ01C.isArray)(options.mapping) || options.mapping instanceof Float32Array) this.curve = Float32Array.from(options.mapping);
        else if ((0, $lQ01C.isFunction)(options.mapping)) this.setMap(options.mapping, options.length);
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            length: 1024
        });
    }
    /**
     * Uses a mapping function to set the value of the curve.
     * @param mapping The function used to define the values.
     *                The mapping function take two arguments:
     *                the first is the value at the current position
     *                which goes from -1 to 1 over the number of elements
     *                in the curve array. The second argument is the array position.
     * @example
     * const shaper = new Tone.WaveShaper();
     * // map the input signal from [-1, 1] to [0, 10]
     * shaper.setMap((val, index) => (val + 1) * 5);
     */ setMap(mapping, length = 1024) {
        const array = new Float32Array(length);
        for(let i = 0, len = length; i < len; i++){
            const normalized = i / (len - 1) * 2 - 1;
            array[i] = mapping(normalized, i);
        }
        this.curve = array;
        return this;
    }
    /**
     * The array to set as the waveshaper curve. For linear curves
     * array length does not make much difference, but for complex curves
     * longer arrays will provide smoother interpolation.
     */ get curve() {
        return this._shaper.curve;
    }
    set curve(mapping) {
        this._shaper.curve = mapping;
    }
    /**
     * Specifies what type of oversampling (if any) should be used when
     * applying the shaping curve. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        const isOverSampleType = [
            "none",
            "2x",
            "4x"
        ].some((str)=>str.includes(oversampling));
        (0, $6Utwn.assert)(isOverSampleType, "oversampling must be either 'none', '2x', or '4x'");
        this._shaper.oversample = oversampling;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._shaper.disconnect();
        return this;
    }
}

});


parcelRegister("QU03h", function(module, exports) {

$parcel$export(module.exports, "Multiply", () => $09f04bd8398886b0$export$f14f83b3b531d498);

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $eCi69 = parcelRequire("eCi69");
class $09f04bd8398886b0$export$f14f83b3b531d498 extends (0, $eCi69.Signal) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($09f04bd8398886b0$export$f14f83b3b531d498.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "Multiply";
        /**
         * Indicates if the value should be overridden on connection
         */ this.override = false;
        const options = (0, $l4RVz.optionsFromArguments)($09f04bd8398886b0$export$f14f83b3b531d498.getDefaults(), arguments, [
            "value"
        ]);
        this._mult = this.input = this.output = new (0, $bdbZZ.Gain)({
            context: this.context,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this.factor = this._param = this._mult.gain;
        this.factor.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._mult.dispose();
        return this;
    }
}

});


parcelRegister("8xh0e", function(module, exports) {

$parcel$export(module.exports, "FMOscillator", () => $019a8ed761c129ec$export$3055866937a7451d);

var $gztBd = parcelRequire("gztBd");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $QU03h = parcelRequire("QU03h");

var $eCi69 = parcelRequire("eCi69");

var $21sLj = parcelRequire("21sLj");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");
class $019a8ed761c129ec$export$3055866937a7451d extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($019a8ed761c129ec$export$3055866937a7451d.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]));
        this.name = "FMOscillator";
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        const options = (0, $l4RVz.optionsFromArguments)($019a8ed761c129ec$export$3055866937a7451d.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        this._carrier = new (0, $1I557.Oscillator)({
            context: this.context,
            detune: options.detune,
            frequency: 0,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.detune = this._carrier.detune;
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this._modulator = new (0, $1I557.Oscillator)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $QU03h.Multiply)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this.modulationIndex = new (0, $QU03h.Multiply)({
            context: this.context,
            units: "positive",
            value: options.modulationIndex
        });
        // connections
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
        this.detune.connect(this._modulator.detune);
        (0, $AD7W4.readOnly)(this, [
            "modulationIndex",
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1I557.Oscillator).getDefaults(), {
            harmonicity: 1,
            modulationIndex: 2,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
        return this;
    }
    get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}

});

parcelRegister("hMSJB", function(module, exports) {

$parcel$export(module.exports, "PulseOscillator", () => $cf31607b318fb2fb$export$f134e81916b1e032);

var $gztBd = parcelRequire("gztBd");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $eCi69 = parcelRequire("eCi69");

var $jAeMP = parcelRequire("jAeMP");

var $21sLj = parcelRequire("21sLj");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");
class $cf31607b318fb2fb$export$f134e81916b1e032 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($cf31607b318fb2fb$export$f134e81916b1e032.getDefaults(), arguments, [
            "frequency",
            "width"
        ]));
        this.name = "PulseOscillator";
        /**
         * gate the width amount
         */ this._widthGate = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        /**
         * Threshold the signal to turn it into a square
         */ this._thresh = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            mapping: (val)=>val <= 0 ? -1 : 1
        });
        const options = (0, $l4RVz.optionsFromArguments)($cf31607b318fb2fb$export$f134e81916b1e032.getDefaults(), arguments, [
            "frequency",
            "width"
        ]);
        this.width = new (0, $eCi69.Signal)({
            context: this.context,
            units: "audioRange",
            value: options.width
        });
        this._triangle = new (0, $1I557.Oscillator)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: "triangle"
        });
        this.frequency = this._triangle.frequency;
        this.detune = this._triangle.detune;
        // connections
        this._triangle.chain(this._thresh, this.output);
        this.width.chain(this._widthGate, this._thresh);
        (0, $AD7W4.readOnly)(this, [
            "width",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            detune: 0,
            frequency: 440,
            phase: 0,
            type: "pulse",
            width: 0.2
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._triangle.start(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._triangle.stop(time);
        // the width is still connected to the output.
        // that needs to be stopped also
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(0, time);
    }
    _restart(time) {
        this._triangle.restart(time);
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._triangle.phase;
    }
    set phase(phase) {
        this._triangle.phase = phase;
    }
    /**
     * The type of the oscillator. Always returns "pulse".
     */ get type() {
        return "pulse";
    }
    /**
     * The baseType of the oscillator. Always returns "pulse".
     */ get baseType() {
        return "pulse";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * *Internal use* The carrier oscillator type is fed through the
     * waveshaper node to create the pulse. Using different carrier oscillators
     * changes oscillator's behavior.
     */ set carrierType(type) {
        this._triangle.type = type;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    /**
     * Clean up method.
     */ dispose() {
        super.dispose();
        this._triangle.dispose();
        this.width.dispose();
        this._widthGate.dispose();
        this._thresh.dispose();
        return this;
    }
}

});

parcelRegister("4n6Sl", function(module, exports) {

$parcel$export(module.exports, "FatOscillator", () => $32eea4be56439699$export$a7d0bd116bda6b00);

var $gztBd = parcelRequire("gztBd");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $eCi69 = parcelRequire("eCi69");

var $21sLj = parcelRequire("21sLj");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");

var $6Utwn = parcelRequire("6Utwn");
class $32eea4be56439699$export$a7d0bd116bda6b00 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($32eea4be56439699$export$a7d0bd116bda6b00.getDefaults(), arguments, [
            "frequency",
            "type",
            "spread"
        ]));
        this.name = "FatOscillator";
        /**
         * The array of oscillators
         */ this._oscillators = [];
        const options = (0, $l4RVz.optionsFromArguments)($32eea4be56439699$export$a7d0bd116bda6b00.getDefaults(), arguments, [
            "frequency",
            "type",
            "spread"
        ]);
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this._spread = options.spread;
        this._type = options.type;
        this._phase = options.phase;
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        // set the count initially
        this.count = options.count;
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1I557.Oscillator).getDefaults(), {
            count: 3,
            spread: 20,
            type: "sawtooth"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.start(time));
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.stop(time));
    }
    _restart(time) {
        this._forEach((osc)=>osc.restart(time));
    }
    /**
     * Iterate over all of the oscillators
     */ _forEach(iterator) {
        for(let i = 0; i < this._oscillators.length; i++)iterator(this._oscillators[i], i);
    }
    /**
     * The type of the oscillator
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        this._forEach((osc)=>osc.type = type);
    }
    /**
     * The detune spread between the oscillators. If "count" is
     * set to 3 oscillators and the "spread" is set to 40,
     * the three oscillators would be detuned like this: [-20, 0, 20]
     * for a total detune spread of 40 cents.
     * @example
     * const fatOsc = new Tone.FatOscillator().toDestination().start();
     * fatOsc.spread = 70;
     */ get spread() {
        return this._spread;
    }
    set spread(spread) {
        this._spread = spread;
        if (this._oscillators.length > 1) {
            const start = -spread / 2;
            const step = spread / (this._oscillators.length - 1);
            this._forEach((osc, i)=>osc.detune.value = start + step * i);
        }
    }
    /**
     * The number of detuned oscillators. Must be an integer greater than 1.
     * @example
     * const fatOsc = new Tone.FatOscillator("C#3", "sawtooth").toDestination().start();
     * // use 4 sawtooth oscillators
     * fatOsc.count = 4;
     */ get count() {
        return this._oscillators.length;
    }
    set count(count) {
        (0, $6Utwn.assertRange)(count, 1);
        if (this._oscillators.length !== count) {
            // dispose the previous oscillators
            this._forEach((osc)=>osc.dispose());
            this._oscillators = [];
            for(let i = 0; i < count; i++){
                const osc = new (0, $1I557.Oscillator)({
                    context: this.context,
                    volume: -6 - count * 1.1,
                    type: this._type,
                    phase: this._phase + i / count * 360,
                    partialCount: this._partialCount,
                    onstop: i === 0 ? ()=>this.onstop(this) : (0, $AD7W4.noOp)
                });
                if (this.type === "custom") osc.partials = this._partials;
                this.frequency.connect(osc.frequency);
                this.detune.connect(osc.detune);
                osc.detune.overridden = false;
                osc.connect(this.output);
                this._oscillators[i] = osc;
            }
            // set the spread
            this.spread = this._spread;
            if (this.state === "started") this._forEach((osc)=>osc.start());
        }
    }
    get phase() {
        return this._phase;
    }
    set phase(phase) {
        this._phase = phase;
        this._forEach((osc, i)=>osc.phase = this._phase + i / this.count * 360);
    }
    get baseType() {
        return this._oscillators[0].baseType;
    }
    set baseType(baseType) {
        this._forEach((osc)=>osc.baseType = baseType);
        this._type = this._oscillators[0].type;
    }
    get partials() {
        return this._oscillators[0].partials;
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) {
            this._type = "custom";
            this._forEach((osc)=>osc.partials = partials);
        }
    }
    get partialCount() {
        return this._oscillators[0].partialCount;
    }
    set partialCount(partialCount) {
        this._partialCount = partialCount;
        this._forEach((osc)=>osc.partialCount = partialCount);
        this._type = this._oscillators[0].type;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._forEach((osc)=>osc.dispose());
        return this;
    }
}

});

parcelRegister("j5zUu", function(module, exports) {

$parcel$export(module.exports, "PWMOscillator", () => $de5a56f512586c7b$export$baa28c9ecd0db52);

var $gztBd = parcelRequire("gztBd");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $QU03h = parcelRequire("QU03h");

var $21sLj = parcelRequire("21sLj");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");

var $hMSJB = parcelRequire("hMSJB");
class $de5a56f512586c7b$export$baa28c9ecd0db52 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($de5a56f512586c7b$export$baa28c9ecd0db52.getDefaults(), arguments, [
            "frequency",
            "modulationFrequency"
        ]));
        this.name = "PWMOscillator";
        this.sourceType = "pwm";
        /**
         * Scale the oscillator so it doesn't go silent
         * at the extreme values.
         */ this._scale = new (0, $QU03h.Multiply)({
            context: this.context,
            value: 2
        });
        const options = (0, $l4RVz.optionsFromArguments)($de5a56f512586c7b$export$baa28c9ecd0db52.getDefaults(), arguments, [
            "frequency",
            "modulationFrequency"
        ]);
        this._pulse = new (0, $hMSJB.PulseOscillator)({
            context: this.context,
            frequency: options.modulationFrequency
        });
        // change the pulse oscillator type
        this._pulse.carrierType = "sine";
        this.modulationFrequency = this._pulse.frequency;
        this._modulator = new (0, $1I557.Oscillator)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase
        });
        this.frequency = this._modulator.frequency;
        this.detune = this._modulator.detune;
        // connections
        this._modulator.chain(this._scale, this._pulse.width);
        this._pulse.connect(this.output);
        (0, $AD7W4.readOnly)(this, [
            "modulationFrequency",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            detune: 0,
            frequency: 440,
            modulationFrequency: 0.4,
            phase: 0,
            type: "pwm"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._modulator.start(time);
        this._pulse.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._modulator.stop(time);
        this._pulse.stop(time);
    }
    /**
     * restart the oscillator
     */ _restart(time) {
        this._modulator.restart(time);
        this._pulse.restart(time);
    }
    /**
     * The type of the oscillator. Always returns "pwm".
     */ get type() {
        return "pwm";
    }
    /**
     * The baseType of the oscillator. Always returns "pwm".
     */ get baseType() {
        return "pwm";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._modulator.phase;
    }
    set phase(phase) {
        this._modulator.phase = phase;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._pulse.dispose();
        this._scale.dispose();
        this._modulator.dispose();
        return this;
    }
}

});

parcelRegister("5Abaq", function(module, exports) {

$parcel$export(module.exports, "OmniOscillator", () => $4108fa167486ae62$export$46c9f562e6d6ca6d);

var $gztBd = parcelRequire("gztBd");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $eCi69 = parcelRequire("eCi69");

var $21sLj = parcelRequire("21sLj");

var $gSu6i = parcelRequire("gSu6i");

var $4n6Sl = parcelRequire("4n6Sl");

var $8xh0e = parcelRequire("8xh0e");

var $1I557 = parcelRequire("1I557");

var $exR5B = parcelRequire("exR5B");

var $hMSJB = parcelRequire("hMSJB");

var $j5zUu = parcelRequire("j5zUu");
const $4108fa167486ae62$var$OmniOscillatorSourceMap = {
    am: (0, $gSu6i.AMOscillator),
    fat: (0, $4n6Sl.FatOscillator),
    fm: (0, $8xh0e.FMOscillator),
    oscillator: (0, $1I557.Oscillator),
    pulse: (0, $hMSJB.PulseOscillator),
    pwm: (0, $j5zUu.PWMOscillator)
};
class $4108fa167486ae62$export$46c9f562e6d6ca6d extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($4108fa167486ae62$export$46c9f562e6d6ca6d.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "OmniOscillator";
        const options = (0, $l4RVz.optionsFromArguments)($4108fa167486ae62$export$46c9f562e6d6ca6d.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "detune"
        ]);
        // set the options
        this.set(options);
    }
    static getDefaults() {
        return Object.assign((0, $1I557.Oscillator).getDefaults(), (0, $8xh0e.FMOscillator).getDefaults(), (0, $gSu6i.AMOscillator).getDefaults(), (0, $4n6Sl.FatOscillator).getDefaults(), (0, $hMSJB.PulseOscillator).getDefaults(), (0, $j5zUu.PWMOscillator).getDefaults());
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._oscillator.start(time);
    }
    /**
     * start the oscillator
     */ _stop(time) {
        this._oscillator.stop(time);
    }
    _restart(time) {
        this._oscillator.restart(time);
        return this;
    }
    /**
     * The type of the oscillator. Can be any of the basic types: sine, square, triangle, sawtooth. Or
     * prefix the basic types with "fm", "am", or "fat" to use the FMOscillator, AMOscillator or FatOscillator
     * types. The oscillator could also be set to "pwm" or "pulse". All of the parameters of the
     * oscillator's class are accessible when the oscillator is set to that type, but throws an error
     * when it's not.
     * @example
     * const omniOsc = new Tone.OmniOscillator().toDestination().start();
     * omniOsc.type = "pwm";
     * // modulationFrequency is parameter which is available
     * // only when the type is "pwm".
     * omniOsc.modulationFrequency.value = 0.5;
     */ get type() {
        let prefix = "";
        if ([
            "am",
            "fm",
            "fat"
        ].some((p)=>this._sourceType === p)) prefix = this._sourceType;
        return prefix + this._oscillator.type;
    }
    set type(type) {
        if (type.substr(0, 2) === "fm") {
            this._createNewOscillator("fm");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 2) === "am") {
            this._createNewOscillator("am");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 3) === "fat") {
            this._createNewOscillator("fat");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(3);
        } else if (type === "pwm") {
            this._createNewOscillator("pwm");
            this._oscillator = this._oscillator;
        } else if (type === "pulse") this._createNewOscillator("pulse");
        else {
            this._createNewOscillator("oscillator");
            this._oscillator = this._oscillator;
            this._oscillator.type = type;
        }
    }
    /**
     * The value is an empty array when the type is not "custom".
     * This is not available on "pwm" and "pulse" oscillator types.
     * See [[Oscillator.partials]]
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partials = partials;
    }
    get partialCount() {
        return this._oscillator.partialCount;
    }
    set partialCount(partialCount) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partialCount = partialCount;
    }
    set(props) {
        // make sure the type is set first
        if (Reflect.has(props, "type") && props.type) this.type = props.type;
        // then set the rest
        super.set(props);
        return this;
    }
    /**
     * connect the oscillator to the frequency and detune signals
     */ _createNewOscillator(oscType) {
        if (oscType !== this._sourceType) {
            this._sourceType = oscType;
            const OscConstructor = $4108fa167486ae62$var$OmniOscillatorSourceMap[oscType];
            // short delay to avoid clicks on the change
            const now = this.now();
            if (this._oscillator) {
                const oldOsc = this._oscillator;
                oldOsc.stop(now);
                // dispose the old one
                this.context.setTimeout(()=>oldOsc.dispose(), this.blockTime);
            }
            this._oscillator = new OscConstructor({
                context: this.context
            });
            this.frequency.connect(this._oscillator.frequency);
            this.detune.connect(this._oscillator.detune);
            this._oscillator.connect(this.output);
            this._oscillator.onstop = ()=>this.onstop(this);
            if (this.state === "started") this._oscillator.start(now);
        }
    }
    get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
    }
    /**
     * The source type of the oscillator.
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare");
     * console.log(omniOsc.sourceType); // 'fm'
     */ get sourceType() {
        return this._sourceType;
    }
    set sourceType(sType) {
        // the basetype defaults to sine
        let baseType = "sine";
        if (this._oscillator.type !== "pwm" && this._oscillator.type !== "pulse") baseType = this._oscillator.type;
        // set the type
        if (sType === "fm") this.type = "fm" + baseType;
        else if (sType === "am") this.type = "am" + baseType;
        else if (sType === "fat") this.type = "fat" + baseType;
        else if (sType === "oscillator") this.type = baseType;
        else if (sType === "pulse") this.type = "pulse";
        else if (sType === "pwm") this.type = "pwm";
    }
    _getOscType(osc, sourceType) {
        return osc instanceof $4108fa167486ae62$var$OmniOscillatorSourceMap[sourceType];
    }
    /**
     * The base type of the oscillator. See [[Oscillator.baseType]]
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare4");
     * console.log(omniOsc.sourceType, omniOsc.baseType, omniOsc.partialCount);
     */ get baseType() {
        return this._oscillator.baseType;
    }
    set baseType(baseType) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm") && baseType !== "pulse" && baseType !== "pwm") this._oscillator.baseType = baseType;
    }
    /**
     * The width of the oscillator when sourceType === "pulse".
     * See [[PWMOscillator.width]]
     */ get width() {
        if (this._getOscType(this._oscillator, "pulse")) return this._oscillator.width;
        else return undefined;
    }
    /**
     * The number of detuned oscillators when sourceType === "fat".
     * See [[FatOscillator.count]]
     */ get count() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.count;
        else return undefined;
    }
    set count(count) {
        if (this._getOscType(this._oscillator, "fat") && (0, $lQ01C.isNumber)(count)) this._oscillator.count = count;
    }
    /**
     * The detune spread between the oscillators when sourceType === "fat".
     * See [[FatOscillator.count]]
     */ get spread() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.spread;
        else return undefined;
    }
    set spread(spread) {
        if (this._getOscType(this._oscillator, "fat") && (0, $lQ01C.isNumber)(spread)) this._oscillator.spread = spread;
    }
    /**
     * The type of the modulator oscillator. Only if the oscillator is set to "am" or "fm" types.
     * See [[AMOscillator]] or [[FMOscillator]]
     */ get modulationType() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.modulationType;
        else return undefined;
    }
    set modulationType(mType) {
        if ((this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) && (0, $lQ01C.isString)(mType)) this._oscillator.modulationType = mType;
    }
    /**
     * The modulation index when the sourceType === "fm"
     * See [[FMOscillator]].
     */ get modulationIndex() {
        if (this._getOscType(this._oscillator, "fm")) return this._oscillator.modulationIndex;
        else return undefined;
    }
    /**
     * Harmonicity is the frequency ratio between the carrier and the modulator oscillators.
     * See [[AMOscillator]] or [[FMOscillator]]
     */ get harmonicity() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.harmonicity;
        else return undefined;
    }
    /**
     * The modulationFrequency Signal of the oscillator when sourceType === "pwm"
     * see [[PWMOscillator]]
     * @min 0.1
     * @max 5
     */ get modulationFrequency() {
        if (this._getOscType(this._oscillator, "pwm")) return this._oscillator.modulationFrequency;
        else return undefined;
    }
    asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            return (0, $exR5B.generateWaveform)(this, length);
        });
    }
    dispose() {
        super.dispose();
        this.detune.dispose();
        this.frequency.dispose();
        this._oscillator.dispose();
        return this;
    }
}

});

parcelRegister("lNxm0", function(module, exports) {

$parcel$export(module.exports, "LFO", () => $fde80bfa18c0a5fe$export$603054d5ec296d77);

var $bdbZZ = parcelRequire("bdbZZ");

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $fdlW4 = parcelRequire("fdlW4");

var $1zJwt = parcelRequire("1zJwt");

var $eCi69 = parcelRequire("eCi69");

var $b1lyj = parcelRequire("b1lyj");

var $1I557 = parcelRequire("1I557");
class $fde80bfa18c0a5fe$export$603054d5ec296d77 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($fde80bfa18c0a5fe$export$603054d5ec296d77.getDefaults(), arguments, [
            "frequency",
            "min",
            "max"
        ]));
        this.name = "LFO";
        /**
         * The value that the LFO outputs when it's stopped
         */ this._stoppedValue = 0;
        /**
         * A private placeholder for the units
         */ this._units = "number";
        /**
         * If the input value is converted using the [[units]]
         */ this.convert = true;
        /**
         * Private methods borrowed from Param
         */ // @ts-ignore
        this._fromType = (0, $lQP4J.Param).prototype._fromType;
        // @ts-ignore
        this._toType = (0, $lQP4J.Param).prototype._toType;
        // @ts-ignore
        this._is = (0, $lQP4J.Param).prototype._is;
        // @ts-ignore
        this._clampValue = (0, $lQP4J.Param).prototype._clampValue;
        const options = (0, $l4RVz.optionsFromArguments)($fde80bfa18c0a5fe$export$603054d5ec296d77.getDefaults(), arguments, [
            "frequency",
            "min",
            "max"
        ]);
        this._oscillator = new (0, $1I557.Oscillator)(options);
        this.frequency = this._oscillator.frequency;
        this._amplitudeGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.amplitude,
            units: "normalRange"
        });
        this.amplitude = this._amplitudeGain.gain;
        this._stoppedSignal = new (0, $eCi69.Signal)({
            context: this.context,
            units: "audioRange",
            value: 0
        });
        this._zeros = new (0, $b1lyj.Zero)({
            context: this.context
        });
        this._a2g = new (0, $fdlW4.AudioToGain)({
            context: this.context
        });
        this._scaler = this.output = new (0, $1zJwt.Scale)({
            context: this.context,
            max: options.max,
            min: options.min
        });
        this.units = options.units;
        this.min = options.min;
        this.max = options.max;
        // connect it up
        this._oscillator.chain(this._amplitudeGain, this._a2g, this._scaler);
        this._zeros.connect(this._a2g);
        this._stoppedSignal.connect(this._a2g);
        (0, $AD7W4.readOnly)(this, [
            "amplitude",
            "frequency"
        ]);
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $1I557.Oscillator).getDefaults(), {
            amplitude: 1,
            frequency: "4n",
            max: 1,
            min: 0,
            type: "sine",
            units: "number"
        });
    }
    /**
     * Start the LFO.
     * @param time The time the LFO will start
     */ start(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(0, time);
        this._oscillator.start(time);
        return this;
    }
    /**
     * Stop the LFO.
     * @param  time The time the LFO will stop
     */ stop(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(this._stoppedValue, time);
        this._oscillator.stop(time);
        return this;
    }
    /**
     * Sync the start/stop/pause to the transport
     * and the frequency to the bpm of the transport
     * @example
     * const lfo = new Tone.LFO("8n");
     * lfo.sync().start(0);
     * // the rate of the LFO will always be an eighth note, even as the tempo changes
     */ sync() {
        this._oscillator.sync();
        this._oscillator.syncFrequency();
        return this;
    }
    /**
     * unsync the LFO from transport control
     */ unsync() {
        this._oscillator.unsync();
        this._oscillator.unsyncFrequency();
        return this;
    }
    /**
     * After the oscillator waveform is updated, reset the `_stoppedSignal` value to match the updated waveform
     */ _setStoppedValue() {
        this._stoppedValue = this._oscillator.getInitialValue();
        this._stoppedSignal.value = this._stoppedValue;
    }
    /**
     * The minimum output of the LFO.
     */ get min() {
        return this._toType(this._scaler.min);
    }
    set min(min) {
        min = this._fromType(min);
        this._scaler.min = min;
    }
    /**
     * The maximum output of the LFO.
     */ get max() {
        return this._toType(this._scaler.max);
    }
    set max(max) {
        max = this._fromType(max);
        this._scaler.max = max;
    }
    /**
     * The type of the oscillator: See [[Oscillator.type]]
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
        this._setStoppedValue();
    }
    /**
     * The oscillator's partials array: See [[Oscillator.partials]]
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        this._oscillator.partials = partials;
        this._setStoppedValue();
    }
    /**
     * The phase of the LFO.
     */ get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
        this._setStoppedValue();
    }
    /**
     * The output units of the LFO.
     */ get units() {
        return this._units;
    }
    set units(val) {
        const currentMin = this.min;
        const currentMax = this.max;
        // convert the min and the max
        this._units = val;
        this.min = currentMin;
        this.max = currentMax;
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     */ get state() {
        return this._oscillator.state;
    }
    /**
     * @param node the destination to connect to
     * @param outputNum the optional output number
     * @param inputNum the input number
     */ connect(node, outputNum, inputNum) {
        if (node instanceof (0, $lQP4J.Param) || node instanceof (0, $eCi69.Signal)) {
            this.convert = node.convert;
            this.units = node.units;
        }
        (0, $eCi69.connectSignal)(this, node, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._oscillator.dispose();
        this._stoppedSignal.dispose();
        this._zeros.dispose();
        this._scaler.dispose();
        this._a2g.dispose();
        this._amplitudeGain.dispose();
        this.amplitude.dispose();
        return this;
    }
}

});
parcelRegister("1zJwt", function(module, exports) {

$parcel$export(module.exports, "Scale", () => $125c5f2f34bd3963$export$d60cfc58d3c358b6);

var $l4RVz = parcelRequire("l4RVz");

var $7AA9s = parcelRequire("7AA9s");

var $QU03h = parcelRequire("QU03h");

var $jlPaH = parcelRequire("jlPaH");
class $125c5f2f34bd3963$export$d60cfc58d3c358b6 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($125c5f2f34bd3963$export$d60cfc58d3c358b6.getDefaults(), arguments, [
            "min",
            "max"
        ])));
        this.name = "Scale";
        const options = (0, $l4RVz.optionsFromArguments)($125c5f2f34bd3963$export$d60cfc58d3c358b6.getDefaults(), arguments, [
            "min",
            "max"
        ]);
        this._mult = this.input = new (0, $QU03h.Multiply)({
            context: this.context,
            value: options.max - options.min
        });
        this._add = this.output = new (0, $7AA9s.Add)({
            context: this.context,
            value: options.min
        });
        this._min = options.min;
        this._max = options.max;
        this.input.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $jlPaH.SignalOperator).getDefaults(), {
            max: 1,
            min: 0
        });
    }
    /**
     * The minimum output value. This number is output when the value input value is 0.
     */ get min() {
        return this._min;
    }
    set min(min) {
        this._min = min;
        this._setRange();
    }
    /**
     * The maximum output value. This number is output when the value input value is 1.
     */ get max() {
        return this._max;
    }
    set max(max) {
        this._max = max;
        this._setRange();
    }
    /**
     * set the values
     */ _setRange() {
        this._add.value = this._min;
        this._mult.value = this._max - this._min;
    }
    dispose() {
        super.dispose();
        this._add.dispose();
        this._mult.dispose();
        return this;
    }
}

});
parcelRegister("7AA9s", function(module, exports) {

$parcel$export(module.exports, "Add", () => $5867f0218e2e08a6$export$d0265b2c425512d6);

var $fDBOr = parcelRequire("fDBOr");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $eCi69 = parcelRequire("eCi69");
class $5867f0218e2e08a6$export$d0265b2c425512d6 extends (0, $eCi69.Signal) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($5867f0218e2e08a6$export$d0265b2c425512d6.getDefaults(), arguments, [
            "value"
        ])));
        this.override = false;
        this.name = "Add";
        /**
         * the summing node
         */ this._sum = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * The value which is added to the input signal
         */ this.addend = this._param;
        (0, $fDBOr.connectSeries)(this._constantSource, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._sum.dispose();
        return this;
    }
}

});


parcelRegister("b1lyj", function(module, exports) {

$parcel$export(module.exports, "Zero", () => $806081964a07f179$export$aaef8a3eae948f03);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $jlPaH = parcelRequire("jlPaH");
class $806081964a07f179$export$aaef8a3eae948f03 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($806081964a07f179$export$aaef8a3eae948f03.getDefaults(), arguments)));
        this.name = "Zero";
        /**
         * The gain node which connects the constant source to the output
         */ this._gain = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * Only outputs 0
         */ this.output = this._gain;
        /**
         * no input node
         */ this.input = undefined;
        (0, $fDBOr.connect)(this.context.getConstant(0), this._gain);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        (0, $fDBOr.disconnect)(this.context.getConstant(0), this._gain);
        return this;
    }
}

});


parcelRegister("ihNA0", function(module, exports) {

$parcel$export(module.exports, "Player", () => $d5004609db9c1091$export$2616165974278734);

var $gztBd = parcelRequire("gztBd");

var $9j0vm = parcelRequire("9j0vm");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $21sLj = parcelRequire("21sLj");

var $a0u4l = parcelRequire("a0u4l");

var $6Utwn = parcelRequire("6Utwn");

var $hLrAi = parcelRequire("hLrAi");
class $d5004609db9c1091$export$2616165974278734 extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($d5004609db9c1091$export$2616165974278734.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "Player";
        /**
         * All of the active buffer source nodes
         */ this._activeSources = new Set();
        const options = (0, $l4RVz.optionsFromArguments)($d5004609db9c1091$export$2616165974278734.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this._buffer = new (0, $9j0vm.ToneAudioBuffer)({
            onload: this._onload.bind(this, options.onload),
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this.autostart = options.autostart;
        this._loop = options.loop;
        this._loopStart = options.loopStart;
        this._loopEnd = options.loopEnd;
        this._playbackRate = options.playbackRate;
        this.fadeIn = options.fadeIn;
        this.fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            autostart: false,
            fadeIn: 0,
            fadeOut: 0,
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $AD7W4.noOp),
            onerror: (0, $AD7W4.noOp),
            playbackRate: 1,
            reverse: false
        });
    }
    /**
     * Load the audio file as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * Note: this does not need to be called if a url
     * was passed in to the constructor. Only use this
     * if you want to manually load a new url.
     * @param url The url of the buffer to load. Filetype support depends on the browser.
     */ load(url) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            yield this._buffer.load(url);
            this._onload();
            return this;
        });
    }
    /**
     * Internal callback when the buffer is loaded.
     */ _onload(callback = (0, $AD7W4.noOp)) {
        callback();
        if (this.autostart) this.start();
    }
    /**
     * Internal callback when the buffer is done playing.
     */ _onSourceEnd(source) {
        // invoke the onstop function
        this.onstop(this);
        // delete the source from the active sources
        this._activeSources.delete(source);
        if (this._activeSources.size === 0 && !this._synced && this._state.getValueAtTime(this.now()) === "started") {
            // remove the 'implicitEnd' event and replace with an explicit end
            this._state.cancel(this.now());
            this._state.setStateAtTime("stopped", this.now());
        }
    }
    /**
     * Play the buffer at the given startTime. Optionally add an offset
     * and/or duration which will play the buffer from a position
     * within the buffer for the given duration.
     *
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     */ start(time, offset, duration) {
        super.start(time, offset, duration);
        return this;
    }
    /**
     * Internal start method
     */ _start(startTime, offset, duration) {
        // if it's a loop the default offset is the loopStart point
        if (this._loop) offset = (0, $l4RVz.defaultArg)(offset, this._loopStart);
        else // otherwise the default offset is 0
        offset = (0, $l4RVz.defaultArg)(offset, 0);
        // compute the values in seconds
        const computedOffset = this.toSeconds(offset);
        // compute the duration which is either the passed in duration of the buffer.duration - offset
        const origDuration = duration;
        duration = (0, $l4RVz.defaultArg)(duration, Math.max(this._buffer.duration - computedOffset, 0));
        let computedDuration = this.toSeconds(duration);
        // scale it by the playback rate
        computedDuration = computedDuration / this._playbackRate;
        // get the start time
        startTime = this.toSeconds(startTime);
        // make the source
        const source = new (0, $a0u4l.ToneBufferSource)({
            url: this._buffer,
            context: this.context,
            fadeIn: this.fadeIn,
            fadeOut: this.fadeOut,
            loop: this._loop,
            loopEnd: this._loopEnd,
            loopStart: this._loopStart,
            onended: this._onSourceEnd.bind(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        // set the looping properties
        if (!this._loop && !this._synced) {
            // cancel the previous stop
            this._state.cancel(startTime + computedDuration);
            // if it's not looping, set the state change at the end of the sample
            this._state.setStateAtTime("stopped", startTime + computedDuration, {
                implicitEnd: true
            });
        }
        // add it to the array of active sources
        this._activeSources.add(source);
        // start it
        if (this._loop && (0, $lQ01C.isUndef)(origDuration)) source.start(startTime, computedOffset);
        else // subtract the fade out time
        source.start(startTime, computedOffset, computedDuration - this.toSeconds(this.fadeOut));
    }
    /**
     * Stop playback.
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((source)=>source.stop(computedTime));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        this._stop(time);
        this._start(time, offset, duration);
    }
    /**
     * Seek to a specific time in the player's buffer. If the
     * source is no longer playing at that time, it will stop.
     * @param offset The time to seek to.
     * @param when The time for the seek event to occur.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/gurgling_theremin_1.mp3", () => {
     * 	player.start();
     * 	// seek to the offset in 1 second from now
     * 	player.seek(0.4, "+1");
     * }).toDestination();
     */ seek(offset, when) {
        const computedTime = this.toSeconds(when);
        if (this._state.getValueAtTime(computedTime) === "started") {
            const computedOffset = this.toSeconds(offset);
            // if it's currently playing, stop it
            this._stop(computedTime);
            // restart it at the given time
            this._start(computedTime, computedOffset);
        }
        return this;
    }
    /**
     * Set the loop start and end. Will only loop if loop is set to true.
     * @param loopStart The loop start time
     * @param loopEnd The loop end time
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/malevoices_aa2_F3.mp3").toDestination();
     * // loop between the given points
     * player.setLoopPoints(0.2, 0.3);
     * player.loop = true;
     * player.autostart = true;
     */ setLoopPoints(loopStart, loopEnd) {
        this.loopStart = loopStart;
        this.loopEnd = loopEnd;
        return this;
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(loopStart) {
        this._loopStart = loopStart;
        if (this.buffer.loaded) (0, $6Utwn.assertRange)(this.toSeconds(loopStart), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopStart = loopStart;
        });
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(loopEnd) {
        this._loopEnd = loopEnd;
        if (this.buffer.loaded) (0, $6Utwn.assertRange)(this.toSeconds(loopEnd), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopEnd = loopEnd;
        });
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/breakbeat.mp3").toDestination();
     * player.loop = true;
     * player.autostart = true;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        // if no change, do nothing
        if (this._loop === loop) return;
        this._loop = loop;
        // set the loop of all of the sources
        this._activeSources.forEach((source)=>{
            source.loop = loop;
        });
        if (loop) {
            // remove the next stopEvent
            const stopEvent = this._state.getNextState("stopped", this.now());
            if (stopEvent) this._state.cancel(stopEvent.time);
        }
    }
    /**
     * Normal speed is 1. The pitch will change with the playback rate.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/femalevoices_aa2_A5.mp3").toDestination();
     * // play at 1/4 speed
     * player.playbackRate = 0.25;
     * // play as soon as the buffer is loaded
     * player.autostart = true;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        const now = this.now();
        // cancel the stop event since it's at a different time now
        const stopEvent = this._state.getNextState("stopped", now);
        if (stopEvent && stopEvent.implicitEnd) {
            this._state.cancel(stopEvent.time);
            this._activeSources.forEach((source)=>source.cancelStop());
        }
        // set all the sources
        this._activeSources.forEach((source)=>{
            source.playbackRate.setValueAtTime(rate, now);
        });
    }
    /**
     * If the buffer should be reversed
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/chime_1.mp3").toDestination();
     * player.autostart = true;
     * player.reverse = true;
     */ get reverse() {
        return this._buffer.reverse;
    }
    set reverse(rev) {
        this._buffer.reverse = rev;
    }
    /**
     * If the buffer is loaded
     */ get loaded() {
        return this._buffer.loaded;
    }
    dispose() {
        super.dispose();
        // disconnect all of the players
        this._activeSources.forEach((source)=>source.dispose());
        this._activeSources.clear();
        this._buffer.dispose();
        return this;
    }
}
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $d5004609db9c1091$export$2616165974278734.prototype, "fadeIn", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $d5004609db9c1091$export$2616165974278734.prototype, "fadeOut", void 0);

});
parcelRegister("hLrAi", function(module, exports) {

$parcel$export(module.exports, "range", () => $ceec3923046f903e$export$d02631cccf789723);
$parcel$export(module.exports, "timeRange", () => $ceec3923046f903e$export$4748a2e3a6d34ca5);

var $6Utwn = parcelRequire("6Utwn");
function $ceec3923046f903e$export$d02631cccf789723(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $6Utwn.assertRange)(newValue, min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}
function $ceec3923046f903e$export$4748a2e3a6d34ca5(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $6Utwn.assertRange)(this.toSeconds(newValue), min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}

});


parcelRegister("jxOmj", function(module, exports) {

var $dTGN1 = parcelRequire("dTGN1");

var $iace4 = parcelRequire("iace4");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $6Utwn = parcelRequire("6Utwn");

var $AD7W4 = parcelRequire("AD7W4");

var $21sLj = parcelRequire("21sLj");

var $ihNA0 = parcelRequire("ihNA0");
class $e3a8299893ab35b6$export$1912c9d78e93a6ed extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e3a8299893ab35b6$export$1912c9d78e93a6ed.getDefaults(), arguments, [
            "urls",
            "onload"
        ], "urls"));
        this.name = "Players";
        /**
         * Players has no input.
         */ this.input = undefined;
        /**
         * The container of all of the players
         */ this._players = new Map();
        const options = (0, $l4RVz.optionsFromArguments)($e3a8299893ab35b6$export$1912c9d78e93a6ed.getDefaults(), arguments, [
            "urls",
            "onload"
        ], "urls");
        /**
         * The output volume node
         */ this._volume = this.output = new (0, $dTGN1.Volume)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $AD7W4.readOnly)(this, "volume");
        this._buffers = new (0, $iace4.ToneAudioBuffers)({
            urls: options.urls,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        // mute initially
        this.mute = options.mute;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            baseUrl: "",
            fadeIn: 0,
            fadeOut: 0,
            mute: false,
            onload: (0, $AD7W4.noOp),
            onerror: (0, $AD7W4.noOp),
            urls: {},
            volume: 0
        });
    }
    /**
     * Mute the output.
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * The fadeIn time of the envelope applied to the source.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(fadeIn) {
        this._fadeIn = fadeIn;
        this._players.forEach((player)=>{
            player.fadeIn = fadeIn;
        });
    }
    /**
     * The fadeOut time of the each of the sources.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(fadeOut) {
        this._fadeOut = fadeOut;
        this._players.forEach((player)=>{
            player.fadeOut = fadeOut;
        });
    }
    /**
     * The state of the players object. Returns "started" if any of the players are playing.
     */ get state() {
        const playing = Array.from(this._players).some(([_, player])=>player.state === "started");
        return playing ? "started" : "stopped";
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name);
    }
    /**
     * Get a player by name.
     * @param  name  The players name as defined in the constructor object or `add` method.
     */ player(name) {
        (0, $6Utwn.assert)(this.has(name), `No Player with the name ${name} exists on this object`);
        if (!this._players.has(name)) {
            const player = new (0, $ihNA0.Player)({
                context: this.context,
                fadeIn: this._fadeIn,
                fadeOut: this._fadeOut,
                url: this._buffers.get(name)
            }).connect(this.output);
            this._players.set(name, player);
        }
        return this._players.get(name);
    }
    /**
     * If all the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Add a player by name and url to the Players
     * @param  name A unique name to give the player
     * @param  url  Either the url of the bufer or a buffer which will be added with the given name.
     * @param callback  The callback to invoke when the url is loaded.
     */ add(name, url, callback) {
        (0, $6Utwn.assert)(!this._buffers.has(name), "A buffer with that name already exists on this object");
        this._buffers.add(name, url, callback);
        return this;
    }
    /**
     * Stop all of the players at the given time
     * @param time The time to stop all of the players.
     */ stopAll(time) {
        this._players.forEach((player)=>player.stop(time));
        return this;
    }
    dispose() {
        super.dispose();
        this._volume.dispose();
        this.volume.dispose();
        this._players.forEach((player)=>player.dispose());
        this._buffers.dispose();
        return this;
    }
}

});

parcelRegister("3rWzZ", function(module, exports) {

var $21sLj = parcelRequire("21sLj");

var $AD7W4 = parcelRequire("AD7W4");

var $9j0vm = parcelRequire("9j0vm");

var $l4RVz = parcelRequire("l4RVz");

var $c60dh = parcelRequire("c60dh");

var $a0u4l = parcelRequire("a0u4l");

var $bmU6v = parcelRequire("bmU6v");

var $6Utwn = parcelRequire("6Utwn");
class $283155655d053e8a$export$564c6bce96a1f8e extends (0, $21sLj.Source) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($283155655d053e8a$export$564c6bce96a1f8e.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "GrainPlayer";
        /**
         * Internal loopStart value
         */ this._loopStart = 0;
        /**
         * Internal loopStart value
         */ this._loopEnd = 0;
        /**
         * All of the currently playing BufferSources
         */ this._activeSources = [];
        const options = (0, $l4RVz.optionsFromArguments)($283155655d053e8a$export$564c6bce96a1f8e.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this.buffer = new (0, $9j0vm.ToneAudioBuffer)({
            onload: options.onload,
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this._clock = new (0, $c60dh.Clock)({
            context: this.context,
            callback: this._tick.bind(this),
            frequency: 1 / options.grainSize
        });
        this._playbackRate = options.playbackRate;
        this._grainSize = options.grainSize;
        this._overlap = options.overlap;
        this.detune = options.detune;
        // setup
        this.overlap = options.overlap;
        this.loop = options.loop;
        this.playbackRate = options.playbackRate;
        this.grainSize = options.grainSize;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.reverse = options.reverse;
        this._clock.on("stop", this._onstop.bind(this));
    }
    static getDefaults() {
        return Object.assign((0, $21sLj.Source).getDefaults(), {
            onload: (0, $AD7W4.noOp),
            onerror: (0, $AD7W4.noOp),
            overlap: 0.1,
            grainSize: 0.2,
            playbackRate: 1,
            detune: 0,
            loop: false,
            loopStart: 0,
            loopEnd: 0,
            reverse: false
        });
    }
    /**
     * Internal start method
     */ _start(time, offset, duration) {
        offset = (0, $l4RVz.defaultArg)(offset, 0);
        offset = this.toSeconds(offset);
        time = this.toSeconds(time);
        const grainSize = 1 / this._clock.frequency.getValueAtTime(time);
        this._clock.start(time, offset / grainSize);
        if (duration) this.stop(time + this.toSeconds(duration));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        this._stop(time);
        this._start(time, offset, duration);
    }
    /**
     * Internal stop method
     */ _stop(time) {
        this._clock.stop(time);
    }
    /**
     * Invoked when the clock is stopped
     */ _onstop(time) {
        // stop the players
        this._activeSources.forEach((source)=>{
            source.fadeOut = 0;
            source.stop(time);
        });
        this.onstop(this);
    }
    /**
     * Invoked on each clock tick. scheduled a new grain at this time.
     */ _tick(time) {
        // check if it should stop looping
        const ticks = this._clock.getTicksAtTime(time);
        const offset = ticks * this._grainSize;
        this.log("offset", offset);
        if (!this.loop && offset > this.buffer.duration) {
            this.stop(time);
            return;
        }
        // at the beginning of the file, the fade in should be 0
        const fadeIn = offset < this._overlap ? 0 : this._overlap;
        // create a buffer source
        const source = new (0, $a0u4l.ToneBufferSource)({
            context: this.context,
            url: this.buffer,
            fadeIn: fadeIn,
            fadeOut: this._overlap,
            loop: this.loop,
            loopStart: this._loopStart,
            loopEnd: this._loopEnd,
            // compute the playbackRate based on the detune
            playbackRate: (0, $bmU6v.intervalToFrequencyRatio)(this.detune / 100)
        }).connect(this.output);
        source.start(time, this._grainSize * ticks);
        source.stop(time + this._grainSize / this.playbackRate);
        // add it to the active sources
        this._activeSources.push(source);
        // remove it when it's done
        source.onended = ()=>{
            const index = this._activeSources.indexOf(source);
            if (index !== -1) this._activeSources.splice(index, 1);
        };
    }
    /**
     * The playback rate of the sample
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        (0, $6Utwn.assertRange)(rate, 0.001);
        this._playbackRate = rate;
        this.grainSize = this._grainSize;
    }
    /**
     * The loop start time.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(time) {
        if (this.buffer.loaded) (0, $6Utwn.assertRange)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopStart = this.toSeconds(time);
    }
    /**
     * The loop end time.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(time) {
        if (this.buffer.loaded) (0, $6Utwn.assertRange)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopEnd = this.toSeconds(time);
    }
    /**
     * The direction the buffer should play in
     */ get reverse() {
        return this.buffer.reverse;
    }
    set reverse(rev) {
        this.buffer.reverse = rev;
    }
    /**
     * The size of each chunk of audio that the
     * buffer is chopped into and played back at.
     */ get grainSize() {
        return this._grainSize;
    }
    set grainSize(size) {
        this._grainSize = this.toSeconds(size);
        this._clock.frequency.setValueAtTime(this._playbackRate / this._grainSize, this.now());
    }
    /**
     * The duration of the cross-fade between successive grains.
     */ get overlap() {
        return this._overlap;
    }
    set overlap(time) {
        const computedTime = this.toSeconds(time);
        (0, $6Utwn.assertRange)(computedTime, 0);
        this._overlap = computedTime;
    }
    /**
     * If all the buffer is loaded
     */ get loaded() {
        return this.buffer.loaded;
    }
    dispose() {
        super.dispose();
        this.buffer.dispose();
        this._clock.dispose();
        this._activeSources.forEach((source)=>source.dispose());
        return this;
    }
}

});


parcelRegister("gRGwA", function(module, exports) {
parcelRequire("7AA9s");
parcelRequire("7t1Lk");
parcelRequire("fdlW4");
parcelRequire("7SBbL");
parcelRequire("3ruxu");
parcelRequire("bmGt3");
parcelRequire("QU03h");
parcelRequire("gVbAi");
parcelRequire("fRTgd");
parcelRequire("eCi69");
parcelRequire("1zJwt");
parcelRequire("9GEPW");
parcelRequire("j0HBF");
parcelRequire("itVZs");
parcelRequire("jAeMP");
parcelRequire("b1lyj");

});
parcelRegister("7t1Lk", function(module, exports) {

$parcel$export(module.exports, "Abs", () => $56fc9bcc24192592$export$b73c596ee8758a66);

var $jlPaH = parcelRequire("jlPaH");

var $jAeMP = parcelRequire("jAeMP");
class $56fc9bcc24192592$export$b73c596ee8758a66 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(...arguments);
        this.name = "Abs";
        /**
         * The node which converts the audio ranges
         */ this._abs = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            mapping: (val)=>{
                if (Math.abs(val) < 0.001) return 0;
                else return Math.abs(val);
            }
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._abs;
        /**
         * The output range [0, 1]
         */ this.output = this._abs;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._abs.dispose();
        return this;
    }
}

});

parcelRegister("7SBbL", function(module, exports) {

$parcel$export(module.exports, "GainToAudio", () => $5bca6c7831dcf950$export$770438008a544d9b);

var $jlPaH = parcelRequire("jlPaH");

var $jAeMP = parcelRequire("jAeMP");
class $5bca6c7831dcf950$export$770438008a544d9b extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(...arguments);
        this.name = "GainToAudio";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            mapping: (x)=>Math.abs(x) * 2 - 1
        });
        /**
         * The NormalRange input [0, 1]
         */ this.input = this._norm;
        /**
         * The AudioRange output [-1, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}

});

parcelRegister("3ruxu", function(module, exports) {

$parcel$export(module.exports, "GreaterThan", () => $281b952e2fd2ff8c$export$fdac76ab71aa5db6);

var $l4RVz = parcelRequire("l4RVz");

var $j0HBF = parcelRequire("j0HBF");

var $eCi69 = parcelRequire("eCi69");

var $bmGt3 = parcelRequire("bmGt3");

var $AD7W4 = parcelRequire("AD7W4");
class $281b952e2fd2ff8c$export$fdac76ab71aa5db6 extends (0, $eCi69.Signal) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($281b952e2fd2ff8c$export$fdac76ab71aa5db6.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "GreaterThan";
        this.override = false;
        const options = (0, $l4RVz.optionsFromArguments)($281b952e2fd2ff8c$export$fdac76ab71aa5db6.getDefaults(), arguments, [
            "value"
        ]);
        this._subtract = this.input = new (0, $j0HBF.Subtract)({
            context: this.context,
            value: options.value
        });
        this._gtz = this.output = new (0, $bmGt3.GreaterThanZero)({
            context: this.context
        });
        this.comparator = this._param = this._subtract.subtrahend;
        (0, $AD7W4.readOnly)(this, "comparator");
        // connect
        this._subtract.connect(this._gtz);
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._gtz.dispose();
        this._subtract.dispose();
        this.comparator.dispose();
        return this;
    }
}

});
parcelRegister("j0HBF", function(module, exports) {

$parcel$export(module.exports, "Subtract", () => $dd6fd7bc9206129b$export$8bc67ae85ef4b74f);

var $fDBOr = parcelRequire("fDBOr");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $gVbAi = parcelRequire("gVbAi");

var $eCi69 = parcelRequire("eCi69");
class $dd6fd7bc9206129b$export$8bc67ae85ef4b74f extends (0, $eCi69.Signal) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($dd6fd7bc9206129b$export$8bc67ae85ef4b74f.getDefaults(), arguments, [
            "value"
        ])));
        this.override = false;
        this.name = "Subtract";
        /**
         * the summing node
         */ this._sum = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * Negate the input of the second input before connecting it to the summing node.
         */ this._neg = new (0, $gVbAi.Negate)({
            context: this.context
        });
        /**
         * The value which is subtracted from the main signal
         */ this.subtrahend = this._param;
        (0, $fDBOr.connectSeries)(this._constantSource, this._neg, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $eCi69.Signal).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._neg.dispose();
        this._sum.dispose();
        return this;
    }
}

});
parcelRegister("gVbAi", function(module, exports) {

$parcel$export(module.exports, "Negate", () => $c51af4a7d379cdc0$export$a4e82151127277b0);

var $QU03h = parcelRequire("QU03h");

var $jlPaH = parcelRequire("jlPaH");
class $c51af4a7d379cdc0$export$a4e82151127277b0 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(...arguments);
        this.name = "Negate";
        /**
         * negation is done by multiplying by -1
         */ this._multiply = new (0, $QU03h.Multiply)({
            context: this.context,
            value: -1
        });
        /**
         * The input and output are equal to the multiply node
         */ this.input = this._multiply;
        this.output = this._multiply;
    }
    /**
     * clean up
     * @returns {Negate} this
     */ dispose() {
        super.dispose();
        this._multiply.dispose();
        return this;
    }
}

});


parcelRegister("bmGt3", function(module, exports) {

$parcel$export(module.exports, "GreaterThanZero", () => $8462b0f535282b02$export$fe50ca7dd7da9c45);

var $jlPaH = parcelRequire("jlPaH");

var $QU03h = parcelRequire("QU03h");

var $jAeMP = parcelRequire("jAeMP");

var $l4RVz = parcelRequire("l4RVz");
class $8462b0f535282b02$export$fe50ca7dd7da9c45 extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($8462b0f535282b02$export$fe50ca7dd7da9c45.getDefaults(), arguments)));
        this.name = "GreaterThanZero";
        this._thresh = this.output = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            length: 127,
            mapping: (val)=>{
                if (val <= 0) return 0;
                else return 1;
            }
        });
        this._scale = this.input = new (0, $QU03h.Multiply)({
            context: this.context,
            value: 10000
        });
        // connections
        this._scale.connect(this._thresh);
    }
    dispose() {
        super.dispose();
        this._scale.dispose();
        this._thresh.dispose();
        return this;
    }
}

});


parcelRegister("fRTgd", function(module, exports) {

$parcel$export(module.exports, "Pow", () => $b8d6abdc9665ac4d$export$ce28d653ec559ee);

var $jAeMP = parcelRequire("jAeMP");

var $l4RVz = parcelRequire("l4RVz");

var $jlPaH = parcelRequire("jlPaH");
class $b8d6abdc9665ac4d$export$ce28d653ec559ee extends (0, $jlPaH.SignalOperator) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($b8d6abdc9665ac4d$export$ce28d653ec559ee.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "Pow";
        const options = (0, $l4RVz.optionsFromArguments)($b8d6abdc9665ac4d$export$ce28d653ec559ee.getDefaults(), arguments, [
            "value"
        ]);
        this._exponentScaler = this.input = this.output = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            mapping: this._expFunc(options.value),
            length: 8192
        });
        this._exponent = options.value;
    }
    static getDefaults() {
        return Object.assign((0, $jlPaH.SignalOperator).getDefaults(), {
            value: 1
        });
    }
    /**
     * the function which maps the waveshaper
     * @param exponent exponent value
     */ _expFunc(exponent) {
        return (val)=>{
            return Math.pow(Math.abs(val), exponent);
        };
    }
    /**
     * The value of the exponent.
     */ get value() {
        return this._exponent;
    }
    set value(exponent) {
        this._exponent = exponent;
        this._exponentScaler.setMap(this._expFunc(this._exponent));
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._exponentScaler.dispose();
        return this;
    }
}

});

parcelRegister("9GEPW", function(module, exports) {

$parcel$export(module.exports, "ScaleExp", () => $70d7b6a36cff373a$export$92c7140174c78083);

var $1zJwt = parcelRequire("1zJwt");

var $l4RVz = parcelRequire("l4RVz");

var $fRTgd = parcelRequire("fRTgd");
class $70d7b6a36cff373a$export$92c7140174c78083 extends (0, $1zJwt.Scale) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($70d7b6a36cff373a$export$92c7140174c78083.getDefaults(), arguments, [
            "min",
            "max",
            "exponent"
        ])));
        this.name = "ScaleExp";
        const options = (0, $l4RVz.optionsFromArguments)($70d7b6a36cff373a$export$92c7140174c78083.getDefaults(), arguments, [
            "min",
            "max",
            "exponent"
        ]);
        this.input = this._exp = new (0, $fRTgd.Pow)({
            context: this.context,
            value: options.exponent
        });
        this._exp.connect(this._mult);
    }
    static getDefaults() {
        return Object.assign((0, $1zJwt.Scale).getDefaults(), {
            exponent: 1
        });
    }
    /**
     * Instead of interpolating linearly between the [[min]] and
     * [[max]] values, setting the exponent will interpolate between
     * the two values with an exponential curve.
     */ get exponent() {
        return this._exp.value;
    }
    set exponent(exp) {
        this._exp.value = exp;
    }
    dispose() {
        super.dispose();
        this._exp.dispose();
        return this;
    }
}

});

parcelRegister("itVZs", function(module, exports) {

var $eCi69 = parcelRequire("eCi69");

var $l4RVz = parcelRequire("l4RVz");

var $31EKY = parcelRequire("31EKY");

var $2Q9k6 = parcelRequire("2Q9k6");
class $d747eb1741c9e2a0$export$35743999fcf7d6a4 extends (0, $eCi69.Signal) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)((0, $eCi69.Signal).getDefaults(), arguments, [
            "value",
            "units"
        ]));
        this.name = "SyncedSignal";
        /**
         * Don't override when something is connected to the input
         */ this.override = false;
        const options = (0, $l4RVz.optionsFromArguments)((0, $eCi69.Signal).getDefaults(), arguments, [
            "value",
            "units"
        ]);
        this._lastVal = options.value;
        this._synced = this.context.transport.scheduleRepeat(this._onTick.bind(this), "1i");
        this._syncedCallback = this._anchorValue.bind(this);
        this.context.transport.on("start", this._syncedCallback);
        this.context.transport.on("pause", this._syncedCallback);
        this.context.transport.on("stop", this._syncedCallback);
        // disconnect the constant source from the output and replace it with another one
        this._constantSource.disconnect();
        this._constantSource.stop(0);
        // create a new one
        this._constantSource = this.output = new (0, $2Q9k6.ToneConstantSource)({
            context: this.context,
            offset: options.value,
            units: options.units
        }).start(0);
        this.setValueAtTime(options.value, 0);
    }
    /**
     * Callback which is invoked every tick.
     */ _onTick(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        // approximate ramp curves with linear ramps
        if (this._lastVal !== val) {
            this._lastVal = val;
            this._constantSource.offset.setValueAtTime(val, time);
        }
    }
    /**
     * Anchor the value at the start and stop of the Transport
     */ _anchorValue(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        this._lastVal = val;
        this._constantSource.offset.cancelAndHoldAtTime(time);
        this._constantSource.offset.setValueAtTime(val, time);
    }
    getValueAtTime(time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        return super.getValueAtTime(computedTime);
    }
    setValueAtTime(value, time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        super.setValueAtTime(value, computedTime);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        super.linearRampToValueAtTime(value, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        super.exponentialRampToValueAtTime(value, computedTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        super.setTargetAtTime(value, computedTime, timeConstant);
        return this;
    }
    cancelScheduledValues(startTime) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        super.cancelScheduledValues(computedTime);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        duration = this.toSeconds(duration);
        super.setValueCurveAtTime(values, computedTime, duration, scaling);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        super.cancelAndHoldAtTime(computedTime);
        return this;
    }
    setRampPoint(time) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, time).toSeconds();
        super.setRampPoint(computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        super.exponentialRampTo(value, rampTime, computedTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        super.linearRampTo(value, rampTime, computedTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $31EKY.TransportTimeClass)(this.context, startTime).toSeconds();
        super.targetRampTo(value, rampTime, computedTime);
        return this;
    }
    dispose() {
        super.dispose();
        this.context.transport.clear(this._synced);
        this.context.transport.off("start", this._syncedCallback);
        this.context.transport.off("pause", this._syncedCallback);
        this.context.transport.off("stop", this._syncedCallback);
        this._constantSource.dispose();
        return this;
    }
}

});


parcelRegister("1PYwV", function(module, exports) {
$parcel$export(module.exports, "DuoSynth", () => (parcelRequire("dDgqq")).DuoSynth);
$parcel$export(module.exports, "MonoSynth", () => (parcelRequire("kNUCa")).MonoSynth);
$parcel$export(module.exports, "NoiseSynth", () => (parcelRequire("kCoIg")).NoiseSynth);
$parcel$export(module.exports, "PolySynth", () => (parcelRequire("ksj9M")).PolySynth);
$parcel$export(module.exports, "Sampler", () => (parcelRequire("7u8Jf")).Sampler);
parcelRequire("jMVxp");
parcelRequire("dDgqq");
parcelRequire("lyfdK");
parcelRequire("jPwQP");
parcelRequire("k2cmp");
parcelRequire("kNUCa");
parcelRequire("kCoIg");
parcelRequire("8XBGU");
parcelRequire("ksj9M");
parcelRequire("7u8Jf");
parcelRequire("9Z1pB");

});
parcelRegister("jMVxp", function(module, exports) {

var $fdlW4 = parcelRequire("fdlW4");

var $l4RVz = parcelRequire("l4RVz");

var $hbOTW = parcelRequire("hbOTW");
class $e67f21d8475870b7$export$cd421a3dd25cf75d extends (0, $hbOTW.ModulationSynth) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e67f21d8475870b7$export$cd421a3dd25cf75d.getDefaults(), arguments));
        this.name = "AMSynth";
        this._modulationScale = new (0, $fdlW4.AudioToGain)({
            context: this.context
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
    }
    dispose() {
        super.dispose();
        this._modulationScale.dispose();
        return this;
    }
}

});
parcelRegister("hbOTW", function(module, exports) {

$parcel$export(module.exports, "ModulationSynth", () => $c83af2afda3a2a32$export$aee9425caad4bd7e);

var $eCi69 = parcelRequire("eCi69");

var $QU03h = parcelRequire("QU03h");

var $bdbZZ = parcelRequire("bdbZZ");

var $jaF5W = parcelRequire("jaF5W");

var $fDBOr = parcelRequire("fDBOr");

var $2Ccmq = parcelRequire("2Ccmq");

var $5Abaq = parcelRequire("5Abaq");

var $21sLj = parcelRequire("21sLj");

var $9Z1pB = parcelRequire("9Z1pB");

var $AD7W4 = parcelRequire("AD7W4");

var $l4RVz = parcelRequire("l4RVz");
class $c83af2afda3a2a32$export$aee9425caad4bd7e extends (0, $2Ccmq.Monophonic) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($c83af2afda3a2a32$export$aee9425caad4bd7e.getDefaults(), arguments));
        this.name = "ModulationSynth";
        const options = (0, $l4RVz.optionsFromArguments)($c83af2afda3a2a32$export$aee9425caad4bd7e.getDefaults(), arguments);
        this._carrier = new (0, $9Z1pB.Synth)({
            context: this.context,
            oscillator: options.oscillator,
            envelope: options.envelope,
            onsilence: ()=>this.onsilence(this),
            volume: -10
        });
        this._modulator = new (0, $9Z1pB.Synth)({
            context: this.context,
            oscillator: options.modulation,
            envelope: options.modulationEnvelope,
            volume: -10
        });
        this.oscillator = this._carrier.oscillator;
        this.envelope = this._carrier.envelope;
        this.modulation = this._modulator.oscillator;
        this.modulationEnvelope = this._modulator.envelope;
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency"
        });
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.detune,
            units: "cents"
        });
        this.harmonicity = new (0, $QU03h.Multiply)({
            context: this.context,
            value: options.harmonicity,
            minValue: 0
        });
        this._modulationNode = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "harmonicity",
            "oscillator",
            "envelope",
            "modulation",
            "modulationEnvelope",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $2Ccmq.Monophonic).getDefaults(), {
            harmonicity: 3,
            oscillator: Object.assign((0, $l4RVz.omitFromObject)((0, $5Abaq.OmniOscillator).getDefaults(), [
                ...Object.keys((0, $21sLj.Source).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "sine"
            }),
            envelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.01,
                decay: 0.01,
                sustain: 1,
                release: 0.5
            }),
            modulation: Object.assign((0, $l4RVz.omitFromObject)((0, $5Abaq.OmniOscillator).getDefaults(), [
                ...Object.keys((0, $21sLj.Source).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "square"
            }),
            modulationEnvelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.5,
                decay: 0.0,
                sustain: 1,
                release: 0.5
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this._carrier._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this._modulator._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this._carrier._triggerEnvelopeRelease(time);
        // @ts-ignore
        this._modulator._triggerEnvelopeRelease(time);
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._modulationNode.dispose();
        return this;
    }
}

});
parcelRegister("jaF5W", function(module, exports) {

$parcel$export(module.exports, "Envelope", () => $df4ed40f6ce7d6a1$export$4e2d65a9843399df);

var $gztBd = parcelRequire("gztBd");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $lQ01C = parcelRequire("lQ01C");

var $eCi69 = parcelRequire("eCi69");

var $iHery = parcelRequire("iHery");

var $6Utwn = parcelRequire("6Utwn");

var $hLrAi = parcelRequire("hLrAi");
class $df4ed40f6ce7d6a1$export$4e2d65a9843399df extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($df4ed40f6ce7d6a1$export$4e2d65a9843399df.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "Envelope";
        /**
         * the signal which is output.
         */ this._sig = new (0, $eCi69.Signal)({
            context: this.context,
            value: 0
        });
        /**
         * The output signal of the envelope
         */ this.output = this._sig;
        /**
         * Envelope has no input
         */ this.input = undefined;
        const options = (0, $l4RVz.optionsFromArguments)($df4ed40f6ce7d6a1$export$4e2d65a9843399df.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        this.attack = options.attack;
        this.decay = options.decay;
        this.sustain = options.sustain;
        this.release = options.release;
        this.attackCurve = options.attackCurve;
        this.releaseCurve = options.releaseCurve;
        this.decayCurve = options.decayCurve;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            attack: 0.01,
            attackCurve: "linear",
            decay: 0.1,
            decayCurve: "exponential",
            release: 1,
            releaseCurve: "exponential",
            sustain: 0.5
        });
    }
    /**
     * Read the current value of the envelope. Useful for
     * synchronizing visual output to the envelope.
     */ get value() {
        return this.getValueAtTime(this.now());
    }
    /**
     * Get the curve
     * @param  curve
     * @param  direction  In/Out
     * @return The curve name
     */ _getCurve(curve, direction) {
        if ((0, $lQ01C.isString)(curve)) return curve;
        else {
            // look up the name in the curves array
            let curveName;
            for(curveName in $df4ed40f6ce7d6a1$var$EnvelopeCurves){
                if ($df4ed40f6ce7d6a1$var$EnvelopeCurves[curveName][direction] === curve) return curveName;
            }
            // return the custom curve
            return curve;
        }
    }
    /**
     * Assign a the curve to the given name using the direction
     * @param  name
     * @param  direction In/Out
     * @param  curve
     */ _setCurve(name, direction, curve) {
        // check if it's a valid type
        if ((0, $lQ01C.isString)(curve) && Reflect.has($df4ed40f6ce7d6a1$var$EnvelopeCurves, curve)) {
            const curveDef = $df4ed40f6ce7d6a1$var$EnvelopeCurves[curve];
            if ((0, $lQ01C.isObject)(curveDef)) {
                if (name !== "_decayCurve") this[name] = curveDef[direction];
            } else this[name] = curveDef;
        } else if ((0, $lQ01C.isArray)(curve) && name !== "_decayCurve") this[name] = curve;
        else throw new Error("Envelope: invalid curve: " + curve);
    }
    /**
     * The shape of the attack.
     * Can be any of these strings:
     * * "linear"
     * * "exponential"
     * * "sine"
     * * "cosine"
     * * "bounce"
     * * "ripple"
     * * "step"
     *
     * Can also be an array which describes the curve. Values
     * in the array are evenly subdivided and linearly
     * interpolated over the duration of the attack.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope(0.4).toDestination();
     * 	env.attackCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get attackCurve() {
        return this._getCurve(this._attackCurve, "In");
    }
    set attackCurve(curve) {
        this._setCurve("_attackCurve", "In", curve);
    }
    /**
     * The shape of the release. See the attack curve types.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		release: 0.8
     * 	}).toDestination();
     * 	env.triggerAttack();
     * 	// release curve could also be defined by an array
     * 	env.releaseCurve = [1, 0.3, 0.4, 0.2, 0.7, 0];
     * 	env.triggerRelease(0.2);
     * }, 1, 1);
     */ get releaseCurve() {
        return this._getCurve(this._releaseCurve, "Out");
    }
    set releaseCurve(curve) {
        this._setCurve("_releaseCurve", "Out", curve);
    }
    /**
     * The shape of the decay either "linear" or "exponential"
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		sustain: 0.1,
     * 		decay: 0.5
     * 	}).toDestination();
     * 	env.decayCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get decayCurve() {
        return this._decayCurve;
    }
    set decayCurve(curve) {
        (0, $6Utwn.assert)([
            "linear",
            "exponential"
        ].some((c)=>c === curve), `Invalid envelope curve: ${curve}`);
        this._decayCurve = curve;
    }
    /**
     * Trigger the attack/decay portion of the ADSR envelope.
     * @param  time When the attack should start.
     * @param velocity The velocity of the envelope scales the vales.
     *                             number between 0-1
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the attack 0.5 seconds from now with a velocity of 0.2
     * env.triggerAttack("+0.5", 0.2);
     */ triggerAttack(time, velocity = 1) {
        this.log("triggerAttack", time, velocity);
        time = this.toSeconds(time);
        const originalAttack = this.toSeconds(this.attack);
        let attack = originalAttack;
        const decay = this.toSeconds(this.decay);
        // check if it's not a complete attack
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            // subtract the current value from the attack time
            const attackRate = 1 / attack;
            const remainingDistance = 1 - currentValue;
            // the attack is now the remaining time
            attack = remainingDistance / attackRate;
        }
        // attack
        if (attack < this.sampleTime) {
            this._sig.cancelScheduledValues(time);
            // case where the attack time is 0 should set instantly
            this._sig.setValueAtTime(velocity, time);
        } else if (this._attackCurve === "linear") this._sig.linearRampTo(velocity, attack, time);
        else if (this._attackCurve === "exponential") this._sig.targetRampTo(velocity, attack, time);
        else {
            this._sig.cancelAndHoldAtTime(time);
            let curve = this._attackCurve;
            // find the starting position in the curve
            for(let i = 1; i < curve.length; i++)// the starting index is between the two values
            if (curve[i - 1] <= currentValue && currentValue <= curve[i]) {
                curve = this._attackCurve.slice(i);
                // the first index is the current value
                curve[0] = currentValue;
                break;
            }
            this._sig.setValueCurveAtTime(curve, time, attack, velocity);
        }
        // decay
        if (decay && this.sustain < 1) {
            const decayValue = velocity * this.sustain;
            const decayStart = time + attack;
            this.log("decay", decayStart);
            if (this._decayCurve === "linear") this._sig.linearRampToValueAtTime(decayValue, decay + decayStart);
            else this._sig.exponentialApproachValueAtTime(decayValue, decayStart, decay);
        }
        return this;
    }
    /**
     * Triggers the release of the envelope.
     * @param  time When the release portion of the envelope should start.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator({
     * 	type: "sawtooth"
     * }).connect(env).start();
     * env.triggerAttack();
     * // trigger the release half a second after the attack
     * env.triggerRelease("+0.5");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        time = this.toSeconds(time);
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            const release = this.toSeconds(this.release);
            if (release < this.sampleTime) this._sig.setValueAtTime(0, time);
            else if (this._releaseCurve === "linear") this._sig.linearRampTo(0, release, time);
            else if (this._releaseCurve === "exponential") this._sig.targetRampTo(0, release, time);
            else {
                (0, $6Utwn.assert)((0, $lQ01C.isArray)(this._releaseCurve), "releaseCurve must be either 'linear', 'exponential' or an array");
                this._sig.cancelAndHoldAtTime(time);
                this._sig.setValueCurveAtTime(this._releaseCurve, time, release, currentValue);
            }
        }
        return this;
    }
    /**
     * Get the scheduled value at the given time. This will
     * return the unconverted (raw) value.
     * @example
     * const env = new Tone.Envelope(0.5, 1, 0.4, 2);
     * env.triggerAttackRelease(2);
     * setInterval(() => console.log(env.getValueAtTime(Tone.now())), 100);
     */ getValueAtTime(time) {
        return this._sig.getValueAtTime(time);
    }
    /**
     * triggerAttackRelease is shorthand for triggerAttack, then waiting
     * some duration, then triggerRelease.
     * @param duration The duration of the sustain.
     * @param time When the attack should be triggered.
     * @param velocity The velocity of the envelope.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the release 0.5 seconds after the attack
     * env.triggerAttackRelease(0.5);
     */ triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + this.toSeconds(duration));
        return this;
    }
    /**
     * Cancels all scheduled envelope changes after the given time.
     */ cancel(after) {
        this._sig.cancelScheduledValues(this.toSeconds(after));
        return this;
    }
    /**
     * Connect the envelope to a destination node.
     */ connect(destination, outputNumber = 0, inputNumber = 0) {
        (0, $eCi69.connectSignal)(this, destination, outputNumber, inputNumber);
        return this;
    }
    /**
     * Render the envelope curve to an array of the given length.
     * Good for visualizing the envelope curve. Rescales the duration of the
     * envelope to fit the length.
     */ asArray(length = 1024) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const duration = length / this.context.sampleRate;
            const context = new (0, $iHery.OfflineContext)(1, duration, this.context.sampleRate);
            // normalize the ADSR for the given duration with 20% sustain time
            const attackPortion = this.toSeconds(this.attack) + this.toSeconds(this.decay);
            const envelopeDuration = attackPortion + this.toSeconds(this.release);
            const sustainTime = envelopeDuration * 0.1;
            const totalDuration = envelopeDuration + sustainTime;
            // @ts-ignore
            const clone = new this.constructor(Object.assign(this.get(), {
                attack: duration * this.toSeconds(this.attack) / totalDuration,
                decay: duration * this.toSeconds(this.decay) / totalDuration,
                release: duration * this.toSeconds(this.release) / totalDuration,
                context: context
            }));
            clone._sig.toDestination();
            clone.triggerAttackRelease(duration * (attackPortion + sustainTime) / totalDuration, 0);
            const buffer = yield context.render();
            return buffer.getChannelData(0);
        });
    }
    dispose() {
        super.dispose();
        this._sig.dispose();
        return this;
    }
}
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $df4ed40f6ce7d6a1$export$4e2d65a9843399df.prototype, "attack", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $df4ed40f6ce7d6a1$export$4e2d65a9843399df.prototype, "decay", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.range)(0, 1)
], $df4ed40f6ce7d6a1$export$4e2d65a9843399df.prototype, "sustain", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $df4ed40f6ce7d6a1$export$4e2d65a9843399df.prototype, "release", void 0);
/**
 * Generate some complex envelope curves.
 */ const $df4ed40f6ce7d6a1$var$EnvelopeCurves = (()=>{
    const curveLen = 128;
    let i;
    let k;
    // cosine curve
    const cosineCurve = [];
    for(i = 0; i < curveLen; i++)cosineCurve[i] = Math.sin(i / (curveLen - 1) * (Math.PI / 2));
    // ripple curve
    const rippleCurve = [];
    const rippleCurveFreq = 6.4;
    for(i = 0; i < curveLen - 1; i++){
        k = i / (curveLen - 1);
        const sineWave = Math.sin(k * (Math.PI * 2) * rippleCurveFreq - Math.PI / 2) + 1;
        rippleCurve[i] = sineWave / 10 + k * 0.83;
    }
    rippleCurve[curveLen - 1] = 1;
    // stairs curve
    const stairsCurve = [];
    const steps = 5;
    for(i = 0; i < curveLen; i++)stairsCurve[i] = Math.ceil(i / (curveLen - 1) * steps) / steps;
    // in-out easing curve
    const sineCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        sineCurve[i] = 0.5 * (1 - Math.cos(Math.PI * k));
    }
    // a bounce curve
    const bounceCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        const freq = Math.pow(k, 3) * 4 + 0.2;
        const val = Math.cos(freq * Math.PI * 2 * k);
        bounceCurve[i] = Math.abs(val * (1 - k));
    }
    /**
     * Invert a value curve to make it work for the release
     */ function invertCurve(curve) {
        const out = new Array(curve.length);
        for(let j = 0; j < curve.length; j++)out[j] = 1 - curve[j];
        return out;
    }
    /**
     * reverse the curve
     */ function reverseCurve(curve) {
        return curve.slice(0).reverse();
    }
    /**
     * attack and release curve arrays
     */ return {
        bounce: {
            In: invertCurve(bounceCurve),
            Out: bounceCurve
        },
        cosine: {
            In: cosineCurve,
            Out: reverseCurve(cosineCurve)
        },
        exponential: "exponential",
        linear: "linear",
        ripple: {
            In: rippleCurve,
            Out: invertCurve(rippleCurve)
        },
        sine: {
            In: sineCurve,
            Out: invertCurve(sineCurve)
        },
        step: {
            In: stairsCurve,
            Out: invertCurve(stairsCurve)
        }
    };
})();

});

parcelRegister("2Ccmq", function(module, exports) {

$parcel$export(module.exports, "Monophonic", () => $1e78b7f293441652$export$f16a08bc2d920a12);

var $gztBd = parcelRequire("gztBd");

var $aZf7A = parcelRequire("aZf7A");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $96T6P = parcelRequire("96T6P");

var $hLrAi = parcelRequire("hLrAi");
class $1e78b7f293441652$export$f16a08bc2d920a12 extends (0, $96T6P.Instrument) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($1e78b7f293441652$export$f16a08bc2d920a12.getDefaults(), arguments));
        const options = (0, $l4RVz.optionsFromArguments)($1e78b7f293441652$export$f16a08bc2d920a12.getDefaults(), arguments);
        this.portamento = options.portamento;
        this.onsilence = options.onsilence;
    }
    static getDefaults() {
        return Object.assign((0, $96T6P.Instrument).getDefaults(), {
            detune: 0,
            onsilence: (0, $AD7W4.noOp),
            portamento: 0
        });
    }
    /**
     * Trigger the attack of the note optionally with a given velocity.
     * @param  note The note to trigger.
     * @param  time When the note should start.
     * @param  velocity The velocity scaler determines how "loud" the note will be triggered.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger the note a half second from now at half velocity
     * synth.triggerAttack("C4", "+0.5", 0.5);
     */ triggerAttack(note, time, velocity = 1) {
        this.log("triggerAttack", note, time, velocity);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeAttack(seconds, velocity);
        this.setNote(note, seconds);
        return this;
    }
    /**
     * Trigger the release portion of the envelope
     * @param  time If no time is given, the release happens immediatly
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // trigger the release a second from now
     * synth.triggerRelease("+1");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeRelease(seconds);
        return this;
    }
    /**
     * Set the note at the given time. If no time is given, the note
     * will set immediately.
     * @param note The note to change to.
     * @param  time The time when the note should be set.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // change to F#6 in one quarter note from now.
     * synth.setNote("F#6", "+4n");
     */ setNote(note, time) {
        const computedTime = this.toSeconds(time);
        const computedFrequency = note instanceof (0, $aZf7A.FrequencyClass) ? note.toFrequency() : note;
        if (this.portamento > 0 && this.getLevelAtTime(computedTime) > 0.05) {
            const portTime = this.toSeconds(this.portamento);
            this.frequency.exponentialRampTo(computedFrequency, portTime, computedTime);
        } else this.frequency.setValueAtTime(computedFrequency, computedTime);
        return this;
    }
}
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $1e78b7f293441652$export$f16a08bc2d920a12.prototype, "portamento", void 0);

});
parcelRegister("96T6P", function(module, exports) {

$parcel$export(module.exports, "Instrument", () => $6a1f6c1ea37a2d04$export$25ef33f358b07cf4);

var $dTGN1 = parcelRequire("dTGN1");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $6a1f6c1ea37a2d04$export$25ef33f358b07cf4 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($6a1f6c1ea37a2d04$export$25ef33f358b07cf4.getDefaults(), arguments));
        /**
         * Keep track of all events scheduled to the transport
         * when the instrument is 'synced'
         */ this._scheduledEvents = [];
        /**
         * If the instrument is currently synced
         */ this._synced = false;
        this._original_triggerAttack = this.triggerAttack;
        this._original_triggerRelease = this.triggerRelease;
        const options = (0, $l4RVz.optionsFromArguments)($6a1f6c1ea37a2d04$export$25ef33f358b07cf4.getDefaults(), arguments);
        this._volume = this.output = new (0, $dTGN1.Volume)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $AD7W4.readOnly)(this, "volume");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            volume: 0
        });
    }
    /**
     * Sync the instrument to the Transport. All subsequent calls of
     * [[triggerAttack]] and [[triggerRelease]] will be scheduled along the transport.
     * @example
     * const fmSynth = new Tone.FMSynth().toDestination();
     * fmSynth.volume.value = -6;
     * fmSynth.sync();
     * // schedule 3 notes when the transport first starts
     * fmSynth.triggerAttackRelease("C4", "8n", 0);
     * fmSynth.triggerAttackRelease("E4", "8n", "8n");
     * fmSynth.triggerAttackRelease("G4", "8n", "4n");
     * // start the transport to hear the notes
     * Tone.Transport.start();
     */ sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 0);
        }
        return this;
    }
    /**
     * set _sync
     */ _syncState() {
        let changed = false;
        if (!this._synced) {
            this._synced = true;
            changed = true;
        }
        return changed;
    }
    /**
     * Wrap the given method so that it can be synchronized
     * @param method Which method to wrap and sync
     * @param  timePosition What position the time argument appears in
     */ _syncMethod(method, timePosition) {
        const originalMethod = this["_original_" + method] = this[method];
        this[method] = (...args)=>{
            const time = args[timePosition];
            const id = this.context.transport.schedule((t)=>{
                args[timePosition] = t;
                originalMethod.apply(this, args);
            }, time);
            this._scheduledEvents.push(id);
        };
    }
    /**
     * Unsync the instrument from the Transport
     */ unsync() {
        this._scheduledEvents.forEach((id)=>this.context.transport.clear(id));
        this._scheduledEvents = [];
        if (this._synced) {
            this._synced = false;
            this.triggerAttack = this._original_triggerAttack;
            this.triggerRelease = this._original_triggerRelease;
        }
        return this;
    }
    /**
     * Trigger the attack and then the release after the duration.
     * @param  note     The note to trigger.
     * @param  duration How long the note should be held for before
     *                         triggering the release. This value must be greater than 0.
     * @param time  When the note should be triggered.
     * @param  velocity The velocity the note should be triggered at.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger "C4" for the duration of an 8th note
     * synth.triggerAttackRelease("C4", "8n");
     */ triggerAttackRelease(note, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        const computedDuration = this.toSeconds(duration);
        this.triggerAttack(note, computedTime, velocity);
        this.triggerRelease(computedTime + computedDuration);
        return this;
    }
    /**
     * clean up
     * @returns {Instrument} this
     */ dispose() {
        super.dispose();
        this._volume.dispose();
        this.unsync();
        this._scheduledEvents = [];
        return this;
    }
}

});


parcelRegister("9Z1pB", function(module, exports) {

$parcel$export(module.exports, "Synth", () => $744ae7f37d677f23$export$8ef26ca8e8d9bf70);

var $8XS4X = parcelRequire("8XS4X");

var $jaF5W = parcelRequire("jaF5W");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $5Abaq = parcelRequire("5Abaq");

var $21sLj = parcelRequire("21sLj");

var $2Ccmq = parcelRequire("2Ccmq");
class $744ae7f37d677f23$export$8ef26ca8e8d9bf70 extends (0, $2Ccmq.Monophonic) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($744ae7f37d677f23$export$8ef26ca8e8d9bf70.getDefaults(), arguments));
        this.name = "Synth";
        const options = (0, $l4RVz.optionsFromArguments)($744ae7f37d677f23$export$8ef26ca8e8d9bf70.getDefaults(), arguments);
        this.oscillator = new (0, $5Abaq.OmniOscillator)(Object.assign({
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }, options.oscillator));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.envelope = new (0, $8XS4X.AmplitudeEnvelope)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the oscillators to the output
        this.oscillator.chain(this.envelope, this.output);
        (0, $AD7W4.readOnly)(this, [
            "oscillator",
            "frequency",
            "detune",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $2Ccmq.Monophonic).getDefaults(), {
            envelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.3
            }),
            oscillator: Object.assign((0, $l4RVz.omitFromObject)((0, $5Abaq.OmniOscillator).getDefaults(), [
                ...Object.keys((0, $21sLj.Source).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "triangle"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity) {
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        this.oscillator.start(time);
        // if there is no release portion, stop the oscillator
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        return this;
    }
}

});
parcelRegister("8XS4X", function(module, exports) {

$parcel$export(module.exports, "AmplitudeEnvelope", () => $686dc85a46eecadd$export$e04e0eedd8192587);

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $jaF5W = parcelRequire("jaF5W");
class $686dc85a46eecadd$export$e04e0eedd8192587 extends (0, $jaF5W.Envelope) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($686dc85a46eecadd$export$e04e0eedd8192587.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "AmplitudeEnvelope";
        this._gainNode = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        this.output = this._gainNode;
        this.input = this._gainNode;
        this._sig.connect(this._gainNode.gain);
        this.output = this._gainNode;
        this.input = this._gainNode;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._gainNode.dispose();
        return this;
    }
}

});




parcelRegister("dDgqq", function(module, exports) {

$parcel$export(module.exports, "DuoSynth", () => $9ecba8929159f01a$export$374aff340bb3ea08);

var $2Ccmq = parcelRequire("2Ccmq");

var $kNUCa = parcelRequire("kNUCa");

var $eCi69 = parcelRequire("eCi69");

var $AD7W4 = parcelRequire("AD7W4");

var $lNxm0 = parcelRequire("lNxm0");

var $bdbZZ = parcelRequire("bdbZZ");

var $QU03h = parcelRequire("QU03h");

var $l4RVz = parcelRequire("l4RVz");
class $9ecba8929159f01a$export$374aff340bb3ea08 extends (0, $2Ccmq.Monophonic) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($9ecba8929159f01a$export$374aff340bb3ea08.getDefaults(), arguments));
        this.name = "DuoSynth";
        const options = (0, $l4RVz.optionsFromArguments)($9ecba8929159f01a$export$374aff340bb3ea08.getDefaults(), arguments);
        this.voice0 = new (0, $kNUCa.MonoSynth)(Object.assign(options.voice0, {
            context: this.context,
            onsilence: ()=>this.onsilence(this)
        }));
        this.voice1 = new (0, $kNUCa.MonoSynth)(Object.assign(options.voice1, {
            context: this.context
        }));
        this.harmonicity = new (0, $QU03h.Multiply)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this._vibrato = new (0, $lNxm0.LFO)({
            frequency: options.vibratoRate,
            context: this.context,
            min: -50,
            max: 50
        });
        // start the vibrato immediately
        this._vibrato.start();
        this.vibratoRate = this._vibrato.frequency;
        this._vibratoGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            units: "normalRange",
            gain: options.vibratoAmount
        });
        this.vibratoAmount = this._vibratoGain.gain;
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: 440
        });
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        // control the two voices frequency
        this.frequency.connect(this.voice0.frequency);
        this.frequency.chain(this.harmonicity, this.voice1.frequency);
        this._vibrato.connect(this._vibratoGain);
        this._vibratoGain.fan(this.voice0.detune, this.voice1.detune);
        this.detune.fan(this.voice0.detune, this.voice1.detune);
        this.voice0.connect(this.output);
        this.voice1.connect(this.output);
        (0, $AD7W4.readOnly)(this, [
            "voice0",
            "voice1",
            "frequency",
            "vibratoAmount",
            "vibratoRate"
        ]);
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.voice0.envelope.getValueAtTime(time) + this.voice1.envelope.getValueAtTime(time);
    }
    static getDefaults() {
        return (0, $l4RVz.deepMerge)((0, $2Ccmq.Monophonic).getDefaults(), {
            vibratoAmount: 0.5,
            vibratoRate: 5,
            harmonicity: 1.5,
            voice0: (0, $l4RVz.deepMerge)((0, $l4RVz.omitFromObject)((0, $kNUCa.MonoSynth).getDefaults(), Object.keys((0, $2Ccmq.Monophonic).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            }),
            voice1: (0, $l4RVz.deepMerge)((0, $l4RVz.omitFromObject)((0, $kNUCa.MonoSynth).getDefaults(), Object.keys((0, $2Ccmq.Monophonic).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this.voice0._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this.voice1._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this.voice0._triggerEnvelopeRelease(time);
        // @ts-ignore
        this.voice1._triggerEnvelopeRelease(time);
        return this;
    }
    dispose() {
        super.dispose();
        this.voice0.dispose();
        this.voice1.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._vibrato.dispose();
        this.vibratoRate.dispose();
        this._vibratoGain.dispose();
        this.harmonicity.dispose();
        return this;
    }
}

});
parcelRegister("kNUCa", function(module, exports) {

$parcel$export(module.exports, "MonoSynth", () => $f2544cb8063b43cd$export$319ecdcd955e80a7);

var $8XS4X = parcelRequire("8XS4X");

var $jaF5W = parcelRequire("jaF5W");

var $82Hwq = parcelRequire("82Hwq");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $2Ccmq = parcelRequire("2Ccmq");

var $5Abaq = parcelRequire("5Abaq");

var $21sLj = parcelRequire("21sLj");

var $gjK3F = parcelRequire("gjK3F");

var $fDBOr = parcelRequire("fDBOr");
class $f2544cb8063b43cd$export$319ecdcd955e80a7 extends (0, $2Ccmq.Monophonic) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($f2544cb8063b43cd$export$319ecdcd955e80a7.getDefaults(), arguments));
        this.name = "MonoSynth";
        const options = (0, $l4RVz.optionsFromArguments)($f2544cb8063b43cd$export$319ecdcd955e80a7.getDefaults(), arguments);
        this.oscillator = new (0, $5Abaq.OmniOscillator)(Object.assign(options.oscillator, {
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.filter = new (0, $82Hwq.Filter)(Object.assign(options.filter, {
            context: this.context
        }));
        this.filterEnvelope = new (0, $gjK3F.FrequencyEnvelope)(Object.assign(options.filterEnvelope, {
            context: this.context
        }));
        this.envelope = new (0, $8XS4X.AmplitudeEnvelope)(Object.assign(options.envelope, {
            context: this.context
        }));
        // connect the oscillators to the output
        this.oscillator.chain(this.filter, this.envelope, this.output);
        // connect the filter envelope
        this.filterEnvelope.connect(this.filter.frequency);
        (0, $AD7W4.readOnly)(this, [
            "oscillator",
            "frequency",
            "detune",
            "filter",
            "filterEnvelope",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $2Ccmq.Monophonic).getDefaults(), {
            envelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.9
            }),
            filter: Object.assign((0, $l4RVz.omitFromObject)((0, $82Hwq.Filter).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                Q: 1,
                rolloff: -12,
                type: "lowpass"
            }),
            filterEnvelope: Object.assign((0, $l4RVz.omitFromObject)((0, $gjK3F.FrequencyEnvelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.6,
                baseFrequency: 200,
                decay: 0.2,
                exponent: 2,
                octaves: 3,
                release: 2,
                sustain: 0.5
            }),
            oscillator: Object.assign((0, $l4RVz.omitFromObject)((0, $5Abaq.OmniOscillator).getDefaults(), Object.keys((0, $21sLj.Source).getDefaults())), {
                type: "sawtooth"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this.filterEnvelope.triggerAttack(time);
        this.oscillator.start(time);
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.filterEnvelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        this.filterEnvelope.dispose();
        this.filter.dispose();
        return this;
    }
}

});
parcelRegister("82Hwq", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $5db0453509f0e13f$export$ec91da630f36d5ea);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $eCi69 = parcelRequire("eCi69");

var $6Utwn = parcelRequire("6Utwn");

var $Lvs5H = parcelRequire("Lvs5H");
class $5db0453509f0e13f$export$ec91da630f36d5ea extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($5db0453509f0e13f$export$ec91da630f36d5ea.getDefaults(), arguments, [
            "frequency",
            "type",
            "rolloff"
        ]));
        this.name = "Filter";
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._filters = [];
        const options = (0, $l4RVz.optionsFromArguments)($5db0453509f0e13f$export$ec91da630f36d5ea.getDefaults(), arguments, [
            "frequency",
            "type",
            "rolloff"
        ]);
        this._filters = [];
        this.Q = new (0, $eCi69.Signal)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.gain = new (0, $eCi69.Signal)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain
        });
        this._type = options.type;
        this.rolloff = options.rolloff;
        (0, $AD7W4.readOnly)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            Q: 1,
            detune: 0,
            frequency: 350,
            gain: 0,
            rolloff: -12,
            type: "lowpass"
        });
    }
    /**
     * The type of the filter. Types: "lowpass", "highpass",
     * "bandpass", "lowshelf", "highshelf", "notch", "allpass", or "peaking".
     */ get type() {
        return this._type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $6Utwn.assert)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._type = type;
        this._filters.forEach((filter)=>filter.type = type);
    }
    /**
     * The rolloff of the filter which is the drop in db
     * per octave. Implemented internally by cascading filters.
     * Only accepts the values -12, -24, -48 and -96.
     */ get rolloff() {
        return this._rolloff;
    }
    set rolloff(rolloff) {
        const rolloffNum = (0, $lQ01C.isNumber)(rolloff) ? rolloff : parseInt(rolloff, 10);
        const possibilities = [
            -12,
            -24,
            -48,
            -96
        ];
        let cascadingCount = possibilities.indexOf(rolloffNum);
        // check the rolloff is valid
        (0, $6Utwn.assert)(cascadingCount !== -1, `rolloff can only be ${possibilities.join(", ")}`);
        cascadingCount += 1;
        this._rolloff = rolloffNum;
        this.input.disconnect();
        this._filters.forEach((filter)=>filter.disconnect());
        this._filters = new Array(cascadingCount);
        for(let count = 0; count < cascadingCount; count++){
            const filter = new (0, $Lvs5H.BiquadFilter)({
                context: this.context
            });
            filter.type = this._type;
            this.frequency.connect(filter.frequency);
            this.detune.connect(filter.detune);
            this.Q.connect(filter.Q);
            this.gain.connect(filter.gain);
            this._filters[count] = filter;
        }
        this._internalChannels = this._filters;
        (0, $fDBOr.connectSeries)(this.input, ...this._internalChannels, this.output);
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const filterClone = new (0, $Lvs5H.BiquadFilter)({
            frequency: this.frequency.value,
            gain: this.gain.value,
            Q: this.Q.value,
            type: this._type,
            detune: this.detune.value
        });
        // start with all 1s
        const totalResponse = new Float32Array(len).map(()=>1);
        this._filters.forEach(()=>{
            const response = filterClone.getFrequencyResponse(len);
            response.forEach((val, i)=>totalResponse[i] *= val);
        });
        filterClone.dispose();
        return totalResponse;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._filters.forEach((filter)=>{
            filter.dispose();
        });
        (0, $AD7W4.writable)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
        this.frequency.dispose();
        this.Q.dispose();
        this.detune.dispose();
        this.gain.dispose();
        return this;
    }
}

});
parcelRegister("Lvs5H", function(module, exports) {

$parcel$export(module.exports, "BiquadFilter", () => $08ecc9a0f3d33491$export$26bbc35c91a15e23);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $lQP4J = parcelRequire("lQP4J");

var $6Utwn = parcelRequire("6Utwn");
class $08ecc9a0f3d33491$export$26bbc35c91a15e23 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($08ecc9a0f3d33491$export$26bbc35c91a15e23.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "BiquadFilter";
        const options = (0, $l4RVz.optionsFromArguments)($08ecc9a0f3d33491$export$26bbc35c91a15e23.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this._filter = this.context.createBiquadFilter();
        this.input = this.output = this._filter;
        this.Q = new (0, $lQP4J.Param)({
            context: this.context,
            units: "number",
            value: options.Q,
            param: this._filter.Q
        });
        this.frequency = new (0, $lQP4J.Param)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            param: this._filter.frequency
        });
        this.detune = new (0, $lQP4J.Param)({
            context: this.context,
            units: "cents",
            value: options.detune,
            param: this._filter.detune
        });
        this.gain = new (0, $lQP4J.Param)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain,
            param: this._filter.gain
        });
        this.type = options.type;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            Q: 1,
            type: "lowpass",
            frequency: 350,
            detune: 0,
            gain: 0
        });
    }
    /**
     * The type of this BiquadFilterNode. For a complete list of types and their attributes, see the
     * [Web Audio API](https://webaudio.github.io/web-audio-api/#dom-biquadfiltertype-lowpass)
     */ get type() {
        return this._filter.type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $6Utwn.assert)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._filter.type = type;
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        // start with all 1s
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        // clone the filter to remove any connections which may be changing the value
        const filterClone = this.context.createBiquadFilter();
        filterClone.type = this.type;
        filterClone.Q.value = this.Q.value;
        filterClone.frequency.value = this.frequency.value;
        filterClone.gain.value = this.gain.value;
        filterClone.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this._filter.disconnect();
        this.Q.dispose();
        this.frequency.dispose();
        this.gain.dispose();
        this.detune.dispose();
        return this;
    }
}

});


parcelRegister("gjK3F", function(module, exports) {

$parcel$export(module.exports, "FrequencyEnvelope", () => $be1225db167643bf$export$46ffd25e6533b005);

var $l4RVz = parcelRequire("l4RVz");

var $jaF5W = parcelRequire("jaF5W");

var $1zJwt = parcelRequire("1zJwt");

var $fRTgd = parcelRequire("fRTgd");

var $6Utwn = parcelRequire("6Utwn");
class $be1225db167643bf$export$46ffd25e6533b005 extends (0, $jaF5W.Envelope) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($be1225db167643bf$export$46ffd25e6533b005.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "FrequencyEnvelope";
        const options = (0, $l4RVz.optionsFromArguments)($be1225db167643bf$export$46ffd25e6533b005.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        this._octaves = options.octaves;
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._exponent = this.input = new (0, $fRTgd.Pow)({
            context: this.context,
            value: options.exponent
        });
        this._scale = this.output = new (0, $1zJwt.Scale)({
            context: this.context,
            min: this._baseFrequency,
            max: this._baseFrequency * Math.pow(2, this._octaves)
        });
        this._sig.chain(this._exponent, this._scale);
    }
    static getDefaults() {
        return Object.assign((0, $jaF5W.Envelope).getDefaults(), {
            baseFrequency: 200,
            exponent: 1,
            octaves: 4
        });
    }
    /**
     * The envelope's minimum output value. This is the value which it
     * starts at.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(min) {
        const freq = this.toFrequency(min);
        (0, $6Utwn.assertRange)(freq, 0);
        this._baseFrequency = freq;
        this._scale.min = this._baseFrequency;
        // update the max value when the min changes
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the baseFrequency that the
     * envelope will scale to.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._scale.max = this._baseFrequency * Math.pow(2, octaves);
    }
    /**
     * The envelope's exponent value.
     */ get exponent() {
        return this._exponent.value;
    }
    set exponent(exponent) {
        this._exponent.value = exponent;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._exponent.dispose();
        this._scale.dispose();
        return this;
    }
}

});



parcelRegister("lyfdK", function(module, exports) {

var $l4RVz = parcelRequire("l4RVz");

var $QU03h = parcelRequire("QU03h");

var $hbOTW = parcelRequire("hbOTW");
class $fb08947ba877855e$export$45372df7fab1f04e extends (0, $hbOTW.ModulationSynth) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($fb08947ba877855e$export$45372df7fab1f04e.getDefaults(), arguments));
        this.name = "FMSynth";
        const options = (0, $l4RVz.optionsFromArguments)($fb08947ba877855e$export$45372df7fab1f04e.getDefaults(), arguments);
        this.modulationIndex = new (0, $QU03h.Multiply)({
            context: this.context,
            value: options.modulationIndex
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $hbOTW.ModulationSynth).getDefaults(), {
            modulationIndex: 10
        });
    }
    dispose() {
        super.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}

});

parcelRegister("jPwQP", function(module, exports) {

var $jaF5W = parcelRequire("jaF5W");

var $82Hwq = parcelRequire("82Hwq");

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $QU03h = parcelRequire("QU03h");

var $1zJwt = parcelRequire("1zJwt");

var $eCi69 = parcelRequire("eCi69");

var $8xh0e = parcelRequire("8xh0e");

var $2Ccmq = parcelRequire("2Ccmq");
/**
 * Inharmonic ratio of frequencies based on the Roland TR-808
 * Taken from https://ccrma.stanford.edu/papers/tr-808-cymbal-physically-informed-circuit-bendable-digital-model
 */ const $e6fc4343708fd1af$var$inharmRatios = [
    1.0,
    1.483,
    1.932,
    2.546,
    2.630,
    3.897
];
class $e6fc4343708fd1af$export$65cb3eae8bee686d extends (0, $2Ccmq.Monophonic) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e6fc4343708fd1af$export$65cb3eae8bee686d.getDefaults(), arguments));
        this.name = "MetalSynth";
        /**
         * The array of FMOscillators
         */ this._oscillators = [];
        /**
         * The frequency multipliers
         */ this._freqMultipliers = [];
        const options = (0, $l4RVz.optionsFromArguments)($e6fc4343708fd1af$export$65cb3eae8bee686d.getDefaults(), arguments);
        this.detune = new (0, $eCi69.Signal)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency"
        });
        this._amplitude = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        }).connect(this.output);
        this._highpass = new (0, $82Hwq.Filter)({
            // Q: -3.0102999566398125,
            Q: 0,
            context: this.context,
            type: "highpass"
        }).connect(this._amplitude);
        for(let i = 0; i < $e6fc4343708fd1af$var$inharmRatios.length; i++){
            const osc = new (0, $8xh0e.FMOscillator)({
                context: this.context,
                harmonicity: options.harmonicity,
                modulationIndex: options.modulationIndex,
                modulationType: "square",
                onstop: i === 0 ? ()=>this.onsilence(this) : (0, $AD7W4.noOp),
                type: "square"
            });
            osc.connect(this._highpass);
            this._oscillators[i] = osc;
            const mult = new (0, $QU03h.Multiply)({
                context: this.context,
                value: $e6fc4343708fd1af$var$inharmRatios[i]
            });
            this._freqMultipliers[i] = mult;
            this.frequency.chain(mult, osc.frequency);
            this.detune.connect(osc.detune);
        }
        this._filterFreqScaler = new (0, $1zJwt.Scale)({
            context: this.context,
            max: 7000,
            min: this.toFrequency(options.resonance)
        });
        this.envelope = new (0, $jaF5W.Envelope)({
            attack: options.envelope.attack,
            attackCurve: "linear",
            context: this.context,
            decay: options.envelope.decay,
            release: options.envelope.release,
            sustain: 0
        });
        this.envelope.chain(this._filterFreqScaler, this._highpass.frequency);
        this.envelope.connect(this._amplitude.gain);
        // set the octaves
        this._octaves = options.octaves;
        this.octaves = options.octaves;
    }
    static getDefaults() {
        return (0, $l4RVz.deepMerge)((0, $2Ccmq.Monophonic).getDefaults(), {
            envelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                attack: 0.001,
                decay: 1.4,
                release: 0.2
            }),
            harmonicity: 5.1,
            modulationIndex: 32,
            octaves: 1.5,
            resonance: 4000
        });
    }
    /**
     * Trigger the attack.
     * @param time When the attack should be triggered.
     * @param velocity The velocity that the envelope should be triggered at.
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this._oscillators.forEach((osc)=>osc.start(time));
        if (this.envelope.sustain === 0) this._oscillators.forEach((osc)=>{
            osc.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        });
        return this;
    }
    /**
     * Trigger the release of the envelope.
     * @param time When the release should be triggered.
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this._oscillators.forEach((osc)=>osc.stop(time + this.toSeconds(this.envelope.release)));
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * The modulationIndex of the oscillators which make up the source.
     * see [[FMOscillator.modulationIndex]]
     * @min 1
     * @max 100
     */ get modulationIndex() {
        return this._oscillators[0].modulationIndex.value;
    }
    set modulationIndex(val) {
        this._oscillators.forEach((osc)=>osc.modulationIndex.value = val);
    }
    /**
     * The harmonicity of the oscillators which make up the source.
     * see Tone.FMOscillator.harmonicity
     * @min 0.1
     * @max 10
     */ get harmonicity() {
        return this._oscillators[0].harmonicity.value;
    }
    set harmonicity(val) {
        this._oscillators.forEach((osc)=>osc.harmonicity.value = val);
    }
    /**
     * The lower level of the highpass filter which is attached to the envelope.
     * This value should be between [0, 7000]
     * @min 0
     * @max 7000
     */ get resonance() {
        return this._filterFreqScaler.min;
    }
    set resonance(val) {
        this._filterFreqScaler.min = this.toFrequency(val);
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the "resonance" frequency
     * that the filter ramps during the attack/decay envelope
     * @min 0
     * @max 8
     */ get octaves() {
        return this._octaves;
    }
    set octaves(val) {
        this._octaves = val;
        this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, val);
    }
    dispose() {
        super.dispose();
        this._oscillators.forEach((osc)=>osc.dispose());
        this._freqMultipliers.forEach((freqMult)=>freqMult.dispose());
        this.frequency.dispose();
        this.detune.dispose();
        this._filterFreqScaler.dispose();
        this._amplitude.dispose();
        this.envelope.dispose();
        this._highpass.dispose();
        return this;
    }
}

});

parcelRegister("k2cmp", function(module, exports) {

var $gztBd = parcelRequire("gztBd");

var $aZf7A = parcelRequire("aZf7A");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $2Ccmq = parcelRequire("2Ccmq");

var $9Z1pB = parcelRequire("9Z1pB");

var $hLrAi = parcelRequire("hLrAi");
class $e95d951445edf71c$export$e4f4b32b2e74f0e2 extends (0, $9Z1pB.Synth) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e95d951445edf71c$export$e4f4b32b2e74f0e2.getDefaults(), arguments));
        this.name = "MembraneSynth";
        /**
         * Portamento is ignored in this synth. use pitch decay instead.
         */ this.portamento = 0;
        const options = (0, $l4RVz.optionsFromArguments)($e95d951445edf71c$export$e4f4b32b2e74f0e2.getDefaults(), arguments);
        this.pitchDecay = options.pitchDecay;
        this.octaves = options.octaves;
        (0, $AD7W4.readOnly)(this, [
            "oscillator",
            "envelope"
        ]);
    }
    static getDefaults() {
        return (0, $l4RVz.deepMerge)((0, $2Ccmq.Monophonic).getDefaults(), (0, $9Z1pB.Synth).getDefaults(), {
            envelope: {
                attack: 0.001,
                attackCurve: "exponential",
                decay: 0.4,
                release: 1.4,
                sustain: 0.01
            },
            octaves: 10,
            oscillator: {
                type: "sine"
            },
            pitchDecay: 0.05
        });
    }
    setNote(note, time) {
        const seconds = this.toSeconds(time);
        const hertz = this.toFrequency(note instanceof (0, $aZf7A.FrequencyClass) ? note.toFrequency() : note);
        const maxNote = hertz * this.octaves;
        this.oscillator.frequency.setValueAtTime(maxNote, seconds);
        this.oscillator.frequency.exponentialRampToValueAtTime(hertz, seconds + this.toSeconds(this.pitchDecay));
        return this;
    }
    dispose() {
        super.dispose();
        return this;
    }
}
(0, $gztBd.__decorate)([
    (0, $hLrAi.range)(0)
], $e95d951445edf71c$export$e4f4b32b2e74f0e2.prototype, "octaves", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $e95d951445edf71c$export$e4f4b32b2e74f0e2.prototype, "pitchDecay", void 0);

});

parcelRegister("kCoIg", function(module, exports) {

$parcel$export(module.exports, "NoiseSynth", () => $f02a86bf85a2d7a5$export$a0d6f4d32fd5959);

var $8XS4X = parcelRequire("8XS4X");

var $l4RVz = parcelRequire("l4RVz");

var $5yVwk = parcelRequire("5yVwk");

var $96T6P = parcelRequire("96T6P");

var $fDBOr = parcelRequire("fDBOr");

var $jaF5W = parcelRequire("jaF5W");

var $21sLj = parcelRequire("21sLj");
class $f02a86bf85a2d7a5$export$a0d6f4d32fd5959 extends (0, $96T6P.Instrument) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($f02a86bf85a2d7a5$export$a0d6f4d32fd5959.getDefaults(), arguments));
        this.name = "NoiseSynth";
        const options = (0, $l4RVz.optionsFromArguments)($f02a86bf85a2d7a5$export$a0d6f4d32fd5959.getDefaults(), arguments);
        this.noise = new (0, $5yVwk.Noise)(Object.assign({
            context: this.context
        }, options.noise));
        this.envelope = new (0, $8XS4X.AmplitudeEnvelope)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the noise to the output
        this.noise.chain(this.envelope, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $96T6P.Instrument).getDefaults(), {
            envelope: Object.assign((0, $l4RVz.omitFromObject)((0, $jaF5W.Envelope).getDefaults(), Object.keys((0, $fDBOr.ToneAudioNode).getDefaults())), {
                decay: 0.1,
                sustain: 0.0
            }),
            noise: Object.assign((0, $l4RVz.omitFromObject)((0, $5yVwk.Noise).getDefaults(), Object.keys((0, $21sLj.Source).getDefaults())), {
                type: "white"
            })
        });
    }
    /**
     * Start the attack portion of the envelopes. Unlike other
     * instruments, Tone.NoiseSynth doesn't have a note.
     * @example
     * const noiseSynth = new Tone.NoiseSynth().toDestination();
     * noiseSynth.triggerAttack();
     */ triggerAttack(time, velocity = 1) {
        time = this.toSeconds(time);
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        // start the noise
        this.noise.start(time);
        if (this.envelope.sustain === 0) this.noise.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        return this;
    }
    /**
     * Start the release portion of the envelopes.
     */ triggerRelease(time) {
        time = this.toSeconds(time);
        this.envelope.triggerRelease(time);
        this.noise.stop(time + this.toSeconds(this.envelope.release));
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 0);
            this._syncMethod("triggerRelease", 0);
        }
        return this;
    }
    triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        duration = this.toSeconds(duration);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + duration);
        return this;
    }
    dispose() {
        super.dispose();
        this.noise.dispose();
        this.envelope.dispose();
        return this;
    }
}

});

parcelRegister("8XBGU", function(module, exports) {

var $9JfLL = parcelRequire("9JfLL");

var $l4RVz = parcelRequire("l4RVz");

var $5yVwk = parcelRequire("5yVwk");

var $96T6P = parcelRequire("96T6P");
class $686112197af110b0$export$8334f51ae3f4c97e extends (0, $96T6P.Instrument) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($686112197af110b0$export$8334f51ae3f4c97e.getDefaults(), arguments));
        this.name = "PluckSynth";
        const options = (0, $l4RVz.optionsFromArguments)($686112197af110b0$export$8334f51ae3f4c97e.getDefaults(), arguments);
        this._noise = new (0, $5yVwk.Noise)({
            context: this.context,
            type: "pink"
        });
        this.attackNoise = options.attackNoise;
        this._lfcf = new (0, $9JfLL.LowpassCombFilter)({
            context: this.context,
            dampening: options.dampening,
            resonance: options.resonance
        });
        this.resonance = options.resonance;
        this.release = options.release;
        this._noise.connect(this._lfcf);
        this._lfcf.connect(this.output);
    }
    static getDefaults() {
        return (0, $l4RVz.deepMerge)((0, $96T6P.Instrument).getDefaults(), {
            attackNoise: 1,
            dampening: 4000,
            resonance: 0.7,
            release: 1
        });
    }
    /**
     * The dampening control. i.e. the lowpass filter frequency of the comb filter
     * @min 0
     * @max 7000
     */ get dampening() {
        return this._lfcf.dampening;
    }
    set dampening(fq) {
        this._lfcf.dampening = fq;
    }
    triggerAttack(note, time) {
        const freq = this.toFrequency(note);
        time = this.toSeconds(time);
        const delayAmount = 1 / freq;
        this._lfcf.delayTime.setValueAtTime(delayAmount, time);
        this._noise.start(time);
        this._noise.stop(time + delayAmount * this.attackNoise);
        this._lfcf.resonance.cancelScheduledValues(time);
        this._lfcf.resonance.setValueAtTime(this.resonance, time);
        return this;
    }
    /**
     * Ramp down the [[resonance]] to 0 over the duration of the release time.
     */ triggerRelease(time) {
        this._lfcf.resonance.linearRampTo(0, this.release, time);
        return this;
    }
    dispose() {
        super.dispose();
        this._noise.dispose();
        this._lfcf.dispose();
        return this;
    }
}

});
parcelRegister("9JfLL", function(module, exports) {

$parcel$export(module.exports, "LowpassCombFilter", () => $71548c84ea06a887$export$e83d2527589f5587);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $ftrg1 = parcelRequire("ftrg1");

var $3B6kz = parcelRequire("3B6kz");
class $71548c84ea06a887$export$e83d2527589f5587 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($71548c84ea06a887$export$e83d2527589f5587.getDefaults(), arguments, [
            "delayTime",
            "resonance",
            "dampening"
        ]));
        this.name = "LowpassCombFilter";
        const options = (0, $l4RVz.optionsFromArguments)($71548c84ea06a887$export$e83d2527589f5587.getDefaults(), arguments, [
            "delayTime",
            "resonance",
            "dampening"
        ]);
        this._combFilter = this.output = new (0, $ftrg1.FeedbackCombFilter)({
            context: this.context,
            delayTime: options.delayTime,
            resonance: options.resonance
        });
        this.delayTime = this._combFilter.delayTime;
        this.resonance = this._combFilter.resonance;
        this._lowpass = this.input = new (0, $3B6kz.OnePoleFilter)({
            context: this.context,
            frequency: options.dampening,
            type: "lowpass"
        });
        // connections
        this._lowpass.connect(this._combFilter);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            dampening: 3000,
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    /**
     * The dampening control of the feedback
     */ get dampening() {
        return this._lowpass.frequency;
    }
    set dampening(fq) {
        this._lowpass.frequency = fq;
    }
    dispose() {
        super.dispose();
        this._combFilter.dispose();
        this._lowpass.dispose();
        return this;
    }
}

});
parcelRegister("ftrg1", function(module, exports) {

$parcel$export(module.exports, "FeedbackCombFilter", () => $b43eb52dd0263153$export$e7a685a7e8ffb78a);

var $bdbZZ = parcelRequire("bdbZZ");

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $ikKDK = parcelRequire("ikKDK");

var $hv8s0 = parcelRequire("hv8s0");
class $b43eb52dd0263153$export$e7a685a7e8ffb78a extends (0, $ikKDK.ToneAudioWorklet) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($b43eb52dd0263153$export$e7a685a7e8ffb78a.getDefaults(), arguments, [
            "delayTime",
            "resonance"
        ]));
        this.name = "FeedbackCombFilter";
        const options = (0, $l4RVz.optionsFromArguments)($b43eb52dd0263153$export$e7a685a7e8ffb78a.getDefaults(), arguments, [
            "delayTime",
            "resonance"
        ]);
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.delayTime = new (0, $lQP4J.Param)({
            context: this.context,
            value: options.delayTime,
            units: "time",
            minValue: 0,
            maxValue: 1,
            param: this._dummyParam,
            swappable: true
        });
        this.resonance = new (0, $lQP4J.Param)({
            context: this.context,
            value: options.resonance,
            units: "normalRange",
            param: this._dummyParam,
            swappable: true
        });
        (0, $AD7W4.readOnly)(this, [
            "resonance",
            "delayTime"
        ]);
    }
    _audioWorkletName() {
        return 0, $hv8s0.workletName;
    }
    /**
     * The default parameters
     */ static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    onReady(node) {
        (0, $fDBOr.connectSeries)(this.input, node, this.output);
        const delayTime = node.parameters.get("delayTime");
        this.delayTime.setParam(delayTime);
        const feedback = node.parameters.get("feedback");
        this.resonance.setParam(feedback);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.delayTime.dispose();
        this.resonance.dispose();
        return this;
    }
}

});
parcelRegister("ikKDK", function(module, exports) {

$parcel$export(module.exports, "ToneAudioWorklet", () => $d58e46062cb67a04$export$212d912bd0512eff);

var $fDBOr = parcelRequire("fDBOr");

var $AD7W4 = parcelRequire("AD7W4");

var $36iEG = parcelRequire("36iEG");
class $d58e46062cb67a04$export$212d912bd0512eff extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = "ToneAudioWorklet";
        /**
         * The constructor options for the node
         */ this.workletOptions = {};
        /**
         * Callback which is invoked when there is an error in the processing
         */ this.onprocessorerror = (0, $AD7W4.noOp);
        const blobUrl = URL.createObjectURL(new Blob([
            (0, $36iEG.getWorkletGlobalScope)()
        ], {
            type: "text/javascript"
        }));
        const name = this._audioWorkletName();
        this._dummyGain = this.context.createGain();
        this._dummyParam = this._dummyGain.gain;
        // Register the processor
        this.context.addAudioWorkletModule(blobUrl, name).then(()=>{
            // create the worklet when it's read
            if (!this.disposed) {
                this._worklet = this.context.createAudioWorkletNode(name, this.workletOptions);
                this._worklet.onprocessorerror = this.onprocessorerror.bind(this);
                this.onReady(this._worklet);
            }
        });
    }
    dispose() {
        super.dispose();
        this._dummyGain.disconnect();
        if (this._worklet) {
            this._worklet.port.postMessage("dispose");
            this._worklet.disconnect();
        }
        return this;
    }
}

});
parcelRegister("36iEG", function(module, exports) {

$parcel$export(module.exports, "addToWorklet", () => $242067250274081b$export$4332289150d1c155);
$parcel$export(module.exports, "registerProcessor", () => $242067250274081b$export$d575e6557ac1729f);
$parcel$export(module.exports, "getWorkletGlobalScope", () => $242067250274081b$export$b2ba7b9987bb8e81);
/**
 * All of the classes or functions which are loaded into the AudioWorkletGlobalScope
 */ const $242067250274081b$var$workletContext = new Set();
function $242067250274081b$export$4332289150d1c155(classOrFunction) {
    $242067250274081b$var$workletContext.add(classOrFunction);
}
function $242067250274081b$export$d575e6557ac1729f(name, classDesc) {
    const processor = /* javascript */ `registerProcessor("${name}", ${classDesc})`;
    $242067250274081b$var$workletContext.add(processor);
}
function $242067250274081b$export$b2ba7b9987bb8e81() {
    return Array.from($242067250274081b$var$workletContext).join("\n");
}

});


parcelRegister("hv8s0", function(module, exports) {

$parcel$export(module.exports, "workletName", () => $cbdbe30e338cc1eb$export$85343ada6050a795);
parcelRequire("2As9c");
parcelRequire("gjlQk");

var $36iEG = parcelRequire("36iEG");
const $cbdbe30e338cc1eb$export$85343ada6050a795 = "feedback-comb-filter";
const $cbdbe30e338cc1eb$var$feedbackCombFilter = /* javascript */ `
	class FeedbackCombFilterWorklet extends SingleIOProcessor {

		constructor(options) {
			super(options);
			this.delayLine = new DelayLine(this.sampleRate, options.channelCount || 2);
		}

		static get parameterDescriptors() {
			return [{
				name: "delayTime",
				defaultValue: 0.1,
				minValue: 0,
				maxValue: 1,
				automationRate: "k-rate"
			}, {
				name: "feedback",
				defaultValue: 0.5,
				minValue: 0,
				maxValue: 0.9999,
				automationRate: "k-rate"
			}];
		}

		generate(input, channel, parameters) {
			const delayedSample = this.delayLine.get(channel, parameters.delayTime * this.sampleRate);
			this.delayLine.push(channel, input + delayedSample * parameters.feedback);
			return delayedSample;
		}
	}
`;
(0, $36iEG.registerProcessor)($cbdbe30e338cc1eb$export$85343ada6050a795, $cbdbe30e338cc1eb$var$feedbackCombFilter);

});
parcelRegister("2As9c", function(module, exports) {
parcelRequire("cTdQk");

var $36iEG = parcelRequire("36iEG");
const $1e24c70aab2c818a$export$3821b1427992e4a0 = /* javascript */ `
	/**
	 * Abstract class for a single input/output processor. 
	 * has a 'generate' function which processes one sample at a time
	 */
	class SingleIOProcessor extends ToneAudioWorkletProcessor {

		constructor(options) {
			super(Object.assign(options, {
				numberOfInputs: 1,
				numberOfOutputs: 1
			}));
			/**
			 * Holds the name of the parameter and a single value of that
			 * parameter at the current sample
			 * @type { [name: string]: number }
			 */
			this.params = {}
		}

		/**
		 * Generate an output sample from the input sample and parameters
		 * @abstract
		 * @param input number
		 * @param channel number
		 * @param parameters { [name: string]: number }
		 * @returns number
		 */
		generate(){}

		/**
		 * Update the private params object with the 
		 * values of the parameters at the given index
		 * @param parameters { [name: string]: Float32Array },
		 * @param index number
		 */
		updateParams(parameters, index) {
			for (const paramName in parameters) {
				const param = parameters[paramName];
				if (param.length > 1) {
					this.params[paramName] = parameters[paramName][index];
				} else {
					this.params[paramName] = parameters[paramName][0];
				}
			}
		}

		/**
		 * Process a single frame of the audio
		 * @param inputs Float32Array[][]
		 * @param outputs Float32Array[][]
		 */
		process(inputs, outputs, parameters) {
			const input = inputs[0];
			const output = outputs[0];
			// get the parameter values
			const channelCount = Math.max(input && input.length || 0, output.length);
			for (let sample = 0; sample < this.blockSize; sample++) {
				this.updateParams(parameters, sample);
				for (let channel = 0; channel < channelCount; channel++) {
					const inputSample = input && input.length ? input[channel][sample] : 0;
					output[channel][sample] = this.generate(inputSample, channel, this.params);
				}
			}
			return !this.disposed;
		}
	};
`;
(0, $36iEG.addToWorklet)($1e24c70aab2c818a$export$3821b1427992e4a0);

});
parcelRegister("cTdQk", function(module, exports) {

var $36iEG = parcelRequire("36iEG");
const $96255c0a19f0cc0c$var$toneAudioWorkletProcessor = /* javascript */ `
	/**
	 * The base AudioWorkletProcessor for use in Tone.js. Works with the [[ToneAudioWorklet]]. 
	 */
	class ToneAudioWorkletProcessor extends AudioWorkletProcessor {

		constructor(options) {
			
			super(options);
			/**
			 * If the processor was disposed or not. Keep alive until it's disposed.
			 */
			this.disposed = false;
		   	/** 
			 * The number of samples in the processing block
			 */
			this.blockSize = 128;
			/**
			 * the sample rate
			 */
			this.sampleRate = sampleRate;

			this.port.onmessage = (event) => {
				// when it receives a dispose 
				if (event.data === "dispose") {
					this.disposed = true;
				}
			};
		}
	}
`;
(0, $36iEG.addToWorklet)($96255c0a19f0cc0c$var$toneAudioWorkletProcessor);

});


parcelRegister("gjlQk", function(module, exports) {

var $36iEG = parcelRequire("36iEG");
const $bdff5d3cd1bfda54$var$delayLine = /* javascript */ `
	/**
	 * A multichannel buffer for use within an AudioWorkletProcessor as a delay line
	 */
	class DelayLine {
		
		constructor(size, channels) {
			this.buffer = [];
			this.writeHead = []
			this.size = size;

			// create the empty channels
			for (let i = 0; i < channels; i++) {
				this.buffer[i] = new Float32Array(this.size);
				this.writeHead[i] = 0;
			}
		}

		/**
		 * Push a value onto the end
		 * @param channel number
		 * @param value number
		 */
		push(channel, value) {
			this.writeHead[channel] += 1;
			if (this.writeHead[channel] > this.size) {
				this.writeHead[channel] = 0;
			}
			this.buffer[channel][this.writeHead[channel]] = value;
		}

		/**
		 * Get the recorded value of the channel given the delay
		 * @param channel number
		 * @param delay number delay samples
		 */
		get(channel, delay) {
			let readHead = this.writeHead[channel] - Math.floor(delay);
			if (readHead < 0) {
				readHead += this.size;
			}
			return this.buffer[channel][readHead];
		}
	}
`;
(0, $36iEG.addToWorklet)($bdff5d3cd1bfda54$var$delayLine);

});



parcelRegister("3B6kz", function(module, exports) {

$parcel$export(module.exports, "OnePoleFilter", () => $29e9bcfa4a5e0d19$export$7961b18021b7c8c9);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $bdbZZ = parcelRequire("bdbZZ");
class $29e9bcfa4a5e0d19$export$7961b18021b7c8c9 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($29e9bcfa4a5e0d19$export$7961b18021b7c8c9.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "OnePoleFilter";
        const options = (0, $l4RVz.optionsFromArguments)($29e9bcfa4a5e0d19$export$7961b18021b7c8c9.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this._frequency = options.frequency;
        this._type = options.type;
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._createFilter();
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            frequency: 880,
            type: "lowpass"
        });
    }
    /**
     * Create a filter and dispose the old one
     */ _createFilter() {
        const oldFilter = this._filter;
        const freq = this.toFrequency(this._frequency);
        const t = 1 / (2 * Math.PI * freq);
        if (this._type === "lowpass") {
            const a0 = 1 / (t * this.context.sampleRate);
            const b1 = a0 - 1;
            this._filter = this.context.createIIRFilter([
                a0,
                0
            ], [
                1,
                b1
            ]);
        } else {
            const b1 = 1 / (t * this.context.sampleRate) - 1;
            this._filter = this.context.createIIRFilter([
                1,
                -1
            ], [
                1,
                b1
            ]);
        }
        this.input.chain(this._filter, this.output);
        if (oldFilter) // dispose it on the next block
        this.context.setTimeout(()=>{
            if (!this.disposed) {
                this.input.disconnect(oldFilter);
                oldFilter.disconnect();
            }
        }, this.blockTime);
    }
    /**
     * The frequency value.
     */ get frequency() {
        return this._frequency;
    }
    set frequency(fq) {
        this._frequency = fq;
        this._createFilter();
    }
    /**
     * The OnePole Filter type, either "highpass" or "lowpass"
     */ get type() {
        return this._type;
    }
    set type(t) {
        this._type = t;
        this._createFilter();
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        this._filter.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this._filter.disconnect();
        return this;
    }
}

});



parcelRegister("ksj9M", function(module, exports) {

$parcel$export(module.exports, "PolySynth", () => $ee45484c5493195d$export$a7e98a317490a78b);

var $3xSib = parcelRequire("3xSib");

var $l4RVz = parcelRequire("l4RVz");

var $lQ01C = parcelRequire("lQ01C");

var $96T6P = parcelRequire("96T6P");

var $9Z1pB = parcelRequire("9Z1pB");

var $6Utwn = parcelRequire("6Utwn");
class $ee45484c5493195d$export$a7e98a317490a78b extends (0, $96T6P.Instrument) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ee45484c5493195d$export$a7e98a317490a78b.getDefaults(), arguments, [
            "voice",
            "options"
        ]));
        this.name = "PolySynth";
        /**
         * The voices which are not currently in use
         */ this._availableVoices = [];
        /**
         * The currently active voices
         */ this._activeVoices = [];
        /**
         * All of the allocated voices for this synth.
         */ this._voices = [];
        /**
         * The GC timeout. Held so that it could be cancelled when the node is disposed.
         */ this._gcTimeout = -1;
        /**
         * A moving average of the number of active voices
         */ this._averageActiveVoices = 0;
        const options = (0, $l4RVz.optionsFromArguments)($ee45484c5493195d$export$a7e98a317490a78b.getDefaults(), arguments, [
            "voice",
            "options"
        ]);
        // check against the old API (pre 14.3.0)
        (0, $6Utwn.assert)(!(0, $lQ01C.isNumber)(options.voice), "DEPRECATED: The polyphony count is no longer the first argument.");
        const defaults = options.voice.getDefaults();
        this.options = Object.assign(defaults, options.options);
        this.voice = options.voice;
        this.maxPolyphony = options.maxPolyphony;
        // create the first voice
        this._dummyVoice = this._getNextAvailableVoice();
        // remove it from the voices list
        const index = this._voices.indexOf(this._dummyVoice);
        this._voices.splice(index, 1);
        // kick off the GC interval
        this._gcTimeout = this.context.setInterval(this._collectGarbage.bind(this), 1);
    }
    static getDefaults() {
        return Object.assign((0, $96T6P.Instrument).getDefaults(), {
            maxPolyphony: 32,
            options: {},
            voice: (0, $9Z1pB.Synth)
        });
    }
    /**
     * The number of active voices.
     */ get activeVoices() {
        return this._activeVoices.length;
    }
    /**
     * Invoked when the source is done making sound, so that it can be
     * readded to the pool of available voices
     */ _makeVoiceAvailable(voice) {
        this._availableVoices.push(voice);
        // remove the midi note from 'active voices'
        const activeVoiceIndex = this._activeVoices.findIndex((e)=>e.voice === voice);
        this._activeVoices.splice(activeVoiceIndex, 1);
    }
    /**
     * Get an available voice from the pool of available voices.
     * If one is not available and the maxPolyphony limit is reached,
     * steal a voice, otherwise return null.
     */ _getNextAvailableVoice() {
        // if there are available voices, return the first one
        if (this._availableVoices.length) return this._availableVoices.shift();
        else if (this._voices.length < this.maxPolyphony) {
            // otherwise if there is still more maxPolyphony, make a new voice
            const voice = new this.voice(Object.assign(this.options, {
                context: this.context,
                onsilence: this._makeVoiceAvailable.bind(this)
            }));
            voice.connect(this.output);
            this._voices.push(voice);
            return voice;
        } else (0, $6Utwn.warn)("Max polyphony exceeded. Note dropped.");
    }
    /**
     * Occasionally check if there are any allocated voices which can be cleaned up.
     */ _collectGarbage() {
        this._averageActiveVoices = Math.max(this._averageActiveVoices * 0.95, this.activeVoices);
        if (this._availableVoices.length && this._voices.length > Math.ceil(this._averageActiveVoices + 1)) {
            // take off an available note
            const firstAvail = this._availableVoices.shift();
            const index = this._voices.indexOf(firstAvail);
            this._voices.splice(index, 1);
            if (!this.context.isOffline) firstAvail.dispose();
        }
    }
    /**
     * Internal method which triggers the attack
     */ _triggerAttack(notes, time, velocity) {
        notes.forEach((note)=>{
            const midiNote = new (0, $3xSib.MidiClass)(this.context, note).toMidi();
            const voice = this._getNextAvailableVoice();
            if (voice) {
                voice.triggerAttack(note, time, velocity);
                this._activeVoices.push({
                    midi: midiNote,
                    voice: voice,
                    released: false
                });
                this.log("triggerAttack", note, time);
            }
        });
    }
    /**
     * Internal method which triggers the release
     */ _triggerRelease(notes, time) {
        notes.forEach((note)=>{
            const midiNote = new (0, $3xSib.MidiClass)(this.context, note).toMidi();
            const event = this._activeVoices.find(({ midi: midi, released: released })=>midi === midiNote && !released);
            if (event) {
                // trigger release on that note
                event.voice.triggerRelease(time);
                // mark it as released
                event.released = true;
                this.log("triggerRelease", note, time);
            }
        });
    }
    /**
     * Schedule the attack/release events. If the time is in the future, then it should set a timeout
     * to wait for just-in-time scheduling
     */ _scheduleEvent(type, notes, time, velocity) {
        (0, $6Utwn.assert)(!this.disposed, "Synth was already disposed");
        // if the notes are greater than this amount of time in the future, they should be scheduled with setTimeout
        if (time <= this.now()) {
            // do it immediately
            if (type === "attack") this._triggerAttack(notes, time, velocity);
            else this._triggerRelease(notes, time);
        } else // schedule it to start in the future
        this.context.setTimeout(()=>{
            this._scheduleEvent(type, notes, time, velocity);
        }, time - this.now());
    }
    /**
     * Trigger the attack portion of the note
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  The start time of the note.
     * @param velocity The velocity of the note.
     * @example
     * const synth = new Tone.PolySynth(Tone.FMSynth).toDestination();
     * // trigger a chord immediately with a velocity of 0.2
     * synth.triggerAttack(["Ab3", "C4", "F5"], Tone.now(), 0.2);
     */ triggerAttack(notes, time, velocity) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("attack", notes, computedTime, velocity);
        return this;
    }
    /**
     * Trigger the release of the note. Unlike monophonic instruments,
     * a note (or array of notes) needs to be passed in as the first argument.
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  When the release will be triggered.
     * @example
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * poly.triggerAttack(["Ab3", "C4", "F5"]);
     * // trigger the release of the given notes.
     * poly.triggerRelease(["Ab3", "C4"], "+1");
     * poly.triggerRelease("F5", "+3");
     */ triggerRelease(notes, time) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("release", notes, computedTime);
        return this;
    }
    /**
     * Trigger the attack and release after the specified duration
     * @param  notes The notes to play. Accepts a single  Frequency or an array of frequencies.
     * @param  duration the duration of the note
     * @param  time  if no time is given, defaults to now
     * @param  velocity the velocity of the attack (0-1)
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * // can pass in an array of durations as well
     * poly.triggerAttackRelease(["Eb3", "G4", "Bb4", "D5"], [4, 3, 2, 1]);
     */ triggerAttackRelease(notes, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $lQ01C.isArray)(duration)) {
            (0, $6Utwn.assert)((0, $lQ01C.isArray)(notes), "If the duration is an array, the notes must also be an array");
            notes;
            for(let i = 0; i < notes.length; i++){
                const d = duration[Math.min(i, duration.length - 1)];
                const durationSeconds = this.toSeconds(d);
                (0, $6Utwn.assert)(durationSeconds > 0, "The duration must be greater than 0");
                this.triggerRelease(notes[i], computedTime + durationSeconds);
            }
        } else {
            const durationSeconds = this.toSeconds(duration);
            (0, $6Utwn.assert)(durationSeconds > 0, "The duration must be greater than 0");
            this.triggerRelease(notes, computedTime + durationSeconds);
        }
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
        }
        return this;
    }
    /**
     * Set a member/attribute of the voices
     * @example
     * const poly = new Tone.PolySynth().toDestination();
     * // set all of the voices using an options object for the synth type
     * poly.set({
     * 	envelope: {
     * 		attack: 0.25
     * 	}
     * });
     * poly.triggerAttackRelease("Bb3", 0.2);
     */ set(options) {
        // remove options which are controlled by the PolySynth
        const sanitizedOptions = (0, $l4RVz.omitFromObject)(options, [
            "onsilence",
            "context"
        ]);
        // store all of the options
        this.options = (0, $l4RVz.deepMerge)(this.options, sanitizedOptions);
        this._voices.forEach((voice)=>voice.set(sanitizedOptions));
        this._dummyVoice.set(sanitizedOptions);
        return this;
    }
    get() {
        return this._dummyVoice.get();
    }
    /**
     * Trigger the release portion of all the currently active voices immediately.
     * Useful for silencing the synth.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeVoices.forEach(({ voice: voice })=>{
            voice.triggerRelease(computedTime);
        });
        return this;
    }
    dispose() {
        super.dispose();
        this._dummyVoice.dispose();
        this._voices.forEach((v)=>v.dispose());
        this._activeVoices = [];
        this._availableVoices = [];
        this.context.clearInterval(this._gcTimeout);
        return this;
    }
}

});

parcelRegister("7u8Jf", function(module, exports) {

$parcel$export(module.exports, "Sampler", () => $57321b1dc694beba$export$322f102bec719b22);

var $gztBd = parcelRequire("gztBd");

var $iace4 = parcelRequire("iace4");

var $bmU6v = parcelRequire("bmU6v");

var $aZf7A = parcelRequire("aZf7A");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $lQ01C = parcelRequire("lQ01C");

var $96T6P = parcelRequire("96T6P");

var $a0u4l = parcelRequire("a0u4l");

var $hLrAi = parcelRequire("hLrAi");

var $6Utwn = parcelRequire("6Utwn");
class $57321b1dc694beba$export$322f102bec719b22 extends (0, $96T6P.Instrument) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($57321b1dc694beba$export$322f102bec719b22.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls"));
        this.name = "Sampler";
        /**
         * The object of all currently playing BufferSources
         */ this._activeSources = new Map();
        const options = (0, $l4RVz.optionsFromArguments)($57321b1dc694beba$export$322f102bec719b22.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        const urlMap = {};
        Object.keys(options.urls).forEach((note)=>{
            const noteNumber = parseInt(note, 10);
            (0, $6Utwn.assert)((0, $lQ01C.isNote)(note) || (0, $lQ01C.isNumber)(noteNumber) && isFinite(noteNumber), `url key is neither a note or midi pitch: ${note}`);
            if ((0, $lQ01C.isNote)(note)) {
                // convert the note name to MIDI
                const mid = new (0, $aZf7A.FrequencyClass)(this.context, note).toMidi();
                urlMap[mid] = options.urls[note];
            } else if ((0, $lQ01C.isNumber)(noteNumber) && isFinite(noteNumber)) // otherwise if it's numbers assume it's midi
            urlMap[noteNumber] = options.urls[noteNumber];
        });
        this._buffers = new (0, $iace4.ToneAudioBuffers)({
            urls: urlMap,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        this.attack = options.attack;
        this.release = options.release;
        this.curve = options.curve;
        // invoke the callback if it's already loaded
        if (this._buffers.loaded) // invoke onload deferred
        Promise.resolve().then(options.onload);
    }
    static getDefaults() {
        return Object.assign((0, $96T6P.Instrument).getDefaults(), {
            attack: 0,
            baseUrl: "",
            curve: "exponential",
            onload: (0, $AD7W4.noOp),
            onerror: (0, $AD7W4.noOp),
            release: 0.1,
            urls: {}
        });
    }
    /**
     * Returns the difference in steps between the given midi note at the closets sample.
     */ _findClosest(midi) {
        // searches within 8 octaves of the given midi note
        const MAX_INTERVAL = 96;
        let interval = 0;
        while(interval < MAX_INTERVAL){
            // check above and below
            if (this._buffers.has(midi + interval)) return -interval;
            else if (this._buffers.has(midi - interval)) return interval;
            interval++;
        }
        throw new Error(`No available buffers for note: ${midi}`);
    }
    /**
     * @param  notes	The note to play, or an array of notes.
     * @param  time     When to play the note
     * @param  velocity The velocity to play the sample back.
     */ triggerAttack(notes, time, velocity = 1) {
        this.log("triggerAttack", notes, time, velocity);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midiFloat = (0, $bmU6v.ftomf)(new (0, $aZf7A.FrequencyClass)(this.context, note).toFrequency());
            const midi = Math.round(midiFloat);
            const remainder = midiFloat - midi;
            // find the closest note pitch
            const difference = this._findClosest(midi);
            const closestNote = midi - difference;
            const buffer = this._buffers.get(closestNote);
            const playbackRate = (0, $bmU6v.intervalToFrequencyRatio)(difference + remainder);
            // play that note
            const source = new (0, $a0u4l.ToneBufferSource)({
                url: buffer,
                context: this.context,
                curve: this.curve,
                fadeIn: this.attack,
                fadeOut: this.release,
                playbackRate: playbackRate
            }).connect(this.output);
            source.start(time, 0, buffer.duration / playbackRate, velocity);
            // add it to the active sources
            if (!(0, $lQ01C.isArray)(this._activeSources.get(midi))) this._activeSources.set(midi, []);
            this._activeSources.get(midi).push(source);
            // remove it when it's done
            source.onended = ()=>{
                if (this._activeSources && this._activeSources.has(midi)) {
                    const sources = this._activeSources.get(midi);
                    const index = sources.indexOf(source);
                    if (index !== -1) sources.splice(index, 1);
                }
            };
        });
        return this;
    }
    /**
     * @param  notes	The note to release, or an array of notes.
     * @param  time     	When to release the note.
     */ triggerRelease(notes, time) {
        this.log("triggerRelease", notes, time);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midi = new (0, $aZf7A.FrequencyClass)(this.context, note).toMidi();
            // find the note
            if (this._activeSources.has(midi) && this._activeSources.get(midi).length) {
                const sources = this._activeSources.get(midi);
                time = this.toSeconds(time);
                sources.forEach((source)=>{
                    source.stop(time);
                });
                this._activeSources.set(midi, []);
            }
        });
        return this;
    }
    /**
     * Release all currently active notes.
     * @param  time     	When to release the notes.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((sources)=>{
            while(sources.length){
                const source = sources.shift();
                source.stop(computedTime);
            }
        });
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
        }
        return this;
    }
    /**
     * Invoke the attack phase, then after the duration, invoke the release.
     * @param  notes	The note to play and release, or an array of notes.
     * @param  duration The time the note should be held
     * @param  time     When to start the attack
     * @param  velocity The velocity of the attack
     */ triggerAttackRelease(notes, duration, time, velocity = 1) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $lQ01C.isArray)(duration)) {
            (0, $6Utwn.assert)((0, $lQ01C.isArray)(notes), "notes must be an array when duration is array");
            notes.forEach((note, index)=>{
                const d = duration[Math.min(index, duration.length - 1)];
                this.triggerRelease(note, computedTime + this.toSeconds(d));
            });
        } else this.triggerRelease(notes, computedTime + this.toSeconds(duration));
        return this;
    }
    /**
     * Add a note to the sampler.
     * @param  note      The buffer's pitch.
     * @param  url  Either the url of the buffer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     */ add(note, url, callback) {
        (0, $6Utwn.assert)((0, $lQ01C.isNote)(note) || isFinite(note), `note must be a pitch or midi: ${note}`);
        if ((0, $lQ01C.isNote)(note)) {
            // convert the note name to MIDI
            const mid = new (0, $aZf7A.FrequencyClass)(this.context, note).toMidi();
            this._buffers.add(mid, url, callback);
        } else // otherwise if it's numbers assume it's midi
        this._buffers.add(note, url, callback);
        return this;
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._buffers.dispose();
        this._activeSources.forEach((sources)=>{
            sources.forEach((source)=>source.dispose());
        });
        this._activeSources.clear();
        return this;
    }
}
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $57321b1dc694beba$export$322f102bec719b22.prototype, "attack", void 0);
(0, $gztBd.__decorate)([
    (0, $hLrAi.timeRange)(0)
], $57321b1dc694beba$export$322f102bec719b22.prototype, "release", void 0);

});


parcelRegister("dvGZu", function(module, exports) {
$parcel$export(module.exports, "Loop", () => (parcelRequire("iilfj")).Loop);
parcelRequire("iilfj");
parcelRequire("6O0UR");
parcelRequire("e8Qn8");
parcelRequire("IshZW");
parcelRequire("jtMjc");

});
parcelRegister("iilfj", function(module, exports) {

$parcel$export(module.exports, "Loop", () => $d51a637337c0cee9$export$550acbd06a1f5a6a);

var $jtMjc = parcelRequire("jtMjc");

var $lXP1H = parcelRequire("lXP1H");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $d51a637337c0cee9$export$550acbd06a1f5a6a extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($d51a637337c0cee9$export$550acbd06a1f5a6a.getDefaults(), arguments, [
            "callback",
            "interval"
        ]));
        this.name = "Loop";
        const options = (0, $l4RVz.optionsFromArguments)($d51a637337c0cee9$export$550acbd06a1f5a6a.getDefaults(), arguments, [
            "callback",
            "interval"
        ]);
        this._event = new (0, $jtMjc.ToneEvent)({
            context: this.context,
            callback: this._tick.bind(this),
            loop: true,
            loopEnd: options.interval,
            playbackRate: options.playbackRate,
            probability: options.probability
        });
        this.callback = options.callback;
        // set the iterations
        this.iterations = options.iterations;
    }
    static getDefaults() {
        return Object.assign((0, $lXP1H.ToneWithContext).getDefaults(), {
            interval: "4n",
            callback: (0, $AD7W4.noOp),
            playbackRate: 1,
            iterations: Infinity,
            probability: 1,
            mute: false,
            humanize: false
        });
    }
    /**
     * Start the loop at the specified time along the Transport's timeline.
     * @param  time  When to start the Loop.
     */ start(time) {
        this._event.start(time);
        return this;
    }
    /**
     * Stop the loop at the given time.
     * @param  time  When to stop the Loop.
     */ stop(time) {
        this._event.stop(time);
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        this._event.cancel(time);
        return this;
    }
    /**
     * Internal function called when the notes should be called
     * @param time  The time the event occurs
     */ _tick(time) {
        this.callback(time);
    }
    /**
     * The state of the Loop, either started or stopped.
     */ get state() {
        return this._event.state;
    }
    /**
     * The progress of the loop as a value between 0-1. 0, when the loop is stopped or done iterating.
     */ get progress() {
        return this._event.progress;
    }
    /**
     * The time between successive callbacks.
     * @example
     * const loop = new Tone.Loop();
     * loop.interval = "8n"; // loop every 8n
     */ get interval() {
        return this._event.loopEnd;
    }
    set interval(interval) {
        this._event.loopEnd = interval;
    }
    /**
     * The playback rate of the loop. The normal playback rate is 1 (no change).
     * A `playbackRate` of 2 would be twice as fast.
     */ get playbackRate() {
        return this._event.playbackRate;
    }
    set playbackRate(rate) {
        this._event.playbackRate = rate;
    }
    /**
     * Random variation +/-0.01s to the scheduled time.
     * Or give it a time value which it will randomize by.
     */ get humanize() {
        return this._event.humanize;
    }
    set humanize(variation) {
        this._event.humanize = variation;
    }
    /**
     * The probably of the callback being invoked.
     */ get probability() {
        return this._event.probability;
    }
    set probability(prob) {
        this._event.probability = prob;
    }
    /**
     * Muting the Loop means that no callbacks are invoked.
     */ get mute() {
        return this._event.mute;
    }
    set mute(mute) {
        this._event.mute = mute;
    }
    /**
     * The number of iterations of the loop. The default value is `Infinity` (loop forever).
     */ get iterations() {
        if (this._event.loop === true) return Infinity;
        else return this._event.loop;
    }
    set iterations(iters) {
        if (iters === Infinity) this._event.loop = true;
        else this._event.loop = iters;
    }
    dispose() {
        super.dispose();
        this._event.dispose();
        return this;
    }
}

});
parcelRegister("jtMjc", function(module, exports) {

$parcel$export(module.exports, "ToneEvent", () => $e2e632d7d02b3339$export$f99f73502b006764);
parcelRequire("9UqGS");

var $lXP1H = parcelRequire("lXP1H");

var $a5kVC = parcelRequire("a5kVC");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $4nQXi = parcelRequire("4nQXi");

var $lQ01C = parcelRequire("lQ01C");
class $e2e632d7d02b3339$export$f99f73502b006764 extends (0, $lXP1H.ToneWithContext) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e2e632d7d02b3339$export$f99f73502b006764.getDefaults(), arguments, [
            "callback",
            "value"
        ]));
        this.name = "ToneEvent";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $4nQXi.StateTimeline)("stopped");
        /**
         * A delay time from when the event is scheduled to start
         */ this._startOffset = 0;
        const options = (0, $l4RVz.optionsFromArguments)($e2e632d7d02b3339$export$f99f73502b006764.getDefaults(), arguments, [
            "callback",
            "value"
        ]);
        this._loop = options.loop;
        this.callback = options.callback;
        this.value = options.value;
        this._loopStart = this.toTicks(options.loopStart);
        this._loopEnd = this.toTicks(options.loopEnd);
        this._playbackRate = options.playbackRate;
        this._probability = options.probability;
        this._humanize = options.humanize;
        this.mute = options.mute;
        this._playbackRate = options.playbackRate;
        this._state.increasing = true;
        // schedule the events for the first time
        this._rescheduleEvents();
    }
    static getDefaults() {
        return Object.assign((0, $lXP1H.ToneWithContext).getDefaults(), {
            callback: (0, $AD7W4.noOp),
            humanize: false,
            loop: false,
            loopEnd: "1m",
            loopStart: 0,
            mute: false,
            playbackRate: 1,
            probability: 1,
            value: null
        });
    }
    /**
     * Reschedule all of the events along the timeline
     * with the updated values.
     * @param after Only reschedules events after the given time.
     */ _rescheduleEvents(after = -1) {
        // if no argument is given, schedules all of the events
        this._state.forEachFrom(after, (event)=>{
            let duration;
            if (event.state === "started") {
                if (event.id !== -1) this.context.transport.clear(event.id);
                const startTick = event.time + Math.round(this.startOffset / this._playbackRate);
                if (this._loop === true || (0, $lQ01C.isNumber)(this._loop) && this._loop > 1) {
                    duration = Infinity;
                    if ((0, $lQ01C.isNumber)(this._loop)) duration = this._loop * this._getLoopDuration();
                    const nextEvent = this._state.getAfter(startTick);
                    if (nextEvent !== null) duration = Math.min(duration, nextEvent.time - startTick);
                    if (duration !== Infinity) {
                        // schedule a stop since it's finite duration
                        this._state.setStateAtTime("stopped", startTick + duration + 1, {
                            id: -1
                        });
                        duration = new (0, $a5kVC.TicksClass)(this.context, duration);
                    }
                    const interval = new (0, $a5kVC.TicksClass)(this.context, this._getLoopDuration());
                    event.id = this.context.transport.scheduleRepeat(this._tick.bind(this), interval, new (0, $a5kVC.TicksClass)(this.context, startTick), duration);
                } else event.id = this.context.transport.schedule(this._tick.bind(this), new (0, $a5kVC.TicksClass)(this.context, startTick));
            }
        });
    }
    /**
     * Returns the playback state of the note, either "started" or "stopped".
     */ get state() {
        return this._state.getValueAtTime(this.context.transport.ticks);
    }
    /**
     * The start from the scheduled start time.
     */ get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
    }
    /**
     * The probability of the notes being triggered.
     */ get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
    }
    /**
     * If set to true, will apply small random variation
     * to the callback time. If the value is given as a time, it will randomize
     * by that amount.
     * @example
     * const event = new Tone.ToneEvent();
     * event.humanize = true;
     */ get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
    }
    /**
     * Start the note at the given time.
     * @param  time  When the event should start.
     */ start(time) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "stopped") {
            this._state.add({
                id: -1,
                state: "started",
                time: ticks
            });
            this._rescheduleEvents(ticks);
        }
        return this;
    }
    /**
     * Stop the Event at the given time.
     * @param  time  When the event should stop.
     */ stop(time) {
        this.cancel(time);
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "started") {
            this._state.setStateAtTime("stopped", ticks, {
                id: -1
            });
            const previousEvent = this._state.getBefore(ticks);
            let reschedulTime = ticks;
            if (previousEvent !== null) reschedulTime = previousEvent.time;
            this._rescheduleEvents(reschedulTime);
        }
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        time = (0, $l4RVz.defaultArg)(time, -Infinity);
        const ticks = this.toTicks(time);
        this._state.forEachFrom(ticks, (event)=>{
            this.context.transport.clear(event.id);
        });
        this._state.cancel(ticks);
        return this;
    }
    /**
     * The callback function invoker. Also
     * checks if the Event is done playing
     * @param  time  The time of the event in seconds
     */ _tick(time) {
        const ticks = this.context.transport.getTicksAtTime(time);
        if (!this.mute && this._state.getValueAtTime(ticks) === "started") {
            if (this.probability < 1 && Math.random() > this.probability) return;
            if (this.humanize) {
                let variation = 0.02;
                if (!(0, $lQ01C.isBoolean)(this.humanize)) variation = this.toSeconds(this.humanize);
                time += (Math.random() * 2 - 1) * variation;
            }
            this.callback(time, this.value);
        }
    }
    /**
     * Get the duration of the loop.
     */ _getLoopDuration() {
        return Math.round((this._loopEnd - this._loopStart) / this._playbackRate);
    }
    /**
     * If the note should loop or not
     * between ToneEvent.loopStart and
     * ToneEvent.loopEnd. If set to true,
     * the event will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._rescheduleEvents();
    }
    /**
     * The playback rate of the note. Defaults to 1.
     * @example
     * const note = new Tone.ToneEvent();
     * note.loop = true;
     * // repeat the note twice as fast
     * note.playbackRate = 2;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._rescheduleEvents();
    }
    /**
     * The loopEnd point is the time the event will loop
     * if ToneEvent.loop is true.
     */ get loopEnd() {
        return new (0, $a5kVC.TicksClass)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The time when the loop should start.
     */ get loopStart() {
        return new (0, $a5kVC.TicksClass)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The current progress of the loop interval.
     * Returns 0 if the event is not started yet or
     * it is not set to loop.
     */ get progress() {
        if (this._loop) {
            const ticks = this.context.transport.ticks;
            const lastEvent = this._state.get(ticks);
            if (lastEvent !== null && lastEvent.state === "started") {
                const loopDuration = this._getLoopDuration();
                const progress = (ticks - lastEvent.time) % loopDuration;
                return progress / loopDuration;
            } else return 0;
        } else return 0;
    }
    dispose() {
        super.dispose();
        this.cancel();
        this._state.dispose();
        return this;
    }
}

});


parcelRegister("6O0UR", function(module, exports) {

$parcel$export(module.exports, "Part", () => $4f481f7d4467bd4b$export$7b5bf7981d51054e);

var $a5kVC = parcelRequire("a5kVC");

var $31EKY = parcelRequire("31EKY");

var $l4RVz = parcelRequire("l4RVz");

var $4nQXi = parcelRequire("4nQXi");

var $lQ01C = parcelRequire("lQ01C");

var $jtMjc = parcelRequire("jtMjc");
class $4f481f7d4467bd4b$export$7b5bf7981d51054e extends (0, $jtMjc.ToneEvent) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($4f481f7d4467bd4b$export$7b5bf7981d51054e.getDefaults(), arguments, [
            "callback",
            "events"
        ]));
        this.name = "Part";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $4nQXi.StateTimeline)("stopped");
        /**
         * The events that belong to this part
         */ this._events = new Set();
        const options = (0, $l4RVz.optionsFromArguments)($4f481f7d4467bd4b$export$7b5bf7981d51054e.getDefaults(), arguments, [
            "callback",
            "events"
        ]);
        // make sure things are assigned in the right order
        this._state.increasing = true;
        // add the events
        options.events.forEach((event)=>{
            if ((0, $lQ01C.isArray)(event)) this.add(event[0], event[1]);
            else this.add(event);
        });
    }
    static getDefaults() {
        return Object.assign((0, $jtMjc.ToneEvent).getDefaults(), {
            events: []
        });
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset from the start of the part to begin playing at.
     */ start(time, offset) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) !== "started") {
            offset = (0, $l4RVz.defaultArg)(offset, this._loop ? this._loopStart : 0);
            if (this._loop) offset = (0, $l4RVz.defaultArg)(offset, this._loopStart);
            else offset = (0, $l4RVz.defaultArg)(offset, 0);
            const computedOffset = this.toTicks(offset);
            this._state.add({
                id: -1,
                offset: computedOffset,
                state: "started",
                time: ticks
            });
            this._forEach((event)=>{
                this._startNote(event, ticks, computedOffset);
            });
        }
        return this;
    }
    /**
     * Start the event in the given event at the correct time given
     * the ticks and offset and looping.
     * @param  event
     * @param  ticks
     * @param  offset
     */ _startNote(event, ticks, offset) {
        ticks -= offset;
        if (this._loop) {
            if (event.startOffset >= this._loopStart && event.startOffset < this._loopEnd) {
                if (event.startOffset < offset) // start it on the next loop
                ticks += this._getLoopDuration();
                event.start(new (0, $a5kVC.TicksClass)(this.context, ticks));
            } else if (event.startOffset < this._loopStart && event.startOffset >= offset) {
                event.loop = false;
                event.start(new (0, $a5kVC.TicksClass)(this.context, ticks));
            }
        } else if (event.startOffset >= offset) event.start(new (0, $a5kVC.TicksClass)(this.context, ticks));
    }
    get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
        this._forEach((event)=>{
            event.startOffset += this._startOffset;
        });
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        const ticks = this.toTicks(time);
        this._state.cancel(ticks);
        this._state.setStateAtTime("stopped", ticks);
        this._forEach((event)=>{
            event.stop(time);
        });
        return this;
    }
    /**
     * Get/Set an Event's value at the given time.
     * If a value is passed in and no event exists at
     * the given time, one will be created with that value.
     * If two events are at the same time, the first one will
     * be returned.
     * @example
     * const part = new Tone.Part();
     * part.at("1m"); // returns the part at the first measure
     * part.at("2m", "C2"); // set the value at "2m" to C2.
     * // if an event didn't exist at that time, it will be created.
     * @param time The time of the event to get or set.
     * @param value If a value is passed in, the value of the event at the given time will be set to it.
     */ at(time, value) {
        const timeInTicks = new (0, $31EKY.TransportTimeClass)(this.context, time).toTicks();
        const tickTime = new (0, $a5kVC.TicksClass)(this.context, 1).toSeconds();
        const iterator = this._events.values();
        let result = iterator.next();
        while(!result.done){
            const event = result.value;
            if (Math.abs(timeInTicks - event.startOffset) < tickTime) {
                if ((0, $lQ01C.isDefined)(value)) event.value = value;
                return event;
            }
            result = iterator.next();
        }
        // if there was no event at that time, create one
        if ((0, $lQ01C.isDefined)(value)) {
            this.add(time, value);
            // return the new event
            return this.at(time);
        } else return null;
    }
    add(time, value) {
        // extract the parameters
        if (time instanceof Object && Reflect.has(time, "time")) {
            value = time;
            time = value.time;
        }
        const ticks = this.toTicks(time);
        let event;
        if (value instanceof (0, $jtMjc.ToneEvent)) {
            event = value;
            event.callback = this._tick.bind(this);
        } else event = new (0, $jtMjc.ToneEvent)({
            callback: this._tick.bind(this),
            context: this.context,
            value: value
        });
        // the start offset
        event.startOffset = ticks;
        // initialize the values
        event.set({
            humanize: this.humanize,
            loop: this.loop,
            loopEnd: this.loopEnd,
            loopStart: this.loopStart,
            playbackRate: this.playbackRate,
            probability: this.probability
        });
        this._events.add(event);
        // start the note if it should be played right now
        this._restartEvent(event);
        return this;
    }
    /**
     * Restart the given event
     */ _restartEvent(event) {
        this._state.forEach((stateEvent)=>{
            if (stateEvent.state === "started") this._startNote(event, stateEvent.time, stateEvent.offset);
            else // stop the note
            event.stop(new (0, $a5kVC.TicksClass)(this.context, stateEvent.time));
        });
    }
    remove(time, value) {
        // extract the parameters
        if ((0, $lQ01C.isObject)(time) && time.hasOwnProperty("time")) {
            value = time;
            time = value.time;
        }
        time = this.toTicks(time);
        this._events.forEach((event)=>{
            if (event.startOffset === time) {
                if ((0, $lQ01C.isUndef)(value) || (0, $lQ01C.isDefined)(value) && event.value === value) {
                    this._events.delete(event);
                    event.dispose();
                }
            }
        });
        return this;
    }
    /**
     * Remove all of the notes from the group.
     */ clear() {
        this._forEach((event)=>event.dispose());
        this._events.clear();
        return this;
    }
    /**
     * Cancel scheduled state change events: i.e. "start" and "stop".
     * @param after The time after which to cancel the scheduled events.
     */ cancel(after) {
        this._forEach((event)=>event.cancel(after));
        this._state.cancel(this.toTicks(after));
        return this;
    }
    /**
     * Iterate over all of the events
     */ _forEach(callback) {
        if (this._events) this._events.forEach((event)=>{
            if (event instanceof $4f481f7d4467bd4b$export$7b5bf7981d51054e) event._forEach(callback);
            else callback(event);
        });
        return this;
    }
    /**
     * Set the attribute of all of the events
     * @param  attr  the attribute to set
     * @param  value      The value to set it to
     */ _setAll(attr, value) {
        this._forEach((event)=>{
            event[attr] = value;
        });
    }
    /**
     * Internal tick method
     * @param  time  The time of the event in seconds
     */ _tick(time, value) {
        if (!this.mute) this.callback(time, value);
    }
    /**
     * Determine if the event should be currently looping
     * given the loop boundries of this Part.
     * @param  event  The event to test
     */ _testLoopBoundries(event) {
        if (this._loop && (event.startOffset < this._loopStart || event.startOffset >= this._loopEnd)) event.cancel(0);
        else if (event.state === "stopped") // reschedule it if it's stopped
        this._restartEvent(event);
    }
    get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
        this._setAll("probability", prob);
    }
    get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
        this._setAll("humanize", variation);
    }
    /**
     * If the part should loop or not
     * between Part.loopStart and
     * Part.loopEnd. If set to true,
     * the part will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     * @example
     * const part = new Tone.Part();
     * // loop the part 8 times
     * part.loop = 8;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._forEach((event)=>{
            event.loopStart = this.loopStart;
            event.loopEnd = this.loopEnd;
            event.loop = loop;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopEnd point determines when it will
     * loop if Part.loop is true.
     */ get loopEnd() {
        return new (0, $a5kVC.TicksClass)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._forEach((event)=>{
            event.loopEnd = loopEnd;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopStart point determines when it will
     * loop if Part.loop is true.
     */ get loopStart() {
        return new (0, $a5kVC.TicksClass)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._forEach((event)=>{
            event.loopStart = this.loopStart;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The playback rate of the part
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._setAll("playbackRate", rate);
    }
    /**
     * The number of scheduled notes in the part.
     */ get length() {
        return this._events.size;
    }
    dispose() {
        super.dispose();
        this.clear();
        return this;
    }
}

});

parcelRegister("e8Qn8", function(module, exports) {

var $iilfj = parcelRequire("iilfj");

var $WUFtN = parcelRequire("WUFtN");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $a4ba7010db593d3a$export$47606a6ae3eaed8e extends (0, $iilfj.Loop) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($a4ba7010db593d3a$export$47606a6ae3eaed8e.getDefaults(), arguments, [
            "callback",
            "values",
            "pattern"
        ]));
        this.name = "Pattern";
        const options = (0, $l4RVz.optionsFromArguments)($a4ba7010db593d3a$export$47606a6ae3eaed8e.getDefaults(), arguments, [
            "callback",
            "values",
            "pattern"
        ]);
        this.callback = options.callback;
        this._values = options.values;
        this._pattern = (0, $WUFtN.PatternGenerator)(options.values, options.pattern);
        this._type = options.pattern;
    }
    static getDefaults() {
        return Object.assign((0, $iilfj.Loop).getDefaults(), {
            pattern: "up",
            values: [],
            callback: (0, $AD7W4.noOp)
        });
    }
    /**
     * Internal function called when the notes should be called
     */ _tick(time) {
        const value = this._pattern.next();
        this._value = value.value;
        this.callback(time, this._value);
    }
    /**
     * The array of events.
     */ get values() {
        return this._values;
    }
    set values(val) {
        this._values = val;
        // reset the pattern
        this.pattern = this._type;
    }
    /**
     * The current value of the pattern.
     */ get value() {
        return this._value;
    }
    /**
     * The pattern type. See Tone.CtrlPattern for the full list of patterns.
     */ get pattern() {
        return this._type;
    }
    set pattern(pattern) {
        this._type = pattern;
        this._pattern = (0, $WUFtN.PatternGenerator)(this._values, this._type);
    }
}

});
parcelRegister("WUFtN", function(module, exports) {

$parcel$export(module.exports, "PatternGenerator", () => $0b115ffbd5e71ea3$export$891c3c0ea1af078a);

var $6Utwn = parcelRequire("6Utwn");

var $j4WGs = parcelRequire("j4WGs");
/**
 * Start at the first value and go up to the last
 */ function* $0b115ffbd5e71ea3$var$upPatternGen(values) {
    let index = 0;
    while(index < values.length){
        index = $0b115ffbd5e71ea3$var$clampToArraySize(index, values);
        yield values[index];
        index++;
    }
}
/**
 * Start at the last value and go down to 0
 */ function* $0b115ffbd5e71ea3$var$downPatternGen(values) {
    let index = values.length - 1;
    while(index >= 0){
        index = $0b115ffbd5e71ea3$var$clampToArraySize(index, values);
        yield values[index];
        index--;
    }
}
/**
 * Infinitely yield the generator
 */ function* $0b115ffbd5e71ea3$var$infiniteGen(values, gen) {
    while(true)yield* gen(values);
}
/**
 * Make sure that the index is in the given range
 */ function $0b115ffbd5e71ea3$var$clampToArraySize(index, values) {
    return (0, $j4WGs.clamp)(index, 0, values.length - 1);
}
/**
 * Alternate between two generators
 */ function* $0b115ffbd5e71ea3$var$alternatingGenerator(values, directionUp) {
    let index = directionUp ? 0 : values.length - 1;
    while(true){
        index = $0b115ffbd5e71ea3$var$clampToArraySize(index, values);
        yield values[index];
        if (directionUp) {
            index++;
            if (index >= values.length - 1) directionUp = false;
        } else {
            index--;
            if (index <= 0) directionUp = true;
        }
    }
}
/**
 * Starting from the bottom move up 2, down 1
 */ function* $0b115ffbd5e71ea3$var$jumpUp(values) {
    let index = 0;
    let stepIndex = 0;
    while(index < values.length){
        index = $0b115ffbd5e71ea3$var$clampToArraySize(index, values);
        yield values[index];
        stepIndex++;
        index += stepIndex % 2 ? 2 : -1;
    }
}
/**
 * Starting from the top move down 2, up 1
 */ function* $0b115ffbd5e71ea3$var$jumpDown(values) {
    let index = values.length - 1;
    let stepIndex = 0;
    while(index >= 0){
        index = $0b115ffbd5e71ea3$var$clampToArraySize(index, values);
        yield values[index];
        stepIndex++;
        index += stepIndex % 2 ? -2 : 1;
    }
}
/**
 * Choose a random index each time
 */ function* $0b115ffbd5e71ea3$var$randomGen(values) {
    while(true){
        const randomIndex = Math.floor(Math.random() * values.length);
        yield values[randomIndex];
    }
}
/**
 * Randomly go through all of the values once before choosing a new random order
 */ function* $0b115ffbd5e71ea3$var$randomOnce(values) {
    // create an array of indices
    const copy = [];
    for(let i = 0; i < values.length; i++)copy.push(i);
    while(copy.length > 0){
        // random choose an index, and then remove it so it's not chosen again
        const randVal = copy.splice(Math.floor(copy.length * Math.random()), 1);
        const index = $0b115ffbd5e71ea3$var$clampToArraySize(randVal[0], values);
        yield values[index];
    }
}
/**
 * Randomly choose to walk up or down 1 index in the values array
 */ function* $0b115ffbd5e71ea3$var$randomWalk(values) {
    // randomly choose a starting index in the values array
    let index = Math.floor(Math.random() * values.length);
    while(true){
        if (index === 0) index++; // at bottom of array, so force upward step
        else if (index === values.length - 1) index--; // at top of array, so force downward step
        else if (Math.random() < 0.5) index--;
        else index++;
        yield values[index];
    }
}
function* $0b115ffbd5e71ea3$export$891c3c0ea1af078a(values, pattern = "up", index = 0) {
    // safeguards
    (0, $6Utwn.assert)(values.length > 0, "The array must have more than one value in it");
    switch(pattern){
        case "up":
            yield* $0b115ffbd5e71ea3$var$infiniteGen(values, $0b115ffbd5e71ea3$var$upPatternGen);
        case "down":
            yield* $0b115ffbd5e71ea3$var$infiniteGen(values, $0b115ffbd5e71ea3$var$downPatternGen);
        case "upDown":
            yield* $0b115ffbd5e71ea3$var$alternatingGenerator(values, true);
        case "downUp":
            yield* $0b115ffbd5e71ea3$var$alternatingGenerator(values, false);
        case "alternateUp":
            yield* $0b115ffbd5e71ea3$var$infiniteGen(values, $0b115ffbd5e71ea3$var$jumpUp);
        case "alternateDown":
            yield* $0b115ffbd5e71ea3$var$infiniteGen(values, $0b115ffbd5e71ea3$var$jumpDown);
        case "random":
            yield* $0b115ffbd5e71ea3$var$randomGen(values);
        case "randomOnce":
            yield* $0b115ffbd5e71ea3$var$infiniteGen(values, $0b115ffbd5e71ea3$var$randomOnce);
        case "randomWalk":
            yield* $0b115ffbd5e71ea3$var$randomWalk(values);
    }
}

});


parcelRegister("IshZW", function(module, exports) {

var $a5kVC = parcelRequire("a5kVC");

var $l4RVz = parcelRequire("l4RVz");

var $lQ01C = parcelRequire("lQ01C");

var $6O0UR = parcelRequire("6O0UR");

var $jtMjc = parcelRequire("jtMjc");
class $085a0dd6dc4c6ae9$export$edde1bcb1b2b310e extends (0, $jtMjc.ToneEvent) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($085a0dd6dc4c6ae9$export$edde1bcb1b2b310e.getDefaults(), arguments, [
            "callback",
            "events",
            "subdivision"
        ]));
        this.name = "Sequence";
        /**
         * The object responsible for scheduling all of the events
         */ this._part = new (0, $6O0UR.Part)({
            callback: this._seqCallback.bind(this),
            context: this.context
        });
        /**
         * private reference to all of the sequence proxies
         */ this._events = [];
        /**
         * The proxied array
         */ this._eventsArray = [];
        const options = (0, $l4RVz.optionsFromArguments)($085a0dd6dc4c6ae9$export$edde1bcb1b2b310e.getDefaults(), arguments, [
            "callback",
            "events",
            "subdivision"
        ]);
        this._subdivision = this.toTicks(options.subdivision);
        this.events = options.events;
        // set all of the values
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.playbackRate = options.playbackRate;
        this.probability = options.probability;
        this.humanize = options.humanize;
        this.mute = options.mute;
        this.playbackRate = options.playbackRate;
    }
    static getDefaults() {
        return Object.assign((0, $l4RVz.omitFromObject)((0, $jtMjc.ToneEvent).getDefaults(), [
            "value"
        ]), {
            events: [],
            loop: true,
            loopEnd: 0,
            loopStart: 0,
            subdivision: "8n"
        });
    }
    /**
     * The internal callback for when an event is invoked
     */ _seqCallback(time, value) {
        if (value !== null) this.callback(time, value);
    }
    /**
     * The sequence
     */ get events() {
        return this._events;
    }
    set events(s) {
        this.clear();
        this._eventsArray = s;
        this._events = this._createSequence(this._eventsArray);
        this._eventsUpdated();
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset index to start at
     */ start(time, offset) {
        this._part.start(time, offset ? this._indexTime(offset) : offset);
        return this;
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        this._part.stop(time);
        return this;
    }
    /**
     * The subdivision of the sequence. This can only be
     * set in the constructor. The subdivision is the
     * interval between successive steps.
     */ get subdivision() {
        return new (0, $a5kVC.TicksClass)(this.context, this._subdivision).toSeconds();
    }
    /**
     * Create a sequence proxy which can be monitored to create subsequences
     */ _createSequence(array) {
        return new Proxy(array, {
            get: (target, property)=>{
                // property is index in this case
                return target[property];
            },
            set: (target, property, value)=>{
                if ((0, $lQ01C.isString)(property) && isFinite(parseInt(property, 10))) {
                    if ((0, $lQ01C.isArray)(value)) target[property] = this._createSequence(value);
                    else target[property] = value;
                } else target[property] = value;
                this._eventsUpdated();
                // return true to accept the changes
                return true;
            }
        });
    }
    /**
     * When the sequence has changed, all of the events need to be recreated
     */ _eventsUpdated() {
        this._part.clear();
        this._rescheduleSequence(this._eventsArray, this._subdivision, this.startOffset);
        // update the loopEnd
        this.loopEnd = this.loopEnd;
    }
    /**
     * reschedule all of the events that need to be rescheduled
     */ _rescheduleSequence(sequence, subdivision, startOffset) {
        sequence.forEach((value, index)=>{
            const eventOffset = index * subdivision + startOffset;
            if ((0, $lQ01C.isArray)(value)) this._rescheduleSequence(value, subdivision / value.length, eventOffset);
            else {
                const startTime = new (0, $a5kVC.TicksClass)(this.context, eventOffset, "i").toSeconds();
                this._part.add(startTime, value);
            }
        });
    }
    /**
     * Get the time of the index given the Sequence's subdivision
     * @param  index
     * @return The time of that index
     */ _indexTime(index) {
        return new (0, $a5kVC.TicksClass)(this.context, index * this._subdivision + this.startOffset).toSeconds();
    }
    /**
     * Clear all of the events
     */ clear() {
        this._part.clear();
        return this;
    }
    dispose() {
        super.dispose();
        this._part.dispose();
        return this;
    }
    //-------------------------------------
    // PROXY CALLS
    //-------------------------------------
    get loop() {
        return this._part.loop;
    }
    set loop(l) {
        this._part.loop = l;
    }
    /**
     * The index at which the sequence should start looping
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(index) {
        this._loopStart = index;
        this._part.loopStart = this._indexTime(index);
    }
    /**
     * The index at which the sequence should end looping
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(index) {
        this._loopEnd = index;
        if (index === 0) this._part.loopEnd = this._indexTime(this._eventsArray.length);
        else this._part.loopEnd = this._indexTime(index);
    }
    get startOffset() {
        return this._part.startOffset;
    }
    set startOffset(start) {
        this._part.startOffset = start;
    }
    get playbackRate() {
        return this._part.playbackRate;
    }
    set playbackRate(rate) {
        this._part.playbackRate = rate;
    }
    get probability() {
        return this._part.probability;
    }
    set probability(prob) {
        this._part.probability = prob;
    }
    get progress() {
        return this._part.progress;
    }
    get humanize() {
        return this._part.humanize;
    }
    set humanize(variation) {
        this._part.humanize = variation;
    }
    /**
     * The number of scheduled events
     */ get length() {
        return this._part.length;
    }
}

});


parcelRegister("6WaTy", function(module, exports) {
$parcel$export(module.exports, "Distortion", () => (parcelRequire("1ZLI2")).Distortion);
$parcel$export(module.exports, "FeedbackDelay", () => (parcelRequire("gtyBS")).FeedbackDelay);
$parcel$export(module.exports, "PitchShift", () => (parcelRequire("e3S5U")).PitchShift);
$parcel$export(module.exports, "Reverb", () => (parcelRequire("7FIGc")).Reverb);
parcelRequire("gCb4B");
parcelRequire("liQaL");
parcelRequire("faBnt");
parcelRequire("5Eglc");
parcelRequire("D8QaL");
parcelRequire("8PtHk");
parcelRequire("1ZLI2");
parcelRequire("gtyBS");
parcelRequire("bBfFC");
parcelRequire("8b9Pm");
parcelRequire("gpbNO");
parcelRequire("hFvFN");
parcelRequire("e3S5U");
parcelRequire("jjlIu");
parcelRequire("7FIGc");
parcelRequire("7YzFO");
parcelRequire("1mjXL");
parcelRequire("km71R");

});
parcelRegister("gCb4B", function(module, exports) {

var $82Hwq = parcelRequire("82Hwq");

var $l4RVz = parcelRequire("l4RVz");

var $i9sDT = parcelRequire("i9sDT");
class $c188c8db5bfec555$export$b80f807aa51d8d02 extends (0, $i9sDT.LFOEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($c188c8db5bfec555$export$b80f807aa51d8d02.getDefaults(), arguments, [
            "frequency",
            "baseFrequency",
            "octaves"
        ]));
        this.name = "AutoFilter";
        const options = (0, $l4RVz.optionsFromArguments)($c188c8db5bfec555$export$b80f807aa51d8d02.getDefaults(), arguments, [
            "frequency",
            "baseFrequency",
            "octaves"
        ]);
        this.filter = new (0, $82Hwq.Filter)(Object.assign(options.filter, {
            context: this.context
        }));
        // connections
        this.connectEffect(this.filter);
        this._lfo.connect(this.filter.frequency);
        this.octaves = options.octaves;
        this.baseFrequency = options.baseFrequency;
    }
    static getDefaults() {
        return Object.assign((0, $i9sDT.LFOEffect).getDefaults(), {
            baseFrequency: 200,
            octaves: 2.6,
            filter: {
                type: "lowpass",
                rolloff: -12,
                Q: 1
            }
        });
    }
    /**
     * The minimum value of the filter's cutoff frequency.
     */ get baseFrequency() {
        return this._lfo.min;
    }
    set baseFrequency(freq) {
        this._lfo.min = this.toFrequency(freq);
        // and set the max
        this.octaves = this._octaves;
    }
    /**
     * The maximum value of the filter's cutoff frequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(oct) {
        this._octaves = oct;
        this._lfo.max = this._lfo.min * Math.pow(2, oct);
    }
    dispose() {
        super.dispose();
        this.filter.dispose();
        return this;
    }
}

});
parcelRegister("i9sDT", function(module, exports) {

$parcel$export(module.exports, "LFOEffect", () => $d36f49128240b05b$export$de224a2741e4b2f8);

var $hadR5 = parcelRequire("hadR5");

var $lNxm0 = parcelRequire("lNxm0");

var $AD7W4 = parcelRequire("AD7W4");
class $d36f49128240b05b$export$de224a2741e4b2f8 extends (0, $hadR5.Effect) {
    constructor(options){
        super(options);
        this.name = "LFOEffect";
        this._lfo = new (0, $lNxm0.LFO)({
            context: this.context,
            frequency: options.frequency,
            amplitude: options.depth
        });
        this.depth = this._lfo.amplitude;
        this.frequency = this._lfo.frequency;
        this.type = options.type;
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "depth"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            frequency: 1,
            type: "sine",
            depth: 1
        });
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfo.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfo.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport. See [[LFO.sync]]
     */ sync() {
        this._lfo.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfo.unsync();
        return this;
    }
    /**
     * The type of the LFO's oscillator: See [[Oscillator.type]]
     * @example
     * const autoFilter = new Tone.AutoFilter().start().toDestination();
     * const noise = new Tone.Noise().start().connect(autoFilter);
     * autoFilter.type = "square";
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}

});
parcelRegister("hadR5", function(module, exports) {

$parcel$export(module.exports, "Effect", () => $c7ee1e3284e81884$export$a32b0b1c1ac59d04);

var $4n30O = parcelRequire("4n30O");

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $AD7W4 = parcelRequire("AD7W4");
class $c7ee1e3284e81884$export$a32b0b1c1ac59d04 extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = "Effect";
        /**
         * the drywet knob to control the amount of effect
         */ this._dryWet = new (0, $4n30O.CrossFade)({
            context: this.context
        });
        /**
         * The wet control is how much of the effected
         * will pass through to the output. 1 = 100% effected
         * signal, 0 = 100% dry signal.
         */ this.wet = this._dryWet.fade;
        /**
         * connect the effectSend to the input of hte effect
         */ this.effectSend = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * connect the output of the effect to the effectReturn
         */ this.effectReturn = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The effect input node
         */ this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The effect output
         */ this.output = this._dryWet;
        // connections
        this.input.fan(this._dryWet.a, this.effectSend);
        this.effectReturn.connect(this._dryWet.b);
        this.wet.setValueAtTime(options.wet, 0);
        this._internalChannels = [
            this.effectReturn,
            this.effectSend
        ];
        (0, $AD7W4.readOnly)(this, "wet");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            wet: 1
        });
    }
    /**
     * chains the effect in between the effectSend and effectReturn
     */ connectEffect(effect) {
        // add it to the internal channels
        this._internalChannels.push(effect);
        this.effectSend.chain(effect, this.effectReturn);
        return this;
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this.effectSend.dispose();
        this.effectReturn.dispose();
        this.wet.dispose();
        return this;
    }
}

});
parcelRegister("4n30O", function(module, exports) {

$parcel$export(module.exports, "CrossFade", () => $32eba590b3245933$export$d78c8c6074541cf2);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $7SBbL = parcelRequire("7SBbL");

var $eCi69 = parcelRequire("eCi69");
class $32eba590b3245933$export$d78c8c6074541cf2 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($32eba590b3245933$export$d78c8c6074541cf2.getDefaults(), arguments, [
            "fade"
        ])));
        this.name = "CrossFade";
        /**
         * The crossfading is done by a StereoPannerNode
         */ this._panner = this.context.createStereoPanner();
        /**
         * Split the output of the panner node into two values used to control the gains.
         */ this._split = this.context.createChannelSplitter(2);
        /**
         * Convert the fade value into an audio range value so it can be connected
         * to the panner.pan AudioParam
         */ this._g2a = new (0, $7SBbL.GainToAudio)({
            context: this.context
        });
        /**
         * The input which is at full level when fade = 0
         */ this.a = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        /**
         * The input which is at full level when fade = 1
         */ this.b = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: 0
        });
        /**
         * The output is a mix between `a` and `b` at the ratio of `fade`
         */ this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._internalChannels = [
            this.a,
            this.b
        ];
        const options = (0, $l4RVz.optionsFromArguments)($32eba590b3245933$export$d78c8c6074541cf2.getDefaults(), arguments, [
            "fade"
        ]);
        this.fade = new (0, $eCi69.Signal)({
            context: this.context,
            units: "normalRange",
            value: options.fade
        });
        (0, $AD7W4.readOnly)(this, "fade");
        this.context.getConstant(1).connect(this._panner);
        this._panner.connect(this._split);
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = 1;
        this._panner.channelCountMode = "explicit";
        (0, $fDBOr.connect)(this._split, this.a.gain, 0);
        (0, $fDBOr.connect)(this._split, this.b.gain, 1);
        this.fade.chain(this._g2a, this._panner.pan);
        this.a.connect(this.output);
        this.b.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            fade: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.a.dispose();
        this.b.dispose();
        this.output.dispose();
        this.fade.dispose();
        this._g2a.dispose();
        this._panner.disconnect();
        this._split.disconnect();
        return this;
    }
}

});




parcelRegister("liQaL", function(module, exports) {

var $32Bfc = parcelRequire("32Bfc");

var $l4RVz = parcelRequire("l4RVz");

var $i9sDT = parcelRequire("i9sDT");
class $f823bfcf45c49e5a$export$e9bd274ee70104df extends (0, $i9sDT.LFOEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($f823bfcf45c49e5a$export$e9bd274ee70104df.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "AutoPanner";
        const options = (0, $l4RVz.optionsFromArguments)($f823bfcf45c49e5a$export$e9bd274ee70104df.getDefaults(), arguments, [
            "frequency"
        ]);
        this._panner = new (0, $32Bfc.Panner)({
            context: this.context,
            channelCount: options.channelCount
        });
        // connections
        this.connectEffect(this._panner);
        this._lfo.connect(this._panner.pan);
        this._lfo.min = -1;
        this._lfo.max = 1;
    }
    static getDefaults() {
        return Object.assign((0, $i9sDT.LFOEffect).getDefaults(), {
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        return this;
    }
}

});
parcelRegister("32Bfc", function(module, exports) {

$parcel$export(module.exports, "Panner", () => $236e72e46824bd68$export$d6d7a1629e59823d);

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $236e72e46824bd68$export$d6d7a1629e59823d extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($236e72e46824bd68$export$d6d7a1629e59823d.getDefaults(), arguments, [
            "pan"
        ])));
        this.name = "Panner";
        /**
         * the panner node
         */ this._panner = this.context.createStereoPanner();
        this.input = this._panner;
        this.output = this._panner;
        const options = (0, $l4RVz.optionsFromArguments)($236e72e46824bd68$export$d6d7a1629e59823d.getDefaults(), arguments, [
            "pan"
        ]);
        this.pan = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.pan,
            value: options.pan,
            minValue: -1,
            maxValue: 1
        });
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = options.channelCount;
        this._panner.channelCountMode = "explicit";
        // initial value
        (0, $AD7W4.readOnly)(this, "pan");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            pan: 0,
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.pan.dispose();
        return this;
    }
}

});


parcelRegister("faBnt", function(module, exports) {

var $hadR5 = parcelRequire("hadR5");

var $82Hwq = parcelRequire("82Hwq");

var $blRAN = parcelRequire("blRAN");

var $l4RVz = parcelRequire("l4RVz");

var $bdbZZ = parcelRequire("bdbZZ");

var $bmU6v = parcelRequire("bmU6v");

var $9GEPW = parcelRequire("9GEPW");

var $AD7W4 = parcelRequire("AD7W4");
class $b0b4c89495ef1c99$export$7107ee8d8b759a00 extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($b0b4c89495ef1c99$export$7107ee8d8b759a00.getDefaults(), arguments, [
            "baseFrequency",
            "octaves",
            "sensitivity"
        ]));
        this.name = "AutoWah";
        const options = (0, $l4RVz.optionsFromArguments)($b0b4c89495ef1c99$export$7107ee8d8b759a00.getDefaults(), arguments, [
            "baseFrequency",
            "octaves",
            "sensitivity"
        ]);
        this._follower = new (0, $blRAN.Follower)({
            context: this.context,
            smoothing: options.follower
        });
        this._sweepRange = new (0, $9GEPW.ScaleExp)({
            context: this.context,
            min: 0,
            max: 1,
            exponent: 0.5
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this._inputBoost = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._bandpass = new (0, $82Hwq.Filter)({
            context: this.context,
            rolloff: -48,
            frequency: 0,
            Q: options.Q
        });
        this._peaking = new (0, $82Hwq.Filter)({
            context: this.context,
            type: "peaking"
        });
        this._peaking.gain.value = options.gain;
        this.gain = this._peaking.gain;
        this.Q = this._bandpass.Q;
        // the control signal path
        this.effectSend.chain(this._inputBoost, this._follower, this._sweepRange);
        this._sweepRange.connect(this._bandpass.frequency);
        this._sweepRange.connect(this._peaking.frequency);
        // the filtered path
        this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn);
        // set the initial value
        this._setSweepRange();
        this.sensitivity = options.sensitivity;
        (0, $AD7W4.readOnly)(this, [
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            baseFrequency: 100,
            octaves: 6,
            sensitivity: 0,
            Q: 2,
            gain: 2,
            follower: 0.2
        });
    }
    /**
     * The number of octaves that the filter will sweep above the baseFrequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._setSweepRange();
    }
    /**
     * The follower's smoothing time
     */ get follower() {
        return this._follower.smoothing;
    }
    set follower(follower) {
        this._follower.smoothing = follower;
    }
    /**
     * The base frequency from which the sweep will start from.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(baseFreq) {
        this._baseFrequency = this.toFrequency(baseFreq);
        this._setSweepRange();
    }
    /**
     * The sensitivity to control how responsive to the input signal the filter is.
     */ get sensitivity() {
        return (0, $bmU6v.gainToDb)(1 / this._inputBoost.gain.value);
    }
    set sensitivity(sensitivity) {
        this._inputBoost.gain.value = 1 / (0, $bmU6v.dbToGain)(sensitivity);
    }
    /**
     * sets the sweep range of the scaler
     */ _setSweepRange() {
        this._sweepRange.min = this._baseFrequency;
        this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
    }
    dispose() {
        super.dispose();
        this._follower.dispose();
        this._sweepRange.dispose();
        this._bandpass.dispose();
        this._peaking.dispose();
        this._inputBoost.dispose();
        return this;
    }
}

});
parcelRegister("blRAN", function(module, exports) {

$parcel$export(module.exports, "Follower", () => $843b3a394b3efd11$export$8ccab1ce4a46f);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $3B6kz = parcelRequire("3B6kz");

var $7t1Lk = parcelRequire("7t1Lk");
class $843b3a394b3efd11$export$8ccab1ce4a46f extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($843b3a394b3efd11$export$8ccab1ce4a46f.getDefaults(), arguments, [
            "smoothing"
        ]));
        this.name = "Follower";
        const options = (0, $l4RVz.optionsFromArguments)($843b3a394b3efd11$export$8ccab1ce4a46f.getDefaults(), arguments, [
            "smoothing"
        ]);
        this._abs = this.input = new (0, $7t1Lk.Abs)({
            context: this.context
        });
        this._lowpass = this.output = new (0, $3B6kz.OnePoleFilter)({
            context: this.context,
            frequency: 1 / this.toSeconds(options.smoothing),
            type: "lowpass"
        });
        this._abs.connect(this._lowpass);
        this._smoothing = options.smoothing;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            smoothing: 0.05
        });
    }
    /**
     * The amount of time it takes a value change to arrive at the updated value.
     */ get smoothing() {
        return this._smoothing;
    }
    set smoothing(smoothing) {
        this._smoothing = smoothing;
        this._lowpass.frequency = 1 / this.toSeconds(this.smoothing);
    }
    dispose() {
        super.dispose();
        this._abs.dispose();
        this._lowpass.dispose();
        return this;
    }
}

});


parcelRegister("5Eglc", function(module, exports) {

var $ikKDK = parcelRequire("ikKDK");

var $hadR5 = parcelRequire("hadR5");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $fDBOr = parcelRequire("fDBOr");

var $lQP4J = parcelRequire("lQP4J");

var $b0izZ = parcelRequire("b0izZ");
class $41cd5d24cc39471f$export$89e1fd5b393fbb6e extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($41cd5d24cc39471f$export$89e1fd5b393fbb6e.getDefaults(), arguments, [
            "bits"
        ]));
        this.name = "BitCrusher";
        const options = (0, $l4RVz.optionsFromArguments)($41cd5d24cc39471f$export$89e1fd5b393fbb6e.getDefaults(), arguments, [
            "bits"
        ]);
        this._bitCrusherWorklet = new $41cd5d24cc39471f$var$BitCrusherWorklet({
            context: this.context,
            bits: options.bits
        });
        // connect it up
        this.connectEffect(this._bitCrusherWorklet);
        this.bits = this._bitCrusherWorklet.bits;
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            bits: 4
        });
    }
    dispose() {
        super.dispose();
        this._bitCrusherWorklet.dispose();
        return this;
    }
}
/**
 * Internal class which creates an AudioWorklet to do the bit crushing
 */ class $41cd5d24cc39471f$var$BitCrusherWorklet extends (0, $ikKDK.ToneAudioWorklet) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($41cd5d24cc39471f$var$BitCrusherWorklet.getDefaults(), arguments));
        this.name = "BitCrusherWorklet";
        const options = (0, $l4RVz.optionsFromArguments)($41cd5d24cc39471f$var$BitCrusherWorklet.getDefaults(), arguments);
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.bits = new (0, $lQP4J.Param)({
            context: this.context,
            value: options.bits,
            units: "positive",
            minValue: 1,
            maxValue: 16,
            param: this._dummyParam,
            swappable: true
        });
    }
    static getDefaults() {
        return Object.assign((0, $ikKDK.ToneAudioWorklet).getDefaults(), {
            bits: 12
        });
    }
    _audioWorkletName() {
        return 0, $b0izZ.workletName;
    }
    onReady(node) {
        (0, $fDBOr.connectSeries)(this.input, node, this.output);
        const bits = node.parameters.get("bits");
        this.bits.setParam(bits);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.bits.dispose();
        return this;
    }
}

});
parcelRegister("b0izZ", function(module, exports) {

$parcel$export(module.exports, "workletName", () => $802e1b4df72cb1e4$export$85343ada6050a795);
parcelRequire("2As9c");

var $36iEG = parcelRequire("36iEG");
const $802e1b4df72cb1e4$export$85343ada6050a795 = "bit-crusher";
const $802e1b4df72cb1e4$export$b0b3e57880d0a354 = /* javascript */ `
	class BitCrusherWorklet extends SingleIOProcessor {

		static get parameterDescriptors() {
			return [{
				name: "bits",
				defaultValue: 12,
				minValue: 1,
				maxValue: 16,
				automationRate: 'k-rate'
			}];
		}

		generate(input, _channel, parameters) {
			const step = Math.pow(0.5, parameters.bits - 1);
			const val = step * Math.floor(input / step + 0.5);
			return val;
		}
	}
`;
(0, $36iEG.registerProcessor)($802e1b4df72cb1e4$export$85343ada6050a795, $802e1b4df72cb1e4$export$b0b3e57880d0a354);

});


parcelRegister("D8QaL", function(module, exports) {

var $hadR5 = parcelRequire("hadR5");

var $l4RVz = parcelRequire("l4RVz");

var $jAeMP = parcelRequire("jAeMP");
class $075a802ba969f713$export$9e28f5c57e778427 extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($075a802ba969f713$export$9e28f5c57e778427.getDefaults(), arguments, [
            "order"
        ]));
        this.name = "Chebyshev";
        const options = (0, $l4RVz.optionsFromArguments)($075a802ba969f713$export$9e28f5c57e778427.getDefaults(), arguments, [
            "order"
        ]);
        this._shaper = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            length: 4096
        });
        this._order = options.order;
        this.connectEffect(this._shaper);
        this.order = options.order;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            order: 1,
            oversample: "none"
        });
    }
    /**
     * get the coefficient for that degree
     * @param  x the x value
     * @param  degree
     * @param  memo memoize the computed value. this speeds up computation greatly.
     */ _getCoefficient(x, degree, memo) {
        if (memo.has(degree)) return memo.get(degree);
        else if (degree === 0) memo.set(degree, 0);
        else if (degree === 1) memo.set(degree, x);
        else memo.set(degree, 2 * x * this._getCoefficient(x, degree - 1, memo) - this._getCoefficient(x, degree - 2, memo));
        return memo.get(degree);
    }
    /**
     * The order of the Chebyshev polynomial which creates the equation which is applied to the incoming
     * signal through a Tone.WaveShaper. The equations are in the form:
     * ```
     * order 2: 2x^2 + 1
     * order 3: 4x^3 + 3x
     * ```
     * @min 1
     * @max 100
     */ get order() {
        return this._order;
    }
    set order(order) {
        this._order = order;
        this._shaper.setMap((x)=>{
            return this._getCoefficient(x, order, new Map());
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}

});

parcelRegister("8PtHk", function(module, exports) {

var $R5uRC = parcelRequire("R5uRC");

var $l4RVz = parcelRequire("l4RVz");

var $lNxm0 = parcelRequire("lNxm0");

var $eQyMC = parcelRequire("eQyMC");

var $AD7W4 = parcelRequire("AD7W4");
class $66da1f8a16968df7$export$e876320b09eb8124 extends (0, $R5uRC.StereoFeedbackEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($66da1f8a16968df7$export$e876320b09eb8124.getDefaults(), arguments, [
            "frequency",
            "delayTime",
            "depth"
        ]));
        this.name = "Chorus";
        const options = (0, $l4RVz.optionsFromArguments)($66da1f8a16968df7$export$e876320b09eb8124.getDefaults(), arguments, [
            "frequency",
            "delayTime",
            "depth"
        ]);
        this._depth = options.depth;
        this._delayTime = options.delayTime / 1000;
        this._lfoL = new (0, $lNxm0.LFO)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $lNxm0.LFO)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._delayNodeL = new (0, $eQyMC.Delay)({
            context: this.context
        });
        this._delayNodeR = new (0, $eQyMC.Delay)({
            context: this.context
        });
        this.frequency = this._lfoL.frequency;
        (0, $AD7W4.readOnly)(this, [
            "frequency"
        ]);
        // have one LFO frequency control the other
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // connections
        this.connectEffectLeft(this._delayNodeL);
        this.connectEffectRight(this._delayNodeR);
        // lfo setup
        this._lfoL.connect(this._delayNodeL.delayTime);
        this._lfoR.connect(this._delayNodeR.delayTime);
        // set the initial values
        this.depth = this._depth;
        this.type = options.type;
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $R5uRC.StereoFeedbackEffect).getDefaults(), {
            frequency: 1.5,
            delayTime: 3.5,
            depth: 0.7,
            type: "sine",
            spread: 180,
            feedback: 0,
            wet: 0.5
        });
    }
    /**
     * The depth of the effect. A depth of 1 makes the delayTime
     * modulate between 0 and 2*delayTime (centered around the delayTime).
     */ get depth() {
        return this._depth;
    }
    set depth(depth) {
        this._depth = depth;
        const deviation = this._delayTime * depth;
        this._lfoL.min = Math.max(this._delayTime - deviation, 0);
        this._lfoL.max = this._delayTime + deviation;
        this._lfoR.min = Math.max(this._delayTime - deviation, 0);
        this._lfoR.max = this._delayTime + deviation;
    }
    /**
     * The delayTime in milliseconds of the chorus. A larger delayTime
     * will give a more pronounced effect. Nominal range a delayTime
     * is between 2 and 20ms.
     */ get delayTime() {
        return this._delayTime * 1000;
    }
    set delayTime(delayTime) {
        this._delayTime = delayTime / 1000;
        this.depth = this._depth;
    }
    /**
     * The oscillator type of the LFO.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase;
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport. See [[LFO.sync]]
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        return this;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._delayNodeL.dispose();
        this._delayNodeR.dispose();
        this.frequency.dispose();
        return this;
    }
}

});
parcelRegister("R5uRC", function(module, exports) {

$parcel$export(module.exports, "StereoFeedbackEffect", () => $09f936e70eaff262$export$d911e987c738486e);

var $aX02O = parcelRequire("aX02O");

var $eCi69 = parcelRequire("eCi69");

var $bdbZZ = parcelRequire("bdbZZ");

var $AD7W4 = parcelRequire("AD7W4");

var $dhkp2 = parcelRequire("dhkp2");

var $hCZMN = parcelRequire("hCZMN");
class $09f936e70eaff262$export$d911e987c738486e extends (0, $aX02O.StereoEffect) {
    constructor(options){
        super(options);
        this.feedback = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.feedback,
            units: "normalRange"
        });
        this._feedbackL = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._feedbackR = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._feedbackSplit = new (0, $dhkp2.Split)({
            context: this.context,
            channels: 2
        });
        this._feedbackMerge = new (0, $hCZMN.Merge)({
            context: this.context,
            channels: 2
        });
        this._merge.connect(this._feedbackSplit);
        this._feedbackMerge.connect(this._split);
        // the left output connected to the left input
        this._feedbackSplit.connect(this._feedbackL, 0, 0);
        this._feedbackL.connect(this._feedbackMerge, 0, 0);
        // the right output connected to the right input
        this._feedbackSplit.connect(this._feedbackR, 1, 0);
        this._feedbackR.connect(this._feedbackMerge, 0, 1);
        // the feedback control
        this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain);
        (0, $AD7W4.readOnly)(this, [
            "feedback"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $aX02O.StereoEffect).getDefaults(), {
            feedback: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.feedback.dispose();
        this._feedbackL.dispose();
        this._feedbackR.dispose();
        this._feedbackSplit.dispose();
        this._feedbackMerge.dispose();
        return this;
    }
}

});
parcelRegister("aX02O", function(module, exports) {

$parcel$export(module.exports, "StereoEffect", () => $7f8f72e5c77c065f$export$f02761adf21def8a);

var $fDBOr = parcelRequire("fDBOr");

var $4n30O = parcelRequire("4n30O");

var $dhkp2 = parcelRequire("dhkp2");

var $bdbZZ = parcelRequire("bdbZZ");

var $hCZMN = parcelRequire("hCZMN");

var $AD7W4 = parcelRequire("AD7W4");
class $7f8f72e5c77c065f$export$f02761adf21def8a extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = "StereoEffect";
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        // force mono sources to be stereo
        this.input.channelCount = 2;
        this.input.channelCountMode = "explicit";
        this._dryWet = this.output = new (0, $4n30O.CrossFade)({
            context: this.context,
            fade: options.wet
        });
        this.wet = this._dryWet.fade;
        this._split = new (0, $dhkp2.Split)({
            context: this.context,
            channels: 2
        });
        this._merge = new (0, $hCZMN.Merge)({
            context: this.context,
            channels: 2
        });
        // connections
        this.input.connect(this._split);
        // dry wet connections
        this.input.connect(this._dryWet.a);
        this._merge.connect(this._dryWet.b);
        (0, $AD7W4.readOnly)(this, [
            "wet"
        ]);
    }
    /**
     * Connect the left part of the effect
     */ connectEffectLeft(...nodes) {
        this._split.connect(nodes[0], 0, 0);
        (0, $fDBOr.connectSeries)(...nodes);
        (0, $fDBOr.connect)(nodes[nodes.length - 1], this._merge, 0, 0);
    }
    /**
     * Connect the right part of the effect
     */ connectEffectRight(...nodes) {
        this._split.connect(nodes[0], 1, 0);
        (0, $fDBOr.connectSeries)(...nodes);
        (0, $fDBOr.connect)(nodes[nodes.length - 1], this._merge, 0, 1);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            wet: 1
        });
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this._split.dispose();
        this._merge.dispose();
        return this;
    }
}

});
parcelRegister("dhkp2", function(module, exports) {

$parcel$export(module.exports, "Split", () => $9aacb0790299f6d5$export$f836382419f64c98);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");
class $9aacb0790299f6d5$export$f836382419f64c98 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($9aacb0790299f6d5$export$f836382419f64c98.getDefaults(), arguments, [
            "channels"
        ]));
        this.name = "Split";
        const options = (0, $l4RVz.optionsFromArguments)($9aacb0790299f6d5$export$f836382419f64c98.getDefaults(), arguments, [
            "channels"
        ]);
        this._splitter = this.input = this.output = this.context.createChannelSplitter(options.channels);
        this._internalChannels = [
            this._splitter
        ];
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._splitter.disconnect();
        return this;
    }
}

});

parcelRegister("hCZMN", function(module, exports) {

$parcel$export(module.exports, "Merge", () => $cd55e9af91a5c15c$export$70ce1d34efd3b886);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");
class $cd55e9af91a5c15c$export$70ce1d34efd3b886 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($cd55e9af91a5c15c$export$70ce1d34efd3b886.getDefaults(), arguments, [
            "channels"
        ]));
        this.name = "Merge";
        const options = (0, $l4RVz.optionsFromArguments)($cd55e9af91a5c15c$export$70ce1d34efd3b886.getDefaults(), arguments, [
            "channels"
        ]);
        this._merger = this.output = this.input = this.context.createChannelMerger(options.channels);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._merger.disconnect();
        return this;
    }
}

});




parcelRegister("1ZLI2", function(module, exports) {

$parcel$export(module.exports, "Distortion", () => $17407f073e06c185$export$406bc4309a3e7a54);

var $l4RVz = parcelRequire("l4RVz");

var $jAeMP = parcelRequire("jAeMP");

var $hadR5 = parcelRequire("hadR5");
class $17407f073e06c185$export$406bc4309a3e7a54 extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($17407f073e06c185$export$406bc4309a3e7a54.getDefaults(), arguments, [
            "distortion"
        ]));
        this.name = "Distortion";
        const options = (0, $l4RVz.optionsFromArguments)($17407f073e06c185$export$406bc4309a3e7a54.getDefaults(), arguments, [
            "distortion"
        ]);
        this._shaper = new (0, $jAeMP.WaveShaper)({
            context: this.context,
            length: 4096
        });
        this._distortion = options.distortion;
        this.connectEffect(this._shaper);
        this.distortion = options.distortion;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            distortion: 0.4,
            oversample: "none"
        });
    }
    /**
     * The amount of distortion. Nominal range is between 0 and 1.
     */ get distortion() {
        return this._distortion;
    }
    set distortion(amount) {
        this._distortion = amount;
        const k = amount * 100;
        const deg = Math.PI / 180;
        this._shaper.setMap((x)=>{
            if (Math.abs(x) < 0.001) // should output 0 when input is 0
            return 0;
            else return (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}

});

parcelRegister("gtyBS", function(module, exports) {

$parcel$export(module.exports, "FeedbackDelay", () => $bfea33966e055885$export$28e4d032ddc580fa);

var $eQyMC = parcelRequire("eQyMC");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $bLS6m = parcelRequire("bLS6m");
class $bfea33966e055885$export$28e4d032ddc580fa extends (0, $bLS6m.FeedbackEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($bfea33966e055885$export$28e4d032ddc580fa.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]));
        this.name = "FeedbackDelay";
        const options = (0, $l4RVz.optionsFromArguments)($bfea33966e055885$export$28e4d032ddc580fa.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        this._delayNode = new (0, $eQyMC.Delay)({
            context: this.context,
            delayTime: options.delayTime,
            maxDelay: options.maxDelay
        });
        this.delayTime = this._delayNode.delayTime;
        // connect it up
        this.connectEffect(this._delayNode);
        (0, $AD7W4.readOnly)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $bLS6m.FeedbackEffect).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this.delayTime.dispose();
        return this;
    }
}

});
parcelRegister("bLS6m", function(module, exports) {

$parcel$export(module.exports, "FeedbackEffect", () => $891e0cf66f5d76d7$export$125ce1b19cf7db0d);

var $bdbZZ = parcelRequire("bdbZZ");

var $AD7W4 = parcelRequire("AD7W4");

var $hadR5 = parcelRequire("hadR5");
class $891e0cf66f5d76d7$export$125ce1b19cf7db0d extends (0, $hadR5.Effect) {
    constructor(options){
        super(options);
        this.name = "FeedbackEffect";
        this._feedbackGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.feedback,
            units: "normalRange"
        });
        this.feedback = this._feedbackGain.gain;
        (0, $AD7W4.readOnly)(this, "feedback");
        // the feedback loop
        this.effectReturn.chain(this._feedbackGain, this.effectSend);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            feedback: 0.125
        });
    }
    dispose() {
        super.dispose();
        this._feedbackGain.dispose();
        this.feedback.dispose();
        return this;
    }
}

});


parcelRegister("bBfFC", function(module, exports) {

var $7vF36 = parcelRequire("7vF36");

var $l4RVz = parcelRequire("l4RVz");

var $hadR5 = parcelRequire("hadR5");

var $7AA9s = parcelRequire("7AA9s");

var $QU03h = parcelRequire("QU03h");

var $gVbAi = parcelRequire("gVbAi");

var $eCi69 = parcelRequire("eCi69");

var $1I557 = parcelRequire("1I557");

var $kcGXj = parcelRequire("kcGXj");
class $871f4e2ee8fb2867$export$183131474cdbc063 extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($871f4e2ee8fb2867$export$183131474cdbc063.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "FrequencyShifter";
        const options = (0, $l4RVz.optionsFromArguments)($871f4e2ee8fb2867$export$183131474cdbc063.getDefaults(), arguments, [
            "frequency"
        ]);
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            minValue: -this.context.sampleRate / 2,
            maxValue: this.context.sampleRate / 2
        });
        this._sine = new (0, $kcGXj.ToneOscillatorNode)({
            context: this.context,
            type: "sine"
        });
        this._cosine = new (0, $1I557.Oscillator)({
            context: this.context,
            phase: -90,
            type: "sine"
        });
        this._sineMultiply = new (0, $QU03h.Multiply)({
            context: this.context
        });
        this._cosineMultiply = new (0, $QU03h.Multiply)({
            context: this.context
        });
        this._negate = new (0, $gVbAi.Negate)({
            context: this.context
        });
        this._add = new (0, $7AA9s.Add)({
            context: this.context
        });
        this._phaseShifter = new (0, $7vF36.PhaseShiftAllpass)({
            context: this.context
        });
        this.effectSend.connect(this._phaseShifter);
        // connect the carrier frequency signal to the two oscillators
        this.frequency.fan(this._sine.frequency, this._cosine.frequency);
        this._phaseShifter.offset90.connect(this._cosineMultiply);
        this._cosine.connect(this._cosineMultiply.factor);
        this._phaseShifter.connect(this._sineMultiply);
        this._sine.connect(this._sineMultiply.factor);
        this._sineMultiply.connect(this._negate);
        this._cosineMultiply.connect(this._add);
        this._negate.connect(this._add.addend);
        this._add.connect(this.effectReturn);
        // start the oscillators at the same time
        const now = this.immediate();
        this._sine.start(now);
        this._cosine.start(now);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            frequency: 0
        });
    }
    dispose() {
        super.dispose();
        this.frequency.dispose();
        this._add.dispose();
        this._cosine.dispose();
        this._cosineMultiply.dispose();
        this._negate.dispose();
        this._phaseShifter.dispose();
        this._sine.dispose();
        this._sineMultiply.dispose();
        return this;
    }
}

});
parcelRegister("7vF36", function(module, exports) {

$parcel$export(module.exports, "PhaseShiftAllpass", () => $577b451d5ec10393$export$fc0fd2e096a27936);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");
class $577b451d5ec10393$export$fc0fd2e096a27936 extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = "PhaseShiftAllpass";
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The phase shifted output
         */ this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The PhaseShifted allpass output
         */ this.offset90 = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        const allpassBank1Values = [
            0.6923878,
            0.9360654322959,
            0.9882295226860,
            0.9987488452737
        ];
        const allpassBank2Values = [
            0.4021921162426,
            0.8561710882420,
            0.9722909545651,
            0.9952884791278
        ];
        this._bank0 = this._createAllPassFilterBank(allpassBank1Values);
        this._bank1 = this._createAllPassFilterBank(allpassBank2Values);
        this._oneSampleDelay = this.context.createIIRFilter([
            0.0,
            1.0
        ], [
            1.0,
            0.0
        ]);
        // connect Allpass filter banks
        (0, $fDBOr.connectSeries)(this.input, ...this._bank0, this._oneSampleDelay, this.output);
        (0, $fDBOr.connectSeries)(this.input, ...this._bank1, this.offset90);
    }
    /**
     * Create all of the IIR filters from an array of values using the coefficient calculation.
     */ _createAllPassFilterBank(bankValues) {
        const nodes = bankValues.map((value)=>{
            const coefficients = [
                [
                    value * value,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    -(value * value)
                ]
            ];
            return this.context.createIIRFilter(coefficients[0], coefficients[1]);
        });
        return nodes;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.offset90.dispose();
        this._bank0.forEach((f)=>f.disconnect());
        this._bank1.forEach((f)=>f.disconnect());
        this._oneSampleDelay.disconnect();
        return this;
    }
}

});


parcelRegister("8b9Pm", function(module, exports) {

var $aX02O = parcelRequire("aX02O");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $eCi69 = parcelRequire("eCi69");

var $9JfLL = parcelRequire("9JfLL");
/**
 * An array of comb filter delay values from Freeverb implementation
 */ const $5f46f95519a47a8c$var$combFilterTunings = [
    1557 / 44100,
    1617 / 44100,
    1491 / 44100,
    1422 / 44100,
    1277 / 44100,
    1356 / 44100,
    1188 / 44100,
    1116 / 44100
];
/**
 * An array of allpass filter frequency values from Freeverb implementation
 */ const $5f46f95519a47a8c$var$allpassFilterFrequencies = [
    225,
    556,
    441,
    341
];
class $5f46f95519a47a8c$export$8f91cfa34e3c0ba extends (0, $aX02O.StereoEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($5f46f95519a47a8c$export$8f91cfa34e3c0ba.getDefaults(), arguments, [
            "roomSize",
            "dampening"
        ]));
        this.name = "Freeverb";
        /**
         * the comb filters
         */ this._combFilters = [];
        /**
         * the allpass filters on the left
         */ this._allpassFiltersL = [];
        /**
         * the allpass filters on the right
         */ this._allpassFiltersR = [];
        const options = (0, $l4RVz.optionsFromArguments)($5f46f95519a47a8c$export$8f91cfa34e3c0ba.getDefaults(), arguments, [
            "roomSize",
            "dampening"
        ]);
        this.roomSize = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        // make the allpass filters on the right
        this._allpassFiltersL = $5f46f95519a47a8c$var$allpassFilterFrequencies.map((freq)=>{
            const allpassL = this.context.createBiquadFilter();
            allpassL.type = "allpass";
            allpassL.frequency.value = freq;
            return allpassL;
        });
        // make the allpass filters on the left
        this._allpassFiltersR = $5f46f95519a47a8c$var$allpassFilterFrequencies.map((freq)=>{
            const allpassR = this.context.createBiquadFilter();
            allpassR.type = "allpass";
            allpassR.frequency.value = freq;
            return allpassR;
        });
        // make the comb filters
        this._combFilters = $5f46f95519a47a8c$var$combFilterTunings.map((delayTime, index)=>{
            const lfpf = new (0, $9JfLL.LowpassCombFilter)({
                context: this.context,
                dampening: options.dampening,
                delayTime: delayTime
            });
            if (index < $5f46f95519a47a8c$var$combFilterTunings.length / 2) this.connectEffectLeft(lfpf, ...this._allpassFiltersL);
            else this.connectEffectRight(lfpf, ...this._allpassFiltersR);
            this.roomSize.connect(lfpf.resonance);
            return lfpf;
        });
        (0, $AD7W4.readOnly)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $aX02O.StereoEffect).getDefaults(), {
            roomSize: 0.7,
            dampening: 3000
        });
    }
    /**
     * The amount of dampening of the reverberant signal.
     */ get dampening() {
        return this._combFilters[0].dampening;
    }
    set dampening(d) {
        this._combFilters.forEach((c)=>c.dampening = d);
    }
    dispose() {
        super.dispose();
        this._allpassFiltersL.forEach((al)=>al.disconnect());
        this._allpassFiltersR.forEach((ar)=>ar.disconnect());
        this._combFilters.forEach((cf)=>cf.dispose());
        this.roomSize.dispose();
        return this;
    }
}

});

parcelRegister("gpbNO", function(module, exports) {

var $aX02O = parcelRequire("aX02O");

var $l4RVz = parcelRequire("l4RVz");

var $1zJwt = parcelRequire("1zJwt");

var $eCi69 = parcelRequire("eCi69");

var $ftrg1 = parcelRequire("ftrg1");

var $AD7W4 = parcelRequire("AD7W4");
/**
 * an array of the comb filter delay time values
 */ const $bf1822dc2f5b9d69$var$combFilterDelayTimes = [
    0.06748,
    0.06404,
    0.08212,
    0.09004
];
/**
 * the resonances of each of the comb filters
 */ const $bf1822dc2f5b9d69$var$combFilterResonances = [
    0.773,
    0.802,
    0.753,
    0.733
];
/**
 * the allpass filter frequencies
 */ const $bf1822dc2f5b9d69$var$allpassFilterFreqs = [
    347,
    113,
    37
];
class $bf1822dc2f5b9d69$export$d0cb5d67c6f5133d extends (0, $aX02O.StereoEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($bf1822dc2f5b9d69$export$d0cb5d67c6f5133d.getDefaults(), arguments, [
            "roomSize"
        ]));
        this.name = "JCReverb";
        /**
         * a series of allpass filters
         */ this._allpassFilters = [];
        /**
         * parallel feedback comb filters
         */ this._feedbackCombFilters = [];
        const options = (0, $l4RVz.optionsFromArguments)($bf1822dc2f5b9d69$export$d0cb5d67c6f5133d.getDefaults(), arguments, [
            "roomSize"
        ]);
        this.roomSize = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        this._scaleRoomSize = new (0, $1zJwt.Scale)({
            context: this.context,
            min: -0.733,
            max: 0.197
        });
        // make the allpass filters
        this._allpassFilters = $bf1822dc2f5b9d69$var$allpassFilterFreqs.map((freq)=>{
            const allpass = this.context.createBiquadFilter();
            allpass.type = "allpass";
            allpass.frequency.value = freq;
            return allpass;
        });
        // and the comb filters
        this._feedbackCombFilters = $bf1822dc2f5b9d69$var$combFilterDelayTimes.map((delayTime, index)=>{
            const fbcf = new (0, $ftrg1.FeedbackCombFilter)({
                context: this.context,
                delayTime: delayTime
            });
            this._scaleRoomSize.connect(fbcf.resonance);
            fbcf.resonance.value = $bf1822dc2f5b9d69$var$combFilterResonances[index];
            if (index < $bf1822dc2f5b9d69$var$combFilterDelayTimes.length / 2) this.connectEffectLeft(...this._allpassFilters, fbcf);
            else this.connectEffectRight(...this._allpassFilters, fbcf);
            return fbcf;
        });
        // chain the allpass filters together
        this.roomSize.connect(this._scaleRoomSize);
        (0, $AD7W4.readOnly)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $aX02O.StereoEffect).getDefaults(), {
            roomSize: 0.5
        });
    }
    dispose() {
        super.dispose();
        this._allpassFilters.forEach((apf)=>apf.disconnect());
        this._feedbackCombFilters.forEach((fbcf)=>fbcf.dispose());
        this.roomSize.dispose();
        this._scaleRoomSize.dispose();
        return this;
    }
}

});

parcelRegister("hFvFN", function(module, exports) {

var $kBzWX = parcelRequire("kBzWX");

var $l4RVz = parcelRequire("l4RVz");

var $eQyMC = parcelRequire("eQyMC");

var $eCi69 = parcelRequire("eCi69");

var $AD7W4 = parcelRequire("AD7W4");
class $cdced5a29b8680b6$export$7920b8962af65831 extends (0, $kBzWX.StereoXFeedbackEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($cdced5a29b8680b6$export$7920b8962af65831.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]));
        this.name = "PingPongDelay";
        const options = (0, $l4RVz.optionsFromArguments)($cdced5a29b8680b6$export$7920b8962af65831.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        this._leftDelay = new (0, $eQyMC.Delay)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightDelay = new (0, $eQyMC.Delay)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightPreDelay = new (0, $eQyMC.Delay)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this.delayTime = new (0, $eCi69.Signal)({
            context: this.context,
            units: "time",
            value: options.delayTime
        });
        // connect it up
        this.connectEffectLeft(this._leftDelay);
        this.connectEffectRight(this._rightPreDelay, this._rightDelay);
        this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime);
        // rearranged the feedback to be after the rightPreDelay
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._rightDelay);
        (0, $AD7W4.readOnly)(this, [
            "delayTime"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $kBzWX.StereoXFeedbackEffect).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._leftDelay.dispose();
        this._rightDelay.dispose();
        this._rightPreDelay.dispose();
        this.delayTime.dispose();
        return this;
    }
}

});
parcelRegister("kBzWX", function(module, exports) {

$parcel$export(module.exports, "StereoXFeedbackEffect", () => $f00326429be15fb9$export$a40db16ae36574f7);

var $R5uRC = parcelRequire("R5uRC");

var $AD7W4 = parcelRequire("AD7W4");
class $f00326429be15fb9$export$a40db16ae36574f7 extends (0, $R5uRC.StereoFeedbackEffect) {
    constructor(options){
        super(options);
        // the left output connected to the right input
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._feedbackMerge, 0, 1);
        // the left output connected to the right input
        this._feedbackR.disconnect();
        this._feedbackR.connect(this._feedbackMerge, 0, 0);
        (0, $AD7W4.readOnly)(this, [
            "feedback"
        ]);
    }
}

});


parcelRegister("e3S5U", function(module, exports) {

$parcel$export(module.exports, "PitchShift", () => $a3cb4e7ee43287c4$export$996a02cfaea06f8f);

var $bLS6m = parcelRequire("bLS6m");

var $l4RVz = parcelRequire("l4RVz");

var $lNxm0 = parcelRequire("lNxm0");

var $eQyMC = parcelRequire("eQyMC");

var $4n30O = parcelRequire("4n30O");

var $eCi69 = parcelRequire("eCi69");

var $AD7W4 = parcelRequire("AD7W4");

var $bmU6v = parcelRequire("bmU6v");
class $a3cb4e7ee43287c4$export$996a02cfaea06f8f extends (0, $bLS6m.FeedbackEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($a3cb4e7ee43287c4$export$996a02cfaea06f8f.getDefaults(), arguments, [
            "pitch"
        ]));
        this.name = "PitchShift";
        const options = (0, $l4RVz.optionsFromArguments)($a3cb4e7ee43287c4$export$996a02cfaea06f8f.getDefaults(), arguments, [
            "pitch"
        ]);
        this._frequency = new (0, $eCi69.Signal)({
            context: this.context
        });
        this._delayA = new (0, $eQyMC.Delay)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoA = new (0, $lNxm0.LFO)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth"
        }).connect(this._delayA.delayTime);
        this._delayB = new (0, $eQyMC.Delay)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoB = new (0, $lNxm0.LFO)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth",
            phase: 180
        }).connect(this._delayB.delayTime);
        this._crossFade = new (0, $4n30O.CrossFade)({
            context: this.context
        });
        this._crossFadeLFO = new (0, $lNxm0.LFO)({
            context: this.context,
            min: 0,
            max: 1,
            type: "triangle",
            phase: 90
        }).connect(this._crossFade.fade);
        this._feedbackDelay = new (0, $eQyMC.Delay)({
            delayTime: options.delayTime,
            context: this.context
        });
        this.delayTime = this._feedbackDelay.delayTime;
        (0, $AD7W4.readOnly)(this, "delayTime");
        this._pitch = options.pitch;
        this._windowSize = options.windowSize;
        // connect the two delay lines up
        this._delayA.connect(this._crossFade.a);
        this._delayB.connect(this._crossFade.b);
        // connect the frequency
        this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency);
        // route the input
        this.effectSend.fan(this._delayA, this._delayB);
        this._crossFade.chain(this._feedbackDelay, this.effectReturn);
        // start the LFOs at the same time
        const now = this.now();
        this._lfoA.start(now);
        this._lfoB.start(now);
        this._crossFadeLFO.start(now);
        // set the initial value
        this.windowSize = this._windowSize;
    }
    static getDefaults() {
        return Object.assign((0, $bLS6m.FeedbackEffect).getDefaults(), {
            pitch: 0,
            windowSize: 0.1,
            delayTime: 0,
            feedback: 0
        });
    }
    /**
     * Repitch the incoming signal by some interval (measured in semi-tones).
     * @example
     * const pitchShift = new Tone.PitchShift().toDestination();
     * const osc = new Tone.Oscillator().connect(pitchShift).start().toDestination();
     * pitchShift.pitch = -12; // down one octave
     * pitchShift.pitch = 7; // up a fifth
     */ get pitch() {
        return this._pitch;
    }
    set pitch(interval) {
        this._pitch = interval;
        let factor = 0;
        if (interval < 0) {
            this._lfoA.min = 0;
            this._lfoA.max = this._windowSize;
            this._lfoB.min = 0;
            this._lfoB.max = this._windowSize;
            factor = (0, $bmU6v.intervalToFrequencyRatio)(interval - 1) + 1;
        } else {
            this._lfoA.min = this._windowSize;
            this._lfoA.max = 0;
            this._lfoB.min = this._windowSize;
            this._lfoB.max = 0;
            factor = (0, $bmU6v.intervalToFrequencyRatio)(interval) - 1;
        }
        this._frequency.value = factor * (1.2 / this._windowSize);
    }
    /**
     * The window size corresponds roughly to the sample length in a looping sampler.
     * Smaller values are desirable for a less noticeable delay time of the pitch shifted
     * signal, but larger values will result in smoother pitch shifting for larger intervals.
     * A nominal range of 0.03 to 0.1 is recommended.
     */ get windowSize() {
        return this._windowSize;
    }
    set windowSize(size) {
        this._windowSize = this.toSeconds(size);
        this.pitch = this._pitch;
    }
    dispose() {
        super.dispose();
        this._frequency.dispose();
        this._delayA.dispose();
        this._delayB.dispose();
        this._lfoA.dispose();
        this._lfoB.dispose();
        this._crossFade.dispose();
        this._crossFadeLFO.dispose();
        this._feedbackDelay.dispose();
        return this;
    }
}

});

parcelRegister("jjlIu", function(module, exports) {

var $aX02O = parcelRequire("aX02O");

var $l4RVz = parcelRequire("l4RVz");

var $lNxm0 = parcelRequire("lNxm0");

var $eCi69 = parcelRequire("eCi69");

var $AD7W4 = parcelRequire("AD7W4");
class $e0f0a32531e72f18$export$1be4418d8537c3f5 extends (0, $aX02O.StereoEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e0f0a32531e72f18$export$1be4418d8537c3f5.getDefaults(), arguments, [
            "frequency",
            "octaves",
            "baseFrequency"
        ]));
        this.name = "Phaser";
        const options = (0, $l4RVz.optionsFromArguments)($e0f0a32531e72f18$export$1be4418d8537c3f5.getDefaults(), arguments, [
            "frequency",
            "octaves",
            "baseFrequency"
        ]);
        this._lfoL = new (0, $lNxm0.LFO)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $lNxm0.LFO)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this.Q = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.Q,
            units: "positive"
        });
        this._filtersL = this._makeFilters(options.stages, this._lfoL);
        this._filtersR = this._makeFilters(options.stages, this._lfoR);
        this.frequency = this._lfoL.frequency;
        this.frequency.value = options.frequency;
        // connect them up
        this.connectEffectLeft(...this._filtersL);
        this.connectEffectRight(...this._filtersR);
        // control the frequency with one LFO
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // set the options
        this.baseFrequency = options.baseFrequency;
        this.octaves = options.octaves;
        // start the lfo
        this._lfoL.start();
        this._lfoR.start();
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $aX02O.StereoEffect).getDefaults(), {
            frequency: 0.5,
            octaves: 3,
            stages: 10,
            Q: 10,
            baseFrequency: 350
        });
    }
    _makeFilters(stages, connectToFreq) {
        const filters = [];
        // make all the filters
        for(let i = 0; i < stages; i++){
            const filter = this.context.createBiquadFilter();
            filter.type = "allpass";
            this.Q.connect(filter.Q);
            connectToFreq.connect(filter.frequency);
            filters.push(filter);
        }
        return filters;
    }
    /**
     * The number of octaves the phase goes above the baseFrequency
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        const max = this._baseFrequency * Math.pow(2, octaves);
        this._lfoL.max = max;
        this._lfoR.max = max;
    }
    /**
     * The the base frequency of the filters.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(freq) {
        this._baseFrequency = this.toFrequency(freq);
        this._lfoL.min = this._baseFrequency;
        this._lfoR.min = this._baseFrequency;
        this.octaves = this._octaves;
    }
    dispose() {
        super.dispose();
        this.Q.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._filtersL.forEach((f)=>f.disconnect());
        this._filtersR.forEach((f)=>f.disconnect());
        this.frequency.dispose();
        return this;
    }
}

});

parcelRegister("7FIGc", function(module, exports) {

$parcel$export(module.exports, "Reverb", () => $595f0535860a5b5c$export$6fb1520d4329a18d);

var $gztBd = parcelRequire("gztBd");

var $hCZMN = parcelRequire("hCZMN");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");

var $5yVwk = parcelRequire("5yVwk");

var $hadR5 = parcelRequire("hadR5");

var $iHery = parcelRequire("iHery");

var $AD7W4 = parcelRequire("AD7W4");

var $6Utwn = parcelRequire("6Utwn");
class $595f0535860a5b5c$export$6fb1520d4329a18d extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($595f0535860a5b5c$export$6fb1520d4329a18d.getDefaults(), arguments, [
            "decay"
        ]));
        this.name = "Reverb";
        /**
         * Convolver node
         */ this._convolver = this.context.createConvolver();
        /**
         * Resolves when the reverb buffer is generated. Whenever either [[decay]]
         * or [[preDelay]] are set, you have to wait until [[ready]] resolves
         * before the IR is generated with the latest values.
         */ this.ready = Promise.resolve();
        const options = (0, $l4RVz.optionsFromArguments)($595f0535860a5b5c$export$6fb1520d4329a18d.getDefaults(), arguments, [
            "decay"
        ]);
        this._decay = options.decay;
        this._preDelay = options.preDelay;
        this.generate();
        this.connectEffect(this._convolver);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            decay: 1.5,
            preDelay: 0.01
        });
    }
    /**
     * The duration of the reverb.
     */ get decay() {
        return this._decay;
    }
    set decay(time) {
        time = this.toSeconds(time);
        (0, $6Utwn.assertRange)(time, 0.001);
        this._decay = time;
        this.generate();
    }
    /**
     * The amount of time before the reverb is fully ramped in.
     */ get preDelay() {
        return this._preDelay;
    }
    set preDelay(time) {
        time = this.toSeconds(time);
        (0, $6Utwn.assertRange)(time, 0);
        this._preDelay = time;
        this.generate();
    }
    /**
     * Generate the Impulse Response. Returns a promise while the IR is being generated.
     * @return Promise which returns this object.
     */ generate() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            const previousReady = this.ready;
            // create a noise burst which decays over the duration in each channel
            const context = new (0, $iHery.OfflineContext)(2, this._decay + this._preDelay, this.context.sampleRate);
            const noiseL = new (0, $5yVwk.Noise)({
                context: context
            });
            const noiseR = new (0, $5yVwk.Noise)({
                context: context
            });
            const merge = new (0, $hCZMN.Merge)({
                context: context
            });
            noiseL.connect(merge, 0, 0);
            noiseR.connect(merge, 0, 1);
            const gainNode = new (0, $bdbZZ.Gain)({
                context: context
            }).toDestination();
            merge.connect(gainNode);
            noiseL.start(0);
            noiseR.start(0);
            // predelay
            gainNode.gain.setValueAtTime(0, 0);
            gainNode.gain.setValueAtTime(1, this._preDelay);
            // decay
            gainNode.gain.exponentialApproachValueAtTime(0, this._preDelay, this.decay);
            // render the buffer
            const renderPromise = context.render();
            this.ready = renderPromise.then((0, $AD7W4.noOp));
            // wait for the previous `ready` to resolve
            yield previousReady;
            // set the buffer
            this._convolver.buffer = (yield renderPromise).get();
            return this;
        });
    }
    dispose() {
        super.dispose();
        this._convolver.disconnect();
        return this;
    }
}

});

parcelRegister("7YzFO", function(module, exports) {

var $7IFvw = parcelRequire("7IFvw");

var $eCi69 = parcelRequire("eCi69");

var $QU03h = parcelRequire("QU03h");

var $j0HBF = parcelRequire("j0HBF");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $fDBOr = parcelRequire("fDBOr");
class $5ce9cefd547c48e6$export$54593a5432d0d54c extends (0, $7IFvw.MidSideEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($5ce9cefd547c48e6$export$54593a5432d0d54c.getDefaults(), arguments, [
            "width"
        ]));
        this.name = "StereoWidener";
        const options = (0, $l4RVz.optionsFromArguments)($5ce9cefd547c48e6$export$54593a5432d0d54c.getDefaults(), arguments, [
            "width"
        ]);
        this.width = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.width,
            units: "normalRange"
        });
        (0, $AD7W4.readOnly)(this, [
            "width"
        ]);
        this._twoTimesWidthMid = new (0, $QU03h.Multiply)({
            context: this.context,
            value: 2
        });
        this._twoTimesWidthSide = new (0, $QU03h.Multiply)({
            context: this.context,
            value: 2
        });
        this._midMult = new (0, $QU03h.Multiply)({
            context: this.context
        });
        this._twoTimesWidthMid.connect(this._midMult.factor);
        this.connectEffectMid(this._midMult);
        this._oneMinusWidth = new (0, $j0HBF.Subtract)({
            context: this.context
        });
        this._oneMinusWidth.connect(this._twoTimesWidthMid);
        (0, $fDBOr.connect)(this.context.getConstant(1), this._oneMinusWidth);
        this.width.connect(this._oneMinusWidth.subtrahend);
        this._sideMult = new (0, $QU03h.Multiply)({
            context: this.context
        });
        this.width.connect(this._twoTimesWidthSide);
        this._twoTimesWidthSide.connect(this._sideMult.factor);
        this.connectEffectSide(this._sideMult);
    }
    static getDefaults() {
        return Object.assign((0, $7IFvw.MidSideEffect).getDefaults(), {
            width: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.width.dispose();
        this._midMult.dispose();
        this._sideMult.dispose();
        this._twoTimesWidthMid.dispose();
        this._twoTimesWidthSide.dispose();
        this._oneMinusWidth.dispose();
        return this;
    }
}

});
parcelRegister("7IFvw", function(module, exports) {

$parcel$export(module.exports, "MidSideEffect", () => $59ecd6f7d37b27aa$export$67948bb93e06c2e);

var $hadR5 = parcelRequire("hadR5");

var $e9kdf = parcelRequire("e9kdf");

var $fPyTb = parcelRequire("fPyTb");
class $59ecd6f7d37b27aa$export$67948bb93e06c2e extends (0, $hadR5.Effect) {
    constructor(options){
        super(options);
        this.name = "MidSideEffect";
        this._midSideMerge = new (0, $fPyTb.MidSideMerge)({
            context: this.context
        });
        this._midSideSplit = new (0, $e9kdf.MidSideSplit)({
            context: this.context
        });
        this._midSend = this._midSideSplit.mid;
        this._sideSend = this._midSideSplit.side;
        this._midReturn = this._midSideMerge.mid;
        this._sideReturn = this._midSideMerge.side;
        // the connections
        this.effectSend.connect(this._midSideSplit);
        this._midSideMerge.connect(this.effectReturn);
    }
    /**
     * Connect the mid chain of the effect
     */ connectEffectMid(...nodes) {
        this._midSend.chain(...nodes, this._midReturn);
    }
    /**
     * Connect the side chain of the effect
     */ connectEffectSide(...nodes) {
        this._sideSend.chain(...nodes, this._sideReturn);
    }
    dispose() {
        super.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        this._midSend.dispose();
        this._sideSend.dispose();
        this._midReturn.dispose();
        this._sideReturn.dispose();
        return this;
    }
}

});
parcelRegister("e9kdf", function(module, exports) {

$parcel$export(module.exports, "MidSideSplit", () => $a4d195c5820ba2fc$export$17b3caaa07b8690f);

var $fDBOr = parcelRequire("fDBOr");

var $dhkp2 = parcelRequire("dhkp2");

var $7AA9s = parcelRequire("7AA9s");

var $QU03h = parcelRequire("QU03h");

var $j0HBF = parcelRequire("j0HBF");

var $l4RVz = parcelRequire("l4RVz");
class $a4d195c5820ba2fc$export$17b3caaa07b8690f extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($a4d195c5820ba2fc$export$17b3caaa07b8690f.getDefaults(), arguments));
        this.name = "MidSideSplit";
        this._split = this.input = new (0, $dhkp2.Split)({
            channels: 2,
            context: this.context
        });
        this._midAdd = new (0, $7AA9s.Add)({
            context: this.context
        });
        this.mid = new (0, $QU03h.Multiply)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._sideSubtract = new (0, $j0HBF.Subtract)({
            context: this.context
        });
        this.side = new (0, $QU03h.Multiply)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._split.connect(this._midAdd, 0);
        this._split.connect(this._midAdd.addend, 1);
        this._split.connect(this._sideSubtract, 0);
        this._split.connect(this._sideSubtract.subtrahend, 1);
        this._midAdd.connect(this.mid);
        this._sideSubtract.connect(this.side);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midAdd.dispose();
        this._sideSubtract.dispose();
        this._split.dispose();
        return this;
    }
}

});

parcelRegister("fPyTb", function(module, exports) {

$parcel$export(module.exports, "MidSideMerge", () => $b866aeab62cf6daf$export$be84ddbe7b4fbb5a);

var $fDBOr = parcelRequire("fDBOr");

var $hCZMN = parcelRequire("hCZMN");

var $7AA9s = parcelRequire("7AA9s");

var $QU03h = parcelRequire("QU03h");

var $j0HBF = parcelRequire("j0HBF");

var $bdbZZ = parcelRequire("bdbZZ");

var $l4RVz = parcelRequire("l4RVz");
class $b866aeab62cf6daf$export$be84ddbe7b4fbb5a extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($b866aeab62cf6daf$export$be84ddbe7b4fbb5a.getDefaults(), arguments));
        this.name = "MidSideMerge";
        this.mid = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.side = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._left = new (0, $7AA9s.Add)({
            context: this.context
        });
        this._leftMult = new (0, $QU03h.Multiply)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._right = new (0, $j0HBF.Subtract)({
            context: this.context
        });
        this._rightMult = new (0, $QU03h.Multiply)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._merge = this.output = new (0, $hCZMN.Merge)({
            context: this.context
        });
        this.mid.fan(this._left);
        this.side.connect(this._left.addend);
        this.mid.connect(this._right);
        this.side.connect(this._right.subtrahend);
        this._left.connect(this._leftMult);
        this._right.connect(this._rightMult);
        this._leftMult.connect(this._merge, 0, 0);
        this._rightMult.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._leftMult.dispose();
        this._rightMult.dispose();
        this._left.dispose();
        this._right.dispose();
        return this;
    }
}

});



parcelRegister("1mjXL", function(module, exports) {

var $aX02O = parcelRequire("aX02O");

var $lNxm0 = parcelRequire("lNxm0");

var $bdbZZ = parcelRequire("bdbZZ");

var $eCi69 = parcelRequire("eCi69");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $0fd754bc7b4248c7$export$74a4578e446afdc7 extends (0, $aX02O.StereoEffect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($0fd754bc7b4248c7$export$74a4578e446afdc7.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]));
        this.name = "Tremolo";
        const options = (0, $l4RVz.optionsFromArguments)($0fd754bc7b4248c7$export$74a4578e446afdc7.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        this._lfoL = new (0, $lNxm0.LFO)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._lfoR = new (0, $lNxm0.LFO)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._amplitudeL = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._amplitudeR = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.frequency = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.frequency,
            units: "frequency"
        });
        this.depth = new (0, $eCi69.Signal)({
            context: this.context,
            value: options.depth,
            units: "normalRange"
        });
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "depth"
        ]);
        this.connectEffectLeft(this._amplitudeL);
        this.connectEffectRight(this._amplitudeR);
        this._lfoL.connect(this._amplitudeL.gain);
        this._lfoR.connect(this._amplitudeR.gain);
        this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency);
        this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude);
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $aX02O.StereoEffect).getDefaults(), {
            frequency: 10,
            type: "sine",
            depth: 0.5,
            spread: 180
        });
    }
    /**
     * Start the tremolo.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the tremolo.
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the effect to the transport.
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the filter from the transport
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * The oscillator type.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase; // 180
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._amplitudeL.dispose();
        this._amplitudeR.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}

});

parcelRegister("km71R", function(module, exports) {

var $hadR5 = parcelRequire("hadR5");

var $l4RVz = parcelRequire("l4RVz");

var $lNxm0 = parcelRequire("lNxm0");

var $eQyMC = parcelRequire("eQyMC");

var $AD7W4 = parcelRequire("AD7W4");
class $ed1b5084e68d7b8c$export$eb898fc31d087455 extends (0, $hadR5.Effect) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ed1b5084e68d7b8c$export$eb898fc31d087455.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]));
        this.name = "Vibrato";
        const options = (0, $l4RVz.optionsFromArguments)($ed1b5084e68d7b8c$export$eb898fc31d087455.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        this._delayNode = new (0, $eQyMC.Delay)({
            context: this.context,
            delayTime: 0,
            maxDelay: options.maxDelay
        });
        this._lfo = new (0, $lNxm0.LFO)({
            context: this.context,
            type: options.type,
            min: 0,
            max: options.maxDelay,
            frequency: options.frequency,
            phase: -90 // offse the phase so the resting position is in the center
        }).start().connect(this._delayNode.delayTime);
        this.frequency = this._lfo.frequency;
        this.depth = this._lfo.amplitude;
        this.depth.value = options.depth;
        (0, $AD7W4.readOnly)(this, [
            "frequency",
            "depth"
        ]);
        this.effectSend.chain(this._delayNode, this.effectReturn);
    }
    static getDefaults() {
        return Object.assign((0, $hadR5.Effect).getDefaults(), {
            maxDelay: 0.005,
            frequency: 5,
            depth: 0.1,
            type: "sine"
        });
    }
    /**
     * Type of oscillator attached to the Vibrato.
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}

});


parcelRegister("esw2V", function(module, exports) {
$parcel$export(module.exports, "Analyser", () => (parcelRequire("kzedo")).Analyser);
$parcel$export(module.exports, "Meter", () => (parcelRequire("lUFsy")).Meter);
$parcel$export(module.exports, "Channel", () => (parcelRequire("1x3k0")).Channel);
$parcel$export(module.exports, "MultibandSplit", () => (parcelRequire("jT0OW")).MultibandSplit);
$parcel$export(module.exports, "Panner", () => (parcelRequire("32Bfc")).Panner);
$parcel$export(module.exports, "Volume", () => (parcelRequire("dTGN1")).Volume);
$parcel$export(module.exports, "Limiter", () => (parcelRequire("2AuBL")).Limiter);
$parcel$export(module.exports, "Filter", () => (parcelRequire("82Hwq")).Filter);
$parcel$export(module.exports, "BiquadFilter", () => (parcelRequire("Lvs5H")).BiquadFilter);
parcelRequire("kzedo");
parcelRequire("lUFsy");
parcelRequire("cT4tc");
parcelRequire("bhyX5");
parcelRequire("8OnbO");
parcelRequire("blRAN");
parcelRequire("1x3k0");
parcelRequire("4n30O");
parcelRequire("hCZMN");
parcelRequire("fPyTb");
parcelRequire("e9kdf");
parcelRequire("gz5x6");
parcelRequire("jT0OW");
parcelRequire("32Bfc");
parcelRequire("lTDL4");
parcelRequire("ido98");
parcelRequire("kqg6z");
parcelRequire("7XLpR");
parcelRequire("dhkp2");
parcelRequire("dTGN1");
parcelRequire("cBHAN");
parcelRequire("2jTAO");
parcelRequire("2AuBL");
parcelRequire("iyIDp");
parcelRequire("5J2ry");
parcelRequire("8XS4X");
parcelRequire("jaF5W");
parcelRequire("gjK3F");
parcelRequire("hlZKu");
parcelRequire("82Hwq");
parcelRequire("3B6kz");
parcelRequire("ftrg1");
parcelRequire("9JfLL");
parcelRequire("fksCJ");
parcelRequire("Lvs5H");

});
parcelRegister("kzedo", function(module, exports) {

$parcel$export(module.exports, "Analyser", () => $ef921a534844b2a1$export$86a05438820989b0);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $dhkp2 = parcelRequire("dhkp2");

var $bdbZZ = parcelRequire("bdbZZ");

var $6Utwn = parcelRequire("6Utwn");
class $ef921a534844b2a1$export$86a05438820989b0 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ef921a534844b2a1$export$86a05438820989b0.getDefaults(), arguments, [
            "type",
            "size"
        ]));
        this.name = "Analyser";
        /**
         * The analyser node.
         */ this._analysers = [];
        /**
         * The buffer that the FFT data is written to
         */ this._buffers = [];
        const options = (0, $l4RVz.optionsFromArguments)($ef921a534844b2a1$export$86a05438820989b0.getDefaults(), arguments, [
            "type",
            "size"
        ]);
        this.input = this.output = this._gain = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._split = new (0, $dhkp2.Split)({
            context: this.context,
            channels: options.channels
        });
        this.input.connect(this._split);
        (0, $6Utwn.assertRange)(options.channels, 1);
        // create the analysers
        for(let channel = 0; channel < options.channels; channel++){
            this._analysers[channel] = this.context.createAnalyser();
            this._split.connect(this._analysers[channel], channel, 0);
        }
        // set the values initially
        this.size = options.size;
        this.type = options.type;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            size: 1024,
            smoothing: 0.8,
            type: "fft",
            channels: 1
        });
    }
    /**
     * Run the analysis given the current settings. If [[channels]] = 1,
     * it will return a Float32Array. If [[channels]] > 1, it will
     * return an array of Float32Arrays where each index in the array
     * represents the analysis done on a channel.
     */ getValue() {
        this._analysers.forEach((analyser, index)=>{
            const buffer = this._buffers[index];
            if (this._type === "fft") analyser.getFloatFrequencyData(buffer);
            else if (this._type === "waveform") analyser.getFloatTimeDomainData(buffer);
        });
        if (this.channels === 1) return this._buffers[0];
        else return this._buffers;
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     */ get size() {
        return this._analysers[0].frequencyBinCount;
    }
    set size(size) {
        this._analysers.forEach((analyser, index)=>{
            analyser.fftSize = size * 2;
            this._buffers[index] = new Float32Array(size);
        });
    }
    /**
     * The number of channels the analyser does the analysis on. Channel
     * separation is done using [[Split]]
     */ get channels() {
        return this._analysers.length;
    }
    /**
     * The analysis function returned by analyser.getValue(), either "fft" or "waveform".
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $6Utwn.assert)(type === "waveform" || type === "fft", `Analyser: invalid type: ${type}`);
        this._type = type;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analysers[0].smoothingTimeConstant;
    }
    set smoothing(val) {
        this._analysers.forEach((a)=>a.smoothingTimeConstant = val);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._analysers.forEach((a)=>a.disconnect());
        this._split.dispose();
        this._gain.dispose();
        return this;
    }
}

});

parcelRegister("lUFsy", function(module, exports) {

$parcel$export(module.exports, "Meter", () => $ff3efcedb5723d5b$export$62e3ae2a4090b879);

var $bmU6v = parcelRequire("bmU6v");

var $l4RVz = parcelRequire("l4RVz");

var $6CY4e = parcelRequire("6CY4e");

var $6Utwn = parcelRequire("6Utwn");

var $kzedo = parcelRequire("kzedo");
class $ff3efcedb5723d5b$export$62e3ae2a4090b879 extends (0, $6CY4e.MeterBase) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ff3efcedb5723d5b$export$62e3ae2a4090b879.getDefaults(), arguments, [
            "smoothing"
        ]));
        this.name = "Meter";
        /**
         * The previous frame's value
         */ this._rms = 0;
        const options = (0, $l4RVz.optionsFromArguments)($ff3efcedb5723d5b$export$62e3ae2a4090b879.getDefaults(), arguments, [
            "smoothing"
        ]);
        this.input = this.output = this._analyser = new (0, $kzedo.Analyser)({
            context: this.context,
            size: 256,
            type: "waveform",
            channels: options.channels
        });
        this.smoothing = options.smoothing, this.normalRange = options.normalRange;
    }
    static getDefaults() {
        return Object.assign((0, $6CY4e.MeterBase).getDefaults(), {
            smoothing: 0.8,
            normalRange: false,
            channels: 1
        });
    }
    /**
     * Use [[getValue]] instead. For the previous getValue behavior, use DCMeter.
     * @deprecated
     */ getLevel() {
        (0, $6Utwn.warn)("'getLevel' has been changed to 'getValue'");
        return this.getValue();
    }
    /**
     * Get the current value of the incoming signal.
     * Output is in decibels when [[normalRange]] is `false`.
     * If [[channels]] = 1, then the output is a single number
     * representing the value of the input signal. When [[channels]] > 1,
     * then each channel is returned as a value in a number array.
     */ getValue() {
        const aValues = this._analyser.getValue();
        const channelValues = this.channels === 1 ? [
            aValues
        ] : aValues;
        const vals = channelValues.map((values)=>{
            const totalSquared = values.reduce((total, current)=>total + current * current, 0);
            const rms = Math.sqrt(totalSquared / values.length);
            // the rms can only fall at the rate of the smoothing
            // but can jump up instantly
            this._rms = Math.max(rms, this._rms * this.smoothing);
            return this.normalRange ? this._rms : (0, $bmU6v.gainToDb)(this._rms);
        });
        if (this.channels === 1) return vals[0];
        else return vals;
    }
    /**
     * The number of channels of analysis.
     */ get channels() {
        return this._analyser.channels;
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}

});
parcelRegister("6CY4e", function(module, exports) {

$parcel$export(module.exports, "MeterBase", () => $4d34e2c8c07ed47c$export$67f5eb90858fca69);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $kzedo = parcelRequire("kzedo");
class $4d34e2c8c07ed47c$export$67f5eb90858fca69 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($4d34e2c8c07ed47c$export$67f5eb90858fca69.getDefaults(), arguments));
        this.name = "MeterBase";
        this.input = this.output = this._analyser = new (0, $kzedo.Analyser)({
            context: this.context,
            size: 256,
            type: "waveform"
        });
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}

});


parcelRegister("cT4tc", function(module, exports) {

var $fDBOr = parcelRequire("fDBOr");

var $bmU6v = parcelRequire("bmU6v");

var $l4RVz = parcelRequire("l4RVz");

var $6CY4e = parcelRequire("6CY4e");

var $6Utwn = parcelRequire("6Utwn");
class $961e16b655c9f171$export$677347237c014ba extends (0, $6CY4e.MeterBase) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($961e16b655c9f171$export$677347237c014ba.getDefaults(), arguments, [
            "size"
        ]));
        this.name = "FFT";
        const options = (0, $l4RVz.optionsFromArguments)($961e16b655c9f171$export$677347237c014ba.getDefaults(), arguments, [
            "size"
        ]);
        this.normalRange = options.normalRange;
        this._analyser.type = "fft";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            normalRange: false,
            size: 1024,
            smoothing: 0.8
        });
    }
    /**
     * Gets the current frequency data from the connected audio source.
     * Returns the frequency data of length [[size]] as a Float32Array of decibel values.
     */ getValue() {
        const values = this._analyser.getValue();
        return values.map((v)=>this.normalRange ? (0, $bmU6v.dbToGain)(v) : v);
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by [[getValue]] (i.e. the number of
     * frequency bins). Large FFT sizes may be costly to compute.
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analyser.smoothing;
    }
    set smoothing(val) {
        this._analyser.smoothing = val;
    }
    /**
     * Returns the frequency value in hertz of each of the indices of the FFT's [[getValue]] response.
     * @example
     * const fft = new Tone.FFT(32);
     * console.log([0, 1, 2, 3, 4].map(index => fft.getFrequencyOfIndex(index)));
     */ getFrequencyOfIndex(index) {
        (0, $6Utwn.assert)(0 <= index && index < this.size, `index must be greater than or equal to 0 and less than ${this.size}`);
        return index * this.context.sampleRate / (this.size * 2);
    }
}

});

parcelRegister("bhyX5", function(module, exports) {

var $l4RVz = parcelRequire("l4RVz");

var $6CY4e = parcelRequire("6CY4e");
class $836c64f737e360cb$export$29aa14d256c74cc6 extends (0, $6CY4e.MeterBase) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($836c64f737e360cb$export$29aa14d256c74cc6.getDefaults(), arguments));
        this.name = "DCMeter";
        this._analyser.type = "waveform";
        this._analyser.size = 256;
    }
    /**
     * Get the signal value of the incoming signal
     */ getValue() {
        const value = this._analyser.getValue();
        return value[0];
    }
}

});

parcelRegister("8OnbO", function(module, exports) {

var $l4RVz = parcelRequire("l4RVz");

var $6CY4e = parcelRequire("6CY4e");
class $66a4fb384132b3cf$export$4c2f72a4f17a358e extends (0, $6CY4e.MeterBase) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($66a4fb384132b3cf$export$4c2f72a4f17a358e.getDefaults(), arguments, [
            "size"
        ]));
        this.name = "Waveform";
        const options = (0, $l4RVz.optionsFromArguments)($66a4fb384132b3cf$export$4c2f72a4f17a358e.getDefaults(), arguments, [
            "size"
        ]);
        this._analyser.type = "waveform";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $6CY4e.MeterBase).getDefaults(), {
            size: 1024
        });
    }
    /**
     * Return the waveform for the current time as a Float32Array where each value in the array
     * represents a sample in the waveform.
     */ getValue() {
        return this._analyser.getValue();
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by [[getValue]].
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
}

});

parcelRegister("1x3k0", function(module, exports) {

$parcel$export(module.exports, "Channel", () => $11db731d0afb93d2$export$cfdacaa37f9b4dd7);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $7XLpR = parcelRequire("7XLpR");

var $ido98 = parcelRequire("ido98");

var $AD7W4 = parcelRequire("AD7W4");

var $bdbZZ = parcelRequire("bdbZZ");
class $11db731d0afb93d2$export$cfdacaa37f9b4dd7 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($11db731d0afb93d2$export$cfdacaa37f9b4dd7.getDefaults(), arguments, [
            "volume",
            "pan"
        ]));
        this.name = "Channel";
        const options = (0, $l4RVz.optionsFromArguments)($11db731d0afb93d2$export$cfdacaa37f9b4dd7.getDefaults(), arguments, [
            "volume",
            "pan"
        ]);
        this._solo = this.input = new (0, $7XLpR.Solo)({
            solo: options.solo,
            context: this.context
        });
        this._panVol = this.output = new (0, $ido98.PanVol)({
            context: this.context,
            pan: options.pan,
            volume: options.volume,
            mute: options.mute,
            channelCount: options.channelCount
        });
        this.pan = this._panVol.pan;
        this.volume = this._panVol.volume;
        this._solo.connect(this._panVol);
        (0, $AD7W4.readOnly)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            pan: 0,
            volume: 0,
            mute: false,
            solo: false,
            channelCount: 1
        });
    }
    /**
     * Solo/unsolo the channel. Soloing is only relative to other [[Channels]] and [[Solo]] instances
     */ get solo() {
        return this._solo.solo;
    }
    set solo(solo) {
        this._solo.solo = solo;
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed,
     * or the channel is muted
     */ get muted() {
        return this._solo.muted || this.mute;
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._panVol.mute;
    }
    set mute(mute) {
        this._panVol.mute = mute;
    }
    /**
     * Get the gain node belonging to the bus name. Create it if
     * it doesn't exist
     * @param name The bus name
     */ _getBus(name) {
        if (!$11db731d0afb93d2$export$cfdacaa37f9b4dd7.buses.has(name)) $11db731d0afb93d2$export$cfdacaa37f9b4dd7.buses.set(name, new (0, $bdbZZ.Gain)({
            context: this.context
        }));
        return $11db731d0afb93d2$export$cfdacaa37f9b4dd7.buses.get(name);
    }
    /**
     * Send audio to another channel using a string. `send` is a lot like
     * [[connect]], except it uses a string instead of an object. This can
     * be useful in large applications to decouple sections since [[send]]
     * and [[receive]] can be invoked separately in order to connect an object
     * @param name The channel name to send the audio
     * @param volume The amount of the signal to send.
     * 	Defaults to 0db, i.e. send the entire signal
     * @returns Returns the gain node of this connection.
     */ send(name, volume = 0) {
        const bus = this._getBus(name);
        const sendKnob = new (0, $bdbZZ.Gain)({
            context: this.context,
            units: "decibels",
            gain: volume
        });
        this.connect(sendKnob);
        sendKnob.connect(bus);
        return sendKnob;
    }
    /**
     * Receive audio from a channel which was connected with [[send]].
     * @param name The channel name to receive audio from.
     */ receive(name) {
        const bus = this._getBus(name);
        bus.connect(this);
        return this;
    }
    dispose() {
        super.dispose();
        this._panVol.dispose();
        this.pan.dispose();
        this.volume.dispose();
        this._solo.dispose();
        return this;
    }
}
/**
 * Store the send/receive channels by name.
 */ $11db731d0afb93d2$export$cfdacaa37f9b4dd7.buses = new Map();

});
parcelRegister("7XLpR", function(module, exports) {

$parcel$export(module.exports, "Solo", () => $5cc2d2edba675949$export$43343ff6c11f7ee5);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");
class $5cc2d2edba675949$export$43343ff6c11f7ee5 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($5cc2d2edba675949$export$43343ff6c11f7ee5.getDefaults(), arguments, [
            "solo"
        ]));
        this.name = "Solo";
        const options = (0, $l4RVz.optionsFromArguments)($5cc2d2edba675949$export$43343ff6c11f7ee5.getDefaults(), arguments, [
            "solo"
        ]);
        this.input = this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        if (!$5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos.has(this.context)) $5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos.set(this.context, new Set());
        $5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos.get(this.context).add(this);
        // set initially
        this.solo = options.solo;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            solo: false
        });
    }
    /**
     * Isolates this instance and mutes all other instances of Solo.
     * Only one instance can be soloed at a time. A soloed
     * instance will report `solo=false` when another instance is soloed.
     */ get solo() {
        return this._isSoloed();
    }
    set solo(solo) {
        if (solo) this._addSolo();
        else this._removeSolo();
        $5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos.get(this.context).forEach((instance)=>instance._updateSolo());
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed
     */ get muted() {
        return this.input.gain.value === 0;
    }
    /**
     * Add this to the soloed array
     */ _addSolo() {
        if (!$5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.has(this.context)) $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.set(this.context, new Set());
        $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.get(this.context).add(this);
    }
    /**
     * Remove this from the soloed array
     */ _removeSolo() {
        if ($5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.has(this.context)) $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.get(this.context).delete(this);
    }
    /**
     * Is this on the soloed array
     */ _isSoloed() {
        return $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.has(this.context) && $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.get(this.context).has(this);
    }
    /**
     * Returns true if no one is soloed
     */ _noSolos() {
        // either does not have any soloed added
        return !$5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.has(this.context) || // or has a solo set but doesn't include any items
        $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.has(this.context) && $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed.get(this.context).size === 0;
    }
    /**
     * Solo the current instance and unsolo all other instances.
     */ _updateSolo() {
        if (this._isSoloed()) this.input.gain.value = 1;
        else if (this._noSolos()) // no one is soloed
        this.input.gain.value = 1;
        else this.input.gain.value = 0;
    }
    dispose() {
        super.dispose();
        $5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos.get(this.context).delete(this);
        this._removeSolo();
        return this;
    }
}
/**
 * Hold all of the solo'ed tracks belonging to a specific context
 */ $5cc2d2edba675949$export$43343ff6c11f7ee5._allSolos = new Map();
/**
 * Hold the currently solo'ed instance(s)
 */ $5cc2d2edba675949$export$43343ff6c11f7ee5._soloed = new Map();

});

parcelRegister("ido98", function(module, exports) {

$parcel$export(module.exports, "PanVol", () => $d42c2bd6705a0129$export$e62efb0df83a5c7c);

var $AD7W4 = parcelRequire("AD7W4");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $32Bfc = parcelRequire("32Bfc");

var $dTGN1 = parcelRequire("dTGN1");
class $d42c2bd6705a0129$export$e62efb0df83a5c7c extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($d42c2bd6705a0129$export$e62efb0df83a5c7c.getDefaults(), arguments, [
            "pan",
            "volume"
        ]));
        this.name = "PanVol";
        const options = (0, $l4RVz.optionsFromArguments)($d42c2bd6705a0129$export$e62efb0df83a5c7c.getDefaults(), arguments, [
            "pan",
            "volume"
        ]);
        this._panner = this.input = new (0, $32Bfc.Panner)({
            context: this.context,
            pan: options.pan,
            channelCount: options.channelCount
        });
        this.pan = this._panner.pan;
        this._volume = this.output = new (0, $dTGN1.Volume)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        // connections
        this._panner.connect(this._volume);
        this.mute = options.mute;
        (0, $AD7W4.readOnly)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mute: false,
            pan: 0,
            volume: 0,
            channelCount: 1
        });
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        this.pan.dispose();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
}

});


parcelRegister("gz5x6", function(module, exports) {

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $hCZMN = parcelRequire("hCZMN");
class $c0f434ed8bcdcbd5$export$6a6cc05ddf64d43 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($c0f434ed8bcdcbd5$export$6a6cc05ddf64d43.getDefaults(), arguments));
        this.name = "Mono";
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._merge = this.output = new (0, $hCZMN.Merge)({
            channels: 2,
            context: this.context
        });
        this.input.connect(this._merge, 0, 0);
        this.input.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this._merge.dispose();
        this.input.dispose();
        return this;
    }
}

});

parcelRegister("jT0OW", function(module, exports) {

$parcel$export(module.exports, "MultibandSplit", () => $e7a3ca4ffccb5120$export$8243399b0243bc0b);

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $eCi69 = parcelRequire("eCi69");

var $82Hwq = parcelRequire("82Hwq");
class $e7a3ca4ffccb5120$export$8243399b0243bc0b extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($e7a3ca4ffccb5120$export$8243399b0243bc0b.getDefaults(), arguments, [
            "lowFrequency",
            "highFrequency"
        ]));
        this.name = "MultibandSplit";
        /**
         * the input
         */ this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * no output node, use either low, mid or high outputs
         */ this.output = undefined;
        /**
         * The low band.
         */ this.low = new (0, $82Hwq.Filter)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * the lower filter of the mid band
         */ this._lowMidFilter = new (0, $82Hwq.Filter)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        /**
         * The mid band output.
         */ this.mid = new (0, $82Hwq.Filter)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * The high band output.
         */ this.high = new (0, $82Hwq.Filter)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        this._internalChannels = [
            this.low,
            this.mid,
            this.high
        ];
        const options = (0, $l4RVz.optionsFromArguments)($e7a3ca4ffccb5120$export$8243399b0243bc0b.getDefaults(), arguments, [
            "lowFrequency",
            "highFrequency"
        ]);
        this.lowFrequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.lowFrequency
        });
        this.highFrequency = new (0, $eCi69.Signal)({
            context: this.context,
            units: "frequency",
            value: options.highFrequency
        });
        this.Q = new (0, $eCi69.Signal)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.input.fan(this.low, this.high);
        this.input.chain(this._lowMidFilter, this.mid);
        // the frequency control signal
        this.lowFrequency.fan(this.low.frequency, this._lowMidFilter.frequency);
        this.highFrequency.fan(this.mid.frequency, this.high.frequency);
        // the Q value
        this.Q.connect(this.low.Q);
        this.Q.connect(this._lowMidFilter.Q);
        this.Q.connect(this.mid.Q);
        this.Q.connect(this.high.Q);
        (0, $AD7W4.readOnly)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            Q: 1,
            highFrequency: 2500,
            lowFrequency: 400
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $AD7W4.writable)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
        this.low.dispose();
        this._lowMidFilter.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this.Q.dispose();
        return this;
    }
}

});

parcelRegister("lTDL4", function(module, exports) {

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");
parcelRequire("83ZfI");
class $ff0d93301abbcc3d$export$40229b68a3be8579 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ff0d93301abbcc3d$export$40229b68a3be8579.getDefaults(), arguments, [
            "positionX",
            "positionY",
            "positionZ"
        ]));
        this.name = "Panner3D";
        const options = (0, $l4RVz.optionsFromArguments)($ff0d93301abbcc3d$export$40229b68a3be8579.getDefaults(), arguments, [
            "positionX",
            "positionY",
            "positionZ"
        ]);
        this._panner = this.input = this.output = this.context.createPanner();
        // set some values
        this.panningModel = options.panningModel;
        this.maxDistance = options.maxDistance;
        this.distanceModel = options.distanceModel;
        this.coneOuterGain = options.coneOuterGain;
        this.coneOuterAngle = options.coneOuterAngle;
        this.coneInnerAngle = options.coneInnerAngle;
        this.refDistance = options.refDistance;
        this.rolloffFactor = options.rolloffFactor;
        this.positionX = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.positionX,
            value: options.positionX
        });
        this.positionY = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.positionY,
            value: options.positionY
        });
        this.positionZ = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.positionZ,
            value: options.positionZ
        });
        this.orientationX = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.orientationX,
            value: options.orientationX
        });
        this.orientationY = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.orientationY,
            value: options.orientationY
        });
        this.orientationZ = new (0, $lQP4J.Param)({
            context: this.context,
            param: this._panner.orientationZ,
            value: options.orientationZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            coneInnerAngle: 360,
            coneOuterAngle: 360,
            coneOuterGain: 0,
            distanceModel: "inverse",
            maxDistance: 10000,
            orientationX: 0,
            orientationY: 0,
            orientationZ: 0,
            panningModel: "equalpower",
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            refDistance: 1,
            rolloffFactor: 1
        });
    }
    /**
     * Sets the position of the source in 3d space.
     */ setPosition(x, y, z) {
        this.positionX.value = x;
        this.positionY.value = y;
        this.positionZ.value = z;
        return this;
    }
    /**
     * Sets the orientation of the source in 3d space.
     */ setOrientation(x, y, z) {
        this.orientationX.value = x;
        this.orientationY.value = y;
        this.orientationZ.value = z;
        return this;
    }
    /**
     * The panning model. Either "equalpower" or "HRTF".
     */ get panningModel() {
        return this._panner.panningModel;
    }
    set panningModel(val) {
        this._panner.panningModel = val;
    }
    /**
     * A reference distance for reducing volume as source move further from the listener
     */ get refDistance() {
        return this._panner.refDistance;
    }
    set refDistance(val) {
        this._panner.refDistance = val;
    }
    /**
     * Describes how quickly the volume is reduced as source moves away from listener.
     */ get rolloffFactor() {
        return this._panner.rolloffFactor;
    }
    set rolloffFactor(val) {
        this._panner.rolloffFactor = val;
    }
    /**
     * The distance model used by,  "linear", "inverse", or "exponential".
     */ get distanceModel() {
        return this._panner.distanceModel;
    }
    set distanceModel(val) {
        this._panner.distanceModel = val;
    }
    /**
     * The angle, in degrees, inside of which there will be no volume reduction
     */ get coneInnerAngle() {
        return this._panner.coneInnerAngle;
    }
    set coneInnerAngle(val) {
        this._panner.coneInnerAngle = val;
    }
    /**
     * The angle, in degrees, outside of which the volume will be reduced
     * to a constant value of coneOuterGain
     */ get coneOuterAngle() {
        return this._panner.coneOuterAngle;
    }
    set coneOuterAngle(val) {
        this._panner.coneOuterAngle = val;
    }
    /**
     * The gain outside of the coneOuterAngle
     */ get coneOuterGain() {
        return this._panner.coneOuterGain;
    }
    set coneOuterGain(val) {
        this._panner.coneOuterGain = val;
    }
    /**
     * The maximum distance between source and listener,
     * after which the volume will not be reduced any further.
     */ get maxDistance() {
        return this._panner.maxDistance;
    }
    set maxDistance(val) {
        this._panner.maxDistance = val;
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.orientationX.dispose();
        this.orientationY.dispose();
        this.orientationZ.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        return this;
    }
}

});
parcelRegister("83ZfI", function(module, exports) {

var $fDBOr = parcelRequire("fDBOr");

var $lQP4J = parcelRequire("lQP4J");

var $7M63q = parcelRequire("7M63q");
class $5dee1dfd65d54630$export$c92b1d5f43586026 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(...arguments);
        this.name = "Listener";
        this.positionX = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.positionX
        });
        this.positionY = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.positionY
        });
        this.positionZ = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.positionZ
        });
        this.forwardX = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.forwardX
        });
        this.forwardY = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.forwardY
        });
        this.forwardZ = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.forwardZ
        });
        this.upX = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.upX
        });
        this.upY = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.upY
        });
        this.upZ = new (0, $lQP4J.Param)({
            context: this.context,
            param: this.context.rawContext.listener.upZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            forwardX: 0,
            forwardY: 0,
            forwardZ: -1,
            upX: 0,
            upY: 1,
            upZ: 0
        });
    }
    dispose() {
        super.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        this.forwardX.dispose();
        this.forwardY.dispose();
        this.forwardZ.dispose();
        this.upX.dispose();
        this.upY.dispose();
        this.upZ.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $7M63q.onContextInit)((context)=>{
    context.listener = new $5dee1dfd65d54630$export$c92b1d5f43586026({
        context: context
    });
});
(0, $7M63q.onContextClose)((context)=>{
    context.listener.dispose();
});

});


parcelRegister("kqg6z", function(module, exports) {

var $gztBd = parcelRequire("gztBd");

var $fDBOr = parcelRequire("fDBOr");

var $bdbZZ = parcelRequire("bdbZZ");

var $6Utwn = parcelRequire("6Utwn");

var $lQat4 = parcelRequire("lQat4");

var $l4RVz = parcelRequire("l4RVz");
class $ede2ba7c0a1a0b9e$export$336a011955157f9a extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ede2ba7c0a1a0b9e$export$336a011955157f9a.getDefaults(), arguments));
        this.name = "Recorder";
        const options = (0, $l4RVz.optionsFromArguments)($ede2ba7c0a1a0b9e$export$336a011955157f9a.getDefaults(), arguments);
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        (0, $6Utwn.assert)($ede2ba7c0a1a0b9e$export$336a011955157f9a.supported, "Media Recorder API is not available");
        this._stream = this.context.createMediaStreamDestination();
        this.input.connect(this._stream);
        this._recorder = new MediaRecorder(this._stream.stream, {
            mimeType: options.mimeType
        });
    }
    static getDefaults() {
        return (0, $fDBOr.ToneAudioNode).getDefaults();
    }
    /**
     * The mime type is the format that the audio is encoded in. For Chrome
     * that is typically webm encoded as "vorbis".
     */ get mimeType() {
        return this._recorder.mimeType;
    }
    /**
     * Test if your platform supports the Media Recorder API. If it's not available,
     * try installing this (polyfill)[https://www.npmjs.com/package/audio-recorder-polyfill].
     */ static get supported() {
        return (0, $lQat4.theWindow) !== null && Reflect.has((0, $lQat4.theWindow), "MediaRecorder");
    }
    /**
     * Get the playback state of the Recorder, either "started", "stopped" or "paused"
     */ get state() {
        if (this._recorder.state === "inactive") return "stopped";
        else if (this._recorder.state === "paused") return "paused";
        else return "started";
    }
    /**
     * Start the Recorder. Returns a promise which resolves
     * when the recorder has started.
     */ start() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            (0, $6Utwn.assert)(this.state !== "started", "Recorder is already started");
            const startPromise = new Promise((done)=>{
                const handleStart = ()=>{
                    this._recorder.removeEventListener("start", handleStart, false);
                    done();
                };
                this._recorder.addEventListener("start", handleStart, false);
            });
            this._recorder.start();
            return yield startPromise;
        });
    }
    /**
     * Stop the recorder. Returns a promise with the recorded content until this point
     * encoded as [[mimeType]]
     */ stop() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            (0, $6Utwn.assert)(this.state !== "stopped", "Recorder is not started");
            const dataPromise = new Promise((done)=>{
                const handleData = (e)=>{
                    this._recorder.removeEventListener("dataavailable", handleData, false);
                    done(e.data);
                };
                this._recorder.addEventListener("dataavailable", handleData, false);
            });
            this._recorder.stop();
            return yield dataPromise;
        });
    }
    /**
     * Pause the recorder
     */ pause() {
        (0, $6Utwn.assert)(this.state === "started", "Recorder must be started");
        this._recorder.pause();
        return this;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._stream.disconnect();
        return this;
    }
}

});

parcelRegister("cBHAN", function(module, exports) {

$parcel$export(module.exports, "Compressor", () => $92dac14f54b29b27$export$41ba31ea44cbf87a);

var $lQP4J = parcelRequire("lQP4J");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");
class $92dac14f54b29b27$export$41ba31ea44cbf87a extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($92dac14f54b29b27$export$41ba31ea44cbf87a.getDefaults(), arguments, [
            "threshold",
            "ratio"
        ]));
        this.name = "Compressor";
        /**
         * the compressor node
         */ this._compressor = this.context.createDynamicsCompressor();
        this.input = this._compressor;
        this.output = this._compressor;
        const options = (0, $l4RVz.optionsFromArguments)($92dac14f54b29b27$export$41ba31ea44cbf87a.getDefaults(), arguments, [
            "threshold",
            "ratio"
        ]);
        this.threshold = new (0, $lQP4J.Param)({
            minValue: this._compressor.threshold.minValue,
            maxValue: this._compressor.threshold.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.threshold,
            units: "decibels",
            value: options.threshold
        });
        this.attack = new (0, $lQP4J.Param)({
            minValue: this._compressor.attack.minValue,
            maxValue: this._compressor.attack.maxValue,
            context: this.context,
            param: this._compressor.attack,
            units: "time",
            value: options.attack
        });
        this.release = new (0, $lQP4J.Param)({
            minValue: this._compressor.release.minValue,
            maxValue: this._compressor.release.maxValue,
            context: this.context,
            param: this._compressor.release,
            units: "time",
            value: options.release
        });
        this.knee = new (0, $lQP4J.Param)({
            minValue: this._compressor.knee.minValue,
            maxValue: this._compressor.knee.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.knee,
            units: "decibels",
            value: options.knee
        });
        this.ratio = new (0, $lQP4J.Param)({
            minValue: this._compressor.ratio.minValue,
            maxValue: this._compressor.ratio.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.ratio,
            units: "positive",
            value: options.ratio
        });
        // set the defaults
        (0, $AD7W4.readOnly)(this, [
            "knee",
            "release",
            "attack",
            "ratio",
            "threshold"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            attack: 0.003,
            knee: 30,
            ratio: 12,
            release: 0.25,
            threshold: -24
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal. If fed no signal the value will be 0 (no gain reduction).
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.disconnect();
        this.attack.dispose();
        this.release.dispose();
        this.threshold.dispose();
        this.ratio.dispose();
        this.knee.dispose();
        return this;
    }
}

});

parcelRegister("2jTAO", function(module, exports) {

var $fDBOr = parcelRequire("fDBOr");

var $3ruxu = parcelRequire("3ruxu");

var $bdbZZ = parcelRequire("bdbZZ");

var $blRAN = parcelRequire("blRAN");

var $l4RVz = parcelRequire("l4RVz");

var $bmU6v = parcelRequire("bmU6v");
class $1b087aad8c2bee3b$export$b4bc28ee584f979c extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($1b087aad8c2bee3b$export$b4bc28ee584f979c.getDefaults(), arguments, [
            "threshold",
            "smoothing"
        ])));
        this.name = "Gate";
        const options = (0, $l4RVz.optionsFromArguments)($1b087aad8c2bee3b$export$b4bc28ee584f979c.getDefaults(), arguments, [
            "threshold",
            "smoothing"
        ]);
        this._follower = new (0, $blRAN.Follower)({
            context: this.context,
            smoothing: options.smoothing
        });
        this._gt = new (0, $3ruxu.GreaterThan)({
            context: this.context,
            value: (0, $bmU6v.dbToGain)(options.threshold)
        });
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._gate = this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        // connections
        this.input.connect(this._gate);
        // the control signal
        this.input.chain(this._follower, this._gt, this._gate.gain);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            smoothing: 0.1,
            threshold: -40
        });
    }
    /**
     * The threshold of the gate in decibels
     */ get threshold() {
        return (0, $bmU6v.gainToDb)(this._gt.value);
    }
    set threshold(thresh) {
        this._gt.value = (0, $bmU6v.dbToGain)(thresh);
    }
    /**
     * The attack/decay speed of the gate. See [[Follower.smoothing]]
     */ get smoothing() {
        return this._follower.smoothing;
    }
    set smoothing(smoothingTime) {
        this._follower.smoothing = smoothingTime;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._follower.dispose();
        this._gt.dispose();
        this._gate.dispose();
        return this;
    }
}

});

parcelRegister("2AuBL", function(module, exports) {

$parcel$export(module.exports, "Limiter", () => $1e26afb0fa190aee$export$18d8154f27ea9172);

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $cBHAN = parcelRequire("cBHAN");

var $AD7W4 = parcelRequire("AD7W4");
class $1e26afb0fa190aee$export$18d8154f27ea9172 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($1e26afb0fa190aee$export$18d8154f27ea9172.getDefaults(), arguments, [
            "threshold"
        ])));
        this.name = "Limiter";
        const options = (0, $l4RVz.optionsFromArguments)($1e26afb0fa190aee$export$18d8154f27ea9172.getDefaults(), arguments, [
            "threshold"
        ]);
        this._compressor = this.input = this.output = new (0, $cBHAN.Compressor)({
            context: this.context,
            ratio: 20,
            attack: 0.003,
            release: 0.01,
            threshold: options.threshold
        });
        this.threshold = this._compressor.threshold;
        (0, $AD7W4.readOnly)(this, "threshold");
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            threshold: -12
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal.
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.dispose();
        this.threshold.dispose();
        return this;
    }
}

});

parcelRegister("iyIDp", function(module, exports) {

var $fDBOr = parcelRequire("fDBOr");

var $cBHAN = parcelRequire("cBHAN");

var $l4RVz = parcelRequire("l4RVz");

var $e9kdf = parcelRequire("e9kdf");

var $fPyTb = parcelRequire("fPyTb");

var $AD7W4 = parcelRequire("AD7W4");
class $d82e067df4c383f0$export$4fe244964f9889ae extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($d82e067df4c383f0$export$4fe244964f9889ae.getDefaults(), arguments)));
        this.name = "MidSideCompressor";
        const options = (0, $l4RVz.optionsFromArguments)($d82e067df4c383f0$export$4fe244964f9889ae.getDefaults(), arguments);
        this._midSideSplit = this.input = new (0, $e9kdf.MidSideSplit)({
            context: this.context
        });
        this._midSideMerge = this.output = new (0, $fPyTb.MidSideMerge)({
            context: this.context
        });
        this.mid = new (0, $cBHAN.Compressor)(Object.assign(options.mid, {
            context: this.context
        }));
        this.side = new (0, $cBHAN.Compressor)(Object.assign(options.side, {
            context: this.context
        }));
        this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid);
        this._midSideSplit.side.chain(this.side, this._midSideMerge.side);
        (0, $AD7W4.readOnly)(this, [
            "mid",
            "side"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            side: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            }
        });
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        return this;
    }
}

});

parcelRegister("5J2ry", function(module, exports) {

var $fDBOr = parcelRequire("fDBOr");

var $cBHAN = parcelRequire("cBHAN");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $jT0OW = parcelRequire("jT0OW");

var $bdbZZ = parcelRequire("bdbZZ");
class $42b30cf48401eded$export$7cd9eb83d48f580b extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super(Object.assign((0, $l4RVz.optionsFromArguments)($42b30cf48401eded$export$7cd9eb83d48f580b.getDefaults(), arguments)));
        this.name = "MultibandCompressor";
        const options = (0, $l4RVz.optionsFromArguments)($42b30cf48401eded$export$7cd9eb83d48f580b.getDefaults(), arguments);
        this._splitter = this.input = new (0, $jT0OW.MultibandSplit)({
            context: this.context,
            lowFrequency: options.lowFrequency,
            highFrequency: options.highFrequency
        });
        this.lowFrequency = this._splitter.lowFrequency;
        this.highFrequency = this._splitter.highFrequency;
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.low = new (0, $cBHAN.Compressor)(Object.assign(options.low, {
            context: this.context
        }));
        this.mid = new (0, $cBHAN.Compressor)(Object.assign(options.mid, {
            context: this.context
        }));
        this.high = new (0, $cBHAN.Compressor)(Object.assign(options.high, {
            context: this.context
        }));
        // connect the compressor
        this._splitter.low.chain(this.low, this.output);
        this._splitter.mid.chain(this.mid, this.output);
        this._splitter.high.chain(this.high, this.output);
        (0, $AD7W4.readOnly)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            lowFrequency: 250,
            highFrequency: 2000,
            low: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            },
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            high: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            }
        });
    }
    dispose() {
        super.dispose();
        this._splitter.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.output.dispose();
        return this;
    }
}

});

parcelRegister("hlZKu", function(module, exports) {

var $bdbZZ = parcelRequire("bdbZZ");

var $fDBOr = parcelRequire("fDBOr");

var $l4RVz = parcelRequire("l4RVz");

var $AD7W4 = parcelRequire("AD7W4");

var $jT0OW = parcelRequire("jT0OW");
class $ca244bd9c5587d5b$export$2adf407ed955ca5d extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($ca244bd9c5587d5b$export$2adf407ed955ca5d.getDefaults(), arguments, [
            "low",
            "mid",
            "high"
        ]));
        this.name = "EQ3";
        /**
         * the output
         */ this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this._internalChannels = [];
        const options = (0, $l4RVz.optionsFromArguments)($ca244bd9c5587d5b$export$2adf407ed955ca5d.getDefaults(), arguments, [
            "low",
            "mid",
            "high"
        ]);
        this.input = this._multibandSplit = new (0, $jT0OW.MultibandSplit)({
            context: this.context,
            highFrequency: options.highFrequency,
            lowFrequency: options.lowFrequency
        });
        this._lowGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.low,
            units: "decibels"
        });
        this._midGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.mid,
            units: "decibels"
        });
        this._highGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.high,
            units: "decibels"
        });
        this.low = this._lowGain.gain;
        this.mid = this._midGain.gain;
        this.high = this._highGain.gain;
        this.Q = this._multibandSplit.Q;
        this.lowFrequency = this._multibandSplit.lowFrequency;
        this.highFrequency = this._multibandSplit.highFrequency;
        // the frequency bands
        this._multibandSplit.low.chain(this._lowGain, this.output);
        this._multibandSplit.mid.chain(this._midGain, this.output);
        this._multibandSplit.high.chain(this._highGain, this.output);
        (0, $AD7W4.readOnly)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._internalChannels = [
            this._multibandSplit
        ];
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            high: 0,
            highFrequency: 2500,
            low: 0,
            lowFrequency: 400,
            mid: 0
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $AD7W4.writable)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._multibandSplit.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this._lowGain.dispose();
        this._midGain.dispose();
        this._highGain.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.Q.dispose();
        return this;
    }
}

});

parcelRegister("fksCJ", function(module, exports) {

var $gztBd = parcelRequire("gztBd");

var $fDBOr = parcelRequire("fDBOr");

var $9j0vm = parcelRequire("9j0vm");

var $l4RVz = parcelRequire("l4RVz");

var $bdbZZ = parcelRequire("bdbZZ");

var $AD7W4 = parcelRequire("AD7W4");
class $b28eed567ab9fb84$export$f48597cb240e2420 extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($b28eed567ab9fb84$export$f48597cb240e2420.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "Convolver";
        /**
         * The native ConvolverNode
         */ this._convolver = this.context.createConvolver();
        const options = (0, $l4RVz.optionsFromArguments)($b28eed567ab9fb84$export$f48597cb240e2420.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this._buffer = new (0, $9j0vm.ToneAudioBuffer)(options.url, (buffer)=>{
            this.buffer = buffer;
            options.onload();
        });
        this.input = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        // set if it's already loaded, set it immediately
        if (this._buffer.loaded) this.buffer = this._buffer;
        // initially set normalization
        this.normalize = options.normalize;
        // connect it up
        this.input.chain(this._convolver, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            normalize: true,
            onload: (0, $AD7W4.noOp)
        });
    }
    /**
     * Load an impulse response url as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     */ load(url) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function*() {
            this.buffer = yield this._buffer.load(url);
        });
    }
    /**
     * The convolver's buffer
     */ get buffer() {
        if (this._buffer.length) return this._buffer;
        else return null;
    }
    set buffer(buffer) {
        if (buffer) this._buffer.set(buffer);
        // if it's already got a buffer, create a new one
        if (this._convolver.buffer) {
            // disconnect the old one
            this.input.disconnect();
            this._convolver.disconnect();
            // create and connect a new one
            this._convolver = this.context.createConvolver();
            this.input.chain(this._convolver, this.output);
        }
        const buff = this._buffer.get();
        this._convolver.buffer = buff ? buff : null;
    }
    /**
     * The normalize property of the ConvolverNode interface is a boolean that
     * controls whether the impulse response from the buffer will be scaled by
     * an equal-power normalization when the buffer attribute is set, or not.
     */ get normalize() {
        return this._convolver.normalize;
    }
    set normalize(norm) {
        this._convolver.normalize = norm;
    }
    dispose() {
        super.dispose();
        this._buffer.dispose();
        this._convolver.disconnect();
        return this;
    }
}

});




parcelRegister("lsfK2", function(module, exports) {

$parcel$export(module.exports, "midiHandler", () => $f9e86c70dde53fb1$export$431fdb9b2afbaac2);

var $Lbl7Y = parcelRequire("Lbl7Y");

var $iJ8Ef = parcelRequire("iJ8Ef");

var $9xysn = parcelRequire("9xysn");

var $5ICqB = parcelRequire("5ICqB");

var $95CQM = parcelRequire("95CQM");
class $f9e86c70dde53fb1$var$MidiHandler {
    notesActivades = new Set();
    boundInstrumentID = undefined;
    constructor(){
        this.typingInput = new $f9e86c70dde53fb1$var$TypingMIDIInput(this);
        this.externalDeviceManager = new $f9e86c70dde53fb1$var$ExternalDeviceMidiManager(this);
    }
    get isWebMidiEnabled() {
        return this.externalDeviceManager.isWebMidiEnabled;
    }
    onNoteOn(pitch, velocity) {
        if (this.boundInstrumentID) this.sendNoteOn(this.boundInstrumentID, pitch, velocity);
    }
    onNoteOff(pitch, velocity) {
        if (this.boundInstrumentID) this.sendNoteOff(this.boundInstrumentID, pitch, velocity);
    }
    bindToInstrument(instrumentID) {
        // treu les notes penjades a l'instrument anterior que no han rebut noteoff
        if (this.boundInstrumentID) this.notesActivades.forEach((pitch)=>this.sendNoteOff(this.boundInstrumentID, pitch, 0, {
                force: true
            }));
        this.boundInstrumentID = instrumentID;
    }
    // called from the panic method on audioEngine
    clearNotes() {
        this.notesActivades.clear();
    }
    sendNoteOn(instrumentID, pitch, velocity) {
        pitch = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).adjustPitchToInstrumentRange(pitch);
        const messageData = {
            pitch: pitch,
            velocity: velocity,
            type: 'noteOn'
        };
        this.notesActivades.add(pitch);
        const doSendToServer = !(0, $Lbl7Y.getAudioGraphInstance)().usesAudioEngine();
        this.sendMidiEvent(instrumentID, messageData, doSendToServer);
    }
    sendNoteOff(instrumentID, pitch, velocity, extras = {}) {
        pitch = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).adjustPitchToInstrumentRange(pitch);
        const messageData = {
            pitch: pitch,
            velocity: velocity,
            type: 'noteOff',
            ...extras
        };
        this.notesActivades.delete(pitch);
        this.sendMidiEvent(instrumentID, messageData, !(0, $Lbl7Y.getAudioGraphInstance)().usesAudioEngine());
    }
    sendMidiEvent(instrumentID, data) {
        (0, $iJ8Ef.sendMessageToServer)('midi_event', {
            instrument_id: instrumentID,
            midi_event_data: data
        });
    }
    receiveMidiEventFromServer(instrumentID, data) {
        // If a instrumentID is provided, only send to the instrument with that id. Otherwise send to all instruments
        const targetStationsIds = instrumentID ? [
            instrumentID
        ] : (0, $95CQM.staticSelect)((0, $5ICqB.selectInstrumentIDs));
        targetStationsIds.forEach((instrumentID)=>{
            const { pitch: pitch, velocity: velocity, type: type, ...extras } = data;
            (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).onMidiNote(pitch, velocity, type === 'noteOff', {
                ...extras,
                skipRecording: false
            });
        });
        data.source = "user";
        this.dispatchBrowserMidiEvent(instrumentID, data);
    }
    dispatchBrowserMidiEvent(instrumentID, data) {
        //Aquest event s'utilitza en el piano roll per dibuixar els requadres sobre les notes que s'estan tocant
        // i en el grid de pads del sampler per seleccionar el pad de l'última nota que s'ha tocat
        // i en el ADSR graph per marcar l'envolupant de l'última nota
        const event = new CustomEvent("midiNote-" + instrumentID, {
            detail: data
        });
        document.dispatchEvent(event);
    }
}
class $f9e86c70dde53fb1$var$Log {
    #entries = [];
    push(data) {
        const timestamp = new Date().toISOString().slice(11, 19); // HH:mm:ss in UTC
        this.entries.push({
            timestamp: timestamp,
            data: data
        });
        this.listeners.forEach((callback)=>callback());
    }
    get entries() {
        return this.#entries;
    }
    listeners = [];
    addListener(callback) {
        this.listeners.push(callback);
    }
    removeListener(callback) {
        this.listeners = this.listeners.filter((fn)=>fn !== callback);
    }
}
class $f9e86c70dde53fb1$var$ExternalDeviceMidiManager {
    webMidiStates = {
        NOT_ALLOWED: "not_allowed",
        ALLOWED: "allowed",
        DENIED: "denied",
        NOT_SUPPORTED: "not_supported"
    };
    webMidiState = this.webMidiStates.NOT_ALLOWED;
    midi = undefined;
    log = new $f9e86c70dde53fb1$var$Log();
    constructor(midiHandler){
        this.midiHandler = midiHandler;
        if (!navigator.requestMIDIAccess) {
            console.error("Navigator doesn't allow/support requestMIDIAccess");
            this.webMidiStates = this.webMidiStates.NOT_SUPPORTED;
        }
    // if webmidi was enabled previously (save and check in localStorage)
    // we could do requestMIDIaccess so that users don't need to activate it in every refresh.
    }
    get isWebMidiEnabled() {
        return this.webMidiState === this.webMidiStates.ALLOWED;
    }
    init(device, callback) {
        this.requestMIDIAccess(callback, callback).then(()=>this.bindToInput(device));
    }
    requestMIDIAccess(onsuccess = ()=>{}, onerror = ()=>{}) {
        return navigator.requestMIDIAccess().then((midiAccess)=>{
            this.webMidiState = this.webMidiStates.ALLOWED;
            this.midi = midiAccess;
            onsuccess();
        }).catch((e)=>{
            this.webMidiState = this.webMidiStates.DENIED;
            onerror();
        });
    }
    getAvailableMidiInputNames() {
        return [
            ...this.midi.inputs.values()
        ].map((input)=>input.name);
    }
    getMidiInputByName(midiInputName) {
        return [
            ...this.midi.inputs.values()
        ].find((input)=>input.name === midiInputName);
    }
    bindToInput(midiInputName) {
        this.unbindFromAllInputs(); // Unbind possibly existing callbacks on other devices
        if (midiInputName == null) return;
        const input = this.getMidiInputByName(midiInputName);
        input.onmidimessage = (message)=>{
            this.log.push({
                device: midiInputName,
                data: message.data
            });
            // https://midi.org/expanded-midi-1-0-messages-list
            const [statusByte, ...dataBytes] = message.data;
            if (0x80 <= statusByte && statusByte < 0xf0) {
                const _channel = (statusByte & 0xf) + 1; // We're ignoring it for now
                const functionType = (statusByte >> 4) - 8;
                if (functionType === 0) this.midiHandler.onNoteOff(...dataBytes);
                if (functionType === 1) {
                    const velocity = dataBytes[1];
                    if (velocity === 0) this.midiHandler.onNoteOff(...dataBytes); // weird, isn't it! some controllers do this
                    else this.midiHandler.onNoteOn(...dataBytes);
                }
            }
        };
        this.boundInput = midiInputName;
    }
    unbindFromAllInputs() {
        for (const entry of this.midi.inputs){
            const input = entry[1];
            input.onmidimessage = undefined;
        }
        this.boundInput = undefined;
    }
}
class $f9e86c70dde53fb1$var$TypingMIDIInput {
    kbMap = new Map([
        "a",
        "w",
        "s",
        "e",
        "d",
        "f",
        "t",
        "g",
        "y",
        "h",
        "u",
        "j",
        "k"
    ].map((key, index)=>[
            key,
            index
        ]));
    padMap = new Map([
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "0"
    ].map((key, index)=>[
            key,
            index
        ]));
    baseNotes = new Map();
    boundKeys = new Map();
    isEnabled = true;
    constructor(midiHandler){
        this.midiHandler = midiHandler;
        document.addEventListener('keydown', (e)=>this.onKeyDown(e));
        document.addEventListener('keyup', (e)=>this.onKeyUp(e));
    }
    enable() {
        this.isEnabled = true;
    }
    disable() {
        this.isEnabled = false;
    }
    handleOctaveUp = (instrumentID)=>{
        const currentBaseNote = this.baseNotes.get(instrumentID);
        if (currentBaseNote >= 100) return;
        this.baseNotes.set(instrumentID, currentBaseNote + 12);
    };
    handleOctaveDown = (instrumentID)=>{
        const currentBaseNote = this.baseNotes.get(instrumentID);
        if (currentBaseNote < 12) return;
        this.baseNotes.set(instrumentID, currentBaseNote - 12);
    };
    isValidEvent(evt) {
        // If typing in a text input, do not trigger MIDI events from keypress
        if (document.activeElement.tagName === "INPUT" && document.activeElement.type === "text") return false;
        if (evt.repeat) return false; // If repeat event, ignore it
        return true;
    }
    onKeyUp(evt) {
        if (!this.isEnabled) return;
        if (!this.isValidEvent(evt)) return;
        const key = evt.key.toLowerCase();
        if (!this.boundKeys.has(key)) return;
        const pitch = this.boundKeys.get(key);
        this.boundKeys.delete(key);
        this.midiHandler.onNoteOff(pitch, 0);
    }
    onKeyDown(evt) {
        if (!this.isEnabled) return;
        if (!this.isValidEvent(evt)) return;
        const key = evt.key.toLowerCase();
        const boundInstrumentID = this.midiHandler.boundInstrumentID;
        if (boundInstrumentID === undefined) return; // needs to be bound to an instrument to work
        const usableRange = (0, $9xysn.getCurrentProject)().getInstrument(boundInstrumentID).pitchRange.usable;
        // Octave change
        if (key == "+") this.handleOctaveUp(boundInstrumentID);
        else if (key == "-") this.handleOctaveDown(boundInstrumentID);
        else if (this.kbMap.has(key)) {
            if (!this.baseNotes.has(boundInstrumentID)) this.baseNotes.set(boundInstrumentID, 60); // default
            let pitch;
            while(true){
                pitch = this.baseNotes.get(boundInstrumentID) + this.kbMap.get(key);
                if (pitch < usableRange.min) this.handleOctaveUp(boundInstrumentID);
                else if (pitch > usableRange.max) this.handleOctaveDown(boundInstrumentID);
                else break;
            }
            this.boundKeys.set(key, pitch);
            this.midiHandler.onNoteOn(pitch, 127);
        } else if (this.padMap.has(key)) {
            const pitch = this.padMap.get(key);
            this.boundKeys.set(key, pitch);
            this.midiHandler.onNoteOn(pitch, 127);
        }
    }
}
const $f9e86c70dde53fb1$export$431fdb9b2afbaac2 = new $f9e86c70dde53fb1$var$MidiHandler();

});
parcelRegister("5ICqB", function(module, exports) {

$parcel$export(module.exports, "TRANSPORT_PARAMS_DESCRIPTION", () => $429eded906a18dec$export$1a9e3bdc92df48a8);
$parcel$export(module.exports, "AUDIO_PARAMS_DESCRIPTION", () => $429eded906a18dec$export$c517347cbf138523);
$parcel$export(module.exports, "PROJECT_PARAMS_DESCRIPTION", () => $429eded906a18dec$export$f5dab16f094d9602);
$parcel$export(module.exports, "selectPresets", () => $429eded906a18dec$export$b7b92364caf81104);
$parcel$export(module.exports, "selectPlaybackMode", () => $429eded906a18dec$export$87e772c289df96a3);
$parcel$export(module.exports, "default", () => $429eded906a18dec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "loadAllData", () => $429eded906a18dec$export$e68235ca2e24c89f);
$parcel$export(module.exports, "updateMetadata", () => $429eded906a18dec$export$f64791b2d30456a0);
$parcel$export(module.exports, "setProjectParameter", () => $429eded906a18dec$export$7ff02179fafde784);
$parcel$export(module.exports, "setTransportParameter", () => $429eded906a18dec$export$c4e0353812e422a1);
$parcel$export(module.exports, "transportStart", () => $429eded906a18dec$export$9b404dddf3c2c59c);
$parcel$export(module.exports, "transportStop", () => $429eded906a18dec$export$131758e4d8b93c18);
$parcel$export(module.exports, "enqueueSlot", () => $429eded906a18dec$export$ef8fedd693c07732);
$parcel$export(module.exports, "launchScene", () => $429eded906a18dec$export$6333097d0417164c);
$parcel$export(module.exports, "dequeueSlots", () => $429eded906a18dec$export$946f2512a2b4acf2);
$parcel$export(module.exports, "setAudioParameter", () => $429eded906a18dec$export$449206e40bce4823);
$parcel$export(module.exports, "addInstrument", () => $429eded906a18dec$export$4669b2c5491c889d);
$parcel$export(module.exports, "removeInstrument", () => $429eded906a18dec$export$a1b3fddc9c10efe5);
$parcel$export(module.exports, "reorderInstrument", () => $429eded906a18dec$export$b3801e6e28ea1bb7);
$parcel$export(module.exports, "renameInstrument", () => $429eded906a18dec$export$b748eeb65de9131);
$parcel$export(module.exports, "setInstrumentParameter", () => $429eded906a18dec$export$9c1e17bd211c9484);
$parcel$export(module.exports, "makePreset", () => $429eded906a18dec$export$80d9bf384fafdbe3);
$parcel$export(module.exports, "savePreset", () => $429eded906a18dec$export$748a59e2e8df3f84);
$parcel$export(module.exports, "deletePreset", () => $429eded906a18dec$export$f6f31fb6da61ffc6);
$parcel$export(module.exports, "loadPresetInInstrument", () => $429eded906a18dec$export$ee7d1eb600e0574e);
$parcel$export(module.exports, "setReturnParameter", () => $429eded906a18dec$export$6c8618ce4b276e3e);
$parcel$export(module.exports, "setMasterChannelParameter", () => $429eded906a18dec$export$3bbb881ba35ada42);
$parcel$export(module.exports, "setPresetParameter", () => $429eded906a18dec$export$b45c2f84691e89f5);
$parcel$export(module.exports, "setClip", () => $429eded906a18dec$export$7aa51ddbfe0fd37);
$parcel$export(module.exports, "setClipParameter", () => $429eded906a18dec$export$bf84d4379af6199e);
$parcel$export(module.exports, "clearClip", () => $429eded906a18dec$export$97a72b68e947086c);
$parcel$export(module.exports, "setClipSequence", () => $429eded906a18dec$export$6b7a1926d1d5380b);
$parcel$export(module.exports, "setClipLength", () => $429eded906a18dec$export$f4a8918cb8d652dd);
$parcel$export(module.exports, "addScene", () => $429eded906a18dec$export$f12804300e12d9b5);
$parcel$export(module.exports, "removeScene", () => $429eded906a18dec$export$a503903e1b3bf31d);
$parcel$export(module.exports, "reorderScene", () => $429eded906a18dec$export$c7baab7eac801307);
$parcel$export(module.exports, "renameScene", () => $429eded906a18dec$export$4be0c382b928103d);
$parcel$export(module.exports, "setSceneDuration", () => $429eded906a18dec$export$fc0d2fe4d1136a2a);
$parcel$export(module.exports, "setClipNumberForInstrumentInScene", () => $429eded906a18dec$export$437bb54ade051fda);
$parcel$export(module.exports, "removeClipForInstrumentInScene", () => $429eded906a18dec$export$a2812aa45861379f);
$parcel$export(module.exports, "setPresetIDForInstrumentInScene", () => $429eded906a18dec$export$8fe1f3e5f44b5a90);
$parcel$export(module.exports, "selectProject", () => $429eded906a18dec$export$6a772d98df0515d3);
$parcel$export(module.exports, "selectProjectName", () => $429eded906a18dec$export$f5395d40a245914b);
$parcel$export(module.exports, "selectConnectedUsers", () => $429eded906a18dec$export$57ee93a2b2140c3a);
$parcel$export(module.exports, "selectScenes", () => $429eded906a18dec$export$636b7292e5260c06);
$parcel$export(module.exports, "selectArrangement", () => $429eded906a18dec$export$929d46894c79a034);
$parcel$export(module.exports, "selectBpm", () => $429eded906a18dec$export$382fa7f15ec21837);
$parcel$export(module.exports, "selectCompas", () => $429eded906a18dec$export$a497cf8e85411d6d);
$parcel$export(module.exports, "selectSwing", () => $429eded906a18dec$export$135d3d1f1b6d27ef);
$parcel$export(module.exports, "selectTonality", () => $429eded906a18dec$export$14baf6d1bec8e229);
$parcel$export(module.exports, "selectInstruments", () => $429eded906a18dec$export$32e491a5aaebe381);
$parcel$export(module.exports, "selectInstrumentIDs", () => $429eded906a18dec$export$865abdeaca175171);
$parcel$export(module.exports, "selectIsAnyInstrumentSolo", () => $429eded906a18dec$export$5e2ab70291075819);
$parcel$export(module.exports, "selectIsRecordingProject", () => $429eded906a18dec$export$87dd0df04b2f6db3);
$parcel$export(module.exports, "selectIsRecordArmed", () => $429eded906a18dec$export$5069376b6a450582);
$parcel$export(module.exports, "selectIsPlaying", () => $429eded906a18dec$export$f4ca3cdb12871ee);
$parcel$export(module.exports, "selectIsMetronomeEnabled", () => $429eded906a18dec$export$cdc7cce98fe9eaba);
$parcel$export(module.exports, "selectTransportCurrentStep", () => $429eded906a18dec$export$3b3601b87b4c407c);
$parcel$export(module.exports, "selectPlayStartMarkerStep", () => $429eded906a18dec$export$4ee6d038db429de2);
$parcel$export(module.exports, "selectTransportSync", () => $429eded906a18dec$export$af1cbe857b379c72);
$parcel$export(module.exports, "selectlaunchedSlots", () => $429eded906a18dec$export$c27c41bdc08988ec);
$parcel$export(module.exports, "selectCurrentSceneIDAndStep", () => $429eded906a18dec$export$c56152a462dae80f);
$parcel$export(module.exports, "createMasterChannelParameterSelector", () => $429eded906a18dec$export$aeb6097ab7abbbf6);
$parcel$export(module.exports, "selectUsesAudioEngine", () => $429eded906a18dec$export$384988ea521471f);
$parcel$export(module.exports, "selectIsGraphBuilt", () => $429eded906a18dec$export$47597ed8b70ad005);
$parcel$export(module.exports, "selectReturns", () => $429eded906a18dec$export$907b9c28d386fa97);
$parcel$export(module.exports, "createReturnParameterSelector", () => $429eded906a18dec$export$8be617ca0bf09b00);
$parcel$export(module.exports, "setSampleRate", () => $429eded906a18dec$export$a2ece3d4ab026fd1);
$parcel$export(module.exports, "setMidiDevice", () => $429eded906a18dec$export$e89c725b4ea1dd04);
$parcel$export(module.exports, "selectSampleRate", () => $429eded906a18dec$export$696e925a4b9a1cbb);
$parcel$export(module.exports, "selectMidiDevice", () => $429eded906a18dec$export$e3e8ebba082fcc9c);

var $6JzMn = parcelRequire("6JzMn");
var $dkYqL = parcelRequire("dkYqL");

var $9xysn = parcelRequire("9xysn");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $iJ8Ef = parcelRequire("iJ8Ef");

var $lsfK2 = parcelRequire("lsfK2");

var $kmdF6 = parcelRequire("kmdF6");

var $abvlt = parcelRequire("abvlt");

var $1zQag = parcelRequire("1zQag");

var $29BVo = parcelRequire("29BVo");

var $duZNX = parcelRequire("duZNX");

var $lejHD = parcelRequire("lejHD");

var $5vTj9 = parcelRequire("5vTj9");

var $eng2W = parcelRequire("eng2W");
const $429eded906a18dec$export$1a9e3bdc92df48a8 = {
    isRecordingProject: {
        type: 'bool',
        initial: false
    },
    isRecordArmed: {
        type: 'bool',
        initial: false
    },
    isPlaying: {
        type: 'bool',
        initial: false
    },
    isMetronomeEnabled: {
        type: 'bool',
        initial: false
    },
    currentStep: {
        type: 'int',
        initial: -1
    },
    playStartMarkerStep: {
        type: 'int',
        initial: 0
    },
    playbackMode: {
        type: 'enum',
        options: [
            'followInstruments',
            'followLauncher',
            'followArrangement'
        ],
        initial: 'followInstruments'
    },
    sync: {
        type: 'enum',
        options: [
            'send',
            'receive',
            'off'
        ],
        initial: 'off'
    } // sync step with other projects
};
const $429eded906a18dec$export$c517347cbf138523 = {
    usesAudioEngine: {
        type: 'bool',
        initial: true
    },
    isGraphBuilt: {
        type: 'bool',
        initial: false
    }
};
const $429eded906a18dec$export$f5dab16f094d9602 = {
    bpm: {
        type: 'float',
        min: 40,
        max: 300,
        initial: 90
    },
    swing: {
        type: 'float',
        display: "percent",
        min: .5,
        max: .75,
        initial: .5,
        step: .01
    },
    compas: {
        type: 'enum',
        options: [
            '2/4',
            '3/4',
            '4/4'
        ],
        initial: '4/4'
    },
    tonality: {
        type: 'enum',
        options: [
            'c:major',
            'c:minor',
            'c#:major',
            'c#:minor',
            'd:major',
            'd:minor',
            'eb:major',
            'eb:minor',
            'e:major',
            'e:minor',
            'f:major',
            'f:minor',
            'f#:major',
            'f#:minor',
            'g:major',
            'g:minor',
            'ab:major',
            'ab:minor',
            'a:major',
            'a:minor',
            'bb:major',
            'bb:minor',
            'b:major',
            'b:minor'
        ],
        initial: 'c:minor'
    }
};
const $429eded906a18dec$var$INITIAL_RETURNS_STATE = {
    "delayA": {
        parameters: {
            ...(0, $1zQag.getInitialParamValues)((0, $29BVo.DelayReturn).parametersDescription),
            feedback: 0
        }
    },
    "delayB": {
        parameters: (0, $1zQag.getInitialParamValues)((0, $29BVo.DelayReturn).parametersDescription)
    },
    "reverbA": {
        parameters: {
            ...(0, $1zQag.getInitialParamValues)((0, $duZNX.ReverbReturn).parametersDescription),
            time: "1/8"
        }
    },
    "reverbB": {
        parameters: (0, $1zQag.getInitialParamValues)((0, $duZNX.ReverbReturn).parametersDescription)
    }
};
function $429eded906a18dec$var$dequeueSlot(state, action) {
    const { instrumentID: instrumentID } = action.payload;
    const launchQueue = state.transport.launchedSlots[instrumentID];
    if (launchQueue.nextScene !== undefined) {
        launchQueue.currentScene = launchQueue.nextScene;
        launchQueue.nextScene = undefined;
    }
}
function $429eded906a18dec$var$deleteAndReplacePreset(state, deletedPresetID, replacerPresetID) {
    Object.values(state.instruments).forEach((instrument)=>{
        if (instrument.parameters.presetID === deletedPresetID) instrument.parameters.presetID = replacerPresetID;
    });
    delete state.presets[deletedPresetID];
}
const $429eded906a18dec$var$projectSlice = (0, $6JzMn.createSlice)({
    name: 'project',
    initialState: {
        metadata: Object.fromEntries([
            'id',
            'name',
            'connected_users'
        ].map((key)=>[
                key,
                undefined
            ])),
        scenes: {
            [(0, $kmdF6.makeUID)("scene")]: {
                name: "Escena 1",
                slots: {}
            },
            [(0, $kmdF6.makeUID)("scene")]: {
                name: "Escena 2",
                slots: {}
            },
            [(0, $kmdF6.makeUID)("scene")]: {
                name: "Escena 3",
                slots: {}
            }
        },
        instruments: {},
        presets: Object.fromEntries((0, $eng2W.factoryPresets).map((preset)=>[
                (0, $kmdF6.makeUID)("preset"),
                preset
            ])),
        returns: $429eded906a18dec$var$INITIAL_RETURNS_STATE,
        masterChannel: {
            parameters: {
                ...(0, $1zQag.getInitialParamValues)((0, $lejHD.MasterChannel).parametersDescription)
            }
        },
        parameters: Object.fromEntries([
            ...Object.entries($429eded906a18dec$export$f5dab16f094d9602)
        ].map(([key, value])=>[
                key,
                value.initial
            ])),
        transport: {
            ...Object.fromEntries([
                ...Object.entries($429eded906a18dec$export$1a9e3bdc92df48a8)
            ].map(([key, value])=>[
                    key,
                    value.initial
                ])),
            launchedSlots: {}
        },
        audio: Object.fromEntries([
            ...Object.entries($429eded906a18dec$export$c517347cbf138523)
        ].map(([key, value])=>[
                key,
                value.initial
            ]))
    },
    reducers: {
        loadAllData: (state, action)=>{
            Object.assign(state, action.payload);
            Object.keys(action.payload.instruments).forEach((instrument)=>{
                state.transport.launchedSlots[instrument] ??= {
                    currentScene: null,
                    nextScene: undefined
                };
            });
        },
        updateMetadata: (state, action)=>{
            state.metadata[action.payload.name] = action.payload.value;
        },
        setProjectParameter: (state, action)=>{
            state.parameters[action.payload.name] = action.payload.value;
        },
        setTransportParameter: (state, action)=>{
            const { name: name, value: value } = action.payload;
            if (name === "isPlaying" || name == "") throw new Error(`There are individual actions for setting transport/${name}`);
            state.transport[name] = value;
            if (name === "playbackMode") {
                if (value === "followArrangement") Object.values(state.transport.launchedSlots).forEach((launchQueue)=>{
                    launchQueue.nextScene = undefined;
                });
                else if (value === "followInstruments") Object.values(state.transport.launchedSlots).forEach((launchQueue)=>{
                    launchQueue.currentScene = null;
                    launchQueue.nextScene = undefined;
                });
            }
        },
        transportStart: (state, _action)=>{
            state.transport.isPlaying = true;
        },
        transportStop: (state, _action)=>{
            state.transport.isPlaying = false;
        },
        enqueueSlot: (state, action)=>{
            const { sceneID: sceneID, instrumentID: instrumentID } = action.payload;
            state.transport.launchedSlots[instrumentID].nextScene = sceneID;
            if (!state.transport.isPlaying) $429eded906a18dec$var$dequeueSlot(state, {
                payload: {
                    instrumentID: instrumentID
                }
            });
        },
        launchScene: (state, action)=>{
            const { sceneID: sceneID } = action.payload;
            Object.keys(state.instruments).forEach((instrumentID)=>state.transport.launchedSlots[instrumentID].currentScene = sceneID);
        },
        dequeueSlots: (state, _action)=>{
            Object.keys(state.instruments).forEach((instrumentID)=>$429eded906a18dec$var$dequeueSlot(state, {
                    payload: {
                        instrumentID: instrumentID
                    }
                }));
        },
        setAudioParameter: (state, action)=>{
            state.audio[action.payload.name] = action.payload.value;
            if (action.payload.name === "usesAudioEngine" && action.payload.value === false) state.transport = {
                ...state.transport,
                isPlaying: false,
                isRecordArmed: false,
                isRecordingProject: false
            };
        },
        addInstrument: (state, action)=>{
            const { id: id, data: data } = action.payload;
            state.instruments[id] = data;
            Object.values(state.scenes).forEach((scene)=>scene.slots[id] = {
                    presetID: 'init'
                });
        },
        removeInstrument: (state, action)=>{
            const { id: id } = action.payload;
            Object.values(state.scenes).forEach((scene)=>delete scene.slots[id]);
            delete state.instruments[id];
        },
        renameInstrument: (state, action)=>{
            const { id: id, name: name } = action.payload;
            state.instruments[id].name = name;
        },
        reorderInstrument: (state, action)=>{
            const { id: id, index: index } = action.payload;
            const array = Object.entries(state.instruments);
            const previousIndex = array.findIndex(([candidateId, _])=>candidateId === id);
            const [instrument] = array.splice(previousIndex, 1);
            array.splice(index, 0, instrument);
            state.instruments = Object.fromEntries(array);
        },
        setInstrumentParameter: (state, action)=>{
            // these parameters are the parameters untied to presets
            // ensureValidValue is missing right now
            const { instrumentID: instrumentID, parameter: parameter, value: value } = action.payload;
            state.instruments[instrumentID].parameters[parameter] = value;
        },
        makePreset: (state, action)=>{
            const { presetID: presetID, data: data } = action.payload;
            state.presets[presetID] = data;
        },
        savePreset: (state, action)=>{
            const { presetID: presetID, name: name, overwrittenID: overwrittenID } = action.payload;
            state.presets[presetID]._metadata.name = name;
            delete state.presets[presetID]._metadata.isUnsaved;
            if (overwrittenID) $429eded906a18dec$var$deleteAndReplacePreset(state, overwrittenID, presetID);
        },
        deletePreset: (state, action)=>{
            const { presetID: presetID } = action.payload;
            $429eded906a18dec$var$deleteAndReplacePreset(state, presetID, "init");
        },
        loadPresetInInstrument: (state, action)=>{
            const { presetID: presetID, instrumentID: instrumentID } = action.payload;
            const previousPresetID = state.instruments[instrumentID].parameters.presetID;
            state.instruments[instrumentID].parameters.presetID = presetID;
            if (previousPresetID !== "init" && presetID !== previousPresetID && state.presets[previousPresetID]._metadata.isUnsaved) delete state.presets[previousPresetID];
        },
        setReturnParameter: (state, action)=>{
            const { returnName: returnName, parameter: parameter, value: value } = action.payload;
            state.returns[returnName].parameters[parameter] = value;
        },
        setMasterChannelParameter: (state, action)=>{
            const { name: name, value: value } = action.payload;
            state.masterChannel.parameters[name] = value;
        },
        setPresetParameter: (state, action)=>{
            const { presetID: presetID, parameter: parameter, value: value } = action.payload;
            if (!(presetID in state.presets)) {
                console.warn(`Preset with id ${presetID} could not be found in the store. Maybe there's a makePreset action that still didn't arrive?`);
                return;
            }
            state.presets[presetID][parameter] = value;
        },
        setClip: (state, action)=>{
            const { instrumentID: instrumentID, clipNumber: clipNumber, value: value } = action.payload;
            state.instruments[instrumentID].clips[clipNumber] = value;
        },
        setClipParameter: (state, action)=>{
            const { instrumentID: instrumentID, parameter: parameter, value: value } = action.payload;
            const clipNumber = action.payload.clipNumber ?? state.instruments[instrumentID].parameters.clipNumber;
            state.instruments[instrumentID].clips[clipNumber].sound[parameter] = value;
        },
        clearClip: (state, action)=>{
            const { instrumentID: instrumentID, clipNumber: clipNumber } = action.payload;
            const clip = state.instruments[instrumentID].clips[clipNumber];
            if (clip.sound) clip.sound = {};
            if (clip.sequence) clip.sequence = [];
        },
        setClipSequence: (state, action)=>{
            const { instrumentID: instrumentID, clipNumber: clipNumber, value: value } = action.payload;
            state.instruments[instrumentID].clips[clipNumber].sequence = value;
        },
        setClipLength: (state, action)=>{
            const { instrumentID: instrumentID, clipNumber: clipNumber, value: value } = action.payload;
            state.instruments[instrumentID].clips[clipNumber].length = value;
        },
        addScene: (state, action)=>{
            const { id: id, name: name } = action.payload;
            state.scenes[id] = {
                slots: Object.fromEntries([
                    ...Object.keys(state.instruments)
                ].map((id)=>[
                        id,
                        {
                            presetID: 'init'
                        }
                    ])),
                name: name
            };
        },
        removeScene: (state, action)=>{
            const { id: id } = action.payload;
            delete state.scenes[id];
        },
        renameScene: (state, action)=>{
            const { id: id, name: name } = action.payload;
            state.scenes[id].name = name;
        },
        reorderScene: (state, action)=>{
            const { id: id, index: index } = action.payload;
            const array = Object.entries(state.scenes);
            const previousIndex = array.findIndex(([candidateId, _])=>candidateId === id);
            const [scene] = array.splice(previousIndex, 1);
            array.splice(index, 0, scene);
            state.scenes = Object.fromEntries(array);
        },
        setSceneDuration: (state, action)=>{
            const { id: id, duration: duration } = action.payload;
            state.scenes[id].duration = duration;
        },
        setClipNumberForInstrumentInScene: (state, action)=>{
            const { instrumentID: instrumentID, sceneID: sceneID, clipNumber: clipNumber } = action.payload;
            state.scenes[sceneID].slots[instrumentID].clipNumber = clipNumber;
        },
        removeClipForInstrumentInScene: (state, action)=>{
            const { instrumentID: instrumentID, sceneID: sceneID } = action.payload;
            delete state.scenes[sceneID].slots[instrumentID].clipNumber;
        },
        setPresetIDForInstrumentInScene: (state, action)=>{
            const { instrumentID: instrumentID, sceneID: sceneID, presetID: presetID } = action.payload;
            state.scenes[sceneID].slots[instrumentID].presetID = presetID;
        }
    }
});
function $429eded906a18dec$var$updateAudioGraphForInstrumentsWithNewPreset(previousState, newPreset) {
    Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>{
        if (newPreset === instrument.getPlaybackPresetID() && newPreset !== instrument.getPlaybackPresetID(previousState)) instrument.updateAudioGraphForPlaybackPreset();
    });
}
// Triguejem canvis a l'audio graph després d'actualitzar l'store
const $429eded906a18dec$var$audioApplier = (storeAPI)=>(next)=>(action)=>{
            const previousState = storeAPI.getState();
            let result = next(action); // primer actualitzem l'store
            const currentState = storeAPI.getState();
            if ((0, $9xysn.getCurrentProject)() == null) return result;
            switch(action.type){
                case "project/loadAllData":
                    Object.entries(action.payload.instruments).forEach(([instrumentID, instrumentData])=>(0, $Lbl7Y.getAudioGraphInstance)().addInstrument(instrumentID, instrumentData));
                    break;
                case "project/setInstrumentParameter":
                    const { instrumentID: instrumentID, parameter: parameter, value: value } = action.payload;
                    if (parameter === "isSolo" || parameter === "isMute") {
                        Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.updateMute());
                        break;
                    }
                    const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
                    instrument.applyAudioGraphParameter(parameter, value);
                    break;
                case "project/savePreset":
                    {
                        const { presetID: presetID } = action.payload;
                        $429eded906a18dec$var$updateAudioGraphForInstrumentsWithNewPreset(previousState, presetID);
                        break;
                    }
                case "project/deletePreset":
                    $429eded906a18dec$var$updateAudioGraphForInstrumentsWithNewPreset(previousState, "init");
                    break;
                case "project/loadPresetInInstrument":
                    {
                        const { presetID: presetID, instrumentID: instrumentID } = action.payload;
                        const instrument = (0, $9xysn.getCurrentProject)().getInstrument(instrumentID);
                        if (presetID === instrument.getPlaybackPresetID()) instrument.updateAudioGraphForPlaybackPreset();
                        break;
                    }
                case "project/setReturnParameter":
                    {
                        const { returnName: returnName, parameter: parameter, value: value } = action.payload;
                        const returnNode = (0, $Lbl7Y.getAudioGraphInstance)().returns[returnName];
                        returnNode[parameter] = value;
                        break;
                    }
                case "project/setMasterChannelParameter":
                    {
                        const { name: name, value: value } = action.payload;
                        (0, $Lbl7Y.getAudioGraphInstance)().masterChannel[name] = value;
                        break;
                    }
                case "project/setPresetParameter":
                    {
                        const { presetID: presetID, parameter: parameter, value: value } = action.payload;
                        if (!(presetID in $429eded906a18dec$export$b7b92364caf81104(currentState))) break;
                        const instrumentType = $429eded906a18dec$export$b7b92364caf81104(currentState)[presetID]._metadata.instrumentType;
                        (0, $9xysn.getCurrentProject)().getInstrumentsOfType(instrumentType).forEach((instrument)=>{
                            if (presetID === instrument.getPlaybackPresetID()) instrument.applyAudioGraphParameter(parameter, value);
                        });
                        break;
                    }
                case "project/setClip":
                    {
                        const { instrumentID: instrumentID } = action.payload;
                        // would be more optimized if it only did it when the clip corresponded to the playback clip
                        // also only for audio clips (the ones used in looper), not midi clips, as those don't have any audiograph parameters.
                        (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).updateAudioGraphForPlaybackClip();
                        break;
                    }
                case "project/setClipParameter":
                    {
                        const { instrumentID: instrumentID, parameter: parameter, value: value } = action.payload;
                        (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).applyAudioGraphParameter(parameter, value);
                        break;
                    }
                case "project/setProjectParameter":
                    {
                        const { name: name, value: value } = action.payload;
                        switch(name){
                            case 'bpm':
                                (0, $Lbl7Y.getAudioGraphInstance)().applyBpm(value);
                                break;
                        }
                        break;
                    }
                case "project/setAudioParameter":
                    {
                        const { name: name, value: value } = action.payload;
                        switch(name){
                            case "usesAudioEngine":
                                if (value) (0, $Lbl7Y.getAudioGraphInstance)().turnAudioOn(); //must be initialized from user action so can't go here
                                else (0, $Lbl7Y.getAudioGraphInstance)().turnAudioOff();
                        }
                        break;
                    }
                case "project/addInstrument":
                    (0, $9xysn.getCurrentProject)().afegeixInstrument(action.payload.id, action.payload.data); // todo: remove this. instrument objects should go in audioinstance
                    (0, $Lbl7Y.getAudioGraphInstance)().addInstrument(action.payload.id, action.payload.data);
                    break;
                case "project/removeInstrument":
                    (0, $Lbl7Y.getAudioGraphInstance)().removeInstrument(action.payload.id);
                    (0, $9xysn.getCurrentProject)().eliminaInstrument(action.payload.id); // todo: remove this. instrument objects should go in audioinstance
                    break;
                case "project/setTransportParameter":
                    const { name: name } = action.payload;
                    if (name === "currentStep") // this should actually go in server communications middleware.
                    // also maybe isTransposrtSyncMaster could come from state directly
                    {
                        if ((0, $Lbl7Y.getAudioGraphInstance)().isTransportSyncMaster()) sendMessageToServer('update_master_sequencer_current_step', {
                            current_step: currentStep
                        });
                    } else if (name === "playbackMode") Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.applyStateToAudioGraph());
                    break;
                case "project/transportStart":
                    (0, $Lbl7Y.getAudioGraphInstance)().transportStart();
                    break;
                case "project/transportStop":
                    (0, $Lbl7Y.getAudioGraphInstance)().transportStop();
                    break;
                case "project/setClipNumberForInstrumentInScene":
                    {
                        const { instrumentID: instrumentID } = action.payload;
                        if ($429eded906a18dec$export$87e772c289df96a3(currentState) === "followLauncher") (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).updateAudioGraphForPlaybackClip();
                        break;
                    }
                case "project/setPresetIDForInstrumentInScene":
                    {
                        const { instrumentID: instrumentID } = action.payload;
                        if ($429eded906a18dec$export$87e772c289df96a3(currentState) === "followLauncher") (0, $9xysn.getCurrentProject)().getInstrument(instrumentID).updateAudioGraphForPlaybackPreset();
                        break;
                    }
                case "project/launchScene":
                    // todo: només s'ha d'actualitzar pels presets que han canviat!
                    Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.updateAudioGraphForPlaybackPreset());
                    // todo: només s'ha d'actualitzar pels clips que han canviat!
                    Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.updateAudioGraphForPlaybackPreset());
                    break;
                case "project/dequeueSlots":
                    // todo: només s'ha d'actualitzar pels presets que han canviat!
                    Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.updateAudioGraphForPlaybackPreset());
                    // todo: només s'ha d'actualitzar pels clips que han canviat!
                    Object.values((0, $9xysn.getCurrentProject)().instruments).forEach((instrument)=>instrument.updateAudioGraphForPlaybackPreset());
                    break;
            }
            return result;
        };
const $429eded906a18dec$var$serverSenderMiddleware = (_storeAPI)=>(next)=>(action)=>{
            let result = next(action);
            if ((0, $9xysn.getCurrentProject)() == null) return result;
            if (action.type.startsWith("project") && action.type !== "project/loadAllData" // don't want to trigger that here
             && action.type !== "project/setTransportParameter" // all of these are local. perhaps it' be better to specify it in the payload
             && action.type !== "project/transportStart" // local
             && action.type !== "project/transportStop" // local
             && action.type !== "project/enqueueSlot" // local
             && action.type !== "project/launchScene" // local
             && action.type !== "project/dequeueSlots" // local
             && action.type !== "project/setAudioParameter" // all of these are local. perhaps it' be better to specify it in the payload
             && !action.payload.isLocal) (0, $iJ8Ef.sendProjectActionToServer)(action);
            return result;
        };
// local settings
const $429eded906a18dec$var$settingsSlice = (0, $6JzMn.createSlice)({
    name: 'settings',
    initialState: {
        sampleRate: 27500,
        midiDevice: null
    },
    reducers: {
        setSampleRate: (state, action)=>{
            const value = action.payload;
            state.sampleRate = value;
        },
        setMidiDevice: (state, action)=>{
            const value = action.payload;
            state.midiDevice = value;
        }
    }
});
const $429eded906a18dec$var$settingsMiddleware = (_storeAPI)=>(next)=>(action)=>{
            let result = next(action);
            if (action.type === "settings/setMidiDevice") (0, $lsfK2.midiHandler).externalDeviceManager.bindToInput(action.payload);
            return result;
        };
// persistence (localstorage)
// from https://read.reduxbook.com/markdown/part2/12-clientside-persistance
// it could be a bit smarter about how it does stuff
const $429eded906a18dec$var$persistMiddleware = (storeAPI)=>(next)=>(action)=>{
            const result = next(action);
            const shouldPersist = action.type.startsWith("settings");
            if (shouldPersist) {
                const appState = storeAPI.getState();
                localStorage.setItem('settings', JSON.stringify(appState.settings));
            }
            return result;
        };
const $429eded906a18dec$var$persistedSettings = JSON.parse(localStorage.getItem('settings')) ?? undefined;
var $429eded906a18dec$export$2e2bcd8739ae039 = (0, $6JzMn.configureStore)({
    reducer: {
        project: $429eded906a18dec$var$projectSlice.reducer,
        settings: $429eded906a18dec$var$settingsSlice.reducer
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat($429eded906a18dec$var$audioApplier).concat($429eded906a18dec$var$serverSenderMiddleware).concat($429eded906a18dec$var$settingsMiddleware).concat($429eded906a18dec$var$persistMiddleware),
    preloadedState: {
        settings: {
            ...$429eded906a18dec$var$settingsSlice.getInitialState(),
            ...$429eded906a18dec$var$persistedSettings
        }
    }
});
const { loadAllData: $429eded906a18dec$export$e68235ca2e24c89f, updateMetadata: $429eded906a18dec$export$f64791b2d30456a0, setProjectParameter: $429eded906a18dec$export$7ff02179fafde784, setTransportParameter: $429eded906a18dec$export$c4e0353812e422a1, transportStart: $429eded906a18dec$export$9b404dddf3c2c59c, transportStop: $429eded906a18dec$export$131758e4d8b93c18, enqueueSlot: $429eded906a18dec$export$ef8fedd693c07732, launchScene: $429eded906a18dec$export$6333097d0417164c, dequeueSlots: $429eded906a18dec$export$946f2512a2b4acf2, setAudioParameter: $429eded906a18dec$export$449206e40bce4823, addInstrument: $429eded906a18dec$export$4669b2c5491c889d, removeInstrument: $429eded906a18dec$export$a1b3fddc9c10efe5, reorderInstrument: $429eded906a18dec$export$b3801e6e28ea1bb7, renameInstrument: $429eded906a18dec$export$b748eeb65de9131, setInstrumentParameter: $429eded906a18dec$export$9c1e17bd211c9484, makePreset: $429eded906a18dec$export$80d9bf384fafdbe3, savePreset: $429eded906a18dec$export$748a59e2e8df3f84, deletePreset: $429eded906a18dec$export$f6f31fb6da61ffc6, loadPresetInInstrument: $429eded906a18dec$export$ee7d1eb600e0574e, setReturnParameter: $429eded906a18dec$export$6c8618ce4b276e3e, setMasterChannelParameter: $429eded906a18dec$export$3bbb881ba35ada42, setPresetParameter: $429eded906a18dec$export$b45c2f84691e89f5, setClip: $429eded906a18dec$export$7aa51ddbfe0fd37, setClipParameter: $429eded906a18dec$export$bf84d4379af6199e, clearClip: $429eded906a18dec$export$97a72b68e947086c, setClipSequence: $429eded906a18dec$export$6b7a1926d1d5380b, setClipLength: $429eded906a18dec$export$f4a8918cb8d652dd, addScene: $429eded906a18dec$export$f12804300e12d9b5, removeScene: $429eded906a18dec$export$a503903e1b3bf31d, reorderScene: $429eded906a18dec$export$c7baab7eac801307, renameScene: $429eded906a18dec$export$4be0c382b928103d, setSceneDuration: $429eded906a18dec$export$fc0d2fe4d1136a2a, setClipNumberForInstrumentInScene: $429eded906a18dec$export$437bb54ade051fda, removeClipForInstrumentInScene: $429eded906a18dec$export$a2812aa45861379f, setPresetIDForInstrumentInScene: $429eded906a18dec$export$8fe1f3e5f44b5a90 } = $429eded906a18dec$var$projectSlice.actions;
const $429eded906a18dec$export$6a772d98df0515d3 = (state)=>state.project;
const $429eded906a18dec$export$ebeafd64c6387f41 = (state)=>state.project.metadata.id;
const $429eded906a18dec$export$f5395d40a245914b = (state)=>state.project.metadata.name;
const $429eded906a18dec$export$57ee93a2b2140c3a = (state)=>state.project.metadata.connected_users;
const $429eded906a18dec$export$636b7292e5260c06 = (state)=>state.project.scenes;
const $429eded906a18dec$export$929d46894c79a034 = (0, $dkYqL.createSelector)($429eded906a18dec$export$636b7292e5260c06, (scenes)=>{
    let nextOnset = 0;
    return Object.entries(scenes).map(([sceneID, { duration: duration, name: name }])=>{
        const onset = nextOnset;
        const length = (duration ?? 2) * 16;
        nextOnset += length;
        return {
            sceneID: sceneID,
            name: name,
            length: length,
            onset: onset
        };
    });
});
const $429eded906a18dec$export$382fa7f15ec21837 = (state)=>state.project.parameters.bpm;
const $429eded906a18dec$export$a497cf8e85411d6d = (state)=>state.project.parameters.compas;
const $429eded906a18dec$export$135d3d1f1b6d27ef = (state)=>state.project.parameters.swing;
const $429eded906a18dec$export$14baf6d1bec8e229 = (state)=>state.project.parameters.tonality;
const $429eded906a18dec$export$32e491a5aaebe381 = (state)=>state.project.instruments;
const $429eded906a18dec$export$865abdeaca175171 = (0, $dkYqL.createSelector)($429eded906a18dec$export$32e491a5aaebe381, (instruments)=>Object.keys(instruments));
const $429eded906a18dec$export$5e2ab70291075819 = (state)=>[
        ...Object.values($429eded906a18dec$export$32e491a5aaebe381(state))
    ].some((data)=>data.parameters.isSolo);
const $429eded906a18dec$export$b7b92364caf81104 = (state)=>state.project.presets;
const $429eded906a18dec$export$87dd0df04b2f6db3 = (state)=>state.project.transport.isRecordingProject;
const $429eded906a18dec$export$5069376b6a450582 = (state)=>state.project.transport.isRecordArmed;
const $429eded906a18dec$export$f4ca3cdb12871ee = (state)=>state.project.transport.isPlaying;
const $429eded906a18dec$export$cdc7cce98fe9eaba = (state)=>state.project.transport.isMetronomeEnabled;
const $429eded906a18dec$export$3b3601b87b4c407c = (state)=>state.project.transport.currentStep;
const $429eded906a18dec$export$4ee6d038db429de2 = (state)=>state.project.transport.playStartMarkerStep;
const $429eded906a18dec$export$af1cbe857b379c72 = (state)=>state.project.transport.sync;
const $429eded906a18dec$export$87e772c289df96a3 = (state)=>state.project.transport.playbackMode;
const $429eded906a18dec$export$c27c41bdc08988ec = (state)=>state.project.transport.launchedSlots;
const $429eded906a18dec$export$c56152a462dae80f = (0, $dkYqL.createSelector)($429eded906a18dec$export$87e772c289df96a3, $429eded906a18dec$export$3b3601b87b4c407c, $429eded906a18dec$export$636b7292e5260c06, (playbackMode, currentStep1, scenes)=>{
    const startingBars = (0, $abvlt.dx2x)([
        ...Object.values(scenes)
    ].map(({ duration: duration = (0, (/*@__PURE__*/$parcel$interopDefault($5vTj9))).SCENE_DURATION })=>duration)); // the last items is the ending measure
    if (playbackMode !== "followArrangement") return {
        step: currentStep1
    };
    const currentBar = Math.floor(currentStep1 / 16);
    let currentSceneIndex = 0;
    while(currentSceneIndex + 1 < startingBars.length){
        if (startingBars[currentSceneIndex + 1] > currentBar) break;
        currentSceneIndex++;
    }
    if (currentSceneIndex === startingBars.length - 1) return {}; // finished
    const currentSceneBar = currentBar - startingBars[currentSceneIndex];
    const step = currentStep1 - (currentBar - currentSceneBar) * 16;
    const sceneID = Object.keys(scenes)[currentSceneIndex];
    return {
        sceneID: sceneID,
        step: step
    };
});
const $429eded906a18dec$export$aeb6097ab7abbbf6 = (parameterName)=>(state)=>state.project.masterChannel.parameters[parameterName];
const $429eded906a18dec$export$384988ea521471f = (state)=>state.project.audio.usesAudioEngine;
const $429eded906a18dec$export$47597ed8b70ad005 = (state)=>state.project.audio.isGraphBuilt;
const $429eded906a18dec$export$907b9c28d386fa97 = (state)=>state.project.returns;
const $429eded906a18dec$export$8be617ca0bf09b00 = (returnName, parameterName)=>(state)=>state.project.returns[returnName].parameters[parameterName];
$429eded906a18dec$export$f5dab16f094d9602.swing.selector = $429eded906a18dec$export$135d3d1f1b6d27ef;
$429eded906a18dec$export$f5dab16f094d9602.swing.updater = (value)=>$429eded906a18dec$export$7ff02179fafde784({
        name: "swing",
        value: value
    });
$429eded906a18dec$export$f5dab16f094d9602.bpm.selector = $429eded906a18dec$export$382fa7f15ec21837;
$429eded906a18dec$export$f5dab16f094d9602.bpm.updater = (value)=>$429eded906a18dec$export$7ff02179fafde784({
        name: "bpm",
        value: value
    });
const { setSampleRate: $429eded906a18dec$export$a2ece3d4ab026fd1, setMidiDevice: $429eded906a18dec$export$e89c725b4ea1dd04 } = $429eded906a18dec$var$settingsSlice.actions;
const $429eded906a18dec$export$696e925a4b9a1cbb = (state)=>state.settings.sampleRate;
const $429eded906a18dec$export$e3e8ebba082fcc9c = (state)=>state.settings.midiDevice; // https://redux-remember.js.org/quick-start/

});
parcelRegister("6JzMn", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $4e72b316ca7efe5f$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $4e72b316ca7efe5f$export$4d8d9bd83c24ae8b);

var $6eQYX = parcelRequire("6eQYX");

var $1qT0G = parcelRequire("1qT0G");

var $dkYqL = parcelRequire("dkYqL");

var $dWCD2 = parcelRequire("dWCD2");
var $4e72b316ca7efe5f$var$__defProp = Object.defineProperty;
var $4e72b316ca7efe5f$var$__defProps = Object.defineProperties;
var $4e72b316ca7efe5f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4e72b316ca7efe5f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4e72b316ca7efe5f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4e72b316ca7efe5f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4e72b316ca7efe5f$var$__defNormalProp = (obj, key, value)=>key in obj ? $4e72b316ca7efe5f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4e72b316ca7efe5f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4e72b316ca7efe5f$var$__hasOwnProp.call(b, prop)) $4e72b316ca7efe5f$var$__defNormalProp(a, prop, b[prop]);
    if ($4e72b316ca7efe5f$var$__getOwnPropSymbols) {
        for (var prop of $4e72b316ca7efe5f$var$__getOwnPropSymbols(b))if ($4e72b316ca7efe5f$var$__propIsEnum.call(b, prop)) $4e72b316ca7efe5f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4e72b316ca7efe5f$var$__spreadProps = (a, b)=>$4e72b316ca7efe5f$var$__defProps(a, $4e72b316ca7efe5f$var$__getOwnPropDescs(b));
var $4e72b316ca7efe5f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4e72b316ca7efe5f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4e72b316ca7efe5f$var$__getOwnPropSymbols) {
        for (var prop of $4e72b316ca7efe5f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4e72b316ca7efe5f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $4e72b316ca7efe5f$var$__publicField = (obj, key, value)=>$4e72b316ca7efe5f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $4e72b316ca7efe5f$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $dkYqL.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $1qT0G.isDraft)(value) ? (0, $1qT0G.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $4e72b316ca7efe5f$export$a5d3c27355e35910 = /* @__PURE__ */ $4e72b316ca7efe5f$export$aab6de9e3dbb1473((0, $dkYqL.weakMapMemoize));
// src/devtoolsExtension.ts
var $4e72b316ca7efe5f$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $6eQYX.compose;
    return (0, $6eQYX.compose).apply(null, arguments);
};
var $4e72b316ca7efe5f$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $4e72b316ca7efe5f$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4e72b316ca7efe5f$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(0));
            return $4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $6eQYX.isAction)(action) && action.type === type;
    return actionCreator;
}
function $4e72b316ca7efe5f$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $4e72b316ca7efe5f$var$hasMatchFunction(action);
}
function $4e72b316ca7efe5f$export$ebd532f9034651f3(action) {
    return (0, $6eQYX.isAction)(action) && Object.keys(action).every($4e72b316ca7efe5f$var$isValidKey);
}
function $4e72b316ca7efe5f$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $4e72b316ca7efe5f$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $4e72b316ca7efe5f$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $4e72b316ca7efe5f$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $4e72b316ca7efe5f$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $4e72b316ca7efe5f$var$freezeDraftable(val) {
    return (0, $1qT0G.isDraftable)(val) ? (0, $1qT0G.produce)(val, ()=>{}) : val;
}
function $4e72b316ca7efe5f$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $4e72b316ca7efe5f$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4e72b316ca7efe5f$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $4e72b316ca7efe5f$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $4e72b316ca7efe5f$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $4e72b316ca7efe5f$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $4e72b316ca7efe5f$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $4e72b316ca7efe5f$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $4e72b316ca7efe5f$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $4e72b316ca7efe5f$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $4e72b316ca7efe5f$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $6eQYX.isPlainObject)(val);
}
function $4e72b316ca7efe5f$export$ada5dca0b571bc7(value, path = "", isSerializable = $4e72b316ca7efe5f$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4e72b316ca7efe5f$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $4e72b316ca7efe5f$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4e72b316ca7efe5f$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4e72b316ca7efe5f$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4e72b316ca7efe5f$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $4e72b316ca7efe5f$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $4e72b316ca7efe5f$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $4e72b316ca7efe5f$export$1908877435b1d5e9();
        if (thunk) {
            if ($4e72b316ca7efe5f$var$isBoolean(thunk)) middlewareArray.push((0, $dWCD2.thunk));
            else middlewareArray.push((0, $dWCD2.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $4e72b316ca7efe5f$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4e72b316ca7efe5f$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$4e72b316ca7efe5f$export$8fb31c0f05df007b]: true
            }
        });
var $4e72b316ca7efe5f$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $4e72b316ca7efe5f$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4e72b316ca7efe5f$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $4e72b316ca7efe5f$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4e72b316ca7efe5f$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $4e72b316ca7efe5f$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $4e72b316ca7efe5f$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($4e72b316ca7efe5f$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $4e72b316ca7efe5f$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $4e72b316ca7efe5f$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $6eQYX.isPlainObject)(reducer)) rootReducer = (0, $6eQYX.combineReducers)(reducer);
    else throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $6eQYX.compose);
    if (devTools) finalCompose = $4e72b316ca7efe5f$var$composeWithDevTools($4e72b316ca7efe5f$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $6eQYX.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $4e72b316ca7efe5f$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $6eQYX.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4e72b316ca7efe5f$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4e72b316ca7efe5f$var$isStateFunction(x) {
    return typeof x === "function";
}
function $4e72b316ca7efe5f$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $4e72b316ca7efe5f$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($4e72b316ca7efe5f$var$isStateFunction(initialState)) getInitialState = ()=>$4e72b316ca7efe5f$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $4e72b316ca7efe5f$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $1qT0G.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $1qT0G.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $1qT0G.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $4e72b316ca7efe5f$var$matches = (matcher, action)=>{
    if ($4e72b316ca7efe5f$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4e72b316ca7efe5f$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$4e72b316ca7efe5f$var$matches(matcher, action));
    };
}
function $4e72b316ca7efe5f$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$4e72b316ca7efe5f$var$matches(matcher, action));
    };
}
function $4e72b316ca7efe5f$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4e72b316ca7efe5f$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4e72b316ca7efe5f$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4e72b316ca7efe5f$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$4e72b316ca7efe5f$var$isAsyncThunkArray(asyncThunks)) return $4e72b316ca7efe5f$export$872dec21e9a69476()(asyncThunks[0]);
    return $4e72b316ca7efe5f$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $4e72b316ca7efe5f$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4e72b316ca7efe5f$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$4e72b316ca7efe5f$var$isAsyncThunkArray(asyncThunks)) return $4e72b316ca7efe5f$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $4e72b316ca7efe5f$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $4e72b316ca7efe5f$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $4e72b316ca7efe5f$export$9dd1fb32974da385($4e72b316ca7efe5f$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$4e72b316ca7efe5f$var$isAsyncThunkArray(asyncThunks)) return $4e72b316ca7efe5f$export$fcc3388fb56de601()(asyncThunks[0]);
    return $4e72b316ca7efe5f$export$9dd1fb32974da385($4e72b316ca7efe5f$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $4e72b316ca7efe5f$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4e72b316ca7efe5f$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$4e72b316ca7efe5f$var$isAsyncThunkArray(asyncThunks)) return $4e72b316ca7efe5f$export$1da80a6ef1307441()(asyncThunks[0]);
    return $4e72b316ca7efe5f$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $4e72b316ca7efe5f$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4e72b316ca7efe5f$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$4e72b316ca7efe5f$var$isAsyncThunkArray(asyncThunks)) return $4e72b316ca7efe5f$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $4e72b316ca7efe5f$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $4e72b316ca7efe5f$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4e72b316ca7efe5f$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $4e72b316ca7efe5f$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4e72b316ca7efe5f$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4e72b316ca7efe5f$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4e72b316ca7efe5f$var$__publicField(this, "_type");
    }
};
var $4e72b316ca7efe5f$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4e72b316ca7efe5f$var$__publicField(this, "_type");
    }
};
var $4e72b316ca7efe5f$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $4e72b316ca7efe5f$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4e72b316ca7efe5f$var$externalAbortMessage = "External signal was aborted";
var $4e72b316ca7efe5f$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $4e72b316ca7efe5f$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $4e72b316ca7efe5f$var$__spreadProps($4e72b316ca7efe5f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $4e72b316ca7efe5f$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $4e72b316ca7efe5f$var$__spreadProps($4e72b316ca7efe5f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $4e72b316ca7efe5f$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $4e72b316ca7efe5f$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4e72b316ca7efe5f$var$__spreadProps($4e72b316ca7efe5f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4e72b316ca7efe5f$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($4e72b316ca7efe5f$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($4e72b316ca7efe5f$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($4e72b316ca7efe5f$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $4e72b316ca7efe5f$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $4e72b316ca7efe5f$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $4e72b316ca7efe5f$var$RejectWithValue) throw result;
                                if (result instanceof $4e72b316ca7efe5f$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $4e72b316ca7efe5f$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($4e72b316ca7efe5f$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $4e72b316ca7efe5f$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $4e72b316ca7efe5f$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4e72b316ca7efe5f$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $4e72b316ca7efe5f$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $4e72b316ca7efe5f$export$343355ed40c51c46 = {
    [$4e72b316ca7efe5f$var$asyncThunkSymbol]: $4e72b316ca7efe5f$export$6abd22dc03e5063f
};
var $4e72b316ca7efe5f$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($4e72b316ca7efe5f$export$23a094319a4b586 || {});
function $4e72b316ca7efe5f$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $4e72b316ca7efe5f$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$4e72b316ca7efe5f$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($4e72b316ca7efe5f$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $4e72b316ca7efe5f$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($4e72b316ca7efe5f$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $4e72b316ca7efe5f$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $4e72b316ca7efe5f$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $4e72b316ca7efe5f$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $4e72b316ca7efe5f$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $4e72b316ca7efe5f$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $4e72b316ca7efe5f$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $4e72b316ca7efe5f$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $4e72b316ca7efe5f$var$wrapSelector(selector, selectState, ()=>$4e72b316ca7efe5f$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $4e72b316ca7efe5f$var$__spreadProps($4e72b316ca7efe5f$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $4e72b316ca7efe5f$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $4e72b316ca7efe5f$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $4e72b316ca7efe5f$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $4e72b316ca7efe5f$export$affdea4146de9cf5();
function $4e72b316ca7efe5f$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $4e72b316ca7efe5f$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $4e72b316ca7efe5f$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$4e72b316ca7efe5f$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $4e72b316ca7efe5f$export$309c7a02b0b0bc62(type, prepareCallback) : $4e72b316ca7efe5f$export$309c7a02b0b0bc62(type));
}
function $4e72b316ca7efe5f$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $4e72b316ca7efe5f$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $4e72b316ca7efe5f$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $4e72b316ca7efe5f$var$noop,
        pending: pending || $4e72b316ca7efe5f$var$noop,
        rejected: rejected || $4e72b316ca7efe5f$var$noop,
        settled: settled || $4e72b316ca7efe5f$var$noop
    });
}
function $4e72b316ca7efe5f$var$noop() {}
// src/entities/entity_state.ts
function $4e72b316ca7efe5f$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4e72b316ca7efe5f$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($4e72b316ca7efe5f$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4e72b316ca7efe5f$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $4e72b316ca7efe5f$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $4e72b316ca7efe5f$var$isDraftTyped = (0, $1qT0G.isDraft);
function $4e72b316ca7efe5f$var$createSingleArgumentStateOperator(mutator) {
    const operator = $4e72b316ca7efe5f$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4e72b316ca7efe5f$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4e72b316ca7efe5f$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($4e72b316ca7efe5f$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $1qT0G.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $4e72b316ca7efe5f$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $4e72b316ca7efe5f$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4e72b316ca7efe5f$var$getCurrent(value) {
    return (0, $1qT0G.isDraft)(value) ? (0, $1qT0G.current)(value) : value;
}
function $4e72b316ca7efe5f$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $4e72b316ca7efe5f$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $4e72b316ca7efe5f$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4e72b316ca7efe5f$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $4e72b316ca7efe5f$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $4e72b316ca7efe5f$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $4e72b316ca7efe5f$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$4e72b316ca7efe5f$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $4e72b316ca7efe5f$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $4e72b316ca7efe5f$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4e72b316ca7efe5f$var$createStateOperator(addOneMutably),
        addMany: $4e72b316ca7efe5f$var$createStateOperator(addManyMutably),
        setOne: $4e72b316ca7efe5f$var$createStateOperator(setOneMutably),
        setMany: $4e72b316ca7efe5f$var$createStateOperator(setManyMutably),
        setAll: $4e72b316ca7efe5f$var$createStateOperator(setAllMutably),
        updateOne: $4e72b316ca7efe5f$var$createStateOperator(updateOneMutably),
        updateMany: $4e72b316ca7efe5f$var$createStateOperator(updateManyMutably),
        upsertOne: $4e72b316ca7efe5f$var$createStateOperator(upsertOneMutably),
        upsertMany: $4e72b316ca7efe5f$var$createStateOperator(upsertManyMutably),
        removeOne: $4e72b316ca7efe5f$var$createStateOperator(removeOneMutably),
        removeMany: $4e72b316ca7efe5f$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4e72b316ca7efe5f$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $4e72b316ca7efe5f$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $4e72b316ca7efe5f$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $4e72b316ca7efe5f$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $4e72b316ca7efe5f$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $4e72b316ca7efe5f$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $4e72b316ca7efe5f$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4e72b316ca7efe5f$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $4e72b316ca7efe5f$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $4e72b316ca7efe5f$var$getCurrent(state.entities);
        const currentIds = $4e72b316ca7efe5f$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $4e72b316ca7efe5f$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4e72b316ca7efe5f$var$createStateOperator(addOneMutably),
        updateOne: $4e72b316ca7efe5f$var$createStateOperator(updateOneMutably),
        upsertOne: $4e72b316ca7efe5f$var$createStateOperator(upsertOneMutably),
        setOne: $4e72b316ca7efe5f$var$createStateOperator(setOneMutably),
        setMany: $4e72b316ca7efe5f$var$createStateOperator(setManyMutably),
        setAll: $4e72b316ca7efe5f$var$createStateOperator(setAllMutably),
        addMany: $4e72b316ca7efe5f$var$createStateOperator(addManyMutably),
        updateMany: $4e72b316ca7efe5f$var$createStateOperator(updateManyMutably),
        upsertMany: $4e72b316ca7efe5f$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4e72b316ca7efe5f$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $4e72b316ca7efe5f$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $4e72b316ca7efe5f$var$createSortedStateAdapter(selectId, sortComparer) : $4e72b316ca7efe5f$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $4e72b316ca7efe5f$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $4e72b316ca7efe5f$var$createSelectorsFactory();
    return $4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues($4e72b316ca7efe5f$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $4e72b316ca7efe5f$var$task = "task";
var $4e72b316ca7efe5f$var$listener = "listener";
var $4e72b316ca7efe5f$var$completed = "completed";
var $4e72b316ca7efe5f$var$cancelled = "cancelled";
var $4e72b316ca7efe5f$var$taskCancelled = `task-${$4e72b316ca7efe5f$var$cancelled}`;
var $4e72b316ca7efe5f$var$taskCompleted = `task-${$4e72b316ca7efe5f$var$completed}`;
var $4e72b316ca7efe5f$var$listenerCancelled = `${$4e72b316ca7efe5f$var$listener}-${$4e72b316ca7efe5f$var$cancelled}`;
var $4e72b316ca7efe5f$var$listenerCompleted = `${$4e72b316ca7efe5f$var$listener}-${$4e72b316ca7efe5f$var$completed}`;
var $4e72b316ca7efe5f$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $4e72b316ca7efe5f$var$__publicField(this, "name", "TaskAbortError");
        $4e72b316ca7efe5f$var$__publicField(this, "message");
        this.message = `${$4e72b316ca7efe5f$var$task} ${$4e72b316ca7efe5f$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $4e72b316ca7efe5f$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($4e72b316ca7efe5f$export$378fa86b259c0280(32));
};
var $4e72b316ca7efe5f$var$noop2 = ()=>{};
var $4e72b316ca7efe5f$var$catchRejection = (promise, onError = $4e72b316ca7efe5f$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $4e72b316ca7efe5f$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $4e72b316ca7efe5f$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $4e72b316ca7efe5f$export$cb1bdac908fed7f(signal.reason);
};
function $4e72b316ca7efe5f$var$raceWithSignal(signal, promise) {
    let cleanup = $4e72b316ca7efe5f$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $4e72b316ca7efe5f$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4e72b316ca7efe5f$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $4e72b316ca7efe5f$var$noop2;
    });
}
var $4e72b316ca7efe5f$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $4e72b316ca7efe5f$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $4e72b316ca7efe5f$var$createPause = (signal)=>{
    return (promise)=>{
        return $4e72b316ca7efe5f$var$catchRejection($4e72b316ca7efe5f$var$raceWithSignal(signal, promise).then((output)=>{
            $4e72b316ca7efe5f$var$validateActive(signal);
            return output;
        }));
    };
};
var $4e72b316ca7efe5f$var$createDelay = (signal)=>{
    const pause = $4e72b316ca7efe5f$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $4e72b316ca7efe5f$var$assign } = Object;
var $4e72b316ca7efe5f$var$INTERNAL_NIL_TOKEN = {};
var $4e72b316ca7efe5f$var$alm = "listenerMiddleware";
var $4e72b316ca7efe5f$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$4e72b316ca7efe5f$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $4e72b316ca7efe5f$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $4e72b316ca7efe5f$var$runTask(async ()=>{
            $4e72b316ca7efe5f$var$validateActive(parentAbortSignal);
            $4e72b316ca7efe5f$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $4e72b316ca7efe5f$var$createPause(childAbortController.signal),
                delay: $4e72b316ca7efe5f$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $4e72b316ca7efe5f$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($4e72b316ca7efe5f$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($4e72b316ca7efe5f$var$noop2));
        return {
            result: $4e72b316ca7efe5f$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($4e72b316ca7efe5f$var$taskCancelled);
            }
        };
    };
};
var $4e72b316ca7efe5f$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $4e72b316ca7efe5f$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $4e72b316ca7efe5f$var$raceWithSignal(signal, Promise.race(promises));
            $4e72b316ca7efe5f$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$4e72b316ca7efe5f$var$catchRejection(take(predicate, timeout));
};
var $4e72b316ca7efe5f$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $4e72b316ca7efe5f$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(21));
    $4e72b316ca7efe5f$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4e72b316ca7efe5f$var$createListenerEntry = /* @__PURE__ */ $4e72b316ca7efe5f$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $4e72b316ca7efe5f$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $4e72b316ca7efe5f$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$4e72b316ca7efe5f$var$createListenerEntry
});
var $4e72b316ca7efe5f$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $4e72b316ca7efe5f$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $4e72b316ca7efe5f$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($4e72b316ca7efe5f$var$listenerCancelled);
    });
};
var $4e72b316ca7efe5f$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$4e72b316ca7efe5f$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $4e72b316ca7efe5f$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $4e72b316ca7efe5f$export$f03a6b845d3fb58b = /* @__PURE__ */ $4e72b316ca7efe5f$var$assign(/* @__PURE__ */ $4e72b316ca7efe5f$export$309c7a02b0b0bc62(`${$4e72b316ca7efe5f$var$alm}/add`), {
    withTypes: ()=>$4e72b316ca7efe5f$export$f03a6b845d3fb58b
});
var $4e72b316ca7efe5f$export$b1b8022855fb2b71 = /* @__PURE__ */ $4e72b316ca7efe5f$export$309c7a02b0b0bc62(`${$4e72b316ca7efe5f$var$alm}/removeAll`);
var $4e72b316ca7efe5f$export$b03e9483f936dccb = /* @__PURE__ */ $4e72b316ca7efe5f$var$assign(/* @__PURE__ */ $4e72b316ca7efe5f$export$309c7a02b0b0bc62(`${$4e72b316ca7efe5f$var$alm}/remove`), {
    withTypes: ()=>$4e72b316ca7efe5f$export$b03e9483f936dccb
});
var $4e72b316ca7efe5f$var$defaultErrorHandler = (...args)=>{
    console.error(`${$4e72b316ca7efe5f$var$alm}/error`, ...args);
};
var $4e72b316ca7efe5f$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $4e72b316ca7efe5f$var$defaultErrorHandler } = middlewareOptions;
    $4e72b316ca7efe5f$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4e72b316ca7efe5f$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $4e72b316ca7efe5f$var$findListenerEntry(listenerMap, options)) != null ? _a : $4e72b316ca7efe5f$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $4e72b316ca7efe5f$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $4e72b316ca7efe5f$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4e72b316ca7efe5f$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $4e72b316ca7efe5f$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $4e72b316ca7efe5f$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $4e72b316ca7efe5f$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $4e72b316ca7efe5f$var$createDelay(internalTaskController.signal),
                pause: $4e72b316ca7efe5f$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $4e72b316ca7efe5f$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($4e72b316ca7efe5f$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($4e72b316ca7efe5f$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $4e72b316ca7efe5f$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $4e72b316ca7efe5f$export$cb1bdac908fed7f)) $4e72b316ca7efe5f$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($4e72b316ca7efe5f$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $4e72b316ca7efe5f$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $6eQYX.isAction)(action)) return next(action);
                if ($4e72b316ca7efe5f$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4e72b316ca7efe5f$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4e72b316ca7efe5f$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $4e72b316ca7efe5f$var$INTERNAL_NIL_TOKEN) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4e72b316ca7efe5f$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4e72b316ca7efe5f$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $4e72b316ca7efe5f$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $4e72b316ca7efe5f$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $4e72b316ca7efe5f$export$4bb1606a79445586 = ()=>{
    const instanceId = $4e72b316ca7efe5f$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($4e72b316ca7efe5f$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $4e72b316ca7efe5f$var$getOrInsertComputed(middlewareMap, middleware2, $4e72b316ca7efe5f$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$4e72b316ca7efe5f$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $6eQYX.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $4e72b316ca7efe5f$export$9dd1fb32974da385(withMiddleware, $4e72b316ca7efe5f$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $4e72b316ca7efe5f$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $4e72b316ca7efe5f$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$4e72b316ca7efe5f$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $4e72b316ca7efe5f$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $4e72b316ca7efe5f$var$isStateProxy = (value)=>!!value && !!value[$4e72b316ca7efe5f$var$ORIGINAL_STATE];
var $4e72b316ca7efe5f$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $4e72b316ca7efe5f$var$createStateProxy = (state, reducerMap, initialStateCache)=>$4e72b316ca7efe5f$var$getOrInsertComputed($4e72b316ca7efe5f$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $4e72b316ca7efe5f$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $4e72b316ca7efe5f$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $4e72b316ca7efe5f$var$original = (state)=>{
    if (!$4e72b316ca7efe5f$var$isStateProxy(state)) throw new Error($4e72b316ca7efe5f$export$378fa86b259c0280(25));
    return state[$4e72b316ca7efe5f$var$ORIGINAL_STATE];
};
var $4e72b316ca7efe5f$var$emptyObject = {};
var $4e72b316ca7efe5f$var$noopReducer = (state = $4e72b316ca7efe5f$var$emptyObject)=>state;
function $4e72b316ca7efe5f$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($4e72b316ca7efe5f$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $6eQYX.combineReducers)(reducerMap) : $4e72b316ca7efe5f$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($4e72b316ca7efe5f$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $4e72b316ca7efe5f$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $4e72b316ca7efe5f$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("6eQYX", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $48ad2606c1c729ac$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $48ad2606c1c729ac$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $48ad2606c1c729ac$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $48ad2606c1c729ac$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $48ad2606c1c729ac$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $48ad2606c1c729ac$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $48ad2606c1c729ac$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $48ad2606c1c729ac$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $48ad2606c1c729ac$var$symbol_observable_default = $48ad2606c1c729ac$var$$$observable;
// src/utils/actionTypes.ts
var $48ad2606c1c729ac$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $48ad2606c1c729ac$var$ActionTypes = {
    INIT: `@@redux/INIT${$48ad2606c1c729ac$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$48ad2606c1c729ac$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$48ad2606c1c729ac$var$randomString()}`
};
var $48ad2606c1c729ac$export$4219e499db7ca678 = $48ad2606c1c729ac$var$ActionTypes;
// src/utils/isPlainObject.ts
function $48ad2606c1c729ac$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $48ad2606c1c729ac$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($48ad2606c1c729ac$var$isDate(val)) return "date";
    if ($48ad2606c1c729ac$var$isError(val)) return "error";
    const constructorName = $48ad2606c1c729ac$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $48ad2606c1c729ac$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $48ad2606c1c729ac$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $48ad2606c1c729ac$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $48ad2606c1c729ac$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $48ad2606c1c729ac$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(1));
        return enhancer($48ad2606c1c729ac$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$48ad2606c1c729ac$export$53b83ca8eaab0383(action)) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $48ad2606c1c729ac$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$48ad2606c1c729ac$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $48ad2606c1c729ac$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$48ad2606c1c729ac$var$symbol_observable_default]: observable
    };
    return store;
}
function $48ad2606c1c729ac$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $48ad2606c1c729ac$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $48ad2606c1c729ac$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $48ad2606c1c729ac$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $48ad2606c1c729ac$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$48ad2606c1c729ac$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$48ad2606c1c729ac$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $48ad2606c1c729ac$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $48ad2606c1c729ac$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $48ad2606c1c729ac$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $48ad2606c1c729ac$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(13));
    });
}
function $48ad2606c1c729ac$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $48ad2606c1c729ac$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $48ad2606c1c729ac$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $48ad2606c1c729ac$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $48ad2606c1c729ac$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $48ad2606c1c729ac$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $48ad2606c1c729ac$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $48ad2606c1c729ac$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $48ad2606c1c729ac$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $48ad2606c1c729ac$export$b956e38827fca970(action) {
    return $48ad2606c1c729ac$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("1qT0G", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $10b2e404278eeb95$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $10b2e404278eeb95$export$16e3aed3edb85946);
$parcel$export(module.exports, "current", () => $10b2e404278eeb95$export$97aac956da55dae9);
$parcel$export(module.exports, "produce", () => $10b2e404278eeb95$export$b46cabe22e78bc00);
var $10b2e404278eeb95$var$__defProp = Object.defineProperty;
var $10b2e404278eeb95$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $10b2e404278eeb95$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $10b2e404278eeb95$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $10b2e404278eeb95$var$__defNormalProp = (obj, key, value)=>key in obj ? $10b2e404278eeb95$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $10b2e404278eeb95$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($10b2e404278eeb95$var$__hasOwnProp.call(b, prop)) $10b2e404278eeb95$var$__defNormalProp(a, prop, b[prop]);
    if ($10b2e404278eeb95$var$__getOwnPropSymbols) {
        for (var prop of $10b2e404278eeb95$var$__getOwnPropSymbols(b))if ($10b2e404278eeb95$var$__propIsEnum.call(b, prop)) $10b2e404278eeb95$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $10b2e404278eeb95$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $10b2e404278eeb95$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $10b2e404278eeb95$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $10b2e404278eeb95$var$errors = [];
function $10b2e404278eeb95$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $10b2e404278eeb95$var$O = Object;
var $10b2e404278eeb95$var$getPrototypeOf = $10b2e404278eeb95$var$O.getPrototypeOf;
var $10b2e404278eeb95$var$CONSTRUCTOR = "constructor";
var $10b2e404278eeb95$var$PROTOTYPE = "prototype";
var $10b2e404278eeb95$var$CONFIGURABLE = "configurable";
var $10b2e404278eeb95$var$ENUMERABLE = "enumerable";
var $10b2e404278eeb95$var$WRITABLE = "writable";
var $10b2e404278eeb95$var$VALUE = "value";
var $10b2e404278eeb95$export$541ac630993a4c84 = (value)=>!!value && !!value[$10b2e404278eeb95$var$DRAFT_STATE];
function $10b2e404278eeb95$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $10b2e404278eeb95$var$isPlainObject(value) || $10b2e404278eeb95$var$isArray(value) || !!value[$10b2e404278eeb95$export$6ee2082928bcb0ee] || !!((_a = value[$10b2e404278eeb95$var$CONSTRUCTOR]) == null ? void 0 : _a[$10b2e404278eeb95$export$6ee2082928bcb0ee]) || $10b2e404278eeb95$var$isMap(value) || $10b2e404278eeb95$var$isSet(value);
}
var $10b2e404278eeb95$var$objectCtorString = $10b2e404278eeb95$var$O[$10b2e404278eeb95$var$PROTOTYPE][$10b2e404278eeb95$var$CONSTRUCTOR].toString();
var $10b2e404278eeb95$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $10b2e404278eeb95$var$isPlainObject(value) {
    if (!value || !$10b2e404278eeb95$var$isObjectish(value)) return false;
    const proto = $10b2e404278eeb95$var$getPrototypeOf(value);
    if (proto === null || proto === $10b2e404278eeb95$var$O[$10b2e404278eeb95$var$PROTOTYPE]) return true;
    const Ctor = $10b2e404278eeb95$var$O.hasOwnProperty.call(proto, $10b2e404278eeb95$var$CONSTRUCTOR) && proto[$10b2e404278eeb95$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$10b2e404278eeb95$var$isFunction(Ctor)) return false;
    let ctorString = $10b2e404278eeb95$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $10b2e404278eeb95$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $10b2e404278eeb95$var$objectCtorString;
}
function $10b2e404278eeb95$export$22e8af3f75a010e3(value) {
    if (!$10b2e404278eeb95$export$541ac630993a4c84(value)) $10b2e404278eeb95$var$die(15, value);
    return value[$10b2e404278eeb95$var$DRAFT_STATE].base_;
}
function $10b2e404278eeb95$var$each(obj, iter, strict = true) {
    if ($10b2e404278eeb95$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $10b2e404278eeb95$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $10b2e404278eeb95$var$getArchtype(thing) {
    const state = thing[$10b2e404278eeb95$var$DRAFT_STATE];
    return state ? state.type_ : $10b2e404278eeb95$var$isArray(thing) ? 1 /* Array */  : $10b2e404278eeb95$var$isMap(thing) ? 2 /* Map */  : $10b2e404278eeb95$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $10b2e404278eeb95$var$has = (thing, prop, type = $10b2e404278eeb95$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $10b2e404278eeb95$var$O[$10b2e404278eeb95$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $10b2e404278eeb95$var$get = (thing, prop, type = $10b2e404278eeb95$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $10b2e404278eeb95$var$set = (thing, propOrOldValue, value, type = $10b2e404278eeb95$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $10b2e404278eeb95$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $10b2e404278eeb95$var$isArray = Array.isArray;
var $10b2e404278eeb95$var$isMap = (target)=>target instanceof Map;
var $10b2e404278eeb95$var$isSet = (target)=>target instanceof Set;
var $10b2e404278eeb95$var$isObjectish = (target)=>typeof target === "object";
var $10b2e404278eeb95$var$isFunction = (target)=>typeof target === "function";
var $10b2e404278eeb95$var$isBoolean = (target)=>typeof target === "boolean";
function $10b2e404278eeb95$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $10b2e404278eeb95$var$getProxyDraft = (value)=>{
    if (!$10b2e404278eeb95$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$10b2e404278eeb95$var$DRAFT_STATE];
};
var $10b2e404278eeb95$var$latest = (state)=>state.copy_ || state.base_;
var $10b2e404278eeb95$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $10b2e404278eeb95$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $10b2e404278eeb95$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $10b2e404278eeb95$var$shallowCopy(base, strict) {
    if ($10b2e404278eeb95$var$isMap(base)) return new Map(base);
    if ($10b2e404278eeb95$var$isSet(base)) return new Set(base);
    if ($10b2e404278eeb95$var$isArray(base)) return Array[$10b2e404278eeb95$var$PROTOTYPE].slice.call(base);
    const isPlain = $10b2e404278eeb95$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $10b2e404278eeb95$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$10b2e404278eeb95$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$10b2e404278eeb95$var$WRITABLE] === false) {
                desc[$10b2e404278eeb95$var$WRITABLE] = true;
                desc[$10b2e404278eeb95$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$10b2e404278eeb95$var$CONFIGURABLE]: true,
                [$10b2e404278eeb95$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$10b2e404278eeb95$var$ENUMERABLE]: desc[$10b2e404278eeb95$var$ENUMERABLE],
                [$10b2e404278eeb95$var$VALUE]: base[key]
            };
        }
        return $10b2e404278eeb95$var$O.create($10b2e404278eeb95$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $10b2e404278eeb95$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $10b2e404278eeb95$var$__spreadValues({}, base);
        const obj = $10b2e404278eeb95$var$O.create(proto);
        return $10b2e404278eeb95$var$O.assign(obj, base);
    }
}
function $10b2e404278eeb95$export$792f3d81ea979f55(obj, deep = false) {
    if ($10b2e404278eeb95$var$isFrozen(obj) || $10b2e404278eeb95$export$541ac630993a4c84(obj) || !$10b2e404278eeb95$export$16e3aed3edb85946(obj)) return obj;
    if ($10b2e404278eeb95$var$getArchtype(obj) > 1) $10b2e404278eeb95$var$O.defineProperties(obj, {
        set: $10b2e404278eeb95$var$dontMutateMethodOverride,
        add: $10b2e404278eeb95$var$dontMutateMethodOverride,
        clear: $10b2e404278eeb95$var$dontMutateMethodOverride,
        delete: $10b2e404278eeb95$var$dontMutateMethodOverride
    });
    $10b2e404278eeb95$var$O.freeze(obj);
    if (deep) $10b2e404278eeb95$var$each(obj, (_key, value)=>{
        $10b2e404278eeb95$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $10b2e404278eeb95$var$dontMutateFrozenCollections() {
    $10b2e404278eeb95$var$die(2);
}
var $10b2e404278eeb95$var$dontMutateMethodOverride = {
    [$10b2e404278eeb95$var$VALUE]: $10b2e404278eeb95$var$dontMutateFrozenCollections
};
function $10b2e404278eeb95$var$isFrozen(obj) {
    if (obj === null || !$10b2e404278eeb95$var$isObjectish(obj)) return true;
    return $10b2e404278eeb95$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $10b2e404278eeb95$var$PluginMapSet = "MapSet";
var $10b2e404278eeb95$var$PluginPatches = "Patches";
var $10b2e404278eeb95$var$PluginArrayMethods = "ArrayMethods";
var $10b2e404278eeb95$var$plugins = {};
function $10b2e404278eeb95$var$getPlugin(pluginKey) {
    const plugin = $10b2e404278eeb95$var$plugins[pluginKey];
    if (!plugin) $10b2e404278eeb95$var$die(0, pluginKey);
    return plugin;
}
var $10b2e404278eeb95$var$isPluginLoaded = (pluginKey)=>!!$10b2e404278eeb95$var$plugins[pluginKey];
function $10b2e404278eeb95$var$loadPlugin(pluginKey, implementation) {
    if (!$10b2e404278eeb95$var$plugins[pluginKey]) $10b2e404278eeb95$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $10b2e404278eeb95$var$currentScope;
var $10b2e404278eeb95$var$getCurrentScope = ()=>$10b2e404278eeb95$var$currentScope;
var $10b2e404278eeb95$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $10b2e404278eeb95$var$isPluginLoaded($10b2e404278eeb95$var$PluginMapSet) ? $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $10b2e404278eeb95$var$isPluginLoaded($10b2e404278eeb95$var$PluginArrayMethods) ? $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginArrayMethods) : void 0
    });
function $10b2e404278eeb95$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $10b2e404278eeb95$var$revokeScope(scope) {
    $10b2e404278eeb95$var$leaveScope(scope);
    scope.drafts_.forEach($10b2e404278eeb95$var$revokeDraft);
    scope.drafts_ = null;
}
function $10b2e404278eeb95$var$leaveScope(scope) {
    if (scope === $10b2e404278eeb95$var$currentScope) $10b2e404278eeb95$var$currentScope = scope.parent_;
}
var $10b2e404278eeb95$var$enterScope = (immer2)=>$10b2e404278eeb95$var$currentScope = $10b2e404278eeb95$var$createScope($10b2e404278eeb95$var$currentScope, immer2);
function $10b2e404278eeb95$var$revokeDraft(draft) {
    const state = draft[$10b2e404278eeb95$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $10b2e404278eeb95$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$10b2e404278eeb95$var$DRAFT_STATE].modified_) {
            $10b2e404278eeb95$var$revokeScope(scope);
            $10b2e404278eeb95$var$die(4);
        }
        if ($10b2e404278eeb95$export$16e3aed3edb85946(result)) result = $10b2e404278eeb95$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$10b2e404278eeb95$var$DRAFT_STATE].base_, result, scope);
    } else result = $10b2e404278eeb95$var$finalize(scope, baseDraft);
    $10b2e404278eeb95$var$maybeFreeze(scope, result, true);
    $10b2e404278eeb95$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $10b2e404278eeb95$export$45b790e32b2810ee ? result : void 0;
}
function $10b2e404278eeb95$var$finalize(rootScope, value) {
    if ($10b2e404278eeb95$var$isFrozen(value)) return value;
    const state = value[$10b2e404278eeb95$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $10b2e404278eeb95$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$10b2e404278eeb95$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $10b2e404278eeb95$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $10b2e404278eeb95$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $10b2e404278eeb95$export$792f3d81ea979f55(value, deep);
}
function $10b2e404278eeb95$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $10b2e404278eeb95$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $10b2e404278eeb95$var$EMPTY_LOCATIONS_RESULT = [];
function $10b2e404278eeb95$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $10b2e404278eeb95$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $10b2e404278eeb95$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $10b2e404278eeb95$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $10b2e404278eeb95$var$each(parentCopy, (key, value)=>{
            if ($10b2e404278eeb95$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $10b2e404278eeb95$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$10b2e404278eeb95$var$set(parentCopy, location, finalizedValue, parentType);
}
function $10b2e404278eeb95$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$10b2e404278eeb95$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $10b2e404278eeb95$var$getFinalValue(state);
        $10b2e404278eeb95$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $10b2e404278eeb95$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $10b2e404278eeb95$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $10b2e404278eeb95$var$markStateFinalized(state);
    }
}
function $10b2e404278eeb95$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($10b2e404278eeb95$export$541ac630993a4c84(value)) {
        const state = value[$10b2e404278eeb95$var$DRAFT_STATE];
        if ($10b2e404278eeb95$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $10b2e404278eeb95$var$prepareCopy(target);
            const finalizedValue = $10b2e404278eeb95$var$getFinalValue(state);
            $10b2e404278eeb95$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($10b2e404278eeb95$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $10b2e404278eeb95$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $10b2e404278eeb95$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($10b2e404278eeb95$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $10b2e404278eeb95$var$handleValue($10b2e404278eeb95$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $10b2e404278eeb95$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($10b2e404278eeb95$export$541ac630993a4c84(target) || handledSet.has(target) || !$10b2e404278eeb95$export$16e3aed3edb85946(target) || $10b2e404278eeb95$var$isFrozen(target)) return target;
    handledSet.add(target);
    $10b2e404278eeb95$var$each(target, (key, value)=>{
        if ($10b2e404278eeb95$export$541ac630993a4c84(value)) {
            const state = value[$10b2e404278eeb95$var$DRAFT_STATE];
            if ($10b2e404278eeb95$var$isSameScope(state, rootScope)) {
                const updatedValue = $10b2e404278eeb95$var$getFinalValue(state);
                $10b2e404278eeb95$var$set(target, key, updatedValue, target.type_);
                $10b2e404278eeb95$var$markStateFinalized(state);
            }
        } else if ($10b2e404278eeb95$export$16e3aed3edb85946(value)) $10b2e404278eeb95$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $10b2e404278eeb95$var$createProxyProxy(base, parent) {
    const baseIsArray = $10b2e404278eeb95$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $10b2e404278eeb95$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $10b2e404278eeb95$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $10b2e404278eeb95$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $10b2e404278eeb95$var$objectTraps = {
    get (state, prop) {
        if (prop === $10b2e404278eeb95$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $10b2e404278eeb95$var$latest(state);
        if (!$10b2e404278eeb95$var$has(source, prop, state.type_)) return $10b2e404278eeb95$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$10b2e404278eeb95$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $10b2e404278eeb95$var$isArrayIndex(prop)) return value;
        if (value === $10b2e404278eeb95$var$peek(state.base_, prop)) {
            $10b2e404278eeb95$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $10b2e404278eeb95$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $10b2e404278eeb95$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($10b2e404278eeb95$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $10b2e404278eeb95$var$getDescriptorFromProto($10b2e404278eeb95$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $10b2e404278eeb95$var$peek($10b2e404278eeb95$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$10b2e404278eeb95$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($10b2e404278eeb95$var$is(value, current2) && (value !== void 0 || $10b2e404278eeb95$var$has(state.base_, prop, state.type_))) return true;
            $10b2e404278eeb95$var$prepareCopy(state);
            $10b2e404278eeb95$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $10b2e404278eeb95$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $10b2e404278eeb95$var$prepareCopy(state);
        if ($10b2e404278eeb95$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $10b2e404278eeb95$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $10b2e404278eeb95$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$10b2e404278eeb95$var$WRITABLE]: true,
            [$10b2e404278eeb95$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$10b2e404278eeb95$var$ENUMERABLE]: desc[$10b2e404278eeb95$var$ENUMERABLE],
            [$10b2e404278eeb95$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $10b2e404278eeb95$var$die(11);
    },
    getPrototypeOf (state) {
        return $10b2e404278eeb95$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $10b2e404278eeb95$var$die(12);
    }
};
var $10b2e404278eeb95$var$arrayTraps = {};
for(let key in $10b2e404278eeb95$var$objectTraps){
    let fn = $10b2e404278eeb95$var$objectTraps[key];
    $10b2e404278eeb95$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$10b2e404278eeb95$var$arrayTraps.deleteProperty = function(state, prop) {
    return $10b2e404278eeb95$var$arrayTraps.set.call(this, state, prop, void 0);
};
$10b2e404278eeb95$var$arrayTraps.set = function(state, prop, value) {
    return $10b2e404278eeb95$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $10b2e404278eeb95$var$peek(draft, prop) {
    const state = draft[$10b2e404278eeb95$var$DRAFT_STATE];
    const source = state ? $10b2e404278eeb95$var$latest(state) : draft;
    return source[prop];
}
function $10b2e404278eeb95$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $10b2e404278eeb95$var$getDescriptorFromProto(source, prop);
    return desc ? $10b2e404278eeb95$var$VALUE in desc ? desc[$10b2e404278eeb95$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $10b2e404278eeb95$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $10b2e404278eeb95$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $10b2e404278eeb95$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $10b2e404278eeb95$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $10b2e404278eeb95$var$markChanged(state.parent_);
    }
}
function $10b2e404278eeb95$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $10b2e404278eeb95$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $10b2e404278eeb95$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($10b2e404278eeb95$var$isFunction(base) && !$10b2e404278eeb95$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$10b2e404278eeb95$var$isFunction(recipe)) $10b2e404278eeb95$var$die(6);
            if (patchListener !== void 0 && !$10b2e404278eeb95$var$isFunction(patchListener)) $10b2e404278eeb95$var$die(7);
            let result;
            if ($10b2e404278eeb95$export$16e3aed3edb85946(base)) {
                const scope = $10b2e404278eeb95$var$enterScope(this);
                const proxy = $10b2e404278eeb95$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $10b2e404278eeb95$var$revokeScope(scope);
                    else $10b2e404278eeb95$var$leaveScope(scope);
                }
                $10b2e404278eeb95$var$usePatchesInScope(scope, patchListener);
                return $10b2e404278eeb95$var$processResult(result, scope);
            } else if (!base || !$10b2e404278eeb95$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $10b2e404278eeb95$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $10b2e404278eeb95$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $10b2e404278eeb95$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($10b2e404278eeb95$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($10b2e404278eeb95$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($10b2e404278eeb95$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($10b2e404278eeb95$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$10b2e404278eeb95$export$16e3aed3edb85946(base)) $10b2e404278eeb95$var$die(8);
        if ($10b2e404278eeb95$export$541ac630993a4c84(base)) base = $10b2e404278eeb95$export$97aac956da55dae9(base);
        const scope = $10b2e404278eeb95$var$enterScope(this);
        const proxy = $10b2e404278eeb95$var$createProxy(scope, base, void 0);
        proxy[$10b2e404278eeb95$var$DRAFT_STATE].isManual_ = true;
        $10b2e404278eeb95$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$10b2e404278eeb95$var$DRAFT_STATE];
        if (!state || !state.isManual_) $10b2e404278eeb95$var$die(9);
        const { scope_: scope } = state;
        $10b2e404278eeb95$var$usePatchesInScope(scope, patchListener);
        return $10b2e404278eeb95$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginPatches).applyPatches_;
        if ($10b2e404278eeb95$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $10b2e404278eeb95$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $10b2e404278eeb95$var$isMap(value) ? $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginMapSet).proxyMap_(value, parent) : $10b2e404278eeb95$var$isSet(value) ? $10b2e404278eeb95$var$getPlugin($10b2e404278eeb95$var$PluginMapSet).proxySet_(value, parent) : $10b2e404278eeb95$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $10b2e404278eeb95$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $10b2e404278eeb95$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $10b2e404278eeb95$export$97aac956da55dae9(value) {
    if (!$10b2e404278eeb95$export$541ac630993a4c84(value)) $10b2e404278eeb95$var$die(10, value);
    return $10b2e404278eeb95$var$currentImpl(value);
}
function $10b2e404278eeb95$var$currentImpl(value) {
    if (!$10b2e404278eeb95$export$16e3aed3edb85946(value) || $10b2e404278eeb95$var$isFrozen(value)) return value;
    const state = value[$10b2e404278eeb95$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $10b2e404278eeb95$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $10b2e404278eeb95$var$shallowCopy(value, true);
    $10b2e404278eeb95$var$each(copy, (key, childValue)=>{
        $10b2e404278eeb95$var$set(copy, key, $10b2e404278eeb95$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $10b2e404278eeb95$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $10b2e404278eeb95$var$getProxyDraft($10b2e404278eeb95$var$get(parentCopy, state.key_));
            const valueAtKey = $10b2e404278eeb95$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $10b2e404278eeb95$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $10b2e404278eeb95$var$get(current2, key);
            if (!$10b2e404278eeb95$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$10b2e404278eeb95$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $10b2e404278eeb95$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $10b2e404278eeb95$var$get(base_, key, type_);
            const value = $10b2e404278eeb95$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $10b2e404278eeb95$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $10b2e404278eeb95$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $10b2e404278eeb95$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $10b2e404278eeb95$var$CONSTRUCTOR)) $10b2e404278eeb95$var$die(errorOffset + 3);
                if ($10b2e404278eeb95$var$isFunction(base) && p === $10b2e404278eeb95$var$PROTOTYPE) $10b2e404278eeb95$var$die(errorOffset + 3);
                base = $10b2e404278eeb95$var$get(base, p);
                if (!$10b2e404278eeb95$var$isObjectish(base)) $10b2e404278eeb95$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $10b2e404278eeb95$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $10b2e404278eeb95$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $10b2e404278eeb95$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$10b2e404278eeb95$export$16e3aed3edb85946(obj)) return obj;
        if ($10b2e404278eeb95$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($10b2e404278eeb95$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($10b2e404278eeb95$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($10b2e404278eeb95$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($10b2e404278eeb95$var$has(obj, $10b2e404278eeb95$export$6ee2082928bcb0ee)) cloned[$10b2e404278eeb95$export$6ee2082928bcb0ee] = obj[$10b2e404278eeb95$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($10b2e404278eeb95$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $10b2e404278eeb95$var$loadPlugin($10b2e404278eeb95$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $10b2e404278eeb95$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$10b2e404278eeb95$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $10b2e404278eeb95$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $10b2e404278eeb95$var$latest(this[$10b2e404278eeb95$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $10b2e404278eeb95$var$latest(this[$10b2e404278eeb95$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$10b2e404278eeb95$var$latest(state).has(key) || $10b2e404278eeb95$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $10b2e404278eeb95$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $10b2e404278eeb95$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $10b2e404278eeb95$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($10b2e404278eeb95$var$latest(state).size) {
                prepareMapCopy(state);
                $10b2e404278eeb95$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $10b2e404278eeb95$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            $10b2e404278eeb95$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $10b2e404278eeb95$var$latest(state).get(key);
            if (state.finalized_ || !$10b2e404278eeb95$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $10b2e404278eeb95$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $10b2e404278eeb95$var$latest(this[$10b2e404278eeb95$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($10b2e404278eeb95$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$10b2e404278eeb95$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$10b2e404278eeb95$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $10b2e404278eeb95$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $10b2e404278eeb95$var$latest(this[$10b2e404278eeb95$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $10b2e404278eeb95$var$markChanged(state);
                state.copy_.add(value);
                $10b2e404278eeb95$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $10b2e404278eeb95$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($10b2e404278eeb95$var$latest(state).size) {
                prepareSetCopy(state);
                $10b2e404278eeb95$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$10b2e404278eeb95$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($10b2e404278eeb95$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$10b2e404278eeb95$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($10b2e404278eeb95$export$16e3aed3edb85946(value)) {
                    const draft = $10b2e404278eeb95$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $10b2e404278eeb95$var$die(3, JSON.stringify($10b2e404278eeb95$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($10b2e404278eeb95$var$getValue(value));
            });
        }
    }
    $10b2e404278eeb95$var$loadPlugin($10b2e404278eeb95$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $10b2e404278eeb95$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $10b2e404278eeb95$var$prepareCopy(state);
        const result = operation();
        $10b2e404278eeb95$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $10b2e404278eeb95$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $10b2e404278eeb95$var$loadPlugin($10b2e404278eeb95$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $10b2e404278eeb95$var$immer = new $10b2e404278eeb95$export$aaadc6ff0f822719();
var $10b2e404278eeb95$export$b46cabe22e78bc00 = $10b2e404278eeb95$var$immer.produce;
var $10b2e404278eeb95$export$4da66d41c9492c78 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.produceWithPatches.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$573f26f60825c493 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.setAutoFreeze.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$333ce65961cbe047 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.setUseStrictShallowCopy.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$1045b3be3904c489 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.setUseStrictIteration.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.applyPatches.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$3c3214997190395f = /* @__PURE__ */ $10b2e404278eeb95$var$immer.createDraft.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$c60f5e69c521b528 = /* @__PURE__ */ $10b2e404278eeb95$var$immer.finishDraft.bind($10b2e404278eeb95$var$immer);
var $10b2e404278eeb95$export$c05b21e3257751e5 = (value)=>value;
var $10b2e404278eeb95$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("dkYqL", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $9b5c04e02f593bb3$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $9b5c04e02f593bb3$export$5943f4447f6ef248);
$parcel$export(module.exports, "createSelector", () => $9b5c04e02f593bb3$export$595d22ed68ca2841);
var $9b5c04e02f593bb3$var$__defProp = Object.defineProperty;
var $9b5c04e02f593bb3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9b5c04e02f593bb3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9b5c04e02f593bb3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9b5c04e02f593bb3$var$__defNormalProp = (obj, key, value)=>key in obj ? $9b5c04e02f593bb3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9b5c04e02f593bb3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9b5c04e02f593bb3$var$__hasOwnProp.call(b, prop)) $9b5c04e02f593bb3$var$__defNormalProp(a, prop, b[prop]);
    if ($9b5c04e02f593bb3$var$__getOwnPropSymbols) {
        for (var prop of $9b5c04e02f593bb3$var$__getOwnPropSymbols(b))if ($9b5c04e02f593bb3$var$__propIsEnum.call(b, prop)) $9b5c04e02f593bb3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9b5c04e02f593bb3$var$__publicField = (obj, key, value)=>{
    $9b5c04e02f593bb3$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $9b5c04e02f593bb3$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $9b5c04e02f593bb3$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $9b5c04e02f593bb3$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $9b5c04e02f593bb3$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($9b5c04e02f593bb3$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $9b5c04e02f593bb3$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $9b5c04e02f593bb3$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $9b5c04e02f593bb3$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $9b5c04e02f593bb3$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $9b5c04e02f593bb3$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $9b5c04e02f593bb3$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $9b5c04e02f593bb3$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $9b5c04e02f593bb3$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $9b5c04e02f593bb3$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $9b5c04e02f593bb3$var$__spreadValues($9b5c04e02f593bb3$var$__spreadValues({}, $9b5c04e02f593bb3$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $9b5c04e02f593bb3$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $9b5c04e02f593bb3$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $9b5c04e02f593bb3$var$$REVISION = 0;
var $9b5c04e02f593bb3$var$CURRENT_TRACKER = null;
var $9b5c04e02f593bb3$var$Cell = class {
    constructor(initialValue, isEqual = $9b5c04e02f593bb3$var$tripleEq){
        $9b5c04e02f593bb3$var$__publicField(this, "revision", $9b5c04e02f593bb3$var$$REVISION);
        $9b5c04e02f593bb3$var$__publicField(this, "_value");
        $9b5c04e02f593bb3$var$__publicField(this, "_lastValue");
        $9b5c04e02f593bb3$var$__publicField(this, "_isEqual", $9b5c04e02f593bb3$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $9b5c04e02f593bb3$var$CURRENT_TRACKER == null || $9b5c04e02f593bb3$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$9b5c04e02f593bb3$var$$REVISION;
    }
};
function $9b5c04e02f593bb3$var$tripleEq(a, b) {
    return a === b;
}
var $9b5c04e02f593bb3$var$TrackingCache = class {
    constructor(fn){
        $9b5c04e02f593bb3$var$__publicField(this, "_cachedValue");
        $9b5c04e02f593bb3$var$__publicField(this, "_cachedRevision", -1);
        $9b5c04e02f593bb3$var$__publicField(this, "_deps", []);
        $9b5c04e02f593bb3$var$__publicField(this, "hits", 0);
        $9b5c04e02f593bb3$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $9b5c04e02f593bb3$var$CURRENT_TRACKER;
            $9b5c04e02f593bb3$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $9b5c04e02f593bb3$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $9b5c04e02f593bb3$var$CURRENT_TRACKER == null || $9b5c04e02f593bb3$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $9b5c04e02f593bb3$var$getValue(cell) {
    if (!(cell instanceof $9b5c04e02f593bb3$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $9b5c04e02f593bb3$var$setValue(storage, value) {
    if (!(storage instanceof $9b5c04e02f593bb3$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $9b5c04e02f593bb3$var$createCell(initialValue, isEqual = $9b5c04e02f593bb3$var$tripleEq) {
    return new $9b5c04e02f593bb3$var$Cell(initialValue, isEqual);
}
function $9b5c04e02f593bb3$var$createCache(fn) {
    $9b5c04e02f593bb3$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $9b5c04e02f593bb3$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $9b5c04e02f593bb3$var$neverEq = (a, b)=>false;
function $9b5c04e02f593bb3$var$createTag() {
    return $9b5c04e02f593bb3$var$createCell(null, $9b5c04e02f593bb3$var$neverEq);
}
function $9b5c04e02f593bb3$var$dirtyTag(tag, value) {
    $9b5c04e02f593bb3$var$setValue(tag, value);
}
var $9b5c04e02f593bb3$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $9b5c04e02f593bb3$var$createTag();
    $9b5c04e02f593bb3$var$getValue(tag);
};
var $9b5c04e02f593bb3$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $9b5c04e02f593bb3$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $9b5c04e02f593bb3$var$REDUX_PROXY_LABEL = Symbol();
var $9b5c04e02f593bb3$var$nextId = 0;
var $9b5c04e02f593bb3$var$proto = Object.getPrototypeOf({});
var $9b5c04e02f593bb3$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $9b5c04e02f593bb3$var$__publicField(this, "proxy", new Proxy(this, $9b5c04e02f593bb3$var$objectProxyHandler));
        $9b5c04e02f593bb3$var$__publicField(this, "tag", $9b5c04e02f593bb3$var$createTag());
        $9b5c04e02f593bb3$var$__publicField(this, "tags", {});
        $9b5c04e02f593bb3$var$__publicField(this, "children", {});
        $9b5c04e02f593bb3$var$__publicField(this, "collectionTag", null);
        $9b5c04e02f593bb3$var$__publicField(this, "id", $9b5c04e02f593bb3$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9b5c04e02f593bb3$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $9b5c04e02f593bb3$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $9b5c04e02f593bb3$var$createNode(childValue);
                if (childNode.tag) $9b5c04e02f593bb3$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $9b5c04e02f593bb3$var$createTag();
                    tag.value = childValue;
                }
                $9b5c04e02f593bb3$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $9b5c04e02f593bb3$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $9b5c04e02f593bb3$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $9b5c04e02f593bb3$var$__publicField(this, "proxy", new Proxy([
            this
        ], $9b5c04e02f593bb3$var$arrayProxyHandler));
        $9b5c04e02f593bb3$var$__publicField(this, "tag", $9b5c04e02f593bb3$var$createTag());
        $9b5c04e02f593bb3$var$__publicField(this, "tags", {});
        $9b5c04e02f593bb3$var$__publicField(this, "children", {});
        $9b5c04e02f593bb3$var$__publicField(this, "collectionTag", null);
        $9b5c04e02f593bb3$var$__publicField(this, "id", $9b5c04e02f593bb3$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9b5c04e02f593bb3$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $9b5c04e02f593bb3$var$consumeCollection(node);
        return $9b5c04e02f593bb3$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $9b5c04e02f593bb3$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $9b5c04e02f593bb3$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $9b5c04e02f593bb3$var$objectProxyHandler.has(node, prop);
    }
};
function $9b5c04e02f593bb3$var$createNode(value) {
    if (Array.isArray(value)) return new $9b5c04e02f593bb3$var$ArrayTreeNode(value);
    return new $9b5c04e02f593bb3$var$ObjectTreeNode(value);
}
function $9b5c04e02f593bb3$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $9b5c04e02f593bb3$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $9b5c04e02f593bb3$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $9b5c04e02f593bb3$var$dirtyCollection(node);
            $9b5c04e02f593bb3$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $9b5c04e02f593bb3$var$updateNode(childNode, newChildValue);
        else {
            $9b5c04e02f593bb3$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $9b5c04e02f593bb3$var$deleteNode(node) {
    if (node.tag) $9b5c04e02f593bb3$var$dirtyTag(node.tag, null);
    $9b5c04e02f593bb3$var$dirtyCollection(node);
    for(const key in node.tags)$9b5c04e02f593bb3$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$9b5c04e02f593bb3$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $9b5c04e02f593bb3$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $9b5c04e02f593bb3$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $9b5c04e02f593bb3$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $9b5c04e02f593bb3$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $9b5c04e02f593bb3$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $9b5c04e02f593bb3$export$3f025202a230c6dd = (a, b)=>a === b;
function $9b5c04e02f593bb3$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $9b5c04e02f593bb3$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $9b5c04e02f593bb3$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $9b5c04e02f593bb3$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $9b5c04e02f593bb3$var$createSingletonCache(comparator) : $9b5c04e02f593bb3$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $9b5c04e02f593bb3$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $9b5c04e02f593bb3$export$c8f9cf88d9fdee55(func) {
    const node = $9b5c04e02f593bb3$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $9b5c04e02f593bb3$var$createCacheKeyComparator($9b5c04e02f593bb3$export$3f025202a230c6dd);
    const cache = $9b5c04e02f593bb3$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $9b5c04e02f593bb3$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $9b5c04e02f593bb3$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $9b5c04e02f593bb3$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $9b5c04e02f593bb3$var$StrongRef;
var $9b5c04e02f593bb3$var$UNTERMINATED = 0;
var $9b5c04e02f593bb3$var$TERMINATED = 1;
function $9b5c04e02f593bb3$var$createCacheNode() {
    return {
        s: $9b5c04e02f593bb3$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $9b5c04e02f593bb3$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $9b5c04e02f593bb3$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $9b5c04e02f593bb3$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $9b5c04e02f593bb3$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $9b5c04e02f593bb3$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $9b5c04e02f593bb3$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $9b5c04e02f593bb3$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $9b5c04e02f593bb3$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $9b5c04e02f593bb3$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $9b5c04e02f593bb3$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $9b5c04e02f593bb3$var$__spreadValues($9b5c04e02f593bb3$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $9b5c04e02f593bb3$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $9b5c04e02f593bb3$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $9b5c04e02f593bb3$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $9b5c04e02f593bb3$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $9b5c04e02f593bb3$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $9b5c04e02f593bb3$export$595d22ed68ca2841 = /* @__PURE__ */ $9b5c04e02f593bb3$export$5943f4447f6ef248($9b5c04e02f593bb3$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $9b5c04e02f593bb3$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $9b5c04e02f593bb3$export$595d22ed68ca2841)=>{
    $9b5c04e02f593bb3$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$9b5c04e02f593bb3$export$75979cfcd91bf38f
});

});

parcelRegister("dWCD2", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $a26ea7fef75baa84$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $a26ea7fef75baa84$export$16d06542a1949d9e);
// src/index.ts
function $a26ea7fef75baa84$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a26ea7fef75baa84$export$dd164f5517779f15 = $a26ea7fef75baa84$var$createThunkMiddleware();
var $a26ea7fef75baa84$export$16d06542a1949d9e = $a26ea7fef75baa84$var$createThunkMiddleware;

});


parcelRegister("kmdF6", function(module, exports) {

$parcel$export(module.exports, "sample", () => $ed2075acb304f501$export$4812e460280c6ef2);
$parcel$export(module.exports, "weightedSample", () => $ed2075acb304f501$export$37704e92080ca049);
$parcel$export(module.exports, "roundToStep", () => $ed2075acb304f501$export$71a5f5b5925a4147);
$parcel$export(module.exports, "clamp", () => $ed2075acb304f501$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "lerp", () => $ed2075acb304f501$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "normalize", () => $ed2075acb304f501$export$a3295358bff77e);
$parcel$export(module.exports, "scale", () => $ed2075acb304f501$export$dcdf75081b88279d);
$parcel$export(module.exports, "degToRad", () => $ed2075acb304f501$export$e6bfdeff8bfc94f9);
$parcel$export(module.exports, "polToCar", () => $ed2075acb304f501$export$8b40c50dea1dd629);
$parcel$export(module.exports, "distanceToAbsolute", () => $ed2075acb304f501$export$2c452778a6a53412);
$parcel$export(module.exports, "euclid", () => $ed2075acb304f501$export$266e778bd374b9f7);
$parcel$export(module.exports, "makeUID", () => $ed2075acb304f501$export$bf4af9f3d2617c75);
$parcel$export(module.exports, "quantizeRound", () => $ed2075acb304f501$export$96ed2b266aac6c21);

var $abvlt = parcelRequire("abvlt");

var $aQPnZ = parcelRequire("aQPnZ");
const $ed2075acb304f501$export$4812e460280c6ef2 = (arr, sampleSize = 1)=>{
    if (sampleSize > arr.length) throw new Error("Sample size cannot be larger than the array size");
    const sampledItems = new Set();
    while(sampledItems.size < sampleSize){
        const randomIndex = Math.floor(Math.random() * arr.length);
        sampledItems.add(arr[randomIndex]);
    }
    if (sampleSize === 1) return [
        ...sampledItems
    ][0];
    return [
        ...sampledItems
    ];
};
const $ed2075acb304f501$export$37704e92080ca049 = (items, weights)=>{
    if (items.length !== weights.length) throw new Error('Items and weights must be of the same size');
    if (!items.length) throw new Error('Items must not be empty');
    const totalWeight = weights.reduce((sum, weight)=>sum + weight, 0); // Calculate the total sum of weights.
    const threshold = totalWeight * Math.random();
    let cumulative = 0;
    for(let i = 0; i < items.length; i++){
        cumulative += weights[i];
        if (cumulative >= threshold) return items[i];
    }
};
const $ed2075acb304f501$export$71a5f5b5925a4147 = (value, step)=>{
    if (step === undefined || step === 0) return value;
    return Math.round(value / step) * step;
};
const $ed2075acb304f501$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.min(Math.max(value, min), max);
const $ed2075acb304f501$export$3a89f8d6f6bf6c9f = (value1, value2, t)=>value1 + (value2 - value1) * t;
const $ed2075acb304f501$export$a3295358bff77e = (value, min, max)=>(value - min) / (max - min);
const $ed2075acb304f501$export$dcdf75081b88279d = (value, inmin, inmax, outmin, outmax)=>$ed2075acb304f501$export$3a89f8d6f6bf6c9f(outmin, outmax, $ed2075acb304f501$export$a3295358bff77e(value, inmin, inmax));
const $ed2075acb304f501$export$e6bfdeff8bfc94f9 = (deg)=>deg / 180 * Math.PI;
const $ed2075acb304f501$export$8b40c50dea1dd629 = ({ r: r, a: a })=>({
        x: r * Math.cos(a),
        y: r * Math.sin(a)
    });
const $ed2075acb304f501$export$2c452778a6a53412 = (distanceArray, startOffset = 0)=>{
    return distanceArray.reduce((absoluteArray, distanceValue, index)=>{
        const absoluteValue = distanceValue + absoluteArray[index];
        absoluteArray.push(absoluteValue);
        return absoluteArray;
    }, [
        startOffset
    ]);
};
const $ed2075acb304f501$export$8109e94e4f1ea04c = (absoluteArray)=>{
    return absoluteArray.slice(1).reduce((distanceArray, absoluteValue, index)=>{
        const distanceValue = absoluteValue - absoluteArray[index];
        distanceArray.push(distanceValue);
        return distanceArray;
    }, []);
};
const $ed2075acb304f501$export$266e778bd374b9f7 = (pulses, steps, offset = 0)=>{
    if (pulses > steps) throw new Error(`More pulses (${pulses}) than steps (${steps})!`);
    const bjorklundArray = Array(steps);
    let lastTruncated = 0;
    for(let i = 1; i <= steps; i++){
        const truncatedValue = Math.floor(i * pulses / steps);
        const bjorklundValue = truncatedValue - lastTruncated;
        lastTruncated = truncatedValue;
        const index = i == steps ? 0 : i; // puts the last element first
        bjorklundArray[index] = bjorklundValue;
    }
    const rotatedBjorklund = (0, $abvlt.rotateArray)(bjorklundArray, offset);
    const euclidAbsolute = rotatedBjorklund.map((value, index)=>value == 1 ? value * index : undefined).filter((item)=>item !== undefined);
    const euclidArray = $ed2075acb304f501$export$8109e94e4f1ea04c([
        ...euclidAbsolute,
        steps
    ]);
    return euclidArray;
};
const $ed2075acb304f501$export$bf4af9f3d2617c75 = (prefix)=>{
    let id = "";
    if (prefix != null) id += prefix + "-";
    id += (0, $aQPnZ.nanoid)();
    return id;
};
const $ed2075acb304f501$export$23c3e1a47b5208e9 = (value, step)=>Math.floor(value / step) * step;
const $ed2075acb304f501$export$96ed2b266aac6c21 = (value, step)=>Math.round(value / step) * step;
const $ed2075acb304f501$export$b4e65604ba7a7280 = (value, step)=>Math.ceil(value / step) * step;

});
parcelRegister("abvlt", function(module, exports) {

$parcel$export(module.exports, "rotateArray", () => $76a33efca356581d$export$28f07b8f6c19ecb5);
$parcel$export(module.exports, "dx2x", () => $76a33efca356581d$export$25f0518148a32b95);
const $76a33efca356581d$export$28f07b8f6c19ecb5 = (array, rotation)=>{
    const n = array.length;
    const rotatedArray = Array(n);
    //	Check for sanity
    rotation = (rotation % n + n) % n;
    for(let i = 0; i < n; i++){
        const element = array[i];
        const newIndex = (i + rotation) % n;
        rotatedArray[newIndex] = element;
    }
    return rotatedArray;
};
const $76a33efca356581d$export$25f0518148a32b95 = (array)=>{
    return array.reduce((result, value, index)=>{
        result.push(result[index] + value);
        return result;
    }, [
        0
    ]);
};

});

parcelRegister("aQPnZ", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $7e669edeb7a3f946$export$ac4959f4f1338dfc);

var $58lla = parcelRequire("58lla");
let $7e669edeb7a3f946$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $7e669edeb7a3f946$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let safeByteCutoff = 256 - 256 % alphabet.length;
    if (safeByteCutoff === 256) {
        let mask = alphabet.length - 1;
        return (size = defaultSize)=>{
            if (!size) return '';
            let id = '';
            while(true){
                let bytes = getRandom(size);
                let j = size;
                while(j--){
                    id += alphabet[bytes[j] & mask];
                    if (id.length >= size) return id;
                }
            }
        };
    }
    let step = Math.ceil(409.6 * defaultSize / safeByteCutoff);
    return (size = defaultSize)=>{
        if (!size) return '';
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--)if (bytes[j] < safeByteCutoff) {
                id += alphabet[bytes[j] % alphabet.length];
                if (id.length >= size) return id;
            }
        }
    };
};
let $7e669edeb7a3f946$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$7e669edeb7a3f946$export$a5cee9e955a615e5(alphabet, size | 0, $7e669edeb7a3f946$export$4385e60b38654f68);
let $7e669edeb7a3f946$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $58lla.urlAlphabet)[bytes[size] & 63];
    return id;
};

});
parcelRegister("58lla", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", () => $3bce40defd566837$export$2b646eea95309f00);
let $3bce40defd566837$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});



parcelRegister("1zQag", function(module, exports) {

$parcel$export(module.exports, "getMasterChannelParameterHandler", () => $1261861a8fafd945$export$dfba213d58cb24ad);
$parcel$export(module.exports, "getInitialParamValues", () => $1261861a8fafd945$export$f5350dc1f7cbe21a);
$parcel$export(module.exports, "limitToNyquist", () => $1261861a8fafd945$export$184d64b4020ac040);
$parcel$export(module.exports, "getWidgetData", () => $1261861a8fafd945$export$437b8f2ce7ba6ba);

var $3wfoi = parcelRequire("3wfoi");

var $5ICqB = parcelRequire("5ICqB");

var $lejHD = parcelRequire("lejHD");

var $95CQM = parcelRequire("95CQM");

var $hI7EC = parcelRequire("hI7EC");
const $1261861a8fafd945$export$dfba213d58cb24ad = (parameterName)=>{
    return new (0, $3wfoi.ParameterHandler)((0, $lejHD.MasterChannel).parametersDescription[parameterName], (0, $5ICqB.createMasterChannelParameterSelector)(parameterName), (value)=>(0, $5ICqB.setMasterChannelParameter)({
            name: parameterName,
            value: value
        }));
};
const $1261861a8fafd945$export$f5350dc1f7cbe21a = (parametersDescription)=>{
    return Object.fromEntries([
        ...Object.entries(parametersDescription)
    ].map(([name, { initial: initial }])=>[
            name,
            initial
        ]));
};
const $1261861a8fafd945$export$184d64b4020ac040 = (frequency)=>{
    const sr = (0, $95CQM.staticSelect)((0, $5ICqB.selectSampleRate));
    return Math.min(frequency, sr / 2);
};
const $1261861a8fafd945$export$437b8f2ce7ba6ba = (widgetID)=>{
    if (widgetID == null) console.warn("No widget ID for this knob!");
    let widgetData;
    if (widgetID) {
        widgetData = (0, $hI7EC.widgetLegends)[widgetID];
        if (widgetData == null) console.warn(`No widget data for widgetID ${widgetID}`);
    }
    return widgetData;
};

});
parcelRegister("3wfoi", function(module, exports) {

$parcel$export(module.exports, "ParameterHandler", () => $29004c8a925c01f5$export$83545dcd1df2934);
parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");

var $kmdF6 = parcelRequire("kmdF6");
class $29004c8a925c01f5$export$83545dcd1df2934 {
    constructor(description, selector, updater){
        this.description = description;
        this.selector = selector;
        this.updater = (value)=>{
            this.notifyUpdateSubscribers(value);
            return updater(value);
        };
        this.subscribers = new Set();
    }
    subscribeToUpdate(subscriber) {
        this.subscribers.add(subscriber);
        return ()=>{
            this.subscribers.delete(subscriber);
        };
    }
    notifyUpdateSubscribers(value) {
        this.subscribers.forEach((subscriber)=>subscriber(value));
    }
    ensureValidValue = (value)=>{
        if (this.description.type === 'float') return (0, $kmdF6.clamp)(value, this.description.min, this.description.max);
        else if (this.description.type === 'enum') return $29004c8a925c01f5$var$ensureValueInOptions(value, this.description.options, this.getDefaultValue());
        return value;
    };
    num2Real = (numValue)=>{
        const discreteValue = (0, $kmdF6.roundToStep)(numValue, this.getStep());
        switch(this.description.type){
            case 'float':
            case 'int':
                return discreteValue;
            case 'enum':
                return this.description.options[discreteValue];
            default:
                this.throwUnknownParameterError();
        }
    };
    real2Num = (realValue)=>{
        switch(this.description.type){
            case 'float':
            case 'int':
                return realValue;
            case 'enum':
                return this.description.options.indexOf(realValue);
            default:
                this.throwUnknownParameterError();
        }
    };
    norm2Num = (normValue)=>{
        const numMin = this.getNumericMin();
        const numMax = this.getNumericMax();
        const exponent = this.description.logarithmExponent ?? 2;
        if (!this.description.logarithmic) return (0, $kmdF6.lerp)(numMin, numMax, normValue);
        return (0, $kmdF6.lerp)(numMin, numMax, Math.pow(normValue, exponent));
    };
    num2Norm = (numValue)=>{
        const numMin = this.getNumericMin();
        const numMax = this.getNumericMax();
        const exponent = this.description.logarithmExponent ?? 2;
        if (!this.description.logarithmic) return (0, $kmdF6.normalize)(numValue, numMin, numMax);
        return Math.pow((0, $kmdF6.normalize)(numValue, numMin, numMax), 1 / exponent);
    };
    real2String = (realValue)=>{
        let displayValue = realValue;
        if (this.description.type === 'float') {
            const valueTenExponent = Math.floor(realValue) === 0 ? 1 : Math.floor(Math.log10(Math.abs(realValue))) + 1; // the number of digits of the integer
            const stepSize = this.getStep();
            const stepDecimals = stepSize ? stepSize.toString().split('.')[1]?.length || 0 : undefined;
            const precision = 4; // but integers can have more ciphers
            let maxDecimals = 2; // for continous values, we show a maximum of 2 decimals.
            if (stepSize) maxDecimals = stepDecimals; // for stepped ones, the ones corresponding to the step size.
            if (this.description.display === "percent") maxDecimals -= 2; // because we'll multiply by 100!
            const decimals = this.description.display === "db" ? 1 : (0, $kmdF6.clamp)(precision - valueTenExponent, 0, maxDecimals);
            if (this.description.display === "db") displayValue = (0, $bmU6v.gainToDb)(displayValue);
            else if (this.description.display === "percent") displayValue *= 100;
            displayValue = displayValue.toFixed(decimals);
            displayValue = displayValue.toString().replace("Infinity", "\u221E");
        }
        const THINSPACE = "\u2009";
        if (this.description.unit) displayValue += THINSPACE + this.description.unit;
        if (this.description.display === "percent") displayValue += THINSPACE + "%";
        return displayValue;
    };
    getNumericMin = ()=>{
        switch(this.description.type){
            case 'float':
            case 'int':
                return this.description.min;
            case 'enum':
                return 0;
            default:
                this.throwUnknownParameterError();
        }
    };
    getNumericMax = ()=>{
        switch(this.description.type){
            case 'float':
            case 'int':
                return this.description.max;
            case 'enum':
                return this.description.options.length - 1;
            default:
                this.throwUnknownParameterError();
        }
    };
    getStep = ()=>{
        switch(this.description.type){
            case 'float':
            case 'int':
                return this.description.step;
            case 'enum':
                return 1;
            default:
                throw this.throwUnknownParameterError();
        }
    };
    // cardinality == number of options. kinda.
    getCardinality = ()=>Math.floor((this.getNumericMax() - this.getNumericMin() + (this.getStep() ?? 0)) / (this.getStep() ?? 0));
    throwUnknownParameterError = ()=>{
        throw new Error(`Unknown parameter type (${this.description.type}) for parameter ${this.description.nom}`);
    };
    getDefaultValue = ()=>this.description.initial;
}
// Make sure enum value is within options
const $29004c8a925c01f5$var$ensureValueInOptions = (value, options, defaultValue)=>{
    if (options.includes(value)) return value;
    if (defaultValue != null) return defaultValue;
    return options[0];
};

});

parcelRegister("lejHD", function(module, exports) {

$parcel$export(module.exports, "MasterChannel", () => $f74a305df6e8f9f0$export$50146a330a0dd241);

var $hysHW = parcelRequire("hysHW");

var $dMqFE = parcelRequire("dMqFE");
parcelRequire("56MRX");
var $kzedo = parcelRequire("kzedo");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $2AuBL = parcelRequire("2AuBL");
var $fDBOr = parcelRequire("fDBOr");
const $f74a305df6e8f9f0$var$SPECTRUM_SIZE = 64;
class $f74a305df6e8f9f0$export$50146a330a0dd241 extends (0, $fDBOr.ToneAudioNode) {
    static parametersDescription = {
        ...(0, $hysHW.GrufBus).parametersDescription,
        djfValue: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 0.5
        },
        djfQ: {
            type: 'float',
            min: 0,
            max: 10,
            initial: 0
        }
    };
    constructor(){
        super();
        this.bus = new (0, $hysHW.GrufBus)();
        this.pregain = new (0, $bdbZZ.Gain)();
        this.djf = new (0, $dMqFE.DJFilter)();
        this.pregain.chain(this.djf, this.bus);
        this.limiter = new (0, $2AuBL.Limiter)(-1);
        this.preLimiterGain = new (0, $bdbZZ.Gain)((0, $bmU6v.dbToGain)(6));
        this.fft = new (0, $kzedo.Analyser)('fft', $f74a305df6e8f9f0$var$SPECTRUM_SIZE);
        this.bus.chain(this.preLimiterGain, this.limiter);
        this.bus.connect(this.fft);
        this.input = this.pregain;
        this.output = this.limiter;
    }
    set gain(value) {
        this.bus.gain = value;
    }
    set pan(value) {
        this.bus.pan = value;
    }
    set djfValue(value) {
        this.djf.set({
            value: value
        });
    }
    set djfQ(value) {
        this.djf.set({
            Q: value
        });
    }
    get spectrumSize() {
        return $f74a305df6e8f9f0$var$SPECTRUM_SIZE;
    }
    get spectrumData() {
        return this.fft.getValue();
    }
    dispose() {
        this.bus.dispose();
        this.limiter.dispose();
        this.preLimiterGain.dispose();
        this.fft.dispose();
    }
    getCurrentLevels() {
        return this.bus.getCurrentLevels();
    }
}

});
parcelRegister("hysHW", function(module, exports) {

$parcel$export(module.exports, "GrufBus", () => $cc7be162bc8840dc$export$7cd499732516d0e8);
parcelRequire("56MRX");
var $1x3k0 = parcelRequire("1x3k0");
var $bmU6v = parcelRequire("bmU6v");
var $lUFsy = parcelRequire("lUFsy");
var $fDBOr = parcelRequire("fDBOr");

var $huphW = parcelRequire("huphW");

var $kmdF6 = parcelRequire("kmdF6");
class $cc7be162bc8840dc$export$7cd499732516d0e8 extends (0, $fDBOr.ToneAudioNode) {
    static parametersDescription = {
        gain: {
            type: 'float',
            display: "db",
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: 0,
            max: 2.0,
            initial: 1.0,
            bind: "preset"
        },
        pan: {
            type: 'float',
            min: -1,
            max: 1,
            initial: 0,
            bind: "preset"
        },
        isMute: {
            type: 'bool',
            initial: false
        },
        isSolo: {
            type: 'bool',
            initial: false
        }
    };
    constructor(){
        super();
        this.masterChannel = new (0, $1x3k0.Channel)({
            channelCount: 2
        });
        this.muteChannel = new (0, $1x3k0.Channel)({
            channelCount: 2
        });
        this.meter = new (0, $lUFsy.Meter)({
            channelCount: 2,
            channels: 2
        });
        this.masterChannel.fan(this.muteChannel, this.meter);
        this.input = this.masterChannel;
        this.output = this.muteChannel;
    }
    dispose() {
        this.masterChannel.dispose();
        this.muteChannel.dispose();
        this.meter.dispose();
    }
    set gain(value) {
        const volume = (0, $bmU6v.gainToDb)(value);
        this.masterChannel.volume.linearRampTo(volume, 0.01);
    }
    set pan(value) {
        this.masterChannel.pan.linearRampTo(value, 0.01);
    }
    getCurrentLevels() {
        return this.meter.getValue().map((dBFSLevel)=>{
            const dBuLevel = dBFSLevel + 18;
            return (0, $kmdF6.clamp)(dBuLevel, -60, 6);
        });
    }
}

});
parcelRegister("huphW", function(module, exports) {
module.exports = JSON.parse("{\"second\":\"s\",\"hertz\":\"Hz\",\"decibel\":\"dB\",\"semitone\":\"st\"}");

});


parcelRegister("dMqFE", function(module, exports) {

$parcel$export(module.exports, "DJFilter", () => $a084724cc47086fc$export$117fc12a8816d4de);
parcelRequire("56MRX");
var $Lvs5H = parcelRequire("Lvs5H");
var $fDBOr = parcelRequire("fDBOr");

var $1zQag = parcelRequire("1zQag");
// DJ Filter.
// Allows to control HPF and LPF with the same value
const $a084724cc47086fc$var$MAX_FREQ = 13745; // the maximum is half the sample rate
const $a084724cc47086fc$var$MIN_FREQ = 20;
class $a084724cc47086fc$export$117fc12a8816d4de extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super();
        this.lpf = new (0, $Lvs5H.BiquadFilter)({
            frequency: (0, $1zQag.limitToNyquist)($a084724cc47086fc$var$MAX_FREQ),
            type: "lowpass",
            Q: 10
        });
        this.hpf = new (0, $Lvs5H.BiquadFilter)({
            frequency: 0,
            type: "highpass",
            Q: 0
        });
        this.lpf.connect(this.hpf);
        this.input = this.lpf;
        this.output = this.hpf;
    }
    dispose() {
        super.dispose();
        this.lpf.dispose();
        this.hpf.dispose();
    }
    #setValue(newValue) {
        let lpfFreq = $a084724cc47086fc$var$MAX_FREQ;
        let hpfFreq = $a084724cc47086fc$var$MIN_FREQ;
        if (newValue < 0.5) {
            const norm = newValue * 2;
            lpfFreq = Math.pow(10, norm * (Math.log10($a084724cc47086fc$var$MAX_FREQ) - Math.log10($a084724cc47086fc$var$MIN_FREQ)) + Math.log10($a084724cc47086fc$var$MIN_FREQ));
        } else if (newValue > 0.5) {
            const norm = newValue * 2 - 1;
            hpfFreq = Math.pow(10, norm * (Math.log10($a084724cc47086fc$var$MAX_FREQ) - Math.log10($a084724cc47086fc$var$MIN_FREQ)) + Math.log10($a084724cc47086fc$var$MIN_FREQ));
        }
        this.lpf.set({
            frequency: (0, $1zQag.limitToNyquist)(lpfFreq)
        });
        this.hpf.set({
            frequency: (0, $1zQag.limitToNyquist)(hpfFreq)
        });
    }
    set(params) {
        const { value: value, frequency: frequency, type: type, ...cascadingParams } = params;
        if (frequency != null) console.error("You don't set frequency direcly to DJFilter; instead, you give it a value between 0 and 1");
        if (type != null) console.error("The DJ Filter's internal filter types are fixed to lowpass and highpass");
        if (value != null) this.#setValue(value);
        this.lpf.set(cascadingParams);
        this.hpf.set(cascadingParams);
    }
}

});


parcelRegister("95CQM", function(module, exports) {

$parcel$export(module.exports, "renderReactComponentInElement", () => $69e2b786b470433a$export$a83baefb40f46067);
$parcel$export(module.exports, "staticSelect", () => $69e2b786b470433a$export$5a44369be6b2fb51);

var $6T1J1 = parcelRequire("6T1J1");

var $8NFma = parcelRequire("8NFma");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");
const $69e2b786b470433a$export$a83baefb40f46067 = (reactComponent, elementID, props = {}, reactRoot)=>{
    let root = reactRoot;
    if (reactRoot === undefined) root = (0, $6T1J1.createRoot)(document.getElementById(elementID));
    root.render(/*#__PURE__*/ (0, $8NFma.createElement)((0, $8NFma.StrictMode), null, /*#__PURE__*/ (0, $8NFma.createElement)((0, $7Kpeg.Provider), {
        store: $5ICqB.default
    }, /*#__PURE__*/ (0, $8NFma.createElement)(reactComponent, props))));
    return root;
};
function $69e2b786b470433a$export$5a44369be6b2fb51(selector, state = (0, $5ICqB.default).getState()) {
    return selector(state);
}

});
parcelRegister("6T1J1", function(module, exports) {
'use strict';
function $503937b663c395c4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($503937b663c395c4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$503937b663c395c4$var$checkDCE();

module.exports = (parcelRequire("gNTjK"));

});
parcelRegister("gNTjK", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $c3bc21db9fc66909$export$882461b6382ed46c, (v) => $c3bc21db9fc66909$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $c3bc21db9fc66909$export$757ceba2d55c277e, (v) => $c3bc21db9fc66909$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $c3bc21db9fc66909$export$83d89fbfd8236492, (v) => $c3bc21db9fc66909$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c3bc21db9fc66909$export$882461b6382ed46c;
var $c3bc21db9fc66909$export$757ceba2d55c277e;
var $c3bc21db9fc66909$export$83d89fbfd8236492;
"use strict";

var $clk2u = parcelRequire("clk2u");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $c3bc21db9fc66909$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c3bc21db9fc66909$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c3bc21db9fc66909$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c3bc21db9fc66909$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $c3bc21db9fc66909$var$assertIsMounted(fiber) {
    if ($c3bc21db9fc66909$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
}
function $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c3bc21db9fc66909$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c3bc21db9fc66909$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c3bc21db9fc66909$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $c3bc21db9fc66909$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $c3bc21db9fc66909$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $c3bc21db9fc66909$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $c3bc21db9fc66909$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $c3bc21db9fc66909$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $c3bc21db9fc66909$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(559));
    }
}
var $c3bc21db9fc66909$var$searchTarget = null, $c3bc21db9fc66909$var$searchBoundary = null;
function $c3bc21db9fc66909$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($c3bc21db9fc66909$var$searchTarget = child, !0) : !1;
}
function $c3bc21db9fc66909$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($c3bc21db9fc66909$var$searchBoundary = child, !1) : child === target ? (null !== $c3bc21db9fc66909$var$searchBoundary && ($c3bc21db9fc66909$var$searchTarget = child), !0) : !1;
}
function $c3bc21db9fc66909$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $c3bc21db9fc66909$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $c3bc21db9fc66909$var$assign = Object.assign, $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c3bc21db9fc66909$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c3bc21db9fc66909$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c3bc21db9fc66909$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c3bc21db9fc66909$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $c3bc21db9fc66909$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $c3bc21db9fc66909$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $c3bc21db9fc66909$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c3bc21db9fc66909$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c3bc21db9fc66909$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $c3bc21db9fc66909$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c3bc21db9fc66909$var$getComponentNameFromType(type.type) || "Memo";
        case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c3bc21db9fc66909$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c3bc21db9fc66909$var$isArrayImpl = Array.isArray, $c3bc21db9fc66909$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$ReactDOMSharedInternals = $2pmb0.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c3bc21db9fc66909$var$valueStack = [], $c3bc21db9fc66909$var$index = -1;
function $c3bc21db9fc66909$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c3bc21db9fc66909$var$pop(cursor) {
    0 > $c3bc21db9fc66909$var$index || (cursor.current = $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index], $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = null, $c3bc21db9fc66909$var$index--);
}
function $c3bc21db9fc66909$var$push(cursor, value) {
    $c3bc21db9fc66909$var$index++;
    $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = cursor.current;
    cursor.current = value;
}
var $c3bc21db9fc66909$var$contextStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$contextFiberStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$rootInstanceStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$hostTransitionProviderCursor = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$pushHostContainer(fiber, nextRootInstance) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$rootInstanceStackCursor, nextRootInstance);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c3bc21db9fc66909$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c3bc21db9fc66909$var$getOwnHostContext(nextRootInstance), fiber = $c3bc21db9fc66909$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, fiber);
}
function $c3bc21db9fc66909$var$popHostContainer() {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$rootInstanceStackCursor);
}
function $c3bc21db9fc66909$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($c3bc21db9fc66909$var$HostTransitionContext._currentValue = stateHook.memoizedState, $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$hostTransitionProviderCursor, fiber));
    stateHook = $c3bc21db9fc66909$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, JSCompiler_inline_result));
}
function $c3bc21db9fc66909$var$popHostContext(fiber) {
    $c3bc21db9fc66909$var$contextFiberStackCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor), $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor));
    $c3bc21db9fc66909$var$hostTransitionProviderCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$hostTransitionProviderCursor), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = $c3bc21db9fc66909$var$sharedNotPendingObject);
}
var $c3bc21db9fc66909$var$prefix, $c3bc21db9fc66909$var$suffix;
function $c3bc21db9fc66909$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c3bc21db9fc66909$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c3bc21db9fc66909$var$prefix = match && match[1] || "";
        $c3bc21db9fc66909$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c3bc21db9fc66909$var$prefix + name + $c3bc21db9fc66909$var$suffix;
}
var $c3bc21db9fc66909$var$reentry = !1;
function $c3bc21db9fc66909$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c3bc21db9fc66909$var$reentry) return "";
    $c3bc21db9fc66909$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c3bc21db9fc66909$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c3bc21db9fc66909$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c3bc21db9fc66909$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Suspense Fallback") : $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $c3bc21db9fc66909$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $c3bc21db9fc66909$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c3bc21db9fc66909$var$scheduleCallback$3 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$cancelCallback$1 = $clk2u.unstable_cancelCallback, $c3bc21db9fc66909$var$shouldYield = $clk2u.unstable_shouldYield, $c3bc21db9fc66909$var$requestPaint = $clk2u.unstable_requestPaint, $c3bc21db9fc66909$var$now = $clk2u.unstable_now, $c3bc21db9fc66909$var$getCurrentPriorityLevel = $clk2u.unstable_getCurrentPriorityLevel, $c3bc21db9fc66909$var$ImmediatePriority = $clk2u.unstable_ImmediatePriority, $c3bc21db9fc66909$var$UserBlockingPriority = $clk2u.unstable_UserBlockingPriority, $c3bc21db9fc66909$var$NormalPriority$1 = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$LowPriority = $clk2u.unstable_LowPriority, $c3bc21db9fc66909$var$IdlePriority = $clk2u.unstable_IdlePriority, $c3bc21db9fc66909$var$log$1 = $clk2u.log, $c3bc21db9fc66909$var$unstable_setDisableYieldValue = $clk2u.unstable_setDisableYieldValue, $c3bc21db9fc66909$var$rendererID = null, $c3bc21db9fc66909$var$injectedHook = null;
function $c3bc21db9fc66909$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c3bc21db9fc66909$var$log$1 && $c3bc21db9fc66909$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.setStrictMode) try {
        $c3bc21db9fc66909$var$injectedHook.setStrictMode($c3bc21db9fc66909$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c3bc21db9fc66909$var$clz32 = Math.clz32 ? Math.clz32 : $c3bc21db9fc66909$var$clz32Fallback, $c3bc21db9fc66909$var$log = Math.log, $c3bc21db9fc66909$var$LN2 = Math.LN2;
function $c3bc21db9fc66909$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c3bc21db9fc66909$var$log(x) / $c3bc21db9fc66909$var$LN2 | 0) | 0;
}
var $c3bc21db9fc66909$var$nextTransitionUpdateLane = 256, $c3bc21db9fc66909$var$nextTransitionDeferredLane = 262144, $c3bc21db9fc66909$var$nextRetryLane = 4194304;
function $c3bc21db9fc66909$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c3bc21db9fc66909$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c3bc21db9fc66909$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c3bc21db9fc66909$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c3bc21db9fc66909$var$claimNextRetryLane() {
    var lane = $c3bc21db9fc66909$var$nextRetryLane;
    $c3bc21db9fc66909$var$nextRetryLane <<= 1;
    0 === ($c3bc21db9fc66909$var$nextRetryLane & 62914560) && ($c3bc21db9fc66909$var$nextRetryLane = 4194304);
    return lane;
}
function $c3bc21db9fc66909$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c3bc21db9fc66909$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c3bc21db9fc66909$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c3bc21db9fc66909$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c3bc21db9fc66909$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $c3bc21db9fc66909$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c3bc21db9fc66909$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c3bc21db9fc66909$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c3bc21db9fc66909$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c3bc21db9fc66909$var$resolveUpdatePriority() {
    var updatePriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c3bc21db9fc66909$var$getEventPriority(updatePriority.type);
}
function $c3bc21db9fc66909$var$runWithPriority(priority, fn) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        return $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c3bc21db9fc66909$var$randomKey = Math.random().toString(36).slice(2), $c3bc21db9fc66909$var$internalInstanceKey = "__reactFiber$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalPropsKey = "__reactProps$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalContainerInstanceKey = "__reactContainer$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlersKey = "__reactEvents$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlerListenersKey = "__reactListeners$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlesSetKey = "__reactHandles$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalRootNodeResourcesKey = "__reactResources$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalHoistableMarker = "__reactMarker$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalLoadPendingKey = "__reactLoad$" + $c3bc21db9fc66909$var$randomKey;
function $c3bc21db9fc66909$var$detachDeletedInstance(node) {
    delete node[$c3bc21db9fc66909$var$internalInstanceKey];
    delete node[$c3bc21db9fc66909$var$internalPropsKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlerListenersKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlesSetKey];
}
function $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$c3bc21db9fc66909$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c3bc21db9fc66909$var$internalContainerInstanceKey] || parentNode[$c3bc21db9fc66909$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c3bc21db9fc66909$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c3bc21db9fc66909$var$internalInstanceKey]) return parentNode;
                targetNode = $c3bc21db9fc66909$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c3bc21db9fc66909$var$getInstanceFromNode(node) {
    if (node = node[$c3bc21db9fc66909$var$internalInstanceKey] || node[$c3bc21db9fc66909$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c3bc21db9fc66909$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(33));
}
function $c3bc21db9fc66909$var$getResourcesFromRoot(root) {
    var resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c3bc21db9fc66909$var$markNodeAsHoistable(node) {
    node[$c3bc21db9fc66909$var$internalHoistableMarker] = !0;
}
function $c3bc21db9fc66909$var$clearPendingLoadOnNode(node) {
    node[$c3bc21db9fc66909$var$internalLoadPendingKey] = void 0;
}
var $c3bc21db9fc66909$var$allNativeEvents = new Set(), $c3bc21db9fc66909$var$registrationNameDependencies = {};
function $c3bc21db9fc66909$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies);
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c3bc21db9fc66909$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c3bc21db9fc66909$var$illegalAttributeNameCache = {}, $c3bc21db9fc66909$var$validatedAttributeNameCache = {};
function $c3bc21db9fc66909$var$isAttributeNameSafe(attributeName) {
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c3bc21db9fc66909$var$validatedAttributeNameCache[attributeName] = !0;
    $c3bc21db9fc66909$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $c3bc21db9fc66909$var$viewTransitionMutationContext = !1;
function $c3bc21db9fc66909$var$pushMutationContext() {
    var prev = $c3bc21db9fc66909$var$viewTransitionMutationContext;
    $c3bc21db9fc66909$var$viewTransitionMutationContext = !1;
    return prev;
}
function $c3bc21db9fc66909$var$setValueForAttribute(node, name, value) {
    if ($c3bc21db9fc66909$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $c3bc21db9fc66909$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $c3bc21db9fc66909$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $c3bc21db9fc66909$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c3bc21db9fc66909$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c3bc21db9fc66909$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $c3bc21db9fc66909$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $c3bc21db9fc66909$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $c3bc21db9fc66909$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c3bc21db9fc66909$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c3bc21db9fc66909$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value);
        } else element.value !== "" + $c3bc21db9fc66909$var$getToStringValue(value) && (element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $c3bc21db9fc66909$var$setDefaultValue(element, $c3bc21db9fc66909$var$getToStringValue(element.value)) : $c3bc21db9fc66909$var$setDefaultValue(element, $c3bc21db9fc66909$var$getToStringValue(value)) : null != defaultValue ? $c3bc21db9fc66909$var$setDefaultValue(element, $c3bc21db9fc66909$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c3bc21db9fc66909$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c3bc21db9fc66909$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $c3bc21db9fc66909$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c3bc21db9fc66909$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $c3bc21db9fc66909$var$track(element);
}
function $c3bc21db9fc66909$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $c3bc21db9fc66909$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c3bc21db9fc66909$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c3bc21db9fc66909$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c3bc21db9fc66909$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
}
function $c3bc21db9fc66909$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(92));
            if ($c3bc21db9fc66909$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c3bc21db9fc66909$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $c3bc21db9fc66909$var$track(element);
}
function $c3bc21db9fc66909$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c3bc21db9fc66909$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c3bc21db9fc66909$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c3bc21db9fc66909$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c3bc21db9fc66909$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($c3bc21db9fc66909$var$setValueForStyle(node, styleName$16, styleName), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c3bc21db9fc66909$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c3bc21db9fc66909$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c3bc21db9fc66909$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c3bc21db9fc66909$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c3bc21db9fc66909$var$sanitizeURL(url) {
    return $c3bc21db9fc66909$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $c3bc21db9fc66909$var$noop$1() {}
var $c3bc21db9fc66909$var$currentReplayingEvent = null;
function $c3bc21db9fc66909$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreQueue = null;
function $c3bc21db9fc66909$var$restoreStateOfTarget(target) {
    var internalInstance = $c3bc21db9fc66909$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c3bc21db9fc66909$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c3bc21db9fc66909$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(90));
                            $c3bc21db9fc66909$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c3bc21db9fc66909$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c3bc21db9fc66909$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c3bc21db9fc66909$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c3bc21db9fc66909$var$isInsideEventHandler = !1;
function $c3bc21db9fc66909$var$batchedUpdates$1(fn, a, b) {
    if ($c3bc21db9fc66909$var$isInsideEventHandler) return fn(a, b);
    $c3bc21db9fc66909$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c3bc21db9fc66909$var$isInsideEventHandler = !1, null !== $c3bc21db9fc66909$var$restoreTarget || null !== $c3bc21db9fc66909$var$restoreQueue) {
            if ($c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$restoreTarget && (a = $c3bc21db9fc66909$var$restoreTarget, fn = $c3bc21db9fc66909$var$restoreQueue, $c3bc21db9fc66909$var$restoreQueue = $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c3bc21db9fc66909$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c3bc21db9fc66909$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c3bc21db9fc66909$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) try {
    var $c3bc21db9fc66909$var$options = {};
    Object.defineProperty($c3bc21db9fc66909$var$options, "passive", {
        get: function() {
            $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
    window.removeEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
} catch (e) {
    $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
}
var $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$startText = null, $c3bc21db9fc66909$var$fallbackText = null;
function $c3bc21db9fc66909$var$getData() {
    if ($c3bc21db9fc66909$var$fallbackText) return $c3bc21db9fc66909$var$fallbackText;
    var start, startValue = $c3bc21db9fc66909$var$startText, startLength = startValue.length, end, endValue = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c3bc21db9fc66909$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c3bc21db9fc66909$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c3bc21db9fc66909$var$functionThatReturnsTrue() {
    return !0;
}
function $c3bc21db9fc66909$var$functionThatReturnsFalse() {
    return !1;
}
function $c3bc21db9fc66909$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c3bc21db9fc66909$var$functionThatReturnsTrue : $c3bc21db9fc66909$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsFalse;
        return this;
    }
    $c3bc21db9fc66909$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c3bc21db9fc66909$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c3bc21db9fc66909$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c3bc21db9fc66909$var$SyntheticEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$EventInterface), $c3bc21db9fc66909$var$UIEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    view: 0,
    detail: 0
}), $c3bc21db9fc66909$var$SyntheticUIEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$UIEventInterface), $c3bc21db9fc66909$var$lastMovementX, $c3bc21db9fc66909$var$lastMovementY, $c3bc21db9fc66909$var$lastMouseEvent, $c3bc21db9fc66909$var$MouseEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c3bc21db9fc66909$var$lastMouseEvent && ($c3bc21db9fc66909$var$lastMouseEvent && "mousemove" === event.type ? ($c3bc21db9fc66909$var$lastMovementX = event.screenX - $c3bc21db9fc66909$var$lastMouseEvent.screenX, $c3bc21db9fc66909$var$lastMovementY = event.screenY - $c3bc21db9fc66909$var$lastMouseEvent.screenY) : $c3bc21db9fc66909$var$lastMovementY = $c3bc21db9fc66909$var$lastMovementX = 0, $c3bc21db9fc66909$var$lastMouseEvent = event);
        return $c3bc21db9fc66909$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c3bc21db9fc66909$var$lastMovementY;
    }
}), $c3bc21db9fc66909$var$SyntheticMouseEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$MouseEventInterface), $c3bc21db9fc66909$var$DragEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    dataTransfer: 0
}), $c3bc21db9fc66909$var$SyntheticDragEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$DragEventInterface), $c3bc21db9fc66909$var$FocusEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    relatedTarget: 0
}), $c3bc21db9fc66909$var$SyntheticFocusEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$FocusEventInterface), $c3bc21db9fc66909$var$AnimationEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticAnimationEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$AnimationEventInterface), $c3bc21db9fc66909$var$ClipboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c3bc21db9fc66909$var$SyntheticClipboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ClipboardEventInterface), $c3bc21db9fc66909$var$CompositionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    data: 0
}), $c3bc21db9fc66909$var$SyntheticCompositionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$CompositionEventInterface), $c3bc21db9fc66909$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c3bc21db9fc66909$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c3bc21db9fc66909$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c3bc21db9fc66909$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c3bc21db9fc66909$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c3bc21db9fc66909$var$getEventModifierState() {
    return $c3bc21db9fc66909$var$modifierStateGetter;
}
var $c3bc21db9fc66909$var$KeyboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c3bc21db9fc66909$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c3bc21db9fc66909$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c3bc21db9fc66909$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c3bc21db9fc66909$var$SyntheticKeyboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$KeyboardEventInterface), $c3bc21db9fc66909$var$PointerEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c3bc21db9fc66909$var$SyntheticPointerEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$PointerEventInterface), $c3bc21db9fc66909$var$SubmitEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    submitter: 0
}), $c3bc21db9fc66909$var$SyntheticSubmitEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$SubmitEventInterface), $c3bc21db9fc66909$var$TouchEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState
}), $c3bc21db9fc66909$var$SyntheticTouchEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TouchEventInterface), $c3bc21db9fc66909$var$TransitionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticTransitionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TransitionEventInterface), $c3bc21db9fc66909$var$WheelEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c3bc21db9fc66909$var$SyntheticWheelEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$WheelEventInterface), $c3bc21db9fc66909$var$ToggleEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $c3bc21db9fc66909$var$SyntheticToggleEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ToggleEventInterface), $c3bc21db9fc66909$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c3bc21db9fc66909$var$canUseCompositionEvent = $c3bc21db9fc66909$var$canUseDOM && "CompositionEvent" in window, $c3bc21db9fc66909$var$documentMode = null;
$c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && ($c3bc21db9fc66909$var$documentMode = document.documentMode);
var $c3bc21db9fc66909$var$canUseTextInputEvent = $c3bc21db9fc66909$var$canUseDOM && "TextEvent" in window && !$c3bc21db9fc66909$var$documentMode, $c3bc21db9fc66909$var$useFallbackCompositionData = $c3bc21db9fc66909$var$canUseDOM && (!$c3bc21db9fc66909$var$canUseCompositionEvent || $c3bc21db9fc66909$var$documentMode && 8 < $c3bc21db9fc66909$var$documentMode && 11 >= $c3bc21db9fc66909$var$documentMode), $c3bc21db9fc66909$var$SPACEBAR_CHAR = String.fromCharCode(32), $c3bc21db9fc66909$var$hasSpaceKeypress = !1;
function $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c3bc21db9fc66909$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c3bc21db9fc66909$var$isComposing = !1;
function $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c3bc21db9fc66909$var$hasSpaceKeypress = !0;
            return $c3bc21db9fc66909$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c3bc21db9fc66909$var$SPACEBAR_CHAR && $c3bc21db9fc66909$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c3bc21db9fc66909$var$isComposing) return "compositionend" === domEventName || !$c3bc21db9fc66909$var$canUseCompositionEvent && $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c3bc21db9fc66909$var$getData(), $c3bc21db9fc66909$var$fallbackText = $c3bc21db9fc66909$var$startText = $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c3bc21db9fc66909$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c3bc21db9fc66909$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c3bc21db9fc66909$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c3bc21db9fc66909$var$restoreTarget ? $c3bc21db9fc66909$var$restoreQueue ? $c3bc21db9fc66909$var$restoreQueue.push(target) : $c3bc21db9fc66909$var$restoreQueue = [
        target
    ] : $c3bc21db9fc66909$var$restoreTarget = target;
    inst = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c3bc21db9fc66909$var$activeElement$1 = null, $c3bc21db9fc66909$var$activeElementInst$1 = null;
function $c3bc21db9fc66909$var$runEventInBatch(dispatchQueue) {
    $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, 0);
}
function $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c3bc21db9fc66909$var$getNodeFromInstance(targetInst);
    if ($c3bc21db9fc66909$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c3bc21db9fc66909$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c3bc21db9fc66909$var$isInputEventSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) {
    var $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$318;
    if ($c3bc21db9fc66909$var$canUseDOM) {
        var $c3bc21db9fc66909$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$c3bc21db9fc66909$var$isSupported$jscomp$inline_474) {
            var $c3bc21db9fc66909$var$element$jscomp$inline_475 = document.createElement("div");
            $c3bc21db9fc66909$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $c3bc21db9fc66909$var$isSupported$jscomp$inline_474 = "function" === typeof $c3bc21db9fc66909$var$element$jscomp$inline_475.oninput;
        }
        $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$318 = $c3bc21db9fc66909$var$isSupported$jscomp$inline_474;
    } else $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$318 = !1;
    $c3bc21db9fc66909$var$isInputEventSupported = $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $c3bc21db9fc66909$var$stopWatchingForValueChange() {
    $c3bc21db9fc66909$var$activeElement$1 && ($c3bc21db9fc66909$var$activeElement$1.detachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange), $c3bc21db9fc66909$var$activeElementInst$1 = $c3bc21db9fc66909$var$activeElement$1 = null);
}
function $c3bc21db9fc66909$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, $c3bc21db9fc66909$var$activeElementInst$1, nativeEvent, $c3bc21db9fc66909$var$getEventTarget(nativeEvent));
        $c3bc21db9fc66909$var$batchedUpdates$1($c3bc21db9fc66909$var$runEventInBatch, dispatchQueue);
    }
}
function $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c3bc21db9fc66909$var$stopWatchingForValueChange(), $c3bc21db9fc66909$var$activeElement$1 = target, $c3bc21db9fc66909$var$activeElementInst$1 = targetInst, $c3bc21db9fc66909$var$activeElement$1.attachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange)) : "focusout" === domEventName && $c3bc21db9fc66909$var$stopWatchingForValueChange();
}
function $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1);
}
function $c3bc21db9fc66909$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c3bc21db9fc66909$var$objectIs = "function" === typeof Object.is ? Object.is : $c3bc21db9fc66909$var$is;
function $c3bc21db9fc66909$var$shallowEqual(objA, objB) {
    if ($c3bc21db9fc66909$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c3bc21db9fc66909$var$hasOwnProperty.call(objB, currentKey) || !$c3bc21db9fc66909$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c3bc21db9fc66909$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $c3bc21db9fc66909$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c3bc21db9fc66909$var$getNodeForCharacterOffset(root, offset) {
    var node = $c3bc21db9fc66909$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c3bc21db9fc66909$var$getLeafNode(node);
    }
}
function $c3bc21db9fc66909$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c3bc21db9fc66909$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c3bc21db9fc66909$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c3bc21db9fc66909$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c3bc21db9fc66909$var$skipSelectionChangeEvent = $c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c3bc21db9fc66909$var$activeElement = null, $c3bc21db9fc66909$var$activeElementInst = null, $c3bc21db9fc66909$var$lastSelection = null, $c3bc21db9fc66909$var$mouseDown = !1;
function $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c3bc21db9fc66909$var$mouseDown || null == $c3bc21db9fc66909$var$activeElement || $c3bc21db9fc66909$var$activeElement !== $c3bc21db9fc66909$var$getActiveElement(doc) || (doc = $c3bc21db9fc66909$var$activeElement, "selectionStart" in doc && $c3bc21db9fc66909$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c3bc21db9fc66909$var$lastSelection && $c3bc21db9fc66909$var$shallowEqual($c3bc21db9fc66909$var$lastSelection, doc) || ($c3bc21db9fc66909$var$lastSelection = doc, doc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners($c3bc21db9fc66909$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c3bc21db9fc66909$var$activeElement)));
}
function $c3bc21db9fc66909$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c3bc21db9fc66909$var$vendorPrefixes = {
    animationend: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionEnd")
}, $c3bc21db9fc66909$var$prefixedEventNames = {}, $c3bc21db9fc66909$var$style = {};
$c3bc21db9fc66909$var$canUseDOM && ($c3bc21db9fc66909$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c3bc21db9fc66909$var$vendorPrefixes.animationend.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationiteration.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c3bc21db9fc66909$var$vendorPrefixes.transitionend.transition);
function $c3bc21db9fc66909$var$getVendorPrefixedEventName(eventName) {
    if ($c3bc21db9fc66909$var$prefixedEventNames[eventName]) return $c3bc21db9fc66909$var$prefixedEventNames[eventName];
    if (!$c3bc21db9fc66909$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c3bc21db9fc66909$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c3bc21db9fc66909$var$style) return $c3bc21db9fc66909$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c3bc21db9fc66909$var$ANIMATION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationend"), $c3bc21db9fc66909$var$ANIMATION_ITERATION = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationiteration"), $c3bc21db9fc66909$var$ANIMATION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationstart"), $c3bc21db9fc66909$var$TRANSITION_RUN = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionrun"), $c3bc21db9fc66909$var$TRANSITION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionstart"), $c3bc21db9fc66909$var$TRANSITION_CANCEL = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitioncancel"), $c3bc21db9fc66909$var$TRANSITION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionend"), $c3bc21db9fc66909$var$topLevelEventsToReactNames = new Map(), $c3bc21db9fc66909$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c3bc21db9fc66909$var$simpleEventPluginEvents.push("scrollEnd");
function $c3bc21db9fc66909$var$registerSimpleEvent(domEventName, reactName) {
    $c3bc21db9fc66909$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c3bc21db9fc66909$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c3bc21db9fc66909$var$globalClientIdCounter$1 = 0;
function $c3bc21db9fc66909$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $c3bc21db9fc66909$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $c3bc21db9fc66909$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $c3bc21db9fc66909$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $c3bc21db9fc66909$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $c3bc21db9fc66909$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $c3bc21db9fc66909$var$getClassNameByType(defaultClass);
    eventClass = $c3bc21db9fc66909$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $c3bc21db9fc66909$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $c3bc21db9fc66909$var$concurrentQueues = [], $c3bc21db9fc66909$var$concurrentQueuesIndex = 0, $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = 0;
function $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c3bc21db9fc66909$var$concurrentQueuesIndex, i = $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = $c3bc21db9fc66909$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var queue = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var update = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var lane = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = fiber;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = queue;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = update;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = lane;
    $c3bc21db9fc66909$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c3bc21db9fc66909$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c3bc21db9fc66909$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c3bc21db9fc66909$var$nestedUpdateCount) throw $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null, Error($c3bc21db9fc66909$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c3bc21db9fc66909$var$emptyContextObject = {};
function $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c3bc21db9fc66909$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode);
}
function $c3bc21db9fc66909$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c3bc21db9fc66909$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c3bc21db9fc66909$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c3bc21db9fc66909$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c3bc21db9fc66909$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $c3bc21db9fc66909$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $c3bc21db9fc66909$var$isHostHoistableType(type, pendingProps, $c3bc21db9fc66909$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return $c3bc21db9fc66909$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c3bc21db9fc66909$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_LEGACY_HIDDEN_TYPE:
        case $c3bc21db9fc66909$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $c3bc21db9fc66909$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $c3bc21db9fc66909$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c3bc21db9fc66909$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c3bc21db9fc66909$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c3bc21db9fc66909$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c3bc21db9fc66909$var$createFiberFromText(content, mode, lanes) {
    content = $c3bc21db9fc66909$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $c3bc21db9fc66909$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $c3bc21db9fc66909$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c3bc21db9fc66909$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c3bc21db9fc66909$var$CapturedStacks = new WeakMap();
function $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c3bc21db9fc66909$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
        };
        $c3bc21db9fc66909$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
    };
}
var $c3bc21db9fc66909$var$forkStack = [], $c3bc21db9fc66909$var$forkStackIndex = 0, $c3bc21db9fc66909$var$treeForkProvider = null, $c3bc21db9fc66909$var$treeForkCount = 0, $c3bc21db9fc66909$var$idStack = [], $c3bc21db9fc66909$var$idStackIndex = 0, $c3bc21db9fc66909$var$treeContextProvider = null, $c3bc21db9fc66909$var$treeContextId = 1, $c3bc21db9fc66909$var$treeContextOverflow = "";
function $c3bc21db9fc66909$var$pushTreeFork(workInProgress, totalChildren) {
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkCount;
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkProvider;
    $c3bc21db9fc66909$var$treeForkProvider = workInProgress;
    $c3bc21db9fc66909$var$treeForkCount = totalChildren;
}
function $c3bc21db9fc66909$var$pushTreeId(workInProgress, totalChildren, index) {
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider;
    $c3bc21db9fc66909$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
    workInProgress = $c3bc21db9fc66909$var$treeContextOverflow;
    var baseLength = 32 - $c3bc21db9fc66909$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c3bc21db9fc66909$var$treeContextId = 1 << 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c3bc21db9fc66909$var$treeContextOverflow = length + workInProgress;
    } else $c3bc21db9fc66909$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c3bc21db9fc66909$var$treeContextOverflow = workInProgress;
}
function $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c3bc21db9fc66909$var$pushTreeFork(workInProgress, 1), $c3bc21db9fc66909$var$pushTreeId(workInProgress, 1, 0));
}
function $c3bc21db9fc66909$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c3bc21db9fc66909$var$treeForkProvider;)$c3bc21db9fc66909$var$treeForkProvider = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null, $c3bc21db9fc66909$var$treeForkCount = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null;
    for(; workInProgress === $c3bc21db9fc66909$var$treeContextProvider;)$c3bc21db9fc66909$var$treeContextProvider = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextOverflow = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextId = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null;
}
function $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider;
    $c3bc21db9fc66909$var$treeContextId = suspendedContext.id;
    $c3bc21db9fc66909$var$treeContextOverflow = suspendedContext.overflow;
    $c3bc21db9fc66909$var$treeContextProvider = workInProgress;
}
var $c3bc21db9fc66909$var$hydrationParentFiber = null, $c3bc21db9fc66909$var$nextHydratableInstance = null, $c3bc21db9fc66909$var$isHydrating = !1, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, $c3bc21db9fc66909$var$HydrationMismatchException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(519));
function $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c3bc21db9fc66909$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(error, fiber));
    throw $c3bc21db9fc66909$var$HydrationMismatchException;
}
function $c3bc21db9fc66909$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c3bc21db9fc66909$var$internalInstanceKey] = fiber;
    instance[$c3bc21db9fc66909$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c3bc21db9fc66909$var$mediaEventTypes.length; type++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            $c3bc21db9fc66909$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance), $c3bc21db9fc66909$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", instance), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c3bc21db9fc66909$var$noop$1), instance = !0) : instance = !1;
    instance || $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber, !0);
}
function $c3bc21db9fc66909$var$popToNextHostParent(fiber) {
    for($c3bc21db9fc66909$var$hydrationParentFiber = fiber.return; $c3bc21db9fc66909$var$hydrationParentFiber;)switch($c3bc21db9fc66909$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
            return;
        default:
            $c3bc21db9fc66909$var$hydrationParentFiber = $c3bc21db9fc66909$var$hydrationParentFiber.return;
    }
}
function $c3bc21db9fc66909$var$popHydrationState(fiber) {
    if (fiber !== $c3bc21db9fc66909$var$hydrationParentFiber) return !1;
    if (!$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$popToNextHostParent(fiber), $c3bc21db9fc66909$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c3bc21db9fc66909$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c3bc21db9fc66909$var$nextHydratableInstance && $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber);
    $c3bc21db9fc66909$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(fiber.type) ? (fiber = $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton, $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null, $c3bc21db9fc66909$var$nextHydratableInstance = fiber) : $c3bc21db9fc66909$var$nextHydratableInstance = tag) : $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber ? $c3bc21db9fc66909$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c3bc21db9fc66909$var$resetHydrationState() {
    $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber = null;
    $c3bc21db9fc66909$var$isHydrating = !1;
}
function $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c3bc21db9fc66909$var$hydrationErrors;
    null !== queuedErrors && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = queuedErrors : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, queuedErrors), $c3bc21db9fc66909$var$hydrationErrors = null);
    return queuedErrors;
}
function $c3bc21db9fc66909$var$queueHydrationError(error) {
    null === $c3bc21db9fc66909$var$hydrationErrors ? $c3bc21db9fc66909$var$hydrationErrors = [
        error
    ] : $c3bc21db9fc66909$var$hydrationErrors.push(error);
}
var $c3bc21db9fc66909$var$valueCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$lastContextDependency = null;
function $c3bc21db9fc66909$var$pushProvider(providerFiber, context, nextValue) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c3bc21db9fc66909$var$popProvider(context) {
    context._currentValue = $c3bc21db9fc66909$var$valueCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$valueCursor);
}
function $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c3bc21db9fc66909$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c3bc21db9fc66909$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c3bc21db9fc66909$var$HostTransitionContext) : current = [
                $c3bc21db9fc66909$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $c3bc21db9fc66909$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c3bc21db9fc66909$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c3bc21db9fc66909$var$prepareToReadContext(workInProgress) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = workInProgress;
    $c3bc21db9fc66909$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c3bc21db9fc66909$var$readContext(context) {
    return $c3bc21db9fc66909$var$readContextForConsumer($c3bc21db9fc66909$var$currentlyRenderingFiber$1, context);
}
function $c3bc21db9fc66909$var$readContextDuringReconciliation(consumer, context) {
    null === $c3bc21db9fc66909$var$currentlyRenderingFiber$1 && $c3bc21db9fc66909$var$prepareToReadContext(consumer);
    return $c3bc21db9fc66909$var$readContextForConsumer(consumer, context);
}
function $c3bc21db9fc66909$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c3bc21db9fc66909$var$lastContextDependency) {
        if (null === consumer) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(308));
        $c3bc21db9fc66909$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$lastContextDependency.next = context;
    return value;
}
var $c3bc21db9fc66909$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c3bc21db9fc66909$var$scheduleCallback$2 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$NormalPriority = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$CacheContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$createCache() {
    return {
        controller: new $c3bc21db9fc66909$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c3bc21db9fc66909$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c3bc21db9fc66909$var$scheduleCallback$2($c3bc21db9fc66909$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $c3bc21db9fc66909$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $c3bc21db9fc66909$var$entangledTransitionTypes = null;
function $c3bc21db9fc66909$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $c3bc21db9fc66909$var$currentEntangledListeners = null, $c3bc21db9fc66909$var$currentEntangledPendingCount = 0, $c3bc21db9fc66909$var$currentEntangledLane = 0, $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
function $c3bc21db9fc66909$var$entangleAsyncAction(transition, thenable) {
    if (null === $c3bc21db9fc66909$var$currentEntangledListeners) {
        var entangledListeners = $c3bc21db9fc66909$var$currentEntangledListeners = [];
        $c3bc21db9fc66909$var$currentEntangledPendingCount = 0;
        $c3bc21db9fc66909$var$currentEntangledLane = $c3bc21db9fc66909$var$requestTransitionLane();
        $c3bc21db9fc66909$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c3bc21db9fc66909$var$currentEntangledPendingCount++;
    thenable.then($c3bc21db9fc66909$var$pingEngtangledActionScope, $c3bc21db9fc66909$var$pingEngtangledActionScope);
    return thenable;
}
function $c3bc21db9fc66909$var$pingEngtangledActionScope() {
    if (0 === --$c3bc21db9fc66909$var$currentEntangledPendingCount && ($c3bc21db9fc66909$var$entangledTransitionTypes = null, null !== $c3bc21db9fc66909$var$currentEntangledListeners)) {
        null !== $c3bc21db9fc66909$var$currentEntangledActionThenable && ($c3bc21db9fc66909$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c3bc21db9fc66909$var$currentEntangledListeners;
        $c3bc21db9fc66909$var$currentEntangledListeners = null;
        $c3bc21db9fc66909$var$currentEntangledLane = 0;
        $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c3bc21db9fc66909$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c3bc21db9fc66909$var$prevOnStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
$c3bc21db9fc66909$var$ReactSharedInternals.S = function(transition, returnValue) {
    $c3bc21db9fc66909$var$globalMostRecentTransitionTime = $c3bc21db9fc66909$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c3bc21db9fc66909$var$entangleAsyncAction(transition, returnValue);
    if (null !== $c3bc21db9fc66909$var$entangledTransitionTypes) for(var root$28 = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root$28;)$c3bc21db9fc66909$var$queueTransitionTypes(root$28, $c3bc21db9fc66909$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root$29;)$c3bc21db9fc66909$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $c3bc21db9fc66909$var$currentEntangledLane) {
            root$29 = $c3bc21db9fc66909$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $c3bc21db9fc66909$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $c3bc21db9fc66909$var$prevOnStartTransitionFinish && $c3bc21db9fc66909$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c3bc21db9fc66909$var$resumedCache = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c3bc21db9fc66909$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c3bc21db9fc66909$var$workInProgressRoot.pooledCache;
}
function $c3bc21db9fc66909$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, $c3bc21db9fc66909$var$resumedCache.current) : $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, prevCachePool.pool);
}
function $c3bc21db9fc66909$var$getSuspendedCache() {
    var cacheFromPool = $c3bc21db9fc66909$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c3bc21db9fc66909$var$SuspenseException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(460)), $c3bc21db9fc66909$var$SuspenseyCommitException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(474)), $c3bc21db9fc66909$var$SuspenseActionException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(542)), $c3bc21db9fc66909$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c3bc21db9fc66909$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c3bc21db9fc66909$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c3bc21db9fc66909$var$noop$1, $c3bc21db9fc66909$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c3bc21db9fc66909$var$noop$1, $c3bc21db9fc66909$var$noop$1);
            else {
                thenableState = $c3bc21db9fc66909$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c3bc21db9fc66909$var$suspendedThenable = thenable;
            throw $c3bc21db9fc66909$var$SuspenseException;
    }
}
function $c3bc21db9fc66909$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $c3bc21db9fc66909$var$suspendedThenable = x, $c3bc21db9fc66909$var$SuspenseException;
        throw x;
    }
}
var $c3bc21db9fc66909$var$suspendedThenable = null;
function $c3bc21db9fc66909$var$getSuspendedThenable() {
    if (null === $c3bc21db9fc66909$var$suspendedThenable) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(459));
    var thenable = $c3bc21db9fc66909$var$suspendedThenable;
    $c3bc21db9fc66909$var$suspendedThenable = null;
    return thenable;
}
function $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c3bc21db9fc66909$var$SuspenseException || rejectedReason === $c3bc21db9fc66909$var$SuspenseActionException) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(483));
}
var $c3bc21db9fc66909$var$thenableState$1 = null, $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
function $c3bc21db9fc66909$var$unwrapThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter$1;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 += 1;
    null === $c3bc21db9fc66909$var$thenableState$1 && ($c3bc21db9fc66909$var$thenableState$1 = []);
    return $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState$1, thenable, index);
}
function $c3bc21db9fc66909$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c3bc21db9fc66909$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c3bc21db9fc66909$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $c3bc21db9fc66909$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c3bc21db9fc66909$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c3bc21db9fc66909$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c3bc21db9fc66909$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c3bc21db9fc66909$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return newChild = $c3bc21db9fc66909$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $c3bc21db9fc66909$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c3bc21db9fc66909$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE ? (lanes = $c3bc21db9fc66909$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c3bc21db9fc66909$var$getIteratorFn(newChild)) {
                key = $c3bc21db9fc66909$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c3bc21db9fc66909$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c3bc21db9fc66909$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c3bc21db9fc66909$var$SuspenseException || x === $c3bc21db9fc66909$var$SuspenseActionException) throw x;
            var fiber = $c3bc21db9fc66909$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c3bc21db9fc66909$var$reconcileChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!0), $c3bc21db9fc66909$var$mountChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!1), $c3bc21db9fc66909$var$hasForceUpdate = !1;
function $c3bc21db9fc66909$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c3bc21db9fc66909$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c3bc21db9fc66909$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
        $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
function $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c3bc21db9fc66909$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c3bc21db9fc66909$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c3bc21db9fc66909$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c3bc21db9fc66909$var$currentEntangledLane && ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c3bc21db9fc66909$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c3bc21db9fc66909$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c3bc21db9fc66909$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c3bc21db9fc66909$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c3bc21db9fc66909$var$callCallback(callbacks[updateQueue], context);
}
var $c3bc21db9fc66909$var$currentTreeHiddenStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$pushHiddenContext(fiber, context) {
    fiber = $c3bc21db9fc66909$var$entangledRenderLanes;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, context);
    $c3bc21db9fc66909$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c3bc21db9fc66909$var$reuseHiddenContextOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, $c3bc21db9fc66909$var$entangledRenderLanes);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current);
}
function $c3bc21db9fc66909$var$popHiddenContext() {
    $c3bc21db9fc66909$var$entangledRenderLanes = $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$currentTreeHiddenStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor);
}
var $c3bc21db9fc66909$var$suspenseHandlerStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$shellBoundary = null;
function $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, handler);
    null === $c3bc21db9fc66909$var$shellBoundary && (null === current || null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current ? $c3bc21db9fc66909$var$shellBoundary = handler : null !== current.memoizedState && ($c3bc21db9fc66909$var$shellBoundary = handler));
}
function $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, fiber);
    null === $c3bc21db9fc66909$var$shellBoundary && ($c3bc21db9fc66909$var$shellBoundary = fiber);
}
function $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, fiber), null === $c3bc21db9fc66909$var$shellBoundary && ($c3bc21db9fc66909$var$shellBoundary = fiber)) : $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack();
}
function $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current);
}
function $c3bc21db9fc66909$var$popSuspenseHandler(fiber) {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseHandlerStackCursor);
    $c3bc21db9fc66909$var$shellBoundary === fiber && ($c3bc21db9fc66909$var$shellBoundary = null);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
}
var $c3bc21db9fc66909$var$suspenseStackCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$pushSuspenseListContext(fiber, newContext) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, newContext);
}
function $c3bc21db9fc66909$var$popSuspenseListContext(fiber) {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseHandlerStackCursor);
    $c3bc21db9fc66909$var$shellBoundary === fiber && ($c3bc21db9fc66909$var$shellBoundary = null);
}
function $c3bc21db9fc66909$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $c3bc21db9fc66909$var$isSuspenseInstancePending(state) || $c3bc21db9fc66909$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c3bc21db9fc66909$var$renderLanes = 0, $c3bc21db9fc66909$var$currentlyRenderingFiber = null, $c3bc21db9fc66909$var$currentHook = null, $c3bc21db9fc66909$var$workInProgressHook = null, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c3bc21db9fc66909$var$localIdCounter = 0, $c3bc21db9fc66909$var$thenableIndexCounter = 0, $c3bc21db9fc66909$var$thenableState = null, $c3bc21db9fc66909$var$globalClientIdCounter = 0;
function $c3bc21db9fc66909$var$throwInvalidHookError() {
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(321));
}
function $c3bc21db9fc66909$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c3bc21db9fc66909$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c3bc21db9fc66909$var$renderLanes = nextRenderLanes;
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate;
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c3bc21db9fc66909$var$finishRenderingHooks(current) {
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c3bc21db9fc66909$var$currentHook && null !== $c3bc21db9fc66909$var$currentHook.next;
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter = 0;
    $c3bc21db9fc66909$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(300));
    null === current || $c3bc21db9fc66909$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0));
}
function $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c3bc21db9fc66909$var$thenableState = null);
        $c3bc21db9fc66909$var$thenableIndexCounter = 0;
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c3bc21db9fc66909$var$TransitionAwareHostComponent() {
    var dispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c3bc21db9fc66909$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$currentHook.memoizedState : null) !== dispatcher && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c3bc21db9fc66909$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c3bc21db9fc66909$var$localIdCounter;
    $c3bc21db9fc66909$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c3bc21db9fc66909$var$resetHooksOnUnwind(workInProgress) {
    if ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter = $c3bc21db9fc66909$var$localIdCounter = 0;
    $c3bc21db9fc66909$var$thenableState = null;
}
function $c3bc21db9fc66909$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = hook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = hook;
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$updateWorkInProgressHook() {
    if (null === $c3bc21db9fc66909$var$currentHook) {
        var nextCurrentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c3bc21db9fc66909$var$currentHook.next;
    var nextWorkInProgressHook = null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c3bc21db9fc66909$var$workInProgressHook = nextWorkInProgressHook, $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(467));
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(310));
        }
        $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c3bc21db9fc66909$var$currentHook.memoizedState,
            baseState: $c3bc21db9fc66909$var$currentHook.baseState,
            baseQueue: $c3bc21db9fc66909$var$currentHook.baseQueue,
            queue: $c3bc21db9fc66909$var$currentHook.queue,
            next: null
        };
        null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = nextCurrentHook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c3bc21db9fc66909$var$useThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter;
    $c3bc21db9fc66909$var$thenableIndexCounter += 1;
    null === $c3bc21db9fc66909$var$thenableState && ($c3bc21db9fc66909$var$thenableState = []);
    thenable = $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState, thenable, index);
    index = $c3bc21db9fc66909$var$currentlyRenderingFiber;
    null === (null === $c3bc21db9fc66909$var$workInProgressHook ? index.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next) && (index = index.alternate, $c3bc21db9fc66909$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c3bc21db9fc66909$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c3bc21db9fc66909$var$useThenable(usable);
        if (usable.$$typeof === $c3bc21db9fc66909$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return $c3bc21db9fc66909$var$readContext(usable);
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(438, String(usable)));
}
function $c3bc21db9fc66909$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c3bc21db9fc66909$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c3bc21db9fc66909$var$updateReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, reducer);
}
function $c3bc21db9fc66909$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c3bc21db9fc66909$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($c3bc21db9fc66909$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= revertLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= updateLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c3bc21db9fc66909$var$objectIs(pendingQueue, hook.memoizedState) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $c3bc21db9fc66909$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c3bc21db9fc66909$var$rerenderReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c3bc21db9fc66909$var$objectIs(newState, hook.memoizedState) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c3bc21db9fc66909$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c3bc21db9fc66909$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c3bc21db9fc66909$var$objectIs(($c3bc21db9fc66909$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c3bc21db9fc66909$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c3bc21db9fc66909$var$updateEffect($c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c3bc21db9fc66909$var$workInProgressHook && 0 !== ($c3bc21db9fc66909$var$workInProgressHook.memoizedState.tag & 1);
    $c3bc21db9fc66909$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c3bc21db9fc66909$var$renderLanes & 127) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c3bc21db9fc66909$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
}
function $c3bc21db9fc66909$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
    });
}
function $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c3bc21db9fc66909$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c3bc21db9fc66909$var$forceStoreRerender(fiber) {
    var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c3bc21db9fc66909$var$mountStateImpl(initialState) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c3bc21db9fc66909$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, "function" === typeof reducer ? reducer : $c3bc21db9fc66909$var$basicStateReducer);
}
function $c3bc21db9fc66909$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c3bc21db9fc66909$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c3bc21db9fc66909$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $c3bc21db9fc66909$var$onActionError(actionQueue, node, error$70);
    }
}
function $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
    }) : $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c3bc21db9fc66909$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c3bc21db9fc66909$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, nextState)));
}
function $c3bc21db9fc66909$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c3bc21db9fc66909$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c3bc21db9fc66909$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c3bc21db9fc66909$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c3bc21db9fc66909$var$mountActionState(action, initialStateProp) {
    if ($c3bc21db9fc66909$var$isHydrating) {
        var ssrFormState = $c3bc21db9fc66909$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c3bc21db9fc66909$var$currentlyRenderingFiber;
                if ($c3bc21db9fc66909$var$isHydrating) {
                    if ($c3bc21db9fc66909$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c3bc21db9fc66909$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c3bc21db9fc66909$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountStateImpl(!1);
    inRootOrSingleton = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c3bc21db9fc66909$var$dispatchActionState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c3bc21db9fc66909$var$updateActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, $c3bc21db9fc66909$var$currentHook, action);
}
function $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c3bc21db9fc66909$var$updateReducerImpl(stateHook, currentStateHook, $c3bc21db9fc66909$var$actionStateReducer)[0];
    stateHook = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c3bc21db9fc66909$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c3bc21db9fc66909$var$SuspenseException) throw $c3bc21db9fc66909$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 2048, $c3bc21db9fc66909$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $c3bc21db9fc66909$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c3bc21db9fc66909$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c3bc21db9fc66909$var$rerenderActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), currentStateHook = $c3bc21db9fc66909$var$currentHook;
    if (null !== currentStateHook) return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c3bc21db9fc66909$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c3bc21db9fc66909$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $c3bc21db9fc66909$var$updateRef() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $c3bc21db9fc66909$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c3bc21db9fc66909$var$currentHook && null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, $c3bc21db9fc66909$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c3bc21db9fc66909$var$mountEffect(create, deps) {
    $c3bc21db9fc66909$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c3bc21db9fc66909$var$updateEffect(create, deps) {
    $c3bc21db9fc66909$var$updateEffectImpl(2048, 8, create, deps);
}
function $c3bc21db9fc66909$var$useEffectEventImpl(payload) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $c3bc21db9fc66909$var$updateEvent(callback) {
    var ref = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
    $c3bc21db9fc66909$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $c3bc21db9fc66909$var$updateInsertionEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 2, create, deps);
}
function $c3bc21db9fc66909$var$updateLayoutEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 4, create, deps);
}
function $c3bc21db9fc66909$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c3bc21db9fc66909$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c3bc21db9fc66909$var$updateEffectImpl(4, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c3bc21db9fc66909$var$mountDebugValue() {}
function $c3bc21db9fc66909$var$updateCallback(callback, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c3bc21db9fc66909$var$updateMemo(nextCreate, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c3bc21db9fc66909$var$renderLanes & 1073741824) && 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c3bc21db9fc66909$var$objectIs(value, prevValue)) return value;
    if (null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current) return hook = $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue), $c3bc21db9fc66909$var$objectIs(hook, prevValue) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0), hook;
    if (0 === ($c3bc21db9fc66909$var$renderLanes & 106) || 0 !== ($c3bc21db9fc66909$var$renderLanes & 1073741824) && 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 261930)) return $c3bc21db9fc66909$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c3bc21db9fc66909$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
    $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c3bc21db9fc66909$var$chainThenableValue(returnValue, finishedState);
            $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
        } else $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, finishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
    } catch (error) {
        $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c3bc21db9fc66909$var$requestUpdateLane());
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$noop() {}
function $c3bc21db9fc66909$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(476));
    var queue = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber).queue;
    $c3bc21db9fc66909$var$startTransition(formFiber, queue, pendingState, $c3bc21db9fc66909$var$sharedNotPendingObject, null === action ? $c3bc21db9fc66909$var$noop : function() {
        $c3bc21db9fc66909$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: $c3bc21db9fc66909$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c3bc21db9fc66909$var$requestFormReset$1(formFiber) {
    var stateHook = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $c3bc21db9fc66909$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $c3bc21db9fc66909$var$requestUpdateLane());
}
function $c3bc21db9fc66909$var$useHostTransitionStatus() {
    return $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$HostTransitionContext);
}
function $c3bc21db9fc66909$var$updateId() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$updateRefresh() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c3bc21db9fc66909$var$requestUpdateLane();
                fiber = $c3bc21db9fc66909$var$createUpdate(lane);
                var root$73 = $c3bc21db9fc66909$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(root$73, provider, lane), $c3bc21db9fc66909$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $c3bc21db9fc66909$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c3bc21db9fc66909$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) ? $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c3bc21db9fc66909$var$dispatchSetState(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c3bc21db9fc66909$var$objectIs(eagerState, currentState)) return $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c3bc21db9fc66909$var$workInProgressRoot && $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c3bc21db9fc66909$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c3bc21db9fc66909$var$currentlyRenderingFiber || null !== alternate && alternate === $c3bc21db9fc66909$var$currentlyRenderingFiber;
}
function $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update) {
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c3bc21db9fc66909$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
var $c3bc21db9fc66909$var$ContextOnlyDispatcher = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$throwInvalidHookError,
    useContext: $c3bc21db9fc66909$var$throwInvalidHookError,
    useEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useImperativeHandle: $c3bc21db9fc66909$var$throwInvalidHookError,
    useLayoutEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useInsertionEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemo: $c3bc21db9fc66909$var$throwInvalidHookError,
    useReducer: $c3bc21db9fc66909$var$throwInvalidHookError,
    useRef: $c3bc21db9fc66909$var$throwInvalidHookError,
    useState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDebugValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDeferredValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useTransition: $c3bc21db9fc66909$var$throwInvalidHookError,
    useSyncExternalStore: $c3bc21db9fc66909$var$throwInvalidHookError,
    useId: $c3bc21db9fc66909$var$throwInvalidHookError,
    useHostTransitionStatus: $c3bc21db9fc66909$var$throwInvalidHookError,
    useFormState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useActionState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useOptimistic: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemoCache: $c3bc21db9fc66909$var$throwInvalidHookError,
    useCacheRefresh: $c3bc21db9fc66909$var$throwInvalidHookError,
    useEffectEvent: $c3bc21db9fc66909$var$throwInvalidHookError
}, $c3bc21db9fc66909$var$HooksDispatcherOnMount = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: function(callback, deps) {
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c3bc21db9fc66909$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c3bc21db9fc66909$var$dispatchReducerAction.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c3bc21db9fc66909$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        return $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c3bc21db9fc66909$var$mountStateImpl(!1);
        stateHook = $c3bc21db9fc66909$var$startTransition.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if ($c3bc21db9fc66909$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
            0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 127) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c3bc21db9fc66909$var$mountEffect($c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c3bc21db9fc66909$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook(), identifierPrefix = $c3bc21db9fc66909$var$workInProgressRoot.identifierPrefix;
        if ($c3bc21db9fc66909$var$isHydrating) {
            var JSCompiler_inline_result = $c3bc21db9fc66909$var$treeContextOverflow;
            var idWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c3bc21db9fc66909$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c3bc21db9fc66909$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $c3bc21db9fc66909$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$mountActionState,
    useActionState: $c3bc21db9fc66909$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: function() {
        return $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = $c3bc21db9fc66909$var$refreshCache.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $c3bc21db9fc66909$var$HooksDispatcherOnUpdate = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$updateReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$updateActionState,
    useActionState: $c3bc21db9fc66909$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh,
    useEffectEvent: $c3bc21db9fc66909$var$updateEvent
}, $c3bc21db9fc66909$var$HooksDispatcherOnRerender = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$rerenderReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return null === $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) : $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$rerenderActionState,
    useActionState: $c3bc21db9fc66909$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        if (null !== $c3bc21db9fc66909$var$currentHook) return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh,
    useEffectEvent: $c3bc21db9fc66909$var$updateEvent
};
function $c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c3bc21db9fc66909$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c3bc21db9fc66909$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(callback, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(callback, inst, lane));
    }
};
function $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c3bc21db9fc66909$var$shallowEqual(oldProps, newProps) || !$c3bc21db9fc66909$var$shallowEqual(oldState, newState) : !0;
}
function $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c3bc21db9fc66909$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c3bc21db9fc66909$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $c3bc21db9fc66909$var$defaultOnUncaughtError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c3bc21db9fc66909$var$defaultOnRecoverableError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $c3bc21db9fc66909$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $c3bc21db9fc66909$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c3bc21db9fc66909$var$createClassErrorUpdate(lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c3bc21db9fc66909$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed ? $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c3bc21db9fc66909$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c3bc21db9fc66909$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $c3bc21db9fc66909$var$shellBoundary ? $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes);
        $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c3bc21db9fc66909$var$isHydrating) return returnFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c3bc21db9fc66909$var$HydrationMismatchException && (root = Error($c3bc21db9fc66909$var$formatProdErrorMessage(422), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c3bc21db9fc66909$var$HydrationMismatchException && (returnFiber = Error($c3bc21db9fc66909$var$formatProdErrorMessage(423), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c3bc21db9fc66909$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c3bc21db9fc66909$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c3bc21db9fc66909$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c3bc21db9fc66909$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors ? $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c3bc21db9fc66909$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c3bc21db9fc66909$var$createClassErrorUpdate(rootRenderLanes), $c3bc21db9fc66909$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c3bc21db9fc66909$var$SelectiveHydrationException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(461)), $c3bc21db9fc66909$var$didReceiveUpdate = !1;
function $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    nextProps = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && key && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c3bc21db9fc66909$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c3bc21db9fc66909$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c3bc21db9fc66909$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c3bc21db9fc66909$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c3bc21db9fc66909$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState) : $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($c3bc21db9fc66909$var$pushTransition(workInProgress, prevState.cachePool), $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null), $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack());
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null);
    $c3bc21db9fc66909$var$reuseHiddenContextOnStack();
    $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $c3bc21db9fc66909$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($c3bc21db9fc66909$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, current);
            $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $c3bc21db9fc66909$var$nextHydratableInstance) ? (current = $c3bc21db9fc66909$var$canHydrateHydrationBoundary(current, $c3bc21db9fc66909$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c3bc21db9fc66909$var$treeContextProvider ? {
                    id: $c3bc21db9fc66909$var$treeContextId,
                    overflow: $c3bc21db9fc66909$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(558));
        } else if ($c3bc21db9fc66909$var$didReceiveUpdate || $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $c3bc21db9fc66909$var$didReceiveUpdate || didSuspend) {
            if (null === $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current) {
                nextProps = $c3bc21db9fc66909$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $c3bc21db9fc66909$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(current, dehydrated), $c3bc21db9fc66909$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $c3bc21db9fc66909$var$SelectiveHydrationException;
                $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(dehydrated.nextSibling), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$isHydrating = !0, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, null !== current && $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $c3bc21db9fc66909$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $c3bc21db9fc66909$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    Component = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && nextProps && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    Component = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && Component && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c3bc21db9fc66909$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c3bc21db9fc66909$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c3bc21db9fc66909$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c3bc21db9fc66909$var$readContext(contextType) : $c3bc21db9fc66909$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c3bc21db9fc66909$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c3bc21db9fc66909$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c3bc21db9fc66909$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c3bc21db9fc66909$var$hasForceUpdate || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c3bc21db9fc66909$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c3bc21db9fc66909$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c3bc21db9fc66909$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c3bc21db9fc66909$var$getSuspendedCache()
    };
}
function $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c3bc21db9fc66909$var$workInProgressDeferredLane);
    return current;
}
function $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c3bc21db9fc66909$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c3bc21db9fc66909$var$isHydrating) {
            showFallback ? $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack();
            (current = $c3bc21db9fc66909$var$nextHydratableInstance) ? (current = $c3bc21db9fc66909$var$canHydrateHydrationBoundary(current, $c3bc21db9fc66909$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c3bc21db9fc66909$var$treeContextProvider ? {
                    id: $c3bc21db9fc66909$var$treeContextId,
                    overflow: $c3bc21db9fc66909$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            $c3bc21db9fc66909$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $c3bc21db9fc66909$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps);
        $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $c3bc21db9fc66909$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $c3bc21db9fc66909$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $c3bc21db9fc66909$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $c3bc21db9fc66909$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $c3bc21db9fc66909$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $c3bc21db9fc66909$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, $c3bc21db9fc66909$var$bailoutOffscreenComponent(current.child, nextProps);
    $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c3bc21db9fc66909$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c3bc21db9fc66909$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $c3bc21db9fc66909$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER;
        return $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps);
    }
    $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($c3bc21db9fc66909$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $c3bc21db9fc66909$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $c3bc21db9fc66909$var$didReceiveUpdate || $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($c3bc21db9fc66909$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current) return $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $c3bc21db9fc66909$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $c3bc21db9fc66909$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(current, nextProps), $c3bc21db9fc66909$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $c3bc21db9fc66909$var$SelectiveHydrationException;
        $c3bc21db9fc66909$var$isSuspenseInstancePending(suspenseInstance) || $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
        return $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($c3bc21db9fc66909$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(suspenseInstance.nextSibling);
    $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress;
    $c3bc21db9fc66909$var$isHydrating = !0;
    $c3bc21db9fc66909$var$hydrationErrors = null;
    $c3bc21db9fc66909$var$rootOrSingletonContext = !1;
    null !== current && $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c3bc21db9fc66909$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $c3bc21db9fc66909$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $c3bc21db9fc66909$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $c3bc21db9fc66909$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $c3bc21db9fc66909$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $c3bc21db9fc66909$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($c3bc21db9fc66909$var$reverseChildren(current), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $c3bc21db9fc66909$var$reverseChildren(current)) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $c3bc21db9fc66909$var$isHydrating ? $c3bc21db9fc66909$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $c3bc21db9fc66909$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $c3bc21db9fc66909$var$reverseChildren(workInProgress));
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c3bc21db9fc66909$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $c3bc21db9fc66909$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
            $c3bc21db9fc66909$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $c3bc21db9fc66909$var$pushSuspenseListContext(workInProgress, $c3bc21db9fc66909$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
    }
    return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c3bc21db9fc66909$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c3bc21db9fc66909$var$didReceiveUpdate = !0;
        else {
            if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c3bc21db9fc66909$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c3bc21db9fc66909$var$pushTreeId(workInProgress, $c3bc21db9fc66909$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $c3bc21db9fc66909$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $c3bc21db9fc66909$var$shouldConstruct(current) ? (props = $c3bc21db9fc66909$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $c3bc21db9fc66909$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c3bc21db9fc66909$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c3bc21db9fc66909$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $c3bc21db9fc66909$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c3bc21db9fc66909$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $c3bc21db9fc66909$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c3bc21db9fc66909$var$getComponentNameFromType(current) || current;
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $c3bc21db9fc66909$var$resolveClassComponentProps(props, workInProgress.pendingProps), $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
                $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props);
                props !== prevState.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                    $c3bc21db9fc66909$var$CacheContext
                ], renderLanes, !0);
                $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $c3bc21db9fc66909$var$createCapturedValueAtFiber(Error($c3bc21db9fc66909$var$formatProdErrorMessage(424)), workInProgress);
                        $c3bc21db9fc66909$var$queueHydrationError($$typeof);
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(current.firstChild);
                        $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress;
                        $c3bc21db9fc66909$var$isHydrating = !0;
                        $c3bc21db9fc66909$var$hydrationErrors = null;
                        $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
                        renderLanes = $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c3bc21db9fc66909$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current ? (renderLanes = $c3bc21db9fc66909$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c3bc21db9fc66909$var$isHydrating || (workInProgress.stateNode = $c3bc21db9fc66909$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $c3bc21db9fc66909$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c3bc21db9fc66909$var$pushHostContext(workInProgress), null === current && $c3bc21db9fc66909$var$isHydrating && (props = workInProgress.stateNode = $c3bc21db9fc66909$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootInstanceStackCursor.current), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$rootOrSingletonContext = !0, $$typeof = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(workInProgress.type) ? ($c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(props.firstChild)) : $c3bc21db9fc66909$var$nextHydratableInstance = $$typeof), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if ($$typeof = props = $c3bc21db9fc66909$var$nextHydratableInstance) props = $c3bc21db9fc66909$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(props.firstChild), $c3bc21db9fc66909$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $c3bc21db9fc66909$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $c3bc21db9fc66909$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, $c3bc21db9fc66909$var$TransitionAwareHostComponent, null, null, renderLanes), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = $$typeof);
            $c3bc21db9fc66909$var$markRef(current, workInProgress);
            $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if (current = renderLanes = $c3bc21db9fc66909$var$nextHydratableInstance) renderLanes = $c3bc21db9fc66909$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $c3bc21db9fc66909$var$markRef(current, workInProgress), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $c3bc21db9fc66909$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), $$typeof = $c3bc21db9fc66909$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $c3bc21db9fc66909$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), props = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), null === current ? ($$typeof = $c3bc21db9fc66909$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $c3bc21db9fc66909$var$workInProgressRoot, prevState = $c3bc21db9fc66909$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props)) : (props = prevState.cache, $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props), props !== $$typeof.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                $c3bc21db9fc66909$var$CacheContext
            ], renderLanes, !0))), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $c3bc21db9fc66909$var$markRef(current, workInProgress), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $c3bc21db9fc66909$var$maySuspendCommit(type, newProps) : $c3bc21db9fc66909$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($c3bc21db9fc66909$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $c3bc21db9fc66909$var$suspendedThenable = $c3bc21db9fc66909$var$noopSuspenseyCommitThenable, $c3bc21db9fc66909$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c3bc21db9fc66909$var$preloadResource(resource)) {
        if ($c3bc21db9fc66909$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $c3bc21db9fc66909$var$suspendedThenable = $c3bc21db9fc66909$var$noopSuspenseyCommitThenable, $c3bc21db9fc66909$var$SuspenseyCommitException;
    }
}
function $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c3bc21db9fc66909$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c3bc21db9fc66909$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c3bc21db9fc66909$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $c3bc21db9fc66909$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c3bc21db9fc66909$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable());
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), null !== nextResource ? ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            renderLanes = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $c3bc21db9fc66909$var$contextStackCursor.current;
                $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c3bc21db9fc66909$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c3bc21db9fc66909$var$markUpdate(workInProgress));
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $c3bc21db9fc66909$var$contextStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer($c3bc21db9fc66909$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    nextResource[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($c3bc21db9fc66909$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
                }
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                current = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c3bc21db9fc66909$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $c3bc21db9fc66909$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(557));
                        current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    } else $c3bc21db9fc66909$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(558));
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c3bc21db9fc66909$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
                        type[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    } else $c3bc21db9fc66909$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null === current && $c3bc21db9fc66909$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 19:
            $c3bc21db9fc66909$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $c3bc21db9fc66909$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c3bc21db9fc66909$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c3bc21db9fc66909$var$pushSuspenseListContext(workInProgress, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1 | 2);
                            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $c3bc21db9fc66909$var$now() > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $c3bc21db9fc66909$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current), $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c3bc21db9fc66909$var$now() - newProps.renderingStartTime > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $c3bc21db9fc66909$var$now();
                current.sibling = null;
                nextResource = $c3bc21db9fc66909$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $c3bc21db9fc66909$var$isHydrating ? $c3bc21db9fc66909$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, workInProgress), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, renderLanes), null === $c3bc21db9fc66909$var$shellBoundary && ($c3bc21db9fc66909$var$shellBoundary = workInProgress));
                $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c3bc21db9fc66909$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$unwindWork(current, workInProgress) {
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(340));
                $c3bc21db9fc66909$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(340));
                $c3bc21db9fc66909$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c3bc21db9fc66909$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$unwindInterruptedWork(current, interruptedWork) {
    $c3bc21db9fc66909$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c3bc21db9fc66909$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c3bc21db9fc66909$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $c3bc21db9fc66909$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            $c3bc21db9fc66909$var$popHiddenContext();
            null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache);
            break;
        case 24:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c3bc21db9fc66909$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c3bc21db9fc66909$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $c3bc21db9fc66909$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $c3bc21db9fc66909$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $c3bc21db9fc66909$var$FragmentInstance(current);
                        $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $c3bc21db9fc66909$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $c3bc21db9fc66909$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$c3bc21db9fc66909$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $c3bc21db9fc66909$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $c3bc21db9fc66909$var$isFragmentInstanceParent(parent) && $c3bc21db9fc66909$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($c3bc21db9fc66909$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $c3bc21db9fc66909$var$isFragmentInstanceParent(parent) && $c3bc21db9fc66909$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($c3bc21db9fc66909$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $c3bc21db9fc66909$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $c3bc21db9fc66909$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $c3bc21db9fc66909$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c3bc21db9fc66909$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c3bc21db9fc66909$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c3bc21db9fc66909$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c3bc21db9fc66909$var$noop$1)), $c3bc21db9fc66909$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($c3bc21db9fc66909$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $c3bc21db9fc66909$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($c3bc21db9fc66909$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c3bc21db9fc66909$var$setInitialProperties(singleton, type, props);
        singleton[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
        singleton[$c3bc21db9fc66909$var$internalPropsKey] = props;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c3bc21db9fc66909$var$shouldStartViewTransition = !1, $c3bc21db9fc66909$var$appearingViewTransitions = null;
function $c3bc21db9fc66909$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $c3bc21db9fc66909$var$shouldStartViewTransition = !0;
}
var $c3bc21db9fc66909$var$viewTransitionCancelableChildren = null;
function $c3bc21db9fc66909$var$pushViewTransitionCancelableScope() {
    var prevChildren = $c3bc21db9fc66909$var$viewTransitionCancelableChildren;
    $c3bc21db9fc66909$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx = 0;
function $c3bc21db9fc66909$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx = 0;
    return $c3bc21db9fc66909$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $c3bc21db9fc66909$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $c3bc21db9fc66909$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $c3bc21db9fc66909$var$measureInstance(instance).view && (inViewport = !0);
            $c3bc21db9fc66909$var$shouldStartViewTransition = !0;
            $c3bc21db9fc66909$var$applyViewTransitionName(instance, 0 === $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx ? name : name + "_" + $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx, className);
            $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $c3bc21db9fc66909$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $c3bc21db9fc66909$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $c3bc21db9fc66909$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($c3bc21db9fc66909$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($c3bc21db9fc66909$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $c3bc21db9fc66909$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $c3bc21db9fc66909$var$getViewTransitionName(props, state), className = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $c3bc21db9fc66909$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($c3bc21db9fc66909$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $c3bc21db9fc66909$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $c3bc21db9fc66909$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$c3bc21db9fc66909$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $c3bc21db9fc66909$var$commitAppearingPairViewTransitions(placement);
}
function $c3bc21db9fc66909$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $c3bc21db9fc66909$var$appearingViewTransitions && 0 !== $c3bc21db9fc66909$var$appearingViewTransitions.size) {
        var pairs = $c3bc21db9fc66909$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($c3bc21db9fc66909$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $c3bc21db9fc66909$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $c3bc21db9fc66909$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $c3bc21db9fc66909$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $c3bc21db9fc66909$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $c3bc21db9fc66909$var$appearingViewTransitions ? $c3bc21db9fc66909$var$appearingViewTransitions.get(name) : void 0, className = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($c3bc21db9fc66909$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $c3bc21db9fc66909$var$appearingViewTransitions.delete(name), $c3bc21db9fc66909$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $c3bc21db9fc66909$var$scheduleViewTransitionEvent(deletion, props.onExit) : $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $c3bc21db9fc66909$var$appearingViewTransitions && $c3bc21db9fc66909$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$c3bc21db9fc66909$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $c3bc21db9fc66909$var$appearingViewTransitions && $c3bc21db9fc66909$var$commitDeletedPairViewTransitions(deletion);
}
function $c3bc21db9fc66909$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $c3bc21db9fc66909$var$getViewTransitionName(props, changedParent.stateNode);
            props = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $c3bc21db9fc66909$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $c3bc21db9fc66909$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $c3bc21db9fc66909$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $c3bc21db9fc66909$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $c3bc21db9fc66909$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $c3bc21db9fc66909$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$c3bc21db9fc66909$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $c3bc21db9fc66909$var$restorePairedViewTransitions(fiber);
}
function $c3bc21db9fc66909$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $c3bc21db9fc66909$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $c3bc21db9fc66909$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$c3bc21db9fc66909$var$viewTransitionHostInstanceIdx], nextMeasurement = $c3bc21db9fc66909$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $c3bc21db9fc66909$var$applyViewTransitionName(instance, 0 === $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $c3bc21db9fc66909$var$viewTransitionCancelableChildren && ($c3bc21db9fc66909$var$viewTransitionCancelableChildren = []), $c3bc21db9fc66909$var$viewTransitionCancelableChildren.push(instance, 0 === $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $c3bc21db9fc66909$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $c3bc21db9fc66909$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $c3bc21db9fc66909$var$getViewTransitionName(props, state), className = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($c3bc21db9fc66909$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx = 0;
            name = $c3bc21db9fc66909$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $c3bc21db9fc66909$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $c3bc21db9fc66909$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = !1, $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = !1, $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = !1, $c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c3bc21db9fc66909$var$nextEffect = null, $c3bc21db9fc66909$var$viewTransitionContextChanged = !1, $c3bc21db9fc66909$var$inUpdateViewTransition = !1, $c3bc21db9fc66909$var$rootViewTransitionAffected = !1, $c3bc21db9fc66909$var$rootViewTransitionNameCanceled = !1;
function $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $c3bc21db9fc66909$var$eventsEnabled = $c3bc21db9fc66909$var$_enabled;
    root = $c3bc21db9fc66909$var$getActiveElementDeep(root);
    if ($c3bc21db9fc66909$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c3bc21db9fc66909$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c3bc21db9fc66909$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $c3bc21db9fc66909$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $c3bc21db9fc66909$var$nextEffect;){
        root = $c3bc21db9fc66909$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $c3bc21db9fc66909$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $c3bc21db9fc66909$var$trackEnterViewTransitions(root), $c3bc21db9fc66909$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $c3bc21db9fc66909$var$commitExitViewTransitions(JSCompiler_temp);
                    $c3bc21db9fc66909$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $c3bc21db9fc66909$var$trackEnterViewTransitions(root);
                    $c3bc21db9fc66909$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $c3bc21db9fc66909$var$nextEffect = JSCompiler_temp) : (committedLanes && $c3bc21db9fc66909$var$commitNestedViewTransitions(root), $c3bc21db9fc66909$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $c3bc21db9fc66909$var$appearingViewTransitions = null;
}
function $c3bc21db9fc66909$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        var fiber = $c3bc21db9fc66909$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $c3bc21db9fc66909$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c3bc21db9fc66909$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $c3bc21db9fc66909$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $c3bc21db9fc66909$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $c3bc21db9fc66909$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $c3bc21db9fc66909$var$nextEffect = current;
            break;
        }
        $c3bc21db9fc66909$var$nextEffect = fiber.return;
    }
}
function $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c3bc21db9fc66909$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                current = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
                prevProps = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = flags;
                ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = current;
                $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c3bc21db9fc66909$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $c3bc21db9fc66909$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $c3bc21db9fc66909$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $c3bc21db9fc66909$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $c3bc21db9fc66909$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $c3bc21db9fc66909$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $c3bc21db9fc66909$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $c3bc21db9fc66909$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c3bc21db9fc66909$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c3bc21db9fc66909$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c3bc21db9fc66909$var$hostParent = null, $c3bc21db9fc66909$var$hostParentIsContainer = !1;
function $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount) try {
        $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount($c3bc21db9fc66909$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$c3bc21db9fc66909$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $c3bc21db9fc66909$var$hostParent, prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$isSingletonScope(deletedFiber.type) && ($c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode, $c3bc21db9fc66909$var$hostParentIsContainer = !1);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = null;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c3bc21db9fc66909$var$hostParent) {
                if ($c3bc21db9fc66909$var$hostParentIsContainer) try {
                    (9 === $c3bc21db9fc66909$var$hostParent.nodeType ? $c3bc21db9fc66909$var$hostParent.body : "HTML" === $c3bc21db9fc66909$var$hostParent.nodeName ? $c3bc21db9fc66909$var$hostParent.ownerDocument.body : $c3bc21db9fc66909$var$hostParent).removeChild(deletedFiber.stateNode), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c3bc21db9fc66909$var$hostParent.removeChild(deletedFiber.stateNode), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c3bc21db9fc66909$var$hostParent && ($c3bc21db9fc66909$var$hostParentIsContainer ? (finishedRoot = $c3bc21db9fc66909$var$hostParent, $c3bc21db9fc66909$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot)) : $c3bc21db9fc66909$var$clearHydrationBoundary($c3bc21db9fc66909$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c3bc21db9fc66909$var$hostParentIsContainer = !0;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c3bc21db9fc66909$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || ($c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = (prevHostParent = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c3bc21db9fc66909$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c3bc21db9fc66909$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c3bc21db9fc66909$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $c3bc21db9fc66909$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c3bc21db9fc66909$var$isSingletonScope(parent.type)) {
                        $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode.containerInfo;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c3bc21db9fc66909$var$hostParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
        $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c3bc21db9fc66909$var$hostParent = null;
        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $c3bc21db9fc66909$var$currentHoistableRoot = null;
function $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c3bc21db9fc66909$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c3bc21db9fc66909$var$commitHookEffectListMount(3, finishedWork), $c3bc21db9fc66909$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            flags & 64 && $c3bc21db9fc66909$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($c3bc21db9fc66909$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $c3bc21db9fc66909$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$c3bc21db9fc66909$var$internalHoistableMarker] || current[$c3bc21db9fc66909$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $c3bc21db9fc66909$var$setInitialProperties(current, root, lanes);
                                            current[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                            $c3bc21db9fc66909$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $c3bc21db9fc66909$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $c3bc21db9fc66909$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $c3bc21db9fc66909$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $c3bc21db9fc66909$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                    $c3bc21db9fc66909$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c3bc21db9fc66909$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $c3bc21db9fc66909$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $c3bc21db9fc66909$var$offscreenDirectParentIsHidden;
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = !1;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = ii;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $c3bc21db9fc66909$var$setTextContent(root, ""), $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($c3bc21db9fc66909$var$needsFormReset = !0);
            break;
        case 6:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c3bc21db9fc66909$var$viewTransitionMutationContext = !1;
            $c3bc21db9fc66909$var$tagCaches = null;
            ii = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(root.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$currentHoistableRoot = ii;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c3bc21db9fc66909$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c3bc21db9fc66909$var$needsFormReset && ($c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$recursivelyResetForms(finishedWork));
            $c3bc21db9fc66909$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $c3bc21db9fc66909$var$offscreenDirectParentIsHidden;
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
            current = $c3bc21db9fc66909$var$pushMutationContext();
            ii = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            $c3bc21db9fc66909$var$currentHoistableRoot = ii;
            $c3bc21db9fc66909$var$viewTransitionMutationContext && $c3bc21db9fc66909$var$inUpdateViewTransition && ($c3bc21db9fc66909$var$rootViewTransitionAffected = !0);
            $c3bc21db9fc66909$var$viewTransitionMutationContext = current;
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c3bc21db9fc66909$var$globalMostRecentFallbackTime = $c3bc21db9fc66909$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $c3bc21db9fc66909$var$offscreenDirectParentIsHidden;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c3bc21db9fc66909$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden, lanes = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden, current = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden, $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = ii || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden, $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = root, $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = lanes, $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = current), !ii && $c3bc21db9fc66909$var$offscreenDirectParentIsHidden || $c3bc21db9fc66909$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            flags = $c3bc21db9fc66909$var$pushMutationContext();
            ii = $c3bc21db9fc66909$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $c3bc21db9fc66909$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $c3bc21db9fc66909$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $c3bc21db9fc66909$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $c3bc21db9fc66909$var$inUpdateViewTransition = ii;
            $c3bc21db9fc66909$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c3bc21db9fc66909$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($c3bc21db9fc66909$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($c3bc21db9fc66909$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c3bc21db9fc66909$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c3bc21db9fc66909$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c3bc21db9fc66909$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $c3bc21db9fc66909$var$_enabled = !0, fiber.reset(), $c3bc21db9fc66909$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $c3bc21db9fc66909$var$measureNestedViewTransitions(parentFiber, !1);
}
function $c3bc21db9fc66909$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $c3bc21db9fc66909$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $c3bc21db9fc66909$var$rootViewTransitionNameCanceled = $c3bc21db9fc66909$var$viewTransitionContextChanged = !1;
            $c3bc21db9fc66909$var$pushViewTransitionCancelableScope();
            $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$c3bc21db9fc66909$var$viewTransitionContextChanged && !$c3bc21db9fc66909$var$rootViewTransitionAffected) {
                finishedWork = $c3bc21db9fc66909$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $c3bc21db9fc66909$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $c3bc21db9fc66909$var$rootViewTransitionNameCanceled = !0;
            }
            $c3bc21db9fc66909$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $c3bc21db9fc66909$var$viewTransitionContextChanged;
            $c3bc21db9fc66909$var$viewTransitionContextChanged = !1;
            $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$viewTransitionContextChanged && ($c3bc21db9fc66909$var$rootViewTransitionAffected = !0);
            $c3bc21db9fc66909$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $c3bc21db9fc66909$var$commitEnterViewTransitions(finishedWork, !1) : $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $c3bc21db9fc66909$var$viewTransitionContextChanged;
            oldName = $c3bc21db9fc66909$var$pushViewTransitionCancelableScope();
            $c3bc21db9fc66909$var$viewTransitionContextChanged = !1;
            $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $c3bc21db9fc66909$var$getViewTransitionName(props, state);
            state = $c3bc21db9fc66909$var$getViewTransitionName(current.memoizedProps, state);
            var className = $c3bc21db9fc66909$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx = 0, root = $c3bc21db9fc66909$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $c3bc21db9fc66909$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($c3bc21db9fc66909$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $c3bc21db9fc66909$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $c3bc21db9fc66909$var$viewTransitionCancelableChildren), $c3bc21db9fc66909$var$viewTransitionCancelableChildren = oldName);
            $c3bc21db9fc66909$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $c3bc21db9fc66909$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $c3bc21db9fc66909$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $c3bc21db9fc66909$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c3bc21db9fc66909$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $c3bc21db9fc66909$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $c3bc21db9fc66909$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$mountHoistable($c3bc21db9fc66909$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c3bc21db9fc66909$var$releaseCache(previousCache));
}
function $c3bc21db9fc66909$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c3bc21db9fc66909$var$releaseCache(current));
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $c3bc21db9fc66909$var$restoreNestedViewTransitions(parentFiber);
}
function $c3bc21db9fc66909$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $c3bc21db9fc66909$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $c3bc21db9fc66909$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $c3bc21db9fc66909$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $c3bc21db9fc66909$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $c3bc21db9fc66909$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(flags.child, !0), $c3bc21db9fc66909$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c3bc21db9fc66909$var$suspenseyCommitFlag = 8192;
function $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $c3bc21db9fc66909$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $c3bc21db9fc66909$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $c3bc21db9fc66909$var$suspendResource(suspendedState, $c3bc21db9fc66909$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $c3bc21db9fc66909$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $c3bc21db9fc66909$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $c3bc21db9fc66909$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $c3bc21db9fc66909$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c3bc21db9fc66909$var$suspenseyCommitFlag, $c3bc21db9fc66909$var$suspenseyCommitFlag = 16777216, $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $c3bc21db9fc66909$var$suspenseyCommitFlag = previousHoistableRoot) : $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $c3bc21db9fc66909$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $c3bc21db9fc66909$var$appearingViewTransitions && ($c3bc21db9fc66909$var$appearingViewTransitions = new Map());
                $c3bc21db9fc66909$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        var fiber = $c3bc21db9fc66909$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c3bc21db9fc66909$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c3bc21db9fc66909$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c3bc21db9fc66909$var$nextEffect;){
            cache = $c3bc21db9fc66909$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c3bc21db9fc66909$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c3bc21db9fc66909$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c3bc21db9fc66909$var$nextEffect = sibling;
                break a;
            }
            $c3bc21db9fc66909$var$nextEffect = returnFiber;
        }
    }
}
var $c3bc21db9fc66909$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext).controller.signal;
    }
}, $c3bc21db9fc66909$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c3bc21db9fc66909$var$executionContext = 0, $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgress = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !1, $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1, $c3bc21db9fc66909$var$entangledRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootPingedLanes = 0, $c3bc21db9fc66909$var$workInProgressDeferredLane = 0, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0, $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c3bc21db9fc66909$var$globalMostRecentFallbackTime = 0, $c3bc21db9fc66909$var$globalMostRecentTransitionTime = 0, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = Infinity, $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null, $c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$pendingFinishedWork = null, $c3bc21db9fc66909$var$pendingEffectsLanes = 0, $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0, $c3bc21db9fc66909$var$pendingPassiveTransitions = null, $c3bc21db9fc66909$var$pendingRecoverableErrors = null, $c3bc21db9fc66909$var$pendingViewTransition = null, $c3bc21db9fc66909$var$pendingViewTransitionEvents = null, $c3bc21db9fc66909$var$pendingTransitionTypes = null, $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null;
function $c3bc21db9fc66909$var$requestUpdateLane() {
    return 0 !== ($c3bc21db9fc66909$var$executionContext & 2) && 0 !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes ? $c3bc21db9fc66909$var$workInProgressRootRenderLanes & -$c3bc21db9fc66909$var$workInProgressRootRenderLanes : null !== $c3bc21db9fc66909$var$ReactSharedInternals.T ? $c3bc21db9fc66909$var$requestTransitionLane() : $c3bc21db9fc66909$var$resolveUpdatePriority();
}
function $c3bc21db9fc66909$var$requestDeferredLane() {
    if (0 === $c3bc21db9fc66909$var$workInProgressDeferredLane) {
        if (0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) || $c3bc21db9fc66909$var$isHydrating) {
            var lane = $c3bc21db9fc66909$var$nextTransitionDeferredLane;
            $c3bc21db9fc66909$var$nextTransitionDeferredLane <<= 1;
            0 === ($c3bc21db9fc66909$var$nextTransitionDeferredLane & 3932160) && ($c3bc21db9fc66909$var$nextTransitionDeferredLane = 262144);
            $c3bc21db9fc66909$var$workInProgressDeferredLane = lane;
        } else $c3bc21db9fc66909$var$workInProgressDeferredLane = 536870912;
    }
    lane = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $c3bc21db9fc66909$var$workInProgressDeferredLane;
}
function $c3bc21db9fc66909$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $c3bc21db9fc66909$var$createViewTransitionInstance($c3bc21db9fc66909$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $c3bc21db9fc66909$var$pendingViewTransitionEvents && ($c3bc21db9fc66909$var$pendingViewTransitionEvents = []);
        $c3bc21db9fc66909$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c3bc21db9fc66909$var$workInProgressRoot && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c3bc21db9fc66909$var$prepareFreshStack(root, 0), $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
    $c3bc21db9fc66909$var$markRootUpdated$1(root, lane);
    if (0 === ($c3bc21db9fc66909$var$executionContext & 2) || root !== $c3bc21db9fc66909$var$workInProgressRoot) root === $c3bc21db9fc66909$var$workInProgressRoot && (0 === ($c3bc21db9fc66909$var$executionContext & 2) && ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1)), $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c3bc21db9fc66909$var$renderRootConcurrent(root$jscomp$0, lanes) : $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c3bc21db9fc66909$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c3bc21db9fc66909$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c3bc21db9fc66909$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors;
                            $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c3bc21db9fc66909$var$prepareFreshStack(root$jscomp$0, 0);
                $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c3bc21db9fc66909$var$globalMostRecentFallbackTime + 300 - $c3bc21db9fc66909$var$now(), 10 < exitStatus)) {
                    $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c3bc21db9fc66909$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $c3bc21db9fc66909$var$scheduleTimeout($c3bc21db9fc66909$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $c3bc21db9fc66909$var$completeRootWhenReady(shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c3bc21db9fc66909$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $c3bc21db9fc66909$var$noop$1
        }, $c3bc21db9fc66909$var$appearingViewTransitions = null, $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $c3bc21db9fc66909$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $c3bc21db9fc66909$var$globalMostRecentFallbackTime - $c3bc21db9fc66909$var$now() : (lanes & 4194048) === lanes ? $c3bc21db9fc66909$var$globalMostRecentTransitionTime - $c3bc21db9fc66909$var$now() : 0, subtreeFlags = $c3bc21db9fc66909$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($c3bc21db9fc66909$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $c3bc21db9fc66909$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c3bc21db9fc66909$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c3bc21db9fc66909$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c3bc21db9fc66909$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $c3bc21db9fc66909$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c3bc21db9fc66909$var$flushSyncWork$1() {
    return 0 === ($c3bc21db9fc66909$var$executionContext & 6) ? ($c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c3bc21db9fc66909$var$resetWorkInProgressStack() {
    if (null !== $c3bc21db9fc66909$var$workInProgress) {
        if (0 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) var interruptedWork = $c3bc21db9fc66909$var$workInProgress.return;
        else interruptedWork = $c3bc21db9fc66909$var$workInProgress, $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$resetHooksOnUnwind(interruptedWork), $c3bc21db9fc66909$var$thenableState$1 = null, $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0, interruptedWork = $c3bc21db9fc66909$var$workInProgress;
        for(; null !== interruptedWork;)$c3bc21db9fc66909$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c3bc21db9fc66909$var$workInProgress = null;
    }
}
function $c3bc21db9fc66909$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c3bc21db9fc66909$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c3bc21db9fc66909$var$pendingEffectsLanes = 0;
    $c3bc21db9fc66909$var$resetWorkInProgressStack();
    $c3bc21db9fc66909$var$workInProgressRoot = root;
    $c3bc21db9fc66909$var$workInProgress = timeoutHandle = $c3bc21db9fc66909$var$createWorkInProgress(root.current, null);
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = lanes;
    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1;
    $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = $c3bc21db9fc66909$var$workInProgressDeferredLane = $c3bc21db9fc66909$var$workInProgressRootPingedLanes = $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0;
    $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null;
    $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $c3bc21db9fc66909$var$entangledRenderLanes = $c3bc21db9fc66909$var$getEntangledLanes(root, lanes);
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c3bc21db9fc66909$var$handleThrow(root, thrownValue) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    thrownValue === $c3bc21db9fc66909$var$SuspenseException || thrownValue === $c3bc21db9fc66909$var$SuspenseActionException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 3) : thrownValue === $c3bc21db9fc66909$var$SuspenseyCommitException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 4) : $c3bc21db9fc66909$var$workInProgressSuspendedReason = thrownValue === $c3bc21db9fc66909$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c3bc21db9fc66909$var$workInProgressThrownValue = thrownValue;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 1, $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c3bc21db9fc66909$var$shouldRemainOnPreviousScreen() {
    var handler = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes ? null === $c3bc21db9fc66909$var$shellBoundary ? !0 : !1 : ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes || 0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) ? handler === $c3bc21db9fc66909$var$shellBoundary : !1;
}
function $c3bc21db9fc66909$var$pushDispatcher() {
    var prevDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c3bc21db9fc66909$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c3bc21db9fc66909$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.A;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = $c3bc21db9fc66909$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() {
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 4;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings || ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes && null !== $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current || ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !0);
    0 === ($c3bc21db9fc66909$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c3bc21db9fc66909$var$workInProgressRoot || $c3bc21db9fc66909$var$markRootSuspended($c3bc21db9fc66909$var$workInProgressRoot, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
}
function $c3bc21db9fc66909$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    if ($c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes) $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            var unitOfWork = $c3bc21db9fc66909$var$workInProgress, thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason;
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c3bc21db9fc66909$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c3bc21db9fc66909$var$workLoopSync();
        exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c3bc21db9fc66909$var$workLoopSync() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress;)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    $c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes ? ($c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes)) : $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            lanes = $c3bc21db9fc66909$var$workInProgress;
            var thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            b: switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 1:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c3bc21db9fc66909$var$isThenableResolved(thrownValue)) {
                        $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                        $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                        $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && 9 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason || $c3bc21db9fc66909$var$workInProgressRoot !== root || ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 7);
                        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c3bc21db9fc66909$var$isThenableResolved(thrownValue) ? ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes)) : ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c3bc21db9fc66909$var$workInProgress.tag){
                        case 26:
                            resource = $c3bc21db9fc66909$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c3bc21db9fc66909$var$workInProgress;
                            if (resource ? $c3bc21db9fc66909$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                                $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c3bc21db9fc66909$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c3bc21db9fc66909$var$workInProgress = returnFiber, $c3bc21db9fc66909$var$completeUnitOfWork(returnFiber)) : $c3bc21db9fc66909$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(462));
            }
        }
        $c3bc21db9fc66909$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    if (null !== $c3bc21db9fc66909$var$workInProgress) return 0;
    $c3bc21db9fc66909$var$workInProgressRoot = null;
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0;
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return $c3bc21db9fc66909$var$workInProgressRootExitStatus;
}
function $c3bc21db9fc66909$var$workLoopConcurrentByScheduler() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress && !$c3bc21db9fc66909$var$shouldYield();)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$performUnitOfWork(unitOfWork) {
    var next = $c3bc21db9fc66909$var$beginWork(unitOfWork.alternate, unitOfWork, $c3bc21db9fc66909$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c3bc21db9fc66909$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $c3bc21db9fc66909$var$hydrationParentFiber && ($c3bc21db9fc66909$var$isHydrating ? ($c3bc21db9fc66909$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($c3bc21db9fc66909$var$nextHydratableInstance = fiber.stateNode)) : ($c3bc21db9fc66909$var$popToNextHostParent(fiber), $c3bc21db9fc66909$var$isHydrating = !0));
        default:
            $c3bc21db9fc66909$var$unwindInterruptedWork(current, next), next = $c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$resetWorkInProgress(next, $c3bc21db9fc66909$var$entangledRenderLanes), next = $c3bc21db9fc66909$var$beginWork(current, next, $c3bc21db9fc66909$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$resetHooksOnUnwind(unitOfWork);
    $c3bc21db9fc66909$var$thenableState$1 = null;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c3bc21db9fc66909$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c3bc21db9fc66909$var$workInProgressRootRenderLanes)) {
            $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
            $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c3bc21db9fc66909$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c3bc21db9fc66909$var$workInProgress = returnFiber, error;
        $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
        $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c3bc21db9fc66909$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c3bc21db9fc66909$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering || 0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, root);
    } else $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork);
}
function $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c3bc21db9fc66909$var$unwindUnitOfWork(completedWork, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c3bc21db9fc66909$var$completeWork(completedWork.alternate, completedWork, $c3bc21db9fc66909$var$entangledRenderLanes);
        if (null !== next) {
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c3bc21db9fc66909$var$workInProgress = completedWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 5);
}
function $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c3bc21db9fc66909$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c3bc21db9fc66909$var$workInProgress = unitOfWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
    $c3bc21db9fc66909$var$workInProgress = null;
}
function $c3bc21db9fc66909$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $c3bc21db9fc66909$var$flushPendingEffects();
    while (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus);
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(177));
        root === $c3bc21db9fc66909$var$workInProgressRoot && ($c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0);
        $c3bc21db9fc66909$var$pendingFinishedWork = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsRoot = root;
        $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = transitions;
        $c3bc21db9fc66909$var$pendingRecoverableErrors = recoverableErrors;
        $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $c3bc21db9fc66909$var$concurrentlyUpdatedLanes;
    $c3bc21db9fc66909$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $c3bc21db9fc66909$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($c3bc21db9fc66909$var$pendingTransitionTypes = $c3bc21db9fc66909$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($c3bc21db9fc66909$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $c3bc21db9fc66909$var$scheduleCallback$1($c3bc21db9fc66909$var$NormalPriority$1, function() {
        $c3bc21db9fc66909$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $c3bc21db9fc66909$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $c3bc21db9fc66909$var$ReactSharedInternals.T;
        $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
        updatedLanes = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $c3bc21db9fc66909$var$executionContext;
        $c3bc21db9fc66909$var$executionContext |= 4;
        try {
            $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $c3bc21db9fc66909$var$executionContext = suspendedRetryLanes, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = updatedLanes, $c3bc21db9fc66909$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $c3bc21db9fc66909$var$pendingEffectsStatus = 1;
    $c3bc21db9fc66909$var$shouldStartViewTransition ? $c3bc21db9fc66909$var$pendingViewTransition = $c3bc21db9fc66909$var$startViewTransition(suspendedState, root.containerInfo, $c3bc21db9fc66909$var$pendingTransitionTypes, $c3bc21db9fc66909$var$flushMutationEffects, $c3bc21db9fc66909$var$flushLayoutEffects, $c3bc21db9fc66909$var$flushAfterMutationEffects, $c3bc21db9fc66909$var$flushSpawnedWork, $c3bc21db9fc66909$var$flushPassiveEffects, $c3bc21db9fc66909$var$reportViewTransitionError, null, null) : ($c3bc21db9fc66909$var$flushMutationEffects(), $c3bc21db9fc66909$var$flushLayoutEffects(), $c3bc21db9fc66909$var$flushSpawnedWork());
}
function $c3bc21db9fc66909$var$reportViewTransitionError(error) {
    if (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus) {
        var onRecoverableError = $c3bc21db9fc66909$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $c3bc21db9fc66909$var$flushAfterMutationEffects() {
    3 === $c3bc21db9fc66909$var$pendingEffectsStatus && ($c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$commitAfterMutationEffectsOnFiber($c3bc21db9fc66909$var$pendingFinishedWork, $c3bc21db9fc66909$var$pendingEffectsRoot), $c3bc21db9fc66909$var$pendingEffectsStatus = 4);
}
function $c3bc21db9fc66909$var$flushMutationEffects() {
    if (1 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$inUpdateViewTransition = $c3bc21db9fc66909$var$rootViewTransitionAffected = !1;
                $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $c3bc21db9fc66909$var$selectionInformation;
                var curFocusedElem = $c3bc21db9fc66909$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c3bc21db9fc66909$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c3bc21db9fc66909$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c3bc21db9fc66909$var$_enabled = !!$c3bc21db9fc66909$var$eventsEnabled;
                $c3bc21db9fc66909$var$selectionInformation = $c3bc21db9fc66909$var$eventsEnabled = null;
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 2;
    }
}
function $c3bc21db9fc66909$var$flushLayoutEffects() {
    if (2 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c3bc21db9fc66909$var$pendingEffectsStatus = 3;
    }
}
function $c3bc21db9fc66909$var$flushSpawnedWork() {
    if (4 === $c3bc21db9fc66909$var$pendingEffectsStatus || 3 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var committedViewTransition = $c3bc21db9fc66909$var$pendingViewTransition;
        $c3bc21db9fc66909$var$pendingViewTransition = null;
        $c3bc21db9fc66909$var$requestPaint();
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes, recoverableErrors = $c3bc21db9fc66909$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $c3bc21db9fc66909$var$pendingEffectsStatus = 5 : ($c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c3bc21db9fc66909$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot($c3bc21db9fc66909$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            passiveSubtreeMask = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c3bc21db9fc66909$var$ReactSharedInternals.T = finishedWork, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $c3bc21db9fc66909$var$pendingViewTransitionEvents;
        onRecoverableError = $c3bc21db9fc66909$var$pendingTransitionTypes;
        $c3bc21db9fc66909$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($c3bc21db9fc66909$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($c3bc21db9fc66909$var$pendingEffectsLanes & 3) && $c3bc21db9fc66909$var$flushPendingEffects();
        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $c3bc21db9fc66909$var$rootWithNestedUpdates ? $c3bc21db9fc66909$var$nestedUpdateCount++ : ($c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = root) : ($c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null);
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c3bc21db9fc66909$var$releaseCache(remainingLanes)));
}
function $c3bc21db9fc66909$var$flushPendingEffects() {
    null !== $c3bc21db9fc66909$var$pendingViewTransition && ($c3bc21db9fc66909$var$pendingViewTransition.skipTransition(), $c3bc21db9fc66909$var$pendingViewTransition = null);
    $c3bc21db9fc66909$var$flushMutationEffects();
    $c3bc21db9fc66909$var$flushLayoutEffects();
    $c3bc21db9fc66909$var$flushSpawnedWork();
    return $c3bc21db9fc66909$var$flushPassiveEffects();
}
function $c3bc21db9fc66909$var$flushPassiveEffects() {
    if (5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return !1;
    var root = $c3bc21db9fc66909$var$pendingEffectsRoot, remainingLanes = $c3bc21db9fc66909$var$pendingEffectsRemainingLanes;
    $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c3bc21db9fc66909$var$lanesToEventPriority($c3bc21db9fc66909$var$pendingEffectsLanes), prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
        renderPriority = $c3bc21db9fc66909$var$pendingPassiveTransitions;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c3bc21db9fc66909$var$pendingEffectsRoot, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null;
        $c3bc21db9fc66909$var$pendingEffectsLanes = 0;
        if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
        $c3bc21db9fc66909$var$executionContext |= 4;
        $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c3bc21db9fc66909$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot($c3bc21db9fc66909$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition, $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c3bc21db9fc66909$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(rootFiber, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(rootFiber));
}
function $c3bc21db9fc66909$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c3bc21db9fc66909$var$createClassErrorUpdate(2);
                instance = $c3bc21db9fc66909$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c3bc21db9fc66909$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c3bc21db9fc66909$var$markRootUpdated$1(instance, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c3bc21db9fc66909$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c3bc21db9fc66909$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c3bc21db9fc66909$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c3bc21db9fc66909$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c3bc21db9fc66909$var$workInProgressRoot === root && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus || 3 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && 300 > $c3bc21db9fc66909$var$now() - $c3bc21db9fc66909$var$globalMostRecentFallbackTime ? 0 === ($c3bc21db9fc66909$var$executionContext & 2) ? $c3bc21db9fc66909$var$prepareFreshStack(root, 0) : $c3bc21db9fc66909$var$workInProgressRootPingedLanes |= pingedLanes : $c3bc21db9fc66909$var$workInProgressRootPingedLanes |= pingedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && ($c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0));
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c3bc21db9fc66909$var$claimNextRetryLane());
    boundaryFiber = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(boundaryFiber, retryLane), $c3bc21db9fc66909$var$ensureRootIsScheduled(boundaryFiber));
}
function $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$scheduleCallback$1(priorityLevel, callback) {
    return $c3bc21db9fc66909$var$scheduleCallback$3(priorityLevel, callback);
}
var $c3bc21db9fc66909$var$firstScheduledRoot = null, $c3bc21db9fc66909$var$lastScheduledRoot = null, $c3bc21db9fc66909$var$didScheduleMicrotask = !1, $c3bc21db9fc66909$var$mightHavePendingSyncWork = !1, $c3bc21db9fc66909$var$isFlushingWork = !1, $c3bc21db9fc66909$var$currentEventTransitionLane = 0;
function $c3bc21db9fc66909$var$ensureRootIsScheduled(root) {
    root !== $c3bc21db9fc66909$var$lastScheduledRoot && null === root.next && (null === $c3bc21db9fc66909$var$lastScheduledRoot ? $c3bc21db9fc66909$var$firstScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot = root : $c3bc21db9fc66909$var$lastScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot.next = root);
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
    $c3bc21db9fc66909$var$didScheduleMicrotask || ($c3bc21db9fc66909$var$didScheduleMicrotask = !0, $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask());
}
function $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c3bc21db9fc66909$var$isFlushingWork && $c3bc21db9fc66909$var$mightHavePendingSyncWork) {
        $c3bc21db9fc66909$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c3bc21db9fc66909$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c3bc21db9fc66909$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c3bc21db9fc66909$var$getNextLanes(root$190, root$190 === $c3bc21db9fc66909$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $c3bc21db9fc66909$var$isFlushingWork = !1;
    }
}
function $c3bc21db9fc66909$var$processRootScheduleInImmediateTask() {
    $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
}
function $c3bc21db9fc66909$var$processRootScheduleInMicrotask() {
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = $c3bc21db9fc66909$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c3bc21db9fc66909$var$currentEventTransitionLane && $c3bc21db9fc66909$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c3bc21db9fc66909$var$currentEventTransitionLane);
    for(var currentTime = $c3bc21db9fc66909$var$now(), prev = null, root = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c3bc21db9fc66909$var$firstScheduledRoot = next : prev.next = next, null === next && ($c3bc21db9fc66909$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $c3bc21db9fc66909$var$pendingEffectsStatus && 5 !== $c3bc21db9fc66909$var$pendingEffectsStatus || $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $c3bc21db9fc66909$var$currentEventTransitionLane && ($c3bc21db9fc66909$var$currentEventTransitionLane = 0);
}
function $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c3bc21db9fc66909$var$workInProgressRoot;
    suspendedLanes = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    suspendedLanes = $c3bc21db9fc66909$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
        switch($c3bc21db9fc66909$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c3bc21db9fc66909$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c3bc21db9fc66909$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
        }
        pingedLanes = $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c3bc21db9fc66909$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus && 5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c3bc21db9fc66909$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$getNextLanes(root, root === $c3bc21db9fc66909$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, $c3bc21db9fc66909$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c3bc21db9fc66909$var$performSyncWorkOnRoot(root, lanes) {
    if ($c3bc21db9fc66909$var$flushPendingEffects()) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, lanes, !0);
}
function $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask() {
    $c3bc21db9fc66909$var$scheduleMicrotask(function() {
        0 !== ($c3bc21db9fc66909$var$executionContext & 6) ? $c3bc21db9fc66909$var$scheduleCallback$3($c3bc21db9fc66909$var$ImmediatePriority, $c3bc21db9fc66909$var$processRootScheduleInImmediateTask) : $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
    });
}
function $c3bc21db9fc66909$var$requestTransitionLane() {
    if (0 === $c3bc21db9fc66909$var$currentEventTransitionLane) {
        var actionScopeLane = $c3bc21db9fc66909$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $c3bc21db9fc66909$var$nextTransitionUpdateLane, $c3bc21db9fc66909$var$nextTransitionUpdateLane <<= 1, 0 === ($c3bc21db9fc66909$var$nextTransitionUpdateLane & 261888) && ($c3bc21db9fc66909$var$nextTransitionUpdateLane = 256));
        $c3bc21db9fc66909$var$currentEventTransitionLane = actionScopeLane;
    }
    return $c3bc21db9fc66909$var$currentEventTransitionLane;
}
function $c3bc21db9fc66909$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c3bc21db9fc66909$var$sanitizeURL(actionProp);
}
function $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c3bc21db9fc66909$var$coerceFormActionProp((nativeEventTarget[$c3bc21db9fc66909$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c3bc21db9fc66909$var$internalPropsKey] || null) ? $c3bc21db9fc66909$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c3bc21db9fc66909$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c3bc21db9fc66909$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c3bc21db9fc66909$var$i$jscomp$inline_1667 = 0; $c3bc21db9fc66909$var$i$jscomp$inline_1667 < $c3bc21db9fc66909$var$simpleEventPluginEvents.length; $c3bc21db9fc66909$var$i$jscomp$inline_1667++){
    var $c3bc21db9fc66909$var$eventName$jscomp$inline_1668 = $c3bc21db9fc66909$var$simpleEventPluginEvents[$c3bc21db9fc66909$var$i$jscomp$inline_1667], $c3bc21db9fc66909$var$domEventName$jscomp$inline_1669 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1668.toLowerCase(), $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1670 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1668[0].toUpperCase() + $c3bc21db9fc66909$var$eventName$jscomp$inline_1668.slice(1);
    $c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$domEventName$jscomp$inline_1669, "on" + $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1670);
}
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_END, "onAnimationEnd");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_ITERATION, "onAnimationIteration");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_START, "onAnimationStart");
$c3bc21db9fc66909$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c3bc21db9fc66909$var$registerSimpleEvent("focusin", "onFocus");
$c3bc21db9fc66909$var$registerSimpleEvent("focusout", "onBlur");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_RUN, "onTransitionRun");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_START, "onTransitionStart");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_CANCEL, "onTransitionCancel");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_END, "onTransitionEnd");
$c3bc21db9fc66909$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c3bc21db9fc66909$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c3bc21db9fc66909$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c3bc21db9fc66909$var$mediaEventTypes));
function $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c3bc21db9fc66909$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c3bc21db9fc66909$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c3bc21db9fc66909$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c3bc21db9fc66909$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c3bc21db9fc66909$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c3bc21db9fc66909$var$listeningMarker]) {
        rootContainerElement[$c3bc21db9fc66909$var$listeningMarker] = !0;
        $c3bc21db9fc66909$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c3bc21db9fc66909$var$nonDelegatedEvents.has(domEventName) || $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c3bc21db9fc66909$var$listeningMarker] || (ownerDocument[$c3bc21db9fc66909$var$listeningMarker] = !0, $c3bc21db9fc66909$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c3bc21db9fc66909$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c3bc21db9fc66909$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c3bc21db9fc66909$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c3bc21db9fc66909$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c3bc21db9fc66909$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c3bc21db9fc66909$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c3bc21db9fc66909$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c3bc21db9fc66909$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c3bc21db9fc66909$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTouchEvent;
                        break;
                    case $c3bc21db9fc66909$var$ANIMATION_END:
                    case $c3bc21db9fc66909$var$ANIMATION_ITERATION:
                    case $c3bc21db9fc66909$var$ANIMATION_START:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticAnimationEvent;
                        break;
                    case $c3bc21db9fc66909$var$TRANSITION_END:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c3bc21db9fc66909$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c3bc21db9fc66909$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $c3bc21db9fc66909$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c3bc21db9fc66909$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c3bc21db9fc66909$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $c3bc21db9fc66909$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $c3bc21db9fc66909$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c3bc21db9fc66909$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $c3bc21db9fc66909$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $c3bc21db9fc66909$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c3bc21db9fc66909$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $c3bc21db9fc66909$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $c3bc21db9fc66909$var$getParent) : null;
                        null !== reactName && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent;
                else if ($c3bc21db9fc66909$var$isTextInputElement(reactName)) {
                    if ($c3bc21db9fc66909$var$isInputEventSupported) getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c3bc21db9fc66909$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c3bc21db9fc66909$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c3bc21db9fc66909$var$activeElement = handleEventFunc, $c3bc21db9fc66909$var$activeElementInst = targetInst, $c3bc21db9fc66909$var$lastSelection = null;
                    break;
                case "focusout":
                    $c3bc21db9fc66909$var$lastSelection = $c3bc21db9fc66909$var$activeElementInst = $c3bc21db9fc66909$var$activeElement = null;
                    break;
                case "mousedown":
                    $c3bc21db9fc66909$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c3bc21db9fc66909$var$mouseDown = !1;
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c3bc21db9fc66909$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c3bc21db9fc66909$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c3bc21db9fc66909$var$isComposing ? $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c3bc21db9fc66909$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c3bc21db9fc66909$var$isComposing && (fallbackData = $c3bc21db9fc66909$var$getData()) : ($c3bc21db9fc66909$var$root = nativeEventTarget, $c3bc21db9fc66909$var$startText = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, $c3bc21db9fc66909$var$isComposing = !0)), handleEventFunc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c3bc21db9fc66909$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c3bc21db9fc66909$var$canUseTextInputEvent ? $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c3bc21db9fc66909$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c3bc21db9fc66909$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c3bc21db9fc66909$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.push($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c3bc21db9fc66909$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c3bc21db9fc66909$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $c3bc21db9fc66909$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c3bc21db9fc66909$var$setProp(domElement, tag, "name", props.name, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c3bc21db9fc66909$var$setProp(domElement, tag, "encType", props.encType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "method", props.method, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            return;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c3bc21db9fc66909$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c3bc21db9fc66909$var$aliases.get(key) || key, $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
}
function $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $c3bc21db9fc66909$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$c3bc21db9fc66909$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$c3bc21db9fc66909$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $c3bc21db9fc66909$var$viewTransitionMutationContext = !0;
}
function $c3bc21db9fc66909$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c3bc21db9fc66909$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $c3bc21db9fc66909$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c3bc21db9fc66909$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c3bc21db9fc66909$var$mediaEventTypes.length; hasSrc++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $c3bc21db9fc66909$var$emptyProps = {};
function $c3bc21db9fc66909$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $c3bc21db9fc66909$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c3bc21db9fc66909$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $c3bc21db9fc66909$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, tag, !0) : $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c3bc21db9fc66909$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c3bc21db9fc66909$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($c3bc21db9fc66909$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $c3bc21db9fc66909$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $c3bc21db9fc66909$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $c3bc21db9fc66909$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $c3bc21db9fc66909$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $c3bc21db9fc66909$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $c3bc21db9fc66909$var$eventsEnabled = null, $c3bc21db9fc66909$var$selectionInformation = null;
function $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c3bc21db9fc66909$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c3bc21db9fc66909$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c3bc21db9fc66909$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$c3bc21db9fc66909$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$c3bc21db9fc66909$var$internalPropsKey] = props;
    $c3bc21db9fc66909$var$setInitialProperties(rootContainerInstance, type, props);
    $c3bc21db9fc66909$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $c3bc21db9fc66909$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
function $c3bc21db9fc66909$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c3bc21db9fc66909$var$currentPopstateTransitionEvent) return !1;
        $c3bc21db9fc66909$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c3bc21db9fc66909$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c3bc21db9fc66909$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c3bc21db9fc66909$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c3bc21db9fc66909$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $c3bc21db9fc66909$var$scheduleTimeout, $c3bc21db9fc66909$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c3bc21db9fc66909$var$localPromise ? function(callback) {
    return $c3bc21db9fc66909$var$localPromise.resolve(null).then(callback).catch($c3bc21db9fc66909$var$handleErrorInNextTick);
} : $c3bc21db9fc66909$var$scheduleTimeout;
function $c3bc21db9fc66909$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c3bc21db9fc66909$var$isSingletonScope(type) {
    return "head" === type;
}
function $c3bc21db9fc66909$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c3bc21db9fc66909$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $c3bc21db9fc66909$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $c3bc21db9fc66909$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$c3bc21db9fc66909$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $c3bc21db9fc66909$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $c3bc21db9fc66909$var$retryIfBlockedOn(hydrationInstance);
}
function $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $c3bc21db9fc66909$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $c3bc21db9fc66909$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $c3bc21db9fc66909$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $c3bc21db9fc66909$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $c3bc21db9fc66909$var$createMeasurement(rect, computedStyle, instance);
}
function $c3bc21db9fc66909$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $c3bc21db9fc66909$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $c3bc21db9fc66909$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $c3bc21db9fc66909$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $c3bc21db9fc66909$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($c3bc21db9fc66909$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $c3bc21db9fc66909$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $c3bc21db9fc66909$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($c3bc21db9fc66909$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $c3bc21db9fc66909$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$c3bc21db9fc66909$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $c3bc21db9fc66909$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$c3bc21db9fc66909$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$c3bc21db9fc66909$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $c3bc21db9fc66909$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $c3bc21db9fc66909$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $c3bc21db9fc66909$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $c3bc21db9fc66909$var$ViewTransitionPseudoElement("old", name),
        new: new $c3bc21db9fc66909$var$ViewTransitionPseudoElement("new", name)
    };
}
function $c3bc21db9fc66909$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $c3bc21db9fc66909$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $c3bc21db9fc66909$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $c3bc21db9fc66909$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $c3bc21db9fc66909$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $c3bc21db9fc66909$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $c3bc21db9fc66909$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $c3bc21db9fc66909$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $c3bc21db9fc66909$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $c3bc21db9fc66909$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $c3bc21db9fc66909$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $c3bc21db9fc66909$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $c3bc21db9fc66909$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $c3bc21db9fc66909$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $c3bc21db9fc66909$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $c3bc21db9fc66909$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $c3bc21db9fc66909$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$c3bc21db9fc66909$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $c3bc21db9fc66909$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $c3bc21db9fc66909$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $c3bc21db9fc66909$var$getInstanceFromHostFiber(fiber);
    return $c3bc21db9fc66909$var$setFocusIfFocusable(fiber, focusOptions);
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $c3bc21db9fc66909$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$c3bc21db9fc66909$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $c3bc21db9fc66909$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $c3bc21db9fc66909$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $c3bc21db9fc66909$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$observeChild, observer, void 0, void 0);
};
function $c3bc21db9fc66909$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $c3bc21db9fc66909$var$pendingIntersectionUnobserves.length; i++){
            var pending = $c3bc21db9fc66909$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $c3bc21db9fc66909$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $c3bc21db9fc66909$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $c3bc21db9fc66909$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $c3bc21db9fc66909$var$pendingIntersectionUnobserves = [], $c3bc21db9fc66909$var$intersectionUnobserveScheduled = !1;
function $c3bc21db9fc66909$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $c3bc21db9fc66909$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $c3bc21db9fc66909$var$intersectionUnobserveScheduled || ($c3bc21db9fc66909$var$intersectionUnobserveScheduled = !0, $c3bc21db9fc66909$var$requestPostPaintCallback(function() {
        $c3bc21db9fc66909$var$intersectionUnobserveScheduled = !1;
        var pending = $c3bc21db9fc66909$var$pendingIntersectionUnobserves;
        $c3bc21db9fc66909$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $c3bc21db9fc66909$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $c3bc21db9fc66909$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$c3bc21db9fc66909$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $c3bc21db9fc66909$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($c3bc21db9fc66909$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $c3bc21db9fc66909$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $c3bc21db9fc66909$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $c3bc21db9fc66909$var$getInstanceFromHostFiber(children[0]);
    result = $c3bc21db9fc66909$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $c3bc21db9fc66909$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $c3bc21db9fc66909$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $c3bc21db9fc66909$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $c3bc21db9fc66909$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $c3bc21db9fc66909$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $c3bc21db9fc66909$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $c3bc21db9fc66909$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $c3bc21db9fc66909$var$searchTarget, $c3bc21db9fc66909$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $c3bc21db9fc66909$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $c3bc21db9fc66909$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $c3bc21db9fc66909$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $c3bc21db9fc66909$var$searchTarget, $c3bc21db9fc66909$var$searchBoundary = $c3bc21db9fc66909$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $c3bc21db9fc66909$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$c3bc21db9fc66909$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(566));
    var children = [];
    $c3bc21db9fc66909$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $c3bc21db9fc66909$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $c3bc21db9fc66909$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $c3bc21db9fc66909$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $c3bc21db9fc66909$var$getInstanceFromHostFiber(hostSiblings);
            $c3bc21db9fc66909$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $c3bc21db9fc66909$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child), $c3bc21db9fc66909$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $c3bc21db9fc66909$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $c3bc21db9fc66909$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $c3bc21db9fc66909$var$getInstanceFromHostFiber(child);
    $c3bc21db9fc66909$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $c3bc21db9fc66909$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $c3bc21db9fc66909$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $c3bc21db9fc66909$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $c3bc21db9fc66909$var$pendingIntersectionUnobserves.length; i++){
            var pending = $c3bc21db9fc66909$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $c3bc21db9fc66909$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $c3bc21db9fc66909$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $c3bc21db9fc66909$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $c3bc21db9fc66909$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $c3bc21db9fc66909$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $c3bc21db9fc66909$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $c3bc21db9fc66909$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c3bc21db9fc66909$var$clearContainerSparingly(node);
                $c3bc21db9fc66909$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c3bc21db9fc66909$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c3bc21db9fc66909$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c3bc21db9fc66909$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c3bc21db9fc66909$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c3bc21db9fc66909$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $c3bc21db9fc66909$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c3bc21db9fc66909$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null;
function $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $c3bc21db9fc66909$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $c3bc21db9fc66909$var$requestPostPaintCallback(callback) {
    $c3bc21db9fc66909$var$localRequestAnimationFrame(function() {
        $c3bc21db9fc66909$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $c3bc21db9fc66909$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(451));
    }
}
function $c3bc21db9fc66909$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $c3bc21db9fc66909$var$setProp(instance, type, propKey, null, $c3bc21db9fc66909$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $c3bc21db9fc66909$var$noop$1 && (instance.onclick = null);
    $c3bc21db9fc66909$var$detachDeletedInstance(instance);
}
function $c3bc21db9fc66909$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c3bc21db9fc66909$var$detachDeletedInstance(instance);
}
var $c3bc21db9fc66909$var$preloadPropsMap = new Map(), $c3bc21db9fc66909$var$preconnectsSet = new Set();
function $c3bc21db9fc66909$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $c3bc21db9fc66909$var$previousDispatcher = $c3bc21db9fc66909$var$ReactDOMSharedInternals.d;
$c3bc21db9fc66909$var$ReactDOMSharedInternals.d = {
    f: $c3bc21db9fc66909$var$flushSyncWork,
    r: $c3bc21db9fc66909$var$requestFormReset,
    D: $c3bc21db9fc66909$var$prefetchDNS,
    C: $c3bc21db9fc66909$var$preconnect,
    L: $c3bc21db9fc66909$var$preload,
    m: $c3bc21db9fc66909$var$preloadModule,
    X: $c3bc21db9fc66909$var$preinitScript,
    S: $c3bc21db9fc66909$var$preinitStyle,
    M: $c3bc21db9fc66909$var$preinitModuleScript
};
function $c3bc21db9fc66909$var$flushSyncWork() {
    var previousWasRendering = $c3bc21db9fc66909$var$previousDispatcher.f(), wasRendering = $c3bc21db9fc66909$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c3bc21db9fc66909$var$requestFormReset(form) {
    var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c3bc21db9fc66909$var$requestFormReset$1(formInst) : $c3bc21db9fc66909$var$previousDispatcher.r(form);
}
var $c3bc21db9fc66909$var$globalDocument = "undefined" === typeof document ? null : document;
function $c3bc21db9fc66909$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c3bc21db9fc66909$var$preconnectsSet.has(limitedEscapedHref) || ($c3bc21db9fc66909$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c3bc21db9fc66909$var$setInitialProperties(href, "link", rel), $c3bc21db9fc66909$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c3bc21db9fc66909$var$prefetchDNS(href) {
    $c3bc21db9fc66909$var$previousDispatcher.D(href);
    $c3bc21db9fc66909$var$preconnectAs("dns-prefetch", href, null);
}
function $c3bc21db9fc66909$var$preconnect(href, crossOrigin) {
    $c3bc21db9fc66909$var$previousDispatcher.C(href, crossOrigin);
    $c3bc21db9fc66909$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c3bc21db9fc66909$var$preload(href, as, options) {
    $c3bc21db9fc66909$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c3bc21db9fc66909$var$getStyleKey(href);
                break;
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        if (!($c3bc21db9fc66909$var$preloadPropsMap.has(key) || (href = $c3bc21db9fc66909$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $c3bc21db9fc66909$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$c3bc21db9fc66909$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $c3bc21db9fc66909$var$clearPendingLoadOnNode(instance);
            });
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $c3bc21db9fc66909$var$preloadModule(href, options) {
    $c3bc21db9fc66909$var$previousDispatcher.m(href, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        if (!$c3bc21db9fc66909$var$preloadPropsMap.has(key) && (href = $c3bc21db9fc66909$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c3bc21db9fc66909$var$setInitialProperties(as, "link", href);
            $c3bc21db9fc66909$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c3bc21db9fc66909$var$preinitStyle(href, precedence, options) {
    $c3bc21db9fc66909$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c3bc21db9fc66909$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c3bc21db9fc66909$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c3bc21db9fc66909$var$markNodeAsHoistable(link);
                $c3bc21db9fc66909$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c3bc21db9fc66909$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c3bc21db9fc66909$var$preinitScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.X(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$preinitModuleScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.M(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c3bc21db9fc66909$var$rootInstanceStackCursor.current) ? $c3bc21db9fc66909$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href), currentProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href);
                var styles$268 = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $c3bc21db9fc66909$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c3bc21db9fc66909$var$preloadPropsMap.set(type, styles$268)), $c3bc21db9fc66909$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $c3bc21db9fc66909$var$getScriptKey(pendingProps), currentProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(444, type));
    }
}
function $c3bc21db9fc66909$var$getStyleKey(href) {
    return 'href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(rawProps) {
    return $c3bc21db9fc66909$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c3bc21db9fc66909$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$c3bc21db9fc66909$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$c3bc21db9fc66909$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $c3bc21db9fc66909$var$clearPendingLoadOnNode.bind(null, key), $c3bc21db9fc66909$var$setInitialProperties(key, "link", preloadProps), $c3bc21db9fc66909$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $c3bc21db9fc66909$var$getScriptKey(src) {
    return '[src="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c3bc21db9fc66909$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c3bc21db9fc66909$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c3bc21db9fc66909$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c3bc21db9fc66909$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            $c3bc21db9fc66909$var$setInitialProperties(instance, "style", styleProps);
            $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c3bc21db9fc66909$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $c3bc21db9fc66909$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(styleProps)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $c3bc21db9fc66909$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $c3bc21db9fc66909$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(instance$274)) instance = $c3bc21db9fc66909$var$assign({}, props), $c3bc21db9fc66909$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps);
            $c3bc21db9fc66909$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c3bc21db9fc66909$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c3bc21db9fc66909$var$tagCaches = null;
function $c3bc21db9fc66909$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c3bc21db9fc66909$var$tagCaches) {
        var cache = new Map();
        var caches = $c3bc21db9fc66909$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c3bc21db9fc66909$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c3bc21db9fc66909$var$internalHoistableMarker] || node[$c3bc21db9fc66909$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c3bc21db9fc66909$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $c3bc21db9fc66909$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $c3bc21db9fc66909$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $c3bc21db9fc66909$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $c3bc21db9fc66909$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $c3bc21db9fc66909$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $c3bc21db9fc66909$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c3bc21db9fc66909$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (key = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $c3bc21db9fc66909$var$estimatedBytesWithinLimit = 0;
function $c3bc21db9fc66909$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $c3bc21db9fc66909$var$estimatedBytesWithinLimit && ($c3bc21db9fc66909$var$estimatedBytesWithinLimit = 62500 * $c3bc21db9fc66909$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $c3bc21db9fc66909$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $c3bc21db9fc66909$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $c3bc21db9fc66909$var$onUnsuspend() {
    this.count--;
    $c3bc21db9fc66909$var$checkIfFullyUnsuspended(this);
}
function $c3bc21db9fc66909$var$onUnsuspendImg() {
    this.imgCount--;
    $c3bc21db9fc66909$var$checkIfFullyUnsuspended(this);
}
var $c3bc21db9fc66909$var$precedencesByRoot = null;
function $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c3bc21db9fc66909$var$precedencesByRoot = new Map(), resources.forEach($c3bc21db9fc66909$var$insertStylesheetIntoRoot, state), $c3bc21db9fc66909$var$precedencesByRoot = null, $c3bc21db9fc66909$var$onUnsuspend.call(state));
}
function $c3bc21db9fc66909$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c3bc21db9fc66909$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c3bc21db9fc66909$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c3bc21db9fc66909$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c3bc21db9fc66909$var$HostTransitionContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _currentValue2: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c3bc21db9fc66909$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c3bc21db9fc66909$var$createLaneMap(0);
    this.hiddenUpdates = $c3bc21db9fc66909$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $c3bc21db9fc66909$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c3bc21db9fc66909$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c3bc21db9fc66909$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c3bc21db9fc66909$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c3bc21db9fc66909$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c3bc21db9fc66909$var$emptyContextObject;
    parentComponent = $c3bc21db9fc66909$var$emptyContextObject;
    return parentComponent;
}
function $c3bc21db9fc66909$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c3bc21db9fc66909$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c3bc21db9fc66909$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c3bc21db9fc66909$var$entangleTransitions(element, rootFiber, lane));
}
function $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
}
function $c3bc21db9fc66909$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $c3bc21db9fc66909$var$requestUpdateLane();
        lane = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane);
        var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, lane);
        $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $c3bc21db9fc66909$var$_enabled = !0;
function $c3bc21db9fc66909$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 8, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c3bc21db9fc66909$var$_enabled) {
        var blockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer), $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c3bc21db9fc66909$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c3bc21db9fc66909$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c3bc21db9fc66909$var$ensureRootIsScheduled(fiber);
                                0 === ($c3bc21db9fc66909$var$executionContext & 6) && ($c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2), $c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c3bc21db9fc66909$var$getEventTarget(nativeEvent);
    return $c3bc21db9fc66909$var$findInstanceBlockingTarget(nativeEvent);
}
var $c3bc21db9fc66909$var$return_targetInst = null;
function $c3bc21db9fc66909$var$findInstanceBlockingTarget(targetNode) {
    $c3bc21db9fc66909$var$return_targetInst = null;
    targetNode = $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $c3bc21db9fc66909$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c3bc21db9fc66909$var$return_targetInst = targetNode;
    return null;
}
function $c3bc21db9fc66909$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c3bc21db9fc66909$var$getCurrentPriorityLevel()){
                case $c3bc21db9fc66909$var$ImmediatePriority:
                    return 2;
                case $c3bc21db9fc66909$var$UserBlockingPriority:
                    return 8;
                case $c3bc21db9fc66909$var$NormalPriority$1:
                case $c3bc21db9fc66909$var$LowPriority:
                    return 32;
                case $c3bc21db9fc66909$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1, $c3bc21db9fc66909$var$queuedFocus = null, $c3bc21db9fc66909$var$queuedDrag = null, $c3bc21db9fc66909$var$queuedMouse = null, $c3bc21db9fc66909$var$queuedPointers = new Map(), $c3bc21db9fc66909$var$queuedPointerCaptures = new Map(), $c3bc21db9fc66909$var$queuedExplicitHydrationTargets = [], $c3bc21db9fc66909$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c3bc21db9fc66909$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c3bc21db9fc66909$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c3bc21db9fc66909$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c3bc21db9fc66909$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c3bc21db9fc66909$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c3bc21db9fc66909$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c3bc21db9fc66909$var$queuedFocus = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c3bc21db9fc66909$var$queuedDrag = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c3bc21db9fc66909$var$queuedMouse = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c3bc21db9fc66909$var$queuedPointers.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c3bc21db9fc66909$var$queuedPointerCaptures.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c3bc21db9fc66909$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c3bc21db9fc66909$var$runWithPriority(queuedTarget.priority, function() {
                        $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $c3bc21db9fc66909$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c3bc21db9fc66909$var$runWithPriority(queuedTarget.priority, function() {
                        $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c3bc21db9fc66909$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c3bc21db9fc66909$var$currentReplayingEvent = null;
        } else return targetContainers = $c3bc21db9fc66909$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c3bc21db9fc66909$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c3bc21db9fc66909$var$replayUnblockedEvents() {
    $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1;
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedFocus) && ($c3bc21db9fc66909$var$queuedFocus = null);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedDrag) && ($c3bc21db9fc66909$var$queuedDrag = null);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedMouse) && ($c3bc21db9fc66909$var$queuedMouse = null);
    $c3bc21db9fc66909$var$queuedPointers.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
}
function $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c3bc21db9fc66909$var$hasScheduledReplayAttempt || ($c3bc21db9fc66909$var$hasScheduledReplayAttempt = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$replayUnblockedEvents)));
}
var $c3bc21db9fc66909$var$lastScheduledReplayQueue = null;
function $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c3bc21db9fc66909$var$lastScheduledReplayQueue !== formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = formReplayingQueue, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, function() {
        $c3bc21db9fc66909$var$lastScheduledReplayQueue === formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c3bc21db9fc66909$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c3bc21db9fc66909$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c3bc21db9fc66909$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedFocus, unblocked);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedDrag, unblocked);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedMouse, unblocked);
    $c3bc21db9fc66909$var$queuedPointers.forEach(unblock);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && (i = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c3bc21db9fc66909$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c3bc21db9fc66909$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c3bc21db9fc66909$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c3bc21db9fc66909$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $c3bc21db9fc66909$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.render = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unmount = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c3bc21db9fc66909$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c3bc21db9fc66909$var$flushSyncWork$1();
        container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = null;
    }
};
function $c3bc21db9fc66909$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c3bc21db9fc66909$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(target);
    }
};
var $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $8NFma.version;
if ("19.3.0" !== $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(527, $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$c3bc21db9fc66909$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c3bc21db9fc66909$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c3bc21db9fc66909$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c3bc21db9fc66909$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c3bc21db9fc66909$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c3bc21db9fc66909$var$hook$jscomp$inline_2587.isDisabled && $c3bc21db9fc66909$var$hook$jscomp$inline_2587.supportsFiber) try {
        $c3bc21db9fc66909$var$rendererID = $c3bc21db9fc66909$var$hook$jscomp$inline_2587.inject($c3bc21db9fc66909$var$internals$jscomp$inline_2586), $c3bc21db9fc66909$var$injectedHook = $c3bc21db9fc66909$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$c3bc21db9fc66909$export$882461b6382ed46c = function(container, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = options.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMRoot(options);
};
$c3bc21db9fc66909$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $c3bc21db9fc66909$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c3bc21db9fc66909$var$requestUpdateLane();
    isStrictMode = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c3bc21db9fc66909$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c3bc21db9fc66909$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c3bc21db9fc66909$var$markRootUpdated$1(initialChildren, options);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(initialChildren);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = initialChildren.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMHydrationRoot(initialChildren);
};
$c3bc21db9fc66909$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("epnUP"));

});
parcelRegister("epnUP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a7d5f39a74a2399f$export$c4744153514ff05d, (v) => $a7d5f39a74a2399f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7, (v) => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a7d5f39a74a2399f$export$e26fe2ed2fa76875, (v) => $a7d5f39a74a2399f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a7d5f39a74a2399f$export$502329bbf4b505b1, (v) => $a7d5f39a74a2399f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a7d5f39a74a2399f$export$6e3807111c4874c4, (v) => $a7d5f39a74a2399f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a7d5f39a74a2399f$export$c27134553091fb3a, (v) => $a7d5f39a74a2399f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2, (v) => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a7d5f39a74a2399f$export$b00a404bbd5edef2, (v) => $a7d5f39a74a2399f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a7d5f39a74a2399f$export$d66a1c1c77bd778b, (v) => $a7d5f39a74a2399f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a7d5f39a74a2399f$export$d3dfb8e4810cb555, (v) => $a7d5f39a74a2399f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $a7d5f39a74a2399f$export$72fdf0e06517287b, (v) => $a7d5f39a74a2399f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a7d5f39a74a2399f$export$816d2913ae6b83b1, (v) => $a7d5f39a74a2399f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a7d5f39a74a2399f$export$61bcfe829111a1d0, (v) => $a7d5f39a74a2399f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f, (v) => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a7d5f39a74a2399f$export$b5836b71941fa3ed, (v) => $a7d5f39a74a2399f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a7d5f39a74a2399f$export$cf845f2c119da08a, (v) => $a7d5f39a74a2399f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a7d5f39a74a2399f$export$c4744153514ff05d;
var $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7;
var $a7d5f39a74a2399f$export$e26fe2ed2fa76875;
var $a7d5f39a74a2399f$export$502329bbf4b505b1;
var $a7d5f39a74a2399f$export$6e3807111c4874c4;
var $a7d5f39a74a2399f$export$c27134553091fb3a;
var $a7d5f39a74a2399f$export$33ee1acdc04fd2a2;
var $a7d5f39a74a2399f$export$b00a404bbd5edef2;
var $a7d5f39a74a2399f$export$d66a1c1c77bd778b;
var $a7d5f39a74a2399f$export$d3dfb8e4810cb555;
var $a7d5f39a74a2399f$export$72fdf0e06517287b;
var $a7d5f39a74a2399f$export$816d2913ae6b83b1;
var $a7d5f39a74a2399f$export$61bcfe829111a1d0;
var $a7d5f39a74a2399f$export$7ee8c9beb337bc3f;
var $a7d5f39a74a2399f$export$b5836b71941fa3ed;
var $a7d5f39a74a2399f$export$cf845f2c119da08a;
"use strict";
function $a7d5f39a74a2399f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $a7d5f39a74a2399f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $a7d5f39a74a2399f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $a7d5f39a74a2399f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $a7d5f39a74a2399f$var$compare(left, last)) rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $a7d5f39a74a2399f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$a7d5f39a74a2399f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a7d5f39a74a2399f$var$localPerformance = performance;
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localPerformance.now();
    };
} else {
    var $a7d5f39a74a2399f$var$localDate = Date, $a7d5f39a74a2399f$var$initialTime = $a7d5f39a74a2399f$var$localDate.now();
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localDate.now() - $a7d5f39a74a2399f$var$initialTime;
    };
}
var $a7d5f39a74a2399f$var$taskQueue = [], $a7d5f39a74a2399f$var$timerQueue = [], $a7d5f39a74a2399f$var$taskIdCounter = 1, $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = 3, $a7d5f39a74a2399f$var$isPerformingWork = !1, $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1, $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$needsPaint = !1, $a7d5f39a74a2399f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $a7d5f39a74a2399f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $a7d5f39a74a2399f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $a7d5f39a74a2399f$var$advanceTimers(currentTime) {
    for(var timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue);
        else if (timer.startTime <= currentTime) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue), timer.sortIndex = timer.expirationTime, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, timer);
        else break;
        timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
    }
}
function $a7d5f39a74a2399f$var$handleTimeout(currentTime) {
    $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1;
    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
    if (!$a7d5f39a74a2399f$var$isHostCallbackScheduled) {
        if (null !== $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue)) $a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $a7d5f39a74a2399f$var$isMessageLoopRunning = !1, $a7d5f39a74a2399f$var$taskTimeoutID = -1, $a7d5f39a74a2399f$var$frameInterval = 5, $a7d5f39a74a2399f$var$startTime = -1;
function $a7d5f39a74a2399f$var$shouldYieldToHost() {
    return $a7d5f39a74a2399f$var$needsPaint ? !0 : $a7d5f39a74a2399f$export$c4744153514ff05d() - $a7d5f39a74a2399f$var$startTime < $a7d5f39a74a2399f$var$frameInterval ? !1 : !0;
}
function $a7d5f39a74a2399f$var$performWorkUntilDeadline() {
    $a7d5f39a74a2399f$var$needsPaint = !1;
    if ($a7d5f39a74a2399f$var$isMessageLoopRunning) {
        var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
        $a7d5f39a74a2399f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1;
                $a7d5f39a74a2399f$var$isHostTimeoutScheduled && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1);
                $a7d5f39a74a2399f$var$isPerformingWork = !0;
                var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
                try {
                    b: {
                        $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                        for($a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue); null !== $a7d5f39a74a2399f$var$currentTask && !($a7d5f39a74a2399f$var$currentTask.expirationTime > currentTime && $a7d5f39a74a2399f$var$shouldYieldToHost());){
                            var callback = $a7d5f39a74a2399f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $a7d5f39a74a2399f$var$currentTask.callback = null;
                                $a7d5f39a74a2399f$var$currentPriorityLevel = $a7d5f39a74a2399f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($a7d5f39a74a2399f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $a7d5f39a74a2399f$var$currentTask.callback = continuationCallback;
                                    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $a7d5f39a74a2399f$var$currentTask === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                                $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                            } else $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                            $a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue);
                        }
                        if (null !== $a7d5f39a74a2399f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
                            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel, $a7d5f39a74a2399f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline() : $a7d5f39a74a2399f$var$isMessageLoopRunning = !1;
        }
    }
}
var $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $a7d5f39a74a2399f$var$localSetImmediate) $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetImmediate($a7d5f39a74a2399f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a7d5f39a74a2399f$var$channel = new MessageChannel(), $a7d5f39a74a2399f$var$port = $a7d5f39a74a2399f$var$channel.port2;
    $a7d5f39a74a2399f$var$channel.port1.onmessage = $a7d5f39a74a2399f$var$performWorkUntilDeadline;
    $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
        $a7d5f39a74a2399f$var$port.postMessage(null);
    };
} else $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetTimeout($a7d5f39a74a2399f$var$performWorkUntilDeadline, 0);
};
function $a7d5f39a74a2399f$var$requestHostTimeout(callback, ms) {
    $a7d5f39a74a2399f$var$taskTimeoutID = $a7d5f39a74a2399f$var$localSetTimeout(function() {
        callback($a7d5f39a74a2399f$export$c4744153514ff05d());
    }, ms);
}
$a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = 5;
$a7d5f39a74a2399f$export$e26fe2ed2fa76875 = 1;
$a7d5f39a74a2399f$export$502329bbf4b505b1 = 4;
$a7d5f39a74a2399f$export$6e3807111c4874c4 = 3;
$a7d5f39a74a2399f$export$c27134553091fb3a = null;
$a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = 2;
$a7d5f39a74a2399f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$a7d5f39a74a2399f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a7d5f39a74a2399f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$a7d5f39a74a2399f$export$d3dfb8e4810cb555 = function() {
    return $a7d5f39a74a2399f$var$currentPriorityLevel;
};
$a7d5f39a74a2399f$export$72fdf0e06517287b = function(eventHandler) {
    switch($a7d5f39a74a2399f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$816d2913ae6b83b1 = function() {
    $a7d5f39a74a2399f$var$needsPaint = !0;
};
$a7d5f39a74a2399f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $a7d5f39a74a2399f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$timerQueue, priorityLevel), null === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && priorityLevel === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue) && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled ? ($a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1) : $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !0, $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, priorityLevel), $a7d5f39a74a2399f$var$isHostCallbackScheduled || $a7d5f39a74a2399f$var$isPerformingWork || ($a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$a7d5f39a74a2399f$export$b5836b71941fa3ed = $a7d5f39a74a2399f$var$shouldYieldToHost;
$a7d5f39a74a2399f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
        $a7d5f39a74a2399f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jMs9J"));

});
parcelRegister("jMs9J", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $e668572f1c95467d$export$9c16c1426311996d, (v) => $e668572f1c95467d$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $e668572f1c95467d$export$dca3b0875bd9a954, (v) => $e668572f1c95467d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e668572f1c95467d$export$16fa2f45be04daa8, (v) => $e668572f1c95467d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e668572f1c95467d$export$ffb0004e005737fa, (v) => $e668572f1c95467d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e668572f1c95467d$export$e2c29f18771995cb, (v) => $e668572f1c95467d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e668572f1c95467d$export$221d75b3f55bb0bd, (v) => $e668572f1c95467d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e668572f1c95467d$export$5f8d39834fd61797, (v) => $e668572f1c95467d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e668572f1c95467d$export$74bf444e3cd11ea5, (v) => $e668572f1c95467d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $e668572f1c95467d$export$8cdaa4703948c5e9, (v) => $e668572f1c95467d$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e668572f1c95467d$export$1ced07cd6b1985ce, (v) => $e668572f1c95467d$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $e668572f1c95467d$export$abd8e32b826d7ea7, (v) => $e668572f1c95467d$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $e668572f1c95467d$export$87c99536b1b8cdd8, (v) => $e668572f1c95467d$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $e668572f1c95467d$export$69a3209f1a06c04d, (v) => $e668572f1c95467d$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $e668572f1c95467d$export$8c538325882c7eec, (v) => $e668572f1c95467d$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $e668572f1c95467d$export$e530037191fcd5d7, (v) => $e668572f1c95467d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e668572f1c95467d$export$fd42f52fd3ae1109, (v) => $e668572f1c95467d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e668572f1c95467d$export$c8a8987d4410bf2d, (v) => $e668572f1c95467d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $e668572f1c95467d$export$7d1e3a5e95ceca43, (v) => $e668572f1c95467d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e668572f1c95467d$export$257a8862b851cb5b, (v) => $e668572f1c95467d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e668572f1c95467d$export$a8257692ac88316c, (v) => $e668572f1c95467d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e668572f1c95467d$export$488013bae63b21da, (v) => $e668572f1c95467d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e668572f1c95467d$export$7c73462e0d25e514, (v) => $e668572f1c95467d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e668572f1c95467d$export$7568632d0d33d16d, (v) => $e668572f1c95467d$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $e668572f1c95467d$export$f93f40ac0ca7e3a8, (v) => $e668572f1c95467d$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $e668572f1c95467d$export$1f96ae73734a86cc, (v) => $e668572f1c95467d$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $e668572f1c95467d$export$9a47ced3238df325, (v) => $e668572f1c95467d$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $e668572f1c95467d$export$35808ee640e87ca7, (v) => $e668572f1c95467d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e668572f1c95467d$export$fae74005e78b1a27, (v) => $e668572f1c95467d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e668572f1c95467d$export$dc8fbce3eb94dc1e, (v) => $e668572f1c95467d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e668572f1c95467d$export$6a7bc4e911dc01cf, (v) => $e668572f1c95467d$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e668572f1c95467d$export$6d9c69b0de29b591, (v) => $e668572f1c95467d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $e668572f1c95467d$export$7f54fc3180508a52, (v) => $e668572f1c95467d$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $e668572f1c95467d$export$f680877a34711e37, (v) => $e668572f1c95467d$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e668572f1c95467d$export$d5a552a76deda3c2, (v) => $e668572f1c95467d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e668572f1c95467d$export$aaabe4eda9ed9969, (v) => $e668572f1c95467d$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e668572f1c95467d$export$e5c5a5f917a5871c, (v) => $e668572f1c95467d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e668572f1c95467d$export$1538c33de8887b59, (v) => $e668572f1c95467d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $e668572f1c95467d$export$fca7f784ae7a249a, (v) => $e668572f1c95467d$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $e668572f1c95467d$export$13e3392192263954, (v) => $e668572f1c95467d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e668572f1c95467d$export$b8f5890fc79d6aca, (v) => $e668572f1c95467d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e668572f1c95467d$export$60241385465d0a34, (v) => $e668572f1c95467d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e668572f1c95467d$export$306c0aa65ff9ec16, (v) => $e668572f1c95467d$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e668572f1c95467d$export$7b286972b8d8ccbf, (v) => $e668572f1c95467d$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e668572f1c95467d$export$83d89fbfd8236492, (v) => $e668572f1c95467d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e668572f1c95467d$export$9c16c1426311996d;
var $e668572f1c95467d$export$dca3b0875bd9a954;
var $e668572f1c95467d$export$16fa2f45be04daa8;
var $e668572f1c95467d$export$ffb0004e005737fa;
var $e668572f1c95467d$export$e2c29f18771995cb;
var $e668572f1c95467d$export$221d75b3f55bb0bd;
var $e668572f1c95467d$export$5f8d39834fd61797;
var $e668572f1c95467d$export$74bf444e3cd11ea5;
var $e668572f1c95467d$export$8cdaa4703948c5e9;
var $e668572f1c95467d$export$1ced07cd6b1985ce;
var $e668572f1c95467d$export$abd8e32b826d7ea7;
var $e668572f1c95467d$export$87c99536b1b8cdd8;
var $e668572f1c95467d$export$69a3209f1a06c04d;
var $e668572f1c95467d$export$8c538325882c7eec;
var $e668572f1c95467d$export$e530037191fcd5d7;
var $e668572f1c95467d$export$fd42f52fd3ae1109;
var $e668572f1c95467d$export$c8a8987d4410bf2d;
var $e668572f1c95467d$export$7d1e3a5e95ceca43;
var $e668572f1c95467d$export$257a8862b851cb5b;
var $e668572f1c95467d$export$a8257692ac88316c;
var $e668572f1c95467d$export$488013bae63b21da;
var $e668572f1c95467d$export$7c73462e0d25e514;
var $e668572f1c95467d$export$7568632d0d33d16d;
var $e668572f1c95467d$export$f93f40ac0ca7e3a8;
var $e668572f1c95467d$export$1f96ae73734a86cc;
var $e668572f1c95467d$export$9a47ced3238df325;
var $e668572f1c95467d$export$35808ee640e87ca7;
var $e668572f1c95467d$export$fae74005e78b1a27;
var $e668572f1c95467d$export$dc8fbce3eb94dc1e;
var $e668572f1c95467d$export$6a7bc4e911dc01cf;
var $e668572f1c95467d$export$6d9c69b0de29b591;
var $e668572f1c95467d$export$7f54fc3180508a52;
var $e668572f1c95467d$export$f680877a34711e37;
var $e668572f1c95467d$export$d5a552a76deda3c2;
var $e668572f1c95467d$export$aaabe4eda9ed9969;
var $e668572f1c95467d$export$e5c5a5f917a5871c;
var $e668572f1c95467d$export$1538c33de8887b59;
var $e668572f1c95467d$export$fca7f784ae7a249a;
var $e668572f1c95467d$export$13e3392192263954;
var $e668572f1c95467d$export$b8f5890fc79d6aca;
var $e668572f1c95467d$export$60241385465d0a34;
var $e668572f1c95467d$export$306c0aa65ff9ec16;
var $e668572f1c95467d$export$7b286972b8d8ccbf;
var $e668572f1c95467d$export$83d89fbfd8236492;
"use strict";
var $e668572f1c95467d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e668572f1c95467d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e668572f1c95467d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e668572f1c95467d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e668572f1c95467d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e668572f1c95467d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e668572f1c95467d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e668572f1c95467d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e668572f1c95467d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e668572f1c95467d$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $e668572f1c95467d$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e668572f1c95467d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e668572f1c95467d$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e668572f1c95467d$var$assign = Object.assign, $e668572f1c95467d$var$emptyObject = {};
function $e668572f1c95467d$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
$e668572f1c95467d$var$Component.prototype.isReactComponent = {};
$e668572f1c95467d$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$e668572f1c95467d$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $e668572f1c95467d$var$ComponentDummy() {}
$e668572f1c95467d$var$ComponentDummy.prototype = $e668572f1c95467d$var$Component.prototype;
function $e668572f1c95467d$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
var $e668572f1c95467d$var$pureComponentPrototype = $e668572f1c95467d$var$PureComponent.prototype = new $e668572f1c95467d$var$ComponentDummy();
$e668572f1c95467d$var$pureComponentPrototype.constructor = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$var$assign($e668572f1c95467d$var$pureComponentPrototype, $e668572f1c95467d$var$Component.prototype);
$e668572f1c95467d$var$pureComponentPrototype.isPureReactComponent = !0;
var $e668572f1c95467d$var$isArrayImpl = Array.isArray;
function $e668572f1c95467d$var$noop() {}
var $e668572f1c95467d$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $e668572f1c95467d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e668572f1c95467d$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $e668572f1c95467d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $e668572f1c95467d$var$cloneAndReplaceKey(oldElement, newKey) {
    return $e668572f1c95467d$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $e668572f1c95467d$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e668572f1c95467d$var$REACT_ELEMENT_TYPE;
}
function $e668572f1c95467d$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $e668572f1c95467d$var$userProvidedKeyEscapeRegex = /\/+/g;
function $e668572f1c95467d$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $e668572f1c95467d$var$escape("" + element.key) : index.toString(36);
}
function $e668572f1c95467d$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($e668572f1c95467d$var$noop, $e668572f1c95467d$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $e668572f1c95467d$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $e668572f1c95467d$var$REACT_ELEMENT_TYPE:
                case $e668572f1c95467d$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $e668572f1c95467d$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $e668572f1c95467d$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $e668572f1c95467d$var$getElementKey(children, 0) : nameSoFar, $e668572f1c95467d$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $e668572f1c95467d$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($e668572f1c95467d$var$isValidElement(callback) && (callback = $e668572f1c95467d$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($e668572f1c95467d$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $e668572f1c95467d$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i++), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $e668572f1c95467d$var$mapIntoArray($e668572f1c95467d$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $e668572f1c95467d$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $e668572f1c95467d$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $e668572f1c95467d$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $e668572f1c95467d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $e668572f1c95467d$var$startTransition(scope) {
    var prevTransition = $e668572f1c95467d$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $e668572f1c95467d$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $e668572f1c95467d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($e668572f1c95467d$var$noop, $e668572f1c95467d$var$reportGlobalError);
    } catch (error) {
        $e668572f1c95467d$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e668572f1c95467d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e668572f1c95467d$var$addTransitionType(type) {
    var transition = $e668572f1c95467d$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $e668572f1c95467d$var$startTransition($e668572f1c95467d$var$addTransitionType.bind(null, type));
}
var $e668572f1c95467d$var$Children = {
    map: $e668572f1c95467d$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $e668572f1c95467d$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $e668572f1c95467d$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $e668572f1c95467d$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$e668572f1c95467d$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$e668572f1c95467d$export$9c16c1426311996d = $e668572f1c95467d$var$REACT_ACTIVITY_TYPE;
$e668572f1c95467d$export$dca3b0875bd9a954 = $e668572f1c95467d$var$Children;
$e668572f1c95467d$export$16fa2f45be04daa8 = $e668572f1c95467d$var$Component;
$e668572f1c95467d$export$ffb0004e005737fa = $e668572f1c95467d$var$REACT_FRAGMENT_TYPE;
$e668572f1c95467d$export$e2c29f18771995cb = $e668572f1c95467d$var$REACT_PROFILER_TYPE;
$e668572f1c95467d$export$221d75b3f55bb0bd = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$export$5f8d39834fd61797 = $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE;
$e668572f1c95467d$export$74bf444e3cd11ea5 = $e668572f1c95467d$var$REACT_SUSPENSE_TYPE;
$e668572f1c95467d$export$8cdaa4703948c5e9 = $e668572f1c95467d$var$REACT_VIEW_TRANSITION_TYPE;
$e668572f1c95467d$export$1ced07cd6b1985ce = $e668572f1c95467d$var$ReactSharedInternals;
$e668572f1c95467d$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $e668572f1c95467d$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$e668572f1c95467d$export$87c99536b1b8cdd8 = $e668572f1c95467d$var$addTransitionType;
$e668572f1c95467d$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$e668572f1c95467d$export$8c538325882c7eec = function() {
    return null;
};
$e668572f1c95467d$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $e668572f1c95467d$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$e668572f1c95467d$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $e668572f1c95467d$var$ReactElement(element.type, key, props);
};
$e668572f1c95467d$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $e668572f1c95467d$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $e668572f1c95467d$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$e668572f1c95467d$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$e668572f1c95467d$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $e668572f1c95467d$var$ReactElement(type, key, props);
};
$e668572f1c95467d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e668572f1c95467d$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$e668572f1c95467d$export$a8257692ac88316c = $e668572f1c95467d$var$isValidElement;
$e668572f1c95467d$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $e668572f1c95467d$var$lazyInitializer
    };
};
$e668572f1c95467d$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$e668572f1c95467d$export$7568632d0d33d16d = $e668572f1c95467d$var$startTransition;
$e668572f1c95467d$export$f93f40ac0ca7e3a8 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCacheRefresh();
};
$e668572f1c95467d$export$1f96ae73734a86cc = function(usable) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.use(usable);
};
$e668572f1c95467d$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$e668572f1c95467d$export$35808ee640e87ca7 = function(callback, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$e668572f1c95467d$export$fae74005e78b1a27 = function(Context) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useContext(Context);
};
$e668572f1c95467d$export$dc8fbce3eb94dc1e = function() {};
$e668572f1c95467d$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$e668572f1c95467d$export$6d9c69b0de29b591 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useEffect(create, deps);
};
$e668572f1c95467d$export$7f54fc3180508a52 = function(callback) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$e668572f1c95467d$export$f680877a34711e37 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useId();
};
$e668572f1c95467d$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$e668572f1c95467d$export$aaabe4eda9ed9969 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$e668572f1c95467d$export$e5c5a5f917a5871c = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$e668572f1c95467d$export$1538c33de8887b59 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useMemo(create, deps);
};
$e668572f1c95467d$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$e668572f1c95467d$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$e668572f1c95467d$export$b8f5890fc79d6aca = function(initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useRef(initialValue);
};
$e668572f1c95467d$export$60241385465d0a34 = function(initialState) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useState(initialState);
};
$e668572f1c95467d$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$e668572f1c95467d$export$7b286972b8d8ccbf = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useTransition();
};
$e668572f1c95467d$export$83d89fbfd8236492 = "19.3.0";

});


parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("jRYbO"));

});
parcelRegister("jRYbO", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0, (v) => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $e771a7f3a12c9e1c$export$3f2684e5d7cb1006, (v) => $e771a7f3a12c9e1c$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $e771a7f3a12c9e1c$export$d39a5bbd09211389, (v) => $e771a7f3a12c9e1c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4, (v) => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $e771a7f3a12c9e1c$export$a0816fa17a9e79be, (v) => $e771a7f3a12c9e1c$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $e771a7f3a12c9e1c$export$7292efcadded39f3, (v) => $e771a7f3a12c9e1c$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $e771a7f3a12c9e1c$export$da407abadb9b8f86, (v) => $e771a7f3a12c9e1c$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $e771a7f3a12c9e1c$export$314cfea32580671c, (v) => $e771a7f3a12c9e1c$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $e771a7f3a12c9e1c$export$513ccb98c53b8039, (v) => $e771a7f3a12c9e1c$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $e771a7f3a12c9e1c$export$dbca993bc2d264a, (v) => $e771a7f3a12c9e1c$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $e771a7f3a12c9e1c$export$4797a8006f0655d0, (v) => $e771a7f3a12c9e1c$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e771a7f3a12c9e1c$export$c78a37762a8d58e1, (v) => $e771a7f3a12c9e1c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6, (v) => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e, (v) => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $e771a7f3a12c9e1c$export$83d89fbfd8236492, (v) => $e771a7f3a12c9e1c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0;
var $e771a7f3a12c9e1c$export$3f2684e5d7cb1006;
var $e771a7f3a12c9e1c$export$d39a5bbd09211389;
var $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4;
var $e771a7f3a12c9e1c$export$a0816fa17a9e79be;
var $e771a7f3a12c9e1c$export$7292efcadded39f3;
var $e771a7f3a12c9e1c$export$da407abadb9b8f86;
var $e771a7f3a12c9e1c$export$314cfea32580671c;
var $e771a7f3a12c9e1c$export$513ccb98c53b8039;
var $e771a7f3a12c9e1c$export$dbca993bc2d264a;
var $e771a7f3a12c9e1c$export$4797a8006f0655d0;
var $e771a7f3a12c9e1c$export$c78a37762a8d58e1;
var $e771a7f3a12c9e1c$export$606f11b2eb45ecc6;
var $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e;
var $e771a7f3a12c9e1c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $e771a7f3a12c9e1c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e771a7f3a12c9e1c$var$noop() {}
var $e771a7f3a12c9e1c$var$Internals = {
    d: {
        f: $e771a7f3a12c9e1c$var$noop,
        r: function() {
            throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(522));
        },
        D: $e771a7f3a12c9e1c$var$noop,
        C: $e771a7f3a12c9e1c$var$noop,
        L: $e771a7f3a12c9e1c$var$noop,
        m: $e771a7f3a12c9e1c$var$noop,
        X: $e771a7f3a12c9e1c$var$noop,
        S: $e771a7f3a12c9e1c$var$noop,
        M: $e771a7f3a12c9e1c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e771a7f3a12c9e1c$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $e771a7f3a12c9e1c$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $e771a7f3a12c9e1c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $e771a7f3a12c9e1c$var$REACT_OPTIMISTIC_KEY ? $e771a7f3a12c9e1c$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $e771a7f3a12c9e1c$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = $e771a7f3a12c9e1c$var$Internals;
$e771a7f3a12c9e1c$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $e771a7f3a12c9e1c$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$e771a7f3a12c9e1c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(299));
    return $e771a7f3a12c9e1c$var$createPortal$1(children, container, null, key);
};
$e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $e771a7f3a12c9e1c$var$ReactSharedInternals.T, previousUpdatePriority = $e771a7f3a12c9e1c$var$Internals.p;
    try {
        if ($e771a7f3a12c9e1c$var$ReactSharedInternals.T = null, $e771a7f3a12c9e1c$var$Internals.p = 2, fn) return fn();
    } finally{
        $e771a7f3a12c9e1c$var$ReactSharedInternals.T = previousTransition, $e771a7f3a12c9e1c$var$Internals.p = previousUpdatePriority, $e771a7f3a12c9e1c$var$Internals.d.f();
    }
};
$e771a7f3a12c9e1c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $e771a7f3a12c9e1c$var$Internals.d.C(href, options));
};
$e771a7f3a12c9e1c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $e771a7f3a12c9e1c$var$Internals.d.D(href);
};
$e771a7f3a12c9e1c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $e771a7f3a12c9e1c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $e771a7f3a12c9e1c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $e771a7f3a12c9e1c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $e771a7f3a12c9e1c$var$Internals.d.M(href);
    }
};
$e771a7f3a12c9e1c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $e771a7f3a12c9e1c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $e771a7f3a12c9e1c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $e771a7f3a12c9e1c$var$Internals.d.m(href);
    }
};
$e771a7f3a12c9e1c$export$4797a8006f0655d0 = function(form) {
    $e771a7f3a12c9e1c$var$Internals.d.r(form);
};
$e771a7f3a12c9e1c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = function() {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$e771a7f3a12c9e1c$export$83d89fbfd8236492 = "19.3.0";

});




parcelRegister("7Kpeg", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", () => $5a4066412ccab0c1$export$d36bdfa510afb180);
$parcel$export(module.exports, "Provider", () => $5a4066412ccab0c1$export$2881499e37b75b9a);
$parcel$export(module.exports, "useDispatch", () => $5a4066412ccab0c1$export$8ad76b76a4c905f8);
$parcel$export(module.exports, "useSelector", () => $5a4066412ccab0c1$export$2105062e25df4afe);

var $8NFma = parcelRequire("8NFma");

var $jUbuP = parcelRequire("jUbuP");
var $5a4066412ccab0c1$var$__defProp = Object.defineProperty;
var $5a4066412ccab0c1$var$__defProps = Object.defineProperties;
var $5a4066412ccab0c1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5a4066412ccab0c1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5a4066412ccab0c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5a4066412ccab0c1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5a4066412ccab0c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $5a4066412ccab0c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5a4066412ccab0c1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5a4066412ccab0c1$var$__hasOwnProp.call(b, prop)) $5a4066412ccab0c1$var$__defNormalProp(a, prop, b[prop]);
    if ($5a4066412ccab0c1$var$__getOwnPropSymbols) {
        for (var prop of $5a4066412ccab0c1$var$__getOwnPropSymbols(b))if ($5a4066412ccab0c1$var$__propIsEnum.call(b, prop)) $5a4066412ccab0c1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5a4066412ccab0c1$var$__spreadProps = (a, b)=>$5a4066412ccab0c1$var$__defProps(a, $5a4066412ccab0c1$var$__getOwnPropDescs(b));
var $5a4066412ccab0c1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5a4066412ccab0c1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5a4066412ccab0c1$var$__getOwnPropSymbols) {
        for (var prop of $5a4066412ccab0c1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5a4066412ccab0c1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $5a4066412ccab0c1$var$IS_REACT_19 = /* @__PURE__ */ $8NFma.version.startsWith("19");
var $5a4066412ccab0c1$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($5a4066412ccab0c1$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $5a4066412ccab0c1$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $5a4066412ccab0c1$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $5a4066412ccab0c1$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $5a4066412ccab0c1$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $5a4066412ccab0c1$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $5a4066412ccab0c1$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $5a4066412ccab0c1$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $5a4066412ccab0c1$var$ForwardRef = $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE;
var $5a4066412ccab0c1$var$Memo = $5a4066412ccab0c1$var$REACT_MEMO_TYPE;
function $5a4066412ccab0c1$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE || type === $5a4066412ccab0c1$var$REACT_PROFILER_TYPE || type === $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE || type === $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE || type === $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE || type === $5a4066412ccab0c1$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $5a4066412ccab0c1$var$REACT_LAZY_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_MEMO_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_CONSUMER_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $5a4066412ccab0c1$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $5a4066412ccab0c1$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE:
                    case $5a4066412ccab0c1$var$REACT_PROFILER_TYPE:
                    case $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE:
                    case $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE:
                    case $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE:
                            case $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE:
                            case $5a4066412ccab0c1$var$REACT_LAZY_TYPE:
                            case $5a4066412ccab0c1$var$REACT_MEMO_TYPE:
                                return object;
                            case $5a4066412ccab0c1$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $5a4066412ccab0c1$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $5a4066412ccab0c1$var$isContextConsumer(object) {
    return $5a4066412ccab0c1$var$IS_REACT_19 ? $5a4066412ccab0c1$var$typeOf(object) === $5a4066412ccab0c1$var$REACT_CONSUMER_TYPE : $5a4066412ccab0c1$var$typeOf(object) === $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE;
}
function $5a4066412ccab0c1$var$isMemo(object) {
    return $5a4066412ccab0c1$var$typeOf(object) === $5a4066412ccab0c1$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $5a4066412ccab0c1$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $5a4066412ccab0c1$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $5a4066412ccab0c1$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $5a4066412ccab0c1$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $5a4066412ccab0c1$var$verify(mapStateToProps, "mapStateToProps");
    $5a4066412ccab0c1$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $5a4066412ccab0c1$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $5a4066412ccab0c1$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $5a4066412ccab0c1$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $5a4066412ccab0c1$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $5a4066412ccab0c1$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $5a4066412ccab0c1$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $5a4066412ccab0c1$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $5a4066412ccab0c1$var$verifyPlainObject(value, displayName, methodName) {
    if (!$5a4066412ccab0c1$var$isPlainObject(value)) $5a4066412ccab0c1$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $5a4066412ccab0c1$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $5a4066412ccab0c1$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $5a4066412ccab0c1$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $5a4066412ccab0c1$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $5a4066412ccab0c1$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $5a4066412ccab0c1$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $5a4066412ccab0c1$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $5a4066412ccab0c1$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $5a4066412ccab0c1$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $5a4066412ccab0c1$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $5a4066412ccab0c1$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $5a4066412ccab0c1$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $5a4066412ccab0c1$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $5a4066412ccab0c1$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $5a4066412ccab0c1$var$__spreadValues($5a4066412ccab0c1$var$__spreadValues($5a4066412ccab0c1$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $5a4066412ccab0c1$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5a4066412ccab0c1$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$5a4066412ccab0c1$var$defaultMergeProps : typeof mergeProps === "function" ? $5a4066412ccab0c1$var$wrapMergePropsFunc(mergeProps) : $5a4066412ccab0c1$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $5a4066412ccab0c1$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $5a4066412ccab0c1$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $5a4066412ccab0c1$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $5a4066412ccab0c1$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $5a4066412ccab0c1$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $5a4066412ccab0c1$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5a4066412ccab0c1$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $5a4066412ccab0c1$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $5a4066412ccab0c1$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $5a4066412ccab0c1$var$isDOM = /* @__PURE__ */ $5a4066412ccab0c1$var$canUseDOM();
var $5a4066412ccab0c1$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $5a4066412ccab0c1$var$isReactNative = /* @__PURE__ */ $5a4066412ccab0c1$var$isRunningInReactNative();
var $5a4066412ccab0c1$var$getUseIsomorphicLayoutEffect = ()=>$5a4066412ccab0c1$var$isDOM || $5a4066412ccab0c1$var$isReactNative ? $8NFma.useLayoutEffect : $8NFma.useEffect;
var $5a4066412ccab0c1$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $5a4066412ccab0c1$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $5a4066412ccab0c1$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5a4066412ccab0c1$export$d36bdfa510afb180(objA, objB) {
    if ($5a4066412ccab0c1$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$5a4066412ccab0c1$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $5a4066412ccab0c1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $5a4066412ccab0c1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $5a4066412ccab0c1$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $5a4066412ccab0c1$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $5a4066412ccab0c1$var$TYPE_STATICS = {
    [$5a4066412ccab0c1$var$ForwardRef]: $5a4066412ccab0c1$var$FORWARD_REF_STATICS,
    [$5a4066412ccab0c1$var$Memo]: $5a4066412ccab0c1$var$MEMO_STATICS
};
function $5a4066412ccab0c1$var$getStatics(component) {
    if ($5a4066412ccab0c1$var$isMemo(component)) return $5a4066412ccab0c1$var$MEMO_STATICS;
    return $5a4066412ccab0c1$var$TYPE_STATICS[component["$$typeof"]] || $5a4066412ccab0c1$var$REACT_STATICS;
}
var $5a4066412ccab0c1$var$defineProperty = Object.defineProperty;
var $5a4066412ccab0c1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $5a4066412ccab0c1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5a4066412ccab0c1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5a4066412ccab0c1$var$getPrototypeOf = Object.getPrototypeOf;
var $5a4066412ccab0c1$var$objectPrototype = Object.prototype;
function $5a4066412ccab0c1$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($5a4066412ccab0c1$var$objectPrototype) {
            const inheritedComponent = $5a4066412ccab0c1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $5a4066412ccab0c1$var$objectPrototype) $5a4066412ccab0c1$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $5a4066412ccab0c1$var$getOwnPropertyNames(sourceComponent);
        if ($5a4066412ccab0c1$var$getOwnPropertySymbols) keys = keys.concat($5a4066412ccab0c1$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $5a4066412ccab0c1$var$getStatics(targetComponent);
        const sourceStatics = $5a4066412ccab0c1$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$5a4066412ccab0c1$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $5a4066412ccab0c1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $5a4066412ccab0c1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $5a4066412ccab0c1$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $5a4066412ccab0c1$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $5a4066412ccab0c1$var$getContext() {
    var _a;
    if (!$8NFma.createContext) return {};
    const contextMap = (_a = $5a4066412ccab0c1$var$gT[$5a4066412ccab0c1$var$ContextKey]) != null ? _a : $5a4066412ccab0c1$var$gT[$5a4066412ccab0c1$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($8NFma.createContext);
    if (!realContext) {
        realContext = $8NFma.createContext(null);
        contextMap.set($8NFma.createContext, realContext);
    }
    return realContext;
}
var $5a4066412ccab0c1$export$cc80c08dc91f1c00 = /* @__PURE__ */ $5a4066412ccab0c1$var$getContext();
// src/components/connect.tsx
var $5a4066412ccab0c1$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $5a4066412ccab0c1$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $5a4066412ccab0c1$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $5a4066412ccab0c1$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $5a4066412ccab0c1$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $5a4066412ccab0c1$var$strictEqual(a, b) {
    return a === b;
}
var $5a4066412ccab0c1$var$hasWarnedAboutDeprecatedPureOption = false;
function $5a4066412ccab0c1$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $5a4066412ccab0c1$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $5a4066412ccab0c1$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $5a4066412ccab0c1$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $5a4066412ccab0c1$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $5a4066412ccab0c1$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $8NFma.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $5a4066412ccab0c1$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $8NFma.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $8NFma.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $8NFma.useMemo(()=>{
                return $5a4066412ccab0c1$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $8NFma.useMemo(()=>{
                if (!shouldHandleStateChanges) return $5a4066412ccab0c1$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $5a4066412ccab0c1$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $8NFma.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $8NFma.useRef(void 0);
            const lastWrapperProps = $8NFma.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $8NFma.useRef(void 0);
            const renderIsScheduled = $8NFma.useRef(false);
            const isMounted = $8NFma.useRef(false);
            const latestSubscriptionCallbackError = $8NFma.useRef(void 0);
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $8NFma.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $8NFma.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $5a4066412ccab0c1$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffectWithArgs($5a4066412ccab0c1$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $8NFma.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $8NFma.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $8NFma.createElement(WrappedComponent, $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $8NFma.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $8NFma.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $8NFma.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $8NFma.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $8NFma.createElement(Connect, $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $5a4066412ccab0c1$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $5a4066412ccab0c1$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $5a4066412ccab0c1$export$64605811ab45167f = $5a4066412ccab0c1$var$connect;
// src/components/Provider.tsx
function $5a4066412ccab0c1$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $8NFma.useMemo(()=>{
        const subscription = $5a4066412ccab0c1$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $8NFma.useMemo(()=>store.getState(), [
        store
    ]);
    $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $5a4066412ccab0c1$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $8NFma.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5a4066412ccab0c1$export$2881499e37b75b9a = $5a4066412ccab0c1$var$Provider;
// src/hooks/useReduxContext.ts
function $5a4066412ccab0c1$var$createReduxContextHook(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $8NFma.useContext(context);
        return contextValue;
    };
}
var $5a4066412ccab0c1$var$useReduxContext = /* @__PURE__ */ $5a4066412ccab0c1$var$createReduxContextHook();
// src/hooks/useStore.ts
function $5a4066412ccab0c1$export$671dba69185d0304(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$var$useReduxContext : // @ts-ignore
    $5a4066412ccab0c1$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $5a4066412ccab0c1$export$6ccbb43953eebf8 = /* @__PURE__ */ $5a4066412ccab0c1$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $5a4066412ccab0c1$export$bc9b55530897c558(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useStore2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$export$6ccbb43953eebf8 : $5a4066412ccab0c1$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $5a4066412ccab0c1$export$8ad76b76a4c905f8 = /* @__PURE__ */ $5a4066412ccab0c1$export$bc9b55530897c558();
var $5a4066412ccab0c1$var$refEquality = (a, b)=>a === b;
function $5a4066412ccab0c1$export$2b53f90d2bd1cbfb(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$var$useReduxContext : $5a4066412ccab0c1$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $5a4066412ccab0c1$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $8NFma.useRef(true);
        const wrappedSelector = $8NFma.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $jUbuP.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $8NFma.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $5a4066412ccab0c1$export$2105062e25df4afe = /* @__PURE__ */ $5a4066412ccab0c1$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $5a4066412ccab0c1$export$712ea50be43a7858 = $5a4066412ccab0c1$var$defaultNoopBatch;

});
parcelRegister("jUbuP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bcILy"));

});
parcelRegister("bcILy", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $82838a4696d811ec$export$bf730a2d8bf68b42, (v) => $82838a4696d811ec$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82838a4696d811ec$export$bf730a2d8bf68b42;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $82838a4696d811ec$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $82838a4696d811ec$var$objectIs = "function" === typeof Object.is ? Object.is : $82838a4696d811ec$var$is, $82838a4696d811ec$var$useSyncExternalStore = $8NFma.useSyncExternalStore, $82838a4696d811ec$var$useRef = $8NFma.useRef, $82838a4696d811ec$var$useEffect = $8NFma.useEffect, $82838a4696d811ec$var$useMemo = $8NFma.useMemo, $82838a4696d811ec$var$useDebugValue = $8NFma.useDebugValue;
$82838a4696d811ec$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $82838a4696d811ec$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $82838a4696d811ec$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($82838a4696d811ec$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $82838a4696d811ec$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $82838a4696d811ec$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $82838a4696d811ec$var$useDebugValue(value);
    return value;
};

});




parcelRegister("hI7EC", function(module, exports) {

$parcel$export(module.exports, "widgetLegends", () => $ce4c7ba9eca1d36a$export$d548963385b331d1);

parcelRequire("ibaza");
const $ce4c7ba9eca1d36a$export$d548963385b331d1 = {
    // BARRA SUPERIOR
    stationSelect: {
        title: {
            ca: "Men\xfa selector d'estacions"
        }
    },
    homeButton: {
        title: {
            ca: "Bot\xf3 d'acc\xe9s directe a l'escriptori d'estacions"
        }
    },
    tonalitySelect: {
        title: {
            ca: "Selector de la tonalitat de la canc\u0327\xf3"
        }
    },
    transportMetronome: {
        title: {
            ca: "Metro\u0300nom"
        }
    },
    transportTempoBox: {
        title: {
            ca: "Control de tempo"
        },
        description: {
            ca: "Representat en BPMs (beats per minut) ens permet modificar la velocitat de la can\xe7\xf3."
        }
    },
    transportSwingBox: {
        title: {
            ca: "Control de swing"
        },
        description: {
            ca: "El swing \xe9s una caracter\xedstica r\xedtmica que d\xf3na a la m\xfasica una sensaci\xf3 de moviment org\xe0nic. Despla\xe7a els cops entre temps i els fa m\xe9s humans i menys r\xedgids."
        }
    },
    transportPlayToggle: {
        title: {
            ca: "Play/Stop"
        },
        description: {
            ca: "Aquest conmutador permet iniciar o aturar la reproducci\xf3 del Gruf."
        }
    },
    transportMidiRecordToggle: {
        title: {
            ca: "Gravaci\xf3"
        },
        description: {
            ca: "Aquest bot\xf3 permet activar la gravaci\xf3 de notes en directe des d'un teclat o dispositiu midi."
        }
    },
    muteToggle: {
        title: {
            ca: "Mute"
        },
        description: {
            ca: "Aquest bot\xf3 permet silenciar l'instrument a on et trobes."
        }
    },
    soloToggle: {
        title: {
            ca: "Solo"
        },
        description: {
            ca: "Serveix per escoltar nom\xe9s l'instrument on et trobes (La resta queden silenciades fins que el tornes a clicar)."
        }
    },
    projectTitle: {
        title: {
            ca: "T\xedtol del projecte"
        }
    },
    connectedUsers: {
        title: {
            ca: "N\xfamero d'usuaris connectats en aquest moment al projecte"
        }
    },
    configurationTrigger: {
        title: {
            ca: "Acc\xe9s a la configuraci\xf3"
        }
    },
    exitButton: {
        title: {
            ca: "Sortir del projecte"
        }
    },
    // ELEMENTS COMUNS ALS INSTRUMENTS
    presetSelect: {
        title: {
            ca: "Selector de sons"
        },
        description: {
            ca: "Des d'aqu\xed podr\xe0s accedir a diferents configuracions de so predeterminades i als presets que has guardat."
        }
    },
    presetMenuTrigger: {
        title: {
            ca: "Accions del preset"
        },
        description: {
            ca: "Des d'aquest men\xfa pots exportar, reanomenar i/o eliminar presets. Tamb\xe9 pots tornar a carregar els valors per defecte de l'instrument."
        }
    },
    presetSaveButton: {
        title: {
            ca: "Bot\xf3 de guardar"
        },
        description: {
            ca: "Permet guardar la configuraci\xf3 del so que tens actualment."
        }
    },
    instrumentVolume: {
        label: {
            ca: "Vol"
        },
        title: {
            ca: "Volum"
        },
        description: {
            ca: "Aquesta roda modifica el volum (intensitat) d'aquest instrument. Aquest element est\xe0 vinculat a la pista d'aquest instrument al Mixer."
        }
    },
    lpfCutoff: {
        label: {
            ca: "Cutoff"
        },
        title: {
            ca: "Cutoff"
        },
        description: {
            ca: "Aquesta roda \xe9s un filtre de freq\xfc\xe8ncies. Si mous la posici\xf3 del potenci\xf2metre cap a l\u2019esquerra desapareixaran progressivament les freq\xfc\xe8ncies mitges i agudes i ens quedarem amb les greus o subgreus."
        }
    },
    hpfCutoff: {
        label: {
            ca: "HPF"
        }
    },
    adsr: {
        label: {
            ca: "ADSR"
        },
        title: {
            ca: "ADSR"
        },
        description: {
            ca: "Dispositiu que modula el volum del so en el temps, amb els par\xe0metres d'Attack, Decay, Sustain i Release."
        }
    },
    adsrAttack: {
        label: {
            ca: "Attack"
        },
        title: {
            ca: "Attack"
        },
        description: {
            ca: "El par\xe0metre attack modifica com comen\xe7a a reproduir-se el so. Pot comen\xe7ar m\xe9s bruscament o m\xe9s suau, depenent d'on col\xb7loquis l'angle del potenci\xf2metre."
        }
    },
    adsrDecay: {
        label: {
            ca: "Decay"
        },
        title: {
            ca: "Decay"
        },
        description: {
            ca: "\xc9s el temps que tarda el so a baixar des del volum m\xe0xim fins al nivell de sosteniment. Serveix per fer que el so sigui m\xe9s curt i sec o m\xe9s llarg i suau."
        }
    },
    adsrSustain: {
        label: {
            ca: "Sustain"
        },
        title: {
            ca: "Sustain"
        },
        description: {
            ca: "El sustain \xe9s el nivell de volum que mant\xe9 el so mentre tens la tecla premuda. Serveix per fer que el so sigui constant o s'apagui r\xe0pid, segons la posici\xf3 del potenci\xf2metre."
        }
    },
    adsrRelease: {
        label: {
            ca: "Release"
        },
        title: {
            ca: "Release"
        },
        description: {
            ca: "El release \xe9s el temps que tarda triga el so a desapar\xe8ixer quan deixes anar la tecla. Pot fer que el so s'acabi de cop o s'esvaeixi suaument."
        }
    },
    equalizer: {
        label: {
            ca: "Equalitzaci\xf3"
        },
        title: {
            ca: "Equalitzador"
        },
        description: {
            ca: "Dispositiu per modificar els 3 rangs freq\xfcencials de greus, mitjos i aguts. S'activa i desactiva amb la pestanya que hi ha a la part superior dreta del requadre."
        }
    },
    eqToggle: {
        title: {
            ca: "EQ On/Off"
        },
        description: {
            ca: "Activa o desactiva l'equalitzador."
        }
    },
    eqLow: {
        label: {
            ca: "Low"
        },
        title: {
            ca: "Rang greu"
        },
        description: {
            ca: "Augmenta o atenua la percepci\xf3 del rang de freq\xfc\xe8ncies greus."
        }
    },
    eqMid: {
        label: {
            ca: "Mid"
        },
        title: {
            ca: "Rang mig"
        },
        description: {
            ca: "Augmenta o atenua la percepci\xf3 del rang de freq\xfc\xe8ncies mitges."
        }
    },
    eqHigh: {
        label: {
            ca: "High"
        },
        title: {
            ca: "Rang agut"
        },
        description: {
            ca: "Augmenta o atenua la percepci\xf3 del rang de freq\xfc\xe8ncies agudes."
        }
    },
    sends: {
        label: {
            ca: "Sends"
        },
        title: {
            ca: "Sends"
        },
        description: {
            ca: "Dispositiu d'enviament de la senyal cap als 4 canals d'efectes: Reverb A i B, Delay A i B."
        }
    },
    sendReverbA: {
        label: {
            ca: "Reverb A"
        },
        title: {
            ca: "Reverb"
        },
        description: {
            ca: "Aplica un efecte al teu instrument per aconseguir ubicar el teu so en un espai m\xe9s gran o m\xe9s petit i poder controlar la proximitat i llunyania del so."
        }
    },
    sendReverbB: {
        label: {
            ca: "Reverb B"
        },
        title: {
            ca: "Reverb"
        },
        description: {
            ca: "Aplica un efecte al teu instrument per aconseguir ubicar el teu so en un espai m\xe9s gran o m\xe9s petit i poder controlar la proximitat i llunyania del so."
        }
    },
    sendDelayA: {
        label: {
            ca: "Delay A"
        },
        title: {
            ca: "Delay"
        },
        description: {
            ca: "Aplica un efecte d'espai al teu instrument a trav\xe9s de repeticions del mateix so, com un eco. Pots controlar la sensaci\xf3 de proximitat o llunyania."
        }
    },
    sendDelayB: {
        label: {
            ca: "Delay B"
        },
        title: {
            ca: "Delay"
        },
        description: {
            ca: "Aplica un efecte d'espai al teu instrument a trav\xe9s de repeticions del mateix so, com un eco. Pots controlar la sensaci\xf3 de proximitat o llunyania."
        }
    },
    helpBox: {
        title: {
            ca: "Caixa d'ajuda"
        }
    },
    pianoRoll: {
        title: {
            ca: "Editor de notes"
        },
        description: {
            ca: "Aquesta graella serveix per escriure, gravar i editar la posici\xf3 i llargada de les notes musicals que sonaran dins d'aquest instrument."
        }
    },
    pianoRollDiatonicColoring: {
        title: {
            ca: "Visi\xf3 diato\u0300nica"
        },
        description: {
            ca: "Aquest bot\xf3 activa la visi\xf3 diat\xf2nica. Significa que veus ressaltades les notes diat\xf2niques de la tonalitat escollida de la can\xe7\xf3. De color violeta/vermell fosc la fonamental,  de color violeta/vermell clar  la resta de notes diat\xf2niques i de color gris les notes que no ho s\xf3n."
        }
    },
    pianoRollChromaticColoring: {
        title: {
            ca: "Visi\xf3 croma\u0300tica"
        },
        description: {
            ca: "Aquest bot\xf3 activa la visi\xf3 crom\xe0tica. No es ressalten notes, es veuen com en un piano perqu\xe8 tinguis una guia."
        }
    },
    clipMenuTrigger: {
        title: {
            ca: "Accions del clip"
        },
        description: {
            ca: "Men\xfa desplegable que permet canviar altres coses del clip que no la durada."
        }
    },
    clipSelect: {
        title: {
            ca: "Banc de clips"
        },
        description: {
            ca: "A, B, C i D s\xf3n 4 clips independents on pots escriure notes diferents i imprimir diferents efectes de so. S'utilitza per fer variacions, \xe9s a dir, per construir diferents parts d'una can\xe7\xf3."
        }
    },
    clipDurationControls: {
        title: {
            ca: "Canvi de durada del clip"
        },
        description: {
            ca: "Control per augmentar o reduir la durada en compassos del clip. Pots escollir entre 1, 2 o 4 compassos de durada."
        }
    },
    // ELEMENTS ESPECÍFICS, SYNTH I SYNTH BASS
    synthesis: {
        label: {
            ca: "S\xedntesi"
        },
        title: {
            ca: "S\xedntesi"
        },
        description: {
            ca: "Dispositiu que genera el so a trav\xe9s de l'oscil\xb7lador i el modifica amb els par\xe0metres Detune, Glide, Mod Rate i Mod Depth."
        }
    },
    oscWaveform: {
        title: {
            ca: "Oscil\xb7lador"
        },
        description: {
            ca: "Genera un so a partir d'una altura musical. Pots escollir 4 formes d'ona diferents: sinuso\xefdal, quadrada, triangular i de serra. Totes 4 amb unes qualitats t\xedmbriques diferents."
        }
    },
    oscOctave: {
        label: {
            ca: "Octave"
        }
    },
    oscDetune: {
        label: {
            ca: "Detune"
        },
        title: {
            ca: "Detune"
        },
        description: {
            ca: "Vols un so m\xe9s gruixut? Aquest par\xe0metre duplica la senyal, en desafina una de les c\xf2pies i aconsegueix aportar cos i amplitud. Com en tot, el secret est\xe0 a aplicar-lo en la seva justa mesura!"
        }
    },
    oscPortamento: {
        label: {
            ca: "Glide"
        },
        title: {
            ca: "Glide"
        },
        description: {
            ca: "El glide (o portamento) converteix el teu sintetitzador en un tobogan musical. En lloc de fer un salt brusc entre una nota i una altra, el so viatja lliscant per totes les notes que hi ha pel mig. Si gires el potenci\xf2metre  al m\xe0xim, el viatge d'una nota a l'altra ser\xe0 molt m\xe9s lent i llarg!"
        }
    },
    lfoRate: {
        label: {
            ca: "Mod Rate"
        },
        title: {
            ca: "Velocitat de modulaci\xf3"
        },
        description: {
            ca: "Juntament amb la profunditat de modulaci\xf3, modula el volum del so (creant un efecte de tre\u0300molo). La velocitat de modulaci\xf3 fa que el volum pugi i baixi de manera m\xe9s lenta o r\xe0pida."
        }
    },
    lfoDepth: {
        label: {
            ca: "Mod Depth"
        },
        title: {
            ca: "Profunditat de modulaci\xf3"
        },
        description: {
            ca: "Juntament amb la velocitat de modulaci\xf3, modula el volum del so (creant un efecte de tre\u0300molo). La profunditat de modulaci\xf3 defineix com de marcat o intens sera\u0300 el canvi de volum."
        }
    },
    // ELEMENTS ESPECÍFICS, PIANO
    pianoSound: {
        label: {
            ca: "So"
        }
    },
    pianoTimbre: {
        label: {
            ca: "Timbre"
        }
    },
    // ELEMENTS ESPECÍFICS, GROOVEBOX
    drumVol: {
        label: {
            ca: "Vol"
        },
        title: {
            ca: "Volum"
        },
        description: {
            ca: "Aquest potenci\xf2metre modifica el volum de l\u2019element de la Groovebox seleccionat (Open hat, closed hat, snare o kick)."
        }
    },
    drumTone: {
        label: {
            ca: "Tone"
        },
        title: {
            ca: "Tone"
        },
        description: {
            ca: "Controla l'afinaci\xf3 de l\u2019element seleccionat. Gira el potenci\xf2metre  per obtenir un cop m\xe9s agut i definit o m\xe9s greu i contundent."
        }
    },
    drumRelease: {
        label: {
            ca: "Release"
        },
        title: {
            ca: "Release"
        },
        description: {
            ca: "Regula la durada de la cua del so seleccionat."
        }
    },
    drumReverb: {
        label: {
            ca: "Reverb"
        },
        title: {
            ca: "Reverb"
        },
        description: {
            ca: "Aquest control simula l'ac\xfastica d'un espai. Com m\xe9s gires el potenci\xf2metre, m\xe9s gran es fa l'habitaci\xf3 on sona el so que has seleccionat. Des d'un espai petit i sec fins a una catedral gegant."
        }
    },
    drumSwing: {
        label: {
            ca: "Swing"
        },
        title: {
            ca: "Swing"
        },
        description: {
            ca: "Afegeix un retard a determinats cops de l\u2019element que has seleccionat per trencar la rigidesa de la graella digital. Aporta un moviment r\xedtmic m\xe9s hum\xe0."
        }
    },
    drumDrumkit: {
        title: {
            ca: "Selector de mostres"
        },
        description: {
            ca: "Aquest control permet seleccionar entre diferents mostres de cada element de la Groovebox."
        }
    },
    drumPad: {
        title: {
            ca: "Pad de so"
        },
        description: {
            ca: "Cada pad reprodueix l'element corresponent de la bateria. Per exemple, si selecciones \u201Csnare\u201D (la caixa), sonara\u0300 la caixa. A m\xe9s podra\u0300s ajustar els seus para\u0300metres espec\xedfics a l'esquerra: Vol, Tone, Release, Reverb i Swing."
        }
    },
    grooveboxSequencer: {
        title: {
            ca: "Seq\xfcenciador"
        },
        description: {
            ca: "\xc9s el cervell de la Groovebox. Permet programar, ordenar i reproduir els cops en el temps per crear els teus patrons de bateria."
        }
    },
    // ELEMENTS ESPECÍFICS, SAMPLER
    sampleSelect: {
        title: {
            ca: "Men\xfa selector de samples"
        },
        description: {
            ca: "Des d'aqu\xed podr\xe0s accedir les diferents mostres samples que hem preparat per utilitzar."
        }
    },
    choke: {
        label: {
            ca: "Choke"
        },
        title: {
            ca: "Choke"
        },
        description: {
            ca: "Activa o desactiva el Choke. La seva funci\xf3 quan est\xe0 activat \xe9s que interromp la reproducci\xf3 d'un so quan se'n dispara un altre."
        }
    },
    padTranspose: {
        label: {
            ca: "Transpose"
        },
        title: {
            ca: "Transposici\xf3 del pad"
        },
        description: {
            ca: "Aquesta rodeta modica l'afinaci\xf3 del pad seleccionat, o de tots si GROUP esta\u0300 activat."
        }
    },
    padVolume: {
        label: {
            ca: "Vol"
        },
        title: {
            ca: "Volum del pad"
        },
        description: {
            ca: "Aquesta rodeta modifica el volum del pad seleccionat, o de tots si GROUP esta\u0300 activat."
        }
    },
    padPan: {
        label: {
            ca: "Pan"
        },
        title: {
            ca: "Panoramitzaci\xf3 del pad"
        },
        description: {
            ca: "Aquesta rodeta modifica la panoramitzaci\xf3 del pad seleccionat (o de tots si GROUP esta\u0300 activat). Fa que el so es senti m\xe9s per l'esquerra o la dreta."
        }
    },
    padReverse: {
        label: {
            ca: "Reverse"
        },
        title: {
            ca: "Reverse del pad"
        },
        description: {
            ca: "Si esta\u0300 activat, el sample \xe9s reprodueixi del final a l'inici, a l'inrev\xe9s."
        }
    },
    padAttack: {
        label: {
            ca: "Attack"
        },
        title: {
            ca: "Attack"
        },
        description: {
            ca: "El par\xe0metre attack modifica com comen\xe7a a reproduir-se la mostra. Pot comen\xe7ar m\xe9s bruscament o m\xe9s suau, depenent d'on col\xb7loquis l'angle del potenci\xf2metre."
        }
    },
    padRelease: {
        label: {
            ca: "Release"
        },
        title: {
            ca: "Release"
        },
        description: {
            ca: "El release \xe9s el temps que tarda el so a desapar\xe8ixer quan deixes anar la tecla. Pot fer que el so s'acabi de cop o s'esvaeixi suaument."
        }
    },
    padSlicer: {
        title: {
            ca: "Barra de tall"
        },
        description: {
            ca: "Marca els extrems del tall de la mostra del pad"
        }
    },
    padWaveformDisplay: {
        title: {
            ca: "Mostra"
        },
        description: {
            ca: "Aqu\xed tens una representaci\xf3 gr\xe0fica de la mostra de so carregada al sampler. En el dibuix pots veure representades les diferents intensitats del so."
        }
    },
    padGrid: {
        title: {
            ca: "Pads"
        },
        description: {
            ca: "Cada pad reprodueix un fragment de la mostra carregada en el sampler."
        }
    },
    padsGroupToggle: {
        label: {
            ca: "GROUP"
        },
        title: {
            ca: "Group"
        },
        description: {
            ca: "Activant aquest bot\xf3 fas que els par\xe0metres que modifiques (Pan, Vol o Pitch) afectin a tots els pads. Desactivat, les modificacions afecten solament al pad seleccionat."
        }
    },
    // ELEMENTS ESPECÍFICS, LOOPER
    looperTranspose: {
        label: {
            ca: "Transpose"
        }
    },
    looperSpeed: {
        label: {
            ca: "Speed"
        }
    },
    looperReverse: {
        label: {
            ca: "Reverse"
        }
    },
    // EFECTES
    fxWet: {
        label: {
            ca: "Wet"
        }
    },
    fxDistortionAmount: {
        label: {
            ca: "Drive"
        }
    },
    delayTime: {
        label: {
            ca: "Time"
        }
    },
    delayFeedback: {
        label: {
            ca: "Feedback"
        }
    },
    reverbDecay: {
        label: {
            ca: "Decay"
        }
    },
    djfValue: {
        label: {
            ca: "Value"
        }
    },
    djfQ: {
        label: {
            ca: "Q"
        }
    }
};

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});



parcelRegister("29BVo", function(module, exports) {

$parcel$export(module.exports, "DelayReturn", () => $1919d71799a89cac$export$468f123211445490);
parcelRequire("56MRX");
var $gtyBS = parcelRequire("gtyBS");
var $fDBOr = parcelRequire("fDBOr");

var $hysHW = parcelRequire("hysHW");

var $Lbl7Y = parcelRequire("Lbl7Y");
class $1919d71799a89cac$export$468f123211445490 extends (0, $fDBOr.ToneAudioNode) {
    static parametersDescription = {
        ...(0, $hysHW.GrufBus).parametersDescription,
        wet: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 1
        },
        time: {
            type: 'enum',
            options: [
                '1/4',
                '1/4T',
                '1/8',
                '1/8T',
                '1/16',
                '1/16T'
            ],
            initial: '1/4'
        },
        feedback: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 0.5
        }
    };
    constructor(){
        super();
        this.delay = new (0, $gtyBS.FeedbackDelay)();
        this.bus = new (0, $hysHW.GrufBus)();
        this.delay.connect(this.bus);
        this.input = this.delay;
        this.output = this.bus;
    }
    dispose() {
        this.delay.dispose();
        this.bus.dispose();
    }
    set gain(value) {
        this.bus.gain = value;
    }
    set wet(value) {
        this.delay.wet.value = value;
    }
    set feedback(value) {
        this.delay.feedback.value = value;
    }
    set time(value) {
        this.delay.delayTime.value = this.getDelayTimeValue(value);
    }
    getDelayTimeValue(delayTime) {
        const fraction = delayTime.replace("T", "");
        const isTriplet = delayTime.endsWith("T");
        let multiplier = {
            '1/4': 1,
            '1/8': 2,
            '1/16': 4
        }[fraction];
        if (isTriplet) multiplier *= 1.5;
        return 60 / (multiplier * (0, $Lbl7Y.getAudioGraphInstance)().getBpm());
    }
    getCurrentLevel() {
        return Math.max(...this.bus.getCurrentLevels());
    }
}

});

parcelRegister("duZNX", function(module, exports) {

$parcel$export(module.exports, "ReverbReturn", () => $9d3e04d875c522d7$export$2bf270056767d131);

var $hysHW = parcelRequire("hysHW");
parcelRequire("56MRX");
var $7FIGc = parcelRequire("7FIGc");
var $fDBOr = parcelRequire("fDBOr");
class $9d3e04d875c522d7$export$2bf270056767d131 extends (0, $fDBOr.ToneAudioNode) {
    static parametersDescription = {
        ...(0, $hysHW.GrufBus).parametersDescription,
        wet: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 1
        },
        decay: {
            type: 'enum',
            options: [
                '1.0',
                '5.0',
                '12.0'
            ],
            initial: '1.0'
        }
    };
    constructor(){
        super();
        this.reverb = new (0, $7FIGc.Reverb)();
        this.bus = new (0, $hysHW.GrufBus)();
        this.reverb.connect(this.bus);
        this.input = this.reverb;
        this.output = this.bus;
    }
    dispose() {
        this.reverb.dispose();
        this.bus.dispose();
    }
    set gain(value) {
        this.bus.gain = value;
    }
    set wet(value) {
        this.reverb.wet.value = value;
    }
    set decay(value) {
        this.reverb.decay = value;
    }
    getCurrentLevel() {
        return Math.max(...this.bus.getCurrentLevels());
    }
}

});

parcelRegister("5vTj9", function(module, exports) {
module.exports = JSON.parse("{\"SCENE_DURATION\":2}");

});

parcelRegister("eng2W", function(module, exports) {

$parcel$export(module.exports, "factoryPresets", () => $a76fa92e66c57748$export$85a8050d463eb2b6);

var $6uI3p = parcelRequire("6uI3p");
const $a76fa92e66c57748$export$85a8050d463eb2b6 = Object.entries($6uI3p).map(([name, preset])=>({
        ...preset,
        _metadata: {
            ...preset._metadata,
            name: name,
            isFactory: true
        }
    }));

});
parcelRegister("6uI3p", function(module, exports) {

var $7Yz0U = parcelRequire("7Yz0U");

var $e33I9 = parcelRequire("e33I9");

var $6MCYy = parcelRequire("6MCYy");

var $1WBH7 = parcelRequire("1WBH7");

var $10g2A = parcelRequire("10g2A");

var $9fnes = parcelRequire("9fnes");

var $jMYpA = parcelRequire("jMYpA");

var $dbI00 = parcelRequire("dbI00");

var $gJZUS = parcelRequire("gJZUS");

var $iBZ5k = parcelRequire("iBZ5k");

var $hNUBS = parcelRequire("hNUBS");

var $jf32a = parcelRequire("jf32a");

var $f6LMN = parcelRequire("f6LMN");

var $9Ffnm = parcelRequire("9Ffnm");
module.exports = {
    "Acid House": $7Yz0U,
    "Dub Reggae": $e33I9,
    "Funky Soul": $6MCYy,
    "Hip Hop Classic 1": $1WBH7,
    "Hip Hop Classic 2": $10g2A,
    "Pop corn": $9fnes,
    "Power bass": $jMYpA,
    "Reggae Roots": $dbI00,
    "Slow pad": $gJZUS,
    "Soul Pop": $iBZ5k,
    "Taurus": $hNUBS,
    "Trap 1": $jf32a,
    "Trap 2": $f6LMN,
    "Urban Reggaeton": $9Ffnm
};

});
parcelRegister("7Yz0U", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Acid House\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Acid House\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Acid House\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Acid House\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("e33I9", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Dub Reggae\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Dub Reggae\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Dub Reggae\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Dub Reggae\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("6MCYy", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Funky Soul\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Funky Soul\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Funky Soul\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Funky Soul\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("1WBH7", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Hip Hop Classic 1\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Hip Hop Classic 1\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Hip Hop Classic 1\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Hip Hop Classic 1\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("10g2A", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Hip Hop Classic 2\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Hip Hop Classic 2\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Hip Hop Classic 2\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Hip Hop Classic 2\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("9fnes", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"env_attack\":0,\"env_decay\":0.4100000000000009,\"env_sustain\":0,\"env_release\":2,\"osc_waveform\":\"triangle\",\"lpf_cutoff\":1744.9503338234701,\"lpf_q\":0.7,\"lfo_rate\":16.655622400000006,\"lfo_depth\":641.9999999999994,\"osc_octave\":1,\"fx_distortion_amount\":1.800000000000001,\"_metadata\":{\"instrumentType\":\"synth_wam\"}}");

});

parcelRegister("jMYpA", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":true,\"fx_EQ_low\":6.912000000000013,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"env_attack\":0.01,\"env_decay\":0.045,\"env_sustain\":0.469,\"env_release\":0.6,\"osc_waveform\":\"square\",\"lpf_cutoff\":12187.518045314411,\"lpf_q\":0.7,\"lfo_rate\":0.3,\"lfo_depth\":0,\"osc_octave\":0,\"fx_distortion_amount\":0,\"osc_portamento\":0,\"osc_detune\":0.8,\"_metadata\":{\"instrumentType\":\"synth_bass_wam\"}}");

});

parcelRegister("dbI00", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Reggae Roots\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Reggae Roots\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Reggae Roots\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Reggae Roots\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("gJZUS", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"env_attack\":1.964,\"env_decay\":1.1300000000000008,\"env_sustain\":0.8,\"env_release\":2,\"osc_waveform\":\"sawtooth\",\"lpf_cutoff\":1744.9503338234701,\"lpf_q\":0.7,\"lfo_rate\":1.0135939871692217,\"lfo_depth\":209.9999999999996,\"osc_octave\":0,\"fx_distortion_amount\":1.800000000000001,\"_metadata\":{\"instrumentType\":\"synth_wam\"}}");

});

parcelRegister("iBZ5k", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Soul Pop\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Soul Pop\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Soul Pop\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Soul Pop\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("hNUBS", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":true,\"fx_EQ_low\":3.887999999999998,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"env_attack\":0.01,\"env_decay\":0.9550000000000001,\"env_sustain\":0.01,\"env_release\":0.6,\"osc_waveform\":\"sawtooth\",\"lpf_cutoff\":3500,\"lpf_q\":0.7,\"lfo_rate\":0.3,\"lfo_depth\":0,\"osc_octave\":0,\"fx_distortion_amount\":0,\"osc_portamento\":0.07739018177180197,\"osc_detune\":0.8,\"_metadata\":{\"instrumentType\":\"synth_bass_wam\"}}");

});

parcelRegister("jf32a", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Trap 1\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Trap 1\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Trap 1\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Trap 1\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("f6LMN", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Trap 2\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Trap 2\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Trap 2\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Trap 2\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("9Ffnm", function(module, exports) {
module.exports = JSON.parse("{\"gain\":1,\"pan\":0,\"fx_EQ_isActive\":false,\"fx_EQ_low\":0,\"fx_EQ_mid\":0,\"fx_EQ_high\":0,\"send_reverbA\":-60,\"send_reverbB\":-60,\"send_delayA\":-60,\"send_delayB\":-60,\"lpf_cutoff\":20000,\"openHat_swing\":0,\"openHat_tone\":0,\"openHat_volume\":-3,\"openHat_release\":1,\"openHat_reverbSend\":-30,\"openHat_drumkit\":\"Urban Reggaeton\",\"closedHat_swing\":0,\"closedHat_tone\":0,\"closedHat_volume\":-3,\"closedHat_release\":1,\"closedHat_reverbSend\":-30,\"closedHat_drumkit\":\"Urban Reggaeton\",\"snare_swing\":0,\"snare_tone\":0,\"snare_volume\":-3,\"snare_release\":1,\"snare_reverbSend\":-30,\"snare_drumkit\":\"Urban Reggaeton\",\"kick_swing\":0,\"kick_tone\":0,\"kick_volume\":-3,\"kick_release\":1,\"kick_reverbSend\":-30,\"kick_drumkit\":\"Urban Reggaeton\",\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});





parcelRegister("1qR2T", function(module, exports) {

$parcel$export(module.exports, "initializeWamHost", () => $10b15ded35359857$export$f0d840867f44d741);
// src/WebAudioModule.js
var $10b15ded35359857$var$WebAudioModule = class {
    static get isWebAudioModuleConstructor() {
        return true;
    }
    static createInstance(groupId, audioContext, initialState) {
        return new this(groupId, audioContext).initialize(initialState);
    }
    constructor(groupId, audioContext){
        this._groupId = groupId;
        this._audioContext = audioContext;
        this._initialized = false;
        this._audioNode = void 0;
        this._timestamp = performance.now();
        this._guiModuleUrl = void 0;
        this._descriptorUrl = "./descriptor.json";
        this._descriptor = {
            identifier: `com.webaudiomodule.default`,
            name: `WebAudioModule_${this.constructor.name}`,
            vendor: "WebAudioModuleVendor",
            description: "",
            version: "0.0.0",
            apiVersion: "2.0.0",
            thumbnail: "",
            keywords: [],
            isInstrument: false,
            website: "",
            hasAudioInput: true,
            hasAudioOutput: true,
            hasAutomationInput: true,
            hasAutomationOutput: true,
            hasMidiInput: true,
            hasMidiOutput: true,
            hasMpeInput: true,
            hasMpeOutput: true,
            hasOscInput: true,
            hasOscOutput: true,
            hasSysexInput: true,
            hasSysexOutput: true
        };
    }
    get isWebAudioModule() {
        return true;
    }
    get groupId() {
        return this._groupId;
    }
    get moduleId() {
        return this.descriptor.identifier;
    }
    get instanceId() {
        return this.moduleId + this._timestamp;
    }
    get descriptor() {
        return this._descriptor;
    }
    get identifier() {
        return this.descriptor.identifier;
    }
    get name() {
        return this.descriptor.name;
    }
    get vendor() {
        return this.descriptor.vendor;
    }
    get audioContext() {
        return this._audioContext;
    }
    get audioNode() {
        if (!this.initialized) console.warn("WAM should be initialized before getting the audioNode");
        return this._audioNode;
    }
    set audioNode(node) {
        this._audioNode = node;
    }
    get initialized() {
        return this._initialized;
    }
    set initialized(value) {
        this._initialized = value;
    }
    async createAudioNode(initialState) {
        throw new TypeError("createAudioNode() not provided");
    }
    async initialize(state) {
        if (!this._audioNode) this.audioNode = await this.createAudioNode();
        this.initialized = true;
        return this;
    }
    async _loadGui() {
        const url = this._guiModuleUrl;
        if (!url) throw new TypeError("Gui module not found");
        return import(/* webpackIgnore: true */ url);
    }
    async _loadDescriptor() {
        const url = this._descriptorUrl;
        if (!url) throw new TypeError("Descriptor not found");
        const response = await fetch(url);
        const descriptor = await response.json();
        Object.assign(this._descriptor, descriptor);
        return this._descriptor;
    }
    async createGui() {
        if (!this.initialized) console.warn("Plugin should be initialized before getting the gui");
        if (!this._guiModuleUrl) return void 0;
        const { createElement: createElement } = await this._loadGui();
        return createElement(this);
    }
    destroyGui() {}
};
var $10b15ded35359857$export$9888a11b976a68a = $10b15ded35359857$var$WebAudioModule;
// src/RingBuffer.js
var $10b15ded35359857$var$getRingBuffer = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    class RingBuffer2 {
        static getStorageForCapacity(capacity, Type) {
            if (!Type.BYTES_PER_ELEMENT) throw new Error("Pass in a ArrayBuffer subclass");
            const bytes = 8 + (capacity + 1) * Type.BYTES_PER_ELEMENT;
            return new SharedArrayBuffer(bytes);
        }
        constructor(sab, Type){
            if (!Type.BYTES_PER_ELEMENT) throw new Error("Pass a concrete typed array class as second argument");
            this._Type = Type;
            this._capacity = (sab.byteLength - 8) / Type.BYTES_PER_ELEMENT;
            this.buf = sab;
            this.write_ptr = new Uint32Array(this.buf, 0, 1);
            this.read_ptr = new Uint32Array(this.buf, 4, 1);
            this.storage = new Type(this.buf, 8, this._capacity);
        }
        get type() {
            return this._Type.name;
        }
        push(elements) {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            if ((wr + 1) % this._storageCapacity() === rd) return 0;
            const toWrite = Math.min(this._availableWrite(rd, wr), elements.length);
            const firstPart = Math.min(this._storageCapacity() - wr, toWrite);
            const secondPart = toWrite - firstPart;
            this._copy(elements, 0, this.storage, wr, firstPart);
            this._copy(elements, firstPart, this.storage, 0, secondPart);
            Atomics.store(this.write_ptr, 0, (wr + toWrite) % this._storageCapacity());
            return toWrite;
        }
        pop(elements) {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            if (wr === rd) return 0;
            const isArray = !Number.isInteger(elements);
            const toRead = Math.min(this._availableRead(rd, wr), isArray ? elements.length : elements);
            if (isArray) {
                const firstPart = Math.min(this._storageCapacity() - rd, toRead);
                const secondPart = toRead - firstPart;
                this._copy(this.storage, rd, elements, 0, firstPart);
                this._copy(this.storage, 0, elements, firstPart, secondPart);
            }
            Atomics.store(this.read_ptr, 0, (rd + toRead) % this._storageCapacity());
            return toRead;
        }
        get empty() {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            return wr === rd;
        }
        get full() {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            return (wr + 1) % this._capacity !== rd;
        }
        get capacity() {
            return this._capacity - 1;
        }
        get availableRead() {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            return this._availableRead(rd, wr);
        }
        get availableWrite() {
            const rd = Atomics.load(this.read_ptr, 0);
            const wr = Atomics.load(this.write_ptr, 0);
            return this._availableWrite(rd, wr);
        }
        _availableRead(rd, wr) {
            if (wr > rd) return wr - rd;
            return wr + this._storageCapacity() - rd;
        }
        _availableWrite(rd, wr) {
            let rv = rd - wr - 1;
            if (wr >= rd) rv += this._storageCapacity();
            return rv;
        }
        _storageCapacity() {
            return this._capacity;
        }
        _copy(input, offsetInput, output, offsetOutput, size) {
            for(let i = 0; i < size; i++)output[offsetOutput + i] = input[offsetInput + i];
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.RingBuffer) ModuleScope.RingBuffer = RingBuffer2;
    }
    return RingBuffer2;
};
var $10b15ded35359857$export$e8c2e0ed6c094464 = $10b15ded35359857$var$getRingBuffer;
// src/WamArrayRingBuffer.js
var $10b15ded35359857$var$getWamArrayRingBuffer = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    class WamArrayRingBuffer {
        static DefaultArrayCapacity = 2;
        static getStorageForEventCapacity(RingBuffer2, arrayLength, arrayType, maxArrayCapacity) {
            if (maxArrayCapacity === void 0) maxArrayCapacity = WamArrayRingBuffer.DefaultArrayCapacity;
            else maxArrayCapacity = Math.max(maxArrayCapacity, WamArrayRingBuffer.DefaultArrayCapacity);
            if (!arrayType.BYTES_PER_ELEMENT) throw new Error("Pass in a ArrayBuffer subclass");
            const capacity = arrayLength * maxArrayCapacity;
            return RingBuffer2.getStorageForCapacity(capacity, arrayType);
        }
        constructor(RingBuffer2, sab, arrayLength, arrayType, maxArrayCapacity){
            if (!arrayType.BYTES_PER_ELEMENT) throw new Error("Pass in a ArrayBuffer subclass");
            this._arrayLength = arrayLength;
            this._arrayType = arrayType;
            this._arrayElementSizeBytes = arrayType.BYTES_PER_ELEMENT;
            this._arraySizeBytes = this._arrayLength * this._arrayElementSizeBytes;
            this._sab = sab;
            if (maxArrayCapacity === void 0) maxArrayCapacity = WamArrayRingBuffer.DefaultArrayCapacity;
            else maxArrayCapacity = Math.max(maxArrayCapacity, WamArrayRingBuffer.DefaultArrayCapacity);
            this._arrayArray = new arrayType(this._arrayLength);
            this._rb = new RingBuffer2(this._sab, arrayType);
        }
        write(array) {
            if (array.length !== this._arrayLength) return false;
            const elementsAvailable = this._rb.availableWrite;
            if (elementsAvailable < this._arrayLength) return false;
            let success = true;
            const elementsWritten = this._rb.push(array);
            if (elementsWritten != this._arrayLength) success = false;
            return success;
        }
        read(array, newest) {
            if (array.length !== this._arrayLength) return false;
            const elementsAvailable = this._rb.availableRead;
            if (elementsAvailable < this._arrayLength) return false;
            if (newest && elementsAvailable > this._arrayLength) this._rb.pop(elementsAvailable - this._arrayLength);
            let success = false;
            const elementsRead = this._rb.pop(array);
            if (elementsRead === this._arrayLength) success = true;
            return success;
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.WamArrayRingBuffer) ModuleScope.WamArrayRingBuffer = WamArrayRingBuffer;
    }
    return WamArrayRingBuffer;
};
var $10b15ded35359857$export$fd69883a3e8bc237 = $10b15ded35359857$var$getWamArrayRingBuffer;
// src/WamEnv.js
var $10b15ded35359857$var$initializeWamEnv = (apiVersion)=>{
    const audioWorkletGlobalScope = globalThis;
    if (audioWorkletGlobalScope.AudioWorkletProcessor && audioWorkletGlobalScope.webAudioModules) return;
    const moduleScopes = /* @__PURE__ */ new Map();
    const groups = /* @__PURE__ */ new Map();
    class WamEnv {
        constructor(){}
        get apiVersion() {
            return apiVersion;
        }
        getModuleScope(moduleId) {
            if (!moduleScopes.has(moduleId)) moduleScopes.set(moduleId, {});
            return moduleScopes.get(moduleId);
        }
        getGroup(groupId, groupKey) {
            const group = groups.get(groupId);
            if (group.validate(groupKey)) return group;
            else throw "Invalid key";
        }
        addGroup(group) {
            if (!groups.has(group.groupId)) groups.set(group.groupId, group);
        }
        removeGroup(group) {
            groups.delete(group.groupId);
        }
        addWam(wam) {
            const group = groups.get(wam.groupId);
            group.addWam(wam);
        }
        removeWam(wam) {
            const group = groups.get(wam.groupId);
            group.removeWam(wam);
        }
        connectEvents(groupId, fromId, toId, output = 0) {
            const group = groups.get(groupId);
            group.connectEvents(fromId, toId, output);
        }
        disconnectEvents(groupId, fromId, toId, output) {
            const group = groups.get(groupId);
            group.disconnectEvents(fromId, toId, output);
        }
        emitEvents(from, ...events) {
            const group = groups.get(from.groupId);
            group.emitEvents(from, ...events);
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        if (!audioWorkletGlobalScope.webAudioModules) audioWorkletGlobalScope.webAudioModules = new WamEnv();
    }
};
var $10b15ded35359857$export$6fa0848cc153f5f6 = $10b15ded35359857$var$initializeWamEnv;
// src/WamGroup.js
var $10b15ded35359857$var$initializeWamGroup = (groupId, groupKey)=>{
    const audioWorkletGlobalScope = globalThis;
    class WamGroup {
        constructor(groupId2, groupKey2){
            this._groupId = groupId2;
            this._validate = (key)=>{
                return key == groupKey2;
            };
            this._processors = /* @__PURE__ */ new Map();
            this._eventGraph = /* @__PURE__ */ new Map();
        }
        get groupId() {
            return this._groupId;
        }
        get processors() {
            return this._processors;
        }
        get eventGraph() {
            return this._eventGraph;
        }
        validate(groupKey2) {
            return this._validate(groupKey2);
        }
        addWam(wam) {
            this._processors.set(wam.instanceId, wam);
        }
        removeWam(wam) {
            if (this._eventGraph.has(wam)) this._eventGraph.delete(wam);
            this._eventGraph.forEach((outputMap)=>{
                outputMap.forEach((set)=>{
                    if (set && set.has(wam)) set.delete(wam);
                });
            });
            this._processors.delete(wam.instanceId);
        }
        connectEvents(fromId, toId, output) {
            const from = this._processors.get(fromId);
            const to = this._processors.get(toId);
            let outputMap;
            if (this._eventGraph.has(from)) outputMap = this._eventGraph.get(from);
            else {
                outputMap = [];
                this._eventGraph.set(from, outputMap);
            }
            if (outputMap[output]) outputMap[output].add(to);
            else {
                const set = /* @__PURE__ */ new Set();
                set.add(to);
                outputMap[output] = set;
            }
        }
        disconnectEvents(fromId, toId, output) {
            const from = this._processors.get(fromId);
            if (!this._eventGraph.has(from)) return;
            const outputMap = this._eventGraph.get(from);
            if (typeof toId === "undefined") {
                outputMap.forEach((set)=>{
                    if (set) set.clear();
                });
                return;
            }
            const to = this._processors.get(toId);
            if (typeof output === "undefined") {
                outputMap.forEach((set)=>{
                    if (set) set.delete(to);
                });
                return;
            }
            if (!outputMap[output]) return;
            outputMap[output].delete(to);
        }
        emitEvents(from, ...events) {
            if (!this._eventGraph.has(from)) return;
            const downstream = this._eventGraph.get(from);
            downstream.forEach((set)=>{
                if (set) set.forEach((wam)=>wam.scheduleEvents(...events));
            });
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) audioWorkletGlobalScope.webAudioModules.addGroup(new WamGroup(groupId, groupKey));
};
var $10b15ded35359857$export$ba6a03b2a7772bf2 = $10b15ded35359857$var$initializeWamGroup;
// src/WamEventRingBuffer.js
var $10b15ded35359857$var$getWamEventRingBuffer = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    class WamEventRingBuffer2 {
        static DefaultExtraBytesPerEvent = 64;
        static WamEventBaseBytes = 13;
        static WamAutomationEventBytes = WamEventRingBuffer2.WamEventBaseBytes + 2 + 8 + 1;
        static WamTransportEventBytes = WamEventRingBuffer2.WamEventBaseBytes + 4 + 8 + 8 + 1 + 1 + 1;
        static WamMidiEventBytes = WamEventRingBuffer2.WamEventBaseBytes + 1 + 1 + 1;
        static WamBinaryEventBytes = WamEventRingBuffer2.WamEventBaseBytes + 4;
        static getStorageForEventCapacity(RingBuffer2, eventCapacity, maxBytesPerEvent) {
            if (maxBytesPerEvent === void 0) maxBytesPerEvent = WamEventRingBuffer2.DefaultExtraBytesPerEvent;
            else maxBytesPerEvent = Math.max(maxBytesPerEvent, WamEventRingBuffer2.DefaultExtraBytesPerEvent);
            const capacity = (Math.max(WamEventRingBuffer2.WamAutomationEventBytes, WamEventRingBuffer2.WamTransportEventBytes, WamEventRingBuffer2.WamMidiEventBytes, WamEventRingBuffer2.WamBinaryEventBytes) + maxBytesPerEvent) * eventCapacity;
            return RingBuffer2.getStorageForCapacity(capacity, Uint8Array);
        }
        constructor(RingBuffer2, sab, parameterIds, maxBytesPerEvent){
            this._eventSizeBytes = {};
            this._encodeEventType = {};
            this._decodeEventType = {};
            const wamEventTypes = [
                "wam-automation",
                "wam-transport",
                "wam-midi",
                "wam-sysex",
                "wam-mpe",
                "wam-osc",
                "wam-info"
            ];
            wamEventTypes.forEach((type, encodedType)=>{
                let byteSize = 0;
                switch(type){
                    case "wam-automation":
                        byteSize = WamEventRingBuffer2.WamAutomationEventBytes;
                        break;
                    case "wam-transport":
                        byteSize = WamEventRingBuffer2.WamTransportEventBytes;
                        break;
                    case "wam-mpe":
                    case "wam-midi":
                        byteSize = WamEventRingBuffer2.WamMidiEventBytes;
                        break;
                    case "wam-osc":
                    case "wam-sysex":
                    case "wam-info":
                        byteSize = WamEventRingBuffer2.WamBinaryEventBytes;
                        break;
                    default:
                        break;
                }
                this._eventSizeBytes[type] = byteSize;
                this._encodeEventType[type] = encodedType;
                this._decodeEventType[encodedType] = type;
            });
            this._parameterCode = 0;
            this._parameterCodes = {};
            this._encodeParameterId = {};
            this._decodeParameterId = {};
            this.setParameterIds(parameterIds);
            this._sab = sab;
            if (maxBytesPerEvent === void 0) maxBytesPerEvent = WamEventRingBuffer2.DefaultExtraBytesPerEvent;
            else maxBytesPerEvent = Math.max(maxBytesPerEvent, WamEventRingBuffer2.DefaultExtraBytesPerEvent);
            this._eventBytesAvailable = Math.max(WamEventRingBuffer2.WamAutomationEventBytes, WamEventRingBuffer2.WamTransportEventBytes, WamEventRingBuffer2.WamMidiEventBytes, WamEventRingBuffer2.WamBinaryEventBytes) + maxBytesPerEvent;
            this._eventBytes = new ArrayBuffer(this._eventBytesAvailable);
            this._eventBytesView = new DataView(this._eventBytes);
            this._rb = new RingBuffer2(this._sab, Uint8Array);
            this._eventSizeArray = new Uint8Array(this._eventBytes, 0, 4);
            this._eventSizeView = new DataView(this._eventBytes, 0, 4);
        }
        _writeHeader(byteSize, type, time) {
            let byteOffset = 0;
            this._eventBytesView.setUint32(byteOffset, byteSize);
            byteOffset += 4;
            this._eventBytesView.setUint8(byteOffset, this._encodeEventType[type]);
            byteOffset += 1;
            this._eventBytesView.setFloat64(byteOffset, Number.isFinite(time) ? time : -1);
            byteOffset += 8;
            return byteOffset;
        }
        _encode(event) {
            let byteOffset = 0;
            const { type: type, time: time } = event;
            switch(event.type){
                case "wam-automation":
                    {
                        if (!(event.data.id in this._encodeParameterId)) break;
                        const byteSize = this._eventSizeBytes[type];
                        byteOffset = this._writeHeader(byteSize, type, time);
                        const { data: data } = event;
                        const encodedParameterId = this._encodeParameterId[data.id];
                        const { value: value, normalized: normalized } = data;
                        this._eventBytesView.setUint16(byteOffset, encodedParameterId);
                        byteOffset += 2;
                        this._eventBytesView.setFloat64(byteOffset, value);
                        byteOffset += 8;
                        this._eventBytesView.setUint8(byteOffset, normalized ? 1 : 0);
                        byteOffset += 1;
                    }
                    break;
                case "wam-transport":
                    {
                        const byteSize = this._eventSizeBytes[type];
                        byteOffset = this._writeHeader(byteSize, type, time);
                        const { data: data } = event;
                        const { currentBar: currentBar, currentBarStarted: currentBarStarted, tempo: tempo, timeSigNumerator: timeSigNumerator, timeSigDenominator: timeSigDenominator, playing: playing } = data;
                        this._eventBytesView.setUint32(byteOffset, currentBar);
                        byteOffset += 4;
                        this._eventBytesView.setFloat64(byteOffset, currentBarStarted);
                        byteOffset += 8;
                        this._eventBytesView.setFloat64(byteOffset, tempo);
                        byteOffset += 8;
                        this._eventBytesView.setUint8(byteOffset, timeSigNumerator);
                        byteOffset += 1;
                        this._eventBytesView.setUint8(byteOffset, timeSigDenominator);
                        byteOffset += 1;
                        this._eventBytesView.setUint8(byteOffset, playing ? 1 : 0);
                        byteOffset += 1;
                    }
                    break;
                case "wam-mpe":
                case "wam-midi":
                    {
                        const byteSize = this._eventSizeBytes[type];
                        byteOffset = this._writeHeader(byteSize, type, time);
                        const { data: data } = event;
                        const { bytes: bytes } = data;
                        let b = 0;
                        while(b < 3){
                            this._eventBytesView.setUint8(byteOffset, bytes[b]);
                            byteOffset += 1;
                            b++;
                        }
                    }
                    break;
                case "wam-osc":
                case "wam-sysex":
                case "wam-info":
                    {
                        let bytes = null;
                        if (event.type === "wam-info") {
                            const { data: data } = event;
                            bytes = new TextEncoder().encode(data.instanceId);
                        } else {
                            const { data: data } = event;
                            bytes = data.bytes;
                        }
                        const numBytes = bytes.length;
                        const byteSize = this._eventSizeBytes[type];
                        byteOffset = this._writeHeader(byteSize + numBytes, type, time);
                        this._eventBytesView.setUint32(byteOffset, numBytes);
                        byteOffset += 4;
                        const bytesRequired = byteOffset + numBytes;
                        if (bytesRequired > this._eventBytesAvailable) console.error(`Event requires ${bytesRequired} bytes but only ${this._eventBytesAvailable} have been allocated!`);
                        const buffer = new Uint8Array(this._eventBytes, byteOffset, numBytes);
                        buffer.set(bytes);
                        byteOffset += numBytes;
                    }
                    break;
                default:
                    break;
            }
            return new Uint8Array(this._eventBytes, 0, byteOffset);
        }
        _decode() {
            let byteOffset = 0;
            const type = this._decodeEventType[this._eventBytesView.getUint8(byteOffset)];
            byteOffset += 1;
            let time = this._eventBytesView.getFloat64(byteOffset);
            if (time === -1) time = void 0;
            byteOffset += 8;
            switch(type){
                case "wam-automation":
                    {
                        const encodedParameterId = this._eventBytesView.getUint16(byteOffset);
                        byteOffset += 2;
                        const value = this._eventBytesView.getFloat64(byteOffset);
                        byteOffset += 8;
                        const normalized = !!this._eventBytesView.getUint8(byteOffset);
                        byteOffset += 1;
                        if (!(encodedParameterId in this._decodeParameterId)) break;
                        const id = this._decodeParameterId[encodedParameterId];
                        const event = {
                            type: type,
                            time: time,
                            data: {
                                id: id,
                                value: value,
                                normalized: normalized
                            }
                        };
                        return event;
                    }
                case "wam-transport":
                    {
                        const currentBar = this._eventBytesView.getUint32(byteOffset);
                        byteOffset += 4;
                        const currentBarStarted = this._eventBytesView.getFloat64(byteOffset);
                        byteOffset += 8;
                        const tempo = this._eventBytesView.getFloat64(byteOffset);
                        byteOffset += 8;
                        const timeSigNumerator = this._eventBytesView.getUint8(byteOffset);
                        byteOffset += 1;
                        const timeSigDenominator = this._eventBytesView.getUint8(byteOffset);
                        byteOffset += 1;
                        const playing = this._eventBytesView.getUint8(byteOffset) == 1;
                        byteOffset += 1;
                        const event = {
                            type: type,
                            time: time,
                            data: {
                                currentBar: currentBar,
                                currentBarStarted: currentBarStarted,
                                tempo: tempo,
                                timeSigNumerator: timeSigNumerator,
                                timeSigDenominator: timeSigDenominator,
                                playing: playing
                            }
                        };
                        return event;
                    }
                case "wam-mpe":
                case "wam-midi":
                    {
                        const bytes = [
                            0,
                            0,
                            0
                        ];
                        let b = 0;
                        while(b < 3){
                            bytes[b] = this._eventBytesView.getUint8(byteOffset);
                            byteOffset += 1;
                            b++;
                        }
                        const event = {
                            type: type,
                            time: time,
                            data: {
                                bytes: bytes
                            }
                        };
                        return event;
                    }
                case "wam-osc":
                case "wam-sysex":
                case "wam-info":
                    {
                        const numBytes = this._eventBytesView.getUint32(byteOffset);
                        byteOffset += 4;
                        const bytes = new Uint8Array(numBytes);
                        bytes.set(new Uint8Array(this._eventBytes, byteOffset, numBytes));
                        byteOffset += numBytes;
                        if (type === "wam-info") {
                            const instanceId = new TextDecoder().decode(bytes);
                            const data = {
                                instanceId: instanceId
                            };
                            return {
                                type: type,
                                time: time,
                                data: data
                            };
                        } else {
                            const data = {
                                bytes: bytes
                            };
                            return {
                                type: type,
                                time: time,
                                data: data
                            };
                        }
                    }
                default:
                    break;
            }
            return false;
        }
        write(...events) {
            const numEvents = events.length;
            let bytesAvailable = this._rb.availableWrite;
            let numSkipped = 0;
            let i = 0;
            while(i < numEvents){
                const event = events[i];
                const bytes = this._encode(event);
                const eventSizeBytes = bytes.byteLength;
                let bytesWritten = 0;
                if (bytesAvailable >= eventSizeBytes) {
                    if (eventSizeBytes === 0) numSkipped++;
                    else bytesWritten = this._rb.push(bytes);
                } else break;
                bytesAvailable -= bytesWritten;
                i++;
            }
            return i - numSkipped;
        }
        read() {
            if (this._rb.empty) return [];
            const events = [];
            let bytesAvailable = this._rb.availableRead;
            let bytesRead = 0;
            while(bytesAvailable > 0){
                bytesRead = this._rb.pop(this._eventSizeArray);
                bytesAvailable -= bytesRead;
                const eventSizeBytes = this._eventSizeView.getUint32(0);
                const eventBytes = new Uint8Array(this._eventBytes, 0, eventSizeBytes - 4);
                bytesRead = this._rb.pop(eventBytes);
                bytesAvailable -= bytesRead;
                const decodedEvent = this._decode();
                if (decodedEvent) events.push(decodedEvent);
            }
            return events;
        }
        setParameterIds(parameterIds) {
            this._encodeParameterId = {};
            this._decodeParameterId = {};
            parameterIds.forEach((parameterId)=>{
                let parameterCode = -1;
                if (parameterId in this._parameterCodes) parameterCode = this._parameterCodes[parameterId];
                else {
                    parameterCode = this._generateParameterCode();
                    this._parameterCodes[parameterId] = parameterCode;
                }
                this._encodeParameterId[parameterId] = parameterCode;
                this._decodeParameterId[parameterCode] = parameterId;
            });
        }
        _generateParameterCode() {
            if (this._parameterCode > 65535) throw Error("Too many parameters have been registered!");
            return this._parameterCode++;
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.WamEventRingBuffer) ModuleScope.WamEventRingBuffer = WamEventRingBuffer2;
    }
    return WamEventRingBuffer2;
};
var $10b15ded35359857$export$aa96e9388daf1fd3 = $10b15ded35359857$var$getWamEventRingBuffer;
// src/addFunctionModule.js
var $10b15ded35359857$var$addFunctionModule = (audioWorklet, processorFunction, ...injection)=>{
    const text = `(${processorFunction.toString()})(${injection.map((s)=>JSON.stringify(s)).join(", ")});`;
    const url = URL.createObjectURL(new Blob([
        text
    ], {
        type: "text/javascript"
    }));
    return audioWorklet.addModule(url);
};
var $10b15ded35359857$export$4fcc018837fb958b = $10b15ded35359857$var$addFunctionModule;
// src/WamParameter.js
var $10b15ded35359857$var$getWamParameter = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    class WamParameter {
        constructor(info){
            this.info = info;
            this._value = info.defaultValue;
        }
        set value(value) {
            this._value = value;
        }
        get value() {
            return this._value;
        }
        set normalizedValue(valueNorm) {
            this.value = this.info.denormalize(valueNorm);
        }
        get normalizedValue() {
            return this.info.normalize(this.value);
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.WamParameter) ModuleScope.WamParameter = WamParameter;
    }
    return WamParameter;
};
var $10b15ded35359857$export$1bd88376aa78ae4a = $10b15ded35359857$var$getWamParameter;
// src/WamParameterInfo.js
var $10b15ded35359857$var$getWamParameterInfo = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    const normExp = (x, e)=>e === 0 ? x : x ** 1.5 ** -e;
    const denormExp = (x, e)=>e === 0 ? x : x ** 1.5 ** e;
    const normalize = (x, min, max, e = 0)=>min === 0 && max === 1 ? normExp(x, e) : normExp((x - min) / (max - min) || 0, e);
    const denormalize = (x, min, max, e = 0)=>min === 0 && max === 1 ? denormExp(x, e) : denormExp(x, e) * (max - min) + min;
    const inRange = (x, min, max)=>x >= min && x <= max;
    class WamParameterInfo {
        constructor(id, config = {}){
            let { type: type, label: label, defaultValue: defaultValue, minValue: minValue, maxValue: maxValue, discreteStep: discreteStep, exponent: exponent, choices: choices, units: units } = config;
            if (type === void 0) type = "float";
            if (label === void 0) label = "";
            if (defaultValue === void 0) defaultValue = 0;
            if (choices === void 0) choices = [];
            if (type === "boolean" || type === "choice") {
                discreteStep = 1;
                minValue = 0;
                if (choices.length) maxValue = choices.length - 1;
                else maxValue = 1;
            } else {
                if (minValue === void 0) minValue = 0;
                if (maxValue === void 0) maxValue = 1;
                if (discreteStep === void 0) discreteStep = 0;
                if (exponent === void 0) exponent = 0;
                if (units === void 0) units = "";
            }
            const errBase = `Param config error | ${id}: `;
            if (minValue >= maxValue) throw Error(errBase.concat("minValue must be less than maxValue"));
            if (!inRange(defaultValue, minValue, maxValue)) throw Error(errBase.concat("defaultValue out of range"));
            if (discreteStep % 1 || discreteStep < 0) throw Error(errBase.concat("discreteStep must be a non-negative integer"));
            else if (discreteStep > 0 && (minValue % 1 || maxValue % 1 || defaultValue % 1)) throw Error(errBase.concat("non-zero discreteStep requires integer minValue, maxValue, and defaultValue"));
            if (type === "choice" && !choices.length) throw Error(errBase.concat("choice type parameter requires list of strings in choices"));
            this.id = id;
            this.label = label;
            this.type = type;
            this.defaultValue = defaultValue;
            this.minValue = minValue;
            this.maxValue = maxValue;
            this.discreteStep = discreteStep;
            this.exponent = exponent;
            this.choices = choices;
            this.units = units;
        }
        normalize(value) {
            return normalize(value, this.minValue, this.maxValue, this.exponent);
        }
        denormalize(valueNorm) {
            return denormalize(valueNorm, this.minValue, this.maxValue, this.exponent);
        }
        valueString(value) {
            if (this.choices) return this.choices[value];
            if (this.units !== "") return `${value} ${this.units}`;
            return `${value}`;
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.WamParameterInfo) ModuleScope.WamParameterInfo = WamParameterInfo;
    }
    return WamParameterInfo;
};
var $10b15ded35359857$export$9eac8df8ff0f930a = $10b15ded35359857$var$getWamParameterInfo;
// src/WamParameterInterpolator.js
var $10b15ded35359857$var$getWamParameterInterpolator = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    const samplesPerQuantum = 128;
    const nullTableKey = "0_0";
    class WamParameterInterpolator {
        static _tables;
        static _tableReferences;
        constructor(info, samplesPerInterpolation, skew = 0){
            if (!WamParameterInterpolator._tables) {
                WamParameterInterpolator._tables = {
                    nullTableKey: new Float32Array(0)
                };
                WamParameterInterpolator._tableReferences = {
                    nullTableKey: []
                };
            }
            this.info = info;
            this.values = new Float32Array(samplesPerQuantum);
            this._tableKey = nullTableKey;
            this._table = WamParameterInterpolator._tables[this._tableKey];
            this._skew = 2;
            const { discreteStep: discreteStep } = info;
            this._discrete = !!discreteStep;
            this._N = this._discrete ? 0 : samplesPerInterpolation;
            this._n = 0;
            this._startValue = info.defaultValue;
            this._endValue = info.defaultValue;
            this._currentValue = info.defaultValue;
            this._deltaValue = 0;
            this._inverted = false;
            this._changed = true;
            this._filled = 0;
            if (!this._discrete) this.setSkew(skew);
            else this._skew = 0;
            this.setStartValue(this._startValue);
        }
        _removeTableReference(oldKey) {
            if (oldKey === nullTableKey) return;
            const { id: id } = this.info;
            const references = WamParameterInterpolator._tableReferences[oldKey];
            if (references) {
                const index = references.indexOf(id);
                if (index !== -1) references.splice(index, 1);
                if (references.length === 0) {
                    delete WamParameterInterpolator._tables[oldKey];
                    delete WamParameterInterpolator._tableReferences[oldKey];
                }
            }
        }
        setSkew(skew) {
            if (this._skew === skew || this._discrete) return;
            if (skew < -1 || skew > 1) throw Error("skew must be in range [-1.0, 1.0]");
            const newKey = [
                this._N,
                skew
            ].join("_");
            const oldKey = this._tableKey;
            const { id: id } = this.info;
            if (newKey === oldKey) return;
            if (WamParameterInterpolator._tables[newKey]) {
                const references = WamParameterInterpolator._tableReferences[newKey];
                if (references) references.push(id);
                else WamParameterInterpolator._tableReferences[newKey] = [
                    id
                ];
            } else {
                let e = Math.abs(skew);
                e = Math.pow(3 - e, e * (e + 2));
                const linear = e === 1;
                const N = this._N;
                const table = new Float32Array(N + 1);
                if (linear) for(let n = 0; n <= N; ++n)table[n] = n / N;
                else for(let n = 0; n <= N; ++n)table[n] = (n / N) ** e;
                WamParameterInterpolator._tables[newKey] = table;
                WamParameterInterpolator._tableReferences[newKey] = [
                    id
                ];
            }
            this._removeTableReference(oldKey);
            this._skew = skew;
            this._tableKey = newKey;
            this._table = WamParameterInterpolator._tables[this._tableKey];
        }
        setStartValue(value, fill = true) {
            this._n = this._N;
            this._startValue = value;
            this._endValue = value;
            this._currentValue = value;
            this._deltaValue = 0;
            this._inverted = false;
            if (fill) {
                this.values.fill(value);
                this._changed = true;
                this._filled = this.values.length;
            } else {
                this._changed = false;
                this._filled = 0;
            }
        }
        setEndValue(value) {
            if (value === this._endValue) return;
            this._n = 0;
            this._startValue = this._currentValue;
            this._endValue = value;
            this._deltaValue = this._endValue - this._startValue;
            this._inverted = this._deltaValue > 0 && this._skew >= 0 || this._deltaValue <= 0 && this._skew < 0;
            this._changed = false;
            this._filled = 0;
        }
        process(startSample, endSample) {
            if (this.done) return;
            const length = endSample - startSample;
            let fill = 0;
            const change = this._N - this._n;
            if (this._discrete || !change) fill = length;
            else {
                if (change < length) {
                    fill = Math.min(length - change, samplesPerQuantum);
                    endSample -= fill;
                }
                if (endSample > startSample) {
                    if (this._inverted) for(let i = startSample; i < endSample; ++i){
                        const tableValue = 1 - this._table[this._N - ++this._n];
                        this.values[i] = this._startValue + tableValue * this._deltaValue;
                    }
                    else for(let i = startSample; i < endSample; ++i){
                        const tableValue = this._table[++this._n];
                        this.values[i] = this._startValue + tableValue * this._deltaValue;
                    }
                }
                if (fill > 0) {
                    startSample = endSample;
                    endSample += fill;
                }
            }
            if (fill > 0) {
                this.values.fill(this._endValue, startSample, endSample);
                this._filled += fill;
            }
            this._currentValue = this.values[endSample - 1];
            if (this._n === this._N) {
                if (!this._changed) this._changed = true;
                else if (this._filled >= this.values.length) {
                    this.setStartValue(this._endValue, false);
                    this._changed = true;
                    this._filled = this.values.length;
                }
            }
        }
        get done() {
            return this._changed && this._filled === this.values.length;
        }
        is(value) {
            return this._endValue === value && this.done;
        }
        destroy() {
            this._removeTableReference(this._tableKey);
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
        if (!ModuleScope.WamParameterInterpolator) ModuleScope.WamParameterInterpolator = WamParameterInterpolator;
    }
    return WamParameterInterpolator;
};
var $10b15ded35359857$export$8c90a248cf1ff38e = $10b15ded35359857$var$getWamParameterInterpolator;
// src/WamProcessor.js
var $10b15ded35359857$var$getWamProcessor = (moduleId)=>{
    const audioWorkletGlobalScope = globalThis;
    const { AudioWorkletProcessor: AudioWorkletProcessor, webAudioModules: webAudioModules } = audioWorkletGlobalScope;
    const ModuleScope = audioWorkletGlobalScope.webAudioModules.getModuleScope(moduleId);
    const { RingBuffer: RingBuffer2, WamEventRingBuffer: WamEventRingBuffer2, WamParameter: WamParameter, WamParameterInterpolator: WamParameterInterpolator } = ModuleScope;
    class WamProcessor extends AudioWorkletProcessor {
        constructor(options){
            super();
            const { groupId: groupId, moduleId: moduleId2, instanceId: instanceId, useSab: useSab } = options.processorOptions;
            if (!moduleId2) throw Error("must provide moduleId argument in processorOptions!");
            if (!instanceId) throw Error("must provide instanceId argument in processorOptions!");
            this.groupId = groupId;
            this.moduleId = moduleId2;
            this.instanceId = instanceId;
            this._samplesPerQuantum = 128;
            this._compensationDelay = 0;
            this._parameterInfo = {};
            this._parameterState = {};
            this._parameterInterpolators = {};
            this._eventQueue = [];
            this._pendingResponses = {};
            this._useSab = !!useSab && !!globalThis.SharedArrayBuffer;
            this._eventSabReady = false;
            this._audioToMainEventSab = null;
            this._mainToAudioEventSab = null;
            this._eventWriter = null;
            this._eventReader = null;
            this._initialized = false;
            this._destroyed = false;
            this._eventQueueRequiresSort = false;
            webAudioModules.addWam(this);
            this.port.onmessage = this._onMessage.bind(this);
            if (this._useSab) this._configureSab();
        }
        getCompensationDelay() {
            return this._compensationDelay;
        }
        scheduleEvents(...events) {
            let i = 0;
            while(i < events.length){
                this._eventQueue.push({
                    id: 0,
                    event: events[i]
                });
                i++;
            }
            this._eventQueueRequiresSort = this._eventQueue.length > 1;
        }
        emitEvents(...events) {
            webAudioModules.emitEvents(this, ...events);
        }
        clearEvents() {
            this._eventQueue = [];
        }
        process(inputs, outputs, parameters) {
            if (!this._initialized) return true;
            if (this._destroyed) return false;
            if (this._eventSabReady) this.scheduleEvents(...this._eventReader.read());
            const processingSlices = this._getProcessingSlices();
            let i = 0;
            while(i < processingSlices.length){
                const { range: range, events: events } = processingSlices[i];
                const [startSample, endSample] = range;
                let j = 0;
                while(j < events.length){
                    this._processEvent(events[j]);
                    j++;
                }
                this._interpolateParameterValues(startSample, endSample);
                this._process(startSample, endSample, inputs, outputs, parameters);
                i++;
            }
            return true;
        }
        destroy() {
            this._destroyed = true;
            this.port.close();
            webAudioModules.removeWam(this);
        }
        _generateWamParameterInfo() {
            return {};
        }
        _initialize() {
            this._parameterState = {};
            this._parameterInterpolators = {};
            this._parameterInfo = this._generateWamParameterInfo();
            Object.keys(this._parameterInfo).forEach((parameterId)=>{
                const info = this._parameterInfo[parameterId];
                this._parameterState[parameterId] = new WamParameter(this._parameterInfo[parameterId]);
                this._parameterInterpolators[parameterId] = new WamParameterInterpolator(info, 256);
            });
        }
        _configureSab() {
            const eventCapacity = 1024;
            const parameterIds = Object.keys(this._parameterInfo);
            if (this._eventSabReady) {
                this._eventWriter.setParameterIds(parameterIds);
                this._eventReader.setParameterIds(parameterIds);
            }
            this.port.postMessage({
                eventSab: {
                    eventCapacity: eventCapacity,
                    parameterIds: parameterIds
                }
            });
        }
        async _onMessage(message) {
            if (message.data.request) {
                const { id: id, request: request, content: content } = message.data;
                const response = {
                    id: id,
                    response: request
                };
                const requestComponents = request.split("/");
                const verb = requestComponents[0];
                const noun = requestComponents[1];
                response.content = "error";
                if (verb === "get") {
                    if (noun === "parameterInfo") {
                        let { parameterIds: parameterIds } = content;
                        if (!parameterIds.length) parameterIds = Object.keys(this._parameterInfo);
                        const parameterInfo = {};
                        let i = 0;
                        while(i < parameterIds.length){
                            const parameterId = parameterIds[i];
                            parameterInfo[parameterId] = this._parameterInfo[parameterId];
                            i++;
                        }
                        response.content = parameterInfo;
                    } else if (noun === "parameterValues") {
                        let { normalized: normalized, parameterIds: parameterIds } = content;
                        response.content = this._getParameterValues(normalized, parameterIds);
                    } else if (noun === "state") response.content = this._getState();
                    else if (noun === "compensationDelay") response.content = this.getCompensationDelay();
                } else if (verb === "set") {
                    if (noun === "parameterValues") {
                        const { parameterValues: parameterValues } = content;
                        this._setParameterValues(parameterValues, true);
                        delete response.content;
                    } else if (noun === "state") {
                        const { state: state } = content;
                        this._setState(state);
                        delete response.content;
                    }
                } else if (verb === "add") {
                    if (noun === "event") {
                        const { event: event } = content;
                        this._eventQueue.push({
                            id: id,
                            event: event
                        });
                        this._eventQueueRequiresSort = this._eventQueue.length > 1;
                        return;
                    }
                } else if (verb === "remove") {
                    if (noun === "events") {
                        const ids = this._eventQueue.map((queued)=>queued.id);
                        this.clearEvents();
                        response.content = ids;
                    }
                } else if (verb === "connect") {
                    if (noun === "events") {
                        const { wamInstanceId: wamInstanceId, output: output } = content;
                        this._connectEvents(wamInstanceId, output);
                        delete response.content;
                    }
                } else if (verb === "disconnect") {
                    if (noun === "events") {
                        const { wamInstanceId: wamInstanceId, output: output } = content;
                        this._disconnectEvents(wamInstanceId, output);
                        delete response.content;
                    }
                } else if (verb === "initialize") {
                    if (noun === "processor") {
                        this._initialize();
                        this._initialized = true;
                        delete response.content;
                    } else if (noun === "eventSab") {
                        const { mainToAudioEventSab: mainToAudioEventSab, audioToMainEventSab: audioToMainEventSab } = content;
                        this._audioToMainEventSab = audioToMainEventSab;
                        this._mainToAudioEventSab = mainToAudioEventSab;
                        const parameterIds = Object.keys(this._parameterInfo);
                        this._eventWriter = new WamEventRingBuffer2(RingBuffer2, this._audioToMainEventSab, parameterIds);
                        this._eventReader = new WamEventRingBuffer2(RingBuffer2, this._mainToAudioEventSab, parameterIds);
                        this._eventSabReady = true;
                        delete response.content;
                    }
                }
                this.port.postMessage(response);
            } else if (message.data.destroy) this.destroy();
        }
        _onTransport(transportData) {
            console.error("_onTransport not implemented!");
        }
        _onMidi(midiData) {
            console.error("_onMidi not implemented!");
        }
        _onSysex(sysexData) {
            console.error("_onMidi not implemented!");
        }
        _onMpe(mpeData) {
            console.error("_onMpe not implemented!");
        }
        _onOsc(oscData) {
            console.error("_onOsc not implemented!");
        }
        _setState(state) {
            if (state.parameterValues) this._setParameterValues(state.parameterValues, false);
        }
        _getState() {
            return {
                parameterValues: this._getParameterValues(false)
            };
        }
        _getParameterValues(normalized, parameterIds) {
            const parameterValues = {};
            if (!parameterIds || !parameterIds.length) parameterIds = Object.keys(this._parameterState);
            let i = 0;
            while(i < parameterIds.length){
                const id = parameterIds[i];
                const parameter = this._parameterState[id];
                parameterValues[id] = {
                    id: id,
                    value: normalized ? parameter.normalizedValue : parameter.value,
                    normalized: normalized
                };
                i++;
            }
            return parameterValues;
        }
        _setParameterValues(parameterUpdates, interpolate) {
            const parameterIds = Object.keys(parameterUpdates);
            let i = 0;
            while(i < parameterIds.length){
                this._setParameterValue(parameterUpdates[parameterIds[i]], interpolate);
                i++;
            }
        }
        _setParameterValue(parameterUpdate, interpolate) {
            const { id: id, value: value, normalized: normalized } = parameterUpdate;
            const parameter = this._parameterState[id];
            if (!parameter) return;
            if (!normalized) parameter.value = value;
            else parameter.normalizedValue = value;
            const interpolator = this._parameterInterpolators[id];
            if (interpolate) interpolator.setEndValue(parameter.value);
            else interpolator.setStartValue(parameter.value);
        }
        _interpolateParameterValues(startIndex, endIndex) {
            const parameterIds = Object.keys(this._parameterInterpolators);
            let i = 0;
            while(i < parameterIds.length){
                this._parameterInterpolators[parameterIds[i]].process(startIndex, endIndex);
                i++;
            }
        }
        _connectEvents(wamInstanceId, output) {
            webAudioModules.connectEvents(this.groupId, this.instanceId, wamInstanceId, output);
        }
        _disconnectEvents(wamInstanceId, output) {
            if (typeof wamInstanceId === "undefined") {
                webAudioModules.disconnectEvents(this.groupId, this.instanceId);
                return;
            }
            webAudioModules.disconnectEvents(this.groupId, this.instanceId, wamInstanceId, output);
        }
        _getProcessingSlices() {
            const response = "add/event";
            const { currentTime: currentTime, sampleRate: sampleRate } = audioWorkletGlobalScope;
            const eventsBySampleIndex = {};
            if (this._eventQueueRequiresSort) {
                this._eventQueue.sort((a, b)=>a.event.time - b.event.time);
                this._eventQueueRequiresSort = false;
            }
            let i = 0;
            while(i < this._eventQueue.length){
                const { id: id, event: event } = this._eventQueue[i];
                const offsetSec = event.time - currentTime;
                const sampleIndex = offsetSec > 0 ? Math.round(offsetSec * sampleRate) : 0;
                if (sampleIndex < this._samplesPerQuantum) {
                    if (eventsBySampleIndex[sampleIndex]) eventsBySampleIndex[sampleIndex].push(event);
                    else eventsBySampleIndex[sampleIndex] = [
                        event
                    ];
                    if (id) this.port.postMessage({
                        id: id,
                        response: response
                    });
                    else if (this._eventSabReady) this._eventWriter.write(event);
                    else this.port.postMessage({
                        event: event
                    });
                    this._eventQueue.shift();
                    i = -1;
                } else break;
                i++;
            }
            const processingSlices = [];
            const keys = Object.keys(eventsBySampleIndex);
            if (keys[0] !== "0") {
                keys.unshift("0");
                eventsBySampleIndex["0"] = [];
            }
            const lastIndex = keys.length - 1;
            i = 0;
            while(i < keys.length){
                const key = keys[i];
                const startSample = parseInt(key);
                const endSample = i < lastIndex ? parseInt(keys[i + 1]) : this._samplesPerQuantum;
                processingSlices.push({
                    range: [
                        startSample,
                        endSample
                    ],
                    events: eventsBySampleIndex[key]
                });
                i++;
            }
            return processingSlices;
        }
        _processEvent(event) {
            switch(event.type){
                case "wam-automation":
                    this._setParameterValue(event.data, true);
                    break;
                case "wam-transport":
                    this._onTransport(event.data);
                    break;
                case "wam-midi":
                    this._onMidi(event.data);
                    break;
                case "wam-sysex":
                    this._onSysex(event.data);
                    break;
                case "wam-mpe":
                    this._onMpe(event.data);
                    break;
                case "wam-osc":
                    this._onOsc(event.data);
                    break;
                default:
                    break;
            }
        }
        _process(startSample, endSample, inputs, outputs, parameters) {
            console.error("_process not implemented!");
        }
    }
    if (audioWorkletGlobalScope.AudioWorkletProcessor) {
        if (!ModuleScope.WamProcessor) ModuleScope.WamProcessor = WamProcessor;
    }
    return WamProcessor;
};
var $10b15ded35359857$export$6bc8f1ca2955cfdf = $10b15ded35359857$var$getWamProcessor;
// src/WamNode.js
var $10b15ded35359857$var$RingBuffer = $10b15ded35359857$export$e8c2e0ed6c094464();
var $10b15ded35359857$var$WamEventRingBuffer = $10b15ded35359857$export$aa96e9388daf1fd3();
var $10b15ded35359857$export$cf06b99312a1c4e9 = class extends AudioWorkletNode {
    static async addModules(audioContext, moduleId) {
        const { audioWorklet: audioWorklet } = audioContext;
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$e8c2e0ed6c094464, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$aa96e9388daf1fd3, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$fd69883a3e8bc237, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$1bd88376aa78ae4a, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$9eac8df8ff0f930a, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$8c90a248cf1ff38e, moduleId);
        await $10b15ded35359857$export$4fcc018837fb958b(audioWorklet, $10b15ded35359857$export$6bc8f1ca2955cfdf, moduleId);
    }
    constructor(module, options){
        const { audioContext: audioContext, groupId: groupId, moduleId: moduleId, instanceId: instanceId } = module;
        options.processorOptions = {
            groupId: groupId,
            moduleId: moduleId,
            instanceId: instanceId,
            ...options.processorOptions
        };
        super(audioContext, moduleId, options);
        this.module = module;
        this._supportedEventTypes = /* @__PURE__ */ new Set([
            "wam-automation",
            "wam-transport",
            "wam-midi",
            "wam-sysex",
            "wam-mpe",
            "wam-osc"
        ]);
        this._messageId = 1;
        this._pendingResponses = {};
        this._pendingEvents = {};
        this._useSab = false;
        this._eventSabReady = false;
        this._destroyed = false;
        this.port.onmessage = this._onMessage.bind(this);
    }
    get groupId() {
        return this.module.groupId;
    }
    get moduleId() {
        return this.module.moduleId;
    }
    get instanceId() {
        return this.module.instanceId;
    }
    async getParameterInfo(...parameterIds) {
        const request = "get/parameterInfo";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    parameterIds: parameterIds
                }
            });
        });
    }
    async getParameterValues(normalized, ...parameterIds) {
        const request = "get/parameterValues";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    normalized: normalized,
                    parameterIds: parameterIds
                }
            });
        });
    }
    async setParameterValues(parameterValues) {
        const request = "set/parameterValues";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    parameterValues: parameterValues
                }
            });
        });
    }
    async getState() {
        const request = "get/state";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request
            });
        });
    }
    async setState(state) {
        const request = "set/state";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    state: state
                }
            });
        });
    }
    async getCompensationDelay() {
        const request = "get/compensationDelay";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request
            });
        });
    }
    addEventListener(type, callback, options) {
        if (this._supportedEventTypes.has(type)) super.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        if (this._supportedEventTypes.has(type)) super.removeEventListener(type, callback, options);
    }
    scheduleEvents(...events) {
        let i = 0;
        const numEvents = events.length;
        if (this._eventSabReady) i = this._eventWriter.write(...events);
        while(i < numEvents){
            const event = events[i];
            const request = "add/event";
            const id = this._generateMessageId();
            let processed = false;
            new Promise((resolve, reject)=>{
                this._pendingResponses[id] = resolve;
                this._pendingEvents[id] = ()=>{
                    if (!processed) reject();
                };
                this.port.postMessage({
                    id: id,
                    request: request,
                    content: {
                        event: event
                    }
                });
            }).then((resolved)=>{
                processed = true;
                delete this._pendingEvents[id];
                this._onEvent(event);
            }).catch((rejected)=>{
                delete this._pendingResponses[id];
            });
            i++;
        }
    }
    async clearEvents() {
        const request = "remove/events";
        const id = this._generateMessageId();
        const ids = Object.keys(this._pendingEvents);
        if (ids.length) return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request
            });
        }).then((clearedIds)=>{
            clearedIds.forEach((clearedId)=>{
                this._pendingEvents[clearedId]();
                delete this._pendingEvents[clearedId];
            });
        });
    }
    connectEvents(toId, output) {
        const request = "connect/events";
        const id = this._generateMessageId();
        new Promise((resolve, reject)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    wamInstanceId: toId,
                    output: output
                }
            });
        });
    }
    disconnectEvents(toId, output) {
        const request = "disconnect/events";
        const id = this._generateMessageId();
        new Promise((resolve, reject)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request,
                content: {
                    wamInstanceId: toId,
                    output: output
                }
            });
        });
    }
    destroy() {
        if (this._audioToMainInterval) clearInterval(this._audioToMainInterval);
        this.port.postMessage({
            destroy: true
        });
        this.port.close();
        this.disconnect();
        this._destroyed = true;
    }
    _generateMessageId() {
        return this._messageId++;
    }
    async _initialize() {
        const request = "initialize/processor";
        const id = this._generateMessageId();
        return new Promise((resolve)=>{
            this._pendingResponses[id] = resolve;
            this.port.postMessage({
                id: id,
                request: request
            });
        });
    }
    _onMessage(message) {
        const { data: data } = message;
        const { response: response, event: event, eventSab: eventSab } = data;
        if (response) {
            const { id: id, content: content } = data;
            const resolvePendingResponse = this._pendingResponses[id];
            if (resolvePendingResponse) {
                delete this._pendingResponses[id];
                resolvePendingResponse(content);
            }
        } else if (eventSab) {
            this._useSab = true;
            const { eventCapacity: eventCapacity, parameterIds: parameterIds } = eventSab;
            if (this._eventSabReady) {
                this._eventWriter.setParameterIds(parameterIds);
                this._eventReader.setParameterIds(parameterIds);
                return;
            }
            this._mainToAudioEventSab = $10b15ded35359857$var$WamEventRingBuffer.getStorageForEventCapacity($10b15ded35359857$var$RingBuffer, eventCapacity);
            this._audioToMainEventSab = $10b15ded35359857$var$WamEventRingBuffer.getStorageForEventCapacity($10b15ded35359857$var$RingBuffer, eventCapacity);
            this._eventWriter = new $10b15ded35359857$var$WamEventRingBuffer($10b15ded35359857$var$RingBuffer, this._mainToAudioEventSab, parameterIds);
            this._eventReader = new $10b15ded35359857$var$WamEventRingBuffer($10b15ded35359857$var$RingBuffer, this._audioToMainEventSab, parameterIds);
            const request = "initialize/eventSab";
            const id = this._generateMessageId();
            new Promise((resolve, reject)=>{
                this._pendingResponses[id] = resolve;
                this.port.postMessage({
                    id: id,
                    request: request,
                    content: {
                        mainToAudioEventSab: this._mainToAudioEventSab,
                        audioToMainEventSab: this._audioToMainEventSab
                    }
                });
            }).then((resolved)=>{
                this._eventSabReady = true;
                this._audioToMainInterval = setInterval(()=>{
                    const events = this._eventReader.read();
                    events.forEach((e)=>{
                        this._onEvent(e);
                    });
                }, 100);
            });
        } else if (event) this._onEvent(event);
    }
    _onEvent(event) {
        const { type: type } = event;
        this.dispatchEvent(new CustomEvent(type, {
            bubbles: true,
            detail: event
        }));
    }
};
// src/apiVersion.js
var $10b15ded35359857$export$bd232a9a3ba573ec = "2.0.0-alpha.6";
// src/initializeWamHost.js
var $10b15ded35359857$var$initializeWamHost = async (audioContext, hostGroupId = `wam-host-${performance.now().toString()}`, hostGroupKey = performance.now().toString())=>{
    await $10b15ded35359857$export$4fcc018837fb958b(audioContext.audioWorklet, $10b15ded35359857$export$6fa0848cc153f5f6, $10b15ded35359857$export$bd232a9a3ba573ec);
    await $10b15ded35359857$export$4fcc018837fb958b(audioContext.audioWorklet, $10b15ded35359857$export$ba6a03b2a7772bf2, hostGroupId, hostGroupKey);
    return [
        hostGroupId,
        hostGroupKey
    ];
};
var $10b15ded35359857$export$f0d840867f44d741 = $10b15ded35359857$var$initializeWamHost;

});

parcelRegister("enQqi", function(module, exports) {

$parcel$export(module.exports, "addKeysAsField", () => $a78be0c9e2b21acf$export$540f082cba3b287d);
$parcel$export(module.exports, "findNoteIndexInSequence", () => $a78be0c9e2b21acf$export$9938d7d12b412242);
$parcel$export(module.exports, "findNoteInSequence", () => $a78be0c9e2b21acf$export$b8ef332678821ab1);
$parcel$export(module.exports, "getURLParamValue", () => $a78be0c9e2b21acf$export$60164931b0a90d7d);
$parcel$export(module.exports, "removeURLParam", () => $a78be0c9e2b21acf$export$f38fdce0dfe9bb0c);
$parcel$export(module.exports, "goToGruf", () => $a78be0c9e2b21acf$export$3c114576525c50f);
$parcel$export(module.exports, "getClipDisplayName", () => $a78be0c9e2b21acf$export$a3f13d67f9c8f8e4);
$parcel$export(module.exports, "getAppVersionInfo", () => $a78be0c9e2b21acf$export$64f813d5db5f1ca1);
$parcel$export(module.exports, "downloadedAudioRecordingFilename", () => $a78be0c9e2b21acf$export$7d4fcf0e0caa4fda);
$parcel$export(module.exports, "downloadObjectAsJson", () => $a78be0c9e2b21acf$export$5ace44f0675ffb07);
$parcel$export(module.exports, "getProjectDataObject", () => $a78be0c9e2b21acf$export$e21bbbd70662bddb);
$parcel$export(module.exports, "sleep", () => $a78be0c9e2b21acf$export$e772c8ff12451969);

var $9xysn = parcelRequire("9xysn");

var $hOWXx = parcelRequire("hOWXx");

var $5ICqB = parcelRequire("5ICqB");
const $a78be0c9e2b21acf$export$540f082cba3b287d = (object, field = "id")=>Object.fromEntries([
        ...Object.entries(object)
    ].map(([key, value])=>[
            key,
            {
                ...value,
                [field]: key
            }
        ]));
const $a78be0c9e2b21acf$export$9938d7d12b412242 = (sequence, targetProperties)=>{
    for(let i = 0; i < sequence.length; i++){
        const note = sequence[i];
        let isMatch = true;
        for(const key in targetProperties)if (note[key] !== targetProperties[key]) {
            isMatch = false;
            break;
        }
        if (isMatch) return i;
    }
    return -1;
};
const $a78be0c9e2b21acf$export$b8ef332678821ab1 = (sequence, targetProperties)=>sequence[$a78be0c9e2b21acf$export$9938d7d12b412242(sequence, targetProperties)];
const $a78be0c9e2b21acf$export$840f5b385384df33 = (numeroBeat)=>{
    return (numeroBeat - 2) % 4 == 0;
};
const $a78be0c9e2b21acf$export$60164931b0a90d7d = (paramName, defaultValue)=>{
    var queryString = location.search;
    let params = new URLSearchParams(queryString);
    if (!params.has(paramName)) return defaultValue;
    return params.get(paramName);
};
const $a78be0c9e2b21acf$export$f38fdce0dfe9bb0c = (paramName)=>{
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    if (params.has(paramName)) {
        params.delete(paramName);
        let newUrl = window.location.pathname;
        if (`${params}` !== '' || window.location.hash !== '') newUrl += `?${params}${window.location.hash}`;
        window.history.replaceState(null, null, newUrl);
    }
};
const $a78be0c9e2b21acf$export$3c114576525c50f = (grufId)=>{
    if (grufId === "") return console.error("GRUFID is empty");
    const projectUrl = appPrefix + "/g/" + grufId;
    window.location.replace(projectUrl);
};
const $a78be0c9e2b21acf$export$a3f13d67f9c8f8e4 = (clipNumber)=>{
    if (clipNumber === undefined) return "";
    // Returns the uppercase character corresponding to the clip number
    return String.fromCharCode(65 + clipNumber);
};
const $a78be0c9e2b21acf$export$64f813d5db5f1ca1 = ()=>{
    return {
        version: appVersion,
        commit: appCommit
    }; // Defined in base.html
};
const $a78be0c9e2b21acf$export$7d4fcf0e0caa4fda = ()=>{
    const date = new Date();
    return `GRUF_${(0, $9xysn.getCurrentProject)().getID()}_${(0, $hOWXx.slugify)((0, $9xysn.getCurrentProject)().getNom())}_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}.wav`;
};
const $a78be0c9e2b21acf$export$598a187e58dc9b87 = (dictionary, key)=>{
    var duplicate = Object.assign({}, dictionary);
    delete duplicate[key];
    return duplicate;
};
function $a78be0c9e2b21acf$export$5ace44f0675ffb07(object, baseName = "object", extension = ".json") {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(object, null, 2));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", baseName + extension);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
}
const $a78be0c9e2b21acf$var$makeSticky = (checkValidity, initial = null)=>{
    let lastValid = initial;
    return (value)=>{
        if (checkValidity(value)) lastValid = value;
        return lastValid;
    };
};
const $a78be0c9e2b21acf$export$748ba1e8dadf65b4 = (selector, checkValidity, initial = null)=>{
    const sticky = $a78be0c9e2b21acf$var$makeSticky(checkValidity, initial);
    return (state, ...args)=>{
        const current = selector(state, ...args);
        return sticky(current);
    };
};
// Collects all the data of the project and returns it as an object that should be suitable to be stored in a redis store
// It has information that probably shouldn't be stored
const $a78be0c9e2b21acf$var$getFullProjectDataObject = ()=>(0, $5ICqB.default).getState().project;
function $a78be0c9e2b21acf$export$e21bbbd70662bddb() {
    const projectObject = structuredClone($a78be0c9e2b21acf$var$getFullProjectDataObject()); // so that we can delete properties, because og object is frozen
    delete projectObject.transport;
    delete projectObject.audio;
    delete projectObject.metadata.connected_users;
    return projectObject;
}
const $a78be0c9e2b21acf$export$e772c8ff12451969 = (ms, signal)=>{
    let abort;
    const promise = new Promise((resolve, reject)=>{
        const done = function() {
            resolve();
            signal?.removeEventListener("abort", abort);
        };
        abort = function() {
            reject();
            clearTimeout(timeoutID);
        };
        const timeoutID = setTimeout(done, ms);
        signal.addEventListener("abort", abort);
    });
    promise.abort = abort;
    return promise;
};

});
parcelRegister("hOWXx", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $cf94d740b82a816b$export$9a00dee1beb8f576);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $cf94d740b82a816b$export$d07f57595c356899);
$parcel$export(module.exports, "slugify", () => $cf94d740b82a816b$export$c383cdd2a518017a);
const $cf94d740b82a816b$export$9a00dee1beb8f576 = (string)=>{
    return string.split(" ").map((word)=>$cf94d740b82a816b$export$d07f57595c356899(word)).join(" ");
};
const $cf94d740b82a816b$export$d07f57595c356899 = (string)=>{
    return string.charAt(0).toUpperCase() + string.slice(1);
};
const $cf94d740b82a816b$export$f08459d87829d2ee = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $cf94d740b82a816b$export$c383cdd2a518017a(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

});


parcelRegister("SPbsj", function(module, exports) {

$parcel$export(module.exports, "importModuleFromExternalUrl", () => $0a4cbf4a61e81f51$export$493ba610f249564);
const $0a4cbf4a61e81f51$export$493ba610f249564 = async (moduleUrl)=>{
    // Use native dynamic import at runtime so bundlers don't try to resolve external URLs.
    const runtimeImport = new Function('url', 'return import(url);');
    return await runtimeImport(moduleUrl);
};

});



parcelRegister("9Rnnc", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $72db31bd550cc612$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $72db31bd550cc612$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $72db31bd550cc612$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $72db31bd550cc612$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $72db31bd550cc612$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $72db31bd550cc612$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $72db31bd550cc612$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $72db31bd550cc612$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $72db31bd550cc612$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $72db31bd550cc612$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $72db31bd550cc612$var$root = $72db31bd550cc612$var$freeGlobal || $72db31bd550cc612$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $72db31bd550cc612$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $72db31bd550cc612$var$objectToString = $72db31bd550cc612$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $72db31bd550cc612$var$nativeMax = Math.max, $72db31bd550cc612$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $72db31bd550cc612$var$now = function() {
    return $72db31bd550cc612$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $72db31bd550cc612$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($72db31bd550cc612$var$FUNC_ERROR_TEXT);
    wait = $72db31bd550cc612$var$toNumber(wait) || 0;
    if ($72db31bd550cc612$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $72db31bd550cc612$var$nativeMax($72db31bd550cc612$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $72db31bd550cc612$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $72db31bd550cc612$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($72db31bd550cc612$var$now());
    }
    function debounced() {
        var time = $72db31bd550cc612$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $72db31bd550cc612$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($72db31bd550cc612$var$FUNC_ERROR_TEXT);
    if ($72db31bd550cc612$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $72db31bd550cc612$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $72db31bd550cc612$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $72db31bd550cc612$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $72db31bd550cc612$var$isSymbol(value) {
    return typeof value == 'symbol' || $72db31bd550cc612$var$isObjectLike(value) && $72db31bd550cc612$var$objectToString.call(value) == $72db31bd550cc612$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $72db31bd550cc612$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($72db31bd550cc612$var$isSymbol(value)) return $72db31bd550cc612$var$NAN;
    if ($72db31bd550cc612$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $72db31bd550cc612$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($72db31bd550cc612$var$reTrim, '');
    var isBinary = $72db31bd550cc612$var$reIsBinary.test(value);
    return isBinary || $72db31bd550cc612$var$reIsOctal.test(value) ? $72db31bd550cc612$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $72db31bd550cc612$var$reIsBadHex.test(value) ? $72db31bd550cc612$var$NAN : +value;
}
module.exports = $72db31bd550cc612$var$throttle;

});

parcelRegister("bLRr9", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $891d88facd7d6bcf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $891d88facd7d6bcf$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $891d88facd7d6bcf$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $891d88facd7d6bcf$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $891d88facd7d6bcf$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $891d88facd7d6bcf$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $891d88facd7d6bcf$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $891d88facd7d6bcf$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $891d88facd7d6bcf$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $891d88facd7d6bcf$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $891d88facd7d6bcf$var$root = $891d88facd7d6bcf$var$freeGlobal || $891d88facd7d6bcf$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $891d88facd7d6bcf$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $891d88facd7d6bcf$var$objectToString = $891d88facd7d6bcf$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $891d88facd7d6bcf$var$nativeMax = Math.max, $891d88facd7d6bcf$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $891d88facd7d6bcf$var$now = function() {
    return $891d88facd7d6bcf$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $891d88facd7d6bcf$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($891d88facd7d6bcf$var$FUNC_ERROR_TEXT);
    wait = $891d88facd7d6bcf$var$toNumber(wait) || 0;
    if ($891d88facd7d6bcf$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $891d88facd7d6bcf$var$nativeMax($891d88facd7d6bcf$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $891d88facd7d6bcf$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $891d88facd7d6bcf$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($891d88facd7d6bcf$var$now());
    }
    function debounced() {
        var time = $891d88facd7d6bcf$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $891d88facd7d6bcf$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $891d88facd7d6bcf$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $891d88facd7d6bcf$var$isSymbol(value) {
    return typeof value == 'symbol' || $891d88facd7d6bcf$var$isObjectLike(value) && $891d88facd7d6bcf$var$objectToString.call(value) == $891d88facd7d6bcf$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $891d88facd7d6bcf$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($891d88facd7d6bcf$var$isSymbol(value)) return $891d88facd7d6bcf$var$NAN;
    if ($891d88facd7d6bcf$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $891d88facd7d6bcf$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($891d88facd7d6bcf$var$reTrim, '');
    var isBinary = $891d88facd7d6bcf$var$reIsBinary.test(value);
    return isBinary || $891d88facd7d6bcf$var$reIsOctal.test(value) ? $891d88facd7d6bcf$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $891d88facd7d6bcf$var$reIsBadHex.test(value) ? $891d88facd7d6bcf$var$NAN : +value;
}
module.exports = $891d88facd7d6bcf$var$debounce;

});


parcelRegister("avF0V", function(module, exports) {

$parcel$export(module.exports, "getSampleLibraryManagerInstance", () => $7a6c9d2813b5b3bc$export$acc03982c7101e66);
$parcel$export(module.exports, "SamplePlayer", () => $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb);

var $56MRX = parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $e3S5U = parcelRequire("e3S5U");
var $ihNA0 = parcelRequire("ihNA0");
var $fDBOr = parcelRequire("fDBOr");

var $i5EW2 = parcelRequire("i5EW2");
const $7a6c9d2813b5b3bc$export$acc03982c7101e66 = ()=>{
    return $7a6c9d2813b5b3bc$var$sampleLibraryManagerInstance;
};
class $7a6c9d2813b5b3bc$var$SampleLibraryManager {
    soundBuffers = {};
    getSoundURL(soundName, defaultURL) {
        // Try find sound name in sample library
        const soundOfSampleLibrary = Object.values((0, $i5EW2.sampleLibrary)).flatMap((_)=>_).find((sound)=>sound.name.toLowerCase() === soundName.toLowerCase());
        if (soundOfSampleLibrary) return window.location.origin + soundOfSampleLibrary.url;
        // Otherwise, return default sound
        return defaultURL ?? 'https://cdn.freesound.org/previews/262/262495_2331961-hq.mp3' // Dark pad 
        ;
    }
    // Loads sound if not loaded yet and returns the buffer.
    // Admits a callback for when the buffer loads
    getBufferForSound(soundName, onLoadCallback, defaultURL) {
        if (!this.soundBuffers.hasOwnProperty(soundName)) {
            const url = this.getSoundURL(soundName);
            console.debug("Carregant so de la llibreria: ", soundName, ", amb url:", url);
            this.soundBuffers[soundName] = new $56MRX.Buffer(url);
        }
        const buffer = this.soundBuffers[soundName];
        if (onLoadCallback == null) return buffer;
        // Si ja està carregat, crida directament el callback
        if (buffer.loaded) onLoadCallback(buffer);
        else {
            // Si existeix però no està carregat encara, encadenem els callbacks
            const originalOnload = buffer.onload;
            buffer.onload = ()=>{
                if (originalOnload) originalOnload();
                onLoadCallback(buffer);
            };
        }
        return buffer;
    }
}
class $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb extends $fDBOr.ToneAudioNode {
    static STRETCH_MODES = {
        STRETCHED: "stretched",
        UNSTRETCHED_REPITCH: "unstretched_repitch",
        UNSTRETCHED_RESPEED: "unstretched_respeed"
    };
    currentSoundInBufferName = "";
    #lastTriggerData = {
        position: 0,
        time: 0
    };
    _start = 0.0;
    _end = 1.0;
    _transpose = 0;
    _speed = 1.0;
    _stretchMode = $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb.STRETCH_MODES.STRETCHED;
    _doesNeedRetrigger = false;
    _fadeIn = 0;
    _fadeOut = 0;
    constructor(){
        super();
        this.gain = new $bdbZZ.Gain($bmU6v.dbToGain(0));
        this.fadeEnvelopeGain = new $bdbZZ.Gain();
        this.pitchShift = new $e3S5U.PitchShift();
        this.player = new $ihNA0.Player({
            volume: -6
        }).chain(this.pitchShift, this.fadeEnvelopeGain, this.gain);
        this.player.fadeIn = 0.01;
        this.player.fadeOut = 0.01;
        this.input = this.player;
        this.output = this.gain;
    }
    dispose() {
        this.pitchShift.dispose();
        this.player.dispose();
        this.gain.dispose();
    }
    get volume() {
        return $bmU6v.gainToDb(this.gain.gain.value);
    }
    set volume(value) {
        this.gain.gain.rampTo($bmU6v.dbToGain(value), 0.01);
    }
    get transpose() {
        return this._transpose;
    }
    set transpose(value) {
        this._transpose = value;
        if (this.stretchMode === $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb.STRETCH_MODES.UNSTRETCHED_RESPEED && this.isPlaying()) this._doesNeedRetrigger = true;
        else this.applyPitchShift();
    }
    get start() {
        return this._start;
    }
    set start(value) {
        if (this._start === value) return;
        this._start = value;
        this.player.loopStart = this.getUnwarpedSoundDuration() * value;
        if (this.isPlaying()) this._doesNeedRetrigger = true;
    }
    get end() {
        return this._end;
    }
    set end(value) {
        if (this._end === value) return;
        this._end = value;
        this.player.loopEnd = this.getUnwarpedSoundDuration() * value;
        if (this.isPlaying()) this._doesNeedRetrigger = true;
    }
    get loop() {
        return this.player.loop;
    }
    set loop(value) {
        this.player.loop = value;
    }
    get isReverse() {
        return this.player.reverse;
    }
    set isReverse(value) {
        if (this.player.reverse === value) return;
        this.player.reverse = value;
        if (this.isPlaying()) this._doesNeedRetrigger = true;
    }
    get speed() {
        return this._speed;
    }
    set speed(value) {
        if (this._speed === value) return;
        this._speed = value;
        if (this.isPlaying()) this._doesNeedRetrigger = true;
    }
    get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(value) {
        this._fadeIn = value;
    }
    get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(value) {
        this._fadeOut = value;
    }
    applyPitchShift() {
        this.pitchShift.pitch = this.transpose + this.getPitchCompensationForSpeed();
    }
    applySpeed() {
        this.player.playbackRate = this.speed * this.getSpeedCompensationForPitch();
        this.player.loopStart = this.start * this.getUnwarpedSoundDuration();
        this.player.loopEnd = this.end * this.getUnwarpedSoundDuration();
        this.applyPitchShift();
    }
    get stretchMode() {
        return this._stretchMode;
    }
    set stretchMode(value) {
        if (this._stretchMode === value) return;
        this._stretchMode = value;
        if (this.isPlaying()) this._doesNeedRetrigger = true;
    }
    doesNeedRetrigger() {
        return this._doesNeedRetrigger;
    }
    loadSound(soundName) {
        $7a6c9d2813b5b3bc$export$acc03982c7101e66().getBufferForSound(soundName, (buffer)=>{
            // we create a duplicate because calling .reverse in the player actually reverses the buffer,
            // which we don't want for buffers that are shared for players, UI, etc.
            // new Tone.Buffer(buffer) just uses the same buffer, that's why we build it from the dumped Buffer
            this.player.buffer = $56MRX.Buffer.fromArray(buffer.toArray());
            this.currentSoundInBufferName = soundName;
            if (this.isPlaying()) this.stop();
        });
    }
    unloadSound() {
        this.currentSoundInBufferName = ""; // Clear current sound name
        if (this.isPlaying()) this.stop(0);
    }
    isBufferLoaded() {
        return this.player.buffer && this.player.buffer.loaded;
    }
    getUnwarpedSoundDuration() {
        if (!this.isBufferLoaded()) return 0;
        return this.player.buffer.duration;
    }
    // and not this.speed because it sometimes changes without the playback rate actually changing (needs a retrigger)
    getActualSoundDuration() {
        return this.getUnwarpedSoundDuration() / this.player.playbackRate;
    }
    isPlaying() {
        // Returns true if the player is currently playing sound, false otherwise. 
        // This is computed from the actual player node, not the "theoretical" playing state
        if (!this.isBufferLoaded()) return false;
        return this.player.state === 'started';
    }
    play(time = $56MRX.now(), slicePosition = 0) {
        // If buffer is not loaded yet, don't trigger the sound and return false
        if (!this.isBufferLoaded()) return false;
        // Configure attributes
        this.applySpeed();
        // Get info about start (needs attributes (see speed) configured)
        const position = this.start + (this.end - this.start) * slicePosition;
        const actualSoundDuration = this.getActualSoundDuration();
        const actualPositionInSeconds = position * actualSoundDuration;
        const actualDurationUntilSliceEnd = this.end * actualSoundDuration - actualPositionInSeconds;
        const unwarpedSoundDuration = this.getUnwarpedSoundDuration();
        const unwarpedPositionInSeconds = position * unwarpedSoundDuration;
        const unwarpedDurationUntilSliceEnd = this.end * unwarpedSoundDuration - unwarpedPositionInSeconds;
        // these 0.01 make it so there aren't any clicks/pops
        const fadeInTime = Math.max(0.01, this.fadeIn);
        const fadeOutTime = Math.max(0.01, this.fadeOut);
        const fadeOutStartTime = time + Math.max(0.01 + fadeInTime, actualDurationUntilSliceEnd - fadeOutTime);
        console.assert(this.fadeIn + this.fadeOut <= actualDurationUntilSliceEnd, "Fade in and out together are longer than sample slice");
        this.fadeEnvelopeGain.gain.cancelAndHoldAtTime(time); // for if there was a previous envelope scheduled
        this.fadeEnvelopeGain.gain.linearRampTo(0, 0.01, time);
        this.fadeEnvelopeGain.gain.linearRampTo(1, fadeInTime, time + 0.01);
        this.fadeEnvelopeGain.gain.linearRampTo(0, fadeOutTime, fadeOutStartTime);
        // Configure player attributes and trigger start. We trigger the sound without a duration set because the sound will be restarted anyway when required (end of the clip).
        // In this way, the player does not go to "stopped" in the middle of a beat and gets re-triggered again in a following step before the next time the sound should be 
        // actually retriggerd. This can happen if clip duration is reset while playing and due to roundings and stuff like that ¯\_(ツ)_/¯
        let playMethod = "start";
        if (this.isPlaying()) // we don't use seek (plus associated linear ramp etc) because if clip duration is changed while playing it will bug
        playMethod = "restart";
        this.player[playMethod](time, unwarpedPositionInSeconds, !this.loop ? unwarpedDurationUntilSliceEnd : undefined);
        // Adjust stuff after start
        this._doesNeedRetrigger = false;
        this.#lastTriggerData = {
            position: position,
            time: this.player.now()
        };
        return true;
    }
    stop(time) {
        if (!this.isPlaying()) return; // If the player is not currently playing, do nothing
        this.player.stop(time); // Triggering stop will add the fadeOut (release) time
    }
    get position() {
        // The Tone.js player object does not expose a "current playback position" parameter (nor does the underlying Web Audio API object).
        // Fortunately, because we only trigger the sounds in sync with the beat steps, we can estimate the playback position percentage based on
        // all sound parameters and some internal variables that we keep updated.
        if (!this.isPlaying()) return undefined;
        const speed = this.player.playbackRate; // and not this.speed because that can be changed in any moment
        if (speed === 0) return this.#lastTriggerData.position;
        const elapsedSeconds = this.player.toSeconds(this.player.now() - this.#lastTriggerData.time);
        const positionDifference = elapsedSeconds / this.getActualSoundDuration();
        return this.#lastTriggerData.position + positionDifference;
    }
    onSlicePosition(time, slicePosition) {
        const position = this.position;
        if (!this.isPlaying() || this.position < this.start || this.end < this.position || slicePosition === 0) this._doesNeedRetrigger = true;
        if (this.doesNeedRetrigger()) this.play(time, slicePosition);
    // else, it's playing and doesn't need to be retriggered
    }
    getPitchCompensationForSpeed() {
        if (this.stretchMode === $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb.STRETCH_MODES.UNSTRETCHED_REPITCH) return 0;
        if (this.stretchMode === $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb.STRETCH_MODES.UNSTRETCHED_RESPEED) return -this.transpose; // cancel out
        // If speed is 2.0 (2x), then pitch compensation should be -12 semitones (1 octave down). 
        // If speed is 0.5 (0.5x), then pitch compensation should be +12 semitones (1 octave up). 
        const speed = this.player.playbackRate; // and not this.speed because it might not be the current playback one
        return -12 * Math.log2(speed);
    }
    getSpeedCompensationForPitch() {
        if (this.stretchMode !== $7a6c9d2813b5b3bc$export$e6099ac3e53bbeeb.STRETCH_MODES.UNSTRETCHED_RESPEED) return 1;
        const pitch = this.transpose;
        return Math.pow(2, pitch / 12);
    }
}
const $7a6c9d2813b5b3bc$var$sampleLibraryManagerInstance = new $7a6c9d2813b5b3bc$var$SampleLibraryManager();

});
parcelRegister("i5EW2", function(module, exports) {

$parcel$export(module.exports, "sampleLibrary", () => $d2b872787a3a09b8$export$b61e06dad0ca864c);
const $d2b872787a3a09b8$export$b61e06dad0ca864c = {
    "sampler": [
        {
            "name": "80sdx",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/80sdx.wav"
        },
        {
            "name": "accordion",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/accordion.wav"
        },
        {
            "name": "adagio strings",
            "scale": "a:minor",
            "url": "/static/dist/public/audio/sampler/adagio strings.wav"
        },
        {
            "name": "anguish",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/anguish.wav"
        },
        {
            "name": "arpa",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/arpa.wav"
        },
        {
            "name": "bass-synth",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/bass-synth.wav"
        },
        {
            "name": "casaencantada",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/casaencantada.wav"
        },
        {
            "name": "cello suite",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/cello suite.wav"
        },
        {
            "name": "classico",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/classico.wav"
        },
        {
            "name": "dark pianos",
            "scale": "g:locrian",
            "url": "/static/dist/public/audio/sampler/dark pianos.wav"
        },
        {
            "name": "darksynth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/darksynth.wav"
        },
        {
            "name": "funkbass",
            "scale": "a:major",
            "url": "/static/dist/public/audio/sampler/funkbass.wav"
        },
        {
            "name": "gsynth",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/gsynth.wav"
        },
        {
            "name": "guit&delayfx",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/guit&delayfx.wav"
        },
        {
            "name": "guit-nostalgia",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/guit-nostalgia.wav"
        },
        {
            "name": "guitarra",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/guitarra.wav"
        },
        {
            "name": "guitarra2",
            "scale": "b:wholetone",
            "url": "/static/dist/public/audio/sampler/guitarra2.wav"
        },
        {
            "name": "guitcolo",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/guitcolo.wav"
        },
        {
            "name": "indiachant",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/indiachant.wav"
        },
        {
            "name": "industrial-noise",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/industrial-noise.wav"
        },
        {
            "name": "jazz loop",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/jazz loop.wav"
        },
        {
            "name": "jazz riff",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/jazz riff.wav"
        },
        {
            "name": "korridor",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/korridor.wav"
        },
        {
            "name": "loop basss- accordion",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/loop basss- accordion.wav"
        },
        {
            "name": "loop fluteguit",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/loop fluteguit.wav"
        },
        {
            "name": "loop synth",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/loop synth.wav"
        },
        {
            "name": "loop tuba",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/loop tuba.wav"
        },
        {
            "name": "loop-guitarra",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/loop-guitarra.wav"
        },
        {
            "name": "loop-piano01",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/loop-piano01.wav"
        },
        {
            "name": "loop-piano02",
            "scale": "db:major",
            "url": "/static/dist/public/audio/sampler/loop-piano02.wav"
        },
        {
            "name": "loop-rhodes",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/loop-rhodes.wav"
        },
        {
            "name": "loopfunk",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/loopfunk.wav"
        },
        {
            "name": "loopfunkbass",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/loopfunkbass.wav"
        },
        {
            "name": "loopguitarra",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/loopguitarra.wav"
        },
        {
            "name": "loopsoul halftruths",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/loopsoul halftruths.wav"
        },
        {
            "name": "lucianovox",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/lucianovox.wav"
        },
        {
            "name": "medievo",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/medievo.wav"
        },
        {
            "name": "met\u00e1 met\u00e1",
            "scale": "eb:minor",
            "url": "/static/dist/public/audio/sampler/met\u00e1 met\u00e1.wav"
        },
        {
            "name": "nero sud",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/nero sud.wav"
        },
        {
            "name": "nostalgia",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/nostalgia.wav"
        },
        {
            "name": "november rains",
            "scale": "eb:minor",
            "url": "/static/dist/public/audio/sampler/november rains.wav"
        },
        {
            "name": "nuovogiorno",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/nuovogiorno.wav"
        },
        {
            "name": "olho do lago",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/olho do lago.wav"
        },
        {
            "name": "orient flute",
            "scale": "ab:harmonic minor",
            "url": "/static/dist/public/audio/sampler/orient flute.wav"
        },
        {
            "name": "padflute",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/padflute.wav"
        },
        {
            "name": "palermo",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/palermo.wav"
        },
        {
            "name": "pastor champion",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/pastor champion.wav"
        },
        {
            "name": "piano & bass 02",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/piano & bass 02.wav"
        },
        {
            "name": "piano",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/piano.wav"
        },
        {
            "name": "piano chords",
            "scale": "ab:major",
            "url": "/static/dist/public/audio/sampler/piano chords.wav"
        },
        {
            "name": "piano fx",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/piano fx.wav"
        },
        {
            "name": "piano&bass",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/piano&bass.wav"
        },
        {
            "name": "piano&guitar",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/piano&guitar.wav"
        },
        {
            "name": "piano&perc",
            "scale": "db:major",
            "url": "/static/dist/public/audio/sampler/piano&perc.wav"
        },
        {
            "name": "piano-chords",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/piano-chords.wav"
        },
        {
            "name": "rhodes",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/rhodes.wav"
        },
        {
            "name": "sad pianos",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/sad pianos.wav"
        },
        {
            "name": "samba lenta",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/samba lenta.wav"
        },
        {
            "name": "see you again",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/see you again.wav"
        },
        {
            "name": "sidechainen vocals",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/sidechainen vocals.wav"
        },
        {
            "name": "sitar",
            "scale": "c#:harmonic minor",
            "url": "/static/dist/public/audio/sampler/sitar.wav"
        },
        {
            "name": "solitudini",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/solitudini.wav"
        },
        {
            "name": "soulguitar01",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/soulguitar01.wav"
        },
        {
            "name": "soulguitar02",
            "scale": "d:locrian",
            "url": "/static/dist/public/audio/sampler/soulguitar02.wav"
        },
        {
            "name": "spectralsynth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/spectralsynth.wav"
        },
        {
            "name": "strings&saxo",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/strings&saxo.wav"
        },
        {
            "name": "synth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/synth.wav"
        },
        {
            "name": "synth$strings",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/synth$strings.wav"
        },
        {
            "name": "synth-fx",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/synth-fx.wav"
        },
        {
            "name": "synth-strings",
            "scale": "a:major",
            "url": "/static/dist/public/audio/sampler/synth-strings.wav"
        },
        {
            "name": "synts-trompes",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/synts-trompes.wav"
        },
        {
            "name": "tension",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/tension.wav"
        },
        {
            "name": "toy piano",
            "scale": "f#:major",
            "url": "/static/dist/public/audio/sampler/toy piano.wav"
        },
        {
            "name": "trap",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/trap.wav"
        },
        {
            "name": "undone",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/undone.wav"
        },
        {
            "name": "vents",
            "scale": "g:locrian",
            "url": "/static/dist/public/audio/sampler/vents.wav"
        },
        {
            "name": "veus misteri",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/veus misteri.wav"
        },
        {
            "name": "vibes ambient",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/vibes ambient.wav"
        },
        {
            "name": "vocals",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/vocals.wav"
        },
        {
            "name": "whitelotus",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/whitelotus.wav"
        },
        {
            "name": "windyvocal",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/windyvocal.wav"
        }
    ],
    "groovebox": [
        {
            "name": "Funky Soul-kick",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Kick Funky Soul.wav"
        },
        {
            "name": "Funky Soul-closedHat",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Closed Hat Funky Soul.wav"
        },
        {
            "name": "Funky Soul-snare",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Snare Funky Soul.wav"
        },
        {
            "name": "Funky Soul-openHat",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Open Hat Funky Soul.wav"
        },
        {
            "name": "Hip hop Classic 2-closedHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Closed Hat HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-openHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Open Hat HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-kick",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Kick HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-snare",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Snare HipHop Classic 2.wav"
        },
        {
            "name": "Trap 2-openHat",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Open Hat Trap 2.wav"
        },
        {
            "name": "Trap 2-kick",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Kick Trap 2.wav"
        },
        {
            "name": "Trap 2-snare",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Snare Trap 2.wav"
        },
        {
            "name": "Trap 2-closedHat",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Closed Hat Trap 2.wav"
        },
        {
            "name": "Hip hop Classic 1-openHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Open Hat HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-kick",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Kick HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-closedHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Closed Hat HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-snare",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Snare HipHop Classic 1.wav"
        },
        {
            "name": "Trap 1-snare",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Clap  Trap 1.wav"
        },
        {
            "name": "Trap 1-closedHat",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Closed hat Trap 1.wav"
        },
        {
            "name": "Trap 1-kick",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Kick Trap 1.wav"
        },
        {
            "name": "Trap 1-openHat",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Open Hat trap 1.wav"
        },
        {
            "name": "Urban reggaeton-snare",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Snare Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-kick",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Kick Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-openHat",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Woodblock Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-closedHat",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Closed Hat Urban Reggaeton.wav"
        },
        {
            "name": "Soul Pop-kick",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Kick Soul Pop.wav"
        },
        {
            "name": "Soul Pop-openHat",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Tambourine Soul Pop.wav"
        },
        {
            "name": "Soul Pop-closedHat",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Closed Hat Soul Pop.wav"
        },
        {
            "name": "Soul Pop-snare",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Snare Soul Pop.wav"
        },
        {
            "name": "Dub Reggae-closedHat",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Closed Hat Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-kick",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Kick Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-snare",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Snare Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-openHat",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Open Hat Dub Reggae.wav"
        },
        {
            "name": "Acid house-snare",
            "url": "/static/dist/public/audio/groovebox/Acid house/Clap Acid House.wav"
        },
        {
            "name": "Acid house-kick",
            "url": "/static/dist/public/audio/groovebox/Acid house/Kick Acid House.wav"
        },
        {
            "name": "Acid house-openHat",
            "url": "/static/dist/public/audio/groovebox/Acid house/Open Hat Acid House.wav"
        },
        {
            "name": "Acid house-closedHat",
            "url": "/static/dist/public/audio/groovebox/Acid house/Closed Hat Acid House.wav"
        },
        {
            "name": "Reggae Roots-closedHat",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Closed Hat Reggae Roots.wav"
        },
        {
            "name": "Reggae Roots-snare",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Snare Reggae Roots.wav"
        },
        {
            "name": "Reggae Roots-openHat",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Open Hat Reggae roots.wav"
        },
        {
            "name": "Reggae Roots-kick",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Kick Reggae Roots.wav"
        }
    ]
};

});


parcelRegister("7baak", function(module, exports) {

$parcel$export(module.exports, "getPCNumber", () => $53a1722d896536e2$export$622a5eaba15d664d);
$parcel$export(module.exports, "getNoteName", () => $53a1722d896536e2$export$393c02f51657ff86);
$parcel$export(module.exports, "getScaleRootAndType", () => $53a1722d896536e2$export$a0a903cbea860f80);
$parcel$export(module.exports, "getScaleDisplayName", () => $53a1722d896536e2$export$af103f9f5ef1475b);
$parcel$export(module.exports, "isScaleCompatibleWith", () => $53a1722d896536e2$export$f2ecc9a4e94aac03);
$parcel$export(module.exports, "getPCsFromScaleName", () => $53a1722d896536e2$export$3d9505afb8b9911c);
$parcel$export(module.exports, "getTranspositionForScaleToMatchTonality", () => $53a1722d896536e2$export$3ecadef291e83426);
$parcel$export(module.exports, "transposeScale", () => $53a1722d896536e2$export$7ddd9b1c122f3172);
$parcel$export(module.exports, "getScaleForSampleName", () => $53a1722d896536e2$export$2afc506ecd4b1ea3);
$parcel$export(module.exports, "buildScaleFromRootPitch", () => $53a1722d896536e2$export$9747b9860c3dac04);
$parcel$export(module.exports, "calcDiatonicInterval", () => $53a1722d896536e2$export$1f4a895e08027217);
$parcel$export(module.exports, "getNextPitchClassAfterPitch", () => $53a1722d896536e2$export$5af211050ec2c566);

var $hOWXx = parcelRequire("hOWXx");

var $i5EW2 = parcelRequire("i5EW2");
const $53a1722d896536e2$var$DIATONIC_MAJOR = [
    0,
    2,
    4,
    5,
    7,
    9,
    11
];
const $53a1722d896536e2$var$SCALES = {
    major: "1P 2M 3M 4P 5P 6M 7M",
    minor: "1P 2M 3m 4P 5P 6m 7m",
    wholetone: "1P 2M 3M 4A 5A 6A",
    locrian: "1P 2m 3m 4P 5d 6m 7m",
    "harmonic minor": "1P 2M 3m 4P 5P 6m 7M"
};
const $53a1722d896536e2$export$622a5eaba15d664d = (pcName)=>{
    return ({
        'c': 0,
        'c#': 1,
        'db': 1,
        'd': 2,
        'd#': 3,
        'eb': 3,
        'e': 4,
        'f': 5,
        'f#': 6,
        'gb': 6,
        'g': 7,
        'g#': 8,
        'ab': 8,
        'a': 9,
        'a#': 10,
        'bb': 10,
        'b': 11
    })[pcName.toLowerCase()];
};
const $53a1722d896536e2$var$wrappedPCNumber = (pcNumber)=>{
    pcNumber = pcNumber % 12;
    if (pcNumber < 0) return pcNumber + 12;
    if (pcNumber >= 12) return pcNumber - 12;
    return pcNumber;
};
const $53a1722d896536e2$var$getPCName = (pcNumber)=>{
    return ({
        0: 'C',
        1: 'C#',
        2: 'D',
        3: 'Eb',
        4: 'E',
        5: 'F',
        6: 'F#',
        7: 'G',
        8: 'Ab',
        9: 'A',
        10: 'Bb',
        11: 'B'
    })[pcNumber];
};
const $53a1722d896536e2$export$393c02f51657ff86 = (pitch, octaveAdjustment = -1)=>{
    const octaveNumber = (pitch / 12 | 0) + octaveAdjustment;
    const letter = $53a1722d896536e2$var$getPCName(pitch % 12);
    return letter + octaveNumber;
};
const $53a1722d896536e2$export$a0a903cbea860f80 = (scaleName)=>{
    const [root, type] = scaleName.split(":");
    return {
        root: root,
        type: type
    };
};
const $53a1722d896536e2$var$makeScaleName = (pcName, scaleType)=>{
    return `${pcName}:${scaleType}`;
};
const $53a1722d896536e2$export$af103f9f5ef1475b = (scale)=>{
    const { root: root, type: type } = $53a1722d896536e2$export$a0a903cbea860f80(scale.toLowerCase());
    const rootDisplayName = (0, $hOWXx.capitalizeFirstLetter)(root);
    let typeDisplayName = " " + type;
    if (type === "major") typeDisplayName = "";
    else if (type === "minor") typeDisplayName = "-";
    return rootDisplayName + typeDisplayName;
};
const $53a1722d896536e2$export$f2ecc9a4e94aac03 = (scale1, scale2)=>{
    if (scale1 == null || scale2 == null) return false;
    const scale1PC = $53a1722d896536e2$export$3d9505afb8b9911c(scale1);
    const scale2PC = $53a1722d896536e2$export$3d9505afb8b9911c(scale2);
    return scale1PC.isSubsetOf(scale2PC);
};
const $53a1722d896536e2$export$3ecadef291e83426 = (scale, tonality)=>{
    if (scale === tonality) return 0;
    const { root: scaleRoot, type: scaleType } = $53a1722d896536e2$export$a0a903cbea860f80(scale);
    const { root: tonalityRoot, type: tonalityType } = $53a1722d896536e2$export$a0a903cbea860f80(tonality);
    const majorTonalityOffsetForScaleType = {
        major: 0,
        minor: -3,
        "harmonic minor": -3,
        locrian: -1
    };
    let offset1 = majorTonalityOffsetForScaleType[scaleType];
    if (offset1 != null && tonalityType === "minor") offset1 += 3;
    offset1 ??= 0;
    const scaleRootPC = $53a1722d896536e2$export$622a5eaba15d664d(scaleRoot);
    const tonalityRootPC = $53a1722d896536e2$export$622a5eaba15d664d(tonalityRoot);
    offset1 += tonalityRootPC - scaleRootPC;
    offset1 = (offset1 % 12 + 12) % 12;
    if (offset1 > 6) offset1 = offset1 - 12;
    return offset1;
};
const $53a1722d896536e2$export$7ddd9b1c122f3172 = (scaleName, semitones)=>{
    if (scaleName === undefined) return undefined;
    const { root: pcName, type: type } = $53a1722d896536e2$export$a0a903cbea860f80(scaleName);
    let newPCNumber = $53a1722d896536e2$var$wrappedPCNumber($53a1722d896536e2$export$622a5eaba15d664d(pcName) + semitones);
    return $53a1722d896536e2$var$makeScaleName($53a1722d896536e2$var$getPCName(newPCNumber), type);
};
const $53a1722d896536e2$export$2afc506ecd4b1ea3 = (sampleName = "")=>{
    if (sampleName === "") return undefined;
    const sound = (0, $i5EW2.sampleLibrary).sampler.find((sound)=>sound.name.toLowerCase() === sampleName.toLowerCase());
    if (sound) return sound.scale;
};
const $53a1722d896536e2$export$3d9505afb8b9911c = (scale)=>{
    const { root: root, type: type } = $53a1722d896536e2$export$a0a903cbea860f80(scale);
    const rootPC = $53a1722d896536e2$export$622a5eaba15d664d(root);
    return new Set($53a1722d896536e2$export$9747b9860c3dac04(rootPC, type).map((pitch)=>pitch % 12));
};
const $53a1722d896536e2$export$9747b9860c3dac04 = (rootPitch, scaleType = "major")=>{
    return [
        0,
        ...$53a1722d896536e2$var$SCALES[scaleType].split(" ").map((diatonicInterval)=>$53a1722d896536e2$var$diatonicToChromatic(diatonicInterval))
    ].map((interval)=>rootPitch + interval);
};
const $53a1722d896536e2$var$ascii = (a)=>a.charCodeAt(0);
const $53a1722d896536e2$var$getWhiteNote = (noteClass1)=>noteClass1.slice(0, 1) + noteClass1.slice(1).replaceAll('#', '').replaceAll('b', '');
const $53a1722d896536e2$var$getScaleDegreeOfNoteClass = (noteClass1, rootNoteClass)=>{
    const rootWhiteAscii = $53a1722d896536e2$var$ascii($53a1722d896536e2$var$getWhiteNote(rootNoteClass));
    const noteWhiteAscii = $53a1722d896536e2$var$ascii($53a1722d896536e2$var$getWhiteNote(noteClass1));
    return noteWhiteAscii - rootWhiteAscii + (rootWhiteAscii > noteWhiteAscii ? 7 : 0);
};
const $53a1722d896536e2$var$separateNoteClassAndOctave = (compoundNote)=>{
    return [
        compoundNote.slice(0, -1),
        compoundNote.slice(-1)
    ];
};
const $53a1722d896536e2$var$noteStrToMidi = (noteStr)=>{
    [noteClass, octave] = $53a1722d896536e2$var$separateNoteClassAndOctave(noteStr);
    return $53a1722d896536e2$export$622a5eaba15d664d(noteClass) + (octave + 1) * 12;
};
const $53a1722d896536e2$export$1f4a895e08027217 = (note1, note2)=>{
    const semitoneDiff = note2 - note1;
    const directionMultiplier = semitoneDiff < 0 ? -1 : 1; // for when it's downwards
    const absModSemitoneDiff = Math.abs(semitoneDiff) % 12;
    const octaveDiff = Math.floor(Math.abs(semitoneDiff) / 12);
    const [absModQuantity, quality] = {
        0: [
            0,
            'P'
        ],
        1: [
            1,
            'm'
        ],
        2: [
            1,
            'M'
        ],
        3: [
            2,
            'm'
        ],
        4: [
            2,
            'M'
        ],
        5: [
            3,
            'P'
        ],
        6: [
            4,
            'd'
        ],
        7: [
            4,
            'P'
        ],
        8: [
            5,
            'm'
        ],
        9: [
            5,
            'M'
        ],
        10: [
            6,
            'm'
        ],
        11: [
            6,
            'M'
        ]
    }[absModSemitoneDiff];
    const quantity = directionMultiplier * (absModQuantity + 7 * octaveDiff);
    return [
        quantity,
        quality
    ];
};
const $53a1722d896536e2$var$diatonicToChromatic = (diatonicInterval)=>{
    const quality = diatonicInterval.slice(-1);
    const number = Number(diatonicInterval.slice(0, -1));
    const tonalIntervalQualities = {
        'A': 1,
        'P': 0,
        'd': -1
    };
    const modalIntervalQualities = {
        'A': 1,
        'M': 0,
        'm': -1,
        'd': -2
    };
    const isTonal = number === 1 || number === 4 || number === 5;
    offset = (isTonal ? tonalIntervalQualities : modalIntervalQualities)[quality];
    const majorOrJust = $53a1722d896536e2$var$DIATONIC_MAJOR[number - 1];
    const chromatic = majorOrJust + offset;
    return chromatic;
};
const $53a1722d896536e2$export$5af211050ec2c566 = (pitchClass, midiPitch)=>{
    return midiPitch - midiPitch % 12 + pitchClass + (midiPitch % 12 <= pitchClass ? 0 : 12);
};

});

parcelRegister("2cXDZ", function(module, exports) {

$parcel$export(module.exports, "white", () => $19baf7d256490793$export$8fa4e5556fd77a60, (v) => $19baf7d256490793$export$8fa4e5556fd77a60 = v);
$parcel$export(module.exports, "grey", () => $19baf7d256490793$export$e4c89085febbc618, (v) => $19baf7d256490793$export$e4c89085febbc618 = v);
$parcel$export(module.exports, "darkGrey", () => $19baf7d256490793$export$59d29cdd58a23868, (v) => $19baf7d256490793$export$59d29cdd58a23868 = v);
$parcel$export(module.exports, "lightGrey", () => $19baf7d256490793$export$8c430709db82137d, (v) => $19baf7d256490793$export$8c430709db82137d = v);
$parcel$export(module.exports, "black", () => $19baf7d256490793$export$c073df10e766abfa, (v) => $19baf7d256490793$export$c073df10e766abfa = v);
$parcel$export(module.exports, "red", () => $19baf7d256490793$export$a90204d1394caf30, (v) => $19baf7d256490793$export$a90204d1394caf30 = v);
$parcel$export(module.exports, "deepRed", () => $19baf7d256490793$export$962eb94b7085afc1, (v) => $19baf7d256490793$export$962eb94b7085afc1 = v);
$parcel$export(module.exports, "lightRed", () => $19baf7d256490793$export$2f95049e6b041020, (v) => $19baf7d256490793$export$2f95049e6b041020 = v);
$parcel$export(module.exports, "orange", () => $19baf7d256490793$export$ad766f34ace1cafd, (v) => $19baf7d256490793$export$ad766f34ace1cafd = v);
$parcel$export(module.exports, "paleOrange", () => $19baf7d256490793$export$58097cc38e987c87, (v) => $19baf7d256490793$export$58097cc38e987c87 = v);
$parcel$export(module.exports, "amber", () => $19baf7d256490793$export$7c1ecc66643fdbd6, (v) => $19baf7d256490793$export$7c1ecc66643fdbd6 = v);
$parcel$export(module.exports, "yellow", () => $19baf7d256490793$export$594c5a8758200c32, (v) => $19baf7d256490793$export$594c5a8758200c32 = v);
$parcel$export(module.exports, "green", () => $19baf7d256490793$export$955a2ebd2fb142ae, (v) => $19baf7d256490793$export$955a2ebd2fb142ae = v);
$parcel$export(module.exports, "turquoise", () => $19baf7d256490793$export$ce5ab05930505cc3, (v) => $19baf7d256490793$export$ce5ab05930505cc3 = v);
$parcel$export(module.exports, "blue", () => $19baf7d256490793$export$2aa0182783e7e9de, (v) => $19baf7d256490793$export$2aa0182783e7e9de = v);
$parcel$export(module.exports, "violet", () => $19baf7d256490793$export$8241b7126941c403, (v) => $19baf7d256490793$export$8241b7126941c403 = v);
$parcel$export(module.exports, "deepViolet", () => $19baf7d256490793$export$f24d4400be59e6a8, (v) => $19baf7d256490793$export$f24d4400be59e6a8 = v);
$parcel$export(module.exports, "lightViolet", () => $19baf7d256490793$export$59cff3ed0f44c758, (v) => $19baf7d256490793$export$59cff3ed0f44c758 = v);
$parcel$export(module.exports, "pink", () => $19baf7d256490793$export$47853bc718611763, (v) => $19baf7d256490793$export$47853bc718611763 = v);
var $19baf7d256490793$export$8fa4e5556fd77a60;
var $19baf7d256490793$export$e4c89085febbc618;
var $19baf7d256490793$export$59d29cdd58a23868;
var $19baf7d256490793$export$8c430709db82137d;
var $19baf7d256490793$export$c073df10e766abfa;
var $19baf7d256490793$export$a90204d1394caf30;
var $19baf7d256490793$export$962eb94b7085afc1;
var $19baf7d256490793$export$2f95049e6b041020;
var $19baf7d256490793$export$ad766f34ace1cafd;
var $19baf7d256490793$export$58097cc38e987c87;
var $19baf7d256490793$export$7c1ecc66643fdbd6;
var $19baf7d256490793$export$594c5a8758200c32;
var $19baf7d256490793$export$955a2ebd2fb142ae;
var $19baf7d256490793$export$ce5ab05930505cc3;
var $19baf7d256490793$export$2aa0182783e7e9de;
var $19baf7d256490793$export$8241b7126941c403;
var $19baf7d256490793$export$f24d4400be59e6a8;
var $19baf7d256490793$export$59cff3ed0f44c758;
var $19baf7d256490793$export$47853bc718611763;
$19baf7d256490793$export$8fa4e5556fd77a60 = "#fffffe";
$19baf7d256490793$export$e4c89085febbc618 = "#a3a3a3";
$19baf7d256490793$export$59d29cdd58a23868 = "#565656";
$19baf7d256490793$export$8c430709db82137d = "#eaeaea";
$19baf7d256490793$export$c073df10e766abfa = "#232326";
$19baf7d256490793$export$a90204d1394caf30 = "#ff5266";
$19baf7d256490793$export$962eb94b7085afc1 = "#e5233f";
$19baf7d256490793$export$2f95049e6b041020 = "#ff97a3";
$19baf7d256490793$export$ad766f34ace1cafd = "#ff9933";
$19baf7d256490793$export$58097cc38e987c87 = "#fdd1ac";
$19baf7d256490793$export$7c1ecc66643fdbd6 = "#ffc933";
$19baf7d256490793$export$594c5a8758200c32 = "#fff233";
$19baf7d256490793$export$955a2ebd2fb142ae = "#8bee8f";
$19baf7d256490793$export$ce5ab05930505cc3 = "#33cccc";
$19baf7d256490793$export$2aa0182783e7e9de = "#66c5ee";
$19baf7d256490793$export$8241b7126941c403 = "#d350dd";
$19baf7d256490793$export$f24d4400be59e6a8 = "#9e3ca6";
$19baf7d256490793$export$59cff3ed0f44c758 = "#e596eb";
$19baf7d256490793$export$47853bc718611763 = "#ff438f";

});

parcelRegister("k5Mle", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea09c5e237c0538e$export$2e2bcd8739ae039);

var $iwKMG = parcelRequire("iwKMG");

var $6y8B8 = parcelRequire("6y8B8");

var $6hcfC = parcelRequire("6hcfC");

var $i5Wwc = parcelRequire("i5Wwc");

var $3kJKP = parcelRequire("3kJKP");

var $gpyea = parcelRequire("gpyea");

var $belQo = parcelRequire("belQo");

var $avlJO = parcelRequire("avlJO");

var $lx6dm = parcelRequire("lx6dm");

var $5RRBq = parcelRequire("5RRBq");
var $ea09c5e237c0538e$export$2e2bcd8739ae039 = [
    (0, $iwKMG.Synth),
    (0, $6y8B8.GrooveBox),
    (0, $6hcfC.Piano),
    (0, $i5Wwc.Baix),
    (0, $3kJKP.Sampler),
    (0, $gpyea.SynthWam),
    (0, $belQo.SynthBassWam),
    (0, $avlJO.PianoWam),
    (0, $5RRBq.PianoSoundFont),
    (0, $lx6dm.Looper)
];

});
parcelRegister("iwKMG", function(module, exports) {

$parcel$export(module.exports, "Synth", () => $d7cf8189d9e5ccca$export$8ef26ca8e8d9bf70);

var $lQ6pU = parcelRequire("lQ6pU");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $g8sjx = parcelRequire("g8sjx");

var $enQqi = parcelRequire("enQqi");
parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");
var $1ZLI2 = parcelRequire("1ZLI2");
var $aZf7A = parcelRequire("aZf7A");

var $2cXDZ = parcelRequire("2cXDZ");

var $95CQM = parcelRequire("95CQM");

var $2Zbj1 = parcelRequire("2Zbj1");
class $d7cf8189d9e5ccca$export$8ef26ca8e8d9bf70 extends (0, $lQ6pU.BaseSynth) {
    static metadata = {
        tipus: 'synth',
        tipusDisplay: 'Synth Legacy',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).red,
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        fx_distortion_isActive: {
            type: 'bool',
            initial: true,
            bind: "preset"
        },
        fx_distortion_amount: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.0,
            bind: "preset"
        },
        env_attack: {
            ...super.parametersDescription.env_attack,
            initial: 1.2
        },
        env_decay: {
            ...super.parametersDescription.env_decay,
            initial: 2.0
        },
        env_sustain: {
            ...super.parametersDescription.env_sustain,
            initial: 0.8
        },
        env_release: {
            ...super.parametersDescription.env_release,
            initial: 2.0
        },
        lpf_cutoff: {
            ...super.parametersDescription.lpf_cutoff,
            initial: 1400
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {
            min: 60,
            max: 83
        }
    };
    getUserInterfaceComponent() {
        return 0, $g8sjx.SynthUI;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph({
            poly: true
        });
    }
    addEffectChainNodes(audioInput, audioOutput) {
        this.distortionNode = new (0, $2Zbj1.FXWrapper)((0, $1ZLI2.Distortion), {
            postgain: 1,
            isActive: (0, $95CQM.staticSelect)(this.getPlaybackParameterSelector("fx_distortion_isActive"))
        });
        audioInput.chain(this.distortionNode, audioOutput);
        super.addEffectChainNodes(audioInput, audioOutput);
    }
    setParameterInAudioGraph(name, value) {
        if (name == "fx_distortion_amount") {
            this.distortionNode.set({
                'wet': 0.5
            });
            this.distortionNode.set({
                'distortion': value
            });
            const makeupGain = (0, $bmU6v.dbToGain)(-1 * Math.pow(value, 0.25) * 6); // He ajustat aquests valors manualment perquè el crossfade em sonés bé
            this.distortionNode.postgain.set({
                'gain': makeupGain
            });
        } else if (name == "fx_distortion_isActive") {
            if (value) this.distortionNode.activate();
            else this.distortionNode.deactivate();
        } else super.setParameterInAudioGraph(name, value);
        return true;
    }
    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.synth.releaseAll();
    }
    onStopAllSounds() {
        // Stop all notes, and set env_release time to 0
        this.setParameterInAudioGraph('env_release', 0.0);
        this.audioNodes.synth.releaseAll();
        this.setParameterInAudioGraph('env_release', (0, $95CQM.staticSelect)(this.getDisplayParameterSelector('env_release')));
    }
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        pitch = this.adjustPitchToInstrumentRange(pitch);
        let soundingPitch = this.adjustPitchForWaveform(pitch);
        soundingPitch += this.getPlaybackParameterValue("osc_octave") * 12;
        const frequency = (0, $aZf7A.Frequency)(soundingPitch, "midi");
        if (!noteOff) this.audioNodes.synth.triggerAttack([
            frequency
        ], undefined, midiVelocity / 127);
        else this.audioNodes.synth.triggerRelease([
            frequency
        ]);
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("lQ6pU", function(module, exports) {

$parcel$export(module.exports, "BaseSynth", () => $fe636e8bceb2a919$export$917fbc770bf5791d);
parcelRequire("56MRX");
var $dDgqq = parcelRequire("dDgqq");
var $82Hwq = parcelRequire("82Hwq");
var $aZf7A = parcelRequire("aZf7A");
var $lNxm0 = parcelRequire("lNxm0");
var $kNUCa = parcelRequire("kNUCa");
var $ksj9M = parcelRequire("ksj9M");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $huphW = parcelRequire("huphW");

var $enQqi = parcelRequire("enQqi");

var $ibyLL = parcelRequire("ibyLL");

var $1zQag = parcelRequire("1zQag");
parcelRequire("95CQM");
class $fe636e8bceb2a919$export$917fbc770bf5791d extends (0, $hmjjw.InstrumentBase) {
    poly = false;
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        ...(0, $ibyLL.PianoRoller).parametersDescription,
        // Synth params
        env_attack: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 2.0,
            initial: 0.01,
            bind: "preset"
        },
        env_decay: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 0.01,
            bind: "preset"
        },
        env_sustain: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 1.0,
            bind: "preset"
        },
        env_release: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 0.01,
            bind: "preset"
        },
        osc_waveform: {
            type: 'enum',
            options: [
                'sine',
                'triangle',
                'square',
                'sawtooth'
            ],
            initial: 'sawtooth',
            bind: "preset"
        },
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 100,
            max: 15000,
            initial: 15000,
            logarithmic: true,
            bind: "preset"
        },
        lpf_q: {
            type: 'float',
            min: 0.0,
            max: 100.0,
            initial: 0.0,
            bind: "preset"
        },
        hpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 10,
            max: 3000,
            initial: 10,
            logarithmic: true,
            bind: "preset"
        },
        osc_detune: {
            type: 'float',
            min: 0.95,
            max: 1.05,
            initial: 1.0,
            bind: "preset"
        },
        lfo_rate: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 0.1,
            max: 50.0,
            initial: 0.5,
            logarithmic: true,
            bind: "preset"
        },
        lfo_depth: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.0,
            bind: "preset"
        },
        osc_octave: {
            type: 'int',
            min: -2,
            max: 2,
            step: 1,
            initial: 0,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange
    };
    async buildInstrumentAudioGraph({ poly: poly }) {
        await super.buildInstrumentAudioGraph();
        this.poly = poly;
        // Creem els nodes del graph i els connectem entre ells
        const hpf = new $82Hwq.Filter((0, $1zQag.limitToNyquist)(6000), "highpass", -24);
        const lpf = new $82Hwq.Filter((0, $1zQag.limitToNyquist)(15000), "lowpass", -24);
        const synth = poly ? new $ksj9M.PolySynth($kNUCa.MonoSynth) : new $dDgqq.DuoSynth();
        const lfo = new $lNxm0.LFO({
            amplitude: 1.0,
            max: (0, $1zQag.limitToNyquist)(15000),
            min: 0
        });
        lpf.connect(hpf);
        synth.connect(lpf);
        // Settejem alguns paràmetres inicials que no canviaran
        if (poly) {
            synth.maxPolyphony = this.constructor.maxPolyphony;
            synth.set({
                attackCurve: "exponential",
                decayCurve: "exponential",
                releaseCurve: "exponential",
                volume: -20 // Avoid clipping, specially when using sine
            });
        } else synth.set({
            vibratoAmount: 0.0,
            voice0: {
                attackCurve: "exponential",
                decayCurve: "exponential",
                releaseCurve: "exponential"
            },
            voice1: {
                attackCurve: "exponential",
                decayCurve: "exponential",
                releaseCurve: "exponential"
            },
            volume: -20
        });
        // LFO can't be connected to an underlying voice of a poly synth, so we connect it to the main lpf filter
        lfo.connect(lpf.frequency);
        lfo.start();
        // Afegeix els nodes al diccionari de nodes de l'instrument
        this.audioNodes = {
            synth: synth,
            hpf: hpf,
            lpf: lpf,
            lfo: lfo
        };
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(hpf, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "lpf_cutoff":
                value = (0, $1zQag.limitToNyquist)(value);
                if (this.poly) {
                    this.audioNodes.synth.set({
                        'filterEnvelope': {
                            'baseFrequency': value
                        }
                    });
                    this.audioNodes.lpf.set({
                        'frequency': value
                    });
                } else this.audioNodes.synth.set({
                    voice0: {
                        'filterEnvelope': {
                            'baseFrequency': value
                        }
                    },
                    voice1: {
                        'filterEnvelope': {
                            'baseFrequency': value
                        }
                    }
                });
                break;
            case "hpf_cutoff":
                this.audioNodes.hpf.frequency.rampTo((0, $1zQag.limitToNyquist)(value), 0.01);
                break;
            case "lpf_q":
                if (this.poly) this.audioNodes.synth.set({
                    'filter': {
                        'Q': value
                    }
                });
                else this.audioNodes.synth.set({
                    voice0: {
                        'filter': {
                            'Q': value
                        }
                    },
                    voice1: {
                        'filter': {
                            'Q': value
                        }
                    }
                });
                break;
            case "lfo_rate":
                this.audioNodes.lfo.set({
                    'frequency': (0, $1zQag.limitToNyquist)(value)
                });
                break;
            case "lfo_depth":
                this.audioNodes.lfo.set({
                    'amplitude': value
                });
                break;
            case "osc_detune":
                if (!this.poly) // This is only available when using DuoSynth
                this.audioNodes.synth.set({
                    'harmonicity': value
                });
                break;
            case "env_attack":
            case "env_decay":
            case "env_sustain":
            case "env_release":
                const internalName = name.replace("env_", "");
                if (this.poly) this.audioNodes.synth.set({
                    'envelope': {
                        [internalName]: value
                    },
                    'filterEnvelope': {
                        [internalName]: value
                    }
                });
                else this.audioNodes.synth.set({
                    voice0: {
                        'envelope': {
                            [internalName]: value
                        },
                        'filterEnvelope': {
                            [internalName]: value
                        }
                    },
                    voice1: {
                        'envelope': {
                            [internalName]: value
                        },
                        'filterEnvelope': {
                            [internalName]: value
                        }
                    }
                });
                break;
            case "osc_waveform":
                if (this.poly) this.audioNodes.synth.set({
                    'oscillator': {
                        type: value
                    }
                });
                else this.audioNodes.synth.set({
                    voice0: {
                        'oscillator': {
                            type: value
                        }
                    },
                    voice1: {
                        'oscillator': {
                            type: value
                        }
                    }
                });
                break;
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                const velocity = (note.velocity ?? 127) / 127;
                let pitch = note.pitch;
                if (this.isMono) pitch = this.adjustPitchForWaveform(pitch);
                pitch += this.getPlaybackParameterValue("osc_octave") * 12;
                this.audioNodes.synth.triggerAttackRelease($aZf7A.Frequency(pitch, "midi"), duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime(), time, velocity);
            }
        }
    }
    adjustPitchForWaveform(pitch) {
        const waveform = this.getPlaybackParameterValue('osc_waveform');
        if (waveform === 'sine' || waveform === 'triangle') return pitch + 12;
        return pitch;
    }
    adjustPitchToInstrumentRange(pitch) {
        const minPitch = this.pitchRange.usable.min;
        const maxPitch = this.pitchRange.usable.max;
        // If note is outside range, make it be inside the range by wraping octaves
        if (pitch < minPitch) {
            const semitonesBelow = (pitch - minPitch) % 12;
            pitch = minPitch + semitonesBelow + 12;
        }
        if (pitch > maxPitch) {
            const semitonesAbove = (pitch - maxPitch) % 12;
            pitch = maxPitch + semitonesAbove - 12;
        }
        return pitch;
    }
}

});
parcelRegister("hmjjw", function(module, exports) {

$parcel$export(module.exports, "InstrumentBase", () => $ca3379158ae0f5a0$export$53233a09ca4736e9);
parcelRequire("56MRX");
var $1x3k0 = parcelRequire("1x3k0");
var $bmU6v = parcelRequire("bmU6v");
var $1Uvh8 = parcelRequire("1Uvh8");

var $huphW = parcelRequire("huphW");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $enQqi = parcelRequire("enQqi");

var $95CQM = parcelRequire("95CQM");
parcelRequire("hOWXx");

var $5ICqB = parcelRequire("5ICqB");

var $dkYqL = parcelRequire("dkYqL");

var $2Zbj1 = parcelRequire("2Zbj1");

var $hysHW = parcelRequire("hysHW");

var $2cXDZ = parcelRequire("2cXDZ");

var $3wfoi = parcelRequire("3wfoi");

var $9BokY = parcelRequire("9BokY");

var $kmdF6 = parcelRequire("kmdF6");

var $kU8gq = parcelRequire("kU8gq");
class $ca3379158ae0f5a0$export$53233a09ca4736e9 {
    static metadata = {
        tipus: 'base',
        tipusDisplay: 'Base Instrument',
        versio: '0.0',
        descripcio: "El millor instrument de la hist\xf2ria dels instruments, el m\xe9s vers\xe0til i el que tot ho pot fer. \xc9s tan bo que no t\xe9 ni un so propi, perqu\xe8 pot ser qualsevol so que vulguis!",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).grey,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...(0, $hysHW.GrufBus).parametersDescription,
        clipNumber: {
            type: 'int',
            min: 0,
            max: 3,
            initial: 0
        },
        presetID: {
            type: 'string',
            initial: 'init'
        },
        isRecordArmed: {
            type: 'bool',
            initial: false,
            local: true
        },
        fx_EQ_isActive: {
            type: 'bool',
            initial: false,
            bind: "preset"
        },
        fx_EQ_low: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -12,
            max: 12,
            initial: 0.0,
            bind: "preset"
        },
        fx_EQ_mid: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -12,
            max: 12,
            initial: 0.0,
            bind: "preset"
        },
        fx_EQ_high: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -12,
            max: 12,
            initial: 0.0,
            bind: "preset"
        },
        send_reverbA: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -60,
            max: 6,
            initial: -60,
            bind: "preset"
        },
        send_reverbB: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -60,
            max: 6,
            initial: -60,
            bind: "preset"
        },
        send_delayA: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -60,
            max: 6,
            initial: -60,
            bind: "preset"
        },
        send_delayB: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
            min: -60,
            max: 6,
            initial: -60,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        usable: {
            min: 0,
            max: 127
        }
    };
    static numClips = 4;
    static defaultClipLength = 32;
    static makeDefaultName() {
        const sameTipusNumber = Object.values((0, $95CQM.staticSelect)((0, $5ICqB.selectInstruments))).filter((value)=>value.tipus === this.metadata.tipus).length;
        return `${this.metadata.tipusDisplay} ${sameTipusNumber + 1}`;
    }
    static createInitialStateObject() {
        return {
            tipus: this.metadata.tipus,
            versio: this.metadata.versio,
            name: this.makeDefaultName(),
            parameters: Object.fromEntries([
                ...Object.entries(this.parametersDescription)
            ].filter(([_key, value])=>value.bind == null) // only unbound parameters
            .map(([key, value])=>[
                    key,
                    value.initial
                ])),
            clips: Array(this.numClips).fill().map(()=>({
                    sequence: this.metadata.tipus !== "looper" ? [] : undefined,
                    length: this.defaultClipLength,
                    sound: this.metadata.tipus === "looper" ? {} : undefined,
                    _metadata: {
                        instrumentType: this.metadata.tipus
                    }
                }))
        };
    }
    // some getters for static fields
    get metadata() {
        return this.constructor.metadata;
    }
    get parametersDescription() {
        return this.constructor.parametersDescription;
    }
    get pitchRange() {
        return this.constructor.pitchRange;
    }
    get defaultClipLength() {
        return this.constructor.defaultClipLength;
    }
    static maxPolyphony = 6;
    audioNodes = {};
    volatileState = {};
    constructor(id){
        this.id = id;
    }
    // Helper functions for parameters
    getParameterDescription = (parameterName)=>this.parametersDescription[parameterName];
    isParameterBoundToPresets = (parameterName)=>this.getParameterDescription(parameterName).bind === "preset";
    isParameterBoundToClips = (parameterName)=>this.getParameterDescription(parameterName).bind === "clip";
    getInitPreset = ()=>Object.fromEntries([
            ...Object.entries(this.parametersDescription).filter(([_parameterName, { bind: bind }])=>bind === "preset").map(([parameterName, { initial: initial }])=>[
                    parameterName,
                    initial
                ]),
            [
                "_metadata",
                {
                    name: "Init",
                    isFactory: true,
                    instrumentType: this.metadata.tipus
                }
            ]
        ]);
    ///////////////////////
    // STORE: SELECTORS
    //////////////////////
    getStateSelector = ()=>(state)=>state.project.instruments[this.id];
    getNameSelector = ()=>(0, $dkYqL.createSelector)(this.getStateSelector(), (selfState)=>selfState.name);
    getClipsSelector = ()=>(0, $dkYqL.createSelector)(this.getStateSelector(), (selfState)=>selfState.clips);
    _getParameterSelector(parameterName, { presetIDSelector: presetIDSelector, clipNumberSelector: clipNumberSelector } = {}) {
        if (this.getParameterDescription(parameterName) === undefined) throw new Error(`Parameter ${parameterName} doesn't exist!`);
        if (this.isParameterBoundToPresets(parameterName)) {
            if (presetIDSelector == null) throw new Error(`The parameter ${parameterName} needs a preset ID!`);
            return (0, $dkYqL.createSelector)((0, $5ICqB.selectPresets), presetIDSelector, (presets, presetID)=>{
                const preset = presetID === "init" ? this.getInitPreset() : presets[presetID];
                return preset[parameterName] ?? this.getParameterDescription(parameterName).initial;
            });
        }
        if (this.isParameterBoundToClips(parameterName)) {
            if (clipNumberSelector == null) throw new Error(`The parameter ${parameterName} needs a clip number!`);
            // TODO: ".sound" is hardcoded. would be nice to be able to drill parameters.
            return (0, $dkYqL.createSelector)(this.getClipsSelector(), clipNumberSelector, (clips, clipNumber)=>{
                const clip = clips[clipNumber];
                return clip.sound[parameterName] ?? this.getParameterDescription(parameterName).initial;
            });
        }
        return (0, $dkYqL.createSelector)(this.getStateSelector(), (selfState)=>selfState.parameters[parameterName]);
    }
    // Selectors: DISPLAY STUFF
    // todo: we should memoize this so that it doesn't recompute ever time it asks for it
    getDisplayParameterSelector = (parameterName)=>{
        if (parameterName === "presetID" || parameterName === "clipNumber") return this._getParameterSelector(parameterName);
        return this._getParameterSelector(parameterName, {
            presetIDSelector: this.getDisplayParameterSelector("presetID"),
            clipNumberSelector: this.getDisplayParameterSelector("clipNumber")
        });
    };
    getDisplayClipSelector = ()=>(0, $dkYqL.createSelector)(this.getDisplayParameterSelector("clipNumber"), this.getClipsSelector(), (clipNumber, clips)=>clips[clipNumber]);
    getDisplaySequenceSelector = ()=>(0, $dkYqL.createSelector)(this.getDisplayClipSelector(), (clip)=>clip.sequence);
    getDisplayClipLengthSelector = ()=>(0, $dkYqL.createSelector)(this.getDisplayClipSelector(), (clip)=>clip.length);
    // Selectors: PLAYBACK STUFF
    getPlaybackParameterSelector = (parameterName)=>{
        if (parameterName === "presetID" || parameterName === "clipNumber") return (0, $dkYqL.createSelector)((0, $5ICqB.selectPlaybackMode), this.getDisplayParameterSelector(parameterName), (0, $5ICqB.selectlaunchedSlots), (0, $5ICqB.selectScenes), (playbackMode, displayParameter, launchedSlots, scenes)=>{
            if (playbackMode === "followInstruments") return displayParameter;
            const scene = launchedSlots[this.id].currentScene;
            if (!scene) return undefined;
            return scenes[scene].slots[this.id][parameterName]; // either clipNumber or presetID
        });
        return this._getParameterSelector(parameterName, {
            presetIDSelector: this.getPlaybackParameterSelector("presetID"),
            clipNumberSelector: this.getPlaybackParameterSelector("clipNumber")
        });
    };
    getPlaybackPresetSelector = ()=>(0, $dkYqL.createSelector)(this.getPlaybackParameterSelector("presetID"), (0, $5ICqB.selectPresets), (presetID, presets)=>{
            return presetID === "init" ? this.getInitPreset() : presets[presetID];
        });
    getPlaybackClipSelector = ()=>(0, $dkYqL.createSelector)(this.getPlaybackParameterSelector("clipNumber"), this.getClipsSelector(), (clipNumber, clips)=>{
            return clips[clipNumber];
        });
    // staticSelect. should never be used inside of react
    getPlaybackClipNumber = (state)=>(0, $95CQM.staticSelect)(this.getPlaybackParameterSelector("clipNumber"), state);
    getPlaybackPresetID = (state)=>(0, $95CQM.staticSelect)(this.getPlaybackParameterSelector("presetID"), state);
    getPlaybackClip = (state)=>(0, $95CQM.staticSelect)(this.getPlaybackClipSelector(), state);
    getPlaybackParameterValue = (parameterName)=>(0, $95CQM.staticSelect)(this.getPlaybackParameterSelector(parameterName));
    _getParameterUpdater(parameterName, { presetID: presetID, clipNumber: clipNumber, load: load } = {}) {
        const isLocal = this.getParameterDescription(parameterName).local;
        if (this.isParameterBoundToPresets(parameterName)) return (value)=>{
            const preset = presetID === "init" ? this.getInitPreset() : (0, $95CQM.staticSelect)((0, $5ICqB.selectPresets))[presetID];
            if (!preset._metadata.isUnsaved) {
                const newPresetID = (0, $kmdF6.makeUID)("preset");
                const newPreset = {
                    ...preset,
                    [parameterName]: value,
                    _metadata: {
                        ...preset._metadata,
                        isUnsaved: true,
                        isFactory: false
                    }
                };
                return (dispatch)=>{
                    dispatch((0, $5ICqB.makePreset)({
                        presetID: newPresetID,
                        data: newPreset
                    }));
                    if (load) dispatch((0, $5ICqB.loadPresetInInstrument)({
                        instrumentID: this.id,
                        presetID: newPresetID
                    }));
                };
            }
            return (0, $5ICqB.setPresetParameter)({
                presetID: presetID,
                parameter: parameterName,
                value: value
            });
        };
        if (this.isParameterBoundToClips(parameterName)) return (value)=>(0, $5ICqB.setClipParameter)({
                instrumentID: this.id,
                clipNumber: clipNumber,
                parameter: parameterName,
                value: value,
                isLocal: isLocal
            });
        return (value)=>(0, $5ICqB.setInstrumentParameter)({
                instrumentID: this.id,
                parameter: parameterName,
                value: value,
                isLocal: isLocal
            });
    }
    getDisplayParameterUpdater(parameterName) {
        return (value)=>{
            const presetID = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("presetID"));
            const clipNumber = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("clipNumber"));
            return this._getParameterUpdater(parameterName, {
                presetID: presetID,
                clipNumber: clipNumber,
                load: true
            })(value);
        };
    }
    // TODO: Remove. Deprecated
    updateParametreInstrument = (nomParametre, valor)=>(0, $5ICqB.default).dispatch(this.getDisplayParameterUpdater(nomParametre)(valor));
    createdParameterHandlers = new Map();
    getParameterHandler(parameterName) {
        if (!this.createdParameterHandlers.has(parameterName)) {
            const parameterHandler = new (0, $3wfoi.ParameterHandler)(this.getParameterDescription(parameterName), this.getDisplayParameterSelector(parameterName), this.getDisplayParameterUpdater(parameterName));
            this.createdParameterHandlers.set(parameterName, parameterHandler);
        }
        return this.createdParameterHandlers.get(parameterName);
    }
    // todo: this should be a method of audioEngine
    getStepDuration = ()=>{
        return 60.0 / (0, $Lbl7Y.getAudioGraphInstance)().getBpm() / 4.0;
    };
    // deprecated. todo: should dispatch directly from react!
    updateSequence(value) {
        const clipNumber = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("clipNumber"));
        return (0, $5ICqB.default).dispatch((0, $5ICqB.setClipSequence)({
            instrumentID: this.id,
            clipNumber: clipNumber,
            value: value
        }));
    }
    // STATE + AUDIO STUFF. KINDA MIXED WITH STORE'S AUDIOAPPLIER
    // Called when we want to update the whole audio graph from the state (for example, to force syncing with the state)
    applyStateToAudioGraph() {
        this.updateAudioGraphForUnboundParameters();
        this.updateAudioGraphForPlaybackPreset();
        this.updateAudioGraphForPlaybackClip();
    }
    updateAudioGraphForUnboundParameters() {
        Object.keys(this.parametersDescription).forEach((parameterName)=>{
            if (parameterName === "clipNumber") return;
            if (this.parametersDescription[parameterName].bind) return;
            const value = (0, $95CQM.staticSelect)(this.getPlaybackParameterSelector(parameterName));
            this.applyAudioGraphParameter(parameterName, value);
        });
    }
    updateAudioGraphForPlaybackPreset() {
        const preset = (0, $95CQM.staticSelect)(this.getPlaybackPresetSelector());
        if (preset == null) return; // todo: remove this return, could lead to more difficult debugging. probably it was an extra call from the store's launchScene or dequeueSlots middleware...
        Object.entries(preset).filter(([name, _v])=>name !== "_metadata").forEach(([name, value])=>{
            this.applyAudioGraphParameter(name, value);
        });
    }
    updateAudioGraphForPlaybackClip() {
        const clip = (0, $95CQM.staticSelect)(this.getPlaybackClipSelector());
        if (clip == null || clip.sound == null) return;
        Object.entries({
            ...(0, $kU8gq.Sound).getDefaults(),
            ...clip.sound
        }).forEach(([name, value])=>this.applyAudioGraphParameter(name, value));
    }
    // Called when a parameter of an station's audio graph is updated
    applyAudioGraphParameter(nomParametre, value) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        const match = this._setParameterInAudioGraph(nomParametre, value); // try to match with general parameters
        if (!match) this.setParameterInAudioGraph(nomParametre, value); // if not, go to individual implementations
    }
    updateMute() {
        const isAnySolo = (0, $95CQM.staticSelect)((0, $5ICqB.selectIsAnyInstrumentSolo));
        if (this.muteChannel) {
            const isChannelSoloed = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector('isSolo'));
            const isChannelIndirectMuted = isAnySolo && !isChannelSoloed;
            const isChannelDirectMuted = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector('isMute'));
            this.muteChannel.mute = isChannelDirectMuted || isChannelIndirectMuted;
        }
    }
    unfinishedNotes = [];
    handlePianoRollRecording(pitch, midiVelocity = 127, noteOff) {
        if (!(0, $95CQM.staticSelect)(this.getPlaybackParameterSelector('isRecordArmed'))) return;
        const currentMainSequencerStep = (0, $Lbl7Y.getAudioGraphInstance)().getTransportCurrentStep();
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        if (!noteOff) return this.unfinishedNotes.push({
            pitch: pitch,
            velocity: midiVelocity,
            onset: currentStep
        });
        const noteIndex = this.unfinishedNotes.findIndex((n)=>n.pitch === pitch);
        if (noteIndex === -1) return; // if there isn't any note like that, ignore
        const [note] = this.unfinishedNotes.splice(noteIndex, 1);
        if (note.onset > currentStep) return; // likewise, don't save the note if the noteoff insn't bigger than the noteon
        note.duration = currentStep === note.onset ? 1 : currentStep - note.onset;
        const jsPianoRollEl = document.getElementById(this.id + "_" + "piano-roll");
        note.id = jsPianoRollEl.getNextAvailableID();
        const sequence = structuredClone((0, $95CQM.staticSelect)(this.getDisplaySequenceSelector())); // we want it to be mutable so we clone it
        sequence.push(note);
        this.updateSequence(sequence); // and save change in server!
    }
    // AUDIO ONLY STUFF
    get masterChannel() {
        return this.bus.masterChannel;
    }
    get muteChannel() {
        return this.bus.muteChannel;
    }
    getCurrentLevel() {
        if (this.bus == null) return -60;
        return Math.max(...this.bus.getCurrentLevels());
    }
    _setParameterInAudioGraph(name, value) {
        if (name.startsWith('fx') || name.startsWith('send')) return this.setFxParameterInAudioGraph(name, value);
        // isSolo and isMute are handled separately in store audioApplier
        switch(name){
            case 'gain':
                if (this.masterChannel !== undefined) {
                    const volume = $bmU6v.gainToDb(value);
                    this.masterChannel.volume.linearRampTo(volume, 0.01);
                }
                return true;
            case 'pan':
                if (this.masterChannel !== undefined) {
                    const pan = value;
                    this.masterChannel.pan.linearRampTo(pan, 0.01);
                }
                return true;
            case 'presetID':
                if ((0, $95CQM.staticSelect)((0, $5ICqB.selectPlaybackMode)) === "followInstruments") this.updateAudioGraphForPlaybackPreset();
                return true;
            case 'clipNumber':
                if ((0, $95CQM.staticSelect)((0, $5ICqB.selectPlaybackMode)) === "followInstruments") this.updateAudioGraphForPlaybackClip();
                return true;
        }
        return false;
    }
    setParameterInAudioGraph(name, value) {
    // Called when a parameter gets updated and needs to update it's corresponding audio graph node
    // This needs to be implemented in each station
    }
    setFxParameterInAudioGraph(name, value) {
        if (this.audioNodes.hasOwnProperty('effects') === false) // If instrument has no effect nodes, don't try tu update anything
        return false;
        const eqNode = this.audioNodes.effects['eq3'];
        // FX propis de l'instrument
        if (name == "fx_EQ_low") eqNode.set({
            'low': value
        });
        else if (name == "fx_EQ_mid") eqNode.set({
            'mid': value
        });
        else if (name == "fx_EQ_high") eqNode.set({
            'high': value
        });
        else if (name == "fx_EQ_isActive") {
            if (value) eqNode.activate();
            else eqNode.deactivate();
        } else if (name === "send_reverbA") this.audioNodes.effects.reverbASendChannel.volume.value = value;
        else if (name === "send_reverbB") this.audioNodes.effects.reverbBSendChannel.volume.value = value;
        else if (name === "send_delayA") this.audioNodes.effects.delayASendChannel.volume.value = value;
        else if (name === "send_delayB") this.audioNodes.effects.delayBSendChannel.volume.value = value;
        else return false;
        return true;
    }
    addEffectChainNodes(audioInput, audioOutput) {
        const effects = {
            eq3: new (0, $2Zbj1.FXWrapper)((0, $9BokY.GrufEQ3), {
                postgain: $bmU6v.dbToGain(3),
                isActive: (0, $95CQM.staticSelect)(this.getPlaybackParameterSelector("fx_EQ_isActive"))
            }, {
                Q: 10
            }),
            reverbASendChannel: new $1x3k0.Channel({
                volume: -100
            }),
            reverbBSendChannel: new $1x3k0.Channel({
                volume: -100
            }),
            delayASendChannel: new $1x3k0.Channel({
                volume: -100
            }),
            delayBSendChannel: new $1x3k0.Channel({
                volume: -100
            })
        };
        // Add the nodes to the station's audioNodes dictionary
        this.audioNodes.effects = effects;
        // Connect the nodes in the effect chain
        audioInput.chain(effects.eq3, audioOutput);
        // Connect global effect sends
        effects.reverbASendChannel.connect((0, $Lbl7Y.getAudioGraphInstance)().returns.reverbA);
        effects.reverbBSendChannel.connect((0, $Lbl7Y.getAudioGraphInstance)().returns.reverbB);
        effects.delayASendChannel.connect((0, $Lbl7Y.getAudioGraphInstance)().returns.delayA);
        effects.delayBSendChannel.connect((0, $Lbl7Y.getAudioGraphInstance)().returns.delayB);
        this.bus.connect(effects.reverbASendChannel);
        this.bus.connect(effects.reverbBSendChannel);
        this.bus.connect(effects.delayASendChannel);
        this.bus.connect(effects.delayBSendChannel);
    }
    async buildInstrumentAudioGraph() {
        this.bus = new (0, $hysHW.GrufBus)();
        // Use this method to build audio nodes and the like.
        // We make it "async" as there might be the need to load resources (e.g. WAM modules)
        // and wait until these are loaded to continue using "await"
        return {};
    }
    dispose() {
        this.onStopAllSounds();
        $1Uvh8.getContext()._timeouts.cancel(0); // This afects all Tone nodes, but it's probably necessary to fully destroy the node 
        this.bus.dispose();
        for (const key of Object.keys(this.audioNodes)){
            if (key == "effects") for (const key2 of Object.keys(this.audioNodes.effects)){
                const node = this.audioNodes.effects[key2];
                node.dispose();
            }
            else {
                const node = this.audioNodes[key];
                node.dispose();
            }
        }
    }
    onTransportStop() {
    // Called when audio graph is stopped
    }
    onSequencerStep(currentMainSequencerStep, time) {
    // Called at each step (16th note) of the main sequencer so the station can trigger notes, etc.
    // You should use staticSelect(getPlaybackParameterSelector), instead of staticSelect(getDisplayParameterSelector), to account for presets, etc.
    }
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
    // Called everytime a note message is received from a live stream of notes (could be MIDI input or virtual input
    // noteOff = boolean which will be true if the message is a noteOff
    }
    onStopAllSounds() {
    // Called when we want to immediately stop all sound produced by the station
    }
    adjustPitchToInstrumentRange(pitch) {
        return pitch;
    }
    // UI stuff
    getUserInterfaceComponent() {
        throw new Error("No UI per aquiesta instrument!"); // If not overriden, throw error
    }
}

});
parcelRegister("2Zbj1", function(module, exports) {

$parcel$export(module.exports, "FXWrapper", () => $22ca0c5ece7a352c$export$d2d7dd219670b562);
parcelRequire("56MRX");
var $bdbZZ = parcelRequire("bdbZZ");
var $fDBOr = parcelRequire("fDBOr");
const $22ca0c5ece7a352c$var$defaultParams = {
    postgain: 1,
    isActive: true
};
class $22ca0c5ece7a352c$export$d2d7dd219670b562 extends (0, $fDBOr.ToneAudioNode) {
    #isActive = false;
    effectParams = {};
    constructor(effectConstructor, wrapperParams, fxParams){
        const { postgain: postgain, isActive: isActive } = {
            ...$22ca0c5ece7a352c$var$defaultParams,
            ...wrapperParams
        };
        super();
        this.effectConstructor = effectConstructor;
        this.pregain = new (0, $bdbZZ.Gain)(1);
        this.postgain = new (0, $bdbZZ.Gain)(postgain);
        this.bypassGain = new (0, $bdbZZ.Gain)(1);
        this.effectGain = new (0, $bdbZZ.Gain)(0);
        this.pregain.chain(this.bypassGain, this.postgain);
        this.effectGain.connect(this.postgain);
        this.input = this.pregain;
        this.output = this.postgain;
        this.set(fxParams);
        if (isActive) this.activate();
    }
    set(fxParams) {
        this.effectParams = {
            ...this.effectParams,
            ...fxParams
        };
        if (this.effect) this.effect.set(fxParams);
    }
    activate(fadeTime = 0.01) {
        if (this.#isActive) return;
        this.#isActive = true;
        this.bypassGain.gain.rampTo(0, fadeTime);
        this.effectGain.gain.rampTo(1, fadeTime);
        this.effect = new this.effectConstructor(this.effectParams);
        this.pregain.chain(this.effect, this.effectGain);
        if (this.deactivationTimeout) clearTimeout(this.deactivationTimeout);
    }
    deactivate(fadeTime = 0.01) {
        if (!this.#isActive) return;
        this.#isActive = false;
        this.bypassGain.gain.rampTo(1, fadeTime);
        this.effectGain.gain.rampTo(0, fadeTime);
        // fer això crea un clic encara que effectGain.gain.value sigui 0
        this.deactivationTimeout = setTimeout(()=>{
            this.effect.disconnect();
            this.effect.dispose();
            this.effect = null;
            this.deactivationTimeout = null;
        }, fadeTime * 1000);
    }
    dispose() {
        super.dispose();
        this.effect?.dispose();
        this.pregain.dispose();
        this.postgain.dispose();
        if (this.deactivationTimeout) clearTimeout(this.deactivationTimeout);
        return this;
    }
}

});

parcelRegister("9BokY", function(module, exports) {

$parcel$export(module.exports, "GrufEQ3", () => $ddb42074ddc17bf6$export$7e2eea5abc68536f);
// Custom EQ3 that allows to change the Q of the multiband split, defaults to 10
parcelRequire("56MRX");
var $bdbZZ = parcelRequire("bdbZZ");
var $jT0OW = parcelRequire("jT0OW");
var $l4RVz = parcelRequire("l4RVz");
var $fDBOr = parcelRequire("fDBOr");
function $ddb42074ddc17bf6$var$isArray(arg) {
    return Array.isArray(arg);
}
function $ddb42074ddc17bf6$var$readOnly(target, property) {
    if ($ddb42074ddc17bf6$var$isArray(property)) property.forEach((str)=>$ddb42074ddc17bf6$var$readOnly(target, str));
    else Object.defineProperty(target, property, {
        enumerable: true,
        writable: false
    });
}
function $ddb42074ddc17bf6$var$writable(target, property) {
    if ($ddb42074ddc17bf6$var$isArray(property)) property.forEach((str)=>$ddb42074ddc17bf6$var$writable(target, str));
    else Object.defineProperty(target, property, {
        writable: true
    });
}
class $ddb42074ddc17bf6$export$7e2eea5abc68536f extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        const options = (0, $l4RVz.optionsFromArguments)($ddb42074ddc17bf6$export$7e2eea5abc68536f.getDefaults(), arguments, [
            "low",
            "mid",
            "high",
            "Q"
        ]);
        super(options), this.name = "EQ3", /**
	 * the output
	 */ this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        }), this._internalChannels = [];
        this.input = this._multibandSplit = new (0, $jT0OW.MultibandSplit)({
            context: this.context,
            highFrequency: options.highFrequency,
            lowFrequency: options.lowFrequency,
            Q: options.Q
        });
        this._lowGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.low,
            units: "decibels"
        });
        this._midGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.mid,
            units: "decibels"
        });
        this._highGain = new (0, $bdbZZ.Gain)({
            context: this.context,
            gain: options.high,
            units: "decibels"
        });
        this.low = this._lowGain.gain;
        this.mid = this._midGain.gain;
        this.high = this._highGain.gain;
        this.Q = this._multibandSplit.Q;
        this.lowFrequency = this._multibandSplit.lowFrequency;
        this.highFrequency = this._multibandSplit.highFrequency;
        // the frequency bands
        this._multibandSplit.low.chain(this._lowGain, this.output);
        this._multibandSplit.mid.chain(this._midGain, this.output);
        this._multibandSplit.high.chain(this._highGain, this.output);
        $ddb42074ddc17bf6$var$readOnly(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency",
            "Q"
        ]);
        this._internalChannels = [
            this._multibandSplit
        ];
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            high: 0,
            highFrequency: 2500,
            low: 0,
            lowFrequency: 400,
            mid: 0,
            Q: 10
        });
    }
    /**
	 * Clean up.
	 */ dispose() {
        super.dispose();
        $ddb42074ddc17bf6$var$writable(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency",
            "Q"
        ]);
        this._multibandSplit.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this._lowGain.dispose();
        this._midGain.dispose();
        this._highGain.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.Q.dispose();
        return this;
    }
}

});

parcelRegister("kU8gq", function(module, exports) {

$parcel$export(module.exports, "Sound", () => $f37f72a7e109fe1c$export$85990f0f98a390bb);
class $f37f72a7e109fe1c$export$85990f0f98a390bb {
    static getDefaults() {
        return {
            soundName: "",
            transpose: 0,
            start: 0,
            end: 1,
            speed: 1,
            isReverse: false
        };
    }
}

});


parcelRegister("ibyLL", function(module, exports) {

$parcel$export(module.exports, "PianoRoller", () => $d3d439883955ea56$export$1e17fea496020be6);

var $enQqi = parcelRequire("enQqi");
class $d3d439883955ea56$export$1e17fea496020be6 {
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        pianoRollColorCode: {
            type: 'enum',
            options: [
                'melodic',
                'harmonic',
                'none'
            ],
            initial: 'melodic',
            local: true
        }
    }, "nom");
}

});


parcelRegister("g8sjx", function(module, exports) {

$parcel$export(module.exports, "SynthUI", () => $fa47452ca2dcfd9f$export$103a2a33147b7f3c);
$parcel$export(module.exports, "SynthBaseUI", () => $fa47452ca2dcfd9f$export$96b300fbdb0423ce);

var $1IdZj = parcelRequire("1IdZj");

var $ly76a = parcelRequire("ly76a");

var $5taCS = parcelRequire("5taCS");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");

var $01tLc = parcelRequire("01tLc");

var $ho4zB = parcelRequire("ho4zB");

var $hOWXx = parcelRequire("hOWXx");
const $fa47452ca2dcfd9f$export$103a2a33147b7f3c = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)($fa47452ca2dcfd9f$export$96b300fbdb0423ce, {
        instrument: instrument,
        synthesisParams: [
            [
                "fx_distortion_amount",
                "hpf_cutoff"
            ],
            [
                "osc_octave"
            ]
        ]
    });
};
const $fa47452ca2dcfd9f$export$96b300fbdb0423ce = ({ instrument: instrument, synthesisParams: synthesisParams = [
    [],
    []
] })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-synth",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "lpfCutoff",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("lpf_cutoff")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument,
                className: "square"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                className: "row-span-2 col-span-2",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {}),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                "data-widget-id": "synthesis",
                className: "modul-border modul-bg flex flex-col gap-20 justify-between items-center row-span-2",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                        text: "S\xedntesi"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $01tLc.WaveformSlider), {
                        instrument: instrument
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "flex-1 grid justify-between w-full",
                        style: {
                            gridTemplateColumns: "1fr auto 1fr",
                            marginTop: -10
                        },
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "flex flex-col justify-center gap-10",
                                children: synthesisParams[0].map((paramName)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                                        "data-widget-id": paramName.split("_").map((word, i)=>i == 0 ? word : (0, $hOWXx.capitalizeFirstLetter)(word)).join(""),
                                        mida: "gran",
                                        knobSize: "50px",
                                        parameterHandler: instrument.getParameterHandler(paramName)
                                    }))
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                                className: "h-full"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "flex flex-col justify-center gap-10",
                                children: synthesisParams[1].map((paramName)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                                        "data-widget-id": paramName.split("_").map((word, i)=>i == 0 ? word : (0, $hOWXx.capitalizeFirstLetter)(word)).join(""),
                                        mida: "gran",
                                        knobSize: "50px",
                                        parameterHandler: instrument.getParameterHandler(paramName)
                                    }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulADSR), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.PianoRoll), {
                className: "row-span-5",
                instrument: instrument,
                colorNotes: instrument.metadata.color
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex gap-10 justify-between align-center",
                children: [
                    instrument.getParameterDescription("pianoRollColorCode") && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.ColorCodeSelector), {
                        instrument: instrument
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                        className: "contents",
                        instrument: instrument,
                        showAutogenerate: true
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2kzMM"));

});
parcelRegister("2kzMM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1b2935584d52f656$export$ffb0004e005737fa, (v) => $1b2935584d52f656$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1b2935584d52f656$export$34b9dba7ce09269b, (v) => $1b2935584d52f656$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1b2935584d52f656$export$25062201e9e25d76, (v) => $1b2935584d52f656$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b2935584d52f656$export$ffb0004e005737fa;
var $1b2935584d52f656$export$34b9dba7ce09269b;
var $1b2935584d52f656$export$25062201e9e25d76;
"use strict";
var $1b2935584d52f656$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1b2935584d52f656$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1b2935584d52f656$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1b2935584d52f656$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1b2935584d52f656$export$ffb0004e005737fa = $1b2935584d52f656$var$REACT_FRAGMENT_TYPE;
$1b2935584d52f656$export$34b9dba7ce09269b = $1b2935584d52f656$var$jsxProd;
$1b2935584d52f656$export$25062201e9e25d76 = $1b2935584d52f656$var$jsxProd;

});


parcelRegister("ly76a", function(module, exports) {

$parcel$export(module.exports, "ClipControls", () => $c5ffb253957e990f$export$328ea28367193be3);

var $1IdZj = parcelRequire("1IdZj");

var $7Kpeg = parcelRequire("7Kpeg");

var $8NFma = parcelRequire("8NFma");

var $5ICqB = parcelRequire("5ICqB");

var $jx1tf = parcelRequire("jx1tf");

var $ba5Ec = parcelRequire("ba5Ec");

var $cU3m9 = parcelRequire("cU3m9");

var $3dVOr = parcelRequire("3dVOr");

var $5mwHr = parcelRequire("5mwHr");

var $k0n2x = parcelRequire("k0n2x");
const $c5ffb253957e990f$export$328ea28367193be3 = ({ className: className, instrument: instrument, showAutogenerate: showAutogenerate, hideLengthControls: hideLengthControls })=>{
    const dispatch = (0, $7Kpeg.useDispatch)();
    const clipNumber = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("clipNumber"));
    const displayClipLength = (0, $7Kpeg.useSelector)(instrument.getDisplayClipLengthSelector());
    handleClipLengthUpdate = (value)=>dispatch((0, $5ICqB.setClipLength)({
            instrumentID: instrument.id,
            clipNumber: clipNumber,
            value: value
        }));
    const factoryClipsForInstrument = (0, $5mwHr.factoryClips).filter((clip)=>clip._metadata.instrumentType === instrument.metadata.tipus);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        className: `clip-controls flex gap-10 ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)($c5ffb253957e990f$var$ClipMenu, {
                currentClipNumber: clipNumber,
                instrument: instrument,
                showAutogenerate: showAutogenerate,
                factoryClipsForInstrument: factoryClipsForInstrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jx1tf.ClipSelector), {
                instrument: instrument,
                buttonWidth: "30px"
            }),
            !hideLengthControls && /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                "data-widget-id": "clipDurationControls",
                className: "length-controls",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                        className: "btn w-30",
                        disabled: displayClipLength <= 16,
                        onClick: ()=>handleClipLengthUpdate(displayClipLength / 2),
                        children: "/2"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                        className: "btn w-30",
                        disabled: displayClipLength >= 64,
                        onClick: ()=>handleClipLengthUpdate(displayClipLength * 2),
                        children: "x2"
                    })
                ]
            })
        ]
    });
};
// very similar to presetmenu in presetbankbar
function $c5ffb253957e990f$var$ClipMenu({ currentClipNumber: currentClipNumber, showAutogenerate: showAutogenerate, instrument: instrument, factoryClipsForInstrument: factoryClipsForInstrument }) {
    const [isOpen, setIsOpen] = (0, $8NFma.useState)(false);
    const [isLoadDialogVisible, setIsLoadDialogVisible] = (0, $8NFma.useState)(false);
    const generate = showAutogenerate && (0, $3dVOr.useNoteGenerator)({
        instrument: instrument
    });
    const currentClip = (0, $7Kpeg.useSelector)(instrument.getDisplayClipSelector());
    const clipType = currentClip.sequence ? "midi" : "audio";
    const isClipEmpty = (clipType === "midi" ? currentClip.sequence : Object.keys(currentClip.sound)).length === 0;
    const dispatch = (0, $7Kpeg.useDispatch)();
    const clear = ()=>dispatch((0, $5ICqB.clearClip)({
            instrumentID: instrument.id,
            clipNumber: currentClipNumber
        }));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $ba5Ec).Root, {
                open: isOpen,
                onOpenChange: setIsOpen,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Trigger, {
                        className: "btn btn-white w-30",
                        "data-widget-id": "clipMenuTrigger",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cU3m9.default), {})
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Portal, {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Positioner, {
                            align: "start",
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $ba5Ec).Popup, {
                                className: "menu",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            onClick: clear,
                                            disabled: isClipEmpty,
                                            children: "Esborra"
                                        })
                                    }),
                                    showAutogenerate && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            onClick: generate,
                                            children: "Auto-genera"
                                        })
                                    }),
                                    factoryClipsForInstrument.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                        onClick: ()=>setIsLoadDialogVisible(true),
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            children: "Carrega clip de f\xe0brica"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            factoryClipsForInstrument.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)($c5ffb253957e990f$var$LoadClipDialog, {
                isVisible: isLoadDialogVisible,
                setIsVisible: setIsLoadDialogVisible,
                clipNumber: currentClipNumber,
                factoryClipsForInstrument: factoryClipsForInstrument,
                instrumentID: instrument.id
            })
        ]
    });
}
function $c5ffb253957e990f$var$LoadClipDialog({ isVisible: isVisible, setIsVisible: setIsVisible, instrumentID: instrumentID, clipNumber: clipNumber, factoryClipsForInstrument: factoryClipsForInstrument }) {
    const dispatch = (0, $7Kpeg.useDispatch)();
    function loadClip(clip) {
        dispatch((0, $5ICqB.setClip)({
            instrumentID: instrumentID,
            clipNumber: clipNumber,
            value: clip
        }));
        setIsVisible(false);
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $k0n2x.Dialog), {
        className: "preset-save-dialog",
        visible: isVisible,
        onHide: ()=>setIsVisible(false),
        draggable: false,
        resizable: false,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                children: "Carrega un clip de f\xe0brica"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                className: "menu",
                children: factoryClipsForInstrument.map((clip)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                            onClick: ()=>loadClip(clip),
                            children: clip._metadata.name
                        })
                    }))
            })
        ]
    });
}

});
parcelRegister("jx1tf", function(module, exports) {

$parcel$export(module.exports, "ClipSelector", () => $2f31e6a5a6bbf086$export$4ccd7867ef4f14c);

var $1IdZj = parcelRequire("1IdZj");

var $7Kpeg = parcelRequire("7Kpeg");

var $dkYqL = parcelRequire("dkYqL");

var $4DYyh = parcelRequire("4DYyh");

var $lClb7 = parcelRequire("lClb7");

var $hmjjw = parcelRequire("hmjjw");

var $enQqi = parcelRequire("enQqi");
parcelRequire("9xysn");
const $2f31e6a5a6bbf086$export$4ccd7867ef4f14c = ({ className: className, instrument: instrument, buttonWidth: buttonWidth, minHeight: minHeight })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        "data-widget-id": "clipSelect",
        className: `gruf-selector-clips buttongroup ${className}`,
        style: {
            minHeight: minHeight
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4DYyh.RadioGroup), {
            children: [
                ...Array((0, $hmjjw.InstrumentBase).numClips).keys()
            ].map((i)=>/*#__PURE__*/ (0, $1IdZj.jsx)($2f31e6a5a6bbf086$var$ClipButton, {
                    instrument: instrument,
                    width: buttonWidth,
                    number: i
                }, "clip_" + i))
        })
    });
};
const $2f31e6a5a6bbf086$var$ClipButton = ({ instrument: instrument, width: width, number: number })=>{
    const isSelected = (0, $7Kpeg.useSelector)((0, $dkYqL.createSelector)(instrument.getDisplayParameterSelector("clipNumber"), (clipNumber)=>clipNumber === number));
    const isPlayback = (0, $7Kpeg.useSelector)((0, $dkYqL.createSelector)(instrument.getPlaybackParameterSelector("clipNumber"), (playbackClipNumber)=>playbackClipNumber === number));
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton), {
        style: {
            width: width
        },
        className: `clip-button flex justify-center items-center ${isPlayback ? "playback" : ""}`,
        checked: isSelected,
        onNewValue: (value)=>{
            value && instrument.updateParametreInstrument("clipNumber", number);
        },
        onClick: (e)=>e.stopPropagation(),
        children: (0, $enQqi.getClipDisplayName)(number)
    });
};

});
parcelRegister("4DYyh", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", () => $6c29dab0ff6b5984$export$a98f0dcb43a68a25);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $3COnN = parcelRequire("3COnN");
const $6c29dab0ff6b5984$export$a98f0dcb43a68a25 = ({ children: children, name: name })=>{
    const id = (0, $8NFma.useId)();
    name = name ?? id;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3COnN.RadioGroupContext), {
        value: {
            name: name
        },
        children: children
    });
};

});
parcelRegister("3COnN", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $2a3c00b1cfda4cb1$export$a79eda4ff50e30b6);

var $8NFma = parcelRequire("8NFma");
const $2a3c00b1cfda4cb1$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $8NFma.createContext)({
    name: undefined
});

});


parcelRegister("lClb7", function(module, exports) {

$parcel$export(module.exports, "RadioButton", () => $e28e5f533ae124eb$export$f4422ae58352e179);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $3COnN = parcelRequire("3COnN");
const $e28e5f533ae124eb$export$f4422ae58352e179 = ({ className: className = "", checked: checked, onNewValue: onNewValue, children: children, style: style, ...props })=>{
    const inputRef = (0, $8NFma.useRef)();
    // make checkbox click in enter (by default only changes with space and that is taken for audio play/stop)
    function handleKeyDown(e) {
        if (e.key !== "Enter") return;
        inputRef.click();
    }
    const { name: name } = (0, $8NFma.useContext)((0, $3COnN.RadioGroupContext));
    // keyboard navigation: radiogroups set moving between buttons of the same group with arrow keys
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
        ...props,
        className: `${className} radiobutton btn ${checked ? "active" : ""}`,
        style: style,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                ref: inputRef,
                type: "radio",
                name: name,
                checked: checked,
                onChange: (e)=>onNewValue(e.target.checked, e),
                onKeyDown: handleKeyDown
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                children: children
            })
        ]
    });
};

});


parcelRegister("ba5Ec", function(module, exports) {

$parcel$export(module.exports, "Arrow", () => (parcelRequire("gzfCM")).MenuArrow);
$parcel$export(module.exports, "Backdrop", () => (parcelRequire("cG2jB")).MenuBackdrop);
$parcel$export(module.exports, "CheckboxItem", () => (parcelRequire("93FQR")).MenuCheckboxItem);
$parcel$export(module.exports, "CheckboxItemIndicator", () => (parcelRequire("8YBSo")).MenuCheckboxItemIndicator);
$parcel$export(module.exports, "Group", () => (parcelRequire("8vvjs")).MenuGroup);
$parcel$export(module.exports, "GroupLabel", () => (parcelRequire("hq9nT")).MenuGroupLabel);
$parcel$export(module.exports, "Item", () => (parcelRequire("180HL")).MenuItem);
$parcel$export(module.exports, "LinkItem", () => (parcelRequire("c7OvE")).MenuLinkItem);
$parcel$export(module.exports, "Popup", () => (parcelRequire("jJv3c")).MenuPopup);
$parcel$export(module.exports, "Portal", () => (parcelRequire("c49N2")).MenuPortal);
$parcel$export(module.exports, "Positioner", () => (parcelRequire("43Vx6")).MenuPositioner);
$parcel$export(module.exports, "RadioGroup", () => (parcelRequire("2cDUf")).MenuRadioGroup);
$parcel$export(module.exports, "RadioItem", () => (parcelRequire("7XlrL")).MenuRadioItem);
$parcel$export(module.exports, "RadioItemIndicator", () => (parcelRequire("kDs3P")).MenuRadioItemIndicator);
$parcel$export(module.exports, "Root", () => (parcelRequire("l8BT5")).MenuRoot);
$parcel$export(module.exports, "SubmenuRoot", () => (parcelRequire("jXF6T")).MenuSubmenuRoot);
$parcel$export(module.exports, "Trigger", () => (parcelRequire("98m8x")).MenuTrigger);
$parcel$export(module.exports, "Viewport", () => (parcelRequire("aJ9QX")).MenuViewport);
$parcel$export(module.exports, "Separator", () => (parcelRequire("aU2TQ")).Separator);
$parcel$export(module.exports, "SubmenuTrigger", () => (parcelRequire("4wUw1")).MenuSubmenuTrigger);
$parcel$export(module.exports, "Handle", () => (parcelRequire("5eHXn")).MenuHandle);
$parcel$export(module.exports, "createHandle", () => (parcelRequire("5eHXn")).createMenuHandle);

var $gzfCM = parcelRequire("gzfCM");

var $cG2jB = parcelRequire("cG2jB");

var $93FQR = parcelRequire("93FQR");

var $8YBSo = parcelRequire("8YBSo");

var $8vvjs = parcelRequire("8vvjs");

var $hq9nT = parcelRequire("hq9nT");

var $180HL = parcelRequire("180HL");

var $c7OvE = parcelRequire("c7OvE");

var $jJv3c = parcelRequire("jJv3c");

var $c49N2 = parcelRequire("c49N2");

var $43Vx6 = parcelRequire("43Vx6");

var $2cDUf = parcelRequire("2cDUf");

var $7XlrL = parcelRequire("7XlrL");

var $kDs3P = parcelRequire("kDs3P");

var $l8BT5 = parcelRequire("l8BT5");

var $jXF6T = parcelRequire("jXF6T");

var $98m8x = parcelRequire("98m8x");

var $aJ9QX = parcelRequire("aJ9QX");

var $aU2TQ = parcelRequire("aU2TQ");

var $4wUw1 = parcelRequire("4wUw1");

var $5eHXn = parcelRequire("5eHXn");

});
parcelRegister("gzfCM", function(module, exports) {

$parcel$export(module.exports, "MenuArrow", () => $1d0bb468f94d327b$export$bcdda4773debf5fa);

var $8NFma = parcelRequire("8NFma");

var $8foVs = parcelRequire("8foVs");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $gVYSt = parcelRequire("gVYSt");
'use client';
const $1d0bb468f94d327b$export$bcdda4773debf5fa = /*#__PURE__*/ $8NFma.forwardRef(function MenuArrow(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, ...elementProps } = componentProps;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const { arrowRef: arrowRef, side: side, align: align, arrowUncentered: arrowUncentered, arrowStyles: arrowStyles } = (0, $8foVs.useMenuPositionerContext)();
    const open = store.useState('open');
    const state = {
        open: open,
        side: side,
        align: align,
        uncentered: arrowUncentered
    };
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        ref: [
            arrowRef,
            forwardedRef
        ],
        stateAttributesMapping: (0, $gVYSt.popupStateMapping),
        state: state,
        props: {
            style: arrowStyles,
            'aria-hidden': true,
            ...elementProps
        }
    });
});

});
parcelRegister("8foVs", function(module, exports) {

$parcel$export(module.exports, "MenuPositionerContext", () => $84698c214dc99980$export$92807d77e27e8316);
$parcel$export(module.exports, "useMenuPositionerContext", () => $84698c214dc99980$export$a19f9c6ffe044d93);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $84698c214dc99980$export$92807d77e27e8316 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $84698c214dc99980$export$a19f9c6ffe044d93(optional) {
    const context = $8NFma.useContext($84698c214dc99980$export$92807d77e27e8316);
    if (context === undefined && !optional) throw new Error((0, $cmjqX.default)(33));
    return context;
}

});
parcelRegister("cmjqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f228cc493b6a03b0$export$2e2bcd8739ae039);
/**
 * Creates a formatErrorMessage function with a custom URL and prefix.
 * @param baseUrl - The base URL for the error page (e.g., 'https://base-ui.com/production-error')
 * @param prefix - The prefix for the error message (e.g., 'Base UI')
 * @returns A function that formats error messages with the given URL and prefix
 */ function $f228cc493b6a03b0$export$50773999d401a251(baseUrl, prefix) {
    return function formatErrorMessage(code, ...args) {
        const url = new URL(baseUrl);
        url.searchParams.set('code', code.toString());
        args.forEach((arg)=>url.searchParams.append('args[]', arg));
        return `${prefix} error #${code}; visit ${url} for the full message.`;
    };
}
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/internal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 */ const $f228cc493b6a03b0$var$formatErrorMessage = $f228cc493b6a03b0$export$50773999d401a251('https://base-ui.com/production-error', 'Base UI');
var $f228cc493b6a03b0$export$2e2bcd8739ae039 = $f228cc493b6a03b0$var$formatErrorMessage;

});


parcelRegister("jtR97", function(module, exports) {

$parcel$export(module.exports, "MenuRootContext", () => $590d59957589afc6$export$db9e2369df092f32);
$parcel$export(module.exports, "useMenuRootContext", () => $590d59957589afc6$export$f872d104fc73db06);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $590d59957589afc6$export$db9e2369df092f32 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $590d59957589afc6$export$f872d104fc73db06(optional) {
    const context = $8NFma.useContext($590d59957589afc6$export$db9e2369df092f32);
    if (context === undefined && !optional) throw new Error((0, $cmjqX.default)(36));
    return context;
}

});

parcelRegister("aEBMJ", function(module, exports) {

$parcel$export(module.exports, "useRenderElement", () => $ddf699c8fd752143$export$fb47f7acae8f7b7b);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");

var $ghAB8 = parcelRequire("ghAB8");

var $e631W = parcelRequire("e631W");

var $eSKeI = parcelRequire("eSKeI");

var $9nGaS = parcelRequire("9nGaS");

var $jWAMz = parcelRequire("jWAMz");

var $lYz63 = parcelRequire("lYz63");

var $dkj3I = parcelRequire("dkj3I");

var $f69gM = parcelRequire("f69gM");

var $eFu2T = parcelRequire("eFu2T");
function $ddf699c8fd752143$export$fb47f7acae8f7b7b(element, componentProps, params = {}) {
    const renderProp = componentProps.render;
    const outProps = $ddf699c8fd752143$var$useRenderElementProps(componentProps, params);
    if (params.enabled === false) return null;
    const state = params.state ?? (0, $jWAMz.EMPTY_OBJECT);
    return $ddf699c8fd752143$var$evaluateRenderProp(element, renderProp, outProps, state);
}
/**
 * Computes render element final props.
 */ function $ddf699c8fd752143$var$useRenderElementProps(componentProps, params = {}) {
    const { className: classNameProp, style: styleProp, render: renderProp } = componentProps;
    const { state: state = (0, $jWAMz.EMPTY_OBJECT), ref: ref, props: props, stateAttributesMapping: stateAttributesMapping, enabled: enabled = true } = params;
    const className = enabled ? (0, $dkj3I.resolveClassName)(classNameProp, state) : undefined;
    const style = enabled ? (0, $f69gM.resolveStyle)(styleProp, state) : undefined;
    const stateProps = enabled ? (0, $lYz63.getStateAttributesProps)(state, stateAttributesMapping) : (0, $jWAMz.EMPTY_OBJECT);
    const resolvedProps = enabled && props ? $ddf699c8fd752143$var$resolveRenderFunctionProps(props) : undefined;
    // Ensure outProps is always a new mutable object when enabled, never EMPTY_OBJECT.
    // This prevents potential TypeError when setting ref, className, or style properties,
    // since EMPTY_OBJECT is frozen and mutations would fail in strict mode.
    const outProps = enabled ? (0, $eSKeI.mergeObjects)(stateProps, resolvedProps) ?? {} : (0, $jWAMz.EMPTY_OBJECT);
    // SAFETY: The `useMergedRefs` functions use a single hook to store the same value,
    // switching between them at runtime is safe. If this assertion fails, React will
    // throw at runtime anyway.
    // This also skips the `useMergedRefs` call on the server, which is fine because
    // refs are not used on the server side.
    /* eslint-disable react-hooks/rules-of-hooks */ if (typeof document !== 'undefined') {
        if (!enabled) (0, $ghAB8.useMergedRefs)(null, null);
        else if (Array.isArray(ref)) outProps.ref = (0, $ghAB8.useMergedRefsN)([
            outProps.ref,
            (0, $e631W.getReactElementRef)(renderProp),
            ...ref
        ]);
        else outProps.ref = (0, $ghAB8.useMergedRefs)(outProps.ref, (0, $e631W.getReactElementRef)(renderProp), ref);
    }
    if (!enabled) return 0, $jWAMz.EMPTY_OBJECT;
    if (className !== undefined) outProps.className = (0, $eFu2T.mergeClassNames)(outProps.className, className);
    if (style !== undefined) outProps.style = (0, $eSKeI.mergeObjects)(outProps.style, style);
    return outProps;
}
function $ddf699c8fd752143$var$resolveRenderFunctionProps(props) {
    if (Array.isArray(props)) return (0, $eFu2T.mergePropsN)(props);
    return (0, $eFu2T.mergeProps)(undefined, props);
}
// The symbol React uses internally for lazy components
// https://github.com/facebook/react/blob/a0566250b210499b4c5677f5ac2eedbd71d51a1b/packages/shared/ReactSymbols.js#L31
//
// TODO delete once https://github.com/facebook/react/issues/32392 is fixed
const $ddf699c8fd752143$var$REACT_LAZY_TYPE = Symbol.for('react.lazy');
const $ddf699c8fd752143$var$COMPONENT_IDENTIFIER_PATTERN = /^[A-Z][A-Za-z0-9$]*$/;
const $ddf699c8fd752143$var$LOWERCASE_CHARACTER_PATTERN = /[a-z]/;
function $ddf699c8fd752143$var$evaluateRenderProp(element, render, props, state) {
    if (render) {
        if (typeof render === 'function') return render(props, state);
        const mergedProps = (0, $eFu2T.mergeProps)(props, render.props);
        mergedProps.ref = props.ref;
        let newElement = render;
        // Workaround for https://github.com/facebook/react/issues/32392
        // This works because the toArray() logic unwrap lazy element type in
        // https://github.com/facebook/react/blob/a0566250b210499b4c5677f5ac2eedbd71d51a1b/packages/react/src/ReactChildren.js#L186
        if (newElement?.$$typeof === $ddf699c8fd752143$var$REACT_LAZY_TYPE) {
            const children = $8NFma.Children.toArray(render);
            newElement = children[0];
        }
        return /*#__PURE__*/ $8NFma.cloneElement(newElement, mergedProps);
    }
    if (element) {
        if (typeof element === 'string') return $ddf699c8fd752143$var$renderTag(element, props);
    }
    // Unreachable, but the typings on `useRenderElement` need to be reworked
    // to annotate it correctly.
    throw new Error((0, $cmjqX.default)(8));
}
function $ddf699c8fd752143$var$warnIfRenderPropLooksLikeComponent(renderFn) {
    const functionName = renderFn.name;
    if (functionName.length === 0) return;
    if (!$ddf699c8fd752143$var$COMPONENT_IDENTIFIER_PATTERN.test(functionName)) return;
    if (!$ddf699c8fd752143$var$LOWERCASE_CHARACTER_PATTERN.test(functionName)) return;
    (0, $9nGaS.warn)(`The \`render\` prop received a function named \`${functionName}\` that starts with an uppercase letter.`, 'This usually means a React component was passed directly as `render={Component}`.', 'Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.', 'If this is an intentional render callback, rename it to start with a lowercase letter.', 'Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.', 'https://base-ui.com/r/invalid-render-prop');
}
function $ddf699c8fd752143$var$renderTag(Tag, props) {
    if (Tag === 'button') return /*#__PURE__*/ (0, $8NFma.createElement)("button", {
        type: "button",
        ...props,
        key: props.key
    });
    if (Tag === 'img') return /*#__PURE__*/ (0, $8NFma.createElement)("img", {
        alt: "",
        ...props,
        key: props.key
    });
    return /*#__PURE__*/ $8NFma.createElement(Tag, props);
}

});
parcelRegister("ghAB8", function(module, exports) {

$parcel$export(module.exports, "useMergedRefs", () => $248289268e21377b$export$9cf7d991616612b3);
$parcel$export(module.exports, "useMergedRefsN", () => $248289268e21377b$export$4ecf6cbdeec5b4c1);

var $gidzQ = parcelRequire("gidzQ");
function $248289268e21377b$export$9cf7d991616612b3(a, b, c, d) {
    const forkRef = (0, $gidzQ.useRefWithInit)($248289268e21377b$var$createForkRef).current;
    if ($248289268e21377b$var$didChange(forkRef, a, b, c, d)) $248289268e21377b$var$update(forkRef, [
        a,
        b,
        c,
        d
    ]);
    return forkRef.callback;
}
function $248289268e21377b$export$4ecf6cbdeec5b4c1(refs) {
    const forkRef = (0, $gidzQ.useRefWithInit)($248289268e21377b$var$createForkRef).current;
    if ($248289268e21377b$var$didChangeN(forkRef, refs)) $248289268e21377b$var$update(forkRef, refs);
    return forkRef.callback;
}
function $248289268e21377b$var$createForkRef() {
    return {
        callback: null,
        cleanup: null,
        refs: []
    };
}
function $248289268e21377b$var$didChange(forkRef, a, b, c, d) {
    // prettier-ignore
    return forkRef.refs[0] !== a || forkRef.refs[1] !== b || forkRef.refs[2] !== c || forkRef.refs[3] !== d;
}
function $248289268e21377b$var$didChangeN(forkRef, newRefs) {
    return forkRef.refs.length !== newRefs.length || forkRef.refs.some((ref, index)=>ref !== newRefs[index]);
}
function $248289268e21377b$var$update(forkRef, refs) {
    forkRef.refs = refs;
    if (refs.every((ref)=>ref == null)) {
        forkRef.callback = null;
        return;
    }
    forkRef.callback = (instance)=>{
        if (forkRef.cleanup) {
            forkRef.cleanup();
            forkRef.cleanup = null;
        }
        if (instance != null) {
            const cleanupCallbacks = Array(refs.length).fill(null);
            for(let i = 0; i < refs.length; i += 1){
                const ref = refs[i];
                if (ref == null) continue;
                switch(typeof ref){
                    case 'function':
                        {
                            const refCleanup = ref(instance);
                            if (typeof refCleanup === 'function') cleanupCallbacks[i] = refCleanup;
                            break;
                        }
                    case 'object':
                        ref.current = instance;
                        break;
                    default:
                }
            }
            forkRef.cleanup = ()=>{
                for(let i = 0; i < refs.length; i += 1){
                    const ref = refs[i];
                    if (ref == null) continue;
                    switch(typeof ref){
                        case 'function':
                            {
                                const cleanupCallback = cleanupCallbacks[i];
                                if (typeof cleanupCallback === 'function') cleanupCallback();
                                else ref(null);
                                break;
                            }
                        case 'object':
                            ref.current = null;
                            break;
                        default:
                    }
                }
            };
        }
    };
}

});
parcelRegister("gidzQ", function(module, exports) {

$parcel$export(module.exports, "useRefWithInit", () => $c0608b9af0ace823$export$b38b9b0f843c3251);

var $8NFma = parcelRequire("8NFma");
'use client';
const $c0608b9af0ace823$var$UNINITIALIZED = {};
function $c0608b9af0ace823$export$b38b9b0f843c3251(init, initArg) {
    const ref = $8NFma.useRef($c0608b9af0ace823$var$UNINITIALIZED);
    if (ref.current === $c0608b9af0ace823$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("e631W", function(module, exports) {

$parcel$export(module.exports, "getReactElementRef", () => $7a7c0e439aef8023$export$4554ac6b8c3e1a5d);

var $8NFma = parcelRequire("8NFma");

var $4srfS = parcelRequire("4srfS");
function $7a7c0e439aef8023$export$4554ac6b8c3e1a5d(element) {
    if (!/*#__PURE__*/ $8NFma.isValidElement(element)) return null;
    const reactElement = element;
    const propsWithRef = reactElement.props;
    return ((0, $4srfS.isReactVersionAtLeast)(19) ? propsWithRef?.ref : reactElement.ref) ?? null;
}

});
parcelRegister("4srfS", function(module, exports) {

$parcel$export(module.exports, "isReactVersionAtLeast", () => $7c064c15e6d0bb3e$export$99c13dc1a9443bc6);

var $8NFma = parcelRequire("8NFma");
const $7c064c15e6d0bb3e$var$majorVersion = parseInt($8NFma.version, 10);
function $7c064c15e6d0bb3e$export$99c13dc1a9443bc6(reactVersionToCheck) {
    return $7c064c15e6d0bb3e$var$majorVersion >= reactVersionToCheck;
}

});


parcelRegister("eSKeI", function(module, exports) {

$parcel$export(module.exports, "mergeObjects", () => $ccda2944dbbff080$export$2321aea138b44780);
function $ccda2944dbbff080$export$2321aea138b44780(a, b) {
    if (a && !b) return a;
    if (!a && b) return b;
    if (a || b) return {
        ...a,
        ...b
    };
    return undefined;
}

});

parcelRegister("9nGaS", function(module, exports) {

$parcel$export(module.exports, "warn", () => $1f033d7d1d566b29$export$c106dd0671a0fc2d);
let $1f033d7d1d566b29$var$set;
function $1f033d7d1d566b29$export$c106dd0671a0fc2d(...messages) {}

});

parcelRegister("jWAMz", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $cd84a9b8525660aa$export$5702a91a6f42969f);
$parcel$export(module.exports, "EMPTY_ARRAY", () => $cd84a9b8525660aa$export$2c66e96878bf4792);
$parcel$export(module.exports, "EMPTY_OBJECT", () => $cd84a9b8525660aa$export$253fab909bb52269);
function $cd84a9b8525660aa$export$5702a91a6f42969f() {}
const $cd84a9b8525660aa$export$2c66e96878bf4792 = Object.freeze([]);
const $cd84a9b8525660aa$export$253fab909bb52269 = Object.freeze({});

});

parcelRegister("lYz63", function(module, exports) {

$parcel$export(module.exports, "getStateAttributesProps", () => $91b1c4b1f2e24fbe$export$ba42057653ec457a);
function $91b1c4b1f2e24fbe$export$ba42057653ec457a(state, customMapping) {
    const props = {};
    /* eslint-disable-next-line guard-for-in */ for(const key in state){
        const value = state[key];
        if (customMapping?.hasOwnProperty(key)) {
            const customProps = customMapping[key](value);
            if (customProps != null) Object.assign(props, customProps);
            continue;
        }
        if (value === true) props[`data-${key.toLowerCase()}`] = '';
        else if (value) props[`data-${key.toLowerCase()}`] = value.toString();
    }
    return props;
}

});

parcelRegister("dkj3I", function(module, exports) {

$parcel$export(module.exports, "resolveClassName", () => $b1e19fd921fd6ac1$export$a7aaff05e5688aa7);
/**
 * If the provided className is a string, it will be returned as is.
 * Otherwise, the function will call the className function with the state as the first argument.
 *
 * @param className
 * @param state
 */ function $b1e19fd921fd6ac1$export$a7aaff05e5688aa7(className, state) {
    return typeof className === 'function' ? className(state) : className;
}

});

parcelRegister("f69gM", function(module, exports) {

$parcel$export(module.exports, "resolveStyle", () => $52cae6c6abcca240$export$d2850a44b8d56931);
/**
 * If the provided style is an object, it will be returned as is.
 * Otherwise, the function will call the style function with the state as the first argument.
 *
 * @param style
 * @param state
 */ function $52cae6c6abcca240$export$d2850a44b8d56931(style, state) {
    return typeof style === 'function' ? style(state) : style;
}

});

parcelRegister("eFu2T", function(module, exports) {

$parcel$export(module.exports, "mergeProps", () => $e787691fb2224f16$export$9d1611c77c2fe928);
$parcel$export(module.exports, "mergePropsN", () => $e787691fb2224f16$export$c05cca1bad1f033d);
$parcel$export(module.exports, "mergeClassNames", () => $e787691fb2224f16$export$8bf64cd1c29a1310);
$parcel$export(module.exports, "makeEventPreventable", () => $e787691fb2224f16$export$ae9f5e45368796a5);

var $eSKeI = parcelRequire("eSKeI");
const $e787691fb2224f16$var$EMPTY_PROPS = {};
function $e787691fb2224f16$export$9d1611c77c2fe928(a, b, c, d, e) {
    if (!c && !d && !e && !a) return $e787691fb2224f16$var$createInitialMergedProps(b);
    // We need to mutably own `merged`.
    let merged = $e787691fb2224f16$var$createInitialMergedProps(a);
    if (b) merged = $e787691fb2224f16$var$mergeInto(merged, b);
    if (c) merged = $e787691fb2224f16$var$mergeInto(merged, c);
    if (d) merged = $e787691fb2224f16$var$mergeInto(merged, d);
    if (e) merged = $e787691fb2224f16$var$mergeInto(merged, e);
    return merged;
}
function $e787691fb2224f16$export$c05cca1bad1f033d(props) {
    if (props.length === 0) return $e787691fb2224f16$var$EMPTY_PROPS;
    if (props.length === 1) return $e787691fb2224f16$var$createInitialMergedProps(props[0]);
    // We need to mutably own `merged`.
    let merged = $e787691fb2224f16$var$createInitialMergedProps(props[0]);
    for(let i = 1; i < props.length; i += 1)merged = $e787691fb2224f16$var$mergeInto(merged, props[i]);
    return merged;
}
function $e787691fb2224f16$var$createInitialMergedProps(inputProps) {
    if ($e787691fb2224f16$var$isPropsGetter(inputProps)) // Getter-returned handlers intentionally keep their existing semantics.
    return {
        ...$e787691fb2224f16$var$resolvePropsGetter(inputProps, $e787691fb2224f16$var$EMPTY_PROPS)
    };
    return $e787691fb2224f16$var$copyInitialProps(inputProps);
}
function $e787691fb2224f16$var$mergeInto(merged, inputProps) {
    if ($e787691fb2224f16$var$isPropsGetter(inputProps)) return $e787691fb2224f16$var$resolvePropsGetter(inputProps, merged);
    return $e787691fb2224f16$var$mutablyMergeInto(merged, inputProps);
}
function $e787691fb2224f16$var$copyInitialProps(inputProps) {
    const copiedProps = {
        ...inputProps
    };
    // `copiedProps` is our fresh own-object copy, so iterating with `for...in` is safe here.
    // eslint-disable-next-line guard-for-in
    for(const propName in copiedProps){
        const propValue = copiedProps[propName];
        if ($e787691fb2224f16$var$isEventHandler(propName, propValue)) copiedProps[propName] = $e787691fb2224f16$var$wrapEventHandler(propValue);
    }
    return copiedProps;
}
/**
 * Merges two sets of props. In case of conflicts, the external props take precedence.
 */ function $e787691fb2224f16$var$mutablyMergeInto(mergedProps, externalProps) {
    if (!externalProps) return mergedProps;
    // eslint-disable-next-line guard-for-in
    for(const propName in externalProps){
        const externalPropValue = externalProps[propName];
        switch(propName){
            case 'style':
                mergedProps[propName] = (0, $eSKeI.mergeObjects)(mergedProps.style, externalPropValue);
                break;
            case 'className':
                mergedProps[propName] = $e787691fb2224f16$export$8bf64cd1c29a1310(mergedProps.className, externalPropValue);
                break;
            default:
                if ($e787691fb2224f16$var$isEventHandler(propName, externalPropValue)) mergedProps[propName] = $e787691fb2224f16$var$mergeEventHandlers(mergedProps[propName], externalPropValue);
                else mergedProps[propName] = externalPropValue;
        }
    }
    return mergedProps;
}
function $e787691fb2224f16$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const code0 = key.charCodeAt(0);
    const code1 = key.charCodeAt(1);
    const code2 = key.charCodeAt(2);
    return code0 === 111 /* o */  && code1 === 110 /* n */  && code2 >= 65 /* A */  && code2 <= 90 /* Z */  && (typeof value === 'function' || typeof value === 'undefined');
}
function $e787691fb2224f16$var$isPropsGetter(inputProps) {
    return typeof inputProps === 'function';
}
function $e787691fb2224f16$var$resolvePropsGetter(inputProps, previousProps) {
    if ($e787691fb2224f16$var$isPropsGetter(inputProps)) return inputProps(previousProps);
    return inputProps ?? $e787691fb2224f16$var$EMPTY_PROPS;
}
function $e787691fb2224f16$var$mergeEventHandlers(ourHandler, theirHandler) {
    if (!theirHandler) return ourHandler;
    if (!ourHandler) return $e787691fb2224f16$var$wrapEventHandler(theirHandler);
    return (...args)=>{
        const event = args[0];
        if ($e787691fb2224f16$var$isSyntheticEvent(event)) {
            const baseUIEvent = event;
            $e787691fb2224f16$export$ae9f5e45368796a5(baseUIEvent);
            const result = theirHandler(...args);
            if (!baseUIEvent.baseUIHandlerPrevented) ourHandler?.(...args);
            return result;
        }
        const result = theirHandler(...args);
        ourHandler?.(...args);
        return result;
    };
}
function $e787691fb2224f16$var$wrapEventHandler(handler) {
    if (!handler) return handler;
    return (...args)=>{
        const event = args[0];
        if ($e787691fb2224f16$var$isSyntheticEvent(event)) $e787691fb2224f16$export$ae9f5e45368796a5(event);
        return handler(...args);
    };
}
function $e787691fb2224f16$export$ae9f5e45368796a5(event) {
    event.preventBaseUIHandler = ()=>{
        event.baseUIHandlerPrevented = true;
    };
    return event;
}
function $e787691fb2224f16$export$8bf64cd1c29a1310(ourClassName, theirClassName) {
    if (theirClassName) {
        if (ourClassName) // eslint-disable-next-line prefer-template
        return theirClassName + ' ' + ourClassName;
        return theirClassName;
    }
    return ourClassName;
}
function $e787691fb2224f16$var$isSyntheticEvent(event) {
    return event != null && typeof event === 'object' && 'nativeEvent' in event;
}

});


parcelRegister("gVYSt", function(module, exports) {

$parcel$export(module.exports, "CommonPopupDataAttributes", () => $99e5408334edadc7$export$aba256529f8ef8d1);
$parcel$export(module.exports, "triggerOpenStateMapping", () => $99e5408334edadc7$export$73e32e420c712e0e);
$parcel$export(module.exports, "pressableTriggerOpenStateMapping", () => $99e5408334edadc7$export$891f541c035ec78b);
$parcel$export(module.exports, "popupStateMapping", () => $99e5408334edadc7$export$80af82586a706c48);

var $eeCd6 = parcelRequire("eeCd6");
let $99e5408334edadc7$export$aba256529f8ef8d1 = function(CommonPopupDataAttributes) {
    /**
   * Present when the popup is open.
   */ CommonPopupDataAttributes["open"] = "data-open";
    /**
   * Present when the popup is closed.
   */ CommonPopupDataAttributes["closed"] = "data-closed";
    /**
   * Present when the popup is animating in.
   */ CommonPopupDataAttributes[CommonPopupDataAttributes["startingStyle"] = (0, $eeCd6.TransitionStatusDataAttributes).startingStyle] = "startingStyle";
    /**
   * Present when the popup is animating out.
   */ CommonPopupDataAttributes[CommonPopupDataAttributes["endingStyle"] = (0, $eeCd6.TransitionStatusDataAttributes).endingStyle] = "endingStyle";
    /**
   * Present when the anchor is hidden.
   */ CommonPopupDataAttributes["anchorHidden"] = "data-anchor-hidden";
    /**
   * Indicates which side the popup is positioned relative to the trigger.
   * @type { 'top' | 'bottom' | 'left' | 'right' | 'inline-end' | 'inline-start'}
   */ CommonPopupDataAttributes["side"] = "data-side";
    /**
   * Indicates how the popup is aligned relative to specified side.
   * @type {'start' | 'center' | 'end'}
   */ CommonPopupDataAttributes["align"] = "data-align";
    return CommonPopupDataAttributes;
}({});
let $99e5408334edadc7$export$63a3173f1705cf80 = /*#__PURE__*/ function(CommonTriggerDataAttributes) {
    /**
   * Present when the popup is open.
   */ CommonTriggerDataAttributes["popupOpen"] = "data-popup-open";
    /**
   * Present when a pressable trigger is pressed.
   */ CommonTriggerDataAttributes["pressed"] = "data-pressed";
    return CommonTriggerDataAttributes;
}({});
const $99e5408334edadc7$var$TRIGGER_HOOK = {
    [$99e5408334edadc7$export$63a3173f1705cf80.popupOpen]: ''
};
const $99e5408334edadc7$var$PRESSABLE_TRIGGER_HOOK = {
    [$99e5408334edadc7$export$63a3173f1705cf80.popupOpen]: '',
    [$99e5408334edadc7$export$63a3173f1705cf80.pressed]: ''
};
const $99e5408334edadc7$var$POPUP_OPEN_HOOK = {
    [$99e5408334edadc7$export$aba256529f8ef8d1.open]: ''
};
const $99e5408334edadc7$var$POPUP_CLOSED_HOOK = {
    [$99e5408334edadc7$export$aba256529f8ef8d1.closed]: ''
};
const $99e5408334edadc7$var$ANCHOR_HIDDEN_HOOK = {
    [$99e5408334edadc7$export$aba256529f8ef8d1.anchorHidden]: ''
};
const $99e5408334edadc7$export$73e32e420c712e0e = {
    open (value) {
        if (value) return $99e5408334edadc7$var$TRIGGER_HOOK;
        return null;
    }
};
const $99e5408334edadc7$export$891f541c035ec78b = {
    open (value) {
        if (value) return $99e5408334edadc7$var$PRESSABLE_TRIGGER_HOOK;
        return null;
    }
};
const $99e5408334edadc7$export$80af82586a706c48 = {
    open (value) {
        if (value) return $99e5408334edadc7$var$POPUP_OPEN_HOOK;
        return $99e5408334edadc7$var$POPUP_CLOSED_HOOK;
    },
    anchorHidden (value) {
        if (value) return $99e5408334edadc7$var$ANCHOR_HIDDEN_HOOK;
        return null;
    }
};

});
parcelRegister("eeCd6", function(module, exports) {

$parcel$export(module.exports, "TransitionStatusDataAttributes", () => $c7dba2146cc5502a$export$4b8685558cabbeb5);
$parcel$export(module.exports, "transitionStatusMapping", () => $c7dba2146cc5502a$export$f278f9cc7af5e0a0);
let $c7dba2146cc5502a$export$4b8685558cabbeb5 = /*#__PURE__*/ function(TransitionStatusDataAttributes) {
    /**
   * Present when the component is animating in.
   */ TransitionStatusDataAttributes["startingStyle"] = "data-starting-style";
    /**
   * Present when the component is animating out.
   */ TransitionStatusDataAttributes["endingStyle"] = "data-ending-style";
    return TransitionStatusDataAttributes;
}({});
const $c7dba2146cc5502a$var$STARTING_HOOK = {
    [$c7dba2146cc5502a$export$4b8685558cabbeb5.startingStyle]: ''
};
const $c7dba2146cc5502a$var$ENDING_HOOK = {
    [$c7dba2146cc5502a$export$4b8685558cabbeb5.endingStyle]: ''
};
const $c7dba2146cc5502a$export$f278f9cc7af5e0a0 = {
    transitionStatus (value) {
        if (value === 'starting') return $c7dba2146cc5502a$var$STARTING_HOOK;
        if (value === 'ending') return $c7dba2146cc5502a$var$ENDING_HOOK;
        return null;
    }
};

});



parcelRegister("cG2jB", function(module, exports) {

$parcel$export(module.exports, "MenuBackdrop", () => $6b2f54c89a674391$export$1b8b8299c9d6524b);

var $8NFma = parcelRequire("8NFma");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $gVYSt = parcelRequire("gVYSt");

var $eeCd6 = parcelRequire("eeCd6");

var $gnjAY = parcelRequire("gnjAY");

var $66jhv = parcelRequire("66jhv");
'use client';
const $6b2f54c89a674391$var$stateAttributesMapping = {
    ...(0, $gVYSt.popupStateMapping),
    ...(0, $eeCd6.transitionStatusMapping)
};
const $6b2f54c89a674391$export$1b8b8299c9d6524b = /*#__PURE__*/ $8NFma.forwardRef(function MenuBackdrop(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, ...elementProps } = componentProps;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const open = store.useState('open');
    const mounted = store.useState('mounted');
    const transitionStatus = store.useState('transitionStatus');
    const lastOpenChangeReason = store.useState('lastOpenChangeReason');
    const contextMenuContext = (0, $gnjAY.useContextMenuRootContext)();
    const state = {
        open: open,
        transitionStatus: transitionStatus
    };
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        ref: contextMenuContext?.backdropRef ? [
            forwardedRef,
            contextMenuContext.backdropRef
        ] : forwardedRef,
        state: state,
        stateAttributesMapping: $6b2f54c89a674391$var$stateAttributesMapping,
        props: [
            {
                role: 'presentation',
                hidden: !mounted,
                style: {
                    pointerEvents: lastOpenChangeReason === (0, $66jhv).triggerHover ? 'none' : undefined,
                    userSelect: 'none',
                    WebkitUserSelect: 'none'
                }
            },
            elementProps
        ]
    });
});

});
parcelRegister("gnjAY", function(module, exports) {

$parcel$export(module.exports, "useContextMenuRootContext", () => $efdb2dbb0abf637d$export$45752890a1942aa5);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $efdb2dbb0abf637d$export$56ce68416a21cae2 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $efdb2dbb0abf637d$export$45752890a1942aa5(optional = true) {
    const context = $8NFma.useContext($efdb2dbb0abf637d$export$56ce68416a21cae2);
    if (context === undefined && !optional) throw new Error((0, $cmjqX.default)(25));
    return context;
}

});

parcelRegister("66jhv", function(module, exports) {

$parcel$export(module.exports, "none", () => $2a1f1706e36fbd8a$export$f883a24d5edde77c);
$parcel$export(module.exports, "triggerPress", () => $2a1f1706e36fbd8a$export$168ce8e593dffac9);
$parcel$export(module.exports, "triggerHover", () => $2a1f1706e36fbd8a$export$7acb746b16d9aaee);
$parcel$export(module.exports, "triggerFocus", () => $2a1f1706e36fbd8a$export$2b92016deb0b7aad);
$parcel$export(module.exports, "outsidePress", () => $2a1f1706e36fbd8a$export$9c47382658ca3c36);
$parcel$export(module.exports, "itemPress", () => $2a1f1706e36fbd8a$export$fad8c1173974a343);
$parcel$export(module.exports, "closePress", () => $2a1f1706e36fbd8a$export$18a5262b37ba1a8c);
$parcel$export(module.exports, "linkPress", () => $2a1f1706e36fbd8a$export$9d98c487d1e3a6ad);
$parcel$export(module.exports, "clearPress", () => $2a1f1706e36fbd8a$export$20a638e99c735c0a);
$parcel$export(module.exports, "chipRemovePress", () => $2a1f1706e36fbd8a$export$cef82b6d5a80b89a);
$parcel$export(module.exports, "trackPress", () => $2a1f1706e36fbd8a$export$9a7215eeb3481da);
$parcel$export(module.exports, "incrementPress", () => $2a1f1706e36fbd8a$export$4b392c66632d58d6);
$parcel$export(module.exports, "decrementPress", () => $2a1f1706e36fbd8a$export$cdf54452fe6e9275);
$parcel$export(module.exports, "inputChange", () => $2a1f1706e36fbd8a$export$f8f649294b55f3b1);
$parcel$export(module.exports, "inputClear", () => $2a1f1706e36fbd8a$export$4be3c315a63aed85);
$parcel$export(module.exports, "inputBlur", () => $2a1f1706e36fbd8a$export$119a6e3fd90ffb6);
$parcel$export(module.exports, "inputPaste", () => $2a1f1706e36fbd8a$export$3c771b17a70902c1);
$parcel$export(module.exports, "inputPress", () => $2a1f1706e36fbd8a$export$af096c0e70f23f2e);
$parcel$export(module.exports, "focusOut", () => $2a1f1706e36fbd8a$export$8ca6645eea8e91a);
$parcel$export(module.exports, "escapeKey", () => $2a1f1706e36fbd8a$export$ccb63190d6bf301);
$parcel$export(module.exports, "closeWatcher", () => $2a1f1706e36fbd8a$export$f9566ed05c1e8d2b);
$parcel$export(module.exports, "listNavigation", () => $2a1f1706e36fbd8a$export$cb59d774ca2a0300);
$parcel$export(module.exports, "keyboard", () => $2a1f1706e36fbd8a$export$cfdd767f5a513509);
$parcel$export(module.exports, "pointer", () => $2a1f1706e36fbd8a$export$b7fd2c2937973304);
$parcel$export(module.exports, "drag", () => $2a1f1706e36fbd8a$export$d7d5d435647ed5a0);
$parcel$export(module.exports, "wheel", () => $2a1f1706e36fbd8a$export$d3028820ea014224);
$parcel$export(module.exports, "scrub", () => $2a1f1706e36fbd8a$export$1b16ec8d157f41c5);
$parcel$export(module.exports, "cancelOpen", () => $2a1f1706e36fbd8a$export$1c9ae54cc6b509a1);
$parcel$export(module.exports, "siblingOpen", () => $2a1f1706e36fbd8a$export$638305f11ec56473);
$parcel$export(module.exports, "disabled", () => $2a1f1706e36fbd8a$export$683472f6198a076e);
$parcel$export(module.exports, "missing", () => $2a1f1706e36fbd8a$export$f156a189c8056443);
$parcel$export(module.exports, "initial", () => $2a1f1706e36fbd8a$export$59ff82fc918bd7e3);
$parcel$export(module.exports, "imperativeAction", () => $2a1f1706e36fbd8a$export$62f501d9b07f4b5);
$parcel$export(module.exports, "swipe", () => $2a1f1706e36fbd8a$export$32e668afce77959f);
$parcel$export(module.exports, "windowResize", () => $2a1f1706e36fbd8a$export$bad6189f4d27c01f);
const $2a1f1706e36fbd8a$export$f883a24d5edde77c = 'none';
const $2a1f1706e36fbd8a$export$168ce8e593dffac9 = 'trigger-press';
const $2a1f1706e36fbd8a$export$7acb746b16d9aaee = 'trigger-hover';
const $2a1f1706e36fbd8a$export$2b92016deb0b7aad = 'trigger-focus';
const $2a1f1706e36fbd8a$export$9c47382658ca3c36 = 'outside-press';
const $2a1f1706e36fbd8a$export$fad8c1173974a343 = 'item-press';
const $2a1f1706e36fbd8a$export$18a5262b37ba1a8c = 'close-press';
const $2a1f1706e36fbd8a$export$9d98c487d1e3a6ad = 'link-press';
const $2a1f1706e36fbd8a$export$20a638e99c735c0a = 'clear-press';
const $2a1f1706e36fbd8a$export$cef82b6d5a80b89a = 'chip-remove-press';
const $2a1f1706e36fbd8a$export$9a7215eeb3481da = 'track-press';
const $2a1f1706e36fbd8a$export$4b392c66632d58d6 = 'increment-press';
const $2a1f1706e36fbd8a$export$cdf54452fe6e9275 = 'decrement-press';
const $2a1f1706e36fbd8a$export$f8f649294b55f3b1 = 'input-change';
const $2a1f1706e36fbd8a$export$4be3c315a63aed85 = 'input-clear';
const $2a1f1706e36fbd8a$export$119a6e3fd90ffb6 = 'input-blur';
const $2a1f1706e36fbd8a$export$3c771b17a70902c1 = 'input-paste';
const $2a1f1706e36fbd8a$export$af096c0e70f23f2e = 'input-press';
const $2a1f1706e36fbd8a$export$8ca6645eea8e91a = 'focus-out';
const $2a1f1706e36fbd8a$export$ccb63190d6bf301 = 'escape-key';
const $2a1f1706e36fbd8a$export$f9566ed05c1e8d2b = 'close-watcher';
const $2a1f1706e36fbd8a$export$cb59d774ca2a0300 = 'list-navigation';
const $2a1f1706e36fbd8a$export$cfdd767f5a513509 = 'keyboard';
const $2a1f1706e36fbd8a$export$b7fd2c2937973304 = 'pointer';
const $2a1f1706e36fbd8a$export$d7d5d435647ed5a0 = 'drag';
const $2a1f1706e36fbd8a$export$d3028820ea014224 = 'wheel';
const $2a1f1706e36fbd8a$export$1b16ec8d157f41c5 = 'scrub';
const $2a1f1706e36fbd8a$export$1c9ae54cc6b509a1 = 'cancel-open';
const $2a1f1706e36fbd8a$export$638305f11ec56473 = 'sibling-open';
const $2a1f1706e36fbd8a$export$683472f6198a076e = 'disabled';
const $2a1f1706e36fbd8a$export$f156a189c8056443 = 'missing';
const $2a1f1706e36fbd8a$export$59ff82fc918bd7e3 = 'initial';
const $2a1f1706e36fbd8a$export$62f501d9b07f4b5 = 'imperative-action';
const $2a1f1706e36fbd8a$export$32e668afce77959f = 'swipe';
const $2a1f1706e36fbd8a$export$bad6189f4d27c01f = 'window-resize';

});


parcelRegister("93FQR", function(module, exports) {

$parcel$export(module.exports, "MenuCheckboxItem", () => $c081baf74f73d2a5$export$f6f243521332502d);

var $8NFma = parcelRequire("8NFma");

var $2W2EF = parcelRequire("2W2EF");

var $8kC0B = parcelRequire("8kC0B");

var $kFTCr = parcelRequire("kFTCr");

var $ipY60 = parcelRequire("ipY60");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $hF6bp = parcelRequire("hF6bp");

var $bwGxG = parcelRequire("bwGxG");

var $8foVs = parcelRequire("8foVs");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $c081baf74f73d2a5$export$f6f243521332502d = /*#__PURE__*/ $8NFma.forwardRef(function MenuCheckboxItem(componentProps, forwardedRef) {
    const { render: render, className: className, id: idProp, label: label, nativeButton: nativeButton = false, disabled: disabled = false, closeOnClick: closeOnClick = false, checked: checkedProp, defaultChecked: defaultChecked, onCheckedChange: onCheckedChange, style: style, ...elementProps } = componentProps;
    const listItem = (0, $ipY60.useCompositeListItem)({
        label: label
    });
    const menuPositionerContext = (0, $8foVs.useMenuPositionerContext)(true);
    const id = (0, $hF6bp.useBaseUiId)(idProp);
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const highlighted = store.useState('isActive', listItem.index);
    const itemProps = store.useState('itemProps');
    const [checked, setChecked] = (0, $2W2EF.useControlled)({
        controlled: checkedProp,
        default: defaultChecked ?? false,
        name: 'MenuCheckboxItem',
        state: 'checked'
    });
    const { getItemProps: getItemProps, itemRef: itemRef } = (0, $kFTCr.useMenuItem)({
        closeOnClick: closeOnClick,
        disabled: disabled,
        highlighted: highlighted,
        id: id,
        store: store,
        nativeButton: nativeButton,
        nodeId: menuPositionerContext?.context.nodeId,
        itemMetadata: (0, $kFTCr.REGULAR_ITEM)
    });
    const state = $8NFma.useMemo(()=>({
            disabled: disabled,
            highlighted: highlighted,
            checked: checked
        }), [
        disabled,
        highlighted,
        checked
    ]);
    function handleClick(event) {
        const details = (0, $6e5YN.createChangeEventDetails)((0, $66jhv).itemPress, event.nativeEvent, undefined, {
            preventUnmountOnClose () {}
        });
        onCheckedChange?.(!checked, details);
        if (details.isCanceled) return;
        setChecked((currentlyChecked)=>!currentlyChecked);
    }
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        stateAttributesMapping: (0, $bwGxG.itemMapping),
        props: [
            itemProps,
            {
                role: 'menuitemcheckbox',
                'aria-checked': checked,
                onClick: handleClick
            },
            elementProps,
            getItemProps
        ],
        ref: [
            itemRef,
            forwardedRef,
            listItem.ref
        ]
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8kC0B.MenuCheckboxItemContext).Provider, {
        value: state,
        children: element
    });
});

});
parcelRegister("2W2EF", function(module, exports) {

$parcel$export(module.exports, "useControlled", () => $6b7acb9b90ab4f41$export$ec718fafe76f05a6);

var $8NFma = parcelRequire("8NFma");

'use client';
function $6b7acb9b90ab4f41$export$ec718fafe76f05a6({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8NFma.useRef(controlled !== undefined);
    const [valueState, setValue] = $8NFma.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8NFma.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}
function $6b7acb9b90ab4f41$var$serializeToDevModeString(input) {
    let nextId = 0;
    const seen = new WeakMap();
    try {
        const result = JSON.stringify(input, function replacer(key, value) {
            if (key === '_owner' && this != null && typeof this === 'object' && '$$typeof' in this) return undefined;
            if (typeof value === 'bigint') return `__bigint__:${value}`;
            if (value !== null && typeof value === 'object') {
                const id = seen.get(value);
                if (id !== undefined) return `__object__:${id}`;
                seen.set(value, nextId);
                nextId += 1;
            }
            return value;
        });
        return result ?? `__top__:${typeof input}`;
    } catch  {
        return '__unserializable__';
    }
}

});

parcelRegister("8kC0B", function(module, exports) {

$parcel$export(module.exports, "MenuCheckboxItemContext", () => $41421f615f213365$export$ab022d463924b48b);
$parcel$export(module.exports, "useMenuCheckboxItemContext", () => $41421f615f213365$export$b9c52b4421dacd7b);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $41421f615f213365$export$ab022d463924b48b = /*#__PURE__*/ $8NFma.createContext(undefined);
function $41421f615f213365$export$b9c52b4421dacd7b() {
    const context = $8NFma.useContext($41421f615f213365$export$ab022d463924b48b);
    if (context === undefined) throw new Error((0, $cmjqX.default)(30));
    return context;
}

});

parcelRegister("kFTCr", function(module, exports) {

$parcel$export(module.exports, "REGULAR_ITEM", () => $7c40f957943b490b$export$ab359cecf1824f46);
$parcel$export(module.exports, "useMenuItem", () => $7c40f957943b490b$export$9d32628fc2aea7da);

var $8NFma = parcelRequire("8NFma");

var $ghAB8 = parcelRequire("ghAB8");

var $hSxhk = parcelRequire("hSxhk");

var $eFu2T = parcelRequire("eFu2T");

var $fzgw1 = parcelRequire("fzgw1");
'use client';
const $7c40f957943b490b$export$ab359cecf1824f46 = {
    type: 'regular-item'
};
function $7c40f957943b490b$export$9d32628fc2aea7da(params) {
    const { closeOnClick: closeOnClick, disabled: disabledProp = false, highlighted: highlighted, id: id, store: store, typingRef: typingRef = store.context.typingRef, nativeButton: nativeButton, itemMetadata: itemMetadata, nodeId: nodeId } = params;
    const rootDisabled = store.useState('disabled');
    const disabled = disabledProp || rootDisabled;
    const itemRef = $8NFma.useRef(null);
    const { getButtonProps: getButtonProps, buttonRef: buttonRef } = (0, $hSxhk.useButton)({
        disabled: disabled,
        focusableWhenDisabled: true,
        native: nativeButton,
        composite: true
    });
    const commonProps = (0, $fzgw1.useMenuItemCommonProps)({
        closeOnClick: closeOnClick,
        highlighted: highlighted,
        id: id,
        nodeId: nodeId,
        store: store,
        typingRef: typingRef,
        itemRef: itemRef,
        itemMetadata: itemMetadata
    });
    const getItemProps = $8NFma.useCallback((externalProps)=>{
        return (0, $eFu2T.mergeProps)(commonProps, {
            onMouseEnter () {
                if (itemMetadata.type !== 'submenu-trigger') return;
                itemMetadata.setActive();
            }
        }, externalProps, getButtonProps);
    }, [
        commonProps,
        getButtonProps,
        itemMetadata
    ]);
    const mergedRef = (0, $ghAB8.useMergedRefs)(itemRef, buttonRef);
    return $8NFma.useMemo(()=>({
            getItemProps: getItemProps,
            itemRef: mergedRef
        }), [
        getItemProps,
        mergedRef
    ]);
}

});
parcelRegister("hSxhk", function(module, exports) {

$parcel$export(module.exports, "useButton", () => $1986499b7c0f3341$export$ea18c227d4417cc3);

var $8NFma = parcelRequire("8NFma");

var $1D9S2 = parcelRequire("1D9S2");

var $fKU9M = parcelRequire("fKU9M");



var $9N3e2 = parcelRequire("9N3e2");

var $eFu2T = parcelRequire("eFu2T");

var $hmL59 = parcelRequire("hmL59");

var $2DcHZ = parcelRequire("2DcHZ");
'use client';
function $1986499b7c0f3341$export$ea18c227d4417cc3(parameters = {}) {
    const { disabled: disabled = false, focusableWhenDisabled: focusableWhenDisabled, tabIndex: tabIndex = 0, native: isNativeButton = true, composite: compositeProp } = parameters;
    const elementRef = $8NFma.useRef(null);
    const compositeRootContext = (0, $hmL59.useCompositeRootContext)(true);
    const isCompositeItem = compositeProp ?? compositeRootContext !== undefined;
    const { props: focusableWhenDisabledProps } = (0, $2DcHZ.useFocusableWhenDisabled)({
        focusableWhenDisabled: focusableWhenDisabled,
        disabled: disabled,
        composite: isCompositeItem,
        tabIndex: tabIndex,
        isNativeButton: isNativeButton
    });
    // handles a disabled composite button rendering another button, e.g.
    // <Toolbar.Button disabled render={<Menu.Trigger />} />
    // the `disabled` prop needs to pass through 2 `useButton`s then finally
    // delete the `disabled` attribute from DOM
    const updateDisabled = $8NFma.useCallback(()=>{
        const element = elementRef.current;
        if (!$1986499b7c0f3341$var$isButtonElement(element)) return;
        if (isCompositeItem && disabled && focusableWhenDisabledProps.disabled === undefined && element.disabled) element.disabled = false;
    }, [
        disabled,
        focusableWhenDisabledProps.disabled,
        isCompositeItem
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(updateDisabled, [
        updateDisabled
    ]);
    const getButtonProps = $8NFma.useCallback((externalProps = {})=>{
        const { onClick: externalOnClick, onMouseDown: externalOnMouseDown, onKeyUp: externalOnKeyUp, onKeyDown: externalOnKeyDown, onPointerDown: externalOnPointerDown, ...otherExternalProps } = externalProps;
        return (0, $eFu2T.mergeProps)({
            onClick (event) {
                if (disabled) {
                    event.preventDefault();
                    return;
                }
                externalOnClick?.(event);
            },
            onMouseDown (event) {
                if (!disabled) externalOnMouseDown?.(event);
            },
            onKeyDown (event) {
                if (disabled) return;
                (0, $eFu2T.makeEventPreventable)(event);
                externalOnKeyDown?.(event);
                if (event.baseUIHandlerPrevented) return;
                const isCurrentTarget = event.target === event.currentTarget;
                const currentTarget = event.currentTarget;
                const isButton = $1986499b7c0f3341$var$isButtonElement(currentTarget);
                const isLink = !isNativeButton && $1986499b7c0f3341$var$isValidLinkElement(currentTarget);
                const shouldClick = isCurrentTarget && (isNativeButton ? isButton : !isLink);
                const isEnterKey = event.key === 'Enter';
                const isSpaceKey = event.key === ' ';
                const role = currentTarget.getAttribute('role');
                const isTextNavigationRole = role?.startsWith('menuitem') || role === 'option' || role === 'gridcell';
                if (isCurrentTarget && isCompositeItem && isSpaceKey) {
                    if (event.defaultPrevented && isTextNavigationRole) return;
                    event.preventDefault();
                    if (isLink || isNativeButton && isButton) {
                        currentTarget.click();
                        event.preventBaseUIHandler();
                    } else if (shouldClick) {
                        externalOnClick?.(event);
                        event.preventBaseUIHandler();
                    }
                    return;
                }
                // Keyboard accessibility for native and non-native elements.
                if (shouldClick) {
                    if (!isNativeButton && (isSpaceKey || isEnterKey)) event.preventDefault();
                    if (!isNativeButton && isEnterKey) externalOnClick?.(event);
                }
            },
            onKeyUp (event) {
                if (disabled) return;
                // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
                // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
                (0, $eFu2T.makeEventPreventable)(event);
                externalOnKeyUp?.(event);
                if (event.target === event.currentTarget && isNativeButton && isCompositeItem && $1986499b7c0f3341$var$isButtonElement(event.currentTarget) && event.key === ' ') {
                    event.preventDefault();
                    return;
                }
                if (event.baseUIHandlerPrevented) return;
                // Keyboard accessibility for non interactive elements
                if (event.target === event.currentTarget && !isNativeButton && !isCompositeItem && event.key === ' ') externalOnClick?.(event);
            },
            onPointerDown (event) {
                if (disabled) {
                    event.preventDefault();
                    return;
                }
                externalOnPointerDown?.(event);
            }
        }, isNativeButton ? {
            type: 'button'
        } : {
            role: 'button'
        }, focusableWhenDisabledProps, otherExternalProps);
    }, [
        disabled,
        focusableWhenDisabledProps,
        isCompositeItem,
        isNativeButton
    ]);
    const buttonRef = (0, $fKU9M.useStableCallback)((element)=>{
        elementRef.current = element;
        updateDisabled();
    });
    return {
        getButtonProps: getButtonProps,
        buttonRef: buttonRef
    };
}
function $1986499b7c0f3341$var$isButtonElement(elem) {
    return (0, $1D9S2.isHTMLElement)(elem) && elem.tagName === 'BUTTON';
}
function $1986499b7c0f3341$var$isValidLinkElement(elem) {
    return Boolean(elem?.tagName === 'A' && elem?.href);
}

});
parcelRegister("1D9S2", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $1301171352b69415$export$651544f548703224);
$parcel$export(module.exports, "isNode", () => $1301171352b69415$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "getWindow", () => $1301171352b69415$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $1301171352b69415$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $1301171352b69415$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $1301171352b69415$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $1301171352b69415$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $1301171352b69415$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $1301171352b69415$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $1301171352b69415$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $1301171352b69415$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $1301171352b69415$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $1301171352b69415$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $1301171352b69415$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $1301171352b69415$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $1301171352b69415$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $1301171352b69415$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $1301171352b69415$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $1301171352b69415$export$7bf1f8740e3e34af);
function $1301171352b69415$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1301171352b69415$export$651544f548703224(node) {
    if ($1301171352b69415$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1301171352b69415$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1301171352b69415$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1301171352b69415$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1301171352b69415$export$8ee0fc9ee280b4ee(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Node;
}
function $1301171352b69415$export$45a5e7f76e0caa8d(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Element;
}
function $1301171352b69415$export$1b3bfaa9684536aa(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1301171352b69415$export$af51f0f06c0f328a(value) {
    if (!$1301171352b69415$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1301171352b69415$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1301171352b69415$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $1301171352b69415$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($1301171352b69415$export$651544f548703224(element));
}
function $1301171352b69415$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $1301171352b69415$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $1301171352b69415$var$containRe = /paint|layout|strict|content/;
const $1301171352b69415$var$isNotNone = (value)=>!!value && value !== 'none';
let $1301171352b69415$var$isWebKitValue;
function $1301171352b69415$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $1301171352b69415$export$45a5e7f76e0caa8d(elementOrCss) ? $1301171352b69415$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $1301171352b69415$var$isNotNone(css.transform) || $1301171352b69415$var$isNotNone(css.translate) || $1301171352b69415$var$isNotNone(css.scale) || $1301171352b69415$var$isNotNone(css.rotate) || $1301171352b69415$var$isNotNone(css.perspective) || !$1301171352b69415$export$78551043582a6a98() && ($1301171352b69415$var$isNotNone(css.backdropFilter) || $1301171352b69415$var$isNotNone(css.filter)) || $1301171352b69415$var$willChangeRe.test(css.willChange || '') || $1301171352b69415$var$containRe.test(css.contain || '');
}
function $1301171352b69415$export$940d8225183e1404(element) {
    let currentNode = $1301171352b69415$export$4e12058fc4d51d56(element);
    while($1301171352b69415$export$1b3bfaa9684536aa(currentNode) && !$1301171352b69415$export$d1162fb0b6d4cd51(currentNode)){
        if ($1301171352b69415$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1301171352b69415$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1301171352b69415$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1301171352b69415$export$78551043582a6a98() {
    if ($1301171352b69415$var$isWebKitValue == null) $1301171352b69415$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $1301171352b69415$var$isWebKitValue;
}
function $1301171352b69415$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($1301171352b69415$export$651544f548703224(node));
}
function $1301171352b69415$export$3735103072e4a80(element) {
    return $1301171352b69415$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1301171352b69415$export$dc8fc79fa2800137(element) {
    if ($1301171352b69415$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1301171352b69415$export$4e12058fc4d51d56(node) {
    if ($1301171352b69415$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1301171352b69415$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1301171352b69415$export$e495491855dc5418(node);
    return $1301171352b69415$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1301171352b69415$export$7cd01a57c8ca906c(node) {
    const parentNode = $1301171352b69415$export$4e12058fc4d51d56(node);
    if ($1301171352b69415$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1301171352b69415$export$1b3bfaa9684536aa(parentNode) && $1301171352b69415$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1301171352b69415$export$7cd01a57c8ca906c(parentNode);
}
function $1301171352b69415$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1301171352b69415$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1301171352b69415$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1301171352b69415$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1301171352b69415$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1301171352b69415$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $1301171352b69415$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1301171352b69415$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});

parcelRegister("fKU9M", function(module, exports) {

$parcel$export(module.exports, "useStableCallback", () => $8f4fb075feb402bb$export$1a8b1350915fe2e0);

var $itiN7 = parcelRequire("itiN7");

var $gidzQ = parcelRequire("gidzQ");
'use client';
const $8f4fb075feb402bb$var$useInsertionEffect = (0, $itiN7.SafeReact).useInsertionEffect;
const $8f4fb075feb402bb$var$useSafeInsertionEffect = // React 17 doesn't have useInsertionEffect.
$8f4fb075feb402bb$var$useInsertionEffect && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
$8f4fb075feb402bb$var$useInsertionEffect !== (0, $itiN7.SafeReact).useLayoutEffect ? $8f4fb075feb402bb$var$useInsertionEffect : (fn)=>fn();
function $8f4fb075feb402bb$export$1a8b1350915fe2e0(callback) {
    const stable = (0, $gidzQ.useRefWithInit)($8f4fb075feb402bb$var$createStableCallback).current;
    stable.next = callback;
    $8f4fb075feb402bb$var$useSafeInsertionEffect(stable.effect);
    return stable.trampoline;
}
function $8f4fb075feb402bb$var$createStableCallback() {
    const stable = {
        next: undefined,
        callback: $8f4fb075feb402bb$var$assertNotCalled,
        trampoline: (...args)=>stable.callback?.(...args),
        effect: ()=>{
            stable.callback = stable.next;
        }
    };
    return stable;
}
function $8f4fb075feb402bb$var$assertNotCalled() {}

});
parcelRegister("itiN7", function(module, exports) {

$parcel$export(module.exports, "SafeReact", () => $57b2160fd8105742$export$6a19590338070f66);

var $8NFma = parcelRequire("8NFma");
const $57b2160fd8105742$export$6a19590338070f66 = {
    ...$8NFma
};

});


parcelRegister("9N3e2", function(module, exports) {

$parcel$export(module.exports, "useIsoLayoutEffect", () => $ea4c53734a4deb8c$export$730fae65bfacf67e);

var $8NFma = parcelRequire("8NFma");
'use client';
const $ea4c53734a4deb8c$var$noop = ()=>{};
const $ea4c53734a4deb8c$export$730fae65bfacf67e = typeof document !== 'undefined' ? $8NFma.useLayoutEffect : $ea4c53734a4deb8c$var$noop;

});

parcelRegister("hmL59", function(module, exports) {

$parcel$export(module.exports, "useCompositeRootContext", () => $16c231a7a26113dd$export$15515d9298dc748c);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $16c231a7a26113dd$export$92b9edc33848704e = /*#__PURE__*/ $8NFma.createContext(undefined);
function $16c231a7a26113dd$export$15515d9298dc748c(optional = false) {
    const context = $8NFma.useContext($16c231a7a26113dd$export$92b9edc33848704e);
    if (context === undefined && !optional) throw new Error((0, $cmjqX.default)(16));
    return context;
}

});

parcelRegister("2DcHZ", function(module, exports) {

$parcel$export(module.exports, "useFocusableWhenDisabled", () => $1146f36f7c74ffbb$export$2158d8cac464bf12);

var $8NFma = parcelRequire("8NFma");
'use client';
function $1146f36f7c74ffbb$export$2158d8cac464bf12(parameters) {
    const { focusableWhenDisabled: focusableWhenDisabled, disabled: disabled, composite: composite = false, tabIndex: tabIndexProp = 0, isNativeButton: isNativeButton } = parameters;
    const isFocusableComposite = composite && focusableWhenDisabled !== false;
    const isNonFocusableComposite = composite && focusableWhenDisabled === false;
    // we can't explicitly assign `undefined` to any of these props because it
    // would otherwise prevent subsequently merged props from setting them
    const props = $8NFma.useMemo(()=>{
        const additionalProps = {
            // allow Tabbing away from focusableWhenDisabled elements
            onKeyDown (event) {
                if (disabled && focusableWhenDisabled && event.key !== 'Tab') event.preventDefault();
            }
        };
        if (!composite) {
            additionalProps.tabIndex = tabIndexProp;
            if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
        }
        if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps['aria-disabled'] = disabled;
        if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
        return additionalProps;
    }, [
        composite,
        disabled,
        focusableWhenDisabled,
        isFocusableComposite,
        isNonFocusableComposite,
        isNativeButton,
        tabIndexProp
    ]);
    return {
        props: props
    };
}

});


parcelRegister("fzgw1", function(module, exports) {

$parcel$export(module.exports, "useMenuItemCommonProps", () => $af69cb3e1a2cc585$export$aab3290a3190584a);

var $8NFma = parcelRequire("8NFma");

var $8QwT3 = parcelRequire("8QwT3");

var $66jhv = parcelRequire("66jhv");

var $gnjAY = parcelRequire("gnjAY");
'use client';
function $af69cb3e1a2cc585$export$aab3290a3190584a(params) {
    const { closeOnClick: closeOnClick, highlighted: highlighted, id: id, nodeId: nodeId, store: store, typingRef: typingRef, itemRef: itemRef, itemMetadata: itemMetadata } = params;
    const { events: menuEvents } = store.useState('floatingTreeRoot');
    const open = store.useState('open');
    const contextMenuContext = (0, $gnjAY.useContextMenuRootContext)(true);
    const isContextMenu = contextMenuContext !== undefined;
    return $8NFma.useMemo(()=>({
            id: id,
            role: 'menuitem',
            tabIndex: open && highlighted ? 0 : -1,
            onKeyDown (event) {
                if (event.key === ' ' && typingRef?.current) event.preventDefault();
            },
            onMouseMove (event) {
                if (!nodeId) return;
                // Inform the floating tree that a menu item within this menu was hovered/moved over
                // so unrelated descendant submenus can be closed.
                menuEvents.emit('itemhover', {
                    nodeId: nodeId,
                    target: event.currentTarget
                });
            },
            onClick (event) {
                if (closeOnClick) menuEvents.emit('close', {
                    domEvent: event,
                    reason: (0, $66jhv).itemPress
                });
            },
            onMouseUp (event) {
                if (contextMenuContext) {
                    const initialCursorPoint = contextMenuContext.initialCursorPointRef.current;
                    contextMenuContext.initialCursorPointRef.current = null;
                    if (isContextMenu && initialCursorPoint && Math.abs(event.clientX - initialCursorPoint.x) <= 1 && Math.abs(event.clientY - initialCursorPoint.y) <= 1) return;
                    // On non-macOS platforms, this mouseup belongs to the right-click gesture
                    // that opened the context menu, so it must not activate an item.
                    if (isContextMenu && !(0, $8QwT3).os.mac && event.button === 2) return;
                }
                if (itemRef.current && store.context.allowMouseUpTriggerRef.current && (!isContextMenu || event.button === 2)) // This fires whenever the user clicks on the trigger, moves the cursor, and releases it over the item.
                // We trigger the click and override the `closeOnClick` preference to always close the menu.
                {
                    if (!itemMetadata || itemMetadata.type === 'regular-item') itemRef.current.click();
                }
            }
        }), [
        closeOnClick,
        highlighted,
        id,
        menuEvents,
        nodeId,
        open,
        store,
        typingRef,
        itemRef,
        contextMenuContext,
        isContextMenu,
        itemMetadata
    ]);
}

});
parcelRegister("8QwT3", function(module, exports) {

$parcel$export(module.exports, "os", () => (parcelRequire("bVZMS")));
$parcel$export(module.exports, "engine", () => (parcelRequire("jWOJl")));
$parcel$export(module.exports, "screenReader", () => (parcelRequire("1H8lc")));
$parcel$export(module.exports, "env", () => (parcelRequire("2F3WM")));

var $bVZMS = parcelRequire("bVZMS");

var $jWOJl = parcelRequire("jWOJl");

var $1H8lc = parcelRequire("1H8lc");

var $2F3WM = parcelRequire("2F3WM");

});
parcelRegister("bVZMS", function(module, exports) {

$parcel$export(module.exports, "ios", () => $46b98a06334428c1$export$e23a29e65f46331c);
$parcel$export(module.exports, "android", () => $46b98a06334428c1$export$49aa0afaaf9db9cb);
$parcel$export(module.exports, "mac", () => $46b98a06334428c1$export$f8d11e097856efcf);
$parcel$export(module.exports, "windows", () => $46b98a06334428c1$export$7379d955a61e74ce);
$parcel$export(module.exports, "linux", () => $46b98a06334428c1$export$b77cd0e2f325ccd7);
$parcel$export(module.exports, "apple", () => $46b98a06334428c1$export$e4305d08716d0e44);

var $dY0gF = parcelRequire("dY0gF");
const $46b98a06334428c1$export$e23a29e65f46331c = /^i(os$|p)/.test((0, $dY0gF.lowerPlatform)) || (0, $dY0gF.lowerPlatform) === 'macintel' && (0, $dY0gF.maxTouchPoints) > 1;
/** Android phones, tablets, and embedded Android browsers. */ const $46b98a06334428c1$var$ANDROID_STRING = 'android';
const $46b98a06334428c1$export$49aa0afaaf9db9cb = (0, $dY0gF.lowerPlatform) === $46b98a06334428c1$var$ANDROID_STRING || (0, $dY0gF.lowerUserAgent).includes($46b98a06334428c1$var$ANDROID_STRING);
const $46b98a06334428c1$export$f8d11e097856efcf = !$46b98a06334428c1$export$e23a29e65f46331c && (0, $dY0gF.lowerPlatform).startsWith('mac');
const $46b98a06334428c1$export$7379d955a61e74ce = (0, $dY0gF.lowerPlatform).startsWith('win');
const $46b98a06334428c1$export$b77cd0e2f325ccd7 = !$46b98a06334428c1$export$49aa0afaaf9db9cb && /^(linux|chrome os)/.test((0, $dY0gF.lowerPlatform));
const $46b98a06334428c1$export$e4305d08716d0e44 = $46b98a06334428c1$export$f8d11e097856efcf || $46b98a06334428c1$export$e23a29e65f46331c;

});
parcelRegister("dY0gF", function(module, exports) {

$parcel$export(module.exports, "maxTouchPoints", () => $b9b520e92c6c712a$export$ccc1f2c4577caf22);
$parcel$export(module.exports, "lowerUserAgent", () => $b9b520e92c6c712a$export$9e7c1e83f0ddaadf);
$parcel$export(module.exports, "lowerPlatform", () => $b9b520e92c6c712a$export$27cb41d0228144a2);
/**
 * Reads `navigator.userAgent` / `navigator.platform` (legacy but universally
 * supported) into a normalized shape. In development, prefers the modern
 * `navigator.userAgentData` API on Chromium to avoid DevTools warnings about
 * the deprecated reads; that branch is dead-code-eliminated in production
 * builds to keep the bundle small.
 *
 * Returns empty/zero values when `navigator` is undefined (SSR), so every
 * derived flag safely evaluates to `false`.
 */ function $b9b520e92c6c712a$var$readRawData() {
    if (typeof navigator === 'undefined') return {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    var brand, version;
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform ?? '',
        maxTouchPoints: navigator.maxTouchPoints ?? 0
    };
}
const { userAgent: $b9b520e92c6c712a$var$userAgent, platform: $b9b520e92c6c712a$var$platform, maxTouchPoints: $b9b520e92c6c712a$export$ccc1f2c4577caf22 } = $b9b520e92c6c712a$var$readRawData();
const $b9b520e92c6c712a$export$9e7c1e83f0ddaadf = $b9b520e92c6c712a$var$userAgent.toLowerCase();
const $b9b520e92c6c712a$export$27cb41d0228144a2 = $b9b520e92c6c712a$var$platform.toLowerCase();

});


parcelRegister("jWOJl", function(module, exports) {

$parcel$export(module.exports, "webkit", () => $02b345320aeb0b1c$export$db07bc05b2fb9b73);
$parcel$export(module.exports, "gecko", () => $02b345320aeb0b1c$export$249f5a6e3b293e58);
$parcel$export(module.exports, "blink", () => $02b345320aeb0b1c$export$a0f5ee27be08228f);

var $dY0gF = parcelRequire("dY0gF");
const $02b345320aeb0b1c$export$db07bc05b2fb9b73 = typeof CSS !== 'undefined' && !!CSS.supports?.('-webkit-backdrop-filter:none');
const $02b345320aeb0b1c$export$249f5a6e3b293e58 = !$02b345320aeb0b1c$export$db07bc05b2fb9b73 && (0, $dY0gF.lowerUserAgent).includes('firefox');
const $02b345320aeb0b1c$export$a0f5ee27be08228f = !$02b345320aeb0b1c$export$db07bc05b2fb9b73 && (0, $dY0gF.lowerUserAgent).includes('chrom');

});

parcelRegister("1H8lc", function(module, exports) {

$parcel$export(module.exports, "voiceOver", () => $cbdcfe2b44da911f$export$467b54ae74bada72);

var $bVZMS = parcelRequire("bVZMS");
const $cbdcfe2b44da911f$export$467b54ae74bada72 = (0, $bVZMS.apple);

});

parcelRegister("2F3WM", function(module, exports) {

$parcel$export(module.exports, "jsdom", () => $47bfcc428bac56fb$export$325417b62d941068);

var $dY0gF = parcelRequire("dY0gF");
const $47bfcc428bac56fb$export$325417b62d941068 = /jsdom|happydom/.test((0, $dY0gF.lowerUserAgent));

});




parcelRegister("ipY60", function(module, exports) {

$parcel$export(module.exports, "useCompositeListItem", () => $4e2751719a5e0dcd$export$8a988f366fc1f1e3);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $6lvpc = parcelRequire("6lvpc");
'use client';
let $4e2751719a5e0dcd$export$a733044304666de5 = /*#__PURE__*/ function(IndexGuessBehavior) {
    IndexGuessBehavior[IndexGuessBehavior["None"] = 0] = "None";
    IndexGuessBehavior[IndexGuessBehavior["GuessFromOrder"] = 1] = "GuessFromOrder";
    return IndexGuessBehavior;
}({});
function $4e2751719a5e0dcd$export$8a988f366fc1f1e3(params = {}) {
    const { label: label, metadata: metadata, textRef: textRef, indexGuessBehavior: indexGuessBehavior, index: externalIndex } = params;
    const { register: register, unregister: unregister, subscribeMapChange: subscribeMapChange, elementsRef: elementsRef, labelsRef: labelsRef, nextIndexRef: nextIndexRef } = (0, $6lvpc.useCompositeListContext)();
    const indexRef = $8NFma.useRef(-1);
    const [index, setIndex] = $8NFma.useState(externalIndex ?? (indexGuessBehavior === $4e2751719a5e0dcd$export$a733044304666de5.GuessFromOrder ? ()=>{
        if (indexRef.current === -1) {
            const newIndex = nextIndexRef.current;
            nextIndexRef.current += 1;
            indexRef.current = newIndex;
        }
        return indexRef.current;
    } : -1));
    const componentRef = $8NFma.useRef(null);
    const ref = $8NFma.useCallback((node)=>{
        componentRef.current = node;
        if (index !== -1 && node !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : textRef?.current?.textContent ?? node.textContent;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label,
        textRef
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (externalIndex != null) return undefined;
        const node = componentRef.current;
        if (node) {
            register(node, metadata);
            return ()=>{
                unregister(node);
            };
        }
        return undefined;
    }, [
        externalIndex,
        register,
        unregister,
        metadata
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (externalIndex != null) return undefined;
        return subscribeMapChange((map)=>{
            const i = componentRef.current ? map.get(componentRef.current)?.index : null;
            if (i != null) setIndex(i);
        });
    }, [
        externalIndex,
        subscribeMapChange,
        setIndex
    ]);
    return {
        ref: ref,
        index: index
    };
}

});
parcelRegister("6lvpc", function(module, exports) {

$parcel$export(module.exports, "CompositeListContext", () => $edec30286d149e0c$export$eaf0f3884322c0c3);
$parcel$export(module.exports, "useCompositeListContext", () => $edec30286d149e0c$export$2b70b0e7627a9f8e);

var $8NFma = parcelRequire("8NFma");
'use client';
const $edec30286d149e0c$export$eaf0f3884322c0c3 = /*#__PURE__*/ $8NFma.createContext({
    register: ()=>{},
    unregister: ()=>{},
    subscribeMapChange: ()=>{
        return ()=>{};
    },
    elementsRef: {
        current: []
    },
    nextIndexRef: {
        current: 0
    }
});
function $edec30286d149e0c$export$2b70b0e7627a9f8e() {
    return $8NFma.useContext($edec30286d149e0c$export$eaf0f3884322c0c3);
}

});


parcelRegister("hF6bp", function(module, exports) {

$parcel$export(module.exports, "useBaseUiId", () => $1adda5e032bb69c3$export$bcbc27c568d91d18);

var $8VAvD = parcelRequire("8VAvD");
'use client';
function $1adda5e032bb69c3$export$bcbc27c568d91d18(idOverride) {
    return (0, $8VAvD.useId)(idOverride, 'base-ui');
}

});
parcelRegister("8VAvD", function(module, exports) {

$parcel$export(module.exports, "useId", () => $11ab523a57711e24$export$f680877a34711e37);

var $8NFma = parcelRequire("8NFma");

var $itiN7 = parcelRequire("itiN7");
'use client';
let $11ab523a57711e24$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $11ab523a57711e24$var$useGlobalId(idOverride, prefix = 'mui') {
    const [defaultId, setDefaultId] = $8NFma.useState(idOverride);
    const id = idOverride || defaultId;
    $8NFma.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $11ab523a57711e24$var$globalId += 1;
            setDefaultId(`${prefix}-${$11ab523a57711e24$var$globalId}`);
        }
    }, [
        defaultId,
        prefix
    ]);
    return id;
}
const $11ab523a57711e24$var$maybeReactUseId = (0, $itiN7.SafeReact).useId;
function $11ab523a57711e24$export$f680877a34711e37(idOverride, prefix) {
    // React.useId() is only available from React 17.0.0.
    if ($11ab523a57711e24$var$maybeReactUseId !== undefined) {
        const reactId = $11ab523a57711e24$var$maybeReactUseId();
        return idOverride ?? (prefix ? `${prefix}-${reactId}` : reactId);
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $11ab523a57711e24$var$useGlobalId(idOverride, prefix);
}

});


parcelRegister("bwGxG", function(module, exports) {

$parcel$export(module.exports, "itemMapping", () => $bfae037e5357856e$export$14714ab72796a0c3);

var $eeCd6 = parcelRequire("eeCd6");

var $ffrR3 = parcelRequire("ffrR3");
const $bfae037e5357856e$export$14714ab72796a0c3 = {
    checked (value) {
        if (value) return {
            [(0, $ffrR3.MenuCheckboxItemDataAttributes).checked]: ''
        };
        return {
            [(0, $ffrR3.MenuCheckboxItemDataAttributes).unchecked]: ''
        };
    },
    ...(0, $eeCd6.transitionStatusMapping)
};

});
parcelRegister("ffrR3", function(module, exports) {

$parcel$export(module.exports, "MenuCheckboxItemDataAttributes", () => $903d66705541366e$export$ac533172b6312c55);
let $903d66705541366e$export$ac533172b6312c55 = /*#__PURE__*/ function(MenuCheckboxItemDataAttributes) {
    /**
   * Present when the menu checkbox item is checked.
   */ MenuCheckboxItemDataAttributes["checked"] = "data-checked";
    /**
   * Present when the menu checkbox item is not checked.
   */ MenuCheckboxItemDataAttributes["unchecked"] = "data-unchecked";
    /**
   * Present when the menu checkbox item is disabled.
   */ MenuCheckboxItemDataAttributes["disabled"] = "data-disabled";
    /**
   * Present when the menu checkbox item is highlighted.
   */ MenuCheckboxItemDataAttributes["highlighted"] = "data-highlighted";
    return MenuCheckboxItemDataAttributes;
}({});

});


parcelRegister("6e5YN", function(module, exports) {

$parcel$export(module.exports, "createChangeEventDetails", () => $e577db0bd10239d0$export$56b63593d3b376b2);
$parcel$export(module.exports, "createGenericEventDetails", () => $e577db0bd10239d0$export$2c2686d46da949ee);

var $jWAMz = parcelRequire("jWAMz");

function $e577db0bd10239d0$export$56b63593d3b376b2(reason, event, trigger, customProperties) {
    let canceled = false;
    let allowPropagation = false;
    const custom = customProperties ?? (0, $jWAMz.EMPTY_OBJECT);
    const details = {
        reason: reason,
        event: event ?? new Event('base-ui'),
        cancel () {
            canceled = true;
        },
        allowPropagation () {
            allowPropagation = true;
        },
        get isCanceled () {
            return canceled;
        },
        get isPropagationAllowed () {
            return allowPropagation;
        },
        trigger: trigger,
        ...custom
    };
    return details;
}
function $e577db0bd10239d0$export$2c2686d46da949ee(reason, event, customProperties) {
    const custom = customProperties ?? (0, $jWAMz.EMPTY_OBJECT);
    const details = {
        reason: reason,
        event: event ?? new Event('base-ui'),
        ...custom
    };
    return details;
}

});


parcelRegister("8YBSo", function(module, exports) {

$parcel$export(module.exports, "MenuCheckboxItemIndicator", () => $f44de471c577b384$export$c565208c9d1f1ba3);

var $8NFma = parcelRequire("8NFma");

var $8kC0B = parcelRequire("8kC0B");

var $aEBMJ = parcelRequire("aEBMJ");

var $bwGxG = parcelRequire("bwGxG");

var $jpauT = parcelRequire("jpauT");

var $ejgm2 = parcelRequire("ejgm2");
'use client';
const $f44de471c577b384$export$c565208c9d1f1ba3 = /*#__PURE__*/ $8NFma.forwardRef(function MenuCheckboxItemIndicator(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, keepMounted: keepMounted = false, ...elementProps } = componentProps;
    const item = (0, $8kC0B.useMenuCheckboxItemContext)();
    const indicatorRef = $8NFma.useRef(null);
    const { transitionStatus: transitionStatus, setMounted: setMounted } = (0, $jpauT.useTransitionStatus)(item.checked);
    (0, $ejgm2.useOpenChangeComplete)({
        open: item.checked,
        ref: indicatorRef,
        onComplete () {
            if (!item.checked) setMounted(false);
        }
    });
    const state = {
        checked: item.checked,
        disabled: item.disabled,
        highlighted: item.highlighted,
        transitionStatus: transitionStatus
    };
    const element = (0, $aEBMJ.useRenderElement)('span', componentProps, {
        state: state,
        ref: [
            forwardedRef,
            indicatorRef
        ],
        stateAttributesMapping: (0, $bwGxG.itemMapping),
        props: {
            'aria-hidden': true,
            ...elementProps
        },
        enabled: keepMounted || item.checked
    });
    return element;
});

});
parcelRegister("jpauT", function(module, exports) {

$parcel$export(module.exports, "useTransitionStatus", () => $b767751a29f53ac3$export$b2ef21706733f7e5);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $dhRNQ = parcelRequire("dhRNQ");
'use client';
function $b767751a29f53ac3$export$b2ef21706733f7e5(open, enableIdleState = false, deferEndingState = false) {
    const [transitionStatus, setTransitionStatus] = $8NFma.useState(open && enableIdleState ? 'idle' : undefined);
    const [mounted, setMounted] = $8NFma.useState(open);
    if (open && !mounted) {
        setMounted(true);
        setTransitionStatus('starting');
    }
    if (!open && mounted && transitionStatus !== 'ending' && !deferEndingState) setTransitionStatus('ending');
    if (!open && !mounted && transitionStatus === 'ending') setTransitionStatus(undefined);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open && mounted && transitionStatus !== 'ending' && deferEndingState) {
            const frame = (0, $dhRNQ.AnimationFrame).request(()=>{
                setTransitionStatus('ending');
            });
            return ()=>{
                (0, $dhRNQ.AnimationFrame).cancel(frame);
            };
        }
        return undefined;
    }, [
        open,
        mounted,
        transitionStatus,
        deferEndingState
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open || enableIdleState) return undefined;
        const frame = (0, $dhRNQ.AnimationFrame).request(()=>{
            // Avoid `flushSync` here due to Firefox.
            // See https://github.com/mui/base-ui/pull/3424
            setTransitionStatus(undefined);
        });
        return ()=>{
            (0, $dhRNQ.AnimationFrame).cancel(frame);
        };
    }, [
        enableIdleState,
        open
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open || !enableIdleState) return undefined;
        if (open && mounted && transitionStatus !== 'idle') setTransitionStatus('starting');
        const frame = (0, $dhRNQ.AnimationFrame).request(()=>{
            setTransitionStatus('idle');
        });
        return ()=>{
            (0, $dhRNQ.AnimationFrame).cancel(frame);
        };
    }, [
        enableIdleState,
        open,
        mounted,
        transitionStatus
    ]);
    return {
        mounted: mounted,
        setMounted: setMounted,
        transitionStatus: transitionStatus
    };
}

});
parcelRegister("dhRNQ", function(module, exports) {

$parcel$export(module.exports, "AnimationFrame", () => $be1d60d309203aa5$export$1f3d5b43727c648a);
$parcel$export(module.exports, "useAnimationFrame", () => $be1d60d309203aa5$export$641fa9c94086b46e);

var $gidzQ = parcelRequire("gidzQ");

var $cIgNk = parcelRequire("cIgNk");
'use client';
/** Unlike `setTimeout`, rAF doesn't guarantee a positive integer return value, so we can't have
 * a monomorphic `uint` type with `0` meaning empty.
 * See warning note at:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestAnimationFrame#return_value */ const $be1d60d309203aa5$var$EMPTY = null;
let $be1d60d309203aa5$var$LAST_RAF = globalThis.requestAnimationFrame;
class $be1d60d309203aa5$var$Scheduler {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */ callbacks = [];
    callbacksCount = 0;
    nextId = 1;
    startId = 1;
    isScheduled = false;
    tick = (timestamp)=>{
        this.isScheduled = false;
        const currentCallbacks = this.callbacks;
        const currentCallbacksCount = this.callbacksCount;
        // Update these before iterating, callbacks could call `requestAnimationFrame` again.
        this.callbacks = [];
        this.callbacksCount = 0;
        this.startId = this.nextId;
        if (currentCallbacksCount > 0) for(let i = 0; i < currentCallbacks.length; i += 1)currentCallbacks[i]?.(timestamp);
    };
    request(fn) {
        const id = this.nextId;
        this.nextId += 1;
        this.callbacks.push(fn);
        this.callbacksCount += 1;
        /* In a test environment with fake timers, a fake `requestAnimationFrame` can be called
     * but there's no guarantee that the animation frame will actually run before the fake
     * timers are teared, which leaves `isScheduled` set, but won't run our `tick()`. */ const didRAFChange = false;
        if (!this.isScheduled || didRAFChange) {
            requestAnimationFrame(this.tick);
            this.isScheduled = true;
        }
        return id;
    }
    cancel(id) {
        const index = id - this.startId;
        if (index < 0 || index >= this.callbacks.length) return;
        this.callbacks[index] = null;
        this.callbacksCount -= 1;
    }
}
const $be1d60d309203aa5$var$scheduler = new $be1d60d309203aa5$var$Scheduler();
class $be1d60d309203aa5$export$1f3d5b43727c648a {
    static create() {
        return new $be1d60d309203aa5$export$1f3d5b43727c648a();
    }
    static request(fn) {
        return $be1d60d309203aa5$var$scheduler.request(fn);
    }
    static cancel(id) {
        return $be1d60d309203aa5$var$scheduler.cancel(id);
    }
    currentId = $be1d60d309203aa5$var$EMPTY;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ request(fn) {
        this.cancel();
        this.currentId = $be1d60d309203aa5$var$scheduler.request(()=>{
            this.currentId = $be1d60d309203aa5$var$EMPTY;
            fn();
        });
    }
    cancel = ()=>{
        if (this.currentId !== $be1d60d309203aa5$var$EMPTY) {
            $be1d60d309203aa5$var$scheduler.cancel(this.currentId);
            this.currentId = $be1d60d309203aa5$var$EMPTY;
        }
    };
    disposeEffect = ()=>{
        return this.cancel;
    };
}
function $be1d60d309203aa5$export$641fa9c94086b46e() {
    const timeout = (0, $gidzQ.useRefWithInit)($be1d60d309203aa5$export$1f3d5b43727c648a.create).current;
    (0, $cIgNk.useOnMount)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("cIgNk", function(module, exports) {

$parcel$export(module.exports, "useOnMount", () => $025d9c31b7d9e3b6$export$820558710db2d9c6);

var $8NFma = parcelRequire("8NFma");
'use client';
const $025d9c31b7d9e3b6$var$EMPTY = [];
function $025d9c31b7d9e3b6$export$820558710db2d9c6(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $8NFma.useEffect(fn, $025d9c31b7d9e3b6$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("ejgm2", function(module, exports) {

$parcel$export(module.exports, "useOpenChangeComplete", () => $3e7579762ac7c687$export$75896e798cf46fd6);

var $8NFma = parcelRequire("8NFma");

var $fKU9M = parcelRequire("fKU9M");

var $45x58 = parcelRequire("45x58");
'use client';
function $3e7579762ac7c687$export$75896e798cf46fd6(parameters) {
    const { enabled: enabled = true, open: open, ref: ref, onComplete: onCompleteParam } = parameters;
    const onComplete = (0, $fKU9M.useStableCallback)(onCompleteParam);
    const runOnceAnimationsFinish = (0, $45x58.useAnimationsFinished)(ref, open, false);
    $8NFma.useEffect(()=>{
        if (!enabled) return undefined;
        const abortController = new AbortController();
        runOnceAnimationsFinish(onComplete, abortController.signal);
        return ()=>{
            abortController.abort();
        };
    }, [
        enabled,
        open,
        onComplete,
        runOnceAnimationsFinish
    ]);
}

});
parcelRegister("45x58", function(module, exports) {

$parcel$export(module.exports, "useAnimationsFinished", () => $8503058d0645f29d$export$733573c94fcb0ff);

var $2pmb0 = parcelRequire("2pmb0");

var $dhRNQ = parcelRequire("dhRNQ");

var $fKU9M = parcelRequire("fKU9M");

var $6Vxb7 = parcelRequire("6Vxb7");

var $eeCd6 = parcelRequire("eeCd6");
'use client';
function $8503058d0645f29d$export$733573c94fcb0ff(elementOrRef, waitForStartingStyleRemoved = false, treatAbortedAsFinished = true) {
    const frame = (0, $dhRNQ.useAnimationFrame)();
    return (0, $fKU9M.useStableCallback)((fnToExecute, /**
   * An optional [AbortSignal](https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal) that
   * can be used to abort `fnToExecute` before all the animations have finished.
   * @default null
   */ signal = null)=>{
        frame.cancel();
        const element = (0, $6Vxb7.resolveRef)(elementOrRef);
        if (element == null) return;
        const resolvedElement = element;
        const done = ()=>{
            // Synchronously flush the unmounting of the component so that the browser doesn't
            // paint: https://github.com/mui/base-ui/issues/979
            $2pmb0.flushSync(fnToExecute);
        };
        if (typeof resolvedElement.getAnimations !== 'function' || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
            fnToExecute();
            return;
        }
        function exec() {
            Promise.all(resolvedElement.getAnimations().map((animation)=>animation.finished)).then(()=>{
                if (!signal?.aborted) done();
            }).catch(()=>{
                if (treatAbortedAsFinished) {
                    if (!signal?.aborted) done();
                    return;
                }
                const currentAnimations = resolvedElement.getAnimations();
                if (!signal?.aborted && currentAnimations.length > 0 && currentAnimations.some((animation)=>animation.pending || animation.playState !== 'finished')) // Sometimes animations can be aborted because a property they depend on changes while the animation plays.
                // In such cases, we need to re-check if any new animations have started.
                exec();
            });
        }
        if (waitForStartingStyleRemoved) {
            const startingStyleAttribute = (0, $eeCd6.TransitionStatusDataAttributes).startingStyle;
            // If `[data-starting-style]` isn't present, fall back to waiting one more frame
            // to give "open" animations a chance to be registered.
            if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
                frame.request(exec);
                return;
            }
            // Wait for `[data-starting-style]` to have been removed.
            const attributeObserver = new MutationObserver(()=>{
                if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
                    attributeObserver.disconnect();
                    exec();
                }
            });
            attributeObserver.observe(resolvedElement, {
                attributes: true,
                attributeFilter: [
                    startingStyleAttribute
                ]
            });
            signal?.addEventListener('abort', ()=>attributeObserver.disconnect(), {
                once: true
            });
            return;
        }
        frame.request(exec);
    });
}

});
parcelRegister("6Vxb7", function(module, exports) {

$parcel$export(module.exports, "resolveRef", () => $c3c2de1d90231c1e$export$fb2b8a41d9966b32);
/**
 * If the provided argument is a ref object, returns its `current` value.
 * Otherwise, returns the argument itself.
 */ function $c3c2de1d90231c1e$export$fb2b8a41d9966b32(maybeRef) {
    if (maybeRef == null) return maybeRef;
    return 'current' in maybeRef ? maybeRef.current : maybeRef;
}

});




parcelRegister("8vvjs", function(module, exports) {

$parcel$export(module.exports, "MenuGroup", () => $cc3deae10bd05941$export$22a631d1f72787bb);

var $8NFma = parcelRequire("8NFma");

var $aEBMJ = parcelRequire("aEBMJ");

var $cFU1r = parcelRequire("cFU1r");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $cc3deae10bd05941$export$22a631d1f72787bb = /*#__PURE__*/ $8NFma.forwardRef(function MenuGroup(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, ...elementProps } = componentProps;
    const [labelId, setLabelId] = $8NFma.useState(undefined);
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        ref: forwardedRef,
        props: {
            role: 'group',
            'aria-labelledby': labelId,
            ...elementProps
        }
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cFU1r.MenuGroupContext).Provider, {
        value: setLabelId,
        children: element
    });
});

});
parcelRegister("cFU1r", function(module, exports) {

$parcel$export(module.exports, "MenuGroupContext", () => $e11f136576cb4737$export$44465e7b78025978);
$parcel$export(module.exports, "useMenuGroupRootContext", () => $e11f136576cb4737$export$9c6d024754b939c1);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $e11f136576cb4737$export$44465e7b78025978 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $e11f136576cb4737$export$9c6d024754b939c1() {
    const context = $8NFma.useContext($e11f136576cb4737$export$44465e7b78025978);
    if (context === undefined) throw new Error((0, $cmjqX.default)(31));
    return context;
}

});


parcelRegister("hq9nT", function(module, exports) {

$parcel$export(module.exports, "MenuGroupLabel", () => $251e8f8b4f13998f$export$f3f62515ff7a22d1);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $aEBMJ = parcelRequire("aEBMJ");

var $hF6bp = parcelRequire("hF6bp");

var $cFU1r = parcelRequire("cFU1r");
'use client';
const $251e8f8b4f13998f$export$f3f62515ff7a22d1 = /*#__PURE__*/ $8NFma.forwardRef(function MenuGroupLabel(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, id: idProp, ...elementProps } = componentProps;
    const id = (0, $hF6bp.useBaseUiId)(idProp);
    const setLabelId = (0, $cFU1r.useMenuGroupRootContext)();
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        setLabelId(id);
        return ()=>{
            setLabelId(undefined);
        };
    }, [
        setLabelId,
        id
    ]);
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        ref: forwardedRef,
        props: {
            id: id,
            role: 'presentation',
            ...elementProps
        }
    });
});

});

parcelRegister("180HL", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5859102bddcc31f5$export$2ce376c2cc3355c8);

var $8NFma = parcelRequire("8NFma");

var $kFTCr = parcelRequire("kFTCr");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $hF6bp = parcelRequire("hF6bp");

var $ipY60 = parcelRequire("ipY60");

var $8foVs = parcelRequire("8foVs");
'use client';
const $5859102bddcc31f5$export$2ce376c2cc3355c8 = /*#__PURE__*/ $8NFma.forwardRef(function MenuItem(componentProps, forwardedRef) {
    const { render: render, className: className, id: idProp, label: label, nativeButton: nativeButton = false, disabled: disabled = false, closeOnClick: closeOnClick = true, style: style, ...elementProps } = componentProps;
    const listItem = (0, $ipY60.useCompositeListItem)({
        label: label
    });
    const menuPositionerContext = (0, $8foVs.useMenuPositionerContext)(true);
    const id = (0, $hF6bp.useBaseUiId)(idProp);
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const highlighted = store.useState('isActive', listItem.index);
    const itemProps = store.useState('itemProps');
    const { getItemProps: getItemProps, itemRef: itemRef } = (0, $kFTCr.useMenuItem)({
        closeOnClick: closeOnClick,
        disabled: disabled,
        highlighted: highlighted,
        id: id,
        store: store,
        nativeButton: nativeButton,
        nodeId: menuPositionerContext?.context.nodeId,
        itemMetadata: (0, $kFTCr.REGULAR_ITEM)
    });
    const state = {
        disabled: disabled,
        highlighted: highlighted
    };
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        props: [
            itemProps,
            elementProps,
            getItemProps
        ],
        ref: [
            itemRef,
            forwardedRef,
            listItem.ref
        ]
    });
});

});

parcelRegister("c7OvE", function(module, exports) {

$parcel$export(module.exports, "MenuLinkItem", () => $faeadbe14b8433ac$export$68ef190193a37bc2);

var $8NFma = parcelRequire("8NFma");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $hF6bp = parcelRequire("hF6bp");

var $ipY60 = parcelRequire("ipY60");

var $8foVs = parcelRequire("8foVs");

var $fzgw1 = parcelRequire("fzgw1");

var $hSxhk = parcelRequire("hSxhk");

var $eFu2T = parcelRequire("eFu2T");
'use client';
const $faeadbe14b8433ac$export$68ef190193a37bc2 = /*#__PURE__*/ $8NFma.forwardRef(function MenuLinkItem(componentProps, forwardedRef) {
    const { render: render, className: className, id: idProp, label: label, closeOnClick: closeOnClick = false, style: style, ...elementProps } = componentProps;
    const linkRef = $8NFma.useRef(null);
    const listItem = (0, $ipY60.useCompositeListItem)({
        label: label
    });
    const menuPositionerContext = (0, $8foVs.useMenuPositionerContext)(true);
    const nodeId = menuPositionerContext?.context.nodeId;
    const id = (0, $hF6bp.useBaseUiId)(idProp);
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const highlighted = store.useState('isActive', listItem.index);
    const itemProps = store.useState('itemProps');
    const typingRef = store.context.typingRef;
    const { getButtonProps: getButtonProps, buttonRef: buttonRef } = (0, $hSxhk.useButton)({
        native: false,
        composite: true
    });
    const commonProps = (0, $fzgw1.useMenuItemCommonProps)({
        closeOnClick: closeOnClick,
        highlighted: highlighted,
        id: id,
        nodeId: nodeId,
        store: store,
        typingRef: typingRef,
        itemRef: linkRef
    });
    function getItemProps(externalProps) {
        return (0, $eFu2T.mergeProps)(commonProps, externalProps, getButtonProps);
    }
    const state = {
        highlighted: highlighted
    };
    return (0, $aEBMJ.useRenderElement)('a', componentProps, {
        state: state,
        props: [
            itemProps,
            elementProps,
            getItemProps
        ],
        ref: [
            linkRef,
            buttonRef,
            forwardedRef,
            listItem.ref
        ]
    });
});

});

parcelRegister("jJv3c", function(module, exports) {

$parcel$export(module.exports, "MenuPopup", () => $4f558fe547258f21$export$304c350e86a38cee);

var $8NFma = parcelRequire("8NFma");

var $bAsTX = parcelRequire("bAsTX");
var $9bngb = parcelRequire("9bngb");

var $jtR97 = parcelRequire("jtR97");

var $8foVs = parcelRequire("8foVs");

var $aEBMJ = parcelRequire("aEBMJ");

var $gVYSt = parcelRequire("gVYSt");

var $eeCd6 = parcelRequire("eeCd6");

var $ejgm2 = parcelRequire("ejgm2");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $5OGtE = parcelRequire("5OGtE");

var $kbm4S = parcelRequire("kbm4S");

var $6OSIs = parcelRequire("6OSIs");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $4f558fe547258f21$var$stateAttributesMapping = {
    ...(0, $gVYSt.popupStateMapping),
    ...(0, $eeCd6.transitionStatusMapping)
};
const $4f558fe547258f21$export$304c350e86a38cee = /*#__PURE__*/ $8NFma.forwardRef(function MenuPopup(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, finalFocus: finalFocus, ...elementProps } = componentProps;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const { side: side, align: align } = (0, $8foVs.useMenuPositionerContext)();
    const insideToolbar = (0, $5OGtE.useToolbarRootContext)(true) != null;
    const open = store.useState('open');
    const transitionStatus = store.useState('transitionStatus');
    const popupProps = store.useState('popupProps');
    const mounted = store.useState('mounted');
    const instantType = store.useState('instantType');
    const triggerElement = store.useState('activeTriggerElement');
    const parent = store.useState('parent');
    const lastOpenChangeReason = store.useState('lastOpenChangeReason');
    const rootId = store.useState('rootId');
    const floatingContext = store.useState('floatingRootContext');
    const floatingTreeRoot = store.useState('floatingTreeRoot');
    const closeDelay = store.useState('closeDelay');
    const activeTriggerElement = store.useState('activeTriggerElement');
    const hoverEnabled = store.useState('hoverEnabled');
    const disabled = store.useState('disabled');
    const openMethod = store.useState('openMethod');
    const isContextMenu = parent.type === 'context-menu';
    (0, $ejgm2.useOpenChangeComplete)({
        open: open,
        ref: store.context.popupRef,
        onComplete () {
            if (open) store.context.onOpenChangeComplete?.(true);
        }
    });
    $8NFma.useEffect(()=>{
        function handleClose(event) {
            store.setOpen(false, (0, $6e5YN.createChangeEventDetails)(event.reason, event.domEvent));
        }
        floatingTreeRoot.events.on('close', handleClose);
        return ()=>{
            floatingTreeRoot.events.off('close', handleClose);
        };
    }, [
        floatingTreeRoot.events,
        store
    ]);
    (0, $9bngb.useHoverFloatingInteraction)(floatingContext, {
        enabled: hoverEnabled && !disabled && !isContextMenu && parent.type !== 'menubar',
        closeDelay: closeDelay
    });
    const setPopupElement = $8NFma.useCallback((element)=>{
        store.set('popupElement', element);
    }, [
        store
    ]);
    const state = {
        transitionStatus: transitionStatus,
        side: side,
        align: align,
        open: open,
        nested: parent.type === 'menu',
        instant: instantType
    };
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        ref: [
            forwardedRef,
            store.context.popupRef,
            setPopupElement
        ],
        stateAttributesMapping: $4f558fe547258f21$var$stateAttributesMapping,
        props: [
            popupProps,
            {
                onKeyDown (event) {
                    if (insideToolbar && (0, $kbm4S.COMPOSITE_KEYS).has(event.key)) event.stopPropagation();
                }
            },
            (0, $6OSIs.getDisabledMountTransitionStyles)(transitionStatus),
            elementProps,
            {
                'data-rootownerid': rootId
            }
        ]
    });
    let returnFocus = parent.type === undefined || isContextMenu;
    if (triggerElement || parent.type === 'menubar' && lastOpenChangeReason !== (0, $66jhv).outsidePress) returnFocus = true;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bAsTX.FloatingFocusManager), {
        context: floatingContext,
        openInteractionType: openMethod,
        modal: isContextMenu,
        disabled: !mounted,
        returnFocus: finalFocus === undefined ? returnFocus : finalFocus,
        initialFocus: parent.type !== 'menu',
        restoreFocus: true,
        externalTree: parent.type !== 'menubar' ? floatingTreeRoot : undefined,
        previousFocusableElement: activeTriggerElement,
        nextFocusableElement: parent.type === undefined ? store.context.triggerFocusTargetRef : undefined,
        beforeContentFocusGuardRef: parent.type === undefined ? store.context.beforeContentFocusGuardRef : undefined,
        children: element
    });
});

});
parcelRegister("bAsTX", function(module, exports) {

$parcel$export(module.exports, "FloatingFocusManager", () => $c0470b4e1de9093f$export$8aeee49171ded61a);

var $8NFma = parcelRequire("8NFma");

var $1D9S2 = parcelRequire("1D9S2");

var $cbA4H = parcelRequire("cbA4H");

var $8v2Os = parcelRequire("8v2Os");

var $ghAB8 = parcelRequire("ghAB8");

var $eiwl7 = parcelRequire("eiwl7");

var $fKU9M = parcelRequire("fKU9M");

var $9N3e2 = parcelRequire("9N3e2");

var $5o6JF = parcelRequire("5o6JF");

var $8QwT3 = parcelRequire("8QwT3");

var $dhRNQ = parcelRequire("dhRNQ");

var $8shn9 = parcelRequire("8shn9");
var $1D9S2 = parcelRequire("1D9S2");

var $4yZSp = parcelRequire("4yZSp");

var $1Pbuv = parcelRequire("1Pbuv");parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $klAiy = parcelRequire("klAiy");

var $18t8v = parcelRequire("18t8v");

var $4yUKk = parcelRequire("4yUKk");

var $kS7mH = parcelRequire("kS7mH");

var $4qeT1 = parcelRequire("4qeT1");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $561ed = parcelRequire("561ed");

var $1pnbo = parcelRequire("1pnbo");

var $lemAI = parcelRequire("lemAI");

var $hrUXZ = parcelRequire("hrUXZ");

var $8Xtx1 = parcelRequire("8Xtx1");

var $cTo2e = parcelRequire("cTo2e");

var $6Vxb7 = parcelRequire("6Vxb7");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $c0470b4e1de9093f$var$getEventType(event, lastInteractionType) {
    const win = (0, $1D9S2.getWindow)((0, $1Pbuv.getTarget)(event));
    if (event instanceof win.KeyboardEvent) return 'keyboard';
    if (event instanceof win.FocusEvent) // Focus events can be caused by a preceding pointer interaction (e.g., focusout on outside press).
    // Prefer the last known pointer type if provided, else treat as keyboard.
    return lastInteractionType || 'keyboard';
    if ('pointerType' in event) return event.pointerType || 'keyboard';
    if ('touches' in event) return 'touch';
    if (event instanceof win.MouseEvent) // onClick events may not contain pointer events, and will fall through to here
    return lastInteractionType || (event.detail === 0 ? 'keyboard' : 'mouse');
    return '';
}
const $c0470b4e1de9093f$var$LIST_LIMIT = 20;
let $c0470b4e1de9093f$var$previouslyFocusedElements = [];
function $c0470b4e1de9093f$var$clearDisconnectedPreviouslyFocusedElements() {
    $c0470b4e1de9093f$var$previouslyFocusedElements = $c0470b4e1de9093f$var$previouslyFocusedElements.filter((entry)=>{
        return entry.deref()?.isConnected;
    });
}
function $c0470b4e1de9093f$var$addPreviouslyFocusedElement(element) {
    $c0470b4e1de9093f$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $1D9S2.getNodeName)(element) !== 'body') {
        $c0470b4e1de9093f$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($c0470b4e1de9093f$var$previouslyFocusedElements.length > $c0470b4e1de9093f$var$LIST_LIMIT) $c0470b4e1de9093f$var$previouslyFocusedElements = $c0470b4e1de9093f$var$previouslyFocusedElements.slice(-$c0470b4e1de9093f$var$LIST_LIMIT);
    }
}
function $c0470b4e1de9093f$var$getPreviouslyFocusedElement() {
    $c0470b4e1de9093f$var$clearDisconnectedPreviouslyFocusedElements();
    return $c0470b4e1de9093f$var$previouslyFocusedElements[$c0470b4e1de9093f$var$previouslyFocusedElements.length - 1]?.deref();
}
function $c0470b4e1de9093f$var$getFirstTabbableElement(container) {
    if (!container) return null;
    if ((0, $4yUKk.isTabbable)(container)) return container;
    return (0, $4yUKk.tabbable)(container)[0] || container;
}
function $c0470b4e1de9093f$var$handleTabIndex(floatingFocusElement) {
    if (floatingFocusElement.hasAttribute('tabindex') && !floatingFocusElement.hasAttribute('data-tabindex')) return;
    if (!floatingFocusElement.getAttribute('role')?.includes('dialog')) return;
    const focusableElements = (0, $4yUKk.focusable)(floatingFocusElement);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $4yUKk.isTabbable)(element) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (tabbableContent.length === 0) {
        if (tabIndex !== '0') {
            floatingFocusElement.setAttribute('tabindex', '0');
            // Mark our own write so the externally-managed early-return above doesn't
            // mistake it for a user-authored `tabindex` and freeze management.
            floatingFocusElement.setAttribute('data-tabindex', '0');
        }
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
function $c0470b4e1de9093f$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, initialFocus: initialFocus = true, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, closeOnFocusOut: closeOnFocusOut = true, openInteractionType: openInteractionType = '', nextFocusableElement: nextFocusableElement, previousFocusableElement: previousFocusableElement, beforeContentFocusGuardRef: beforeContentFocusGuardRef, externalTree: externalTree, getInsideElements: getInsideElements } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const open = store.useState('open');
    const domReference = store.useState('domReferenceElement');
    const floating = store.useState('floatingElement');
    const { events: events, dataRef: dataRef } = store.context;
    const getNodeId = (0, $fKU9M.useStableCallback)(()=>dataRef.current.floatingContext?.nodeId);
    const ignoreInitialFocus = initialFocus === false;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $klAiy.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    const initialFocusRef = (0, $eiwl7.useValueAsRef)(initialFocus);
    const returnFocusRef = (0, $eiwl7.useValueAsRef)(returnFocus);
    const openInteractionTypeRef = (0, $eiwl7.useValueAsRef)(openInteractionType);
    const openRef = (0, $eiwl7.useValueAsRef)(open);
    const tree = (0, $8Xtx1.useFloatingTree)(externalTree);
    const portalContext = (0, $hrUXZ.usePortalContext)();
    const preventReturnFocusRef = $8NFma.useRef(false);
    const isPointerDownRef = $8NFma.useRef(false);
    const pointerDownOutsideRef = $8NFma.useRef(false);
    const lastFocusedTabbableRef = $8NFma.useRef(null);
    const closeTypeRef = $8NFma.useRef('');
    const lastInteractionTypeRef = $8NFma.useRef('');
    const beforeGuardRef = $8NFma.useRef(null);
    const afterGuardRef = $8NFma.useRef(null);
    const mergedBeforeGuardRef = (0, $ghAB8.useMergedRefs)(beforeGuardRef, beforeContentFocusGuardRef, portalContext?.beforeInsideRef);
    const mergedAfterGuardRef = (0, $ghAB8.useMergedRefs)(afterGuardRef, portalContext?.afterInsideRef);
    const blurTimeout = (0, $5o6JF.useTimeout)();
    const pointerDownTimeout = (0, $5o6JF.useTimeout)();
    const restoreFocusFrame = (0, $dhRNQ.useAnimationFrame)();
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $klAiy.getFloatingFocusElement)(floating);
    const getTabbableContent = (0, $fKU9M.useStableCallback)((container = floatingFocusElement)=>{
        return container ? (0, $4yUKk.tabbable)(container) : [];
    });
    const getResolvedInsideElements = (0, $fKU9M.useStableCallback)(()=>getInsideElements?.().filter((element)=>element != null) ?? []);
    // Prevent Tab from escaping the modal when there are no tabbable elements.
    $8NFma.useEffect(()=>{
        if (disabled || !modal) return undefined;
        function onKeyDown(event) {
            if (event.key === 'Tab') // The focus guards have nothing to focus, so we need to stop the event.
            {
                if ((0, $1Pbuv.contains)(floatingFocusElement, (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $18t8v.stopEvent)(event);
            }
        }
        const doc = (0, $8shn9.ownerDocument)(floatingFocusElement);
        return (0, $cbA4H.addEventListener)(doc, 'keydown', onKeyDown);
    }, [
        disabled,
        floatingFocusElement,
        modal,
        isUntrappedTypeableCombobox,
        getTabbableContent
    ]);
    // Track pointer/keyboard interactions to disambiguate focus and outside presses.
    $8NFma.useEffect(()=>{
        if (disabled || !open) return undefined;
        const doc = (0, $8shn9.ownerDocument)(floatingFocusElement);
        function clearPointerDownOutside() {
            pointerDownOutsideRef.current = false;
        }
        function onPointerDown(event) {
            const target = (0, $1Pbuv.getTarget)(event);
            const insideElements = getResolvedInsideElements();
            const pointerTargetInside = (0, $1Pbuv.contains)(floating, target) || (0, $1Pbuv.contains)(domReference, target) || (0, $1Pbuv.contains)(portalContext?.portalNode, target) || insideElements.some((element)=>element === target || (0, $1Pbuv.contains)(element, target));
            pointerDownOutsideRef.current = !pointerTargetInside;
            lastInteractionTypeRef.current = event.pointerType || 'keyboard';
            if (target?.closest(`[${(0, $cTo2e.CLICK_TRIGGER_IDENTIFIER)}]`)) {
                isPointerDownRef.current = true;
                // Reset on the next tick so a single click on a click-trigger doesn't
                // permanently suppress focus-out closing for the lifetime of the instance.
                pointerDownTimeout.start(0, ()=>{
                    isPointerDownRef.current = false;
                });
            }
        }
        function onKeyDown() {
            lastInteractionTypeRef.current = 'keyboard';
        }
        return (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(doc, 'pointerdown', onPointerDown, true), (0, $cbA4H.addEventListener)(doc, 'pointerup', clearPointerDownOutside, true), (0, $cbA4H.addEventListener)(doc, 'pointercancel', clearPointerDownOutside, true), (0, $cbA4H.addEventListener)(doc, 'keydown', onKeyDown, true), // Avoid a stale `true` leaking into the next open (e.g. keep-mounted popups)
        // if the popup dismissed between pointerdown and pointerup.
        clearPointerDownOutside);
    }, [
        disabled,
        floating,
        domReference,
        floatingFocusElement,
        open,
        portalContext,
        pointerDownTimeout,
        getResolvedInsideElements
    ]);
    // Close on focus out and restore focus within the floating tree when needed.
    $8NFma.useEffect(()=>{
        if (disabled || !closeOnFocusOut) return undefined;
        const doc = (0, $8shn9.ownerDocument)(floatingFocusElement);
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            pointerDownTimeout.start(0, ()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusIn(event) {
            const target = (0, $1Pbuv.getTarget)(event);
            if ((0, $4yUKk.isTabbable)(target)) lastFocusedTabbableRef.current = target;
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $1Pbuv.getTarget)(event);
            // When focus is lost to the body (e.g. on a backdrop press), record the element that
            // had focus so a confirmation dialog opened while the body is focused can return focus
            // to it. Scoped to `modal` to avoid non-modal popups polluting the shared stack.
            if (modal && relatedTarget == null && target != null && (0, $1Pbuv.contains)(floating, target)) $c0470b4e1de9093f$var$addPreviouslyFocusedElement(target);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const triggers = store.context.triggerElements;
                const insideElements = getResolvedInsideElements();
                const isRelatedFocusGuard = relatedTarget?.hasAttribute((0, $561ed.createAttribute)('focus-guard')) && [
                    beforeGuardRef.current,
                    afterGuardRef.current,
                    portalContext?.beforeInsideRef.current,
                    portalContext?.afterInsideRef.current,
                    portalContext?.beforeOutsideRef.current,
                    portalContext?.afterOutsideRef.current,
                    (0, $6Vxb7.resolveRef)(previousFocusableElement),
                    (0, $6Vxb7.resolveRef)(nextFocusableElement)
                ].includes(relatedTarget);
                const movedToUnrelatedNode = !((0, $1Pbuv.contains)(domReference, relatedTarget) || (0, $1Pbuv.contains)(floating, relatedTarget) || (0, $1Pbuv.contains)(relatedTarget, floating) || (0, $1Pbuv.contains)(portalContext?.portalNode, relatedTarget) || insideElements.some((element)=>element === relatedTarget || (0, $1Pbuv.contains)(element, relatedTarget)) || relatedTarget != null && triggers.hasElement(relatedTarget) || triggers.hasMatchingElement((trigger)=>(0, $1Pbuv.contains)(trigger, relatedTarget)) || isRelatedFocusGuard || tree && ((0, $kS7mH.getNodeChildren)(tree.nodesRef.current, nodeId).find((node)=>(0, $1Pbuv.contains)(node.context?.elements.floating, relatedTarget) || (0, $1Pbuv.contains)(node.context?.elements.domReference, relatedTarget)) || (0, $kS7mH.getNodeAncestors)(tree.nodesRef.current, nodeId).find((node)=>[
                        node.context?.elements.floating,
                        (0, $klAiy.getFloatingFocusElement)(node.context?.elements.floating)
                    ].includes(relatedTarget) || node.context?.elements.domReference === relatedTarget)));
                if (currentTarget === domReference && floatingFocusElement) $c0470b4e1de9093f$var$handleTabIndex(floatingFocusElement);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(0, $4qeT1.isElementVisible)(target) && (0, $1Pbuv.activeElement)(doc) === doc.body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $1D9S2.isHTMLElement)(floatingFocusElement)) {
                        floatingFocusElement.focus();
                        // If explicitly requested to restore focus to the popup container, do not search
                        // for the next/previous tabbable element.
                        if (restoreFocus === 'popup') {
                            // If the element is removed on pointerdown, focus tries to move it,
                            // but since it's removed at the same time, focus gets lost as it
                            // happens after the .focus() call above.
                            // In this case, focus needs to be moved asynchronously.
                            restoreFocusFrame.request(()=>{
                                floatingFocusElement.focus();
                            });
                            return;
                        }
                    }
                    const tabbableContent = getTabbableContent();
                    const prevTabbable = lastFocusedTabbableRef.current;
                    const nodeToFocus = (prevTabbable && tabbableContent.includes(prevTabbable) ? prevTabbable : null) || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $1D9S2.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                // For an "untrapped" typeable combobox (input role=combobox with
                // initialFocus=false), re-opening the popup and tabbing out should still close it even
                // when the previously focused element (e.g. the next tabbable outside the popup) is
                // focused again. Otherwise, the popup remains open on the second Tab sequence:
                // click input -> Tab (closes) -> click input -> Tab.
                // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
                (isUntrappedTypeableCombobox || relatedTarget !== $c0470b4e1de9093f$var$getPreviouslyFocusedElement())) {
                    preventReturnFocusRef.current = true;
                    store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).focusOut, event));
                }
            });
        }
        function markInsideReactTree() {
            if (pointerDownOutsideRef.current) return;
            dataRef.current.insideReactTree = true;
            blurTimeout.start(0, ()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        const domReferenceElement = (0, $1D9S2.isHTMLElement)(domReference) ? domReference : null;
        if (!floating && !domReferenceElement) return undefined;
        return (0, $8v2Os.mergeCleanups)(domReferenceElement && (0, $cbA4H.addEventListener)(domReferenceElement, 'focusout', handleFocusOutside), domReferenceElement && (0, $cbA4H.addEventListener)(domReferenceElement, 'pointerdown', handlePointerDown), floating && (0, $cbA4H.addEventListener)(floating, 'focusin', handleFocusIn), floating && (0, $cbA4H.addEventListener)(floating, 'focusout', handleFocusOutside), floating && portalContext && (0, $cbA4H.addEventListener)(floating, 'focusout', markInsideReactTree, true));
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        store,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        dataRef,
        blurTimeout,
        pointerDownTimeout,
        restoreFocusFrame,
        nextFocusableElement,
        previousFocusableElement,
        getResolvedInsideElements
    ]);
    // Hide everything outside the floating tree from assistive tech while open.
    $8NFma.useEffect(()=>{
        if (disabled || !floating || !open) return undefined;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from(portalContext?.portalNode?.querySelectorAll(`[${(0, $561ed.createAttribute)('portal')}]`) || []);
        const ancestors = tree ? (0, $kS7mH.getNodeAncestors)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = ancestors.find((node)=>(0, $klAiy.isTypeableCombobox)(node.context?.elements.domReference || null))?.context?.elements.domReference;
        const controlInsideElements = [
            floating,
            ...portalNodes,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext?.beforeOutsideRef.current,
            portalContext?.afterOutsideRef.current,
            ...getResolvedInsideElements()
        ];
        const insideElements = [
            ...controlInsideElements,
            rootAncestorComboboxDomReference,
            (0, $6Vxb7.resolveRef)(previousFocusableElement),
            (0, $6Vxb7.resolveRef)(nextFocusableElement),
            isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const ariaHiddenCleanup = (0, $lemAI.markOthers)(insideElements, {
            ariaHidden: modal || isUntrappedTypeableCombobox,
            mark: false
        });
        const markerInsideElements = [
            floating,
            ...portalNodes
        ].filter((x)=>x != null);
        const markerCleanup = (0, $lemAI.markOthers)(markerInsideElements);
        return ()=>{
            markerCleanup();
            ariaHiddenCleanup();
        };
    }, [
        open,
        disabled,
        domReference,
        floating,
        modal,
        portalContext,
        isUntrappedTypeableCombobox,
        tree,
        getNodeId,
        nextFocusableElement,
        previousFocusableElement,
        getResolvedInsideElements
    ]);
    // Focus the initial element when the floating element opens.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open || disabled || !(0, $1D9S2.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $8shn9.ownerDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $1Pbuv.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const initialFocusValueOrFn = initialFocusRef.current;
            const resolvedInitialFocus = typeof initialFocusValueOrFn === 'function' ? initialFocusValueOrFn(openInteractionTypeRef.current || '') : initialFocusValueOrFn;
            // `null` should fallback to default behavior in case of an empty ref.
            if (resolvedInitialFocus === undefined || resolvedInitialFocus === false) return;
            const focusAlreadyInsideFloatingEl = (0, $1Pbuv.contains)(floatingFocusElement, previouslyFocusedElement);
            if (focusAlreadyInsideFloatingEl) return;
            let focusableElements = null;
            const getDefaultFocusElement = ()=>{
                if (focusableElements == null) focusableElements = getTabbableContent(floatingFocusElement);
                return focusableElements[0] || floatingFocusElement;
            };
            let elToFocus;
            if (resolvedInitialFocus === true || resolvedInitialFocus === null) elToFocus = getDefaultFocusElement();
            else elToFocus = (0, $6Vxb7.resolveRef)(resolvedInitialFocus);
            elToFocus = elToFocus || getDefaultFocusElement();
            const hadFocusInside = (0, $1Pbuv.contains)(floatingFocusElement, (0, $1Pbuv.activeElement)(doc));
            (0, $1pnbo.enqueueFocus)(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement,
                shouldFocus () {
                    // This focus is queued on the next animation frame. If the floating element has closed
                    // before it runs — e.g. tabbing out of a kept-mounted popup — don't pull focus back
                    // onto the initial element after it has legitimately moved elsewhere.
                    if (!openRef.current) return false;
                    if (hadFocusInside) return true;
                    const currentActiveElement = (0, $1Pbuv.activeElement)(doc);
                    const focusMovedInside = currentActiveElement !== elToFocus && (0, $1Pbuv.contains)(floatingFocusElement, currentActiveElement);
                    return !focusMovedInside;
                }
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        getTabbableContent,
        initialFocusRef,
        openInteractionTypeRef,
        openRef
    ]);
    // Track return focus targets and restore focus on unmount/close.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return undefined;
        const doc = (0, $8shn9.ownerDocument)(floatingFocusElement);
        const elementFocusedBeforeOpen = (0, $1Pbuv.activeElement)(doc);
        // Only nullish interaction types represent programmatic opens. The empty
        // string default is intentionally not treated as programmatic.
        const preferPreviousFocus = openInteractionTypeRef.current == null;
        $c0470b4e1de9093f$var$addPreviouslyFocusedElement(elementFocusedBeforeOpen);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChangeLocal(details) {
            if (!details.open) closeTypeRef.current = $c0470b4e1de9093f$var$getEventType(details.nativeEvent, lastInteractionTypeRef.current);
            if (details.reason === (0, $66jhv).triggerHover && details.nativeEvent.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (details.reason !== (0, $66jhv).outsidePress) return;
            if (details.nested) preventReturnFocusRef.current = false;
            else if ((0, $18t8v.isVirtualClick)(details.nativeEvent) || (0, $18t8v.isVirtualPointerEvent)(details.nativeEvent)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                (0, $8shn9.ownerDocument)(floatingFocusElement).createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChangeLocal);
        function getReturnElement() {
            const returnFocusValueOrFn = returnFocusRef.current;
            let resolvedReturnFocusValue = typeof returnFocusValueOrFn === 'function' ? returnFocusValueOrFn(closeTypeRef.current) : returnFocusValueOrFn;
            // `null` should fallback to default behavior in case of an empty ref.
            if (resolvedReturnFocusValue === undefined || resolvedReturnFocusValue === false) return null;
            if (resolvedReturnFocusValue === null) resolvedReturnFocusValue = true;
            const referenceReturnElement = domReference?.isConnected ? domReference : null;
            const previousReturnElement = elementFocusedBeforeOpen?.isConnected && (0, $1D9S2.getNodeName)(elementFocusedBeforeOpen) !== 'body' ? elementFocusedBeforeOpen : null;
            let defaultReturnElement = preferPreviousFocus ? previousReturnElement || referenceReturnElement : referenceReturnElement || previousReturnElement;
            if (!defaultReturnElement) defaultReturnElement = $c0470b4e1de9093f$var$getPreviouslyFocusedElement() || null;
            if (typeof resolvedReturnFocusValue === 'boolean') return defaultReturnElement;
            return (0, $6Vxb7.resolveRef)(resolvedReturnFocusValue) || defaultReturnElement || null;
        }
        return ()=>{
            events.off('openchange', onOpenChangeLocal);
            const activeEl = (0, $1Pbuv.activeElement)(doc);
            const insideElements = getResolvedInsideElements();
            const isFocusInsideFloatingTree = (0, $1Pbuv.contains)(floating, activeEl) || insideElements.some((element)=>element === activeEl || (0, $1Pbuv.contains)(element, activeEl)) || tree && (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, getNodeId(), false).some((node)=>(0, $1Pbuv.contains)(node.context?.elements.floating, activeEl));
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const returnFocusValueOrFn = returnFocusRef.current;
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $c0470b4e1de9093f$var$getFirstTabbableElement(returnElement);
                const hasExplicitReturnFocus = typeof returnFocusValueOrFn !== 'boolean';
                if (returnFocusValueOrFn && !preventReturnFocusRef.current && (0, $1D9S2.isHTMLElement)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (!hasExplicitReturnFocus && tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                preventReturnFocusRef.current = false;
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        openInteractionTypeRef,
        events,
        tree,
        domReference,
        getNodeId,
        getResolvedInsideElements
    ]);
    // Safari may randomly scroll to the bottom of the page if an input inside a popup has focus
    // when the popup unmounts from the DOM.
    // By blurring it before the popup unmounts, we can prevent this behavior.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!(0, $8QwT3).engine.webkit || open || !floating) return;
        const activeEl = (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(floating));
        if (!(0, $1D9S2.isHTMLElement)(activeEl) || !(0, $klAiy.isTypeableElement)(activeEl)) return;
        if ((0, $1Pbuv.contains)(floating, activeEl)) activeEl.blur();
    }, [
        open,
        floating
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (disabled || !portalContext) return undefined;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: store.setOpen,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        store,
        closeOnFocusOut,
        domReference
    ]);
    // Keep the floating element tabIndex in sync and clear stale focus records.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return undefined;
        $c0470b4e1de9093f$var$handleTabIndex(floatingFocusElement);
        return ()=>{
            queueMicrotask($c0470b4e1de9093f$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled,
        floatingFocusElement
    ]);
    const shouldRenderGuards = !disabled && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableContent();
                        (0, $1pnbo.enqueueFocus)(els[els.length - 1]);
                    } else if (portalContext?.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $4yUKk.isOutsideEvent)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $4yUKk.getNextTabbable)(domReference);
                            nextTabbable?.focus();
                        } else (0, $6Vxb7.resolveRef)(previousFocusableElement ?? portalContext.beforeOutsideRef)?.focus();
                    }
                }
            }),
            children,
            shouldRenderGuards && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) (0, $1pnbo.enqueueFocus)(getTabbableContent()[0]);
                    else if (portalContext?.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $4yUKk.isOutsideEvent)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $4yUKk.getPreviousTabbable)(domReference);
                            prevTabbable?.focus();
                        } else (0, $6Vxb7.resolveRef)(nextFocusableElement ?? portalContext.afterOutsideRef)?.focus();
                    }
                }
            })
        ]
    });
}

});
parcelRegister("cbA4H", function(module, exports) {

$parcel$export(module.exports, "addEventListener", () => $713e9653fddebb4b$export$3f65cefe8380dbea);
/**
 * Adds an event listener and returns a cleanup function to remove it.
 */ function $713e9653fddebb4b$export$3f65cefe8380dbea(target, type, listener, options) {
    target.addEventListener(type, listener, options);
    return ()=>{
        target.removeEventListener(type, listener, options);
    };
}

});

parcelRegister("8v2Os", function(module, exports) {

$parcel$export(module.exports, "mergeCleanups", () => $01cb51217b591867$export$edb15b164fe9e566);
/**
 * Combines multiple cleanup functions into a single cleanup function.
 */ function $01cb51217b591867$export$edb15b164fe9e566(...cleanups) {
    return ()=>{
        for(let i = 0; i < cleanups.length; i += 1){
            const cleanup = cleanups[i];
            if (cleanup) cleanup();
        }
    };
}

});

parcelRegister("eiwl7", function(module, exports) {

$parcel$export(module.exports, "useValueAsRef", () => $d13b57a4d71db6b6$export$fe6539659f54bdf1);

var $9N3e2 = parcelRequire("9N3e2");

var $gidzQ = parcelRequire("gidzQ");
'use client';
function $d13b57a4d71db6b6$export$fe6539659f54bdf1(value) {
    const latest = (0, $gidzQ.useRefWithInit)($d13b57a4d71db6b6$var$createLatestRef, value).current;
    latest.next = value;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $9N3e2.useIsoLayoutEffect)(latest.effect);
    return latest;
}
function $d13b57a4d71db6b6$var$createLatestRef(value) {
    const latest = {
        current: value,
        next: value,
        effect: ()=>{
            latest.current = latest.next;
        }
    };
    return latest;
}

});

parcelRegister("5o6JF", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $34145a3a5b79280a$export$786b4da70f00938b);
$parcel$export(module.exports, "useTimeout", () => $34145a3a5b79280a$export$d8e6abf214c9ec0f);

var $gidzQ = parcelRequire("gidzQ");

var $cIgNk = parcelRequire("cIgNk");
'use client';
const $34145a3a5b79280a$var$EMPTY = 0;
class $34145a3a5b79280a$export$786b4da70f00938b {
    static create() {
        return new $34145a3a5b79280a$export$786b4da70f00938b();
    }
    currentId = $34145a3a5b79280a$var$EMPTY;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = $34145a3a5b79280a$var$EMPTY;
            fn();
        }, delay); /* Node.js types are enabled in development */ 
    }
    isStarted() {
        return this.currentId !== $34145a3a5b79280a$var$EMPTY;
    }
    clear = ()=>{
        if (this.currentId !== $34145a3a5b79280a$var$EMPTY) {
            clearTimeout(this.currentId);
            this.currentId = $34145a3a5b79280a$var$EMPTY;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $34145a3a5b79280a$export$d8e6abf214c9ec0f() {
    const timeout = (0, $gidzQ.useRefWithInit)($34145a3a5b79280a$export$786b4da70f00938b.create).current;
    (0, $cIgNk.useOnMount)(timeout.disposeEffect);
    return timeout;
}

});

parcelRegister("8shn9", function(module, exports) {

$parcel$export(module.exports, "ownerDocument", () => $ea8b82f64ed5a66a$export$512a1115db01100d);

var $1D9S2 = parcelRequire("1D9S2");
function $ea8b82f64ed5a66a$export$512a1115db01100d(node) {
    return node?.ownerDocument || document;
}

});

parcelRegister("4yZSp", function(module, exports) {

$parcel$export(module.exports, "FocusGuard", () => $03f1c96d58760dfe$export$e8108ebdda72a9a5);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $8QwT3 = parcelRequire("8QwT3");

var $jFLbg = parcelRequire("jFLbg");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $03f1c96d58760dfe$export$e8108ebdda72a9a5 = /*#__PURE__*/ $8NFma.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $8NFma.useState();
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Unlike NVDA and JAWS, VoiceOver's virtual cursor triggers `onFocus` as
        // it moves — but only on focusable/role-button elements through WebKit's
        // NSAccessibility path. Setting `role="button"` lets the focus trap catch
        // the cursor.
        if ((0, $8QwT3).screenReader.voiceOver && (0, $8QwT3).engine.webkit) setRole('button');
    }, []);
    const restProps = {
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
        ...props,
        ref: ref,
        style: (0, $jFLbg.visuallyHidden),
        "aria-hidden": role ? undefined : true,
        ...restProps,
        "data-base-ui-focus-guard": ""
    });
});

});
parcelRegister("jFLbg", function(module, exports) {

$parcel$export(module.exports, "visuallyHidden", () => $05df49adebf5b8c0$export$a1b3edb637fb4f35);
$parcel$export(module.exports, "visuallyHiddenInput", () => $05df49adebf5b8c0$export$52760678fd0803cb);
const $05df49adebf5b8c0$var$visuallyHiddenBase = {
    clipPath: 'inset(50%)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    border: 0,
    padding: 0,
    width: 1,
    height: 1,
    margin: -1
};
const $05df49adebf5b8c0$export$a1b3edb637fb4f35 = {
    ...$05df49adebf5b8c0$var$visuallyHiddenBase,
    position: 'fixed',
    top: 0,
    left: 0
};
const $05df49adebf5b8c0$export$52760678fd0803cb = {
    ...$05df49adebf5b8c0$var$visuallyHiddenBase,
    position: 'absolute'
};

});


parcelRegister("1Pbuv", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $c139712995cd40dd$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $c139712995cd40dd$export$2344b14b097df817);
$parcel$export(module.exports, "getTarget", () => $c139712995cd40dd$export$c22522a4dfa48e9c);

var $1D9S2 = parcelRequire("1D9S2");
function $c139712995cd40dd$export$da980962bd2147a4(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}
function $c139712995cd40dd$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode?.();
    // First, attempt with the faster native method.
    if (parent.contains(child)) return true;
    // Then fall back to traversing out of shadow roots when needed.
    if (rootNode && (0, $1D9S2.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            next = next.parentNode || next.host;
        }
    }
    return false;
}
function $c139712995cd40dd$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS assumes `composedPath()` always exists, but older browsers without
    // shadow DOM support still fall back to `target`.
    return event.target;
}

});

parcelRegister("klAiy", function(module, exports) {

$parcel$export(module.exports, "isTargetInsideEnabledTrigger", () => $2f05da160e7324b8$export$990b15d2e0d4fcc0);
$parcel$export(module.exports, "isEventTargetWithin", () => $2f05da160e7324b8$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "isRootElement", () => $2f05da160e7324b8$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "isTypeableElement", () => $2f05da160e7324b8$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "isInteractiveElement", () => $2f05da160e7324b8$export$3dee5e4542c672d9);
$parcel$export(module.exports, "isTypeableCombobox", () => $2f05da160e7324b8$export$259ba5ae38188551);
$parcel$export(module.exports, "matchesFocusVisible", () => $2f05da160e7324b8$export$65750043c2fb2f40);
$parcel$export(module.exports, "getFloatingFocusElement", () => $2f05da160e7324b8$export$9b0901b5e9b45fc7);
$parcel$export(module.exports, "contains", () => (parcelRequire("1Pbuv")).contains);

var $1D9S2 = parcelRequire("1D9S2");

var $8QwT3 = parcelRequire("8QwT3");

var $aJh1u = parcelRequire("aJh1u");

var $1Pbuv = parcelRequire("1Pbuv");
function $2f05da160e7324b8$export$990b15d2e0d4fcc0(target, triggerElements) {
    if (!(0, $1D9S2.isElement)(target)) return false;
    const targetElement = target;
    if (triggerElements.hasElement(targetElement)) return !targetElement.hasAttribute('data-trigger-disabled');
    for (const [, trigger] of triggerElements.entries()){
        if ((0, $1Pbuv.contains)(trigger, targetElement)) return !trigger.hasAttribute('data-trigger-disabled');
    }
    return false;
}
function $2f05da160e7324b8$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const eventAgain = event;
    return eventAgain.target != null && node.contains(eventAgain.target);
}
function $2f05da160e7324b8$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $2f05da160e7324b8$export$42ad131c32f0fb8d(element) {
    return (0, $1D9S2.isHTMLElement)(element) && element.matches((0, $aJh1u.TYPEABLE_SELECTOR));
}
function $2f05da160e7324b8$export$3dee5e4542c672d9(element) {
    return element?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${(0, $aJh1u.TYPEABLE_SELECTOR)}`) != null;
}
function $2f05da160e7324b8$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $2f05da160e7324b8$export$42ad131c32f0fb8d(element);
}
function $2f05da160e7324b8$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || (0, $8QwT3).env.jsdom) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $2f05da160e7324b8$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute((0, $aJh1u.FOCUSABLE_ATTRIBUTE)) ? floatingElement : floatingElement.querySelector(`[${(0, $aJh1u.FOCUSABLE_ATTRIBUTE)}]`) || floatingElement;
}

});
parcelRegister("aJh1u", function(module, exports) {

$parcel$export(module.exports, "FOCUSABLE_ATTRIBUTE", () => $40fde97e9f993856$export$1022acd1ec27c201);
$parcel$export(module.exports, "TYPEABLE_SELECTOR", () => $40fde97e9f993856$export$78b3d091ff376bc);
$parcel$export(module.exports, "ARROW_LEFT", () => $40fde97e9f993856$export$8d4f84cc5dc5fc15);
$parcel$export(module.exports, "ARROW_RIGHT", () => $40fde97e9f993856$export$e9510a4613bb01df);
$parcel$export(module.exports, "ARROW_UP", () => $40fde97e9f993856$export$8188339dbe6c99c4);
$parcel$export(module.exports, "ARROW_DOWN", () => $40fde97e9f993856$export$59f214baefff6196);
const $40fde97e9f993856$export$1022acd1ec27c201 = 'data-base-ui-focusable';
const $40fde97e9f993856$export$9225aed8d5a879cb = 'active';
const $40fde97e9f993856$export$4d027fb911bf33f3 = 'selected';
const $40fde97e9f993856$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $40fde97e9f993856$export$8d4f84cc5dc5fc15 = 'ArrowLeft';
const $40fde97e9f993856$export$e9510a4613bb01df = 'ArrowRight';
const $40fde97e9f993856$export$8188339dbe6c99c4 = 'ArrowUp';
const $40fde97e9f993856$export$59f214baefff6196 = 'ArrowDown';

});


parcelRegister("18t8v", function(module, exports) {

$parcel$export(module.exports, "stopEvent", () => $242a97640697c6a4$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isReactEvent", () => $242a97640697c6a4$export$94781ce41a161222);
$parcel$export(module.exports, "isVirtualClick", () => $242a97640697c6a4$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $242a97640697c6a4$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isMouseLikePointerType", () => $242a97640697c6a4$export$81cf264172d31e51);
$parcel$export(module.exports, "isClickLikeEvent", () => $242a97640697c6a4$export$c8bf7f62d0010d9);

var $8QwT3 = parcelRequire("8QwT3");
function $242a97640697c6a4$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $242a97640697c6a4$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $242a97640697c6a4$export$60278871457622de(event) {
    if (event.pointerType === '' && event.isTrusted) return true;
    if ((0, $8QwT3).os.android && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $242a97640697c6a4$export$29bf1b5f2c56cf63(event) {
    if ((0, $8QwT3).env.jsdom) return false;
    return !(0, $8QwT3).os.android && event.width === 0 && event.height === 0 || (0, $8QwT3).os.android && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $242a97640697c6a4$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $242a97640697c6a4$export$c8bf7f62d0010d9(event) {
    const type = event.type;
    return type === 'click' || type === 'mousedown' || type === 'keydown' || type === 'keyup';
}

});

parcelRegister("4yUKk", function(module, exports) {

$parcel$export(module.exports, "isTabbable", () => $d02fdffef5b22c5f$export$bebd5a1431fec25d);
$parcel$export(module.exports, "focusable", () => $d02fdffef5b22c5f$export$ecc6d1fcdff4f700);
$parcel$export(module.exports, "tabbable", () => $d02fdffef5b22c5f$export$17100aea90429aa7);
$parcel$export(module.exports, "getNextTabbable", () => $d02fdffef5b22c5f$export$28f33206776129a7);
$parcel$export(module.exports, "getPreviousTabbable", () => $d02fdffef5b22c5f$export$2e5518c3303f364a);
$parcel$export(module.exports, "getTabbableAfterElement", () => $d02fdffef5b22c5f$export$2b6f2a24e5585421);
$parcel$export(module.exports, "getTabbableBeforeElement", () => $d02fdffef5b22c5f$export$c0e56f1798e7dab9);
$parcel$export(module.exports, "isOutsideEvent", () => $d02fdffef5b22c5f$export$6e0c4e272f3faa2);
$parcel$export(module.exports, "disableFocusInside", () => $d02fdffef5b22c5f$export$3995dd353b80da11);
$parcel$export(module.exports, "enableFocusInside", () => $d02fdffef5b22c5f$export$a65f4028abb17f36);

var $1D9S2 = parcelRequire("1D9S2");

var $8shn9 = parcelRequire("8shn9");

var $1Pbuv = parcelRequire("1Pbuv");parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");

var $4qeT1 = parcelRequire("4qeT1");
const $d02fdffef5b22c5f$var$CANDIDATE_SELECTOR = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function $d02fdffef5b22c5f$var$getParentElement(element) {
    const assignedSlot = element.assignedSlot;
    if (assignedSlot) return assignedSlot;
    if (element.parentElement) return element.parentElement;
    const rootNode = element.getRootNode();
    return (0, $1D9S2.isShadowRoot)(rootNode) ? rootNode.host : null;
}
function $d02fdffef5b22c5f$var$getDetailsSummary(details) {
    for (const child of Array.from(details.children)){
        if ((0, $1D9S2.getNodeName)(child) === 'summary') return child;
    }
    return null;
}
function $d02fdffef5b22c5f$var$isWithinOpenDetailsSummary(element, details) {
    const summary = $d02fdffef5b22c5f$var$getDetailsSummary(details);
    return !!summary && (element === summary || (0, $1Pbuv.contains)(summary, element));
}
function $d02fdffef5b22c5f$var$isFocusableCandidate(element) {
    const nodeName = element ? (0, $1D9S2.getNodeName)(element) : '';
    return element != null && element.matches($d02fdffef5b22c5f$var$CANDIDATE_SELECTOR) && (nodeName !== 'summary' || element.parentElement != null && (0, $1D9S2.getNodeName)(element.parentElement) === 'details' && $d02fdffef5b22c5f$var$getDetailsSummary(element.parentElement) === element) && (nodeName !== 'details' || $d02fdffef5b22c5f$var$getDetailsSummary(element) == null) && (nodeName !== 'input' || element.type !== 'hidden');
}
function $d02fdffef5b22c5f$var$isFocusableElement(element) {
    if (!$d02fdffef5b22c5f$var$isFocusableCandidate(element) || !element.isConnected || element.matches(':disabled')) return false;
    for(let current = element; current; current = $d02fdffef5b22c5f$var$getParentElement(current)){
        const isAncestor = current !== element;
        const isSlot = (0, $1D9S2.getNodeName)(current) === 'slot';
        if (current.hasAttribute('inert')) return false;
        if (isAncestor && (0, $1D9S2.getNodeName)(current) === 'details' && !current.open && !$d02fdffef5b22c5f$var$isWithinOpenDetailsSummary(element, current) || current.hasAttribute('hidden') || !isSlot && !$d02fdffef5b22c5f$var$isVisibleInTabbableTree(current, isAncestor)) return false;
    }
    return true;
}
function $d02fdffef5b22c5f$var$isVisibleInTabbableTree(element, isAncestor) {
    const styles = (0, $1D9S2.getComputedStyle)(element);
    if (!isAncestor) return (0, $4qeT1.isElementVisible)(element, styles);
    return styles.display !== 'none';
}
function $d02fdffef5b22c5f$var$getTabIndex(element) {
    const tabIndex = element.tabIndex;
    if (tabIndex < 0) {
        const nodeName = (0, $1D9S2.getNodeName)(element);
        if (nodeName === 'details' || nodeName === 'audio' || nodeName === 'video' || (0, $1D9S2.isHTMLElement)(element) && element.isContentEditable) return 0;
    }
    return tabIndex;
}
function $d02fdffef5b22c5f$var$getNamedRadioInput(element) {
    if ((0, $1D9S2.getNodeName)(element) !== 'input') return null;
    const input = element;
    return input.type === 'radio' && input.name !== '' ? input : null;
}
function $d02fdffef5b22c5f$var$isTabbableRadio(element, candidates) {
    const input = $d02fdffef5b22c5f$var$getNamedRadioInput(element);
    if (!input) return true;
    const checkedRadio = candidates.find((candidate)=>{
        const radio = $d02fdffef5b22c5f$var$getNamedRadioInput(candidate);
        return radio?.name === input.name && radio.form === input.form && radio.checked;
    });
    if (checkedRadio) return checkedRadio === input;
    return candidates.find((candidate)=>{
        const radio = $d02fdffef5b22c5f$var$getNamedRadioInput(candidate);
        return radio?.name === input.name && radio.form === input.form;
    }) === input;
}
function $d02fdffef5b22c5f$var$getComposedChildren(container) {
    if ((0, $1D9S2.isHTMLElement)(container) && (0, $1D9S2.getNodeName)(container) === 'slot') {
        const assignedElements = container.assignedElements({
            flatten: true
        });
        if (assignedElements.length > 0) return assignedElements;
    }
    if ((0, $1D9S2.isHTMLElement)(container) && container.shadowRoot) return Array.from(container.shadowRoot.children);
    return Array.from(container.children);
}
function $d02fdffef5b22c5f$var$appendCandidates(container, list) {
    $d02fdffef5b22c5f$var$getComposedChildren(container).forEach((child)=>{
        if ($d02fdffef5b22c5f$var$isFocusableCandidate(child)) list.push(child);
        $d02fdffef5b22c5f$var$appendCandidates(child, list);
    });
}
function $d02fdffef5b22c5f$var$appendMatchingElements(container, selector, list) {
    $d02fdffef5b22c5f$var$getComposedChildren(container).forEach((child)=>{
        if ((0, $1D9S2.isHTMLElement)(child) && child.matches(selector)) list.push(child);
        $d02fdffef5b22c5f$var$appendMatchingElements(child, selector, list);
    });
}
function $d02fdffef5b22c5f$export$bebd5a1431fec25d(element) {
    return $d02fdffef5b22c5f$var$isFocusableElement(element) && $d02fdffef5b22c5f$var$getTabIndex(element) >= 0;
}
function $d02fdffef5b22c5f$export$ecc6d1fcdff4f700(container) {
    const candidates = [];
    $d02fdffef5b22c5f$var$appendCandidates(container, candidates);
    return candidates.filter($d02fdffef5b22c5f$var$isFocusableElement);
}
function $d02fdffef5b22c5f$export$17100aea90429aa7(container) {
    const candidates = $d02fdffef5b22c5f$export$ecc6d1fcdff4f700(container);
    return candidates.filter((element)=>$d02fdffef5b22c5f$var$getTabIndex(element) >= 0 && $d02fdffef5b22c5f$var$isTabbableRadio(element, candidates));
}
function $d02fdffef5b22c5f$var$getTabbableIn(container, dir) {
    const list = $d02fdffef5b22c5f$export$17100aea90429aa7(container);
    const len = list.length;
    if (len === 0) return undefined;
    const active = (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(container));
    const index = list.indexOf(active);
    // eslint-disable-next-line no-nested-ternary
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $d02fdffef5b22c5f$export$28f33206776129a7(referenceElement) {
    return $d02fdffef5b22c5f$var$getTabbableIn((0, $8shn9.ownerDocument)(referenceElement).body, 1) || referenceElement;
}
function $d02fdffef5b22c5f$export$2e5518c3303f364a(referenceElement) {
    return $d02fdffef5b22c5f$var$getTabbableIn((0, $8shn9.ownerDocument)(referenceElement).body, -1) || referenceElement;
}
function $d02fdffef5b22c5f$var$getTabbableNearElement(referenceElement, dir) {
    if (!referenceElement) return null;
    const list = $d02fdffef5b22c5f$export$17100aea90429aa7((0, $8shn9.ownerDocument)(referenceElement).body);
    const elementCount = list.length;
    if (elementCount === 0) return null;
    const index = list.indexOf(referenceElement);
    if (index === -1) return null;
    const nextIndex = (index + dir + elementCount) % elementCount;
    return list[nextIndex];
}
function $d02fdffef5b22c5f$export$2b6f2a24e5585421(referenceElement) {
    return $d02fdffef5b22c5f$var$getTabbableNearElement(referenceElement, 1);
}
function $d02fdffef5b22c5f$export$c0e56f1798e7dab9(referenceElement) {
    return $d02fdffef5b22c5f$var$getTabbableNearElement(referenceElement, -1);
}
function $d02fdffef5b22c5f$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $1Pbuv.contains)(containerElement, relatedTarget);
}
function $d02fdffef5b22c5f$export$3995dd353b80da11(container) {
    const tabbableElements = $d02fdffef5b22c5f$export$17100aea90429aa7(container);
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $d02fdffef5b22c5f$export$a65f4028abb17f36(container) {
    const elements = [];
    $d02fdffef5b22c5f$var$appendMatchingElements(container, '[data-tabindex]', elements);
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}

});
parcelRegister("4qeT1", function(module, exports) {

$parcel$export(module.exports, "isIndexOutOfListBounds", () => $83be4b84b4437d7a$export$75effb89758ec596);
$parcel$export(module.exports, "getMinListIndex", () => $83be4b84b4437d7a$export$53f691ee0acc6058);
$parcel$export(module.exports, "findNonDisabledListIndex", () => $83be4b84b4437d7a$export$3fc3ea4a67cf714);
$parcel$export(module.exports, "getMaxListIndex", () => $83be4b84b4437d7a$export$b585558af466e926);
$parcel$export(module.exports, "isListIndexDisabled", () => $83be4b84b4437d7a$export$446656ed0410fd9);
$parcel$export(module.exports, "isElementVisible", () => $83be4b84b4437d7a$export$e989c0fffaa6b27a);

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");

var $18t8v = parcelRequire("18t8v");

var $aJh1u = parcelRequire("aJh1u");
function $83be4b84b4437d7a$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $83be4b84b4437d7a$export$75effb89758ec596(list, index) {
    return index < 0 || index >= list.length;
}
function $83be4b84b4437d7a$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $83be4b84b4437d7a$export$3fc3ea4a67cf714(listRef.current, {
        disabledIndices: disabledIndices
    });
}
function $83be4b84b4437d7a$export$b585558af466e926(listRef, disabledIndices) {
    return $83be4b84b4437d7a$export$3fc3ea4a67cf714(listRef.current, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = {}) {
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $83be4b84b4437d7a$export$446656ed0410fd9(list, index, disabledIndices));
    return index;
}
function $83be4b84b4437d7a$export$342fcce33a2688bc(list, { event: event, orientation: orientation, loopFocus: loopFocus, onLoop: onLoop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false }) {
    let nextIndex = prevIndex;
    let verticalDirection;
    if (event.key === (0, $aJh1u.ARROW_UP)) verticalDirection = 'up';
    else if (event.key === (0, $aJh1u.ARROW_DOWN)) verticalDirection = 'down';
    if (verticalDirection) {
        // -------------------------------------------------------------------------
        // Detect row structure only when handling vertical navigation. This keeps
        // the non-vertical key paths free from row inference work.
        // -------------------------------------------------------------------------
        const rows = [];
        const rowIndexMap = [];
        let hasRoleRow = false;
        let visibleItemCount = 0;
        {
            let currentRowEl = null;
            let currentRowIndex = -1;
            list.forEach((el, idx)=>{
                if (el == null) return;
                visibleItemCount += 1;
                const rowEl = el.closest('[role="row"]');
                if (rowEl) hasRoleRow = true;
                if (rowEl !== currentRowEl || currentRowIndex === -1) {
                    currentRowEl = rowEl;
                    currentRowIndex += 1;
                    rows[currentRowIndex] = [];
                }
                rows[currentRowIndex].push(idx);
                rowIndexMap[idx] = currentRowIndex;
            });
        }
        let hasDomRows = false;
        let inferredDomCols = 0;
        if (hasRoleRow) for (const row of rows){
            const rowLength = row.length;
            if (rowLength > inferredDomCols) inferredDomCols = rowLength;
            if (rowLength !== cols) hasDomRows = true;
        }
        const hasVirtualizedGaps = hasDomRows && visibleItemCount < list.length;
        const verticalCols = inferredDomCols || cols;
        const navigateVertically = (direction)=>{
            if (!hasDomRows || prevIndex === -1) return undefined;
            const currentRow = rowIndexMap[prevIndex];
            if (currentRow == null) return undefined;
            const colInRow = rows[currentRow].indexOf(prevIndex);
            const step = direction === 'up' ? -1 : 1;
            for(let nextRow = currentRow + step, i = 0; i < rows.length; i += 1, nextRow += step){
                if (nextRow < 0 || nextRow >= rows.length) {
                    if (!loopFocus || hasVirtualizedGaps) return undefined;
                    nextRow = nextRow < 0 ? rows.length - 1 : 0;
                    if (onLoop) {
                        const clampedCol = Math.min(colInRow, rows[nextRow].length - 1);
                        const targetItemIndex = rows[nextRow][clampedCol] ?? rows[nextRow][0];
                        const returnedItemIndex = onLoop(event, prevIndex, targetItemIndex);
                        nextRow = rowIndexMap[returnedItemIndex] ?? nextRow;
                    }
                }
                const targetRow = rows[nextRow];
                for(let col = Math.min(colInRow, targetRow.length - 1); col >= 0; col -= 1){
                    const candidate = targetRow[col];
                    if (!$83be4b84b4437d7a$export$446656ed0410fd9(list, candidate, disabledIndices)) return candidate;
                }
            }
            return undefined;
        };
        const navigateVerticallyWithInferredRows = (direction)=>{
            if (!hasVirtualizedGaps || prevIndex === -1) return undefined;
            const colInRow = prevIndex % verticalCols;
            const rowStep = direction === 'up' ? -verticalCols : verticalCols;
            const lastRowStart = maxIndex - maxIndex % verticalCols;
            const rowCount = (0, $Euxde.floor)(maxIndex / verticalCols) + 1;
            for(let rowStart = prevIndex - colInRow + rowStep, i = 0; i < rowCount; i += 1, rowStart += rowStep){
                if (rowStart < 0 || rowStart > maxIndex) {
                    if (!loopFocus) return undefined;
                    rowStart = rowStart < 0 ? lastRowStart : 0;
                }
                const rowEnd = Math.min(rowStart + verticalCols - 1, maxIndex);
                for(let candidate = Math.min(rowStart + colInRow, rowEnd); candidate >= rowStart; candidate -= 1){
                    if (!$83be4b84b4437d7a$export$446656ed0410fd9(list, candidate, disabledIndices)) return candidate;
                }
            }
            return undefined;
        };
        if (stop) (0, $18t8v.stopEvent)(event);
        const verticalCandidate = navigateVertically(verticalDirection) ?? navigateVerticallyWithInferredRows(verticalDirection);
        if (verticalCandidate !== undefined) nextIndex = verticalCandidate;
        else if (prevIndex === -1) nextIndex = verticalDirection === 'up' ? maxIndex : minIndex;
        else {
            nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                startingIndex: prevIndex,
                amount: verticalCols,
                decrement: verticalDirection === 'up',
                disabledIndices: disabledIndices
            });
            if (loopFocus) {
                if (verticalDirection === 'up' && (prevIndex - verticalCols < minIndex || nextIndex < 0)) {
                    const col = prevIndex % verticalCols;
                    const maxCol = maxIndex % verticalCols;
                    const offset = maxIndex - (maxCol - col);
                    if (maxCol === col) nextIndex = maxIndex;
                    else nextIndex = maxCol > col ? offset : offset - verticalCols;
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
                if (verticalDirection === 'down' && prevIndex + verticalCols > maxIndex) {
                    nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                        startingIndex: prevIndex % verticalCols - verticalCols,
                        amount: verticalCols,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            }
        }
        if ($83be4b84b4437d7a$export$75effb89758ec596(list, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $Euxde.floor)(prevIndex / cols);
        if (event.key === (rtl ? (0, $aJh1u.ARROW_LEFT) : (0, $aJh1u.ARROW_RIGHT))) {
            if (stop) (0, $18t8v.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loopFocus && $83be4b84b4437d7a$export$709046525cac3019(nextIndex, cols, prevRow)) {
                    nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                        startingIndex: prevIndex - prevIndex % cols - 1,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            } else if (loopFocus) {
                nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
                if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
            }
            if ($83be4b84b4437d7a$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? (0, $aJh1u.ARROW_RIGHT) : (0, $aJh1u.ARROW_LEFT))) {
            if (stop) (0, $18t8v.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loopFocus && $83be4b84b4437d7a$export$709046525cac3019(nextIndex, cols, prevRow)) {
                    nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                        startingIndex: prevIndex + (cols - prevIndex % cols),
                        decrement: true,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            } else if (loopFocus) {
                nextIndex = $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
            }
            if ($83be4b84b4437d7a$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $Euxde.floor)(maxIndex / cols) === prevRow;
        if ($83be4b84b4437d7a$export$75effb89758ec596(list, nextIndex)) {
            if (loopFocus && lastRow) {
                nextIndex = event.key === (rtl ? (0, $aJh1u.ARROW_RIGHT) : (0, $aJh1u.ARROW_LEFT)) ? maxIndex : $83be4b84b4437d7a$export$3fc3ea4a67cf714(list, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
                if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
            } else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
function $83be4b84b4437d7a$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach(({ width: width, height: height }, index)=>{
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i += 1)for(let j = 0; j < height; j += 1)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex += 1;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
function $83be4b84b4437d7a$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
        default:
            return -1;
    }
}
function $83be4b84b4437d7a$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $83be4b84b4437d7a$export$446656ed0410fd9(list, index, disabledIndices) {
    const isExplicitlyDisabled = typeof disabledIndices === 'function' ? disabledIndices(index) : disabledIndices?.includes(index) ?? false;
    if (isExplicitlyDisabled) return true;
    const element = list[index];
    if (!element) return false;
    if (!$83be4b84b4437d7a$export$e989c0fffaa6b27a(element)) return true;
    return !disabledIndices && (element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true');
}
function $83be4b84b4437d7a$export$761d91c02cf99ecc(styles) {
    return styles.visibility === 'hidden' || styles.visibility === 'collapse';
}
function $83be4b84b4437d7a$export$e989c0fffaa6b27a(element, styles = element ? (0, $1D9S2.getComputedStyle)(element) : null) {
    if (!element || !element.isConnected || !styles || $83be4b84b4437d7a$export$761d91c02cf99ecc(styles)) return false;
    if (typeof element.checkVisibility === 'function') return element.checkVisibility();
    return styles.display !== 'none' && styles.display !== 'contents';
}

});
parcelRegister("Euxde", function(module, exports) {

$parcel$export(module.exports, "sides", () => $079b6c18061715d9$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $079b6c18061715d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $079b6c18061715d9$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $079b6c18061715d9$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $079b6c18061715d9$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $079b6c18061715d9$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $079b6c18061715d9$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $079b6c18061715d9$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $079b6c18061715d9$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $079b6c18061715d9$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $079b6c18061715d9$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $079b6c18061715d9$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $079b6c18061715d9$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $079b6c18061715d9$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $079b6c18061715d9$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $079b6c18061715d9$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $079b6c18061715d9$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $079b6c18061715d9$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $079b6c18061715d9$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $079b6c18061715d9$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $079b6c18061715d9$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $079b6c18061715d9$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $079b6c18061715d9$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $079b6c18061715d9$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $079b6c18061715d9$export$803cd8101b6c182b = /*#__PURE__*/ $079b6c18061715d9$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[0], side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[1]), []);
const $079b6c18061715d9$export$96ec731ed4dcb222 = Math.min;
const $079b6c18061715d9$export$8960430cfd85939f = Math.max;
const $079b6c18061715d9$export$2077e0241d6afd3c = Math.round;
const $079b6c18061715d9$export$a3fe094919f356fd = Math.floor;
const $079b6c18061715d9$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $079b6c18061715d9$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $079b6c18061715d9$export$7d15b64cf5a3a4c4(start, value, end) {
    return $079b6c18061715d9$export$8960430cfd85939f(start, $079b6c18061715d9$export$96ec731ed4dcb222(value, end));
}
function $079b6c18061715d9$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $079b6c18061715d9$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $079b6c18061715d9$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $079b6c18061715d9$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $079b6c18061715d9$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $079b6c18061715d9$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $079b6c18061715d9$export$2b57e0052a6d6d4c(placement) {
    return $079b6c18061715d9$export$8a000a963141ac32($079b6c18061715d9$export$f28e8f882010718a(placement));
}
function $079b6c18061715d9$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    const alignmentAxis = $079b6c18061715d9$export$2b57e0052a6d6d4c(placement);
    const length = $079b6c18061715d9$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $079b6c18061715d9$export$496432a3699e50b1(placement) {
    const oppositePlacement = $079b6c18061715d9$export$9c5e28bad23365fa(placement);
    return [
        $079b6c18061715d9$export$2b182c584985588b(placement),
        oppositePlacement,
        $079b6c18061715d9$export$2b182c584985588b(oppositePlacement)
    ];
}
function $079b6c18061715d9$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $079b6c18061715d9$var$lrPlacement = [
    'left',
    'right'
];
const $079b6c18061715d9$var$rlPlacement = [
    'right',
    'left'
];
const $079b6c18061715d9$var$tbPlacement = [
    'top',
    'bottom'
];
const $079b6c18061715d9$var$btPlacement = [
    'bottom',
    'top'
];
function $079b6c18061715d9$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $079b6c18061715d9$var$rlPlacement : $079b6c18061715d9$var$lrPlacement;
            return isStart ? $079b6c18061715d9$var$lrPlacement : $079b6c18061715d9$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $079b6c18061715d9$var$tbPlacement : $079b6c18061715d9$var$btPlacement;
        default:
            return [];
    }
}
function $079b6c18061715d9$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    let list = $079b6c18061715d9$var$getSideList($079b6c18061715d9$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($079b6c18061715d9$export$2b182c584985588b));
    }
    return list;
}
function $079b6c18061715d9$export$9c5e28bad23365fa(placement) {
    const side = $079b6c18061715d9$export$3c915306cb7fc97a(placement);
    return $079b6c18061715d9$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $079b6c18061715d9$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $079b6c18061715d9$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $079b6c18061715d9$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $079b6c18061715d9$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});



parcelRegister("kS7mH", function(module, exports) {

$parcel$export(module.exports, "getNodeChildren", () => $77155c5db680702b$export$1f1998cc3c6b56fb);
$parcel$export(module.exports, "getNodeAncestors", () => $77155c5db680702b$export$5d8eb345316b65c0);
/* eslint-disable @typescript-eslint/no-loop-func */ function $77155c5db680702b$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren = true) {
    const directChildren = nodes.filter((node)=>node.parentId === id);
    return directChildren.flatMap((child)=>[
            ...!onlyOpenChildren || child.context?.open ? [
                child
            ] : [],
            ...$77155c5db680702b$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $77155c5db680702b$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $77155c5db680702b$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $77155c5db680702b$export$5d8eb345316b65c0(nodes, id) {
    let allAncestors = [];
    let currentParentId = nodes.find((node)=>node.id === id)?.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode?.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}

});

parcelRegister("561ed", function(module, exports) {

$parcel$export(module.exports, "createAttribute", () => $79c89ec47c6c341f$export$b070af26bb536375);
function $79c89ec47c6c341f$export$b070af26bb536375(name) {
    return `data-base-ui-${name}`;
}

});

parcelRegister("1pnbo", function(module, exports) {

$parcel$export(module.exports, "enqueueFocus", () => $e217cd5ec441c55d$export$a309567c568d3930);

var $jWAMz = parcelRequire("jWAMz");
let $e217cd5ec441c55d$var$rafId = 0;
function $e217cd5ec441c55d$export$a309567c568d3930(el, options = {}) {
    const { preventScroll: preventScroll = false, sync: sync = false, shouldFocus: shouldFocus } = options;
    cancelAnimationFrame($e217cd5ec441c55d$var$rafId);
    function exec() {
        if (shouldFocus && !shouldFocus()) return;
        el?.focus({
            preventScroll: preventScroll
        });
    }
    if (sync) {
        exec();
        return 0, $jWAMz.NOOP;
    }
    const currentRafId = requestAnimationFrame(exec);
    $e217cd5ec441c55d$var$rafId = currentRafId;
    return ()=>{
        if ($e217cd5ec441c55d$var$rafId === currentRafId) {
            cancelAnimationFrame(currentRafId);
            $e217cd5ec441c55d$var$rafId = 0;
        }
    };
}

});

parcelRegister("lemAI", function(module, exports) {

$parcel$export(module.exports, "markOthers", () => $0035a67261526498$export$cea0be4da43dc380);
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts

var $1D9S2 = parcelRequire("1D9S2");

var $8shn9 = parcelRequire("8shn9");
const $0035a67261526498$var$counters = {
    inert: new WeakMap(),
    'aria-hidden': new WeakMap()
};
const $0035a67261526498$var$markerName = 'data-base-ui-inert';
const $0035a67261526498$var$uncontrolledElementsSets = {
    inert: new WeakSet(),
    'aria-hidden': new WeakSet()
};
let $0035a67261526498$var$markerCounterMap = new WeakMap();
let $0035a67261526498$var$lockCount = 0;
function $0035a67261526498$var$getUncontrolledElementsSet(controlAttribute) {
    return $0035a67261526498$var$uncontrolledElementsSets[controlAttribute];
}
function $0035a67261526498$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $1D9S2.isShadowRoot)(node) ? node.host : $0035a67261526498$var$unwrapHost(node.parentNode);
}
const $0035a67261526498$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $0035a67261526498$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
const $0035a67261526498$var$buildKeepSet = (targets)=>{
    const keep = new Set();
    targets.forEach((target)=>{
        let node = target;
        while(node && !keep.has(node)){
            keep.add(node);
            node = node.parentNode;
        }
    });
    return keep;
};
const $0035a67261526498$var$collectOutsideElements = (root, keepElements, stopElements)=>{
    const outside = [];
    const walk = (parent)=>{
        if (!parent || stopElements.has(parent)) return;
        Array.from(parent.children).forEach((node)=>{
            if ((0, $1D9S2.getNodeName)(node) === 'script') return;
            if (keepElements.has(node)) walk(node);
            else outside.push(node);
        });
    };
    walk(root);
    return outside;
};
function $0035a67261526498$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert, { mark: mark = true }) {
    let controlAttribute = null;
    if (inert) controlAttribute = 'inert';
    else if (ariaHidden) controlAttribute = 'aria-hidden';
    let counterMap = null;
    let uncontrolledElementsSet = null;
    const avoidElements = $0035a67261526498$var$correctElements(body, uncorrectedAvoidElements);
    const markerTargets = mark ? $0035a67261526498$var$collectOutsideElements(body, $0035a67261526498$var$buildKeepSet(avoidElements), new Set(avoidElements)) : [];
    const hiddenElements = [];
    const markedElements = [];
    if (controlAttribute) {
        const map = $0035a67261526498$var$counters[controlAttribute];
        const currentUncontrolledElementsSet = $0035a67261526498$var$getUncontrolledElementsSet(controlAttribute);
        uncontrolledElementsSet = currentUncontrolledElementsSet;
        counterMap = map;
        const ariaLiveElements = $0035a67261526498$var$correctElements(body, Array.from(body.querySelectorAll('[aria-live]')));
        const controlElements = avoidElements.concat(ariaLiveElements);
        const controlTargets = $0035a67261526498$var$collectOutsideElements(body, $0035a67261526498$var$buildKeepSet(controlElements), new Set(controlElements));
        controlTargets.forEach((node)=>{
            const attr = node.getAttribute(controlAttribute);
            const alreadyHidden = attr !== null && attr !== 'false';
            const counterValue = (map.get(node) || 0) + 1;
            map.set(node, counterValue);
            hiddenElements.push(node);
            if (counterValue === 1 && alreadyHidden) currentUncontrolledElementsSet.add(node);
            if (!alreadyHidden) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
        });
    }
    if (mark) markerTargets.forEach((node)=>{
        const markerValue = ($0035a67261526498$var$markerCounterMap.get(node) || 0) + 1;
        $0035a67261526498$var$markerCounterMap.set(node, markerValue);
        markedElements.push(node);
        if (markerValue === 1) node.setAttribute($0035a67261526498$var$markerName, '');
    });
    $0035a67261526498$var$lockCount += 1;
    return ()=>{
        if (counterMap) hiddenElements.forEach((element)=>{
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            counterMap.set(element, counterValue);
            if (!counterValue) {
                if (!uncontrolledElementsSet?.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet?.delete(element);
            }
        });
        if (mark) markedElements.forEach((element)=>{
            const markerValue = ($0035a67261526498$var$markerCounterMap.get(element) || 0) - 1;
            $0035a67261526498$var$markerCounterMap.set(element, markerValue);
            if (!markerValue) element.removeAttribute($0035a67261526498$var$markerName);
        });
        $0035a67261526498$var$lockCount -= 1;
        if (!$0035a67261526498$var$lockCount) {
            $0035a67261526498$var$counters.inert = new WeakMap();
            $0035a67261526498$var$counters['aria-hidden'] = new WeakMap();
            $0035a67261526498$var$uncontrolledElementsSets.inert = new WeakSet();
            $0035a67261526498$var$uncontrolledElementsSets['aria-hidden'] = new WeakSet();
            $0035a67261526498$var$markerCounterMap = new WeakMap();
        }
    };
}
function $0035a67261526498$export$cea0be4da43dc380(avoidElements, options = {}) {
    const { ariaHidden: ariaHidden = false, inert: inert = false, mark: mark = true } = options;
    const body = (0, $8shn9.ownerDocument)(avoidElements[0]).body;
    return $0035a67261526498$var$applyAttributeToOthers(avoidElements, body, ariaHidden, inert, {
        mark: mark
    });
}

});

parcelRegister("hrUXZ", function(module, exports) {

$parcel$export(module.exports, "usePortalContext", () => $5b33729c90e2f557$export$40dd24f08c9c9fa8);
$parcel$export(module.exports, "useFloatingPortalNode", () => $5b33729c90e2f557$export$ac107512f3c5cca6);
$parcel$export(module.exports, "FloatingPortal", () => $5b33729c90e2f557$export$31fa5d718fa2ac09);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $1D9S2 = parcelRequire("1D9S2");

var $cbA4H = parcelRequire("cbA4H");

var $8v2Os = parcelRequire("8v2Os");

var $8VAvD = parcelRequire("8VAvD");

var $9N3e2 = parcelRequire("9N3e2");

var $fKU9M = parcelRequire("fKU9M");

var $jWAMz = parcelRequire("jWAMz");

var $4yZSp = parcelRequire("4yZSp");

var $4yUKk = parcelRequire("4yUKk");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $561ed = parcelRequire("561ed");

var $aEBMJ = parcelRequire("aEBMJ");

var $cTo2e = parcelRequire("cTo2e");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $5b33729c90e2f557$var$PortalContext = /*#__PURE__*/ $8NFma.createContext(null);
const $5b33729c90e2f557$export$40dd24f08c9c9fa8 = ()=>$8NFma.useContext($5b33729c90e2f557$var$PortalContext);
const $5b33729c90e2f557$var$attr = (0, $561ed.createAttribute)('portal');
function $5b33729c90e2f557$export$ac107512f3c5cca6(props = {}) {
    const { ref: ref, container: containerProp, componentProps: componentProps = (0, $jWAMz.EMPTY_OBJECT), elementProps: elementProps } = props;
    const uniqueId = (0, $8VAvD.useId)();
    const portalContext = $5b33729c90e2f557$export$40dd24f08c9c9fa8();
    const parentPortalNode = portalContext?.portalNode;
    const [containerElement, setContainerElement] = $8NFma.useState(null);
    const [portalNode, setPortalNode] = $8NFma.useState(null);
    const setPortalNodeRef = (0, $fKU9M.useStableCallback)((node)=>{
        if (node !== null) // the useIsoLayoutEffect below watching containerProp / parentPortalNode
        // sets setPortalNode(null) when the container becomes null or changes.
        // So even though the ref callback now ignores null, the portal node still gets cleared.
        setPortalNode(node);
    });
    const containerRef = $8NFma.useRef(null);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Wait for the container to be resolved if explicitly `null`.
        if (containerProp === null) {
            if (containerRef.current) {
                containerRef.current = null;
                setPortalNode(null);
                setContainerElement(null);
            }
            return;
        }
        // React 17 does not use React.useId().
        if (uniqueId == null) return;
        const resolvedContainer = (containerProp && ((0, $1D9S2.isNode)(containerProp) ? containerProp : containerProp.current)) ?? parentPortalNode ?? document.body;
        if (resolvedContainer == null) {
            if (containerRef.current) {
                containerRef.current = null;
                setPortalNode(null);
                setContainerElement(null);
            }
            return;
        }
        if (containerRef.current !== resolvedContainer) {
            containerRef.current = resolvedContainer;
            setPortalNode(null);
            setContainerElement(resolvedContainer);
        }
    }, [
        containerProp,
        parentPortalNode,
        uniqueId
    ]);
    const portalElement = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        ref: [
            ref,
            setPortalNodeRef
        ],
        props: [
            {
                id: uniqueId,
                [$5b33729c90e2f557$var$attr]: ''
            },
            elementProps
        ]
    });
    // This `createPortal` call injects `portalElement` into the `container`.
    // Another call inside `FloatingPortal`/`FloatingPortalLite` then injects the children into `portalElement`.
    const portalSubtree = containerElement && portalElement ? /*#__PURE__*/ $2pmb0.createPortal(portalElement, containerElement) : null;
    return {
        portalNode: portalNode,
        portalSubtree: portalSubtree
    };
}
const $5b33729c90e2f557$export$31fa5d718fa2ac09 = /*#__PURE__*/ $8NFma.forwardRef(function FloatingPortal(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, children: children, container: container, renderGuards: renderGuards, ...elementProps } = componentProps;
    const { portalNode: portalNode, portalSubtree: portalSubtree } = $5b33729c90e2f557$export$ac107512f3c5cca6({
        container: container,
        ref: forwardedRef,
        componentProps: componentProps,
        elementProps: elementProps
    });
    const beforeOutsideRef = $8NFma.useRef(null);
    const afterOutsideRef = $8NFma.useRef(null);
    const beforeInsideRef = $8NFma.useRef(null);
    const afterInsideRef = $8NFma.useRef(null);
    const [focusManagerState, setFocusManagerState] = $8NFma.useState(null);
    const focusInsideDisabledRef = $8NFma.useRef(false);
    const modal = focusManagerState?.modal;
    const open = focusManagerState?.open;
    const shouldRenderGuards = typeof renderGuards === 'boolean' ? renderGuards : !!focusManagerState && !focusManagerState.modal && focusManagerState.open && !!portalNode;
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $8NFma.useEffect(()=>{
        if (!portalNode || modal) return undefined;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && event.relatedTarget && (0, $4yUKk.isOutsideEvent)(event)) {
                if (event.type === 'focusin') {
                    if (focusInsideDisabledRef.current) {
                        (0, $4yUKk.enableFocusInside)(portalNode);
                        focusInsideDisabledRef.current = false;
                    }
                } else {
                    (0, $4yUKk.disableFocusInside)(portalNode);
                    focusInsideDisabledRef.current = true;
                }
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        return (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(portalNode, 'focusin', onFocus, true), (0, $cbA4H.addEventListener)(portalNode, 'focusout', onFocus, true));
    }, [
        portalNode,
        modal
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!portalNode || open !== true || !focusInsideDisabledRef.current) return;
        // Restore tabbability before the focus manager's queued focus-on-open step runs.
        (0, $4yUKk.enableFocusInside)(portalNode);
        focusInsideDisabledRef.current = false;
    }, [
        open,
        portalNode
    ]);
    const portalContextValue = $8NFma.useMemo(()=>({
            beforeOutsideRef: beforeOutsideRef,
            afterOutsideRef: afterOutsideRef,
            beforeInsideRef: beforeInsideRef,
            afterInsideRef: afterInsideRef,
            portalNode: portalNode,
            setFocusManagerState: setFocusManagerState
        }), [
        portalNode
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            portalSubtree,
            /*#__PURE__*/ (0, $1IdZj.jsxs)($5b33729c90e2f557$var$PortalContext.Provider, {
                value: portalContextValue,
                children: [
                    shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                        "data-type": "outside",
                        ref: beforeOutsideRef,
                        onFocus: (event)=>{
                            if ((0, $4yUKk.isOutsideEvent)(event, portalNode)) beforeInsideRef.current?.focus();
                            else {
                                const domReference = focusManagerState ? focusManagerState.domReference : null;
                                const prevTabbable = (0, $4yUKk.getPreviousTabbable)(domReference);
                                prevTabbable?.focus();
                            }
                        }
                    }),
                    shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                        "aria-owns": portalNode.id,
                        style: (0, $cTo2e.ownerVisuallyHidden)
                    }),
                    portalNode && /*#__PURE__*/ $2pmb0.createPortal(children, portalNode),
                    shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                        "data-type": "outside",
                        ref: afterOutsideRef,
                        onFocus: (event)=>{
                            if ((0, $4yUKk.isOutsideEvent)(event, portalNode)) afterInsideRef.current?.focus();
                            else {
                                const domReference = focusManagerState ? focusManagerState.domReference : null;
                                const nextTabbable = (0, $4yUKk.getNextTabbable)(domReference);
                                nextTabbable?.focus();
                                if (focusManagerState?.closeOnFocusOut) focusManagerState?.onOpenChange(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).focusOut, event.nativeEvent));
                            }
                        }
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("cTo2e", function(module, exports) {

$parcel$export(module.exports, "TYPEAHEAD_RESET_MS", () => $8d219387a7c88477$export$840ef7c4cca16b84);
$parcel$export(module.exports, "PATIENT_CLICK_THRESHOLD", () => $8d219387a7c88477$export$b3a060fb75aa61b7);
$parcel$export(module.exports, "DISABLED_TRANSITIONS_STYLE", () => $8d219387a7c88477$export$a836c2637cefced7);
$parcel$export(module.exports, "CLICK_TRIGGER_IDENTIFIER", () => $8d219387a7c88477$export$d0c4c879395d8eb5);
$parcel$export(module.exports, "BASE_UI_SWIPE_IGNORE_SELECTOR", () => $8d219387a7c88477$export$37b7988db2380266);
$parcel$export(module.exports, "LEGACY_SWIPE_IGNORE_SELECTOR", () => $8d219387a7c88477$export$5e2ddd7ac4618443);
$parcel$export(module.exports, "DROPDOWN_COLLISION_AVOIDANCE", () => $8d219387a7c88477$export$a48e9fc7de5459a3);
$parcel$export(module.exports, "POPUP_COLLISION_AVOIDANCE", () => $8d219387a7c88477$export$4ede28d40cd5222e);
$parcel$export(module.exports, "ownerVisuallyHidden", () => $8d219387a7c88477$export$c9d41dec7a2c0d80);
const $8d219387a7c88477$export$840ef7c4cca16b84 = 500;
const $8d219387a7c88477$export$b3a060fb75aa61b7 = 500;
const $8d219387a7c88477$export$a836c2637cefced7 = {
    style: {
        transition: 'none'
    }
};
const $8d219387a7c88477$export$d0c4c879395d8eb5 = 'data-base-ui-click-trigger';
const $8d219387a7c88477$export$ba18e4eff9f32fb2 = 'data-base-ui-swipe-ignore';
const $8d219387a7c88477$export$fee793975151e428 = 'data-swipe-ignore';
const $8d219387a7c88477$export$37b7988db2380266 = `[${$8d219387a7c88477$export$ba18e4eff9f32fb2}]`;
const $8d219387a7c88477$export$5e2ddd7ac4618443 = `[${$8d219387a7c88477$export$fee793975151e428}]`;
const $8d219387a7c88477$export$a48e9fc7de5459a3 = {
    fallbackAxisSide: 'none'
};
const $8d219387a7c88477$export$4ede28d40cd5222e = {
    fallbackAxisSide: 'end'
};
const $8d219387a7c88477$export$c9d41dec7a2c0d80 = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};

});


parcelRegister("8Xtx1", function(module, exports) {

$parcel$export(module.exports, "useFloatingParentNodeId", () => $ed464d567e53f408$export$165209eae06d3488);
$parcel$export(module.exports, "useFloatingTree", () => $ed464d567e53f408$export$db0c2a7c7a2a4f69);
$parcel$export(module.exports, "useFloatingNodeId", () => $ed464d567e53f408$export$9b136e0e758a42f4);
$parcel$export(module.exports, "FloatingNode", () => $ed464d567e53f408$export$ca00a83b5b253862);
$parcel$export(module.exports, "FloatingTree", () => $ed464d567e53f408$export$587b60129641c4c8);

var $8NFma = parcelRequire("8NFma");

var $8VAvD = parcelRequire("8VAvD");

var $9N3e2 = parcelRequire("9N3e2");

var $gidzQ = parcelRequire("gidzQ");

var $k3oe4 = parcelRequire("k3oe4");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $ed464d567e53f408$var$FloatingNodeContext = /*#__PURE__*/ $8NFma.createContext(null);
const $ed464d567e53f408$var$FloatingTreeContext = /*#__PURE__*/ $8NFma.createContext(null);
const $ed464d567e53f408$export$165209eae06d3488 = ()=>$8NFma.useContext($ed464d567e53f408$var$FloatingNodeContext)?.id || null;
const $ed464d567e53f408$export$db0c2a7c7a2a4f69 = (externalTree)=>{
    const contextTree = $8NFma.useContext($ed464d567e53f408$var$FloatingTreeContext);
    return externalTree ?? contextTree;
};
function $ed464d567e53f408$export$9b136e0e758a42f4(externalTree) {
    const id = (0, $8VAvD.useId)();
    const tree = $ed464d567e53f408$export$db0c2a7c7a2a4f69(externalTree);
    const parentId = $ed464d567e53f408$export$165209eae06d3488();
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!id) return undefined;
        const node = {
            id: id,
            parentId: parentId
        };
        tree?.addNode(node);
        return ()=>{
            tree?.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
function $ed464d567e53f408$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $ed464d567e53f408$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $1IdZj.jsx)($ed464d567e53f408$var$FloatingNodeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
function $ed464d567e53f408$export$587b60129641c4c8(props) {
    const { children: children, externalTree: externalTree } = props;
    const tree = (0, $gidzQ.useRefWithInit)(()=>externalTree ?? new (0, $k3oe4.FloatingTreeStore)()).current;
    return /*#__PURE__*/ (0, $1IdZj.jsx)($ed464d567e53f408$var$FloatingTreeContext.Provider, {
        value: tree,
        children: children
    });
}

});
parcelRegister("k3oe4", function(module, exports) {

$parcel$export(module.exports, "FloatingTreeStore", () => $1bd38a2070a2f162$export$8426323236501868);

var $5FZox = parcelRequire("5FZox");
class $1bd38a2070a2f162$export$8426323236501868 {
    nodesRef = {
        current: []
    };
    events = (0, $5FZox.createEventEmitter)();
    addNode(node) {
        this.nodesRef.current.push(node);
    }
    removeNode(node) {
        const index = this.nodesRef.current.findIndex((n)=>n === node);
        if (index !== -1) this.nodesRef.current.splice(index, 1);
    }
}

});
parcelRegister("5FZox", function(module, exports) {

$parcel$export(module.exports, "createEventEmitter", () => $ffaf800012557b0c$export$abfecd6a8e6070c1);
function $ffaf800012557b0c$export$abfecd6a8e6070c1() {
    const map = new Map();
    return {
        emit (event, data) {
            map.get(event)?.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            map.get(event)?.delete(listener);
        }
    };
}

});




parcelRegister("9bngb", function(module, exports) {

$parcel$export(module.exports, "useHoverFloatingInteraction", () => $1572ea45fde4fa2a$export$75ac6b0cc26176a4);

var $8NFma = parcelRequire("8NFma");

var $cbA4H = parcelRequire("cbA4H");

var $8v2Os = parcelRequire("8v2Os");

var $9N3e2 = parcelRequire("9N3e2");

var $8shn9 = parcelRequire("8shn9");

var $fKU9M = parcelRequire("fKU9M");

var $5o6JF = parcelRequire("5o6JF");

var $1D9S2 = parcelRequire("1D9S2");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $8Xtx1 = parcelRequire("8Xtx1");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $1Pbuv = parcelRequire("1Pbuv");

var $kS7mH = parcelRequire("kS7mH");

var $lb1NF = parcelRequire("lb1NF");
var $klAiy = parcelRequire("klAiy");

var $5tgFR = parcelRequire("5tgFR");
var $klAiy = parcelRequire("klAiy");
'use client';
function $1572ea45fde4fa2a$export$75ac6b0cc26176a4(context, parameters = {}) {
    const { enabled: enabled = true, closeDelay: closeDelayProp = 0, nodeId: nodeIdProp } = parameters;
    const store = 'rootStore' in context ? context.rootStore : context;
    const open = store.useState('open');
    const floatingElement = store.useState('floatingElement');
    const domReferenceElement = store.useState('domReferenceElement');
    const { dataRef: dataRef } = store.context;
    const tree = (0, $8Xtx1.useFloatingTree)();
    const parentId = (0, $8Xtx1.useFloatingParentNodeId)();
    const instance = (0, $lb1NF.useHoverInteractionSharedState)(store);
    const childClosedTimeout = (0, $5o6JF.useTimeout)();
    const isClickLikeOpenEvent = (0, $fKU9M.useStableCallback)(()=>{
        return (0, $5tgFR.isClickLikeOpenEvent)(dataRef.current.openEvent?.type, instance.interactedInside);
    });
    const isHoverOpen = (0, $fKU9M.useStableCallback)(()=>{
        return (0, $5tgFR.isHoverOpenEvent)(dataRef.current.openEvent?.type);
    });
    const clearPointerEvents = (0, $fKU9M.useStableCallback)(()=>{
        (0, $lb1NF.clearSafePolygonPointerEventsMutation)(instance);
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open) {
            instance.pointerType = undefined;
            instance.restTimeoutPending = false;
            instance.interactedInside = false;
            clearPointerEvents();
        }
    }, [
        open,
        instance,
        clearPointerEvents
    ]);
    $8NFma.useEffect(()=>{
        return clearPointerEvents;
    }, [
        clearPointerEvents
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled) return undefined;
        if (open && instance.handleCloseOptions?.blockPointerEvents && isHoverOpen() && (0, $1D9S2.isElement)(domReferenceElement) && floatingElement) {
            const ref = domReferenceElement;
            const floatingEl = floatingElement;
            const doc = (0, $8shn9.ownerDocument)(floatingElement);
            const parentFloating = tree?.nodesRef.current.find((node)=>node.id === parentId)?.context?.elements.floating;
            if (parentFloating) parentFloating.style.pointerEvents = '';
            // A keep-mounted submenu can appear in the tree before it opens, so a
            // cached scope or parent lookup may resolve to the submenu itself. That
            // would not shield sibling items in the parent menu.
            const cachedScopeElement = instance.pointerEventsScopeElement !== floatingEl ? instance.pointerEventsScopeElement : null;
            const parentScopeElement = parentFloating !== floatingEl ? parentFloating : null;
            const scopeElement = instance.handleCloseOptions?.getScope?.() ?? cachedScopeElement ?? parentScopeElement ?? ref.closest('[data-rootownerid]') ?? doc.body;
            (0, $lb1NF.applySafePolygonPointerEventsMutation)(instance, {
                scopeElement: scopeElement,
                referenceElement: ref,
                floatingElement: floatingEl
            });
            return ()=>{
                clearPointerEvents();
            };
        }
        return undefined;
    }, [
        enabled,
        open,
        domReferenceElement,
        floatingElement,
        instance,
        isHoverOpen,
        tree,
        parentId,
        clearPointerEvents
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return undefined;
        function hasParentChildren() {
            return !!(tree && parentId && (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, parentId).length > 0);
        }
        function closeWithDelay(event) {
            const closeDelay = (0, $5tgFR.getDelay)(closeDelayProp, 'close', instance.pointerType);
            const close = ()=>{
                store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event));
                tree?.events.emit('floating.closed', event);
            };
            if (closeDelay) instance.openChangeTimeout.start(closeDelay, close);
            else {
                instance.openChangeTimeout.clear();
                close();
            }
        }
        function handleInteractInside(event) {
            const target = (0, $1Pbuv.getTarget)(event);
            if (!(0, $klAiy.isInteractiveElement)(target)) {
                instance.interactedInside = false;
                return;
            }
            instance.interactedInside = target?.closest('[aria-haspopup]') != null;
        }
        function onFloatingMouseEnter() {
            instance.openChangeTimeout.clear();
            childClosedTimeout.clear();
            tree?.events.off('floating.closed', onNodeClosed);
            clearPointerEvents();
        }
        function onFloatingMouseLeave(event) {
            if (hasParentChildren() && tree) {
                tree.events.on('floating.closed', onNodeClosed);
                return;
            }
            if ((0, $klAiy.isTargetInsideEnabledTrigger)(event.relatedTarget, store.context.triggerElements)) // If the mouse is leaving the reference element to another trigger, don't explicitly close the popup
            // as it will be moved.
            return;
            const currentNodeId = dataRef.current.floatingContext?.nodeId ?? nodeIdProp;
            const relatedTarget = event.relatedTarget;
            const isMovingIntoDescendantFloating = tree && currentNodeId && (0, $1D9S2.isElement)(relatedTarget) && (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, currentNodeId, false).some((node)=>(0, $1Pbuv.contains)(node.context?.elements.floating, relatedTarget));
            if (isMovingIntoDescendantFloating) return;
            // If the safePolygon handler is active, let it handle the close logic.
            if (instance.handler) {
                instance.handler(event);
                return;
            }
            clearPointerEvents();
            if (isHoverOpen() && !isClickLikeOpenEvent()) closeWithDelay(event);
        }
        function onNodeClosed(event) {
            if (!tree || !parentId || hasParentChildren()) return;
            // Allow the mouseenter event to fire in case child was closed because mouse moved into parent.
            childClosedTimeout.start(0, ()=>{
                tree.events.off('floating.closed', onNodeClosed);
                store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event));
                tree.events.emit('floating.closed', event);
            });
        }
        const floating = floatingElement;
        return (0, $8v2Os.mergeCleanups)(floating && (0, $cbA4H.addEventListener)(floating, 'mouseenter', onFloatingMouseEnter), floating && (0, $cbA4H.addEventListener)(floating, 'mouseleave', onFloatingMouseLeave), floating && (0, $cbA4H.addEventListener)(floating, 'pointerdown', handleInteractInside, true), ()=>{
            tree?.events.off('floating.closed', onNodeClosed);
        });
    }, [
        enabled,
        floatingElement,
        store,
        dataRef,
        closeDelayProp,
        nodeIdProp,
        isHoverOpen,
        isClickLikeOpenEvent,
        clearPointerEvents,
        instance,
        tree,
        parentId,
        childClosedTimeout
    ]);
}

});
parcelRegister("lb1NF", function(module, exports) {

$parcel$export(module.exports, "clearSafePolygonPointerEventsMutation", () => $c9e713be05d95656$export$2cad79e4f8cfbfa7);
$parcel$export(module.exports, "applySafePolygonPointerEventsMutation", () => $c9e713be05d95656$export$27b1d68e2e14b62);
$parcel$export(module.exports, "useHoverInteractionSharedState", () => $c9e713be05d95656$export$e7264309cf70e6c0);

var $cIgNk = parcelRequire("cIgNk");

var $gidzQ = parcelRequire("gidzQ");

var $5o6JF = parcelRequire("5o6JF");

var $klAiy = parcelRequire("klAiy");
'use client';
class $c9e713be05d95656$export$ec0d47900a925491 {
    constructor(){
        this.pointerType = undefined;
        this.interactedInside = false;
        this.handler = undefined;
        this.blockMouseMove = true;
        this.performedPointerEventsMutation = false;
        this.pointerEventsScopeElement = null;
        this.pointerEventsReferenceElement = null;
        this.pointerEventsFloatingElement = null;
        this.restTimeoutPending = false;
        this.openChangeTimeout = new (0, $5o6JF.Timeout)();
        this.restTimeout = new (0, $5o6JF.Timeout)();
        this.handleCloseOptions = undefined;
    }
    static create() {
        return new $c9e713be05d95656$export$ec0d47900a925491();
    }
    dispose = ()=>{
        this.openChangeTimeout.clear();
        this.restTimeout.clear();
    };
    disposeEffect = ()=>{
        return this.dispose;
    };
}
const $c9e713be05d95656$var$pointerEventsMutationOwnerByScopeElement = new WeakMap();
function $c9e713be05d95656$export$2cad79e4f8cfbfa7(instance) {
    if (!instance.performedPointerEventsMutation) return;
    const scopeElement = instance.pointerEventsScopeElement;
    if (scopeElement && $c9e713be05d95656$var$pointerEventsMutationOwnerByScopeElement.get(scopeElement) === instance) {
        instance.pointerEventsScopeElement?.style.removeProperty('pointer-events');
        instance.pointerEventsReferenceElement?.style.removeProperty('pointer-events');
        instance.pointerEventsFloatingElement?.style.removeProperty('pointer-events');
        $c9e713be05d95656$var$pointerEventsMutationOwnerByScopeElement.delete(scopeElement);
    }
    instance.performedPointerEventsMutation = false;
    instance.pointerEventsScopeElement = null;
    instance.pointerEventsReferenceElement = null;
    instance.pointerEventsFloatingElement = null;
}
function $c9e713be05d95656$export$27b1d68e2e14b62(instance, options) {
    const { scopeElement: scopeElement, referenceElement: referenceElement, floatingElement: floatingElement } = options;
    const existingOwner = $c9e713be05d95656$var$pointerEventsMutationOwnerByScopeElement.get(scopeElement);
    if (existingOwner && existingOwner !== instance) $c9e713be05d95656$export$2cad79e4f8cfbfa7(existingOwner);
    $c9e713be05d95656$export$2cad79e4f8cfbfa7(instance);
    instance.performedPointerEventsMutation = true;
    instance.pointerEventsScopeElement = scopeElement;
    instance.pointerEventsReferenceElement = referenceElement;
    instance.pointerEventsFloatingElement = floatingElement;
    $c9e713be05d95656$var$pointerEventsMutationOwnerByScopeElement.set(scopeElement, instance);
    scopeElement.style.pointerEvents = 'none';
    referenceElement.style.pointerEvents = 'auto';
    floatingElement.style.pointerEvents = 'auto';
}
function $c9e713be05d95656$export$e7264309cf70e6c0(store) {
    const data = store.context.dataRef.current;
    const instance = (0, $gidzQ.useRefWithInit)(()=>data.hoverInteractionState ?? $c9e713be05d95656$export$ec0d47900a925491.create()).current;
    if (!data.hoverInteractionState) data.hoverInteractionState = instance;
    (0, $cIgNk.useOnMount)(data.hoverInteractionState.disposeEffect);
    return data.hoverInteractionState;
}

});

parcelRegister("5tgFR", function(module, exports) {

$parcel$export(module.exports, "getDelay", () => $ab1f76a48c9ed1a1$export$621ec2f31bd1c7ec);
$parcel$export(module.exports, "getRestMs", () => $ab1f76a48c9ed1a1$export$b958953d1a5c5447);
$parcel$export(module.exports, "isClickLikeOpenEvent", () => $ab1f76a48c9ed1a1$export$85db29449a63105);
$parcel$export(module.exports, "isHoverOpenEvent", () => $ab1f76a48c9ed1a1$export$17ed8c004a2aacf);

var $18t8v = parcelRequire("18t8v");

var $klAiy = parcelRequire("klAiy");
function $ab1f76a48c9ed1a1$var$resolveValue(value, pointerType) {
    if (pointerType != null && !(0, $18t8v.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'function') return value();
    return value;
}
function $ab1f76a48c9ed1a1$export$621ec2f31bd1c7ec(value, prop, pointerType) {
    const result = $ab1f76a48c9ed1a1$var$resolveValue(value, pointerType);
    if (typeof result === 'number') return result;
    return result?.[prop];
}
function $ab1f76a48c9ed1a1$export$b958953d1a5c5447(value) {
    if (typeof value === 'function') return value();
    return value;
}
function $ab1f76a48c9ed1a1$export$85db29449a63105(openEventType, interactedInside) {
    return interactedInside || openEventType === 'click' || openEventType === 'mousedown';
}
function $ab1f76a48c9ed1a1$export$17ed8c004a2aacf(openEventType) {
    return openEventType?.includes('mouse') && openEventType !== 'mousedown';
}

});


parcelRegister("5OGtE", function(module, exports) {

$parcel$export(module.exports, "useToolbarRootContext", () => $81a8231577cd93c6$export$87c58391f29b3076);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $81a8231577cd93c6$export$5029303a5b8e0f62 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $81a8231577cd93c6$export$87c58391f29b3076(optional) {
    const context = $8NFma.useContext($81a8231577cd93c6$export$5029303a5b8e0f62);
    if (context === undefined && !optional) throw new Error((0, $cmjqX.default)(69));
    return context;
}

});

parcelRegister("kbm4S", function(module, exports) {

$parcel$export(module.exports, "COMPOSITE_KEYS", () => $eb542c09a8ce26be$export$4ecf34e5b3779415);

var $1D9S2 = parcelRequire("1D9S2");

const $eb542c09a8ce26be$export$8188339dbe6c99c4 = 'ArrowUp';
const $eb542c09a8ce26be$export$59f214baefff6196 = 'ArrowDown';
const $eb542c09a8ce26be$export$8d4f84cc5dc5fc15 = 'ArrowLeft';
const $eb542c09a8ce26be$export$e9510a4613bb01df = 'ArrowRight';
const $eb542c09a8ce26be$export$a7c5707626fc90f = 'Home';
const $eb542c09a8ce26be$export$32239d68d9c6cb49 = 'End';
const $eb542c09a8ce26be$export$4f958dbcbb315b8e = 'PageUp';
const $eb542c09a8ce26be$export$fae76282e3728a4 = 'PageDown';
const $eb542c09a8ce26be$export$b820694d8e9164bf = new Set([
    $eb542c09a8ce26be$export$8d4f84cc5dc5fc15,
    $eb542c09a8ce26be$export$e9510a4613bb01df
]);
const $eb542c09a8ce26be$export$76d9f44f79f43972 = new Set([
    $eb542c09a8ce26be$export$8d4f84cc5dc5fc15,
    $eb542c09a8ce26be$export$e9510a4613bb01df,
    $eb542c09a8ce26be$export$a7c5707626fc90f,
    $eb542c09a8ce26be$export$32239d68d9c6cb49
]);
const $eb542c09a8ce26be$export$619501df4c5fb584 = new Set([
    $eb542c09a8ce26be$export$8188339dbe6c99c4,
    $eb542c09a8ce26be$export$59f214baefff6196
]);
const $eb542c09a8ce26be$export$899eee77bd8bc202 = new Set([
    $eb542c09a8ce26be$export$8188339dbe6c99c4,
    $eb542c09a8ce26be$export$59f214baefff6196,
    $eb542c09a8ce26be$export$a7c5707626fc90f,
    $eb542c09a8ce26be$export$32239d68d9c6cb49
]);
const $eb542c09a8ce26be$export$a50ee5b5729adf78 = new Set([
    ...$eb542c09a8ce26be$export$b820694d8e9164bf,
    ...$eb542c09a8ce26be$export$619501df4c5fb584
]);
const $eb542c09a8ce26be$export$4ecf34e5b3779415 = new Set([
    ...$eb542c09a8ce26be$export$a50ee5b5729adf78,
    $eb542c09a8ce26be$export$a7c5707626fc90f,
    $eb542c09a8ce26be$export$32239d68d9c6cb49
]);
const $eb542c09a8ce26be$export$d36167fd695703b4 = 'Shift';
const $eb542c09a8ce26be$export$43f367b3e957f219 = 'Control';
const $eb542c09a8ce26be$export$88cf69ae39db8aa2 = 'Alt';
const $eb542c09a8ce26be$export$80fe244ee60b2675 = 'Meta';
const $eb542c09a8ce26be$export$6bb09f89558baff4 = new Set([
    $eb542c09a8ce26be$export$d36167fd695703b4,
    $eb542c09a8ce26be$export$43f367b3e957f219,
    $eb542c09a8ce26be$export$88cf69ae39db8aa2,
    $eb542c09a8ce26be$export$80fe244ee60b2675
]);
function $eb542c09a8ce26be$var$isInputElement(element) {
    return (0, $1D9S2.isHTMLElement)(element) && element.tagName === 'INPUT';
}
function $eb542c09a8ce26be$export$4a81a12cc2bcc231(element) {
    if ($eb542c09a8ce26be$var$isInputElement(element) && element.selectionStart != null) return true;
    if ((0, $1D9S2.isHTMLElement)(element) && element.tagName === 'TEXTAREA') return true;
    return false;
}
function $eb542c09a8ce26be$export$9657601bf1e130ee(scrollContainer, element, direction, orientation) {
    if (!scrollContainer || !element || !element.scrollTo) return;
    let targetX = scrollContainer.scrollLeft;
    let targetY = scrollContainer.scrollTop;
    const isOverflowingX = scrollContainer.clientWidth < scrollContainer.scrollWidth;
    const isOverflowingY = scrollContainer.clientHeight < scrollContainer.scrollHeight;
    if (isOverflowingX && orientation !== 'vertical') {
        const elementOffsetLeft = $eb542c09a8ce26be$var$getOffset(scrollContainer, element, 'left');
        const containerStyles = $eb542c09a8ce26be$var$getStyles(scrollContainer);
        const elementStyles = $eb542c09a8ce26be$var$getStyles(element);
        if (direction === 'ltr') {
            if (elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight > scrollContainer.scrollLeft + scrollContainer.clientWidth - containerStyles.scrollPaddingRight) // overflow to the right, scroll to align right edges
            targetX = elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight - scrollContainer.clientWidth + containerStyles.scrollPaddingRight;
            else if (elementOffsetLeft - elementStyles.scrollMarginLeft < scrollContainer.scrollLeft + containerStyles.scrollPaddingLeft) // overflow to the left, scroll to align left edges
            targetX = elementOffsetLeft - elementStyles.scrollMarginLeft - containerStyles.scrollPaddingLeft;
        }
        if (direction === 'rtl') {
            if (elementOffsetLeft - elementStyles.scrollMarginRight < scrollContainer.scrollLeft + containerStyles.scrollPaddingLeft) // overflow to the left, scroll to align left edges
            targetX = elementOffsetLeft - elementStyles.scrollMarginLeft - containerStyles.scrollPaddingLeft;
            else if (elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight > scrollContainer.scrollLeft + scrollContainer.clientWidth - containerStyles.scrollPaddingRight) // overflow to the right, scroll to align right edges
            targetX = elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight - scrollContainer.clientWidth + containerStyles.scrollPaddingRight;
        }
    }
    if (isOverflowingY && orientation !== 'horizontal') {
        const elementOffsetTop = $eb542c09a8ce26be$var$getOffset(scrollContainer, element, 'top');
        const containerStyles = $eb542c09a8ce26be$var$getStyles(scrollContainer);
        const elementStyles = $eb542c09a8ce26be$var$getStyles(element);
        if (elementOffsetTop - elementStyles.scrollMarginTop < scrollContainer.scrollTop + containerStyles.scrollPaddingTop) // overflow upwards, align top edges
        targetY = elementOffsetTop - elementStyles.scrollMarginTop - containerStyles.scrollPaddingTop;
        else if (elementOffsetTop + element.offsetHeight + elementStyles.scrollMarginBottom > scrollContainer.scrollTop + scrollContainer.clientHeight - containerStyles.scrollPaddingBottom) // overflow downwards, align bottom edges
        targetY = elementOffsetTop + element.offsetHeight + elementStyles.scrollMarginBottom - scrollContainer.clientHeight + containerStyles.scrollPaddingBottom;
    }
    scrollContainer.scrollTo({
        left: targetX,
        top: targetY,
        behavior: 'auto'
    });
}
function $eb542c09a8ce26be$var$getOffset(ancestor, element, side) {
    const propName = side === 'left' ? 'offsetLeft' : 'offsetTop';
    let result = 0;
    while(element.offsetParent){
        result += element[propName];
        if (element.offsetParent === ancestor) break;
        element = element.offsetParent;
    }
    return result;
}
function $eb542c09a8ce26be$var$getStyles(element) {
    const styles = getComputedStyle(element);
    return {
        scrollMarginTop: parseFloat(styles.scrollMarginTop) || 0,
        scrollMarginRight: parseFloat(styles.scrollMarginRight) || 0,
        scrollMarginBottom: parseFloat(styles.scrollMarginBottom) || 0,
        scrollMarginLeft: parseFloat(styles.scrollMarginLeft) || 0,
        scrollPaddingTop: parseFloat(styles.scrollPaddingTop) || 0,
        scrollPaddingRight: parseFloat(styles.scrollPaddingRight) || 0,
        scrollPaddingBottom: parseFloat(styles.scrollPaddingBottom) || 0,
        scrollPaddingLeft: parseFloat(styles.scrollPaddingLeft) || 0
    };
}

});

parcelRegister("6OSIs", function(module, exports) {

$parcel$export(module.exports, "getDisabledMountTransitionStyles", () => $978e20fb010578e3$export$b5660a9e6290ea2);

var $jWAMz = parcelRequire("jWAMz");

var $cTo2e = parcelRequire("cTo2e");
function $978e20fb010578e3$export$b5660a9e6290ea2(transitionStatus) {
    return transitionStatus === 'starting' ? (0, $cTo2e.DISABLED_TRANSITIONS_STYLE) : (0, $jWAMz.EMPTY_OBJECT);
}

});


parcelRegister("c49N2", function(module, exports) {

$parcel$export(module.exports, "MenuPortal", () => $fc3f12cfad69a41e$export$793392f970497feb);

var $8NFma = parcelRequire("8NFma");

var $hrUXZ = parcelRequire("hrUXZ");

var $jtR97 = parcelRequire("jtR97");

var $iWqL0 = parcelRequire("iWqL0");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $fc3f12cfad69a41e$export$793392f970497feb = /*#__PURE__*/ $8NFma.forwardRef(function MenuPortal(props, forwardedRef) {
    const { keepMounted: keepMounted = false, ...portalProps } = props;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const mounted = store.useState('mounted');
    const shouldRender = mounted || keepMounted;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $iWqL0.MenuPortalContext).Provider, {
        value: keepMounted,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hrUXZ.FloatingPortal), {
            ref: forwardedRef,
            ...portalProps
        })
    });
});

});
parcelRegister("iWqL0", function(module, exports) {

$parcel$export(module.exports, "MenuPortalContext", () => $c3eeebd4c6fc3141$export$b4a7b0bd7e400058);
$parcel$export(module.exports, "useMenuPortalContext", () => $c3eeebd4c6fc3141$export$2a7bbfdbe32d87e5);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $c3eeebd4c6fc3141$export$b4a7b0bd7e400058 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $c3eeebd4c6fc3141$export$2a7bbfdbe32d87e5() {
    const value = $8NFma.useContext($c3eeebd4c6fc3141$export$b4a7b0bd7e400058);
    if (value === undefined) throw new Error((0, $cmjqX.default)(32));
    return value;
}

});


parcelRegister("43Vx6", function(module, exports) {

$parcel$export(module.exports, "MenuPositioner", () => $3841859177b9751e$export$fbbef597793ae27b);

var $8NFma = parcelRequire("8NFma");

var $lwkkr = parcelRequire("lwkkr");

var $9N3e2 = parcelRequire("9N3e2");

var $5o6JF = parcelRequire("5o6JF");

var $8Xtx1 = parcelRequire("8Xtx1");

var $8foVs = parcelRequire("8foVs");

var $jtR97 = parcelRequire("jtR97");

var $5GLN0 = parcelRequire("5GLN0");

var $2I5FP = parcelRequire("2I5FP");

var $dGxil = parcelRequire("dGxil");

var $iWqL0 = parcelRequire("iWqL0");

var $cTo2e = parcelRequire("cTo2e");

var $gnjAY = parcelRequire("gnjAY");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $gLdy7 = parcelRequire("gLdy7");

var $45x58 = parcelRequire("45x58");

var $ag8av = parcelRequire("ag8av");

var $424ib = parcelRequire("424ib");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $3841859177b9751e$export$fbbef597793ae27b = /*#__PURE__*/ $8NFma.forwardRef(function MenuPositioner(componentProps, forwardedRef) {
    const { anchor: anchorProp, positionMethod: positionMethodProp = 'absolute', className: className, render: render, side: side, align: alignProp, sideOffset: sideOffsetProp = 0, alignOffset: alignOffsetProp = 0, collisionBoundary: collisionBoundary = 'clipping-ancestors', collisionPadding: collisionPadding = 5, arrowPadding: arrowPadding = 5, sticky: sticky = false, disableAnchorTracking: disableAnchorTracking = false, collisionAvoidance: collisionAvoidanceProp = (0, $cTo2e.DROPDOWN_COLLISION_AVOIDANCE), style: style, ...elementProps } = componentProps;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const keepMounted = (0, $iWqL0.useMenuPortalContext)();
    const contextMenuContext = (0, $gnjAY.useContextMenuRootContext)(true);
    const parent = store.useState('parent');
    const floatingRootContext = store.useState('floatingRootContext');
    const floatingTreeRoot = store.useState('floatingTreeRoot');
    const mounted = store.useState('mounted');
    const open = store.useState('open');
    const modal = store.useState('modal');
    const openMethod = store.useState('openMethod');
    const triggerElement = store.useState('activeTriggerElement');
    const transitionStatus = store.useState('transitionStatus');
    const positionerElement = store.useState('positionerElement');
    const instantType = store.useState('instantType');
    const hasViewport = store.useState('hasViewport');
    const lastOpenChangeReason = store.useState('lastOpenChangeReason');
    const floatingNodeId = store.useState('floatingNodeId');
    const floatingParentNodeId = store.useState('floatingParentNodeId');
    const domReference = floatingRootContext.useState('domReferenceElement');
    const previousTriggerRef = $8NFma.useRef(null);
    const runOnceAnimationsFinish = (0, $45x58.useAnimationsFinished)(positionerElement, false, false);
    let anchor = anchorProp;
    let sideOffset = sideOffsetProp;
    let alignOffset = alignOffsetProp;
    let align = alignProp;
    let collisionAvoidance = collisionAvoidanceProp;
    if (parent.type === 'context-menu') {
        anchor = anchorProp ?? parent.context?.anchor;
        align = align ?? 'start';
        if (!side && align !== 'center') {
            alignOffset = componentProps.alignOffset ?? 2;
            sideOffset = componentProps.sideOffset ?? -5;
        }
    }
    let computedSide = side;
    let computedAlign = align;
    if (parent.type === 'menu') {
        computedSide = computedSide ?? 'inline-end';
        computedAlign = computedAlign ?? 'start';
        collisionAvoidance = componentProps.collisionAvoidance ?? (0, $cTo2e.POPUP_COLLISION_AVOIDANCE);
    } else if (parent.type === 'menubar') {
        computedSide = computedSide ?? (parent.context.orientation === 'vertical' ? 'inline-end' : 'bottom');
        computedAlign = computedAlign ?? 'start';
    }
    const contextMenu = parent.type === 'context-menu';
    const positioner = (0, $5GLN0.useAnchorPositioning)({
        anchor: anchor,
        floatingRootContext: floatingRootContext,
        positionMethod: contextMenuContext ? 'fixed' : positionMethodProp,
        mounted: mounted,
        side: computedSide,
        sideOffset: sideOffset,
        align: computedAlign,
        alignOffset: alignOffset,
        arrowPadding: contextMenu ? 0 : arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        nodeId: floatingNodeId,
        keepMounted: keepMounted,
        disableAnchorTracking: disableAnchorTracking,
        collisionAvoidance: collisionAvoidance,
        shiftCrossAxis: contextMenu && !('side' in collisionAvoidance && collisionAvoidance.side === 'flip'),
        externalTree: floatingTreeRoot,
        adaptiveOrigin: hasViewport ? (0, $gLdy7.adaptiveOrigin) : undefined
    });
    $8NFma.useEffect(()=>{
        function onMenuOpenChange(details) {
            if (details.open) {
                if (details.parentNodeId === floatingNodeId) store.set('hoverEnabled', false);
                if (details.nodeId !== floatingNodeId && details.parentNodeId === store.select('floatingParentNodeId')) store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).siblingOpen));
            }
        }
        floatingTreeRoot.events.on('menuopenchange', onMenuOpenChange);
        return ()=>{
            floatingTreeRoot.events.off('menuopenchange', onMenuOpenChange);
        };
    }, [
        store,
        floatingTreeRoot.events,
        floatingNodeId
    ]);
    $8NFma.useEffect(()=>{
        if (store.select('floatingParentNodeId') == null) return undefined;
        function onParentClose(details) {
            if (details.open || details.nodeId !== store.select('floatingParentNodeId')) return;
            const reason = details.reason ?? (0, $66jhv).siblingOpen;
            store.setOpen(false, (0, $6e5YN.createChangeEventDetails)(reason));
        }
        floatingTreeRoot.events.on('menuopenchange', onParentClose);
        return ()=>{
            floatingTreeRoot.events.off('menuopenchange', onParentClose);
        };
    }, [
        floatingTreeRoot.events,
        store
    ]);
    const closeTimeout = (0, $5o6JF.useTimeout)();
    // Clear pending close timeout when the menu closes.
    $8NFma.useEffect(()=>{
        if (!open) closeTimeout.clear();
    }, [
        open,
        closeTimeout
    ]);
    // Close unrelated child submenus when hovering a different item in the parent menu.
    $8NFma.useEffect(()=>{
        function onItemHover(event) {
            // If an item within our parent menu is hovered, and this menu's trigger is not that item,
            // close this submenu. This ensures hovering a different item in the parent closes other branches.
            if (!open || event.nodeId !== store.select('floatingParentNodeId')) return;
            if (event.target && triggerElement && triggerElement !== event.target) {
                const delay = store.select('closeDelay');
                if (delay > 0) {
                    if (!closeTimeout.isStarted()) closeTimeout.start(delay, ()=>{
                        store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).siblingOpen));
                    });
                } else store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).siblingOpen));
            } else // User re-hovered the submenu trigger, cancel pending close.
            closeTimeout.clear();
        }
        floatingTreeRoot.events.on('itemhover', onItemHover);
        return ()=>{
            floatingTreeRoot.events.off('itemhover', onItemHover);
        };
    }, [
        floatingTreeRoot.events,
        open,
        triggerElement,
        store,
        closeTimeout
    ]);
    $8NFma.useEffect(()=>{
        const eventDetails = {
            open: open,
            nodeId: floatingNodeId,
            parentNodeId: floatingParentNodeId,
            reason: store.select('lastOpenChangeReason')
        };
        floatingTreeRoot.events.emit('menuopenchange', eventDetails);
    }, [
        floatingTreeRoot.events,
        open,
        store,
        floatingNodeId,
        floatingParentNodeId
    ]);
    // Keep positioner transition behavior aligned with Popover when switching detached triggers.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        const currentTrigger = domReference;
        const previousTrigger = previousTriggerRef.current;
        if (currentTrigger) previousTriggerRef.current = currentTrigger;
        if (previousTrigger && currentTrigger && currentTrigger !== previousTrigger) {
            store.set('instantType', undefined);
            const abortController = new AbortController();
            runOnceAnimationsFinish(()=>{
                store.set('instantType', 'trigger-change');
            }, abortController.signal);
            return ()=>{
                abortController.abort();
            };
        }
        return undefined;
    }, [
        domReference,
        runOnceAnimationsFinish,
        store
    ]);
    const state = {
        open: open,
        side: positioner.side,
        align: positioner.align,
        anchorHidden: positioner.anchorHidden,
        nested: parent.type === 'menu',
        instant: instantType
    };
    const menubarModal = parent.type === 'menubar' && parent.context.modal;
    const popupModal = modal && lastOpenChangeReason !== (0, $66jhv).triggerHover;
    (0, $424ib.useAnchoredPopupScrollLock)(open && (menubarModal || popupModal), openMethod === 'touch', positionerElement, triggerElement);
    const element = (0, $ag8av.usePositioner)(componentProps, state, {
        styles: positioner.positionerStyles,
        transitionStatus: transitionStatus,
        props: elementProps,
        refs: [
            forwardedRef,
            store.useStateSetter('positionerElement')
        ],
        hidden: !mounted,
        inert: !open
    });
    const shouldRenderBackdrop = mounted && parent.type !== 'menu' && (parent.type !== 'menubar' && modal && lastOpenChangeReason !== (0, $66jhv).triggerHover || parent.type === 'menubar' && parent.context.modal);
    // cuts a hole in the backdrop to allow pointer interaction with the menubar or dropdown menu trigger element
    let backdropCutout = null;
    if (parent.type === 'menubar') backdropCutout = parent.context.contentElement;
    else if (parent.type === undefined) backdropCutout = triggerElement;
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8foVs.MenuPositionerContext).Provider, {
        value: positioner,
        children: [
            shouldRenderBackdrop && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dGxil.InternalBackdrop), {
                ref: parent.type === 'context-menu' || parent.type === 'nested-context-menu' ? parent.context.internalBackdropRef : null,
                inert: (0, $lwkkr.inertValue)(!open),
                cutout: backdropCutout
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8Xtx1.FloatingNode), {
                id: floatingNodeId,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2I5FP.CompositeList), {
                    elementsRef: store.context.itemDomElements,
                    labelsRef: store.context.itemLabels,
                    children: element
                })
            })
        ]
    });
});

});
parcelRegister("lwkkr", function(module, exports) {

$parcel$export(module.exports, "inertValue", () => $9377872b72949761$export$a9d04c5684123369);

var $4srfS = parcelRequire("4srfS");
function $9377872b72949761$export$a9d04c5684123369(value) {
    if ((0, $4srfS.isReactVersionAtLeast)(19)) return value;
    // compatibility with React < 19
    return value ? 'true' : undefined;
}

});

parcelRegister("5GLN0", function(module, exports) {

$parcel$export(module.exports, "useAnchorPositioning", () => $b4c8307ddf27ffa3$export$2df0a020850c37b);

var $8NFma = parcelRequire("8NFma");

var $Euxde = parcelRequire("Euxde");

var $8shn9 = parcelRequire("8shn9");
var $1D9S2 = parcelRequire("1D9S2");

var $9N3e2 = parcelRequire("9N3e2");

var $eiwl7 = parcelRequire("eiwl7");

var $fKU9M = parcelRequire("fKU9M");

var $8i2T6 = parcelRequire("8i2T6");
var $eqxtD = parcelRequire("eqxtD");
var $eMGxX = parcelRequire("eMGxX");

var $jSzfV = parcelRequire("jSzfV");

var $imZZx = parcelRequire("imZZx");

var $2IVmA = parcelRequire("2IVmA");

var $gLdy7 = parcelRequire("gLdy7");
'use client';
function $b4c8307ddf27ffa3$var$getLogicalSide(sideParam, renderedSide, isRtl) {
    const isLogicalSideParam = sideParam === 'inline-start' || sideParam === 'inline-end';
    const logicalRight = isRtl ? 'inline-start' : 'inline-end';
    const logicalLeft = isRtl ? 'inline-end' : 'inline-start';
    return ({
        top: 'top',
        right: isLogicalSideParam ? logicalRight : 'right',
        bottom: 'bottom',
        left: isLogicalSideParam ? logicalLeft : 'left'
    })[renderedSide];
}
function $b4c8307ddf27ffa3$var$getOffsetData(state, sideParam, isRtl) {
    const { rects: rects, placement: placement } = state;
    const data = {
        side: $b4c8307ddf27ffa3$var$getLogicalSide(sideParam, (0, $Euxde.getSide)(placement), isRtl),
        align: (0, $Euxde.getAlignment)(placement) || 'center',
        anchor: {
            width: rects.reference.width,
            height: rects.reference.height
        },
        positioner: {
            width: rects.floating.width,
            height: rects.floating.height
        }
    };
    return data;
}
function $b4c8307ddf27ffa3$export$2df0a020850c37b(params) {
    const { anchor: // Public parameters
    anchor, positionMethod: positionMethod = 'absolute', side: sideParam = 'bottom', sideOffset: sideOffset = 0, align: align = 'center', alignOffset: alignOffset = 0, collisionBoundary: collisionBoundary, collisionPadding: collisionPaddingParam = 5, sticky: sticky = false, arrowPadding: arrowPadding = 5, disableAnchorTracking: disableAnchorTracking = false, inline: inlineMiddleware, keepMounted: // Private parameters
    keepMounted = false, floatingRootContext: floatingRootContext, mounted: mounted, collisionAvoidance: collisionAvoidance, shiftCrossAxis: shiftCrossAxis = false, nodeId: nodeId, adaptiveOrigin: adaptiveOrigin, lazyFlip: lazyFlip = false, externalTree: externalTree } = params;
    const [mountSide, setMountSide] = $8NFma.useState(null);
    if (!mounted && mountSide !== null) setMountSide(null);
    const collisionAvoidanceSide = collisionAvoidance.side || 'flip';
    const collisionAvoidanceAlign = collisionAvoidance.align || 'flip';
    const collisionAvoidanceFallbackAxisSide = collisionAvoidance.fallbackAxisSide || 'end';
    const anchorFn = typeof anchor === 'function' ? anchor : undefined;
    const anchorFnCallback = (0, $fKU9M.useStableCallback)(anchorFn);
    const anchorDep = anchorFn ? anchorFnCallback : anchor;
    const anchorValueRef = (0, $eiwl7.useValueAsRef)(anchor);
    const mountedRef = (0, $eiwl7.useValueAsRef)(mounted);
    const direction = (0, $jSzfV.useDirection)();
    const isRtl = direction === 'rtl';
    const side = mountSide || ({
        top: 'top',
        right: 'right',
        bottom: 'bottom',
        left: 'left',
        'inline-end': isRtl ? 'left' : 'right',
        'inline-start': isRtl ? 'right' : 'left'
    })[sideParam];
    const placement = align === 'center' ? side : `${side}-${align}`;
    let collisionPadding = collisionPaddingParam;
    // Create a bias to the preferred side.
    // On iOS, when the mobile software keyboard opens, the input is exactly centered
    // in the viewport, but this can cause it to flip to the top undesirably.
    const bias = 1;
    const biasTop = sideParam === 'bottom' ? bias : 0;
    const biasBottom = sideParam === 'top' ? bias : 0;
    const biasLeft = sideParam === 'right' ? bias : 0;
    const biasRight = sideParam === 'left' ? bias : 0;
    if (typeof collisionPadding === 'number') collisionPadding = {
        top: collisionPadding + biasTop,
        right: collisionPadding + biasRight,
        bottom: collisionPadding + biasBottom,
        left: collisionPadding + biasLeft
    };
    else if (collisionPadding) collisionPadding = {
        top: (collisionPadding.top || 0) + biasTop,
        right: (collisionPadding.right || 0) + biasRight,
        bottom: (collisionPadding.bottom || 0) + biasBottom,
        left: (collisionPadding.left || 0) + biasLeft
    };
    const commonCollisionProps = {
        boundary: collisionBoundary === 'clipping-ancestors' ? 'clippingAncestors' : collisionBoundary,
        padding: collisionPadding
    };
    // Using a ref assumes that the arrow element is always present in the DOM for the lifetime of the
    // popup. If this assumption ends up being false, we can switch to state to manage the arrow's
    // presence.
    const arrowRef = $8NFma.useRef(null);
    // Keep these reactive if they're not functions
    const sideOffsetRef = (0, $eiwl7.useValueAsRef)(sideOffset);
    const alignOffsetRef = (0, $eiwl7.useValueAsRef)(alignOffset);
    const sideOffsetDep = typeof sideOffset !== 'function' ? sideOffset : 0;
    const alignOffsetDep = typeof alignOffset !== 'function' ? alignOffset : 0;
    const middleware = [];
    if (inlineMiddleware) middleware.push(inlineMiddleware);
    middleware.push((0, $eqxtD.offset)((state)=>{
        const data = $b4c8307ddf27ffa3$var$getOffsetData(state, sideParam, isRtl);
        const sideAxis = typeof sideOffsetRef.current === 'function' ? sideOffsetRef.current(data) : sideOffsetRef.current;
        const alignAxis = typeof alignOffsetRef.current === 'function' ? alignOffsetRef.current(data) : alignOffsetRef.current;
        return {
            mainAxis: sideAxis,
            crossAxis: alignAxis,
            alignmentAxis: alignAxis
        };
    }, [
        sideOffsetDep,
        alignOffsetDep,
        isRtl,
        sideParam
    ]));
    const shiftDisabled = collisionAvoidanceAlign === 'none' && collisionAvoidanceSide !== 'shift';
    const crossAxisShiftEnabled = !shiftDisabled && (sticky || shiftCrossAxis || collisionAvoidanceSide === 'shift');
    const flipMiddleware = collisionAvoidanceSide === 'none' ? null : (0, $eqxtD.flip)({
        ...commonCollisionProps,
        // Ensure the popup flips if it's been limited by its --available-height and it resizes.
        // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
        padding: {
            top: collisionPadding.top + bias,
            right: collisionPadding.right + bias,
            bottom: collisionPadding.bottom + bias,
            left: collisionPadding.left + bias
        },
        mainAxis: !shiftCrossAxis && collisionAvoidanceSide === 'flip',
        crossAxis: collisionAvoidanceAlign === 'flip' ? 'alignment' : false,
        fallbackAxisSideDirection: collisionAvoidanceFallbackAxisSide
    });
    const shiftMiddleware = shiftDisabled ? null : (0, $eqxtD.shift)((data)=>{
        const html = (0, $8shn9.ownerDocument)(data.elements.floating).documentElement;
        return {
            ...commonCollisionProps,
            // Use the Layout Viewport to avoid shifting around when pinch-zooming
            // for context menus.
            rootBoundary: shiftCrossAxis ? {
                x: 0,
                y: 0,
                width: html.clientWidth,
                height: html.clientHeight
            } : undefined,
            mainAxis: collisionAvoidanceAlign !== 'none',
            crossAxis: crossAxisShiftEnabled,
            limiter: sticky || shiftCrossAxis ? undefined : (0, $eqxtD.limitShift)((limitData)=>{
                if (!arrowRef.current) return {};
                const { width: width, height: height } = arrowRef.current.getBoundingClientRect();
                const sideAxis = (0, $Euxde.getSideAxis)((0, $Euxde.getSide)(limitData.placement));
                const arrowSize = sideAxis === 'y' ? width : height;
                const offsetAmount = sideAxis === 'y' ? collisionPadding.left + collisionPadding.right : collisionPadding.top + collisionPadding.bottom;
                return {
                    offset: arrowSize / 2 + offsetAmount / 2
                };
            })
        };
    }, [
        commonCollisionProps,
        sticky,
        shiftCrossAxis,
        collisionPadding,
        collisionAvoidanceAlign
    ]);
    // https://floating-ui.com/docs/flip#combining-with-shift
    if (collisionAvoidanceSide === 'shift' || collisionAvoidanceAlign === 'shift' || align === 'center') middleware.push(shiftMiddleware, flipMiddleware);
    else middleware.push(flipMiddleware, shiftMiddleware);
    middleware.push((0, $eqxtD.size)({
        ...commonCollisionProps,
        apply ({ elements: { floating: floating }, availableWidth: availableWidth, availableHeight: availableHeight, rects: rects }) {
            if (!mountedRef.current) return;
            const floatingStyle = floating.style;
            floatingStyle.setProperty('--available-width', `${availableWidth}px`);
            floatingStyle.setProperty('--available-height', `${availableHeight}px`);
            // Snap anchor dimensions to device pixels to ensure the popup's visual width matches the anchor's one.
            const dpr = (0, $1D9S2.getWindow)(floating).devicePixelRatio || 1;
            const { x: x, y: y, width: width, height: height } = rects.reference;
            const anchorWidth = (Math.round((x + width) * dpr) - Math.round(x * dpr)) / dpr;
            const anchorHeight = (Math.round((y + height) * dpr) - Math.round(y * dpr)) / dpr;
            floatingStyle.setProperty('--anchor-width', `${anchorWidth}px`);
            floatingStyle.setProperty('--anchor-height', `${anchorHeight}px`);
        }
    }), (0, $imZZx.arrow)((state)=>({
            // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
            // we'll create a fake element.
            element: arrowRef.current || (0, $8shn9.ownerDocument)(state.elements.floating).createElement('div'),
            padding: arrowPadding,
            offsetParent: 'floating'
        }), [
        arrowPadding
    ]), {
        name: 'transformOrigin',
        fn (state) {
            const { elements: elements, middlewareData: middlewareData, placement: renderedPlacement, rects: rects, y: y } = state;
            const currentRenderedSide = (0, $Euxde.getSide)(renderedPlacement);
            const currentRenderedAxis = (0, $Euxde.getSideAxis)(currentRenderedSide);
            const arrowEl = arrowRef.current;
            const arrowX = middlewareData.arrow?.x || 0;
            const arrowY = middlewareData.arrow?.y || 0;
            const arrowWidth = arrowEl?.clientWidth || 0;
            const arrowHeight = arrowEl?.clientHeight || 0;
            const transformX = arrowX + arrowWidth / 2;
            const transformY = arrowY + arrowHeight / 2;
            const shiftY = Math.abs(middlewareData.shift?.y || 0);
            const halfAnchorHeight = rects.reference.height / 2;
            const sideOffsetValue = typeof sideOffset === 'function' ? sideOffset($b4c8307ddf27ffa3$var$getOffsetData(state, sideParam, isRtl)) : sideOffset;
            const isOverlappingAnchor = shiftY > sideOffsetValue;
            const adjacentTransformOrigin = {
                top: `${transformX}px calc(100% + ${sideOffsetValue}px)`,
                bottom: `${transformX}px ${-sideOffsetValue}px`,
                left: `calc(100% + ${sideOffsetValue}px) ${transformY}px`,
                right: `${-sideOffsetValue}px ${transformY}px`
            }[currentRenderedSide];
            const overlapTransformOrigin = `${transformX}px ${rects.reference.y + halfAnchorHeight - y}px`;
            elements.floating.style.setProperty('--transform-origin', crossAxisShiftEnabled && currentRenderedAxis === 'y' && isOverlappingAnchor ? overlapTransformOrigin : adjacentTransformOrigin);
            return {};
        }
    }, (0, $2IVmA.hide), adaptiveOrigin);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Ensure positioning doesn't run initially for `keepMounted` elements that
        // aren't initially open.
        if (!mounted && floatingRootContext) floatingRootContext.update({
            referenceElement: null,
            floatingElement: null,
            domReferenceElement: null,
            positionReference: null
        });
    }, [
        mounted,
        floatingRootContext
    ]);
    const autoUpdateOptions = $8NFma.useMemo(()=>({
            elementResize: !disableAnchorTracking && typeof ResizeObserver !== 'undefined',
            layoutShift: !disableAnchorTracking && typeof IntersectionObserver !== 'undefined'
        }), [
        disableAnchorTracking
    ]);
    const { refs: refs, elements: elements, x: x, y: y, middlewareData: middlewareData, update: update, placement: renderedPlacement, context: context, isPositioned: isPositioned, floatingStyles: originalFloatingStyles } = (0, $eMGxX.useFloating)({
        rootContext: floatingRootContext,
        open: keepMounted ? mounted : undefined,
        placement: placement,
        middleware: middleware,
        strategy: positionMethod,
        whileElementsMounted: keepMounted ? undefined : (...args)=>(0, $8i2T6.autoUpdate)(...args, autoUpdateOptions),
        nodeId: nodeId,
        externalTree: externalTree
    });
    const { sideX: sideX, sideY: sideY } = middlewareData.adaptiveOrigin || (0, $gLdy7.DEFAULT_SIDES);
    // Default to `fixed` when not positioned to prevent `autoFocus` scroll jumps.
    // This ensures the popup is inside the viewport initially before it gets positioned.
    const resolvedPosition = isPositioned ? positionMethod : 'fixed';
    const floatingStyles = $8NFma.useMemo(()=>{
        const base = adaptiveOrigin ? {
            position: resolvedPosition,
            [sideX]: x,
            [sideY]: y
        } : {
            position: resolvedPosition,
            ...originalFloatingStyles
        };
        if (!isPositioned) base.opacity = 0;
        return base;
    }, [
        adaptiveOrigin,
        resolvedPosition,
        sideX,
        x,
        sideY,
        y,
        originalFloatingStyles,
        isPositioned
    ]);
    const registeredPositionReferenceRef = $8NFma.useRef(null);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!mounted) return;
        const anchorValue = anchorValueRef.current;
        const resolvedAnchor = typeof anchorValue === 'function' ? anchorValue() : anchorValue;
        const unwrappedElement = ($b4c8307ddf27ffa3$var$isRef(resolvedAnchor) ? resolvedAnchor.current : resolvedAnchor) || null;
        const finalAnchor = unwrappedElement || null;
        if (finalAnchor !== registeredPositionReferenceRef.current) {
            refs.setPositionReference(finalAnchor);
            registeredPositionReferenceRef.current = finalAnchor;
        }
    }, [
        mounted,
        refs,
        anchorDep,
        anchorValueRef
    ]);
    $8NFma.useEffect(()=>{
        if (!mounted) return;
        const anchorValue = anchorValueRef.current;
        // Refs from parent components are set after useLayoutEffect runs and are available in useEffect.
        // Therefore, if the anchor is a ref, we need to update the position reference in useEffect.
        if (typeof anchorValue === 'function') return;
        if ($b4c8307ddf27ffa3$var$isRef(anchorValue) && anchorValue.current !== registeredPositionReferenceRef.current) {
            refs.setPositionReference(anchorValue.current);
            registeredPositionReferenceRef.current = anchorValue.current;
        }
    }, [
        mounted,
        refs,
        anchorDep,
        anchorValueRef
    ]);
    $8NFma.useEffect(()=>{
        if (keepMounted && mounted && elements.reference && elements.floating) return (0, $8i2T6.autoUpdate)(elements.reference, elements.floating, update, autoUpdateOptions);
        return undefined;
    }, [
        keepMounted,
        mounted,
        elements,
        update,
        autoUpdateOptions
    ]);
    const renderedSide = (0, $Euxde.getSide)(renderedPlacement);
    const logicalRenderedSide = $b4c8307ddf27ffa3$var$getLogicalSide(sideParam, renderedSide, isRtl);
    const renderedAlign = (0, $Euxde.getAlignment)(renderedPlacement) || 'center';
    const anchorHidden = Boolean(middlewareData.hide?.referenceHidden);
    // Locks the flip (makes it "sticky") so it doesn't prefer a given placement
    // and flips back lazily, not eagerly. Ideal for filtered lists that change
    // the size of the popup dynamically to avoid unwanted flipping when typing.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (lazyFlip && mounted && isPositioned) setMountSide(renderedSide);
    }, [
        lazyFlip,
        mounted,
        isPositioned,
        renderedSide
    ]);
    const arrowStyles = $8NFma.useMemo(()=>({
            position: 'absolute',
            top: middlewareData.arrow?.y,
            left: middlewareData.arrow?.x
        }), [
        middlewareData.arrow
    ]);
    const arrowUncentered = middlewareData.arrow?.centerOffset !== 0;
    return $8NFma.useMemo(()=>({
            positionerStyles: floatingStyles,
            arrowStyles: arrowStyles,
            arrowRef: arrowRef,
            arrowUncentered: arrowUncentered,
            side: logicalRenderedSide,
            align: renderedAlign,
            physicalSide: renderedSide,
            anchorHidden: anchorHidden,
            refs: refs,
            context: context,
            isPositioned: isPositioned,
            update: update
        }), [
        floatingStyles,
        arrowStyles,
        arrowRef,
        arrowUncentered,
        logicalRenderedSide,
        renderedAlign,
        renderedSide,
        anchorHidden,
        refs,
        context,
        isPositioned,
        update
    ]);
}
function $b4c8307ddf27ffa3$var$isRef(param) {
    return param != null && 'current' in param;
}

});
parcelRegister("8i2T6", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $60923e9f3f841413$export$deee3a793edee05f);
$parcel$export(module.exports, "offset", () => $60923e9f3f841413$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $60923e9f3f841413$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $60923e9f3f841413$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $60923e9f3f841413$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $60923e9f3f841413$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $60923e9f3f841413$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $60923e9f3f841413$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $60923e9f3f841413$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $60923e9f3f841413$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $60923e9f3f841413$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("1D9S2")).getOverflowAncestors);

var $E7rjD = parcelRequire("E7rjD");
var $Euxde = parcelRequire("Euxde");

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");
function $60923e9f3f841413$var$getCssDimensions(element) {
    const css = (0, $1D9S2.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1D9S2.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $Euxde.round)(width) !== offsetWidth || (0, $Euxde.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $60923e9f3f841413$var$unwrapElement(element) {
    return !(0, $1D9S2.isElement)(element) ? element.contextElement : element;
}
function $60923e9f3f841413$var$getScale(element) {
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    if (!(0, $1D9S2.isHTMLElement)(domElement)) return (0, $Euxde.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $60923e9f3f841413$var$getCssDimensions(domElement);
    let x = ($ ? (0, $Euxde.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $Euxde.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $60923e9f3f841413$var$noOffsets = /*#__PURE__*/ (0, $Euxde.createCoords)(0);
function $60923e9f3f841413$var$getVisualOffsets(element) {
    const win = (0, $1D9S2.getWindow)(element);
    if (!(0, $1D9S2.isWebKit)() || !win.visualViewport) return $60923e9f3f841413$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $60923e9f3f841413$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1D9S2.getWindow)(element)) return false;
    return isFixed;
}
function $60923e9f3f841413$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    let scale = (0, $Euxde.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1D9S2.isElement)(offsetParent)) scale = $60923e9f3f841413$var$getScale(offsetParent);
        } else scale = $60923e9f3f841413$var$getScale(element);
    }
    const visualOffsets = $60923e9f3f841413$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $60923e9f3f841413$var$getVisualOffsets(domElement) : (0, $Euxde.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1D9S2.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1D9S2.isElement)(offsetParent) ? (0, $1D9S2.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $60923e9f3f841413$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1D9S2.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1D9S2.getWindow)(currentIFrame);
            currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        }
    }
    return (0, $Euxde.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $60923e9f3f841413$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1D9S2.getNodeScroll)(element).scrollLeft;
    if (!rect) return $60923e9f3f841413$var$getBoundingClientRect((0, $1D9S2.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $60923e9f3f841413$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $1D9S2.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $Euxde.createCoords)(1);
    const offsets = (0, $Euxde.createCoords)(0);
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent);
            scale = $60923e9f3f841413$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) : (0, $Euxde.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $60923e9f3f841413$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $60923e9f3f841413$var$getDocumentRect(element) {
    const html = (0, $1D9S2.getDocumentElement)(element);
    const scroll = (0, $1D9S2.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $Euxde.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $Euxde.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $60923e9f3f841413$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1D9S2.getComputedStyle)(body).direction === 'rtl') x += (0, $Euxde.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $60923e9f3f841413$var$SCROLLBAR_MAX = 25;
function $60923e9f3f841413$var$getViewportRect(element, strategy) {
    const win = (0, $1D9S2.getWindow)(element);
    const html = (0, $1D9S2.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1D9S2.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $60923e9f3f841413$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $60923e9f3f841413$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $60923e9f3f841413$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $60923e9f3f841413$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $60923e9f3f841413$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1D9S2.isHTMLElement)(element) ? $60923e9f3f841413$var$getScale(element) : (0, $Euxde.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $60923e9f3f841413$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $60923e9f3f841413$var$getDocumentRect((0, $1D9S2.getDocumentElement)(element));
    else if ((0, $1D9S2.isElement)(clippingAncestor)) rect = $60923e9f3f841413$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $60923e9f3f841413$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $Euxde.rectToClientRect)(rect);
}
function $60923e9f3f841413$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1D9S2.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1D9S2.isElement)(parentNode) || (0, $1D9S2.isLastTraversableNode)(parentNode)) return false;
    return (0, $1D9S2.getComputedStyle)(parentNode).position === 'fixed' || $60923e9f3f841413$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $60923e9f3f841413$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1D9S2.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1D9S2.isElement)(el) && (0, $1D9S2.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1D9S2.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1D9S2.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1D9S2.isElement)(currentNode) && !(0, $1D9S2.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1D9S2.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1D9S2.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $1D9S2.isOverflowElement)(currentNode) && !currentNodeIsContaining && $60923e9f3f841413$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1D9S2.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $60923e9f3f841413$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1D9S2.isTopLayer)(element) ? [] : $60923e9f3f841413$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $Euxde.max)(rect.top, top);
        right = (0, $Euxde.min)(rect.right, right);
        bottom = (0, $Euxde.min)(rect.bottom, bottom);
        left = (0, $Euxde.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $60923e9f3f841413$var$getDimensions(element) {
    const { width: width, height: height } = $60923e9f3f841413$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $60923e9f3f841413$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $60923e9f3f841413$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $Euxde.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $60923e9f3f841413$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) : (0, $Euxde.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $60923e9f3f841413$var$isStaticPositioned(element) {
    return (0, $1D9S2.getComputedStyle)(element).position === 'static';
}
function $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1D9S2.isHTMLElement)(element) || (0, $1D9S2.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1D9S2.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $60923e9f3f841413$var$getOffsetParent(element, polyfill) {
    const win = (0, $1D9S2.getWindow)(element);
    if ((0, $1D9S2.isTopLayer)(element)) return win;
    if (!(0, $1D9S2.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $1D9S2.getParentNode)(element);
        while(svgOffsetParent && !(0, $1D9S2.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $1D9S2.isElement)(svgOffsetParent) && !$60923e9f3f841413$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1D9S2.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1D9S2.isTableElement)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent))offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1D9S2.isLastTraversableNode)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent) && !(0, $1D9S2.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $1D9S2.getContainingBlock)(element) || win;
}
const $60923e9f3f841413$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $60923e9f3f841413$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $60923e9f3f841413$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $60923e9f3f841413$var$isRTL(element) {
    return (0, $1D9S2.getComputedStyle)(element).direction === 'rtl';
}
const $60923e9f3f841413$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1D9S2.getDocumentElement,
    getClippingRect: $60923e9f3f841413$var$getClippingRect,
    getOffsetParent: $60923e9f3f841413$var$getOffsetParent,
    getElementRects: $60923e9f3f841413$var$getElementRects,
    getClientRects: $60923e9f3f841413$var$getClientRects,
    getDimensions: $60923e9f3f841413$var$getDimensions,
    getScale: $60923e9f3f841413$var$getScale,
    isElement: $1D9S2.isElement,
    isRTL: $60923e9f3f841413$var$isRTL
};
function $60923e9f3f841413$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $60923e9f3f841413$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1D9S2.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $Euxde.floor)(top);
        const insetRight = (0, $Euxde.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $Euxde.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $Euxde.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $Euxde.max)(0, (0, $Euxde.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$60923e9f3f841413$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $60923e9f3f841413$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $60923e9f3f841413$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1D9S2.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $1D9S2.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $60923e9f3f841413$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $60923e9f3f841413$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $60923e9f3f841413$var$getBoundingClientRect(reference);
        if (prevRefRect && !$60923e9f3f841413$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $60923e9f3f841413$export$37b6bde19b108ecc = (0, $E7rjD.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $60923e9f3f841413$export$cc800923e997bb8 = (0, $E7rjD.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $60923e9f3f841413$export$91fb6ecbd551914 = (0, $E7rjD.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $60923e9f3f841413$export$fba63a578e423eb = (0, $E7rjD.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $60923e9f3f841413$export$8a83211c878a3f1f = (0, $E7rjD.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $60923e9f3f841413$export$346677f925de839c = (0, $E7rjD.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $60923e9f3f841413$export$fe8985bb6374093c = (0, $E7rjD.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $60923e9f3f841413$export$f2120bbfa5450bd2 = (0, $E7rjD.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $60923e9f3f841413$export$18c8ad048e32c7d5 = (0, $E7rjD.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $60923e9f3f841413$export$7bf07e38f3dc4b69 = (0, $E7rjD.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $60923e9f3f841413$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $60923e9f3f841413$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $E7rjD.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("E7rjD", function(module, exports) {

$parcel$export(module.exports, "detectOverflow", () => $078981e2e5df035a$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $078981e2e5df035a$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $078981e2e5df035a$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $078981e2e5df035a$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $078981e2e5df035a$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $078981e2e5df035a$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $078981e2e5df035a$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $078981e2e5df035a$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $078981e2e5df035a$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $078981e2e5df035a$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $078981e2e5df035a$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("Euxde")).rectToClientRect);

var $Euxde = parcelRequire("Euxde");
function $078981e2e5df035a$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $Euxde.getSideAxis)(placement);
    const alignmentAxis = (0, $Euxde.getAlignmentAxis)(placement);
    const alignLength = (0, $Euxde.getAxisLength)(alignmentAxis);
    const side = (0, $Euxde.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $Euxde.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $078981e2e5df035a$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state);
    const paddingObject = (0, $Euxde.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $Euxde.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $Euxde.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $078981e2e5df035a$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $078981e2e5df035a$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $078981e2e5df035a$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $078981e2e5df035a$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $078981e2e5df035a$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $Euxde.getAlignmentAxis)(placement);
            const length = (0, $Euxde.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $Euxde.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $Euxde.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $Euxde.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $Euxde.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $078981e2e5df035a$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $Euxde.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $Euxde.getAlignment)(placement) === alignment || (autoAlignment ? (0, $Euxde.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $078981e2e5df035a$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $Euxde.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $Euxde.placements) ? $078981e2e5df035a$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $Euxde.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $Euxde.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $Euxde.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $Euxde.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $078981e2e5df035a$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $Euxde.getSide)(placement);
            const initialSideAxis = (0, $Euxde.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $Euxde.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $Euxde.getOppositePlacement)(initialPlacement)
            ] : (0, $Euxde.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $Euxde.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $Euxde.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $Euxde.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $Euxde.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $Euxde.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $078981e2e5df035a$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $078981e2e5df035a$var$isAnySideFullyClipped(overflow) {
    return (0, $Euxde.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $078981e2e5df035a$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $078981e2e5df035a$var$getBoundingRect(rects) {
    const minX = (0, $Euxde.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $Euxde.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $Euxde.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $Euxde.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $078981e2e5df035a$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $078981e2e5df035a$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $Euxde.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $078981e2e5df035a$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $Euxde.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $Euxde.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $Euxde.getSide)(placement) === 'left';
                    const maxRight = (0, $Euxde.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $Euxde.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $078981e2e5df035a$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $078981e2e5df035a$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $Euxde.getSide)(placement);
    const alignment = (0, $Euxde.getAlignment)(placement);
    const isVertical = (0, $Euxde.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $078981e2e5df035a$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $Euxde.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $078981e2e5df035a$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $078981e2e5df035a$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $078981e2e5df035a$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $Euxde.getSideAxis)((0, $Euxde.getSide)(placement));
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $Euxde.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $Euxde.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $078981e2e5df035a$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $Euxde.getSideAxis)(placement);
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $Euxde.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $078981e2e5df035a$var$originSides.has((0, $Euxde.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $078981e2e5df035a$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $Euxde.getSide)(placement);
            const alignment = (0, $Euxde.getAlignment)(placement);
            const isYAxis = (0, $Euxde.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $Euxde.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $Euxde.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $Euxde.max)(overflow.left, 0);
                const xMax = (0, $Euxde.max)(overflow.right, 0);
                const yMin = (0, $Euxde.max)(overflow.top, 0);
                const yMax = (0, $Euxde.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $Euxde.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $Euxde.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});


parcelRegister("eqxtD", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $a80d76388d068913$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $a80d76388d068913$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $a80d76388d068913$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $a80d76388d068913$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "flip", () => $a80d76388d068913$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $a80d76388d068913$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $a80d76388d068913$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $a80d76388d068913$export$f2120bbfa5450bd2);

var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
var $a80d76388d068913$var$isClient = typeof document !== 'undefined';
var $a80d76388d068913$var$noop = function noop() {};
var $a80d76388d068913$var$index = $a80d76388d068913$var$isClient ? (0, $8NFma.useLayoutEffect) : $a80d76388d068913$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $a80d76388d068913$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$a80d76388d068913$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$a80d76388d068913$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $a80d76388d068913$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $a80d76388d068913$var$roundByDPR(element, value) {
    const dpr = $a80d76388d068913$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $a80d76388d068913$var$useLatestRef(value) {
    const ref = $8NFma.useRef(value);
    $a80d76388d068913$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a80d76388d068913$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8NFma.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8NFma.useState(middleware);
    if (!$a80d76388d068913$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8NFma.useState(null);
    const [_floating, _setFloating] = $8NFma.useState(null);
    const setReference = $8NFma.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8NFma.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8NFma.useRef(null);
    const floatingRef = $8NFma.useRef(null);
    const dataRef = $8NFma.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $a80d76388d068913$var$useLatestRef(whileElementsMounted);
    const platformRef = $a80d76388d068913$var$useLatestRef(platform);
    const openRef = $a80d76388d068913$var$useLatestRef(open);
    const update = $8NFma.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $8i2T6.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$a80d76388d068913$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $2pmb0.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $a80d76388d068913$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8NFma.useRef(false);
    $a80d76388d068913$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $a80d76388d068913$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8NFma.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8NFma.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8NFma.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $a80d76388d068913$var$roundByDPR(elements.floating, data.x);
        const y = $a80d76388d068913$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$a80d76388d068913$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8NFma.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $8i2T6.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $8i2T6.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $a80d76388d068913$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $8i2T6.offset)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $a80d76388d068913$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $8i2T6.shift)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $a80d76388d068913$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $8i2T6.limitShift)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $a80d76388d068913$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $8i2T6.flip)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $a80d76388d068913$export$346677f925de839c = (options, deps)=>{
    const result = (0, $8i2T6.size)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $a80d76388d068913$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $8i2T6.autoPlacement)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $a80d76388d068913$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $8i2T6.hide)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $a80d76388d068913$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $8i2T6.inline)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $a80d76388d068913$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};

});

parcelRegister("eMGxX", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $fe637abf7f1aa92b$export$4e02a5c1d08bac65);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $eqxtD = parcelRequire("eqxtD");

var $1D9S2 = parcelRequire("1D9S2");

var $8Xtx1 = parcelRequire("8Xtx1");

var $fno7H = parcelRequire("fno7H");
'use client';
function $fe637abf7f1aa92b$export$4e02a5c1d08bac65(options = {}) {
    const { nodeId: nodeId, externalTree: externalTree } = options;
    const internalStore = (0, $fno7H.useFloatingRootContext)(options);
    const store = options.rootContext || internalStore;
    const referenceElement = store.useState('referenceElement');
    const floatingElement = store.useState('floatingElement');
    const domReferenceElement = store.useState('domReferenceElement');
    const open = store.useState('open');
    const floatingId = store.useState('floatingId');
    const [positionReference, setPositionReferenceRaw] = $8NFma.useState(null);
    const [localDomReference, setLocalDomReference] = $8NFma.useState(undefined);
    const [localFloatingElement, setLocalFloatingElement] = $8NFma.useState(undefined);
    const domReferenceRef = $8NFma.useRef(null);
    const tree = (0, $8Xtx1.useFloatingTree)(externalTree);
    const storeElements = $8NFma.useMemo(()=>({
            reference: referenceElement,
            floating: floatingElement,
            domReference: domReferenceElement
        }), [
        referenceElement,
        floatingElement,
        domReferenceElement
    ]);
    const position = (0, $eqxtD.useFloating)({
        ...options,
        elements: {
            ...storeElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const localDomReferenceElement = (0, $1D9S2.isElement)(localDomReference) ? localDomReference : null;
    const syncedFloatingElement = localFloatingElement === undefined ? store.state.floatingElement : localFloatingElement;
    store.useSyncedValue('referenceElement', localDomReference ?? null);
    store.useSyncedValue('domReferenceElement', localDomReference === undefined ? domReferenceElement : localDomReferenceElement);
    store.useSyncedValue('floatingElement', syncedFloatingElement);
    const setPositionReference = $8NFma.useCallback((node)=>{
        const computedPositionReference = (0, $1D9S2.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        setPositionReferenceRaw(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $8NFma.useCallback((node)=>{
        if ((0, $1D9S2.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setLocalDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $1D9S2.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $1D9S2.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs,
        setLocalDomReference
    ]);
    const setFloating = $8NFma.useCallback((node)=>{
        setLocalFloatingElement(node);
        position.refs.setFloating(node);
    }, [
        position.refs
    ]);
    const refs = $8NFma.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setFloating: setFloating,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setFloating,
        setPositionReference
    ]);
    const elements = $8NFma.useMemo(()=>({
            ...position.elements,
            domReference: domReferenceElement
        }), [
        position.elements,
        domReferenceElement
    ]);
    const context = $8NFma.useMemo(()=>({
            ...position,
            dataRef: store.context.dataRef,
            open: open,
            onOpenChange: store.setOpen,
            events: store.context.events,
            floatingId: floatingId,
            refs: refs,
            elements: elements,
            nodeId: nodeId,
            rootStore: store
        }), [
        position,
        refs,
        elements,
        nodeId,
        store,
        open,
        floatingId
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (domReferenceElement) domReferenceRef.current = domReferenceElement;
    }, [
        domReferenceElement
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        store.context.dataRef.current.floatingContext = context;
        const node = tree?.nodesRef.current.find((n)=>n.id === nodeId);
        if (node) node.context = context;
    });
    return $8NFma.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements,
            rootStore: store
        }), [
        position,
        refs,
        elements,
        context,
        store
    ]);
}

});
parcelRegister("fno7H", function(module, exports) {

$parcel$export(module.exports, "useFloatingRootContext", () => $a85cef586f15c3f6$export$1df81146f8ad8e4c);

var $1D9S2 = parcelRequire("1D9S2");

var $8VAvD = parcelRequire("8VAvD");

var $9N3e2 = parcelRequire("9N3e2");

var $gidzQ = parcelRequire("gidzQ");

var $8Ruu1 = parcelRequire("8Ruu1");

var $8Xtx1 = parcelRequire("8Xtx1");

var $8akDT = parcelRequire("8akDT");
'use client';
function $a85cef586f15c3f6$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChange, elements: elements = {} } = options;
    const floatingId = (0, $8VAvD.useId)();
    const nested = (0, $8Xtx1.useFloatingParentNodeId)() != null;
    const store = (0, $gidzQ.useRefWithInit)(()=>new (0, $8akDT.FloatingRootStore)({
            open: open,
            transitionStatus: undefined,
            onOpenChange: onOpenChange,
            referenceElement: elements.reference ?? null,
            floatingElement: elements.floating ?? null,
            triggerElements: new (0, $8Ruu1.PopupTriggerMap)(),
            floatingId: floatingId,
            syncOnly: false,
            nested: nested
        })).current;
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        const valuesToSync = {
            open: open,
            floatingId: floatingId
        };
        // Only sync elements that are defined to avoid overwriting existing ones
        if (elements.reference !== undefined) {
            valuesToSync.referenceElement = elements.reference;
            valuesToSync.domReferenceElement = (0, $1D9S2.isElement)(elements.reference) ? elements.reference : null;
        }
        if (elements.floating !== undefined) valuesToSync.floatingElement = elements.floating;
        store.update(valuesToSync);
    }, [
        open,
        floatingId,
        elements.reference,
        elements.floating,
        store
    ]);
    store.context.onOpenChange = onOpenChange;
    store.context.nested = nested;
    return store;
}

});
parcelRegister("8Ruu1", function(module, exports) {

$parcel$export(module.exports, "PopupTriggerMap", () => $78a63286987e2e77$export$9848e19880cb26dc);
/**
 * Data structure to keep track of popup trigger elements by their IDs.
 * Uses both a set of Elements and a map of IDs to Elements for efficient lookups.
 */ class $78a63286987e2e77$export$9848e19880cb26dc {
    constructor(){
        this.elementsSet = new Set();
        this.idMap = new Map();
    }
    /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */ add(id, element) {
        const existingElement = this.idMap.get(id);
        if (existingElement === element) return;
        if (existingElement !== undefined) // We assume that the same element won't be registered under multiple ids.
        // This is safe considering how useTriggerRegistration is implemented.
        this.elementsSet.delete(existingElement);
        this.elementsSet.add(element);
        this.idMap.set(id, element);
    }
    /**
   * Removes the trigger element with the given ID.
   */ delete(id) {
        const element = this.idMap.get(id);
        if (element) {
            this.elementsSet.delete(element);
            this.idMap.delete(id);
        }
    }
    /**
   * Whether the given element is registered as a trigger.
   */ hasElement(element) {
        return this.elementsSet.has(element);
    }
    /**
   * Whether there is a registered trigger element matching the given predicate.
   */ hasMatchingElement(predicate) {
        for (const element of this.elementsSet){
            if (predicate(element)) return true;
        }
        return false;
    }
    /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */ getById(id) {
        return this.idMap.get(id);
    }
    /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */ entries() {
        return this.idMap.entries();
    }
    /**
   * Returns an iterable of all registered trigger elements.
   */ elements() {
        return this.elementsSet.values();
    }
    /**
   * Returns the number of registered trigger elements.
   */ get size() {
        return this.idMap.size;
    }
}

});

parcelRegister("8akDT", function(module, exports) {

$parcel$export(module.exports, "FloatingRootStore", () => $e0167a03d68ed492$export$6689dbe6107f63d8);

var $2r4G3 = parcelRequire("2r4G3");
var $4g8mc = parcelRequire("4g8mc");

var $5FZox = parcelRequire("5FZox");

var $18t8v = parcelRequire("18t8v");
const $e0167a03d68ed492$var$selectors = {
    open: (0, $2r4G3.createSelector)((state)=>state.open),
    transitionStatus: (0, $2r4G3.createSelector)((state)=>state.transitionStatus),
    domReferenceElement: (0, $2r4G3.createSelector)((state)=>state.domReferenceElement),
    referenceElement: (0, $2r4G3.createSelector)((state)=>state.positionReference ?? state.referenceElement),
    floatingElement: (0, $2r4G3.createSelector)((state)=>state.floatingElement),
    floatingId: (0, $2r4G3.createSelector)((state)=>state.floatingId)
};
class $e0167a03d68ed492$export$6689dbe6107f63d8 extends (0, $4g8mc.ReactStore) {
    constructor(options){
        const { syncOnly: syncOnly, nested: nested, onOpenChange: onOpenChange, triggerElements: triggerElements, ...initialState } = options;
        super({
            ...initialState,
            positionReference: initialState.referenceElement,
            domReferenceElement: initialState.referenceElement
        }, {
            onOpenChange: onOpenChange,
            dataRef: {
                current: {}
            },
            events: (0, $5FZox.createEventEmitter)(),
            nested: nested,
            triggerElements: triggerElements
        }, $e0167a03d68ed492$var$selectors);
        this.syncOnly = syncOnly;
    }
    /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */ syncOpenEvent = (newOpen, event)=>{
        if (!newOpen || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
        // click events to upgrade a hover-open.
        event != null && (0, $18t8v.isClickLikeEvent)(event)) this.context.dataRef.current.openEvent = newOpen ? event : undefined;
    };
    /**
   * Runs the root-owned side effects for an open state change.
   */ dispatchOpenChange = (newOpen, eventDetails)=>{
        this.syncOpenEvent(newOpen, eventDetails.event);
        const details = {
            open: newOpen,
            reason: eventDetails.reason,
            nativeEvent: eventDetails.event,
            nested: this.context.nested,
            triggerElement: eventDetails.trigger
        };
        this.context.events.emit('openchange', details);
    };
    /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */ setOpen = (newOpen, eventDetails)=>{
        if (this.syncOnly) {
            this.context.onOpenChange?.(newOpen, eventDetails);
            return;
        }
        this.dispatchOpenChange(newOpen, eventDetails);
        this.context.onOpenChange?.(newOpen, eventDetails);
    };
}

});
parcelRegister("2r4G3", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $7b1460e9316baaea$export$595d22ed68ca2841);

var $cmjqX = parcelRequire("cmjqX");
const $7b1460e9316baaea$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error((0, $cmjqX.default)(1));
    let selector;
    if (a && b && c && d && e && f) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        return f(va, vb, vc, vd, ve, a1, a2, a3);
    };
    else if (a && b && c && d && e) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        return e(va, vb, vc, vd, a1, a2, a3);
    };
    else if (a && b && c && d) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        return d(va, vb, vc, a1, a2, a3);
    };
    else if (a && b && c) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        return c(va, vb, a1, a2, a3);
    };
    else if (a && b) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        return b(va, a1, a2, a3);
    };
    else if (a) selector = a;
    else throw /* minify-error-disabled */ new Error('Missing arguments');
    return selector;
}; /* eslint-enable id-denylist */ 

});

parcelRegister("4g8mc", function(module, exports) {

$parcel$export(module.exports, "ReactStore", () => $f3290b29016564a2$export$4a179aea5dfbb0ec);
/* False positives - ESLint thinks we're calling a hook from a class component. */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $8NFma = parcelRequire("8NFma");

var $8hFBI = parcelRequire("8hFBI");

var $etCPF = parcelRequire("etCPF");

var $fKU9M = parcelRequire("fKU9M");

var $9N3e2 = parcelRequire("9N3e2");

var $jWAMz = parcelRequire("jWAMz");
'use client';
class $f3290b29016564a2$export$4a179aea5dfbb0ec extends (0, $8hFBI.Store) {
    /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */ constructor(state, context = {}, selectors){
        super(state);
        this.context = context;
        this.selectors = selectors;
    }
    /**
   * Non-reactive values such as refs, callbacks, etc.
   */ /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */ useSyncedValue(key, value) {
        $8NFma.useDebugValue(key);
        // eslint-disable-next-line consistent-this
        const store = this;
        (0, $9N3e2.useIsoLayoutEffect)(()=>{
            if (store.state[key] !== value) store.set(key, value);
        }, [
            store,
            key,
            value
        ]);
    }
    /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */ useSyncedValueWithCleanup(key, value) {
        // eslint-disable-next-line consistent-this
        const store = this;
        (0, $9N3e2.useIsoLayoutEffect)(()=>{
            if (store.state[key] !== value) store.set(key, value);
            return ()=>{
                store.set(key, undefined);
            };
        }, [
            store,
            key,
            value
        ]);
    }
    /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */ useSyncedValues(statePart) {
        // eslint-disable-next-line consistent-this
        const store = this;
        var p, key, index;
        const dependencies = Object.values(statePart);
        (0, $9N3e2.useIsoLayoutEffect)(()=>{
            store.update(statePart);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            store,
            ...dependencies
        ]);
    }
    /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */ useControlledProp(key, controlled) {
        $8NFma.useDebugValue(key);
        // eslint-disable-next-line consistent-this
        const store = this;
        const isControlled = controlled !== undefined;
        (0, $9N3e2.useIsoLayoutEffect)(()=>{
            if (isControlled && !Object.is(store.state[key], controlled)) // Set the internal state to match the controlled value.
            store.setState({
                ...store.state,
                [key]: controlled
            });
        }, [
            store,
            key,
            controlled,
            isControlled
        ]);
    }
    /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */ select(key, a1, a2, a3) {
        const selector = this.selectors[key];
        return selector(this.state, a1, a2, a3);
    }
    /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */ useState(key, a1, a2, a3) {
        $8NFma.useDebugValue(key);
        return (0, $etCPF.useStore)(this, this.selectors[key], a1, a2, a3);
    }
    /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */ useContextCallback(key, fn) {
        $8NFma.useDebugValue(key);
        const stableFunction = (0, $fKU9M.useStableCallback)(fn ?? (0, $jWAMz.NOOP));
        this.context[key] = stableFunction;
    }
    /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */ useStateSetter(key) {
        const ref = $8NFma.useRef(undefined);
        if (ref.current === undefined) ref.current = (value)=>{
            this.set(key, value);
        };
        return ref.current;
    }
    /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */ observe(selector, listener) {
        let selectFn;
        if (typeof selector === 'function') selectFn = selector;
        else selectFn = this.selectors[selector];
        let prevValue = selectFn(this.state);
        listener(prevValue, prevValue, this);
        return this.subscribe((nextState)=>{
            const nextValue = selectFn(nextState);
            if (!Object.is(prevValue, nextValue)) {
                const oldValue = prevValue;
                prevValue = nextValue;
                listener(nextValue, oldValue, this);
            }
        });
    }
}

});
parcelRegister("8hFBI", function(module, exports) {

$parcel$export(module.exports, "Store", () => $cb1b6f770eb39fa3$export$390f32400eaf98c9);

var $etCPF = parcelRequire("etCPF");
class $cb1b6f770eb39fa3$export$390f32400eaf98c9 {
    /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */ // Internal state to handle recursive `setState()` calls
    constructor(state){
        this.state = state;
        this.listeners = new Set();
        this.updateTick = 0;
    }
    /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */ subscribe = (fn)=>{
        this.listeners.add(fn);
        return ()=>{
            this.listeners.delete(fn);
        };
    };
    /**
   * Returns the current state of the store.
   */ getSnapshot = ()=>{
        return this.state;
    };
    /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */ setState(newState) {
        if (this.state === newState) return;
        this.state = newState;
        this.updateTick += 1;
        const currentTick = this.updateTick;
        for (const listener of this.listeners){
            if (currentTick !== this.updateTick) // If the tick has changed, a recursive `setState` call has been made,
            // and it has already notified all listeners.
            return;
            listener(newState);
        }
    }
    /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */ update(changes) {
        for(const key in changes)if (!Object.is(this.state[key], changes[key])) {
            this.setState({
                ...this.state,
                ...changes
            });
            return;
        }
    }
    /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */ set(key, value) {
        if (!Object.is(this.state[key], value)) this.setState({
            ...this.state,
            [key]: value
        });
    }
    /**
   * Gives the state a new reference and updates all registered listeners.
   */ notifyAll() {
        const newState = {
            ...this.state
        };
        this.setState(newState);
    }
    use(selector, a1, a2, a3) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $etCPF.useStore)(this, selector, a1, a2, a3);
    }
}

});
parcelRegister("etCPF", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $47f6e69c9d091449$export$6ccbb43953eebf8);

var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");

var $8jW4Q = parcelRequire("8jW4Q");

var $4srfS = parcelRequire("4srfS");

var $4rsXc = parcelRequire("4rsXc");
/* Some tests fail in R18 with the raw useSyncExternalStore. It may be possible to make it work
 * but for now we only enable it for R19+. */ const $47f6e69c9d091449$var$canUseRawUseSyncExternalStore = (0, $4srfS.isReactVersionAtLeast)(19);
const $47f6e69c9d091449$var$useStoreImplementation = $47f6e69c9d091449$var$canUseRawUseSyncExternalStore ? $47f6e69c9d091449$var$useStoreFast : $47f6e69c9d091449$var$useStoreLegacy;
function $47f6e69c9d091449$export$6ccbb43953eebf8(store, selector, a1, a2, a3) {
    return $47f6e69c9d091449$var$useStoreImplementation(store, selector, a1, a2, a3);
}
function $47f6e69c9d091449$var$useStoreR19(store, selector, a1, a2, a3) {
    const getSelection = $8NFma.useCallback(()=>selector(store.getSnapshot(), a1, a2, a3), [
        store,
        selector,
        a1,
        a2,
        a3
    ]);
    return (0, $ck4pA.useSyncExternalStore)(store.subscribe, getSelection, getSelection);
}
(0, $4rsXc.register)({
    before (instance) {
        instance.syncIndex = 0;
        if (!instance.didInitialize) {
            instance.syncTick = 1;
            instance.syncHooks = [];
            instance.didChangeStore = true;
            instance.getSnapshot = ()=>{
                let didChange = false;
                for(let i = 0; i < instance.syncHooks.length; i += 1){
                    const hook = instance.syncHooks[i];
                    const value = hook.selector(hook.store.state, hook.a1, hook.a2, hook.a3);
                    if (!Object.is(hook.value, value)) {
                        didChange = true;
                        hook.value = value;
                    }
                }
                if (didChange) instance.syncTick += 1;
                return instance.syncTick;
            };
        }
    },
    after (instance) {
        if (instance.syncHooks.length > 0) {
            if (instance.didChangeStore) {
                instance.didChangeStore = false;
                instance.subscribe = (onStoreChange)=>{
                    const stores = new Set();
                    for (const hook of instance.syncHooks)stores.add(hook.store);
                    const unsubscribes = [];
                    for (const store of stores)unsubscribes.push(store.subscribe(onStoreChange));
                    return ()=>{
                        for (const unsubscribe of unsubscribes)unsubscribe();
                    };
                };
            }
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $ck4pA.useSyncExternalStore)(instance.subscribe, instance.getSnapshot, instance.getSnapshot);
        }
    }
});
function $47f6e69c9d091449$var$useStoreFast(store, selector, a1, a2, a3) {
    const instance = (0, $4rsXc.getInstance)();
    if (!instance) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $47f6e69c9d091449$var$useStoreR19(store, selector, a1, a2, a3);
    const index = instance.syncIndex;
    instance.syncIndex += 1;
    let hook;
    if (!instance.didInitialize) {
        hook = {
            store: store,
            selector: selector,
            a1: a1,
            a2: a2,
            a3: a3,
            value: selector(store.getSnapshot(), a1, a2, a3)
        };
        instance.syncHooks.push(hook);
    } else {
        hook = instance.syncHooks[index];
        if (hook.store !== store || hook.selector !== selector || !Object.is(hook.a1, a1) || !Object.is(hook.a2, a2) || !Object.is(hook.a3, a3)) {
            if (hook.store !== store) instance.didChangeStore = true;
            hook.store = store;
            hook.selector = selector;
            hook.a1 = a1;
            hook.a2 = a2;
            hook.a3 = a3;
            hook.value = selector(store.getSnapshot(), a1, a2, a3);
        }
    }
    return hook.value;
}
function $47f6e69c9d091449$var$useStoreLegacy(store, selector, a1, a2, a3) {
    return (0, $8jW4Q.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, (state)=>selector(state, a1, a2, a3));
}

});
parcelRegister("ck4pA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4l02y"));

});
parcelRegister("4l02y", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $32892794e355c28f$export$306c0aa65ff9ec16, (v) => $32892794e355c28f$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $32892794e355c28f$export$306c0aa65ff9ec16;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $32892794e355c28f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $32892794e355c28f$var$objectIs = "function" === typeof Object.is ? Object.is : $32892794e355c28f$var$is, $32892794e355c28f$var$useState = $8NFma.useState, $32892794e355c28f$var$useEffect = $8NFma.useEffect, $32892794e355c28f$var$useLayoutEffect = $8NFma.useLayoutEffect, $32892794e355c28f$var$useDebugValue = $8NFma.useDebugValue;
function $32892794e355c28f$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $32892794e355c28f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $32892794e355c28f$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $32892794e355c28f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $32892794e355c28f$var$useEffect(function() {
        $32892794e355c28f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $32892794e355c28f$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $32892794e355c28f$var$useDebugValue(value);
    return value;
}
function $32892794e355c28f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$32892794e355c28f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $32892794e355c28f$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $32892794e355c28f$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $32892794e355c28f$var$useSyncExternalStore$1 : $32892794e355c28f$var$useSyncExternalStore$2;
$32892794e355c28f$export$306c0aa65ff9ec16 = void 0 !== $8NFma.useSyncExternalStore ? $8NFma.useSyncExternalStore : $32892794e355c28f$var$shim;

});


parcelRegister("8jW4Q", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hnOT8"));

});
parcelRegister("hnOT8", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $ca7c0f057ae91fa4$export$bf730a2d8bf68b42, (v) => $ca7c0f057ae91fa4$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ca7c0f057ae91fa4$export$bf730a2d8bf68b42;
"use strict";

var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");
function $ca7c0f057ae91fa4$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ca7c0f057ae91fa4$var$objectIs = "function" === typeof Object.is ? Object.is : $ca7c0f057ae91fa4$var$is, $ca7c0f057ae91fa4$var$useSyncExternalStore = $ck4pA.useSyncExternalStore, $ca7c0f057ae91fa4$var$useRef = $8NFma.useRef, $ca7c0f057ae91fa4$var$useEffect = $8NFma.useEffect, $ca7c0f057ae91fa4$var$useMemo = $8NFma.useMemo, $ca7c0f057ae91fa4$var$useDebugValue = $8NFma.useDebugValue;
$ca7c0f057ae91fa4$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $ca7c0f057ae91fa4$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $ca7c0f057ae91fa4$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($ca7c0f057ae91fa4$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $ca7c0f057ae91fa4$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $ca7c0f057ae91fa4$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $ca7c0f057ae91fa4$var$useDebugValue(value);
    return value;
};

});


parcelRegister("4rsXc", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $f29649165c9cee37$export$8bedcca5bbd73999);
$parcel$export(module.exports, "register", () => $f29649165c9cee37$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "fastComponent", () => $f29649165c9cee37$export$64e73b799fac14d);
$parcel$export(module.exports, "fastComponentRef", () => $f29649165c9cee37$export$be067d121a144254);

var $8NFma = parcelRequire("8NFma");

var $gidzQ = parcelRequire("gidzQ");
const $f29649165c9cee37$var$hooks = [];
let $f29649165c9cee37$var$currentInstance = undefined;
function $f29649165c9cee37$export$8bedcca5bbd73999() {
    return $f29649165c9cee37$var$currentInstance;
}
function $f29649165c9cee37$export$7fbc60ba12697434(instance) {
    $f29649165c9cee37$var$currentInstance = instance;
}
function $f29649165c9cee37$export$6503ec6e8aabbaf(hook) {
    $f29649165c9cee37$var$hooks.push(hook);
}
function $f29649165c9cee37$export$64e73b799fac14d(fn) {
    const FastComponent = (props, forwardedRef)=>{
        const instance = (0, $gidzQ.useRefWithInit)($f29649165c9cee37$var$createInstance).current;
        let result;
        try {
            $f29649165c9cee37$var$currentInstance = instance;
            for (const hook of $f29649165c9cee37$var$hooks)hook.before(instance);
            result = fn(props, forwardedRef);
            for (const hook of $f29649165c9cee37$var$hooks)hook.after(instance);
            instance.didInitialize = true;
        } finally{
            $f29649165c9cee37$var$currentInstance = undefined;
        }
        return result;
    };
    FastComponent.displayName = fn.displayName || fn.name;
    return FastComponent;
}
function $f29649165c9cee37$export$be067d121a144254(fn) {
    return /*#__PURE__*/ $8NFma.forwardRef($f29649165c9cee37$export$64e73b799fac14d(fn));
}
function $f29649165c9cee37$var$createInstance() {
    return {
        didInitialize: false
    };
}

});







parcelRegister("jSzfV", function(module, exports) {

$parcel$export(module.exports, "useDirection", () => $a6189964094b3e8d$export$b39126d51d94e6f3);

var $8NFma = parcelRequire("8NFma");
'use client';
const $a6189964094b3e8d$export$46f936cc30cb9075 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $a6189964094b3e8d$export$b39126d51d94e6f3() {
    const context = $8NFma.useContext($a6189964094b3e8d$export$46f936cc30cb9075);
    return context?.direction ?? 'ltr';
}

});

parcelRegister("imZZx", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $53565f2efe3720f6$export$f2120bbfa5450bd2);

var $Euxde = parcelRequire("Euxde");
const $53565f2efe3720f6$export$32c507017976ecd8 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0, offsetParent: offsetParent = 'real' } = (0, $Euxde.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $Euxde.getAlignmentAxis)(placement);
            const length = (0, $Euxde.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = offsetParent === 'real' ? await platform.getOffsetParent?.(element) : elements.floating;
            let clientSize = elements.floating[clientProp] || rects.floating[length];
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await platform.isElement?.(arrowOffsetParent)) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = Math.min(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = Math.min(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $Euxde.clamp)(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $Euxde.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            // eslint-disable-next-line no-nested-ternary
            const alignmentOffset = shouldAddOffset ? center < min ? center - min : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
const $53565f2efe3720f6$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$53565f2efe3720f6$export$32c507017976ecd8(options),
        options: [
            options,
            deps
        ]
    });

});

parcelRegister("2IVmA", function(module, exports) {

$parcel$export(module.exports, "hide", () => $2843f0f2f2725dfc$export$fe8985bb6374093c);

var $eqxtD = parcelRequire("eqxtD");
const $2843f0f2f2725dfc$var$nativeHideFn = (0, $eqxtD.hide)().fn;
const $2843f0f2f2725dfc$export$fe8985bb6374093c = {
    name: 'hide',
    async fn (state) {
        const { width: width, height: height, x: x, y: y } = state.rects.reference;
        const anchorHidden = width === 0 && height === 0 && x === 0 && y === 0;
        const nativeHideResult = await $2843f0f2f2725dfc$var$nativeHideFn(state);
        return {
            data: {
                referenceHidden: nativeHideResult.data?.referenceHidden || anchorHidden
            }
        };
    }
};

});

parcelRegister("gLdy7", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SIDES", () => $a1ba1893f3569cbc$export$bae2fcbeb591a166);
$parcel$export(module.exports, "adaptiveOrigin", () => $a1ba1893f3569cbc$export$85c88fe2fea131bc);

var $8shn9 = parcelRequire("8shn9");
var $1D9S2 = parcelRequire("1D9S2");

var $Euxde = parcelRequire("Euxde");
const $a1ba1893f3569cbc$export$bae2fcbeb591a166 = {
    sideX: 'left',
    sideY: 'top'
};
const $a1ba1893f3569cbc$export$85c88fe2fea131bc = {
    name: 'adaptiveOrigin',
    async fn (state) {
        const { x: rawX, y: rawY, rects: { floating: floatRect }, elements: { floating: floating }, platform: platform, strategy: strategy, placement: placement } = state;
        const win = (0, $1D9S2.getWindow)(floating);
        const styles = win.getComputedStyle(floating);
        const hasTransition = styles.transitionDuration !== '0s' && styles.transitionDuration !== '';
        if (!hasTransition) return {
            x: rawX,
            y: rawY,
            data: $a1ba1893f3569cbc$export$bae2fcbeb591a166
        };
        const offsetParent = await platform.getOffsetParent?.(floating);
        let offsetDimensions = {
            width: 0,
            height: 0
        };
        // For fixed strategy, prefer visualViewport if available
        if (strategy === 'fixed' && win?.visualViewport) offsetDimensions = {
            width: win.visualViewport.width,
            height: win.visualViewport.height
        };
        else if (offsetParent === win) {
            const doc = (0, $8shn9.ownerDocument)(floating);
            offsetDimensions = {
                width: doc.documentElement.clientWidth,
                height: doc.documentElement.clientHeight
            };
        } else if (await platform.isElement?.(offsetParent)) offsetDimensions = await platform.getDimensions(offsetParent);
        const currentSide = (0, $Euxde.getSide)(placement);
        let x = rawX;
        let y = rawY;
        if (currentSide === 'left') x = offsetDimensions.width - (rawX + floatRect.width);
        if (currentSide === 'top') y = offsetDimensions.height - (rawY + floatRect.height);
        const sideX = currentSide === 'left' ? 'right' : $a1ba1893f3569cbc$export$bae2fcbeb591a166.sideX;
        const sideY = currentSide === 'top' ? 'bottom' : $a1ba1893f3569cbc$export$bae2fcbeb591a166.sideY;
        return {
            x: x,
            y: y,
            data: {
                sideX: sideX,
                sideY: sideY
            }
        };
    }
};

});


parcelRegister("2I5FP", function(module, exports) {

$parcel$export(module.exports, "CompositeList", () => $5a58df559c29e3ac$export$2f096f2d6afe1a7d);
/* eslint-disable no-bitwise */ 
var $8NFma = parcelRequire("8NFma");

var $gidzQ = parcelRequire("gidzQ");

var $fKU9M = parcelRequire("fKU9M");

var $9N3e2 = parcelRequire("9N3e2");

var $6lvpc = parcelRequire("6lvpc");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $5a58df559c29e3ac$export$2f096f2d6afe1a7d(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef, onMapChange: onMapChangeProp } = props;
    const onMapChange = (0, $fKU9M.useStableCallback)(onMapChangeProp);
    const nextIndexRef = $8NFma.useRef(0);
    const listeners = (0, $gidzQ.useRefWithInit)($5a58df559c29e3ac$var$createListeners).current;
    // We use a stable `map` to avoid O(n^2) re-allocation costs for large lists.
    // `mapTick` is our re-render trigger mechanism. We also need to update the
    // elements and label refs, but there's a lot of async work going on and sometimes
    // the effect that handles `onMapChange` gets called after those refs have been
    // filled, and we don't want to lose those values by setting their lengths to `0`.
    // We also need to have them at the proper length because floating-ui uses that
    // information for list navigation.
    const map = (0, $gidzQ.useRefWithInit)($5a58df559c29e3ac$var$createMap).current;
    // `mapTick` uses a counter rather than objects for low precision-loss risk and better memory efficiency
    const [mapTick, setMapTick] = $8NFma.useState(0);
    const lastTickRef = $8NFma.useRef(mapTick);
    const register = (0, $fKU9M.useStableCallback)((node, metadata)=>{
        map.set(node, metadata ?? null);
        lastTickRef.current += 1;
        setMapTick(lastTickRef.current);
    });
    const unregister = (0, $fKU9M.useStableCallback)((node)=>{
        map.delete(node);
        lastTickRef.current += 1;
        setMapTick(lastTickRef.current);
    });
    const sortedMap = $8NFma.useMemo(()=>{
        // `mapTick` is the `useMemo` trigger as `map` is stable.
        $5a58df559c29e3ac$var$disableEslintWarning(mapTick);
        const newMap = new Map();
        // Filter out disconnected elements before sorting to avoid inconsistent
        // compareDocumentPosition results when elements are detached from the DOM.
        const sortedNodes = Array.from(map.keys()).filter((node)=>node.isConnected).sort($5a58df559c29e3ac$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            const metadata = map.get(node) ?? {};
            newMap.set(node, {
                ...metadata,
                index: index
            });
        });
        return newMap;
    }, [
        map,
        mapTick
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (typeof MutationObserver !== 'function' || sortedMap.size === 0) return undefined;
        const mutationObserver = new MutationObserver((entries)=>{
            const diff = new Set();
            const updateDiff = (node)=>diff.has(node) ? diff.delete(node) : diff.add(node);
            entries.forEach((entry)=>{
                entry.removedNodes.forEach(updateDiff);
                entry.addedNodes.forEach(updateDiff);
            });
            if (diff.size === 0) {
                lastTickRef.current += 1;
                setMapTick(lastTickRef.current);
            }
        });
        sortedMap.forEach((_, node)=>{
            if (node.parentElement) mutationObserver.observe(node.parentElement, {
                childList: true
            });
        });
        return ()=>{
            mutationObserver.disconnect();
        };
    }, [
        sortedMap
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        const shouldUpdateLengths = lastTickRef.current === mapTick;
        if (shouldUpdateLengths) {
            if (elementsRef.current.length !== sortedMap.size) elementsRef.current.length = sortedMap.size;
            if (labelsRef && labelsRef.current.length !== sortedMap.size) labelsRef.current.length = sortedMap.size;
            nextIndexRef.current = sortedMap.size;
        }
        onMapChange(sortedMap);
    }, [
        onMapChange,
        sortedMap,
        elementsRef,
        labelsRef,
        mapTick
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        return ()=>{
            elementsRef.current = [];
        };
    }, [
        elementsRef
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        return ()=>{
            if (labelsRef) labelsRef.current = [];
        };
    }, [
        labelsRef
    ]);
    const subscribeMapChange = (0, $fKU9M.useStableCallback)((fn)=>{
        listeners.add(fn);
        return ()=>{
            listeners.delete(fn);
        };
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        listeners.forEach((l)=>l(sortedMap));
    }, [
        listeners,
        sortedMap
    ]);
    const contextValue = $8NFma.useMemo(()=>({
            register: register,
            unregister: unregister,
            subscribeMapChange: subscribeMapChange,
            elementsRef: elementsRef,
            labelsRef: labelsRef,
            nextIndexRef: nextIndexRef
        }), [
        register,
        unregister,
        subscribeMapChange,
        elementsRef,
        labelsRef,
        nextIndexRef
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6lvpc.CompositeListContext).Provider, {
        value: contextValue,
        children: children
    });
}
function $5a58df559c29e3ac$var$createMap() {
    return new Map();
}
function $5a58df559c29e3ac$var$createListeners() {
    return new Set();
}
function $5a58df559c29e3ac$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $5a58df559c29e3ac$var$disableEslintWarning(_) {}

});

parcelRegister("dGxil", function(module, exports) {

$parcel$export(module.exports, "InternalBackdrop", () => $b8aa98ec49ca74c0$export$9cbc97179cc329fc);

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
const $b8aa98ec49ca74c0$export$9cbc97179cc329fc = /*#__PURE__*/ $8NFma.forwardRef(function InternalBackdrop(props, ref) {
    const { cutout: cutout, ...otherProps } = props;
    let clipPath;
    if (cutout) {
        const rect = cutout.getBoundingClientRect();
        clipPath = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${rect.left}px ${rect.top}px,${rect.left}px ${rect.bottom}px,${rect.right}px ${rect.bottom}px,${rect.right}px ${rect.top}px,${rect.left}px ${rect.top}px)`;
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ref: ref,
        role: "presentation",
        "data-base-ui-inert": "",
        ...otherProps,
        style: {
            position: 'fixed',
            inset: 0,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            clipPath: clipPath
        }
    });
});

});

parcelRegister("ag8av", function(module, exports) {

$parcel$export(module.exports, "usePositioner", () => $cfa4b18aa63c2a73$export$b5b025415a3917e8);

var $gVYSt = parcelRequire("gVYSt");

var $aEBMJ = parcelRequire("aEBMJ");

var $6OSIs = parcelRequire("6OSIs");
'use client';
function $cfa4b18aa63c2a73$export$b5b025415a3917e8(componentProps, state, { styles: styles, transitionStatus: transitionStatus, props: props, refs: refs, hidden: hidden, inert: inert = false }) {
    const style = {
        ...styles
    };
    if (inert) style.pointerEvents = 'none';
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        ref: refs,
        props: [
            {
                role: 'presentation',
                hidden: hidden,
                style: style
            },
            (0, $6OSIs.getDisabledMountTransitionStyles)(transitionStatus),
            props
        ],
        stateAttributesMapping: (0, $gVYSt.popupStateMapping)
    });
}

});

parcelRegister("424ib", function(module, exports) {

$parcel$export(module.exports, "useAnchoredPopupScrollLock", () => $56438ea0a15d8759$export$62e8b9c3adfcff8);

var $8NFma = parcelRequire("8NFma");

var $8shn9 = parcelRequire("8shn9");

var $3uGMS = parcelRequire("3uGMS");

var $9N3e2 = parcelRequire("9N3e2");
'use client';
// Touch-opened popups normally avoid scroll locking so users can still swipe outside to dismiss.
// This hook re-enables scroll lock only when the popup is effectively full-width.
// Treat popups with up to 20px of total horizontal gutter as full-width so common ~10px side
// padding still locks scroll, since that leaves too little outside space for a reliable swipe.
const $56438ea0a15d8759$var$VIEWPORT_WIDTH_TOLERANCE_PX = 20;
function $56438ea0a15d8759$export$62e8b9c3adfcff8(enabled, touchOpen, positionerElement, referenceElement) {
    const [touchOpenShouldLockScroll, setTouchOpenShouldLockScroll] = $8NFma.useState(false);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled || !touchOpen || positionerElement == null) {
            setTouchOpenShouldLockScroll(false);
            return;
        }
        const viewportWidth = (0, $8shn9.ownerDocument)(positionerElement).documentElement.clientWidth;
        const popupWidth = positionerElement.offsetWidth;
        setTouchOpenShouldLockScroll(viewportWidth > 0 && popupWidth > 0 && popupWidth >= viewportWidth - $56438ea0a15d8759$var$VIEWPORT_WIDTH_TOLERANCE_PX);
    }, [
        enabled,
        touchOpen,
        positionerElement
    ]);
    (0, $3uGMS.useScrollLock)(enabled && (!touchOpen || touchOpenShouldLockScroll), referenceElement);
}

});
parcelRegister("3uGMS", function(module, exports) {

$parcel$export(module.exports, "useScrollLock", () => $9906724f2736a236$export$e47ba1b900da5d3b);

var $1D9S2 = parcelRequire("1D9S2");

var $cbA4H = parcelRequire("cbA4H");

var $8QwT3 = parcelRequire("8QwT3");

var $8shn9 = parcelRequire("8shn9");
var $1D9S2 = parcelRequire("1D9S2");

var $9N3e2 = parcelRequire("9N3e2");

var $5o6JF = parcelRequire("5o6JF");

var $dhRNQ = parcelRequire("dhRNQ");

var $jWAMz = parcelRequire("jWAMz");
'use client';
let $9906724f2736a236$var$originalHtmlStyles = {};
let $9906724f2736a236$var$originalBodyStyles = {};
let $9906724f2736a236$var$originalHtmlScrollBehavior = '';
function $9906724f2736a236$var$hasInsetScrollbars(referenceElement) {
    if (typeof document === 'undefined') return false;
    const doc = (0, $8shn9.ownerDocument)(referenceElement);
    const win = (0, $1D9S2.getWindow)(doc);
    return win.innerWidth - doc.documentElement.clientWidth > 0;
}
function $9906724f2736a236$var$supportsStableScrollbarGutter(referenceElement) {
    const supported = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('scrollbar-gutter', 'stable');
    if (!supported || typeof document === 'undefined') return false;
    const doc = (0, $8shn9.ownerDocument)(referenceElement);
    const html = doc.documentElement;
    const body = doc.body;
    const scrollContainer = (0, $1D9S2.isOverflowElement)(html) ? html : body;
    const originalScrollContainerOverflowY = scrollContainer.style.overflowY;
    const originalHtmlStyleGutter = html.style.scrollbarGutter;
    html.style.scrollbarGutter = 'stable';
    scrollContainer.style.overflowY = 'scroll';
    const before = scrollContainer.offsetWidth;
    scrollContainer.style.overflowY = 'hidden';
    const after = scrollContainer.offsetWidth;
    scrollContainer.style.overflowY = originalScrollContainerOverflowY;
    html.style.scrollbarGutter = originalHtmlStyleGutter;
    return before === after;
}
function $9906724f2736a236$var$preventScrollOverlayScrollbars(referenceElement) {
    const doc = (0, $8shn9.ownerDocument)(referenceElement);
    const html = doc.documentElement;
    const body = doc.body;
    // If an `overflow` style is present on <html>, we need to lock it, because a lock on <body>
    // won't have any effect.
    // But if <body> has an `overflow` style (like `overflow-x: hidden`), we need to lock it
    // instead, as sticky elements shift otherwise.
    const elementToLock = (0, $1D9S2.isOverflowElement)(html) ? html : body;
    const originalElementToLockStyles = {
        overflowY: elementToLock.style.overflowY,
        overflowX: elementToLock.style.overflowX
    };
    Object.assign(elementToLock.style, {
        overflowY: 'hidden',
        overflowX: 'hidden'
    });
    return ()=>{
        Object.assign(elementToLock.style, originalElementToLockStyles);
    };
}
function $9906724f2736a236$var$preventScrollInsetScrollbars(referenceElement) {
    const doc = (0, $8shn9.ownerDocument)(referenceElement);
    const html = doc.documentElement;
    const body = doc.body;
    const win = (0, $1D9S2.getWindow)(html);
    let scrollTop = 0;
    let scrollLeft = 0;
    let updateGutterOnly = false;
    const resizeFrame = (0, $dhRNQ.AnimationFrame).create();
    // Pinch-zoom in Safari causes a shift. Just don't lock scroll if there's any pinch-zoom.
    if ((0, $8QwT3).engine.webkit && (win.visualViewport?.scale ?? 1) !== 1) return ()=>{};
    function lockScroll() {
        /* DOM reads: */ const htmlStyles = win.getComputedStyle(html);
        const bodyStyles = win.getComputedStyle(body);
        const htmlScrollbarGutterValue = htmlStyles.scrollbarGutter || '';
        const hasBothEdges = htmlScrollbarGutterValue.includes('both-edges');
        const scrollbarGutterValue = hasBothEdges ? 'stable both-edges' : 'stable';
        scrollTop = html.scrollTop;
        scrollLeft = html.scrollLeft;
        $9906724f2736a236$var$originalHtmlStyles = {
            scrollbarGutter: html.style.scrollbarGutter,
            overflowY: html.style.overflowY,
            overflowX: html.style.overflowX
        };
        $9906724f2736a236$var$originalHtmlScrollBehavior = html.style.scrollBehavior;
        $9906724f2736a236$var$originalBodyStyles = {
            position: body.style.position,
            height: body.style.height,
            width: body.style.width,
            boxSizing: body.style.boxSizing,
            overflowY: body.style.overflowY,
            overflowX: body.style.overflowX,
            scrollBehavior: body.style.scrollBehavior
        };
        const isScrollableY = html.scrollHeight > html.clientHeight;
        const isScrollableX = html.scrollWidth > html.clientWidth;
        const hasConstantOverflowY = htmlStyles.overflowY === 'scroll' || bodyStyles.overflowY === 'scroll';
        const hasConstantOverflowX = htmlStyles.overflowX === 'scroll' || bodyStyles.overflowX === 'scroll';
        // Values can be negative in Firefox
        const scrollbarWidth = Math.max(0, win.innerWidth - body.clientWidth);
        const scrollbarHeight = Math.max(0, win.innerHeight - body.clientHeight);
        // Avoid shift due to the default <body> margin. This does cause elements to be clipped
        // with whitespace. Warn if <body> has margins?
        const marginY = parseFloat(bodyStyles.marginTop) + parseFloat(bodyStyles.marginBottom);
        const marginX = parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight);
        const elementToLock = (0, $1D9S2.isOverflowElement)(html) ? html : body;
        updateGutterOnly = $9906724f2736a236$var$supportsStableScrollbarGutter(referenceElement);
        /*
     * DOM writes:
     * Do not read the DOM past this point!
     */ if (updateGutterOnly) {
            html.style.scrollbarGutter = scrollbarGutterValue;
            elementToLock.style.overflowY = 'hidden';
            elementToLock.style.overflowX = 'hidden';
            return;
        }
        Object.assign(html.style, {
            scrollbarGutter: scrollbarGutterValue,
            overflowY: 'hidden',
            overflowX: 'hidden'
        });
        if (isScrollableY || hasConstantOverflowY) html.style.overflowY = 'scroll';
        if (isScrollableX || hasConstantOverflowX) html.style.overflowX = 'scroll';
        Object.assign(body.style, {
            position: 'relative',
            height: marginY || scrollbarHeight ? `calc(100dvh - ${marginY + scrollbarHeight}px)` : '100dvh',
            width: marginX || scrollbarWidth ? `calc(100vw - ${marginX + scrollbarWidth}px)` : '100vw',
            boxSizing: 'border-box',
            overflow: 'hidden',
            scrollBehavior: 'unset'
        });
        body.scrollTop = scrollTop;
        body.scrollLeft = scrollLeft;
        html.setAttribute('data-base-ui-scroll-locked', '');
        html.style.scrollBehavior = 'unset';
    }
    function cleanup() {
        Object.assign(html.style, $9906724f2736a236$var$originalHtmlStyles);
        Object.assign(body.style, $9906724f2736a236$var$originalBodyStyles);
        if (!updateGutterOnly) {
            html.scrollTop = scrollTop;
            html.scrollLeft = scrollLeft;
            html.removeAttribute('data-base-ui-scroll-locked');
            html.style.scrollBehavior = $9906724f2736a236$var$originalHtmlScrollBehavior;
        }
    }
    function handleResize() {
        cleanup();
        resizeFrame.request(lockScroll);
    }
    lockScroll();
    const unsubscribeResize = (0, $cbA4H.addEventListener)(win, 'resize', handleResize);
    return ()=>{
        resizeFrame.cancel();
        cleanup();
        // Sometimes this cleanup can run after test teardown because it is called
        // in a `setTimeout(fn, 0)`. Guard the returned cleanup to avoid calling
        // `removeEventListener` when it is no longer available in tests.
        if (typeof win.removeEventListener === 'function') unsubscribeResize();
    };
}
class $9906724f2736a236$var$ScrollLocker {
    lockCount = 0;
    restore = null;
    timeoutLock = (0, $5o6JF.Timeout).create();
    timeoutUnlock = (0, $5o6JF.Timeout).create();
    acquire(referenceElement) {
        this.lockCount += 1;
        if (this.lockCount === 1 && this.restore === null) this.timeoutLock.start(0, ()=>this.lock(referenceElement));
        return this.release;
    }
    release = ()=>{
        this.lockCount -= 1;
        if (this.lockCount === 0 && this.restore) this.timeoutUnlock.start(0, this.unlock);
    };
    unlock = ()=>{
        if (this.lockCount === 0 && this.restore) {
            this.restore?.();
            this.restore = null;
        }
    };
    lock(referenceElement) {
        if (this.lockCount === 0 || this.restore !== null) return;
        const doc = (0, $8shn9.ownerDocument)(referenceElement);
        const html = doc.documentElement;
        const htmlOverflowY = (0, $1D9S2.getWindow)(html).getComputedStyle(html).overflowY;
        // If the site author already hid overflow on <html>, respect it and bail out.
        if (htmlOverflowY === 'hidden' || htmlOverflowY === 'clip') {
            this.restore = (0, $jWAMz.NOOP);
            return;
        }
        const hasOverlayScrollbars = (0, $8QwT3).os.ios || !$9906724f2736a236$var$hasInsetScrollbars(referenceElement);
        // On iOS, scroll locking does not work if the navbar is collapsed. Due to numerous
        // side effects and bugs that arise on iOS, it must be researched extensively before
        // being enabled to ensure it doesn't cause the following issues:
        // - Textboxes must scroll into view when focused, nor cause a glitchy scroll animation.
        // - The navbar must not force itself into view and cause layout shift.
        // - Scroll containers must not flicker upon closing a popup when it has an exit animation.
        this.restore = hasOverlayScrollbars ? $9906724f2736a236$var$preventScrollOverlayScrollbars(referenceElement) : $9906724f2736a236$var$preventScrollInsetScrollbars(referenceElement);
    }
}
const $9906724f2736a236$var$SCROLL_LOCKER = new $9906724f2736a236$var$ScrollLocker();
function $9906724f2736a236$export$e47ba1b900da5d3b(enabled = true, referenceElement = null) {
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled) return undefined;
        return $9906724f2736a236$var$SCROLL_LOCKER.acquire(referenceElement);
    }, [
        enabled,
        referenceElement
    ]);
}

});



parcelRegister("2cDUf", function(module, exports) {

$parcel$export(module.exports, "MenuRadioGroup", () => $cb0f8becdb9239c4$export$ea2200c9eee416b3);

var $8NFma = parcelRequire("8NFma");

var $2W2EF = parcelRequire("2W2EF");

var $fKU9M = parcelRequire("fKU9M");

var $7E7br = parcelRequire("7E7br");

var $cFU1r = parcelRequire("cFU1r");

var $aEBMJ = parcelRequire("aEBMJ");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $cb0f8becdb9239c4$export$ea2200c9eee416b3 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function MenuRadioGroup(componentProps, forwardedRef) {
    const { render: render, className: className, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChangeProp, disabled: disabled = false, style: style, 'aria-labelledby': ariaLabelledByProp, ...elementProps } = componentProps;
    const [labelId, setLabelId] = $8NFma.useState(undefined);
    const [value, setValueUnwrapped] = (0, $2W2EF.useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'MenuRadioGroup'
    });
    const setValue = (0, $fKU9M.useStableCallback)((newValue, eventDetails)=>{
        onValueChangeProp?.(newValue, eventDetails);
        if (eventDetails.isCanceled) return;
        setValueUnwrapped(newValue);
    });
    const state = {
        disabled: disabled
    };
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        ref: forwardedRef,
        props: {
            role: 'group',
            'aria-labelledby': ariaLabelledByProp ?? labelId,
            'aria-disabled': disabled || undefined,
            ...elementProps
        }
    });
    const context = $8NFma.useMemo(()=>({
            value: value,
            setValue: setValue,
            disabled: disabled
        }), [
        value,
        setValue,
        disabled
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cFU1r.MenuGroupContext).Provider, {
        value: setLabelId,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7E7br.MenuRadioGroupContext).Provider, {
            value: context,
            children: element
        })
    });
}));

});
parcelRegister("7E7br", function(module, exports) {

$parcel$export(module.exports, "MenuRadioGroupContext", () => $8335109b926f7cdd$export$ca2d9104ddb3d7d3);
$parcel$export(module.exports, "useMenuRadioGroupContext", () => $8335109b926f7cdd$export$641949229ddf1be5);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $8335109b926f7cdd$export$ca2d9104ddb3d7d3 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $8335109b926f7cdd$export$641949229ddf1be5() {
    const context = $8NFma.useContext($8335109b926f7cdd$export$ca2d9104ddb3d7d3);
    if (context === undefined) throw new Error((0, $cmjqX.default)(34));
    return context;
}

});


parcelRegister("7XlrL", function(module, exports) {

$parcel$export(module.exports, "MenuRadioItem", () => $0959bbaa861174e3$export$69bd225e9817f6d0);

var $8NFma = parcelRequire("8NFma");

var $jtR97 = parcelRequire("jtR97");

var $aEBMJ = parcelRequire("aEBMJ");

var $hF6bp = parcelRequire("hF6bp");

var $7E7br = parcelRequire("7E7br");

var $6O3BK = parcelRequire("6O3BK");

var $bwGxG = parcelRequire("bwGxG");

var $ipY60 = parcelRequire("ipY60");

var $kFTCr = parcelRequire("kFTCr");

var $8foVs = parcelRequire("8foVs");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $0959bbaa861174e3$export$69bd225e9817f6d0 = /*#__PURE__*/ $8NFma.forwardRef(function MenuRadioItem(componentProps, forwardedRef) {
    const { render: render, className: className, id: idProp, label: label, nativeButton: nativeButton = false, disabled: disabledProp = false, closeOnClick: closeOnClick = false, value: value, style: style, ...elementProps } = componentProps;
    const listItem = (0, $ipY60.useCompositeListItem)({
        label: label
    });
    const menuPositionerContext = (0, $8foVs.useMenuPositionerContext)(true);
    const id = (0, $hF6bp.useBaseUiId)(idProp);
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const highlighted = store.useState('isActive', listItem.index);
    const itemProps = store.useState('itemProps');
    const { value: selectedValue, setValue: setSelectedValue, disabled: groupDisabled } = (0, $7E7br.useMenuRadioGroupContext)();
    const disabled = groupDisabled || disabledProp;
    const checked = selectedValue === value;
    const { getItemProps: getItemProps, itemRef: itemRef } = (0, $kFTCr.useMenuItem)({
        closeOnClick: closeOnClick,
        disabled: disabled,
        highlighted: highlighted,
        id: id,
        store: store,
        nativeButton: nativeButton,
        nodeId: menuPositionerContext?.context.nodeId,
        itemMetadata: (0, $kFTCr.REGULAR_ITEM)
    });
    const state = $8NFma.useMemo(()=>({
            disabled: disabled,
            highlighted: highlighted,
            checked: checked
        }), [
        disabled,
        highlighted,
        checked
    ]);
    function handleClick(event) {
        const details = (0, $6e5YN.createChangeEventDetails)((0, $66jhv).itemPress, event.nativeEvent, undefined, {
            preventUnmountOnClose () {}
        });
        setSelectedValue(value, details);
    }
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        stateAttributesMapping: (0, $bwGxG.itemMapping),
        props: [
            itemProps,
            {
                role: 'menuitemradio',
                'aria-checked': checked,
                onClick: handleClick
            },
            elementProps,
            getItemProps
        ],
        ref: [
            itemRef,
            forwardedRef,
            listItem.ref
        ]
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6O3BK.MenuRadioItemContext).Provider, {
        value: state,
        children: element
    });
});

});
parcelRegister("6O3BK", function(module, exports) {

$parcel$export(module.exports, "MenuRadioItemContext", () => $f704b75fa33e403b$export$347d568de7dd0549);
$parcel$export(module.exports, "useMenuRadioItemContext", () => $f704b75fa33e403b$export$42030934605e3fed);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $f704b75fa33e403b$export$347d568de7dd0549 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $f704b75fa33e403b$export$42030934605e3fed() {
    const context = $8NFma.useContext($f704b75fa33e403b$export$347d568de7dd0549);
    if (context === undefined) throw new Error((0, $cmjqX.default)(35));
    return context;
}

});


parcelRegister("kDs3P", function(module, exports) {

$parcel$export(module.exports, "MenuRadioItemIndicator", () => $19453977d85d57f3$export$1425b3440508edd4);

var $8NFma = parcelRequire("8NFma");

var $6O3BK = parcelRequire("6O3BK");

var $aEBMJ = parcelRequire("aEBMJ");

var $bwGxG = parcelRequire("bwGxG");

var $jpauT = parcelRequire("jpauT");

var $ejgm2 = parcelRequire("ejgm2");
'use client';
const $19453977d85d57f3$export$1425b3440508edd4 = /*#__PURE__*/ $8NFma.forwardRef(function MenuRadioItemIndicator(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, keepMounted: keepMounted = false, ...elementProps } = componentProps;
    const item = (0, $6O3BK.useMenuRadioItemContext)();
    const indicatorRef = $8NFma.useRef(null);
    const { transitionStatus: transitionStatus, setMounted: setMounted } = (0, $jpauT.useTransitionStatus)(item.checked);
    (0, $ejgm2.useOpenChangeComplete)({
        open: item.checked,
        ref: indicatorRef,
        onComplete () {
            if (!item.checked) setMounted(false);
        }
    });
    const state = {
        checked: item.checked,
        disabled: item.disabled,
        highlighted: item.highlighted,
        transitionStatus: transitionStatus
    };
    const element = (0, $aEBMJ.useRenderElement)('span', componentProps, {
        state: state,
        stateAttributesMapping: (0, $bwGxG.itemMapping),
        ref: [
            forwardedRef,
            indicatorRef
        ],
        props: {
            'aria-hidden': true,
            ...elementProps
        },
        enabled: keepMounted || item.checked
    });
    return element;
});

});

parcelRegister("l8BT5", function(module, exports) {

$parcel$export(module.exports, "MenuRoot", () => $534723f56a69884c$export$5ef9b2654717bfc2);

var $8NFma = parcelRequire("8NFma");

var $5o6JF = parcelRequire("5o6JF");

var $fKU9M = parcelRequire("fKU9M");

var $8VAvD = parcelRequire("8VAvD");

var $9N3e2 = parcelRequire("9N3e2");

var $jWAMz = parcelRequire("jWAMz");

var $4rsXc = parcelRequire("4rsXc");

var $8Xtx1 = parcelRequire("8Xtx1");
var $bfyYf = parcelRequire("bfyYf");
var $7VEf7 = parcelRequire("7VEf7");
var $2t3QX = parcelRequire("2t3QX");
var $hEYuq = parcelRequire("hEYuq");

var $jtR97 = parcelRequire("jtR97");

var $9qHuC = parcelRequire("9qHuC");

var $cTo2e = parcelRequire("cTo2e");

var $jSzfV = parcelRequire("jSzfV");

var $3Fl8O = parcelRequire("3Fl8O");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $gnjAY = parcelRequire("gnjAY");

var $eFu2T = parcelRequire("eFu2T");

var $2eLUt = parcelRequire("2eLUt");

var $kjC6g = parcelRequire("kjC6g");

var $bqzP8 = parcelRequire("bqzP8");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $534723f56a69884c$export$5ef9b2654717bfc2 = (0, $4rsXc.fastComponent)(function MenuRoot(props) {
    const { children: children, open: openProp, onOpenChange: onOpenChange, onOpenChangeComplete: onOpenChangeComplete, defaultOpen: defaultOpen = false, disabled: disabledProp = false, modal: modalProp, loopFocus: loopFocus = true, orientation: orientation = 'vertical', actionsRef: actionsRef, closeParentOnEsc: closeParentOnEsc = false, handle: handle, triggerId: triggerIdProp, defaultTriggerId: defaultTriggerIdProp = null, highlightItemOnHover: highlightItemOnHover = true } = props;
    const contextMenuContext = (0, $gnjAY.useContextMenuRootContext)(true);
    const parentMenuRootContext = (0, $jtR97.useMenuRootContext)(true);
    const menubarContext = (0, $9qHuC.useMenubarContext)(true);
    const isSubmenu = (0, $bqzP8.useMenuSubmenuRootContext)();
    const parentFromContext = $8NFma.useMemo(()=>{
        if (isSubmenu && parentMenuRootContext) return {
            type: 'menu',
            store: parentMenuRootContext.store
        };
        if (menubarContext) return {
            type: 'menubar',
            context: menubarContext
        };
        // Ensure this is not a Menu nested inside ContextMenu.Trigger.
        // ContextMenu parentContext is always undefined as ContextMenu.Root is instantiated with
        // <MenuRootContext.Provider value={undefined}>
        if (contextMenuContext && !parentMenuRootContext) return {
            type: 'context-menu',
            context: contextMenuContext
        };
        return {
            type: undefined
        };
    }, [
        contextMenuContext,
        parentMenuRootContext,
        menubarContext,
        isSubmenu
    ]);
    const store = (0, $2eLUt.MenuStore).useStore(handle?.store, {
        open: defaultOpen,
        openProp: openProp,
        activeTriggerId: defaultTriggerIdProp,
        triggerIdProp: triggerIdProp,
        parent: parentFromContext
    });
    (0, $kjC6g.useInitialOpenSync)(store, openProp, defaultOpen, defaultTriggerIdProp);
    store.useControlledProp('openProp', openProp);
    store.useControlledProp('triggerIdProp', triggerIdProp);
    store.useContextCallback('onOpenChangeComplete', onOpenChangeComplete);
    const rootId = (0, $8VAvD.useId)();
    const floatingId = (0, $8VAvD.useId)();
    const floatingTreeRoot = store.useState('floatingTreeRoot');
    const floatingNodeIdFromContext = (0, $8Xtx1.useFloatingNodeId)(floatingTreeRoot);
    const floatingParentNodeIdFromContext = (0, $8Xtx1.useFloatingParentNodeId)();
    const open = store.useState('open');
    const activeTriggerElement = store.useState('activeTriggerElement');
    const positionerElement = store.useState('positionerElement');
    const hoverEnabled = store.useState('hoverEnabled');
    const disabled = store.useState('disabled');
    const lastOpenChangeReason = store.useState('lastOpenChangeReason');
    const parent = store.useState('parent');
    const activeIndex = store.useState('activeIndex');
    const payload = store.useState('payload');
    const floatingParentNodeId = store.useState('floatingParentNodeId');
    const openEventRef = $8NFma.useRef(null);
    const allowOutsidePressDismissalRef = $8NFma.useRef(parent.type !== 'context-menu');
    const allowOutsidePressDismissalTimeout = (0, $5o6JF.useTimeout)();
    const allowTouchToCloseRef = $8NFma.useRef(true);
    const allowTouchToCloseTimeout = (0, $5o6JF.useTimeout)();
    const nested = floatingParentNodeId != null;
    const { openMethod: openMethod, triggerProps: interactionTypeProps } = (0, $3Fl8O.useOpenInteractionType)(open);
    store.useSyncedValues({
        disabled: disabledProp,
        highlightItemOnHover: highlightItemOnHover,
        modal: parent.type === undefined ? modalProp : undefined,
        openMethod: openMethod,
        rootId: rootId
    });
    (0, $kjC6g.useImplicitActiveTrigger)(store);
    const { forceUnmount: forceUnmount } = (0, $kjC6g.useOpenStateTransitions)(open, store, ()=>{
        store.update({
            allowMouseEnter: false,
            stickIfOpen: true
        });
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (contextMenuContext && !parentMenuRootContext) // This is a context menu root.
        // It doesn't support detached triggers yet, so we have to sync the parent context manually.
        store.update({
            parent: {
                type: 'context-menu',
                context: contextMenuContext
            },
            floatingNodeId: floatingNodeIdFromContext,
            floatingParentNodeId: floatingParentNodeIdFromContext
        });
        else if (parentMenuRootContext) store.update({
            floatingNodeId: floatingNodeIdFromContext,
            floatingParentNodeId: floatingParentNodeIdFromContext
        });
    }, [
        contextMenuContext,
        parentMenuRootContext,
        floatingNodeIdFromContext,
        floatingParentNodeIdFromContext,
        store
    ]);
    $8NFma.useEffect(()=>{
        if (!open) openEventRef.current = null;
        if (parent.type !== 'context-menu') return;
        if (!open) {
            allowOutsidePressDismissalTimeout.clear();
            allowOutsidePressDismissalRef.current = false;
            return;
        }
        // With `mousedown` outside press events and long press touch input, there
        // needs to be a grace period after opening to ensure the dismissal event
        // doesn't fire immediately after open.
        allowOutsidePressDismissalTimeout.start(500, ()=>{
            allowOutsidePressDismissalRef.current = true;
        });
    }, [
        allowOutsidePressDismissalTimeout,
        open,
        parent.type
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open && !hoverEnabled) store.set('hoverEnabled', true);
    }, [
        open,
        hoverEnabled,
        store
    ]);
    const setOpen = (0, $fKU9M.useStableCallback)((nextOpen, eventDetails)=>{
        const reason = eventDetails.reason;
        if (open === nextOpen && eventDetails.trigger === activeTriggerElement && lastOpenChangeReason === reason) return;
        const shouldPreventUnmountOnClose = (0, $kjC6g.attachPreventUnmountOnClose)(eventDetails);
        // Do not immediately reset the activeTriggerId to allow
        // exit animations to play and focus to be returned correctly.
        if (!nextOpen && eventDetails.trigger == null) eventDetails.trigger = activeTriggerElement ?? undefined;
        onOpenChange?.(nextOpen, eventDetails);
        if (eventDetails.isCanceled) return;
        store.state.floatingRootContext.dispatchOpenChange(nextOpen, eventDetails);
        const nativeEvent = eventDetails.event;
        if (nextOpen === false && nativeEvent?.type === 'click' && nativeEvent.pointerType === 'touch' && !allowTouchToCloseRef.current) return;
        // Prevent the menu from closing on mobile devices that have a delayed click event.
        // In some cases the menu, when tapped, will fire the focus event first and then the click event.
        // Without this guard, the menu will close immediately after opening.
        if (nextOpen && reason === (0, $66jhv).triggerFocus) {
            allowTouchToCloseRef.current = false;
            allowTouchToCloseTimeout.start(300, ()=>{
                allowTouchToCloseRef.current = true;
            });
        } else {
            allowTouchToCloseRef.current = true;
            allowTouchToCloseTimeout.clear();
        }
        const isKeyboardClick = (reason === (0, $66jhv).triggerPress || reason === (0, $66jhv).itemPress) && nativeEvent.detail === 0 && nativeEvent?.isTrusted;
        const isDismissClose = !nextOpen && (reason === (0, $66jhv).escapeKey || reason == null);
        const updatedState = {
            open: nextOpen,
            openChangeReason: reason
        };
        openEventRef.current = eventDetails.event ?? null;
        (0, $kjC6g.setPopupOpenState)(updatedState, nextOpen, eventDetails.trigger, shouldPreventUnmountOnClose());
        store.update(updatedState);
        if (parent.type === 'menubar' && (reason === (0, $66jhv).triggerFocus || reason === (0, $66jhv).focusOut || reason === (0, $66jhv).triggerHover || reason === (0, $66jhv).listNavigation || reason === (0, $66jhv).siblingOpen)) store.set('instantType', 'group');
        else if (isKeyboardClick || isDismissClose) store.set('instantType', isKeyboardClick ? 'click' : 'dismiss');
        else store.set('instantType', undefined);
    });
    const floatingRootContext = (0, $2t3QX.useSyncedFloatingRootContext)({
        popupStore: store,
        floatingId: floatingId,
        nested: floatingParentNodeIdFromContext != null,
        onOpenChange: setOpen
    });
    const floatingEvents = floatingRootContext.context.events;
    $8NFma.useEffect(()=>{
        const handleSetOpenEvent = ({ open: nextOpen, eventDetails: eventDetails })=>setOpen(nextOpen, eventDetails);
        floatingEvents.on('setOpen', handleSetOpenEvent);
        return ()=>{
            floatingEvents?.off('setOpen', handleSetOpenEvent);
        };
    }, [
        floatingEvents,
        setOpen
    ]);
    const handleImperativeClose = $8NFma.useCallback(()=>{
        store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).imperativeAction));
    }, [
        store
    ]);
    $8NFma.useImperativeHandle(actionsRef, ()=>({
            unmount: forceUnmount,
            close: handleImperativeClose
        }), [
        forceUnmount,
        handleImperativeClose
    ]);
    let ctx;
    if (parent.type === 'context-menu') ctx = parent.context;
    $8NFma.useImperativeHandle(ctx?.positionerRef, ()=>positionerElement, [
        positionerElement
    ]);
    $8NFma.useImperativeHandle(ctx?.actionsRef, ()=>({
            setOpen: setOpen
        }), [
        setOpen
    ]);
    const dismiss = (0, $bfyYf.useDismiss)(floatingRootContext, {
        enabled: !disabled,
        bubbles: {
            escapeKey: closeParentOnEsc && parent.type === 'menu'
        },
        outsidePress () {
            if (parent.type !== 'context-menu' || openEventRef.current?.type === 'contextmenu') return true;
            return allowOutsidePressDismissalRef.current;
        },
        externalTree: nested ? floatingTreeRoot : undefined
    });
    const direction = (0, $jSzfV.useDirection)();
    const setActiveIndex = $8NFma.useCallback((index)=>{
        if (store.select('activeIndex') === index) return;
        store.set('activeIndex', index);
    }, [
        store
    ]);
    const listNavigation = (0, $7VEf7.useListNavigation)(floatingRootContext, {
        enabled: !disabled,
        listRef: store.context.itemDomElements,
        activeIndex: activeIndex,
        nested: parent.type !== undefined,
        loopFocus: loopFocus,
        orientation: orientation,
        parentOrientation: parent.type === 'menubar' ? parent.context.orientation : undefined,
        rtl: direction === 'rtl',
        disabledIndices: (0, $jWAMz.EMPTY_ARRAY),
        onNavigate: setActiveIndex,
        openOnArrowKeyDown: parent.type !== 'context-menu',
        externalTree: nested ? floatingTreeRoot : undefined,
        focusItemOnHover: highlightItemOnHover
    });
    const onTyping = $8NFma.useCallback((nextTyping)=>{
        store.context.typingRef.current = nextTyping;
    }, [
        store
    ]);
    const typeahead = (0, $hEYuq.useTypeahead)(floatingRootContext, {
        enabled: !disabled,
        listRef: store.context.itemLabels,
        elementsRef: store.context.itemDomElements,
        activeIndex: activeIndex,
        resetMs: (0, $cTo2e.TYPEAHEAD_RESET_MS),
        onMatch: (index)=>{
            if (open && index !== activeIndex) store.set('activeIndex', index);
        },
        onTyping: onTyping
    });
    const activeTriggerProps = $8NFma.useMemo(()=>{
        const mergedProps = (0, $eFu2T.mergeProps)(typeahead.reference, listNavigation.reference, dismiss.reference, {
            onMouseMove () {
                store.set('allowMouseEnter', true);
            }
        }, interactionTypeProps);
        mergedProps['aria-haspopup'] = 'menu';
        mergedProps['aria-expanded'] = open;
        return mergedProps;
    }, [
        store,
        typeahead.reference,
        listNavigation.reference,
        dismiss.reference,
        interactionTypeProps,
        open
    ]);
    const inactiveTriggerProps = $8NFma.useMemo(()=>{
        const mergedProps = (0, $eFu2T.mergeProps)(listNavigation.trigger, dismiss.trigger, interactionTypeProps);
        mergedProps['aria-haspopup'] = 'menu';
        mergedProps['aria-expanded'] = false;
        return mergedProps;
    }, [
        listNavigation.trigger,
        dismiss.trigger,
        interactionTypeProps
    ]);
    const popupProps = $8NFma.useMemo(()=>(0, $eFu2T.mergeProps)((0, $kjC6g.FOCUSABLE_POPUP_PROPS), {
            id: floatingId,
            role: 'menu',
            'aria-labelledby': activeTriggerElement?.id,
            onMouseMove () {
                store.set('allowMouseEnter', true);
                if (parent.type === 'menu') store.set('hoverEnabled', false);
            },
            onClick () {
                if (store.select('hoverEnabled')) store.set('hoverEnabled', false);
            },
            onKeyDown (event) {
                // The Menubar's CompositeRoot captures keyboard events via
                // event delegation. This works well when Menu.Root is nested inside Menubar,
                // but with detached triggers we need to manually forward the event to the CompositeRoot.
                const relay = store.select('keyboardEventRelay');
                if (relay && !event.isPropagationStopped()) relay(event);
            }
        }, typeahead.floating, listNavigation.floating, dismiss.floating), [
        activeTriggerElement,
        floatingId,
        parent.type,
        store,
        typeahead.floating,
        listNavigation.floating,
        dismiss.floating
    ]);
    const itemProps = listNavigation.item ?? (0, $jWAMz.EMPTY_OBJECT);
    (0, $kjC6g.usePopupInteractionProps)(store, {
        floatingRootContext: floatingRootContext,
        activeTriggerProps: activeTriggerProps,
        inactiveTriggerProps: inactiveTriggerProps,
        popupProps: popupProps,
        itemProps: itemProps
    });
    const context = $8NFma.useMemo(()=>({
            store: store,
            parent: parentFromContext
        }), [
        store,
        parentFromContext
    ]);
    const content = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jtR97.MenuRootContext).Provider, {
        value: context,
        children: typeof children === 'function' ? children({
            payload: payload
        }) : children
    });
    if (parent.type === undefined || parent.type === 'context-menu') // set up a FloatingTree to provide the context to nested menus
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8Xtx1.FloatingTree), {
        externalTree: floatingTreeRoot,
        children: content
    });
    return content;
});

});
parcelRegister("bfyYf", function(module, exports) {

$parcel$export(module.exports, "useDismiss", () => $cd875440f0c54bf6$export$fcdf1ba5fafc089b);

var $8NFma = parcelRequire("8NFma");

var $cbA4H = parcelRequire("cbA4H");

var $8v2Os = parcelRequire("8v2Os");

var $8shn9 = parcelRequire("8shn9");

var $fKU9M = parcelRequire("fKU9M");

var $5o6JF = parcelRequire("5o6JF");

var $1D9S2 = parcelRequire("1D9S2");

var $8QwT3 = parcelRequire("8QwT3");

var $8Xtx1 = parcelRequire("8Xtx1");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $561ed = parcelRequire("561ed");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $klAiy = parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");

var $18t8v = parcelRequire("18t8v");

var $kS7mH = parcelRequire("kS7mH");
'use client';
function $cd875440f0c54bf6$var$alwaysFalse() {
    return false;
}
function $cd875440f0c54bf6$export$8772f90ea49c204(normalizable) {
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : normalizable?.escapeKey ?? false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : normalizable?.outsidePress ?? true
    };
}
function $cd875440f0c54bf6$export$fcdf1ba5fafc089b(context, props = {}) {
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: outsidePressProp = true, outsidePressEvent: outsidePressEvent = 'sloppy', referencePress: referencePress = $cd875440f0c54bf6$var$alwaysFalse, bubbles: bubbles, externalTree: externalTree } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const open = store.useState('open');
    const floatingElement = store.useState('floatingElement');
    const { dataRef: dataRef } = store.context;
    const tree = (0, $8Xtx1.useFloatingTree)(externalTree);
    const outsidePressFn = (0, $fKU9M.useStableCallback)(typeof outsidePressProp === 'function' ? outsidePressProp : ()=>false);
    const outsidePress = typeof outsidePressProp === 'function' ? outsidePressFn : outsidePressProp;
    const outsidePressEnabled = outsidePress !== false;
    const getOutsidePressEventProp = (0, $fKU9M.useStableCallback)(()=>outsidePressEvent);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $cd875440f0c54bf6$export$8772f90ea49c204(bubbles);
    const pressStartedInsideRef = $8NFma.useRef(false);
    const pressStartPreventedRef = $8NFma.useRef(false);
    // Ignore only the very next outside click after dragging from inside to outside.
    const suppressNextOutsideClickRef = $8NFma.useRef(false);
    const isComposingRef = $8NFma.useRef(false);
    const currentPointerTypeRef = $8NFma.useRef('');
    const touchStateRef = $8NFma.useRef(null);
    const cancelDismissOnEndTimeout = (0, $5o6JF.useTimeout)();
    const clearInsideReactTreeTimeout = (0, $5o6JF.useTimeout)();
    const clearInsideReactTree = (0, $fKU9M.useStableCallback)(()=>{
        clearInsideReactTreeTimeout.clear();
        dataRef.current.insideReactTree = false;
    });
    const hasBlockingChild = (0, $fKU9M.useStableCallback)((bubbleKey)=>{
        const nodeId = dataRef.current.floatingContext?.nodeId;
        const children = tree ? (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        return children.some((child)=>child.context?.open && !child.context.dataRef.current[bubbleKey]);
    });
    const isEventWithinOwnElements = (0, $fKU9M.useStableCallback)((event)=>{
        return (0, $klAiy.isEventTargetWithin)(event, store.select('floatingElement')) || (0, $klAiy.isEventTargetWithin)(event, store.select('domReferenceElement'));
    });
    const closeOnReferencePress = (0, $fKU9M.useStableCallback)((event)=>{
        if (!referencePress()) return;
        store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerPress, event.nativeEvent));
    });
    const closeOnEscapeKeyDown = (0, $fKU9M.useStableCallback)((event)=>{
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        if (!escapeKeyBubbles && hasBlockingChild('__escapeKeyBubbles')) return;
        const native = (0, $18t8v.isReactEvent)(event) ? event.nativeEvent : event;
        const eventDetails = (0, $6e5YN.createChangeEventDetails)((0, $66jhv).escapeKey, native);
        store.setOpen(false, eventDetails);
        if (!eventDetails.isCanceled) event.preventDefault();
        if (!escapeKeyBubbles && !eventDetails.isPropagationAllowed) event.stopPropagation();
    });
    const markInsideReactTree = (0, $fKU9M.useStableCallback)(()=>{
        dataRef.current.insideReactTree = true;
        clearInsideReactTreeTimeout.start(0, clearInsideReactTree);
    });
    const markPressStartedInsideReactTree = (0, $fKU9M.useStableCallback)((event)=>{
        if (!open || !enabled || event.button !== 0) return;
        const target = (0, $1Pbuv.getTarget)(event.nativeEvent);
        // Only treat presses that start within the floating DOM subtree as inside.
        // This avoids suppressing parent dismissal when interacting with nested portals.
        if (!(0, $1Pbuv.contains)(store.select('floatingElement'), target)) return;
        if (!pressStartedInsideRef.current) {
            pressStartedInsideRef.current = true;
            pressStartPreventedRef.current = false;
        }
    });
    const markInsidePressStartPrevented = (0, $fKU9M.useStableCallback)((event)=>{
        if (!open || !enabled) return;
        if (!(event.defaultPrevented || event.nativeEvent.defaultPrevented)) return;
        if (pressStartedInsideRef.current) pressStartPreventedRef.current = true;
    });
    $8NFma.useEffect(()=>{
        if (!open || !enabled) return undefined;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        const compositionTimeout = new (0, $5o6JF.Timeout)();
        const preventedPressSuppressionTimeout = new (0, $5o6JF.Timeout)();
        function handleCompositionStart() {
            compositionTimeout.clear();
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout.start(// 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $8QwT3).engine.webkit ? 5 : 0, ()=>{
                isComposingRef.current = false;
            });
        }
        function suppressImmediateOutsideClickAfterPreventedStart() {
            suppressNextOutsideClickRef.current = true;
            // Firefox can emit the synthetic outside click in a later task after
            // pointer lock exit, so microtask clearing is too early here.
            preventedPressSuppressionTimeout.start(0, ()=>{
                suppressNextOutsideClickRef.current = false;
            });
        }
        function resetPressStartState() {
            pressStartedInsideRef.current = false;
            pressStartPreventedRef.current = false;
        }
        function getOutsidePressEvent() {
            const type = currentPointerTypeRef.current;
            const computedType = type === 'pen' || !type ? 'mouse' : type;
            const outsidePressEventValue = getOutsidePressEventProp();
            const resolved = typeof outsidePressEventValue === 'function' ? outsidePressEventValue() : outsidePressEventValue;
            if (typeof resolved === 'string') return resolved;
            return resolved[computedType];
        }
        function shouldIgnoreEvent(event) {
            const computedOutsidePressEvent = getOutsidePressEvent();
            return computedOutsidePressEvent === 'intentional' && event.type !== 'click' || computedOutsidePressEvent === 'sloppy' && event.type === 'click';
        }
        function isEventWithinFloatingTree(event) {
            const nodeId = dataRef.current.floatingContext?.nodeId;
            const targetIsInsideChildren = tree && (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, nodeId).some((node)=>(0, $klAiy.isEventTargetWithin)(event, node.context?.elements.floating));
            return isEventWithinOwnElements(event) || targetIsInsideChildren;
        }
        function closeOnPressOutside(event) {
            if (shouldIgnoreEvent(event)) {
                // A new press began outside the floating element and its trigger. Clear any
                // leftover drag-out suppression so this press's eventual click can dismiss.
                if (event.type !== 'click' && !isEventWithinOwnElements(event)) {
                    preventedPressSuppressionTimeout.clear();
                    suppressNextOutsideClickRef.current = false;
                }
                clearInsideReactTree();
                return;
            }
            if (dataRef.current.insideReactTree) {
                clearInsideReactTree();
                return;
            }
            const target = (0, $1Pbuv.getTarget)(event);
            const inertSelector = `[${(0, $561ed.createAttribute)('inert')}]`;
            const targetRoot = (0, $1D9S2.isElement)(target) ? target.getRootNode() : null;
            const markers = Array.from(((0, $1D9S2.isShadowRoot)(targetRoot) ? targetRoot : (0, $8shn9.ownerDocument)(store.select('floatingElement'))).querySelectorAll(inertSelector));
            const triggers = store.context.triggerElements;
            // If another trigger is clicked, don't close the floating element.
            if (target && (triggers.hasElement(target) || triggers.hasMatchingElement((trigger)=>(0, $1Pbuv.contains)(trigger, target)))) return;
            let targetRootAncestor = (0, $1D9S2.isElement)(target) ? target : null;
            while(targetRootAncestor && !(0, $1D9S2.isLastTraversableNode)(targetRootAncestor)){
                const nextParent = (0, $1D9S2.getParentNode)(targetRootAncestor);
                if ((0, $1D9S2.isLastTraversableNode)(nextParent) || !(0, $1D9S2.isElement)(nextParent)) break;
                targetRootAncestor = nextParent;
            }
            // Check if the click occurred on a third-party element injected after the
            // floating element rendered.
            if (markers.length && (0, $1D9S2.isElement)(target) && !(0, $klAiy.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
            !(0, $1Pbuv.contains)(target, store.select('floatingElement')) && // If the target root element contains none of the markers, then the
            // element was injected after the floating element rendered.
            markers.every((marker)=>!(0, $1Pbuv.contains)(targetRootAncestor, marker))) return;
            // Check if the click occurred on the scrollbar
            // Skip for touch events: scrollbars don't receive touch events on most platforms
            if ((0, $1D9S2.isHTMLElement)(target) && !('touches' in event)) {
                const lastTraversableNode = (0, $1D9S2.isLastTraversableNode)(target);
                const style = (0, $1D9S2.getComputedStyle)(target);
                const scrollRe = /auto|scroll/;
                const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
                const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
                const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
                const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
                const isRTL = style.direction === 'rtl';
                // Check click position relative to scrollbar.
                // In some browsers it is possible to change the <body> (or window)
                // scrollbar to the left side, but is very rare and is difficult to
                // check for. Plus, for modal dialogs with backdrops, it is more
                // important that the backdrop is checked but not so much the window.
                const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
                const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
                if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
            }
            if (isEventWithinFloatingTree(event)) return;
            // In intentional mode, a press that starts inside and ends outside gets
            // one suppressed outside click. Run this after inside-target checks so
            // inside clicks don't consume the one-shot suppression.
            if (getOutsidePressEvent() === 'intentional' && suppressNextOutsideClickRef.current) {
                preventedPressSuppressionTimeout.clear();
                suppressNextOutsideClickRef.current = false;
                return;
            }
            if (typeof outsidePress === 'function' && !outsidePress(event)) return;
            if (hasBlockingChild('__outsidePressBubbles')) return;
            store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).outsidePress, event));
            clearInsideReactTree();
        }
        function handlePointerDown(event) {
            if (getOutsidePressEvent() !== 'sloppy' || event.pointerType === 'touch' || !store.select('open') || !enabled || isEventWithinOwnElements(event)) return;
            closeOnPressOutside(event);
        }
        function handleTouchStart(event) {
            if (getOutsidePressEvent() !== 'sloppy' || !store.select('open') || !enabled || isEventWithinOwnElements(event)) return;
            const touch = event.touches[0];
            if (touch) {
                touchStateRef.current = {
                    startTime: Date.now(),
                    startX: touch.clientX,
                    startY: touch.clientY,
                    dismissOnTouchEnd: false,
                    dismissOnMouseDown: true
                };
                cancelDismissOnEndTimeout.start(1000, ()=>{
                    if (touchStateRef.current) {
                        touchStateRef.current.dismissOnTouchEnd = false;
                        touchStateRef.current.dismissOnMouseDown = false;
                    }
                });
            }
        }
        function addTargetEventListenerOnce(event, listener) {
            const target = (0, $1Pbuv.getTarget)(event);
            if (!target) return;
            const unsubscribe = (0, $cbA4H.addEventListener)(target, event.type, ()=>{
                listener(event);
                unsubscribe();
            });
        }
        function handleTouchStartCapture(event) {
            currentPointerTypeRef.current = 'touch';
            addTargetEventListenerOnce(event, handleTouchStart);
        }
        function closeOnPressOutsideCapture(event) {
            cancelDismissOnEndTimeout.clear();
            if (event.type === 'pointerdown') currentPointerTypeRef.current = event.pointerType;
            if (event.type === 'mousedown' && touchStateRef.current && !touchStateRef.current.dismissOnMouseDown) return;
            addTargetEventListenerOnce(event, (targetEvent)=>{
                if (targetEvent.type === 'pointerdown') handlePointerDown(targetEvent);
                else closeOnPressOutside(targetEvent);
            });
        }
        function handlePressEndCapture(event) {
            if (!pressStartedInsideRef.current) return;
            const pressStartedInsideDefaultPrevented = pressStartPreventedRef.current;
            resetPressStartState();
            if (getOutsidePressEvent() !== 'intentional') return;
            if (event.type === 'pointercancel') {
                if (pressStartedInsideDefaultPrevented) suppressImmediateOutsideClickAfterPreventedStart();
                return;
            }
            if (isEventWithinFloatingTree(event)) return;
            // If pointerdown was prevented, no click may be generated for that
            // interaction. However, Firefox may still emit an immediate click after
            // pointerup (e.g. NumberField scrub with pointer lock), so suppress for
            // one tick to absorb that synthetic click only.
            if (pressStartedInsideDefaultPrevented) {
                suppressImmediateOutsideClickAfterPreventedStart();
                return;
            }
            // Avoid suppressing when outsidePress explicitly ignores this target.
            if (typeof outsidePress === 'function' && !outsidePress(event)) return;
            preventedPressSuppressionTimeout.clear();
            suppressNextOutsideClickRef.current = true;
            clearInsideReactTree();
        }
        function handleTouchMove(event) {
            if (getOutsidePressEvent() !== 'sloppy' || !touchStateRef.current || isEventWithinOwnElements(event)) return;
            const touch = event.touches[0];
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - touchStateRef.current.startX);
            const deltaY = Math.abs(touch.clientY - touchStateRef.current.startY);
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            if (distance > 5) touchStateRef.current.dismissOnTouchEnd = true;
            if (distance > 10) {
                closeOnPressOutside(event);
                cancelDismissOnEndTimeout.clear();
                touchStateRef.current = null;
            }
        }
        function handleTouchMoveCapture(event) {
            addTargetEventListenerOnce(event, handleTouchMove);
        }
        function handleTouchEnd(event) {
            if (getOutsidePressEvent() !== 'sloppy' || !touchStateRef.current || isEventWithinOwnElements(event)) return;
            if (touchStateRef.current.dismissOnTouchEnd) closeOnPressOutside(event);
            cancelDismissOnEndTimeout.clear();
            touchStateRef.current = null;
        }
        function handleTouchEndCapture(event) {
            addTargetEventListenerOnce(event, handleTouchEnd);
        }
        const doc = (0, $8shn9.ownerDocument)(floatingElement);
        const unsubscribe = (0, $8v2Os.mergeCleanups)(escapeKey && (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(doc, 'keydown', closeOnEscapeKeyDown), (0, $cbA4H.addEventListener)(doc, 'compositionstart', handleCompositionStart), (0, $cbA4H.addEventListener)(doc, 'compositionend', handleCompositionEnd)), outsidePressEnabled && (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(doc, 'click', closeOnPressOutsideCapture, true), (0, $cbA4H.addEventListener)(doc, 'pointerdown', closeOnPressOutsideCapture, true), (0, $cbA4H.addEventListener)(doc, 'pointerup', handlePressEndCapture, true), (0, $cbA4H.addEventListener)(doc, 'pointercancel', handlePressEndCapture, true), (0, $cbA4H.addEventListener)(doc, 'mousedown', closeOnPressOutsideCapture, true), (0, $cbA4H.addEventListener)(doc, 'mouseup', handlePressEndCapture, true), (0, $cbA4H.addEventListener)(doc, 'touchstart', handleTouchStartCapture, true), (0, $cbA4H.addEventListener)(doc, 'touchmove', handleTouchMoveCapture, true), (0, $cbA4H.addEventListener)(doc, 'touchend', handleTouchEndCapture, true)));
        return ()=>{
            unsubscribe();
            compositionTimeout.clear();
            preventedPressSuppressionTimeout.clear();
            resetPressStartState();
            suppressNextOutsideClickRef.current = false;
        };
    }, [
        dataRef,
        floatingElement,
        escapeKey,
        outsidePressEnabled,
        outsidePress,
        open,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        clearInsideReactTree,
        getOutsidePressEventProp,
        hasBlockingChild,
        isEventWithinOwnElements,
        tree,
        store,
        cancelDismissOnEndTimeout
    ]);
    $8NFma.useEffect(clearInsideReactTree, [
        outsidePress,
        clearInsideReactTree
    ]);
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onPointerDown: closeOnReferencePress,
            onClick: closeOnReferencePress
        }), [
        closeOnEscapeKeyDown,
        closeOnReferencePress
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            // `onMouseDown` may be blocked if `event.preventDefault()` is called in
            // `onPointerDown`, such as with <NumberField.ScrubArea>.
            // See https://github.com/mui/base-ui/pull/3379
            onPointerDown: markInsidePressStartPrevented,
            onMouseDown: markInsidePressStartPrevented,
            onClickCapture: markInsideReactTree,
            onMouseDownCapture (event) {
                markInsideReactTree();
                markPressStartedInsideReactTree(event);
            },
            onPointerDownCapture (event) {
                markInsideReactTree();
                markPressStartedInsideReactTree(event);
            },
            onMouseUpCapture: markInsideReactTree,
            onTouchEndCapture: markInsideReactTree,
            onTouchMoveCapture: markInsideReactTree
        }), [
        closeOnEscapeKeyDown,
        markInsideReactTree,
        markPressStartedInsideReactTree,
        markInsidePressStartPrevented
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            trigger: reference
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}

});

parcelRegister("7VEf7", function(module, exports) {

$parcel$export(module.exports, "useListNavigation", () => $c55604dac98f3c61$export$b5d22cac4ad33f40);

var $8NFma = parcelRequire("8NFma");

var $dhRNQ = parcelRequire("dhRNQ");

var $9N3e2 = parcelRequire("9N3e2");

var $8shn9 = parcelRequire("8shn9");

var $fKU9M = parcelRequire("fKU9M");

var $eiwl7 = parcelRequire("eiwl7");

var $1D9S2 = parcelRequire("1D9S2");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $8Xtx1 = parcelRequire("8Xtx1");

var $4qeT1 = parcelRequire("4qeT1");

var $aJh1u = parcelRequire("aJh1u");

var $1Pbuv = parcelRequire("1Pbuv");parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $klAiy = parcelRequire("klAiy");

var $1pnbo = parcelRequire("1pnbo");

var $18t8v = parcelRequire("18t8v");
'use client';
const $c55604dac98f3c61$export$2bb790b9008907b4 = 'Escape';
function $c55604dac98f3c61$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $c55604dac98f3c61$var$isMainOrientationKey(key, orientation) {
    const vertical = key === (0, $aJh1u.ARROW_UP) || key === (0, $aJh1u.ARROW_DOWN);
    const horizontal = key === (0, $aJh1u.ARROW_LEFT) || key === (0, $aJh1u.ARROW_RIGHT);
    return $c55604dac98f3c61$var$doSwitch(orientation, vertical, horizontal);
}
function $c55604dac98f3c61$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === (0, $aJh1u.ARROW_DOWN);
    const horizontal = rtl ? key === (0, $aJh1u.ARROW_LEFT) : key === (0, $aJh1u.ARROW_RIGHT);
    return $c55604dac98f3c61$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $c55604dac98f3c61$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === (0, $aJh1u.ARROW_LEFT) : key === (0, $aJh1u.ARROW_RIGHT);
    const horizontal = key === (0, $aJh1u.ARROW_DOWN);
    return $c55604dac98f3c61$var$doSwitch(orientation, vertical, horizontal);
}
function $c55604dac98f3c61$var$isCrossOrientationCloseKey(key, orientation, rtl, grid) {
    const vertical = rtl ? key === (0, $aJh1u.ARROW_RIGHT) : key === (0, $aJh1u.ARROW_LEFT);
    const horizontal = key === (0, $aJh1u.ARROW_UP);
    if (orientation === 'both' || orientation === 'horizontal' && grid) return key === $c55604dac98f3c61$export$2bb790b9008907b4;
    return $c55604dac98f3c61$var$doSwitch(orientation, vertical, horizontal);
}
function $c55604dac98f3c61$export$b5d22cac4ad33f40(context, props) {
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: onNavigateProp = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loopFocus: loopFocus = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, id: id, resetOnPointerLeave: resetOnPointerLeave = true, externalTree: externalTree, grid: navigateGrid } = props;
    const isGrid = navigateGrid != null;
    const store = 'rootStore' in context ? context.rootStore : context;
    const open = store.useState('open');
    const floatingElement = store.useState('floatingElement');
    const domReferenceElement = store.useState('domReferenceElement');
    const dataRef = store.context.dataRef;
    const floatingFocusElement = (0, $klAiy.getFloatingFocusElement)(floatingElement);
    const typeableComboboxReference = (0, $klAiy.isTypeableCombobox)(domReferenceElement);
    const floatingFocusElementRef = (0, $eiwl7.useValueAsRef)(floatingFocusElement);
    const parentId = (0, $8Xtx1.useFloatingParentNodeId)();
    const tree = (0, $8Xtx1.useFloatingTree)(externalTree);
    const focusItemOnOpenRef = $8NFma.useRef(focusItemOnOpen);
    const indexRef = $8NFma.useRef(selectedIndex ?? -1);
    const keyRef = $8NFma.useRef(null);
    const isPointerModalityRef = $8NFma.useRef(true);
    const onNavigate = (0, $fKU9M.useStableCallback)((event)=>{
        onNavigateProp(indexRef.current === -1 ? null : indexRef.current, event);
    });
    const previousMountedRef = $8NFma.useRef(!!floatingElement);
    const previousOpenRef = $8NFma.useRef(open);
    const forceSyncFocusRef = $8NFma.useRef(false);
    const forceScrollIntoViewRef = $8NFma.useRef(false);
    const cancelQueuedFocusRef = $8NFma.useRef(null);
    const disabledIndicesRef = (0, $eiwl7.useValueAsRef)(disabledIndices);
    const latestOpenRef = (0, $eiwl7.useValueAsRef)(open);
    const selectedIndexRef = (0, $eiwl7.useValueAsRef)(selectedIndex);
    const resetOnPointerLeaveRef = (0, $eiwl7.useValueAsRef)(resetOnPointerLeave);
    const focusFrame = (0, $dhRNQ.useAnimationFrame)();
    const waitForListPopulatedFrame = (0, $dhRNQ.useAnimationFrame)();
    const focusItem = (0, $fKU9M.useStableCallback)(()=>{
        function runFocus(item) {
            if (virtual) tree?.events.emit('virtualfocus', item);
            else cancelQueuedFocusRef.current = (0, $1pnbo.enqueueFocus)(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (callback)=>callback() : (callback)=>focusFrame.request(callback);
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const shouldScrollIntoView = // eslint-disable-next-line @typescript-eslint/no-use-before-define
            item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView?.({
                block: 'nearest',
                inline: 'nearest'
            });
        });
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        dataRef.current.orientation = orientation;
    }, [
        dataRef,
        orientation
    ]);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled) return;
        if (open && floatingElement) {
            indexRef.current = selectedIndex ?? -1;
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Reset the active index when the list is no longer open and mounted (closing or
            // unmounting). `onNavigate` is a stable callback that always forwards to the latest
            // `onNavigate` prop.
            indexRef.current = -1;
            onNavigate();
        }
    }, [
        enabled,
        open,
        floatingElement,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) {
            forceSyncFocusRef.current = false;
            return;
        }
        if (!floatingElement) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? (callback)=>waitForListPopulatedFrame.request(callback) : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs += 1;
                    } else {
                        // Initially focus the first non-disabled item. `disabledIndices` is deliberately
                        // omitted here so attribute-disabled items (`disabled`/`aria-disabled`) are skipped
                        // on open even when the consumer passes an empty `disabledIndices` array. Passing it
                        // would regress that behavior (see mui/base-ui#2604).
                        indexRef.current = keyRef.current == null || $c55604dac98f3c61$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $4qeT1.getMinListIndex)(listRef) : (0, $4qeT1.getMaxListIndex)(listRef);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $4qeT1.isIndexOutOfListBounds)(listRef.current, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        floatingElement,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        waitForListPopulatedFrame
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!enabled || floatingElement || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = nodes.find((node)=>node.id === parentId)?.context?.elements.floating;
        // `floatingElement` is null here (see the guard above), so resolve the owner document from an
        // in-DOM element for realm-safety (shadow DOM/iframes): the reference element, falling back to
        // the parent floating element when the reference is virtual (`domReferenceElement` is null).
        const activeEl = (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(domReferenceElement ?? parent ?? null));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $1Pbuv.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        floatingElement,
        domReferenceElement,
        tree,
        parentId,
        virtual
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        previousOpenRef.current = open;
        previousMountedRef.current = !!floatingElement;
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const syncCurrentTarget = (0, $fKU9M.useStableCallback)((event)=>{
        if (!latestOpenRef.current) return;
        const index = listRef.current.indexOf(event.currentTarget);
        if (index !== -1 && (indexRef.current !== index || activeIndex !== index)) {
            indexRef.current = index;
            onNavigate(event);
        }
    });
    const getParentOrientation = (0, $fKU9M.useStableCallback)(()=>{
        return parentOrientation ?? tree?.nodesRef.current.find((node)=>node.id === parentId)?.context?.dataRef?.current.orientation;
    });
    const getMinEnabledIndex = (0, $fKU9M.useStableCallback)(()=>{
        return (0, $4qeT1.getMinListIndex)(listRef, disabledIndicesRef.current);
    });
    const commonOnKeyDown = (0, $fKU9M.useStableCallback)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $c55604dac98f3c61$var$isCrossOrientationCloseKey(event.key, orientation, rtl, isGrid)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$c55604dac98f3c61$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $18t8v.stopEvent)(event);
            store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).listNavigation, event.nativeEvent));
            if ((0, $1D9S2.isHTMLElement)(domReferenceElement)) {
                if (virtual) tree?.events.emit('virtualfocus', domReferenceElement);
                else domReferenceElement.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $4qeT1.getMinListIndex)(listRef, disabledIndices);
        const maxIndex = (0, $4qeT1.getMaxListIndex)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $18t8v.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(event);
            }
            if (event.key === 'End') {
                (0, $18t8v.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(event);
            }
        }
        // Grid navigation is injected by grid-capable consumers so non-grid
        // consumers (menu, select) tree-shake the grid helpers out.
        if (navigateGrid != null) {
            const index = navigateGrid(event, indexRef.current, listRef, orientation, loopFocus, rtl, disabledIndices, minIndex, maxIndex);
            if (index != null) {
                indexRef.current = index;
                onNavigate(event);
            }
            if (orientation === 'both') return;
        }
        if ($c55604dac98f3c61$var$isMainOrientationKey(event.key, orientation)) {
            (0, $18t8v.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $1Pbuv.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $c55604dac98f3c61$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(event);
                return;
            }
            if ($c55604dac98f3c61$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loopFocus) {
                    if (currentIndex >= maxIndex) {
                        if (allowEscape && currentIndex !== listRef.current.length) indexRef.current = -1;
                        else {
                            // Give time for virtualizers to update the listRef.
                            forceSyncFocusRef.current = false;
                            indexRef.current = minIndex;
                        }
                    } else indexRef.current = (0, $4qeT1.findNonDisabledListIndex)(listRef.current, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                } else indexRef.current = Math.min(maxIndex, (0, $4qeT1.findNonDisabledListIndex)(listRef.current, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loopFocus) {
                if (currentIndex <= minIndex) {
                    if (allowEscape && currentIndex !== -1) indexRef.current = listRef.current.length;
                    else {
                        // Give time for virtualizers to update the listRef.
                        forceSyncFocusRef.current = false;
                        indexRef.current = maxIndex;
                    }
                } else indexRef.current = (0, $4qeT1.findNonDisabledListIndex)(listRef.current, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else indexRef.current = Math.max(minIndex, (0, $4qeT1.findNonDisabledListIndex)(listRef.current, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $4qeT1.isIndexOutOfListBounds)(listRef.current, indexRef.current)) indexRef.current = -1;
            onNavigate(event);
        }
    });
    const item = $8NFma.useMemo(()=>{
        const itemProps = {
            onFocus (event) {
                forceSyncFocusRef.current = true;
                syncCurrentTarget(event);
            },
            onClick: ({ currentTarget: currentTarget })=>currentTarget.focus({
                    preventScroll: true
                }),
            // Safari
            onMouseMove (event) {
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(event);
            },
            onPointerLeave (event) {
                if (!latestOpenRef.current || !isPointerModalityRef.current || event.pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                const relatedTarget = event.relatedTarget;
                if (!focusItemOnHover || listRef.current.includes(relatedTarget)) return;
                if (!resetOnPointerLeaveRef.current) return;
                cancelQueuedFocusRef.current?.();
                cancelQueuedFocusRef.current = null;
                indexRef.current = -1;
                onNavigate(event);
                if (!virtual) {
                    const floatingFocusEl = floatingFocusElementRef.current;
                    const activeEl = (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(floatingFocusEl));
                    if (floatingFocusEl && (0, $1Pbuv.contains)(floatingFocusEl, activeEl)) floatingFocusEl.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return itemProps;
    }, [
        syncCurrentTarget,
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        resetOnPointerLeaveRef,
        virtual
    ]);
    const ariaActiveDescendantProp = $8NFma.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': `${id}-${activeIndex}`
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        id,
        activeIndex
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown (event) {
                // Close submenu on Shift+Tab
                if (event.key === 'Tab' && event.shiftKey && open && !virtual) {
                    // If the event originated from within a nested element (e.g., a Dialog opened from
                    // within the menu), don't close the menu. The nested element has its own focus
                    // management and should handle the Tab key.
                    const target = (0, $1Pbuv.getTarget)(event.nativeEvent);
                    if (target && !(0, $1Pbuv.contains)(floatingFocusElementRef.current, target)) return;
                    (0, $18t8v.stopEvent)(event);
                    store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).focusOut, event.nativeEvent));
                    if ((0, $1D9S2.isHTMLElement)(domReferenceElement)) domReferenceElement.focus();
                    return;
                }
                commonOnKeyDown(event);
            },
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        floatingFocusElementRef,
        orientation,
        typeableComboboxReference,
        store,
        open,
        virtual,
        domReferenceElement
    ]);
    const trigger = $8NFma.useMemo(()=>{
        function openOnNavigationKeyDown(event) {
            store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).listNavigation, event.nativeEvent, event.currentTarget));
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $18t8v.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = !virtual;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $18t8v.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            onKeyDown (event) {
                // non-reactive open state (to prevent re-creation of the handler)
                const currentOpen = store.select('open');
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isParentCrossOpenKey = $c55604dac98f3c61$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $c55604dac98f3c61$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && currentOpen) return commonOnKeyDown(event);
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!currentOpen && !openOnArrowKeyDown && isArrowKey) return undefined;
                if (isNavigationKey) {
                    const isParentMainKey = $c55604dac98f3c61$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $18t8v.stopEvent)(event);
                        if (currentOpen) {
                            indexRef.current = getMinEnabledIndex();
                            onNavigate(event);
                        } else openOnNavigationKeyDown(event);
                    }
                    return undefined;
                }
                if (isMainKey) {
                    if (selectedIndexRef.current != null) indexRef.current = selectedIndexRef.current;
                    (0, $18t8v.stopEvent)(event);
                    if (!currentOpen && openOnArrowKeyDown) openOnNavigationKeyDown(event);
                    else commonOnKeyDown(event);
                    if (currentOpen) onNavigate(event);
                }
                return undefined;
            },
            onFocus (event) {
                if (store.select('open') && !virtual) {
                    indexRef.current = -1;
                    onNavigate(event);
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        commonOnKeyDown,
        focusItemOnOpen,
        getMinEnabledIndex,
        nested,
        onNavigate,
        store,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndexRef,
        virtual
    ]);
    const reference = $8NFma.useMemo(()=>{
        return {
            ...ariaActiveDescendantProp,
            ...trigger
        };
    }, [
        ariaActiveDescendantProp,
        trigger
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item,
            trigger: trigger
        } : {}, [
        enabled,
        reference,
        floating,
        trigger,
        item
    ]);
}

});

parcelRegister("2t3QX", function(module, exports) {

$parcel$export(module.exports, "useSyncedFloatingRootContext", () => $46c05702fce01635$export$5a1f41af8a18b587);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $1D9S2 = parcelRequire("1D9S2");

var $8akDT = parcelRequire("8akDT");
'use client';
function $46c05702fce01635$export$5a1f41af8a18b587(options) {
    const { popupStore: popupStore, treatPopupAsFloatingElement: treatPopupAsFloatingElement = false, floatingRootContext: floatingRootContextProp, floatingId: floatingId, nested: nested, onOpenChange: onOpenChange } = options;
    const open = popupStore.useState('open');
    const referenceElement = popupStore.useState('activeTriggerElement');
    const floatingElement = popupStore.useState(treatPopupAsFloatingElement ? 'popupElement' : 'positionerElement');
    const triggerElements = popupStore.context.triggerElements;
    const handleOpenChange = onOpenChange;
    const internalStoreRef = $8NFma.useRef(null);
    if (floatingRootContextProp === undefined && internalStoreRef.current === null) internalStoreRef.current = new (0, $8akDT.FloatingRootStore)({
        open: open,
        transitionStatus: undefined,
        referenceElement: referenceElement,
        floatingElement: floatingElement,
        triggerElements: triggerElements,
        onOpenChange: handleOpenChange,
        floatingId: floatingId,
        syncOnly: true,
        nested: nested
    });
    const store = floatingRootContextProp ?? internalStoreRef.current;
    popupStore.useSyncedValue('floatingId', floatingId);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        const valuesToSync = {
            open: open,
            floatingId: floatingId,
            referenceElement: referenceElement,
            floatingElement: floatingElement
        };
        if ((0, $1D9S2.isElement)(referenceElement)) valuesToSync.domReferenceElement = referenceElement;
        if (store.state.positionReference === store.state.referenceElement) valuesToSync.positionReference = referenceElement;
        store.update(valuesToSync);
    }, [
        open,
        floatingId,
        referenceElement,
        floatingElement,
        store
    ]);
    // Keep non-reactive context values fresh for interactions that call `store.setOpen`.
    store.context.onOpenChange = handleOpenChange;
    store.context.nested = nested;
    return store;
}

});

parcelRegister("hEYuq", function(module, exports) {

$parcel$export(module.exports, "useTypeahead", () => $b81feec9d9397a22$export$d8d674d50b73ba93);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $fKU9M = parcelRequire("fKU9M");

var $5o6JF = parcelRequire("5o6JF");

var $jWAMz = parcelRequire("jWAMz");

var $4qeT1 = parcelRequire("4qeT1");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");

var $18t8v = parcelRequire("18t8v");
'use client';
function $b81feec9d9397a22$export$d8d674d50b73ba93(context, props) {
    const { listRef: listRef, elementsRef: elementsRef, activeIndex: activeIndex, onMatch: onMatchProp, disabledIndices: disabledIndices, onTyping: onTyping, enabled: enabled = true, resetMs: resetMs = 750, selectedIndex: selectedIndex = null } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const open = store.useState('open');
    const timeout = (0, $5o6JF.useTimeout)();
    const stringRef = $8NFma.useRef('');
    const prevIndexRef = $8NFma.useRef(selectedIndex ?? activeIndex ?? -1);
    const matchIndexRef = $8NFma.useRef(null);
    const onKeyDown = (0, $fKU9M.useStableCallback)((event)=>{
        function isVisible(index) {
            const element = elementsRef?.current[index];
            return !element || (0, $4qeT1.isElementVisible)(element);
        }
        function isItemAvailable(index) {
            if (!isVisible(index)) return false;
            // Visibility is handled above; pass an empty element list so `isListIndexDisabled`
            // resolves only the explicit `disabledIndices` (array/predicate) and skips its own
            // visibility/attribute fallbacks. Consumers that don't opt in keep matching every
            // visible item.
            return disabledIndices == null || !(0, $4qeT1.isListIndexDisabled)((0, $jWAMz.EMPTY_ARRAY), index, disabledIndices);
        }
        function getMatchingIndex(list, string, startIndex = 0) {
            if (list.length === 0) return -1;
            const normalizedStartIndex = (startIndex % list.length + list.length) % list.length;
            const lowerString = string.toLowerCase();
            for(let offset = 0; offset < list.length; offset += 1){
                const index = (normalizedStartIndex + offset) % list.length;
                const text = list[index];
                if (!text?.toLowerCase().startsWith(lowerString) || !isItemAvailable(index)) continue;
                return index;
            }
            return -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && event.key === ' ') {
            // Space should continue the in-progress typeahead session.
            (0, $18t8v.stopEvent)(event);
            onTyping?.(true);
        }
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, stringRef.current) === -1 && event.key !== ' ') onTyping?.(false);
        }
        if (listContent == null || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $18t8v.stopEvent)(event);
            onTyping?.(true);
        }
        // Capture whether this is a new typing session before mutating the string.
        const isNewSession = stringRef.current === '';
        if (isNewSession) prevIndexRef.current = selectedIndex ?? activeIndex ?? -1;
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too. Unavailable items are skipped while matching, so
        // they must be ignored here as well — otherwise a hidden or disabled double-letter
        // label would block rapid cycling through the available items.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text, index)=>text && isItemAvailable(index) ? text[0]?.toLowerCase() !== text[1]?.toLowerCase() : true);
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        timeout.start(resetMs, ()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            onTyping?.(false);
        });
        // Compute the starting index for this search.
        // If this is a new typing session (string is empty), base it on the current
        // selection/active item; otherwise continue from the last matched index.
        const prevIndex = isNewSession ? selectedIndex ?? activeIndex ?? -1 : prevIndexRef.current;
        const startIndex = (prevIndex ?? 0) + 1;
        const index = getMatchingIndex(listContent, stringRef.current, startIndex);
        if (index !== -1) {
            onMatchProp?.(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            onTyping?.(false);
        }
    });
    const onBlur = (0, $fKU9M.useStableCallback)((event)=>{
        const next = event.relatedTarget;
        const currentDomReferenceElement = store.select('domReferenceElement');
        const currentFloatingElement = store.select('floatingElement');
        const withinComposite = (0, $1Pbuv.contains)(currentDomReferenceElement, next) || (0, $1Pbuv.contains)(currentFloatingElement, next);
        // Keep the session if focus moves within the composite (reference <-> floating).
        if (withinComposite) return;
        // End the current typing session when focus leaves the composite entirely.
        timeout.clear();
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
        onTyping?.(false);
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open && selectedIndex !== null) return;
        timeout.clear();
        matchIndexRef.current = null;
        if (stringRef.current !== '') stringRef.current = '';
    }, [
        open,
        selectedIndex,
        timeout
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') prevIndexRef.current = selectedIndex ?? activeIndex ?? -1;
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const sharedProps = $8NFma.useMemo(()=>({
            onKeyDown: onKeyDown,
            onBlur: onBlur
        }), [
        onKeyDown,
        onBlur
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: sharedProps,
            floating: sharedProps
        } : {}, [
        enabled,
        sharedProps
    ]);
}

});

parcelRegister("9qHuC", function(module, exports) {

$parcel$export(module.exports, "useMenubarContext", () => $c9e2c319cbcf478d$export$a96d9182603d794d);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");
'use client';
const $c9e2c319cbcf478d$export$8f982c862a51d245 = /*#__PURE__*/ $8NFma.createContext(null);
function $c9e2c319cbcf478d$export$a96d9182603d794d(optional) {
    const context = $8NFma.useContext($c9e2c319cbcf478d$export$8f982c862a51d245);
    if (context === null && !optional) throw new Error((0, $cmjqX.default)(5));
    return context;
}

});

parcelRegister("3Fl8O", function(module, exports) {

$parcel$export(module.exports, "useOpenMethodTriggerProps", () => $e3da18209cb412a3$export$371c4d04ce58e506);
$parcel$export(module.exports, "useOpenInteractionType", () => $e3da18209cb412a3$export$e66f7374e5373c5d);

var $8NFma = parcelRequire("8NFma");

var $fKU9M = parcelRequire("fKU9M");

var $Lp2bF = parcelRequire("Lp2bF");

var $8QwT3 = parcelRequire("8QwT3");

var $9L0v9 = parcelRequire("9L0v9");
'use client';
function $e3da18209cb412a3$export$371c4d04ce58e506(open, setOpenMethod) {
    const handleTriggerClick = (0, $fKU9M.useStableCallback)((_, interactionType)=>{
        const isOpen = typeof open === 'function' ? open() : open;
        if (!isOpen) setOpenMethod(interactionType || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
        // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
        // will be "" in that case.
        ((0, $8QwT3).os.ios ? 'touch' : ''));
    });
    const { onClick: onClick, onPointerDown: onPointerDown } = (0, $Lp2bF.useEnhancedClickHandler)(handleTriggerClick);
    return $8NFma.useMemo(()=>({
            onClick: onClick,
            onPointerDown: onPointerDown
        }), [
        onClick,
        onPointerDown
    ]);
}
function $e3da18209cb412a3$export$e66f7374e5373c5d(open) {
    const [openMethod, setOpenMethod] = $8NFma.useState(null);
    const triggerProps = $e3da18209cb412a3$export$371c4d04ce58e506(open, setOpenMethod);
    (0, $9L0v9.useValueChanged)(open, (previousOpen)=>{
        if (previousOpen && !open) setOpenMethod(null);
    });
    return $8NFma.useMemo(()=>({
            openMethod: openMethod,
            triggerProps: triggerProps
        }), [
        openMethod,
        triggerProps
    ]);
}

});
parcelRegister("Lp2bF", function(module, exports) {

$parcel$export(module.exports, "useEnhancedClickHandler", () => $1eedb69ca1037adb$export$e12b1f26020a8f34);

var $8NFma = parcelRequire("8NFma");
'use client';
function $1eedb69ca1037adb$export$e12b1f26020a8f34(handler) {
    const lastClickInteractionTypeRef = $8NFma.useRef('');
    const handlePointerDown = $8NFma.useCallback((event)=>{
        if (event.defaultPrevented) return;
        lastClickInteractionTypeRef.current = event.pointerType;
        handler(event, event.pointerType);
    }, [
        handler
    ]);
    const handleClick = $8NFma.useCallback((event)=>{
        // event.detail has the number of clicks performed on the element. 0 means it was triggered by the keyboard.
        if (event.detail === 0) {
            handler(event, 'keyboard');
            return;
        }
        if ('pointerType' in event) // Chrome and Edge correctly use PointerEvent
        handler(event, event.pointerType);
        else handler(event, lastClickInteractionTypeRef.current);
        lastClickInteractionTypeRef.current = '';
    }, [
        handler
    ]);
    return {
        onClick: handleClick,
        onPointerDown: handlePointerDown
    };
}

});

parcelRegister("9L0v9", function(module, exports) {

$parcel$export(module.exports, "useValueChanged", () => $217726e272388582$export$48fba3795b179f87);

var $8NFma = parcelRequire("8NFma");

var $9N3e2 = parcelRequire("9N3e2");

var $fKU9M = parcelRequire("fKU9M");
'use client';
function $217726e272388582$export$48fba3795b179f87(value, onChange) {
    const valueRef = $8NFma.useRef(value);
    const onChangeCallback = (0, $fKU9M.useStableCallback)(onChange);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (valueRef.current === value) return;
        onChangeCallback(valueRef.current);
    }, [
        value,
        onChangeCallback
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
}

});


parcelRegister("2eLUt", function(module, exports) {

$parcel$export(module.exports, "MenuStore", () => $55e994c804ec1c20$export$688a30d8df3e0b9e);

var $8NFma = parcelRequire("8NFma");

var $2r4G3 = parcelRequire("2r4G3");
var $4g8mc = parcelRequire("4g8mc");

var $jWAMz = parcelRequire("jWAMz");

var $gidzQ = parcelRequire("gidzQ");

var $k3oe4 = parcelRequire("k3oe4");

var $178Yi = parcelRequire("178Yi");
var $8Ruu1 = parcelRequire("8Ruu1");
const $55e994c804ec1c20$var$selectors = {
    ...(0, $178Yi.popupStoreSelectors),
    disabled: (0, $2r4G3.createSelector)((state)=>state.parent.type === 'menubar' ? state.parent.context.disabled || state.disabled : state.disabled),
    modal: (0, $2r4G3.createSelector)((state)=>(state.parent.type === undefined || state.parent.type === 'context-menu') && (state.modal ?? true)),
    openMethod: (0, $2r4G3.createSelector)((state)=>state.openMethod),
    allowMouseEnter: (0, $2r4G3.createSelector)((state)=>state.allowMouseEnter),
    highlightItemOnHover: (0, $2r4G3.createSelector)((state)=>state.highlightItemOnHover),
    stickIfOpen: (0, $2r4G3.createSelector)((state)=>state.stickIfOpen),
    parent: (0, $2r4G3.createSelector)((state)=>state.parent),
    rootId: (0, $2r4G3.createSelector)((state)=>{
        if (state.parent.type === 'menu') return state.parent.store.select('rootId');
        return state.parent.type !== undefined ? state.parent.context.rootId : state.rootId;
    }),
    activeIndex: (0, $2r4G3.createSelector)((state)=>state.activeIndex),
    isActive: (0, $2r4G3.createSelector)((state, itemIndex)=>state.activeIndex === itemIndex),
    hoverEnabled: (0, $2r4G3.createSelector)((state)=>state.hoverEnabled),
    instantType: (0, $2r4G3.createSelector)((state)=>state.instantType),
    lastOpenChangeReason: (0, $2r4G3.createSelector)((state)=>state.openChangeReason),
    floatingTreeRoot: (0, $2r4G3.createSelector)((state)=>{
        if (state.parent.type === 'menu') return state.parent.store.select('floatingTreeRoot');
        return state.floatingTreeRoot;
    }),
    floatingNodeId: (0, $2r4G3.createSelector)((state)=>state.floatingNodeId),
    floatingParentNodeId: (0, $2r4G3.createSelector)((state)=>state.floatingParentNodeId),
    itemProps: (0, $2r4G3.createSelector)((state)=>state.itemProps),
    closeDelay: (0, $2r4G3.createSelector)((state)=>state.closeDelay),
    hasViewport: (0, $2r4G3.createSelector)((state)=>state.hasViewport),
    keyboardEventRelay: (0, $2r4G3.createSelector)((state)=>{
        if (state.keyboardEventRelay) return state.keyboardEventRelay;
        if (state.parent.type === 'menu') return state.parent.store.select('keyboardEventRelay');
        return undefined;
    })
};
class $55e994c804ec1c20$export$688a30d8df3e0b9e extends (0, $4g8mc.ReactStore) {
    constructor(initialState){
        super({
            ...$55e994c804ec1c20$var$createInitialState(),
            ...initialState
        }, {
            positionerRef: /*#__PURE__*/ $8NFma.createRef(),
            popupRef: /*#__PURE__*/ $8NFma.createRef(),
            typingRef: {
                current: false
            },
            itemDomElements: {
                current: []
            },
            itemLabels: {
                current: []
            },
            allowMouseUpTriggerRef: {
                current: false
            },
            triggerFocusTargetRef: /*#__PURE__*/ $8NFma.createRef(),
            beforeContentFocusGuardRef: /*#__PURE__*/ $8NFma.createRef(),
            onOpenChangeComplete: undefined,
            triggerElements: new (0, $8Ruu1.PopupTriggerMap)()
        }, $55e994c804ec1c20$var$selectors);
        // Set up propagation of state from parent menu if applicable.
        this.unsubscribeParentListener = this.observe('parent', (parent)=>{
            this.unsubscribeParentListener?.();
            if (parent.type === 'menu') {
                let rootId = parent.store.select('rootId');
                let floatingTreeRoot = parent.store.select('floatingTreeRoot');
                let keyboardEventRelay = parent.store.select('keyboardEventRelay');
                this.unsubscribeParentListener = parent.store.subscribe(()=>{
                    const nextRootId = parent.store.select('rootId');
                    const nextFloatingTreeRoot = parent.store.select('floatingTreeRoot');
                    const nextKeyboardEventRelay = parent.store.select('keyboardEventRelay');
                    if (rootId === nextRootId && floatingTreeRoot === nextFloatingTreeRoot && keyboardEventRelay === nextKeyboardEventRelay) return;
                    rootId = nextRootId;
                    floatingTreeRoot = nextFloatingTreeRoot;
                    keyboardEventRelay = nextKeyboardEventRelay;
                    this.notifyAll();
                });
                this.context.allowMouseUpTriggerRef = parent.store.context.allowMouseUpTriggerRef;
                return;
            }
            if (parent.type !== undefined) this.context.allowMouseUpTriggerRef = parent.context.allowMouseUpTriggerRef;
            this.unsubscribeParentListener = null;
        });
    }
    setOpen(open, eventDetails) {
        this.state.floatingRootContext.context.events.emit('setOpen', {
            open: open,
            eventDetails: eventDetails
        });
    }
    static useStore(externalStore, initialState) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const internalStore = (0, $gidzQ.useRefWithInit)(()=>{
            return new $55e994c804ec1c20$export$688a30d8df3e0b9e(initialState);
        }).current;
        return externalStore ?? internalStore;
    }
    unsubscribeParentListener = null;
}
function $55e994c804ec1c20$var$createInitialState() {
    return {
        ...(0, $178Yi.createInitialPopupStoreState)(),
        disabled: false,
        modal: true,
        openMethod: null,
        allowMouseEnter: false,
        highlightItemOnHover: true,
        stickIfOpen: true,
        parent: {
            type: undefined
        },
        rootId: undefined,
        activeIndex: null,
        hoverEnabled: true,
        instantType: undefined,
        openChangeReason: null,
        floatingTreeRoot: new (0, $k3oe4.FloatingTreeStore)(),
        floatingNodeId: undefined,
        floatingParentNodeId: null,
        itemProps: (0, $jWAMz.EMPTY_OBJECT),
        keyboardEventRelay: undefined,
        closeDelay: 0,
        hasViewport: false
    };
}

});
parcelRegister("178Yi", function(module, exports) {

$parcel$export(module.exports, "createInitialPopupStoreState", () => $5188b0db1fa69387$export$cd8429fd283f6422);
$parcel$export(module.exports, "createPopupFloatingRootContext", () => $5188b0db1fa69387$export$cca8961d24c27d6b);
$parcel$export(module.exports, "popupStoreSelectors", () => $5188b0db1fa69387$export$12293ea13dbfb17c);

var $2r4G3 = parcelRequire("2r4G3");

var $jWAMz = parcelRequire("jWAMz");

var $8akDT = parcelRequire("8akDT");

var $ibRVA = parcelRequire("ibRVA");
function $5188b0db1fa69387$export$cd8429fd283f6422() {
    return {
        open: false,
        openProp: undefined,
        mounted: false,
        transitionStatus: undefined,
        floatingRootContext: (0, $ibRVA.getEmptyRootContext)(),
        floatingId: undefined,
        triggerCount: 0,
        preventUnmountingOnClose: false,
        payload: undefined,
        activeTriggerId: null,
        activeTriggerElement: null,
        triggerIdProp: undefined,
        popupElement: null,
        positionerElement: null,
        activeTriggerProps: (0, $jWAMz.EMPTY_OBJECT),
        inactiveTriggerProps: (0, $jWAMz.EMPTY_OBJECT),
        popupProps: (0, $jWAMz.EMPTY_OBJECT)
    };
}
function $5188b0db1fa69387$export$cca8961d24c27d6b(triggerElements, floatingId, nested = false) {
    return new (0, $8akDT.FloatingRootStore)({
        open: false,
        transitionStatus: undefined,
        floatingElement: null,
        referenceElement: null,
        triggerElements: triggerElements,
        floatingId: floatingId,
        syncOnly: true,
        nested: nested,
        onOpenChange: undefined
    });
}
const $5188b0db1fa69387$var$activeTriggerIdSelector = (0, $2r4G3.createSelector)((state)=>state.triggerIdProp ?? state.activeTriggerId);
const $5188b0db1fa69387$var$openSelector = (0, $2r4G3.createSelector)((state)=>state.openProp ?? state.open);
const $5188b0db1fa69387$var$popupIdSelector = (0, $2r4G3.createSelector)((state)=>{
    const popupId = state.popupElement?.id ?? state.floatingId;
    return popupId || undefined;
});
function $5188b0db1fa69387$var$triggerOwnsOpenPopup(state, triggerId) {
    return triggerId !== undefined && $5188b0db1fa69387$var$openSelector(state) && $5188b0db1fa69387$var$activeTriggerIdSelector(state) === triggerId;
}
function $5188b0db1fa69387$var$triggerOwnsOpenPopupOrIsOnlyTrigger(state, triggerId) {
    if ($5188b0db1fa69387$var$triggerOwnsOpenPopup(state, triggerId)) return true;
    return triggerId !== undefined && $5188b0db1fa69387$var$openSelector(state) && $5188b0db1fa69387$var$activeTriggerIdSelector(state) == null && state.triggerCount === 1;
}
const $5188b0db1fa69387$export$12293ea13dbfb17c = {
    open: $5188b0db1fa69387$var$openSelector,
    mounted: (0, $2r4G3.createSelector)((state)=>state.mounted),
    transitionStatus: (0, $2r4G3.createSelector)((state)=>state.transitionStatus),
    floatingRootContext: (0, $2r4G3.createSelector)((state)=>state.floatingRootContext),
    triggerCount: (0, $2r4G3.createSelector)((state)=>state.triggerCount),
    preventUnmountingOnClose: (0, $2r4G3.createSelector)((state)=>state.preventUnmountingOnClose),
    payload: (0, $2r4G3.createSelector)((state)=>state.payload),
    activeTriggerId: $5188b0db1fa69387$var$activeTriggerIdSelector,
    activeTriggerElement: (0, $2r4G3.createSelector)((state)=>state.mounted ? state.activeTriggerElement : null),
    popupId: $5188b0db1fa69387$var$popupIdSelector,
    /**
   * Whether the trigger with the given ID was used to open the popup.
   */ isTriggerActive: (0, $2r4G3.createSelector)((state, triggerId)=>triggerId !== undefined && $5188b0db1fa69387$var$activeTriggerIdSelector(state) === triggerId),
    /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */ isOpenedByTrigger: (0, $2r4G3.createSelector)((state, triggerId)=>$5188b0db1fa69387$var$triggerOwnsOpenPopup(state, triggerId)),
    /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */ isMountedByTrigger: (0, $2r4G3.createSelector)((state, triggerId)=>triggerId !== undefined && $5188b0db1fa69387$var$activeTriggerIdSelector(state) === triggerId && state.mounted),
    triggerProps: (0, $2r4G3.createSelector)((state, isActive)=>isActive ? state.activeTriggerProps : state.inactiveTriggerProps),
    /**
   * Popup id for the trigger that currently owns the open popup.
   */ triggerPopupId: (0, $2r4G3.createSelector)((state, triggerId)=>$5188b0db1fa69387$var$triggerOwnsOpenPopupOrIsOnlyTrigger(state, triggerId) ? $5188b0db1fa69387$var$popupIdSelector(state) : undefined),
    popupProps: (0, $2r4G3.createSelector)((state)=>state.popupProps),
    popupElement: (0, $2r4G3.createSelector)((state)=>state.popupElement),
    positionerElement: (0, $2r4G3.createSelector)((state)=>state.positionerElement)
};

});
parcelRegister("ibRVA", function(module, exports) {

$parcel$export(module.exports, "getEmptyRootContext", () => $1f1c7e94afd6fbb7$export$80fda12713e1c062);

var $8Ruu1 = parcelRequire("8Ruu1");

var $8akDT = parcelRequire("8akDT");
function $1f1c7e94afd6fbb7$export$80fda12713e1c062() {
    return new (0, $8akDT.FloatingRootStore)({
        open: false,
        transitionStatus: undefined,
        floatingElement: null,
        referenceElement: null,
        triggerElements: new (0, $8Ruu1.PopupTriggerMap)(),
        floatingId: undefined,
        syncOnly: false,
        nested: false,
        onOpenChange: undefined
    });
}

});



parcelRegister("kjC6g", function(module, exports) {

$parcel$export(module.exports, "FOCUSABLE_POPUP_PROPS", () => $e587cec772684f96$export$d9db6ada662be949);
$parcel$export(module.exports, "createDefaultInitialFocus", () => $e587cec772684f96$export$76a9ce73549ae2f3);
$parcel$export(module.exports, "usePopupStore", () => $e587cec772684f96$export$81db38fdff0c82f6);
$parcel$export(module.exports, "useTriggerRegistration", () => $e587cec772684f96$export$60040dc08aa559e);
$parcel$export(module.exports, "setPopupOpenState", () => $e587cec772684f96$export$e11011aa1ab94166);
$parcel$export(module.exports, "attachPreventUnmountOnClose", () => $e587cec772684f96$export$c8bf6076fcb6c8f0);
$parcel$export(module.exports, "useInitialOpenSync", () => $e587cec772684f96$export$c363d23f6153a387);
$parcel$export(module.exports, "useTriggerDataForwarding", () => $e587cec772684f96$export$a76f42c94c5d2837);
$parcel$export(module.exports, "useImplicitActiveTrigger", () => $e587cec772684f96$export$508ec735a33812a1);
$parcel$export(module.exports, "useOpenStateTransitions", () => $e587cec772684f96$export$1c6df4c338a766ea);
$parcel$export(module.exports, "usePopupInteractionProps", () => $e587cec772684f96$export$6417b597d4fe3f8d);
$parcel$export(module.exports, "usePopupRootSync", () => $e587cec772684f96$export$635c03eadbd4edcc);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $jWAMz = parcelRequire("jWAMz");

var $8VAvD = parcelRequire("8VAvD");

var $fKU9M = parcelRequire("fKU9M");

var $9N3e2 = parcelRequire("9N3e2");

var $kkZwe = parcelRequire("kkZwe");

var $aJh1u = parcelRequire("aJh1u");

var $8Xtx1 = parcelRequire("8Xtx1");

var $2t3QX = parcelRequire("2t3QX");

var $jpauT = parcelRequire("jpauT");

var $ejgm2 = parcelRequire("ejgm2");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");
'use client';
const $e587cec772684f96$export$d9db6ada662be949 = {
    tabIndex: -1,
    [(0, $aJh1u.FOCUSABLE_ATTRIBUTE)]: ''
};
function $e587cec772684f96$export$76a9ce73549ae2f3(popupRef) {
    return (interactionType)=>interactionType === 'touch' ? popupRef.current : true;
}
function $e587cec772684f96$export$81db38fdff0c82f6(externalStore, createStore, treatPopupAsFloatingElement = false) {
    const floatingId = (0, $8VAvD.useId)();
    const nested = (0, $8Xtx1.useFloatingParentNodeId)() != null;
    const internalStoreRef = $8NFma.useRef(null);
    if (externalStore === undefined && internalStoreRef.current === null) internalStoreRef.current = createStore(floatingId, nested);
    const store = externalStore ?? internalStoreRef.current;
    (0, $2t3QX.useSyncedFloatingRootContext)({
        popupStore: store,
        treatPopupAsFloatingElement: treatPopupAsFloatingElement,
        floatingRootContext: store.state.floatingRootContext,
        floatingId: floatingId,
        nested: nested,
        onOpenChange: store.setOpen
    });
    return {
        store: store,
        internalStore: internalStoreRef.current
    };
}
function $e587cec772684f96$export$60040dc08aa559e(id, store) {
    // Keep track of the currently registered element to unregister it on unmount or id change.
    const registeredElementIdRef = $8NFma.useRef(null);
    const registeredElementRef = $8NFma.useRef(null);
    return $8NFma.useCallback((element)=>{
        if (id === undefined) return;
        let shouldSyncTriggerCount = false;
        if (registeredElementIdRef.current !== null) {
            const registeredId = registeredElementIdRef.current;
            const registeredElement = registeredElementRef.current;
            const currentElement = store.context.triggerElements.getById(registeredId);
            if (registeredElement && currentElement === registeredElement) {
                store.context.triggerElements.delete(registeredId);
                shouldSyncTriggerCount = true;
            }
            registeredElementIdRef.current = null;
            registeredElementRef.current = null;
        }
        if (element !== null) {
            registeredElementIdRef.current = id;
            registeredElementRef.current = element;
            store.context.triggerElements.add(id, element);
            shouldSyncTriggerCount = true;
        }
        if (shouldSyncTriggerCount) {
            const triggerCount = store.context.triggerElements.size;
            if (store.select('open') && store.state.triggerCount !== triggerCount) store.set('triggerCount', triggerCount);
        }
    }, [
        store,
        id
    ]);
}
function $e587cec772684f96$export$e11011aa1ab94166(state, open, trigger, preventUnmountOnClose = false) {
    if (open) // Opening starts a new close cycle, so clear any previous request to keep the popup mounted.
    state.preventUnmountingOnClose = false;
    else if (preventUnmountOnClose) state.preventUnmountingOnClose = true;
    const triggerId = trigger?.id ?? null;
    // If a popup is closing, the `trigger` may be undefined.
    // We want to keep the previous value so that exit animations are played and focus is returned correctly.
    if (triggerId || open) {
        state.activeTriggerId = triggerId;
        state.activeTriggerElement = trigger ?? null;
    }
}
function $e587cec772684f96$export$c8bf6076fcb6c8f0(eventDetails) {
    let preventUnmountOnClose = false;
    eventDetails.preventUnmountOnClose = ()=>{
        preventUnmountOnClose = true;
    };
    return ()=>preventUnmountOnClose;
}
function $e587cec772684f96$export$7c267893b36fc088(store, nextOpen, eventDetails, options = {}) {
    const reason = eventDetails.reason;
    const isHover = reason === (0, $66jhv).triggerHover;
    const isFocusOpen = nextOpen && reason === (0, $66jhv).triggerFocus;
    const isDismissClose = !nextOpen && (reason === (0, $66jhv).triggerPress || reason === (0, $66jhv).escapeKey);
    const shouldPreventUnmountOnClose = $e587cec772684f96$export$c8bf6076fcb6c8f0(eventDetails);
    store.context.onOpenChange?.(nextOpen, eventDetails);
    if (eventDetails.isCanceled) return;
    options.onBeforeDispatch?.();
    store.state.floatingRootContext.dispatchOpenChange(nextOpen, eventDetails);
    const changeState = ()=>{
        // Spread `extraState` first so `open` always reflects `nextOpen`, keeping it in
        // sync with the value already passed to `dispatchOpenChange`/`setPopupOpenState`.
        const updatedState = {
            ...options.extraState,
            open: nextOpen
        };
        if (isFocusOpen) updatedState.instantType = 'focus';
        else if (isDismissClose) updatedState.instantType = 'dismiss';
        else if (isHover) updatedState.instantType = undefined;
        $e587cec772684f96$export$e11011aa1ab94166(updatedState, nextOpen, eventDetails.trigger, shouldPreventUnmountOnClose());
        store.update(updatedState);
    };
    if (isHover) // Flush synchronously for hover so `node.getAnimations()` sees the new state.
    $2pmb0.flushSync(changeState);
    else changeState();
}
function $e587cec772684f96$export$c363d23f6153a387(store, openProp, defaultOpen, defaultTriggerId) {
    (0, $kkZwe.useOnFirstRender)(()=>{
        if (openProp === undefined && store.state.open === false && defaultOpen) // Avoid notifying detached trigger subscribers while the Root is rendering.
        store.state = {
            ...store.state,
            open: true,
            activeTriggerId: defaultTriggerId,
            preventUnmountingOnClose: false
        };
    });
}
function $e587cec772684f96$export$a76f42c94c5d2837(triggerId, triggerElementRef, store, stateUpdates) {
    const isMountedByThisTrigger = store.useState('isMountedByTrigger', triggerId);
    const baseRegisterTrigger = $e587cec772684f96$export$60040dc08aa559e(triggerId, store);
    const registerTrigger = (0, $fKU9M.useStableCallback)((element)=>{
        baseRegisterTrigger(element);
        if (!element) return;
        const open = store.select('open');
        const activeTriggerId = store.select('activeTriggerId');
        if (activeTriggerId === triggerId) {
            store.update({
                activeTriggerElement: element,
                ...open ? stateUpdates : null
            });
            return;
        }
        if (activeTriggerId == null && open) // If a popup is already open, a detached trigger can mount before any active trigger
        // has been established. Claim the first registered trigger so trigger-owned focus
        // management and ARIA relationships work.
        store.update({
            activeTriggerId: triggerId,
            activeTriggerElement: element,
            ...stateUpdates
        });
    });
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (isMountedByThisTrigger) store.update({
            activeTriggerElement: triggerElementRef.current,
            ...stateUpdates
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMountedByThisTrigger,
        store,
        triggerElementRef,
        ...Object.values(stateUpdates)
    ]);
    return {
        registerTrigger: registerTrigger,
        isMountedByThisTrigger: isMountedByThisTrigger
    };
}
function $e587cec772684f96$export$508ec735a33812a1(store, options = {}) {
    const { closeOnActiveTriggerUnmount: closeOnActiveTriggerUnmount = false } = options;
    const open = store.useState('open');
    const reactiveTriggerCount = store.useState('triggerCount');
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open) {
            if (store.state.triggerCount !== 0) store.set('triggerCount', 0);
            return;
        }
        const triggerCount = store.context.triggerElements.size;
        const stateUpdates = {};
        if (store.state.triggerCount !== triggerCount) stateUpdates.triggerCount = triggerCount;
        const activeTriggerId = store.select('activeTriggerId');
        let lostActiveTriggerId = null;
        if (activeTriggerId) {
            const activeTriggerElement = store.context.triggerElements.getById(activeTriggerId);
            if (!activeTriggerElement) lostActiveTriggerId = activeTriggerId;
            else if (activeTriggerElement !== store.state.activeTriggerElement) stateUpdates.activeTriggerElement = activeTriggerElement;
        }
        if (!lostActiveTriggerId && !activeTriggerId && triggerCount === 1) {
            const iteratorResult = store.context.triggerElements.entries().next();
            if (!iteratorResult.done) {
                const [implicitTriggerId, implicitTriggerElement] = iteratorResult.value;
                stateUpdates.activeTriggerId = implicitTriggerId;
                stateUpdates.activeTriggerElement = implicitTriggerElement;
            }
        }
        if (stateUpdates.triggerCount !== undefined || stateUpdates.activeTriggerId !== undefined || stateUpdates.activeTriggerElement !== undefined) store.update(stateUpdates);
        if (lostActiveTriggerId) {
            if (closeOnActiveTriggerUnmount) // Defer so a same-tick replacement trigger with the same id can register first.
            queueMicrotask(()=>{
                if (store.select('open') && store.select('activeTriggerId') === lostActiveTriggerId && !store.context.triggerElements.getById(lostActiveTriggerId)) {
                    const eventDetails = (0, $6e5YN.createChangeEventDetails)((0, $66jhv).none);
                    store.setOpen(false, eventDetails);
                    // If closing is canceled, keep the previous active trigger ownership for the
                    // still-open popup instead of claiming another trigger implicitly.
                    if (!eventDetails.isCanceled) store.update({
                        activeTriggerId: null,
                        activeTriggerElement: null
                    });
                }
            });
        }
    }, [
        open,
        store,
        reactiveTriggerCount,
        closeOnActiveTriggerUnmount
    ]);
}
function $e587cec772684f96$export$1c6df4c338a766ea(open, store, onUnmount) {
    const { mounted: mounted, setMounted: setMounted, transitionStatus: transitionStatus } = (0, $jpauT.useTransitionStatus)(open);
    const preventUnmountingOnClose = store.useState('preventUnmountingOnClose');
    // Opening starts a new close cycle. Clear during render so the close-completion hook below
    // reads the synchronized value on the same pass.
    const syncedPreventUnmountingOnClose = open ? false : preventUnmountingOnClose;
    store.useSyncedValues({
        mounted: mounted,
        transitionStatus: transitionStatus,
        preventUnmountingOnClose: syncedPreventUnmountingOnClose
    });
    const forceUnmount = (0, $fKU9M.useStableCallback)(()=>{
        setMounted(false);
        store.update({
            activeTriggerId: null,
            activeTriggerElement: null,
            mounted: false,
            preventUnmountingOnClose: false
        });
        onUnmount?.();
        store.context.onOpenChangeComplete?.(false);
    });
    (0, $ejgm2.useOpenChangeComplete)({
        enabled: mounted && !open && !syncedPreventUnmountingOnClose,
        open: open,
        ref: store.context.popupRef,
        onComplete () {
            if (!open) forceUnmount();
        }
    });
    return {
        forceUnmount: forceUnmount,
        transitionStatus: transitionStatus
    };
}
function $e587cec772684f96$export$6417b597d4fe3f8d(store, statePart) {
    store.useSyncedValues(statePart);
    (0, $9N3e2.useIsoLayoutEffect)(()=>()=>{
            store.update({
                activeTriggerProps: (0, $jWAMz.EMPTY_OBJECT),
                inactiveTriggerProps: (0, $jWAMz.EMPTY_OBJECT),
                popupProps: (0, $jWAMz.EMPTY_OBJECT)
            });
        }, [
        store
    ]);
}
function $e587cec772684f96$export$635c03eadbd4edcc(store, open) {
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open && store.state.openMethod !== null) store.set('openMethod', null);
    }, [
        open,
        store
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>()=>{
            if (store.state.openMethod !== null) store.set('openMethod', null);
        }, [
        store
    ]);
}

});
parcelRegister("kkZwe", function(module, exports) {

$parcel$export(module.exports, "useOnFirstRender", () => $090a413086fb8014$export$e41f426d635fcf9a);

var $8NFma = parcelRequire("8NFma");
'use client';
function $090a413086fb8014$export$e41f426d635fcf9a(fn) {
    const ref = $8NFma.useRef(true);
    if (ref.current) {
        ref.current = false;
        fn();
    }
}

});


parcelRegister("bqzP8", function(module, exports) {

$parcel$export(module.exports, "MenuSubmenuRootContext", () => $4d2cef658184f8da$export$7285a20ae9de9f00);
$parcel$export(module.exports, "useMenuSubmenuRootContext", () => $4d2cef658184f8da$export$75b9c838b3240e92);

var $8NFma = parcelRequire("8NFma");
'use client';
const $4d2cef658184f8da$export$7285a20ae9de9f00 = /*#__PURE__*/ $8NFma.createContext(undefined);
function $4d2cef658184f8da$export$75b9c838b3240e92() {
    return $8NFma.useContext($4d2cef658184f8da$export$7285a20ae9de9f00);
}

});


parcelRegister("jXF6T", function(module, exports) {

$parcel$export(module.exports, "MenuSubmenuRoot", () => $e2946d0e597322e8$export$1459a6ff37424efa);

var $8NFma = parcelRequire("8NFma");

var $l8BT5 = parcelRequire("l8BT5");

var $jtR97 = parcelRequire("jtR97");

var $bqzP8 = parcelRequire("bqzP8");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $e2946d0e597322e8$export$1459a6ff37424efa(props) {
    const parentMenu = (0, $jtR97.useMenuRootContext)().store;
    const contextValue = $8NFma.useMemo(()=>({
            parentMenu: parentMenu
        }), [
        parentMenu
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bqzP8.MenuSubmenuRootContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $l8BT5.MenuRoot), {
            ...props
        })
    });
}

});

parcelRegister("98m8x", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $b1a735675339984c$export$27d2ad3c5815583e);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");

var $5o6JF = parcelRequire("5o6JF");

var $8shn9 = parcelRequire("8shn9");

var $4rsXc = parcelRequire("4rsXc");

var $fKU9M = parcelRequire("fKU9M");

var $9N3e2 = parcelRequire("9N3e2");

var $jWAMz = parcelRequire("jWAMz");

var $8ET7Y = parcelRequire("8ET7Y");
var $ioKKL = parcelRequire("ioKKL");
var $8Xtx1 = parcelRequire("8Xtx1");
var $45s08 = parcelRequire("45s08");
var $ixSMG = parcelRequire("ixSMG");

var $k3oe4 = parcelRequire("k3oe4");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");

var $jtR97 = parcelRequire("jtR97");

var $gVYSt = parcelRequire("gVYSt");

var $aEBMJ = parcelRequire("aEBMJ");

var $hSxhk = parcelRequire("hSxhk");

var $9elfO = parcelRequire("9elfO");

var $cyKGK = parcelRequire("cyKGK");

var $hmL59 = parcelRequire("hmL59");

var $aF9H7 = parcelRequire("aF9H7");

var $kjC6g = parcelRequire("kjC6g");

var $4LuBl = parcelRequire("4LuBl");

var $hF6bp = parcelRequire("hF6bp");

var $66jhv = parcelRequire("66jhv");

var $k9vAr = parcelRequire("k9vAr");

var $gnjAY = parcelRequire("gnjAY");

var $9qHuC = parcelRequire("9qHuC");

var $cTo2e = parcelRequire("cTo2e");

var $4yZSp = parcelRequire("4yZSp");

var $eFu2T = parcelRequire("eFu2T");

var $1IdZj = parcelRequire("1IdZj");
'use client';
const $b1a735675339984c$var$BOUNDARY_OFFSET = 2;
const $b1a735675339984c$export$27d2ad3c5815583e = (0, $4rsXc.fastComponentRef)(function MenuTrigger(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, disabled: disabledProp = false, nativeButton: nativeButton = true, id: idProp, openOnHover: openOnHoverProp, delay: delay = 100, closeDelay: closeDelay = 0, handle: handle, payload: payload, ...elementProps } = componentProps;
    const rootContext = (0, $jtR97.useMenuRootContext)(true);
    const store = handle?.store ?? rootContext?.store;
    if (!store) throw new Error((0, $cmjqX.default)(85));
    const thisTriggerId = (0, $hF6bp.useBaseUiId)(idProp);
    const isTriggerActive = store.useState('isTriggerActive', thisTriggerId);
    const floatingRootContext = store.useState('floatingRootContext');
    const isOpenedByThisTrigger = store.useState('isOpenedByTrigger', thisTriggerId);
    const popupId = store.useState('triggerPopupId', thisTriggerId);
    const triggerElementRef = $8NFma.useRef(null);
    const parent = $b1a735675339984c$var$useMenuParent();
    const compositeRootContext = (0, $hmL59.useCompositeRootContext)(true);
    const floatingTreeRootFromContext = (0, $8Xtx1.useFloatingTree)();
    const floatingTreeRoot = $8NFma.useMemo(()=>{
        return floatingTreeRootFromContext ?? new (0, $k3oe4.FloatingTreeStore)();
    }, [
        floatingTreeRootFromContext
    ]);
    const floatingNodeId = (0, $8Xtx1.useFloatingNodeId)(floatingTreeRoot);
    const floatingParentNodeId = (0, $8Xtx1.useFloatingParentNodeId)();
    const { registerTrigger: registerTrigger, isMountedByThisTrigger: isMountedByThisTrigger } = (0, $kjC6g.useTriggerDataForwarding)(thisTriggerId, triggerElementRef, store, {
        payload: payload,
        closeDelay: closeDelay,
        parent: parent,
        floatingTreeRoot: floatingTreeRoot,
        floatingNodeId: floatingNodeId,
        floatingParentNodeId: floatingParentNodeId,
        keyboardEventRelay: compositeRootContext?.relayKeyboardEvent
    });
    const isInMenubar = parent.type === 'menubar';
    const rootDisabled = store.useState('disabled');
    const disabled = disabledProp || rootDisabled || isInMenubar && parent.context.disabled;
    const { getButtonProps: getButtonProps, buttonRef: buttonRef } = (0, $hSxhk.useButton)({
        disabled: disabled,
        native: nativeButton
    });
    $8NFma.useEffect(()=>{
        if (!isOpenedByThisTrigger && parent.type === undefined) store.context.allowMouseUpTriggerRef.current = false;
    }, [
        store,
        isOpenedByThisTrigger,
        parent.type
    ]);
    const triggerRef = $8NFma.useRef(null);
    const allowMouseUpTriggerTimeout = (0, $5o6JF.useTimeout)();
    const handleDocumentMouseUp = (0, $fKU9M.useStableCallback)((mouseEvent)=>{
        if (!triggerRef.current) return;
        allowMouseUpTriggerTimeout.clear();
        store.context.allowMouseUpTriggerRef.current = false;
        const mouseUpTarget = mouseEvent.target;
        if ((0, $1Pbuv.contains)(triggerRef.current, mouseUpTarget) || (0, $1Pbuv.contains)(store.select('positionerElement'), mouseUpTarget) || mouseUpTarget === triggerRef.current) return;
        if (mouseUpTarget != null && (0, $aF9H7.findRootOwnerId)(mouseUpTarget) === store.select('rootId')) return;
        const bounds = (0, $9elfO.getPseudoElementBounds)(triggerRef.current);
        if (mouseEvent.clientX >= bounds.left - $b1a735675339984c$var$BOUNDARY_OFFSET && mouseEvent.clientX <= bounds.right + $b1a735675339984c$var$BOUNDARY_OFFSET && mouseEvent.clientY >= bounds.top - $b1a735675339984c$var$BOUNDARY_OFFSET && mouseEvent.clientY <= bounds.bottom + $b1a735675339984c$var$BOUNDARY_OFFSET) return;
        floatingTreeRoot.events.emit('close', {
            domEvent: mouseEvent,
            reason: (0, $66jhv).cancelOpen
        });
    });
    $8NFma.useEffect(()=>{
        if (isOpenedByThisTrigger && store.select('lastOpenChangeReason') === (0, $66jhv).triggerHover) {
            const doc = (0, $8shn9.ownerDocument)(triggerRef.current);
            doc.addEventListener('mouseup', handleDocumentMouseUp, {
                once: true
            });
        }
    }, [
        isOpenedByThisTrigger,
        handleDocumentMouseUp,
        store
    ]);
    const parentMenubarHasSubmenuOpen = isInMenubar && parent.context.hasSubmenuOpen;
    const openOnHover = openOnHoverProp ?? parentMenubarHasSubmenuOpen;
    const hoverProps = (0, $ixSMG.useHoverReferenceInteraction)(floatingRootContext, {
        enabled: openOnHover && !disabled && parent.type !== 'context-menu' && (!isInMenubar || parentMenubarHasSubmenuOpen && !isMountedByThisTrigger),
        handleClose: (0, $8ET7Y.safePolygon)({
            blockPointerEvents: !isInMenubar
        }),
        mouseOnly: true,
        move: false,
        restMs: parent.type === undefined ? delay : undefined,
        delay: {
            close: closeDelay
        },
        triggerElementRef: triggerElementRef,
        externalTree: floatingTreeRoot,
        isActiveTrigger: isTriggerActive,
        isClosing: ()=>store.select('transitionStatus') === 'ending'
    });
    // Whether to ignore clicks to open the menu.
    // `lastOpenChangeReason` doesn't need to be reactive here, as we need to run this
    // only when `isOpenedByThisTrigger` changes.
    const stickIfOpen = $b1a735675339984c$var$useStickIfOpen(isOpenedByThisTrigger, store.select('lastOpenChangeReason'));
    const click = (0, $ioKKL.useClick)(floatingRootContext, {
        enabled: !disabled && parent.type !== 'context-menu',
        event: isOpenedByThisTrigger && isInMenubar ? 'click' : 'mousedown',
        toggle: true,
        ignoreMouse: false,
        stickIfOpen: parent.type === undefined ? stickIfOpen : false
    });
    const focus = (0, $45s08.useFocus)(floatingRootContext, {
        enabled: !disabled && parentMenubarHasSubmenuOpen
    });
    const mixedToggleHandlers = (0, $k9vAr.useMixedToggleClickHandler)({
        open: isOpenedByThisTrigger,
        enabled: isInMenubar,
        mouseDownAction: 'open'
    });
    const localInteractionProps = $8NFma.useMemo(()=>(0, $eFu2T.mergeProps)(focus.reference, click.reference), [
        focus.reference,
        click.reference
    ]);
    const rootTriggerProps = store.useState('triggerProps', isMountedByThisTrigger);
    const { preFocusGuardRef: preFocusGuardRef, handlePreFocusGuardFocus: handlePreFocusGuardFocus, handleFocusTargetFocus: handleFocusTargetFocus } = (0, $4LuBl.useTriggerFocusGuards)(store, triggerElementRef);
    const state = {
        disabled: disabled,
        open: isOpenedByThisTrigger
    };
    const ref = [
        triggerRef,
        forwardedRef,
        buttonRef,
        registerTrigger,
        triggerElementRef
    ];
    const props = [
        localInteractionProps,
        hoverProps ?? (0, $jWAMz.EMPTY_OBJECT),
        rootTriggerProps,
        {
            'aria-haspopup': 'menu',
            'aria-controls': popupId,
            id: thisTriggerId,
            onMouseDown: (event)=>{
                if (store.select('open')) return;
                // mousedown -> mouseup on menu item should not trigger it within 200ms.
                allowMouseUpTriggerTimeout.start(200, ()=>{
                    store.context.allowMouseUpTriggerRef.current = true;
                });
                const doc = (0, $8shn9.ownerDocument)(event.currentTarget);
                doc.addEventListener('mouseup', handleDocumentMouseUp, {
                    once: true
                });
            }
        },
        isInMenubar ? {
            role: 'menuitem'
        } : {},
        mixedToggleHandlers,
        elementProps,
        getButtonProps
    ];
    const element = (0, $aEBMJ.useRenderElement)('button', componentProps, {
        enabled: !isInMenubar,
        stateAttributesMapping: (0, $gVYSt.pressableTriggerOpenStateMapping),
        state: state,
        ref: ref,
        props: props
    });
    if (isInMenubar) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cyKGK.CompositeItem), {
        tag: "button",
        render: render,
        className: className,
        style: style,
        state: state,
        refs: ref,
        props: props,
        stateAttributesMapping: (0, $gVYSt.pressableTriggerOpenStateMapping)
    });
    // A fragment with key is required to ensure that the `element` is mounted to the same DOM node
    // regardless of whether the focus guards are rendered or not.
    if (isOpenedByThisTrigger) return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                ref: preFocusGuardRef,
                onFocus: handlePreFocusGuardFocus
            }, `${thisTriggerId}-pre-focus-guard`),
            /*#__PURE__*/ (0, $1IdZj.jsx)($8NFma.Fragment, {
                children: element
            }, thisTriggerId),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4yZSp.FocusGuard), {
                ref: store.context.triggerFocusTargetRef,
                onFocus: handleFocusTargetFocus
            }, `${thisTriggerId}-post-focus-guard`)
        ]
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)($8NFma.Fragment, {
        children: element
    }, thisTriggerId);
});
/**
 * Determines whether to ignore clicks after a hover-open.
 */ function $b1a735675339984c$var$useStickIfOpen(open, openReason) {
    const stickIfOpenTimeout = (0, $5o6JF.useTimeout)();
    const [stickIfOpen, setStickIfOpen] = $8NFma.useState(false);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (open && openReason === 'trigger-hover') {
            // Only allow "patient" clicks to close the menu if it's open.
            // If they clicked within 500ms of the menu opening, keep it open.
            setStickIfOpen(true);
            stickIfOpenTimeout.start((0, $cTo2e.PATIENT_CLICK_THRESHOLD), ()=>{
                setStickIfOpen(false);
            });
        } else if (!open) {
            stickIfOpenTimeout.clear();
            setStickIfOpen(false);
        }
    }, [
        open,
        openReason,
        stickIfOpenTimeout
    ]);
    return stickIfOpen;
}
function $b1a735675339984c$var$useMenuParent() {
    const contextMenuContext = (0, $gnjAY.useContextMenuRootContext)(true);
    const parentContext = (0, $jtR97.useMenuRootContext)(true);
    const menubarContext = (0, $9qHuC.useMenubarContext)(true);
    const parent = $8NFma.useMemo(()=>{
        if (menubarContext) return {
            type: 'menubar',
            context: menubarContext
        };
        // Ensure this is not a Menu nested inside ContextMenu.Trigger.
        // ContextMenu parentContext is always undefined as ContextMenu.Root is instantiated with
        // <MenuRootContext.Provider value={undefined}>
        if (contextMenuContext && !parentContext) return {
            type: 'context-menu',
            context: contextMenuContext
        };
        return {
            type: undefined
        };
    }, [
        contextMenuContext,
        parentContext,
        menubarContext
    ]);
    return parent;
}

});
parcelRegister("8ET7Y", function(module, exports) {

$parcel$export(module.exports, "safePolygon", () => $7290133a52dbbeb5$export$7484214ab62358d2);

var $1D9S2 = parcelRequire("1D9S2");

var $5o6JF = parcelRequire("5o6JF");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $1Pbuv = parcelRequire("1Pbuv");

var $kS7mH = parcelRequire("kS7mH");
/* eslint-disable no-nested-ternary */ const $7290133a52dbbeb5$var$CURSOR_SPEED_THRESHOLD = 0.1;
const $7290133a52dbbeb5$var$CURSOR_SPEED_THRESHOLD_SQUARED = $7290133a52dbbeb5$var$CURSOR_SPEED_THRESHOLD * $7290133a52dbbeb5$var$CURSOR_SPEED_THRESHOLD;
const $7290133a52dbbeb5$var$POLYGON_BUFFER = 0.5;
function $7290133a52dbbeb5$var$hasIntersectingEdge(pointX, pointY, xi, yi, xj, yj) {
    return yi >= pointY !== yj >= pointY && pointX <= (xj - xi) * (pointY - yi) / (yj - yi) + xi;
}
function $7290133a52dbbeb5$var$isPointInQuadrilateral(pointX, pointY, x1, y1, x2, y2, x3, y3, x4, y4) {
    let isInsideValue = false;
    if ($7290133a52dbbeb5$var$hasIntersectingEdge(pointX, pointY, x1, y1, x2, y2)) isInsideValue = !isInsideValue;
    if ($7290133a52dbbeb5$var$hasIntersectingEdge(pointX, pointY, x2, y2, x3, y3)) isInsideValue = !isInsideValue;
    if ($7290133a52dbbeb5$var$hasIntersectingEdge(pointX, pointY, x3, y3, x4, y4)) isInsideValue = !isInsideValue;
    if ($7290133a52dbbeb5$var$hasIntersectingEdge(pointX, pointY, x4, y4, x1, y1)) isInsideValue = !isInsideValue;
    return isInsideValue;
}
function $7290133a52dbbeb5$var$isInsideRect(pointX, pointY, rect) {
    return pointX >= rect.x && pointX <= rect.x + rect.width && pointY >= rect.y && pointY <= rect.y + rect.height;
}
function $7290133a52dbbeb5$var$isInsideAxisAlignedRect(pointX, pointY, x1, y1, x2, y2) {
    const minX = Math.min(x1, x2);
    const maxX = Math.max(x1, x2);
    const minY = Math.min(y1, y2);
    const maxY = Math.max(y1, y2);
    return pointX >= minX && pointX <= maxX && pointY >= minY && pointY <= maxY;
}
function $7290133a52dbbeb5$export$7484214ab62358d2(options = {}) {
    const { blockPointerEvents: blockPointerEvents = false } = options;
    const timeout = new (0, $5o6JF.Timeout)();
    const fn = ({ x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree })=>{
        const side = placement?.split('-')[0];
        let hasLanded = false;
        let lastX = null;
        let lastY = null;
        let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
        function isCursorMovingSlowly(nextX, nextY) {
            const currentTime = performance.now();
            const elapsedTime = currentTime - lastCursorTime;
            if (lastX === null || lastY === null || elapsedTime === 0) {
                lastX = nextX;
                lastY = nextY;
                lastCursorTime = currentTime;
                return false;
            }
            const deltaX = nextX - lastX;
            const deltaY = nextY - lastY;
            const distanceSquared = deltaX * deltaX + deltaY * deltaY;
            const thresholdSquared = elapsedTime * elapsedTime * $7290133a52dbbeb5$var$CURSOR_SPEED_THRESHOLD_SQUARED;
            lastX = nextX;
            lastY = nextY;
            lastCursorTime = currentTime;
            return distanceSquared < thresholdSquared;
        }
        function close() {
            timeout.clear();
            onClose();
        }
        return function onMouseMove(event) {
            timeout.clear();
            const domReference = elements.domReference;
            const floating = elements.floating;
            if (!domReference || !floating || side == null || x == null || y == null) return undefined;
            const { clientX: clientX, clientY: clientY } = event;
            const target = (0, $1Pbuv.getTarget)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $1Pbuv.contains)(floating, target);
            const isOverReferenceEl = (0, $1Pbuv.contains)(domReference, target);
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return undefined;
            }
            if (isOverReferenceEl) {
                hasLanded = false;
                if (!isLeave) {
                    hasLanded = true;
                    return undefined;
                }
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $1D9S2.isElement)(event.relatedTarget) && (0, $1Pbuv.contains)(floating, event.relatedTarget)) return undefined;
            function hasOpenChildNode() {
                return Boolean(tree && (0, $kS7mH.getNodeChildren)(tree.nodesRef.current, nodeId).length > 0);
            }
            function closeIfNoOpenChild() {
                if (!hasOpenChildNode()) close();
            }
            // If any nested child is open, abort.
            if (hasOpenChildNode()) return undefined;
            const refRect = domReference.getBoundingClientRect();
            const rect = floating.getBoundingClientRect();
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
                closeIfNoOpenChild();
                return undefined;
            }
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let isInsideTroughRect = false;
            switch(side){
                case 'top':
                    isInsideTroughRect = $7290133a52dbbeb5$var$isInsideAxisAlignedRect(clientX, clientY, left, refRect.top + 1, right, rect.bottom - 1);
                    break;
                case 'bottom':
                    isInsideTroughRect = $7290133a52dbbeb5$var$isInsideAxisAlignedRect(clientX, clientY, left, rect.top + 1, right, refRect.bottom - 1);
                    break;
                case 'left':
                    isInsideTroughRect = $7290133a52dbbeb5$var$isInsideAxisAlignedRect(clientX, clientY, rect.right - 1, bottom, refRect.left + 1, top);
                    break;
                case 'right':
                    isInsideTroughRect = $7290133a52dbbeb5$var$isInsideAxisAlignedRect(clientX, clientY, refRect.right - 1, bottom, rect.left + 1, top);
                    break;
                default:
            }
            if (isInsideTroughRect) return undefined;
            if (hasLanded && !$7290133a52dbbeb5$var$isInsideRect(clientX, clientY, refRect)) {
                closeIfNoOpenChild();
                return undefined;
            }
            if (!isLeave && isCursorMovingSlowly(clientX, clientY)) {
                closeIfNoOpenChild();
                return undefined;
            }
            let isInsidePolygon = false;
            switch(side){
                case 'top':
                    {
                        const cursorXOffset = isFloatingWider ? $7290133a52dbbeb5$var$POLYGON_BUFFER / 2 : $7290133a52dbbeb5$var$POLYGON_BUFFER * 4;
                        const cursorPointOneX = isFloatingWider ? x + cursorXOffset : cursorLeaveFromRight ? x + cursorXOffset : x - cursorXOffset;
                        const cursorPointTwoX = isFloatingWider ? x - cursorXOffset : cursorLeaveFromRight ? x + cursorXOffset : x - cursorXOffset;
                        const cursorPointY = y + $7290133a52dbbeb5$var$POLYGON_BUFFER + 1;
                        const commonYLeft = cursorLeaveFromRight ? rect.bottom - $7290133a52dbbeb5$var$POLYGON_BUFFER : isFloatingWider ? rect.bottom - $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.top;
                        const commonYRight = cursorLeaveFromRight ? isFloatingWider ? rect.bottom - $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.top : rect.bottom - $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        isInsidePolygon = $7290133a52dbbeb5$var$isPointInQuadrilateral(clientX, clientY, cursorPointOneX, cursorPointY, cursorPointTwoX, cursorPointY, rect.left, commonYLeft, rect.right, commonYRight);
                        break;
                    }
                case 'bottom':
                    {
                        const cursorXOffset = isFloatingWider ? $7290133a52dbbeb5$var$POLYGON_BUFFER / 2 : $7290133a52dbbeb5$var$POLYGON_BUFFER * 4;
                        const cursorPointOneX = isFloatingWider ? x + cursorXOffset : cursorLeaveFromRight ? x + cursorXOffset : x - cursorXOffset;
                        const cursorPointTwoX = isFloatingWider ? x - cursorXOffset : cursorLeaveFromRight ? x + cursorXOffset : x - cursorXOffset;
                        const cursorPointY = y - $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        const commonYLeft = cursorLeaveFromRight ? rect.top + $7290133a52dbbeb5$var$POLYGON_BUFFER : isFloatingWider ? rect.top + $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.bottom;
                        const commonYRight = cursorLeaveFromRight ? isFloatingWider ? rect.top + $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.bottom : rect.top + $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        isInsidePolygon = $7290133a52dbbeb5$var$isPointInQuadrilateral(clientX, clientY, cursorPointOneX, cursorPointY, cursorPointTwoX, cursorPointY, rect.left, commonYLeft, rect.right, commonYRight);
                        break;
                    }
                case 'left':
                    {
                        const cursorYOffset = isFloatingTaller ? $7290133a52dbbeb5$var$POLYGON_BUFFER / 2 : $7290133a52dbbeb5$var$POLYGON_BUFFER * 4;
                        const cursorPointOneY = isFloatingTaller ? y + cursorYOffset : cursorLeaveFromBottom ? y + cursorYOffset : y - cursorYOffset;
                        const cursorPointTwoY = isFloatingTaller ? y - cursorYOffset : cursorLeaveFromBottom ? y + cursorYOffset : y - cursorYOffset;
                        const cursorPointX = x + $7290133a52dbbeb5$var$POLYGON_BUFFER + 1;
                        const commonXTop = cursorLeaveFromBottom ? rect.right - $7290133a52dbbeb5$var$POLYGON_BUFFER : isFloatingTaller ? rect.right - $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.left;
                        const commonXBottom = cursorLeaveFromBottom ? isFloatingTaller ? rect.right - $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.left : rect.right - $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        isInsidePolygon = $7290133a52dbbeb5$var$isPointInQuadrilateral(clientX, clientY, commonXTop, rect.top, commonXBottom, rect.bottom, cursorPointX, cursorPointOneY, cursorPointX, cursorPointTwoY);
                        break;
                    }
                case 'right':
                    {
                        const cursorYOffset = isFloatingTaller ? $7290133a52dbbeb5$var$POLYGON_BUFFER / 2 : $7290133a52dbbeb5$var$POLYGON_BUFFER * 4;
                        const cursorPointOneY = isFloatingTaller ? y + cursorYOffset : cursorLeaveFromBottom ? y + cursorYOffset : y - cursorYOffset;
                        const cursorPointTwoY = isFloatingTaller ? y - cursorYOffset : cursorLeaveFromBottom ? y + cursorYOffset : y - cursorYOffset;
                        const cursorPointX = x - $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        const commonXTop = cursorLeaveFromBottom ? rect.left + $7290133a52dbbeb5$var$POLYGON_BUFFER : isFloatingTaller ? rect.left + $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.right;
                        const commonXBottom = cursorLeaveFromBottom ? isFloatingTaller ? rect.left + $7290133a52dbbeb5$var$POLYGON_BUFFER : rect.right : rect.left + $7290133a52dbbeb5$var$POLYGON_BUFFER;
                        isInsidePolygon = $7290133a52dbbeb5$var$isPointInQuadrilateral(clientX, clientY, cursorPointX, cursorPointOneY, cursorPointX, cursorPointTwoY, commonXTop, rect.top, commonXBottom, rect.bottom);
                        break;
                    }
                default:
            }
            if (!isInsidePolygon) closeIfNoOpenChild();
            else if (!hasLanded) timeout.start(40, closeIfNoOpenChild);
            return undefined;
        };
    };
    // eslint-disable-next-line no-underscore-dangle
    fn.__options = {
        ...options,
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});

parcelRegister("ioKKL", function(module, exports) {

$parcel$export(module.exports, "useClick", () => $5e90d108c6bfea2b$export$98524f11226063fc);

var $8NFma = parcelRequire("8NFma");

var $dhRNQ = parcelRequire("dhRNQ");

var $5o6JF = parcelRequire("5o6JF");

var $jWAMz = parcelRequire("jWAMz");

var $1Pbuv = parcelRequire("1Pbuv");
var $klAiy = parcelRequire("klAiy");

var $18t8v = parcelRequire("18t8v");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");
'use client';
function $5e90d108c6bfea2b$export$98524f11226063fc(context, props = {}) {
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, stickIfOpen: stickIfOpen = true, touchOpenDelay: touchOpenDelay = 0, reason: reason = (0, $66jhv).triggerPress } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const dataRef = store.context.dataRef;
    const pointerTypeRef = $8NFma.useRef(undefined);
    const frame = (0, $dhRNQ.useAnimationFrame)();
    const touchOpenTimeout = (0, $5o6JF.useTimeout)();
    const reference = $8NFma.useMemo(()=>{
        function setOpenWithTouchDelay(nextOpen, nativeEvent, target, pointerType) {
            const details = (0, $6e5YN.createChangeEventDetails)(reason, nativeEvent, target);
            if (nextOpen && pointerType === 'touch' && touchOpenDelay > 0) touchOpenTimeout.start(touchOpenDelay, ()=>{
                store.setOpen(true, details);
            });
            else store.setOpen(nextOpen, details);
        }
        function getNextOpen(open, currentTarget, isClickLikeOpenEvent) {
            const openEvent = dataRef.current.openEvent;
            const hasClickedOnInactiveTrigger = store.select('domReferenceElement') !== currentTarget;
            if (open && hasClickedOnInactiveTrigger) // Moving between triggers should always open the newly active one.
            return true;
            if (!open) // A closed popup should open on the next press.
            return true;
            if (!toggle) // Non-toggle mode never closes on a repeated trigger press.
            return true;
            if (openEvent && stickIfOpen) // Preserve hover/focus-opened popups until the matching click-like event closes them.
            return !isClickLikeOpenEvent(openEvent.type);
            // Otherwise, a repeated click toggles the popup closed.
            return false;
        }
        return {
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                const nativeEvent = event.nativeEvent;
                const open = store.select('open');
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0 || eventOption === 'click' || (0, $18t8v.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                const nextOpen = getNextOpen(open, event.currentTarget, (openEventType)=>openEventType === 'click' || openEventType === 'mousedown');
                // Animations sometimes won't run on a typeable element if using a rAF.
                // Focus is always set on these elements. For touch, we may delay opening.
                const target = (0, $1Pbuv.getTarget)(nativeEvent);
                if ((0, $klAiy.isTypeableElement)(target)) {
                    setOpenWithTouchDelay(nextOpen, nativeEvent, target, pointerType);
                    return;
                }
                // Capture the currentTarget before the rAF.
                // as React sets it to null after the event handler completes.
                const eventCurrentTarget = event.currentTarget;
                // Wait until focus is set on the element. This is an alternative to
                // `event.preventDefault()` to avoid :focus-visible from appearing when using a pointer.
                frame.request(()=>{
                    setOpenWithTouchDelay(nextOpen, nativeEvent, eventCurrentTarget, pointerType);
                });
            },
            onClick (event) {
                if (eventOption === 'mousedown-only') return;
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerType) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $18t8v.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                const open = store.select('open');
                const nextOpen = getNextOpen(open, event.currentTarget, (openEventType)=>openEventType === 'click' || openEventType === 'mousedown' || openEventType === 'keydown' || openEventType === 'keyup');
                setOpenWithTouchDelay(nextOpen, event.nativeEvent, event.currentTarget, pointerType);
            },
            onKeyDown () {
                pointerTypeRef.current = undefined;
            }
        };
    }, [
        dataRef,
        eventOption,
        ignoreMouse,
        reason,
        store,
        stickIfOpen,
        toggle,
        frame,
        touchOpenTimeout,
        touchOpenDelay
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : (0, $jWAMz.EMPTY_OBJECT), [
        enabled,
        reference
    ]);
}

});

parcelRegister("45s08", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $38689f0b5aab0e96$export$f8168d8dd8fd66e6);

var $8NFma = parcelRequire("8NFma");

var $cbA4H = parcelRequire("cbA4H");

var $8QwT3 = parcelRequire("8QwT3");

var $8v2Os = parcelRequire("8v2Os");

var $8shn9 = parcelRequire("8shn9");

var $5o6JF = parcelRequire("5o6JF");

var $1D9S2 = parcelRequire("1D9S2");

var $561ed = parcelRequire("561ed");

var $1Pbuv = parcelRequire("1Pbuv");parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $klAiy = parcelRequire("klAiy");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");
'use client';
const $38689f0b5aab0e96$var$isMacSafari = (0, $8QwT3).os.mac && (0, $8QwT3).engine.webkit;
function $38689f0b5aab0e96$export$f8168d8dd8fd66e6(context, props = {}) {
    const { enabled: enabled = true, delay: delay } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const { events: events, dataRef: dataRef } = store.context;
    const blockFocusRef = $8NFma.useRef(false);
    // Track which reference should be blocked from re-opening after Escape/press dismissal.
    const blockedReferenceRef = $8NFma.useRef(null);
    const keyboardModalityRef = $8NFma.useRef(true);
    const timeout = (0, $5o6JF.useTimeout)();
    $8NFma.useEffect(()=>{
        const domReference = store.select('domReferenceElement');
        if (!enabled) return undefined;
        const win = (0, $1D9S2.getWindow)(domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            const currentDomReference = store.select('domReferenceElement');
            if (!store.select('open') && (0, $1D9S2.isHTMLElement)(currentDomReference) && currentDomReference === (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(currentDomReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        return (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(win, 'blur', onBlur), $38689f0b5aab0e96$var$isMacSafari && (0, $cbA4H.addEventListener)(win, 'keydown', onKeyDown, true), $38689f0b5aab0e96$var$isMacSafari && (0, $cbA4H.addEventListener)(win, 'pointerdown', onPointerDown, true));
    }, [
        store,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return undefined;
        function onOpenChangeLocal(details) {
            if (details.reason === (0, $66jhv).triggerPress || details.reason === (0, $66jhv).escapeKey) {
                const referenceElement = store.select('domReferenceElement');
                if ((0, $1D9S2.isElement)(referenceElement)) {
                    blockedReferenceRef.current = referenceElement;
                    blockFocusRef.current = true;
                }
            }
        }
        events.on('openchange', onOpenChangeLocal);
        return ()=>{
            events.off('openchange', onOpenChangeLocal);
        };
    }, [
        events,
        enabled,
        store
    ]);
    const reference = $8NFma.useMemo(()=>{
        function resetBlockedFocus() {
            blockFocusRef.current = false;
            blockedReferenceRef.current = null;
        }
        return {
            onMouseLeave () {
                resetBlockedFocus();
            },
            onFocus (event) {
                const focusTarget = event.currentTarget;
                if (blockFocusRef.current) {
                    if (blockedReferenceRef.current === focusTarget) return;
                    resetBlockedFocus();
                }
                const target = (0, $1Pbuv.getTarget)(event.nativeEvent);
                if ((0, $1D9S2.isElement)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($38689f0b5aab0e96$var$isMacSafari && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $klAiy.isTypeableElement)(target)) return;
                    } else if (!(0, $klAiy.matchesFocusVisible)(target)) return;
                }
                const movedFromOtherEnabledTrigger = (0, $klAiy.isTargetInsideEnabledTrigger)(event.relatedTarget, store.context.triggerElements);
                const { nativeEvent: nativeEvent, currentTarget: currentTarget } = event;
                const delayValue = typeof delay === 'function' ? delay() : delay;
                if (store.select('open') && movedFromOtherEnabledTrigger || delayValue === 0 || delayValue === undefined) {
                    store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerFocus, nativeEvent, currentTarget));
                    return;
                }
                timeout.start(delayValue, ()=>{
                    if (blockFocusRef.current) return;
                    store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerFocus, nativeEvent, currentTarget));
                });
            },
            onBlur (event) {
                resetBlockedFocus();
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $1D9S2.isElement)(relatedTarget) && relatedTarget.hasAttribute((0, $561ed.createAttribute)('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeout.start(0, ()=>{
                    const domReference = store.select('domReferenceElement');
                    const activeEl = (0, $1Pbuv.activeElement)((0, $8shn9.ownerDocument)(domReference));
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $1Pbuv.contains)(dataRef.current.floatingContext?.refs.floating.current, activeEl) || (0, $1Pbuv.contains)(domReference, activeEl) || movedToFocusGuard) return;
                    // If the next focused element is one of the triggers, do not close
                    // the floating element. The focus handler of that trigger will
                    // handle the open state.
                    const nextFocusedElement = relatedTarget ?? activeEl;
                    if ((0, $klAiy.isTargetInsideEnabledTrigger)(nextFocusedElement, store.context.triggerElements)) return;
                    store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerFocus, nativeEvent));
                });
            }
        };
    }, [
        dataRef,
        delay,
        store,
        timeout
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            trigger: reference
        } : {}, [
        enabled,
        reference
    ]);
}

});

parcelRegister("ixSMG", function(module, exports) {

$parcel$export(module.exports, "useHoverReferenceInteraction", () => $9c1ceda86a7fe2f0$export$f4c3b7bba9a36f87);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $cbA4H = parcelRequire("cbA4H");

var $8v2Os = parcelRequire("8v2Os");

var $8shn9 = parcelRequire("8shn9");

var $fKU9M = parcelRequire("fKU9M");

var $eiwl7 = parcelRequire("eiwl7");

var $1D9S2 = parcelRequire("1D9S2");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");

var $8Xtx1 = parcelRequire("8Xtx1");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $1Pbuv = parcelRequire("1Pbuv");

var $18t8v = parcelRequire("18t8v");

var $lb1NF = parcelRequire("lb1NF");

var $5tgFR = parcelRequire("5tgFR");
var $klAiy = parcelRequire("klAiy");
'use client';
const $9c1ceda86a7fe2f0$var$EMPTY_REF = {
    current: null
};
function $9c1ceda86a7fe2f0$export$f4c3b7bba9a36f87(context, props = {}) {
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true, triggerElementRef: triggerElementRef = $9c1ceda86a7fe2f0$var$EMPTY_REF, externalTree: externalTree, isActiveTrigger: isActiveTrigger = true, getHandleCloseContext: getHandleCloseContext, isClosing: isClosing, shouldOpen: shouldOpenProp } = props;
    const store = 'rootStore' in context ? context.rootStore : context;
    const { dataRef: dataRef, events: events } = store.context;
    const tree = (0, $8Xtx1.useFloatingTree)(externalTree);
    const instance = (0, $lb1NF.useHoverInteractionSharedState)(store);
    const isHoverCloseActiveRef = $8NFma.useRef(false);
    const handleCloseRef = (0, $eiwl7.useValueAsRef)(handleClose);
    const delayRef = (0, $eiwl7.useValueAsRef)(delay);
    const restMsRef = (0, $eiwl7.useValueAsRef)(restMs);
    const enabledRef = (0, $eiwl7.useValueAsRef)(enabled);
    const shouldOpenRef = (0, $eiwl7.useValueAsRef)(shouldOpenProp);
    const isClosingRef = (0, $eiwl7.useValueAsRef)(isClosing);
    const isClickLikeOpenEvent = (0, $fKU9M.useStableCallback)(()=>{
        return (0, $5tgFR.isClickLikeOpenEvent)(dataRef.current.openEvent?.type, instance.interactedInside);
    });
    const checkShouldOpen = (0, $fKU9M.useStableCallback)(()=>{
        return shouldOpenRef.current?.() !== false;
    });
    const isOverInactiveTrigger = (0, $fKU9M.useStableCallback)((currentDomReference, currentTarget, target)=>{
        const allTriggers = store.context.triggerElements;
        // Fast path for normal usage where handlers are attached directly to triggers.
        if (allTriggers.hasElement(currentTarget)) return !currentDomReference || !(0, $1Pbuv.contains)(currentDomReference, currentTarget);
        // Fallback for delegated/wrapper usage where currentTarget may be outside the trigger map.
        if (!(0, $1D9S2.isElement)(target)) return false;
        const targetElement = target;
        return allTriggers.hasMatchingElement((trigger)=>(0, $1Pbuv.contains)(trigger, targetElement)) && (!currentDomReference || !(0, $1Pbuv.contains)(currentDomReference, targetElement));
    });
    const cleanupMouseMoveHandler = (0, $fKU9M.useStableCallback)(()=>{
        if (!instance.handler) return;
        const doc = (0, $8shn9.ownerDocument)(store.select('domReferenceElement'));
        doc.removeEventListener('mousemove', instance.handler);
        instance.handler = undefined;
    });
    const clearPointerEvents = (0, $fKU9M.useStableCallback)(()=>{
        (0, $lb1NF.clearSafePolygonPointerEventsMutation)(instance);
    });
    if (isActiveTrigger) // eslint-disable-next-line no-underscore-dangle
    instance.handleCloseOptions = handleCloseRef.current?.__options;
    $8NFma.useEffect(()=>cleanupMouseMoveHandler, [
        cleanupMouseMoveHandler
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $8NFma.useEffect(()=>{
        if (!enabled) return undefined;
        function onOpenChangeLocal(details) {
            if (!details.open) {
                isHoverCloseActiveRef.current = details.reason === (0, $66jhv).triggerHover;
                cleanupMouseMoveHandler();
                instance.openChangeTimeout.clear();
                instance.restTimeout.clear();
                instance.blockMouseMove = true;
                instance.restTimeoutPending = false;
            } else isHoverCloseActiveRef.current = false;
        }
        events.on('openchange', onOpenChangeLocal);
        return ()=>{
            events.off('openchange', onOpenChangeLocal);
        };
    }, [
        enabled,
        events,
        instance,
        cleanupMouseMoveHandler
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return undefined;
        function closeWithDelay(event, runElseBranch = true) {
            const closeDelay = (0, $5tgFR.getDelay)(delayRef.current, 'close', instance.pointerType);
            if (closeDelay) instance.openChangeTimeout.start(closeDelay, ()=>{
                store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event));
                tree?.events.emit('floating.closed', event);
            });
            else if (runElseBranch) {
                instance.openChangeTimeout.clear();
                store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event));
                tree?.events.emit('floating.closed', event);
            }
        }
        const trigger = triggerElementRef.current ?? (isActiveTrigger ? store.select('domReferenceElement') : null);
        if (!(0, $1D9S2.isElement)(trigger)) return undefined;
        function onMouseEnter(event) {
            instance.openChangeTimeout.clear();
            instance.blockMouseMove = false;
            if (mouseOnly && !(0, $18t8v.isMouseLikePointerType)(instance.pointerType)) return;
            // Only rest delay is set; there's no fallback delay.
            // This will be handled by `onMouseMove`.
            const restMsValue = (0, $5tgFR.getRestMs)(restMsRef.current);
            const openDelay = (0, $5tgFR.getDelay)(delayRef.current, 'open', instance.pointerType);
            const eventTarget = (0, $1Pbuv.getTarget)(event);
            const currentTarget = event.currentTarget ?? null;
            const currentDomReference = store.select('domReferenceElement');
            let triggerNode = currentTarget;
            // Wrapper/delegated mode: resolve the actual trigger from the event target.
            if ((0, $1D9S2.isElement)(eventTarget) && !store.context.triggerElements.hasElement(eventTarget)) {
                for (const triggerElement of store.context.triggerElements.elements())if ((0, $1Pbuv.contains)(triggerElement, eventTarget)) {
                    triggerNode = triggerElement;
                    break;
                }
            }
            // Wrapper/delegated mode fallback: if the wrapper contains the active trigger,
            // treat this as re-entering that active trigger.
            if ((0, $1D9S2.isElement)(currentTarget) && (0, $1D9S2.isElement)(currentDomReference) && !store.context.triggerElements.hasElement(currentTarget) && (0, $1Pbuv.contains)(currentTarget, currentDomReference)) triggerNode = currentDomReference;
            const isOverInactive = triggerNode == null ? false : isOverInactiveTrigger(currentDomReference, triggerNode, eventTarget);
            const isOpen = store.select('open');
            const isInClosingTransition = isClosingRef.current?.() ?? store.select('transitionStatus') === 'ending';
            const isHoverCloseTransition = !isOpen && isInClosingTransition && isHoverCloseActiveRef.current;
            const isReenteringSameTriggerDuringCloseTransition = !isOverInactive && (0, $1D9S2.isElement)(triggerNode) && (0, $1D9S2.isElement)(currentDomReference) && (0, $1Pbuv.contains)(currentDomReference, triggerNode) && isHoverCloseTransition;
            const isRestOnlyDelay = restMsValue > 0 && !openDelay;
            const shouldOpenImmediately = isOverInactive && (isOpen || isHoverCloseTransition) || isReenteringSameTriggerDuringCloseTransition;
            const shouldOpen = !isOpen || isOverInactive;
            // Open immediately when moving between triggers while open, or during
            // a hover-driven close transition (including same-trigger re-entry).
            if (shouldOpenImmediately) {
                if (checkShouldOpen()) store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event, triggerNode));
                return;
            }
            if (isRestOnlyDelay) return;
            if (openDelay) instance.openChangeTimeout.start(openDelay, ()=>{
                if (shouldOpen && checkShouldOpen()) store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event, triggerNode));
            });
            else if (shouldOpen) {
                if (checkShouldOpen()) store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, event, triggerNode));
            }
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            cleanupMouseMoveHandler();
            const domReferenceElement = store.select('domReferenceElement');
            const doc = (0, $8shn9.ownerDocument)(domReferenceElement);
            instance.restTimeout.clear();
            instance.restTimeoutPending = false;
            const handleCloseContextBase = dataRef.current.floatingContext ?? getHandleCloseContext?.();
            if ((0, $klAiy.isTargetInsideEnabledTrigger)(event.relatedTarget, store.context.triggerElements)) return;
            if (handleCloseRef.current && handleCloseContextBase) {
                if (!store.select('open')) instance.openChangeTimeout.clear();
                const currentTrigger = triggerElementRef.current;
                instance.handler = handleCloseRef.current({
                    ...handleCloseContextBase,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (enabledRef.current && !isClickLikeOpenEvent() && currentTrigger === store.select('domReferenceElement')) closeWithDelay(event, true);
                    }
                });
                doc.addEventListener('mousemove', instance.handler);
                instance.handler(event);
                return;
            }
            const shouldClose = instance.pointerType === 'touch' ? !(0, $1Pbuv.contains)(store.select('floatingElement'), event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        if (move) return (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(trigger, 'mousemove', onMouseEnter, {
            once: true
        }), (0, $cbA4H.addEventListener)(trigger, 'mouseenter', onMouseEnter), (0, $cbA4H.addEventListener)(trigger, 'mouseleave', onMouseLeave));
        return (0, $8v2Os.mergeCleanups)((0, $cbA4H.addEventListener)(trigger, 'mouseenter', onMouseEnter), (0, $cbA4H.addEventListener)(trigger, 'mouseleave', onMouseLeave));
    }, [
        cleanupMouseMoveHandler,
        clearPointerEvents,
        dataRef,
        delayRef,
        store,
        enabled,
        handleCloseRef,
        instance,
        isActiveTrigger,
        isOverInactiveTrigger,
        isClickLikeOpenEvent,
        mouseOnly,
        move,
        restMsRef,
        triggerElementRef,
        tree,
        enabledRef,
        getHandleCloseContext,
        isClosingRef,
        checkShouldOpen
    ]);
    return $8NFma.useMemo(()=>{
        if (!enabled) return undefined;
        function setPointerRef(event) {
            instance.pointerType = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                const trigger = event.currentTarget;
                const currentDomReference = store.select('domReferenceElement');
                const currentOpen = store.select('open');
                const isOverInactive = isOverInactiveTrigger(currentDomReference, trigger, event.target);
                if (mouseOnly && !(0, $18t8v.isMouseLikePointerType)(instance.pointerType)) return;
                if (currentOpen && isOverInactive && instance.handleCloseOptions?.blockPointerEvents) {
                    const floatingElement = store.select('floatingElement');
                    if (floatingElement) {
                        const scopeElement = instance.handleCloseOptions?.getScope?.() ?? trigger.ownerDocument.body;
                        (0, $lb1NF.applySafePolygonPointerEventsMutation)(instance, {
                            scopeElement: scopeElement,
                            referenceElement: trigger,
                            floatingElement: floatingElement
                        });
                    }
                }
                const restMsValue = (0, $5tgFR.getRestMs)(restMsRef.current);
                if (currentOpen && !isOverInactive || restMsValue === 0) return;
                if (!isOverInactive && instance.restTimeoutPending && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                instance.restTimeout.clear();
                function handleMouseMove() {
                    instance.restTimeoutPending = false;
                    // A delayed hover open should not override a click-like open that happened
                    // while the hover delay was pending.
                    if (isClickLikeOpenEvent()) return;
                    const latestOpen = store.select('open');
                    if (!instance.blockMouseMove && (!latestOpen || isOverInactive) && checkShouldOpen()) store.setOpen(true, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).triggerHover, nativeEvent, trigger));
                }
                if (instance.pointerType === 'touch') $2pmb0.flushSync(()=>{
                    handleMouseMove();
                });
                else if (isOverInactive && currentOpen) handleMouseMove();
                else {
                    instance.restTimeoutPending = true;
                    instance.restTimeout.start(restMsValue, handleMouseMove);
                }
            }
        };
    }, [
        enabled,
        instance,
        isClickLikeOpenEvent,
        isOverInactiveTrigger,
        mouseOnly,
        store,
        restMsRef,
        checkShouldOpen
    ]);
}

});

parcelRegister("9elfO", function(module, exports) {

$parcel$export(module.exports, "getPseudoElementBounds", () => $34e42f287461b35a$export$f86365220fe52493);

var $1D9S2 = parcelRequire("1D9S2");

var $8QwT3 = parcelRequire("8QwT3");
function $34e42f287461b35a$export$f86365220fe52493(element) {
    const elementRect = element.getBoundingClientRect();
    const win = (0, $1D9S2.getWindow)(element);
    // Avoid "Not implemented: window.getComputedStyle(elt, pseudoElt)" in jsdom.
    if ((0, $8QwT3).env.jsdom) return elementRect;
    const beforeStyles = win.getComputedStyle(element, '::before');
    const afterStyles = win.getComputedStyle(element, '::after');
    const hasPseudoElements = beforeStyles.content !== 'none' || afterStyles.content !== 'none';
    if (!hasPseudoElements) return elementRect;
    // Get dimensions of pseudo-elements
    const beforeWidth = parseFloat(beforeStyles.width) || 0;
    const beforeHeight = parseFloat(beforeStyles.height) || 0;
    const afterWidth = parseFloat(afterStyles.width) || 0;
    const afterHeight = parseFloat(afterStyles.height) || 0;
    // Calculate max dimensions including pseudo-elements
    const totalWidth = Math.max(elementRect.width, beforeWidth, afterWidth);
    const totalHeight = Math.max(elementRect.height, beforeHeight, afterHeight);
    // Calculate the differences to extend the bounds
    const widthDiff = totalWidth - elementRect.width;
    const heightDiff = totalHeight - elementRect.height;
    return {
        left: elementRect.left - widthDiff / 2,
        right: elementRect.right + widthDiff / 2,
        top: elementRect.top - heightDiff / 2,
        bottom: elementRect.bottom + heightDiff / 2
    };
}

});

parcelRegister("cyKGK", function(module, exports) {

$parcel$export(module.exports, "CompositeItem", () => $a4fea0008ae930c4$export$ef1ef7a3a43ace8e);

var $jWAMz = parcelRequire("jWAMz");

var $aEBMJ = parcelRequire("aEBMJ");

var $kHHk0 = parcelRequire("kHHk0");
'use client';
function $a4fea0008ae930c4$export$ef1ef7a3a43ace8e(componentProps) {
    const { render: render, className: className, style: style, state: state = (0, $jWAMz.EMPTY_OBJECT), props: props = (0, $jWAMz.EMPTY_ARRAY), refs: refs = (0, $jWAMz.EMPTY_ARRAY), metadata: metadata, stateAttributesMapping: stateAttributesMapping, tag: tag = 'div', ...elementProps } = componentProps;
    const { compositeProps: compositeProps, compositeRef: compositeRef } = (0, $kHHk0.useCompositeItem)({
        metadata: metadata
    });
    return (0, $aEBMJ.useRenderElement)(tag, componentProps, {
        state: state,
        ref: [
            ...refs,
            compositeRef
        ],
        props: [
            compositeProps,
            ...props,
            elementProps
        ],
        stateAttributesMapping: stateAttributesMapping
    });
}

});
parcelRegister("kHHk0", function(module, exports) {

$parcel$export(module.exports, "useCompositeItem", () => $ec5d2294577221c3$export$5d135041cfe9980);

var $8NFma = parcelRequire("8NFma");

var $ghAB8 = parcelRequire("ghAB8");

var $hmL59 = parcelRequire("hmL59");

var $ipY60 = parcelRequire("ipY60");
'use client';
function $ec5d2294577221c3$export$5d135041cfe9980(params = {}) {
    const { highlightItemOnHover: highlightItemOnHover, highlightedIndex: highlightedIndex, onHighlightedIndexChange: onHighlightedIndexChange } = (0, $hmL59.useCompositeRootContext)();
    const { ref: ref, index: index } = (0, $ipY60.useCompositeListItem)(params);
    const isHighlighted = highlightedIndex === index;
    const itemRef = $8NFma.useRef(null);
    const mergedRef = (0, $ghAB8.useMergedRefs)(ref, itemRef);
    const compositeProps = {
        tabIndex: isHighlighted ? 0 : -1,
        onFocus () {
            onHighlightedIndexChange(index);
        },
        onMouseMove () {
            const item = itemRef.current;
            if (!highlightItemOnHover || !item) return;
            const disabled = item.hasAttribute('disabled') || item.ariaDisabled === 'true';
            if (!isHighlighted && !disabled) item.focus();
        }
    };
    return {
        compositeProps: compositeProps,
        compositeRef: mergedRef,
        index: index
    };
}

});


parcelRegister("aF9H7", function(module, exports) {

$parcel$export(module.exports, "findRootOwnerId", () => $ebda2123753e56d1$export$f04c85243b30436);

var $1D9S2 = parcelRequire("1D9S2");
function $ebda2123753e56d1$export$f04c85243b30436(node) {
    if ((0, $1D9S2.isHTMLElement)(node) && node.hasAttribute('data-rootownerid')) return node.getAttribute('data-rootownerid') ?? undefined;
    if ((0, $1D9S2.isLastTraversableNode)(node)) return undefined;
    return $ebda2123753e56d1$export$f04c85243b30436((0, $1D9S2.getParentNode)(node));
}

});

parcelRegister("4LuBl", function(module, exports) {

$parcel$export(module.exports, "useTriggerFocusGuards", () => $f6f447ab1ea11845$export$c3ed090c3d5d514);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
parcelRequire("klAiy");
var $1Pbuv = parcelRequire("1Pbuv");
var $4yUKk = parcelRequire("4yUKk");

var $6e5YN = parcelRequire("6e5YN");

var $66jhv = parcelRequire("66jhv");
'use client';
function $f6f447ab1ea11845$export$c3ed090c3d5d514(store, triggerElementRef) {
    const preFocusGuardRef = $8NFma.useRef(null);
    function handlePreFocusGuardFocus(event) {
        $2pmb0.flushSync(()=>{
            store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).focusOut, event.nativeEvent, event.currentTarget));
        });
        const previousTabbable = (0, $4yUKk.getTabbableBeforeElement)(preFocusGuardRef.current);
        previousTabbable?.focus();
    }
    function handleFocusTargetFocus(event) {
        const positionerElement = store.select('positionerElement');
        if (positionerElement && (0, $4yUKk.isOutsideEvent)(event, positionerElement)) store.context.beforeContentFocusGuardRef.current?.focus();
        else {
            $2pmb0.flushSync(()=>{
                store.setOpen(false, (0, $6e5YN.createChangeEventDetails)((0, $66jhv).focusOut, event.nativeEvent, event.currentTarget));
            });
            let nextTabbable = (0, $4yUKk.getTabbableAfterElement)(store.context.triggerFocusTargetRef.current || triggerElementRef.current);
            while(nextTabbable !== null && (0, $1Pbuv.contains)(positionerElement, nextTabbable)){
                const prevTabbable = nextTabbable;
                nextTabbable = (0, $4yUKk.getNextTabbable)(nextTabbable);
                if (nextTabbable === prevTabbable) break;
            }
            nextTabbable?.focus();
        }
    }
    return {
        preFocusGuardRef: preFocusGuardRef,
        handlePreFocusGuardFocus: handlePreFocusGuardFocus,
        handleFocusTargetFocus: handleFocusTargetFocus
    };
}

});

parcelRegister("k9vAr", function(module, exports) {

$parcel$export(module.exports, "useMixedToggleClickHandler", () => $8075db4b4a6b8d24$export$98ae49617e2d0f43);

var $8NFma = parcelRequire("8NFma");

var $8shn9 = parcelRequire("8shn9");

var $jWAMz = parcelRequire("jWAMz");
'use client';
function $8075db4b4a6b8d24$export$98ae49617e2d0f43(params) {
    const { enabled: enabled = true, mouseDownAction: mouseDownAction, open: open } = params;
    const ignoreClickRef = $8NFma.useRef(false);
    return $8NFma.useMemo(()=>{
        if (!enabled) return 0, $jWAMz.EMPTY_OBJECT;
        return {
            onMouseDown: (event)=>{
                if (mouseDownAction === 'open' && !open || mouseDownAction === 'close' && open) {
                    ignoreClickRef.current = true;
                    (0, $8shn9.ownerDocument)(event.currentTarget).addEventListener('click', ()=>{
                        ignoreClickRef.current = false;
                    }, {
                        once: true
                    });
                }
            },
            onClick: (event)=>{
                if (ignoreClickRef.current) {
                    ignoreClickRef.current = false;
                    event.preventBaseUIHandler();
                }
            }
        };
    }, [
        enabled,
        mouseDownAction,
        open
    ]);
}

});


parcelRegister("aJ9QX", function(module, exports) {

$parcel$export(module.exports, "MenuViewport", () => $b39bc0a61c417f2f$export$941120b09d1fefdc);

var $8NFma = parcelRequire("8NFma");

var $jtR97 = parcelRequire("jtR97");

var $8foVs = parcelRequire("8foVs");

var $aEBMJ = parcelRequire("aEBMJ");

var $58RK0 = parcelRequire("58RK0");

var $9z4ze = parcelRequire("9z4ze");
'use client';
const $b39bc0a61c417f2f$var$stateAttributesMapping = {
    activationDirection: (value)=>value ? {
            'data-activation-direction': value
        } : null
};
const $b39bc0a61c417f2f$export$941120b09d1fefdc = /*#__PURE__*/ $8NFma.forwardRef(function MenuViewport(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, children: children, ...elementProps } = componentProps;
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const { side: side } = (0, $8foVs.useMenuPositionerContext)();
    const instantType = store.useState('instantType');
    const { children: childrenToRender, state: viewportState } = (0, $58RK0.usePopupViewport)({
        store: store,
        side: side,
        cssVars: (0, $9z4ze.MenuViewportCssVars),
        children: children
    });
    const state = {
        activationDirection: viewportState.activationDirection,
        transitioning: viewportState.transitioning,
        instant: instantType
    };
    return (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        ref: forwardedRef,
        props: [
            elementProps,
            {
                children: childrenToRender
            }
        ],
        stateAttributesMapping: $b39bc0a61c417f2f$var$stateAttributesMapping
    });
});

});
parcelRegister("58RK0", function(module, exports) {

$parcel$export(module.exports, "usePopupViewport", () => $83695e2a9a9b29ee$export$678579933577b504);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $lwkkr = parcelRequire("lwkkr");

var $dhRNQ = parcelRequire("dhRNQ");

var $61xYN = parcelRequire("61xYN");

var $9N3e2 = parcelRequire("9N3e2");

var $fKU9M = parcelRequire("fKU9M");

var $8shn9 = parcelRequire("8shn9");

var $45x58 = parcelRequire("45x58");

var $eIpqi = parcelRequire("eIpqi");

var $jSzfV = parcelRequire("jSzfV");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $83695e2a9a9b29ee$export$678579933577b504(parameters) {
    const { store: store, side: side, cssVars: cssVars, children: children } = parameters;
    const direction = (0, $jSzfV.useDirection)();
    const activeTrigger = store.useState('activeTriggerElement');
    const activeTriggerId = store.useState('activeTriggerId');
    const open = store.useState('open');
    const payload = store.useState('payload');
    const mounted = store.useState('mounted');
    const popupElement = store.useState('popupElement');
    const positionerElement = store.useState('positionerElement');
    const previousActiveTrigger = (0, $61xYN.usePreviousValue)(open ? activeTrigger : null);
    // Remount current content on trigger changes (and once more when payload lags) to avoid DOM reuse flashes.
    // The key bumps immediately on trigger switches, then again if the payload arrives on a later render.
    const currentContentKey = $83695e2a9a9b29ee$var$usePopupContentKey(activeTriggerId, payload);
    const capturedNodeRef = $8NFma.useRef(null);
    const [previousContentNode, setPreviousContentNode] = $8NFma.useState(null);
    const [newTriggerOffset, setNewTriggerOffset] = $8NFma.useState(null);
    const currentContainerRef = $8NFma.useRef(null);
    const previousContainerRef = $8NFma.useRef(null);
    const onAnimationsFinished = (0, $45x58.useAnimationsFinished)(currentContainerRef, true, false);
    const cleanupFrame = (0, $dhRNQ.useAnimationFrame)();
    const [previousContentDimensions, setPreviousContentDimensions] = $8NFma.useState(null);
    const [showStartingStyleAttribute, setShowStartingStyleAttribute] = $8NFma.useState(false);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        store.set('hasViewport', true);
        return ()=>{
            store.set('hasViewport', false);
        };
    }, [
        store
    ]);
    const handleMeasureLayout = (0, $fKU9M.useStableCallback)(()=>{
        currentContainerRef.current?.style.setProperty('animation', 'none');
        currentContainerRef.current?.style.setProperty('transition', 'none');
        previousContainerRef.current?.style.setProperty('display', 'none');
    });
    const handleMeasureLayoutComplete = (0, $fKU9M.useStableCallback)((previousDimensions)=>{
        currentContainerRef.current?.style.removeProperty('animation');
        currentContainerRef.current?.style.removeProperty('transition');
        previousContainerRef.current?.style.removeProperty('display');
        if (previousDimensions) setPreviousContentDimensions(previousDimensions);
    });
    const lastHandledTriggerRef = $8NFma.useRef(null);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        if (!open || !mounted) lastHandledTriggerRef.current = null;
    }, [
        open,
        mounted
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // When a trigger changes, set the captured children HTML to state,
        // so we can render both new and old content.
        if (activeTrigger && previousActiveTrigger && activeTrigger !== previousActiveTrigger && lastHandledTriggerRef.current !== activeTrigger && capturedNodeRef.current) {
            setPreviousContentNode(capturedNodeRef.current);
            setShowStartingStyleAttribute(true);
            // Calculate the relative position between the previous and new trigger,
            // so we can pass it to the style hook for animation purposes.
            const offset = $83695e2a9a9b29ee$var$calculateRelativePosition(previousActiveTrigger, activeTrigger);
            setNewTriggerOffset(offset);
            cleanupFrame.request(()=>{
                $2pmb0.flushSync(()=>{
                    setShowStartingStyleAttribute(false);
                });
                onAnimationsFinished(()=>{
                    setPreviousContentNode(null);
                    setPreviousContentDimensions(null);
                    capturedNodeRef.current = null;
                });
            });
            lastHandledTriggerRef.current = activeTrigger;
        }
    }, [
        activeTrigger,
        previousActiveTrigger,
        previousContentNode,
        onAnimationsFinished,
        cleanupFrame
    ]);
    // Capture a clone of the current content DOM subtree when not transitioning.
    // We can't store previous React nodes as they may be stateful; instead we capture DOM clones for visual continuity.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // When a transition is in progress, we store the next content in capturedNodeRef.
        // This handles the case where the trigger changes multiple times before the transition finishes.
        // We want to always capture the latest content for the previous snapshot.
        // So clicking quickly on T1, T2, T3 will result in the following sequence:
        // 1. T1 -> T2: previousContent = T1, currentContent = T2
        // 2. T2 -> T3: previousContent = T2, currentContent = T3
        const source = currentContainerRef.current;
        if (!source) return;
        const wrapper = (0, $8shn9.ownerDocument)(source).createElement('div');
        for (const child of Array.from(source.childNodes))wrapper.appendChild(child.cloneNode(true));
        capturedNodeRef.current = wrapper;
    });
    const isTransitioning = previousContentNode != null;
    let childrenToRender;
    if (!isTransitioning) childrenToRender = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        "data-current": true,
        ref: currentContainerRef,
        children: children
    }, currentContentKey);
    else childrenToRender = /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                "data-previous": true,
                inert: (0, $lwkkr.inertValue)(true),
                ref: previousContainerRef,
                style: {
                    ...previousContentDimensions ? {
                        [cssVars.popupWidth]: `${previousContentDimensions.width}px`,
                        [cssVars.popupHeight]: `${previousContentDimensions.height}px`
                    } : null,
                    position: 'absolute'
                },
                "data-ending-style": showStartingStyleAttribute ? undefined : ''
            }, "previous"),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                "data-current": true,
                ref: currentContainerRef,
                "data-starting-style": showStartingStyleAttribute ? '' : undefined,
                children: children
            }, currentContentKey)
        ]
    });
    // When previousContentNode is present, imperatively populate the previous container with the cloned children.
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        const container = previousContainerRef.current;
        if (!container || !previousContentNode) return;
        container.replaceChildren(...Array.from(previousContentNode.childNodes));
    }, [
        previousContentNode
    ]);
    (0, $eIpqi.usePopupAutoResize)({
        popupElement: popupElement,
        positionerElement: positionerElement,
        mounted: mounted,
        content: payload,
        onMeasureLayout: handleMeasureLayout,
        onMeasureLayoutComplete: handleMeasureLayoutComplete,
        side: side,
        direction: direction
    });
    const state = {
        activationDirection: $83695e2a9a9b29ee$var$getActivationDirection(newTriggerOffset),
        transitioning: isTransitioning
    };
    return {
        children: childrenToRender,
        state: state
    };
}
/**
 * Returns a string describing the provided offset.
 * It describes both the horizontal and vertical offset, separated by a space.
 *
 * @param offset
 */ function $83695e2a9a9b29ee$var$getActivationDirection(offset) {
    if (!offset) return undefined;
    return `${$83695e2a9a9b29ee$var$getValueWithTolerance(offset.horizontal, 5, 'right', 'left')} ${$83695e2a9a9b29ee$var$getValueWithTolerance(offset.vertical, 5, 'down', 'up')}`;
}
/**
 * Returns a label describing the value (positive/negative) treating values
 * within tolerance as zero.
 *
 * @param value Value to check
 * @param tolerance Tolerance to treat the value as zero.
 * @param positiveLabel
 * @param negativeLabel
 * @returns If 0 < abs(value) < tolerance, returns an empty string. Otherwise returns positiveLabel or negativeLabel.
 */ function $83695e2a9a9b29ee$var$getValueWithTolerance(value, tolerance, positiveLabel, negativeLabel) {
    if (value > tolerance) return positiveLabel;
    if (value < -tolerance) return negativeLabel;
    return '';
}
/**
 * Calculates the relative position between centers of two elements.
 */ function $83695e2a9a9b29ee$var$calculateRelativePosition(from, to) {
    const fromRect = from.getBoundingClientRect();
    const toRect = to.getBoundingClientRect();
    const fromCenter = {
        x: fromRect.left + fromRect.width / 2,
        y: fromRect.top + fromRect.height / 2
    };
    const toCenter = {
        x: toRect.left + toRect.width / 2,
        y: toRect.top + toRect.height / 2
    };
    return {
        horizontal: toCenter.x - fromCenter.x,
        vertical: toCenter.y - fromCenter.y
    };
}
/**
 * Returns a key that forces remounting content when triggers change or a payload is updated.
 */ function $83695e2a9a9b29ee$var$usePopupContentKey(activeTriggerId, payload) {
    const [contentKey, setContentKey] = $8NFma.useState(0);
    const previousActiveTriggerIdRef = $8NFma.useRef(activeTriggerId);
    const previousPayloadRef = $8NFma.useRef(payload);
    const pendingPayloadUpdateRef = $8NFma.useRef(false);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Compare against the last committed values to decide whether we need a new DOM subtree.
        const previousActiveTriggerId = previousActiveTriggerIdRef.current;
        const previousPayload = previousPayloadRef.current;
        const triggerIdChanged = activeTriggerId !== previousActiveTriggerId;
        const payloadChanged = payload !== previousPayload;
        if (triggerIdChanged) {
            // Remount immediately on trigger change; remember if payload hasn't caught up yet.
            setContentKey((value)=>value + 1);
            pendingPayloadUpdateRef.current = !payloadChanged;
        } else if (pendingPayloadUpdateRef.current && payloadChanged) {
            // Payload arrived a render later, so remount once more to avoid reusing the old <img>.
            setContentKey((value)=>value + 1);
            pendingPayloadUpdateRef.current = false;
        }
        // Persist current values for the next render's comparison.
        previousActiveTriggerIdRef.current = activeTriggerId;
        previousPayloadRef.current = payload;
    }, [
        activeTriggerId,
        payload
    ]);
    return `${activeTriggerId ?? 'current'}-${contentKey}`;
}

});
parcelRegister("61xYN", function(module, exports) {

$parcel$export(module.exports, "usePreviousValue", () => $c2436def2524f5b6$export$54b70074ca60d2e1);

var $8NFma = parcelRequire("8NFma");
'use client';
function $c2436def2524f5b6$export$54b70074ca60d2e1(value) {
    const [state, setState] = $8NFma.useState({
        current: value,
        previous: null
    });
    if (value !== state.current) setState({
        current: value,
        previous: state.current
    });
    return state.previous;
}

});

parcelRegister("eIpqi", function(module, exports) {

$parcel$export(module.exports, "usePopupAutoResize", () => $3878455205aef210$export$5d1e8d0ca137eec);

var $8NFma = parcelRequire("8NFma");

var $dhRNQ = parcelRequire("dhRNQ");

var $9N3e2 = parcelRequire("9N3e2");

var $fKU9M = parcelRequire("fKU9M");

var $jWAMz = parcelRequire("jWAMz");

var $45x58 = parcelRequire("45x58");

var $2FWV3 = parcelRequire("2FWV3");
'use client';
function $3878455205aef210$export$5d1e8d0ca137eec(parameters) {
    const { popupElement: popupElement, positionerElement: positionerElement, content: content, mounted: mounted, onMeasureLayout: onMeasureLayoutParam, onMeasureLayoutComplete: onMeasureLayoutCompleteParam, side: side, direction: direction } = parameters;
    const runOnceAnimationsFinish = (0, $45x58.useAnimationsFinished)(popupElement, true, false);
    const animationFrame = (0, $dhRNQ.useAnimationFrame)();
    const committedDimensionsRef = $8NFma.useRef(null);
    const isInitialRenderRef = $8NFma.useRef(true);
    const restoreAnchoringStylesRef = $8NFma.useRef((0, $jWAMz.NOOP));
    const onMeasureLayout = (0, $fKU9M.useStableCallback)(onMeasureLayoutParam);
    const onMeasureLayoutComplete = (0, $fKU9M.useStableCallback)(onMeasureLayoutCompleteParam);
    const anchoringStyles = $8NFma.useMemo(()=>{
        // Ensure popup size transitions correctly when anchored to `bottom` (side=top) or `right` (side=left).
        let isOriginSide = side === 'top';
        let isPhysicalLeft = side === 'left';
        if (direction === 'rtl') {
            isOriginSide = isOriginSide || side === 'inline-end';
            isPhysicalLeft = isPhysicalLeft || side === 'inline-end';
        } else {
            isOriginSide = isOriginSide || side === 'inline-start';
            isPhysicalLeft = isPhysicalLeft || side === 'inline-start';
        }
        return isOriginSide ? {
            position: 'absolute',
            [side === 'top' ? 'bottom' : 'top']: '0',
            [isPhysicalLeft ? 'right' : 'left']: '0'
        } : (0, $jWAMz.EMPTY_OBJECT);
    }, [
        side,
        direction
    ]);
    (0, $9N3e2.useIsoLayoutEffect)(()=>{
        // Reset the state when the popup is closed.
        if (!mounted) {
            restoreAnchoringStylesRef.current = (0, $jWAMz.NOOP);
            isInitialRenderRef.current = true;
            committedDimensionsRef.current = null;
            return undefined;
        }
        if (!popupElement || !positionerElement) return undefined;
        restoreAnchoringStylesRef.current = $3878455205aef210$var$applyElementStyles(popupElement, anchoringStyles);
        // Measure the rendered size to enable transitions:
        $3878455205aef210$var$setPopupCssSize(popupElement, 'auto');
        const restorePopupPosition = $3878455205aef210$var$overrideElementStyle(popupElement, 'position', 'static');
        const restorePopupTransform = $3878455205aef210$var$overrideElementStyle(popupElement, 'transform', 'none');
        const restorePopupScale = $3878455205aef210$var$overrideElementStyle(popupElement, 'scale', '1');
        const restorePositionerAvailableSize = $3878455205aef210$var$applyElementStyles(positionerElement, {
            '--available-width': 'max-content',
            '--available-height': 'max-content'
        });
        function restoreMeasurementOverrides() {
            restorePopupPosition();
            restorePopupTransform();
            restorePositionerAvailableSize();
        }
        function restoreMeasurementOverridesIncludingScale() {
            restoreMeasurementOverrides();
            restorePopupScale();
        }
        onMeasureLayout?.();
        // Initial render (for each time the popup opens).
        if (isInitialRenderRef.current || committedDimensionsRef.current === null) {
            $3878455205aef210$var$setPositionerCssSize(positionerElement, 'max-content');
            const dimensions = (0, $2FWV3.getCssDimensions)(popupElement);
            committedDimensionsRef.current = dimensions;
            $3878455205aef210$var$setPositionerCssSize(positionerElement, dimensions);
            restoreMeasurementOverridesIncludingScale();
            onMeasureLayoutComplete?.(null, dimensions);
            isInitialRenderRef.current = false;
            return ()=>{
                restoreAnchoringStylesRef.current();
                restoreAnchoringStylesRef.current = (0, $jWAMz.NOOP);
            };
        }
        // Subsequent renders while open (when `content` changes).
        $3878455205aef210$var$setPositionerCssSize(positionerElement, 'max-content');
        const previousDimensions = committedDimensionsRef.current;
        const newDimensions = (0, $2FWV3.getCssDimensions)(popupElement);
        // Commit immediately so future content changes have a stable previous size.
        committedDimensionsRef.current = newDimensions;
        $3878455205aef210$var$setPopupCssSize(popupElement, previousDimensions);
        restoreMeasurementOverridesIncludingScale();
        onMeasureLayoutComplete?.(previousDimensions, newDimensions);
        $3878455205aef210$var$setPositionerCssSize(positionerElement, newDimensions);
        const abortController = new AbortController();
        animationFrame.request(()=>{
            $3878455205aef210$var$setPopupCssSize(popupElement, newDimensions);
            runOnceAnimationsFinish(()=>{
                popupElement.style.setProperty('--popup-width', 'auto');
                popupElement.style.setProperty('--popup-height', 'auto');
            }, abortController.signal);
        });
        return ()=>{
            abortController.abort();
            animationFrame.cancel();
            restoreAnchoringStylesRef.current();
            restoreAnchoringStylesRef.current = (0, $jWAMz.NOOP);
        };
    }, [
        content,
        popupElement,
        positionerElement,
        runOnceAnimationsFinish,
        animationFrame,
        mounted,
        onMeasureLayout,
        onMeasureLayoutComplete,
        anchoringStyles
    ]);
}
function $3878455205aef210$var$overrideElementStyle(element, property, value) {
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, value);
    return ()=>{
        element.style.setProperty(property, originalValue);
    };
}
function $3878455205aef210$var$applyElementStyles(element, styles) {
    const restorers = [];
    for (const [key, value] of Object.entries(styles))restorers.push($3878455205aef210$var$overrideElementStyle(element, key, value));
    return restorers.length ? ()=>{
        restorers.forEach((restore)=>restore());
    } : (0, $jWAMz.NOOP);
}
function $3878455205aef210$var$setPopupCssSize(popupElement, size) {
    const width = size === 'auto' ? 'auto' : `${size.width}px`;
    const height = size === 'auto' ? 'auto' : `${size.height}px`;
    popupElement.style.setProperty('--popup-width', width);
    popupElement.style.setProperty('--popup-height', height);
}
function $3878455205aef210$var$setPositionerCssSize(positionerElement, size) {
    const width = size === 'max-content' ? 'max-content' : `${size.width}px`;
    const height = size === 'max-content' ? 'max-content' : `${size.height}px`;
    positionerElement.style.setProperty('--positioner-width', width);
    positionerElement.style.setProperty('--positioner-height', height);
}

});
parcelRegister("2FWV3", function(module, exports) {

$parcel$export(module.exports, "getCssDimensions", () => $85b887514f87c82a$export$148a3394c6bbcfe9);

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");
function $85b887514f87c82a$export$148a3394c6bbcfe9(element) {
    const css = (0, $1D9S2.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1D9S2.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $Euxde.round)(width) !== offsetWidth || (0, $Euxde.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height
    };
}

});



parcelRegister("9z4ze", function(module, exports) {

$parcel$export(module.exports, "MenuViewportCssVars", () => $4ca516f2f5dce6e6$export$28ffb5cfe14731dd);
let $4ca516f2f5dce6e6$export$28ffb5cfe14731dd = /*#__PURE__*/ function(MenuViewportCssVars) {
    /**
   * The width of the parent popup.
   * This variable is placed on the 'previous' container and stores the width of the popup when the previous content was rendered.
   * It can be used to freeze the dimensions of the popup when animating between different content.
   */ MenuViewportCssVars["popupWidth"] = "--popup-width";
    /**
   * The height of the parent popup.
   * This variable is placed on the 'previous' container and stores the height of the popup when the previous content was rendered.
   * It can be used to freeze the dimensions of the popup when animating between different content.
   */ MenuViewportCssVars["popupHeight"] = "--popup-height";
    return MenuViewportCssVars;
}({});

});


parcelRegister("aU2TQ", function(module, exports) {

$parcel$export(module.exports, "Separator", () => $19d62ae8ea8254a9$export$1ff3c3f08ae963c0);

var $8NFma = parcelRequire("8NFma");

var $aEBMJ = parcelRequire("aEBMJ");
'use client';
const $19d62ae8ea8254a9$export$1ff3c3f08ae963c0 = /*#__PURE__*/ $8NFma.forwardRef(function SeparatorComponent(componentProps, forwardedRef) {
    const { className: className, render: render, orientation: orientation = 'horizontal', style: style, ...elementProps } = componentProps;
    const state = {
        orientation: orientation
    };
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        ref: forwardedRef,
        props: [
            {
                role: 'separator',
                'aria-orientation': orientation
            },
            elementProps
        ]
    });
    return element;
});

});

parcelRegister("4wUw1", function(module, exports) {

$parcel$export(module.exports, "MenuSubmenuTrigger", () => $a26976bb1209211c$export$d14d905c34db668c);

var $cmjqX = parcelRequire("cmjqX");

var $8NFma = parcelRequire("8NFma");





var $jWAMz = parcelRequire("jWAMz");

var $8ET7Y = parcelRequire("8ET7Y");
var $ioKKL = parcelRequire("ioKKL");
var $ixSMG = parcelRequire("ixSMG");

var $jtR97 = parcelRequire("jtR97");

var $hF6bp = parcelRequire("hF6bp");

var $gVYSt = parcelRequire("gVYSt");

var $ipY60 = parcelRequire("ipY60");

var $kFTCr = parcelRequire("kFTCr");

var $aEBMJ = parcelRequire("aEBMJ");

var $8foVs = parcelRequire("8foVs");

var $kjC6g = parcelRequire("kjC6g");

var $bqzP8 = parcelRequire("bqzP8");
'use client';
const $a26976bb1209211c$export$d14d905c34db668c = /*#__PURE__*/ $8NFma.forwardRef(function MenuSubmenuTrigger(componentProps, forwardedRef) {
    const { render: render, className: className, style: style, label: label, id: idProp, nativeButton: nativeButton = false, openOnHover: openOnHover = true, delay: delay = 100, closeDelay: closeDelay = 0, disabled: disabledProp = false, ...elementProps } = componentProps;
    const listItem = (0, $ipY60.useCompositeListItem)({
        label: label
    });
    const menuPositionerContext = (0, $8foVs.useMenuPositionerContext)();
    const { store: store } = (0, $jtR97.useMenuRootContext)();
    const thisTriggerId = (0, $hF6bp.useBaseUiId)(idProp);
    const open = store.useState('open');
    const floatingRootContext = store.useState('floatingRootContext');
    const floatingTreeRoot = store.useState('floatingTreeRoot');
    const popupId = store.useState('triggerPopupId', thisTriggerId);
    const baseRegisterTrigger = (0, $kjC6g.useTriggerRegistration)(thisTriggerId, store);
    const registerTrigger = $8NFma.useCallback((element)=>{
        const cleanup = baseRegisterTrigger(element);
        if (element !== null && store.select('open') && store.select('activeTriggerId') == null) store.update({
            activeTriggerId: thisTriggerId,
            activeTriggerElement: element,
            closeDelay: closeDelay
        });
        return cleanup;
    }, [
        baseRegisterTrigger,
        closeDelay,
        store,
        thisTriggerId
    ]);
    const triggerElementRef = $8NFma.useRef(null);
    const handleTriggerElementRef = $8NFma.useCallback((el)=>{
        triggerElementRef.current = el;
        store.set('activeTriggerElement', el);
    }, [
        store
    ]);
    const submenuRootContext = (0, $bqzP8.useMenuSubmenuRootContext)();
    if (!submenuRootContext?.parentMenu) throw new Error((0, $cmjqX.default)(37));
    store.useSyncedValue('closeDelay', closeDelay);
    const parentMenuStore = submenuRootContext.parentMenu;
    const rootDisabled = store.useState('disabled');
    const parentDisabled = parentMenuStore.useState('disabled');
    const disabled = disabledProp || rootDisabled || parentDisabled;
    const itemProps = parentMenuStore.useState('itemProps');
    const highlighted = parentMenuStore.useState('isActive', listItem.index);
    const itemMetadata = $8NFma.useMemo(()=>({
            type: 'submenu-trigger',
            setActive () {
                if (parentMenuStore.select('highlightItemOnHover')) parentMenuStore.set('activeIndex', listItem.index);
            }
        }), [
        parentMenuStore,
        listItem.index
    ]);
    const { getItemProps: getItemProps, itemRef: itemRef } = (0, $kFTCr.useMenuItem)({
        closeOnClick: false,
        disabled: disabled,
        highlighted: highlighted,
        id: thisTriggerId,
        store: store,
        typingRef: parentMenuStore.context.typingRef,
        nativeButton: nativeButton,
        itemMetadata: itemMetadata,
        nodeId: menuPositionerContext?.context.nodeId
    });
    const hoverEnabled = store.useState('hoverEnabled');
    const hoverProps = (0, $ixSMG.useHoverReferenceInteraction)(floatingRootContext, {
        enabled: hoverEnabled && openOnHover && !disabled,
        handleClose: (0, $8ET7Y.safePolygon)({
            blockPointerEvents: true
        }),
        mouseOnly: true,
        move: true,
        restMs: delay,
        delay: {
            open: delay,
            close: closeDelay
        },
        shouldOpen: delay > 0 ? ()=>parentMenuStore.select('allowMouseEnter') : undefined,
        triggerElementRef: triggerElementRef,
        externalTree: floatingTreeRoot,
        isClosing: ()=>store.select('transitionStatus') === 'ending'
    });
    const click = (0, $ioKKL.useClick)(floatingRootContext, {
        enabled: !disabled,
        event: 'mousedown',
        toggle: !openOnHover,
        ignoreMouse: openOnHover,
        stickIfOpen: false
    });
    const localInteractionProps = click.reference ?? (0, $jWAMz.EMPTY_OBJECT);
    const rootTriggerProps = store.useState('triggerProps', true);
    delete rootTriggerProps.id;
    const state = {
        disabled: disabled,
        highlighted: highlighted,
        open: open
    };
    const element = (0, $aEBMJ.useRenderElement)('div', componentProps, {
        state: state,
        stateAttributesMapping: (0, $gVYSt.triggerOpenStateMapping),
        props: [
            localInteractionProps,
            hoverProps,
            rootTriggerProps,
            itemProps,
            {
                'aria-controls': popupId,
                tabIndex: open || highlighted ? 0 : -1,
                onBlur () {
                    if (highlighted) parentMenuStore.set('activeIndex', null);
                }
            },
            elementProps,
            getItemProps
        ],
        ref: [
            forwardedRef,
            listItem.ref,
            itemRef,
            registerTrigger,
            handleTriggerElementRef
        ]
    });
    return element;
});

});

parcelRegister("5eHXn", function(module, exports) {

$parcel$export(module.exports, "MenuHandle", () => $4a7a37bac4b6cb5c$export$87fca5e0753a6ab9);
$parcel$export(module.exports, "createMenuHandle", () => $4a7a37bac4b6cb5c$export$11344e54c01d7620);

var $cmjqX = parcelRequire("cmjqX");

var $6e5YN = parcelRequire("6e5YN");

var $2eLUt = parcelRequire("2eLUt");
class $4a7a37bac4b6cb5c$export$87fca5e0753a6ab9 {
    /**
   * Internal store holding the menu's state.
   * @internal
   */ constructor(){
        this.store = new (0, $2eLUt.MenuStore)();
    }
    /**
   * Opens the menu and associates it with the trigger with the given id.
   * The trigger must be a Menu.Trigger component with this handle passed as a prop.
   *
   * @param triggerId ID of the trigger to associate with the menu.
   */ open(triggerId) {
        const triggerElement = triggerId ? this.store.context.triggerElements.getById(triggerId) : undefined;
        if (triggerId && !triggerElement) throw new Error((0, $cmjqX.default)(83, triggerId));
        this.store.setOpen(true, (0, $6e5YN.createChangeEventDetails)('imperative-action', undefined, triggerElement));
    }
    /**
   * Closes the menu.
   */ close() {
        this.store.setOpen(false, (0, $6e5YN.createChangeEventDetails)('imperative-action', undefined, undefined));
    }
    /**
   * Indicates whether the menu is currently open.
   */ get isOpen() {
        return this.store.select('open');
    }
}
function $4a7a37bac4b6cb5c$export$11344e54c01d7620() {
    return new $4a7a37bac4b6cb5c$export$87fca5e0753a6ab9();
}

});


parcelRegister("cU3m9", function(module, exports) {

$parcel$export(module.exports, "default", () => $006868e14dd1063c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $006868e14dd1063c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 5h16",
            key: "1tepv9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 19h16",
            key: "1djgab"
        }
    ]
];
const $006868e14dd1063c$export$2e2bcd8739ae039 = (0, $8KNb5.default)("menu", $006868e14dd1063c$export$3efd853dbb351e94);

});
parcelRegister("8KNb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b85aae96429aa4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8NFma = parcelRequire("8NFma");

var $jr6ni = parcelRequire("jr6ni");

var $7fOWr = parcelRequire("7fOWr");

var $1H7vT = parcelRequire("1H7vT");

var $jAF2f = parcelRequire("jAF2f");
const $58b85aae96429aa4$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $8NFma.forwardRef)(({ className: className, ...props }, ref)=>(0, $8NFma.createElement)((0, $jAF2f.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $jr6ni.mergeClasses)(`lucide-${(0, $7fOWr.toKebabCase)((0, $1H7vT.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $1H7vT.toPascalCase)(iconName);
    return Component;
};

});
parcelRegister("jr6ni", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", () => $c0701dc7a74644c2$export$3d46f4579dba46e5);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c0701dc7a74644c2$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("7fOWr", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $636750329d9e9b6c$export$73bda83cddbc7187);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $636750329d9e9b6c$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});

parcelRegister("1H7vT", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", () => $01cb72138aa55363$export$6fb43ff9addf7357);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bzpcq = parcelRequire("bzpcq");
const $01cb72138aa55363$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $bzpcq.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("bzpcq", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $c82ade8fa4dd499f$export$86f54f62aa7a7514);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c82ade8fa4dd499f$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());

});


parcelRegister("jAF2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6797b1066137ff$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $dmuam = parcelRequire("dmuam");

var $hZ6ht = parcelRequire("hZ6ht");

var $jr6ni = parcelRequire("jr6ni");

var $3I3VB = parcelRequire("3I3VB");
"use strict";
"use client";
const $1a6797b1066137ff$export$2e2bcd8739ae039 = (0, $8NFma.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $3I3VB.useLucideContext)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $8NFma.createElement)("svg", {
        ref: ref,
        ...(0, $dmuam.default),
        width: size ?? contextSize ?? (0, $dmuam.default).width,
        height: size ?? contextSize ?? (0, $dmuam.default).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $jr6ni.mergeClasses)("lucide", contextClass, className),
        ...!children && !(0, $hZ6ht.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $8NFma.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("dmuam", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bafe5e268bfd873$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $3bafe5e268bfd873$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});

parcelRegister("hZ6ht", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", () => $c6760ec8dbcaa5f0$export$ab365959aa6deed0);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c6760ec8dbcaa5f0$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});

parcelRegister("3I3VB", function(module, exports) {

$parcel$export(module.exports, "useLucideContext", () => $9b021b62266f38b6$export$52ee7576b6cde767);

var $8NFma = parcelRequire("8NFma");
"use strict";
"use client";
const $9b021b62266f38b6$var$LucideContext = (0, $8NFma.createContext)({});
function $9b021b62266f38b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $8NFma.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $8NFma.createElement)($9b021b62266f38b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $9b021b62266f38b6$export$52ee7576b6cde767 = ()=>(0, $8NFma.useContext)($9b021b62266f38b6$var$LucideContext);

});




parcelRegister("3dVOr", function(module, exports) {

$parcel$export(module.exports, "useNoteGenerator", () => $258f6e5a49f1cec9$export$710dba3e3a17f4b1);

var $8NFma = parcelRequire("8NFma");

var $kmdF6 = parcelRequire("kmdF6");

var $7baak = parcelRequire("7baak");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");
const $258f6e5a49f1cec9$export$710dba3e3a17f4b1 = ({ instrument: instrument })=>{
    const tonality = (0, $7Kpeg.useSelector)((0, $5ICqB.selectTonality));
    let jsPianoRollEl;
    (0, $8NFma.useEffect)(()=>{
        jsPianoRollEl = document.getElementById(instrument.id + "_piano-roll");
    });
    const numSteps = (0, $7Kpeg.useSelector)(instrument.getDisplayClipLengthSelector());
    const pitchRange = instrument.pitchRange.typical ?? instrument.pitchRange.usable;
    const lowestNote = pitchRange.min;
    const highestNote = pitchRange.max;
    const scalePCs = (0, $7baak.getPCsFromScaleName)(tonality);
    const scalePitchesInRange = new Map();
    let i = 0;
    scalePCs.forEach((scalePC)=>{
        const degree = i + 1;
        let octavedPC = (0, $7baak.getNextPitchClassAfterPitch)(scalePC, lowestNote);
        while(octavedPC <= highestNote){
            scalePitchesInRange.set(octavedPC, {
                degree: degree
            });
            octavedPC += 12;
        }
        i++;
    });
    const degreeWeights = {
        1: 5,
        2: 1,
        3: 2,
        4: 1,
        5: 4,
        6: 1,
        7: 1
    };
    const diatonicIntervalWeights = {
        0: 1,
        1: 6,
        2: 1,
        3: 1,
        4: 1,
        5: 1,
        7: 2
    };
    const getNextPitch = (previousPitch)=>{
        const possiblePitches = [
            ...scalePitchesInRange.keys()
        ];
        const weights = [
            ...scalePitchesInRange.entries()
        ].map(([pitch, noteInfo])=>{
            const degreeWeight = degreeWeights[noteInfo.degree];
            const [intervalQuantity, _] = previousPitch !== undefined ? (0, $7baak.calcDiatonicInterval)(previousPitch, pitch) : [
                0,
                'P'
            ];
            const intervalWeight = diatonicIntervalWeights[Math.abs(intervalQuantity)] ?? 0;
            return degreeWeight * intervalWeight;
        });
        return (0, $kmdF6.weightedSample)(possiblePitches, weights);
    };
    const randomHalves = (array, iterations = 0)=>{
        if (typeof array === "number") array = [
            array
        ];
        if (iterations === 0) return array;
        const newArray = [];
        array.forEach((element)=>{
            if (Math.random() < 0.5) newArray.push(element);
            else newArray.push(element / 2, element / 2);
        });
        return randomHalves(newArray, iterations - 1);
    };
    const generate = ()=>{
        const parts = randomHalves(numSteps, numSteps / 16);
        const durations = [];
        parts.forEach((partDuration)=>{
            durations.push(...(0, $kmdF6.euclid)((0, $kmdF6.sample)([
                2,
                3,
                4,
                5
            ]), partDuration));
        });
        const onsets = (0, $kmdF6.distanceToAbsolute)(durations).slice(0, -1);
        const newSequence = [];
        let previousPitch;
        const firstAvailableID = jsPianoRollEl.getNextAvailableID();
        onsets.forEach((onset, index)=>{
            const duration = durations[index];
            const pitch = getNextPitch(previousPitch);
            const nota = {
                onset: onset,
                duration: duration,
                pitch: pitch,
                s: 0,
                id: firstAvailableID + index
            };
            newSequence.push(nota);
            previousPitch = pitch;
        });
        instrument.updateSequence(newSequence);
    };
    return generate;
};

});

parcelRegister("5mwHr", function(module, exports) {

$parcel$export(module.exports, "factoryClips", () => $3e785f5072d25646$export$cd302938163c97e);

var $89z11 = parcelRequire("89z11");
const $3e785f5072d25646$export$cd302938163c97e = Object.entries($89z11).map(([name, clip])=>({
        ...clip,
        _metadata: {
            ...clip._metadata,
            name: name,
            isFactory: true
        }
    }));

});
parcelRegister("89z11", function(module, exports) {

var $kwq97 = parcelRequire("kwq97");

var $axOAB = parcelRequire("axOAB");

var $iNiPa = parcelRequire("iNiPa");

var $ctgrC = parcelRequire("ctgrC");

var $2jK6s = parcelRequire("2jK6s");

var $7Pd26 = parcelRequire("7Pd26");

var $926gH = parcelRequire("926gH");

var $lTeI6 = parcelRequire("lTeI6");

var $3cecg = parcelRequire("3cecg");

var $9OK6d = parcelRequire("9OK6d");
module.exports = {
    "Acid House": $kwq97,
    "Dub Reggae": $axOAB,
    "Funky Soul": $iNiPa,
    "Hip Hop Classic 1": $ctgrC,
    "Hip Hop Classic 2": $2jK6s,
    "Reggae Roots": $7Pd26,
    "Soul Pop": $926gH,
    "Trap 1": $lTeI6,
    "Trap 2": $3cecg,
    "Urban Reggaeton": $9OK6d
};

});
parcelRegister("kwq97", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":8,\"duration\":1},{\"pitch\":46,\"onset\":0,\"duration\":1},{\"pitch\":36,\"onset\":4,\"duration\":1},{\"pitch\":36,\"onset\":12,\"duration\":1},{\"pitch\":46,\"onset\":14,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("axOAB", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":36,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":36,\"onset\":2,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":36,\"onset\":6,\"duration\":1},{\"pitch\":46,\"onset\":8,\"duration\":1},{\"pitch\":36,\"onset\":8,\"duration\":1},{\"pitch\":36,\"onset\":10,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":14,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("iNiPa", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":36,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":2,\"duration\":1},{\"pitch\":36,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":38,\"onset\":15,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("ctgrC", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":36,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1},{\"pitch\":46,\"onset\":14,\"duration\":1},{\"pitch\":36,\"onset\":15,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("2jK6s", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":36,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":9,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":38,\"onset\":15,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("7Pd26", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":38,\"onset\":15,\"duration\":1},{\"pitch\":38,\"onset\":2,\"duration\":1},{\"pitch\":36,\"onset\":4,\"duration\":1},{\"pitch\":46,\"onset\":11,\"duration\":1},{\"pitch\":36,\"onset\":11,\"duration\":1},{\"pitch\":42,\"onset\":13,\"duration\":1},{\"pitch\":36,\"onset\":13,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("926gH", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":38,\"onset\":4,\"duration\":1},{\"pitch\":36,\"onset\":8,\"duration\":1},{\"pitch\":38,\"onset\":12,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("lTeI6", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":1,\"duration\":1},{\"pitch\":42,\"onset\":5,\"duration\":1},{\"pitch\":42,\"onset\":7,\"duration\":1},{\"pitch\":38,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":11,\"duration\":1},{\"pitch\":42,\"onset\":13,\"duration\":1},{\"pitch\":42,\"onset\":14,\"duration\":1},{\"pitch\":42,\"onset\":15,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("3cecg", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":1,\"duration\":1},{\"pitch\":42,\"onset\":5,\"duration\":1},{\"pitch\":38,\"onset\":8,\"duration\":1},{\"pitch\":42,\"onset\":11,\"duration\":1},{\"pitch\":42,\"onset\":13,\"duration\":1},{\"pitch\":42,\"onset\":15,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":36,\"onset\":4,\"duration\":1},{\"pitch\":42,\"onset\":9,\"duration\":1},{\"pitch\":36,\"onset\":15,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});

parcelRegister("9OK6d", function(module, exports) {
module.exports = JSON.parse("{\"sequence\":[{\"pitch\":36,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":0,\"duration\":1},{\"pitch\":42,\"onset\":2,\"duration\":1},{\"pitch\":42,\"onset\":10,\"duration\":1},{\"pitch\":42,\"onset\":4,\"duration\":1},{\"pitch\":36,\"onset\":4,\"duration\":1},{\"pitch\":38,\"onset\":3,\"duration\":1},{\"pitch\":42,\"onset\":6,\"duration\":1},{\"pitch\":38,\"onset\":6,\"duration\":1},{\"pitch\":42,\"onset\":8,\"duration\":1},{\"pitch\":36,\"onset\":8,\"duration\":1},{\"pitch\":38,\"onset\":11,\"duration\":1},{\"pitch\":42,\"onset\":12,\"duration\":1},{\"pitch\":36,\"onset\":12,\"duration\":1},{\"pitch\":38,\"onset\":14,\"duration\":1},{\"pitch\":46,\"onset\":14,\"duration\":1}],\"length\":16,\"_metadata\":{\"instrumentType\":\"groovebox\"}}");

});



parcelRegister("k0n2x", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $e905adff5d5055d5$export$3ddf2d174ce01153);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $64a8q = parcelRequire("64a8q");

var $cknS9 = parcelRequire("cknS9");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");

var $gMyz9 = parcelRequire("gMyz9");

var $4ldcI = parcelRequire("4ldcI");

var $gK2aR = parcelRequire("gK2aR");

var $bKF0T = parcelRequire("bKF0T");

var $cLCHn = parcelRequire("cLCHn");
'use client';
function $e905adff5d5055d5$var$_extends() {
    return $e905adff5d5055d5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e905adff5d5055d5$var$_extends.apply(null, arguments);
}
function $e905adff5d5055d5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e905adff5d5055d5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e905adff5d5055d5$var$_typeof(o);
}
function $e905adff5d5055d5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e905adff5d5055d5$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e905adff5d5055d5$var$_arrayLikeToArray(r);
}
function $e905adff5d5055d5$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e905adff5d5055d5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e905adff5d5055d5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e905adff5d5055d5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e905adff5d5055d5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e905adff5d5055d5$var$_toConsumableArray(r) {
    return $e905adff5d5055d5$var$_arrayWithoutHoles(r) || $e905adff5d5055d5$var$_iterableToArray(r) || $e905adff5d5055d5$var$_unsupportedIterableToArray(r) || $e905adff5d5055d5$var$_nonIterableSpread();
}
function $e905adff5d5055d5$var$toPrimitive(t, r) {
    if ("object" != $e905adff5d5055d5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e905adff5d5055d5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e905adff5d5055d5$var$toPropertyKey(t) {
    var i = $e905adff5d5055d5$var$toPrimitive(t, "string");
    return "symbol" == $e905adff5d5055d5$var$_typeof(i) ? i : i + "";
}
function $e905adff5d5055d5$var$_defineProperty(e, r, t) {
    return (r = $e905adff5d5055d5$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e905adff5d5055d5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e905adff5d5055d5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e905adff5d5055d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e905adff5d5055d5$var$_slicedToArray(r, e) {
    return $e905adff5d5055d5$var$_arrayWithHoles(r) || $e905adff5d5055d5$var$_iterableToArrayLimit(r, e) || $e905adff5d5055d5$var$_unsupportedIterableToArray(r, e) || $e905adff5d5055d5$var$_nonIterableRest();
}
var $e905adff5d5055d5$var$styles$1 = '';
var $e905adff5d5055d5$var$FocusTrapBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'FocusTrap',
        children: undefined
    },
    css: {
        styles: $e905adff5d5055d5$var$styles$1
    },
    getProps: function getProps(props) {
        return (0, $kMhUd.ObjectUtils).getMergedProps(props, $e905adff5d5055d5$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $kMhUd.ObjectUtils).getDiffProps(props, $e905adff5d5055d5$var$FocusTrapBase.defaultProps);
    }
});
function $e905adff5d5055d5$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e905adff5d5055d5$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e905adff5d5055d5$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $e905adff5d5055d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e905adff5d5055d5$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e905adff5d5055d5$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $eGEKG.PrimeReactContext));
    var props = $e905adff5d5055d5$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $kocnD.useStyle)($e905adff5d5055d5$var$FocusTrapBase.css.styles, {
        name: 'focustrap'
    });
    var _FocusTrapBase$setMet = $e905adff5d5055d5$var$FocusTrapBase.setMetaData($e905adff5d5055d5$var$_objectSpread$2({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $kocnD.useMountEffect)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? '' : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? '' : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $kMhUd.DomHandler).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $kMhUd.DomHandler).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $kMhUd.DomHandler).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ":not(.p-hidden-focusable):not([data-p-hidden-focusable=\"true\"])".concat(selector !== null && selector !== void 0 ? selector : '');
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $kMhUd.DomHandler).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $kMhUd.DomHandler).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $kMhUd.DomHandler).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $kMhUd.DomHandler).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(inRef, onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", {
                ref: inRef,
                className: 'p-hidden-accessible p-hidden-focusable',
                tabIndex: tabIndex,
                role: 'presentation',
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(firstFocusableElementRef, onFirstHiddenElementFocus, 'firstfocusableelement');
        var lastFocusableElement = createFocusableElement(lastFocusableElementRef, onLastHiddenElementFocus, 'lastfocusableelement');
        if (firstFocusableElementRef.current && lastFocusableElementRef.current) {
            firstFocusableElementRef.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElementRef.current;
            lastFocusableElementRef.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElementRef.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $e905adff5d5055d5$var$FocusTrap$1 = $e905adff5d5055d5$var$FocusTrap;
function $e905adff5d5055d5$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e905adff5d5055d5$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e905adff5d5055d5$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $e905adff5d5055d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e905adff5d5055d5$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e905adff5d5055d5$var$classes = {
    closeButtonIcon: 'p-dialog-header-close-icon',
    closeButton: 'p-dialog-header-icon p-dialog-header-close p-link',
    maximizableIcon: 'p-dialog-header-maximize-icon',
    maximizableButton: 'p-dialog-header-icon p-dialog-header-maximize p-link',
    header: function header(_ref) {
        var props = _ref.props;
        return (0, $kMhUd.classNames)('p-dialog-header', props.headerClassName);
    },
    headerTitle: 'p-dialog-title',
    headerIcons: 'p-dialog-header-icons',
    content: function content(_ref2) {
        var props = _ref2.props;
        return (0, $kMhUd.classNames)('p-dialog-content', props.contentClassName);
    },
    footer: function footer(_ref3) {
        var props = _ref3.props;
        return (0, $kMhUd.classNames)('p-dialog-footer', props.footerClassName);
    },
    mask: function mask(_ref4) {
        var props = _ref4.props, maskVisibleState = _ref4.maskVisibleState;
        var positions = [
            'center',
            'left',
            'right',
            'top',
            'top-left',
            'top-right',
            'bottom',
            'bottom-left',
            'bottom-right'
        ];
        var pos = positions.find(function(item) {
            return item === props.position || item.replace('-', '') === props.position;
        });
        return (0, $kMhUd.classNames)('p-dialog-mask', pos ? "p-dialog-".concat(pos) : '', {
            'p-component-overlay p-component-overlay-enter': props.modal,
            'p-dialog-visible': maskVisibleState,
            'p-dialog-draggable': props.draggable,
            'p-dialog-resizable': props.resizable
        }, props.maskClassName);
    },
    root: function root(_ref5) {
        var props = _ref5.props, maximized = _ref5.maximized, context = _ref5.context;
        return (0, $kMhUd.classNames)('p-dialog p-component', {
            'p-dialog-rtl': props.rtl,
            'p-dialog-maximized': maximized,
            'p-dialog-default': !maximized,
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $eGEKG.default).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $eGEKG.default).ripple === false
        });
    },
    transition: 'p-dialog'
};
var $e905adff5d5055d5$var$styles = "\n@layer primereact {\n    .p-dialog-mask {\n        background-color: transparent;\n        transition-property: background-color;\n    }\n\n    .p-dialog-visible {\n        display: flex;\n    }\n\n    .p-dialog-mask.p-component-overlay {\n        pointer-events: auto;\n    }\n\n    .p-dialog {\n        display: flex;\n        flex-direction: column;\n        pointer-events: auto;\n        max-height: 90%;\n        transform: scale(1);\n        position: relative;\n    }\n\n    .p-dialog-content {\n        overflow-y: auto;\n        flex-grow: 1;\n    }\n\n    .p-dialog-header {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n    }\n\n    .p-dialog-footer {\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icons {\n        display: flex;\n        align-items: center;\n        align-self: flex-start;\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-dialog .p-dialog-title {\n        flex-grow: 1;\n    }\n\n    /* Fluid */\n    .p-fluid .p-dialog-footer .p-button {\n        width: auto;\n    }\n\n    /* Animation */\n    /* Center */\n    .p-dialog-enter {\n        opacity: 0;\n        transform: scale(0.7);\n    }\n\n    .p-dialog-enter-active {\n        opacity: 1;\n        transform: scale(1);\n        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-dialog-enter-done {\n        transform: none;\n    }\n\n    .p-dialog-exit-active {\n        opacity: 0;\n        transform: scale(0.7);\n        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    /* Top, Bottom, Left, Right, Top* and Bottom* */\n    .p-dialog-top .p-dialog,\n    .p-dialog-bottom .p-dialog,\n    .p-dialog-left .p-dialog,\n    .p-dialog-right .p-dialog,\n    .p-dialog-top-left .p-dialog,\n    .p-dialog-top-right .p-dialog,\n    .p-dialog-bottom-left .p-dialog,\n    .p-dialog-bottom-right .p-dialog {\n        margin: 0.75em;\n    }\n\n    .p-dialog-top .p-dialog-enter,\n    .p-dialog-top .p-dialog-exit-active {\n        transform: translate3d(0px, -100%, 0px);\n    }\n\n    .p-dialog-bottom .p-dialog-enter,\n    .p-dialog-bottom .p-dialog-exit-active {\n        transform: translate3d(0px, 100%, 0px);\n    }\n\n    .p-dialog-left .p-dialog-enter,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-enter,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-enter,\n    .p-dialog-bottom-left .p-dialog-exit-active {\n        transform: translate3d(-100%, 0px, 0px);\n    }\n\n    .p-dialog-right .p-dialog-enter,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-enter,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-enter,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transform: translate3d(100%, 0px, 0px);\n    }\n\n    .p-dialog-top .p-dialog-enter-active,\n    .p-dialog-bottom .p-dialog-enter-active,\n    .p-dialog-left .p-dialog-enter-active,\n    .p-dialog-top-left .p-dialog-enter-active,\n    .p-dialog-bottom-left .p-dialog-enter-active,\n    .p-dialog-right .p-dialog-enter-active,\n    .p-dialog-top-right .p-dialog-enter-active,\n    .p-dialog-bottom-right .p-dialog-enter-active {\n        transform: translate3d(0px, 0px, 0px);\n        transition: all 0.3s ease-out;\n    }\n\n    .p-dialog-top .p-dialog-exit-active,\n    .p-dialog-bottom .p-dialog-exit-active,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-exit-active,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transition: all 0.3s ease-out;\n    }\n\n    /* Maximize */\n    .p-dialog-maximized {\n        transition: none;\n        transform: none;\n        margin: 0;\n        width: 100vw !important;\n        height: 100vh !important;\n        max-height: 100%;\n        top: 0px !important;\n        left: 0px !important;\n    }\n\n    .p-dialog-maximized .p-dialog-content {\n        flex-grow: 1;\n    }\n\n    .p-confirm-dialog .p-dialog-content {\n        display: flex;\n        align-items: center;\n    }\n\n    /* Resizable */\n    .p-dialog .p-resizable-handle {\n        position: absolute;\n        font-size: 0.1px;\n        display: block;\n        cursor: se-resize;\n        width: 12px;\n        height: 12px;\n        right: 1px;\n        bottom: 1px;\n    }\n\n    .p-dialog-draggable .p-dialog-header {\n        cursor: move;\n    }\n}\n";
var $e905adff5d5055d5$var$inlineStyles = {
    mask: function mask(_ref6) {
        var props = _ref6.props;
        return $e905adff5d5055d5$var$_objectSpread$1({
            position: 'fixed',
            height: '100%',
            width: '100%',
            left: 0,
            top: 0,
            display: 'flex',
            justifyContent: props.position === 'left' || props.position === 'top-left' || props.position === 'bottom-left' ? 'flex-start' : props.position === 'right' || props.position === 'top-right' || props.position === 'bottom-right' ? 'flex-end' : 'center',
            alignItems: props.position === 'top' || props.position === 'top-left' || props.position === 'top-right' ? 'flex-start' : props.position === 'bottom' || props.position === 'bottom-left' || props.position === 'bottom-right' ? 'flex-end' : 'center',
            pointerEvents: !props.modal && 'none'
        }, props.maskStyle);
    }
};
var $e905adff5d5055d5$var$DialogBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Dialog',
        __parentMetadata: null,
        appendTo: null,
        ariaCloseIconLabel: null,
        baseZIndex: 0,
        blockScroll: false,
        breakpoints: null,
        className: null,
        closable: true,
        closeIcon: null,
        closeOnEscape: true,
        content: null,
        contentClassName: null,
        contentStyle: null,
        dismissableMask: false,
        draggable: true,
        focusOnShow: true,
        footer: null,
        footerClassName: null,
        header: null,
        headerClassName: null,
        headerStyle: null,
        icons: null,
        id: null,
        keepInViewport: true,
        maskClassName: null,
        maskStyle: null,
        maximizable: false,
        maximizeIcon: null,
        maximized: false,
        minX: 0,
        minY: 0,
        minimizeIcon: null,
        modal: true,
        onClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragStart: null,
        onHide: null,
        onMaskClick: null,
        onMaximize: null,
        onResize: null,
        onResizeEnd: null,
        onResizeStart: null,
        onShow: null,
        position: 'center',
        resizable: true,
        rtl: false,
        showHeader: true,
        showCloseIcon: true,
        style: null,
        transitionOptions: null,
        visible: false,
        children: undefined
    },
    css: {
        classes: $e905adff5d5055d5$var$classes,
        styles: $e905adff5d5055d5$var$styles,
        inlineStyles: $e905adff5d5055d5$var$inlineStyles
    }
});
function $e905adff5d5055d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e905adff5d5055d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e905adff5d5055d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e905adff5d5055d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e905adff5d5055d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e905adff5d5055d5$export$3ddf2d174ce01153 = /*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $e905adff5d5055d5$var$DialogBase.getProps(inProps, context);
    var uniqueId = props.id ? props.id : (0, $kMhUd.UniqueComponentId)();
    var _React$useState = $8NFma.useState(uniqueId), _React$useState2 = $e905adff5d5055d5$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0];
    _React$useState2[1];
    var _React$useState3 = $8NFma.useState(false), _React$useState4 = $e905adff5d5055d5$var$_slicedToArray(_React$useState3, 2), maskVisibleState = _React$useState4[0], setMaskVisibleState = _React$useState4[1];
    var _React$useState5 = $8NFma.useState(false), _React$useState6 = $e905adff5d5055d5$var$_slicedToArray(_React$useState5, 2), visibleState = _React$useState6[0], setVisibleState = _React$useState6[1];
    var _React$useState7 = $8NFma.useState(props.maximized), _React$useState8 = $e905adff5d5055d5$var$_slicedToArray(_React$useState7, 2), maximizedState = _React$useState8[0], setMaximizedState = _React$useState8[1];
    var dialogRef = $8NFma.useRef(null);
    var maskRef = $8NFma.useRef(null);
    var pointerRef = $8NFma.useRef(null);
    var contentRef = $8NFma.useRef(null);
    var headerRef = $8NFma.useRef(null);
    var footerRef = $8NFma.useRef(null);
    var closeRef = $8NFma.useRef(null);
    var dragging = $8NFma.useRef(false);
    var resizing = $8NFma.useRef(false);
    var lastPageX = $8NFma.useRef(null);
    var lastPageY = $8NFma.useRef(null);
    var styleElement = $8NFma.useRef(null);
    var attributeSelector = $8NFma.useRef(uniqueId);
    var focusElementOnHide = $8NFma.useRef(null);
    var maximized = props.onMaximize ? props.maximized : maximizedState;
    var shouldBlockScroll = visibleState && (props.blockScroll || props.maximizable && maximized);
    var isCloseOnEscape = props.closable && props.closeOnEscape && visibleState;
    var displayOrder = (0, $kocnD.useDisplayOrder)('dialog', isCloseOnEscape);
    var _DialogBase$setMetaDa = $e905adff5d5055d5$var$DialogBase.setMetaData($e905adff5d5055d5$var$_objectSpread($e905adff5d5055d5$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            id: idState,
            maximized: maximized,
            containerVisible: maskVisibleState
        }
    })), ptm = _DialogBase$setMetaDa.ptm, cx = _DialogBase$setMetaDa.cx, sx = _DialogBase$setMetaDa.sx, isUnstyled = _DialogBase$setMetaDa.isUnstyled;
    (0, $64a8q.useHandleStyle)($e905adff5d5055d5$var$DialogBase.css.styles, isUnstyled, {
        name: 'dialog'
    });
    (0, $kocnD.useGlobalOnEscapeKey)({
        callback: function callback(event) {
            onClose(event);
        },
        when: isCloseOnEscape && displayOrder,
        priority: [
            (0, $kocnD.ESC_KEY_HANDLING_PRIORITIES).DIALOG,
            displayOrder
        ]
    });
    var _useEventListener = (0, $kocnD.useEventListener)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener2 = $e905adff5d5055d5$var$_slicedToArray(_useEventListener, 2), bindDocumentResizeListener = _useEventListener2[0], unbindDocumentResizeListener = _useEventListener2[1];
    var _useEventListener3 = (0, $kocnD.useEventListener)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResizeEnd(event);
        }
    }), _useEventListener4 = $e905adff5d5055d5$var$_slicedToArray(_useEventListener3, 2), bindDocumentResizeEndListener = _useEventListener4[0], unbindDocumentResizEndListener = _useEventListener4[1];
    var _useEventListener5 = (0, $kocnD.useEventListener)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $e905adff5d5055d5$var$_slicedToArray(_useEventListener5, 2), bindDocumentDragListener = _useEventListener6[0], unbindDocumentDragListener = _useEventListener6[1];
    var _useEventListener7 = (0, $kocnD.useEventListener)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $e905adff5d5055d5$var$_slicedToArray(_useEventListener7, 2), bindDocumentDragEndListener = _useEventListener8[0], unbindDocumentDragEndListener = _useEventListener8[1];
    var onClose = function onClose(event) {
        props.onHide(event);
        event.preventDefault();
    };
    var focus = function focus() {
        var activeElement = document.activeElement;
        var isActiveElementInDialog = activeElement && dialogRef.current && dialogRef.current.contains(activeElement);
        if (!isActiveElementInDialog && props.closable && props.showCloseIcon && props.showHeader && closeRef.current) closeRef.current.focus();
    };
    var onDialogPointerDown = function onDialogPointerDown(event) {
        pointerRef.current = event.target;
        props.onPointerDown && props.onPointerDown(event);
    };
    var onMaskPointerUp = function onMaskPointerUp(event) {
        if (props.dismissableMask && props.modal && maskRef.current === event.target && !pointerRef.current) onClose(event);
        props.onMaskClick && props.onMaskClick(event);
        pointerRef.current = null;
    };
    var toggleMaximize = function toggleMaximize(event) {
        if (props.onMaximize) props.onMaximize({
            originalEvent: event,
            maximized: !maximized
        });
        else setMaximizedState(function(prevMaximized) {
            return !prevMaximized;
        });
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event) {
        if ((0, $kMhUd.DomHandler).hasClass(event.target, 'p-dialog-header-icon') || (0, $kMhUd.DomHandler).hasClass(event.target.parentElement, 'p-dialog-header-icon')) return;
        if (props.draggable) {
            dragging.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $kMhUd.DomHandler).addClass(document.body, 'p-unselectable-text');
            props.onDragStart && props.onDragStart(event);
        }
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            var width = (0, $kMhUd.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $kMhUd.DomHandler).getOuterHeight(dialogRef.current);
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var offset = dialogRef.current.getBoundingClientRect();
            var leftPos = offset.left + deltaX;
            var topPos = offset.top + deltaY;
            var viewport = (0, $kMhUd.DomHandler).getViewport();
            var computedStyle = getComputedStyle(dialogRef.current);
            var leftMargin = parseFloat(computedStyle.marginLeft);
            var topMargin = parseFloat(computedStyle.marginTop);
            dialogRef.current.style.position = 'fixed';
            if (props.keepInViewport) {
                if (leftPos >= props.minX && leftPos + width < viewport.width) {
                    lastPageX.current = event.pageX;
                    dialogRef.current.style.left = leftPos - leftMargin + 'px';
                }
                if (topPos >= props.minY && (deltaY < 0 || topPos + height < viewport.height)) {
                    lastPageY.current = event.pageY;
                    dialogRef.current.style.top = topPos - topMargin + 'px';
                }
            } else {
                lastPageX.current = event.pageX;
                dialogRef.current.style.left = leftPos - leftMargin + 'px';
                lastPageY.current = event.pageY;
                dialogRef.current.style.top = topPos - topMargin + 'px';
            }
            props.onDrag && props.onDrag(event);
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            (0, $kMhUd.DomHandler).removeClass(document.body, 'p-unselectable-text');
            props.onDragEnd && props.onDragEnd(event);
        }
    };
    var onResizeStart = function onResizeStart(event) {
        if (props.resizable) {
            resizing.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $kMhUd.DomHandler).addClass(document.body, 'p-unselectable-text');
            props.onResizeStart && props.onResizeStart(event);
        }
    };
    var convertToPx = function convertToPx(value, property, viewport) {
        !viewport && (viewport = (0, $kMhUd.DomHandler).getViewport());
        var val = parseInt(value);
        if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(value)) return val * (viewport[property] / 100);
        return val;
    };
    var onResize = function onResize(event) {
        if (resizing.current) {
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var width = (0, $kMhUd.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $kMhUd.DomHandler).getOuterHeight(dialogRef.current);
            var offset = dialogRef.current.getBoundingClientRect();
            var viewport = (0, $kMhUd.DomHandler).getViewport();
            var hasBeenDragged = !parseInt(dialogRef.current.style.top) || !parseInt(dialogRef.current.style.left);
            var minWidth = convertToPx(dialogRef.current.style.minWidth, 'width', viewport);
            var minHeight = convertToPx(dialogRef.current.style.minHeight, 'height', viewport);
            var newWidth = width + deltaX;
            var newHeight = height + deltaY;
            if (hasBeenDragged) {
                newWidth = newWidth + deltaX;
                newHeight = newHeight + deltaY;
            }
            if ((!minWidth || newWidth > minWidth) && (deltaX < 0 || offset.left + newWidth < viewport.width)) dialogRef.current.style.width = newWidth + 'px';
            if ((!minHeight || newHeight > minHeight) && (deltaY < 0 || offset.top + newHeight < viewport.height)) dialogRef.current.style.height = newHeight + 'px';
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            props.onResize && props.onResize(event);
        }
    };
    var onResizeEnd = function onResizeEnd(event) {
        if (resizing.current) {
            resizing.current = false;
            (0, $kMhUd.DomHandler).removeClass(document.body, 'p-unselectable-text');
            props.onResizeEnd && props.onResizeEnd(event);
        }
    };
    var resetPosition = function resetPosition() {
        dialogRef.current.style.position = '';
        dialogRef.current.style.left = '';
        dialogRef.current.style.top = '';
        dialogRef.current.style.margin = '';
    };
    var onEnter = function onEnter() {
        dialogRef.current.setAttribute(attributeSelector.current, '');
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
        if (props.focusOnShow) focus();
        enableDocumentSettings();
    };
    var onExiting = function onExiting() {
        if (props.modal) !isUnstyled() && (0, $kMhUd.DomHandler).addClass(maskRef.current, 'p-component-overlay-leave');
    };
    var onExited = function onExited() {
        dragging.current = false;
        (0, $kMhUd.ZIndexUtils).clear(maskRef.current);
        setMaskVisibleState(false);
        disableDocumentSettings();
        // return focus to element before dialog was open
        (0, $kMhUd.DomHandler).focus(focusElementOnHide.current);
        focusElementOnHide.current = null;
    };
    var enableDocumentSettings = function enableDocumentSettings() {
        bindGlobalListeners();
    };
    var disableDocumentSettings = function disableDocumentSettings() {
        unbindGlobalListeners();
    };
    var updateScrollBlocker = function updateScrollBlocker() {
        // Scroll should be unblocked if there is at least one dialog that blocks scrolling:
        var isThereAnyDialogThatBlocksScrolling = document.primeDialogParams && document.primeDialogParams.some(function(i) {
            return i.hasBlockScroll;
        });
        if (isThereAnyDialogThatBlocksScrolling) (0, $kMhUd.DomHandler).blockBodyScroll();
        else (0, $kMhUd.DomHandler).unblockBodyScroll();
    };
    var updateGlobalDialogsRegistry = function updateGlobalDialogsRegistry(isMounted) {
        // Update current dialog info in global registry if it is mounted and visible:
        if (isMounted && visibleState) {
            var newParam = {
                id: idState,
                hasBlockScroll: shouldBlockScroll
            };
            // Create registry if not yet created:
            if (!document.primeDialogParams) document.primeDialogParams = [];
            var currentDialogIndexInRegistry = document.primeDialogParams.findIndex(function(dialogInRegistry) {
                return dialogInRegistry.id === idState;
            });
            if (currentDialogIndexInRegistry === -1) document.primeDialogParams = [].concat($e905adff5d5055d5$var$_toConsumableArray(document.primeDialogParams), [
                newParam
            ]);
            else document.primeDialogParams = document.primeDialogParams.toSpliced(currentDialogIndexInRegistry, 1, newParam);
        } else document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(param) {
            return param.id !== idState;
        });
        // Always update scroll blocker after dialog registry - this way we ensure that
        // p-overflow-hidden class is properly added/removed:
        updateScrollBlocker();
    };
    var bindGlobalListeners = function bindGlobalListeners() {
        if (props.draggable) {
            bindDocumentDragListener();
            bindDocumentDragEndListener();
        }
        if (props.resizable) {
            bindDocumentResizeListener();
            bindDocumentResizeEndListener();
        }
    };
    var unbindGlobalListeners = function unbindGlobalListeners() {
        unbindDocumentDragListener();
        unbindDocumentDragEndListener();
        unbindDocumentResizeListener();
        unbindDocumentResizEndListener();
    };
    var createStyle = function createStyle() {
        styleElement.current = (0, $kMhUd.DomHandler).createInlineStyle(context && context.nonce || (0, $eGEKG.default).nonce, context && context.styleContainer);
        var innerHTML = '';
        for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                @media screen and (max-width: ".concat(breakpoint, ") {\n                     [data-pc-name=\"dialog\"][").concat(attributeSelector.current, "] {\n                        width: ").concat(props.breakpoints[breakpoint], " !important;\n                    }\n                }\n            ");
        styleElement.current.innerHTML = innerHTML;
    };
    var destroyStyle = function destroyStyle() {
        styleElement.current = (0, $kMhUd.DomHandler).removeInlineStyle(styleElement.current);
    };
    (0, $kocnD.useMountEffect)(function() {
        updateGlobalDialogsRegistry(true);
        if (props.visible) setMaskVisibleState(true);
    });
    $8NFma.useEffect(function() {
        if (props.breakpoints) createStyle();
        return function() {
            destroyStyle();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.breakpoints
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (props.visible && !maskVisibleState) setMaskVisibleState(true);
        if (props.visible !== visibleState && maskVisibleState) setVisibleState(props.visible);
        if (props.visible) // Remember the focused element before we opened the dialog
        // so we can return focus to it once we close the dialog.
        focusElementOnHide.current = document.activeElement;
    }, [
        props.visible,
        maskVisibleState
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (maskVisibleState) {
            (0, $kMhUd.ZIndexUtils).set('modal', maskRef.current, context && context.autoZIndex || (0, $eGEKG.default).autoZIndex, props.baseZIndex || context && context.zIndex.modal || (0, $eGEKG.default).zIndex.modal);
            setVisibleState(true);
        }
    }, [
        maskVisibleState
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        updateGlobalDialogsRegistry(true);
    }, [
        shouldBlockScroll,
        visibleState
    ]);
    (0, $kocnD.useUnmountEffect)(function() {
        disableDocumentSettings();
        updateGlobalDialogsRegistry(false);
        (0, $kMhUd.DomHandler).removeInlineStyle(styleElement.current);
        (0, $kMhUd.ZIndexUtils).clear(maskRef.current);
    });
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            resetPosition: resetPosition,
            getElement: function getElement() {
                return dialogRef.current;
            },
            getMask: function getMask() {
                return maskRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getHeader: function getHeader() {
                return headerRef.current;
            },
            getFooter: function getFooter() {
                return footerRef.current;
            },
            getCloseButton: function getCloseButton() {
                return closeRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        if (props.closable && props.showCloseIcon) {
            var labelAria = props.ariaCloseIconLabel || (0, $eGEKG.ariaLabel)('close');
            var closeButtonIconProps = mergeProps({
                className: cx('closeButtonIcon'),
                'aria-hidden': true
            }, ptm('closeButtonIcon'));
            var icon = props.closeIcon || /*#__PURE__*/ $8NFma.createElement((0, $gMyz9.TimesIcon), closeButtonIconProps);
            var headerCloseIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $e905adff5d5055d5$var$_objectSpread({}, closeButtonIconProps), {
                props: props
            });
            var closeButtonProps = mergeProps({
                ref: closeRef,
                type: 'button',
                className: cx('closeButton'),
                'aria-label': labelAria,
                onClick: onClose,
                onKeyDown: function onKeyDown(ev) {
                    if (ev.key !== 'Escape') ev.stopPropagation();
                }
            }, ptm('closeButton'));
            return /*#__PURE__*/ $8NFma.createElement("button", closeButtonProps, headerCloseIcon, /*#__PURE__*/ $8NFma.createElement((0, $cLCHn.Ripple), null));
        }
        return null;
    };
    var createMaximizeIcon = function createMaximizeIcon() {
        var icon;
        var maximizableIconProps = mergeProps({
            className: cx('maximizableIcon')
        }, ptm('maximizableIcon'));
        if (!maximized) icon = props.maximizeIcon || /*#__PURE__*/ $8NFma.createElement((0, $4ldcI.WindowMaximizeIcon), maximizableIconProps);
        else icon = props.minimizeIcon || /*#__PURE__*/ $8NFma.createElement((0, $gK2aR.WindowMinimizeIcon), maximizableIconProps);
        var toggleIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, maximizableIconProps, {
            props: props
        });
        if (props.maximizable) {
            var maximizableButtonProps = mergeProps({
                type: 'button',
                className: cx('maximizableButton'),
                onClick: toggleMaximize
            }, ptm('maximizableButton'));
            return /*#__PURE__*/ $8NFma.createElement("button", maximizableButtonProps, toggleIcon, /*#__PURE__*/ $8NFma.createElement((0, $cLCHn.Ripple), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.showHeader) {
            var closeIcon = createCloseIcon();
            var maximizeIcon = createMaximizeIcon();
            var icons = (0, $kMhUd.ObjectUtils).getJSXElement(props.icons, props);
            var header = (0, $kMhUd.ObjectUtils).getJSXElement(props.header, props);
            var headerId = idState + '_header';
            var headerProps = mergeProps({
                ref: headerRef,
                style: props.headerStyle,
                className: cx('header'),
                onMouseDown: onDragStart
            }, ptm('header'));
            var headerTitleProps = mergeProps({
                id: headerId,
                className: cx('headerTitle')
            }, ptm('headerTitle'));
            var headerIconsProps = mergeProps({
                className: cx('headerIcons')
            }, ptm('headerIcons'));
            return /*#__PURE__*/ $8NFma.createElement("div", headerProps, /*#__PURE__*/ $8NFma.createElement("div", headerTitleProps, header), /*#__PURE__*/ $8NFma.createElement("div", headerIconsProps, icons, maximizeIcon, closeIcon));
        }
        return null;
    };
    var createContent = function createContent() {
        var contentId = idState + '_content';
        var contentProps = mergeProps({
            id: contentId,
            ref: contentRef,
            style: props.contentStyle,
            className: cx('content')
        }, ptm('content'));
        return /*#__PURE__*/ $8NFma.createElement("div", contentProps, props.children);
    };
    var createFooter = function createFooter() {
        var footer = (0, $kMhUd.ObjectUtils).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            ref: footerRef,
            className: cx('footer')
        }, ptm('footer'));
        return footer && /*#__PURE__*/ $8NFma.createElement("div", footerProps, footer);
    };
    var createResizer = function createResizer() {
        if (props.resizable) return /*#__PURE__*/ $8NFma.createElement("span", {
            className: "p-resizable-handle",
            style: {
                zIndex: 90
            },
            onMouseDown: onResizeStart
        });
        return null;
    };
    var createTemplateElement = function createTemplateElement() {
        var _props$children;
        var messageProps = {
            header: props.header,
            content: props.message,
            message: props === null || props === void 0 || (_props$children = props.children) === null || _props$children === void 0 || (_props$children = _props$children[1]) === null || _props$children === void 0 || (_props$children = _props$children.props) === null || _props$children === void 0 ? void 0 : _props$children.children
        };
        var templateElementProps = {
            headerRef: headerRef,
            contentRef: contentRef,
            footerRef: footerRef,
            closeRef: closeRef,
            hide: onClose,
            message: messageProps
        };
        return (0, $kMhUd.ObjectUtils).getJSXElement(inProps.content, templateElementProps);
    };
    var createElement = function createElement() {
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var resizer = createResizer();
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, header, content, footer, resizer);
    };
    var createDialog = function createDialog() {
        var headerId = idState + '_header';
        var contentId = idState + '_content';
        var transitionTimeout = {
            enter: props.position === 'center' ? 150 : 300,
            exit: props.position === 'center' ? 150 : 300
        };
        var maskProps = mergeProps({
            ref: maskRef,
            style: sx('mask'),
            className: cx('mask'),
            onPointerUp: onMaskPointerUp
        }, ptm('mask'));
        var rootProps = mergeProps({
            ref: dialogRef,
            id: idState,
            className: (0, $kMhUd.classNames)(props.className, cx('root', {
                props: props,
                maximized: maximized,
                context: context
            })),
            style: props.style,
            onClick: props.onClick,
            role: 'dialog',
            'aria-labelledby': headerId,
            'aria-describedby': contentId,
            'aria-modal': props.modal,
            onPointerDown: onDialogPointerDown
        }, $e905adff5d5055d5$var$DialogBase.getOtherProps(props), ptm('root'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            timeout: transitionTimeout,
            "in": visibleState,
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExiting: onExiting,
            onExited: onExited
        }, ptm('transition'));
        var contentElement = null;
        if (inProps !== null && inProps !== void 0 && inProps.content) contentElement = createTemplateElement();
        else contentElement = createElement();
        var rootElement = /*#__PURE__*/ $8NFma.createElement("div", maskProps, /*#__PURE__*/ $8NFma.createElement((0, $cknS9.CSSTransition), $e905adff5d5055d5$var$_extends({
            nodeRef: dialogRef
        }, transitionProps), /*#__PURE__*/ $8NFma.createElement("div", rootProps, /*#__PURE__*/ $8NFma.createElement($e905adff5d5055d5$var$FocusTrap$1, {
            autoFocus: props.focusOnShow
        }, contentElement))));
        return /*#__PURE__*/ $8NFma.createElement((0, $bKF0T.Portal), {
            element: rootElement,
            appendTo: props.appendTo,
            visible: true
        });
    };
    return maskVisibleState && createDialog();
});
$e905adff5d5055d5$export$3ddf2d174ce01153.displayName = 'Dialog';

});
parcelRegister("eGEKG", function(module, exports) {

$parcel$export(module.exports, "FilterService", () => $ab14996a8e5844c3$export$f4fb036b8adcc8c8);
$parcel$export(module.exports, "localeOption", () => $ab14996a8e5844c3$export$aa1e8754cc4d1e7a);
$parcel$export(module.exports, "ariaLabel", () => $ab14996a8e5844c3$export$eb839c9fd3d638b9);
$parcel$export(module.exports, "PrimeReactContext", () => $ab14996a8e5844c3$export$43502877ff87a530);
$parcel$export(module.exports, "default", () => $ab14996a8e5844c3$export$2e2bcd8739ae039);

var $kMhUd = parcelRequire("kMhUd");

var $8NFma = parcelRequire("8NFma");
'use client';
var $ab14996a8e5844c3$export$b9fbdf9129f67822 = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    NOT_IN: 'notIn',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
var $ab14996a8e5844c3$export$9cc7a9d8d8c733ca = Object.freeze({
    AND: 'and',
    OR: 'or'
});
function $ab14996a8e5844c3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ab14996a8e5844c3$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ab14996a8e5844c3$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $ab14996a8e5844c3$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ab14996a8e5844c3$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $ab14996a8e5844c3$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $ab14996a8e5844c3$export$f4fb036b8adcc8c8 = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = $ab14996a8e5844c3$var$_createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === 'string') {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = $ab14996a8e5844c3$var$_createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, $kMhUd.ObjectUtils).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            return (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            return (0, $kMhUd.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, $kMhUd.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $kMhUd.ObjectUtils).equals(value, filter[i])) return true;
            }
            return false;
        },
        notIn: function notIn(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $kMhUd.ObjectUtils).equals(value, filter[i])) return false;
            }
            return true;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function $ab14996a8e5844c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab14996a8e5844c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab14996a8e5844c3$var$_typeof(o);
}
function $ab14996a8e5844c3$var$toPrimitive(t, r) {
    if ("object" != $ab14996a8e5844c3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab14996a8e5844c3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab14996a8e5844c3$var$toPropertyKey(t) {
    var i = $ab14996a8e5844c3$var$toPrimitive(t, "string");
    return "symbol" == $ab14996a8e5844c3$var$_typeof(i) ? i : i + "";
}
function $ab14996a8e5844c3$var$_defineProperty(e, r, t) {
    return (r = $ab14996a8e5844c3$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab14996a8e5844c3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ab14996a8e5844c3$var$toPropertyKey(o.key), o);
    }
}
function $ab14996a8e5844c3$var$_createClass(e, r, t) {
    return r && $ab14996a8e5844c3$var$_defineProperties(e.prototype, r), t && $ab14996a8e5844c3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $ab14996a8e5844c3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @deprecated please use PrimeReactContext
 */ var $ab14996a8e5844c3$var$PrimeReact$1 = /*#__PURE__*/ $ab14996a8e5844c3$var$_createClass(function PrimeReact() {
    $ab14996a8e5844c3$var$_classCallCheck(this, PrimeReact);
});
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "ripple", false);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "inputStyle", 'outlined');
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "locale", 'en');
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "appendTo", null);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "cssTransition", true);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "autoZIndex", true);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "hideOverlaysOnDocumentScrolling", false);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "nonce", null);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "nullSortOrder", 1);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "pt", undefined);
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "filterMatchModeOptions", {
    text: [
        $ab14996a8e5844c3$export$b9fbdf9129f67822.STARTS_WITH,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.CONTAINS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_CONTAINS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.ENDS_WITH,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.EQUALS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_EQUALS
    ],
    numeric: [
        $ab14996a8e5844c3$export$b9fbdf9129f67822.EQUALS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_EQUALS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.LESS_THAN,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.GREATER_THAN,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_IS,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_IS_NOT,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_BEFORE,
        $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_AFTER
    ]
});
$ab14996a8e5844c3$var$_defineProperty($ab14996a8e5844c3$var$PrimeReact$1, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
function $ab14996a8e5844c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab14996a8e5844c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab14996a8e5844c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab14996a8e5844c3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab14996a8e5844c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab14996a8e5844c3$var$locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileChosenMessage: '{0} files',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFileChosenMessage: 'No file chosen',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseLabel: 'Collapse',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandLabel: 'Expand',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listLabel: 'Option List',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            otpLabel: 'Please enter one time password character {0}',
            pageLabel: 'Page {page}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            prevPageLabel: 'Previous Page',
            removeLabel: 'Remove',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectLabel: 'Select',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectLabel: 'Unselect',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
function $ab14996a8e5844c3$export$162ce11d62a1ca51(locale) {
    locale && ($ab14996a8e5844c3$var$PrimeReact$1.locale = locale);
    return {
        locale: $ab14996a8e5844c3$var$PrimeReact$1.locale,
        options: $ab14996a8e5844c3$var$locales[$ab14996a8e5844c3$var$PrimeReact$1.locale]
    };
}
function $ab14996a8e5844c3$export$3ab428da39598a54(locale, options) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    $ab14996a8e5844c3$var$locales[locale] = $ab14996a8e5844c3$var$_objectSpread($ab14996a8e5844c3$var$_objectSpread({}, $ab14996a8e5844c3$var$locales.en), options);
}
function $ab14996a8e5844c3$export$7cd3e26e5d06a8a9(key, value, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    $ab14996a8e5844c3$export$ef9c48731c26e22d(locale)[key] = value;
}
function $ab14996a8e5844c3$export$8024ed7ed764e4fc(options, locale) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    var _locale = locale || $ab14996a8e5844c3$var$PrimeReact$1.locale;
    $ab14996a8e5844c3$var$locales[_locale] = $ab14996a8e5844c3$var$_objectSpread($ab14996a8e5844c3$var$_objectSpread({}, $ab14996a8e5844c3$var$locales[_locale]), options);
}
function $ab14996a8e5844c3$export$aa1e8754cc4d1e7a(key, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    var _locale = locale || $ab14996a8e5844c3$var$PrimeReact$1.locale;
    try {
        return $ab14996a8e5844c3$export$ef9c48731c26e22d(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $ab14996a8e5844c3$export$eb839c9fd3d638b9(ariaKey, options) {
    if (ariaKey.includes('__proto__') || ariaKey.includes('prototype')) throw new Error('Unsafe ariaKey detected');
    var _locale = $ab14996a8e5844c3$var$PrimeReact$1.locale;
    try {
        var _ariaLabel = $ab14996a8e5844c3$export$ef9c48731c26e22d(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $ab14996a8e5844c3$export$ef9c48731c26e22d(locale) {
    var _locale = locale || $ab14996a8e5844c3$var$PrimeReact$1.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return $ab14996a8e5844c3$var$locales[_locale];
}
var $ab14996a8e5844c3$export$bb45678bd9ad9127 = Object.freeze({
    SUCCESS: 'success',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    SECONDARY: 'secondary',
    CONTRAST: 'contrast'
});
var $ab14996a8e5844c3$export$9daa7f1467519fd8 = Object.freeze({
    ADDRESS_BOOK: 'pi pi-address-book',
    ALIGN_CENTER: 'pi pi-align-center',
    ALIGN_JUSTIFY: 'pi pi-align-justify',
    ALIGN_LEFT: 'pi pi-align-left',
    ALIGN_RIGHT: 'pi pi-align-right',
    AMAZON: 'pi pi-amazon',
    ANDROID: 'pi pi-android',
    ANGLE_DOUBLE_DOWN: 'pi pi-angle-double-down',
    ANGLE_DOUBLE_LEFT: 'pi pi-angle-double-left',
    ANGLE_DOUBLE_RIGHT: 'pi pi-angle-double-right',
    ANGLE_DOUBLE_UP: 'pi pi-angle-double-up',
    ANGLE_DOWN: 'pi pi-angle-down',
    ANGLE_LEFT: 'pi pi-angle-left',
    ANGLE_RIGHT: 'pi pi-angle-right',
    ANGLE_UP: 'pi pi-angle-up',
    APPLE: 'pi pi-apple',
    ARROW_CIRCLE_DOWN: 'pi pi-arrow-circle-down',
    ARROW_CIRCLE_LEFT: 'pi pi-arrow-circle-left',
    ARROW_CIRCLE_RIGHT: 'pi pi-arrow-circle-right',
    ARROW_CIRCLE_UP: 'pi pi-arrow-circle-up',
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: 'pi pi-arrow-down-left-and-arrow-up-right-to-center',
    ARROW_DOWN_LEFT: 'pi pi-arrow-down-left',
    ARROW_DOWN_RIGHT: 'pi pi-arrow-down-right',
    ARROW_DOWN: 'pi pi-arrow-down',
    ARROW_LEFT: 'pi pi-arrow-left',
    ARROW_RIGHT_ARROW_LEFT: 'pi pi-arrow-right-arrow-left',
    ARROW_RIGHT: 'pi pi-arrow-right',
    ARROW_UP_LEFT: 'pi pi-arrow-up-left',
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: 'pi pi-arrow-up-right-and-arrow-down-left-from-center',
    ARROW_UP_RIGHT: 'pi pi-arrow-up-right',
    ARROW_UP: 'pi pi-arrow-up',
    ARROWS_ALT: 'pi pi-arrows-alt',
    ARROWS_H: 'pi pi-arrows-h',
    ARROWS_V: 'pi pi-arrows-v',
    ASTERISK: 'pi pi-asterisk',
    AT: 'pi pi-at',
    BACKWARD: 'pi pi-backward',
    BAN: 'pi pi-ban',
    BARCODE: 'pi pi-barcode',
    BARS: 'pi pi-bars',
    BELL_SLASH: 'pi pi-bell-slash',
    BELL: 'pi pi-bell',
    BITCOIN: 'pi pi-bitcoin',
    BOLT: 'pi pi-bolt',
    BOOK: 'pi pi-book',
    BOOKMARK_FILL: 'pi pi-bookmark-fill',
    BOOKMARK: 'pi pi-bookmark',
    BOX: 'pi pi-box',
    BRIEFCASE: 'pi pi-briefcase',
    BUILDING_COLUMNS: 'pi pi-building-columns',
    BUILDING: 'pi pi-building',
    BULLSEYE: 'pi pi-bullseye',
    CALCULATOR: 'pi pi-calculator',
    CALENDAR_CLOCK: 'pi pi-calendar-clock',
    CALENDAR_MINUS: 'pi pi-calendar-minus',
    CALENDAR_PLUS: 'pi pi-calendar-plus',
    CALENDAR_TIMES: 'pi pi-calendar-times',
    CALENDAR: 'pi pi-calendar',
    CAMERA: 'pi pi-camera',
    CAR: 'pi pi-car',
    CARET_DOWN: 'pi pi-caret-down',
    CARET_LEFT: 'pi pi-caret-left',
    CARET_RIGHT: 'pi pi-caret-right',
    CARET_UP: 'pi pi-caret-up',
    CART_ARROW_DOWN: 'pi pi-cart-arrow-down',
    CART_MINUS: 'pi pi-cart-minus',
    CART_PLUS: 'pi pi-cart-plus',
    CHART_BAR: 'pi pi-chart-bar',
    CHART_LINE: 'pi pi-chart-line',
    CHART_PIE: 'pi pi-chart-pie',
    CHART_SCATTER: 'pi pi-chart-scatter',
    CHECK_CIRCLE: 'pi pi-check-circle',
    CHECK_SQUARE: 'pi pi-check-square',
    CHECK: 'pi pi-check',
    CHEVRON_CIRCLE_DOWN: 'pi pi-chevron-circle-down',
    CHEVRON_CIRCLE_LEFT: 'pi pi-chevron-circle-left',
    CHEVRON_CIRCLE_RIGHT: 'pi pi-chevron-circle-right',
    CHEVRON_CIRCLE_UP: 'pi pi-chevron-circle-up',
    CHEVRON_DOWN: 'pi pi-chevron-down',
    CHEVRON_LEFT: 'pi pi-chevron-left',
    CHEVRON_RIGHT: 'pi pi-chevron-right',
    CHEVRON_UP: 'pi pi-chevron-up',
    CIRCLE_FILL: 'pi pi-circle-fill',
    CIRCLE_OFF: 'pi pi-circle-off',
    CIRCLE_ON: 'pi pi-circle-on',
    CIRCLE: 'pi pi-circle',
    CLIPBOARD: 'pi pi-clipboard',
    CLOCK: 'pi pi-clock',
    CLONE: 'pi pi-clone',
    CLOUD_DOWNLOAD: 'pi pi-cloud-download',
    CLOUD_UPLOAD: 'pi pi-cloud-upload',
    CLOUD: 'pi pi-cloud',
    CODE: 'pi pi-code',
    COG: 'pi pi-cog',
    COMMENT: 'pi pi-comment',
    COMMENTS: 'pi pi-comments',
    COMPASS: 'pi pi-compass',
    COPY: 'pi pi-copy',
    CREDIT_CARD: 'pi pi-credit-card',
    CROWN: 'pi pi-crown',
    DATABASE: 'pi pi-database',
    DELETE_LEFT: 'pi pi-delete-left',
    DESKTOP: 'pi pi-desktop',
    DIRECTIONS_ALT: 'pi pi-directions-alt',
    DIRECTIONS: 'pi pi-directions',
    DISCORD: 'pi pi-discord',
    DOLLAR: 'pi pi-dollar',
    DOWNLOAD: 'pi pi-download',
    EJECT: 'pi pi-eject',
    ELLIPSIS_H: 'pi pi-ellipsis-h',
    ELLIPSIS_V: 'pi pi-ellipsis-v',
    ENVELOPE: 'pi pi-envelope',
    EQUALS: 'pi pi-equals',
    ERASER: 'pi pi-eraser',
    ETHEREUM: 'pi pi-ethereum',
    EURO: 'pi pi-euro',
    EXCLAMATION_CIRCLE: 'pi pi-exclamation-circle',
    EXCLAMATION_TRIANGLE: 'pi pi-exclamation-triangle',
    EXPAND: 'pi pi-expand',
    EXTERNAL_LINK: 'pi pi-external-link',
    EYE_SLASH: 'pi pi-eye-slash',
    EYE: 'pi pi-eye',
    FACE_SMILE: 'pi pi-face-smile',
    FACEBOOK: 'pi pi-facebook',
    FAST_BACKWARD: 'pi pi-fast-backward',
    FAST_FORWARD: 'pi pi-fast-forward',
    FILE_ARROW_UP: 'pi pi-file-arrow-up',
    FILE_CHECK: 'pi pi-file-check',
    FILE_EDIT: 'pi pi-file-edit',
    FILE_EXCEL: 'pi pi-file-excel',
    FILE_EXPORT: 'pi pi-file-export',
    FILE_IMPORT: 'pi pi-file-import',
    FILE_O: 'pi pi-file-o',
    FILE_PDF: 'pi pi-file-pdf',
    FILE_PLUS: 'pi pi-file-plus',
    FILE_WORD: 'pi pi-file-word',
    FILE: 'pi pi-file',
    FILTER_FILL: 'pi pi-filter-fill',
    FILTER_SLASH: 'pi pi-filter-slash',
    FILTER: 'pi pi-filter',
    FLAG_FILL: 'pi pi-flag-fill',
    FLAG: 'pi pi-flag',
    FOLDER_OPEN: 'pi pi-folder-open',
    FOLDER_PLUS: 'pi pi-folder-plus',
    FOLDER: 'pi pi-folder',
    FORWARD: 'pi pi-forward',
    GAUGE: 'pi pi-gauge',
    GIFT: 'pi pi-gift',
    GITHUB: 'pi pi-github',
    GLOBE: 'pi pi-globe',
    GOOGLE: 'pi pi-google',
    GRADUATION_CAP: 'pi pi-graduation-cap',
    HAMMER: 'pi pi-hammer',
    HASHTAG: 'pi pi-hashtag',
    HEADPHONES: 'pi pi-headphones',
    HEART_FILL: 'pi pi-heart-fill',
    HEART: 'pi pi-heart',
    HISTORY: 'pi pi-history',
    HOME: 'pi pi-home',
    HOURGLASS: 'pi pi-hourglass',
    ID_CARD: 'pi pi-id-card',
    IMAGE: 'pi pi-image',
    IMAGES: 'pi pi-images',
    INBOX: 'pi pi-inbox',
    INDIAN_RUPEE: 'pi pi-indian-rupee',
    INFO_CIRCLE: 'pi pi-info-circle',
    INFO: 'pi pi-info',
    INSTAGRAM: 'pi pi-instagram',
    KEY: 'pi pi-key',
    LANGUAGE: 'pi pi-language',
    LIGHTBULB: 'pi pi-lightbulb',
    LINK: 'pi pi-link',
    LINKEDIN: 'pi pi-linkedin',
    LIST_CHECK: 'pi pi-list-check',
    LIST: 'pi pi-list',
    LOCK_OPEN: 'pi pi-lock-open',
    LOCK: 'pi pi-lock',
    MAP_MARKER: 'pi pi-map-marker',
    MAP: 'pi pi-map',
    MARS: 'pi pi-mars',
    MEGAPHONE: 'pi pi-megaphone',
    MICROCHIP_AI: 'pi pi-microchip-ai',
    MICROCHIP: 'pi pi-microchip',
    MICROPHONE: 'pi pi-microphone',
    MICROSOFT: 'pi pi-microsoft',
    MINUS_CIRCLE: 'pi pi-minus-circle',
    MINUS: 'pi pi-minus',
    MOBILE: 'pi pi-mobile',
    MONEY_BILL: 'pi pi-money-bill',
    MOON: 'pi pi-moon',
    OBJECTS_COLUMN: 'pi pi-objects-column',
    PALETTE: 'pi pi-palette',
    PAPERCLIP: 'pi pi-paperclip',
    PAUSE_CIRCLE: 'pi pi-pause-circle',
    PAUSE: 'pi pi-pause',
    PAYPAL: 'pi pi-paypal',
    PEN_TO_SQUARE: 'pi pi-pen-to-square',
    PENCIL: 'pi pi-pencil',
    PERCENTAGE: 'pi pi-percentage',
    PHONE: 'pi pi-phone',
    PINTEREST: 'pi pi-pinterest',
    PLAY_CIRCLE: 'pi pi-play-circle',
    PLAY: 'pi pi-play',
    PLUS_CIRCLE: 'pi pi-plus-circle',
    PLUS: 'pi pi-plus',
    POUND: 'pi pi-pound',
    POWER_OFF: 'pi pi-power-off',
    PRIME: 'pi pi-prime',
    PRINT: 'pi pi-print',
    QRCODE: 'pi pi-qrcode',
    QUESTION_CIRCLE: 'pi pi-question-circle',
    QUESTION: 'pi pi-question',
    RECEIPT: 'pi pi-receipt',
    REDDIT: 'pi pi-reddit',
    REFRESH: 'pi pi-refresh',
    REPLAY: 'pi pi-replay',
    REPLY: 'pi pi-reply',
    SAVE: 'pi pi-save',
    SEARCH_MINUS: 'pi pi-search-minus',
    SEARCH_PLUS: 'pi pi-search-plus',
    SEARCH: 'pi pi-search',
    SEND: 'pi pi-send',
    SERVER: 'pi pi-server',
    SHARE_ALT: 'pi pi-share-alt',
    SHIELD: 'pi pi-shield',
    SHOP: 'pi pi-shop',
    SHOPPING_BAG: 'pi pi-shopping-bag',
    SHOPPING_CART: 'pi pi-shopping-cart',
    SIGN_IN: 'pi pi-sign-in',
    SIGN_OUT: 'pi pi-sign-out',
    SITEMAP: 'pi pi-sitemap',
    SLACK: 'pi pi-slack',
    SLIDERS_H: 'pi pi-sliders-h',
    SLIDERS_V: 'pi pi-sliders-v',
    SORT_ALPHA_DOWN_ALT: 'pi pi-sort-alpha-down-alt',
    SORT_ALPHA_DOWN: 'pi pi-sort-alpha-down',
    SORT_ALPHA_UP_ALT: 'pi pi-sort-alpha-up-alt',
    SORT_ALPHA_UP: 'pi pi-sort-alpha-up',
    SORT_ALT_SLASH: 'pi pi-sort-alt-slash',
    SORT_ALT: 'pi pi-sort-alt',
    SORT_AMOUNT_DOWN_ALT: 'pi pi-sort-amount-down-alt',
    SORT_AMOUNT_DOWN: 'pi pi-sort-amount-down',
    SORT_AMOUNT_UP_ALT: 'pi pi-sort-amount-up-alt',
    SORT_AMOUNT_UP: 'pi pi-sort-amount-up',
    SORT_DOWN_FILL: 'pi pi-sort-down-fill',
    SORT_DOWN: 'pi pi-sort-down',
    SORT_NUMERIC_DOWN_ALT: 'pi pi-sort-numeric-down-alt',
    SORT_NUMERIC_DOWN: 'pi pi-sort-numeric-down',
    SORT_NUMERIC_UP_ALT: 'pi pi-sort-numeric-up-alt',
    SORT_NUMERIC_UP: 'pi pi-sort-numeric-up',
    SORT_UP_FILL: 'pi pi-sort-up-fill',
    SORT_UP: 'pi pi-sort-up',
    SORT: 'pi pi-sort',
    SPARKLES: 'pi pi-sparkles',
    SPINNER_DOTTED: 'pi pi-spinner-dotted',
    SPINNER: 'pi pi-spinner',
    STAR_FILL: 'pi pi-star-fill',
    STAR_HALF_FILL: 'pi pi-star-half-fill',
    STAR_HALF: 'pi pi-star-half',
    STAR: 'pi pi-star',
    STEP_BACKWARD_ALT: 'pi pi-step-backward-alt',
    STEP_BACKWARD: 'pi pi-step-backward',
    STEP_FORWARD_ALT: 'pi pi-step-forward-alt',
    STEP_FORWARD: 'pi pi-step-forward',
    STOP_CIRCLE: 'pi pi-stop-circle',
    STOP: 'pi pi-stop',
    STOPWATCH: 'pi pi-stopwatch',
    SUN: 'pi pi-sun',
    SYNC: 'pi pi-sync',
    TABLE: 'pi pi-table',
    TABLET: 'pi pi-tablet',
    TAG: 'pi pi-tag',
    TAGS: 'pi pi-tags',
    TELEGRAM: 'pi pi-telegram',
    TH_LARGE: 'pi pi-th-large',
    THUMBS_DOWN_FILL: 'pi pi-thumbs-down-fill',
    THUMBS_DOWN: 'pi pi-thumbs-down',
    THUMBS_UP_FILL: 'pi pi-thumbs-up-fill',
    THUMBS_UP: 'pi pi-thumbs-up',
    THUMBTACK: 'pi pi-thumbtack',
    TICKET: 'pi pi-ticket',
    TIKTOK: 'pi pi-tiktok',
    TIMES_CIRCLE: 'pi pi-times-circle',
    TIMES: 'pi pi-times',
    TRASH: 'pi pi-trash',
    TROPHY: 'pi pi-trophy',
    TRUCK: 'pi pi-truck',
    TURKISH_LIRA: 'pi pi-turkish-lira',
    TWITCH: 'pi pi-twitch',
    TWITTER: 'pi pi-twitter',
    UNDO: 'pi pi-undo',
    UNLOCK: 'pi pi-unlock',
    UPLOAD: 'pi pi-upload',
    USER_EDIT: 'pi pi-user-edit',
    USER_MINUS: 'pi pi-user-minus',
    USER_PLUS: 'pi pi-user-plus',
    USER: 'pi pi-user',
    USERS: 'pi pi-users',
    VENUS: 'pi pi-venus',
    VERIFIED: 'pi pi-verified',
    VIDEO: 'pi pi-video',
    VIMEO: 'pi pi-vimeo',
    VOLUME_DOWN: 'pi pi-volume-down',
    VOLUME_OFF: 'pi pi-volume-off',
    VOLUME_UP: 'pi pi-volume-up',
    WALLET: 'pi pi-wallet',
    WAREHOUSE: 'pi pi-warehouse',
    WAVE_PULSE: 'pi pi-wave-pulse',
    WHATSAPP: 'pi pi-whatsapp',
    WIFI: 'pi pi-wifi',
    WINDOW_MAXIMIZE: 'pi pi-window-maximize',
    WINDOW_MINIMIZE: 'pi pi-window-minimize',
    WRENCH: 'pi pi-wrench',
    YOUTUBE: 'pi pi-youtube'
});
var $ab14996a8e5844c3$export$7ae723045d45777a = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});
function $ab14996a8e5844c3$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ab14996a8e5844c3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ab14996a8e5844c3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ab14996a8e5844c3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ab14996a8e5844c3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ab14996a8e5844c3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ab14996a8e5844c3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab14996a8e5844c3$var$_slicedToArray(r, e) {
    return $ab14996a8e5844c3$var$_arrayWithHoles(r) || $ab14996a8e5844c3$var$_iterableToArrayLimit(r, e) || $ab14996a8e5844c3$var$_unsupportedIterableToArray(r, e) || $ab14996a8e5844c3$var$_nonIterableRest();
}
var $ab14996a8e5844c3$export$43502877ff87a530 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext();
var $ab14996a8e5844c3$export$6a5b5c2279ff1e8d = function PrimeReactProvider(props) {
    var _props$value, _propsValue$ripple, _propsValue$inputStyl, _propsValue$locale, _propsValue$appendTo, _propsValue$styleCont, _propsValue$cssTransi, _propsValue$autoZInde, _propsValue$hideOverl, _propsValue$nonce, _propsValue$nullSortO, _propsValue$zIndex, _propsValue$ptOptions, _propsValue$pt, _propsValue$unstyled, _propsValue$filterMat;
    var propsValue = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : {};
    var _useState = (0, $8NFma.useState)((_propsValue$ripple = propsValue.ripple) !== null && _propsValue$ripple !== void 0 ? _propsValue$ripple : false), _useState2 = $ab14996a8e5844c3$var$_slicedToArray(_useState, 2), ripple = _useState2[0], setRipple = _useState2[1];
    var _useState3 = (0, $8NFma.useState)((_propsValue$inputStyl = propsValue.inputStyle) !== null && _propsValue$inputStyl !== void 0 ? _propsValue$inputStyl : 'outlined'), _useState4 = $ab14996a8e5844c3$var$_slicedToArray(_useState3, 2), inputStyle = _useState4[0], setInputStyle = _useState4[1];
    var _useState5 = (0, $8NFma.useState)((_propsValue$locale = propsValue.locale) !== null && _propsValue$locale !== void 0 ? _propsValue$locale : 'en'), _useState6 = $ab14996a8e5844c3$var$_slicedToArray(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, $8NFma.useState)((_propsValue$appendTo = propsValue.appendTo) !== null && _propsValue$appendTo !== void 0 ? _propsValue$appendTo : null), _useState8 = $ab14996a8e5844c3$var$_slicedToArray(_useState7, 2), appendTo = _useState8[0], setAppendTo = _useState8[1];
    var _useState9 = (0, $8NFma.useState)((_propsValue$styleCont = propsValue.styleContainer) !== null && _propsValue$styleCont !== void 0 ? _propsValue$styleCont : null), _useState10 = $ab14996a8e5844c3$var$_slicedToArray(_useState9, 2), styleContainer = _useState10[0], setStyleContainer = _useState10[1];
    var _useState11 = (0, $8NFma.useState)((_propsValue$cssTransi = propsValue.cssTransition) !== null && _propsValue$cssTransi !== void 0 ? _propsValue$cssTransi : true), _useState12 = $ab14996a8e5844c3$var$_slicedToArray(_useState11, 2), cssTransition = _useState12[0], setCssTransition = _useState12[1];
    var _useState13 = (0, $8NFma.useState)((_propsValue$autoZInde = propsValue.autoZIndex) !== null && _propsValue$autoZInde !== void 0 ? _propsValue$autoZInde : true), _useState14 = $ab14996a8e5844c3$var$_slicedToArray(_useState13, 2), autoZIndex = _useState14[0], setAutoZIndex = _useState14[1];
    var _useState15 = (0, $8NFma.useState)((_propsValue$hideOverl = propsValue.hideOverlaysOnDocumentScrolling) !== null && _propsValue$hideOverl !== void 0 ? _propsValue$hideOverl : false), _useState16 = $ab14996a8e5844c3$var$_slicedToArray(_useState15, 2), hideOverlaysOnDocumentScrolling = _useState16[0], setHideOverlaysOnDocumentScrolling = _useState16[1];
    var _useState17 = (0, $8NFma.useState)((_propsValue$nonce = propsValue.nonce) !== null && _propsValue$nonce !== void 0 ? _propsValue$nonce : null), _useState18 = $ab14996a8e5844c3$var$_slicedToArray(_useState17, 2), nonce = _useState18[0], setNonce = _useState18[1];
    var _useState19 = (0, $8NFma.useState)((_propsValue$nullSortO = propsValue.nullSortOrder) !== null && _propsValue$nullSortO !== void 0 ? _propsValue$nullSortO : 1), _useState20 = $ab14996a8e5844c3$var$_slicedToArray(_useState19, 2), nullSortOrder = _useState20[0], setNullSortOrder = _useState20[1];
    var _useState21 = (0, $8NFma.useState)((_propsValue$zIndex = propsValue.zIndex) !== null && _propsValue$zIndex !== void 0 ? _propsValue$zIndex : {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100,
        toast: 1200
    }), _useState22 = $ab14996a8e5844c3$var$_slicedToArray(_useState21, 2), zIndex = _useState22[0], setZIndex = _useState22[1];
    var _useState23 = (0, $8NFma.useState)((_propsValue$ptOptions = propsValue.ptOptions) !== null && _propsValue$ptOptions !== void 0 ? _propsValue$ptOptions : {
        mergeSections: true,
        mergeProps: true
    }), _useState24 = $ab14996a8e5844c3$var$_slicedToArray(_useState23, 2), ptOptions = _useState24[0], setPtOptions = _useState24[1];
    var _useState25 = (0, $8NFma.useState)((_propsValue$pt = propsValue.pt) !== null && _propsValue$pt !== void 0 ? _propsValue$pt : undefined), _useState26 = $ab14996a8e5844c3$var$_slicedToArray(_useState25, 2), pt = _useState26[0], setPt = _useState26[1];
    var _useState27 = (0, $8NFma.useState)((_propsValue$unstyled = propsValue.unstyled) !== null && _propsValue$unstyled !== void 0 ? _propsValue$unstyled : false), _useState28 = $ab14996a8e5844c3$var$_slicedToArray(_useState27, 2), unstyled = _useState28[0], setUnstyled = _useState28[1];
    var _useState29 = (0, $8NFma.useState)((_propsValue$filterMat = propsValue.filterMatchModeOptions) !== null && _propsValue$filterMat !== void 0 ? _propsValue$filterMat : {
        text: [
            $ab14996a8e5844c3$export$b9fbdf9129f67822.STARTS_WITH,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.CONTAINS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_CONTAINS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.ENDS_WITH,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.EQUALS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_EQUALS
        ],
        numeric: [
            $ab14996a8e5844c3$export$b9fbdf9129f67822.EQUALS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.NOT_EQUALS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.LESS_THAN,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.GREATER_THAN,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_IS,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_IS_NOT,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_BEFORE,
            $ab14996a8e5844c3$export$b9fbdf9129f67822.DATE_AFTER
        ]
    }), _useState30 = $ab14996a8e5844c3$var$_slicedToArray(_useState29, 2), filterMatchModeOptions = _useState30[0], setFilterMatchModeOptions = _useState30[1];
    var changeTheme = function changeTheme(currentTheme, newTheme, linkElementId, callback) {
        var _linkElement$parentNo;
        var linkElement = document.getElementById(linkElementId);
        if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
        var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
        var newLinkElement = document.createElement('link');
        newLinkElement.setAttribute('rel', 'stylesheet');
        newLinkElement.setAttribute('id', linkElementId);
        newLinkElement.setAttribute('href', newThemeUrl);
        newLinkElement.addEventListener('load', function() {
            if (callback) callback();
        });
        (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
    };
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        $ab14996a8e5844c3$var$PrimeReact$1.ripple = ripple;
    }, [
        ripple
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        $ab14996a8e5844c3$var$PrimeReact$1.inputStyle = inputStyle;
    }, [
        inputStyle
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        $ab14996a8e5844c3$var$PrimeReact$1.locale = locale;
    }, [
        locale
    ]);
    var value = {
        changeTheme: changeTheme,
        ripple: ripple,
        setRipple: setRipple,
        inputStyle: inputStyle,
        setInputStyle: setInputStyle,
        locale: locale,
        setLocale: setLocale,
        appendTo: appendTo,
        setAppendTo: setAppendTo,
        styleContainer: styleContainer,
        setStyleContainer: setStyleContainer,
        cssTransition: cssTransition,
        setCssTransition: setCssTransition,
        autoZIndex: autoZIndex,
        setAutoZIndex: setAutoZIndex,
        hideOverlaysOnDocumentScrolling: hideOverlaysOnDocumentScrolling,
        setHideOverlaysOnDocumentScrolling: setHideOverlaysOnDocumentScrolling,
        nonce: nonce,
        setNonce: setNonce,
        nullSortOrder: nullSortOrder,
        setNullSortOrder: setNullSortOrder,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ptOptions: ptOptions,
        setPtOptions: setPtOptions,
        pt: pt,
        setPt: setPt,
        filterMatchModeOptions: filterMatchModeOptions,
        setFilterMatchModeOptions: setFilterMatchModeOptions,
        unstyled: unstyled,
        setUnstyled: setUnstyled
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($ab14996a8e5844c3$export$43502877ff87a530.Provider, {
        value: value
    }, props.children);
};
var $ab14996a8e5844c3$export$2e2bcd8739ae039 = $ab14996a8e5844c3$var$PrimeReact$1;

});
parcelRegister("kMhUd", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $f2062e055e39f5bd$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "DomHandler", () => $f2062e055e39f5bd$export$ff8ccbac9225de62);
$parcel$export(module.exports, "EventBus", () => $f2062e055e39f5bd$export$5087227eb54526);
$parcel$export(module.exports, "ObjectUtils", () => $f2062e055e39f5bd$export$4855211e6b8ad895);
$parcel$export(module.exports, "UniqueComponentId", () => $f2062e055e39f5bd$export$d5d9b89141473caf);
$parcel$export(module.exports, "IconUtils", () => $f2062e055e39f5bd$export$7114f767f3d3c711);
$parcel$export(module.exports, "mergeProps", () => $f2062e055e39f5bd$export$9d1611c77c2fe928);
$parcel$export(module.exports, "ZIndexUtils", () => $f2062e055e39f5bd$export$832931caede8e4b9);

var $8NFma = parcelRequire("8NFma");
'use client';
function $f2062e055e39f5bd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $f2062e055e39f5bd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f2062e055e39f5bd$var$_arrayLikeToArray$2(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f2062e055e39f5bd$var$_unsupportedIterableToArray$2(r, a) {
    if (r) {
        if ("string" == typeof r) return $f2062e055e39f5bd$var$_arrayLikeToArray$2(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f2062e055e39f5bd$var$_arrayLikeToArray$2(r, a) : void 0;
    }
}
function $f2062e055e39f5bd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2062e055e39f5bd$var$_slicedToArray(r, e) {
    return $f2062e055e39f5bd$var$_arrayWithHoles(r) || $f2062e055e39f5bd$var$_iterableToArrayLimit(r, e) || $f2062e055e39f5bd$var$_unsupportedIterableToArray$2(r, e) || $f2062e055e39f5bd$var$_nonIterableRest();
}
function $f2062e055e39f5bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f2062e055e39f5bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f2062e055e39f5bd$var$_typeof(o);
}
function $f2062e055e39f5bd$export$ce4ab0c55987d1ff() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = $f2062e055e39f5bd$var$_typeof(className);
            if (type === 'string' || type === 'number') classes.push(className);
            else if (type === 'object') {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = $f2062e055e39f5bd$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(' ').trim();
    }
    return undefined;
}
function $f2062e055e39f5bd$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $f2062e055e39f5bd$var$_arrayLikeToArray$2(r);
}
function $f2062e055e39f5bd$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $f2062e055e39f5bd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2062e055e39f5bd$var$_toConsumableArray(r) {
    return $f2062e055e39f5bd$var$_arrayWithoutHoles(r) || $f2062e055e39f5bd$var$_iterableToArray(r) || $f2062e055e39f5bd$var$_unsupportedIterableToArray$2(r) || $f2062e055e39f5bd$var$_nonIterableSpread();
}
function $f2062e055e39f5bd$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $f2062e055e39f5bd$var$toPrimitive(t, r) {
    if ("object" != $f2062e055e39f5bd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f2062e055e39f5bd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f2062e055e39f5bd$var$toPropertyKey(t) {
    var i = $f2062e055e39f5bd$var$toPrimitive(t, "string");
    return "symbol" == $f2062e055e39f5bd$var$_typeof(i) ? i : i + "";
}
function $f2062e055e39f5bd$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f2062e055e39f5bd$var$toPropertyKey(o.key), o);
    }
}
function $f2062e055e39f5bd$var$_createClass(e, r, t) {
    return r && $f2062e055e39f5bd$var$_defineProperties(e.prototype, r), t && $f2062e055e39f5bd$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $f2062e055e39f5bd$var$_defineProperty(e, r, t) {
    return (r = $f2062e055e39f5bd$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2062e055e39f5bd$var$_createForOfIteratorHelper$1(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f2062e055e39f5bd$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f2062e055e39f5bd$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $f2062e055e39f5bd$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f2062e055e39f5bd$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $f2062e055e39f5bd$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f2062e055e39f5bd$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    function DomHandler() {
        $f2062e055e39f5bd$var$_classCallCheck(this, DomHandler);
    }
    return $f2062e055e39f5bd$var$_createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width + (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var _width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    _width = _width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return _width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.getBoundingClientRect().width || el.offsetWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.getBoundingClientRect().height || el.offsetHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window;
                var d = document;
                var e = d.documentElement;
                var g = d.getElementsByTagName('body')[0];
                var w = win.innerWidth || e.clientWidth || g.clientWidth;
                var h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(' ');
                        for(var _i = 0; _i < _styles.length; _i++)element.className = element.className + (' ' + _styles[_i]);
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(' ');
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp('(^|\\b)' + _styles2[_i2].split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className = element.className + (' ' + className);
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
                }
                return false;
            }
        },
        {
            key: "addStyles",
            value: function addStyles(element) {
                var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) Object.entries(styles).forEach(function(_ref) {
                    var _ref2 = $f2062e055e39f5bd$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return element.style[key] = value;
                });
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(element) {
                var _this = this;
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) {
                    var _computedStyles = function computedStyles(rule, value) {
                        var _element$$attrs, _element$$attrs2;
                        var styles = element !== null && element !== void 0 && (_element$$attrs = element.$attrs) !== null && _element$$attrs !== void 0 && _element$$attrs[rule] ? [
                            element === null || element === void 0 || (_element$$attrs2 = element.$attrs) === null || _element$$attrs2 === void 0 ? void 0 : _element$$attrs2[rule]
                        ] : [];
                        return [
                            value
                        ].flat().reduce(function(cv, v) {
                            if (v !== null && v !== undefined) {
                                var type = $f2062e055e39f5bd$var$_typeof(v);
                                if (type === 'string' || type === 'number') cv.push(v);
                                else if (type === 'object') {
                                    var _cv = Array.isArray(v) ? _computedStyles(rule, v) : Object.entries(v).map(function(_ref3) {
                                        var _ref4 = $f2062e055e39f5bd$var$_slicedToArray(_ref3, 2), _k = _ref4[0], _v = _ref4[1];
                                        return rule === 'style' && (!!_v || _v === 0) ? "".concat(_k.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(), ":").concat(_v) : _v ? _k : undefined;
                                    });
                                    cv = _cv.length ? cv.concat(_cv.filter(function(c) {
                                        return !!c;
                                    })) : cv;
                                }
                            }
                            return cv;
                        }, styles);
                    };
                    Object.entries(attributes).forEach(function(_ref5) {
                        var _ref6 = $f2062e055e39f5bd$var$_slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
                        if (value !== undefined && value !== null) {
                            var matchedEvent = key.match(/^on(.+)/);
                            if (matchedEvent) element.addEventListener(matchedEvent[1].toLowerCase(), value);
                            else if (key === 'p-bind') _this.setAttributes(element, value);
                            else {
                                value = key === 'class' ? $f2062e055e39f5bd$var$_toConsumableArray(new Set(_computedStyles('class', value))).join(' ').trim() : key === 'style' ? _computedStyles('style', value).join(';').trim() : value;
                                element.$attrs = element.$attrs || {}, element.$attrs[key] = value;
                                element.setAttribute(key, value);
                            }
                        }
                    });
                }
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(element, name) {
                if (element) {
                    var value = element.getAttribute(name);
                    if (!isNaN(value)) return +value;
                    if (value === 'true' || value === 'false') return value === 'true';
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "isAttributeEquals",
            value: function isAttributeEquals(element, name, value) {
                return element ? this.getAttribute(element, name) === value : false;
            }
        },
        {
            key: "isAttributeNotEquals",
            value: function isAttributeNotEquals(element, name, value) {
                return !this.isAttributeEquals(element, name, value);
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height = height - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === 'self') this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + 'px');
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left';
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = 'top';
                    }
                    var targetOffsetPx = targetOffset.left;
                    if (align === 'left') {
                        if (targetOffsetPx + elementOuterWidth > viewport.width) left = Math.max(0, targetOffsetPx + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                        else left = targetOffsetPx + windowScrollLeft;
                    } else if (targetOffsetPx + targetOuterWidth - elementOuterWidth < 0) left = windowScrollLeft;
                    else left = targetOffsetPx + targetOuterWidth - elementOuterWidth + windowScrollLeft;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = 'top';
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this2 = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left top';
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'left bottom';
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(' ');
                    var atArr = at.split(' ');
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === 'left' ? 0 : -1 * (position.my.x === 'center' ? _this2.getOuterWidth(element) / 2 : _this2.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === 'top' ? 0 : -1 * (position.my.y === 'center' ? _this2.getOuterHeight(element) / 2 : _this2.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = 'left';
                                position.at.x = 'right';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = 'right';
                                position.at.x = 'left';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = 'top';
                                position.at.y = 'bottom';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = 'bottom';
                                position.at.y = 'top';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === 'y') {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + 'px';
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + 'px';
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]('x');
                    alignWithAt[position.at.y]('y');
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === 'top' || position === 'bottom';
                    var myXPosition = position === 'left' ? 'right' : 'left';
                    var myYPosition = position === 'top' ? 'bottom' : 'top';
                    if (isAxisY) return {
                        axis: 'y',
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: 'x',
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element.parentNode === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var _this3 = this;
                var scrollableParents = [];
                if (element) {
                    // Get all parent elements
                    var parents = this.getParents(element);
                    // Regex to match auto or scroll overflow values
                    var overflowRegex = /(auto|scroll)/;
                    /**
         * Checks if an element has overflow scroll/auto in any direction
         * @param {HTMLElement} node - Element to check
         * @returns {boolean} True if element has overflow scroll/auto
         */ var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue('overflow')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-x')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-y')));
                    };
                    /**
         * Adds a scrollable parent element to the collection
         * @param {HTMLElement} node - Element to add
         */ var addScrollableParent = function addScrollableParent(node) {
                        // For document/body/html elements, add window instead
                        scrollableParents.push(node.nodeName === 'BODY' || node.nodeName === 'HTML' || _this3.isDocument(node) ? window : node);
                    };
                    // Iterate through all parent elements
                    var _iterator = $f2062e055e39f5bd$var$_createForOfIteratorHelper$1(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _parent$dataset;
                            var parent = _step.value;
                            // Check for custom scroll selectors in data attribute
                            var scrollSelectors = parent.nodeType === 1 && ((_parent$dataset = parent.dataset) === null || _parent$dataset === void 0 ? void 0 : _parent$dataset.scrollselectors);
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(',');
                                // Check each selector
                                var _iterator2 = $f2062e055e39f5bd$var$_createForOfIteratorHelper$1(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) addScrollableParent(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            // Check if the parent itself is scrollable
                            if (parent.nodeType === 1 && overflowCheck(parent)) addScrollableParent(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementHeight = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementWidth = element.offsetWidth;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var _tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(_tick) || setTimeout(_tick, 16);
                    };
                    _tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1;
                    var interval = 50;
                    var gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity = opacity - gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isChrome",
            value: function isChrome() {
                return /(chrome)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isClient",
            value: function isClient() {
                return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error('Cannot append ' + target + ' to ' + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error('Cannot remove ' + element + ' from ' + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : $f2062e055e39f5bd$var$_typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && $f2062e055e39f5bd$var$_typeof(obj) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string';
            }
        },
        {
            key: "isDocument",
            value: function isDocument(obj) {
                return (typeof Document === "undefined" ? "undefined" : $f2062e055e39f5bd$var$_typeof(Document)) === 'object' ? obj instanceof Document : obj && $f2062e055e39f5bd$var$_typeof(obj) === 'object' && obj !== null && obj.nodeType === 9;
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue('border-top-width');
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue('padding-top');
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document.selection && document.selection.empty) try {
                    document.selection.empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                }
                if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                var scrollDiv = document.createElement('div');
                scrollDiv.className = 'p-scrollbar-measure';
                document.body.appendChild(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                this.calculatedScrollbarWidth = scrollbarWidth;
                return scrollbarWidth;
            }
        },
        {
            key: "calculateBodyScrollbarWidth",
            value: function calculateBodyScrollbarWidth() {
                return window.innerWidth - document.documentElement.offsetWidth;
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser.version = matched.version;
                    }
                    if (this.browser.chrome) this.browser.webkit = true;
                    else if (this.browser.webkit) this.browser.safari = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || '',
                    version: match[2] || '0'
                };
            }
        },
        {
            key: "blockBodyScroll",
            value: function blockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                /* PR Ref: https://github.com/primefaces/primereact/pull/4976
       * @todo This method is called several times after this PR. Refactors will be made to prevent this in future releases.
       */ var hasScrollbarWidth = !!document.body.style.getPropertyValue('--scrollbar-width');
                !hasScrollbarWidth && document.body.style.setProperty('--scrollbar-width', this.calculateBodyScrollbarWidth() + 'px');
                this.addClass(document.body, className);
            }
        },
        {
            key: "unblockBodyScroll",
            value: function unblockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                document.body.style.removeProperty('--scrollbar-width');
                this.removeClass(document.body, className);
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== 'none');
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return !!(element !== null && typeof element !== 'undefined' && element.nodeName && element.parentNode);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var focusableElements = DomHandler.find(element, "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])".concat(selector, ",\n                [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = $f2062e055e39f5bd$var$_createForOfIteratorHelper$1(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== 'none' && getComputedStyle(focusableElement).visibility !== 'hidden') visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "focusFirstElement",
            value: function focusFirstElement(el, scrollTo) {
                if (!el) return;
                var firstFocusableElement = DomHandler.getFirstFocusableElement(el);
                firstFocusableElement && DomHandler.focus(firstFocusableElement, scrollTo);
                return firstFocusableElement;
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement('div');
                    ghostDiv.style.position = 'absolute';
                    ghostDiv.style.top = '0px';
                    ghostDiv.style.left = '0px';
                    ghostDiv.style.visibility = 'hidden';
                    ghostDiv.style.pointerEvents = 'none';
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, '<br />');
                    var ghostSpan = document.createElement('span');
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === 'INPUT' || targetNode === 'TEXTAREA' || targetNode === 'BUTTON' || targetNode === 'A' || parentNode === 'INPUT' || parentNode === 'TEXTAREA' || parentNode === 'BUTTON' || parentNode === 'A' || this.hasClass(element, 'p-button') || this.hasClass(element.parentElement, 'p-button') || this.hasClass(element.parentElement, 'p-checkbox') || this.hasClass(element.parentElement, 'p-radiobutton');
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === 'string') element.style.cssText = style;
                else for(var prop in style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: 'application/csv;charset=utf-8;'
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + '.csv');
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + '.csv',
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = 'data:text/csv;charset=utf-8,' + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement('a');
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute('href', src);
                        link.setAttribute('download', name);
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce, styleContainer) {
                var styleElement = document.createElement('style');
                DomHandler.addNonce(styleElement, nonce);
                if (!styleContainer) styleContainer = document.head;
                styleContainer.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        styleElement.parentNode.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "addNonce",
            value: function addNonce(styleElement, nonce) {
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute('nonce', nonce);
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === 'document') return document;
                else if (target === 'window') return window;
                else if ($f2062e055e39f5bd$var$_typeof(target) === 'object' && target.hasOwnProperty('current')) return this.isExist(target.current) ? target.current : null;
                var isFunction = function isFunction(obj) {
                    return !!(obj && obj.constructor && obj.call && obj.apply);
                };
                var element = isFunction(target) ? target() : target;
                return this.isDocument(element) || this.isExist(element) ? element : null;
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index;
                var rv;
                var attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1;
                var attrs2;
                var name;
                var node1;
                var node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(',') !== attrs2.join(',')) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === 'style') {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                    return false;
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        },
        {
            key: "hasCSSAnimation",
            value: function hasCSSAnimation(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var animationDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
                    return animationDuration > 0;
                }
                return false;
            }
        },
        {
            key: "hasCSSTransition",
            value: function hasCSSTransition(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var transitionDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
                    return transitionDuration > 0;
                }
                return false;
            }
        }
    ]);
}();
/**
 * All data- properties like data-test-id
 */ $f2062e055e39f5bd$var$_defineProperty($f2062e055e39f5bd$export$ff8ccbac9225de62, "DATA_PROPS", [
    'data-'
]);
/**
 * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
 */ $f2062e055e39f5bd$var$_defineProperty($f2062e055e39f5bd$export$ff8ccbac9225de62, "ARIA_PROPS", [
    'aria',
    'focus-target'
]);
function $f2062e055e39f5bd$export$5087227eb54526() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function $f2062e055e39f5bd$var$_extends() {
    return $f2062e055e39f5bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f2062e055e39f5bd$var$_extends.apply(null, arguments);
}
function $f2062e055e39f5bd$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f2062e055e39f5bd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f2062e055e39f5bd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f2062e055e39f5bd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f2062e055e39f5bd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f2062e055e39f5bd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f2062e055e39f5bd$export$4855211e6b8ad895 = /*#__PURE__*/ function() {
    function ObjectUtils() {
        $f2062e055e39f5bd$var$_classCallCheck(this, ObjectUtils);
    }
    return $f2062e055e39f5bd$var$_createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && $f2062e055e39f5bd$var$_typeof(obj1) === 'object' && obj2 && $f2062e055e39f5bd$var$_typeof(obj2) === 'object') return this.deepEquals(this.resolveFieldData(obj1, field), this.resolveFieldData(obj2, field));
                return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && $f2062e055e39f5bd$var$_typeof(a) === 'object' && $f2062e055e39f5bd$var$_typeof(b) === 'object') {
                    var arrA = Array.isArray(a);
                    var arrB = Array.isArray(b);
                    var i;
                    var length;
                    var key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date;
                    var dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp;
                    var regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (!data || !field) // short circuit if there is nothing to resolve
                return null;
                try {
                    var value = data[field];
                    if (this.isNotEmpty(value)) return value;
                } catch (_unused) {
                // Performance optimization: https://github.com/primefaces/primereact/issues/4797
                // do nothing and continue to other methods to resolve field data
                }
                if (Object.keys(data).length) {
                    if (this.isFunction(field)) return field(data);
                    else if (this.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf('.') === -1) return data[field];
                    var fields = field.split('.');
                    var _value = data;
                    for(var i = 0, len = fields.length; i < len; ++i){
                        if (_value == null) return null;
                        _value = _value[fields[i]];
                    }
                    return _value;
                }
                return null;
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                if (value && from !== to) {
                    if (to >= value.length) {
                        to = to % value.length;
                        from = from % value.length;
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getItemValue",
            value: function getItemValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getProp",
            value: function getProp(props) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var value = props ? props[prop] : undefined;
                return value === undefined ? defaultProps[prop] : value;
            }
        },
        {
            key: "getPropCaseInsensitive",
            value: function getPropCaseInsensitive(props, prop) {
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var fkey = this.toFlatCase(prop);
                for(var key in props){
                    if (props.hasOwnProperty(key) && this.toFlatCase(key) === fkey) return props[key];
                }
                for(var _key3 in defaultProps){
                    if (defaultProps.hasOwnProperty(_key3) && this.toFlatCase(_key3) === fkey) return defaultProps[_key3];
                }
                return undefined; // Property not found
            }
        },
        {
            key: "getMergedProps",
            value: function getMergedProps(props, defaultProps) {
                return Object.assign({}, defaultProps, props);
            }
        },
        {
            key: "getDiffProps",
            value: function getDiffProps(props, defaultProps) {
                return this.findDiffKeys(props, defaultProps);
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                // If obj is not a function, return it directly
                if (!this.isFunction(obj)) return obj;
                // Handle function invocation
                for(var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++)params[_key4 - 1] = arguments[_key4];
                if (params.length === 1) {
                    // For single parameter case, unwrap array if needed to avoid extra nesting
                    var param = params[0];
                    return obj(Array.isArray(param) ? param[0] : param);
                }
                // Pass all parameters to function
                return obj.apply(void 0, params);
            }
        },
        {
            key: "getComponentProp",
            value: function getComponentProp(component) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.isNotEmpty(component) ? this.getProp(component.props, prop, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentProps",
            value: function getComponentProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getMergedProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentDiffProps",
            value: function getComponentDiffProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getDiffProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "isValidChild",
            value: function isValidChild(child, type, validTypes) {
                /* eslint-disable */ if (child) {
                    var _child$type;
                    var childType = this.getComponentProp(child, '__TYPE') || (child.type ? child.type.displayName : undefined);
                    // for App Router in Next.js ^14,
                    if (!childType && child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && (_child$type = _child$type._payload) !== null && _child$type !== void 0 && _child$type.value) childType = child.type._payload.value.find(function(v) {
                        return v === type;
                    });
                    var isValid = childType === type;
                    try {
                        var messageTypes;
                    } catch (error) {
                    // NOOP
                    }
                    return isValid;
                }
                return false;
            /* eslint-enable */ }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return $f2062e055e39f5bd$var$_typeof(ref) === 'object' && ref.hasOwnProperty('current') ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === 'function') forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, 'A').replace(/[\xC6]/g, 'AE').replace(/[\xC7]/g, 'C').replace(/[\xC8-\xCB]/g, 'E').replace(/[\xCC-\xCF]/g, 'I').replace(/[\xD0]/g, 'D').replace(/[\xD1]/g, 'N').replace(/[\xD2-\xD6\xD8]/g, 'O').replace(/[\xD9-\xDC]/g, 'U').replace(/[\xDD]/g, 'Y').replace(/[\xDE]/g, 'P').replace(/[\xE0-\xE5]/g, 'a').replace(/[\xE6]/g, 'ae').replace(/[\xE7]/g, 'c').replace(/[\xE8-\xEB]/g, 'e').replace(/[\xEC-\xEF]/g, 'i').replace(/[\xF1]/g, 'n').replace(/[\xF2-\xF6\xF8]/g, 'o').replace(/[\xF9-\xFC]/g, 'u').replace(/[\xFE]/g, 'p').replace(/[\xFD\xFF]/g, 'y');
                return str;
            }
        },
        {
            key: "toFlatCase",
            value: function toFlatCase(str) {
                // convert snake, kebab, camel and pascal cases to flat case
                return this.isNotEmpty(str) && this.isString(str) ? str.replace(/(-|_)/g, '').toLowerCase() : str;
            }
        },
        {
            key: "toCapitalCase",
            value: function toCapitalCase(str) {
                return this.isNotEmpty(str) && this.isString(str) ? str[0].toUpperCase() + str.slice(1) : str;
            }
        },
        {
            key: "trim",
            value: function trim(value) {
                // trim only if the value is actually a string
                return this.isNotEmpty(value) && this.isString(value) ? value.trim() : value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && $f2062e055e39f5bd$var$_typeof(value) === 'object' && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "isFunction",
            value: function isFunction(value) {
                return !!(value && value.constructor && value.call && value.apply);
            }
        },
        {
            key: "isObject",
            value: function isObject(value) {
                return value !== null && value instanceof Object && value.constructor === Object;
            }
        },
        {
            key: "isDate",
            value: function isDate(value) {
                return value !== null && value instanceof Date && value.constructor === Date;
            }
        },
        {
            key: "isArray",
            value: function isArray(value) {
                return value !== null && Array.isArray(value);
            }
        },
        {
            key: "isString",
            value: function isString(value) {
                return value !== null && typeof value === 'string';
            }
        },
        {
            key: "isPrintableCharacter",
            value: function isPrintableCharacter() {
                var _char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return this.isNotEmpty(_char) && _char.length === 1 && _char.match(/\S| /);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char2) {
                return /^[a-zA-Z\u00C0-\u017F]$/.test(_char2);
            }
        },
        {
            key: "isScalar",
            value: function isScalar(value) {
                return value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint' || typeof value === 'boolean');
            }
        },
        {
            key: "findLast",
            value: function findLast(arr, callback) {
                var item;
                if (this.isNotEmpty(arr)) try {
                    item = arr.findLast(callback);
                } catch (_unused2) {
                    item = $f2062e055e39f5bd$var$_toConsumableArray(arr).reverse().find(callback);
                }
                return item;
            }
        },
        {
            key: "findLastIndex",
            value: function findLastIndex(arr, callback) {
                var index = -1;
                if (this.isNotEmpty(arr)) try {
                    index = arr.findLastIndex(callback);
                } catch (_unused3) {
                    index = arr.lastIndexOf($f2062e055e39f5bd$var$_toConsumableArray(arr).reverse().find(callback));
                }
                return index;
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var comparator = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = this.compare(value1, value2, comparator, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (this.isEmpty(value1) || this.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, comparator) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = this.isEmpty(value1);
                var emptyValue2 = this.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === 'string' && typeof value2 === 'string') result = comparator(value1, value2);
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        },
        {
            key: "localeComparator",
            value: function localeComparator(locale) {
                //performance gain using Int.Collator. It is not recommended to use localeCompare against large arrays.
                return new Intl.Collator(locale, {
                    numeric: true
                }).compare;
            }
        },
        {
            key: "findChildrenByKey",
            value: function findChildrenByKey(data, key) {
                var _iterator = $f2062e055e39f5bd$var$_createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        if (item.key === key) return item.children || [];
                        else if (item.children) {
                            var result = this.findChildrenByKey(item.children, key);
                            if (result.length > 0) return result;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return [];
            }
        },
        {
            key: "mutateFieldData",
            value: function mutateFieldData(data, field, value) {
                if ($f2062e055e39f5bd$var$_typeof(data) !== 'object' || typeof field !== 'string') // short circuit if there is nothing to resolve
                return;
                var fields = field.split('.');
                var obj = data;
                for(var i = 0, len = fields.length; i < len; ++i){
                    // Check if we are on the last field
                    if (i + 1 - len === 0) {
                        obj[fields[i]] = value;
                        break;
                    }
                    if (!obj[fields[i]]) obj[fields[i]] = {};
                    obj = obj[fields[i]];
                }
            }
        },
        {
            key: "getNestedValue",
            value: function getNestedValue(obj, path) {
                return path.split('.').reduce(function(acc, part) {
                    return acc && acc[part] !== undefined ? acc[part] : undefined;
                }, obj);
            }
        },
        {
            key: "absoluteCompare",
            value: function absoluteCompare(objA, objB) {
                var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var currentDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (!objA || !objB) return true;
                if (currentDepth > maxDepth) return true;
                if ($f2062e055e39f5bd$var$_typeof(objA) !== $f2062e055e39f5bd$var$_typeof(objB)) return false;
                var aKeys = Object.keys(objA);
                var bKeys = Object.keys(objB);
                if (aKeys.length !== bKeys.length) return false;
                for(var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++){
                    var key = _aKeys[_i];
                    var aValue = objA[key];
                    var bValue = objB[key];
                    // Skip comparison if values are objects
                    var isObject = ObjectUtils.isObject(aValue) && ObjectUtils.isObject(bValue);
                    var isFunction = ObjectUtils.isFunction(aValue) && ObjectUtils.isFunction(bValue);
                    if ((isObject || isFunction) && !this.absoluteCompare(aValue, bValue, maxDepth, currentDepth + 1)) return false;
                    if (!isObject && aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "selectiveCompare",
            value: function selectiveCompare(a, b, keysToCompare) {
                var maxDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                if (a === b) return true;
                if (!a || !b || $f2062e055e39f5bd$var$_typeof(a) !== 'object' || $f2062e055e39f5bd$var$_typeof(b) !== 'object') return false;
                if (!keysToCompare) return this.absoluteCompare(a, b, 1); // If no keys are provided, the comparison is limited to one depth level.
                var _iterator2 = $f2062e055e39f5bd$var$_createForOfIteratorHelper(keysToCompare), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var key = _step2.value;
                        var aValue = this.getNestedValue(a, key);
                        var bValue = this.getNestedValue(b, key);
                        var isObject = $f2062e055e39f5bd$var$_typeof(aValue) === 'object' && aValue !== null && $f2062e055e39f5bd$var$_typeof(bValue) === 'object' && bValue !== null;
                        // If the current key is an object, they are compared in one further level only.
                        if (isObject && !this.absoluteCompare(aValue, bValue, maxDepth)) return false;
                        if (!isObject && aValue !== bValue) return false;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return true;
            }
        }
    ]);
}();
var $f2062e055e39f5bd$var$lastId = 0;
function $f2062e055e39f5bd$export$d5d9b89141473caf() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pr_id_';
    $f2062e055e39f5bd$var$lastId++;
    return "".concat(prefix).concat($f2062e055e39f5bd$var$lastId);
}
function $f2062e055e39f5bd$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2062e055e39f5bd$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2062e055e39f5bd$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $f2062e055e39f5bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2062e055e39f5bd$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2062e055e39f5bd$export$7114f767f3d3c711 = /*#__PURE__*/ function() {
    function IconUtils() {
        $f2062e055e39f5bd$var$_classCallCheck(this, IconUtils);
    }
    return $f2062e055e39f5bd$var$_createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = $f2062e055e39f5bd$var$_typeof(icon);
                    var className = $f2062e055e39f5bd$export$ce4ab0c55987d1ff(iconProps.className, iconType === 'string' && icon);
                    content = /*#__PURE__*/ $8NFma.createElement("span", $f2062e055e39f5bd$var$_extends({}, iconProps, {
                        className: className,
                        key: $f2062e055e39f5bd$export$d5d9b89141473caf('icon')
                    }));
                    if (iconType !== 'string') {
                        var defaultContentOptions = $f2062e055e39f5bd$var$_objectSpread$2({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return $f2062e055e39f5bd$export$4855211e6b8ad895.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
}();
function $f2062e055e39f5bd$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2062e055e39f5bd$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2062e055e39f5bd$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $f2062e055e39f5bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2062e055e39f5bd$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f2062e055e39f5bd$export$d99f0801a68bbcf1(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: '_',
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = $f2062e055e39f5bd$var$_objectSpread$1($f2062e055e39f5bd$var$_objectSpread$1({}, defaultOptions), options);
    var tests;
    var partialPosition;
    var len;
    var firstNonMaskPos;
    var defs;
    var androidChrome;
    var lastRequiredNonMaskPos;
    var oldVal;
    var focusText;
    var caretTimeoutId;
    var buffer;
    var defaultBuffer;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === 'number') {
            begin = first;
            end = typeof last === 'number' ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || $f2062e055e39f5bd$export$ff8ccbac9225de62.isIOS() && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos = caret();
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if ($f2062e055e39f5bd$export$ff8ccbac9225de62.isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join('');
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join('') === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = '';
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace('?', '').length) caret(0, pos);
            else caret(pos);
        }, 100);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join('');
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue();
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : '',
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    value: defaultBuffer !== val ? val : ''
                }
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', onBlur);
        el.addEventListener('keydown', onKeyDown);
        el.addEventListener('keypress', onKeyPress);
        el.addEventListener('input', onInput);
        el.addEventListener('paste', handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', onBlur);
        el.removeEventListener('keydown', onKeyDown);
        el.removeEventListener('keypress', onKeyPress);
        el.removeEventListener('input', onInput);
        el.removeEventListener('paste', handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]'
        };
        androidChrome = $f2062e055e39f5bd$export$ff8ccbac9225de62.isChrome() && $f2062e055e39f5bd$export$ff8ccbac9225de62.isAndroid();
        var maskTokens = options.mask.split('');
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === '?') {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== '?') {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join('');
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function $f2062e055e39f5bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2062e055e39f5bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2062e055e39f5bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f2062e055e39f5bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2062e055e39f5bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Merges properties together taking an Array of props and merging into one single set of
 * properties. The options can contain a "classNameMergeFunction" which can be something
 * like Tailwind Merge for properly merging Tailwind classes.
 *
 * @param {object[]} props the array of object properties to merge
 * @param {*} options either empty or could contain a custom merge function like TailwindMerge
 * @returns the single properties value after merging
 */ function $f2062e055e39f5bd$export$9d1611c77c2fe928(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!props) return undefined;
    var isFunction = function isFunction(obj) {
        return typeof obj === 'function';
    };
    var classNameMergeFunction = options.classNameMergeFunction;
    var hasMergeFunction = isFunction(classNameMergeFunction);
    return props.reduce(function(merged, ps) {
        if (!ps) return merged;
        var _loop = function _loop() {
            var value = ps[key];
            if (key === 'style') merged.style = $f2062e055e39f5bd$var$_objectSpread($f2062e055e39f5bd$var$_objectSpread({}, merged.style), ps.style);
            else if (key === 'className') {
                var newClassName = '';
                if (hasMergeFunction) newClassName = classNameMergeFunction(merged.className, ps.className);
                else newClassName = [
                    merged.className,
                    ps.className
                ].join(' ').trim();
                merged.className = newClassName || undefined;
            } else if (isFunction(value)) {
                var existingFn = merged[key];
                merged[key] = existingFn ? function() {
                    existingFn.apply(void 0, arguments);
                    value.apply(void 0, arguments);
                } : value;
            } else merged[key] = value;
        };
        for(var key in ps)_loop();
        return merged;
    }, {});
}
function $f2062e055e39f5bd$var$handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return $f2062e055e39f5bd$var$_toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex($f2062e055e39f5bd$export$832931caede8e4b9.get(el));
                el.style.zIndex = '';
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var $f2062e055e39f5bd$export$832931caede8e4b9 = $f2062e055e39f5bd$var$handler();

});


parcelRegister("64a8q", function(module, exports) {

$parcel$export(module.exports, "ComponentBase", () => $46aafa626dd50ea9$export$425c3e0a21b857e8);
$parcel$export(module.exports, "useHandleStyle", () => $46aafa626dd50ea9$export$142583cb150b394);

var $eGEKG = parcelRequire("eGEKG");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");
'use client';
function $46aafa626dd50ea9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $46aafa626dd50ea9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $46aafa626dd50ea9$var$_arrayLikeToArray(r);
}
function $46aafa626dd50ea9$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $46aafa626dd50ea9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $46aafa626dd50ea9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $46aafa626dd50ea9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $46aafa626dd50ea9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $46aafa626dd50ea9$var$_toConsumableArray(r) {
    return $46aafa626dd50ea9$var$_arrayWithoutHoles(r) || $46aafa626dd50ea9$var$_iterableToArray(r) || $46aafa626dd50ea9$var$_unsupportedIterableToArray(r) || $46aafa626dd50ea9$var$_nonIterableSpread();
}
function $46aafa626dd50ea9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $46aafa626dd50ea9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46aafa626dd50ea9$var$_typeof(o);
}
function $46aafa626dd50ea9$var$toPrimitive(t, r) {
    if ("object" != $46aafa626dd50ea9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $46aafa626dd50ea9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $46aafa626dd50ea9$var$toPropertyKey(t) {
    var i = $46aafa626dd50ea9$var$toPrimitive(t, "string");
    return "symbol" == $46aafa626dd50ea9$var$_typeof(i) ? i : i + "";
}
function $46aafa626dd50ea9$var$_defineProperty(e, r, t) {
    return (r = $46aafa626dd50ea9$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $46aafa626dd50ea9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46aafa626dd50ea9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46aafa626dd50ea9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $46aafa626dd50ea9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46aafa626dd50ea9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46aafa626dd50ea9$var$baseStyle = "\n.p-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0;\n    pointer-events: none;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n}\n\n.p-overflow-hidden {\n    overflow: hidden;\n    padding-right: var(--scrollbar-width);\n}\n";
var $46aafa626dd50ea9$var$buttonStyles = "\n.p-button {\n    margin: 0;\n    display: inline-flex;\n    cursor: pointer;\n    user-select: none;\n    align-items: center;\n    vertical-align: bottom;\n    text-align: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.p-button-label {\n    flex: 1 1 auto;\n}\n\n.p-button-icon {\n    pointer-events: none;\n}\n\n.p-button-icon-right {\n    order: 1;\n}\n\n.p-button:disabled {\n    cursor: default;\n}\n\n.p-button-icon-only {\n    justify-content: center;\n}\n\n.p-button-icon-only .p-button-label {\n    visibility: hidden;\n    width: 0;\n    flex: 0 0 auto;\n}\n\n.p-button-vertical {\n    flex-direction: column;\n}\n\n.p-button-icon-bottom {\n    order: 2;\n}\n\n.p-button-group .p-button {\n    margin: 0;\n}\n\n.p-button-group .p-button:not(:last-child) {\n    border-right: 0 none;\n}\n\n.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {\n    border-radius: 0;\n}\n\n.p-button-group .p-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.p-button-group .p-button:last-of-type {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.p-button-group .p-button:focus {\n    position: relative;\n    z-index: 1;\n}\n\n.p-button-group-single .p-button:first-of-type {\n    border-top-right-radius: var(--border-radius) !important;\n    border-bottom-right-radius: var(--border-radius) !important;\n}\n\n.p-button-group-single .p-button:last-of-type {\n    border-top-left-radius: var(--border-radius) !important;\n    border-bottom-left-radius: var(--border-radius) !important;\n}\n";
var $46aafa626dd50ea9$var$inputTextStyles = "\n.p-inputtext {\n    margin: 0;\n}\n\n.p-fluid .p-inputtext {\n    width: 100%;\n}\n\n/* InputGroup */\n.p-inputgroup {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup-addon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-inputgroup .p-float-label {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup .p-inputtext,\n.p-fluid .p-inputgroup .p-inputtext,\n.p-inputgroup .p-inputwrapper,\n.p-fluid .p-inputgroup .p-input {\n    flex: 1 1 auto;\n    width: 1%;\n}\n\n/* Floating Label */\n.p-float-label {\n    display: block;\n    position: relative;\n}\n\n.p-float-label label {\n    position: absolute;\n    pointer-events: none;\n    top: 50%;\n    margin-top: -0.5rem;\n    transition-property: all;\n    transition-timing-function: ease;\n    line-height: 1;\n}\n\n.p-float-label textarea ~ label,\n.p-float-label .p-mention ~ label {\n    top: 1rem;\n}\n\n.p-float-label input:focus ~ label,\n.p-float-label input:-webkit-autofill ~ label,\n.p-float-label input.p-filled ~ label,\n.p-float-label textarea:focus ~ label,\n.p-float-label textarea.p-filled ~ label,\n.p-float-label .p-inputwrapper-focus ~ label,\n.p-float-label .p-inputwrapper-filled ~ label,\n.p-float-label .p-tooltip-target-wrapper ~ label {\n    top: -0.75rem;\n    font-size: 12px;\n}\n\n.p-float-label .p-placeholder,\n.p-float-label input::placeholder,\n.p-float-label .p-inputtext::placeholder {\n    opacity: 0;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-float-label .p-focus .p-placeholder,\n.p-float-label input:focus::placeholder,\n.p-float-label .p-inputtext:focus::placeholder {\n    opacity: 1;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-input-icon-left,\n.p-input-icon-right {\n    position: relative;\n    display: inline-block;\n}\n\n.p-input-icon-left > i,\n.p-input-icon-right > i,\n.p-input-icon-left > svg,\n.p-input-icon-right > svg,\n.p-input-icon-left > .p-input-prefix,\n.p-input-icon-right > .p-input-suffix {\n    position: absolute;\n    top: 50%;\n    margin-top: -0.5rem;\n}\n\n.p-fluid .p-input-icon-left,\n.p-fluid .p-input-icon-right {\n    display: block;\n    width: 100%;\n}\n";
var $46aafa626dd50ea9$var$iconStyles = "\n.p-icon {\n    display: inline-block;\n}\n\n.p-icon-spin {\n    -webkit-animation: p-icon-spin 2s infinite linear;\n    animation: p-icon-spin 2s infinite linear;\n}\n\nsvg.p-icon {\n    pointer-events: auto;\n}\n\nsvg.p-icon g,\n.p-disabled svg.p-icon {\n    pointer-events: none;\n}\n\n@-webkit-keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n\n@keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n";
var $46aafa626dd50ea9$var$commonStyle = "\n@layer primereact {\n    .p-component, .p-component * {\n        box-sizing: border-box;\n    }\n\n    .p-hidden {\n        display: none;\n    }\n\n    .p-hidden-space {\n        visibility: hidden;\n    }\n\n    .p-reset {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        text-decoration: none;\n        font-size: 100%;\n        list-style: none;\n    }\n\n    .p-disabled, .p-disabled * {\n        cursor: default;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    .p-component-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .p-unselectable-text {\n        user-select: none;\n    }\n\n    .p-scrollbar-measure {\n        width: 100px;\n        height: 100px;\n        overflow: scroll;\n        position: absolute;\n        top: -9999px;\n    }\n\n    @-webkit-keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n    @keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n\n    .p-link {\n        text-align: left;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        border: none;\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-link:disabled {\n        cursor: default;\n    }\n\n    /* Non react overlay animations */\n    .p-connected-overlay {\n        opacity: 0;\n        transform: scaleY(0.8);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-visible {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n\n    .p-connected-overlay-hidden {\n        opacity: 0;\n        transform: scaleY(1);\n        transition: opacity .1s linear;\n    }\n\n    /* React based overlay animations */\n    .p-connected-overlay-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    .p-connected-overlay-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-enter-done {\n        transform: none;\n    }\n\n    .p-connected-overlay-exit {\n        opacity: 1;\n    }\n\n    .p-connected-overlay-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n\n    /* Toggleable Content */\n    .p-toggleable-content-enter {\n        max-height: 0;\n    }\n\n    .p-toggleable-content-enter-active {\n        overflow: hidden;\n        max-height: 1000px;\n        transition: max-height 1s ease-in-out;\n    }\n\n    .p-toggleable-content-enter-done {\n        transform: none;\n    }\n\n    .p-toggleable-content-exit {\n        max-height: 1000px;\n    }\n\n    .p-toggleable-content-exit-active {\n        overflow: hidden;\n        max-height: 0;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n    }\n\n    /* @todo Refactor */\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    ".concat($46aafa626dd50ea9$var$buttonStyles, "\n    ").concat($46aafa626dd50ea9$var$inputTextStyles, "\n    ").concat($46aafa626dd50ea9$var$iconStyles, "\n}\n");
var $46aafa626dd50ea9$export$425c3e0a21b857e8 = {
    cProps: undefined,
    cParams: undefined,
    cName: undefined,
    defaultProps: {
        pt: undefined,
        ptOptions: undefined,
        unstyled: false
    },
    context: {},
    globalCSS: undefined,
    classes: {},
    styles: '',
    extend: function extend() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var css = props.css;
        var defaultProps = $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, props.defaultProps), $46aafa626dd50ea9$export$425c3e0a21b857e8.defaultProps);
        var inlineStyles = {};
        var getProps = function getProps(props) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            $46aafa626dd50ea9$export$425c3e0a21b857e8.context = context;
            $46aafa626dd50ea9$export$425c3e0a21b857e8.cProps = props;
            return (0, $kMhUd.ObjectUtils).getMergedProps(props, defaultProps);
        };
        var getOtherProps = function getOtherProps(props) {
            return (0, $kMhUd.ObjectUtils).getDiffProps(props, defaultProps);
        };
        var getPTValue = function getPTValue() {
            var _ComponentBase$contex;
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var searchInDefaultPT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            // obj either is the passthrough options or has a .pt property.
            if (obj.hasOwnProperty('pt') && obj.pt !== undefined) obj = obj.pt;
            var originalkey = key;
            var isNestedParam = /./g.test(originalkey) && !!params[originalkey.split('.')[0]];
            var fkey = isNestedParam ? (0, $kMhUd.ObjectUtils).toFlatCase(originalkey.split('.')[1]) : (0, $kMhUd.ObjectUtils).toFlatCase(originalkey);
            var hostName = params.hostName && (0, $kMhUd.ObjectUtils).toFlatCase(params.hostName);
            var componentName = hostName || params.props && params.props.__TYPE && (0, $kMhUd.ObjectUtils).toFlatCase(params.props.__TYPE) || '';
            var isTransition = fkey === 'transition';
            var datasetPrefix = 'data-pc-';
            var _getHostInstance = function getHostInstance(params) {
                return params !== null && params !== void 0 && params.props ? params.hostName ? params.props.__TYPE === params.hostName ? params.props : _getHostInstance(params.parent) : params.parent : undefined;
            };
            var getPropValue = function getPropValue(name) {
                var _params$props, _getHostInstance2;
                return ((_params$props = params.props) === null || _params$props === void 0 ? void 0 : _params$props[name]) || ((_getHostInstance2 = _getHostInstance(params)) === null || _getHostInstance2 === void 0 ? void 0 : _getHostInstance2[name]);
            };
            $46aafa626dd50ea9$export$425c3e0a21b857e8.cParams = params;
            $46aafa626dd50ea9$export$425c3e0a21b857e8.cName = componentName;
            var _ref = getPropValue('ptOptions') || $46aafa626dd50ea9$export$425c3e0a21b857e8.context.ptOptions || {}, _ref$mergeSections = _ref.mergeSections, mergeSections = _ref$mergeSections === void 0 ? true : _ref$mergeSections, _ref$mergeProps = _ref.mergeProps, useMergeProps = _ref$mergeProps === void 0 ? false : _ref$mergeProps;
            var getPTClassValue = function getPTClassValue() {
                var value = $46aafa626dd50ea9$var$_getOptionValue.apply(void 0, arguments);
                if (Array.isArray(value)) return {
                    className: (0, $kMhUd.classNames).apply(void 0, $46aafa626dd50ea9$var$_toConsumableArray(value))
                };
                if ((0, $kMhUd.ObjectUtils).isString(value)) return {
                    className: value
                };
                if (value !== null && value !== void 0 && value.hasOwnProperty('className') && Array.isArray(value.className)) return {
                    className: (0, $kMhUd.classNames).apply(void 0, $46aafa626dd50ea9$var$_toConsumableArray(value.className))
                };
                return value;
            };
            var globalPT = searchInDefaultPT ? isNestedParam ? $46aafa626dd50ea9$var$_useGlobalPT(getPTClassValue, originalkey, params) : $46aafa626dd50ea9$var$_useDefaultPT(getPTClassValue, originalkey, params) : undefined;
            var self = isNestedParam ? undefined : $46aafa626dd50ea9$var$_usePT($46aafa626dd50ea9$var$_getPT(obj, componentName), getPTClassValue, originalkey, params);
            var datasetProps = !isTransition && $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, fkey === 'root' && $46aafa626dd50ea9$var$_defineProperty({}, "".concat(datasetPrefix, "name"), params.props && params.props.__parentMetadata ? (0, $kMhUd.ObjectUtils).toFlatCase(params.props.__TYPE) : componentName)), {}, $46aafa626dd50ea9$var$_defineProperty({}, "".concat(datasetPrefix, "section"), fkey));
            return mergeSections || !mergeSections && self ? useMergeProps ? (0, $kMhUd.mergeProps)([
                globalPT,
                self,
                Object.keys(datasetProps).length ? datasetProps : {}
            ], {
                classNameMergeFunction: (_ComponentBase$contex = $46aafa626dd50ea9$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex === void 0 ? void 0 : _ComponentBase$contex.classNameMergeFunction
            }) : $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, globalPT), self), Object.keys(datasetProps).length ? datasetProps : {}) : $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, self), Object.keys(datasetProps).length ? datasetProps : {});
        };
        var setMetaData = function setMetaData() {
            var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var props = metadata.props, state = metadata.state;
            var ptm = function ptm() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return getPTValue((props || {}).pt, key, $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, metadata), params));
            };
            var ptmo = function ptmo() {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return getPTValue(obj, key, params, false);
            };
            var isUnstyled = function isUnstyled() {
                return $46aafa626dd50ea9$export$425c3e0a21b857e8.context.unstyled || (0, $eGEKG.default).unstyled || props.unstyled;
            };
            var cx = function cx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return !isUnstyled() ? $46aafa626dd50ea9$var$_getOptionValue(css && css.classes, key, $46aafa626dd50ea9$var$_objectSpread({
                    props: props,
                    state: state
                }, params)) : undefined;
            };
            var sx = function sx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                if (when) {
                    var _ComponentBase$contex2;
                    var self = $46aafa626dd50ea9$var$_getOptionValue(css && css.inlineStyles, key, $46aafa626dd50ea9$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    var base = $46aafa626dd50ea9$var$_getOptionValue(inlineStyles, key, $46aafa626dd50ea9$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    return (0, $kMhUd.mergeProps)([
                        base,
                        self
                    ], {
                        classNameMergeFunction: (_ComponentBase$contex2 = $46aafa626dd50ea9$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex2 === void 0 ? void 0 : _ComponentBase$contex2.classNameMergeFunction
                    });
                }
                return undefined;
            };
            return {
                ptm: ptm,
                ptmo: ptmo,
                sx: sx,
                cx: cx,
                isUnstyled: isUnstyled
            };
        };
        return $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({
            getProps: getProps,
            getOtherProps: getOtherProps,
            setMetaData: setMetaData
        }, props), {}, {
            defaultProps: defaultProps
        });
    }
};
var $46aafa626dd50ea9$var$_getOptionValue = function getOptionValue(obj) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var fKeys = String((0, $kMhUd.ObjectUtils).toFlatCase(key)).split('.');
    var fKey = fKeys.shift();
    var matchedPTOption = (0, $kMhUd.ObjectUtils).isNotEmpty(obj) ? Object.keys(obj).find(function(k) {
        return (0, $kMhUd.ObjectUtils).toFlatCase(k) === fKey;
    }) : '';
    return fKey ? (0, $kMhUd.ObjectUtils).isObject(obj) ? $46aafa626dd50ea9$var$_getOptionValue((0, $kMhUd.ObjectUtils).getItemValue(obj[matchedPTOption], params), fKeys.join('.'), params) : undefined : (0, $kMhUd.ObjectUtils).getItemValue(obj, params);
};
var $46aafa626dd50ea9$var$_getPT = function _getPT(pt) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var _usept = pt === null || pt === void 0 ? void 0 : pt._usept;
    var getValue = function getValue(value) {
        var _ref3;
        var checkSameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _value = callback ? callback(value) : value;
        var _key = (0, $kMhUd.ObjectUtils).toFlatCase(key);
        return (_ref3 = checkSameKey ? _key !== $46aafa626dd50ea9$export$425c3e0a21b857e8.cName ? _value === null || _value === void 0 ? void 0 : _value[_key] : undefined : _value === null || _value === void 0 ? void 0 : _value[_key]) !== null && _ref3 !== void 0 ? _ref3 : _value;
    };
    return (0, $kMhUd.ObjectUtils).isNotEmpty(_usept) ? {
        _usept: _usept,
        originalValue: getValue(pt.originalValue),
        value: getValue(pt.value)
    } : getValue(pt, true);
};
var $46aafa626dd50ea9$var$_usePT = function _usePT(pt, callback, key, params) {
    var fn = function fn(value) {
        return callback(value, key, params);
    };
    if (pt !== null && pt !== void 0 && pt.hasOwnProperty('_usept')) {
        var _ref4 = pt._usept || $46aafa626dd50ea9$export$425c3e0a21b857e8.context.ptOptions || {}, _ref4$mergeSections = _ref4.mergeSections, mergeSections = _ref4$mergeSections === void 0 ? true : _ref4$mergeSections, _ref4$mergeProps = _ref4.mergeProps, useMergeProps = _ref4$mergeProps === void 0 ? false : _ref4$mergeProps, classNameMergeFunction = _ref4.classNameMergeFunction;
        var originalValue = fn(pt.originalValue);
        var value = fn(pt.value);
        if (originalValue === undefined && value === undefined) return undefined;
        else if ((0, $kMhUd.ObjectUtils).isString(value)) return value;
        else if ((0, $kMhUd.ObjectUtils).isString(originalValue)) return originalValue;
        return mergeSections || !mergeSections && value ? useMergeProps ? (0, $kMhUd.mergeProps)([
            originalValue,
            value
        ], {
            classNameMergeFunction: classNameMergeFunction
        }) : $46aafa626dd50ea9$var$_objectSpread($46aafa626dd50ea9$var$_objectSpread({}, originalValue), value) : value;
    }
    return fn(pt);
};
var $46aafa626dd50ea9$var$getGlobalPT = function getGlobalPT() {
    return $46aafa626dd50ea9$var$_getPT($46aafa626dd50ea9$export$425c3e0a21b857e8.context.pt || (0, $eGEKG.default).pt, undefined, function(value) {
        return (0, $kMhUd.ObjectUtils).getItemValue(value, $46aafa626dd50ea9$export$425c3e0a21b857e8.cParams);
    });
};
var $46aafa626dd50ea9$var$getDefaultPT = function getDefaultPT() {
    return $46aafa626dd50ea9$var$_getPT($46aafa626dd50ea9$export$425c3e0a21b857e8.context.pt || (0, $eGEKG.default).pt, undefined, function(value) {
        return $46aafa626dd50ea9$var$_getOptionValue(value, $46aafa626dd50ea9$export$425c3e0a21b857e8.cName, $46aafa626dd50ea9$export$425c3e0a21b857e8.cParams) || (0, $kMhUd.ObjectUtils).getItemValue(value, $46aafa626dd50ea9$export$425c3e0a21b857e8.cParams);
    });
};
var $46aafa626dd50ea9$var$_useGlobalPT = function _useGlobalPT(callback, key, params) {
    return $46aafa626dd50ea9$var$_usePT($46aafa626dd50ea9$var$getGlobalPT(), callback, key, params);
};
var $46aafa626dd50ea9$var$_useDefaultPT = function _useDefaultPT(callback, key, params) {
    return $46aafa626dd50ea9$var$_usePT($46aafa626dd50ea9$var$getDefaultPT(), callback, key, params);
};
var $46aafa626dd50ea9$export$142583cb150b394 = function useHandleStyle(styles) {
    var _isUnstyled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {};
    var config = arguments.length > 2 ? arguments[2] : undefined;
    var name = config.name, _config$styled = config.styled, styled = _config$styled === void 0 ? false : _config$styled, _config$hostName = config.hostName, hostName = _config$hostName === void 0 ? '' : _config$hostName;
    var globalCSS = $46aafa626dd50ea9$var$_useGlobalPT($46aafa626dd50ea9$var$_getOptionValue, 'global.css', $46aafa626dd50ea9$export$425c3e0a21b857e8.cParams);
    var componentName = (0, $kMhUd.ObjectUtils).toFlatCase(name);
    var _useStyle = (0, $kocnD.useStyle)($46aafa626dd50ea9$var$baseStyle, {
        name: 'base',
        manual: true
    }), loadBaseStyle = _useStyle.load;
    var _useStyle2 = (0, $kocnD.useStyle)($46aafa626dd50ea9$var$commonStyle, {
        name: 'common',
        manual: true
    }), loadCommonStyle = _useStyle2.load;
    var _useStyle3 = (0, $kocnD.useStyle)(globalCSS, {
        name: 'global',
        manual: true
    }), loadGlobalStyle = _useStyle3.load;
    var _useStyle4 = (0, $kocnD.useStyle)(styles, {
        name: name,
        manual: true
    }), loadComponentStyle = _useStyle4.load;
    var hook = function hook(hookName) {
        if (!hostName) {
            var selfHook = $46aafa626dd50ea9$var$_usePT($46aafa626dd50ea9$var$_getPT(($46aafa626dd50ea9$export$425c3e0a21b857e8.cProps || {}).pt, componentName), $46aafa626dd50ea9$var$_getOptionValue, "hooks.".concat(hookName));
            var defaultHook = $46aafa626dd50ea9$var$_useDefaultPT($46aafa626dd50ea9$var$_getOptionValue, "hooks.".concat(hookName));
            selfHook === null || selfHook === void 0 || selfHook();
            defaultHook === null || defaultHook === void 0 || defaultHook();
        }
    };
    hook('useMountEffect');
    (0, $kocnD.useMountEffect)(function() {
        // Load base and global styles first as they are always needed
        loadBaseStyle();
        loadGlobalStyle();
        // Only load additional styles if component is styled
        if (!_isUnstyled()) {
            // Load common styles shared across components
            loadCommonStyle();
            // Load component-specific styles if not explicitly styled
            if (!styled) loadComponentStyle();
        }
    });
    (0, $kocnD.useUpdateEffect)(function() {
        hook('useUpdateEffect');
    });
    (0, $kocnD.useUnmountEffect)(function() {
        hook('useUnmountEffect');
    });
};

});
parcelRegister("kocnD", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $ed7fa700edabacaa$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useUnmountEffect", () => $ed7fa700edabacaa$export$f3a192d0cbd30b96);
$parcel$export(module.exports, "useEventListener", () => $ed7fa700edabacaa$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useDebounce", () => $ed7fa700edabacaa$export$21805fee57372823);
$parcel$export(module.exports, "useMountEffect", () => $ed7fa700edabacaa$export$51c44cea289ac0f6);
$parcel$export(module.exports, "useDisplayOrder", () => $ed7fa700edabacaa$export$6353a33119af9098);
$parcel$export(module.exports, "ESC_KEY_HANDLING_PRIORITIES", () => $ed7fa700edabacaa$export$5153c70e1a2d4b71);
$parcel$export(module.exports, "useGlobalOnEscapeKey", () => $ed7fa700edabacaa$export$dee4359f392495ae);
$parcel$export(module.exports, "useMergeProps", () => $ed7fa700edabacaa$export$9596428d77cc41ba);
$parcel$export(module.exports, "useOverlayScrollListener", () => $ed7fa700edabacaa$export$d04245b74d6bdcb8);
$parcel$export(module.exports, "useResizeListener", () => $ed7fa700edabacaa$export$158eb97be50d41ef);
$parcel$export(module.exports, "useOverlayListener", () => $ed7fa700edabacaa$export$2fef17345d27a5b4);
$parcel$export(module.exports, "useStyle", () => $ed7fa700edabacaa$export$72c85e333541e7f);
$parcel$export(module.exports, "useTimeout", () => $ed7fa700edabacaa$export$d8e6abf214c9ec0f);
$parcel$export(module.exports, "useUpdateEffect", () => $ed7fa700edabacaa$export$496315a1608d9602);

var $8NFma = parcelRequire("8NFma");

var $kMhUd = parcelRequire("kMhUd");

var $eGEKG = parcelRequire("eGEKG");
'use client';
function $ed7fa700edabacaa$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ed7fa700edabacaa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ed7fa700edabacaa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ed7fa700edabacaa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ed7fa700edabacaa$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ed7fa700edabacaa$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ed7fa700edabacaa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ed7fa700edabacaa$var$_slicedToArray(r, e) {
    return $ed7fa700edabacaa$var$_arrayWithHoles(r) || $ed7fa700edabacaa$var$_iterableToArrayLimit(r, e) || $ed7fa700edabacaa$var$_unsupportedIterableToArray(r, e) || $ed7fa700edabacaa$var$_nonIterableRest();
}
var $ed7fa700edabacaa$export$5cae361ad82dce8b = function usePrevious(newValue) {
    var ref = $8NFma.useRef(null);
    $8NFma.useEffect(function() {
        ref.current = newValue;
        return function() {
            ref.current = null;
        };
    }, [
        newValue
    ]);
    return ref.current;
};
/* eslint-disable */ var $ed7fa700edabacaa$export$f3a192d0cbd30b96 = function useUnmountEffect(fn) {
    return $8NFma.useEffect(function() {
        return fn;
    }, []);
};
/* eslint-enable */ var $ed7fa700edabacaa$export$7080b3e976bc91ab = function useEventListener(_ref) {
    var _ref$target = _ref.target, target = _ref$target === void 0 ? 'document' : _ref$target, type = _ref.type, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = $8NFma.useRef(null);
    var listenerRef = $8NFma.useRef(null);
    var prevListener = $ed7fa700edabacaa$export$5cae361ad82dce8b(listener);
    var prevOptions = $ed7fa700edabacaa$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var bindTarget = bindOptions.target;
        if ((0, $kMhUd.ObjectUtils).isNotEmpty(bindTarget)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $kMhUd.DomHandler).getTargetElement(bindTarget));
        }
        if (!listenerRef.current && targetRef.current) {
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            targetRef.current.addEventListener(type, listenerRef.current, options);
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            targetRef.current.removeEventListener(type, listenerRef.current, options);
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // Prevent memory leak by releasing
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $8NFma.useCallback(function() {
        if (when) targetRef.current = (0, $kMhUd.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $8NFma.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $8NFma.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $ed7fa700edabacaa$export$1896bab46732d207 = function useClickOutside(ref, callback) {
    var isOutsideClicked = function isOutsideClicked(event) {
        if (!ref.current || ref.current.contains(event.target)) return;
        callback(event);
    };
    var _useEventListener = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'mousedown',
        listener: isOutsideClicked
    }), _useEventListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener, 2), bindMouseDownListener = _useEventListener2[0], unbindMouseDownListener = _useEventListener2[1];
    var _useEventListener3 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'touchstart',
        listener: isOutsideClicked
    }), _useEventListener4 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener3, 2), bindTouchStartListener = _useEventListener4[0], unbindTouchStartListener = _useEventListener4[1];
    $8NFma.useEffect(function() {
        if (!ref.current) return;
        bindMouseDownListener();
        bindTouchStartListener();
        return function() {
            unbindMouseDownListener();
            unbindTouchStartListener();
        };
    });
    return [
        ref,
        callback
    ];
};
var $ed7fa700edabacaa$export$70c4067197c60e2d = function useCounter() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        step: 1
    };
    var _React$useState = $8NFma.useState(initialValue), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), count = _React$useState2[0], setCount = _React$useState2[1];
    var increment = function increment() {
        if (options.max && count >= options.max) return;
        setCount(count + options.step);
    };
    var decrement = function decrement() {
        if (options.min || options.min === 0 && count <= options.min) return null;
        setCount(count - options.step);
    };
    var reset = function reset() {
        setCount(0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset
    };
};
var $ed7fa700edabacaa$export$21805fee57372823 = function useDebounce(initialValue, delay) {
    var _React$useState = $8NFma.useState(initialValue), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), inputValue = _React$useState2[0], setInputValue = _React$useState2[1];
    var _React$useState3 = $8NFma.useState(initialValue), _React$useState4 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState3, 2), debouncedValue = _React$useState4[0], setDebouncedValue = _React$useState4[1];
    var mountedRef = $8NFma.useRef(false);
    var timeoutRef = $8NFma.useRef(null);
    var cancelTimer = function cancelTimer() {
        return window.clearTimeout(timeoutRef.current);
    };
    $ed7fa700edabacaa$export$51c44cea289ac0f6(function() {
        mountedRef.current = true;
    });
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        cancelTimer();
    });
    $8NFma.useEffect(function() {
        if (!mountedRef.current) return;
        cancelTimer();
        timeoutRef.current = window.setTimeout(function() {
            setDebouncedValue(inputValue);
        }, delay);
    }, [
        inputValue,
        delay
    ]);
    return [
        inputValue,
        debouncedValue,
        setInputValue
    ];
};
var $ed7fa700edabacaa$var$groupToDisplayedElements = {};
var $ed7fa700edabacaa$export$6353a33119af9098 = function useDisplayOrder(group) {
    var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $8NFma.useState(function() {
        return (0, $kMhUd.UniqueComponentId)();
    }), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 1), uid = _React$useState2[0];
    var _React$useState3 = $8NFma.useState(0), _React$useState4 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState3, 2), displayOrder = _React$useState4[0], setDisplayOrder = _React$useState4[1];
    $8NFma.useEffect(function() {
        if (isVisible) {
            if (!$ed7fa700edabacaa$var$groupToDisplayedElements[group]) $ed7fa700edabacaa$var$groupToDisplayedElements[group] = [];
            var newDisplayOrder = $ed7fa700edabacaa$var$groupToDisplayedElements[group].push(uid);
            setDisplayOrder(newDisplayOrder);
            return function() {
                delete $ed7fa700edabacaa$var$groupToDisplayedElements[group][newDisplayOrder - 1];
                // Reduce array length, by removing undefined elements at the end of array:
                var lastIndex = $ed7fa700edabacaa$var$groupToDisplayedElements[group].length - 1;
                var lastOrder = (0, $kMhUd.ObjectUtils).findLastIndex($ed7fa700edabacaa$var$groupToDisplayedElements[group], function(el) {
                    return el !== undefined;
                });
                if (lastOrder !== lastIndex) $ed7fa700edabacaa$var$groupToDisplayedElements[group].splice(lastOrder + 1);
                setDisplayOrder(undefined);
            };
        }
    }, [
        group,
        uid,
        isVisible
    ]);
    return displayOrder;
};
var $ed7fa700edabacaa$var$TYPE_MAP = {
    ico: 'image/x-icon',
    png: 'image/png',
    svg: 'image/svg+xml',
    gif: 'image/gif'
};
var $ed7fa700edabacaa$export$1252d0179ae6292b = function useFavicon() {
    var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var rel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'shortcut icon';
    $8NFma.useLayoutEffect(function() {
        if (newIcon) {
            var linkElements = document.querySelectorAll("link[rel*='icon']");
            linkElements.forEach(function(linkEl) {
                document.head.removeChild(linkEl);
            });
            var link = document.createElement('link');
            link.setAttribute('type', $ed7fa700edabacaa$var$TYPE_MAP[newIcon.split('.').pop()]);
            link.setAttribute('rel', rel);
            link.setAttribute('href', newIcon);
            document.head.appendChild(link);
        }
    }, [
        newIcon,
        rel
    ]);
};
function $ed7fa700edabacaa$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ed7fa700edabacaa$var$_arrayLikeToArray(r);
}
function $ed7fa700edabacaa$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $ed7fa700edabacaa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ed7fa700edabacaa$var$_toConsumableArray(r) {
    return $ed7fa700edabacaa$var$_arrayWithoutHoles(r) || $ed7fa700edabacaa$var$_iterableToArray(r) || $ed7fa700edabacaa$var$_unsupportedIterableToArray(r) || $ed7fa700edabacaa$var$_nonIterableSpread();
}
/**
 * Priorities of different components (bigger number handled first)
 */ var $ed7fa700edabacaa$export$5153c70e1a2d4b71 = {
    SIDEBAR: 100,
    SLIDE_MENU: 200,
    DIALOG: 300,
    IMAGE: 400,
    MENU: 500,
    OVERLAY_PANEL: 600,
    PASSWORD: 700,
    CASCADE_SELECT: 800,
    SPLIT_BUTTON: 900,
    SPEED_DIAL: 1000,
    TOOLTIP: 1200
};
/**
 * Object, that manages global escape key handling logic
 */ var $ed7fa700edabacaa$var$globalEscKeyHandlingLogic = {
    /**
   * Mapping from ESC_KEY_HANDLING_PRIORITY to array of related listeners, grouped by priority
   * @example
   * Map<{
   *     [ESC_KEY_HANDLING_PRIORITIES.SIDEBAR]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>,
   *     [ESC_KEY_HANDLING_PRIORITIES.DIALOG]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>
   * }>;
   */ escKeyListeners: new Map(),
    /**
   * Keydown handler (attached to any keydown)
   */ onGlobalKeyDown: function onGlobalKeyDown(event) {
        // Do nothing if not an "esc" key is pressed:
        if (event.code !== 'Escape') return;
        var escKeyListeners = $ed7fa700edabacaa$var$globalEscKeyHandlingLogic.escKeyListeners;
        var maxPrimaryPriority = Math.max.apply(Math, $ed7fa700edabacaa$var$_toConsumableArray(escKeyListeners.keys()));
        var theMostImportantEscHandlersSet = escKeyListeners.get(maxPrimaryPriority);
        var maxSecondaryPriority = Math.max.apply(Math, $ed7fa700edabacaa$var$_toConsumableArray(theMostImportantEscHandlersSet.keys()));
        var theMostImportantEscHandler = theMostImportantEscHandlersSet.get(maxSecondaryPriority);
        theMostImportantEscHandler(event);
    },
    /**
   * Attach global keydown listener if there are any "esc" key handlers assigned,
   * otherwise detach.
   */ refreshGlobalKeyDownListener: function refreshGlobalKeyDownListener() {
        var document1 = (0, $kMhUd.DomHandler).getTargetElement('document');
        if (this.escKeyListeners.size > 0) document1.addEventListener('keydown', this.onGlobalKeyDown);
        else document1.removeEventListener('keydown', this.onGlobalKeyDown);
    },
    /**
   * Add "Esc" key handler
   */ addListener: function addListener(callback, _ref) {
        var _this = this;
        var _ref2 = $ed7fa700edabacaa$var$_slicedToArray(_ref, 2), primaryPriority = _ref2[0], secondaryPriority = _ref2[1];
        var escKeyListeners = this.escKeyListeners;
        if (!escKeyListeners.has(primaryPriority)) escKeyListeners.set(primaryPriority, new Map());
        var primaryPriorityListeners = escKeyListeners.get(primaryPriority);
        // To prevent unexpected override of callback:
        if (primaryPriorityListeners.has(secondaryPriority)) throw new Error("Unexpected: global esc key listener with priority [".concat(primaryPriority, ", ").concat(secondaryPriority, "] already exists."));
        primaryPriorityListeners.set(secondaryPriority, callback);
        this.refreshGlobalKeyDownListener();
        return function() {
            primaryPriorityListeners["delete"](secondaryPriority);
            if (primaryPriorityListeners.size === 0) escKeyListeners["delete"](primaryPriority);
            _this.refreshGlobalKeyDownListener();
        };
    }
};
var $ed7fa700edabacaa$export$dee4359f392495ae = function useGlobalOnEscapeKey(_ref3) {
    var callback = _ref3.callback, when = _ref3.when, priority = _ref3.priority;
    (0, $8NFma.useEffect)(function() {
        if (!when) return;
        return $ed7fa700edabacaa$var$globalEscKeyHandlingLogic.addListener(callback, priority);
    }, [
        callback,
        when,
        priority
    ]);
};
var $ed7fa700edabacaa$export$a7395f9832c00176 = function useIntersectionObserver(ref) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _React$useState = $8NFma.useState(false), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), isElementVisible = _React$useState2[0], setIsElementVisible = _React$useState2[1];
    $8NFma.useEffect(function() {
        if (!ref.current) return;
        var observer = new IntersectionObserver(function(_ref) {
            var _ref2 = $ed7fa700edabacaa$var$_slicedToArray(_ref, 1), entry = _ref2[0];
            setIsElementVisible(entry.isIntersecting);
        }, options);
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        options,
        ref
    ]);
    return isElementVisible;
};
/* eslint-disable */ var $ed7fa700edabacaa$export$f4b266cd2aae9cb1 = function useInterval(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $8NFma.useRef(null);
    var savedCallback = $8NFma.useRef(null);
    var clear = $8NFma.useCallback(function() {
        return clearInterval(timeout.current);
    }, [
        timeout.current
    ]);
    $8NFma.useEffect(function() {
        savedCallback.current = fn;
    });
    $8NFma.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setInterval(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ var $ed7fa700edabacaa$export$dd42f485803cd57d = function useMatchMedia(query) {
    var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $8NFma.useState(false), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    var matchMedia = $8NFma.useRef(null);
    var handleChange = function handleChange(e) {
        return setMatches(e.matches);
    };
    var bind = function bind() {
        return matchMedia.current && matchMedia.current.addEventListener('change', handleChange);
    };
    var unbind = function unbind() {
        return matchMedia.current && matchMedia.current.removeEventListener('change', handleChange) && (matchMedia.current = null);
    };
    $8NFma.useEffect(function() {
        if (when) {
            matchMedia.current = window.matchMedia(query);
            setMatches(matchMedia.current.matches);
            bind();
        }
        return unbind;
    }, [
        query,
        when
    ]);
    return matches;
};
/* eslint-enable */ /**
 * Hook to merge properties including custom merge function for things like Tailwind merge.
 */ var $ed7fa700edabacaa$export$9596428d77cc41ba = function useMergeProps() {
    var context = (0, $8NFma.useContext)((0, $eGEKG.PrimeReactContext));
    return function() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++)props[_key] = arguments[_key];
        return (0, $kMhUd.mergeProps)(props, context === null || context === void 0 ? void 0 : context.ptOptions);
    };
};
/* eslint-disable */ /**
 * Custom hook to run a mount effect only once.
 * @param {*} fn the callback function
 * @returns the hook
 */ var $ed7fa700edabacaa$export$51c44cea289ac0f6 = function useMountEffect(fn) {
    var mounted = $8NFma.useRef(false);
    return $8NFma.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return fn && fn();
        }
    }, []);
};
/* eslint-enable */ function $ed7fa700edabacaa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ed7fa700edabacaa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ed7fa700edabacaa$var$_typeof(o);
}
function $ed7fa700edabacaa$var$toPrimitive(t, r) {
    if ("object" != $ed7fa700edabacaa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ed7fa700edabacaa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ed7fa700edabacaa$var$toPropertyKey(t) {
    var i = $ed7fa700edabacaa$var$toPrimitive(t, "string");
    return "symbol" == $ed7fa700edabacaa$var$_typeof(i) ? i : i + "";
}
function $ed7fa700edabacaa$var$_defineProperty(e, r, t) {
    return (r = $ed7fa700edabacaa$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed7fa700edabacaa$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed7fa700edabacaa$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed7fa700edabacaa$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $ed7fa700edabacaa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed7fa700edabacaa$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed7fa700edabacaa$export$70811b4970b0f258 = function useMouse() {
    var _React$useState = $8NFma.useState({
        x: 0,
        y: 0
    }), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), position = _React$useState2[0], setPosition = _React$useState2[1];
    var ref = $8NFma.useRef(null);
    var handleMouseMove = $8NFma.useCallback(function(event) {
        var x;
        var y;
        if (ref.current) {
            var rect = event.currentTarget.getBoundingClientRect();
            x = event.pageX - rect.left - (window.pageXOffset || window.scrollX);
            y = event.pageY - rect.top - (window.pageYOffset || window.scrollY);
        } else {
            x = event.clientX;
            y = event.clientY;
        }
        setPosition({
            x: Math.max(0, Math.round(x)),
            y: Math.max(0, Math.round(y))
        });
    }, []);
    var _useEventListener = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: ref,
        type: 'mousemove',
        listener: handleMouseMove
    }), _useEventListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener, 2), bindMouseMoveEventListener = _useEventListener2[0], unbindMouseMoveEventListener = _useEventListener2[1];
    var _useEventListener3 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'mousemove',
        listener: handleMouseMove
    }), _useEventListener4 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener3, 2), bindDocumentMoveEventListener = _useEventListener4[0], unbindDocumentMoveEventListener = _useEventListener4[1];
    var reset = function reset() {
        return setPosition({
            x: 0,
            y: 0
        });
    };
    $8NFma.useEffect(function() {
        bindMouseMoveEventListener();
        if (!ref.current) bindDocumentMoveEventListener();
        return function() {
            unbindMouseMoveEventListener();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (!ref.current) unbindDocumentMoveEventListener();
        };
    }, [
        bindDocumentMoveEventListener,
        bindMouseMoveEventListener,
        unbindDocumentMoveEventListener,
        unbindMouseMoveEventListener
    ]);
    return $ed7fa700edabacaa$var$_objectSpread$1($ed7fa700edabacaa$var$_objectSpread$1({
        ref: ref
    }, position), {}, {
        reset: reset
    });
};
function $ed7fa700edabacaa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed7fa700edabacaa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed7fa700edabacaa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ed7fa700edabacaa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed7fa700edabacaa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ed7fa700edabacaa$export$36da96379f79f245(_ref) {
    var _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'both' : _ref$mode, _ref$initialValue = _ref.initialValue, initialValue = _ref$initialValue === void 0 ? {
        x: 0,
        y: 0
    } : _ref$initialValue;
    var _React$useState = $8NFma.useState(initialValue), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), positions = _React$useState2[0], setPositions = _React$useState2[1];
    var _React$useState3 = $8NFma.useState(false), _React$useState4 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState3, 2), active = _React$useState4[0], setActive = _React$useState4[1];
    var isMounted = $8NFma.useRef(false);
    var isSliding = $8NFma.useRef(false);
    var ref = $8NFma.useRef(null);
    var onMouseMove = function onMouseMove(event) {
        return updateMousePosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    var handlePositionChange = function handlePositionChange(_ref2) {
        var clampedX = _ref2.clampedX, clampedY = _ref2.clampedY;
        if (mode === 'vertical') setPositions({
            y: 1 - clampedY
        });
        else if (mode === 'horizontal') setPositions({
            x: clampedX
        });
        else if (mode === 'both') setPositions({
            x: clampedX,
            y: clampedY
        });
    };
    var onMouseDown = function onMouseDown(event) {
        startScrubbing();
        event.preventDefault();
        onMouseMove(event);
    };
    var stopScrubbing = function stopScrubbing() {
        if (isSliding.current && isMounted.current) {
            isSliding.current = false;
            setActive(false);
            unbindListeners();
        }
    };
    var onTouchMove = function onTouchMove(event) {
        if (event.cancelable) event.preventDefault();
        updateMousePosition({
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        });
    };
    var onTouchStart = function onTouchStart(event) {
        if (event.cancelable) event.preventDefault();
        startScrubbing();
        onTouchMove(event);
    };
    var _useEventListener = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'mousemove',
        listener: onMouseMove
    }), _useEventListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'mouseup',
        listener: stopScrubbing
    }), _useEventListener4 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'touchmove',
        listener: onTouchMove
    }), _useEventListener6 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        type: 'touchend',
        listener: stopScrubbing
    }), _useEventListener8 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _useEventListener9 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: ref,
        type: 'mousedown',
        listener: onMouseDown
    }), _useEventListener10 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener9, 2), bindMouseDownListener = _useEventListener10[0], unbindMouseDownListener = _useEventListener10[1];
    var _useEventListener11 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: ref,
        type: 'touchstart',
        listener: onTouchStart,
        options: {
            passive: false
        }
    }), _useEventListener12 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener11, 2), bindTouchStartListener = _useEventListener12[0], unbindTouchStartListener = _useEventListener12[1];
    var clamp = function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    var clampPositions = function clampPositions(_ref3) {
        var x = _ref3.x, y = _ref3.y;
        return {
            clampedX: clamp(x, 0, 1),
            clampedY: clamp(y, 0, 1)
        };
    };
    var bindListeners = function bindListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindListeners = function unbindListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var reset = function reset() {
        setPositions(initialValue);
    };
    $8NFma.useEffect(function() {
        isMounted.current = true;
    }, []);
    var startScrubbing = function startScrubbing() {
        if (!isSliding.current && isMounted.current) {
            isSliding.current = true;
            setActive(true);
            bindListeners();
        }
    };
    var updateMousePosition = function updateMousePosition(_ref4) {
        var x = _ref4.x, y = _ref4.y;
        if (isSliding.current) {
            var rect = ref.current.getBoundingClientRect();
            var _clampPositions = clampPositions({
                x: (x - rect.left) / rect.width,
                y: (y - rect.top) / rect.height
            }), clampedX = _clampPositions.clampedX, clampedY = _clampPositions.clampedY;
            handlePositionChange({
                clampedX: clampedX,
                clampedY: clampedY
            });
        }
    };
    $8NFma.useEffect(function() {
        if (ref.current) {
            bindMouseDownListener();
            bindTouchStartListener();
        }
        return function() {
            if (ref.current) {
                unbindMouseDownListener();
                unbindTouchStartListener();
            }
        };
    }, [
        bindMouseDownListener,
        bindTouchStartListener,
        positions,
        unbindMouseDownListener,
        unbindTouchStartListener
    ]);
    return $ed7fa700edabacaa$var$_objectSpread($ed7fa700edabacaa$var$_objectSpread({
        ref: ref
    }, positions), {}, {
        active: active,
        reset: reset
    });
}
var $ed7fa700edabacaa$export$d04245b74d6bdcb8 = function useOverlayScrollListener(_ref) {
    var target = _ref.target, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var targetRef = $8NFma.useRef(null);
    var listenerRef = $8NFma.useRef(null);
    var scrollableParentsRef = $8NFma.useRef([]);
    var prevListener = $ed7fa700edabacaa$export$5cae361ad82dce8b(listener);
    var prevOptions = $ed7fa700edabacaa$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $kMhUd.ObjectUtils).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $kMhUd.DomHandler).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            var hideOnScroll = context ? context.hideOverlaysOnDocumentScrolling : (0, $eGEKG.default).hideOverlaysOnDocumentScrolling;
            var nodes = scrollableParentsRef.current = (0, $kMhUd.DomHandler).getScrollableParents(targetRef.current);
            // Ensure window/body is always included as fallback
            if (!nodes.some(function(node) {
                return node === document.body || node === window;
            })) nodes.push(hideOnScroll ? window : document.body);
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            nodes.forEach(function(node) {
                return node.addEventListener('scroll', listenerRef.current, options);
            });
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            var nodes = scrollableParentsRef.current;
            nodes.forEach(function(node) {
                return node.removeEventListener('scroll', listenerRef.current, options);
            });
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // #5927 prevent memory leak by releasing
        scrollableParentsRef.current = null;
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $8NFma.useCallback(function() {
        if (when) targetRef.current = (0, $kMhUd.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $8NFma.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $8NFma.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $ed7fa700edabacaa$export$158eb97be50d41ef = function useResizeListener(_ref) {
    var listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: 'window',
        type: 'resize',
        listener: listener,
        when: when
    });
};
var $ed7fa700edabacaa$export$2fef17345d27a5b4 = function useOverlayListener(_ref) {
    var target = _ref.target, overlay = _ref.overlay, _listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when, _ref$type = _ref.type, type = _ref$type === void 0 ? 'click' : _ref$type;
    var targetRef = $8NFma.useRef(null);
    var overlayRef = $8NFma.useRef(null);
    /**
   * The parameters of the 'listener' method in the following event handlers;
   * @param {Event} event A click event of the document.
   * @param {string} options.type The custom type to detect event.
   * @param {boolean} options.valid It is controlled by PrimeReact. It is determined whether it is valid or not according to some custom validation.
   */ var _useEventListener = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: 'window',
        type: type,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'outside',
                valid: event.which !== 3 && isOutsideClicked(event)
            });
        },
        when: when
    }), _useEventListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = $ed7fa700edabacaa$export$158eb97be50d41ef({
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'resize',
                valid: !(0, $kMhUd.DomHandler).isTouchDevice()
            });
        },
        when: when
    }), _useResizeListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useEventListener3 = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: 'window',
        type: 'orientationchange',
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'orientationchange',
                valid: true
            });
        },
        when: when
    }), _useEventListener4 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener3, 2), bindWindowOrientationChangeListener = _useEventListener4[0], unbindWindowOrientationChangeListener = _useEventListener4[1];
    var _useOverlayScrollList = $ed7fa700edabacaa$export$d04245b74d6bdcb8({
        target: target,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'scroll',
                valid: true
            });
        },
        when: when
    }), _useOverlayScrollList2 = $ed7fa700edabacaa$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isOutsideClicked = function isOutsideClicked(event) {
        return targetRef.current && !(targetRef.current.isSameNode(event.target) || targetRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var bind = function bind() {
        bindDocumentClickListener();
        bindWindowResizeListener();
        bindWindowOrientationChangeListener();
        bindOverlayScrollListener();
    };
    var unbind = function unbind() {
        unbindDocumentClickListener();
        unbindWindowResizeListener();
        unbindWindowOrientationChangeListener();
        unbindOverlayScrollListener();
    };
    $8NFma.useEffect(function() {
        if (when) {
            targetRef.current = (0, $kMhUd.DomHandler).getTargetElement(target);
            overlayRef.current = (0, $kMhUd.DomHandler).getTargetElement(overlay);
        } else {
            unbind();
            targetRef.current = overlayRef.current = null;
        }
    }, [
        target,
        overlay,
        when
    ]);
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ /**
 * Hook to wrap around useState that stores the value in the browser local/session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local/session storage
 * @param {string} storage either 'local' or 'session' for what type of storage
 * @returns a stateful value, and a function to update it.
 */ var $ed7fa700edabacaa$export$95809329f49ea9f9 = function useStorage(initialValue, key) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
    // Since the local storage API isn't available in server-rendering environments,
    // we check that typeof window !== 'undefined' to make SSR and SSG work properly.
    var storageAvailable = typeof window !== 'undefined';
    // subscribe to window storage event so changes in one tab to a stored value
    // are properly reflected in all tabs
    var _useEventListener = $ed7fa700edabacaa$export$7080b3e976bc91ab({
        target: 'window',
        type: 'storage',
        listener: function listener(event) {
            var area = storage === 'local' ? window.localStorage : window.sessionStorage;
            if (event.storageArea === area && event.key === key) {
                var newValue = event.newValue ? JSON.parse(event.newValue) : undefined;
                setStoredValue(newValue);
            }
        }
    }), _useEventListener2 = $ed7fa700edabacaa$var$_slicedToArray(_useEventListener, 2), bindWindowStorageListener = _useEventListener2[0], unbindWindowStorageListener = _useEventListener2[1];
    var _React$useState = $8NFma.useState(initialValue), _React$useState2 = $ed7fa700edabacaa$var$_slicedToArray(_React$useState, 2), storedValue = _React$useState2[0], setStoredValue = _React$useState2[1];
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (storageAvailable) {
                var serializedValue = JSON.stringify(valueToStore);
                storage === 'local' ? window.localStorage.setItem(key, serializedValue) : window.sessionStorage.setItem(key, serializedValue);
            }
        } catch (error) {
            throw new Error("PrimeReact useStorage: Failed to serialize the value at key: ".concat(key));
        }
    };
    $8NFma.useEffect(function() {
        if (!storageAvailable) setStoredValue(initialValue);
        try {
            var item = storage === 'local' ? window.localStorage.getItem(key) : window.sessionStorage.getItem(key);
            setStoredValue(item ? JSON.parse(item) : initialValue);
        } catch (error) {
            // If error also return initialValue
            setStoredValue(initialValue);
        }
        bindWindowStorageListener();
        return function() {
            return unbindWindowStorageListener();
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
};
/**
 * Hook to wrap around useState that stores the value in the browser local storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local storage
 * @returns a stateful value, and a function to update it.
 */ var $ed7fa700edabacaa$export$86e2cef2561044ac = function useLocalStorage(initialValue, key) {
    return $ed7fa700edabacaa$export$95809329f49ea9f9(initialValue, key, 'local');
};
/**
 * Hook to wrap around useState that stores the value in the browser session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in session storage
 * @returns a stateful value, and a function to update it.
 */ var $ed7fa700edabacaa$export$864b6828bd07eda6 = function useSessionStorage(initialValue, key) {
    return $ed7fa700edabacaa$export$95809329f49ea9f9(initialValue, key, 'session');
};
/* eslint-enable */ var $ed7fa700edabacaa$var$_id = 0;
var $ed7fa700edabacaa$export$72c85e333541e7f = function useStyle(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _useState = (0, $8NFma.useState)(false), _useState2 = $ed7fa700edabacaa$var$_slicedToArray(_useState, 2), isLoaded = _useState2[0], setIsLoaded = _useState2[1];
    var styleRef = (0, $8NFma.useRef)(null);
    var context = (0, $8NFma.useContext)((0, $eGEKG.PrimeReactContext));
    var defaultDocument = (0, $kMhUd.DomHandler).isClient() ? window.document : undefined;
    var _options$document = options.document, document1 = _options$document === void 0 ? defaultDocument : _options$document, _options$manual = options.manual, manual = _options$manual === void 0 ? false : _options$manual, _options$name = options.name, name = _options$name === void 0 ? "style_".concat(++$ed7fa700edabacaa$var$_id) : _options$name, _options$id = options.id, id = _options$id === void 0 ? undefined : _options$id, _options$media = options.media, media = _options$media === void 0 ? undefined : _options$media;
    var getCurrentStyleRef = function getCurrentStyleRef(styleContainer) {
        var existingStyle = styleContainer.querySelector("style[data-primereact-style-id=\"".concat(name, "\"]"));
        if (existingStyle) return existingStyle;
        if (id !== undefined) {
            var existingElement = document1.getElementById(id);
            if (existingElement) return existingElement;
        }
        // finally if not found create the new style
        return document1.createElement('style');
    };
    var update = function update(newCSS) {
        isLoaded && css !== newCSS && (styleRef.current.textContent = newCSS);
    };
    var load = function load() {
        if (!document1 || isLoaded) return;
        var styleContainer = (context === null || context === void 0 ? void 0 : context.styleContainer) || document1.head;
        styleRef.current = getCurrentStyleRef(styleContainer);
        if (!styleRef.current.isConnected) {
            styleRef.current.type = 'text/css';
            if (id) styleRef.current.id = id;
            if (media) styleRef.current.media = media;
            (0, $kMhUd.DomHandler).addNonce(styleRef.current, context && context.nonce || (0, $eGEKG.default).nonce);
            styleContainer.appendChild(styleRef.current);
            if (name) styleRef.current.setAttribute('data-primereact-style-id', name);
        }
        styleRef.current.textContent = css;
        setIsLoaded(true);
    };
    var unload = function unload() {
        if (!document1 || !styleRef.current) return;
        (0, $kMhUd.DomHandler).removeInlineStyle(styleRef.current);
        setIsLoaded(false);
    };
    (0, $8NFma.useEffect)(function() {
        if (!manual) load();
    // return () => {if (!manual) unload()}; /* @todo */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        manual
    ]);
    return {
        id: id,
        name: name,
        update: update,
        unload: unload,
        load: load,
        isLoaded: isLoaded
    };
};
/* eslint-disable */ var $ed7fa700edabacaa$export$d8e6abf214c9ec0f = function useTimeout(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $8NFma.useRef(null);
    var savedCallback = $8NFma.useRef(null);
    var clear = $8NFma.useCallback(function() {
        return clearTimeout(timeout.current);
    }, [
        timeout.current
    ]);
    $8NFma.useEffect(function() {
        savedCallback.current = fn;
    });
    $8NFma.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setTimeout(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $ed7fa700edabacaa$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ /* eslint-disable */ var $ed7fa700edabacaa$export$496315a1608d9602 = function useUpdateEffect(fn, deps) {
    var mounted = $8NFma.useRef(false);
    return $8NFma.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        return fn && fn();
    }, deps);
};

});


parcelRegister("cknS9", function(module, exports) {

$parcel$export(module.exports, "CSSTransition", () => $8f99deda3b624f72$export$a7a5590ad6d7af0);

var $8NFma = parcelRequire("8NFma");

var $4OXLD = parcelRequire("4OXLD");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");

var $eGEKG = parcelRequire("eGEKG");
'use client';
function $8f99deda3b624f72$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8f99deda3b624f72$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8f99deda3b624f72$var$_typeof(o);
}
function $8f99deda3b624f72$var$toPrimitive(t, r) {
    if ("object" != $8f99deda3b624f72$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8f99deda3b624f72$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8f99deda3b624f72$var$toPropertyKey(t) {
    var i = $8f99deda3b624f72$var$toPrimitive(t, "string");
    return "symbol" == $8f99deda3b624f72$var$_typeof(i) ? i : i + "";
}
function $8f99deda3b624f72$var$_defineProperty(e, r, t) {
    return (r = $8f99deda3b624f72$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $8f99deda3b624f72$var$CSSTransitionBase = {
    defaultProps: {
        __TYPE: 'CSSTransition',
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $kMhUd.ObjectUtils).getMergedProps(props, $8f99deda3b624f72$var$CSSTransitionBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $kMhUd.ObjectUtils).getDiffProps(props, $8f99deda3b624f72$var$CSSTransitionBase.defaultProps);
    }
};
function $8f99deda3b624f72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f99deda3b624f72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f99deda3b624f72$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8f99deda3b624f72$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f99deda3b624f72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8f99deda3b624f72$export$a7a5590ad6d7af0 = /*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var props = $8f99deda3b624f72$var$CSSTransitionBase.getProps(inProps);
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var disabled = props.disabled || props.options && props.options.disabled || context && !context.cssTransition || !(0, $eGEKG.default).cssTransition;
    var onEnter = function onEnter(node, isAppearing) {
        props.onEnter && props.onEnter(node, isAppearing); // component
        props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
    };
    var onEntering = function onEntering(node, isAppearing) {
        props.onEntering && props.onEntering(node, isAppearing); // component
        props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
    };
    var onEntered = function onEntered(node, isAppearing) {
        props.onEntered && props.onEntered(node, isAppearing); // component
        props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
    };
    var onExit = function onExit(node) {
        props.onExit && props.onExit(node); // component
        props.options && props.options.onExit && props.options.onExit(node); // user option
    };
    var onExiting = function onExiting(node) {
        props.onExiting && props.onExiting(node); // component
        props.options && props.options.onExiting && props.options.onExiting(node); // user option
    };
    var onExited = function onExited(node) {
        props.onExited && props.onExited(node); // component
        props.options && props.options.onExited && props.options.onExited(node); // user option
    };
    (0, $kocnD.useUpdateEffect)(function() {
        if (disabled) {
            // no animation
            var node = (0, $kMhUd.ObjectUtils).getRefElement(props.nodeRef);
            if (props["in"]) {
                onEnter(node, true);
                onEntering(node, true);
                onEntered(node, true);
            } else {
                onExit(node);
                onExiting(node);
                onExited(node);
            }
        }
    }, [
        props["in"]
    ]);
    if (disabled) return props["in"] ? props.children : null;
    var immutableProps = {
        nodeRef: props.nodeRef,
        "in": props["in"],
        appear: props.appear,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
    };
    var mutableProps = {
        classNames: props.classNames,
        timeout: props.timeout,
        unmountOnExit: props.unmountOnExit
    };
    var mergedProps = $8f99deda3b624f72$var$_objectSpread($8f99deda3b624f72$var$_objectSpread($8f99deda3b624f72$var$_objectSpread({}, mutableProps), props.options || {}), immutableProps);
    return /*#__PURE__*/ $8NFma.createElement((0, $4OXLD.default), mergedProps, props.children);
});
$8f99deda3b624f72$export$a7a5590ad6d7af0.displayName = 'CSSTransition';

});
parcelRegister("4OXLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $382a3175b1b632fd$export$2e2bcd8739ae039);

var $crSgh = parcelRequire("crSgh");

var $d6w00 = parcelRequire("d6w00");

var $dgdbe = parcelRequire("dgdbe");


var $haMLY = parcelRequire("haMLY");

var $8dZJo = parcelRequire("8dZJo");

var $8NFma = parcelRequire("8NFma");

var $4Z1kj = parcelRequire("4Z1kj");


var $fM6fj = parcelRequire("fM6fj");
var $382a3175b1b632fd$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $haMLY.default)(node, c);
    });
};
var $382a3175b1b632fd$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8dZJo.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $382a3175b1b632fd$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $dgdbe.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $fM6fj.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $382a3175b1b632fd$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $382a3175b1b632fd$var$removeClass(node, baseClassName);
        if (activeClassName) $382a3175b1b632fd$var$removeClass(node, activeClassName);
        if (doneClassName) $382a3175b1b632fd$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $d6w00.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $4Z1kj.default), (0, $crSgh.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$382a3175b1b632fd$var$CSSTransition.defaultProps = {
    classNames: ''
};
$382a3175b1b632fd$var$CSSTransition.propTypes = {};
var $382a3175b1b632fd$export$2e2bcd8739ae039 = $382a3175b1b632fd$var$CSSTransition;

});
parcelRegister("crSgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $910218dca3627835$export$2e2bcd8739ae039);
function $910218dca3627835$export$2e2bcd8739ae039() {
    return $910218dca3627835$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $910218dca3627835$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("d6w00", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a4a8404377d887$export$2e2bcd8739ae039);
function $98a4a8404377d887$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("dgdbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a76fe4fb56e549c$export$2e2bcd8739ae039);

var $hpTIO = parcelRequire("hpTIO");
function $9a76fe4fb56e549c$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $hpTIO.default)(t, o);
}

});
parcelRegister("hpTIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cadffea099205136$export$2e2bcd8739ae039);
function $cadffea099205136$export$2e2bcd8739ae039(t, e) {
    return $cadffea099205136$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $cadffea099205136$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("haMLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c809341340fce654$export$2e2bcd8739ae039);

var $hdXrI = parcelRequire("hdXrI");
function $c809341340fce654$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $hdXrI.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("hdXrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a1c34a06a8c397$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c8a1c34a06a8c397$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("8dZJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fcf6c25c378978d$export$2e2bcd8739ae039);
function $5fcf6c25c378978d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $5fcf6c25c378978d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $5fcf6c25c378978d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $5fcf6c25c378978d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("4Z1kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0de358fcee31a7$export$2e2bcd8739ae039);

var $d6w00 = parcelRequire("d6w00");

var $dgdbe = parcelRequire("dgdbe");


var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $adZnW = parcelRequire("adZnW");


var $6uueD = parcelRequire("6uueD");

var $fM6fj = parcelRequire("fM6fj");
var $3a0de358fcee31a7$export$bb38bb9a1161268 = 'unmounted';
var $3a0de358fcee31a7$export$84cbff306f539230 = 'exited';
var $3a0de358fcee31a7$export$df38205c966be359 = 'entering';
var $3a0de358fcee31a7$export$78e9e6e3e014d60a = 'entered';
var $3a0de358fcee31a7$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3a0de358fcee31a7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dgdbe.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
                _this.appearStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else initialStatus = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3a0de358fcee31a7$export$bb38bb9a1161268;
        else initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3a0de358fcee31a7$export$bb38bb9a1161268) return {
            status: $3a0de358fcee31a7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3a0de358fcee31a7$export$df38205c966be359 && status !== $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else if (status === $3a0de358fcee31a7$export$df38205c966be359 || status === $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3a0de358fcee31a7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $fM6fj.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3a0de358fcee31a7$export$84cbff306f539230) this.setState({
            status: $3a0de358fcee31a7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3a0de358fcee31a7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3a0de358fcee31a7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $d6w00.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6uueD.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$3a0de358fcee31a7$var$Transition.contextType = (0, $6uueD.default);
$3a0de358fcee31a7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3a0de358fcee31a7$var$noop() {}
$3a0de358fcee31a7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3a0de358fcee31a7$var$noop,
    onEntering: $3a0de358fcee31a7$var$noop,
    onEntered: $3a0de358fcee31a7$var$noop,
    onExit: $3a0de358fcee31a7$var$noop,
    onExiting: $3a0de358fcee31a7$var$noop,
    onExited: $3a0de358fcee31a7$var$noop
};
$3a0de358fcee31a7$var$Transition.UNMOUNTED = $3a0de358fcee31a7$export$bb38bb9a1161268;
$3a0de358fcee31a7$var$Transition.EXITED = $3a0de358fcee31a7$export$84cbff306f539230;
$3a0de358fcee31a7$var$Transition.ENTERING = $3a0de358fcee31a7$export$df38205c966be359;
$3a0de358fcee31a7$var$Transition.ENTERED = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
$3a0de358fcee31a7$var$Transition.EXITING = $3a0de358fcee31a7$export$4aacc83d4d59139f;
var $3a0de358fcee31a7$export$2e2bcd8739ae039 = $3a0de358fcee31a7$var$Transition;

});
parcelRegister("adZnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $771abc1b9c3ac5e0$export$2e2bcd8739ae039);
var $771abc1b9c3ac5e0$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6uueD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9cff7e01ef990e$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
var $4b9cff7e01ef990e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(null);

});

parcelRegister("fM6fj", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $b7c02f0ad3191e79$export$7d26bbb1236dafd6);
var $b7c02f0ad3191e79$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});




parcelRegister("gMyz9", function(module, exports) {

$parcel$export(module.exports, "TimesIcon", () => $c37bf118acaa1cbe$export$32edebbf2d9136cc);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $c37bf118acaa1cbe$var$_extends() {
    return $c37bf118acaa1cbe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c37bf118acaa1cbe$var$_extends.apply(null, arguments);
}
var $c37bf118acaa1cbe$export$32edebbf2d9136cc = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $c37bf118acaa1cbe$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
        fill: "currentColor"
    }));
}));
$c37bf118acaa1cbe$export$32edebbf2d9136cc.displayName = 'TimesIcon';

});
parcelRegister("e6EfM", function(module, exports) {

$parcel$export(module.exports, "IconBase", () => $a450d9ba96ccd0b1$export$a188ecdd443fe91a);

var $kMhUd = parcelRequire("kMhUd");
'use client';
var $a450d9ba96ccd0b1$export$a188ecdd443fe91a = {
    defaultProps: {
        __TYPE: 'IconBase',
        className: null,
        label: null,
        spin: false
    },
    getProps: function getProps(props) {
        return (0, $kMhUd.ObjectUtils).getMergedProps(props, $a450d9ba96ccd0b1$export$a188ecdd443fe91a.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $kMhUd.ObjectUtils).getDiffProps(props, $a450d9ba96ccd0b1$export$a188ecdd443fe91a.defaultProps);
    },
    getPTI: function getPTI(props) {
        var isLabelEmpty = (0, $kMhUd.ObjectUtils).isEmpty(props.label);
        var otherProps = $a450d9ba96ccd0b1$export$a188ecdd443fe91a.getOtherProps(props);
        var ptiProps = {
            className: (0, $kMhUd.classNames)('p-icon', {
                'p-icon-spin': props.spin
            }, props.className),
            role: !isLabelEmpty ? 'img' : undefined,
            'aria-label': !isLabelEmpty ? props.label : undefined,
            'aria-hidden': props.label ? isLabelEmpty : undefined
        };
        return (0, $kMhUd.ObjectUtils).getMergedProps(otherProps, ptiProps);
    }
};

});


parcelRegister("4ldcI", function(module, exports) {

$parcel$export(module.exports, "WindowMaximizeIcon", () => $32935da379e50428$export$e9bf06badb7c79be);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $32935da379e50428$var$_extends() {
    return $32935da379e50428$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $32935da379e50428$var$_extends.apply(null, arguments);
}
var $32935da379e50428$export$e9bf06badb7c79be = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $32935da379e50428$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
        fill: "currentColor"
    }));
}));
$32935da379e50428$export$e9bf06badb7c79be.displayName = 'WindowMaximizeIcon';

});

parcelRegister("gK2aR", function(module, exports) {

$parcel$export(module.exports, "WindowMinimizeIcon", () => $c302a0f66ba5cb22$export$e1e96001ddb7b5e7);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $c302a0f66ba5cb22$var$_extends() {
    return $c302a0f66ba5cb22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c302a0f66ba5cb22$var$_extends.apply(null, arguments);
}
var $c302a0f66ba5cb22$export$e1e96001ddb7b5e7 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $c302a0f66ba5cb22$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
        fill: "currentColor"
    }));
}));
$c302a0f66ba5cb22$export$e1e96001ddb7b5e7.displayName = 'WindowMinimizeIcon';

});

parcelRegister("bKF0T", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $88e3cdfe246d0257$export$602eac185826482c);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $eGEKG = parcelRequire("eGEKG");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");
'use client';
function $88e3cdfe246d0257$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $88e3cdfe246d0257$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $88e3cdfe246d0257$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $88e3cdfe246d0257$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $88e3cdfe246d0257$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $88e3cdfe246d0257$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $88e3cdfe246d0257$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88e3cdfe246d0257$var$_slicedToArray(r, e) {
    return $88e3cdfe246d0257$var$_arrayWithHoles(r) || $88e3cdfe246d0257$var$_iterableToArrayLimit(r, e) || $88e3cdfe246d0257$var$_unsupportedIterableToArray(r, e) || $88e3cdfe246d0257$var$_nonIterableRest();
}
var $88e3cdfe246d0257$var$PortalBase = {
    defaultProps: {
        __TYPE: 'Portal',
        element: null,
        appendTo: null,
        visible: false,
        onMounted: null,
        onUnmounted: null,
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $kMhUd.ObjectUtils).getMergedProps(props, $88e3cdfe246d0257$var$PortalBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $kMhUd.ObjectUtils).getDiffProps(props, $88e3cdfe246d0257$var$PortalBase.defaultProps);
    }
};
var $88e3cdfe246d0257$export$602eac185826482c = /*#__PURE__*/ $8NFma.memo(function(inProps) {
    var props = $88e3cdfe246d0257$var$PortalBase.getProps(inProps);
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var _React$useState = $8NFma.useState(props.visible && (0, $kMhUd.DomHandler).isClient()), _React$useState2 = $88e3cdfe246d0257$var$_slicedToArray(_React$useState, 2), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    (0, $kocnD.useMountEffect)(function() {
        if ((0, $kMhUd.DomHandler).isClient() && !mountedState) {
            setMountedState(true);
            props.onMounted && props.onMounted();
        }
    });
    (0, $kocnD.useUpdateEffect)(function() {
        props.onMounted && props.onMounted();
    }, [
        mountedState
    ]);
    (0, $kocnD.useUnmountEffect)(function() {
        props.onUnmounted && props.onUnmounted();
    });
    var element = props.element || props.children;
    if (element && mountedState) {
        var appendTo = props.appendTo || context && context.appendTo || (0, $eGEKG.default).appendTo;
        if ((0, $kMhUd.ObjectUtils).isFunction(appendTo)) appendTo = appendTo();
        if (!appendTo) appendTo = document.body;
        return appendTo === 'self' ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).createPortal(element, appendTo);
    }
    return null;
});
$88e3cdfe246d0257$export$602eac185826482c.displayName = 'Portal';

});

parcelRegister("cLCHn", function(module, exports) {

$parcel$export(module.exports, "Ripple", () => $94b7e496c203aeda$export$9e9146f7e027fdaa);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");

var $64a8q = parcelRequire("64a8q");
'use client';
function $94b7e496c203aeda$var$_extends() {
    return $94b7e496c203aeda$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $94b7e496c203aeda$var$_extends.apply(null, arguments);
}
function $94b7e496c203aeda$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $94b7e496c203aeda$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $94b7e496c203aeda$var$_typeof(o);
}
function $94b7e496c203aeda$var$toPrimitive(t, r) {
    if ("object" != $94b7e496c203aeda$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $94b7e496c203aeda$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $94b7e496c203aeda$var$toPropertyKey(t) {
    var i = $94b7e496c203aeda$var$toPrimitive(t, "string");
    return "symbol" == $94b7e496c203aeda$var$_typeof(i) ? i : i + "";
}
function $94b7e496c203aeda$var$_defineProperty(e, r, t) {
    return (r = $94b7e496c203aeda$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $94b7e496c203aeda$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $94b7e496c203aeda$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $94b7e496c203aeda$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $94b7e496c203aeda$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $94b7e496c203aeda$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $94b7e496c203aeda$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $94b7e496c203aeda$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94b7e496c203aeda$var$_slicedToArray(r, e) {
    return $94b7e496c203aeda$var$_arrayWithHoles(r) || $94b7e496c203aeda$var$_iterableToArrayLimit(r, e) || $94b7e496c203aeda$var$_unsupportedIterableToArray(r, e) || $94b7e496c203aeda$var$_nonIterableRest();
}
var $94b7e496c203aeda$var$styles = "\n@layer primereact {\n    .p-ripple {\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-ink {\n        display: block;\n        position: absolute;\n        background: rgba(255, 255, 255, 0.5);\n        border-radius: 100%;\n        transform: scale(0);\n    }\n    \n    .p-ink-active {\n        animation: ripple 0.4s linear;\n    }\n    \n    .p-ripple-disabled .p-ink {\n        display: none;\n    }\n}\n\n@keyframes ripple {\n    100% {\n        opacity: 0;\n        transform: scale(2.5);\n    }\n}\n\n";
var $94b7e496c203aeda$var$classes = {
    root: 'p-ink'
};
var $94b7e496c203aeda$var$RippleBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Ripple',
        children: undefined
    },
    css: {
        styles: $94b7e496c203aeda$var$styles,
        classes: $94b7e496c203aeda$var$classes
    },
    getProps: function getProps(props) {
        return (0, $kMhUd.ObjectUtils).getMergedProps(props, $94b7e496c203aeda$var$RippleBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $kMhUd.ObjectUtils).getDiffProps(props, $94b7e496c203aeda$var$RippleBase.defaultProps);
    }
});
function $94b7e496c203aeda$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94b7e496c203aeda$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94b7e496c203aeda$var$ownKeys(Object(t), !0).forEach(function(r) {
            $94b7e496c203aeda$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94b7e496c203aeda$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $94b7e496c203aeda$export$9e9146f7e027fdaa = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var _React$useState = $8NFma.useState(false), _React$useState2 = $94b7e496c203aeda$var$_slicedToArray(_React$useState, 2), isMounted = _React$useState2[0], setMounted = _React$useState2[1];
    var inkRef = $8NFma.useRef(null);
    var targetRef = $8NFma.useRef(null);
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $94b7e496c203aeda$var$RippleBase.getProps(inProps, context);
    var isRippleActive = context && context.ripple || (0, $eGEKG.default).ripple;
    var metaData = {
        props: props
    };
    (0, $kocnD.useStyle)($94b7e496c203aeda$var$RippleBase.css.styles, {
        name: 'ripple',
        manual: !isRippleActive
    });
    var _RippleBase$setMetaDa = $94b7e496c203aeda$var$RippleBase.setMetaData($94b7e496c203aeda$var$_objectSpread({}, metaData)), ptm = _RippleBase$setMetaDa.ptm, cx = _RippleBase$setMetaDa.cx;
    var getTarget = function getTarget() {
        return inkRef.current && inkRef.current.parentElement;
    };
    var bindEvents = function bindEvents() {
        if (targetRef.current) targetRef.current.addEventListener('pointerdown', onPointerDown);
    };
    var unbindEvents = function unbindEvents() {
        if (targetRef.current) targetRef.current.removeEventListener('pointerdown', onPointerDown);
    };
    var onPointerDown = function onPointerDown(event) {
        var offset = (0, $kMhUd.DomHandler).getOffset(targetRef.current);
        var offsetX = event.pageX - offset.left + document.body.scrollTop - (0, $kMhUd.DomHandler).getWidth(inkRef.current) / 2;
        var offsetY = event.pageY - offset.top + document.body.scrollLeft - (0, $kMhUd.DomHandler).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var activateRipple = function activateRipple(offsetX, offsetY) {
        if (!inkRef.current || getComputedStyle(inkRef.current, null).display === 'none') return;
        (0, $kMhUd.DomHandler).removeClass(inkRef.current, 'p-ink-active');
        setDimensions();
        inkRef.current.style.top = offsetY + 'px';
        inkRef.current.style.left = offsetX + 'px';
        (0, $kMhUd.DomHandler).addClass(inkRef.current, 'p-ink-active');
    };
    var onAnimationEnd = function onAnimationEnd(event) {
        (0, $kMhUd.DomHandler).removeClass(event.currentTarget, 'p-ink-active');
    };
    var setDimensions = function setDimensions() {
        if (inkRef.current && !(0, $kMhUd.DomHandler).getHeight(inkRef.current) && !(0, $kMhUd.DomHandler).getWidth(inkRef.current)) {
            var d = Math.max((0, $kMhUd.DomHandler).getOuterWidth(targetRef.current), (0, $kMhUd.DomHandler).getOuterHeight(targetRef.current));
            inkRef.current.style.height = d + 'px';
            inkRef.current.style.width = d + 'px';
        }
    };
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return inkRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $kocnD.useMountEffect)(function() {
        // for App Router in Next.js ^14
        setMounted(true);
    });
    (0, $kocnD.useUpdateEffect)(function() {
        if (isMounted && inkRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    }, [
        isMounted
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (inkRef.current && !targetRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    });
    (0, $kocnD.useUnmountEffect)(function() {
        if (inkRef.current) {
            targetRef.current = null;
            unbindEvents();
        }
    });
    if (!isRippleActive) return null;
    var rootProps = mergeProps({
        'aria-hidden': true,
        className: (0, $kMhUd.classNames)(cx('root'))
    }, $94b7e496c203aeda$var$RippleBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $8NFma.createElement("span", $94b7e496c203aeda$var$_extends({
        role: "presentation",
        ref: inkRef
    }, rootProps, {
        onAnimationEnd: onAnimationEnd
    }));
}));
$94b7e496c203aeda$export$9e9146f7e027fdaa.displayName = 'Ripple';

});



parcelRegister("5taCS", function(module, exports) {

$parcel$export(module.exports, "PianoRoll", () => $0d79a52b309c755f$export$ca36adf5db0653d5);
$parcel$export(module.exports, "ColorCodeSelector", () => $0d79a52b309c755f$export$1c6ade03df0867cf);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $7Kpeg = parcelRequire("7Kpeg");

var $7baak = parcelRequire("7baak");

var $dwPAA = parcelRequire("dwPAA");

var $lsfK2 = parcelRequire("lsfK2");

var $j9SQv = parcelRequire("j9SQv");

var $5ICqB = parcelRequire("5ICqB");

var $dkYqL = parcelRequire("dkYqL");

var $7baak = parcelRequire("7baak");

var $4DYyh = parcelRequire("4DYyh");

var $lClb7 = parcelRequire("lClb7");

var $1OofT = parcelRequire("1OofT");
var $dxGmH = parcelRequire("dxGmH");
var $hSkWI = parcelRequire("hSkWI");

var $95CQM = parcelRequire("95CQM");

var $7s3ba = parcelRequire("7s3ba");
const $0d79a52b309c755f$export$ca36adf5db0653d5 = ({ className: className, instrument: instrument, colorNotes: colorNotes, modeSampler: modeSampler, triggerNotes: triggerNotes = true })=>{
    const sequence = (0, $7Kpeg.useSelector)(instrument.getDisplaySequenceSelector());
    const numSteps = (0, $7Kpeg.useSelector)(instrument.getDisplayClipLengthSelector());
    const currentStep = (0, $7Kpeg.useSelector)((0, $dkYqL.createSelector)((0, $5ICqB.selectTransportCurrentStep), (currentStep)=>currentStep % numSteps));
    const uniqueId = instrument.id + "_piano-roll";
    let lastEditedData = "";
    const colorCodeDescription = instrument.getParameterDescription("pianoRollColorCode");
    const colorCode = colorCodeDescription ? (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("pianoRollColorCode")) : "none";
    const tonality = (0, $7Kpeg.useSelector)((0, $5ICqB.selectTonality));
    const { root: root, type: mode } = (0, $7baak.getScaleRootAndType)(tonality);
    const rootPC = (0, $7baak.getPCNumber)(root);
    const instrumentRange = instrument.pitchRange.usable.max - instrument.pitchRange.usable.min + 1;
    const wrapperRef = (0, $8NFma.useRef)();
    function applyDimensions() {
        const jsElement = document.getElementById(uniqueId);
        const { width: width, height: height } = wrapperRef.current.getBoundingClientRect();
        jsElement.setDimensions({
            width: width,
            height: height
        });
    }
    (0, $7s3ba.useObserve)(wrapperRef, applyDimensions);
    (0, $8NFma.useEffect)(()=>{
        const jsElement = document.getElementById(uniqueId);
        jsElement.setRootPC(rootPC);
        jsElement.setScaleType(mode);
    }, [
        tonality
    ]);
    (0, $8NFma.useEffect)(()=>{
        const jsElement = document.getElementById(uniqueId);
        jsElement.setColorCodeMode(colorCode);
    }, [
        colorCode
    ]);
    (0, $8NFma.useEffect)(()=>{
        const jsElement = document.getElementById(uniqueId);
        jsElement.setXRange(numSteps);
    }, [
        numSteps
    ]);
    const isPlaying = (0, $7Kpeg.useSelector)((0, $5ICqB.selectIsPlaying));
    (0, $8NFma.useEffect)(()=>{
        const jsElement = document.getElementById(uniqueId);
        const controller = new AbortController();
        jsElement.addEventListener("pianoRollEdited", (evt)=>{
            const stringifiedData = JSON.stringify(evt.detail);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($dwPAA)))(stringifiedData, lastEditedData)) {
                handleSequenceEdited(evt.detail);
                lastEditedData = stringifiedData // Save using stringified version to avoid using a reference. If using a reference, "isequal" above will always be true after the first iteration
                ;
            }
        }, {
            signal: controller.signal
        });
        if (triggerNotes) {
            jsElement.addEventListener("pianoRollNoteSelectedOrCreated", (evt)=>{
                // When a note is created or selected, we will trigger a midi note
                if (isPlaying) return; // but not if it's playing
                (0, $lsfK2.midiHandler).sendNoteOn(instrument.id, evt.detail.pitch, evt.detail.velocity);
                setTimeout(()=>{
                    (0, $lsfK2.midiHandler).sendNoteOff(instrument.id, evt.detail.pitch, 0);
                }, evt.detail.durationInBeats * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime() * 1000);
            }, {
                signal: controller.signal
            });
            jsElement.addEventListener("pianoRollKeyboardNote", (evt)=>{
                // When a note is played in the display keyboard, we will trigger a midi note
                if (evt.detail.noteOff == true) (0, $lsfK2.midiHandler).sendNoteOff(instrument.id, evt.detail.pitch, 0);
                else (0, $lsfK2.midiHandler).sendNoteOn(instrument.id, evt.detail.pitch, evt.detail.velocity);
            }, {
                signal: controller.signal
            });
        }
        return ()=>{
            controller.abort();
        };
    }, [
        isPlaying
    ]);
    (0, $8NFma.useEffect)(()=>{
        const jsElement = document.getElementById(uniqueId);
        const newWidgetSequence = appSequenceToWidgetSequence(sequence);
        const oldWidgetSequence = jsElement.sequence;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dwPAA)))(oldWidgetSequence, newWidgetSequence)) {
            jsElement.sequence = newWidgetSequence.map((notaNova)=>{
                // si la nota ja existia, la coloquem amb la mateixa referència amb Object.assign
                // així, el widget sap que és la mateixa nota, i mantindrà el seu estat de selecció i s'hi podrà interactuar bé
                const notaAntigua = oldWidgetSequence.find((nota)=>nota.id === notaNova.id);
                if (notaAntigua) return Object.assign(notaAntigua, notaNova);
                return {
                    ...notaNova,
                    f: 0
                };
            });
            jsElement.redraw();
        }
        if (currentStep >= 0 && (0, $95CQM.staticSelect)(instrument.getDisplayParameterSelector("clipNumber")) === instrument.getPlaybackParameterValue("clipNumber")) jsElement.locate(currentStep);
        else jsElement.locate(-10); // make it dissapear
    });
    const appSequenceToWidgetSequence = (sequence)=>{
        return sequence.map((value)=>{
            return {
                t: value.onset,
                n: value.pitch,
                g: value.duration,
                v: value.velocity,
                id: value.id
            };
        });
    };
    const widgetSequenceToAppSequence = (wSequence)=>{
        return wSequence.map((value)=>{
            return {
                onset: value.t,
                pitch: value.n,
                duration: value.g,
                velocity: value.v,
                id: value.id
            };
        });
    };
    const handleSequenceEdited = (widgetSequence)=>{
        instrument.updateSequence(widgetSequenceToAppSequence(widgetSequence));
    };
    const maxYRange = 36;
    const doesYScroll = instrumentRange > maxYRange;
    const getLowestNoteForYOffset = ()=>{
        // if the roll doesn't scroll, simply return the lowest roll
        if (!doesYScroll) return instrument.pitchRange.usable.min;
        // else, return the lowest drawn note, if there are any notes drawn on the roll
        // if (sequence && sequence.map(note => note.pitch)) return sequence.map(note => note.pitch).reduce((min, value) => Math.min(min, value));
        // else, return a sensible default, if it exists
        if (instrument.pitchRange.typical) return instrument.pitchRange.typical.min;
        return 0;
    };
    // Available webaudio-pianoroll attributes: https://github.com/g200kg/webaudio-pianoroll
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        "data-widget-id": "pianoRoll",
        ref: wrapperRef,
        className: `gruf-piano-roll ${className}`,
        style: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("gruf-pianoroll", {
            id: uniqueId,
            editmode: instrument.isMono ? "dragmono" : "dragpoly",
            instrumentid: instrument.id,
            rootpc: rootPC,
            scaletype: mode,
            colorcodemode: colorCode,
            grid: 2,
            xrange: numSteps,
            yrange: Math.min(instrumentRange, maxYRange),
            yoffset: modeSampler === undefined ? getLowestNoteForYOffset() : 0,
            xruler: 20,
            markstart: -10,
            markend: -10,
            //cursoroffset={2500}  // make it dissapear
            yscroll: doesYScroll ? 1 : 0,
            //xscroll={true}
            accentColor: colorNotes || "#f22",
            colnotedissalowed: "#333",
            collt: "rgb(200, 200, 200)",
            coldk: "rgb(176, 176, 176)",
            colgrid: "#999",
            colrulerbg: "#4b4b4b",
            colrulerfg: "#fff",
            colrulerborder: "#4b4b4b",
            cursorsrc: (0, (/*@__PURE__*/$parcel$interopDefault($j9SQv))),
            kbwidth: modeSampler === undefined ? 65 : 0,
            kbstyle: modeSampler === undefined ? "piano" : "midi",
            yruler: modeSampler === undefined ? 20 : 22
        })
    });
};
const $0d79a52b309c755f$export$1c6ade03df0867cf = ({ instrument: instrument })=>{
    const colorCodeDescription = instrument.getParameterDescription("pianoRollColorCode");
    const colorCode = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("pianoRollColorCode"));
    const modes = {
        "melodic": {
            icon: (0, $dxGmH.default),
            widgetId: "pianoRollDiatonicColoring"
        },
        "harmonic": {
            icon: (0, $hSkWI.default)
        },
        "none": {
            icon: (0, $1OofT.default),
            widgetId: "pianoRollChromaticColoring"
        }
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "buttongroup",
        style: {
            display: "flex",
            "--border-radius": "4px"
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4DYyh.RadioGroup), {
            children: colorCodeDescription.options.map((option)=>{
                const Icon = modes[option].icon;
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton), {
                    "data-widget-id": modes[option].widgetId,
                    className: "btn w-30",
                    style: {
                        display: "grid",
                        placeContent: "center"
                    },
                    checked: colorCode == option,
                    onNewValue: (value)=>value && instrument.updateParametreInstrument("pianoRollColorCode", option),
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)(Icon, {})
                }, option);
            })
        })
    });
};

});
parcelRegister("dwPAA", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("j9SQv", function(module, exports) {
module.exports = $parcel$resolve("cgPKr");

});

parcelRegister("1OofT", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a713b02c9ec358$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $76a713b02c9ec358$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M8.35 2.69A10 10 0 0 1 21.3 15.65",
            key: "1pfsoa"
        }
    ],
    [
        "path",
        {
            d: "M19.08 19.08A10 10 0 1 1 4.92 4.92",
            key: "1ablyi"
        }
    ]
];
const $76a713b02c9ec358$export$2e2bcd8739ae039 = (0, $8KNb5.default)("circle-off", $76a713b02c9ec358$export$3efd853dbb351e94);

});

parcelRegister("dxGmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $87826e392c68c261$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $87826e392c68c261$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const $87826e392c68c261$export$2e2bcd8739ae039 = (0, $8KNb5.default)("ellipsis", $87826e392c68c261$export$3efd853dbb351e94);

});

parcelRegister("hSkWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d98b1b940e9c82$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $26d98b1b940e9c82$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const $26d98b1b940e9c82$export$2e2bcd8739ae039 = (0, $8KNb5.default)("grip-vertical", $26d98b1b940e9c82$export$3efd853dbb351e94);

});

parcelRegister("7s3ba", function(module, exports) {

$parcel$export(module.exports, "useObserve", () => $56cd9d3a76189de9$export$7bad575475eaafb1);

var $8NFma = parcelRequire("8NFma");
function $56cd9d3a76189de9$export$7bad575475eaafb1(ref, callback) {
    (0, $8NFma.useEffect)(()=>{
        if (ref.current == null) return;
        callback();
        const observer = new ResizeObserver(()=>callback());
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        ref.current
    ]);
}

});


parcelRegister("9FuEs", function(module, exports) {

$parcel$export(module.exports, "GrufModulADSR", () => $f4683fe14929552b$export$bc87bbf985f7abcb);
$parcel$export(module.exports, "GrufModulEQ", () => $f4683fe14929552b$export$4ab313267ef4a516);
$parcel$export(module.exports, "GrufModulSends", () => $f4683fe14929552b$export$54172bd61c417fb3);
$parcel$export(module.exports, "GrufModulDelay", () => $f4683fe14929552b$export$f66adc2fa5472177);
$parcel$export(module.exports, "GrufModulReverb", () => $f4683fe14929552b$export$3f335637860a3c73);

var $1IdZj = parcelRequire("1IdZj");

var $ho4zB = parcelRequire("ho4zB");

var $Uyv5t = parcelRequire("Uyv5t");

var $9veCd = parcelRequire("9veCd");

var $2dIO2 = parcelRequire("2dIO2");

var $hOWXx = parcelRequire("hOWXx");

var $8LfjP = parcelRequire("8LfjP");

var $kPXWT = parcelRequire("kPXWT");


var $3wfoi = parcelRequire("3wfoi");

var $29BVo = parcelRequire("29BVo");

var $8NFma = parcelRequire("8NFma");

var $5ICqB = parcelRequire("5ICqB");

var $1eLw3 = parcelRequire("1eLw3");

var $1zQag = parcelRequire("1zQag");
const $f4683fe14929552b$export$bc87bbf985f7abcb = ({ className: className, instrument: instrument, soundNumber: soundNumber = "", style: style, availableParameters: availableParameters = [
    "env_attack",
    "env_decay",
    "env_sustain",
    "env_release"
], colorizeLabel: colorizeLabel = false })=>{
    const knobs = availableParameters.map((parameter)=>{
        const parameterName = parameter + soundNumber;
        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
            "data-widget-id": `adsr${(0, $hOWXx.capitalize)(parameter.replace("env_", ""))}`,
            mida: "petit",
            parameterHandler: instrument.getParameterHandler(parameterName),
            colorizeLabel: colorizeLabel
        }, parameter);
    });
    const attackParamName = `env_attack${soundNumber}`;
    const decayParamName = `env_decay${soundNumber}`;
    const sustainParamName = `env_sustain${soundNumber}`;
    const releaseParamName = `env_release${soundNumber}`;
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        "data-widget-id": "adsr",
        className: `gruf-adsr-widget ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                text: (0, $1zQag.getWidgetData)("adsr").label.ca,
                style: {
                    margin: "10px 0 0 10px"
                }
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2dIO2.ADSRGraph), {
                instrument: instrument,
                dynamicHighlight: false,
                adsrParameterNames: [
                    attackParamName,
                    decayParamName,
                    sustainParamName,
                    releaseParamName
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "adsr-knobs",
                children: knobs
            })
        ]
    });
};
const $f4683fe14929552b$export$4ab313267ef4a516 = ({ className: className, instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        "data-widget-id": "equalizer",
        className: `gruf-modul gruf-modul-eq ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                text: (0, $1zQag.getWidgetData)("equalizer").label.ca
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9veCd.ParameterToggle), {
                "data-widget-id": "eqToggle",
                className: "justify-self-end",
                parameterHandler: instrument.getParameterHandler("fx_EQ_isActive"),
                noLabel: true
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "eqLow",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("fx_EQ_low")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "eqMid",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("fx_EQ_mid")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "eqHigh",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("fx_EQ_high")
                    })
                ]
            })
        ]
    });
};
const $f4683fe14929552b$export$54172bd61c417fb3 = ({ instrument: instrument, className: className, style: style })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        "data-widget-id": "sends",
        className: `gruf-modul gruf-modul-sends ${className}`,
        style: style,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                text: (0, $1zQag.getWidgetData)("sends").label.ca
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "sends-controls",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "sendReverbA",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("send_reverbA"),
                        label: "Reverb A"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "sendReverbB",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("send_reverbB"),
                        label: "Reverb B"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "row-span-full h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "sendDelayA",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("send_delayA"),
                        label: "Delay A"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "sendDelayB",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("send_delayB"),
                        label: "Delay B"
                    })
                ]
            })
        ]
    });
};
const $f4683fe14929552b$export$f66adc2fa5472177 = ({ name: name, className: className, returnName: returnName })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        className: `gruf-modul gruf-modul-delay ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                text: name
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                mida: "petit",
                parameterHandler: (0, $8NFma.useMemo)(()=>new (0, $3wfoi.ParameterHandler)((0, $29BVo.DelayReturn).parametersDescription.feedback, (0, $5ICqB.createReturnParameterSelector)(returnName, "feedback"), (value)=>(0, $5ICqB.setReturnParameter)({
                            returnName: returnName,
                            parameter: "feedback",
                            value: value
                        })), [
                    returnName
                ])
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                className: "gruf-label-petit",
                style: {
                    display: "contents"
                },
                children: [
                    "Durada",
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kPXWT.Enum2Columns), {
                        parameterHandler: (0, $8NFma.useMemo)(()=>new (0, $3wfoi.ParameterHandler)((0, $29BVo.DelayReturn).parametersDescription.time, (0, $5ICqB.createReturnParameterSelector)(returnName, "time"), (value)=>(0, $5ICqB.setReturnParameter)({
                                    returnName: returnName,
                                    parameter: "time",
                                    value: value
                                })), [
                            returnName
                        ])
                    })
                ]
            })
        ]
    });
};
const $f4683fe14929552b$export$3f335637860a3c73 = ({ name: name, className: className, returnName: returnName, style: style = {} })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        className: `gruf-modul gruf-modul-reverb ${className}`,
        style: style,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ho4zB.Legend), {
                text: name
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $Uyv5t.GrufReverbDecay), {
                returnName: returnName
            })
        ]
    });
};

});
parcelRegister("ho4zB", function(module, exports) {

$parcel$export(module.exports, "Legend", () => $5c4dff50af470111$export$ed247974535929c7);

var $1IdZj = parcelRequire("1IdZj");
const $5c4dff50af470111$export$ed247974535929c7 = ({ text: text, style: style = {} })=>{
    // we actually style the span element inside the legend element :)
    return /*#__PURE__*/ (0, $1IdZj.jsx)("legend", {
        style: {
            display: 'contents'
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            style: style,
            className: "gruf-legend",
            children: text
        })
    });
};

});

parcelRegister("Uyv5t", function(module, exports) {

$parcel$export(module.exports, "GrufReverbDecay", () => $39eba44459cc29a4$export$75a3e8ffac984804);

var $1IdZj = parcelRequire("1IdZj");

var $4DYyh = parcelRequire("4DYyh");

var $lClb7 = parcelRequire("lClb7");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");
const $39eba44459cc29a4$export$75a3e8ffac984804 = ({ returnName: returnName })=>{
    const parameterName = "decay";
    const parameterValue = (0, $7Kpeg.useSelector)((0, $5ICqB.createReturnParameterSelector)(returnName, parameterName));
    const dispatch = (0, $7Kpeg.useDispatch)();
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "gruf-reverb-time",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $4DYyh.RadioGroup), {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Curta"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton // todo: curta, etc. són labels!
                ), {
                    style: {
                        width: "20%"
                    },
                    checked: parameterValue == 1.0,
                    onNewValue: (value)=>value && dispatch((0, $5ICqB.setReturnParameter)({
                            returnName: returnName,
                            parameter: parameterName,
                            value: '1.0'
                        }))
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Mitja"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton), {
                    style: {
                        width: "50%"
                    },
                    checked: parameterValue == 5.0,
                    onNewValue: (value)=>value && dispatch((0, $5ICqB.setReturnParameter)({
                            returnName: returnName,
                            parameter: parameterName,
                            value: '5.0'
                        }))
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Llarga"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton), {
                    style: {
                        width: "100%"
                    },
                    checked: parameterValue == 12.0,
                    onNewValue: (value)=>value && dispatch((0, $5ICqB.setReturnParameter)({
                            returnName: returnName,
                            parameter: parameterName,
                            value: '12.0'
                        }))
                })
            ]
        })
    });
};

});

parcelRegister("9veCd", function(module, exports) {

$parcel$export(module.exports, "ParameterToggle", () => $7dd8ad94882dfb65$export$2fcb27302f1aa415);

var $1IdZj = parcelRequire("1IdZj");

var $igO6t = parcelRequire("igO6t");

var $7Kpeg = parcelRequire("7Kpeg");
const $7dd8ad94882dfb65$export$2fcb27302f1aa415 = ({ parameterHandler: parameterHandler, label: label, labelSize: labelSize, valueToBool: valueToBool, boolToValue: boolToValue, noLabel: noLabel = false, colorizeLabel: colorizeLabel, className: className = "", ...props })=>{
    const dispatch = (0, $7Kpeg.useDispatch)();
    const parameterValue = (0, $7Kpeg.useSelector)(parameterHandler.selector);
    const onNewValue = (value)=>dispatch(parameterHandler.updater(boolToValue ? boolToValue(value) : value));
    if (!label && parameterHandler.description.label) label = parameterHandler.description.label;
    if (noLabel) label = undefined;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $igO6t.Toggle), {
        ...props,
        checked: valueToBool ? valueToBool(parameterValue) : parameterValue,
        className: className,
        onNewValue: onNewValue,
        label: label,
        labelSize: labelSize,
        colorizeLabel: colorizeLabel
    });
};

});
parcelRegister("igO6t", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $d87503c146802487$export$bea8ebba691c5813);

var $1IdZj = parcelRequire("1IdZj");

var $ao8RU = parcelRequire("ao8RU");

var $8NFma = parcelRequire("8NFma");

var $1zQag = parcelRequire("1zQag");
const $d87503c146802487$export$bea8ebba691c5813 = ({ className: className = "", width: width, checked: checked, onNewValue: onNewValue, label: label, labelSize: labelSize, colorizeLabel: colorizeLabel, ...props })=>{
    const toggleId = (0, $8NFma.useId)();
    const widgetData = (0, $1zQag.getWidgetData)(props['data-widget-id']);
    if (widgetData) label ??= widgetData.label?.ca;
    if (label) return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        ...props,
        className: "toggle-wrapper",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ao8RU.Checkbox), {
                id: toggleId,
                className: `${className} toggle`,
                checked: checked,
                onNewValue: onNewValue,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "toggle-indicator"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                className: colorizeLabel ? "text-accent" : "",
                htmlFor: toggleId,
                style: labelSize ? {
                    fontSize: labelSize
                } : undefined,
                children: label
            })
        ]
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ao8RU.Checkbox), {
        ...props,
        className: `${className} toggle`,
        checked: checked,
        onNewValue: onNewValue,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "toggle-indicator"
        })
    });
};

});
parcelRegister("ao8RU", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $15fa2c8c21752d4e$export$48513f6b9f8ce62d);

var $1IdZj = parcelRequire("1IdZj");
const $15fa2c8c21752d4e$export$48513f6b9f8ce62d = ({ className: className = "", checked: checked, onNewValue: onNewValue, children: children, ...props })=>{
    // make checkbox click in enter (by default only changes with space and that is taken for audio play/stop)
    function handleKeyDown(e) {
        if (e.key !== "Enter") return;
        onNewValue(!checked);
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
        className: `${className} checkbox ${checked ? "active" : ""}`,
        ...props,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: (e)=>onNewValue(e.target.checked, e),
                onKeyDown: handleKeyDown
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                children: children
            })
        ]
    });
};

});



parcelRegister("2dIO2", function(module, exports) {

$parcel$export(module.exports, "ADSRGraph", () => $d66324b950075890$export$3350c105bcb97de8);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $kmdF6 = parcelRequire("kmdF6");

var $7Kpeg = parcelRequire("7Kpeg");
const $d66324b950075890$export$3350c105bcb97de8 = ({ instrument: instrument, adsrParameterNames: adsrParameterNames, dynamicHighlight: dynamicHighlight })=>{
    (0, $8NFma.useEffect)(()=>{
        if (dynamicHighlight) {
            document.addEventListener("midiNote-" + instrument.id, onMidiNote);
            ()=>document.removeEventListener("midiNote-" + instrument.id, onMidiNote);
        }
    }, []);
    const lastNoteInfoRef = (0, $8NFma.useRef)({});
    const onMidiNote = (evt)=>{
        const { a: a, d: d, r: r } = adsrRef.current;
        let lastNoteInfo = lastNoteInfoRef.current;
        const { type: type, pitch: pitch } = evt.detail;
        if (type === "noteOff") {
            if (pitch !== lastNoteInfo.pitch && !instrument.isMono) return;
            lastNoteInfo = {
                stage: 'release',
                duration: r * 1000
            };
        } else lastNoteInfo = {
            stage: 'pre-sustain',
            duration: (a + d) * 1000,
            pitch: pitch
        };
        lastNoteInfo = {
            ...lastNoteInfo,
            initTime: Date.now()
        };
        lastNoteInfoRef.current = lastNoteInfo;
        checkLastNoteStatus();
    };
    const [lastNoteStatus, setLastNoteStatus] = (0, $8NFma.useState)({
        stage: 'finished',
        progress: '1'
    });
    const checkLastNoteStatus = ()=>{
        const lastNoteInfo = lastNoteInfoRef.current;
        const elapsedTime = Date.now() - lastNoteInfo.initTime;
        const progress = Math.min(lastNoteInfo.duration === 0 ? 1 : elapsedTime / lastNoteInfo.duration, 1);
        let stage = lastNoteInfo.stage;
        if (progress === 1) {
            if (stage === 'pre-sustain') stage = 'sustain';
            if (stage === 'release') stage = 'finished';
        }
        setLastNoteStatus({
            progress: progress,
            stage: stage
        });
        if (progress < 1) setTimeout(checkLastNoteStatus, 30);
    };
    const a = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector(adsrParameterNames[0]));
    const d = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector(adsrParameterNames[1]));
    const s = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector(adsrParameterNames[2]));
    const r = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector(adsrParameterNames[3]));
    const adsrRef = (0, $8NFma.useRef)({});
    adsrRef.current = {
        a: a,
        d: d,
        s: s,
        r: r
    };
    const strokeWidthPx = 3;
    const timeValues = [
        a,
        d,
        r
    ];
    const maxTime = 9; // knowing that the sum of the max values for attack, decay and release is 9. maybe it could get it automatically?
    const sustainTime = maxTime - timeValues.reduce((sum, element)=>sum + element);
    const timeValuesWithSustain = [
        a,
        d,
        sustainTime,
        r
    ];
    const absoluteTimeValues = (0, $kmdF6.distanceToAbsolute)(timeValuesWithSustain);
    const gainValues = [
        0,
        1,
        s,
        s,
        0
    ];
    const adsrPoints = absoluteTimeValues.map((absTimeValue, index)=>{
        const normTimeValue = absTimeValue / maxTime;
        const gainValue = gainValues[index];
        return {
            x: normTimeValue * (100 - strokeWidthPx / 2) + strokeWidthPx / 4,
            y: 75 - gainValue * 50
        }; // we account for stroke width so that the line isn't clipped
    });
    const sustainPoints = [
        adsrPoints[2],
        adsrPoints[3]
    ];
    const adsrPathString = adsrPoints.reduce((pathString, point)=>{
        return pathString + ` L ${point.x} ${point.y}`;
    }, `M ${strokeWidthPx / 4} 75`);
    const gridSize = 4;
    let bgLineItems = [];
    for(let i = 1; i < gridSize; i++){
        const crossAxisPos = i / gridSize * 100;
        const hLine = /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
            x1: "0",
            x2: "100",
            y1: crossAxisPos,
            y2: crossAxisPos,
            vectorEffect: "non-scaling-stroke"
        }, `bgHLine-${i}`);
        const vLine = /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
            x1: crossAxisPos,
            x2: crossAxisPos,
            y1: "100",
            y2: "0",
            vectorEffect: "non-scaling-stroke"
        }, `bgVLine-${i}`);
        bgLineItems.push(hLine, vLine);
    }
    const getEnvStatusLine = ()=>{
        const { stage: stage, progress: progress } = lastNoteStatus;
        if (stage === 'finished') return undefined;
        let endPoints = [
            {},
            {}
        ];
        stage;
        endPoints = [
            adsrPoints[0],
            sustainPoints[0]
        ];
        if (stage === 'release') endPoints = [
            sustainPoints[1],
            adsrPoints[adsrPoints.length - 1]
        ];
        const x = (0, $kmdF6.lerp)(endPoints[0].x, endPoints[1].x, progress);
        const lastPoint = adsrPoints.reduce((result, current)=>current.x >= x || current.x < result.x ? result : current);
        const nextPoint = adsrPoints[adsrPoints.indexOf(lastPoint) + 1];
        const segmentDuration = nextPoint.x - lastPoint.x;
        const segmentProgress = segmentDuration === 0 ? 1 : (x - lastPoint.x) / segmentDuration;
        const y = (0, $kmdF6.lerp)(lastPoint.y, nextPoint.y, segmentProgress);
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                    x: x - 20,
                    y: "25",
                    width: "20",
                    height: "50",
                    vectorEffect: "non-scaling-stroke",
                    fill: "url(#grad)",
                    mask: "url(#adsr-mask)"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("circle", {
                    cx: x,
                    cy: y,
                    r: "0.9",
                    fill: "var(--accent-color)"
                })
            ]
        });
    };
    const envStatusLine = getEnvStatusLine();
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "adsr-graph",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("svg", {
            viewBox: "0 0 100 100",
            preserveAspectRatio: "none",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("g", {
                    stroke: "#555",
                    strokeDasharray: "1 4",
                    strokeLinecap: "round",
                    children: bgLineItems
                }),
                /*#__PURE__*/ (0, $1IdZj.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("mask", {
                            id: "sustain-mask",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                                    x: "0",
                                    y: "0",
                                    width: "100",
                                    height: "100",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("g", {
                                    fill: "black",
                                    stroke: "black",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
                                            x1: sustainPoints[0].x,
                                            x2: sustainPoints[1].x,
                                            y1: sustainPoints[0].y,
                                            y2: sustainPoints[1].y,
                                            vectorEffect: "non-scaling-stroke",
                                            strokeWidth: strokeWidthPx,
                                            strokeLinecap: "round"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("g", {
                                            fill: "white",
                                            stroke: "white",
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
                                                x1: sustainPoints[0].x,
                                                x2: sustainPoints[1].x,
                                                y1: sustainPoints[0].y,
                                                y2: sustainPoints[1].y,
                                                vectorEffect: "non-scaling-stroke",
                                                strokeWidth: strokeWidthPx,
                                                strokeLinecap: "round",
                                                strokeDasharray: "8"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("mask", {
                            id: "adsr-mask",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                                d: adsrPathString + " Z",
                                fill: "white",
                                stroke: "white",
                                strokeWidth: strokeWidthPx,
                                vectorEffect: "non-scaling-stroke",
                                strokeLinejoin: "round"
                            })
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("linearGradient", {
                            id: "grad",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("stop", {
                                    offset: "0%",
                                    stopColor: "transparent"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("stop", {
                                    offset: "80%",
                                    stopColor: "color-mix(in srgb, var(--accent-color) 10%, transparent)"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("stop", {
                                    offset: "90%",
                                    stopColor: "color-mix(in srgb, var(--accent-color) 30%, transparent)"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("stop", {
                                    offset: "100%",
                                    stopColor: "var(--accent-color)"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("g", {
                    fill: "color-mix(in srgb, var(--accent-color) 10%, transparent)",
                    stroke: "var(--accent-color)",
                    strokeWidth: strokeWidthPx,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                        d: adsrPathString,
                        vectorEffect: "non-scaling-stroke",
                        mask: "url(#sustain-mask)",
                        stroke: "color-mix(in srgb, var(--accent-color) 90%, transparent)"
                    })
                }),
                envStatusLine && envStatusLine
            ]
        })
    });
};

});

parcelRegister("8LfjP", function(module, exports) {

$parcel$export(module.exports, "ParameterKnob", () => $22c407441b82cc90$export$81e831935274c318);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $9xysn = parcelRequire("9xysn");

var $hgsXJ = parcelRequire("hgsXJ");

var $9Rnnc = parcelRequire("9Rnnc");

var $7Kpeg = parcelRequire("7Kpeg");

var $7Hv6G = parcelRequire("7Hv6G");

var $edOXz = parcelRequire("edOXz");

var $kmdF6 = parcelRequire("kmdF6");

var $1zQag = parcelRequire("1zQag");
const $22c407441b82cc90$var$ANGLE_MIN = -145;
const $22c407441b82cc90$var$ANGLE_MAX = 145;
const $22c407441b82cc90$var$MAX_MARKS = 17;
const $22c407441b82cc90$export$81e831935274c318 = ({ parameterHandler: parameterHandler, sideEffect: sideEffect, label: label, mida: mida, colorizeLabel: colorizeLabel = false, markLabelRed: markLabelRed = false, noOutput: noOutput = false, knobSize: knobSize, ...props })=>{
    const widgetData = (0, $1zQag.getWidgetData)(props['data-widget-id']);
    if (widgetData) label ??= widgetData.label?.ca;
    const [discreteOffset, setDiscreteOffset] = (0, $8NFma.useState)(0); // for when there are discrete options (parameterHandler.description.type === 'enum')
    const realValue = (0, $7Kpeg.useSelector)(parameterHandler.selector);
    const { num2Norm: num2Norm, norm2Num: norm2Num, real2Num: real2Num, num2Real: num2Real, real2String: real2String, getNumericMin: getNumericMin, getNumericMax: getNumericMax, getCardinality: getCardinality } = parameterHandler;
    const normValue = num2Norm(real2Num(realValue)); // without discreteOffset for snapping when there are discrete options
    const angle = normValue * ($22c407441b82cc90$var$ANGLE_MAX - $22c407441b82cc90$var$ANGLE_MIN) + $22c407441b82cc90$var$ANGLE_MIN;
    const numValue = real2Num(realValue) + discreteOffset;
    const dispatch = (0, $7Kpeg.useDispatch)();
    const markQ = Math.min(getCardinality(), $22c407441b82cc90$var$MAX_MARKS);
    const marks = /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        viewBox: "-50 -50 100 100",
        className: "absolute",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("g", {
            stroke: "currentColor",
            strokeWidth: "1",
            vectorEffect: "non-scaling-stroke",
            children: Array(markQ).fill().map((_, i)=>{
                const angle = (0, $kmdF6.lerp)($22c407441b82cc90$var$ANGLE_MIN, $22c407441b82cc90$var$ANGLE_MAX, i / (markQ - 1));
                const { x: x1, y: y1 } = (0, $kmdF6.polToCar)({
                    r: 47.5,
                    a: (0, $kmdF6.degToRad)(angle - 90)
                });
                const { x: x2, y: y2 } = (0, $kmdF6.polToCar)({
                    r: 42,
                    a: (0, $kmdF6.degToRad)(angle - 90)
                });
                return /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
                    x1: x1,
                    x2: x2,
                    y1: y1,
                    y2: y2
                });
            })
        })
    });
    const updateParameterThrottledFunction = (0, $8NFma.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9Rnnc)))((newValue, parameterHandler, format)=>{
        // We need to pass updateParameter together with newNumValue because there are cases in which the same knob changes the parametre that it controls at render time (basically in the samppler with the pad-dependant controls)
        if (format === "num") {
            const numValue = newValue;
            newValue = num2Real(numValue);
            format = "real";
            setDiscreteOffset(numValue - real2Num(newValue));
        }
        if (format !== "real") throw new Error("Format should be 'real' by now");
        dispatch(parameterHandler.updater(newValue));
        sideEffect && sideEffect();
    }, (0, $9xysn.getCurrentProject)().continuousControlThrottleTime));
    let labelClass = "";
    if (colorizeLabel) labelClass = "text-accent";
    if (markLabelRed) labelClass = "text-red";
    const { setRef: setRef, focus: focus } = (0, $edOXz.useFocus)();
    const knobctrlId = (0, $8NFma.useId)();
    const { onKeyDown: onKeyDown } = (0, $hgsXJ.useKnobKeyboardControls)({
        valueRaw: normValue,
        valueMin: 0,
        valueMax: 1,
        step: 0.01,
        stepLarger: 0.1,
        onValueRawChange: (newNormValue)=>updateParameterThrottledFunction.current(norm2Num(newNormValue), parameterHandler)
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7Hv6G.FloatingValue), {
        isVisible: focus && !noOutput,
        value: real2String(realValue),
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: `knob knob-${mida}`,
            ...props,
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "knobctrl-wrapper",
                    style: {
                        width: knobSize,
                        height: knobSize
                    },
                    children: [
                        marks,
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hgsXJ.KnobHeadless), {
                            ref: setRef,
                            id: knobctrlId,
                            className: "knobctrl",
                            style: {
                                rotate: `${angle}deg`
                            },
                            includeIntoTabOrder: true,
                            onKeyDown: onKeyDown,
                            valueRaw: numValue,
                            valueMin: getNumericMin(),
                            valueMax: getNumericMax(),
                            mapTo01: (x)=>num2Norm(x),
                            mapFrom01: (x)=>norm2Num(x),
                            onValueRawChange: (newNumValue)=>{
                                updateParameterThrottledFunction.current(newNumValue, parameterHandler, "num");
                            },
                            valueRawRoundFn: (value)=>value.toFixed(2),
                            valueRawDisplayFn: (numValue)=>real2String(num2Real(numValue)),
                            dragSensitivity: "0.009",
                            axis: "xy",
                            onDoubleClick: ()=>updateParameterThrottledFunction.current(parameterHandler.getDefaultValue(), parameterHandler, "real")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                    htmlFor: knobctrlId,
                    className: labelClass,
                    children: label || parameterHandler.description.label
                })
            ]
        })
    });
};

});
parcelRegister("hgsXJ", function(module, exports) {

$parcel$export(module.exports, "KnobHeadless", () => $799f54ef2f8975e2$export$4d31429a95b3f2af);
$parcel$export(module.exports, "useKnobKeyboardControls", () => $799f54ef2f8975e2$export$afe864d4ea8427b2);

var $8NFma = parcelRequire("8NFma");

var $c87Yd = parcelRequire("c87Yd");

var $1MjSC = parcelRequire("1MjSC");

var $9jTEz = parcelRequire("9jTEz");

var $1IdZj = parcelRequire("1IdZj");
var $799f54ef2f8975e2$var$C = Object.defineProperty;
var $799f54ef2f8975e2$var$p = Object.getOwnPropertySymbols;
var $799f54ef2f8975e2$var$P = Object.prototype.hasOwnProperty, $799f54ef2f8975e2$var$H = Object.prototype.propertyIsEnumerable;
var $799f54ef2f8975e2$var$x = (e, r, o)=>r in e ? $799f54ef2f8975e2$var$C(e, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : e[r] = o, $799f54ef2f8975e2$var$s = (e, r)=>{
    for(var o in r || (r = {}))$799f54ef2f8975e2$var$P.call(r, o) && $799f54ef2f8975e2$var$x(e, o, r[o]);
    if ($799f54ef2f8975e2$var$p) for (var o of $799f54ef2f8975e2$var$p(r))$799f54ef2f8975e2$var$H.call(r, o) && $799f54ef2f8975e2$var$x(e, o, r[o]);
    return e;
};
var $799f54ef2f8975e2$var$v = (e, r)=>{
    var o = {};
    for(var n in e)$799f54ef2f8975e2$var$P.call(e, n) && r.indexOf(n) < 0 && (o[n] = e[n]);
    if (e != null && $799f54ef2f8975e2$var$p) for (var n of $799f54ef2f8975e2$var$p(e))r.indexOf(n) < 0 && $799f54ef2f8975e2$var$H.call(e, n) && (o[n] = e[n]);
    return o;
};
var $799f54ef2f8975e2$var$w = "y", $799f54ef2f8975e2$var$L = !1, $799f54ef2f8975e2$var$D = (0, $9jTEz.mapTo01Linear), $799f54ef2f8975e2$var$T = (0, $9jTEz.mapFrom01Linear), $799f54ef2f8975e2$export$4d31429a95b3f2af = (0, $8NFma.forwardRef)((M, A)=>{
    var K = M, { valueRaw: e, valueMin: r, valueMax: o, dragSensitivity: n, valueRawRoundFn: i, valueRawDisplayFn: t, onValueRawChange: l, orientation: u, axis: a = $799f54ef2f8975e2$var$w, includeIntoTabOrder: y = $799f54ef2f8975e2$var$L, mapTo01: N = $799f54ef2f8975e2$var$D, mapFrom01: R = $799f54ef2f8975e2$var$T } = K, g = $799f54ef2f8975e2$var$v(K, [
        "valueRaw",
        "valueMin",
        "valueMax",
        "dragSensitivity",
        "valueRawRoundFn",
        "valueRawDisplayFn",
        "onValueRawChange",
        "orientation",
        "axis",
        "includeIntoTabOrder",
        "mapTo01",
        "mapFrom01"
    ]);
    let k = i(e), F = (0, $c87Yd.useDrag)(({ delta: b })=>{
        let c = 0;
        c += b[0] * n, c += b[1] * -n;
        let h = N(e, r, o), z = (0, $9jTEz.clamp01)(h + c), I = (0, $9jTEz.clamp)(R(z, r, o), r, o);
        l(I);
    }, {
        pointer: {
            keys: !1
        },
        axis: $799f54ef2f8975e2$var$S(u, a)
    });
    return (0, $1IdZj.jsx)("div", $799f54ef2f8975e2$var$s({
        ref: A,
        role: "slider",
        "aria-valuenow": k,
        "aria-valuemin": r,
        "aria-valuemax": o,
        "aria-orientation": $799f54ef2f8975e2$var$W(u, a),
        "aria-valuetext": t(e),
        tabIndex: y ? 0 : -1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1MjSC)))(F(), {
        style: {
            touchAction: "none"
        },
        onPointerDown (b) {
            b.currentTarget.focus();
        }
    }, g)));
});
$799f54ef2f8975e2$export$4d31429a95b3f2af.displayName = "KnobHeadless";
$799f54ef2f8975e2$export$4d31429a95b3f2af.defaultProps = {
    axis: $799f54ef2f8975e2$var$w,
    includeIntoTabOrder: $799f54ef2f8975e2$var$L,
    mapTo01: $799f54ef2f8975e2$var$D,
    mapFrom01: $799f54ef2f8975e2$var$T
};
var $799f54ef2f8975e2$var$S = (e, r)=>e ? e === "horizontal" ? "x" : "y" : r === "xy" ? void 0 : r, $799f54ef2f8975e2$var$W = (e, r)=>{
    if (e) return e;
    if (r !== "xy") return r === "x" ? "horizontal" : "vertical";
};
var $799f54ef2f8975e2$export$f757151c47e738c7 = (0, $8NFma.forwardRef)((e, r)=>(0, $1IdZj.jsx)("label", $799f54ef2f8975e2$var$s({
        ref: r
    }, e)));
$799f54ef2f8975e2$export$f757151c47e738c7.displayName = "KnobHeadlessLabel";
var $799f54ef2f8975e2$export$f32ecd445c198174 = (0, $8NFma.forwardRef)((e, r)=>(0, $1IdZj.jsx)("output", $799f54ef2f8975e2$var$s({
        ref: r
    }, e)));
$799f54ef2f8975e2$export$f32ecd445c198174.displayName = "KnobHeadlessOutput";
var $799f54ef2f8975e2$export$afe864d4ea8427b2 = ({ valueRaw: e, valueMin: r, valueMax: o, step: n, stepLarger: i, onValueRawChange: t, noDefaultPrevention: l = !1 })=>({
        onKeyDown: (a)=>{
            let { code: y } = a;
            switch(y){
                case "ArrowUp":
                case "ArrowRight":
                    t((0, $9jTEz.clamp)(e + n, r, o), a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
                case "ArrowDown":
                case "ArrowLeft":
                    t((0, $9jTEz.clamp)(e - n, r, o), a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
                case "PageUp":
                    t((0, $9jTEz.clamp)(e + i, r, o), a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
                case "PageDown":
                    t((0, $9jTEz.clamp)(e - i, r, o), a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
                case "Home":
                    t(r, a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
                case "End":
                    t(o, a), $799f54ef2f8975e2$var$d({
                        event: a,
                        noDefaultPrevention: l
                    });
                    break;
            }
        }
    }), $799f54ef2f8975e2$var$d = ({ event: e, noDefaultPrevention: r })=>{
    r || e.preventDefault();
};
 //# sourceMappingURL=out.js.map

});
parcelRegister("c87Yd", function(module, exports) {

$parcel$export(module.exports, "useDrag", () => $8d4c6a21f0317400$export$7941f8aafa4b6021);
parcelRequire("hGuhl");
var $42dur = parcelRequire("42dur");

var $8NFma = parcelRequire("8NFma");

var $ct9XI = parcelRequire("ct9XI");
parcelRequire("ffM9D");

var $4RwTX = parcelRequire("4RwTX");
function $8d4c6a21f0317400$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useMemo(()=>new (0, $ct9XI.Controller)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $8d4c6a21f0317400$export$7941f8aafa4b6021(handler, config) {
    (0, $42dur.r)((0, $42dur.e));
    return $8d4c6a21f0317400$var$useRecognizers({
        drag: handler
    }, config || {}, 'drag');
}
function $8d4c6a21f0317400$export$ccc26886ea7dba8f(handler, config) {
    (0, $42dur.r)((0, $42dur.f));
    return $8d4c6a21f0317400$var$useRecognizers({
        pinch: handler
    }, config || {}, 'pinch');
}
function $8d4c6a21f0317400$export$43260e1b277d5f62(handler, config) {
    (0, $42dur.r)((0, $42dur.w));
    return $8d4c6a21f0317400$var$useRecognizers({
        wheel: handler
    }, config || {}, 'wheel');
}
function $8d4c6a21f0317400$export$d928051c8cd740b(handler, config) {
    (0, $42dur.r)((0, $42dur.s));
    return $8d4c6a21f0317400$var$useRecognizers({
        scroll: handler
    }, config || {}, 'scroll');
}
function $8d4c6a21f0317400$export$36da96379f79f245(handler, config) {
    (0, $42dur.r)((0, $42dur.m));
    return $8d4c6a21f0317400$var$useRecognizers({
        move: handler
    }, config || {}, 'move');
}
function $8d4c6a21f0317400$export$ae780daf29e6d456(handler, config) {
    (0, $42dur.r)((0, $42dur.h));
    return $8d4c6a21f0317400$var$useRecognizers({
        hover: handler
    }, config || {}, 'hover');
}
function $8d4c6a21f0317400$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $42dur.r));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $ct9XI.parseMergedHandlers)(_handlers, _config || {});
        return $8d4c6a21f0317400$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $8d4c6a21f0317400$export$ece84446a783717(handlers, config) {
    const hook = $8d4c6a21f0317400$export$ee99e1f7df2b9180([
        (0, $42dur.e),
        (0, $42dur.f),
        (0, $42dur.s),
        (0, $42dur.w),
        (0, $42dur.m),
        (0, $42dur.h)
    ]);
    return hook(handlers, config || {});
}
$parcel$exportWildcard(module.exports, $4RwTX);

});
parcelRegister("hGuhl", function(module, exports) {

$parcel$export(module.exports, "dragAction", () => (parcelRequire("42dur")).e);
$parcel$export(module.exports, "hoverAction", () => (parcelRequire("42dur")).h);
$parcel$export(module.exports, "moveAction", () => (parcelRequire("42dur")).m);
$parcel$export(module.exports, "pinchAction", () => (parcelRequire("42dur")).f);
$parcel$export(module.exports, "registerAction", () => (parcelRequire("42dur")).r);
$parcel$export(module.exports, "scrollAction", () => (parcelRequire("42dur")).s);
$parcel$export(module.exports, "wheelAction", () => (parcelRequire("42dur")).w);

var $42dur = parcelRequire("42dur");


});
parcelRegister("42dur", function(module, exports) {

$parcel$export(module.exports, "a", () => $2f01d0261bce3adb$export$407448d2b89b1813);
$parcel$export(module.exports, "_", () => $2f01d0261bce3adb$export$71511d61b312f219);
$parcel$export(module.exports, "d", () => $2f01d0261bce3adb$export$4368d992c4eafac0);
$parcel$export(module.exports, "p", () => $2f01d0261bce3adb$export$ffb5f4729a158638);
$parcel$export(module.exports, "t", () => $2f01d0261bce3adb$export$625550452a3fa3ec);
$parcel$export(module.exports, "i", () => $2f01d0261bce3adb$export$23f2a1d2818174ef);
$parcel$export(module.exports, "b", () => $2f01d0261bce3adb$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "c", () => $2f01d0261bce3adb$export$db3b6bfb95261072);
$parcel$export(module.exports, "S", () => $2f01d0261bce3adb$export$25ce5a424b770e84);
$parcel$export(module.exports, "E", () => $2f01d0261bce3adb$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "C", () => $2f01d0261bce3adb$export$e7094788287c5e9b);
$parcel$export(module.exports, "r", () => $2f01d0261bce3adb$export$43caf9889c228507);
$parcel$export(module.exports, "e", () => $2f01d0261bce3adb$export$f1e1789686576879);
$parcel$export(module.exports, "h", () => $2f01d0261bce3adb$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "m", () => $2f01d0261bce3adb$export$953cecd6e717a553);
$parcel$export(module.exports, "f", () => $2f01d0261bce3adb$export$2d1720544b23b823);
$parcel$export(module.exports, "s", () => $2f01d0261bce3adb$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "w", () => $2f01d0261bce3adb$export$efccba1c4a2ef57b);

var $369CE = parcelRequire("369CE");
function $2f01d0261bce3adb$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2f01d0261bce3adb$var$_toPropertyKey(arg) {
    var key = $2f01d0261bce3adb$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2f01d0261bce3adb$export$407448d2b89b1813(obj, key, value) {
    key = $2f01d0261bce3adb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2f01d0261bce3adb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f01d0261bce3adb$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f01d0261bce3adb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f01d0261bce3adb$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f01d0261bce3adb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2f01d0261bce3adb$var$EVENT_TYPE_MAP = {
    pointer: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    mouse: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    touch: {
        start: 'start',
        change: 'move',
        end: 'end'
    },
    gesture: {
        start: 'start',
        change: 'change',
        end: 'end'
    }
};
function $2f01d0261bce3adb$var$capitalize(string) {
    if (!string) return '';
    return string[0].toUpperCase() + string.slice(1);
}
const $2f01d0261bce3adb$var$actionsWithoutCaptureSupported = [
    'enter',
    'leave'
];
function $2f01d0261bce3adb$var$hasCapture(capture = false, actionKey) {
    return capture && !$2f01d0261bce3adb$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $2f01d0261bce3adb$export$4368d992c4eafac0(device, action = '', capture = false) {
    const deviceProps = $2f01d0261bce3adb$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return 'on' + $2f01d0261bce3adb$var$capitalize(device) + $2f01d0261bce3adb$var$capitalize(actionKey) + ($2f01d0261bce3adb$var$hasCapture(capture, actionKey) ? 'Capture' : '');
}
const $2f01d0261bce3adb$var$pointerCaptureEvents = [
    'gotpointercapture',
    'lostpointercapture'
];
function $2f01d0261bce3adb$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf('passive');
    if (passive) eventKey = eventKey.replace('passive', '');
    const captureKey = $2f01d0261bce3adb$var$pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace('capture', '');
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $2f01d0261bce3adb$export$625550452a3fa3ec(device, action = '') {
    const deviceProps = $2f01d0261bce3adb$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $2f01d0261bce3adb$export$23f2a1d2818174ef(event) {
    return 'touches' in event;
}
function $2f01d0261bce3adb$var$getPointerType(event) {
    if ($2f01d0261bce3adb$export$23f2a1d2818174ef(event)) return 'touch';
    if ('pointerType' in event) return event.pointerType;
    return 'mouse';
}
function $2f01d0261bce3adb$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $2f01d0261bce3adb$var$getTouchList(event) {
    return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function $2f01d0261bce3adb$var$getValueEvent(event) {
    return $2f01d0261bce3adb$export$23f2a1d2818174ef(event) ? $2f01d0261bce3adb$var$getTouchList(event)[0] : event;
}
function $2f01d0261bce3adb$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $2f01d0261bce3adb$export$8b22cf2602fb60ce(event) {
    return $2f01d0261bce3adb$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $2f01d0261bce3adb$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $2f01d0261bce3adb$var$distanceAngle(P1, P2);
}
function $2f01d0261bce3adb$var$pointerId(event) {
    const valueEvent = $2f01d0261bce3adb$var$getValueEvent(event);
    return $2f01d0261bce3adb$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $2f01d0261bce3adb$var$pointerValues(event) {
    const valueEvent = $2f01d0261bce3adb$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $2f01d0261bce3adb$var$LINE_HEIGHT = 40;
const $2f01d0261bce3adb$var$PAGE_HEIGHT = 800;
function $2f01d0261bce3adb$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $2f01d0261bce3adb$var$LINE_HEIGHT;
        deltaY *= $2f01d0261bce3adb$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $2f01d0261bce3adb$var$PAGE_HEIGHT;
        deltaY *= $2f01d0261bce3adb$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $2f01d0261bce3adb$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $2f01d0261bce3adb$var$getEventDetails(event) {
    const payload = {};
    if ('buttons' in event) payload.buttons = event.buttons;
    if ('shiftKey' in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $2f01d0261bce3adb$var$call(v, ...args) {
    if (typeof v === 'function') return v(...args);
    else return v;
}
function $2f01d0261bce3adb$var$noop() {}
function $2f01d0261bce3adb$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $2f01d0261bce3adb$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $2f01d0261bce3adb$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $2f01d0261bce3adb$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $2f01d0261bce3adb$var$Engine {
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $2f01d0261bce3adb$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $2f01d0261bce3adb$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $369CE.V).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ('bounds' in config) state._bounds = $2f01d0261bce3adb$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $369CE.c)(state._bounds, state.offset, rubberband);
        state.delta = (0, $369CE.V).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $2f01d0261bce3adb$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $369CE.V).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $369CE.V).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
}
function $2f01d0261bce3adb$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return 'x';
    if (absDy > absDx && absDy > threshold) return 'y';
    return undefined;
}
class $2f01d0261bce3adb$var$CoordinatesEngine extends $2f01d0261bce3adb$var$Engine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "aliasKey", 'xy');
    }
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $369CE.V).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $369CE.V).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[$2f01d0261bce3adb$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $2f01d0261bce3adb$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case 'x':
                v[1] = 0;
                break;
            case 'y':
                v[0] = 0;
                break;
        }
    }
}
const $2f01d0261bce3adb$var$identity = (v)=>v;
const $2f01d0261bce3adb$var$DEFAULT_RUBBERBAND = 0.15;
const $2f01d0261bce3adb$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $2f01d0261bce3adb$var$DEFAULT_RUBBERBAND,
                    $2f01d0261bce3adb$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $369CE.V).toVector(value);
        }
    },
    from (value) {
        if (typeof value === 'function') return value;
        if (value != null) return (0, $369CE.V).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $2f01d0261bce3adb$var$identity;
    },
    threshold (value) {
        return (0, $369CE.V).toVector(value, 0);
    }
};
var $2f01d0261bce3adb$var$value, $2f01d0261bce3adb$var$value1, $2f01d0261bce3adb$var$value2;
const $2f01d0261bce3adb$var$DEFAULT_AXIS_THRESHOLD = 0;
const $2f01d0261bce3adb$var$coordinatesConfigResolver = $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === 'lock';
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $2f01d0261bce3adb$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === 'function') return (state)=>$2f01d0261bce3adb$var$coordinatesConfigResolver.bounds(value(state));
        if ('current' in value) return ()=>value.current;
        if (typeof HTMLElement === 'function' && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $2f01d0261bce3adb$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $2f01d0261bce3adb$var$DragEngine extends $2f01d0261bce3adb$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'dragging');
    }
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $2f01d0261bce3adb$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $2f01d0261bce3adb$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($2f01d0261bce3adb$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $2f01d0261bce3adb$var$getPointerType(event) !== 'mouse') {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $2f01d0261bce3adb$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $2f01d0261bce3adb$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $369CE.V).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $369CE.V).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove('dragDelay');
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove('startPointerDrag');
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $2f01d0261bce3adb$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $2f01d0261bce3adb$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
        this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
        this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add('dragDelay', ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $2f01d0261bce3adb$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $369CE.V).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $2f01d0261bce3adb$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, 'start', this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, 'change', this.pointerMove.bind(this));
            bindFunction(device, 'end', this.pointerUp.bind(this));
            bindFunction(device, 'cancel', this.pointerUp.bind(this));
            bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction('key', 'down', this.keyDown.bind(this));
            bindFunction('key', 'up', this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction('click', '', this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
}
function $2f01d0261bce3adb$var$persistEvent(event) {
    'persist' in event && typeof event.persist === 'function' && event.persist();
}
const $2f01d0261bce3adb$var$isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function $2f01d0261bce3adb$var$supportsTouchEvents() {
    return $2f01d0261bce3adb$var$isBrowser && 'ontouchstart' in window;
}
function $2f01d0261bce3adb$var$isTouchScreen() {
    return $2f01d0261bce3adb$var$supportsTouchEvents() || $2f01d0261bce3adb$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $2f01d0261bce3adb$var$supportsPointerEvents() {
    return $2f01d0261bce3adb$var$isBrowser && 'onpointerdown' in window;
}
function $2f01d0261bce3adb$var$supportsPointerLock() {
    return $2f01d0261bce3adb$var$isBrowser && 'exitPointerLock' in window.document;
}
function $2f01d0261bce3adb$var$supportsGestureEvents() {
    try {
        return 'constructor' in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $2f01d0261bce3adb$export$25ce5a424b770e84 = {
    isBrowser: $2f01d0261bce3adb$var$isBrowser,
    gesture: $2f01d0261bce3adb$var$supportsGestureEvents(),
    touch: $2f01d0261bce3adb$var$supportsTouchEvents(),
    touchscreen: $2f01d0261bce3adb$var$isTouchScreen(),
    pointer: $2f01d0261bce3adb$var$supportsPointerEvents(),
    pointerLock: $2f01d0261bce3adb$var$supportsPointerLock()
};
const $2f01d0261bce3adb$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $2f01d0261bce3adb$var$DEFAULT_DRAG_DELAY = 180;
const $2f01d0261bce3adb$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $2f01d0261bce3adb$var$DEFAULT_SWIPE_DISTANCE = 50;
const $2f01d0261bce3adb$var$DEFAULT_SWIPE_DURATION = 250;
const $2f01d0261bce3adb$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $2f01d0261bce3adb$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $2f01d0261bce3adb$var$dragConfigResolver = $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $2f01d0261bce3adb$export$25ce5a424b770e84.pointerLock;
        if ($2f01d0261bce3adb$export$25ce5a424b770e84.touch && touch) return 'touch';
        if (this.pointerLock) return 'mouse';
        if ($2f01d0261bce3adb$export$25ce5a424b770e84.pointer && !mouse) return 'pointer';
        if ($2f01d0261bce3adb$export$25ce5a424b770e84.touch) return 'touch';
        return 'mouse';
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? $2f01d0261bce3adb$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$2f01d0261bce3adb$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? 'y' : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === 'pointer' && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $369CE.V).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $2f01d0261bce3adb$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $2f01d0261bce3adb$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $2f01d0261bce3adb$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $369CE.V).toVector(velocity)),
            distance: this.transform((0, $369CE.V).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $2f01d0261bce3adb$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $2f01d0261bce3adb$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $2f01d0261bce3adb$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $2f01d0261bce3adb$var$value3, $2f01d0261bce3adb$var$value4, $2f01d0261bce3adb$var$value5, $2f01d0261bce3adb$var$value6, $2f01d0261bce3adb$var$value7;
function $2f01d0261bce3adb$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $2f01d0261bce3adb$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $2f01d0261bce3adb$var$PINCH_WHEEL_RATIO = 100;
class $2f01d0261bce3adb$var$PinchEngine extends $2f01d0261bce3adb$var$Engine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'pinching');
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "aliasKey", 'da');
    }
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === 'wheel') this.state.offset = (0, $369CE.V).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $2f01d0261bce3adb$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = 'angle';
            else if (axisMovementDifference > 0) state.axis = 'scale';
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === 'scale') v[1] = 0;
            else if (this.state.axis === 'angle') v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $2f01d0261bce3adb$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $2f01d0261bce3adb$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $2f01d0261bce3adb$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $2f01d0261bce3adb$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $369CE.V).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = 'uv' in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$2f01d0261bce3adb$var$wheelValues(event)[1] / $2f01d0261bce3adb$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $369CE.V).addTo(state._movement, state._delta);
        $2f01d0261bce3adb$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, 'start', this[device + 'Start'].bind(this));
            bindFunction(device, 'change', this[device + 'Move'].bind(this));
            bindFunction(device, 'end', this[device + 'End'].bind(this));
            bindFunction(device, 'cancel', this[device + 'End'].bind(this));
            bindFunction('lostPointerCapture', '', this[device + 'End'].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction('wheel', '', this.wheel.bind(this), {
            passive: false
        });
    }
}
const $2f01d0261bce3adb$var$pinchConfigResolver = $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$2f01d0261bce3adb$export$25ce5a424b770e84.touch && $2f01d0261bce3adb$export$25ce5a424b770e84.gesture) return 'gesture';
        if ($2f01d0261bce3adb$export$25ce5a424b770e84.touch && touch) return 'touch';
        if ($2f01d0261bce3adb$export$25ce5a424b770e84.touchscreen) {
            if ($2f01d0261bce3adb$export$25ce5a424b770e84.pointer) return 'pointer';
            if ($2f01d0261bce3adb$export$25ce5a424b770e84.touch) return 'touch';
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $2f01d0261bce3adb$var$assignDefault($2f01d0261bce3adb$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $2f01d0261bce3adb$var$assignDefault($2f01d0261bce3adb$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === 'lock';
        const threshold = (0, $369CE.V).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return 'ctrlKey';
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $2f01d0261bce3adb$var$MoveEngine extends $2f01d0261bce3adb$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'moving');
    }
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($2f01d0261bce3adb$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $2f01d0261bce3adb$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $369CE.V).sub(values, state._values);
        (0, $369CE.V).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'change', this.move.bind(this));
        bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
}
const $2f01d0261bce3adb$var$moveConfigResolver = $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $2f01d0261bce3adb$var$ScrollEngine extends $2f01d0261bce3adb$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'scrolling');
    }
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $2f01d0261bce3adb$var$scrollValues(event);
        state._delta = (0, $369CE.V).sub(values, state._values);
        (0, $369CE.V).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('scroll', '', this.scroll.bind(this));
    }
}
const $2f01d0261bce3adb$var$scrollConfigResolver = $2f01d0261bce3adb$var$coordinatesConfigResolver;
class $2f01d0261bce3adb$var$WheelEngine extends $2f01d0261bce3adb$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'wheeling');
    }
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $2f01d0261bce3adb$var$wheelValues(event);
        (0, $369CE.V).addTo(state._movement, state._delta);
        $2f01d0261bce3adb$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('wheel', '', this.wheel.bind(this));
    }
}
const $2f01d0261bce3adb$var$wheelConfigResolver = $2f01d0261bce3adb$var$coordinatesConfigResolver;
class $2f01d0261bce3adb$var$HoverEngine extends $2f01d0261bce3adb$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $2f01d0261bce3adb$export$407448d2b89b1813(this, "ingKey", 'hovering');
    }
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        this.start(event);
        this.computeValues($2f01d0261bce3adb$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $2f01d0261bce3adb$var$pointerValues(event);
        state._movement = state._delta = (0, $369CE.V).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'enter', this.enter.bind(this));
        bindFunction('pointer', 'leave', this.leave.bind(this));
    }
}
const $2f01d0261bce3adb$var$hoverConfigResolver = $2f01d0261bce3adb$export$71511d61b312f219($2f01d0261bce3adb$export$71511d61b312f219({}, $2f01d0261bce3adb$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $2f01d0261bce3adb$export$a9c23c6ac3fc3eca = new Map();
const $2f01d0261bce3adb$export$e7094788287c5e9b = new Map();
function $2f01d0261bce3adb$export$43caf9889c228507(action) {
    $2f01d0261bce3adb$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $2f01d0261bce3adb$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $2f01d0261bce3adb$export$f1e1789686576879 = {
    key: 'drag',
    engine: $2f01d0261bce3adb$var$DragEngine,
    resolver: $2f01d0261bce3adb$var$dragConfigResolver
};
const $2f01d0261bce3adb$export$dda1d9f60106f0e9 = {
    key: 'hover',
    engine: $2f01d0261bce3adb$var$HoverEngine,
    resolver: $2f01d0261bce3adb$var$hoverConfigResolver
};
const $2f01d0261bce3adb$export$953cecd6e717a553 = {
    key: 'move',
    engine: $2f01d0261bce3adb$var$MoveEngine,
    resolver: $2f01d0261bce3adb$var$moveConfigResolver
};
const $2f01d0261bce3adb$export$2d1720544b23b823 = {
    key: 'pinch',
    engine: $2f01d0261bce3adb$var$PinchEngine,
    resolver: $2f01d0261bce3adb$var$pinchConfigResolver
};
const $2f01d0261bce3adb$export$2408f22a0fab9ae5 = {
    key: 'scroll',
    engine: $2f01d0261bce3adb$var$ScrollEngine,
    resolver: $2f01d0261bce3adb$var$scrollConfigResolver
};
const $2f01d0261bce3adb$export$efccba1c4a2ef57b = {
    key: 'wheel',
    engine: $2f01d0261bce3adb$var$WheelEngine,
    resolver: $2f01d0261bce3adb$var$wheelConfigResolver
};

});
parcelRegister("369CE", function(module, exports) {

$parcel$export(module.exports, "V", () => $241965769c02484d$export$e7c866399fa523f5);
$parcel$export(module.exports, "c", () => $241965769c02484d$export$db3b6bfb95261072);
function $241965769c02484d$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $241965769c02484d$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $241965769c02484d$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $241965769c02484d$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $241965769c02484d$var$clamp(position, min, max);
    if (position < min) return -$241965769c02484d$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$241965769c02484d$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $241965769c02484d$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $241965769c02484d$export$43caf9889c228507(Vx, X0, X1, Rx),
        $241965769c02484d$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}

});



parcelRegister("ct9XI", function(module, exports) {

$parcel$export(module.exports, "Controller", () => $913febbc345fc47c$export$bd0bf19f25da8474);
$parcel$export(module.exports, "parseMergedHandlers", () => $913febbc345fc47c$export$c14d3c7045c4485d);

var $42dur = parcelRequire("42dur");

function $913febbc345fc47c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $913febbc345fc47c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $913febbc345fc47c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $913febbc345fc47c$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>'current' in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $42dur.S).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $913febbc345fc47c$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $913febbc345fc47c$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case 'function':
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case 'object':
            result[key] = $913febbc345fc47c$var$resolveWith(config[key], resolver);
            break;
        case 'boolean':
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $913febbc345fc47c$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $913febbc345fc47c$var$_objectWithoutProperties(_ref, $913febbc345fc47c$var$_excluded);
    _config.shared = $913febbc345fc47c$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $913febbc345fc47c$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $42dur.C).get(gestureKey);
        _config[gestureKey] = $913febbc345fc47c$var$resolveWith((0, $42dur._)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $42dur.C).get(key);
        if (resolver) _config[key] = $913febbc345fc47c$var$resolveWith((0, $42dur._)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $913febbc345fc47c$var$EventStore {
    constructor(ctrl, gestureKey){
        (0, $42dur.a)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $42dur.t)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $42dur._)((0, $42dur._)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
}
class $913febbc345fc47c$var$TimeoutStore {
    constructor(){
        (0, $42dur.a)(this, "_timeouts", new Map());
    }
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
}
class $913febbc345fc47c$export$bd0bf19f25da8474 {
    constructor(handlers){
        (0, $42dur.a)(this, "gestures", new Set());
        (0, $42dur.a)(this, "_targetEventStore", new $913febbc345fc47c$var$EventStore(this));
        (0, $42dur.a)(this, "gestureEventStores", {});
        (0, $42dur.a)(this, "gestureTimeoutStores", {});
        (0, $42dur.a)(this, "handlers", {});
        (0, $42dur.a)(this, "config", {});
        (0, $42dur.a)(this, "pointerIds", new Set());
        (0, $42dur.a)(this, "touchIds", new Set());
        (0, $42dur.a)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $913febbc345fc47c$var$resolveGestures(this, handlers);
    }
    setEventIds(event) {
        if ((0, $42dur.i)(event)) {
            this.touchIds = new Set((0, $42dur.b)(event));
            return this.touchIds;
        } else if ('pointerId' in event) {
            if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);
            else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $913febbc345fc47c$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $913febbc345fc47c$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $42dur.E).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $913febbc345fc47c$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, '', (event)=>this.nativeHandlers[eventKey]((0, $42dur._)((0, $42dur._)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $42dur.c)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $42dur.p)(handlerProp);
            this._targetEventStore.add(target, device, '', props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
}
function $913febbc345fc47c$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $913febbc345fc47c$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $913febbc345fc47c$var$TimeoutStore();
}
function $913febbc345fc47c$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $913febbc345fc47c$var$setupGesture(ctrl, 'drag');
    if (internalHandlers.wheel) $913febbc345fc47c$var$setupGesture(ctrl, 'wheel');
    if (internalHandlers.scroll) $913febbc345fc47c$var$setupGesture(ctrl, 'scroll');
    if (internalHandlers.move) $913febbc345fc47c$var$setupGesture(ctrl, 'move');
    if (internalHandlers.pinch) $913febbc345fc47c$var$setupGesture(ctrl, 'pinch');
    if (internalHandlers.hover) $913febbc345fc47c$var$setupGesture(ctrl, 'hover');
}
const $913febbc345fc47c$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $42dur.d)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += 'Passive';
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $913febbc345fc47c$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $913febbc345fc47c$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($913febbc345fc47c$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $913febbc345fc47c$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $42dur.E).has(key)) return;
    const startKey = handlerKey + 'Start';
    const endKey = handlerKey + 'End';
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $913febbc345fc47c$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $913febbc345fc47c$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
    $913febbc345fc47c$var$registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}

});

parcelRegister("ffM9D", function(module, exports) {


});

parcelRegister("4RwTX", function(module, exports) {

});


parcelRegister("1MjSC", function(module, exports) {
"use strict";
var $14b9b1e8b297fb6f$var$__assign = module.exports && module.exports.__assign || function() {
    $14b9b1e8b297fb6f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14b9b1e8b297fb6f$var$__assign.apply(this, arguments);
};
function $14b9b1e8b297fb6f$var$pushProp(target, key, value) {
    if (key === 'className') target.className = [
        target.className,
        value
    ].join(' ').trim();
    else if (key === 'style') target.style = $14b9b1e8b297fb6f$var$__assign($14b9b1e8b297fb6f$var$__assign({}, target.style), value);
    else if (typeof value === 'function') {
        var oldFn_1 = target[key];
        target[key] = oldFn_1 ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            oldFn_1.apply(void 0, args);
            value.apply(void 0, args);
        } : value;
    } else if (// skip merging undefined values
    value === undefined || // skip if both value are the same primitive value
    typeof value !== 'object' && value === target[key]) return;
    else if (!(key in target)) target[key] = value;
    else throw new Error("Didn\u2019t know how to merge prop '".concat(key, "'. ") + "Only 'className', 'style', and event handlers are supported");
}
module.exports = function mergeProps() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    if (props.length === 1) return props[0];
    return props.reduce(function(merged, ps) {
        for(var key in ps)$14b9b1e8b297fb6f$var$pushProp(merged, key, ps[key]);
        return merged;
    }, {});
};

});

parcelRegister("9jTEz", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $8b3b0bf1e0f8dafc$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "clamp01", () => $8b3b0bf1e0f8dafc$export$5c5ee632c52bc4a2);
$parcel$export(module.exports, "mapFrom01Linear", () => $8b3b0bf1e0f8dafc$export$4b0e1c7a0a9bbf7d);
$parcel$export(module.exports, "mapTo01Linear", () => $8b3b0bf1e0f8dafc$export$4ae741d5e32a8509);
var $8b3b0bf1e0f8dafc$export$7d15b64cf5a3a4c4 = (r, m, e)=>Math.max(m, Math.min(e, r)), $8b3b0bf1e0f8dafc$export$5c5ee632c52bc4a2 = (r)=>$8b3b0bf1e0f8dafc$export$7d15b64cf5a3a4c4(r, 0, 1);
var $8b3b0bf1e0f8dafc$export$4b0e1c7a0a9bbf7d = (r, m, e)=>(e - m) * r + m, $8b3b0bf1e0f8dafc$export$4ae741d5e32a8509 = (r, m, e)=>(r - m) / (e - m);
 //# sourceMappingURL=out.js.map

});


parcelRegister("7Hv6G", function(module, exports) {

$parcel$export(module.exports, "FloatingValue", () => $38b4be86fa8be497$export$96cc1b8a292daaa5);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $8i2T6 = parcelRequire("8i2T6");
var $dXIky = parcelRequire("dXIky");
function $38b4be86fa8be497$export$96cc1b8a292daaa5({ value: value, children: children, isVisible: isVisible }) {
    const { refs: refs, floatingStyles: floatingStyles } = (0, $dXIky.useFloating)({
        isOpen: isVisible,
        whileElementsMounted: (0, $8i2T6.autoUpdate)
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement(children, {
                ref: refs.setReference
            }),
            isVisible && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dXIky.FloatingPortal), {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("output", {
                    className: "parameter-value-display",
                    style: floatingStyles,
                    ref: refs.setFloating,
                    children: value
                })
            })
        ]
    });
}

});
parcelRegister("dXIky", function(module, exports) {

$parcel$export(module.exports, "FloatingArrow", () => $a2a32c30b64f04ab$export$33511391554732bc);
$parcel$export(module.exports, "FloatingPortal", () => $a2a32c30b64f04ab$export$31fa5d718fa2ac09);
$parcel$export(module.exports, "useFloating", () => $a2a32c30b64f04ab$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => (parcelRequire("eqxtD")).offset);

var $8NFma = parcelRequire("8NFma");

var $hn8gG = parcelRequire("hn8gG");

var $1IdZj = parcelRequire("1IdZj");

var $1D9S2 = parcelRequire("1D9S2");

var $6X8j6 = parcelRequire("6X8j6");

var $2pmb0 = parcelRequire("2pmb0");

var $eqxtD = parcelRequire("eqxtD");
var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");

var $Euxde = parcelRequire("Euxde");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $a2a32c30b64f04ab$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $8NFma.useRef(undefined);
    const refEffect = $8NFma.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $8NFma.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $a2a32c30b64f04ab$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $a2a32c30b64f04ab$var$FloatingListContext = /*#__PURE__*/ $8NFma.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $a2a32c30b64f04ab$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $8NFma.useState(()=>new Set());
    const register = $8NFma.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $8NFma.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $8NFma.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($a2a32c30b64f04ab$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FloatingListContext.Provider, {
        value: $8NFma.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingListContext);
    const [index, setIndex] = $8NFma.useState(null);
    const componentRef = $8NFma.useRef(null);
    const ref = $8NFma.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $8NFma.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $a2a32c30b64f04ab$var$ACTIVE_KEY = 'active';
const $a2a32c30b64f04ab$var$SELECTED_KEY = 'selected';
const $a2a32c30b64f04ab$var$ARROW_LEFT = 'ArrowLeft';
const $a2a32c30b64f04ab$var$ARROW_RIGHT = 'ArrowRight';
const $a2a32c30b64f04ab$var$ARROW_UP = 'ArrowUp';
const $a2a32c30b64f04ab$var$ARROW_DOWN = 'ArrowDown';
function $a2a32c30b64f04ab$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $8NFma.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ...computedProps
    });
}
const $a2a32c30b64f04ab$var$CompositeContext = /*#__PURE__*/ $8NFma.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $a2a32c30b64f04ab$var$horizontalKeys = [
    $a2a32c30b64f04ab$var$ARROW_LEFT,
    $a2a32c30b64f04ab$var$ARROW_RIGHT
];
const $a2a32c30b64f04ab$var$verticalKeys = [
    $a2a32c30b64f04ab$var$ARROW_UP,
    $a2a32c30b64f04ab$var$ARROW_DOWN
];
const $a2a32c30b64f04ab$var$allKeys = [
    ...$a2a32c30b64f04ab$var$horizontalKeys,
    ...$a2a32c30b64f04ab$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$43586241d9db0c6d = /*#__PURE__*/ $8NFma.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $8NFma.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $hn8gG.useEffectEvent)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $8NFma.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $8NFma.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$a2a32c30b64f04ab$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $hn8gG.getMinListIndex)(elementsRef, disabledIndices);
        const maxIndex = (0, $hn8gG.getMaxListIndex)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $a2a32c30b64f04ab$var$ARROW_LEFT : $a2a32c30b64f04ab$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $a2a32c30b64f04ab$var$ARROW_RIGHT : $a2a32c30b64f04ab$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $hn8gG.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $hn8gG.isListIndexDisabled)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $hn8gG.isListIndexDisabled)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $hn8gG.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $hn8gG.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $hn8gG.isListIndexDisabled)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $hn8gG.getGridCellIndexOfCorner)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $a2a32c30b64f04ab$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $a2a32c30b64f04ab$var$allKeys : ({
            horizontal: $a2a32c30b64f04ab$var$horizontalKeys,
            vertical: $a2a32c30b64f04ab$var$verticalKeys,
            both: $a2a32c30b64f04ab$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $hn8gG.findNonDisabledListIndex)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $hn8gG.isIndexOutOfListBounds)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $a2a32c30b64f04ab$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $8NFma.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $8NFma.useContext($a2a32c30b64f04ab$var$CompositeContext);
    const { ref: ref, index: index } = $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a();
    const mergedRef = $a2a32c30b64f04ab$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $a2a32c30b64f04ab$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $a2a32c30b64f04ab$var$SafeReact = {
    ...$8NFma
};
let $a2a32c30b64f04ab$var$serverHandoffComplete = false;
let $a2a32c30b64f04ab$var$count = 0;
const $a2a32c30b64f04ab$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $a2a32c30b64f04ab$var$count++;
function $a2a32c30b64f04ab$var$useFloatingId() {
    const [id, setId] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$serverHandoffComplete ? $a2a32c30b64f04ab$var$genId() : undefined);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (id == null) setId($a2a32c30b64f04ab$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $8NFma.useEffect(()=>{
        $a2a32c30b64f04ab$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $a2a32c30b64f04ab$var$useReactId = $a2a32c30b64f04ab$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $a2a32c30b64f04ab$export$f680877a34711e37 = $a2a32c30b64f04ab$var$useReactId || $a2a32c30b64f04ab$var$useFloatingId;
let $a2a32c30b64f04ab$var$devMessageSet;
function $a2a32c30b64f04ab$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $a2a32c30b64f04ab$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $a2a32c30b64f04ab$export$33511391554732bc = /*#__PURE__*/ $8NFma.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $8NFma.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!floating) return;
        const isRTL = (0, $1D9S2.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $a2a32c30b64f04ab$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $a2a32c30b64f04ab$var$FloatingNodeContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$FloatingTreeContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $a2a32c30b64f04ab$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69 = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$9b136e0e758a42f4(customParentId) {
    const id = $a2a32c30b64f04ab$export$f680877a34711e37();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const reactParentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FloatingNodeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $8NFma.useRef([]);
    const addNode = $8NFma.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $8NFma.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createEventEmitter());
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FloatingTreeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $a2a32c30b64f04ab$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $a2a32c30b64f04ab$var$safePolygonIdentifier = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('safe-polygon');
function $a2a32c30b64f04ab$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $hn8gG.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $a2a32c30b64f04ab$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $a2a32c30b64f04ab$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const handleCloseRef = (0, $hn8gG.useLatestRef)(handleClose);
    const delayRef = (0, $hn8gG.useLatestRef)(delay);
    const openRef = (0, $hn8gG.useLatestRef)(open);
    const restMsRef = (0, $hn8gG.useLatestRef)(restMs);
    const pointerTypeRef = $8NFma.useRef();
    const timeoutRef = $8NFma.useRef(-1);
    const handlerRef = $8NFma.useRef();
    const restTimeoutRef = $8NFma.useRef(-1);
    const blockMouseMoveRef = $8NFma.useRef(true);
    const performedPointerEventsMutationRef = $8NFma.useRef(false);
    const unbindMouseMoveRef = $8NFma.useRef(()=>{});
    const restTimeoutPendingRef = $8NFma.useRef(false);
    const isHoverOpen = (0, $hn8gG.useEffectEvent)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
                $a2a32c30b64f04ab$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $hn8gG.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $8NFma.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $hn8gG.useEffectEvent)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $hn8gG.useEffectEvent)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $hn8gG.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $hn8gG.useEffectEvent)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current) || $a2a32c30b64f04ab$var$getRestMs(restMsRef.current) > 0 && !$a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $hn8gG.getDocument)(elements.floating);
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $hn8gG.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $1D9S2.isElement)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $1D9S2.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $hn8gG.getDocument)(elements.floating).body;
                body.setAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || $a2a32c30b64f04ab$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $a2a32c30b64f04ab$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $a2a32c30b64f04ab$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$NOOP = ()=>{};
const $a2a32c30b64f04ab$var$FloatingDelayGroupContext = /*#__PURE__*/ $8NFma.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $a2a32c30b64f04ab$var$NOOP,
    setState: $a2a32c30b64f04ab$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $a2a32c30b64f04ab$export$e2411914b150383d = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $8NFma.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $8NFma.useRef(null);
    const setCurrentId = $8NFma.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FloatingDelayGroupContext.Provider, {
        value: $8NFma.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $a2a32c30b64f04ab$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $a2a32c30b64f04ab$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (setCurrentId === $a2a32c30b64f04ab$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $a2a32c30b64f04ab$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $8NFma.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $8NFma.useRef(delay);
    const initialDelayRef = $8NFma.useRef(delay);
    const currentIdRef = $8NFma.useRef(null);
    const currentContextRef = $8NFma.useRef(null);
    const timeoutIdRef = $8NFma.useRef(-1);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$NextFloatingDelayGroupContext.Provider, {
        value: $8NFma.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $8NFma.useContext($a2a32c30b64f04ab$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $8NFma.useState(false);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $a2a32c30b64f04ab$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $8NFma.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $a2a32c30b64f04ab$var$rafId = 0;
function $a2a32c30b64f04ab$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($a2a32c30b64f04ab$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $a2a32c30b64f04ab$var$rafId = requestAnimationFrame(exec);
}
function $a2a32c30b64f04ab$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $1D9S2.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $a2a32c30b64f04ab$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $a2a32c30b64f04ab$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $a2a32c30b64f04ab$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $a2a32c30b64f04ab$var$getCounterMap(control) {
    if (control === 'inert') return $a2a32c30b64f04ab$var$counters.inert;
    if (control === 'aria-hidden') return $a2a32c30b64f04ab$var$counters['aria-hidden'];
    return $a2a32c30b64f04ab$var$counters.none;
}
let $a2a32c30b64f04ab$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $a2a32c30b64f04ab$var$markerMap = {};
let $a2a32c30b64f04ab$var$lockCount$1 = 0;
const $a2a32c30b64f04ab$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $a2a32c30b64f04ab$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $1D9S2.isShadowRoot)(node) ? node.host : $a2a32c30b64f04ab$var$unwrapHost(node.parentNode);
}
const $a2a32c30b64f04ab$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $a2a32c30b64f04ab$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $a2a32c30b64f04ab$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $a2a32c30b64f04ab$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$a2a32c30b64f04ab$var$markerMap[markerName]) $a2a32c30b64f04ab$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $a2a32c30b64f04ab$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $1D9S2.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $a2a32c30b64f04ab$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $a2a32c30b64f04ab$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $a2a32c30b64f04ab$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $a2a32c30b64f04ab$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$a2a32c30b64f04ab$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $a2a32c30b64f04ab$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $a2a32c30b64f04ab$var$lockCount$1--;
        if (!$a2a32c30b64f04ab$var$lockCount$1) {
            $a2a32c30b64f04ab$var$counters.inert = new WeakMap();
            $a2a32c30b64f04ab$var$counters['aria-hidden'] = new WeakMap();
            $a2a32c30b64f04ab$var$counters.none = new WeakMap();
            $a2a32c30b64f04ab$var$uncontrolledElementsSet = new WeakSet();
            $a2a32c30b64f04ab$var$markerMap = {};
        }
    };
}
function $a2a32c30b64f04ab$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $a2a32c30b64f04ab$var$getDocument(avoidElements[0]).body;
    return $a2a32c30b64f04ab$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $a2a32c30b64f04ab$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $a2a32c30b64f04ab$var$FocusGuard = /*#__PURE__*/ $8NFma.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $8NFma.useState();
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if ((0, $hn8gG.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$a2a32c30b64f04ab$var$createAttribute('focus-guard')]: '',
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $a2a32c30b64f04ab$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const $a2a32c30b64f04ab$var$PortalContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$attr = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $a2a32c30b64f04ab$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const [portalNode, setPortalNode] = $8NFma.useState(null);
    const portalNodeRef = $8NFma.useRef(null);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $1D9S2.isNode)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $a2a32c30b64f04ab$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $a2a32c30b64f04ab$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $8NFma.useState(null);
    const beforeOutsideRef = $8NFma.useRef(null);
    const afterOutsideRef = $8NFma.useRef(null);
    const beforeInsideRef = $8NFma.useRef(null);
    const afterInsideRef = $8NFma.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $8NFma.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $hn8gG.isOutsideEvent)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $hn8gG.enableFocusInside) : (0, $hn8gG.disableFocusInside);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $8NFma.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $hn8gG.enableFocusInside)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($a2a32c30b64f04ab$var$PortalContext.Provider, {
        value: $8NFma.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $hn8gG.isOutsideEvent)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $hn8gG.getPreviousTabbable)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $a2a32c30b64f04ab$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $2pmb0.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $hn8gG.isOutsideEvent)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $hn8gG.getNextTabbable)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $a2a32c30b64f04ab$var$usePortalContext = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$PortalContext);
function $a2a32c30b64f04ab$var$useLiteMergeRefs(refs) {
    return $8NFma.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $a2a32c30b64f04ab$var$LIST_LIMIT = 20;
let $a2a32c30b64f04ab$var$previouslyFocusedElements = [];
function $a2a32c30b64f04ab$var$clearDisconnectedPreviouslyFocusedElements() {
    $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(element) {
    $a2a32c30b64f04ab$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $1D9S2.getNodeName)(element) !== 'body') {
        $a2a32c30b64f04ab$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($a2a32c30b64f04ab$var$previouslyFocusedElements.length > $a2a32c30b64f04ab$var$LIST_LIMIT) $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.slice(-$a2a32c30b64f04ab$var$LIST_LIMIT);
    }
}
function $a2a32c30b64f04ab$var$getPreviouslyFocusedElement() {
    $a2a32c30b64f04ab$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $a2a32c30b64f04ab$var$previouslyFocusedElements[$a2a32c30b64f04ab$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $a2a32c30b64f04ab$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $hn8gG.getTabbableOptions)();
    if ((0, $6X8j6.isTabbable)(container, tabbableOptions)) return container;
    return (0, $6X8j6.tabbable)(container, tabbableOptions)[0] || container;
}
function $a2a32c30b64f04ab$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $hn8gG.getTabbableOptions)();
    const focusableElements = (0, $6X8j6.focusable)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $6X8j6.isTabbable)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $a2a32c30b64f04ab$var$VisuallyHiddenDismiss = /*#__PURE__*/ $8NFma.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $a2a32c30b64f04ab$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $hn8gG.useEffectEvent)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $hn8gG.useEffectEvent)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $hn8gG.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $a2a32c30b64f04ab$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $hn8gG.useLatestRef)(order);
    const initialFocusRef = (0, $hn8gG.useLatestRef)(initialFocus);
    const returnFocusRef = (0, $hn8gG.useLatestRef)(returnFocus);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const startDismissButtonRef = $8NFma.useRef(null);
    const endDismissButtonRef = $8NFma.useRef(null);
    const preventReturnFocusRef = $8NFma.useRef(false);
    const isPointerDownRef = $8NFma.useRef(false);
    const tabbableIndexRef = $8NFma.useRef(-1);
    const blurTimeoutRef = $8NFma.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $hn8gG.getFloatingFocusElement)(floating);
    const getTabbableContent = (0, $hn8gG.useEffectEvent)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $6X8j6.tabbable)(container, (0, $hn8gG.getTabbableOptions)()) : [];
    });
    const getTabbableElements = (0, $hn8gG.useEffectEvent)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $hn8gG.contains)(floatingFocusElement, (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $hn8gG.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $hn8gG.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $hn8gG.stopEvent)(event);
                    if (event.shiftKey) $a2a32c30b64f04ab$var$enqueueFocus(els[els.length - 1]);
                    else $a2a32c30b64f04ab$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $hn8gG.stopEvent)(event);
                    $a2a32c30b64f04ab$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $hn8gG.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $hn8gG.getTarget)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $hn8gG.contains)(domReference, relatedTarget) || (0, $hn8gG.contains)(floating, relatedTarget) || (0, $hn8gG.contains)(relatedTarget, floating) || (0, $hn8gG.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) || tree && ((0, $hn8gG.getNodeChildren)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $hn8gG.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $hn8gG.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $hn8gG.getNodeAncestors)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $hn8gG.getFloatingFocusElement)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $a2a32c30b64f04ab$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement)) === (0, $hn8gG.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $1D9S2.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $1D9S2.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $a2a32c30b64f04ab$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $1D9S2.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $8NFma.useRef(null);
    const afterGuardRef = $8NFma.useRef(null);
    const mergedBeforeGuardRef = $a2a32c30b64f04ab$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $a2a32c30b64f04ab$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $8NFma.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $a2a32c30b64f04ab$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $hn8gG.getNodeAncestors)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $hn8gG.isTypeableCombobox)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $a2a32c30b64f04ab$var$markOthers(insideElements, !useInert, useInert) : $a2a32c30b64f04ab$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (disabled || !(0, $1D9S2.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $hn8gG.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $a2a32c30b64f04ab$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $hn8gG.isVirtualClick)(event) || (0, $hn8gG.isVirtualPointerEvent)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $a2a32c30b64f04ab$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $a2a32c30b64f04ab$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $hn8gG.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $hn8gG.contains)(floating, activeEl) || tree && (0, $hn8gG.getNodeChildren)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $hn8gG.contains)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $a2a32c30b64f04ab$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $1D9S2.isHTMLElement)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $8NFma.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($a2a32c30b64f04ab$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $a2a32c30b64f04ab$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $a2a32c30b64f04ab$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $hn8gG.isOutsideEvent)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $hn8gG.getNextTabbable)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $1IdZj.jsx)($a2a32c30b64f04ab$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $a2a32c30b64f04ab$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $hn8gG.isOutsideEvent)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $hn8gG.getPreviousTabbable)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $a2a32c30b64f04ab$var$lockCount = 0;
const $a2a32c30b64f04ab$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $a2a32c30b64f04ab$var$enableScrollLock() {
    const platform = (0, $hn8gG.getPlatform)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($a2a32c30b64f04ab$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($a2a32c30b64f04ab$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $a2a32c30b64f04ab$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $a2a32c30b64f04ab$export$a35954495955337b = /*#__PURE__*/ $8NFma.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!lockScroll) return;
        $a2a32c30b64f04ab$var$lockCount++;
        if ($a2a32c30b64f04ab$var$lockCount === 1) $a2a32c30b64f04ab$var$cleanup = $a2a32c30b64f04ab$var$enableScrollLock();
        return ()=>{
            $a2a32c30b64f04ab$var$lockCount--;
            if ($a2a32c30b64f04ab$var$lockCount === 0) $a2a32c30b64f04ab$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $a2a32c30b64f04ab$var$isButtonTarget(event) {
    return (0, $1D9S2.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $a2a32c30b64f04ab$var$isAnchorTarget(event) {
    return (0, $1D9S2.isHTMLElement)(event.target) && event.target.tagName === 'A';
}
function $a2a32c30b64f04ab$var$isSpaceIgnored(element) {
    return (0, $hn8gG.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $a2a32c30b64f04ab$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $8NFma.useRef();
    const didKeyDownRef = $8NFma.useRef(false);
    const reference = $8NFma.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($a2a32c30b64f04ab$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event) || $a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $a2a32c30b64f04ab$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $a2a32c30b64f04ab$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $a2a32c30b64f04ab$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $8NFma.useRef(false);
    const cleanupListenerRef = $8NFma.useRef(null);
    const [pointerType, setPointerType] = $8NFma.useState();
    const [reactive, setReactive] = $8NFma.useState([]);
    const setReference = (0, $hn8gG.useEffectEvent)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($a2a32c30b64f04ab$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $hn8gG.useEffectEvent)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $hn8gG.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $8NFma.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $1D9S2.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $hn8gG.getTarget)(event);
            if (!(0, $hn8gG.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $8NFma.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $8NFma.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $a2a32c30b64f04ab$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $a2a32c30b64f04ab$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $a2a32c30b64f04ab$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $hn8gG.useEffectEvent)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $8NFma.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $a2a32c30b64f04ab$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $a2a32c30b64f04ab$var$normalizeProp(capture);
    const isComposingRef = $8NFma.useRef(false);
    const closeOnEscapeKeyDown = (0, $hn8gG.useEffectEvent)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $hn8gG.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $hn8gG.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $hn8gG.useEffectEvent)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $hn8gG.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $hn8gG.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $hn8gG.useEffectEvent)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $hn8gG.getTarget)(event);
        const inertSelector = "[" + $a2a32c30b64f04ab$var$createAttribute('inert') + "]";
        const markers = (0, $hn8gG.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $1D9S2.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $1D9S2.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $1D9S2.getParentNode)(targetRootAncestor);
            if ((0, $1D9S2.isLastTraversableNode)(nextParent) || !(0, $1D9S2.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $1D9S2.isElement)(target) && !(0, $hn8gG.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $hn8gG.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $hn8gG.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $1D9S2.isHTMLElement)(target) && floating) {
            const lastTraversableNode = (0, $1D9S2.isLastTraversableNode)(target);
            const style = (0, $1D9S2.getComputedStyle)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $hn8gG.getNodeChildren)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $hn8gG.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $hn8gG.isEventTargetWithin)(event, elements.floating) || (0, $hn8gG.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $hn8gG.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $hn8gG.useEffectEvent)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $hn8gG.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $hn8gG.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $8NFma.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $1D9S2.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $hn8gG.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $1D9S2.isElement)(elements.domReference)) ancestors = (0, $1D9S2.getOverflowAncestors)(elements.domReference);
            if ((0, $1D9S2.isElement)(elements.floating)) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.floating));
            if (!(0, $1D9S2.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $8NFma.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$a2a32c30b64f04ab$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $8NFma.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$a2a32c30b64f04ab$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const dataRef = $8NFma.useRef({});
    const [events] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createEventEmitter());
    const nested = $a2a32c30b64f04ab$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $8NFma.useState(elementsProp.reference);
    const onOpenChange = (0, $hn8gG.useEffectEvent)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $8NFma.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $8NFma.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $8NFma.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a2a32c30b64f04ab$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $a2a32c30b64f04ab$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $8NFma.useState(null);
    const [positionReference, _setPositionReference] = $8NFma.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $8NFma.useRef(null);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $eqxtD.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $8NFma.useCallback((node)=>{
        const computedPositionReference = (0, $1D9S2.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $8NFma.useCallback((node)=>{
        if ((0, $1D9S2.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $1D9S2.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $1D9S2.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $8NFma.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $8NFma.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $8NFma.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $8NFma.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $a2a32c30b64f04ab$var$isMacSafari() {
    return (0, $hn8gG.isMac)() && (0, $hn8gG.isSafari)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $a2a32c30b64f04ab$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $8NFma.useRef(false);
    const timeoutRef = $8NFma.useRef(-1);
    const keyboardModalityRef = $8NFma.useRef(true);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $1D9S2.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $1D9S2.isHTMLElement)(elements.domReference) && elements.domReference === (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($a2a32c30b64f04ab$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($a2a32c30b64f04ab$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $8NFma.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $hn8gG.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $1D9S2.isElement)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($a2a32c30b64f04ab$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $hn8gG.isTypeableElement)(target)) return;
                    } else if (!(0, $hn8gG.matchesFocusVisible)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $1D9S2.isElement)(relatedTarget) && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $hn8gG.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $hn8gG.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $hn8gG.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $a2a32c30b64f04ab$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$a2a32c30b64f04ab$var$ACTIVE_KEY]: _, [$a2a32c30b64f04ab$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $a2a32c30b64f04ab$var$ACTIVE_KEY,
                    $a2a32c30b64f04ab$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $a2a32c30b64f04ab$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $8NFma.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $a2a32c30b64f04ab$var$ESCAPE = 'Escape';
function $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $a2a32c30b64f04ab$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_UP || key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_LEFT || key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_RIGHT : key === $a2a32c30b64f04ab$var$ARROW_LEFT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $a2a32c30b64f04ab$var$ESCAPE;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $a2a32c30b64f04ab$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $hn8gG.getFloatingFocusElement)(elements.floating);
    const floatingFocusElementRef = (0, $hn8gG.useLatestRef)(floatingFocusElement);
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $hn8gG.useEffectEvent)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $hn8gG.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $8NFma.useRef(focusItemOnOpen);
    const indexRef = $8NFma.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $8NFma.useRef(null);
    const isPointerModalityRef = $8NFma.useRef(true);
    const previousOnNavigateRef = $8NFma.useRef(onNavigate);
    const previousMountedRef = $8NFma.useRef(!!elements.floating);
    const previousOpenRef = $8NFma.useRef(open);
    const forceSyncFocusRef = $8NFma.useRef(false);
    const forceScrollIntoViewRef = $8NFma.useRef(false);
    const disabledIndicesRef = (0, $hn8gG.useLatestRef)(disabledIndices);
    const latestOpenRef = (0, $hn8gG.useLatestRef)(open);
    const scrollItemIntoViewRef = (0, $hn8gG.useLatestRef)(scrollItemIntoView);
    const selectedIndexRef = (0, $hn8gG.useLatestRef)(selectedIndex);
    const [activeId, setActiveId] = $8NFma.useState();
    const [virtualId, setVirtualId] = $8NFma.useState();
    const focusItem = (0, $hn8gG.useEffectEvent)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $a2a32c30b64f04ab$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $a2a32c30b64f04ab$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $hn8gG.getMinListIndex)(listRef, disabledIndicesRef.current) : (0, $hn8gG.getMaxListIndex)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $hn8gG.isIndexOutOfListBounds)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $hn8gG.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $8NFma.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $8NFma.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $hn8gG.useEffectEvent)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$a2a32c30b64f04ab$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $hn8gG.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $1D9S2.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $hn8gG.getMinListIndex)(listRef, disabledIndices);
        const maxIndex = (0, $hn8gG.getMaxListIndex)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $hn8gG.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $hn8gG.isListIndexDisabled)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $hn8gG.isListIndexDisabled)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $hn8gG.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $hn8gG.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $hn8gG.isListIndexDisabled)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $hn8gG.getGridCellIndexOfCorner)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $a2a32c30b64f04ab$var$ARROW_LEFT : $a2a32c30b64f04ab$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation)) {
            (0, $hn8gG.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $hn8gG.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $hn8gG.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $hn8gG.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $hn8gG.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $hn8gG.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $hn8gG.isIndexOutOfListBounds)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $8NFma.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $8NFma.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $hn8gG.getDeepestNode)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $hn8gG.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $hn8gG.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $a2a32c30b64f04ab$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $hn8gG.stopEvent)(event);
                        if (open) {
                            indexRef.current = (0, $hn8gG.getMinListIndex)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $hn8gG.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $a2a32c30b64f04ab$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $8NFma.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $hn8gG.getFloatingFocusElement)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $8NFma.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $8NFma.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $8NFma.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $a2a32c30b64f04ab$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $a2a32c30b64f04ab$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $a2a32c30b64f04ab$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $8NFma.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $8NFma.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $8NFma.useState('unmounted');
    const isMounted = $a2a32c30b64f04ab$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $2pmb0.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $a2a32c30b64f04ab$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $8NFma.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $8NFma.useState(()=>({
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $hn8gG.useLatestRef)(unstable_initial);
    const openRef = (0, $hn8gG.useLatestRef)(unstable_open);
    const closeRef = (0, $hn8gG.useLatestRef)(unstable_close);
    const commonRef = (0, $hn8gG.useLatestRef)(unstable_common);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        const initialStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $a2a32c30b64f04ab$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $8NFma.useRef(-1);
    const stringRef = $8NFma.useRef('');
    const prevIndexRef = $8NFma.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $8NFma.useRef(null);
    const onMatch = (0, $hn8gG.useEffectEvent)(unstable_onMatch);
    const onTypingChange = (0, $hn8gG.useEffectEvent)(unstable_onTypingChange);
    const findMatchRef = (0, $hn8gG.useLatestRef)(findMatch);
    const ignoreKeysRef = (0, $hn8gG.useLatestRef)(ignoreKeys);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        if (open) {
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $hn8gG.useModernLayoutEffect)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $hn8gG.useEffectEvent)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $hn8gG.useEffectEvent)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $hn8gG.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $hn8gG.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $a2a32c30b64f04ab$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $Euxde.evaluate)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $eqxtD.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $Euxde.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $Euxde.round);
            const maxHeight = rounder((0, $Euxde.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $Euxde.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $Euxde.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $2pmb0.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $a2a32c30b64f04ab$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $hn8gG.useEffectEvent)(unstable_onChange);
    const controlledScrollingRef = $8NFma.useRef(false);
    const prevScrollTopRef = $8NFma.useRef(null);
    const initialOverflowRef = $8NFma.useRef(null);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $2pmb0.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $hn8gG.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $2pmb0.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$a2a32c30b64f04ab$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $a2a32c30b64f04ab$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $a2a32c30b64f04ab$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $a2a32c30b64f04ab$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $a2a32c30b64f04ab$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $a2a32c30b64f04ab$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $a2a32c30b64f04ab$var$contains(elements.floating, target);
            const isOverReferenceEl = $a2a32c30b64f04ab$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $a2a32c30b64f04ab$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $1D9S2.isElement)(event.relatedTarget) && $a2a32c30b64f04ab$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $a2a32c30b64f04ab$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("hn8gG", function(module, exports) {

$parcel$export(module.exports, "getPlatform", () => $ca5aff85a2f3333d$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $ca5aff85a2f3333d$export$7935961ef7719cb0);
$parcel$export(module.exports, "isSafari", () => $ca5aff85a2f3333d$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $ca5aff85a2f3333d$export$9ac100e40613ea10);
$parcel$export(module.exports, "activeElement", () => $ca5aff85a2f3333d$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $ca5aff85a2f3333d$export$2344b14b097df817);
$parcel$export(module.exports, "getTarget", () => $ca5aff85a2f3333d$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isEventTargetWithin", () => $ca5aff85a2f3333d$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "isRootElement", () => $ca5aff85a2f3333d$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $ca5aff85a2f3333d$export$f65ca476c09acec0);
$parcel$export(module.exports, "isTypeableElement", () => $ca5aff85a2f3333d$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "isTypeableCombobox", () => $ca5aff85a2f3333d$export$259ba5ae38188551);
$parcel$export(module.exports, "matchesFocusVisible", () => $ca5aff85a2f3333d$export$65750043c2fb2f40);
$parcel$export(module.exports, "getFloatingFocusElement", () => $ca5aff85a2f3333d$export$9b0901b5e9b45fc7);
$parcel$export(module.exports, "getNodeChildren", () => $ca5aff85a2f3333d$export$1f1998cc3c6b56fb);
$parcel$export(module.exports, "getDeepestNode", () => $ca5aff85a2f3333d$export$e7e88d43cb97db79);
$parcel$export(module.exports, "getNodeAncestors", () => $ca5aff85a2f3333d$export$5d8eb345316b65c0);
$parcel$export(module.exports, "stopEvent", () => $ca5aff85a2f3333d$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isReactEvent", () => $ca5aff85a2f3333d$export$94781ce41a161222);
$parcel$export(module.exports, "isVirtualClick", () => $ca5aff85a2f3333d$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $ca5aff85a2f3333d$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isMouseLikePointerType", () => $ca5aff85a2f3333d$export$81cf264172d31e51);
$parcel$export(module.exports, "useModernLayoutEffect", () => $ca5aff85a2f3333d$export$bb3b3b3acfd7447f);
$parcel$export(module.exports, "useLatestRef", () => $ca5aff85a2f3333d$export$bcd07ba85a740103);
$parcel$export(module.exports, "useEffectEvent", () => $ca5aff85a2f3333d$export$7f54fc3180508a52);
$parcel$export(module.exports, "isIndexOutOfListBounds", () => $ca5aff85a2f3333d$export$75effb89758ec596);
$parcel$export(module.exports, "getMinListIndex", () => $ca5aff85a2f3333d$export$53f691ee0acc6058);
$parcel$export(module.exports, "findNonDisabledListIndex", () => $ca5aff85a2f3333d$export$3fc3ea4a67cf714);
$parcel$export(module.exports, "getMaxListIndex", () => $ca5aff85a2f3333d$export$b585558af466e926);
$parcel$export(module.exports, "isListIndexDisabled", () => $ca5aff85a2f3333d$export$446656ed0410fd9);
$parcel$export(module.exports, "getGridNavigatedIndex", () => $ca5aff85a2f3333d$export$342fcce33a2688bc);
$parcel$export(module.exports, "createGridCellMap", () => $ca5aff85a2f3333d$export$5334c96856356f08);
$parcel$export(module.exports, "getGridCellIndexOfCorner", () => $ca5aff85a2f3333d$export$dab2b2ce7761f8e4);
$parcel$export(module.exports, "getGridCellIndices", () => $ca5aff85a2f3333d$export$50d8709b2ccc23f9);
$parcel$export(module.exports, "getTabbableOptions", () => $ca5aff85a2f3333d$export$6324a2bbae6a332f);
$parcel$export(module.exports, "getNextTabbable", () => $ca5aff85a2f3333d$export$28f33206776129a7);
$parcel$export(module.exports, "getPreviousTabbable", () => $ca5aff85a2f3333d$export$2e5518c3303f364a);
$parcel$export(module.exports, "isOutsideEvent", () => $ca5aff85a2f3333d$export$6e0c4e272f3faa2);
$parcel$export(module.exports, "disableFocusInside", () => $ca5aff85a2f3333d$export$3995dd353b80da11);
$parcel$export(module.exports, "enableFocusInside", () => $ca5aff85a2f3333d$export$a65f4028abb17f36);

var $1D9S2 = parcelRequire("1D9S2");

var $8NFma = parcelRequire("8NFma");

var $Euxde = parcelRequire("Euxde");

var $6X8j6 = parcelRequire("6X8j6");
// Avoid Chrome DevTools blue warning.
function $ca5aff85a2f3333d$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $ca5aff85a2f3333d$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $ca5aff85a2f3333d$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $ca5aff85a2f3333d$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($ca5aff85a2f3333d$export$867a782338812cb4()) || re.test($ca5aff85a2f3333d$export$7935961ef7719cb0());
}
function $ca5aff85a2f3333d$export$9ac100e40613ea10() {
    return $ca5aff85a2f3333d$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $ca5aff85a2f3333d$export$c8f880a2d81914c4() {
    return $ca5aff85a2f3333d$export$7935961ef7719cb0().includes('jsdom/');
}
const $ca5aff85a2f3333d$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $ca5aff85a2f3333d$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $ca5aff85a2f3333d$var$ARROW_LEFT = 'ArrowLeft';
const $ca5aff85a2f3333d$var$ARROW_RIGHT = 'ArrowRight';
const $ca5aff85a2f3333d$var$ARROW_UP = 'ArrowUp';
const $ca5aff85a2f3333d$var$ARROW_DOWN = 'ArrowDown';
function $ca5aff85a2f3333d$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $ca5aff85a2f3333d$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $1D9S2.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $ca5aff85a2f3333d$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $ca5aff85a2f3333d$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $ca5aff85a2f3333d$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $ca5aff85a2f3333d$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element) {
    return (0, $1D9S2.isHTMLElement)(element) && element.matches($ca5aff85a2f3333d$var$TYPEABLE_SELECTOR);
}
function $ca5aff85a2f3333d$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element);
}
function $ca5aff85a2f3333d$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $ca5aff85a2f3333d$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $ca5aff85a2f3333d$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($ca5aff85a2f3333d$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $ca5aff85a2f3333d$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $ca5aff85a2f3333d$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$ca5aff85a2f3333d$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $ca5aff85a2f3333d$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $ca5aff85a2f3333d$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $ca5aff85a2f3333d$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $ca5aff85a2f3333d$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $ca5aff85a2f3333d$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($ca5aff85a2f3333d$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $ca5aff85a2f3333d$export$29bf1b5f2c56cf63(event) {
    if ($ca5aff85a2f3333d$export$c8f880a2d81914c4()) return false;
    return !$ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $ca5aff85a2f3333d$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $ca5aff85a2f3333d$var$isClient = typeof document !== 'undefined';
var $ca5aff85a2f3333d$var$noop = function noop() {};
var $ca5aff85a2f3333d$export$bb3b3b3acfd7447f = $ca5aff85a2f3333d$var$isClient ? (0, $8NFma.useLayoutEffect) : $ca5aff85a2f3333d$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $ca5aff85a2f3333d$var$SafeReact = {
    ...$8NFma
};
function $ca5aff85a2f3333d$export$bcd07ba85a740103(value) {
    const ref = $8NFma.useRef(value);
    $ca5aff85a2f3333d$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $ca5aff85a2f3333d$var$useInsertionEffect = $ca5aff85a2f3333d$var$SafeReact.useInsertionEffect;
const $ca5aff85a2f3333d$var$useSafeInsertionEffect = $ca5aff85a2f3333d$var$useInsertionEffect || ((fn)=>fn());
function $ca5aff85a2f3333d$export$7f54fc3180508a52(callback) {
    const ref = $8NFma.useRef(()=>{});
    $ca5aff85a2f3333d$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $8NFma.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $ca5aff85a2f3333d$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $ca5aff85a2f3333d$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $ca5aff85a2f3333d$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $ca5aff85a2f3333d$export$b585558af466e926(listRef, disabledIndices) {
    return $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $ca5aff85a2f3333d$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $ca5aff85a2f3333d$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $ca5aff85a2f3333d$var$ARROW_UP) {
        stop && $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($ca5aff85a2f3333d$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $ca5aff85a2f3333d$var$ARROW_DOWN) {
        stop && $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($ca5aff85a2f3333d$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $Euxde.floor)(prevIndex / cols);
        if (event.key === (rtl ? $ca5aff85a2f3333d$var$ARROW_LEFT : $ca5aff85a2f3333d$var$ARROW_RIGHT)) {
            stop && $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $ca5aff85a2f3333d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($ca5aff85a2f3333d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $ca5aff85a2f3333d$var$ARROW_RIGHT : $ca5aff85a2f3333d$var$ARROW_LEFT)) {
            stop && $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $ca5aff85a2f3333d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($ca5aff85a2f3333d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $Euxde.floor)(maxIndex / cols) === prevRow;
        if ($ca5aff85a2f3333d$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $ca5aff85a2f3333d$var$ARROW_RIGHT : $ca5aff85a2f3333d$var$ARROW_LEFT) ? maxIndex : $ca5aff85a2f3333d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $ca5aff85a2f3333d$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $ca5aff85a2f3333d$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $ca5aff85a2f3333d$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $ca5aff85a2f3333d$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $ca5aff85a2f3333d$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $ca5aff85a2f3333d$var$getTabbableIn(container, dir) {
    const list = (0, $6X8j6.tabbable)(container, $ca5aff85a2f3333d$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $ca5aff85a2f3333d$export$da980962bd2147a4($ca5aff85a2f3333d$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $ca5aff85a2f3333d$export$28f33206776129a7(referenceElement) {
    return $ca5aff85a2f3333d$var$getTabbableIn($ca5aff85a2f3333d$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $ca5aff85a2f3333d$export$2e5518c3303f364a(referenceElement) {
    return $ca5aff85a2f3333d$var$getTabbableIn($ca5aff85a2f3333d$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $ca5aff85a2f3333d$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$ca5aff85a2f3333d$export$2344b14b097df817(containerElement, relatedTarget);
}
function $ca5aff85a2f3333d$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $6X8j6.tabbable)(container, $ca5aff85a2f3333d$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $ca5aff85a2f3333d$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}

});
parcelRegister("6X8j6", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $50feb264d5622a99$export$17100aea90429aa7);
$parcel$export(module.exports, "focusable", () => $50feb264d5622a99$export$ecc6d1fcdff4f700);
$parcel$export(module.exports, "isTabbable", () => $50feb264d5622a99$export$bebd5a1431fec25d);
/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $50feb264d5622a99$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $50feb264d5622a99$var$candidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.join(',');
var $50feb264d5622a99$var$NoElement = typeof Element === 'undefined';
var $50feb264d5622a99$var$matches = $50feb264d5622a99$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $50feb264d5622a99$var$getRootNode = !$50feb264d5622a99$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $50feb264d5622a99$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $50feb264d5622a99$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $50feb264d5622a99$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $50feb264d5622a99$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($50feb264d5622a99$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($50feb264d5622a99$var$candidateSelector));
    if (includeContainer && $50feb264d5622a99$var$matches.call(el, $50feb264d5622a99$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $50feb264d5622a99$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($50feb264d5622a99$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $50feb264d5622a99$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $50feb264d5622a99$var$matches.call(element, $50feb264d5622a99$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$50feb264d5622a99$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $50feb264d5622a99$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $50feb264d5622a99$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $50feb264d5622a99$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $50feb264d5622a99$var$isContentEditable(node)) && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $50feb264d5622a99$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $50feb264d5622a99$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $50feb264d5622a99$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $50feb264d5622a99$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $50feb264d5622a99$var$isHiddenInput = function isHiddenInput(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'hidden';
};
var $50feb264d5622a99$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $50feb264d5622a99$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $50feb264d5622a99$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $50feb264d5622a99$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $50feb264d5622a99$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $50feb264d5622a99$var$isRadio = function isRadio(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'radio';
};
var $50feb264d5622a99$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $50feb264d5622a99$var$isRadio(node) && !$50feb264d5622a99$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $50feb264d5622a99$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $50feb264d5622a99$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $50feb264d5622a99$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $50feb264d5622a99$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $50feb264d5622a99$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $50feb264d5622a99$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($50feb264d5622a99$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $50feb264d5622a99$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $50feb264d5622a99$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($50feb264d5622a99$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $50feb264d5622a99$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $50feb264d5622a99$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $50feb264d5622a99$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $50feb264d5622a99$var$isHiddenInput(node) || $50feb264d5622a99$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $50feb264d5622a99$var$isDetailsWithSummary(node) || $50feb264d5622a99$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($50feb264d5622a99$var$isNonTabbableRadio(node) || $50feb264d5622a99$export$a4672efddb4181b8(node) < 0 || !$50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $50feb264d5622a99$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $50feb264d5622a99$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $50feb264d5622a99$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $50feb264d5622a99$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($50feb264d5622a99$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $50feb264d5622a99$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $50feb264d5622a99$var$isShadowRootTabbable
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $50feb264d5622a99$var$_sortByOrder(candidates);
};
var $50feb264d5622a99$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $50feb264d5622a99$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$candidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorTabbable(options, node);
};
var $50feb264d5622a99$var$focusableCandidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $50feb264d5622a99$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$focusableCandidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node);
};

});




parcelRegister("edOXz", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $a5a9cf2826a935ca$export$f8168d8dd8fd66e6);

var $8NFma = parcelRequire("8NFma");
function $a5a9cf2826a935ca$export$f8168d8dd8fd66e6(removeOnPointerUp = true) {
    const [focus, _setFocus] = (0, $8NFma.useState)(false);
    const refRef = (0, $8NFma.useRef)();
    function setFocus(value) {
        if (value) refRef.current.focus();
        else refRef.current.blur();
    }
    const controllerRef = (0, $8NFma.useRef)(null);
    function setRef(ref) {
        if (ref == null) {
            controllerRef.current.abort();
            return;
        }
        refRef.current = ref;
        const controller = new AbortController();
        controllerRef.current = controller;
        ref.addEventListener("focus", ()=>_setFocus(true), {
            signal: controller.signal
        });
        ref.addEventListener("blur", ()=>_setFocus(false), {
            signal: controller.signal
        });
        if (removeOnPointerUp) document.addEventListener("pointerup", ()=>setFocus(false), {
            signal: controller.signal
        });
    }
    return {
        setRef: setRef,
        focus: focus,
        setFocus: setFocus
    };
}

});


parcelRegister("kPXWT", function(module, exports) {

$parcel$export(module.exports, "Enum2Columns", () => $82e3f62aeb429781$export$f4a6c62e14cc8dfb);

var $1IdZj = parcelRequire("1IdZj");

var $lClb7 = parcelRequire("lClb7");

var $4DYyh = parcelRequire("4DYyh");

var $7Kpeg = parcelRequire("7Kpeg");
parcelRequire("5ICqB");
const $82e3f62aeb429781$export$f4a6c62e14cc8dfb = ({ parameterHandler: parameterHandler })=>{
    const parameterValue = (0, $7Kpeg.useSelector)(parameterHandler.selector);
    const enumOptions = parameterHandler.description.options;
    const dispatch = (0, $7Kpeg.useDispatch)();
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "gruf-enum-2-columns",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4DYyh.RadioGroup), {
            children: enumOptions.map((option, index)=>{
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lClb7.RadioButton), {
                    checked: parameterValue == option,
                    onNewValue: (value)=>value && dispatch(parameterHandler.updater(option)),
                    children: option
                }, index);
            })
        })
    });
};

});

parcelRegister("1eLw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2b13c089e208291$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
function $a2b13c089e208291$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        width: 1,
        preserveAspectRatio: "none",
        viewBox: "-1 0 2 1",
        ...props,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            stroke: "currentColor",
            d: "M0 0v1",
            "vector-effect": "non-scaling-stroke"
        })
    });
}

});


parcelRegister("cITjR", function(module, exports) {

$parcel$export(module.exports, "HelpBox", () => $6c2da74fd1d19bb0$export$3a1d3541d81a142e);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $hI7EC = parcelRequire("hI7EC");

var $enQqi = parcelRequire("enQqi");

var $kmdF6 = parcelRequire("kmdF6");
function $6c2da74fd1d19bb0$export$94afc34dfbe08f53(el) {
    if (el.dataset && el.dataset.widgetId) return el.dataset.widgetId;
    if (el.parentNode) return $6c2da74fd1d19bb0$export$94afc34dfbe08f53(el.parentNode);
}
const $6c2da74fd1d19bb0$var$HelpBoxFrame = ({ ref: ref, className: className, children: children })=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ref: ref,
        "data-widget-id": "helpBox",
        style: {
            overflow: "hidden"
        },
        className: `gruf-modul ${className}`,
        children: children
    });
const $6c2da74fd1d19bb0$export$3a1d3541d81a142e = ({ className: className, style: style })=>{
    const [widgetID, setWidgetID] = (0, $8NFma.useState)();
    (0, $8NFma.useEffect)(()=>{
        const updateWidgetID = (e)=>setWidgetID($6c2da74fd1d19bb0$export$94afc34dfbe08f53(e.target));
        document.addEventListener("mousemove", updateWidgetID);
        document.addEventListener("focusin", updateWidgetID);
        return ()=>{
            document.removeEventListener("mousemove", updateWidgetID);
            document.removeEventListener("focusin", updateWidgetID);
        };
    }, []);
    const frameRef = (0, $8NFma.useRef)();
    function smoothScrollTo(element, endPos, speed, signal) {
        const startPos = element.scrollTop;
        const duration = Math.abs(endPos - startPos) / speed * 1000; // in milliseconds
        let startTime;
        let resolve, reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        function scrollStep(timestamp) {
            if (signal.aborted) return reject();
            startTime ??= timestamp;
            const elapsed = timestamp - startTime;
            if (elapsed >= duration) {
                element.scrollTop = endPos;
                return resolve();
            }
            element.scrollTop = (0, $kmdF6.lerp)(startPos, endPos, elapsed / duration);
            requestAnimationFrame(scrollStep);
        }
        requestAnimationFrame(scrollStep);
        return promise;
    }
    (0, $8NFma.useEffect)(()=>{
        if (frameRef.current == null) return;
        const height = frameRef.current.clientHeight;
        const scrollHeight = frameRef.current.scrollHeight;
        if (scrollHeight <= height) return;
        const controller = new AbortController();
        async function loop() {
            const staticTime = 2000;
            const speed = 10;
            try {
                // wait on top
                await (0, $enQqi.sleep)(staticTime, controller.signal);
                // scroll to bottom
                await smoothScrollTo(frameRef.current, scrollHeight - height, speed, controller.signal);
                // wait on bottom
                await (0, $enQqi.sleep)(staticTime, controller.signal);
                // scroll to top
                await smoothScrollTo(frameRef.current, 0, speed, controller.signal);
                loop();
            } catch  {
                return;
            }
        }
        loop();
        return ()=>controller.abort();
    }, [
        widgetID
    ]);
    if (!widgetID) return /*#__PURE__*/ (0, $1IdZj.jsx)($6c2da74fd1d19bb0$var$HelpBoxFrame, {
        className: className
    });
    const widgetTextData = (0, $hI7EC.widgetLegends)[widgetID];
    if (!widgetTextData) return /*#__PURE__*/ (0, $1IdZj.jsx)($6c2da74fd1d19bb0$var$HelpBoxFrame, {
        className: className
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($6c2da74fd1d19bb0$var$HelpBoxFrame, {
        ref: frameRef,
        className: className,
        children: [
            widgetTextData.title && /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                style: {
                    fontWeight: "bold"
                },
                children: [
                    widgetTextData.title.ca,
                    "."
                ]
            }),
            widgetTextData.description && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                children: " " + widgetTextData.description.ca
            })
        ]
    });
};

});

parcelRegister("6NH4g", function(module, exports) {

$parcel$export(module.exports, "PresetBankBar", () => $7f50539072ecb46a$export$e1f8540177d9c470);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
parcelRequire("7baak");

var $3Iyvj = parcelRequire("3Iyvj");
parcelRequire("i5EW2");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");

var $cU3m9 = parcelRequire("cU3m9");
var $cfEU5 = parcelRequire("cfEU5");

var $k0n2x = parcelRequire("k0n2x");

var $ba5Ec = parcelRequire("ba5Ec");

var $enQqi = parcelRequire("enQqi");
function $7f50539072ecb46a$export$e1f8540177d9c470({ className: className, instrument: instrument }) {
    const currentPresetID = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("presetID"));
    const presetBank = {
        ...(0, $7Kpeg.useSelector)((0, $5ICqB.selectPresets))
    };
    presetBank.init = {
        _metadata: {
            name: "Init",
            isFactory: true,
            instrumentType: instrument.metadata.tipus
        }
    };
    const currentPreset = presetBank[currentPresetID];
    const savedPresetsForInstrumentType = Object.fromEntries(Object.entries(presetBank).filter(([_id, { _metadata: { instrumentType: instrumentType, isUnsaved: isUnsaved } }])=>!isUnsaved && instrumentType === instrument.metadata.tipus));
    const dispatch = (0, $7Kpeg.useDispatch)();
    const [isDialogVisible, setIsDialogVisible] = (0, $8NFma.useState)(false);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: `${className} flex`,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)($7f50539072ecb46a$var$PresetMenu, {
                        "data-widget-id": "presetMenuTrigger",
                        currentPresetID: currentPresetID,
                        currentPreset: currentPreset,
                        instrumentID: instrument.id,
                        showNamePresetDialog: ()=>setIsDialogVisible(true)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3Iyvj.PresetDropdown), {
                        "data-widget-id": "presetSelect",
                        currentPresetID: currentPresetID,
                        onChange: (evt)=>dispatch((0, $5ICqB.loadPresetInInstrument)({
                                instrumentID: instrument.id,
                                presetID: evt.target.value
                            })),
                        instrumentType: instrument.metadata.tipus,
                        hideInit: true
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                        "data-widget-id": "presetSaveButton",
                        className: "btn btn-white w-30",
                        onClick: ()=>setIsDialogVisible(true),
                        disabled: !currentPreset._metadata.isUnsaved,
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cfEU5.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($7f50539072ecb46a$var$NamePresetDialog, {
                isVisible: isDialogVisible,
                setIsVisible: setIsDialogVisible,
                presetName: currentPreset._metadata.name,
                presetID: currentPresetID,
                savedPresetsForInstrumentType: savedPresetsForInstrumentType
            })
        ]
    });
}
// Per anomenar i reanomenar presets
// (name és un verb en aquest cas i em confón una mica, encara que no he trobat una millor alternativa)
function $7f50539072ecb46a$var$NamePresetDialog({ isVisible: isVisible, setIsVisible: setIsVisible, presetName: presetName, presetID: presetID, savedPresetsForInstrumentType: savedPresetsForInstrumentType }) {
    const [tmpName, setTmpName] = (0, $8NFma.useState)("");
    const name = tmpName.trim();
    const overwrittenID = Object.entries(savedPresetsForInstrumentType).find(([id, { _metadata: { name: candidateName } }])=>id !== presetID && name === candidateName)?.[0];
    const inputRef = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        if (!isVisible) return;
        setTmpName(presetName);
        const timeout = setTimeout(()=>inputRef.current.select(), 100);
        return ()=>clearTimeout(timeout);
    }, [
        isVisible
    ]);
    function isNameValid() {
        if (name.length == 0) return false;
        if (Object.values(savedPresetsForInstrumentType).filter(({ _metadata: _metadata })=>_metadata.isFactory).map(({ _metadata: _metadata })=>_metadata.name).includes(name)) return false;
        if (name.endsWith("*")) return false; // aquest és el símbol que fem servir per presets sense guardar
        return true;
    }
    const dispatch = (0, $7Kpeg.useDispatch)();
    const [isConfirmDialogVisible, setIsConfirmDialogVisible] = (0, $8NFma.useState)(false);
    function confirm() {
        dispatch((0, $5ICqB.savePreset)({
            presetID: presetID,
            name: name,
            overwrittenID: overwrittenID
        }));
        setIsVisible(false);
    }
    function commitPresetName() {
        if (!isNameValid()) return;
        if (overwrittenID != null) return setIsConfirmDialogVisible(true);
        confirm();
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $k0n2x.Dialog), {
                className: "preset-save-dialog",
                visible: isVisible,
                onHide: ()=>setIsVisible(false),
                draggable: false,
                resizable: false,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                        children: "Anomena el preset"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        onKeyDown: (e)=>e.key === "Enter" && commitPresetName(),
                        ref: inputRef,
                        value: tmpName,
                        onChange: (e)=>setTmpName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                        className: "btn btn-white",
                        disabled: !isNameValid(),
                        onClick: commitPresetName,
                        children: "OK"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $k0n2x.Dialog), {
                className: "confirm-dialog",
                visible: isConfirmDialogVisible,
                onHide: ()=>setIsConfirmDialogVisible(false),
                draggable: false,
                resizable: false,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                        children: "Confirma"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                        children: [
                            'Ja existeix un preset amb el nom "',
                            name,
                            '". El vols sobrescriure?'
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "confirm-btns",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                className: "btn btn-white",
                                onClick: ()=>{
                                    setIsConfirmDialogVisible(false);
                                },
                                children: "No"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                className: "btn btn-white",
                                onClick: ()=>{
                                    setIsConfirmDialogVisible(false);
                                    confirm();
                                },
                                children: "S\xed"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $7f50539072ecb46a$var$PresetMenu({ currentPresetID: currentPresetID, currentPreset: currentPreset, instrumentID: instrumentID, showNamePresetDialog: showNamePresetDialog, ...props }) {
    const isCurrentPresetFactory = currentPreset._metadata.isFactory;
    const isCurrentPresetMetadataModifiable = !(currentPreset._metadata.isUnsaved || isCurrentPresetFactory);
    const isDisabled = currentPresetID === "init";
    const [isOpen, setIsOpen] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        setIsOpen;
    }, [
        isDisabled
    ]);
    const dispatch = (0, $7Kpeg.useDispatch)();
    function initialize() {
        dispatch((0, $5ICqB.loadPresetInInstrument)({
            instrumentID: instrumentID,
            presetID: "init"
        }));
    }
    function exportCurrentPreset() {
        const preset = {
            ...currentPreset,
            _metadata: {
                ...currentPreset._metadata
            }
        };
        const name = preset._metadata.name;
        delete preset._metadata.isSaved;
        delete preset._metadata.isFactory;
        delete preset._metadata.name;
        (0, $enQqi.downloadObjectAsJson)(preset, name, ".grufpreset");
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $ba5Ec).Root, {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Trigger, {
                className: "btn btn-white w-30",
                disabled: isDisabled,
                ...props,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cU3m9.default), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Portal, {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Positioner, {
                    align: "start",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $ba5Ec).Popup, {
                        className: "menu",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    onClick: initialize,
                                    children: "Carrega els valors per defecte"
                                })
                            }),
                            !isCurrentPresetFactory && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    onClick: exportCurrentPreset,
                                    children: "Exporta"
                                })
                            }),
                            isCurrentPresetMetadataModifiable && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    onClick: showNamePresetDialog,
                                    children: "Reanomena"
                                })
                            }),
                            isCurrentPresetMetadataModifiable && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ba5Ec).Item, {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    onClick: ()=>dispatch((0, $5ICqB.deletePreset)({
                                            presetID: currentPresetID
                                        })),
                                    children: "Elimina"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}

});
parcelRegister("3Iyvj", function(module, exports) {

$parcel$export(module.exports, "PresetDropdown", () => $532549254f964a7f$export$1516fe7cdd49764e);

var $1IdZj = parcelRequire("1IdZj");

var $9lLIM = parcelRequire("9lLIM");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");
function $532549254f964a7f$export$1516fe7cdd49764e({ instrumentType: instrumentType, currentPresetID: currentPresetID, onChange: onChange, hideInit: hideInit, ...props }) {
    const presetBank = {
        ...(0, $7Kpeg.useSelector)((0, $5ICqB.selectPresets))
    };
    presetBank.init = {
        _metadata: {
            name: "Init",
            isFactory: true,
            instrumentType: instrumentType
        }
    };
    const currentPreset = presetBank[currentPresetID];
    const savedPresetsForInstrumentType = Object.fromEntries(Object.entries(presetBank).filter(([_id, { _metadata: { instrumentType: pInstrumentType, isUnsaved: isUnsaved } }])=>!isUnsaved && pInstrumentType === instrumentType));
    const valueTemplate = ()=>{
        const { name: name, isUnsaved: isUnsaved } = currentPreset._metadata;
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
            children: [
                name,
                isUnsaved ? "*" : ""
            ]
        });
    };
    const traduccions = {
        custom: 'Personalitzat',
        factory: "F\xe0brica"
    }; // todo: fer servir la manera real d'aconseguir les tradus
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9lLIM.Dropdown), {
        ...props,
        value: currentPresetID,
        onChange: onChange,
        options: Object.entries(Object.entries(savedPresetsForInstrumentType).reduce((acc, cur)=>{
            const [id, { _metadata: { name: name, isFactory: isFactory } }] = cur;
            if (hideInit && id === "init") return acc;
            const group = isFactory ? "factory" : "custom";
            acc[group] ??= [];
            acc[group].push({
                value: id,
                name: name
            });
            return acc;
        }, {})).sort(([groupName1, _1], [groupName2, _2])=>groupName1 < groupName2 ? -1 : 1) // així veiem custom abans de factory
        .map(([groupName, items])=>({
                label: groupName,
                items: items
            })),
        valueTemplate: valueTemplate,
        itemTemplate: (option)=>/*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                children: option.name
            }),
        optionGroupTemplate: (group)=>/*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                children: traduccions[group.label]
            }),
        optionGroupLabel: "label"
    });
}

});
parcelRegister("9lLIM", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $6ceb17a9faf5d2a9$export$931cbfb6bfb85fc);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $64a8q = parcelRequire("64a8q");

var $kocnD = parcelRequire("kocnD");

var $7Hg4o = parcelRequire("7Hg4o");

var $forNC = parcelRequire("forNC");

var $6rN57 = parcelRequire("6rN57");

var $gMyz9 = parcelRequire("gMyz9");

var $dnd0Z = parcelRequire("dnd0Z");

var $7dgG7 = parcelRequire("7dgG7");

var $kMhUd = parcelRequire("kMhUd");

var $cknS9 = parcelRequire("cknS9");

var $ixBc2 = parcelRequire("ixBc2");

var $bKF0T = parcelRequire("bKF0T");

var $ex9Xv = parcelRequire("ex9Xv");

var $cLCHn = parcelRequire("cLCHn");

var $gcC5Z = parcelRequire("gcC5Z");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $6ceb17a9faf5d2a9$var$_extends() {
    return $6ceb17a9faf5d2a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6ceb17a9faf5d2a9$var$_extends.apply(null, arguments);
}
function $6ceb17a9faf5d2a9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6ceb17a9faf5d2a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ceb17a9faf5d2a9$var$_typeof(o);
}
function $6ceb17a9faf5d2a9$var$toPrimitive(t, r) {
    if ("object" != $6ceb17a9faf5d2a9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6ceb17a9faf5d2a9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6ceb17a9faf5d2a9$var$toPropertyKey(t) {
    var i = $6ceb17a9faf5d2a9$var$toPrimitive(t, "string");
    return "symbol" == $6ceb17a9faf5d2a9$var$_typeof(i) ? i : i + "";
}
function $6ceb17a9faf5d2a9$var$_defineProperty(e, r, t) {
    return (r = $6ceb17a9faf5d2a9$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6ceb17a9faf5d2a9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $6ceb17a9faf5d2a9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6ceb17a9faf5d2a9$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6ceb17a9faf5d2a9$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $6ceb17a9faf5d2a9$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6ceb17a9faf5d2a9$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $6ceb17a9faf5d2a9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ceb17a9faf5d2a9$var$_slicedToArray(r, e) {
    return $6ceb17a9faf5d2a9$var$_arrayWithHoles(r) || $6ceb17a9faf5d2a9$var$_iterableToArrayLimit(r, e) || $6ceb17a9faf5d2a9$var$_unsupportedIterableToArray$1(r, e) || $6ceb17a9faf5d2a9$var$_nonIterableRest();
}
function $6ceb17a9faf5d2a9$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ceb17a9faf5d2a9$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ceb17a9faf5d2a9$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $6ceb17a9faf5d2a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ceb17a9faf5d2a9$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6ceb17a9faf5d2a9$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, overlayVisibleState = _ref.overlayVisibleState, context = _ref.context;
        return (0, $kMhUd.classNames)('p-dropdown p-component p-inputwrapper', {
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-focus': focusedState,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled',
            'p-dropdown-clearable': props.showClear && !props.disabled,
            'p-inputwrapper-filled': (0, $kMhUd.ObjectUtils).isNotEmpty(props.value),
            'p-inputwrapper-focus': focusedState || overlayVisibleState
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, label = _ref2.label;
        return props.editable ? 'p-dropdown-label p-inputtext' : (0, $kMhUd.classNames)('p-dropdown-label p-inputtext', {
            'p-placeholder': label === null && props.placeholder,
            'p-dropdown-label-empty': label === null && !props.placeholder
        });
    },
    trigger: 'p-dropdown-trigger',
    emptyMessage: 'p-dropdown-empty-message',
    itemGroup: function itemGroup(_ref3) {
        var optionGroupLabel = _ref3.optionGroupLabel;
        return (0, $kMhUd.classNames)('p-dropdown-item-group', {
            'p-dropdown-item-empty': !optionGroupLabel || optionGroupLabel.length === 0
        });
    },
    itemGroupLabel: 'p-dropdown-item-group-label',
    dropdownIcon: 'p-dropdown-trigger-icon p-clickable',
    loadingIcon: 'p-dropdown-trigger-icon p-clickable',
    clearIcon: 'p-dropdown-clear-icon p-clickable',
    filterIcon: 'p-dropdown-filter-icon',
    filterClearIcon: 'p-dropdown-filter-clear-icon',
    filterContainer: function filterContainer(_ref4) {
        var clearIcon = _ref4.clearIcon;
        return (0, $kMhUd.classNames)('p-dropdown-filter-container', {
            'p-dropdown-clearable-filter': !!clearIcon
        });
    },
    filterInput: function filterInput(_ref5) {
        var props = _ref5.props, context = _ref5.context;
        return (0, $kMhUd.classNames)('p-dropdown-filter p-inputtext p-component', {
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    list: function list(_ref6) {
        var virtualScrollerOptions = _ref6.virtualScrollerOptions;
        return virtualScrollerOptions ? 'p-dropdown-items' : 'p-dropdown-items';
    },
    panel: function panel(_ref7) {
        var context = _ref7.context;
        return (0, $kMhUd.classNames)('p-dropdown-panel p-component', {
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $eGEKG.default).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $eGEKG.default).ripple === false
        });
    },
    item: function item(_ref8) {
        var selected = _ref8.selected, disabled = _ref8.disabled, label = _ref8.label, index = _ref8.index, focusedOptionIndex = _ref8.focusedOptionIndex, highlightOnSelect = _ref8.highlightOnSelect;
        return (0, $kMhUd.classNames)('p-dropdown-item', {
            'p-highlight': selected && highlightOnSelect,
            'p-disabled': disabled,
            'p-focus': index === focusedOptionIndex,
            'p-dropdown-item-empty': !label || label.length === 0
        });
    },
    itemLabel: 'p-dropdown-item-label',
    checkIcon: 'p-dropdown-check-icon',
    blankIcon: 'p-dropdown-blank-icon',
    wrapper: 'p-dropdown-items-wrapper',
    header: 'p-dropdown-header',
    footer: 'p-dropdown-footer',
    transition: 'p-connected-overlay'
};
var $6ceb17a9faf5d2a9$var$styles = "\n@layer primereact {\n    .p-dropdown {\n        display: inline-flex;\n        cursor: pointer;\n        position: relative;\n        user-select: none;\n    }\n    \n    .p-dropdown-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n    \n    .p-dropdown-label {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        flex: 1 1 auto;\n        width: 1%;\n        text-overflow: ellipsis;\n        cursor: pointer;\n    }\n    \n    .p-dropdown-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n    \n    input.p-dropdown-label  {\n        cursor: default;\n    }\n    \n    .p-dropdown .p-dropdown-panel {\n        min-width: 100%;\n    }\n    \n    .p-dropdown-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-dropdown-items-wrapper {\n        overflow: auto;\n    }\n    \n    .p-dropdown-item {\n        cursor: pointer;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-dropdown-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-dropdown-filter {\n        width: 100%;\n    }\n    \n    .p-dropdown-filter-container {\n        position: relative;\n    }\n    \n    .p-dropdown-clear-icon,\n    .p-dropdown-filter-icon,\n    .p-dropdown-filter-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n        right: 2rem;\n    }\n    \n    .p-fluid .p-dropdown {\n        display: flex;\n    }\n    \n    .p-fluid .p-dropdown .p-dropdown-label {\n        width: 1%;\n    }\n}\n";
var $6ceb17a9faf5d2a9$var$inlineStyles = {
    wrapper: function wrapper(_ref9) {
        var props = _ref9.props;
        return {
            maxHeight: props.scrollHeight || 'auto'
        };
    },
    panel: function panel(_ref10) {
        var props = _ref10.props;
        return $6ceb17a9faf5d2a9$var$_objectSpread$2({}, props.panelStyle);
    }
};
var $6ceb17a9faf5d2a9$var$DropdownBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Dropdown',
        __parentMetadata: null,
        appendTo: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        autoFocus: false,
        autoOptionFocus: false,
        checkmark: false,
        children: undefined,
        className: null,
        clearIcon: null,
        collapseIcon: null,
        dataKey: null,
        disabled: false,
        dropdownIcon: null,
        editable: false,
        emptyFilterMessage: null,
        emptyMessage: null,
        filter: false,
        filterBy: null,
        filterClearIcon: null,
        filterDelay: 300,
        filterIcon: null,
        filterInputAutoFocus: false,
        filterLocale: undefined,
        filterMatchMode: 'contains',
        filterPlaceholder: null,
        filterTemplate: null,
        focusInputRef: null,
        focusOnHover: true,
        highlightOnSelect: true,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        itemTemplate: null,
        loading: false,
        loadingIcon: null,
        maxLength: null,
        name: null,
        onBlur: null,
        onChange: null,
        onClick: null,
        onContextMenu: null,
        onFilter: null,
        onFocus: null,
        onHide: null,
        onMouseDown: null,
        onShow: null,
        optionDisabled: null,
        optionGroupChildren: 'items',
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        options: null,
        optionValue: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        required: false,
        resetFilterOnHide: false,
        scrollHeight: '200px',
        selectOnFocus: false,
        showClear: false,
        showFilterClear: false,
        showOnFocus: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        useOptionAsValue: false,
        value: null,
        valueTemplate: null,
        variant: null,
        virtualScrollerOptions: null
    },
    css: {
        classes: $6ceb17a9faf5d2a9$var$classes,
        styles: $6ceb17a9faf5d2a9$var$styles,
        inlineStyles: $6ceb17a9faf5d2a9$var$inlineStyles
    }
});
var $6ceb17a9faf5d2a9$var$BlankIcon = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $6ceb17a9faf5d2a9$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("rect", {
        width: "1",
        height: "1",
        fill: "currentColor",
        fillOpacity: "0"
    }));
}));
$6ceb17a9faf5d2a9$var$BlankIcon.displayName = 'BlankIcon';
var $6ceb17a9faf5d2a9$var$DropdownItem = /*#__PURE__*/ $8NFma.memo(function(props) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, selected = props.selected, disabled = props.disabled, option = props.option, label = props.label, index = props.index, focusedOptionIndex = props.focusedOptionIndex, ariaSetSize = props.ariaSetSize, checkmark = props.checkmark, highlightOnSelect = props.highlightOnSelect, onInputKeyDown = props.onInputKeyDown;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            context: {
                selected: selected,
                disabled: disabled,
                focused: index === focusedOptionIndex
            }
        });
    };
    var _onClick = function onClick(event, i) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: option
        });
    };
    var content = props.template ? (0, $kMhUd.ObjectUtils).getJSXElement(props.template, props.option) : props.label;
    var itemProps = mergeProps({
        id: "dropdownItem_".concat(index),
        role: 'option',
        className: (0, $kMhUd.classNames)(option.className, cx('item', {
            selected: selected,
            disabled: disabled,
            label: label,
            index: index,
            focusedOptionIndex: focusedOptionIndex,
            highlightOnSelect: highlightOnSelect
        })),
        style: props.style,
        tabIndex: 0,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            return onInputKeyDown(e);
        },
        onMouseMove: function onMouseMove(e) {
            return props === null || props === void 0 ? void 0 : props.onMouseMove(e, index);
        },
        'aria-setsize': ariaSetSize,
        'aria-posinset': index + 1,
        'aria-label': label,
        'aria-selected': selected,
        'data-p-highlight': selected,
        'data-p-focused': focusedOptionIndex === index,
        'data-p-disabled': disabled
    }, getPTOptions('item'));
    var itemGroupLabelProps = mergeProps({
        className: cx('itemLabel')
    }, getPTOptions('itemLabel'));
    var iconRenderer = function iconRenderer() {
        if (selected) {
            var checkIconProps = mergeProps({
                className: cx('checkIcon')
            }, getPTOptions('checkIcon'));
            return /*#__PURE__*/ $8NFma.createElement((0, $gcC5Z.CheckIcon), checkIconProps);
        }
        var blankIconProps = mergeProps({
            className: cx('blankIcon')
        }, getPTOptions('blankIcon'));
        return /*#__PURE__*/ $8NFma.createElement($6ceb17a9faf5d2a9$var$BlankIcon, blankIconProps);
    };
    return /*#__PURE__*/ $8NFma.createElement("li", $6ceb17a9faf5d2a9$var$_extends({
        key: props.label
    }, itemProps), checkmark && iconRenderer(), /*#__PURE__*/ $8NFma.createElement("span", itemGroupLabelProps, content), /*#__PURE__*/ $8NFma.createElement((0, $cLCHn.Ripple), null));
});
$6ceb17a9faf5d2a9$var$DropdownItem.displayName = 'DropdownItem';
function $6ceb17a9faf5d2a9$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ceb17a9faf5d2a9$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ceb17a9faf5d2a9$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $6ceb17a9faf5d2a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ceb17a9faf5d2a9$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6ceb17a9faf5d2a9$var$DropdownPanel = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(props, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var filterInputRef = $8NFma.useRef(null);
    var isEmptyFilter = !(props.visibleOptions && props.visibleOptions.length) && props.hasFilter;
    var ariaSetSize = props.visibleOptions ? props.visibleOptions.length : 0;
    var filterOptions = {
        filter: function filter(e) {
            return onFilterInputChange(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $6ceb17a9faf5d2a9$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onEnter = function onEnter() {
        props.onEnter(function() {
            if (props.virtualScrollerRef.current) {
                var selectedIndex = props.getSelectedOptionIndex();
                if (selectedIndex !== -1) setTimeout(function() {
                    return props.virtualScrollerRef.current.scrollToIndex(selectedIndex);
                }, 0);
            }
        });
    };
    var onEntered = function onEntered() {
        props.onEntered(function() {
            if (props.filter && props.filterInputAutoFocus) (0, $kMhUd.DomHandler).focus(filterInputRef.current, false);
        });
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        props.onFilterInputChange && props.onFilterInputChange(event);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $kMhUd.ObjectUtils).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx('footer')
            }, getPTOptions('footer'));
            return /*#__PURE__*/ $8NFma.createElement("div", footerProps, content);
        }
        return null;
    };
    var changeFocusedItemOnHover = function changeFocusedItemOnHover(event, index) {
        if (props.focusOnHover) {
            var _props$changeFocusedO;
            props === null || props === void 0 || (_props$changeFocusedO = props.changeFocusedOptionIndex) === null || _props$changeFocusedO === void 0 || _props$changeFocusedO.call(props, event, index);
        }
    };
    var createEmptyMessage = function createEmptyMessage(emptyMessage, isFilter) {
        var message = (0, $kMhUd.ObjectUtils).getJSXElement(emptyMessage, props) || (0, $eGEKG.localeOption)(isFilter ? 'emptyFilterMessage' : 'emptyMessage');
        var emptyMessageProps = mergeProps({
            className: cx('emptyMessage')
        }, getPTOptions('emptyMessage'));
        return /*#__PURE__*/ $8NFma.createElement("li", emptyMessageProps, message);
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        style = $6ceb17a9faf5d2a9$var$_objectSpread$1($6ceb17a9faf5d2a9$var$_objectSpread$1({}, style), option.style);
        if (option.group && props.optionGroupLabel) {
            var optionGroupLabel = props.optionGroupLabel;
            var groupContent = props.optionGroupTemplate ? (0, $kMhUd.ObjectUtils).getJSXElement(props.optionGroupTemplate, option, index) : props.getOptionGroupLabel(option);
            var key = index + '_' + props.getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: cx('itemGroup', {
                    optionGroupLabel: optionGroupLabel
                }),
                style: style,
                'data-p-highlight': props.selected
            }, getPTOptions('itemGroup'));
            var itemGroupLabelProps = mergeProps({
                className: cx('itemGroupLabel')
            }, getPTOptions('itemGroupLabel'));
            return /*#__PURE__*/ $8NFma.createElement("li", $6ceb17a9faf5d2a9$var$_extends({
                key: key
            }, itemGroupProps), /*#__PURE__*/ $8NFma.createElement("span", itemGroupLabelProps, groupContent));
        }
        var optionKey = props.getOptionRenderKey(option) + '_' + index;
        var optionLabel = props.getOptionLabel(option);
        var disabled = props.isOptionDisabled(option);
        return /*#__PURE__*/ $8NFma.createElement($6ceb17a9faf5d2a9$var$DropdownItem, {
            key: optionKey,
            label: optionLabel,
            index: index,
            focusedOptionIndex: props.focusedOptionIndex,
            option: option,
            ariaSetSize: ariaSetSize,
            onInputKeyDown: props.onInputKeyDown,
            style: style,
            template: props.itemTemplate,
            selected: props.isSelected(option),
            highlightOnSelect: props.highlightOnSelect,
            disabled: disabled,
            onClick: props.onOptionClick,
            onMouseMove: changeFocusedItemOnHover,
            ptm: ptm,
            cx: cx,
            checkmark: props.checkmark
        });
    };
    var createItems = function createItems() {
        if ((0, $kMhUd.ObjectUtils).isNotEmpty(props.visibleOptions)) return props.visibleOptions.map(createItem);
        else if (props.hasFilter) return createEmptyMessage(props.emptyFilterMessage, true);
        return createEmptyMessage(props.emptyMessage);
    };
    var createFilterClearIcon = function createFilterClearIcon() {
        if (props.showFilterClear && props.filterValue) {
            var ariaLabelFilterClear = (0, $eGEKG.localeOption)('clear');
            var clearIconProps = mergeProps({
                className: cx('filterClearIcon'),
                'aria-label': ariaLabelFilterClear,
                onClick: function onClick() {
                    return props.onFilterClearIconClick(function() {
                        return (0, $kMhUd.DomHandler).focus(filterInputRef.current);
                    });
                }
            }, getPTOptions('filterClearIcon'));
            var icon = props.filterClearIcon || /*#__PURE__*/ $8NFma.createElement((0, $gMyz9.TimesIcon), clearIconProps);
            var filterClearIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $6ceb17a9faf5d2a9$var$_objectSpread$1({}, clearIconProps), {
                props: props
            });
            return filterClearIcon;
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filter) {
            var clearIcon = createFilterClearIcon();
            var filterIconProps = mergeProps({
                className: cx('filterIcon')
            }, getPTOptions('filterIcon'));
            var icon = props.filterIcon || /*#__PURE__*/ $8NFma.createElement((0, $ixBc2.SearchIcon), filterIconProps);
            var filterIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $6ceb17a9faf5d2a9$var$_objectSpread$1({}, filterIconProps), {
                props: props
            });
            var filterContainerProps = mergeProps({
                className: cx('filterContainer', {
                    clearIcon: clearIcon
                })
            }, getPTOptions('filterContainer'));
            var filterInputProps = mergeProps({
                ref: filterInputRef,
                type: 'text',
                autoComplete: 'off',
                className: cx('filterInput', {
                    context: context
                }),
                placeholder: props.filterPlaceholder,
                onKeyDown: props.onFilterInputKeyDown,
                onChange: function onChange(e) {
                    return onFilterInputChange(e);
                },
                value: props.filterValue
            }, getPTOptions('filterInput'));
            var content = /*#__PURE__*/ $8NFma.createElement("div", filterContainerProps, /*#__PURE__*/ $8NFma.createElement("input", filterInputProps), clearIcon, filterIcon);
            if (props.filterTemplate) {
                var defaultContentOptions = {
                    className: (0, $kMhUd.classNames)('p-dropdown-filter-container', {
                        'p-dropdown-clearable-filter': !!clearIcon
                    }),
                    element: content,
                    filterOptions: filterOptions,
                    filterInputKeyDown: props.onFilterInputKeyDown,
                    filterInputChange: onFilterInputChange,
                    filterIconClassName: 'p-dropdown-filter-icon',
                    clearIcon: clearIcon,
                    props: props
                };
                content = (0, $kMhUd.ObjectUtils).getJSXElement(props.filterTemplate, defaultContentOptions);
            }
            var headerProps = mergeProps({
                className: cx('header')
            }, getPTOptions('header'));
            return /*#__PURE__*/ $8NFma.createElement("div", headerProps, content);
        }
        return null;
    };
    var createContent = function createContent() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $6ceb17a9faf5d2a9$var$_objectSpread$1($6ceb17a9faf5d2a9$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $6ceb17a9faf5d2a9$var$_objectSpread$1($6ceb17a9faf5d2a9$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                className: (0, $kMhUd.classNames)('p-dropdown-items-wrapper', props.virtualScrollerOptions.className),
                items: props.visibleOptions,
                autoSize: true,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($6ceb17a9faf5d2a9$var$_objectSpread$1($6ceb17a9faf5d2a9$var$_objectSpread$1({}, event), {
                        filter: props.filterValue
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var children = options.children || [];
                    var emptyMessage = props.hasFilter ? props.emptyFilterMessage : props.emptyMessage;
                    var content = isEmptyFilter || (children === null || children === void 0 ? void 0 : children.length) === 0 ? createEmptyMessage(emptyMessage) : children;
                    var listProps = mergeProps({
                        ref: options.contentRef,
                        style: options.style,
                        className: (0, $kMhUd.classNames)(options.className, cx('list', {
                            virtualScrollerProps: props.virtualScrollerOptions
                        })),
                        role: 'listbox',
                        'aria-label': (0, $eGEKG.ariaLabel)('listLabel')
                    }, getPTOptions('list'));
                    return /*#__PURE__*/ $8NFma.createElement("ul", listProps, content);
                }
            });
            return /*#__PURE__*/ $8NFma.createElement((0, $ex9Xv.VirtualScroller), $6ceb17a9faf5d2a9$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptm('virtualScroller')
            }));
        }
        var items = createItems();
        var wrapperProps = mergeProps({
            className: cx('wrapper'),
            style: sx('wrapper')
        }, getPTOptions('wrapper'));
        var listProps = mergeProps({
            className: cx('list'),
            role: 'listbox',
            'aria-label': (0, $eGEKG.ariaLabel)('listLabel')
        }, getPTOptions('list'));
        return /*#__PURE__*/ $8NFma.createElement("div", wrapperProps, /*#__PURE__*/ $8NFma.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var filter = createFilter();
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $kMhUd.classNames)(props.panelClassName, cx('panel', {
                context: context
            })),
            style: sx('panel'),
            onClick: props.onClick,
            'data-pr-is-overlay': true
        }, getPTOptions('panel'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, getPTOptions('transition'));
        return /*#__PURE__*/ $8NFma.createElement((0, $cknS9.CSSTransition), $6ceb17a9faf5d2a9$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $8NFma.createElement("div", $6ceb17a9faf5d2a9$var$_extends({
            ref: ref
        }, panelProps), props.firstFocusableElement, filter, content, footer, props.lastFocusableElement));
    };
    var element = createElement();
    return /*#__PURE__*/ $8NFma.createElement((0, $bKF0T.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$6ceb17a9faf5d2a9$var$DropdownPanel.displayName = 'DropdownPanel';
function $6ceb17a9faf5d2a9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6ceb17a9faf5d2a9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6ceb17a9faf5d2a9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6ceb17a9faf5d2a9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6ceb17a9faf5d2a9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6ceb17a9faf5d2a9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6ceb17a9faf5d2a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ceb17a9faf5d2a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ceb17a9faf5d2a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6ceb17a9faf5d2a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ceb17a9faf5d2a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6ceb17a9faf5d2a9$export$931cbfb6bfb85fc = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $6ceb17a9faf5d2a9$var$DropdownBase.getProps(inProps, context);
    var _useDebounce = (0, $kocnD.useDebounce)('', props.filterDelay || 0), _useDebounce2 = $6ceb17a9faf5d2a9$var$_slicedToArray(_useDebounce, 3), filterValue = _useDebounce2[0], filterState = _useDebounce2[1], setFilterState = _useDebounce2[2];
    var _React$useState = $8NFma.useState(false), _React$useState2 = $6ceb17a9faf5d2a9$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $8NFma.useState(-1), _React$useState4 = $6ceb17a9faf5d2a9$var$_slicedToArray(_React$useState3, 2), focusedOptionIndex = _React$useState4[0], setFocusedOptionIndex = _React$useState4[1];
    var _React$useState5 = $8NFma.useState(false), _React$useState6 = $6ceb17a9faf5d2a9$var$_slicedToArray(_React$useState5, 2), overlayVisibleState = _React$useState6[0], setOverlayVisibleState = _React$useState6[1];
    var clickedRef = $8NFma.useRef(false);
    var elementRef = $8NFma.useRef(null);
    var overlayRef = $8NFma.useRef(null);
    var firstHiddenFocusableElementOnOverlay = $8NFma.useRef(null);
    var lastHiddenFocusableElementOnOverlay = $8NFma.useRef(null);
    var inputRef = $8NFma.useRef(props.inputRef);
    var focusInputRef = $8NFma.useRef(props.focusInputRef);
    var virtualScrollerRef = $8NFma.useRef(null);
    var searchTimeout = $8NFma.useRef(null);
    var searchValue = $8NFma.useRef(null);
    var isLazy = props.virtualScrollerOptions && props.virtualScrollerOptions.lazy;
    var hasFilter = (0, $kMhUd.ObjectUtils).isNotEmpty(filterState);
    var appendTo = props.appendTo || context && context.appendTo || (0, $eGEKG.default).appendTo;
    var _DropdownBase$setMeta = $6ceb17a9faf5d2a9$var$DropdownBase.setMetaData($6ceb17a9faf5d2a9$var$_objectSpread($6ceb17a9faf5d2a9$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            filter: filterState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    })), ptm = _DropdownBase$setMeta.ptm, cx = _DropdownBase$setMeta.cx, sx = _DropdownBase$setMeta.sx, isUnstyled = _DropdownBase$setMeta.isUnstyled;
    (0, $64a8q.useHandleStyle)($6ceb17a9faf5d2a9$var$DropdownBase.css.styles, isUnstyled, {
        name: 'dropdown'
    });
    var _useOverlayListener = (0, $kocnD.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) {
                if (type === 'outside') {
                    if (!isClearClicked(event)) hide();
                } else if (context.hideOverlaysOnDocumentScrolling) hide();
                else if (!(0, $kMhUd.DomHandler).isDocument(event.target)) alignOverlay();
            }
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $6ceb17a9faf5d2a9$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push($6ceb17a9faf5d2a9$var$_objectSpread($6ceb17a9faf5d2a9$var$_objectSpread({}, option), {}, {
                group: true,
                index: index
            }));
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter && !isLazy) {
            var _filterValue = filterState.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(',') : [
                props.optionLabel || 'label'
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator = $6ceb17a9faf5d2a9$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optgroup = _step.value;
                        var filteredSubOptions = (0, $eGEKG.FilterService).filter(getOptionGroupChildren(optgroup), searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($6ceb17a9faf5d2a9$var$_objectSpread($6ceb17a9faf5d2a9$var$_objectSpread({}, optgroup), $6ceb17a9faf5d2a9$var$_defineProperty({}, "".concat(props.optionGroupChildren), filteredSubOptions)));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $eGEKG.FilterService).filter(options, searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var onFirstHiddenFocus = function onFirstHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $kMhUd.DomHandler).getFirstFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $kMhUd.DomHandler).focus(focusableEl);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $kMhUd.DomHandler).getLastFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $kMhUd.DomHandler).focus(focusableEl);
    };
    var isClearClicked = function isClearClicked(event) {
        return (0, $kMhUd.DomHandler).isAttributeEquals(event.target, 'data-pc-section', 'clearicon') || (0, $kMhUd.DomHandler).isAttributeEquals(event.target.parentElement || event.target, 'data-pc-section', 'filterclearicon');
    };
    var _onClick = function onClick(event) {
        if (props.disabled || props.loading) return;
        props.onClick && props.onClick(event);
        // do not continue if the user defined click wants to prevent it
        if (event.defaultPrevented) return;
        if (isClearClicked(event) || event.target.tagName === 'INPUT') return;
        else if (!overlayRef.current || !(overlayRef.current && overlayRef.current.contains(event.target))) {
            (0, $kMhUd.DomHandler).focus(focusInputRef.current);
            overlayVisibleState ? hide() : show();
        }
        event.preventDefault();
        clickedRef.current = true;
    };
    var onInputFocus = function onInputFocus(event) {
        if (props.showOnFocus && !overlayVisibleState) show();
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.onBlur) setTimeout(function() {
            var currentValue = inputRef.current ? inputRef.current.value : undefined;
            props.onBlur({
                originalEvent: event.originalEvent,
                value: currentValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: currentValue
                }
            });
        }, 200);
    };
    var onOptionSelect = function onOptionSelect(event, option) {
        var isHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        selectItem({
            originalEvent: event,
            option: option
        });
        if (isHide) {
            hide();
            (0, $kMhUd.DomHandler).focus(focusInputRef.current);
        }
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $dnd0Z.OverlayService).emit('overlay-click', {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var code = (0, $kMhUd.DomHandler).isAndroid() ? event.key : event.code;
        switch(code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                onArrowLeftKey(event, props.editable);
                break;
            case 'Home':
                onHomeKey(event);
                break;
            case 'End':
                onEndKey(event);
                break;
            case 'PageDown':
                onPageDownKey(event);
                break;
            case 'PageUp':
                onPageUpKey(event);
                break;
            case 'Space':
                onSpaceKey(event, props.editable);
                break;
            case 'NumpadEnter':
            case 'Enter':
                onEnterKey(event);
                break;
            case 'Escape':
                onEscapeKey(event);
                break;
            case 'Tab':
                onTabKey(event);
                break;
            case 'Backspace':
                onBackspaceKey(event, props.editable);
                break;
            case 'ShiftLeft':
            case 'ShiftRight':
                break;
            default:
                var metaKey = event.metaKey || event.ctrlKey || event.altKey;
                // Only handle printable characters when no meta keys are pressed
                if (!metaKey && (0, $kMhUd.ObjectUtils).isPrintableCharacter(event.key)) {
                    !overlayVisibleState && !props.editable && show();
                    !props.editable && searchOptions(event, event.key);
                }
                break;
        }
        clickedRef.current = false;
    };
    var onFilterInputKeyDown = function onFilterInputKeyDown(event) {
        switch(event.code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                onArrowLeftKey(event, true);
                break;
            case 'Enter':
            case 'NumpadEnter':
                onEnterKey(event);
                event.preventDefault();
                break;
            case 'Escape':
                onEscapeKey(event);
                break;
        }
    };
    var hasFocusableElements = function hasFocusableElements() {
        return (0, $kMhUd.DomHandler).getFocusableElements(overlayRef.current, ':not([data-p-hidden-focusable="true"])').length > 0;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.current.toLocaleLowerCase(props.filterLocale)));
    };
    var isValidOption = function isValidOption(option) {
        return (0, $kMhUd.ObjectUtils).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $kMhUd.ObjectUtils).isNotEmpty(props.value);
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        return hasSelectedOption ? visibleOptions.findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var searchOptions = function searchOptions(event, _char) {
        searchValue.current = (searchValue.current || '') + _char;
        var optionIndex = -1;
        var matched = false;
        if ((0, $kMhUd.ObjectUtils).isNotEmpty(searchValue.current)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex !== -1) matched = true;
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = '';
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $kMhUd.ObjectUtils).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $kMhUd.ObjectUtils).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            focusOnItem(index);
            if (props.selectOnFocus) onOptionSelect(event, visibleOptions[index], false);
        }
    };
    var focusOnItem = function focusOnItem(index) {
        var focusedItem = (0, $kMhUd.DomHandler).findSingle(overlayRef.current, "li[id=\"dropdownItem_".concat(index, "\"]"));
        focusedItem && focusedItem.focus();
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        if (!overlayVisibleState) {
            show();
            props.editable && changeFocusedOptionIndex(event, findSelectedOptionIndex());
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : clickedRef.current ? findFirstOptionIndex() : findFirstFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event.altKey && !pressedInInputText) {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            state.overlayVisible && hide();
            event.preventDefault();
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : clickedRef.current ? findLastOptionIndex() : findLastFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
            event.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        pressedInInputText && setFocusedOptionIndex(-1);
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            event.currentTarget.setSelectionRange(0, 0);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findFirstOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            var target = event.currentTarget;
            var len = target.value.length;
            target.setSelectionRange(len, len);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findLastOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        !pressedInInputText && onEnterKey(event);
    };
    var onEnterKey = function onEnterKey(event) {
        event.preventDefault();
        if (!overlayVisibleState) {
            setFocusedOptionIndex(-1);
            onArrowDownKey(event);
        } else {
            if (focusedOptionIndex === -1) return;
            var focusedOption = visibleOptions[focusedOptionIndex];
            var optionValue = getOptionValue(focusedOption);
            if (optionValue == null || optionValue == undefined) {
                hide();
                resetFilter();
                updateEditableLabel(selectedOption);
                return;
            }
            onOptionSelect(event, focusedOption);
        }
    };
    var onEscapeKey = function onEscapeKey(event) {
        overlayVisibleState && hide();
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!pressedInInputText) {
            if (overlayVisibleState && !hasFocusableElements()) {
                (0, $kMhUd.DomHandler).focus(firstHiddenFocusableElementOnOverlay.current);
                event.preventDefault();
            } else {
                if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
                overlayVisibleState && hide();
            }
        }
    };
    var onBackspaceKey = function onBackspaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event && pressedInInputText) !overlayVisibleState && show();
    };
    var findInArray = function findInArray(visibleOptions, searchText) {
        if (!searchText || !(visibleOptions !== null && visibleOptions !== void 0 && visibleOptions.length)) return -1;
        var normalizedSearch = searchText.toLocaleLowerCase();
        var exactMatch = visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase() === normalizedSearch;
        });
        if (exactMatch !== -1) return exactMatch;
        return visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase().startsWith(normalizedSearch);
        });
    };
    var onEditableInputChange = function onEditableInputChange(event) {
        !overlayVisibleState && show();
        var searchIndex = null;
        if (event.target.value && visibleOptions) searchIndex = findInArray(visibleOptions, event.target.value);
        setFocusedOptionIndex(searchIndex);
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: event.target.value,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: event.target.value
            }
        });
    };
    var onEditableInputFocus = function onEditableInputFocus(event) {
        setFocusedState(true);
        hide();
        props.onFocus && props.onFocus(event);
    };
    var onOptionClick = function onOptionClick(event) {
        var option = event.option;
        if (!option.disabled) {
            selectItem(event);
            (0, $kMhUd.DomHandler).focus(focusInputRef.current);
        }
        hide();
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        var filter = event.target.value;
        setFilterState(filter);
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            filter: filter
        });
    };
    var onFilterClearIconClick = function onFilterClearIconClick(callback) {
        resetFilter(callback);
    };
    var resetFilter = function resetFilter(callback) {
        setFilterState('');
        props.onFilter && props.onFilter({
            filter: ''
        });
        callback && callback();
    };
    var clear = function clear(event) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: undefined,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: undefined
            }
        });
        if (props.filter) resetFilter();
        updateEditableLabel();
        setFocusedOptionIndex(-1);
    };
    var selectItem = function selectItem(event) {
        if (selectedOption !== event.option) {
            updateEditableLabel(event.option);
            setFocusedOptionIndex(-1);
            var optionValue = getOptionValue(event.option);
            var selectedOptionIndex = findOptionIndexInList(event.option, visibleOptions);
            if (props.onChange) props.onChange({
                originalEvent: event.originalEvent,
                value: optionValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: optionValue
                }
            });
            changeFocusedOptionIndex(event.originalEvent, selectedOptionIndex);
        }
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex(options) {
        options = options || visibleOptions;
        if (options) {
            if (props.optionGroupLabel) for(var i = 0; i < options.length; i++){
                var selectedOptionIndex = findOptionIndexInList(props.value, getOptionGroupChildren(options[i]));
                if (selectedOptionIndex !== -1) return {
                    group: i,
                    option: selectedOptionIndex
                };
            }
            else return findOptionIndexInList(props.value, options);
        }
        return -1;
    };
    var equalityKey = function equalityKey() {
        return props.optionValue ? null : props.dataKey;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        var key = equalityKey();
        return list.findIndex(function(item) {
            return (0, $kMhUd.ObjectUtils).equals(value, getOptionValue(item), key);
        });
    };
    var isSelected = function isSelected(option) {
        return (0, $kMhUd.ObjectUtils).equals(props.value, getOptionValue(option), equalityKey());
    };
    var show = function show() {
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : props.editable ? -1 : findSelectedOptionIndex());
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        clickedRef.current = false;
    };
    var onFocus = function onFocus() {
        if (props.editable && !overlayVisibleState && clickedRef.current === false) (0, $kMhUd.DomHandler).focus(inputRef.current);
    };
    var onOverlayEnter = function onOverlayEnter(callback) {
        (0, $kMhUd.ZIndexUtils).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $eGEKG.default).autoZIndex, context && context.zIndex.overlay || (0, $eGEKG.default).zIndex.overlay);
        (0, $kMhUd.DomHandler).addStyles(overlayRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        alignOverlay();
        callback && callback();
    };
    var onOverlayEntered = function onOverlayEntered(callback) {
        callback && callback();
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        if (props.filter && props.resetFilterOnHide) resetFilter();
        (0, $kMhUd.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $kMhUd.DomHandler).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $eGEKG.default).appendTo);
    };
    var scrollInView = function scrollInView() {
        var focusedItem = (0, $kMhUd.DomHandler).findSingle(overlayRef.current, 'li[data-p-focused="true"]');
        if (focusedItem && focusedItem.scrollIntoView) focusedItem.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
        });
        else {
            var highlightItem = (0, $kMhUd.DomHandler).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            if (highlightItem && highlightItem.scrollIntoView) highlightItem.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        }
    };
    var updateEditableLabel = function updateEditableLabel(option) {
        if (inputRef.current) {
            inputRef.current.value = option ? getOptionLabel(option) : props.value || '';
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = inputRef.current.value;
        }
    };
    var getOptionLabel = function getOptionLabel(option) {
        if ((0, $kMhUd.ObjectUtils).isScalar(option)) return "".concat(option);
        var optionLabel = props.optionLabel ? (0, $kMhUd.ObjectUtils).resolveFieldData(option, props.optionLabel) : option['label'];
        return "".concat(optionLabel);
    };
    var getOptionValue = function getOptionValue(option) {
        if (props.useOptionAsValue) return option;
        var optionValue = props.optionValue ? (0, $kMhUd.ObjectUtils).resolveFieldData(option, props.optionValue) : option ? option['value'] : (0, $kMhUd.ObjectUtils).resolveFieldData(option, 'value');
        return props.optionValue || (0, $kMhUd.ObjectUtils).isNotEmpty(optionValue) ? optionValue : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $kMhUd.ObjectUtils).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.group;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $kMhUd.ObjectUtils).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $kMhUd.ObjectUtils).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $kMhUd.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $kMhUd.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $kMhUd.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var updateInputField = function updateInputField() {
        if (props.editable && inputRef.current) {
            var label = selectedOption ? getOptionLabel(selectedOption) : null;
            var value = label || props.value || '';
            inputRef.current.value = value;
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = value;
        }
    };
    var getSelectedOption = function getSelectedOption() {
        var index = getSelectedOptionIndex(props.options);
        return index !== -1 ? props.optionGroupLabel ? getOptionGroupChildren(props.options[index.group])[index.option] : props.options[index] : null;
    };
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            clear: clear,
            focus: function focus() {
                return (0, $kMhUd.DomHandler).focus(focusInputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getFocusInput: function getFocusInput() {
                return focusInputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    $8NFma.useEffect(function() {
        (0, $kMhUd.ObjectUtils).combinedRefs(inputRef, props.inputRef);
        (0, $kMhUd.ObjectUtils).combinedRefs(focusInputRef, props.focusInputRef);
    }, [
        inputRef,
        props.inputRef,
        focusInputRef,
        props.focusInputRef
    ]);
    (0, $kocnD.useMountEffect)(function() {
        if (props.autoFocus) (0, $kMhUd.DomHandler).focus(focusInputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $kocnD.useUpdateEffect)(function() {
        if (overlayVisibleState && (props.value || focusedOptionIndex >= 0)) scrollInView();
    }, [
        overlayVisibleState,
        props.value,
        focusedOptionIndex
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (overlayVisibleState && filterState && props.filter) alignOverlay();
    }, [
        overlayVisibleState,
        filterState,
        props.filter
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        virtualScrollerRef.current && virtualScrollerRef.current.scrollInView(0);
    }, [
        filterState
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        updateInputField();
        if (inputRef.current) inputRef.current.selectedIndex = 1;
    });
    (0, $kocnD.useUnmountEffect)(function() {
        (0, $kMhUd.ZIndexUtils).clear(overlayRef.current);
    });
    var createHiddenSelect = function createHiddenSelect() {
        var option = {
            value: '',
            label: props.placeholder
        };
        if (selectedOption) {
            var optionValue = getOptionValue(selectedOption);
            option = {
                value: $6ceb17a9faf5d2a9$var$_typeof(optionValue) === 'object' ? props.options.findIndex(function(o) {
                    return o === optionValue;
                }) : optionValue,
                label: getOptionLabel(selectedOption)
            };
        }
        var hiddenSelectedMessageProps = mergeProps({
            className: 'p-hidden-accessible p-dropdown-hidden-select'
        }, ptm('hiddenSelectedMessage'));
        var selectProps = mergeProps({
            ref: inputRef,
            required: props.required,
            defaultValue: option.value,
            name: props.name,
            tabIndex: -1
        }, ptm('select'));
        var optionProps = mergeProps({
            value: option.value
        }, ptm('option'));
        return /*#__PURE__*/ $8NFma.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $8NFma.createElement("select", selectProps, /*#__PURE__*/ $8NFma.createElement("option", optionProps, option.label)));
    };
    var createKeyboardHelper = function createKeyboardHelper() {
        var value = (0, $kMhUd.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) value = value || props.value || '';
        var hiddenSelectedMessageProps = mergeProps({
            className: 'p-hidden-accessible'
        }, ptm('hiddenSelectedMessage'));
        var inputProps = mergeProps($6ceb17a9faf5d2a9$var$_objectSpread({
            ref: focusInputRef,
            id: props.inputId,
            defaultValue: value,
            type: 'text',
            readOnly: true,
            'aria-haspopup': 'listbox',
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            disabled: props.disabled,
            tabIndex: !props.disabled ? props.tabIndex || 0 : -1
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $8NFma.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $8NFma.createElement("input", inputProps));
    };
    var createLabel = function createLabel() {
        var label = (0, $kMhUd.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) {
            var value = label || props.value || '';
            var _inputProps = mergeProps($6ceb17a9faf5d2a9$var$_objectSpread({
                ref: inputRef,
                type: 'text',
                defaultValue: value,
                className: cx('input', {
                    label: label
                }),
                disabled: props.disabled,
                placeholder: props.placeholder,
                maxLength: props.maxLength,
                onInput: onEditableInputChange,
                onFocus: onEditableInputFocus,
                onKeyDown: onInputKeyDown,
                onBlur: onInputBlur,
                tabIndex: !props.disabled ? props.tabIndex || 0 : -1,
                'aria-haspopup': 'listbox'
            }, ariaProps), ptm('input'));
            return /*#__PURE__*/ $8NFma.createElement("input", _inputProps);
        }
        var content = props.valueTemplate ? (0, $kMhUd.ObjectUtils).getJSXElement(props.valueTemplate, selectedOption, props) : label || props.placeholder || props.emptyMessage || /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, "\xA0");
        var inputProps = mergeProps({
            ref: inputRef,
            className: cx('input', {
                label: label
            }),
            tabIndex: '-1'
        }, ptm('input'));
        return /*#__PURE__*/ $8NFma.createElement("span", inputProps, content);
    };
    var onClearIconKeyDown = function onClearIconKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
            clear(event);
            event.preventDefault();
        }
    };
    var createClearIcon = function createClearIcon() {
        if (props.value != null && props.showClear && !props.disabled && !(0, $kMhUd.ObjectUtils).isEmpty(props.options)) {
            var clearIconProps = mergeProps({
                className: cx('clearIcon'),
                onPointerUp: clear,
                tabIndex: props.editable ? -1 : props.tabIndex || '0',
                onKeyDown: onClearIconKeyDown,
                'aria-label': (0, $eGEKG.localeOption)('clear')
            }, ptm('clearIcon'));
            var icon = props.clearIcon || /*#__PURE__*/ $8NFma.createElement((0, $gMyz9.TimesIcon), clearIconProps);
            return (0, $kMhUd.IconUtils).getJSXIcon(icon, $6ceb17a9faf5d2a9$var$_objectSpread({}, clearIconProps), {
                props: props
            });
        }
        return null;
    };
    var createLoadingIcon = function createLoadingIcon() {
        var loadingIconProps = mergeProps({
            className: cx('loadingIcon'),
            'data-pr-overlay-visible': overlayVisibleState
        }, ptm('loadingIcon'));
        var icon = props.loadingIcon || /*#__PURE__*/ $8NFma.createElement((0, $6rN57.SpinnerIcon), {
            spin: true
        });
        var loadingIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $6ceb17a9faf5d2a9$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var loadingButtonProps = mergeProps({
            className: cx('trigger'),
            role: 'button',
            'aria-haspopup': 'listbox',
            'aria-expanded': overlayVisibleState,
            'aria-label': ariaLabel
        }, ptm('trigger'));
        return /*#__PURE__*/ $8NFma.createElement("div", loadingButtonProps, loadingIcon);
    };
    var createDropdownIcon = function createDropdownIcon() {
        var dropdownIconProps = mergeProps({
            className: cx('dropdownIcon'),
            'data-pr-overlay-visible': overlayVisibleState
        }, ptm('dropdownIcon'));
        var icon = !overlayVisibleState ? props.dropdownIcon || /*#__PURE__*/ $8NFma.createElement((0, $7Hg4o.ChevronDownIcon), dropdownIconProps) : props.collapseIcon || /*#__PURE__*/ $8NFma.createElement((0, $forNC.ChevronUpIcon), dropdownIconProps);
        var dropdownIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $6ceb17a9faf5d2a9$var$_objectSpread({}, dropdownIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var triggerProps = mergeProps({
            className: cx('trigger'),
            role: 'button',
            'aria-haspopup': 'listbox',
            'aria-expanded': overlayVisibleState,
            'aria-label': ariaLabel
        }, ptm('trigger'));
        return /*#__PURE__*/ $8NFma.createElement("div", triggerProps, dropdownIcon);
    };
    var visibleOptions = getVisibleOptions();
    var selectedOption = getSelectedOption();
    var hasTooltip = (0, $kMhUd.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $6ceb17a9faf5d2a9$var$DropdownBase.getOtherProps(props);
    var ariaProps = (0, $kMhUd.ObjectUtils).reduceKeys(otherProps, (0, $kMhUd.DomHandler).ARIA_PROPS);
    var hiddenSelect = createHiddenSelect();
    var keyboardHelper = createKeyboardHelper();
    var labelElement = createLabel();
    var dropdownIcon = props.loading ? createLoadingIcon() : createDropdownIcon();
    var clearIcon = createClearIcon();
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $kMhUd.classNames)(props.className, cx('root', {
            context: context,
            focusedState: focusedState,
            overlayVisibleState: overlayVisibleState
        })),
        style: props.style,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onMouseDown: props.onMouseDown,
        onContextMenu: props.onContextMenu,
        onFocus: onFocus,
        'data-p-disabled': props.disabled,
        'data-p-focus': focusedState,
        'aria-activedescendant': focusedState ? "dropdownItem_".concat(focusedOptionIndex) : undefined
    }, otherProps, ptm('root'));
    var firstHiddenFocusableElementProps = mergeProps({
        ref: firstHiddenFocusableElementOnOverlay,
        role: 'presentation',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: '0',
        onFocus: onFirstHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptm('hiddenFirstFocusableEl'));
    var lastHiddenFocusableElementProps = mergeProps({
        ref: lastHiddenFocusableElementOnOverlay,
        role: 'presentation',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: '0',
        onFocus: onLastHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptm('hiddenLastFocusableEl'));
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("div", rootProps, keyboardHelper, hiddenSelect, labelElement, clearIcon, dropdownIcon, /*#__PURE__*/ $8NFma.createElement($6ceb17a9faf5d2a9$var$DropdownPanel, $6ceb17a9faf5d2a9$var$_extends({
        hostName: "Dropdown",
        ref: overlayRef,
        visibleOptions: visibleOptions,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        appendTo: appendTo,
        cx: cx,
        filterValue: filterValue,
        focusedOptionIndex: focusedOptionIndex,
        getOptionGroupChildren: getOptionGroupChildren,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupRenderKey: getOptionGroupRenderKey,
        getOptionLabel: getOptionLabel,
        getOptionRenderKey: getOptionRenderKey,
        getSelectedOptionIndex: getSelectedOptionIndex,
        hasFilter: hasFilter,
        "in": overlayVisibleState,
        isOptionDisabled: isOptionDisabled,
        isSelected: isSelected,
        onOverlayHide: hide,
        onClick: onPanelClick,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        onFilterClearIconClick: onFilterClearIconClick,
        onFilterInputChange: onFilterInputChange,
        onFilterInputKeyDown: onFilterInputKeyDown,
        onOptionClick: onOptionClick,
        onInputKeyDown: onInputKeyDown,
        ptm: ptm,
        resetFilter: resetFilter,
        changeFocusedOptionIndex: changeFocusedOptionIndex,
        firstFocusableElement: /*#__PURE__*/ $8NFma.createElement("span", firstHiddenFocusableElementProps),
        lastFocusableElement: /*#__PURE__*/ $8NFma.createElement("span", lastHiddenFocusableElementProps),
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $8NFma.createElement((0, $7dgG7.Tooltip), $6ceb17a9faf5d2a9$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$6ceb17a9faf5d2a9$export$931cbfb6bfb85fc.displayName = 'Dropdown';

});
parcelRegister("7Hg4o", function(module, exports) {

$parcel$export(module.exports, "ChevronDownIcon", () => $59a903b542444659$export$4857d3f3f5f8319b);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $59a903b542444659$var$_extends() {
    return $59a903b542444659$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $59a903b542444659$var$_extends.apply(null, arguments);
}
var $59a903b542444659$export$4857d3f3f5f8319b = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $59a903b542444659$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
        fill: "currentColor"
    }));
}));
$59a903b542444659$export$4857d3f3f5f8319b.displayName = 'ChevronDownIcon';

});

parcelRegister("forNC", function(module, exports) {

$parcel$export(module.exports, "ChevronUpIcon", () => $b34ea949d80f748f$export$7f01a6cbee61a0f2);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $b34ea949d80f748f$var$_extends() {
    return $b34ea949d80f748f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b34ea949d80f748f$var$_extends.apply(null, arguments);
}
var $b34ea949d80f748f$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $b34ea949d80f748f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
        fill: "currentColor"
    }));
}));
$b34ea949d80f748f$export$7f01a6cbee61a0f2.displayName = 'ChevronUpIcon';

});

parcelRegister("6rN57", function(module, exports) {

$parcel$export(module.exports, "SpinnerIcon", () => $4b1b5644639f8cad$export$fe708d541030d854);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $4b1b5644639f8cad$var$_extends() {
    return $4b1b5644639f8cad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4b1b5644639f8cad$var$_extends.apply(null, arguments);
}
var $4b1b5644639f8cad$export$fe708d541030d854 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $4b1b5644639f8cad$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
        fill: "currentColor"
    }));
}));
$4b1b5644639f8cad$export$fe708d541030d854.displayName = 'SpinnerIcon';

});

parcelRegister("dnd0Z", function(module, exports) {

$parcel$export(module.exports, "OverlayService", () => $9bc784db3c911a79$export$dbec172f58a34ef1);

var $kMhUd = parcelRequire("kMhUd");
'use client';
var $9bc784db3c911a79$export$dbec172f58a34ef1 = (0, $kMhUd.EventBus)();

});

parcelRegister("7dgG7", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $5406af40ad66850f$export$28c660c63b792dea);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $64a8q = parcelRequire("64a8q");

var $kocnD = parcelRequire("kocnD");

var $bKF0T = parcelRequire("bKF0T");

var $kMhUd = parcelRequire("kMhUd");
'use client';
function $5406af40ad66850f$var$_extends() {
    return $5406af40ad66850f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5406af40ad66850f$var$_extends.apply(null, arguments);
}
function $5406af40ad66850f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5406af40ad66850f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5406af40ad66850f$var$_typeof(o);
}
function $5406af40ad66850f$var$toPrimitive(t, r) {
    if ("object" != $5406af40ad66850f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5406af40ad66850f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5406af40ad66850f$var$toPropertyKey(t) {
    var i = $5406af40ad66850f$var$toPrimitive(t, "string");
    return "symbol" == $5406af40ad66850f$var$_typeof(i) ? i : i + "";
}
function $5406af40ad66850f$var$_defineProperty(e, r, t) {
    return (r = $5406af40ad66850f$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5406af40ad66850f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5406af40ad66850f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5406af40ad66850f$var$_arrayLikeToArray(r);
}
function $5406af40ad66850f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $5406af40ad66850f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5406af40ad66850f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5406af40ad66850f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5406af40ad66850f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5406af40ad66850f$var$_toConsumableArray(r) {
    return $5406af40ad66850f$var$_arrayWithoutHoles(r) || $5406af40ad66850f$var$_iterableToArray(r) || $5406af40ad66850f$var$_unsupportedIterableToArray(r) || $5406af40ad66850f$var$_nonIterableSpread();
}
function $5406af40ad66850f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5406af40ad66850f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5406af40ad66850f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5406af40ad66850f$var$_slicedToArray(r, e) {
    return $5406af40ad66850f$var$_arrayWithHoles(r) || $5406af40ad66850f$var$_iterableToArrayLimit(r, e) || $5406af40ad66850f$var$_unsupportedIterableToArray(r, e) || $5406af40ad66850f$var$_nonIterableRest();
}
var $5406af40ad66850f$var$classes = {
    root: function root(_ref) {
        var positionState = _ref.positionState, classNameState = _ref.classNameState;
        return (0, $kMhUd.classNames)('p-tooltip p-component', $5406af40ad66850f$var$_defineProperty({}, "p-tooltip-".concat(positionState), true), classNameState);
    },
    arrow: 'p-tooltip-arrow',
    text: 'p-tooltip-text'
};
var $5406af40ad66850f$var$inlineStyles = {
    arrow: function arrow(_ref2) {
        var context = _ref2.context;
        return {
            top: context.bottom ? '0' : context.right || context.left || !context.right && !context.left && !context.top && !context.bottom ? '50%' : null,
            bottom: context.top ? '0' : null,
            left: context.right || !context.right && !context.left && !context.top && !context.bottom ? '0' : context.top || context.bottom ? '50%' : null,
            right: context.left ? '0' : null
        };
    }
};
var $5406af40ad66850f$var$styles = "\n@layer primereact {\n    .p-tooltip {\n        position: absolute;\n        padding: .25em .5rem;\n        /* #3687: Tooltip prevent scrollbar flickering */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-tooltip.p-tooltip-right,\n    .p-tooltip.p-tooltip-left {\n        padding: 0 .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top,\n    .p-tooltip.p-tooltip-bottom {\n        padding:.25em 0;\n    }\n    \n    .p-tooltip .p-tooltip-text {\n       white-space: pre-line;\n       word-break: break-word;\n    }\n    \n    .p-tooltip-arrow {\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-color: transparent;\n        border-style: solid;\n    }\n    \n    .p-tooltip-right .p-tooltip-arrow {\n        top: 50%;\n        left: 0;\n        margin-top: -.25rem;\n        border-width: .25em .25em .25em 0;\n    }\n    \n    .p-tooltip-left .p-tooltip-arrow {\n        top: 50%;\n        right: 0;\n        margin-top: -.25rem;\n        border-width: .25em 0 .25em .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top {\n        padding: .25em 0;\n    }\n    \n    .p-tooltip-top .p-tooltip-arrow {\n        bottom: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: .25em .25em 0;\n    }\n    \n    .p-tooltip-bottom .p-tooltip-arrow {\n        top: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: 0 .25em .25rem;\n    }\n\n    .p-tooltip-target-wrapper {\n        display: inline-flex;\n    }\n}\n";
var $5406af40ad66850f$var$TooltipBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Tooltip',
        appendTo: null,
        at: null,
        autoHide: true,
        autoZIndex: true,
        baseZIndex: 0,
        className: null,
        closeOnEscape: false,
        content: null,
        disabled: false,
        event: null,
        hideDelay: 0,
        hideEvent: 'mouseleave',
        id: null,
        mouseTrack: false,
        mouseTrackLeft: 5,
        mouseTrackTop: 5,
        my: null,
        onBeforeHide: null,
        onBeforeShow: null,
        onHide: null,
        onShow: null,
        position: 'right',
        showDelay: 0,
        showEvent: 'mouseenter',
        showOnDisabled: false,
        style: null,
        target: null,
        updateDelay: 0,
        children: undefined
    },
    css: {
        classes: $5406af40ad66850f$var$classes,
        styles: $5406af40ad66850f$var$styles,
        inlineStyles: $5406af40ad66850f$var$inlineStyles
    }
});
function $5406af40ad66850f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5406af40ad66850f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5406af40ad66850f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5406af40ad66850f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5406af40ad66850f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5406af40ad66850f$export$28c660c63b792dea = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $5406af40ad66850f$var$TooltipBase.getProps(inProps, context);
    var _React$useState = $8NFma.useState(false), _React$useState2 = $5406af40ad66850f$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $8NFma.useState(props.position || 'right'), _React$useState4 = $5406af40ad66850f$var$_slicedToArray(_React$useState3, 2), positionState = _React$useState4[0], setPositionState = _React$useState4[1];
    var _React$useState5 = $8NFma.useState(''), _React$useState6 = $5406af40ad66850f$var$_slicedToArray(_React$useState5, 2), classNameState = _React$useState6[0], setClassNameState = _React$useState6[1];
    var _React$useState7 = $8NFma.useState(false), _React$useState8 = $5406af40ad66850f$var$_slicedToArray(_React$useState7, 2), multipleFocusEvents = _React$useState8[0], setMultipleFocusEvents = _React$useState8[1];
    var isCloseOnEscape = visibleState && props.closeOnEscape;
    var overlayDisplayOrder = (0, $kocnD.useDisplayOrder)('tooltip', isCloseOnEscape);
    var metaData = {
        props: props,
        state: {
            visible: visibleState,
            position: positionState,
            className: classNameState
        },
        context: {
            right: positionState === 'right',
            left: positionState === 'left',
            top: positionState === 'top',
            bottom: positionState === 'bottom'
        }
    };
    var _TooltipBase$setMetaD = $5406af40ad66850f$var$TooltipBase.setMetaData(metaData), ptm = _TooltipBase$setMetaD.ptm, cx = _TooltipBase$setMetaD.cx, sx = _TooltipBase$setMetaD.sx, isUnstyled = _TooltipBase$setMetaD.isUnstyled;
    (0, $64a8q.useHandleStyle)($5406af40ad66850f$var$TooltipBase.css.styles, isUnstyled, {
        name: 'tooltip'
    });
    (0, $kocnD.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: isCloseOnEscape,
        priority: [
            (0, $kocnD.ESC_KEY_HANDLING_PRIORITIES).TOOLTIP,
            overlayDisplayOrder
        ]
    });
    var elementRef = $8NFma.useRef(null);
    var textRef = $8NFma.useRef(null);
    var currentTargetRef = $8NFma.useRef(null);
    var containerSize = $8NFma.useRef(null);
    var allowHide = $8NFma.useRef(true);
    var timeouts = $8NFma.useRef({});
    var currentMouseEvent = $8NFma.useRef(null);
    var _useResizeListener = (0, $kocnD.useResizeListener)({
        listener: function listener(event) {
            !(0, $kMhUd.DomHandler).isTouchDevice() && hide(event);
        }
    }), _useResizeListener2 = $5406af40ad66850f$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = (0, $kocnD.useOverlayScrollListener)({
        target: currentTargetRef.current,
        listener: function listener(event) {
            hide(event);
        },
        when: visibleState
    }), _useOverlayScrollList2 = $5406af40ad66850f$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isTargetContentEmpty = function isTargetContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip'));
    };
    var isContentEmpty = function isContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip') || props.children);
    };
    var isMouseTrack = function isMouseTrack(target) {
        return getTargetOption(target, 'mousetrack') || props.mouseTrack;
    };
    var isDisabled = function isDisabled(target) {
        return getTargetOption(target, 'disabled') === 'true' || hasTargetOption(target, 'disabled') || props.disabled;
    };
    var isShowOnDisabled = function isShowOnDisabled(target) {
        return getTargetOption(target, 'showondisabled') || props.showOnDisabled;
    };
    var isAutoHide = function isAutoHide() {
        return getTargetOption(currentTargetRef.current, 'autohide') || props.autoHide;
    };
    var getTargetOption = function getTargetOption(target, option) {
        return hasTargetOption(target, "data-pr-".concat(option)) ? target.getAttribute("data-pr-".concat(option)) : null;
    };
    var hasTargetOption = function hasTargetOption(target, option) {
        return target && target.hasAttribute(option);
    };
    var getEvents = function getEvents(target) {
        var showEvents = [
            getTargetOption(target, 'showevent') || props.showEvent
        ];
        var hideEvents = [
            getTargetOption(target, 'hideevent') || props.hideEvent
        ];
        if (isMouseTrack(target)) {
            showEvents = [
                'mousemove'
            ];
            hideEvents = [
                'mouseleave'
            ];
        } else {
            var event = getTargetOption(target, 'event') || props.event;
            if (event === 'focus') {
                showEvents = [
                    'focus'
                ];
                hideEvents = [
                    'blur'
                ];
            }
            if (event === 'both') {
                showEvents = [
                    'focus',
                    'mouseenter'
                ];
                hideEvents = multipleFocusEvents ? [
                    'blur'
                ] : [
                    'mouseleave',
                    'blur'
                ];
            }
        }
        return {
            showEvents: showEvents,
            hideEvents: hideEvents
        };
    };
    var getPosition = function getPosition(target) {
        return getTargetOption(target, 'position') || positionState;
    };
    var getMouseTrackPosition = function getMouseTrackPosition(target) {
        var top = getTargetOption(target, 'mousetracktop') || props.mouseTrackTop;
        var left = getTargetOption(target, 'mousetrackleft') || props.mouseTrackLeft;
        return {
            top: top,
            left: left
        };
    };
    var updateText = function updateText(target, callback) {
        if (textRef.current) {
            var content = getTargetOption(target, 'tooltip') || props.content;
            if (content) {
                textRef.current.innerHTML = ''; // remove children
                textRef.current.appendChild(document.createTextNode(content));
                callback();
            } else if (props.children) callback();
        }
    };
    var updateTooltipState = function updateTooltipState(position) {
        updateText(currentTargetRef.current, function() {
            var _currentMouseEvent$cu = currentMouseEvent.current, x = _currentMouseEvent$cu.pageX, y = _currentMouseEvent$cu.pageY;
            if (props.autoZIndex && !(0, $kMhUd.ZIndexUtils).get(elementRef.current)) (0, $kMhUd.ZIndexUtils).set('tooltip', elementRef.current, context && context.autoZIndex || (0, $eGEKG.default).autoZIndex, props.baseZIndex || context && context.zIndex.tooltip || (0, $eGEKG.default).zIndex.tooltip);
            elementRef.current.style.left = '';
            elementRef.current.style.top = '';
            // GitHub #2695 disable pointer events when autohiding
            if (isAutoHide()) elementRef.current.style.pointerEvents = 'none';
            var mouseTrackCheck = isMouseTrack(currentTargetRef.current) || position === 'mouse';
            if (mouseTrackCheck && !containerSize.current || mouseTrackCheck) containerSize.current = {
                width: (0, $kMhUd.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $kMhUd.DomHandler).getOuterHeight(elementRef.current)
            };
            align(currentTargetRef.current, {
                x: x,
                y: y
            }, position);
        });
    };
    var show = function show(e) {
        if (e.type && e.type === 'focus') setMultipleFocusEvents(true);
        currentTargetRef.current = e.currentTarget;
        var disabled = isDisabled(currentTargetRef.current);
        var empty = isContentEmpty(isShowOnDisabled(currentTargetRef.current) && disabled ? currentTargetRef.current.firstChild : currentTargetRef.current);
        if (empty || disabled) return;
        currentMouseEvent.current = e;
        if (visibleState) applyDelay('updateDelay', updateTooltipState);
        else {
            // #2653 give the callback a chance to return false and not continue with display
            var success = sendCallback(props.onBeforeShow, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('showDelay', function() {
                setVisibleState(true);
                sendCallback(props.onShow, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var hide = function hide(e) {
        if (e && e.type === 'blur') setMultipleFocusEvents(false);
        clearTimeouts();
        if (visibleState) {
            var success = sendCallback(props.onBeforeHide, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('hideDelay', function() {
                if (!isAutoHide() && allowHide.current === false) return;
                (0, $kMhUd.ZIndexUtils).clear(elementRef.current);
                (0, $kMhUd.DomHandler).removeClass(elementRef.current, 'p-tooltip-active');
                setVisibleState(false);
                sendCallback(props.onHide, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        } else if (!props.onBeforeHide && !getDelay('hideDelay')) // handles the case when visibleState change from mouseenter was queued and mouseleave handler was called earlier than queued re-render
        setVisibleState(false);
    };
    var align = function align(target, coordinate, position) {
        var left = 0;
        var top = 0;
        var currentPosition = position || positionState;
        if ((isMouseTrack(target) || currentPosition == 'mouse') && coordinate) {
            var _containerSize = {
                width: (0, $kMhUd.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $kMhUd.DomHandler).getOuterHeight(elementRef.current)
            };
            left = coordinate.x;
            top = coordinate.y;
            var _getMouseTrackPositio = getMouseTrackPosition(target), mouseTrackTop = _getMouseTrackPositio.top, mouseTrackLeft = _getMouseTrackPositio.left;
            switch(currentPosition){
                case 'left':
                    left = left - (_containerSize.width + mouseTrackLeft);
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case 'right':
                case 'mouse':
                    left = left + mouseTrackLeft;
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case 'top':
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top - (_containerSize.height + mouseTrackTop);
                    break;
                case 'bottom':
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top + mouseTrackTop;
                    break;
            }
            if (left <= 0 || containerSize.current.width > _containerSize.width) {
                elementRef.current.style.left = '0px';
                elementRef.current.style.right = window.innerWidth - _containerSize.width - left + 'px';
            } else {
                elementRef.current.style.right = '';
                elementRef.current.style.left = left + 'px';
            }
            elementRef.current.style.top = top + 'px';
            (0, $kMhUd.DomHandler).addClass(elementRef.current, 'p-tooltip-active');
        } else {
            var pos = (0, $kMhUd.DomHandler).findCollisionPosition(currentPosition);
            var my = getTargetOption(target, 'my') || props.my || pos.my;
            var at = getTargetOption(target, 'at') || props.at || pos.at;
            elementRef.current.style.padding = '0px';
            (0, $kMhUd.DomHandler).flipfitCollision(elementRef.current, target, my, at, function(calculatedPosition) {
                var _calculatedPosition$a = calculatedPosition.at, atX = _calculatedPosition$a.x, atY = _calculatedPosition$a.y;
                var myX = calculatedPosition.my.x;
                var newPosition = props.at ? atX !== 'center' && atX !== myX ? atX : atY : calculatedPosition.at["".concat(pos.axis)];
                elementRef.current.style.padding = '';
                setPositionState(newPosition);
                updateContainerPosition(newPosition);
                (0, $kMhUd.DomHandler).addClass(elementRef.current, 'p-tooltip-active');
            });
        }
    };
    var updateContainerPosition = function updateContainerPosition(position) {
        if (elementRef.current) {
            var style = getComputedStyle(elementRef.current);
            if (position === 'left') elementRef.current.style.left = parseFloat(style.left) - parseFloat(style.paddingLeft) * 2 + 'px';
            else if (position === 'top') elementRef.current.style.top = parseFloat(style.top) - parseFloat(style.paddingTop) * 2 + 'px';
        }
    };
    var _onMouseEnter = function onMouseEnter() {
        if (!isAutoHide()) allowHide.current = false;
    };
    var _onMouseLeave = function onMouseLeave(e) {
        if (!isAutoHide()) {
            allowHide.current = true;
            hide(e);
        }
    };
    var bindTargetEvent = function bindTargetEvent(target) {
        if (target) {
            var _getEvents = getEvents(target), showEvents = _getEvents.showEvents, hideEvents = _getEvents.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, hide);
            });
        }
    };
    var unbindTargetEvent = function unbindTargetEvent(target) {
        if (target) {
            var _getEvents2 = getEvents(target), showEvents = _getEvents2.showEvents, hideEvents = _getEvents2.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, hide);
            });
        }
    };
    var getDelay = function getDelay(delayProp) {
        return getTargetOption(currentTargetRef.current, delayProp.toLowerCase()) || props[delayProp];
    };
    var applyDelay = function applyDelay(delayProp, callback) {
        clearTimeouts();
        var delay = getDelay(delayProp);
        delay ? timeouts.current["".concat(delayProp)] = setTimeout(function() {
            return callback();
        }, delay) : callback();
    };
    var sendCallback = function sendCallback(callback) {
        if (callback) {
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            var result = callback.apply(void 0, params);
            if (result === undefined) result = true;
            return result;
        }
        return true;
    };
    var clearTimeouts = function clearTimeouts() {
        Object.values(timeouts.current).forEach(function(t) {
            return clearTimeout(t);
        });
    };
    var getTarget = function getTarget(target) {
        if (target) {
            if (isShowOnDisabled(target)) {
                if (!target.hasWrapper) {
                    var wrapper = document.createElement('div');
                    var isInputElement = target.nodeName === 'INPUT';
                    if (isInputElement) (0, $kMhUd.DomHandler).addMultipleClasses(wrapper, 'p-tooltip-target-wrapper p-inputwrapper');
                    else (0, $kMhUd.DomHandler).addClass(wrapper, 'p-tooltip-target-wrapper');
                    target.parentNode.insertBefore(wrapper, target);
                    wrapper.appendChild(target);
                    target.hasWrapper = true;
                    return wrapper;
                }
                return target.parentElement;
            } else if (target.hasWrapper) {
                var _target$parentElement;
                (_target$parentElement = target.parentElement).replaceWith.apply(_target$parentElement, $5406af40ad66850f$var$_toConsumableArray(target.parentElement.childNodes));
                delete target.hasWrapper;
            }
            return target;
        }
        return null;
    };
    var updateTargetEvents = function updateTargetEvents(target) {
        unloadTargetEvents(target);
        loadTargetEvents(target);
    };
    var loadTargetEvents = function loadTargetEvents(target) {
        setTargetEventOperations(target || props.target, bindTargetEvent);
    };
    var unloadTargetEvents = function unloadTargetEvents(target) {
        setTargetEventOperations(target || props.target, unbindTargetEvent);
    };
    var setTargetEventOperations = function setTargetEventOperations(target, operation) {
        target = (0, $kMhUd.ObjectUtils).getRefElement(target);
        if (target) {
            if ((0, $kMhUd.DomHandler).isElement(target)) operation(target);
            else {
                var setEvent = function setEvent(target) {
                    var element = (0, $kMhUd.DomHandler).find(document, target);
                    element.forEach(function(el) {
                        operation(el);
                    });
                };
                if (target instanceof Array) target.forEach(function(t) {
                    setEvent(t);
                });
                else setEvent(target);
            }
        }
    };
    (0, $kocnD.useMountEffect)(function() {
        if (visibleState && currentTargetRef.current && isDisabled(currentTargetRef.current)) hide();
    });
    (0, $kocnD.useUpdateEffect)(function() {
        loadTargetEvents();
        return function() {
            unloadTargetEvents();
        };
    }, [
        show,
        hide,
        props.target
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (visibleState) {
            var position = getPosition(currentTargetRef.current);
            var classname = getTargetOption(currentTargetRef.current, 'classname');
            setPositionState(position);
            setClassNameState(classname);
            updateTooltipState(position);
            bindWindowResizeListener();
            bindOverlayScrollListener();
        } else {
            setPositionState(props.position || 'right');
            setClassNameState('');
            currentTargetRef.current = null;
            containerSize.current = null;
            allowHide.current = true;
        }
        return function() {
            unbindWindowResizeListener();
            unbindOverlayScrollListener();
        };
    }, [
        visibleState
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        var position = getPosition(currentTargetRef.current);
        if (visibleState && position !== 'mouse') applyDelay('updateDelay', function() {
            updateText(currentTargetRef.current, function() {
                align(currentTargetRef.current);
            });
        });
    }, [
        props.content
    ]);
    (0, $kocnD.useUnmountEffect)(function() {
        hide();
        (0, $kMhUd.ZIndexUtils).clear(elementRef.current);
    });
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            updateTargetEvents: updateTargetEvents,
            loadTargetEvents: loadTargetEvents,
            unloadTargetEvents: unloadTargetEvents,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            },
            getTarget: function getTarget() {
                return currentTargetRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var empty = isTargetContentEmpty(currentTargetRef.current);
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $kMhUd.classNames)(props.className, cx('root', {
                positionState: positionState,
                classNameState: classNameState
            })),
            style: props.style,
            role: 'tooltip',
            'aria-hidden': visibleState,
            onMouseEnter: function onMouseEnter(e) {
                return _onMouseEnter();
            },
            onMouseLeave: function onMouseLeave(e) {
                return _onMouseLeave(e);
            }
        }, $5406af40ad66850f$var$TooltipBase.getOtherProps(props), ptm('root'));
        var arrowProps = mergeProps({
            className: cx('arrow'),
            style: sx('arrow', $5406af40ad66850f$var$_objectSpread({}, metaData))
        }, ptm('arrow'));
        var textProps = mergeProps({
            className: cx('text')
        }, ptm('text'));
        return /*#__PURE__*/ $8NFma.createElement("div", $5406af40ad66850f$var$_extends({
            ref: elementRef
        }, rootProps), /*#__PURE__*/ $8NFma.createElement("div", arrowProps), /*#__PURE__*/ $8NFma.createElement("div", $5406af40ad66850f$var$_extends({
            ref: textRef
        }, textProps), empty && props.children));
    };
    if (visibleState) {
        var element = createElement();
        return /*#__PURE__*/ $8NFma.createElement((0, $bKF0T.Portal), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    }
    return null;
}));
$5406af40ad66850f$export$28c660c63b792dea.displayName = 'Tooltip';

});

parcelRegister("ixBc2", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $d7f828d5d6af601e$export$82eafebb825fc23f);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $d7f828d5d6af601e$var$_extends() {
    return $d7f828d5d6af601e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7f828d5d6af601e$var$_extends.apply(null, arguments);
}
var $d7f828d5d6af601e$export$82eafebb825fc23f = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $d7f828d5d6af601e$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
        fill: "currentColor"
    }));
}));
$d7f828d5d6af601e$export$82eafebb825fc23f.displayName = 'SearchIcon';

});

parcelRegister("ex9Xv", function(module, exports) {

$parcel$export(module.exports, "VirtualScroller", () => $a94bdf5ee55b1ef3$export$fbd4ea7fe0fb889);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $kocnD = parcelRequire("kocnD");

var $6rN57 = parcelRequire("6rN57");

var $kMhUd = parcelRequire("kMhUd");

var $64a8q = parcelRequire("64a8q");
'use client';
function $a94bdf5ee55b1ef3$var$_extends() {
    return $a94bdf5ee55b1ef3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a94bdf5ee55b1ef3$var$_extends.apply(null, arguments);
}
function $a94bdf5ee55b1ef3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a94bdf5ee55b1ef3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a94bdf5ee55b1ef3$var$_typeof(o);
}
function $a94bdf5ee55b1ef3$var$toPrimitive(t, r) {
    if ("object" != $a94bdf5ee55b1ef3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a94bdf5ee55b1ef3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a94bdf5ee55b1ef3$var$toPropertyKey(t) {
    var i = $a94bdf5ee55b1ef3$var$toPrimitive(t, "string");
    return "symbol" == $a94bdf5ee55b1ef3$var$_typeof(i) ? i : i + "";
}
function $a94bdf5ee55b1ef3$var$_defineProperty(e, r, t) {
    return (r = $a94bdf5ee55b1ef3$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a94bdf5ee55b1ef3$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $a94bdf5ee55b1ef3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a94bdf5ee55b1ef3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a94bdf5ee55b1ef3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a94bdf5ee55b1ef3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a94bdf5ee55b1ef3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a94bdf5ee55b1ef3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a94bdf5ee55b1ef3$var$_slicedToArray(r, e) {
    return $a94bdf5ee55b1ef3$var$_arrayWithHoles(r) || $a94bdf5ee55b1ef3$var$_iterableToArrayLimit(r, e) || $a94bdf5ee55b1ef3$var$_unsupportedIterableToArray(r, e) || $a94bdf5ee55b1ef3$var$_nonIterableRest();
}
var $a94bdf5ee55b1ef3$var$styles = "\n.p-virtualscroller {\n    position: relative;\n    overflow: auto;\n    contain: strict;\n    transform: translateZ(0);\n    will-change: scroll-position;\n    outline: 0 none;\n}\n\n.p-virtualscroller-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*contain: content;*/\n    min-height: 100%;\n    min-width: 100%;\n    will-change: transform;\n}\n\n.p-virtualscroller-spacer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1px;\n    width: 1px;\n    transform-origin: 0 0;\n    pointer-events: none;\n}\n\n.p-virtualscroller-loader {\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.p-virtualscroller-loader.p-component-overlay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-virtualscroller-loading-icon {\n    font-size: 2rem;\n}\n\n.p-virtualscroller-horizontal > .p-virtualscroller-content {\n    display: flex;\n}\n\n/* Inline */\n.p-virtualscroller-inline .p-virtualscroller-content {\n    position: static;\n}\n";
var $a94bdf5ee55b1ef3$var$VirtualScrollerBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'VirtualScroller',
        __parentMetadata: null,
        id: null,
        style: null,
        className: null,
        tabIndex: 0,
        items: null,
        itemSize: 0,
        scrollHeight: null,
        scrollWidth: null,
        orientation: 'vertical',
        step: 0,
        numToleratedItems: null,
        delay: 0,
        resizeDelay: 10,
        appendOnly: false,
        inline: false,
        lazy: false,
        disabled: false,
        loaderDisabled: false,
        loadingIcon: null,
        columns: null,
        loading: undefined,
        autoSize: false,
        showSpacer: true,
        showLoader: false,
        loadingTemplate: null,
        loaderIconTemplate: null,
        itemTemplate: null,
        contentTemplate: null,
        onScroll: null,
        onScrollIndexChange: null,
        onLazyLoad: null,
        children: undefined
    },
    css: {
        styles: $a94bdf5ee55b1ef3$var$styles
    }
});
function $a94bdf5ee55b1ef3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a94bdf5ee55b1ef3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a94bdf5ee55b1ef3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a94bdf5ee55b1ef3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a94bdf5ee55b1ef3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a94bdf5ee55b1ef3$export$fbd4ea7fe0fb889 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $a94bdf5ee55b1ef3$var$VirtualScrollerBase.getProps(inProps, context);
    var prevProps = (0, $kocnD.usePrevious)(inProps) || {};
    var vertical = props.orientation === 'vertical';
    var horizontal = props.orientation === 'horizontal';
    var both = props.orientation === 'both';
    var _React$useState = $8NFma.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState2 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $8NFma.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState4 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState3, 2), lastState = _React$useState4[0], setLastState = _React$useState4[1];
    var _React$useState5 = $8NFma.useState(0), _React$useState6 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState5, 2), pageState = _React$useState6[0], setPageState = _React$useState6[1];
    var _React$useState7 = $8NFma.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState8 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState7, 2), numItemsInViewportState = _React$useState8[0], setNumItemsInViewportState = _React$useState8[1];
    var _React$useState9 = $8NFma.useState(props.numToleratedItems), _React$useState10 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState9, 2), numToleratedItemsState = _React$useState10[0], setNumToleratedItemsState = _React$useState10[1];
    var _React$useState11 = $8NFma.useState(props.loading || false), _React$useState12 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState11, 2), loadingState = _React$useState12[0], setLoadingState = _React$useState12[1];
    var _React$useState13 = $8NFma.useState([]), _React$useState14 = $a94bdf5ee55b1ef3$var$_slicedToArray(_React$useState13, 2), loaderArrState = _React$useState14[0], setLoaderArrState = _React$useState14[1];
    var _VirtualScrollerBase$ = $a94bdf5ee55b1ef3$var$VirtualScrollerBase.setMetaData({
        props: props,
        state: {
            first: firstState,
            last: lastState,
            page: pageState,
            numItemsInViewport: numItemsInViewportState,
            numToleratedItems: numToleratedItemsState,
            loading: loadingState,
            loaderArr: loaderArrState
        }
    }), ptm = _VirtualScrollerBase$.ptm;
    (0, $kocnD.useStyle)($a94bdf5ee55b1ef3$var$VirtualScrollerBase.css.styles, {
        name: 'virtualscroller'
    });
    var elementRef = $8NFma.useRef(null);
    var _contentRef = $8NFma.useRef(null);
    var _spacerRef = $8NFma.useRef(null);
    var _stickyRef = $8NFma.useRef(null);
    var lastScrollPos = $8NFma.useRef(both ? {
        top: 0,
        left: 0
    } : 0);
    var scrollTimeout = $8NFma.useRef(null);
    var resizeTimeout = $8NFma.useRef(null);
    var contentStyle = $8NFma.useRef({});
    var spacerStyle = $8NFma.useRef({});
    var defaultWidth = $8NFma.useRef(null);
    var defaultHeight = $8NFma.useRef(null);
    var defaultContentWidth = $8NFma.useRef(null);
    var defaultContentHeight = $8NFma.useRef(null);
    var isItemRangeChanged = $8NFma.useRef(false);
    var lazyLoadState = $8NFma.useRef(null);
    var viewInitialized = $8NFma.useRef(false);
    var _useResizeListener = (0, $kocnD.useResizeListener)({
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useResizeListener2 = $a94bdf5ee55b1ef3$var$_slicedToArray(_useResizeListener, 1), bindWindowResizeListener = _useResizeListener2[0];
    var _useEventListener = (0, $kocnD.useEventListener)({
        target: 'window',
        type: 'orientationchange',
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useEventListener2 = $a94bdf5ee55b1ef3$var$_slicedToArray(_useEventListener, 1), bindOrientationChangeListener = _useEventListener2[0];
    var getElementRef = function getElementRef() {
        return elementRef;
    };
    var getPageByFirst = function getPageByFirst(first) {
        return Math.floor((first + numToleratedItemsState * 4) / (props.step || 1));
    };
    var setContentElement = function setContentElement(element) {
        _contentRef.current = element || _contentRef.current || (0, $kMhUd.DomHandler).findSingle(elementRef.current, '.p-virtualscroller-content');
    };
    var isPageChanged = function isPageChanged(first) {
        return props.step ? pageState !== getPageByFirst(first) : true;
    };
    var scrollTo = function scrollTo(options) {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
        elementRef.current && elementRef.current.scrollTo(options);
    };
    var scrollToIndex = function scrollToIndex(index) {
        var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
        var _calculateNumItems = calculateNumItems(), numToleratedItems = _calculateNumItems.numToleratedItems;
        var contentPos = getContentPosition();
        var calculateFirst = function calculateFirst() {
            var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var _numT = arguments.length > 1 ? arguments[1] : undefined;
            return _index <= _numT ? 0 : _index;
        };
        var calculateCoord = function calculateCoord(_first, _size, _cpos) {
            return _first * _size + _cpos;
        };
        var scrollToItem = function scrollToItem() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return scrollTo({
                left: left,
                top: top,
                behavior: behavior
            });
        };
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var isRangeChanged = false;
        if (both) {
            newFirst = {
                rows: calculateFirst(index[0], numToleratedItems[0]),
                cols: calculateFirst(index[1], numToleratedItems[1])
            };
            scrollToItem(calculateCoord(newFirst.cols, props.itemSize[1], contentPos.left), calculateCoord(newFirst.rows, props.itemSize[0], contentPos.top));
            isRangeChanged = firstState.rows !== newFirst.rows || firstState.cols !== newFirst.cols;
        } else {
            newFirst = calculateFirst(index, numToleratedItems);
            horizontal ? scrollToItem(calculateCoord(newFirst, props.itemSize, contentPos.left), 0) : scrollToItem(0, calculateCoord(newFirst, props.itemSize, contentPos.top));
            isRangeChanged = firstState !== newFirst;
        }
        isItemRangeChanged.current = isRangeChanged;
        setFirstState(newFirst);
    };
    var scrollInView = function scrollInView(index, to) {
        var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
        if (to) {
            var _getRenderedRange = getRenderedRange(), first = _getRenderedRange.first, viewport = _getRenderedRange.viewport;
            var scrollToItem = function scrollToItem() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return scrollTo({
                    left: left,
                    top: top,
                    behavior: behavior
                });
            };
            var isToStart = to === 'to-start';
            var isToEnd = to === 'to-end';
            if (isToStart) {
                if (both) {
                    if (viewport.first.rows - first.rows > index[0]) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows - 1) * props.itemSize[0]);
                    else if (viewport.first.cols - first.cols > index[1]) scrollToItem((viewport.first.cols - 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.first - first > index) {
                    var pos = (viewport.first - 1) * props.itemSize;
                    horizontal ? scrollToItem(pos, 0) : scrollToItem(0, pos);
                }
            } else if (isToEnd) {
                if (both) {
                    if (viewport.last.rows - first.rows <= index[0] + 1) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows + 1) * props.itemSize[0]);
                    else if (viewport.last.cols - first.cols <= index[1] + 1) scrollToItem((viewport.first.cols + 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.last - first <= index + 1) {
                    var _pos2 = (viewport.first + 1) * props.itemSize;
                    horizontal ? scrollToItem(_pos2, 0) : scrollToItem(0, _pos2);
                }
            }
        } else scrollToIndex(index, behavior);
    };
    var getRows = function getRows() {
        return loadingState ? props.loaderDisabled ? loaderArrState : [] : loadedItems();
    };
    var getColumns = function getColumns() {
        if (props.columns && both || horizontal) return loadingState && props.loaderDisabled ? both ? loaderArrState[0] : loaderArrState : props.columns.slice(both ? firstState.cols : firstState, both ? lastState.cols : lastState);
        return props.columns;
    };
    var getRenderedRange = function getRenderedRange() {
        var calculateFirstInViewport = function calculateFirstInViewport(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var firstInViewport = firstState;
        var lastInViewport = 0;
        if (elementRef.current) {
            var _elementRef$current = elementRef.current, scrollTop = _elementRef$current.scrollTop, scrollLeft = _elementRef$current.scrollLeft;
            if (both) {
                firstInViewport = {
                    rows: calculateFirstInViewport(scrollTop, props.itemSize[0]),
                    cols: calculateFirstInViewport(scrollLeft, props.itemSize[1])
                };
                lastInViewport = {
                    rows: firstInViewport.rows + numItemsInViewportState.rows,
                    cols: firstInViewport.cols + numItemsInViewportState.cols
                };
            } else {
                var scrollPos = horizontal ? scrollLeft : scrollTop;
                firstInViewport = calculateFirstInViewport(scrollPos, props.itemSize);
                lastInViewport = firstInViewport + numItemsInViewportState;
            }
        }
        return {
            first: firstState,
            last: lastState,
            viewport: {
                first: firstInViewport,
                last: lastInViewport
            }
        };
    };
    var calculateNumItems = function calculateNumItems() {
        var contentPos = getContentPosition();
        var contentWidth = elementRef.current ? elementRef.current.offsetWidth - contentPos.left : 0;
        var contentHeight = elementRef.current ? elementRef.current.offsetHeight - contentPos.top : 0;
        var calculateNumItemsInViewport = function calculateNumItemsInViewport(_contentSize, _itemSize) {
            return Math.ceil(_contentSize / (_itemSize || _contentSize));
        };
        var calculateNumToleratedItems = function calculateNumToleratedItems(_numItems) {
            return Math.ceil(_numItems / 2);
        };
        var numItemsInViewport = both ? {
            rows: calculateNumItemsInViewport(contentHeight, props.itemSize[0]),
            cols: calculateNumItemsInViewport(contentWidth, props.itemSize[1])
        } : calculateNumItemsInViewport(horizontal ? contentWidth : contentHeight, props.itemSize);
        var numToleratedItems = numToleratedItemsState || (both ? [
            calculateNumToleratedItems(numItemsInViewport.rows),
            calculateNumToleratedItems(numItemsInViewport.cols)
        ] : calculateNumToleratedItems(numItemsInViewport));
        return {
            numItemsInViewport: numItemsInViewport,
            numToleratedItems: numToleratedItems
        };
    };
    var calculateOptions = function calculateOptions() {
        var _calculateNumItems2 = calculateNumItems(), numItemsInViewport = _calculateNumItems2.numItemsInViewport, numToleratedItems = _calculateNumItems2.numToleratedItems;
        var calculateLast = function calculateLast(_first, _num, _numT) {
            var _isCols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return getLast(_first + _num + (_first < _numT ? 2 : 3) * _numT, _isCols);
        };
        var last = both ? {
            rows: calculateLast(firstState.rows, numItemsInViewport.rows, numToleratedItems[0]),
            cols: calculateLast(firstState.cols, numItemsInViewport.cols, numToleratedItems[1], true)
        } : calculateLast(firstState, numItemsInViewport, numToleratedItems);
        setNumItemsInViewportState(numItemsInViewport);
        setNumToleratedItemsState(numToleratedItems);
        setLastState(last);
        if (props.showLoader) setLoaderArrState(both ? Array.from({
            length: numItemsInViewport.rows
        }).map(function() {
            return Array.from({
                length: numItemsInViewport.cols
            });
        }) : Array.from({
            length: numItemsInViewport
        }));
        if (props.lazy) Promise.resolve().then(function() {
            lazyLoadState.current = {
                first: props.step ? both ? {
                    rows: 0,
                    cols: firstState.cols
                } : 0 : firstState,
                last: Math.min(props.step ? props.step : last, (props.items || []).length)
            };
            props.onLazyLoad && props.onLazyLoad(lazyLoadState.current);
        });
    };
    var calculateAutoSize = function calculateAutoSize(loading) {
        if (props.autoSize && !loading) Promise.resolve().then(function() {
            if (_contentRef.current) {
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = 'auto';
                _contentRef.current.style.position = 'relative';
                elementRef.current.style.contain = 'none';
                /*const [contentWidth, contentHeight] = [DomHandler.getWidth(contentRef.current), DomHandler.getHeight(contentRef.current)];
           contentWidth !== defaultContentWidth.current && (elementRef.current.style.width = '');
          contentHeight !== defaultContentHeight.current && (elementRef.current.style.height = '');*/ var _ref = [
                    (0, $kMhUd.DomHandler).getWidth(elementRef.current),
                    (0, $kMhUd.DomHandler).getHeight(elementRef.current)
                ], width = _ref[0], height = _ref[1];
                (both || horizontal) && (elementRef.current.style.width = (width < defaultWidth.current ? width : props.scrollWidth || defaultWidth.current) + 'px');
                (both || vertical) && (elementRef.current.style.height = (height < defaultHeight.current ? height : props.scrollHeight || defaultHeight.current) + 'px');
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = '';
                _contentRef.current.style.position = '';
                elementRef.current.style.contain = '';
            }
        });
    };
    var getLast = function getLast() {
        var _ref2;
        var last = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var isCols = arguments.length > 1 ? arguments[1] : undefined;
        return props.items ? Math.min(isCols ? ((_ref2 = props.columns || props.items[0]) === null || _ref2 === void 0 ? void 0 : _ref2.length) || 0 : (props.items || []).length, last) : 0;
    };
    var getContentPosition = function getContentPosition() {
        if (_contentRef.current) {
            var style = getComputedStyle(_contentRef.current);
            var left = parseFloat(style.paddingLeft) + Math.max(parseFloat(style.left) || 0, 0);
            var right = parseFloat(style.paddingRight) + Math.max(parseFloat(style.right) || 0, 0);
            var top = parseFloat(style.paddingTop) + Math.max(parseFloat(style.top) || 0, 0);
            var bottom = parseFloat(style.paddingBottom) + Math.max(parseFloat(style.bottom) || 0, 0);
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                x: left + right,
                y: top + bottom
            };
        }
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            x: 0,
            y: 0
        };
    };
    var setSize = function setSize() {
        if (elementRef.current) {
            var parentElement = elementRef.current.parentElement;
            var width = props.scrollWidth || "".concat(elementRef.current.offsetWidth || parentElement.offsetWidth, "px");
            var height = props.scrollHeight || "".concat(elementRef.current.offsetHeight || parentElement.offsetHeight, "px");
            var setProp = function setProp(_name, _value) {
                return elementRef.current.style[_name] = _value;
            };
            if (both || horizontal) {
                setProp('height', height);
                setProp('width', width);
            } else setProp('height', height);
        }
    };
    var setSpacerSize = function setSpacerSize() {
        var items = props.items;
        if (items) {
            var contentPos = getContentPosition();
            var setProp = function setProp(_name, _value, _size) {
                var _cpos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                return spacerStyle.current = $a94bdf5ee55b1ef3$var$_objectSpread($a94bdf5ee55b1ef3$var$_objectSpread({}, spacerStyle.current), $a94bdf5ee55b1ef3$var$_defineProperty({}, "".concat(_name), (_value || []).length * _size + _cpos + 'px'));
            };
            if (both) {
                setProp('height', items, props.itemSize[0], contentPos.y);
                setProp('width', props.columns || items[1], props.itemSize[1], contentPos.x);
            } else horizontal ? setProp('width', props.columns || items, props.itemSize, contentPos.x) : setProp('height', items, props.itemSize, contentPos.y);
        }
    };
    var setContentPosition = function setContentPosition(pos) {
        if (_contentRef.current && !props.appendOnly) {
            var first = pos ? pos.first : firstState;
            var calculateTranslateVal = function calculateTranslateVal(_first, _size) {
                return _first * _size;
            };
            var setTransform = function setTransform() {
                var _x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var _y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _stickyRef.current && (_stickyRef.current.style.top = "-".concat(_y, "px"));
                contentStyle.current = $a94bdf5ee55b1ef3$var$_objectSpread($a94bdf5ee55b1ef3$var$_objectSpread({}, contentStyle.current), {
                    transform: "translate3d(".concat(_x, "px, ").concat(_y, "px, 0)")
                });
            };
            if (both) setTransform(calculateTranslateVal(first.cols, props.itemSize[1]), calculateTranslateVal(first.rows, props.itemSize[0]));
            else {
                var translateVal = calculateTranslateVal(first, props.itemSize);
                horizontal ? setTransform(translateVal, 0) : setTransform(0, translateVal);
            }
        }
    };
    var onScrollPositionChange = function onScrollPositionChange(event) {
        var target = event.target;
        var contentPos = getContentPosition();
        var calculateScrollPos = function calculateScrollPos(_pos, _cpos) {
            return _pos ? _pos > _cpos ? _pos - _cpos : _pos : 0;
        };
        var calculateCurrentIndex = function calculateCurrentIndex(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var calculateTriggerIndex = function calculateTriggerIndex(_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            return _currentIndex <= _numT ? _numT : _isScrollDownOrRight ? _last - _num - _numT : _first + _numT - 1;
        };
        var calculateFirst = function calculateFirst(_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            if (_currentIndex <= _numT) return 0;
            return Math.max(0, _isScrollDownOrRight ? _currentIndex < _triggerIndex ? _first : _currentIndex - _numT : _currentIndex > _triggerIndex ? _first : _currentIndex - 2 * _numT);
        };
        var calculateLast = function calculateLast(_currentIndex, _first, _last, _num, _numT, _isCols) {
            var lastValue = _first + _num + 2 * _numT;
            if (_currentIndex >= _numT) lastValue = lastValue + (_numT + 1);
            return getLast(lastValue, _isCols);
        };
        var scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
        var scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var newLast = lastState;
        var isRangeChanged = false;
        var newScrollPos = lastScrollPos.current;
        if (both) {
            var isScrollDown = lastScrollPos.current.top <= scrollTop;
            var isScrollRight = lastScrollPos.current.left <= scrollLeft;
            if (!props.appendOnly || props.appendOnly && (isScrollDown || isScrollRight)) {
                var currentIndex = {
                    rows: calculateCurrentIndex(scrollTop, props.itemSize[0]),
                    cols: calculateCurrentIndex(scrollLeft, props.itemSize[1])
                };
                var triggerIndex = {
                    rows: calculateTriggerIndex(currentIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateTriggerIndex(currentIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newFirst = {
                    rows: calculateFirst(currentIndex.rows, triggerIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateFirst(currentIndex.cols, triggerIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newLast = {
                    rows: calculateLast(currentIndex.rows, newFirst.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0]),
                    cols: calculateLast(currentIndex.cols, newFirst.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], true)
                };
                isRangeChanged = newFirst.rows !== firstState.rows || newLast.rows !== lastState.rows || newFirst.cols !== firstState.cols || newLast.cols !== lastState.cols || isItemRangeChanged.current;
                newScrollPos = {
                    top: scrollTop,
                    left: scrollLeft
                };
            }
        } else {
            var scrollPos = horizontal ? scrollLeft : scrollTop;
            var isScrollDownOrRight = lastScrollPos.current <= scrollPos;
            if (!props.appendOnly || props.appendOnly && isScrollDownOrRight) {
                var _currentIndex2 = calculateCurrentIndex(scrollPos, props.itemSize);
                var _triggerIndex2 = calculateTriggerIndex(_currentIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newFirst = calculateFirst(_currentIndex2, _triggerIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newLast = calculateLast(_currentIndex2, newFirst, lastState, numItemsInViewportState, numToleratedItemsState);
                isRangeChanged = newFirst !== firstState || newLast !== lastState || isItemRangeChanged.current;
                newScrollPos = scrollPos;
            }
        }
        return {
            first: newFirst,
            last: newLast,
            isRangeChanged: isRangeChanged,
            scrollPos: newScrollPos
        };
    };
    var onScrollChange = function onScrollChange(event) {
        var _onScrollPositionChan = onScrollPositionChange(event), first = _onScrollPositionChan.first, last = _onScrollPositionChan.last, isRangeChanged = _onScrollPositionChan.isRangeChanged, scrollPos = _onScrollPositionChan.scrollPos;
        if (isRangeChanged) {
            var newState = {
                first: first,
                last: last
            };
            setContentPosition(newState);
            setFirstState(first);
            setLastState(last);
            lastScrollPos.current = scrollPos;
            props.onScrollIndexChange && props.onScrollIndexChange(newState);
            if (props.lazy && isPageChanged(first)) {
                var newLazyLoadState = {
                    first: props.step ? Math.min(getPageByFirst(first) * props.step, (props.items || []).length - props.step) : first,
                    last: Math.min(props.step ? (getPageByFirst(first) + 1) * props.step : last, (props.items || []).length)
                };
                var isLazyStateChanged = !lazyLoadState.current || lazyLoadState.current.first !== newLazyLoadState.first || lazyLoadState.current.last !== newLazyLoadState.last;
                isLazyStateChanged && props.onLazyLoad && props.onLazyLoad(newLazyLoadState);
                lazyLoadState.current = newLazyLoadState;
            }
        }
    };
    var _onScroll = function onScroll(event) {
        props.onScroll && props.onScroll(event);
        if (props.delay) {
            if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
            if (isPageChanged(firstState)) {
                if (!loadingState && props.showLoader) {
                    var _onScrollPositionChan2 = onScrollPositionChange(event), isRangeChanged = _onScrollPositionChan2.isRangeChanged;
                    var changed = isRangeChanged || (props.step ? isPageChanged(firstState) : false);
                    changed && setLoadingState(true);
                }
                scrollTimeout.current = setTimeout(function() {
                    onScrollChange(event);
                    if (loadingState && props.showLoader && (!props.lazy || props.loading === undefined)) {
                        setLoadingState(false);
                        setPageState(getPageByFirst(firstState));
                    }
                }, props.delay);
            }
        } else onScrollChange(event);
    };
    var onResize = function onResize() {
        if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
        resizeTimeout.current = setTimeout(function() {
            if (elementRef.current) {
                var _ref3 = [
                    (0, $kMhUd.DomHandler).getWidth(elementRef.current),
                    (0, $kMhUd.DomHandler).getHeight(elementRef.current)
                ], width = _ref3[0], height = _ref3[1];
                var isDiffWidth = width !== defaultWidth.current, isDiffHeight = height !== defaultHeight.current;
                var reinit = both ? isDiffWidth || isDiffHeight : horizontal ? isDiffWidth : vertical ? isDiffHeight : false;
                if (reinit) {
                    setNumToleratedItemsState(props.numToleratedItems);
                    defaultWidth.current = width;
                    defaultHeight.current = height;
                    defaultContentWidth.current = (0, $kMhUd.DomHandler).getWidth(_contentRef.current);
                    defaultContentHeight.current = (0, $kMhUd.DomHandler).getHeight(_contentRef.current);
                }
            }
        }, props.resizeDelay);
    };
    var getOptions = function getOptions(renderedIndex) {
        var count = (props.items || []).length;
        var index = both ? firstState.rows + renderedIndex : firstState + renderedIndex;
        return {
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        };
    };
    var loaderOptions = function loaderOptions(index, extOptions) {
        var count = loaderArrState.length || 0;
        return $a94bdf5ee55b1ef3$var$_objectSpread({
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        }, extOptions);
    };
    var loadedItems = function loadedItems() {
        var items = props.items;
        if (items && !loadingState) {
            if (both) return items.slice(props.appendOnly ? 0 : firstState.rows, lastState.rows).map(function(item) {
                return props.columns ? item : item.slice(props.appendOnly ? 0 : firstState.cols, lastState.cols);
            });
            else if (horizontal && props.columns) return items;
            return items.slice(props.appendOnly ? 0 : firstState, lastState);
        }
        return [];
    };
    var viewInit = function viewInit() {
        if (elementRef.current && isVisible()) {
            setContentElement(_contentRef.current);
            init();
            bindWindowResizeListener();
            bindOrientationChangeListener();
            defaultWidth.current = (0, $kMhUd.DomHandler).getWidth(elementRef.current);
            defaultHeight.current = (0, $kMhUd.DomHandler).getHeight(elementRef.current);
            defaultContentWidth.current = (0, $kMhUd.DomHandler).getWidth(_contentRef.current);
            defaultContentHeight.current = (0, $kMhUd.DomHandler).getHeight(_contentRef.current);
        }
    };
    var init = function init() {
        if (!props.disabled && isVisible()) {
            setSize();
            calculateOptions();
            setSpacerSize();
        }
    };
    var isVisible = function isVisible() {
        if ((0, $kMhUd.DomHandler).isVisible(elementRef.current)) {
            var rect = elementRef.current.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0;
        }
        return false;
    };
    $8NFma.useEffect(function() {
        if (!viewInitialized.current && isVisible()) {
            viewInit();
            viewInitialized.current = true;
        }
    });
    (0, $kocnD.useUpdateEffect)(function() {
        init();
    }, [
        props.itemSize,
        props.scrollHeight,
        props.scrollWidth
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (props.numToleratedItems !== numToleratedItemsState) setNumToleratedItemsState(props.numToleratedItems);
    }, [
        props.numToleratedItems
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        if (props.numToleratedItems === numToleratedItemsState) init(); // reinit after resizing
    }, [
        numToleratedItemsState
    ]);
    (0, $kocnD.useUpdateEffect)(function() {
        // Check if the previous/current rows array exists
        var prevRowsExist = prevProps.items !== undefined && prevProps.items !== null;
        var currentRowsExist = props.items !== undefined && props.items !== null;
        // Get the length of the previous/current rows array, or 0 if it doesn't exist
        var prevRowsLength = prevRowsExist ? prevProps.items.length : 0;
        var currentRowsLength = currentRowsExist ? props.items.length : 0;
        // Check if the length of the rows arrays has changed
        var valuesChanged = prevRowsLength !== currentRowsLength;
        // If both is true, we also need to check the lengths of the first element (assuming it's a matrix)
        if (both && !valuesChanged) {
            // Get the length of the columns or 0
            var prevColumnsLength = prevRowsExist && prevProps.items.length > 0 ? prevProps.items[0].length : 0;
            var currentColumnsLength = currentRowsExist && props.items.length > 0 ? props.items[0].length : 0;
            // Check if the length of the columns has changed
            valuesChanged = prevColumnsLength !== currentColumnsLength;
        }
        // If the previous items array doesn't exist or if any values have changed, call the init function
        if (!prevRowsExist || valuesChanged) init();
        var loading = loadingState;
        if (props.lazy && prevProps.loading !== props.loading && props.loading !== loadingState) {
            setLoadingState(props.loading);
            loading = props.loading;
        }
        calculateAutoSize(loading);
    });
    (0, $kocnD.useUpdateEffect)(function() {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
    }, [
        props.orientation
    ]);
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElementRef: getElementRef,
            scrollTo: scrollTo,
            scrollToIndex: scrollToIndex,
            scrollInView: scrollInView,
            getRenderedRange: getRenderedRange
        };
    });
    var createLoaderItem = function createLoaderItem(index) {
        var extOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = loaderOptions(index, extOptions);
        var content = (0, $kMhUd.ObjectUtils).getJSXElement(props.loadingTemplate, options);
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, {
            key: index
        }, content);
    };
    var createLoader = function createLoader() {
        var iconClassName = 'p-virtualscroller-loading-icon';
        var loadingIconProps = mergeProps({
            className: iconClassName
        }, ptm('loadingIcon'));
        var icon = props.loadingIcon || /*#__PURE__*/ $8NFma.createElement((0, $6rN57.SpinnerIcon), $a94bdf5ee55b1ef3$var$_extends({}, loadingIconProps, {
            spin: true
        }));
        var loadingIcon = (0, $kMhUd.IconUtils).getJSXIcon(icon, $a94bdf5ee55b1ef3$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        if (!props.loaderDisabled && props.showLoader && loadingState) {
            var _className = (0, $kMhUd.classNames)('p-virtualscroller-loader', {
                'p-component-overlay': !props.loadingTemplate
            });
            var _content = loadingIcon;
            if (props.loadingTemplate) _content = loaderArrState.map(function(_, index) {
                return createLoaderItem(index, both && {
                    numCols: numItemsInViewportState.cols
                });
            });
            else if (props.loaderIconTemplate) {
                var defaultContentOptions = {
                    iconClassName: iconClassName,
                    element: _content,
                    props: props
                };
                _content = (0, $kMhUd.ObjectUtils).getJSXElement(props.loaderIconTemplate, defaultContentOptions);
            }
            var loaderProps = mergeProps({
                className: _className
            }, ptm('loader'));
            return /*#__PURE__*/ $8NFma.createElement("div", loaderProps, _content);
        }
        return null;
    };
    var createSpacer = function createSpacer() {
        if (props.showSpacer) {
            var spacerProps = mergeProps({
                ref: _spacerRef,
                style: spacerStyle.current,
                className: 'p-virtualscroller-spacer'
            }, ptm('spacer'));
            return /*#__PURE__*/ $8NFma.createElement("div", spacerProps);
        }
        return null;
    };
    var createItem = function createItem(item, index) {
        var options = getOptions(index);
        var content = (0, $kMhUd.ObjectUtils).getJSXElement(props.itemTemplate, item, options);
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, {
            key: options.index
        }, content);
    };
    var createItems = function createItems() {
        var items = loadedItems();
        return items.map(createItem);
    };
    var createContent = function createContent() {
        var items = createItems();
        var className = (0, $kMhUd.classNames)('p-virtualscroller-content', {
            'p-virtualscroller-loading': loadingState
        });
        var contentProps = mergeProps({
            ref: _contentRef,
            style: contentStyle.current,
            className: className
        }, ptm('content'));
        var content = /*#__PURE__*/ $8NFma.createElement("div", contentProps, items);
        if (props.contentTemplate) {
            var defaultOptions = {
                style: contentStyle.current,
                className: className,
                spacerStyle: spacerStyle.current,
                contentRef: function contentRef(el) {
                    return _contentRef.current = (0, $kMhUd.ObjectUtils).getRefElement(el);
                },
                spacerRef: function spacerRef(el) {
                    return _spacerRef.current = (0, $kMhUd.ObjectUtils).getRefElement(el);
                },
                stickyRef: function stickyRef(el) {
                    return _stickyRef.current = (0, $kMhUd.ObjectUtils).getRefElement(el);
                },
                items: loadedItems(),
                getItemOptions: function getItemOptions(index) {
                    return getOptions(index);
                },
                children: items,
                element: content,
                props: props,
                loading: loadingState,
                getLoaderOptions: function getLoaderOptions(index, ext) {
                    return loaderOptions(index, ext);
                },
                loadingTemplate: props.loadingTemplate,
                itemSize: props.itemSize,
                rows: getRows(),
                columns: getColumns(),
                vertical: vertical,
                horizontal: horizontal,
                both: both
            };
            return (0, $kMhUd.ObjectUtils).getJSXElement(props.contentTemplate, defaultOptions);
        }
        return content;
    };
    if (props.disabled) {
        var _content2 = (0, $kMhUd.ObjectUtils).getJSXElement(props.contentTemplate, {
            items: props.items,
            rows: props.items,
            columns: props.columns
        });
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, props.children, _content2);
    }
    var className = (0, $kMhUd.classNames)('p-virtualscroller', {
        'p-virtualscroller-inline': props.inline,
        'p-virtualscroller-both p-both-scroll': both,
        'p-virtualscroller-horizontal p-horizontal-scroll': horizontal
    }, props.className);
    var loader = createLoader();
    var content = createContent();
    var spacer = createSpacer();
    var rootProps = mergeProps({
        ref: elementRef,
        className: className,
        tabIndex: props.tabIndex,
        style: props.style,
        onScroll: function onScroll(e) {
            return _onScroll(e);
        }
    }, $a94bdf5ee55b1ef3$var$VirtualScrollerBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $8NFma.createElement("div", rootProps, content, spacer, loader);
}));
$a94bdf5ee55b1ef3$export$fbd4ea7fe0fb889.displayName = 'VirtualScroller';

});

parcelRegister("gcC5Z", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", () => $bcbb51528baef266$export$7dd004358974b05d);

var $8NFma = parcelRequire("8NFma");

var $e6EfM = parcelRequire("e6EfM");
'use client';
function $bcbb51528baef266$var$_extends() {
    return $bcbb51528baef266$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bcbb51528baef266$var$_extends.apply(null, arguments);
}
var $bcbb51528baef266$export$7dd004358974b05d = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var pti = (0, $e6EfM.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $8NFma.createElement("svg", $bcbb51528baef266$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
        fill: "currentColor"
    }));
}));
$bcbb51528baef266$export$7dd004358974b05d.displayName = 'CheckIcon';

});



parcelRegister("cfEU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f39b4c02daa6303$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $9f39b4c02daa6303$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
];
const $9f39b4c02daa6303$export$2e2bcd8739ae039 = (0, $8KNb5.default)("save", $9f39b4c02daa6303$export$3efd853dbb351e94);

});


parcelRegister("01tLc", function(module, exports) {

$parcel$export(module.exports, "WaveformSlider", () => $378ab9c2e06beec6$export$3fecc7e6d09e4d26);

var $1IdZj = parcelRequire("1IdZj");

var $fsDVB = parcelRequire("fsDVB");

var $8G5I5 = parcelRequire("8G5I5");

var $iyzl5 = parcelRequire("iyzl5");

var $5Yd7b = parcelRequire("5Yd7b");

var $dq8y8 = parcelRequire("dq8y8");
function $378ab9c2e06beec6$export$3fecc7e6d09e4d26({ instrument: instrument }) {
    const waveformIcons = {
        sine: (0, $fsDVB.default),
        triangle: (0, $8G5I5.default),
        square: (0, $iyzl5.default),
        sawtooth: (0, $5Yd7b.default)
    };
    const handler = instrument.getParameterHandler("osc_waveform");
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        "data-widget-id": "oscWaveform",
        className: "flex flex-col w-full",
        style: {
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dq8y8.ParameterSlider), {
                orientation: "horizontal",
                parameterHandler: handler,
                noLabel: "true",
                noOutput: "true",
                style: {
                    width: "75%"
                },
                className: "self-center"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "flex justify-between",
                style: {
                    height: 10,
                    paddingInline: 10
                },
                children: handler.description.options.map((option)=>{
                    const Icon = waveformIcons[option];
                    return /*#__PURE__*/ (0, $1IdZj.jsx)(Icon, {}, option);
                })
            })
        ]
    });
}

});
parcelRegister("fsDVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a401b2945f229d6d$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
function $a401b2945f229d6d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        xmlSpace: "preserve",
        id: "eebf5e__svg45",
        viewBox: "0 0 96.735 35.893",
        ...props,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            fill: "none",
            stroke: "#979595",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
            strokeWidth: 4.167,
            d: "m2.083 18.012 5.459-7.186a22.206 22.206 0 0 1 35.367 0l5.458 7.186 5.39 7.053a22.342 22.342 0 0 0 35.504 0l5.39-7.053"
        })
    });
}

});

parcelRegister("8G5I5", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fc251d0f1aeb8e$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
function $10fc251d0f1aeb8e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        xmlSpace: "preserve",
        id: "9863ea__svg45",
        viewBox: "0 0 96.735 39.899",
        ...props,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            id: "9863ea__path49",
            fill: "none",
            stroke: "#979595",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
            strokeWidth: 4.167,
            d: "M2.083 37.816 48.368 2.083 94.65 37.816"
        })
    });
}

});

parcelRegister("iyzl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6296d2ddcec7d66$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
function $d6296d2ddcec7d66$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        xmlSpace: "preserve",
        id: "380638__svg45",
        viewBox: "0 0 96.735 39.9",
        ...props,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            id: "380638__path51",
            fill: "none",
            stroke: "#979595",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
            strokeWidth: 4.167,
            d: "M2.083 37.816V2.083h46.284v35.733h46.284"
        })
    });
}

});

parcelRegister("5Yd7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbe0ebc3f3cbca5$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
function $3cbe0ebc3f3cbca5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        xmlSpace: "preserve",
        id: "9c326d__svg45",
        viewBox: "0 0 96.735 39.9",
        ...props,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            id: "9c326d__path50",
            fill: "none",
            stroke: "#979595",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
            strokeWidth: 4.167,
            d: "M2.083 37.816V2.083l92.568 35.733"
        })
    });
}

});

parcelRegister("dq8y8", function(module, exports) {

$parcel$export(module.exports, "ParameterSlider", () => $442a2cff06a4e3d0$export$20ce166b0ab4c911);

var $1IdZj = parcelRequire("1IdZj");

var $9Vyg3 = parcelRequire("9Vyg3");

var $7Kpeg = parcelRequire("7Kpeg");
const $442a2cff06a4e3d0$export$20ce166b0ab4c911 = ({ parameterHandler: parameterHandler, orientation: orientation, className: className, size: size, style: style = {}, label: label, labelSize: labelSize = "12px", noLabel: noLabel = false, noOutput: noOutput = false, ...props })=>{
    if (orientation === 'vertical') style.height = size ?? style.height ?? '80px';
    if (orientation === 'horizontal') style.width = size ?? style.width ?? '200px';
    const dispatch = (0, $7Kpeg.useDispatch)();
    const onNewValue = (value)=>dispatch(parameterHandler.updater(parameterHandler.num2Real(value)));
    const realValue = (0, $7Kpeg.useSelector)(parameterHandler.selector);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9Vyg3.Slider), {
        ...props,
        style: style,
        className: className,
        orientation: orientation,
        value: parameterHandler.real2Num(realValue),
        step: parameterHandler.getStep(),
        min: parameterHandler.getNumericMin(),
        max: parameterHandler.getNumericMax(),
        onNewValue: onNewValue,
        label: label || parameterHandler.description.label,
        output: parameterHandler.real2String(realValue),
        noLabel: noLabel,
        noOutput: noOutput,
        onDoubleClick: ()=>dispatch(parameterHandler.updater(parameterHandler.getDefaultValue()))
    });
};

});
parcelRegister("9Vyg3", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $c788b680cc370733$export$472062a354075cee);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $9xysn = parcelRequire("9xysn");

var $bZQ44 = parcelRequire("bZQ44");

var $9Rnnc = parcelRequire("9Rnnc");

var $1zQag = parcelRequire("1zQag");
const $c788b680cc370733$export$472062a354075cee = ({ className: className = "", value: value, step: step, min: min, max: max, onNewValue: onNewValue, orientation: orientation = 'horizontal', style: style, label: label, labelSize: labelSize = "12px", output: output, noLabel: noLabel = false, noOutput: noOutput = false, isRange: isRange = false, colorRange: colorRange = false, throttleDeps: throttleDeps = [], ...props })=>{
    const widgetData = (0, $1zQag.getWidgetData)(props['data-widget-id']);
    if (widgetData) label ??= widgetData.label?.ca;
    const [isDragging, setIsDragging] = (0, $8NFma.useState)(false);
    const handleChange = (0, $8NFma.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9Rnnc)))((value, ...throttleDeps)=>onNewValue(value, ...throttleDeps), (0, $9xysn.getCurrentProject)().continuousControlThrottleTime));
    const sliderId = (0, $8NFma.useId)();
    // can't use useFocus and FloatingValue because PrimeSlider doesn't give us a ref to attach to
    // TODO: substitute PrimeSlider for another widget
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: `slider ${orientation} ${className}`,
        style: style,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bZQ44.Slider), {
                ...props,
                className: `${colorRange ? "color-range" : ""}`,
                id: sliderId,
                orientation: orientation,
                value: value,
                step: step,
                min: min,
                max: max,
                onChange: (e)=>{
                    const newValue = e.value;
                    const oldValue = value;
                    handleChange.current(newValue, ...throttleDeps, oldValue);
                },
                range: isRange,
                onPointerDown: (e)=>{
                    if (e.target.className.includes("p-slider-handle")) setIsDragging(true);
                },
                onSlideEnd: ()=>setIsDragging(false)
            }),
            !noLabel && /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                style: {
                    fontSize: labelSize
                },
                htmlFor: sliderId,
                children: label
            }),
            !noOutput && /*#__PURE__*/ (0, $1IdZj.jsx)("output", {
                className: `parameter-value-display compatibility ${isDragging ? "show" : ""}`,
                htmlFor: sliderId,
                children: output
            })
        ]
    });
};

});
parcelRegister("bZQ44", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $8bbdc72d87d9bf8d$export$472062a354075cee);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $64a8q = parcelRequire("64a8q");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");
'use client';
function $8bbdc72d87d9bf8d$var$_extends() {
    return $8bbdc72d87d9bf8d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8bbdc72d87d9bf8d$var$_extends.apply(null, arguments);
}
function $8bbdc72d87d9bf8d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8bbdc72d87d9bf8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8bbdc72d87d9bf8d$var$_typeof(o);
}
function $8bbdc72d87d9bf8d$var$toPrimitive(t, r) {
    if ("object" != $8bbdc72d87d9bf8d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8bbdc72d87d9bf8d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8bbdc72d87d9bf8d$var$toPropertyKey(t) {
    var i = $8bbdc72d87d9bf8d$var$toPrimitive(t, "string");
    return "symbol" == $8bbdc72d87d9bf8d$var$_typeof(i) ? i : i + "";
}
function $8bbdc72d87d9bf8d$var$_defineProperty(e, r, t) {
    return (r = $8bbdc72d87d9bf8d$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8bbdc72d87d9bf8d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8bbdc72d87d9bf8d$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8bbdc72d87d9bf8d$var$_arrayLikeToArray(r);
}
function $8bbdc72d87d9bf8d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $8bbdc72d87d9bf8d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8bbdc72d87d9bf8d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8bbdc72d87d9bf8d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8bbdc72d87d9bf8d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8bbdc72d87d9bf8d$var$_toConsumableArray(r) {
    return $8bbdc72d87d9bf8d$var$_arrayWithoutHoles(r) || $8bbdc72d87d9bf8d$var$_iterableToArray(r) || $8bbdc72d87d9bf8d$var$_unsupportedIterableToArray(r) || $8bbdc72d87d9bf8d$var$_nonIterableSpread();
}
function $8bbdc72d87d9bf8d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $8bbdc72d87d9bf8d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8bbdc72d87d9bf8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8bbdc72d87d9bf8d$var$_slicedToArray(r, e) {
    return $8bbdc72d87d9bf8d$var$_arrayWithHoles(r) || $8bbdc72d87d9bf8d$var$_iterableToArrayLimit(r, e) || $8bbdc72d87d9bf8d$var$_unsupportedIterableToArray(r, e) || $8bbdc72d87d9bf8d$var$_nonIterableRest();
}
var $8bbdc72d87d9bf8d$var$classes = {
    handle: function handle(_ref) {
        var index = _ref.index, handleIndex = _ref.handleIndex;
        return (0, $kMhUd.classNames)('p-slider-handle', {
            'p-slider-handle-start': index === 0,
            'p-slider-handle-end': index === 1,
            'p-slider-handle-active': handleIndex.current === index
        });
    },
    range: 'p-slider-range',
    root: function root(_ref2) {
        var props = _ref2.props, vertical = _ref2.vertical, horizontal = _ref2.horizontal;
        return (0, $kMhUd.classNames)('p-slider p-component', {
            'p-disabled': props.disabled,
            'p-slider-horizontal': horizontal,
            'p-slider-vertical': vertical
        });
    }
};
var $8bbdc72d87d9bf8d$var$styles = "\n@layer primereact {\n    .p-slider {\n        position: relative;\n    }\n    \n    .p-slider .p-slider-handle {\n        position: absolute;\n        cursor: grab;\n        touch-action: none;\n        display: block;\n        z-index: 1;\n    }\n    \n    .p-slider .p-slider-handle.p-slider-handle-active {\n        z-index: 2;\n    }\n    \n    .p-slider-range {\n        position: absolute;\n        display: block;\n    }\n    \n    .p-slider-horizontal .p-slider-range {\n        top: 0;\n        left: 0;\n        height: 100%;\n    }\n    \n    .p-slider-horizontal .p-slider-handle {\n        top: 50%;\n    }\n    \n    .p-slider-vertical {\n        height: 100px;\n    }\n    \n    .p-slider-vertical .p-slider-handle {\n        left: 50%;\n    }\n    \n    .p-slider-vertical .p-slider-range {\n        bottom: 0;\n        left: 0;\n        width: 100%;\n    }\n}\n";
var $8bbdc72d87d9bf8d$var$inlineStyles = {
    handle: {
        position: 'absolute'
    },
    range: {
        position: 'absolute'
    }
};
var $8bbdc72d87d9bf8d$var$SliderBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Slider',
        id: null,
        value: null,
        min: 0,
        max: 100,
        orientation: 'horizontal',
        step: null,
        range: false,
        style: null,
        className: null,
        disabled: false,
        tabIndex: 0,
        onChange: null,
        onSlideEnd: null,
        children: undefined
    },
    css: {
        classes: $8bbdc72d87d9bf8d$var$classes,
        styles: $8bbdc72d87d9bf8d$var$styles,
        inlineStyles: $8bbdc72d87d9bf8d$var$inlineStyles
    }
});
function $8bbdc72d87d9bf8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bbdc72d87d9bf8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bbdc72d87d9bf8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8bbdc72d87d9bf8d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bbdc72d87d9bf8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8bbdc72d87d9bf8d$export$472062a354075cee = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var _props$value, _ref, _props$value2;
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $8bbdc72d87d9bf8d$var$SliderBase.getProps(inProps, context);
    var elementRef = $8NFma.useRef(null);
    var handleIndex = $8NFma.useRef(0);
    var sliderHandleClick = $8NFma.useRef(false);
    var dragging = $8NFma.useRef(false);
    var initX = $8NFma.useRef(0);
    var initY = $8NFma.useRef(0);
    var barWidth = $8NFma.useRef(0);
    var barHeight = $8NFma.useRef(0);
    var touchId = $8NFma.useRef();
    var value = props.range ? (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : [
        props.min,
        props.max
    ] : (_ref = (_props$value2 = props.value) !== null && _props$value2 !== void 0 ? _props$value2 : props.min) !== null && _ref !== void 0 ? _ref : 0;
    var horizontal = props.orientation === 'horizontal';
    var vertical = props.orientation === 'vertical';
    var _useEventListener = (0, $kocnD.useEventListener)({
        type: 'mousemove',
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener2 = $8bbdc72d87d9bf8d$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $kocnD.useEventListener)({
        type: 'mouseup',
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener4 = $8bbdc72d87d9bf8d$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = (0, $kocnD.useEventListener)({
        type: 'touchmove',
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $8bbdc72d87d9bf8d$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = (0, $kocnD.useEventListener)({
        type: 'touchend',
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $8bbdc72d87d9bf8d$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _SliderBase$setMetaDa = $8bbdc72d87d9bf8d$var$SliderBase.setMetaData({
        props: props
    }), ptm = _SliderBase$setMetaDa.ptm, cx = _SliderBase$setMetaDa.cx, sx = _SliderBase$setMetaDa.sx, isUnstyled = _SliderBase$setMetaDa.isUnstyled;
    (0, $64a8q.useHandleStyle)($8bbdc72d87d9bf8d$var$SliderBase.css.styles, isUnstyled, {
        name: 'slider'
    });
    var spin = function spin(event, dir) {
        var val = props.range ? value[handleIndex.current] : value;
        var step = (props.step || 1) * dir;
        updateValue(event, val + step);
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event, index) {
        if (props.disabled) return;
        dragging.current = true;
        updateDomData();
        sliderHandleClick.current = true;
        if (props.range && value[0] === props.max) handleIndex.current = 0;
        else handleIndex.current = index;
        event.preventDefault();
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            setValue(event);
            event.preventDefault();
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            var newValue = setValue(event);
            props.onSlideEnd && props.onSlideEnd({
                originalEvent: event,
                value: newValue
            });
            touchId.current = undefined;
            unbindDocumentMouseMoveListener();
            unbindDocumentMouseUpListener();
            unbindDocumentTouchMoveListener();
            unbindDocumentTouchEndListener();
        }
    };
    var _onMouseDown = function onMouseDown(event, index) {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        onDragStart(event, index);
    };
    var _onTouchStart = function onTouchStart(event, index) {
        if (event.changedTouches && event.changedTouches[0]) touchId.current = event.changedTouches[0].identifier;
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
        onDragStart(event, index);
    };
    var _onKeyDown = function onKeyDown(event, index) {
        if (props.disabled) return;
        handleIndex.current = index;
        var key = event.key;
        switch(key){
            case 'ArrowRight':
            case 'ArrowUp':
                spin(event, 1);
                break;
            case 'ArrowLeft':
            case 'ArrowDown':
                spin(event, -1);
                break;
            case 'PageUp':
                spin(event, 10);
                event.preventDefault();
                break;
            case 'PageDown':
                spin(event, -10);
                event.preventDefault();
                break;
            case 'Home':
                spin(event, -value);
                event.preventDefault();
                break;
            case 'End':
                spin(event, props.max);
                event.preventDefault();
                break;
        }
    };
    var onBarClick = function onBarClick(event) {
        if (props.disabled) return;
        if (!sliderHandleClick.current) {
            updateDomData();
            var _value = setValue(event);
            props.onSlideEnd && props.onSlideEnd({
                originalEvent: event,
                value: _value
            });
        }
        sliderHandleClick.current = false;
    };
    var updateDomData = function updateDomData() {
        var rect = elementRef.current.getBoundingClientRect();
        initX.current = rect.left + (0, $kMhUd.DomHandler).getWindowScrollLeft();
        initY.current = rect.top + (0, $kMhUd.DomHandler).getWindowScrollTop();
        barWidth.current = elementRef.current.offsetWidth;
        barHeight.current = elementRef.current.offsetHeight;
    };
    var trackTouch = function trackTouch(event) {
        var _event$changedTouches;
        var _event = Array.from((_event$changedTouches = event.changedTouches) !== null && _event$changedTouches !== void 0 ? _event$changedTouches : []).find(function(t) {
            return t.identifier === touchId.current;
        }) || event;
        return {
            pageX: _event.pageX,
            pageY: _event.pageY
        };
    };
    var setValue = function setValue(event) {
        var handleValue;
        var _trackTouch = trackTouch(event), pageX = _trackTouch.pageX, pageY = _trackTouch.pageY;
        if (!pageX || !pageY) return;
        if (horizontal) handleValue = (pageX - initX.current) * 100 / barWidth.current;
        else handleValue = (initY.current + barHeight.current - pageY) * 100 / barHeight.current;
        var newValue = (props.max - props.min) * (handleValue / 100) + props.min;
        if (props.step) {
            var oldValue = props.range ? value[handleIndex.current] : value;
            var diff = newValue - oldValue;
            if (diff < 0) newValue = oldValue + Math.ceil(newValue / props.step - oldValue / props.step) * props.step;
            else if (diff > 0) newValue = oldValue + Math.floor(newValue / props.step - oldValue / props.step) * props.step;
        } else newValue = Math.floor(newValue);
        return updateValue(event, newValue);
    };
    var updateValue = function updateValue(event, val) {
        var parsedValue = parseFloat(val.toFixed(10));
        var newValue = parsedValue;
        if (props.range) {
            if (handleIndex.current === 0) {
                if (parsedValue < props.min) parsedValue = props.min;
                else if (parsedValue > props.max) parsedValue = props.max;
            } else if (parsedValue > props.max) parsedValue = props.max;
            else if (parsedValue < props.min) parsedValue = props.min;
            newValue = $8bbdc72d87d9bf8d$var$_toConsumableArray(value);
            newValue[handleIndex.current] = parsedValue;
            if (props.onChange) props.onChange({
                originalEvent: event,
                value: newValue
            });
        } else {
            if (parsedValue < props.min) parsedValue = props.min;
            else if (parsedValue > props.max) parsedValue = props.max;
            newValue = parsedValue;
            if (props.onChange) props.onChange({
                originalEvent: event,
                value: newValue
            });
        }
        return newValue;
    };
    var createHandle = function createHandle(leftValue, bottomValue, index) {
        leftValue = (0, $kMhUd.ObjectUtils).isEmpty(leftValue) ? null : leftValue;
        bottomValue = (0, $kMhUd.ObjectUtils).isEmpty(bottomValue) ? null : bottomValue;
        var style = {
            transition: dragging.current ? 'none' : null,
            left: leftValue != null ? leftValue + '%' : null,
            bottom: bottomValue != null ? bottomValue + '%' : null
        };
        var handleProps = mergeProps($8bbdc72d87d9bf8d$var$_objectSpread({
            className: cx('handle', {
                index: index,
                handleIndex: handleIndex
            }),
            style: $8bbdc72d87d9bf8d$var$_objectSpread($8bbdc72d87d9bf8d$var$_objectSpread({}, sx('handle', {
                dragging: dragging,
                leftValue: leftValue,
                bottomValue: bottomValue
            })), style),
            tabIndex: props.tabIndex,
            role: 'slider',
            onMouseDown: function onMouseDown(event) {
                return _onMouseDown(event, index);
            },
            onTouchStart: function onTouchStart(event) {
                return _onTouchStart(event, index);
            },
            onKeyDown: function onKeyDown(event) {
                return _onKeyDown(event, index);
            },
            'aria-valuemin': props.min,
            'aria-valuemax': props.max,
            'aria-valuenow': leftValue || bottomValue || 0,
            'aria-orientation': props.orientation
        }, ariaProps), ptm('handle'));
        return /*#__PURE__*/ $8NFma.createElement("span", handleProps);
    };
    var createRangeSlider = function createRangeSlider() {
        var handleValueStart = (value[0] < props.min ? props.min : value[0] - props.min) * 100 / (props.max - props.min);
        var handleValueEnd = (value[1] > props.max ? props.max : value[1] - props.min) * 100 / (props.max - props.min);
        var rangeStartHandle = horizontal ? createHandle(handleValueStart, null, 0) : createHandle(null, handleValueStart, 0);
        var rangeEndHandle = horizontal ? createHandle(handleValueEnd, null, 1) : createHandle(null, handleValueEnd, 1);
        var rangeSliderWidth = handleValueEnd > handleValueStart ? handleValueEnd - handleValueStart : handleValueStart - handleValueEnd;
        var rangeSliderPosition = handleValueEnd > handleValueStart ? handleValueStart : handleValueEnd;
        var rangeStyle = horizontal ? {
            left: rangeSliderPosition + '%',
            width: rangeSliderWidth + '%'
        } : {
            bottom: rangeSliderPosition + '%',
            height: rangeSliderWidth + '%'
        };
        var rangeProps = mergeProps({
            className: cx('range'),
            style: $8bbdc72d87d9bf8d$var$_objectSpread($8bbdc72d87d9bf8d$var$_objectSpread({}, sx('range')), rangeStyle)
        }, ptm('range'));
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("span", rangeProps), rangeStartHandle, rangeEndHandle);
    };
    var createSingleSlider = function createSingleSlider() {
        var handleValue;
        if (value < props.min) handleValue = props.min;
        else if (value > props.max) handleValue = props.max;
        else handleValue = (value - props.min) * 100 / (props.max - props.min);
        var rangeStyle = horizontal ? {
            width: handleValue + '%'
        } : {
            height: handleValue + '%'
        };
        var handle = horizontal ? createHandle(handleValue, null, null) : createHandle(null, handleValue, null);
        var rangeProps = mergeProps({
            className: cx('range'),
            style: $8bbdc72d87d9bf8d$var$_objectSpread($8bbdc72d87d9bf8d$var$_objectSpread({}, sx('range')), rangeStyle)
        }, ptm('range'));
        return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("span", rangeProps), handle);
    };
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var otherProps = $8bbdc72d87d9bf8d$var$SliderBase.getOtherProps(props);
    var ariaProps = (0, $kMhUd.ObjectUtils).reduceKeys(otherProps, (0, $kMhUd.DomHandler).ARIA_PROPS);
    var content = props.range ? createRangeSlider() : createSingleSlider();
    var rootProps = mergeProps({
        style: props.style,
        className: (0, $kMhUd.classNames)(props.className, cx('root', {
            vertical: vertical,
            horizontal: horizontal
        })),
        onClick: onBarClick
    }, $8bbdc72d87d9bf8d$var$SliderBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $8NFma.createElement("div", $8bbdc72d87d9bf8d$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), content);
}));
$8bbdc72d87d9bf8d$export$472062a354075cee.displayName = 'Slider';

});






parcelRegister("6y8B8", function(module, exports) {

$parcel$export(module.exports, "GrooveBox", () => $4c4c966de0e348d3$export$82860526b7cefdc0);
parcelRequire("56MRX");
var $1x3k0 = parcelRequire("1x3k0");
var $bmU6v = parcelRequire("bmU6v");
var $82Hwq = parcelRequire("82Hwq");
var $bdbZZ = parcelRequire("bdbZZ");
var $ihNA0 = parcelRequire("ihNA0");
var $7FIGc = parcelRequire("7FIGc");

var $hmjjw = parcelRequire("hmjjw");

var $huphW = parcelRequire("huphW");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $2WSWG = parcelRequire("2WSWG");

var $avF0V = parcelRequire("avF0V");

var $enQqi = parcelRequire("enQqi");

var $95CQM = parcelRequire("95CQM");

var $1zQag = parcelRequire("1zQag");

var $2cXDZ = parcelRequire("2cXDZ");
// midiPitches are also constrained by pitchRange
const $4c4c966de0e348d3$var$playerConfig = {
    openHat: {
        label: "Open Hat",
        midiPitch: 46,
        defaultSampleURL: "https://cdn.freesound.org/previews/509/509984_8033171-hq.mp3",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).green
    },
    closedHat: {
        label: "Closed Hat",
        midiPitch: 42,
        defaultSampleURL: "https://cdn.freesound.org/previews/173/173537_1372815-hq.mp3",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).red
    },
    snare: {
        label: "Snare",
        midiPitch: 38,
        defaultSampleURL: "https://cdn.freesound.org/previews/561/561511_12517458-hq.mp3",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).turquoise
    },
    kick: {
        label: "Kick",
        midiPitch: 36,
        defaultSampleURL: "https://cdn.freesound.org/previews/324/324982_3914271-hq.mp3",
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow
    }
};
class $4c4c966de0e348d3$export$82860526b7cefdc0 extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'groovebox',
        tipusDisplay: 'GrooveBox',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow,
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 200,
            max: 20000,
            initial: 20000,
            logarithmic: true,
            bind: "preset"
        },
        ...Object.fromEntries(Object.entries($4c4c966de0e348d3$var$playerConfig).flatMap(([name, { label: label }])=>{
            return [
                [
                    `${name}_swing`,
                    {
                        type: 'float',
                        display: "percent",
                        min: -0.25,
                        max: .25,
                        initial: 0,
                        bind: "preset"
                    }
                ],
                [
                    `${name}_tone`,
                    {
                        type: 'float',
                        unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).semitone,
                        min: -12,
                        max: 12,
                        step: 1,
                        initial: 0,
                        bind: "preset"
                    }
                ],
                [
                    `${name}_volume`,
                    {
                        type: 'float',
                        unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
                        min: -30,
                        max: 6,
                        initial: -3,
                        bind: "preset"
                    }
                ],
                [
                    `${name}_release`,
                    {
                        type: 'float',
                        display: "percent",
                        min: 0,
                        max: 1,
                        step: .01,
                        initial: 1,
                        bind: "preset"
                    }
                ],
                [
                    `${name}_reverbSend`,
                    {
                        type: 'float',
                        unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
                        min: -30,
                        max: 6,
                        initial: -30,
                        bind: "preset"
                    }
                ],
                [
                    `${name}_drumkit`,
                    {
                        type: 'enum',
                        options: [
                            'Hip Hop Classic 1',
                            'Hip Hop Classic 2',
                            'Reggae Roots',
                            'Dub Reggae',
                            'Soul Pop',
                            'Funky Soul',
                            'Acid House',
                            'Trap 1',
                            'Trap 2',
                            'Urban Reggaeton'
                        ],
                        initial: 'Hip Hop Classic 1',
                        bind: "preset"
                    }
                ]
            ];
        }))
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {
            min: 36,
            max: 46
        }
    };
    static defaultClipLength = 16;
    getUserInterfaceComponent() {
        return 0, $2WSWG.GrooveBoxUI;
    }
    get playerNames() {
        return [
            ...Object.keys($4c4c966de0e348d3$var$playerConfig)
        ];
    }
    getPlayerPitch = (playerName)=>$4c4c966de0e348d3$var$playerConfig[playerName].midiPitch;
    getPlayerColor = (playerName)=>$4c4c966de0e348d3$var$playerConfig[playerName].color;
    getPlayerLabel = (playerName)=>$4c4c966de0e348d3$var$playerConfig[playerName].label;
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const cutoff = new $82Hwq.Filter((0, $1zQag.limitToNyquist)(500), 'lowpass', -24);
        cutoff.set({
            'Q': 1.0
        }) // Afegeix un punt de ressonància que li dona vidilla
        ;
        const mainChannel = new $1x3k0.Channel({
            volume: 0
        }).connect(cutoff);
        const grooveBoxReverb = new $7FIGc.Reverb({
            wet: 1,
            decay: 5
        }).connect(this.bus);
        const grooveBoxReverbChannel = new $1x3k0.Channel({
            volume: 0
        }).connect(grooveBoxReverb);
        this.audioNodes = {
            mainChannel: mainChannel,
            cutoff: cutoff
        };
        this.playerNames.forEach((playerName)=>{
            const reverbSend = new $bdbZZ.Gain(-100, "decibels").connect(grooveBoxReverbChannel);
            const player = new $ihNA0.Player({
                fadeIn: 0.01,
                fadeOut: 0.01
            }).fan(mainChannel, reverbSend);
            Object.assign(this.audioNodes, {
                [`${playerName}reverbSend`]: reverbSend,
                [playerName]: player
            });
        });
        this.addEffectChainNodes(cutoff, this.bus);
    }
    setParameterInAudioGraph(parameterName, value) {
        const parametersMatch = parameterName.match(/^(\w+)_(drumkit|volume|release|tone|reverbSend)$/);
        if (parametersMatch) {
            const [_, playerName, parameterType] = parametersMatch;
            if (parameterType === 'volume') this.audioNodes[playerName].set({
                'volume': value > -30 ? value : -100
            });
            else if (parameterType === 'tone') this.audioNodes[playerName].set({
                'playbackRate': Math.pow(2, value / 12)
            });
            else if (parameterType === 'reverbSend') {
                const nodeName = `${playerName}reverbSend`;
                this.audioNodes[nodeName].gain.value = value > -30 ? value : -100;
            } else if (parameterType === 'drumkit') {
                const soundName = `${value}-${playerName}`;
                const player = this.audioNodes[playerName];
                const defaultURL = $4c4c966de0e348d3$var$playerConfig[playerName].defaultSampleURL;
                (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(soundName, (buffer)=>player.buffer = buffer, defaultURL);
            }
        } else if (parameterName == 'lpf_cutoff') this.audioNodes.cutoff.frequency.rampTo((0, $1zQag.limitToNyquist)(value), 0.01);
    }
    launchSound(playerName, time, normVelocity = 1) {
        const release = this.getPlaybackParameterValue(`${playerName}_release`);
        const duration = release * this.getStepDuration() * 2; // dirty hack to make longer samples play for longer
        if (!this.audioNodes[playerName].buffer.loaded) {
            console.warn(`Audio buffer for player "${playerName}" still not loaded, aborting sound launch`);
            return;
        }
        const baseVolume = this.getPlaybackParameterValue(`${playerName}_volume`);
        const volume = $bmU6v.gainToDb($bmU6v.dbToGain(baseVolume) * normVelocity);
        this.audioNodes[playerName].volume.setValueAtTime(volume, time);
        this.audioNodes[playerName].start(time, 0, duration);
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        // Check if sounds should be played in the current step and do it
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const LOOKAHEAD_SWING = true; // swinged third 16th note is handled in the second one
        if (LOOKAHEAD_SWING && currentStep % 4 === 2) return;
        const sequence = this.getPlaybackClip().sequence;
        const generalSwing = (0, $Lbl7Y.getAudioGraphInstance)().getSwing();
        const stepDuration = this.getStepDuration();
        this.playerNames.forEach((playerName)=>{
            const pitch = this.getPlayerPitch(playerName);
            const targetProperties = {
                pitch: pitch,
                onset: currentStep
            };
            const note = (0, $enQqi.findNoteInSequence)(sequence, targetProperties);
            if (note != null) this.launchSound(playerName, time, (note.velocity ?? 127) / 127);
            if (LOOKAHEAD_SWING && (currentStep + 1) % 4 === 2) {
                const targetProperties = {
                    pitch: pitch,
                    onset: currentStep + 1
                };
                const nextNote = (0, $enQqi.findNoteInSequence)(sequence, targetProperties);
                if (nextNote != null) {
                    const instrumentSwing = this.getPlaybackParameterValue(`${playerName}_swing`);
                    const totalSwing = generalSwing + instrumentSwing;
                    const delay = stepDuration * 2 * totalSwing;
                    this.launchSound(playerName, time + delay, (nextNote.velocity ?? 127) / 127);
                }
            }
        });
    }
    onMidiNote(pitch, midiVelocity = 127, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        const playerName = [
            ...Object.entries($4c4c966de0e348d3$var$playerConfig)
        ].find(([_name, { midiPitch: midiPitch }])=>midiPitch === pitch)?.[0];
        if (!playerName) return;
        if (noteOff) return;
        this.launchSound(playerName, undefined, midiVelocity / 127);
        const recEnabled = !extras.skipRecording && this.getPlaybackParameterValue('isRecordArmed');
        // Si Rec està ON
        if (recEnabled) {
            const currentMainSequencerStep = (0, $Lbl7Y.getAudioGraphInstance)().getTransportCurrentStep();
            const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
            const sequence = structuredClone((0, $95CQM.staticSelect)(this.getDisplaySequenceSelector()));
            const targetProperties = {
                pitch: pitch,
                onset: currentStep
            };
            const alreadyExistingNoteIndex = (0, $enQqi.findNoteIndexInSequence)(sequence, targetProperties);
            if (alreadyExistingNoteIndex !== -1) sequence.splice(alreadyExistingNoteIndex, 1);
            sequence.push({
                ...targetProperties,
                duration: 1,
                velocity: midiVelocity
            });
            this.updateSequence(sequence);
        }
    }
}

});
parcelRegister("2WSWG", function(module, exports) {

$parcel$export(module.exports, "GrooveBoxUI", () => $41f9d5fbc5db05cf$export$d6decb93b2dbdd);

var $1IdZj = parcelRequire("1IdZj");

var $ly76a = parcelRequire("ly76a");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $bbqmh = parcelRequire("bbqmh");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");

var $8NFma = parcelRequire("8NFma");

var $fITdy = parcelRequire("fITdy");

var $7Kpeg = parcelRequire("7Kpeg");

var $iBMhP = parcelRequire("iBMhP");
var $7PSp0 = parcelRequire("7PSp0");
const $41f9d5fbc5db05cf$export$d6decb93b2dbdd = ({ instrument: instrument })=>{
    const [selectedPlayerName, setSelectedPlayerName] = (0, $8NFma.useState)(instrument.playerNames[0]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-groovebox",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument,
                className: "col-span-2"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "col-span-3"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between col-span-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "lpfCutoff",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("lpf_cutoff")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                className: "flex flex-col justify-around modul-border",
                style: {
                    borderColor: instrument.getPlayerColor(selectedPlayerName)
                },
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "drumVol",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler(`${selectedPlayerName}_volume`)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "drumTone",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler(`${selectedPlayerName}_tone`)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "drumRelease",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler(`${selectedPlayerName}_release`)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "drumReverb",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler(`${selectedPlayerName}_reverbSend`)
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "drumSwing",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler(`${selectedPlayerName}_swing`)
                    })
                ]
            }, selectedPlayerName),
            /*#__PURE__*/ (0, $1IdZj.jsx)("fieldset", {
                className: "groovebox-pads",
                children: instrument.playerNames.map((playerName)=>{
                    const isSelected = selectedPlayerName === playerName;
                    const color = instrument.getPlayerColor(playerName);
                    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                className: "groovebox-pad-wrapper",
                                children: [
                                    isSelected && /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
                                        viewBox: "0 0 1 2",
                                        preserveAspectRatio: "none",
                                        className: "center-absolute h-full",
                                        style: {
                                            width: 135
                                        },
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("line", {
                                            x1: "0",
                                            x2: "1",
                                            y1: "1",
                                            y2: "1",
                                            stroke: color,
                                            vectorEffect: "non-scaling-stroke"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fITdy.MidiPad), {
                                        "data-widget-id": "drumPad",
                                        className: "groovebox-pad w-full",
                                        style: {
                                            "--accent-color": color
                                        },
                                        instrument: instrument,
                                        isSelected: isSelected,
                                        pitch: instrument.getPlayerPitch(playerName),
                                        setSelected: ()=>setSelectedPlayerName(playerName),
                                        label: instrument.getPlayerLabel(playerName)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)($41f9d5fbc5db05cf$var$PlayerDrumkitSelector, {
                                instrument: instrument,
                                playerName: playerName
                            })
                        ]
                    });
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bbqmh.GrooveboxSequencer), {
                className: "col-span-3",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {}),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                className: "col-span-4 justify-self-end",
                instrument: instrument
            })
        ]
    }, instrument.id);
};
function $41f9d5fbc5db05cf$var$PlayerDrumkitSelector({ instrument: instrument, playerName: playerName }) {
    const handler = instrument.getParameterHandler(`${playerName}_drumkit`);
    const value = (0, $7Kpeg.useSelector)(handler.selector);
    // if there's a number, we don't want to cut it with the ellipsis
    const nameWithNumber = value.match(/^(.*?) (\d)$/);
    let name = value;
    let number = undefined;
    if (nameWithNumber) [_, name, number] = nameWithNumber;
    const options = handler.description.options;
    const currentIndex = handler.real2Num(value);
    const previousOption = options[(currentIndex - 1 + options.length) % options.length];
    const nextOption = options[(currentIndex + 1 + options.length) % options.length];
    const dispatch = (0, $7Kpeg.useDispatch)();
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        "data-widget-id": "drumDrumkit",
        className: "flex justify-between items-center absolute",
        style: {
            inset: "50px 50%",
            translate: "-50%",
            width: 125
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                className: "center-grid",
                onClick: ()=>dispatch(handler.updater(previousOption)),
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $iBMhP.default), {})
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                className: "flex",
                style: {
                    whiteSpace: "nowrap",
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                        className: "ellipsis",
                        style: {
                            overflow: "hidden"
                        },
                        children: name
                    }),
                    nameWithNumber && /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                        children: [
                            "\xa0",
                            number
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                className: "center-grid",
                onClick: ()=>dispatch(handler.updater(nextOption)),
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7PSp0.default), {})
            })
        ]
    });
}

});
parcelRegister("bbqmh", function(module, exports) {

$parcel$export(module.exports, "GrooveboxSequencer", () => $85e3b84a891707e2$export$841a7ad26aea1c9f);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $7Kpeg = parcelRequire("7Kpeg");

var $dkYqL = parcelRequire("dkYqL");

var $enQqi = parcelRequire("enQqi");

var $5ICqB = parcelRequire("5ICqB");

var $jkxMa = parcelRequire("jkxMa");

var $enQqi = parcelRequire("enQqi");

var $95CQM = parcelRequire("95CQM");

var $kmdF6 = parcelRequire("kmdF6");

var $7Hv6G = parcelRequire("7Hv6G");
const $85e3b84a891707e2$export$841a7ad26aea1c9f = ({ className: className, instrument: instrument })=>{
    const numSteps = (0, $7Kpeg.useSelector)(instrument.getDisplayClipLengthSelector());
    const wrapperRef = (0, $8NFma.useRef)();
    const stepsPerBeat = 4;
    const beatsPerBar = 4;
    const bars = numSteps / stepsPerBeat / beatsPerBar;
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        "data-widget-id": "grooveboxSequencer",
        ref: wrapperRef,
        className: `groovebox-sequencer-wrapper ${className}`,
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: `groovebox-sequencer ${bars === 1 ? "expanded" : ""}`,
            style: {
                "--num-steps": numSteps
            },
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jkxMa.ScrollArea), {
                    scrollElementRef: wrapperRef,
                    style: {
                        position: "absolute",
                        inset: 0,
                        height: "fit-content"
                    },
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        style: {
                            height: 28
                        }
                    })
                }),
                Array(bars).fill().map((_, barIndex)=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "bar-and-timeline",
                        children: Array(beatsPerBar).fill().map((_, beatInBarIndex)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                className: "beat-and-timeline",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        children: `${barIndex + 1}.${beatInBarIndex + 1}`
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "beat-group",
                                        style: {
                                            "--steps-per-group": stepsPerBeat
                                        },
                                        children: instrument.playerNames.map((playerName)=>{
                                            const pitch = instrument.getPlayerPitch(playerName);
                                            return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                                className: "beat-group-row",
                                                style: {
                                                    "--accent-color": instrument.getPlayerColor(playerName)
                                                },
                                                children: Array(stepsPerBeat).fill().map((_, stepIndexInBeatGroup)=>{
                                                    const stepIndex = (barIndex * beatsPerBar + beatInBarIndex) * stepsPerBeat + stepIndexInBeatGroup;
                                                    return /*#__PURE__*/ (0, $1IdZj.jsx)($85e3b84a891707e2$var$GrooveboxStep, {
                                                        instrument: instrument,
                                                        numSteps: numSteps,
                                                        pitch: pitch,
                                                        stepIndex: stepIndex
                                                    }, `${pitch}_${stepIndex}`);
                                                })
                                            }, playerName);
                                        })
                                    })
                                ]
                            }, beatInBarIndex))
                    }, barIndex))
            ]
        })
    });
};
function $85e3b84a891707e2$var$GrooveboxStep({ instrument: instrument, numSteps: numSteps, pitch: pitch, stepIndex: stepIndex }) {
    const currentStep = (0, $7Kpeg.useSelector)((0, $dkYqL.createSelector)((0, $5ICqB.selectTransportCurrentStep), (currentStep)=>currentStep % numSteps));
    const sequence = (0, $7Kpeg.useSelector)(instrument.getDisplaySequenceSelector());
    const displayClipNumber = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("clipNumber"));
    const playbackClipNumber = (0, $7Kpeg.useSelector)(instrument.getPlaybackParameterSelector("clipNumber"));
    const targetProperties = {
        pitch: pitch,
        onset: stepIndex
    };
    const yOffsetRef = (0, $8NFma.useRef)(null);
    const [isDragging, setIsDragging] = (0, $8NFma.useState)(false);
    function handleClick() {
        // we can't use the state because this lives in an envent handler
        const isDragging = yOffsetRef.current != null;
        if (isDragging) return;
        let updatedSequence = [
            ...sequence
        ];
        const index = (0, $enQqi.findNoteIndexInSequence)(sequence, targetProperties);
        if (index !== -1) updatedSequence.splice(index, 1);
        else updatedSequence.push({
            ...targetProperties,
            duration: 1
        });
        instrument.updateSequence(updatedSequence);
    }
    function handlePointerDown(downE, note) {
        const controller = new AbortController();
        const initialVelocity = note ? note.velocity : 1;
        const stopDrag = ()=>{
            controller.abort();
            yOffsetRef.current = null;
            setIsDragging(false);
        };
        document.addEventListener("pointermove", (e)=>handleDrag(e, downE, initialVelocity ?? 127), {
            signal: controller.signal
        });
        document.addEventListener("pointerup", stopDrag, {
            signal: controller.signal
        });
        document.addEventListener("pointercancel", stopDrag, {
            signal: controller.signal
        });
    }
    function handleDrag(e, downE, initialVelocity) {
        const threshold = 10;
        let movementY = e.clientY - downE.clientY;
        if (yOffsetRef.current == null) {
            // si el moviment és molt petit probablement l'usuari volia fer click i no drag
            if (Math.abs(movementY) < threshold) return;
            yOffsetRef.current = -movementY;
            setIsDragging(true);
        }
        movementY += yOffsetRef.current;
        const latestSequence = [
            ...(0, $95CQM.staticSelect)(instrument.getDisplaySequenceSelector())
        ];
        const index = (0, $enQqi.findNoteIndexInSequence)(latestSequence, targetProperties);
        const note = latestSequence[index] ?? {
            ...targetProperties,
            duration: 1
        };
        const velocity = Math.round((0, $kmdF6.clamp)(initialVelocity - movementY, 1, 127));
        if (index !== -1) latestSequence.splice(index, 1);
        latestSequence.push({
            ...note,
            velocity: velocity
        });
        instrument.updateSequence(latestSequence);
    }
    const note = (0, $enQqi.findNoteInSequence)(sequence, targetProperties);
    const velocity = note ? note.velocity ?? 127 : null;
    const isFilled = note != null;
    const opacity = isFilled ? (0, $kmdF6.scale)(velocity, 0, 127, .3, 1) : 1;
    const isActive = currentStep == stepIndex && displayClipNumber === playbackClipNumber;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7Hv6G.FloatingValue), {
        value: velocity,
        isVisible: isDragging,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            onClick: handleClick,
            onPointerDown: (downE)=>handlePointerDown(downE, note),
            className: `step ${isFilled ? 'selected' : ''} ${isActive ? 'active' : ''}`,
            style: {
                opacity: opacity
            }
        })
    });
}

});
parcelRegister("jkxMa", function(module, exports) {

$parcel$export(module.exports, "ScrollArea", () => $2b34b74b50f94a47$export$ccf8d8d7bbf3c2cc);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $8W33b = parcelRequire("8W33b");
const $2b34b74b50f94a47$export$ccf8d8d7bbf3c2cc = ({ scrollElementRef: scrollElementRef, children: children, ...props })=>{
    const [isScrolling, setIsScrolling] = (0, $8NFma.useState)(false);
    const [isOverflowing, setIsOverflowing] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        setIsOverflowing((0, $8W33b.checkOverflow)(scrollElementRef.current));
        const observer = new MutationObserver(()=>{
            setIsOverflowing((0, $8W33b.checkOverflow)(scrollElementRef.current));
        });
        observer.observe(scrollElementRef.current, {
            subtree: true,
            childList: true
        });
        return ()=>observer.disconnect();
    }, []);
    function handlePointerDown(e) {
        if (!isOverflowing) return;
        setIsScrolling(true);
        const controller = new AbortController();
        const stopScrolling = ()=>{
            setIsScrolling(false);
            controller.abort();
        };
        const scroll = (e)=>{
            scrollElementRef.current.scrollBy({
                top: -e.movementY,
                left: -e.movementX
            });
        };
        document.addEventListener("pointerup", stopScrolling, {
            signal: controller.signal
        });
        document.addEventListener("pointercancel", stopScrolling, {
            signal: controller.signal
        });
        document.addEventListener("pointermove", scroll, {
            signal: controller.signal
        });
        return ()=>stopScrolling();
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                onPointerDown: handlePointerDown,
                style: {
                    ...props.style,
                    cursor: isOverflowing ? "grab" : undefined
                },
                children: children
            }),
            isScrolling && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                style: {
                    position: "fixed",
                    inset: 0,
                    height: "100%",
                    zIndex: 999,
                    cursor: "grabbing"
                }
            })
        ]
    });
};

});
parcelRegister("8W33b", function(module, exports) {

$parcel$export(module.exports, "checkOverflow", () => $68161b3bab84b505$export$69a2e097ddb11c91);
$parcel$export(module.exports, "selectContent", () => $68161b3bab84b505$export$f57c4385397c8c37);
$parcel$export(module.exports, "isElementPartOfInteractive", () => $68161b3bab84b505$export$e05d54e9bf59570c);
function $68161b3bab84b505$export$69a2e097ddb11c91(DOMElement) {
    const isOverflowingX = DOMElement.scrollWidth > DOMElement.offsetWidth;
    const isOverflowingY = DOMElement.scrollHeight > DOMElement.offsetHeight;
    return isOverflowingX || isOverflowingY;
}
function $68161b3bab84b505$export$f57c4385397c8c37(el) {
    const range = document.createRange();
    range.selectNodeContents(el);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
}
function $68161b3bab84b505$export$e05d54e9bf59570c(el) {
    if (el.tagName === "BUTTON" && !el.getAttribute("disabled")) return true;
    if (el.parentNode) return $68161b3bab84b505$export$e05d54e9bf59570c(el.parentNode);
    return false;
}

});



parcelRegister("fITdy", function(module, exports) {

$parcel$export(module.exports, "MidiPad", () => $ccc5b5a0523d178f$export$63a77c1682b76313);

var $1IdZj = parcelRequire("1IdZj");

var $hs3Xb = parcelRequire("hs3Xb");

var $lsfK2 = parcelRequire("lsfK2");

var $jyiOD = parcelRequire("jyiOD");

var $8NFma = parcelRequire("8NFma");
const $ccc5b5a0523d178f$export$63a77c1682b76313 = ({ style: style, className: className, instrument: instrument, pitch: pitch, isSelected: isSelected, setSelected: setSelected, label: label, ...props })=>{
    const pressProps = (0, $jyiOD.useOnPress)({
        onPress: ()=>{
            setSelected();
            (0, $lsfK2.midiHandler).sendNoteOn(instrument.id, pitch, 127);
        },
        onUnpress: ()=>{
            (0, $lsfK2.midiHandler).sendNoteOff(instrument.id, pitch, 0);
        }
    });
    const [isPlaying, setIsPlaying] = (0, $8NFma.useState)(false);
    function updateIsPlaying(midiEvent) {
        if (midiEvent.detail.pitch !== pitch) return;
        setIsPlaying(midiEvent.detail.type !== 'noteOff');
    }
    (0, $8NFma.useEffect)(()=>{
        document.addEventListener("midiNote-" + instrument.id, updateIsPlaying);
        return ()=>document.removeEventListener("midiNote-" + instrument.id, updateIsPlaying);
    }, [
        pitch
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hs3Xb.Button), {
        ...props,
        className: `btn ${isSelected || isPlaying ? 'selected' : ''} ${className}`,
        style: style,
        ...pressProps,
        label: label
    });
};

});
parcelRegister("hs3Xb", function(module, exports) {

$parcel$export(module.exports, "Button", () => $cb481e49c5149f10$export$353f5b6fc5456de1);

var $8NFma = parcelRequire("8NFma");

var $eGEKG = parcelRequire("eGEKG");

var $64a8q = parcelRequire("64a8q");

var $kocnD = parcelRequire("kocnD");

var $kMhUd = parcelRequire("kMhUd");

var $6rN57 = parcelRequire("6rN57");

var $cLCHn = parcelRequire("cLCHn");

var $7dgG7 = parcelRequire("7dgG7");
'use client';
function $cb481e49c5149f10$var$_extends() {
    return $cb481e49c5149f10$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cb481e49c5149f10$var$_extends.apply(null, arguments);
}
function $cb481e49c5149f10$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cb481e49c5149f10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cb481e49c5149f10$var$_typeof(o);
}
function $cb481e49c5149f10$var$toPrimitive(t, r) {
    if ("object" != $cb481e49c5149f10$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cb481e49c5149f10$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cb481e49c5149f10$var$toPropertyKey(t) {
    var i = $cb481e49c5149f10$var$toPrimitive(t, "string");
    return "symbol" == $cb481e49c5149f10$var$_typeof(i) ? i : i + "";
}
function $cb481e49c5149f10$var$_defineProperty(e, r, t) {
    return (r = $cb481e49c5149f10$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $cb481e49c5149f10$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $kMhUd.classNames)('p-badge p-component', $cb481e49c5149f10$var$_defineProperty({
            'p-badge-no-gutter': (0, $kMhUd.ObjectUtils).isNotEmpty(props.value) && String(props.value).length === 1,
            'p-badge-dot': (0, $kMhUd.ObjectUtils).isEmpty(props.value),
            'p-badge-lg': props.size === 'large',
            'p-badge-xl': props.size === 'xlarge'
        }, "p-badge-".concat(props.severity), props.severity !== null));
    }
};
var $cb481e49c5149f10$var$styles = "\n@layer primereact {\n    .p-badge {\n        display: inline-block;\n        border-radius: 10px;\n        text-align: center;\n        padding: 0 .5rem;\n    }\n    \n    .p-overlay-badge {\n        position: relative;\n    }\n    \n    .p-overlay-badge .p-badge {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%,-50%);\n        transform-origin: 100% 0;\n        margin: 0;\n    }\n    \n    .p-badge-dot {\n        width: .5rem;\n        min-width: .5rem;\n        height: .5rem;\n        border-radius: 50%;\n        padding: 0;\n    }\n    \n    .p-badge-no-gutter {\n        padding: 0;\n        border-radius: 50%;\n    }\n}\n";
var $cb481e49c5149f10$var$BadgeBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Badge',
        __parentMetadata: null,
        value: null,
        severity: null,
        size: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $cb481e49c5149f10$var$classes$1,
        styles: $cb481e49c5149f10$var$styles
    }
});
function $cb481e49c5149f10$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb481e49c5149f10$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb481e49c5149f10$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $cb481e49c5149f10$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb481e49c5149f10$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb481e49c5149f10$var$Badge = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $cb481e49c5149f10$var$BadgeBase.getProps(inProps, context);
    var _BadgeBase$setMetaDat = $cb481e49c5149f10$var$BadgeBase.setMetaData($cb481e49c5149f10$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata)), ptm = _BadgeBase$setMetaDat.ptm, cx = _BadgeBase$setMetaDat.cx, isUnstyled = _BadgeBase$setMetaDat.isUnstyled;
    (0, $64a8q.useHandleStyle)($cb481e49c5149f10$var$BadgeBase.css.styles, isUnstyled, {
        name: 'badge'
    });
    var elementRef = $8NFma.useRef(null);
    $8NFma.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        style: props.style,
        className: (0, $kMhUd.classNames)(props.className, cx('root'))
    }, $cb481e49c5149f10$var$BadgeBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $8NFma.createElement("span", rootProps, props.value);
}));
$cb481e49c5149f10$var$Badge.displayName = 'Badge';
var $cb481e49c5149f10$var$classes = {
    icon: function icon(_ref) {
        var props = _ref.props;
        return (0, $kMhUd.classNames)('p-button-icon p-c', $cb481e49c5149f10$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
    },
    loadingIcon: function loadingIcon(_ref2) {
        var props = _ref2.props, className = _ref2.className;
        return (0, $kMhUd.classNames)(className, {
            'p-button-loading-icon': props.loading
        });
    },
    label: 'p-button-label p-c',
    root: function root(_ref3) {
        var props = _ref3.props, size = _ref3.size, disabled = _ref3.disabled;
        return (0, $kMhUd.classNames)('p-button p-component', $cb481e49c5149f10$var$_defineProperty($cb481e49c5149f10$var$_defineProperty($cb481e49c5149f10$var$_defineProperty($cb481e49c5149f10$var$_defineProperty({
            'p-button-icon-only': (props.icon || props.loading) && !props.label && !props.children,
            'p-button-vertical': (props.iconPos === 'top' || props.iconPos === 'bottom') && props.label,
            'p-disabled': disabled,
            'p-button-loading': props.loading,
            'p-button-outlined': props.outlined,
            'p-button-raised': props.raised,
            'p-button-link': props.link,
            'p-button-text': props.text,
            'p-button-rounded': props.rounded,
            'p-button-loading-label-only': props.loading && !props.icon && props.label
        }, "p-button-loading-".concat(props.iconPos), props.loading && props.label), "p-button-".concat(size), size), "p-button-".concat(props.severity), props.severity), 'p-button-plain', props.plain));
    }
};
var $cb481e49c5149f10$var$ButtonBase = (0, $64a8q.ComponentBase).extend({
    defaultProps: {
        __TYPE: 'Button',
        __parentMetadata: null,
        badge: null,
        badgeClassName: null,
        className: null,
        children: undefined,
        disabled: false,
        icon: null,
        iconPos: 'left',
        label: null,
        link: false,
        loading: false,
        loadingIcon: null,
        outlined: false,
        plain: false,
        raised: false,
        rounded: false,
        severity: null,
        size: null,
        text: false,
        tooltip: null,
        tooltipOptions: null,
        visible: true
    },
    css: {
        classes: $cb481e49c5149f10$var$classes
    }
});
function $cb481e49c5149f10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb481e49c5149f10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb481e49c5149f10$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cb481e49c5149f10$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb481e49c5149f10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb481e49c5149f10$export$353f5b6fc5456de1 = /*#__PURE__*/ $8NFma.memo(/*#__PURE__*/ $8NFma.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $kocnD.useMergeProps)();
    var context = $8NFma.useContext((0, $eGEKG.PrimeReactContext));
    var props = $cb481e49c5149f10$var$ButtonBase.getProps(inProps, context);
    var disabled = props.disabled || props.loading;
    var metaData = $cb481e49c5149f10$var$_objectSpread($cb481e49c5149f10$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: disabled
        }
    });
    var _ButtonBase$setMetaDa = $cb481e49c5149f10$var$ButtonBase.setMetaData(metaData), ptm = _ButtonBase$setMetaDa.ptm, cx = _ButtonBase$setMetaDa.cx, isUnstyled = _ButtonBase$setMetaDa.isUnstyled;
    (0, $64a8q.useHandleStyle)($cb481e49c5149f10$var$ButtonBase.css.styles, isUnstyled, {
        name: 'button',
        styled: true
    });
    var elementRef = $8NFma.useRef(ref);
    $8NFma.useEffect(function() {
        (0, $kMhUd.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    if (props.visible === false) return null;
    var createIcon = function createIcon() {
        var className = (0, $kMhUd.classNames)('p-button-icon p-c', $cb481e49c5149f10$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
        var iconsProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        className = (0, $kMhUd.classNames)(className, {
            'p-button-loading-icon': props.loading
        });
        var loadingIconProps = mergeProps({
            className: cx('loadingIcon', {
                className: className
            })
        }, ptm('loadingIcon'));
        var icon = props.loading ? props.loadingIcon || /*#__PURE__*/ $8NFma.createElement((0, $6rN57.SpinnerIcon), $cb481e49c5149f10$var$_extends({}, loadingIconProps, {
            spin: true
        })) : props.icon;
        return (0, $kMhUd.IconUtils).getJSXIcon(icon, $cb481e49c5149f10$var$_objectSpread({}, iconsProps), {
            props: props
        });
    };
    var createLabel = function createLabel() {
        var labelProps = mergeProps({
            className: cx('label')
        }, ptm('label'));
        if (props.label) return /*#__PURE__*/ $8NFma.createElement("span", labelProps, props.label);
        return !props.children && !props.label && /*#__PURE__*/ $8NFma.createElement("span", $cb481e49c5149f10$var$_extends({}, labelProps, {
            dangerouslySetInnerHTML: {
                __html: '&nbsp;'
            }
        }));
    };
    var createBadge = function createBadge() {
        if (props.badge) {
            var badgeProps = mergeProps({
                className: (0, $kMhUd.classNames)(props.badgeClassName),
                value: props.badge,
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: metaData
                }
            }, ptm('badge'));
            return /*#__PURE__*/ $8NFma.createElement($cb481e49c5149f10$var$Badge, badgeProps, props.badge);
        }
        return null;
    };
    var showTooltip = !disabled || props.tooltipOptions && props.tooltipOptions.showOnDisabled;
    var hasTooltip = (0, $kMhUd.ObjectUtils).isNotEmpty(props.tooltip) && showTooltip;
    var sizeMapping = {
        large: 'lg',
        small: 'sm'
    };
    var size = sizeMapping[props.size];
    var icon = createIcon();
    var label = createLabel();
    var badge = createBadge();
    var defaultAriaLabel = props.label ? props.label + (props.badge ? ' ' + props.badge : '') : props['aria-label'];
    var rootProps = mergeProps({
        ref: elementRef,
        'aria-label': defaultAriaLabel,
        'data-pc-autofocus': props.autoFocus,
        className: (0, $kMhUd.classNames)(props.className, cx('root', {
            size: size,
            disabled: disabled
        })),
        disabled: disabled
    }, $cb481e49c5149f10$var$ButtonBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("button", rootProps, icon, label, props.children, badge, /*#__PURE__*/ $8NFma.createElement((0, $cLCHn.Ripple), null)), hasTooltip && /*#__PURE__*/ $8NFma.createElement((0, $7dgG7.Tooltip), $cb481e49c5149f10$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$cb481e49c5149f10$export$353f5b6fc5456de1.displayName = 'Button';

});

parcelRegister("jyiOD", function(module, exports) {

$parcel$export(module.exports, "useOnPress", () => $e3bfc9b20df17353$export$e6e1f0385927505b);

var $8NFma = parcelRequire("8NFma");
const $e3bfc9b20df17353$export$e6e1f0385927505b = ({ onPress: onPress, onUnpress: onUnpress })=>{
    const isPressed = (0, $8NFma.useRef)();
    const handlePress = ()=>{
        if (isPressed.current) return;
        isPressed.current = true;
        onPress();
    };
    const handleUnpress = ()=>{
        if (!isPressed.current) return;
        isPressed.current = false;
        onUnpress();
    };
    const handleMouseDown = ()=>{
        handlePress();
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        handleUnpress();
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const handleKeyDown = (e)=>{
        if (e.key !== "Enter") return;
        handlePress();
        document.addEventListener("keyup", handleKeyUp);
    };
    const handleKeyUp = (e)=>{
        if (e.key !== "Enter") return;
        handleUnpress();
        document.removeEventListener("keyup", removeKeyUp);
    };
    return {
        onMouseDown: handleMouseDown,
        onKeyDown: handleKeyDown
    };
};

});


parcelRegister("iBMhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $135907b4fec3d9b1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $135907b4fec3d9b1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $135907b4fec3d9b1$export$2e2bcd8739ae039 = (0, $8KNb5.default)("chevron-left", $135907b4fec3d9b1$export$3efd853dbb351e94);

});

parcelRegister("7PSp0", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b666a15c441751$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $8KNb5 = parcelRequire("8KNb5");
const $45b666a15c441751$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $45b666a15c441751$export$2e2bcd8739ae039 = (0, $8KNb5.default)("chevron-right", $45b666a15c441751$export$3efd853dbb351e94);

});



parcelRegister("6hcfC", function(module, exports) {

$parcel$export(module.exports, "Piano", () => $491dd56544e09f63$export$223eafc6788c499c);
parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");
var $82Hwq = parcelRequire("82Hwq");
var $aZf7A = parcelRequire("aZf7A");
var $bdbZZ = parcelRequire("bdbZZ");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");
parcelRequire("1UHUZ");
var $crZqV = parcelRequire("crZqV");

var $iKsY6 = parcelRequire("iKsY6");

var $huphW = parcelRequire("huphW");

var $enQqi = parcelRequire("enQqi");

var $1zQag = parcelRequire("1zQag");

var $2cXDZ = parcelRequire("2cXDZ");

var $ibyLL = parcelRequire("ibyLL");
class $491dd56544e09f63$export$223eafc6788c499c extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'piano',
        tipusDisplay: 'Piano Legacy',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).orange,
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        ...(0, $ibyLL.PianoRoller).parametersDescription,
        timbre: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 1200,
            max: 12000,
            initial: 12000,
            logarithmic: true,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {
            min: 48,
            max: 71
        }
    };
    getUserInterfaceComponent() {
        return 0, $iKsY6.PianoUI;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        // Creem els nodes del graph i els guardem
        const timbre = new $82Hwq.Filter(500, 'lowpass', -12);
        const gainFixPiano = new $bdbZZ.Gain($bmU6v.dbToGain(-20)).connect(timbre);
        const piano = new (0, $crZqV.Piano)({
            velocities: 4,
            maxPolyphony: this.constructor.maxPolyphony,
            url: appPrefix + "/static/dist/public/audio/piano/"
        }).connect(gainFixPiano);
        piano.load().then(()=>{
            console.debug('Mostres del piano carregades!');
        });
        this.audioNodes = {
            piano: piano,
            timbre: timbre,
            gainFixPiano: gainFixPiano
        };
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(timbre, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        if (name == "timbre") this.audioNodes.timbre.frequency.rampTo((0, $1zQag.limitToNyquist)(value), 0.01);
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                this.audioNodes.piano.keyDown({
                    note: $aZf7A.Frequency(note.pitch, "midi").toNote(),
                    velocity: (note.velocity ?? 127) / 127,
                    time: time
                });
                this.audioNodes.piano.keyUp({
                    note: $aZf7A.Frequency(note.pitch, "midi").toNote(),
                    time: time + duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime()
                });
            }
        }
    }
    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.piano.stopAll();
    }
    onStopAllSounds() {
        // Stop all notes that are still playing
        this.audioNodes.piano.stopAll();
    }
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        if (!noteOff) this.audioNodes.piano.keyDown({
            note: $aZf7A.Frequency(pitch, "midi").toNote(),
            velocity: midiVelocity / 127
        });
        else this.audioNodes.piano.keyUp({
            note: $aZf7A.Frequency(pitch, "midi").toNote()
        });
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("1UHUZ", function(module, exports) {

$parcel$export(module.exports, "Piano", () => (parcelRequire("crZqV")).Piano);

var $crZqV = parcelRequire("crZqV");

var $ddOR2 = parcelRequire("ddOR2");

});
parcelRegister("crZqV", function(module, exports) {

$parcel$export(module.exports, "Piano", () => $9107a906c912a77c$export$223eafc6788c499c);
parcelRequire("56MRX");
var $bdbZZ = parcelRequire("bdbZZ");
var $lQ01C = parcelRequire("lQ01C");
var $3xSib = parcelRequire("3xSib");
var $l4RVz = parcelRequire("l4RVz");
var $fDBOr = parcelRequire("fDBOr");

var $aNDH5 = parcelRequire("aNDH5");

var $3SVvL = parcelRequire("3SVvL");

var $eTGGB = parcelRequire("eTGGB");

var $kTwyA = parcelRequire("kTwyA");
var $9107a906c912a77c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9107a906c912a77c$export$223eafc6788c499c extends (0, $fDBOr.ToneAudioNode) {
    constructor(){
        super((0, $l4RVz.optionsFromArguments)($9107a906c912a77c$export$223eafc6788c499c.getDefaults(), arguments));
        this.name = 'Piano';
        this.input = undefined;
        this.output = new (0, $bdbZZ.Gain)({
            context: this.context
        });
        /**
         * The currently held notes
         */ this._heldNotes = new Map();
        /**
         * If it's loaded or not
         */ this._loaded = false;
        const options = (0, $l4RVz.optionsFromArguments)($9107a906c912a77c$export$223eafc6788c499c.getDefaults(), arguments);
        // make sure it ends with a /
        if (!options.url.endsWith('/')) options.url += '/';
        this.maxPolyphony = options.maxPolyphony;
        this._heldNotes = new Map();
        this._sustainedNotes = new Map();
        this._strings = new (0, $kTwyA.PianoStrings)(Object.assign({}, options, {
            enabled: true,
            samples: options.url,
            volume: options.volume.strings
        })).connect(this.output);
        this.strings = this._strings.volume;
        this._pedal = new (0, $eTGGB.Pedal)(Object.assign({}, options, {
            enabled: options.pedal,
            samples: options.url,
            volume: options.volume.pedal
        })).connect(this.output);
        this.pedal = this._pedal.volume;
        this._keybed = new (0, $3SVvL.Keybed)(Object.assign({}, options, {
            enabled: options.release,
            samples: options.url,
            volume: options.volume.keybed
        })).connect(this.output);
        this.keybed = this._keybed.volume;
        this._harmonics = new (0, $aNDH5.Harmonics)(Object.assign({}, options, {
            enabled: options.release,
            samples: options.url,
            volume: options.volume.harmonics
        })).connect(this.output);
        this.harmonics = this._harmonics.volume;
    }
    static getDefaults() {
        return Object.assign((0, $fDBOr.ToneAudioNode).getDefaults(), {
            maxNote: 108,
            minNote: 21,
            pedal: true,
            release: false,
            url: 'https://tambien.github.io/Piano/audio/',
            velocities: 1,
            maxPolyphony: 32,
            volume: {
                harmonics: 0,
                keybed: 0,
                pedal: 0,
                strings: 0
            }
        });
    }
    /**
     *  Load all the samples
     */ load() {
        return $9107a906c912a77c$var$__awaiter(this, void 0, void 0, function*() {
            yield Promise.all([
                this._strings.load(),
                this._pedal.load(),
                this._keybed.load(),
                this._harmonics.load()
            ]);
            this._loaded = true;
        });
    }
    /**
     * If all the samples are loaded or not
     */ get loaded() {
        return this._loaded;
    }
    /**
     *  Put the pedal down at the given time. Causes subsequent
     *  notes and currently held notes to sustain.
     */ pedalDown({ time: time = this.immediate() } = {}) {
        if (this.loaded) {
            time = this.toSeconds(time);
            if (!this._pedal.isDown(time)) this._pedal.down(time);
        }
        return this;
    }
    /**
     *  Put the pedal up. Dampens sustained notes
     */ pedalUp({ time: time = this.immediate() } = {}) {
        if (this.loaded) {
            const seconds = this.toSeconds(time);
            if (this._pedal.isDown(seconds)) {
                this._pedal.up(seconds);
                // dampen each of the notes
                this._sustainedNotes.forEach((t, note)=>{
                    if (!this._heldNotes.has(note)) this._strings.triggerRelease(note, seconds);
                });
                this._sustainedNotes.clear();
            }
        }
        return this;
    }
    /**
     *  Play a note.
     *  @param note	  The note to play. If it is a number, it is assumed to be MIDI
     *  @param velocity  The velocity to play the note
     *  @param time	  The time of the event
     */ keyDown({ note: note, midi: midi, time: time = this.immediate(), velocity: velocity = 0.8 }) {
        if (this.loaded && this.maxPolyphony > this._heldNotes.size + this._sustainedNotes.size) {
            time = this.toSeconds(time);
            if ((0, $lQ01C.isString)(note)) midi = Math.round((0, $3xSib.Midi)(note).toMidi());
            if (!this._heldNotes.has(midi)) {
                // record the start time and velocity
                this._heldNotes.set(midi, {
                    time: time,
                    velocity: velocity
                });
                this._strings.triggerAttack(midi, time, velocity);
            }
        } else console.warn('samples not loaded');
        return this;
    }
    /**
     *  Release a held note.
     */ keyUp({ note: note, midi: midi, time: time = this.immediate(), velocity: velocity = 0.8 }) {
        if (this.loaded) {
            time = this.toSeconds(time);
            if ((0, $lQ01C.isString)(note)) midi = Math.round((0, $3xSib.Midi)(note).toMidi());
            if (this._heldNotes.has(midi)) {
                const prevNote = this._heldNotes.get(midi);
                this._heldNotes.delete(midi);
                // compute the release velocity
                const holdTime = Math.pow(Math.max(time - prevNote.time, 0.1), 0.7);
                const prevVel = prevNote.velocity;
                let dampenGain = 3 / holdTime * prevVel * velocity;
                dampenGain = Math.max(dampenGain, 0.4);
                dampenGain = Math.min(dampenGain, 4);
                if (this._pedal.isDown(time)) {
                    if (!this._sustainedNotes.has(midi)) this._sustainedNotes.set(midi, time);
                } else {
                    // release the string sound
                    this._strings.triggerRelease(midi, time);
                    // trigger the harmonics sound
                    this._harmonics.triggerAttack(midi, time, dampenGain);
                }
                // trigger the keybed release sound
                this._keybed.start(midi, time, velocity);
            }
        }
        return this;
    }
    stopAll() {
        this.pedalUp();
        this._heldNotes.forEach((_, midi)=>{
            this.keyUp({
                midi: midi
            });
        });
        return this;
    }
}

});
parcelRegister("aNDH5", function(module, exports) {

$parcel$export(module.exports, "Harmonics", () => $7dcd4562530b6492$export$67b62bd51d276a74);
parcelRequire("56MRX");
var $3xSib = parcelRequire("3xSib");
var $7u8Jf = parcelRequire("7u8Jf");

var $adXr0 = parcelRequire("adXr0");

var $avmYT = parcelRequire("avmYT");

var $5bGb7 = parcelRequire("5bGb7");
class $7dcd4562530b6492$export$67b62bd51d276a74 extends (0, $adXr0.PianoComponent) {
    constructor(options){
        super(options);
        this._urls = {};
        const notes = (0, $avmYT.getHarmonicsInRange)(options.minNote, options.maxNote);
        for (const n of notes)this._urls[n] = (0, $avmYT.getHarmonicsUrl)(n);
    }
    triggerAttack(note, time, velocity) {
        if (this._enabled && (0, $avmYT.inHarmonicsRange)(note)) this._sampler.triggerAttack((0, $3xSib.Midi)(note).toNote(), time, velocity * (0, $5bGb7.randomBetween)(0.5, 1));
    }
    _internalLoad() {
        return new Promise((onload)=>{
            this._sampler = new (0, $7u8Jf.Sampler)({
                baseUrl: this.samples,
                onload: onload,
                urls: this._urls
            }).connect(this.output);
        });
    }
}

});
parcelRegister("adXr0", function(module, exports) {

$parcel$export(module.exports, "PianoComponent", () => $771938c1dea6d80a$export$bfd2d97ccc59b247);
parcelRequire("56MRX");
var $fDBOr = parcelRequire("fDBOr");
var $dTGN1 = parcelRequire("dTGN1");
var $771938c1dea6d80a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $771938c1dea6d80a$export$bfd2d97ccc59b247 extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = 'PianoComponent';
        this.input = undefined;
        this.output = new (0, $dTGN1.Volume)({
            context: this.context
        });
        /**
         * If the component is enabled or not
         */ this._enabled = false;
        /**
         * The volume output of the component
         */ this.volume = this.output.volume;
        /**
         * Boolean indication of if the component is loaded or not
         */ this._loaded = false;
        this.volume.value = options.volume;
        this._enabled = options.enabled;
        this.samples = options.samples;
    }
    /**
     * If the samples are loaded or not
     */ get loaded() {
        return this._loaded;
    }
    /**
     * Load the samples
     */ load() {
        return $771938c1dea6d80a$var$__awaiter(this, void 0, void 0, function*() {
            if (this._enabled) {
                yield this._internalLoad();
                this._loaded = true;
            } else return Promise.resolve();
        });
    }
}

});

parcelRegister("avmYT", function(module, exports) {

$parcel$export(module.exports, "getReleasesUrl", () => $7a5ea03518779222$export$438d9ec7910d621a);
$parcel$export(module.exports, "getHarmonicsUrl", () => $7a5ea03518779222$export$14ed58bee236d998);
$parcel$export(module.exports, "getNotesUrl", () => $7a5ea03518779222$export$ec59e9c4b29f3446);
$parcel$export(module.exports, "velocitiesMap", () => $7a5ea03518779222$export$cdbea52bc9e7d007);
$parcel$export(module.exports, "getNotesInRange", () => $7a5ea03518779222$export$a86a83cd0ab5f0f1);
$parcel$export(module.exports, "getHarmonicsInRange", () => $7a5ea03518779222$export$9cc7496ce2cd2412);
$parcel$export(module.exports, "inHarmonicsRange", () => $7a5ea03518779222$export$fd0fe0dd952db82);

var $5bGb7 = parcelRequire("5bGb7");
const $7a5ea03518779222$export$85718880e747a153 = 'https://tambien.github.io/Piano/Salamander/';
function $7a5ea03518779222$export$438d9ec7910d621a(midi) {
    return `rel${midi - 20}.[mp3|ogg]`;
}
function $7a5ea03518779222$export$14ed58bee236d998(midi) {
    return `harmS${(0, $5bGb7.midiToNote)(midi).replace('#', 's')}.[mp3|ogg]`;
}
function $7a5ea03518779222$export$ec59e9c4b29f3446(midi, vel) {
    return `${(0, $5bGb7.midiToNote)(midi).replace('#', 's')}v${vel}.[mp3|ogg]`;
}
const $7a5ea03518779222$export$cdbea52bc9e7d007 = {
    1: [
        8
    ],
    2: [
        6,
        12
    ],
    3: [
        1,
        7,
        15
    ],
    4: [
        1,
        5,
        10,
        15
    ],
    5: [
        1,
        4,
        8,
        12,
        16
    ],
    6: [
        1,
        3,
        7,
        10,
        13,
        16
    ],
    7: [
        1,
        3,
        6,
        9,
        11,
        13,
        16
    ],
    8: [
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        16
    ],
    9: [
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15,
        16
    ],
    10: [
        1,
        2,
        3,
        5,
        7,
        9,
        11,
        13,
        15,
        16
    ],
    11: [
        1,
        2,
        3,
        5,
        7,
        9,
        11,
        13,
        14,
        15,
        16
    ],
    12: [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        11,
        13,
        14,
        15,
        16
    ],
    13: [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        11,
        12,
        13,
        14,
        15,
        16
    ],
    14: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        9,
        11,
        12,
        13,
        14,
        15,
        16
    ],
    15: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
    ],
    16: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
    ]
};
const $7a5ea03518779222$export$3968e70426c92b35 = [
    21,
    24,
    27,
    30,
    33,
    36,
    39,
    42,
    45,
    48,
    51,
    54,
    57,
    60,
    63,
    66,
    69,
    72,
    75,
    78,
    81,
    84,
    87,
    90,
    93,
    96,
    99,
    102,
    105,
    108
];
function $7a5ea03518779222$export$a86a83cd0ab5f0f1(min, max) {
    return $7a5ea03518779222$export$3968e70426c92b35.filter((note)=>min <= note && note <= max);
}
/**
 * All the notes of audio samples
 */ const $7a5ea03518779222$var$harmonics = [
    21,
    24,
    27,
    30,
    33,
    36,
    39,
    42,
    45,
    48,
    51,
    54,
    57,
    60,
    63,
    66,
    69,
    72,
    75,
    78,
    81,
    84,
    87
];
function $7a5ea03518779222$export$9cc7496ce2cd2412(min, max) {
    return $7a5ea03518779222$var$harmonics.filter((note)=>min <= note && note <= max);
}
function $7a5ea03518779222$export$fd0fe0dd952db82(note) {
    return $7a5ea03518779222$var$harmonics[0] <= note && note <= $7a5ea03518779222$var$harmonics[$7a5ea03518779222$var$harmonics.length - 1];
}

});
parcelRegister("5bGb7", function(module, exports) {

$parcel$export(module.exports, "midiToNote", () => $3c6eb296e4be4968$export$c750f99b7dcda73);
$parcel$export(module.exports, "randomBetween", () => $3c6eb296e4be4968$export$4dc0b9eca0839ce2);
// import * as Tone from '../node_modules/tone/Tone'
parcelRequire("56MRX");
var $aZf7A = parcelRequire("aZf7A");
var $bmU6v = parcelRequire("bmU6v");
var $a0u4l = parcelRequire("a0u4l");
function $3c6eb296e4be4968$export$25a3774aa9165c3f(note) {
    return (0, $aZf7A.Frequency)(note).toMidi();
}
function $3c6eb296e4be4968$export$c750f99b7dcda73(midi) {
    const frequency = (0, $aZf7A.Frequency)(midi, 'midi');
    const ret = frequency.toNote();
    return ret;
}
function $3c6eb296e4be4968$var$midiToFrequencyRatio(midi) {
    const mod = midi % 3;
    if (mod === 1) return [
        midi - 1,
        (0, $bmU6v.intervalToFrequencyRatio)(1)
    ];
    else if (mod === 2) // @ts-ignore
    return [
        midi + 1,
        (0, $bmU6v.intervalToFrequencyRatio)(-1)
    ];
    else return [
        midi,
        1
    ];
}
function $3c6eb296e4be4968$var$createSource(buffer) {
    return new (0, $a0u4l.ToneBufferSource)(buffer);
}
function $3c6eb296e4be4968$export$4dc0b9eca0839ce2(low, high) {
    return Math.random() * (high - low) + low;
}

});



parcelRegister("3SVvL", function(module, exports) {

$parcel$export(module.exports, "Keybed", () => $2d4306c5c6d91f14$export$777620819a77666);
parcelRequire("56MRX");
var $iace4 = parcelRequire("iace4");
var $a0u4l = parcelRequire("a0u4l");

var $adXr0 = parcelRequire("adXr0");

var $avmYT = parcelRequire("avmYT");

var $5bGb7 = parcelRequire("5bGb7");
class $2d4306c5c6d91f14$export$777620819a77666 extends (0, $adXr0.PianoComponent) {
    constructor(options){
        super(options);
        /**
         * The urls to load
         */ this._urls = {};
        for(let i = options.minNote; i <= options.maxNote; i++)this._urls[i] = (0, $avmYT.getReleasesUrl)(i);
    }
    _internalLoad() {
        return new Promise((success)=>{
            this._buffers = new (0, $iace4.ToneAudioBuffers)(this._urls, success, this.samples);
        });
    }
    start(note, time, velocity) {
        if (this._enabled && this._buffers.has(note)) {
            const source = new (0, $a0u4l.ToneBufferSource)({
                url: this._buffers.get(note),
                context: this.context
            }).connect(this.output);
            // randomize the velocity slightly
            source.start(time, 0, undefined, 0.015 * velocity * (0, $5bGb7.randomBetween)(0.5, 1));
        }
    }
}

});

parcelRegister("eTGGB", function(module, exports) {

$parcel$export(module.exports, "Pedal", () => $ad87505425fc1920$export$fa297ea4afae26f5);
parcelRequire("56MRX");
var $iace4 = parcelRequire("iace4");
var $a0u4l = parcelRequire("a0u4l");

var $adXr0 = parcelRequire("adXr0");

var $5bGb7 = parcelRequire("5bGb7");
class $ad87505425fc1920$export$fa297ea4afae26f5 extends (0, $adXr0.PianoComponent) {
    constructor(options){
        super(options);
        this._downTime = Infinity;
        this._currentSound = null;
        this._downTime = Infinity;
    }
    _internalLoad() {
        return new Promise((success)=>{
            this._buffers = new (0, $iace4.ToneAudioBuffers)({
                down1: 'pedalD1.mp3',
                down2: 'pedalD2.mp3',
                up1: 'pedalU1.mp3',
                up2: 'pedalU2.mp3'
            }, success, this.samples);
        });
    }
    /**
     *  Squash the current playing sound
     */ _squash(time) {
        if (this._currentSound && this._currentSound.state !== 'stopped') this._currentSound.stop(time);
        this._currentSound = null;
    }
    _playSample(time, dir) {
        if (this._enabled) {
            this._currentSound = new (0, $a0u4l.ToneBufferSource)({
                url: this._buffers.get(`${dir}${Math.random() > 0.5 ? 1 : 2}`),
                context: this.context,
                curve: 'exponential',
                fadeIn: 0.05,
                fadeOut: 0.1
            }).connect(this.output);
            this._currentSound.start(time, (0, $5bGb7.randomBetween)(0, 0.01), undefined, 0.1 * (0, $5bGb7.randomBetween)(0.5, 1));
        }
    }
    /**
     * Put the pedal down
     */ down(time) {
        this._squash(time);
        this._downTime = time;
        this._playSample(time, 'down');
    }
    /**
     * Put the pedal up
     */ up(time) {
        this._squash(time);
        this._downTime = Infinity;
        this._playSample(time, 'up');
    }
    /**
     * Indicates if the pedal is down at the given time
     */ isDown(time) {
        return time > this._downTime;
    }
}

});

parcelRegister("kTwyA", function(module, exports) {

$parcel$export(module.exports, "PianoStrings", () => $f36232d30d21ba89$export$30949ea05f813c3f);
parcelRequire("56MRX");
var $3xSib = parcelRequire("3xSib");

var $adXr0 = parcelRequire("adXr0");

var $avmYT = parcelRequire("avmYT");

var $1hrfn = parcelRequire("1hrfn");
var $f36232d30d21ba89$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $f36232d30d21ba89$export$30949ea05f813c3f extends (0, $adXr0.PianoComponent) {
    constructor(options){
        super(options);
        const notes = (0, $avmYT.getNotesInRange)(options.minNote, options.maxNote);
        const velocities = (0, $avmYT.velocitiesMap)[options.velocities].slice();
        this._strings = velocities.map((velocity)=>{
            const string = new (0, $1hrfn.PianoString)(Object.assign(options, {
                notes: notes,
                velocity: velocity
            }));
            return string;
        });
        this._activeNotes = new Map();
    }
    /**
     * Scale a value between a given range
     */ scale(val, inMin, inMax, outMin, outMax) {
        return (val - inMin) / (inMax - inMin) * (outMax - outMin) + outMin;
    }
    triggerAttack(note, time, velocity) {
        const scaledVel = this.scale(velocity, 0, 1, -0.5, this._strings.length - 0.51);
        const stringIndex = Math.max(Math.round(scaledVel), 0);
        let gain = 1 + scaledVel - stringIndex;
        if (this._strings.length === 1) gain = velocity;
        const sampler = this._strings[stringIndex];
        if (this._activeNotes.has(note)) this.triggerRelease(note, time);
        this._activeNotes.set(note, sampler);
        sampler.triggerAttack((0, $3xSib.Midi)(note).toNote(), time, gain);
    }
    triggerRelease(note, time) {
        // trigger the release of all of the notes at that velociy
        if (this._activeNotes.has(note)) {
            this._activeNotes.get(note).triggerRelease((0, $3xSib.Midi)(note).toNote(), time);
            this._activeNotes.delete(note);
        }
    }
    _internalLoad() {
        return $f36232d30d21ba89$var$__awaiter(this, void 0, void 0, function*() {
            yield Promise.all(this._strings.map((s)=>$f36232d30d21ba89$var$__awaiter(this, void 0, void 0, function*() {
                    yield s.load();
                    s.connect(this.output);
                })));
        });
    }
}

});
parcelRegister("1hrfn", function(module, exports) {

$parcel$export(module.exports, "PianoString", () => $0eec83a9e1ed1372$export$edd3f4b540cc98f0);
parcelRequire("56MRX");
var $7u8Jf = parcelRequire("7u8Jf");
var $fDBOr = parcelRequire("fDBOr");

var $avmYT = parcelRequire("avmYT");
class $0eec83a9e1ed1372$export$edd3f4b540cc98f0 extends (0, $fDBOr.ToneAudioNode) {
    constructor(options){
        super(options);
        this.name = 'PianoString';
        this._urls = {};
        // create the urls
        options.notes.forEach((note)=>this._urls[note] = (0, $avmYT.getNotesUrl)(note, options.velocity));
        this.samples = options.samples;
    }
    load() {
        return new Promise((onload)=>{
            this._sampler = this.output = new (0, $7u8Jf.Sampler)({
                attack: 0,
                baseUrl: this.samples,
                curve: 'exponential',
                onload: onload,
                release: 0.4,
                urls: this._urls,
                volume: 3
            });
        });
    }
    triggerAttack(note, time, velocity) {
        this._sampler.triggerAttack(note, time, velocity);
    }
    triggerRelease(note, time) {
        this._sampler.triggerRelease(note, time);
    }
}

});



parcelRegister("ddOR2", function(module, exports) {

var $9sqfU = parcelRequire("9sqfU");

var $fjJaN = parcelRequire("fjJaN");
var $9a03efdee428b1c5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9a03efdee428b1c5$export$13c79618714c35ae extends (0, $9sqfU.EventEmitter) {
    constructor(deviceId = 'all'){
        super();
        this.deviceId = deviceId;
        /**
         * Automatically attaches the event listeners when a device is connect
         * and removes listeners when a device is disconnected
         */ $9a03efdee428b1c5$export$13c79618714c35ae.enabled().then(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($fjJaN))).addListener('connected', (event)=>{
                if (event.port.type === 'input') this._addListeners(event.port);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($fjJaN))).addListener('disconnected', (event)=>{
                this._removeListeners(event.port);
            });
            // add all of the existing inputs
            (0, (/*@__PURE__*/$parcel$interopDefault($fjJaN))).inputs.forEach((input)=>this._addListeners(input));
        });
    }
    /**
     * Attach listeners to the device when it's connected
     */ _addListeners(device) {
        if (!$9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices.has(device.id)) {
            $9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices.set(device.id, device);
            this.emit('connect', this._inputToDevice(device));
            device.addListener('noteon', 'all', (event)=>{
                if (this.deviceId === 'all' || this.deviceId === device.id) this.emit('keyDown', {
                    note: `${event.note.name}${event.note.octave}`,
                    midi: event.note.number,
                    velocity: event.velocity,
                    device: this._inputToDevice(device)
                });
            });
            device.addListener('noteoff', 'all', (event)=>{
                if (this.deviceId === 'all' || this.deviceId === device.id) this.emit('keyUp', {
                    note: `${event.note.name}${event.note.octave}`,
                    midi: event.note.number,
                    velocity: event.velocity,
                    device: this._inputToDevice(device)
                });
            });
            device.addListener('controlchange', 'all', (event)=>{
                if (this.deviceId === 'all' || this.deviceId === device.id) {
                    if (event.controller.name === 'holdpedal') this.emit(event.value ? 'pedalDown' : 'pedalUp', {
                        device: this._inputToDevice(device)
                    });
                }
            });
        }
    }
    _inputToDevice(input) {
        return {
            name: input.name,
            id: input.id,
            manufacturer: input.manufacturer
        };
    }
    /**
     * Internal call to remove all event listeners associated with the device
     */ _removeListeners(event) {
        if ($9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices.has(event.id)) {
            const device = $9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices.get(event.id);
            this.emit('disconnect', this._inputToDevice(device));
            $9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices.delete(event.id);
            device.removeListener('noteon');
            device.removeListener('noteoff');
            device.removeListener('controlchange');
        }
    }
    // EVENT FUNCTIONS
    emit(event, data) {
        return super.emit(event, data);
    }
    on(event, listener) {
        super.on(event, listener);
        return this;
    }
    once(event, listener) {
        super.once(event, listener);
        return this;
    }
    off(event, listener) {
        super.off(event, listener);
        return this;
    }
    /**
     * Resolves when the MIDI Input is enabled and ready to use
     */ static enabled() {
        return $9a03efdee428b1c5$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9a03efdee428b1c5$export$13c79618714c35ae._isEnabled) yield new Promise((done, error)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($fjJaN))).enable((e)=>{
                    if (e) error(e);
                    else {
                        $9a03efdee428b1c5$export$13c79618714c35ae._isEnabled = true;
                        done();
                    }
                });
            });
        });
    }
    /**
     * Get a list of devices that are currently connected
     */ static getDevices() {
        return $9a03efdee428b1c5$var$__awaiter(this, void 0, void 0, function*() {
            yield $9a03efdee428b1c5$export$13c79618714c35ae.enabled();
            return (0, (/*@__PURE__*/$parcel$interopDefault($fjJaN))).inputs;
        });
    }
}
// STATIC
$9a03efdee428b1c5$export$13c79618714c35ae.connectedDevices = new Map();
$9a03efdee428b1c5$export$13c79618714c35ae._isEnabled = false;

});
parcelRegister("9sqfU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6e2b186194ca9ee7$var$R = typeof Reflect === 'object' ? Reflect : null;
var $6e2b186194ca9ee7$var$ReflectApply = $6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.apply === 'function' ? $6e2b186194ca9ee7$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6e2b186194ca9ee7$var$ReflectOwnKeys;
if ($6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.ownKeys === 'function') $6e2b186194ca9ee7$var$ReflectOwnKeys = $6e2b186194ca9ee7$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6e2b186194ca9ee7$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6e2b186194ca9ee7$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6e2b186194ca9ee7$var$EventEmitter() {
    $6e2b186194ca9ee7$var$EventEmitter.init.call(this);
}
module.exports = $6e2b186194ca9ee7$var$EventEmitter;
module.exports.once = $6e2b186194ca9ee7$var$once;
// Backwards-compat with node 0.10.x
$6e2b186194ca9ee7$var$EventEmitter.EventEmitter = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$var$EventEmitter.prototype._events = undefined;
$6e2b186194ca9ee7$var$EventEmitter.prototype._eventsCount = 0;
$6e2b186194ca9ee7$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6e2b186194ca9ee7$var$defaultMaxListeners = 10;
function $6e2b186194ca9ee7$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6e2b186194ca9ee7$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $6e2b186194ca9ee7$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $6e2b186194ca9ee7$var$defaultMaxListeners = arg;
    }
});
$6e2b186194ca9ee7$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6e2b186194ca9ee7$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $6e2b186194ca9ee7$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6e2b186194ca9ee7$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6e2b186194ca9ee7$var$_getMaxListeners(this);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $6e2b186194ca9ee7$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6e2b186194ca9ee7$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6e2b186194ca9ee7$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6e2b186194ca9ee7$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6e2b186194ca9ee7$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6e2b186194ca9ee7$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, false);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.on = $6e2b186194ca9ee7$var$EventEmitter.prototype.addListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, true);
};
function $6e2b186194ca9ee7$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6e2b186194ca9ee7$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6e2b186194ca9ee7$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.once = function once(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.on(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.prependListener(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6e2b186194ca9ee7$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.off = $6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6e2b186194ca9ee7$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6e2b186194ca9ee7$var$unwrapListeners(evlistener) : $6e2b186194ca9ee7$var$arrayClone(evlistener, evlistener.length);
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, true);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, false);
};
$6e2b186194ca9ee7$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $6e2b186194ca9ee7$var$listenerCount.call(emitter, type);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.listenerCount = $6e2b186194ca9ee7$var$listenerCount;
function $6e2b186194ca9ee7$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6e2b186194ca9ee7$var$ReflectOwnKeys(this._events) : [];
};
function $6e2b186194ca9ee7$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6e2b186194ca9ee7$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6e2b186194ca9ee7$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6e2b186194ca9ee7$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("fjJaN", function(module, exports) {
/**
 * WEBMIDI.js v3.1.9
 * A JavaScript library to kickstart your MIDI projects
 * https://webmidijs.org
 * Build generated on April 21st, 2024.
 *
 * © Copyright 2015-2024, Jean-Philippe Côté.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
class EventEmitter {
    constructor(e = !1){
        this.eventMap = {}, this.eventsSuspended = 1 == e;
    }
    addListener(e, t, n = {}) {
        if ("string" == typeof e && e.length < 1 || e instanceof String && e.length < 1 || "string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if ("function" != typeof t) throw new TypeError("The callback must be a function.");
        const r = new Listener(e, this, t, n);
        return this.eventMap[e] || (this.eventMap[e] = []), n.prepend ? this.eventMap[e].unshift(r) : this.eventMap[e].push(r), r;
    }
    addOneTimeListener(e, t, n = {}) {
        n.remaining = 1, this.addListener(e, t, n);
    }
    static get ANY_EVENT() {
        return Symbol.for("Any event");
    }
    hasListener(e, t) {
        if (void 0 === e) return !!(this.eventMap[EventEmitter.ANY_EVENT] && this.eventMap[EventEmitter.ANY_EVENT].length > 0) || Object.entries(this.eventMap).some(([, e])=>e.length > 0);
        if (this.eventMap[e] && this.eventMap[e].length > 0) {
            if (t instanceof Listener) return this.eventMap[e].filter((e)=>e === t).length > 0;
            if ("function" == typeof t) return this.eventMap[e].filter((e)=>e.callback === t).length > 0;
            return null == t;
        }
        return !1;
    }
    get eventNames() {
        return Object.keys(this.eventMap);
    }
    getListeners(e) {
        return this.eventMap[e] || [];
    }
    suspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !0;
        });
    }
    unsuspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !1;
        });
    }
    getListenerCount(e) {
        return this.getListeners(e).length;
    }
    emit(e, ...t) {
        if ("string" != typeof e && !(e instanceof String)) throw new TypeError("The 'event' parameter must be a string.");
        if (this.eventsSuspended) return;
        let n = [], r = this.eventMap[EventEmitter.ANY_EVENT] || [];
        return this.eventMap[e] && (r = r.concat(this.eventMap[e])), r.forEach((e)=>{
            if (e.suspended) return;
            let r = [
                ...t
            ];
            Array.isArray(e.arguments) && (r = r.concat(e.arguments)), e.remaining > 0 && (n.push(e.callback.apply(e.context, r)), e.count++), --e.remaining < 1 && e.remove();
        }), n;
    }
    removeListener(e, t, n = {}) {
        if (void 0 === e) return void (this.eventMap = {});
        if (!this.eventMap[e]) return;
        let r = this.eventMap[e].filter((e)=>t && e.callback !== t || n.remaining && n.remaining !== e.remaining || n.context && n.context !== e.context);
        r.length ? this.eventMap[e] = r : delete this.eventMap[e];
    }
    async waitFor(e, t = {}) {
        return t.duration = parseInt(t.duration), (isNaN(t.duration) || t.duration <= 0) && (t.duration = 1 / 0), new Promise((n, r)=>{
            let i, s = this.addListener(e, ()=>{
                clearTimeout(i), n();
            }, {
                remaining: 1
            });
            t.duration !== 1 / 0 && (i = setTimeout(()=>{
                s.remove(), r("The duration expired before the event was emitted.");
            }, t.duration));
        });
    }
    get eventCount() {
        return Object.keys(this.eventMap).length;
    }
}
class Listener {
    constructor(e, t, n, r = {}){
        if ("string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if (!t) throw new ReferenceError("The 'target' parameter is mandatory.");
        if ("function" != typeof n) throw new TypeError("The 'callback' must be a function.");
        void 0 === r.arguments || Array.isArray(r.arguments) || (r.arguments = [
            r.arguments
        ]), (r = Object.assign({
            context: t,
            remaining: 1 / 0,
            arguments: void 0,
            duration: 1 / 0
        }, r)).duration !== 1 / 0 && setTimeout(()=>this.remove(), r.duration), this.arguments = r.arguments, this.callback = n, this.context = r.context, this.count = 0, this.event = e, this.remaining = parseInt(r.remaining) >= 1 ? parseInt(r.remaining) : 1 / 0, this.suspended = !1, this.target = t;
    }
    remove() {
        this.target.removeListener(this.event, this.callback, {
            context: this.context,
            remaining: this.remaining
        });
    }
}
/**
 * The `Enumerations` class contains enumerations and arrays of elements used throughout the
 * library. All its properties are static and should be referenced using the class name. For
 * example: `Enumerations.CHANNEL_MESSAGES`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Enumerations {
    static get MIDI_CHANNEL_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MESSAGES enum instead."), Enumerations.CHANNEL_MESSAGES;
    }
    static get CHANNEL_MESSAGES() {
        return {
            noteoff: 8,
            noteon: 9,
            keyaftertouch: 10,
            controlchange: 11,
            programchange: 12,
            channelaftertouch: 13,
            pitchbend: 14
        };
    }
    static get CHANNEL_NUMBERS() {
        return [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get MIDI_CHANNEL_NUMBERS() {
        return this.validation && console.warn("The MIDI_CHANNEL_NUMBERS array has been deprecated. Use the Enumerations.CHANNEL_NUMBERS array instead."), [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get CHANNEL_MODE_MESSAGES() {
        return {
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MODE_MESSAGES enum instead."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    static get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been deprecated. Use the Enumerations.CONTROL_CHANGE_MESSAGES array instead."), {
            bankselectcoarse: 0,
            modulationwheelcoarse: 1,
            breathcontrollercoarse: 2,
            controller3: 3,
            footcontrollercoarse: 4,
            portamentotimecoarse: 5,
            dataentrycoarse: 6,
            volumecoarse: 7,
            balancecoarse: 8,
            controller9: 9,
            pancoarse: 10,
            expressioncoarse: 11,
            effectcontrol1coarse: 12,
            effectcontrol2coarse: 13,
            controller14: 14,
            controller15: 15,
            generalpurposeslider1: 16,
            generalpurposeslider2: 17,
            generalpurposeslider3: 18,
            generalpurposeslider4: 19,
            controller20: 20,
            controller21: 21,
            controller22: 22,
            controller23: 23,
            controller24: 24,
            controller25: 25,
            controller26: 26,
            controller27: 27,
            controller28: 28,
            controller29: 29,
            controller30: 30,
            controller31: 31,
            bankselectfine: 32,
            modulationwheelfine: 33,
            breathcontrollerfine: 34,
            controller35: 35,
            footcontrollerfine: 36,
            portamentotimefine: 37,
            dataentryfine: 38,
            volumefine: 39,
            balancefine: 40,
            controller41: 41,
            panfine: 42,
            expressionfine: 43,
            effectcontrol1fine: 44,
            effectcontrol2fine: 45,
            controller46: 46,
            controller47: 47,
            controller48: 48,
            controller49: 49,
            controller50: 50,
            controller51: 51,
            controller52: 52,
            controller53: 53,
            controller54: 54,
            controller55: 55,
            controller56: 56,
            controller57: 57,
            controller58: 58,
            controller59: 59,
            controller60: 60,
            controller61: 61,
            controller62: 62,
            controller63: 63,
            holdpedal: 64,
            portamento: 65,
            sustenutopedal: 66,
            softpedal: 67,
            legatopedal: 68,
            hold2pedal: 69,
            soundvariation: 70,
            resonance: 71,
            soundreleasetime: 72,
            soundattacktime: 73,
            brightness: 74,
            soundcontrol6: 75,
            soundcontrol7: 76,
            soundcontrol8: 77,
            soundcontrol9: 78,
            soundcontrol10: 79,
            generalpurposebutton1: 80,
            generalpurposebutton2: 81,
            generalpurposebutton3: 82,
            generalpurposebutton4: 83,
            controller84: 84,
            controller85: 85,
            controller86: 86,
            controller87: 87,
            controller88: 88,
            controller89: 89,
            controller90: 90,
            reverblevel: 91,
            tremololevel: 92,
            choruslevel: 93,
            celestelevel: 94,
            phaserlevel: 95,
            databuttonincrement: 96,
            databuttondecrement: 97,
            nonregisteredparametercoarse: 98,
            nonregisteredparameterfine: 99,
            registeredparametercoarse: 100,
            registeredparameterfine: 101,
            controller102: 102,
            controller103: 103,
            controller104: 104,
            controller105: 105,
            controller106: 106,
            controller107: 107,
            controller108: 108,
            controller109: 109,
            controller110: 110,
            controller111: 111,
            controller112: 112,
            controller113: 113,
            controller114: 114,
            controller115: 115,
            controller116: 116,
            controller117: 117,
            controller118: 118,
            controller119: 119,
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get CONTROL_CHANGE_MESSAGES() {
        return [
            {
                number: 0,
                name: "bankselectcoarse",
                description: "Bank Select (Coarse)",
                position: "msb"
            },
            {
                number: 1,
                name: "modulationwheelcoarse",
                description: "Modulation Wheel (Coarse)",
                position: "msb"
            },
            {
                number: 2,
                name: "breathcontrollercoarse",
                description: "Breath Controller (Coarse)",
                position: "msb"
            },
            {
                number: 3,
                name: "controller3",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 4,
                name: "footcontrollercoarse",
                description: "Foot Controller (Coarse)",
                position: "msb"
            },
            {
                number: 5,
                name: "portamentotimecoarse",
                description: "Portamento Time (Coarse)",
                position: "msb"
            },
            {
                number: 6,
                name: "dataentrycoarse",
                description: "Data Entry (Coarse)",
                position: "msb"
            },
            {
                number: 7,
                name: "volumecoarse",
                description: "Channel Volume (Coarse)",
                position: "msb"
            },
            {
                number: 8,
                name: "balancecoarse",
                description: "Balance (Coarse)",
                position: "msb"
            },
            {
                number: 9,
                name: "controller9",
                description: "Controller 9 (Coarse)",
                position: "msb"
            },
            {
                number: 10,
                name: "pancoarse",
                description: "Pan (Coarse)",
                position: "msb"
            },
            {
                number: 11,
                name: "expressioncoarse",
                description: "Expression Controller (Coarse)",
                position: "msb"
            },
            {
                number: 12,
                name: "effectcontrol1coarse",
                description: "Effect Control 1 (Coarse)",
                position: "msb"
            },
            {
                number: 13,
                name: "effectcontrol2coarse",
                description: "Effect Control 2 (Coarse)",
                position: "msb"
            },
            {
                number: 14,
                name: "controller14",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 15,
                name: "controller15",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 16,
                name: "generalpurposecontroller1",
                description: "General Purpose Controller 1 (Coarse)",
                position: "msb"
            },
            {
                number: 17,
                name: "generalpurposecontroller2",
                description: "General Purpose Controller 2 (Coarse)",
                position: "msb"
            },
            {
                number: 18,
                name: "generalpurposecontroller3",
                description: "General Purpose Controller 3 (Coarse)",
                position: "msb"
            },
            {
                number: 19,
                name: "generalpurposecontroller4",
                description: "General Purpose Controller 4 (Coarse)",
                position: "msb"
            },
            {
                number: 20,
                name: "controller20",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 21,
                name: "controller21",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 22,
                name: "controller22",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 23,
                name: "controller23",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 24,
                name: "controller24",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 25,
                name: "controller25",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 26,
                name: "controller26",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 27,
                name: "controller27",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 28,
                name: "controller28",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 29,
                name: "controller29",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 30,
                name: "controller30",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 31,
                name: "controller31",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 32,
                name: "bankselectfine",
                description: "Bank Select (Fine)",
                position: "lsb"
            },
            {
                number: 33,
                name: "modulationwheelfine",
                description: "Modulation Wheel (Fine)",
                position: "lsb"
            },
            {
                number: 34,
                name: "breathcontrollerfine",
                description: "Breath Controller (Fine)",
                position: "lsb"
            },
            {
                number: 35,
                name: "controller35",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 36,
                name: "footcontrollerfine",
                description: "Foot Controller (Fine)",
                position: "lsb"
            },
            {
                number: 37,
                name: "portamentotimefine",
                description: "Portamento Time (Fine)",
                position: "lsb"
            },
            {
                number: 38,
                name: "dataentryfine",
                description: "Data Entry (Fine)",
                position: "lsb"
            },
            {
                number: 39,
                name: "channelvolumefine",
                description: "Channel Volume (Fine)",
                position: "lsb"
            },
            {
                number: 40,
                name: "balancefine",
                description: "Balance (Fine)",
                position: "lsb"
            },
            {
                number: 41,
                name: "controller41",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 42,
                name: "panfine",
                description: "Pan (Fine)",
                position: "lsb"
            },
            {
                number: 43,
                name: "expressionfine",
                description: "Expression Controller (Fine)",
                position: "lsb"
            },
            {
                number: 44,
                name: "effectcontrol1fine",
                description: "Effect control 1 (Fine)",
                position: "lsb"
            },
            {
                number: 45,
                name: "effectcontrol2fine",
                description: "Effect control 2 (Fine)",
                position: "lsb"
            },
            {
                number: 46,
                name: "controller46",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 47,
                name: "controller47",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 48,
                name: "controller48",
                description: "General Purpose Controller 1 (Fine)",
                position: "lsb"
            },
            {
                number: 49,
                name: "controller49",
                description: "General Purpose Controller 2 (Fine)",
                position: "lsb"
            },
            {
                number: 50,
                name: "controller50",
                description: "General Purpose Controller 3 (Fine)",
                position: "lsb"
            },
            {
                number: 51,
                name: "controller51",
                description: "General Purpose Controller 4 (Fine)",
                position: "lsb"
            },
            {
                number: 52,
                name: "controller52",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 53,
                name: "controller53",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 54,
                name: "controller54",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 55,
                name: "controller55",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 56,
                name: "controller56",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 57,
                name: "controller57",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 58,
                name: "controller58",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 59,
                name: "controller59",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 60,
                name: "controller60",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 61,
                name: "controller61",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 62,
                name: "controller62",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 63,
                name: "controller63",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 64,
                name: "damperpedal",
                description: "Damper Pedal On/Off"
            },
            {
                number: 65,
                name: "portamento",
                description: "Portamento On/Off"
            },
            {
                number: 66,
                name: "sostenuto",
                description: "Sostenuto On/Off"
            },
            {
                number: 67,
                name: "softpedal",
                description: "Soft Pedal On/Off"
            },
            {
                number: 68,
                name: "legatopedal",
                description: "Legato Pedal On/Off"
            },
            {
                number: 69,
                name: "hold2",
                description: "Hold 2 On/Off"
            },
            {
                number: 70,
                name: "soundvariation",
                description: "Sound Variation",
                position: "lsb"
            },
            {
                number: 71,
                name: "resonance",
                description: "Resonance",
                position: "lsb"
            },
            {
                number: 72,
                name: "releasetime",
                description: "Release Time",
                position: "lsb"
            },
            {
                number: 73,
                name: "attacktime",
                description: "Attack Time",
                position: "lsb"
            },
            {
                number: 74,
                name: "brightness",
                description: "Brightness",
                position: "lsb"
            },
            {
                number: 75,
                name: "decaytime",
                description: "Decay Time",
                position: "lsb"
            },
            {
                number: 76,
                name: "vibratorate",
                description: "Vibrato Rate",
                position: "lsb"
            },
            {
                number: 77,
                name: "vibratodepth",
                description: "Vibrato Depth",
                position: "lsb"
            },
            {
                number: 78,
                name: "vibratodelay",
                description: "Vibrato Delay",
                position: "lsb"
            },
            {
                number: 79,
                name: "controller79",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 80,
                name: "generalpurposecontroller5",
                description: "General Purpose Controller 5",
                position: "lsb"
            },
            {
                number: 81,
                name: "generalpurposecontroller6",
                description: "General Purpose Controller 6",
                position: "lsb"
            },
            {
                number: 82,
                name: "generalpurposecontroller7",
                description: "General Purpose Controller 7",
                position: "lsb"
            },
            {
                number: 83,
                name: "generalpurposecontroller8",
                description: "General Purpose Controller 8",
                position: "lsb"
            },
            {
                number: 84,
                name: "portamentocontrol",
                description: "Portamento Control",
                position: "lsb"
            },
            {
                number: 85,
                name: "controller85",
                description: "Undefined"
            },
            {
                number: 86,
                name: "controller86",
                description: "Undefined"
            },
            {
                number: 87,
                name: "controller87",
                description: "Undefined"
            },
            {
                number: 88,
                name: "highresolutionvelocityprefix",
                description: "High Resolution Velocity Prefix",
                position: "lsb"
            },
            {
                number: 89,
                name: "controller89",
                description: "Undefined"
            },
            {
                number: 90,
                name: "controller90",
                description: "Undefined"
            },
            {
                number: 91,
                name: "effect1depth",
                description: "Effects 1 Depth (Reverb Send Level)"
            },
            {
                number: 92,
                name: "effect2depth",
                description: "Effects 2 Depth"
            },
            {
                number: 93,
                name: "effect3depth",
                description: "Effects 3 Depth (Chorus Send Level)"
            },
            {
                number: 94,
                name: "effect4depth",
                description: "Effects 4 Depth"
            },
            {
                number: 95,
                name: "effect5depth",
                description: "Effects 5 Depth"
            },
            {
                number: 96,
                name: "dataincrement",
                description: "Data Increment"
            },
            {
                number: 97,
                name: "datadecrement",
                description: "Data Decrement"
            },
            {
                number: 98,
                name: "nonregisteredparameterfine",
                description: "Non-Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 99,
                name: "nonregisteredparametercoarse",
                description: "Non-Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 100,
                name: "registeredparameterfine",
                description: "Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 101,
                name: "registeredparametercoarse",
                description: "Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 102,
                name: "controller102",
                description: "Undefined"
            },
            {
                number: 103,
                name: "controller103",
                description: "Undefined"
            },
            {
                number: 104,
                name: "controller104",
                description: "Undefined"
            },
            {
                number: 105,
                name: "controller105",
                description: "Undefined"
            },
            {
                number: 106,
                name: "controller106",
                description: "Undefined"
            },
            {
                number: 107,
                name: "controller107",
                description: "Undefined"
            },
            {
                number: 108,
                name: "controller108",
                description: "Undefined"
            },
            {
                number: 109,
                name: "controller109",
                description: "Undefined"
            },
            {
                number: 110,
                name: "controller110",
                description: "Undefined"
            },
            {
                number: 111,
                name: "controller111",
                description: "Undefined"
            },
            {
                number: 112,
                name: "controller112",
                description: "Undefined"
            },
            {
                number: 113,
                name: "controller113",
                description: "Undefined"
            },
            {
                number: 114,
                name: "controller114",
                description: "Undefined"
            },
            {
                number: 115,
                name: "controller115",
                description: "Undefined"
            },
            {
                number: 116,
                name: "controller116",
                description: "Undefined"
            },
            {
                number: 117,
                name: "controller117",
                description: "Undefined"
            },
            {
                number: 118,
                name: "controller118",
                description: "Undefined"
            },
            {
                number: 119,
                name: "controller119",
                description: "Undefined"
            },
            {
                number: 120,
                name: "allsoundoff",
                description: "All Sound Off"
            },
            {
                number: 121,
                name: "resetallcontrollers",
                description: "Reset All Controllers"
            },
            {
                number: 122,
                name: "localcontrol",
                description: "Local Control On/Off"
            },
            {
                number: 123,
                name: "allnotesoff",
                description: "All Notes Off"
            },
            {
                number: 124,
                name: "omnimodeoff",
                description: "Omni Mode Off"
            },
            {
                number: 125,
                name: "omnimodeon",
                description: "Omni Mode On"
            },
            {
                number: 126,
                name: "monomodeon",
                description: "Mono Mode On"
            },
            {
                number: 127,
                name: "polymodeon",
                description: "Poly Mode On"
            }
        ];
    }
    static get REGISTERED_PARAMETERS() {
        return {
            pitchbendrange: [
                0,
                0
            ],
            channelfinetuning: [
                0,
                1
            ],
            channelcoarsetuning: [
                0,
                2
            ],
            tuningprogram: [
                0,
                3
            ],
            tuningbank: [
                0,
                4
            ],
            modulationrange: [
                0,
                5
            ],
            azimuthangle: [
                61,
                0
            ],
            elevationangle: [
                61,
                1
            ],
            gain: [
                61,
                2
            ],
            distanceratio: [
                61,
                3
            ],
            maximumdistance: [
                61,
                4
            ],
            maximumdistancegain: [
                61,
                5
            ],
            referencedistanceratio: [
                61,
                6
            ],
            panspreadangle: [
                61,
                7
            ],
            rollangle: [
                61,
                8
            ]
        };
    }
    static get MIDI_REGISTERED_PARAMETERS() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETERS enum has been deprecated. Use the Enumerations.REGISTERED_PARAMETERS enum instead."), Enumerations.MIDI_REGISTERED_PARAMETERS;
    }
    static get SYSTEM_MESSAGES() {
        return {
            sysex: 240,
            timecode: 241,
            songposition: 242,
            songselect: 243,
            tunerequest: 246,
            tuningrequest: 246,
            sysexend: 247,
            clock: 248,
            start: 250,
            continue: 251,
            stop: 252,
            activesensing: 254,
            reset: 255,
            midimessage: 0,
            unknownsystemmessage: -1
        };
    }
    static get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been deprecated. Use the Enumerations.SYSTEM_MESSAGES enum instead."), Enumerations.SYSTEM_MESSAGES;
    }
    static get CHANNEL_EVENTS() {
        return [
            "noteoff",
            "controlchange",
            "noteon",
            "keyaftertouch",
            "programchange",
            "channelaftertouch",
            "pitchbend",
            "allnotesoff",
            "allsoundoff",
            "localcontrol",
            "monomode",
            "omnimode",
            "resetallcontrollers",
            "nrpn",
            "nrpn-dataentrycoarse",
            "nrpn-dataentryfine",
            "nrpn-dataincrement",
            "nrpn-datadecrement",
            "rpn",
            "rpn-dataentrycoarse",
            "rpn-dataentryfine",
            "rpn-dataincrement",
            "rpn-datadecrement",
            "nrpn-databuttonincrement",
            "nrpn-databuttondecrement",
            "rpn-databuttonincrement",
            "rpn-databuttondecrement"
        ];
    }
}
/**
 * The `Note` class represents a single musical note such as `"D3"`, `"G#4"`, `"F-1"`, `"Gb7"`, etc.
 *
 * `Note` objects can be played back on a single channel by calling
 * [`OutputChannel.playNote()`]{@link OutputChannel#playNote} or, on multiple channels of the same
 * output, by calling [`Output.playNote()`]{@link Output#playNote}.
 *
 * The note has [`attack`](#attack) and [`release`](#release) velocities set at `0.5` by default.
 * These can be changed by passing in the appropriate option. It is also possible to set a
 * system-wide default for attack and release velocities by using the
 * [`WebMidi.defaults`](WebMidi#defaults) property.
 *
 * If you prefer to work with raw MIDI values (`0` to `127`), you can use [`rawAttack`](#rawAttack) and
 * [`rawRelease`](#rawRelease) to both get and set the values.
 *
 * The note may have a [`duration`](#duration). If it does, playback will be automatically stopped
 * when the duration has elapsed by sending a `"noteoff"` event. By default, the duration is set to
 * `Infinity`. In this case, it will never stop playing unless explicitly stopped by calling a
 * method such as [`OutputChannel.stopNote()`]{@link OutputChannel#stopNote},
 * [`Output.stopNote()`]{@link Output#stopNote} or similar.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Note {
    constructor(e, t = {}){
        this.duration = wm.defaults.note.duration, this.attack = wm.defaults.note.attack, this.release = wm.defaults.note.release, null != t.duration && (this.duration = t.duration), null != t.attack && (this.attack = t.attack), null != t.rawAttack && (this.attack = Utilities.from7bitToFloat(t.rawAttack)), null != t.release && (this.release = t.release), null != t.rawRelease && (this.release = Utilities.from7bitToFloat(t.rawRelease)), Number.isInteger(e) ? this.identifier = Utilities.toNoteIdentifier(e) : this.identifier = e;
    }
    get identifier() {
        return this._name + (this._accidental || "") + this._octave;
    }
    set identifier(e) {
        const t = Utilities.getNoteDetails(e);
        if (wm.validation && !e) throw new Error("Invalid note identifier");
        this._name = t.name, this._accidental = t.accidental, this._octave = t.octave;
    }
    get name() {
        return this._name;
    }
    set name(e) {
        if (wm.validation && (e = e.toUpperCase(), ![
            "C",
            "D",
            "E",
            "F",
            "G",
            "A",
            "B"
        ].includes(e))) throw new Error("Invalid name value");
        this._name = e;
    }
    get accidental() {
        return this._accidental;
    }
    set accidental(e) {
        if (wm.validation && (e = e.toLowerCase(), ![
            "#",
            "##",
            "b",
            "bb"
        ].includes(e))) throw new Error("Invalid accidental value");
        this._accidental = e;
    }
    get octave() {
        return this._octave;
    }
    set octave(e) {
        if (wm.validation && (e = parseInt(e), isNaN(e))) throw new Error("Invalid octave value");
        this._octave = e;
    }
    get duration() {
        return this._duration;
    }
    set duration(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || null === e || e < 0)) throw new RangeError("Invalid duration value.");
        this._duration = e;
    }
    get attack() {
        return this._attack;
    }
    set attack(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid attack value.");
        this._attack = e;
    }
    get release() {
        return this._release;
    }
    set release(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid release value.");
        this._release = e;
    }
    get rawAttack() {
        return Utilities.fromFloatTo7Bit(this._attack);
    }
    set rawAttack(e) {
        this._attack = Utilities.from7bitToFloat(e);
    }
    get rawRelease() {
        return Utilities.fromFloatTo7Bit(this._release);
    }
    set rawRelease(e) {
        this._release = Utilities.from7bitToFloat(e);
    }
    get number() {
        return Utilities.toNoteNumber(this.identifier);
    }
    getOffsetNumber(e = 0, t = 0) {
        return wm.validation && (e = parseInt(e) || 0, t = parseInt(t) || 0), Math.min(Math.max(this.number + 12 * e + t, 0), 127);
    }
}
/**
 * The `Utilities` class contains general-purpose utility methods. All methods are static and
 * should be called using the class name. For example: `Utilities.getNoteDetails("C4")`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Utilities {
    /**
   * Returns a MIDI note number matching the identifier passed in the form of a string. The
   * identifier must include the octave number. The identifier also optionally include a sharp (#),
   * a double sharp (##), a flat (b) or a double flat (bb) symbol. For example, these are all valid
   * identifiers: C5, G4, D#-1, F0, Gb7, Eb-1, Abb4, B##6, etc.
   *
   * When converting note identifiers to numbers, C4 is considered to be middle C (MIDI note number
   * 60) as per the scientific pitch notation standard.
   *
   * The resulting note number can be offset by using the `octaveOffset` parameter.
   *
   * @param identifier {string} The identifier in the form of a letter, followed by an optional "#",
   * "##", "b" or "bb" followed by the octave number. For exemple: C5, G4, D#-1, F0, Gb7, Eb-1,
   * Abb4, B##6, etc.
   *
   * @param {number} [octaveOffset=0] A integer to offset the octave by.
   *
   * @returns {number} The MIDI note number (an integer between 0 and 127).
   *
   * @throws RangeError Invalid 'octaveOffset' value
   *
   * @throws TypeError Invalid note identifier
   *
   * @license Apache-2.0
   * @since 3.0.0
   * @static
   */ static toNoteNumber(e, t = 0) {
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid 'octaveOffset' value");
        "string" != typeof e && (e = "");
        const n = this.getNoteDetails(e);
        if (!n) throw new TypeError("Invalid note identifier");
        let r = 12 * (n.octave + 1 + t);
        if (r += ({
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        })[n.name], n.accidental && (n.accidental.startsWith("b") ? r -= n.accidental.length : r += n.accidental.length), r < 0 || r > 127) throw new RangeError("Invalid octaveOffset value");
        return r;
    }
    static getNoteDetails(e) {
        Number.isInteger(e) && (e = this.toNoteIdentifier(e));
        const t = e.match(/^([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)$/i);
        if (!t) throw new TypeError("Invalid note identifier");
        const n = t[1].toUpperCase(), r = parseInt(t[3]);
        let i = t[2].toLowerCase();
        i = "" === i ? void 0 : i;
        return {
            accidental: i,
            identifier: n + (i || "") + r,
            name: n,
            octave: r
        };
    }
    static sanitizeChannels(e) {
        let t;
        if (wm.validation) {
            if ("all" === e) t = [
                "all"
            ];
            else if ("none" === e) return [];
        }
        return t = Array.isArray(e) ? e : [
            e
        ], t.indexOf("all") > -1 && (t = Enumerations.MIDI_CHANNEL_NUMBERS), t.map(function(e) {
            return parseInt(e);
        }).filter(function(e) {
            return e >= 1 && e <= 16;
        });
    }
    static toTimestamp(e) {
        let t = !1;
        const n = parseFloat(e);
        return !isNaN(n) && ("string" == typeof e && "+" === e.substring(0, 1) ? n >= 0 && (t = wm.time + n) : n >= 0 && (t = n), t);
    }
    static guessNoteNumber(e, t) {
        t = parseInt(t) || 0;
        let n = !1;
        if (Number.isInteger(e) && e >= 0 && e <= 127) n = parseInt(e);
        else if (parseInt(e) >= 0 && parseInt(e) <= 127) n = parseInt(e);
        else if ("string" == typeof e || e instanceof String) try {
            n = this.toNoteNumber(e.trim(), t);
        } catch (e) {
            return !1;
        }
        return n;
    }
    static toNoteIdentifier(e, t) {
        if (e = parseInt(e), isNaN(e) || e < 0 || e > 127) throw new RangeError("Invalid note number");
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid octaveOffset value");
        const n = Math.floor(e / 12 - 1) + t;
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ][e % 12] + n.toString();
    }
    static buildNote(e, t = {}) {
        if (t.octaveOffset = parseInt(t.octaveOffset) || 0, e instanceof Note) return e;
        let n = this.guessNoteNumber(e, t.octaveOffset);
        if (!1 === n) throw new TypeError(`The input could not be parsed as a note (${e})`);
        return t.octaveOffset = void 0, new Note(n, t);
    }
    static buildNoteArray(e, t = {}) {
        let n = [];
        return Array.isArray(e) || (e = [
            e
        ]), e.forEach((e)=>{
            n.push(this.buildNote(e, t));
        }), n;
    }
    static from7bitToFloat(e) {
        return e === 1 / 0 && (e = 127), e = parseInt(e) || 0, Math.min(Math.max(e / 127, 0), 1);
    }
    static fromFloatTo7Bit(e) {
        return e === 1 / 0 && (e = 1), e = parseFloat(e) || 0, Math.min(Math.max(Math.round(127 * e), 0), 127);
    }
    static fromMsbLsbToFloat(e, t = 0) {
        wm.validation && (e = Math.min(Math.max(parseInt(e) || 0, 0), 127), t = Math.min(Math.max(parseInt(t) || 0, 0), 127));
        const n = ((e << 7) + t) / 16383;
        return Math.min(Math.max(n, 0), 1);
    }
    static fromFloatToMsbLsb(e) {
        wm.validation && (e = Math.min(Math.max(parseFloat(e) || 0, 0), 1));
        const t = Math.round(16383 * e);
        return {
            msb: t >> 7,
            lsb: 127 & t
        };
    }
    static offsetNumber(e, t = 0, n = 0) {
        if (wm.validation) {
            if (e = parseInt(e), isNaN(e)) throw new Error("Invalid note number");
            t = parseInt(t) || 0, n = parseInt(n) || 0;
        }
        return Math.min(Math.max(e + 12 * t + n, 0), 127);
    }
    static getPropertyByValue(e, t) {
        return Object.keys(e).find((n)=>e[n] === t);
    }
    static getCcNameByNumber(e) {
        if (!wm.validation || (e = parseInt(e)) >= 0 && e <= 127) return Enumerations.CONTROL_CHANGE_MESSAGES[e].name;
    }
    static getCcNumberByName(e) {
        let t = Enumerations.CONTROL_CHANGE_MESSAGES.find((t)=>t.name === e);
        return t ? t.number : Enumerations.MIDI_CONTROL_CHANGE_MESSAGES[e];
    }
    static getChannelModeByNumber(e) {
        if (!(e >= 120 && e <= 127)) return !1;
        for(let t in Enumerations.CHANNEL_MODE_MESSAGES)if (Enumerations.CHANNEL_MODE_MESSAGES.hasOwnProperty(t) && e === Enumerations.CHANNEL_MODE_MESSAGES[t]) return t;
        return !1;
    }
    static get isNode() {
        return false;
    }
    static get isBrowser() {
        return "undefined" != typeof window && void 0 !== window.document;
    }
}
/**
 * The `OutputChannel` class represents a single output MIDI channel. `OutputChannel` objects are
 * provided by an [`Output`](Output) port which, itself, is made available by a device. The
 * `OutputChannel` object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `OutputChannel` objects can be found inside the parent output's
 * [`channels`]{@link Output#channels} property.
 *
 * @param {Output} output The [`Output`](Output) this channel belongs to.
 * @param {number} number The MIDI channel number (`1` - `16`).
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class OutputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._output = e, this._number = t, this._octaveOffset = 0;
    }
    destroy() {
        this._output = null, this._number = null, this._octaveOffset = 0, this.removeListener();
    }
    send(e, t = {
        time: 0
    }) {
        return this.output.send(e, t), this;
    }
    sendKeyAftertouch(e, t, n = {}) {
        if (wm.validation) {
            if (n.useRawValue && (n.rawValue = n.useRawValue), isNaN(parseFloat(t))) throw new RangeError("Invalid key aftertouch value.");
            if (n.rawValue) {
                if (!(t >= 0 && t <= 127 && Number.isInteger(t))) throw new RangeError("Key aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(t >= 0 && t <= 1)) throw new RangeError("Key aftertouch value must be a float between 0 and 1.");
        }
        n.rawValue || (t = Utilities.fromFloatTo7Bit(t));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Array.isArray(e) || (e = [
            e
        ]), Utilities.buildNoteArray(e).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.keyaftertouch << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                t
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    /**
   * Sends a MIDI **control change** message to the channel at the scheduled time. The control
   * change message to send can be specified numerically (`0` to `127`) or by using one of the
   * following common names:
   *
   * | Number | Name                          |
   * |--------|-------------------------------|
   * | 0      |`bankselectcoarse`             |
   * | 1      |`modulationwheelcoarse`        |
   * | 2      |`breathcontrollercoarse`       |
   * | 4      |`footcontrollercoarse`         |
   * | 5      |`portamentotimecoarse`         |
   * | 6      |`dataentrycoarse`              |
   * | 7      |`volumecoarse`                 |
   * | 8      |`balancecoarse`                |
   * | 10     |`pancoarse`                    |
   * | 11     |`expressioncoarse`             |
   * | 12     |`effectcontrol1coarse`         |
   * | 13     |`effectcontrol2coarse`         |
   * | 18     |`generalpurposeslider3`        |
   * | 19     |`generalpurposeslider4`        |
   * | 32     |`bankselectfine`               |
   * | 33     |`modulationwheelfine`          |
   * | 34     |`breathcontrollerfine`         |
   * | 36     |`footcontrollerfine`           |
   * | 37     |`portamentotimefine`           |
   * | 38     |`dataentryfine`                |
   * | 39     |`volumefine`                   |
   * | 40     |`balancefine`                  |
   * | 42     |`panfine`                      |
   * | 43     |`expressionfine`               |
   * | 44     |`effectcontrol1fine`           |
   * | 45     |`effectcontrol2fine`           |
   * | 64     |`holdpedal`                    |
   * | 65     |`portamento`                   |
   * | 66     |`sustenutopedal`               |
   * | 67     |`softpedal`                    |
   * | 68     |`legatopedal`                  |
   * | 69     |`hold2pedal`                   |
   * | 70     |`soundvariation`               |
   * | 71     |`resonance`                    |
   * | 72     |`soundreleasetime`             |
   * | 73     |`soundattacktime`              |
   * | 74     |`brightness`                   |
   * | 75     |`soundcontrol6`                |
   * | 76     |`soundcontrol7`                |
   * | 77     |`soundcontrol8`                |
   * | 78     |`soundcontrol9`                |
   * | 79     |`soundcontrol10`               |
   * | 80     |`generalpurposebutton1`        |
   * | 81     |`generalpurposebutton2`        |
   * | 82     |`generalpurposebutton3`        |
   * | 83     |`generalpurposebutton4`        |
   * | 91     |`reverblevel`                  |
   * | 92     |`tremololevel`                 |
   * | 93     |`choruslevel`                  |
   * | 94     |`celestelevel`                 |
   * | 95     |`phaserlevel`                  |
   * | 96     |`dataincrement`                |
   * | 97     |`datadecrement`                |
   * | 98     |`nonregisteredparametercoarse` |
   * | 99     |`nonregisteredparameterfine`   |
   * | 100    |`registeredparametercoarse`    |
   * | 101    |`registeredparameterfine`      |
   * | 120    |`allsoundoff`                  |
   * | 121    |`resetallcontrollers`          |
   * | 122    |`localcontrol`                 |
   * | 123    |`allnotesoff`                  |
   * | 124    |`omnimodeoff`                  |
   * | 125    |`omnimodeon`                   |
   * | 126    |`monomodeon`                   |
   * | 127    |`polymodeon`                   |
   *
   * As you can see above, not all control change message have a matching name. This does not mean
   * you cannot use the others. It simply means you will need to use their number
   * (`0` to `127`) instead of their name. While you can still use them, numbers `120` to `127` are
   * usually reserved for *channel mode* messages. See
   * [`sendChannelMode()`]{@link OutputChannel#sendChannelMode} method for more info.
   *
   * To view a detailed list of all available **control change** messages, please consult "Table 3 -
   * Control Change Messages" from the [MIDI Messages](
   * https://www.midi.org/specifications/item/table-3-control-change-messages-data-bytes-2)
   * specification.
   *
   * **Note**: messages #0-31 (MSB) are paired with messages #32-63 (LSB). For example, message #1
   * (`modulationwheelcoarse`) can be accompanied by a second control change message for
   * `modulationwheelfine` to achieve a greater level of precision. if you want to specify both MSB
   * and LSB for messages between `0` and `31`, you can do so by passing a 2-value array as the
   * second parameter.
   *
   * @param {number|string} controller The MIDI controller name or number (`0` - `127`).
   *
   * @param {number|number[]} value The value to send (0-127). You can also use a two-position array
   * for controllers 0 to 31. In this scenario, the first value will be sent as usual and the second
   * value will be sent to the matching LSB controller (which is obtained by adding 32 to the first
   * controller)
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} Controller numbers must be between 0 and 127.
   * @throws {RangeError} Invalid controller name.
   * @throws {TypeError} The value array must have a length of 2.
   *
   * @returns {OutputChannel} Returns the `OutputChannel` object so methods can be chained.
   *
   * @license Apache-2.0
   * @since 3.0.0
   */ sendControlChange(e, t, n = {}) {
        if ("string" == typeof e && (e = Utilities.getCcNumberByName(e)), Array.isArray(t) || (t = [
            t
        ]), wm.validation) {
            if (void 0 === e) throw new TypeError("Control change must be identified with a valid name or an integer between 0 and 127.");
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new TypeError("Control change number must be an integer between 0 and 127.");
            if (2 === (t = t.map((e)=>{
                const t = Math.min(Math.max(parseInt(e), 0), 127);
                if (isNaN(t)) throw new TypeError("Values must be integers between 0 and 127");
                return t;
            })).length && e >= 32) throw new TypeError("To use a value array, the controller must be between 0 and 31");
        }
        return t.forEach((r, i)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
                e + 32 * i,
                t[i]
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    _selectNonRegisteredParameter(e, t = {}) {
        return this.sendControlChange(99, e[0], t), this.sendControlChange(98, e[1], t), this;
    }
    _deselectRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _deselectNonRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _selectRegisteredParameter(e, t = {}) {
        return this.sendControlChange(101, e[0], t), this.sendControlChange(100, e[1], t), this;
    }
    _setCurrentParameter(e, t = {}) {
        return e = [].concat(e), this.sendControlChange(6, e[0], t), e.length < 2 || this.sendControlChange(38, e[1], t), this;
    }
    sendRpnDecrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(97, 0, t), this._deselectRegisteredParameter(t), this;
    }
    sendRpnIncrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(96, 0, t), this._deselectRegisteredParameter(t), this;
    }
    playNote(e, t = {}) {
        this.sendNoteOn(e, t);
        const n = Array.isArray(e) ? e : [
            e
        ];
        for (let e of n)if (parseInt(e.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(e.duration),
                release: e.release,
                rawRelease: e.rawRelease
            };
            this.sendNoteOff(e, n);
        } else if (parseInt(t.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(t.duration),
                release: t.release,
                rawRelease: t.rawRelease
            };
            this.sendNoteOff(e, n);
        }
        return this;
    }
    sendNoteOff(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawRelease && !(t.rawRelease >= 0 && t.rawRelease <= 127)) throw new RangeError("The 'rawRelease' option must be an integer between 0 and 127");
            if (null != t.release && !(t.release >= 0 && t.release <= 1)) throw new RangeError("The 'release' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawRelease = t.velocity, console.warn("The 'rawVelocity' option is deprecated. Use 'rawRelease' instead.")), t.velocity && (t.release = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawRelease ? n = t.rawRelease : isNaN(t.release) || (n = Math.round(127 * t.release));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawRelease: parseInt(n)
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteoff << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawRelease
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    stopNote(e, t = {}) {
        return this.sendNoteOff(e, t);
    }
    sendNoteOn(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawAttack && !(t.rawAttack >= 0 && t.rawAttack <= 127)) throw new RangeError("The 'rawAttack' option must be an integer between 0 and 127");
            if (null != t.attack && !(t.attack >= 0 && t.attack <= 1)) throw new RangeError("The 'attack' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawAttack = t.velocity, t.rawRelease = t.release, console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' or 'rawRelease'.")), t.velocity && (t.attack = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawAttack ? n = t.rawAttack : isNaN(t.attack) || (n = Math.round(127 * t.attack));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawAttack: n
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteon << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawAttack
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    sendChannelMode(e, t = 0, n = {}) {
        if ("string" == typeof e && (e = Enumerations.CHANNEL_MODE_MESSAGES[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("Invalid channel mode message name or number.");
            if (isNaN(e) || !(e >= 120 && e <= 127)) throw new TypeError("Invalid channel mode message number.");
            if (isNaN(parseInt(t)) || t < 0 || t > 127) throw new RangeError("Value must be an integer between 0 and 127.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
            e,
            t
        ], {
            time: Utilities.toTimestamp(n.time)
        }), this;
    }
    sendOmniMode(e, t = {}) {
        return void 0 === e || e ? this.sendChannelMode("omnimodeon", 0, t) : this.sendChannelMode("omnimodeoff", 0, t), this;
    }
    sendChannelAftertouch(e, t = {}) {
        if (wm.validation) {
            if (isNaN(parseFloat(e))) throw new RangeError("Invalid channel aftertouch value.");
            if (t.rawValue) {
                if (!(e >= 0 && e <= 127 && Number.isInteger(e))) throw new RangeError("Channel aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(e >= 0 && e <= 1)) throw new RangeError("Channel aftertouch value must be a float between 0 and 1.");
        }
        return t.rawValue || (e = Utilities.fromFloatTo7Bit(e)), this.send([
            (Enumerations.CHANNEL_MESSAGES.channelaftertouch << 4) + (this.number - 1),
            Math.round(e)
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendMasterTuning(e, t = {}) {
        if (e = parseFloat(e) || 0, wm.validation && !(e > -65 && e < 64)) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        let n = Math.floor(e) + 64, r = e - Math.floor(e);
        r = Math.round((r + 1) / 2 * 16383);
        let i = r >> 7 & 127, s = 127 & r;
        return this.sendRpnValue("channelcoarsetuning", n, t), this.sendRpnValue("channelfinetuning", [
            i,
            s
        ], t), this;
    }
    sendModulationRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!(null == t || Number.isInteger(t) && t >= 0 && t <= 127)) throw new RangeError("If specified, the cents value must be an integer between 0 and 127.");
        }
        return t >= 0 && t <= 127 || (t = 0), this.sendRpnValue("modulationrange", [
            e,
            t
        ], n), this;
    }
    sendNrpnValue(e, t, n = {}) {
        if (t = [].concat(t), wm.validation) {
            if (!Array.isArray(e) || !Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the NRPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the NRPN must be between 0 and 127.");
            t.forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the NRPN must be between 0 and 127.");
            });
        }
        return this._selectNonRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectNonRegisteredParameter(n), this;
    }
    sendPitchBend(e, t = {}) {
        if (wm.validation) {
            if (t.rawValue && Array.isArray(e)) {
                if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
                if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The pitch bend LSB must be an integer between 0 and 127.");
            } else if (t.rawValue && !Array.isArray(e)) {
                if (!(e >= 0 && e <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
            } else {
                if (isNaN(e) || null === e) throw new RangeError("Invalid pitch bend value.");
                if (!(e >= -1 && e <= 1)) throw new RangeError("The pitch bend value must be a float between -1 and 1.");
            }
        }
        let n = 0, r = 0;
        if (t.rawValue && Array.isArray(e)) n = e[0], r = e[1];
        else if (t.rawValue && !Array.isArray(e)) n = e;
        else {
            const t = Utilities.fromFloatToMsbLsb((e + 1) / 2);
            n = t.msb, r = t.lsb;
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.pitchbend << 4) + (this.number - 1),
            r,
            n
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendPitchBendRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!Number.isInteger(t) || !(t >= 0 && t <= 127)) throw new RangeError("The cents value must be an integer between 0 and 127.");
        }
        return this.sendRpnValue("pitchbendrange", [
            e,
            t
        ], n), this;
    }
    sendProgramChange(e, t = {}) {
        if (e = parseInt(e) || 0, wm.validation && !(e >= 0 && e <= 127)) throw new RangeError("The program number must be between 0 and 127.");
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.programchange << 4) + (this.number - 1),
            e
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendRpnValue(e, t, n = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (!Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the RPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the RPN must be between 0 and 127.");
            [].concat(t).forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the RPN must be between 0 and 127.");
            });
        }
        return this._selectRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectRegisteredParameter(n), this;
    }
    sendTuningBank(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning bank number must be between 0 and 127.");
        return this.sendRpnValue("tuningbank", e, t), this;
    }
    sendTuningProgram(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning program number must be between 0 and 127.");
        return this.sendRpnValue("tuningprogram", e, t), this;
    }
    sendLocalControl(e, t = {}) {
        return e ? this.sendChannelMode("localcontrol", 127, t) : this.sendChannelMode("localcontrol", 0, t);
    }
    sendAllNotesOff(e = {}) {
        return this.sendChannelMode("allnotesoff", 0, e);
    }
    sendAllSoundOff(e = {}) {
        return this.sendChannelMode("allsoundoff", 0, e);
    }
    sendResetAllControllers(e = {}) {
        return this.sendChannelMode("resetallcontrollers", 0, e);
    }
    sendPolyphonicMode(e, t = {}) {
        return "mono" === e ? this.sendChannelMode("monomodeon", 0, t) : this.sendChannelMode("polymodeon", 0, t);
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get output() {
        return this._output;
    }
    get number() {
        return this._number;
    }
}
/**
 * The `Output` class represents a single MIDI output port (not to be confused with a MIDI channel).
 * A port is made available by a MIDI device. A MIDI device can advertise several input and output
 * ports. Each port has 16 MIDI channels which can be accessed via the [`channels`](#channels)
 * property.
 *
 * The `Output` object is automatically instantiated by the library according to the host's MIDI
 * subsystem and should not be directly instantiated.
 *
 * You can access all available `Output` objects by referring to the
 * [`WebMidi.outputs`](WebMidi#outputs) array or by using methods such as
 * [`WebMidi.getOutputByName()`](WebMidi#getOutputByName) or
 * [`WebMidi.getOutputById()`](WebMidi#getOutputById).
 *
 * @fires Output#opened
 * @fires Output#disconnected
 * @fires Output#closed
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Output extends EventEmitter {
    constructor(e){
        super(), this._midiOutput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new OutputChannel(this, e);
        this._midiOutput.onstatechange = this._onStateChange.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._midiOutput && (this._midiOutput.onstatechange = null), await this.close(), this._midiOutput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time
        };
        "open" === e.port.connection ? (t.type = "opened", t.target = this, t.port = t.target, this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", t.target = this, t.port = t.target, this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught:", e.port.connection, e.port.state);
    }
    async open() {
        try {
            return await this._midiOutput.open(), Promise.resolve(this);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    async close() {
        this._midiOutput ? await this._midiOutput.close() : await Promise.resolve();
    }
    /**
   * Sends a MIDI message on the MIDI output port. If no time is specified, the message will be
   * sent immediately. The message should be an array of 8 bit unsigned integers (0-225), a
   * [`Uint8Array`]{@link https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array}
   * object or a [`Message`](Message) object.
   *
   * It is usually not necessary to use this method directly as you can use one of the simpler
   * helper methods such as [`playNote()`](#playNote), [`stopNote()`](#stopNote),
   * [`sendControlChange()`](#sendControlChange), etc.
   *
   * Details on the format of MIDI messages are available in the summary of
   * [MIDI messages]{@link https://www.midi.org/specifications-old/item/table-1-summary-of-midi-message}
   * from the MIDI Manufacturers Association.
   *
   * @param message {number[]|Uint8Array|Message} An array of 8bit unsigned integers, a `Uint8Array`
   * object (not available in Node.js) containing the message bytes or a `Message` object.
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} The first byte (status) must be an integer between 128 and 255.
   *
   * @returns {Output} Returns the `Output` object so methods can be chained.
   *
   * @license Apache-2.0
   */ send(e, t = {
        time: 0
    }, n = 0) {
        if (e instanceof Message && (e = Utilities.isNode ? e.data : e.rawData), e instanceof Uint8Array && Utilities.isNode && (e = Array.from(e)), wm.validation) {
            if (Array.isArray(e) || e instanceof Uint8Array || (e = [
                e
            ], Array.isArray(t) && (e = e.concat(t)), t = isNaN(n) ? {
                time: 0
            } : {
                time: n
            }), !(parseInt(e[0]) >= 128 && parseInt(e[0]) <= 255)) throw new RangeError("The first byte (status) must be an integer between 128 and 255.");
            e.slice(1).forEach((e)=>{
                if (!((e = parseInt(e)) >= 0 && e <= 255)) throw new RangeError("Data bytes must be integers between 0 and 255.");
            }), t || (t = {
                time: 0
            });
        }
        return this._midiOutput.send(e, Utilities.toTimestamp(t.time)), this;
    }
    sendSysex(e, t = [], n = {}) {
        if (e = [].concat(e), t instanceof Uint8Array) {
            const r = new Uint8Array(1 + e.length + t.length + 1);
            r[0] = Enumerations.SYSTEM_MESSAGES.sysex, r.set(Uint8Array.from(e), 1), r.set(t, 1 + e.length), r[r.length - 1] = Enumerations.SYSTEM_MESSAGES.sysexend, this.send(r, {
                time: n.time
            });
        } else {
            const r = e.concat(t, Enumerations.SYSTEM_MESSAGES.sysexend);
            this.send([
                Enumerations.SYSTEM_MESSAGES.sysex
            ].concat(r), {
                time: n.time
            });
        }
        return this;
    }
    clear() {
        return this._midiOutput.clear ? this._midiOutput.clear() : wm.validation && console.warn("The 'clear()' method has not yet been implemented in your environment."), this;
    }
    sendTimecodeQuarterFrame(e, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The value must be an integer between 0 and 127.");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.timecode,
            e
        ], {
            time: t.time
        }), this;
    }
    sendSongPosition(e = 0, t = {}) {
        var n = (e = Math.floor(e) || 0) >> 7 & 127, r = 127 & e;
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songposition,
            n,
            r
        ], {
            time: t.time
        }), this;
    }
    sendSongSelect(e = 0, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The program value must be between 0 and 127");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songselect,
            e
        ], {
            time: t.time
        }), this;
    }
    sendTuneRequest(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.tunerequest
        ], {
            time: e.time
        }), this;
    }
    sendClock(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.clock
        ], {
            time: e.time
        }), this;
    }
    sendStart(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.start
        ], {
            time: e.time
        }), this;
    }
    sendContinue(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.continue
        ], {
            time: e.time
        }), this;
    }
    sendStop(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.stop
        ], {
            time: e.time
        }), this;
    }
    sendActiveSensing(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.activesensing
        ], {
            time: e.time
        }), this;
    }
    sendReset(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.reset
        ], {
            time: e.time
        }), this;
    }
    sendTuningRequest(e = {}) {
        return wm.validation && console.warn("The sendTuningRequest() method has been deprecated. Use sendTuningRequest() instead."), this.sendTuneRequest(e);
    }
    sendKeyAftertouch(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendKeyAftertouch(e, t, n);
        }), this;
    }
    sendControlChange(e, t, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendControlChange(e, t, n);
        }), this;
    }
    sendPitchBendRange(e = 0, t = 0, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendPitchBendRange(e, t, n);
        }), this;
    }
    setPitchBendRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setPitchBendRange() method is deprecated. Use sendPitchBendRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendPitchBendRange(e, t, r);
    }
    sendRpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendRpnValue(e, t, n);
        }), this;
    }
    setRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setRegisteredParameter() method is deprecated. Use sendRpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnValue(e, t, r);
    }
    sendChannelAftertouch(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendChannelAftertouch(e, t);
        }), this;
    }
    sendPitchBend(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPitchBend(e, t);
        }), this;
    }
    sendProgramChange(e = 0, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendProgramChange(e, t);
        }), this;
    }
    sendModulationRange(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendModulationRange(e, t, n);
        }), this;
    }
    setModulationRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setModulationRange() method is deprecated. Use sendModulationRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendModulationRange(e, t, r);
    }
    sendMasterTuning(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendMasterTuning(e, t);
        }), this;
    }
    setMasterTuning(e, t = {}, n = {}) {
        return wm.validation && (console.warn("The setMasterTuning() method is deprecated. Use sendMasterTuning() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendMasterTuning(e, n);
    }
    sendTuningProgram(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningProgram(e, t);
        }), this;
    }
    setTuningProgram(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningProgram() method is deprecated. Use sendTuningProgram() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningProgram(e, n);
    }
    sendTuningBank(e = 0, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningBank(e, t);
        }), this;
    }
    setTuningBank(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningBank() method is deprecated. Use sendTuningBank() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningBank(e, n);
    }
    sendChannelMode(e, t = 0, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendChannelMode(e, t, n);
        }), this;
    }
    sendAllSoundOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllSoundOff(e);
        }), this;
    }
    sendAllNotesOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllNotesOff(e);
        }), this;
    }
    sendResetAllControllers(e = {}, t = {}) {
        if (wm.validation && (Array.isArray(e) || Number.isInteger(e) || "all" === e)) {
            const n = e;
            (e = t).channels = n, "all" === e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendResetAllControllers(e);
        }), this;
    }
    sendPolyphonicMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPolyphonicMode(e, t);
        }), this;
    }
    sendLocalControl(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendLocalControl(e, t);
        }), this;
    }
    sendOmniMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendOmniMode(e, t);
        }), this;
    }
    sendNrpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendNrpnValue(e, t, n);
        }), this;
    }
    setNonRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setNonRegisteredParameter() method is deprecated. Use sendNrpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendNrpnValue(e, t, r);
    }
    sendRpnIncrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnIncrement(e, t);
        }), this;
    }
    incrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The incrementRegisteredParameter() method is deprecated. Use sendRpnIncrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnIncrement(e, n);
    }
    sendRpnDecrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnDecrement(e, t);
        }), this;
    }
    decrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The decrementRegisteredParameter() method is deprecated. Use sendRpnDecrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnDecrement(e, n);
    }
    sendNoteOff(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOff(e, t);
        }), this;
    }
    stopNote(e, t) {
        return this.sendNoteOff(e, t);
    }
    playNote(e, t = {}, n = {}) {
        if (wm.validation && (t.rawVelocity && console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' instead."), t.velocity && console.warn("The 'velocity' option is deprecated. Use 'velocity' instead."), Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].playNote(e, t);
        }), this;
    }
    sendNoteOn(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOn(e, t);
        }), this;
    }
    get name() {
        return this._midiOutput.name;
    }
    get id() {
        return this._midiOutput.id;
    }
    get connection() {
        return this._midiOutput.connection;
    }
    get manufacturer() {
        return this._midiOutput.manufacturer;
    }
    get state() {
        return this._midiOutput.state;
    }
    get type() {
        return this._midiOutput.type;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
}
/**
 * The `Forwarder` class allows the forwarding of MIDI messages to predetermined outputs. When you
 * call its [`forward()`](#forward) method, it will send the specified [`Message`](Message) object
 * to all the outputs listed in its [`destinations`](#destinations) property.
 *
 * If specific channels or message types have been defined in the [`channels`](#channels) or
 * [`types`](#types) properties, only messages matching the channels/types will be forwarded.
 *
 * While it can be manually instantiated, you are more likely to come across a `Forwarder` object as
 * the return value of the [`Input.addForwarder()`](Input#addForwarder) method.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Forwarder {
    constructor(e = [], t = {}){
        this.destinations = [], this.types = [
            ...Object.keys(Enumerations.SYSTEM_MESSAGES),
            ...Object.keys(Enumerations.CHANNEL_MESSAGES)
        ], this.channels = Enumerations.MIDI_CHANNEL_NUMBERS, this.suspended = !1, Array.isArray(e) || (e = [
            e
        ]), t.types && !Array.isArray(t.types) && (t.types = [
            t.types
        ]), t.channels && !Array.isArray(t.channels) && (t.channels = [
            t.channels
        ]), wm.validation && (e.forEach((e)=>{
            if (!(e instanceof Output)) throw new TypeError("Destinations must be of type 'Output'.");
        }), void 0 !== t.types && t.types.forEach((e)=>{
            if (!Enumerations.SYSTEM_MESSAGES.hasOwnProperty(e) && !Enumerations.CHANNEL_MESSAGES.hasOwnProperty(e)) throw new TypeError("Type must be a valid message type.");
        }), void 0 !== t.channels && t.channels.forEach((e)=>{
            if (!Enumerations.MIDI_CHANNEL_NUMBERS.includes(e)) throw new TypeError("MIDI channel must be between 1 and 16.");
        })), this.destinations = e, t.types && (this.types = t.types), t.channels && (this.channels = t.channels);
    }
    forward(e) {
        this.suspended || this.types.includes(e.type) && (e.channel && !this.channels.includes(e.channel) || this.destinations.forEach((t)=>{
            (!wm.validation || t instanceof Output) && t.send(e);
        }));
    }
}
/**
 * The `InputChannel` class represents a single MIDI input channel (1-16) from a single input
 * device. This object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `InputChannel` objects can be found inside the input's [`channels`](Input#channels)
 * property.
 *
 * @fires InputChannel#midimessage
 * @fires InputChannel#unknownmessage
 *
 * @fires InputChannel#noteoff
 * @fires InputChannel#noteon
 * @fires InputChannel#keyaftertouch
 * @fires InputChannel#programchange
 * @fires InputChannel#channelaftertouch
 * @fires InputChannel#pitchbend
 *
 * @fires InputChannel#allnotesoff
 * @fires InputChannel#allsoundoff
 * @fires InputChannel#localcontrol
 * @fires InputChannel#monomode
 * @fires InputChannel#omnimode
 * @fires InputChannel#resetallcontrollers
 *
 * @fires InputChannel#event:nrpn
 * @fires InputChannel#event:nrpn-dataentrycoarse
 * @fires InputChannel#event:nrpn-dataentryfine
 * @fires InputChannel#event:nrpn-dataincrement
 * @fires InputChannel#event:nrpn-datadecrement
 * @fires InputChannel#event:rpn
 * @fires InputChannel#event:rpn-dataentrycoarse
 * @fires InputChannel#event:rpn-dataentryfine
 * @fires InputChannel#event:rpn-dataincrement
 * @fires InputChannel#event:rpn-datadecrement
 *
 * @fires InputChannel#controlchange
 * @fires InputChannel#event:controlchange-controllerxxx
 * @fires InputChannel#event:controlchange-bankselectcoarse
 * @fires InputChannel#event:controlchange-modulationwheelcoarse
 * @fires InputChannel#event:controlchange-breathcontrollercoarse
 * @fires InputChannel#event:controlchange-footcontrollercoarse
 * @fires InputChannel#event:controlchange-portamentotimecoarse
 * @fires InputChannel#event:controlchange-dataentrycoarse
 * @fires InputChannel#event:controlchange-volumecoarse
 * @fires InputChannel#event:controlchange-balancecoarse
 * @fires InputChannel#event:controlchange-pancoarse
 * @fires InputChannel#event:controlchange-expressioncoarse
 * @fires InputChannel#event:controlchange-effectcontrol1coarse
 * @fires InputChannel#event:controlchange-effectcontrol2coarse
 * @fires InputChannel#event:controlchange-generalpurposecontroller1
 * @fires InputChannel#event:controlchange-generalpurposecontroller2
 * @fires InputChannel#event:controlchange-generalpurposecontroller3
 * @fires InputChannel#event:controlchange-generalpurposecontroller4
 * @fires InputChannel#event:controlchange-bankselectfine
 * @fires InputChannel#event:controlchange-modulationwheelfine
 * @fires InputChannel#event:controlchange-breathcontrollerfine
 * @fires InputChannel#event:controlchange-footcontrollerfine
 * @fires InputChannel#event:controlchange-portamentotimefine
 * @fires InputChannel#event:controlchange-dataentryfine
 * @fires InputChannel#event:controlchange-channelvolumefine
 * @fires InputChannel#event:controlchange-balancefine
 * @fires InputChannel#event:controlchange-panfine
 * @fires InputChannel#event:controlchange-expressionfine
 * @fires InputChannel#event:controlchange-effectcontrol1fine
 * @fires InputChannel#event:controlchange-effectcontrol2fine
 * @fires InputChannel#event:controlchange-damperpedal
 * @fires InputChannel#event:controlchange-portamento
 * @fires InputChannel#event:controlchange-sostenuto
 * @fires InputChannel#event:controlchange-softpedal
 * @fires InputChannel#event:controlchange-legatopedal
 * @fires InputChannel#event:controlchange-hold2
 * @fires InputChannel#event:controlchange-soundvariation
 * @fires InputChannel#event:controlchange-resonance
 * @fires InputChannel#event:controlchange-releasetime
 * @fires InputChannel#event:controlchange-attacktime
 * @fires InputChannel#event:controlchange-brightness
 * @fires InputChannel#event:controlchange-decaytime
 * @fires InputChannel#event:controlchange-vibratorate
 * @fires InputChannel#event:controlchange-vibratodepth
 * @fires InputChannel#event:controlchange-vibratodelay
 * @fires InputChannel#event:controlchange-generalpurposecontroller5
 * @fires InputChannel#event:controlchange-generalpurposecontroller6
 * @fires InputChannel#event:controlchange-generalpurposecontroller7
 * @fires InputChannel#event:controlchange-generalpurposecontroller8
 * @fires InputChannel#event:controlchange-portamentocontrol
 * @fires InputChannel#event:controlchange-highresolutionvelocityprefix
 * @fires InputChannel#event:controlchange-effect1depth
 * @fires InputChannel#event:controlchange-effect2depth
 * @fires InputChannel#event:controlchange-effect3depth
 * @fires InputChannel#event:controlchange-effect4depth
 * @fires InputChannel#event:controlchange-effect5depth
 * @fires InputChannel#event:controlchange-dataincrement
 * @fires InputChannel#event:controlchange-datadecrement
 * @fires InputChannel#event:controlchange-nonregisteredparameterfine
 * @fires InputChannel#event:controlchange-nonregisteredparametercoarse
 * @fires InputChannel#event:controlchange-registeredparameterfine
 * @fires InputChannel#event:controlchange-registeredparametercoarse
 * @fires InputChannel#event:controlchange-allsoundoff
 * @fires InputChannel#event:controlchange-resetallcontrollers
 * @fires InputChannel#event:controlchange-localcontrol
 * @fires InputChannel#event:controlchange-allnotesoff
 * @fires InputChannel#event:controlchange-omnimodeoff
 * @fires InputChannel#event:controlchange-omnimodeon
 * @fires InputChannel#event:controlchange-monomodeon
 * @fires InputChannel#event:controlchange-polymodeon
 * @fires InputChannel#event:
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class InputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._input = e, this._number = t, this._octaveOffset = 0, this._nrpnBuffer = [], this._rpnBuffer = [], this.parameterNumberEventsEnabled = !0, this.notesState = new Array(128).fill(!1);
    }
    destroy() {
        this._input = null, this._number = null, this._octaveOffset = 0, this._nrpnBuffer = [], this.notesState = new Array(128).fill(!1), this.parameterNumberEventsEnabled = !1, this.removeListener();
    }
    _processMidiMessageEvent(e) {
        const t = Object.assign({}, e);
        t.port = this.input, t.target = this, t.type = "midimessage", this.emit(t.type, t), this._parseEventForStandardMessages(t);
    }
    _parseEventForStandardMessages(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmessage";
        const n = e.message.dataBytes[0], r = e.message.dataBytes[1];
        if ("noteoff" === t.type || "noteon" === t.type && 0 === r) this.notesState[n] = !1, t.type = "noteoff", t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: 0,
            rawRelease: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.release, t.rawVelocity = t.note.rawRelease;
        else if ("noteon" === t.type) this.notesState[n] = !0, t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.attack, t.rawVelocity = t.note.rawAttack;
        else if ("keyaftertouch" === t.type) t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset)), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.identifier = t.note.identifier, t.key = t.note.number, t.rawKey = n;
        else if ("controlchange" === t.type) {
            t.controller = {
                number: n,
                name: Enumerations.CONTROL_CHANGE_MESSAGES[n].name,
                description: Enumerations.CONTROL_CHANGE_MESSAGES[n].description,
                position: Enumerations.CONTROL_CHANGE_MESSAGES[n].position
            }, t.subtype = t.controller.name || "controller" + n, t.value = Utilities.from7bitToFloat(r), t.rawValue = r;
            const e = Object.assign({}, t);
            e.type = `${t.type}-controller${n}`, delete e.subtype, this.emit(e.type, e);
            const i = Object.assign({}, t);
            i.type = t.type + "-" + Enumerations.CONTROL_CHANGE_MESSAGES[n].name, delete i.subtype, 0 !== i.type.indexOf("controller") && this.emit(i.type, i), t.message.dataBytes[0] >= 120 && this._parseChannelModeMessage(t), this.parameterNumberEventsEnabled && this._isRpnOrNrpnController(t.message.dataBytes[0]) && this._parseEventForParameterNumber(t);
        } else "programchange" === t.type ? (t.value = n, t.rawValue = t.value) : "channelaftertouch" === t.type ? (t.value = Utilities.from7bitToFloat(n), t.rawValue = n) : "pitchbend" === t.type ? (t.value = ((r << 7) + n - 8192) / 8192, t.rawValue = (r << 7) + n) : t.type = "unknownmessage";
        this.emit(t.type, t);
    }
    _parseChannelModeMessage(e) {
        const t = Object.assign({}, e);
        t.type = t.controller.name, "localcontrol" === t.type && (t.value = 127 === t.message.data[2], t.rawValue = t.message.data[2]), "omnimodeon" === t.type ? (t.type = "omnimode", t.value = !0, t.rawValue = t.message.data[2]) : "omnimodeoff" === t.type && (t.type = "omnimode", t.value = !1, t.rawValue = t.message.data[2]), "monomodeon" === t.type ? (t.type = "monomode", t.value = !0, t.rawValue = t.message.data[2]) : "polymodeon" === t.type && (t.type = "monomode", t.value = !1, t.rawValue = t.message.data[2]), this.emit(t.type, t);
    }
    _parseEventForParameterNumber(e) {
        const t = e.message.dataBytes[0], n = e.message.dataBytes[1];
        99 === t || 101 === t ? (this._nrpnBuffer = [], this._rpnBuffer = [], 99 === t ? this._nrpnBuffer = [
            e.message
        ] : 127 !== n && (this._rpnBuffer = [
            e.message
        ])) : 98 === t || 100 === t ? 98 === t ? (this._rpnBuffer = [], 1 === this._nrpnBuffer.length ? this._nrpnBuffer.push(e.message) : this._nrpnBuffer = []) : (this._nrpnBuffer = [], 1 === this._rpnBuffer.length && 127 !== n ? this._rpnBuffer.push(e.message) : this._rpnBuffer = []) : 6 !== t && 38 !== t && 96 !== t && 97 !== t || (2 === this._rpnBuffer.length ? this._dispatchParameterNumberEvent("rpn", this._rpnBuffer[0].dataBytes[1], this._rpnBuffer[1].dataBytes[1], e) : 2 === this._nrpnBuffer.length ? this._dispatchParameterNumberEvent("nrpn", this._nrpnBuffer[0].dataBytes[1], this._nrpnBuffer[1].dataBytes[1], e) : (this._nrpnBuffer = [], this._rpnBuffer = []));
    }
    _isRpnOrNrpnController(e) {
        return 6 === e || 38 === e || 96 === e || 97 === e || 98 === e || 99 === e || 100 === e || 101 === e;
    }
    _dispatchParameterNumberEvent(e, t, n, r) {
        e = "nrpn" === e ? "nrpn" : "rpn";
        const i = {
            target: r.target,
            timestamp: r.timestamp,
            message: r.message,
            parameterMsb: t,
            parameterLsb: n,
            value: Utilities.from7bitToFloat(r.message.dataBytes[1]),
            rawValue: r.message.dataBytes[1]
        };
        i.parameter = "rpn" === e ? Object.keys(Enumerations.REGISTERED_PARAMETERS).find((e)=>Enumerations.REGISTERED_PARAMETERS[e][0] === t && Enumerations.REGISTERED_PARAMETERS[e][1] === n) : (t << 7) + n;
        const s = Enumerations.CONTROL_CHANGE_MESSAGES[r.message.dataBytes[0]].name;
        i.type = `${e}-${s}`, this.emit(i.type, i);
        const a = Object.assign({}, i);
        "nrpn-dataincrement" === a.type ? a.type = "nrpn-databuttonincrement" : "nrpn-datadecrement" === a.type ? a.type = "nrpn-databuttondecrement" : "rpn-dataincrement" === a.type ? a.type = "rpn-databuttonincrement" : "rpn-datadecrement" === a.type && (a.type = "rpn-databuttondecrement"), this.emit(a.type, a), i.type = e, i.subtype = s, this.emit(i.type, i);
    }
    getChannelModeByNumber(e) {
        return wm.validation && (console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class."), e = Math.floor(e)), Utilities.getChannelModeByNumber(e);
    }
    getCcNameByNumber(e) {
        if (wm.validation && (console.warn("The 'getCcNameByNumber()' method has been moved to the 'Utilities' class."), !((e = parseInt(e)) >= 0 && e <= 127))) throw new RangeError("Invalid control change number.");
        return Utilities.getCcNameByNumber(e);
    }
    getNoteState(e) {
        e instanceof Note && (e = e.identifier);
        const t = Utilities.guessNoteNumber(e, wm.octaveOffset + this.input.octaveOffset + this.octaveOffset);
        return this.notesState[t];
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get input() {
        return this._input;
    }
    get number() {
        return this._number;
    }
    get nrpnEventsEnabled() {
        return this.parameterNumberEventsEnabled;
    }
    set nrpnEventsEnabled(e) {
        this.validation && (e = !!e), this.parameterNumberEventsEnabled = e;
    }
}
/**
 * The `Message` class represents a single MIDI message. It has several properties that make it
 * easy to make sense of the binary data it contains.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Message {
    constructor(e){
        this.rawData = e, this.data = Array.from(this.rawData), this.statusByte = this.rawData[0], this.rawDataBytes = this.rawData.slice(1), this.dataBytes = this.data.slice(1), this.isChannelMessage = !1, this.isSystemMessage = !1, this.command = void 0, this.channel = void 0, this.manufacturerId = void 0, this.type = void 0, this.statusByte < 240 ? (this.isChannelMessage = !0, this.command = this.statusByte >> 4, this.channel = 1 + (15 & this.statusByte)) : (this.isSystemMessage = !0, this.command = this.statusByte), this.isChannelMessage ? this.type = Utilities.getPropertyByValue(Enumerations.CHANNEL_MESSAGES, this.command) : this.isSystemMessage && (this.type = Utilities.getPropertyByValue(Enumerations.SYSTEM_MESSAGES, this.command)), this.statusByte === Enumerations.SYSTEM_MESSAGES.sysex && (0 === this.dataBytes[0] ? (this.manufacturerId = this.dataBytes.slice(0, 3), this.dataBytes = this.dataBytes.slice(3, this.rawDataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(3, this.rawDataBytes.length - 1)) : (this.manufacturerId = [
            this.dataBytes[0]
        ], this.dataBytes = this.dataBytes.slice(1, this.dataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(1, this.rawDataBytes.length - 1)));
    }
}
/**
 * The `Input` class represents a single MIDI input port. This object is automatically instantiated
 * by the library according to the host's MIDI subsystem and does not need to be directly
 * instantiated. Instead, you can access all `Input` objects by referring to the
 * [`WebMidi.inputs`](WebMidi#inputs) array. You can also retrieve inputs by using methods such as
 * [`WebMidi.getInputByName()`](WebMidi#getInputByName) and
 * [`WebMidi.getInputById()`](WebMidi#getInputById).
 *
 * Note that a single MIDI device may expose several inputs and/or outputs.
 *
 * **Important**: the `Input` class does not directly fire channel-specific MIDI messages
 * (such as [`noteon`](InputChannel#event:noteon) or
 * [`controlchange`](InputChannel#event:controlchange), etc.). The [`InputChannel`](InputChannel)
 * object does that. However, you can still use the
 * [`Input.addListener()`](#addListener) method to listen to channel-specific events on multiple
 * [`InputChannel`](InputChannel) objects at once.
 *
 * @fires Input#opened
 * @fires Input#disconnected
 * @fires Input#closed
 * @fires Input#midimessage
 *
 * @fires Input#sysex
 * @fires Input#timecode
 * @fires Input#songposition
 * @fires Input#songselect
 * @fires Input#tunerequest
 * @fires Input#clock
 * @fires Input#start
 * @fires Input#continue
 * @fires Input#stop
 * @fires Input#activesensing
 * @fires Input#reset
 *
 * @fires Input#unknownmidimessage
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Input extends EventEmitter {
    constructor(e){
        super(), this._midiInput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new InputChannel(this, e);
        this._forwarders = [], this._midiInput.onstatechange = this._onStateChange.bind(this), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._forwarders = [], this._midiInput && (this._midiInput.onstatechange = null, this._midiInput.onmidimessage = null), await this.close(), this._midiInput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time,
            target: this,
            port: this
        };
        "open" === e.port.connection ? (t.type = "opened", this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught: ", e.port.connection, e.port.state);
    }
    _onMidiMessage(e) {
        const t = new Message(e.data), n = {
            port: this,
            target: this,
            message: t,
            timestamp: e.timeStamp,
            type: "midimessage",
            data: t.data,
            rawData: t.data,
            statusByte: t.data[0],
            dataBytes: t.dataBytes
        };
        this.emit("midimessage", n), t.isSystemMessage ? this._parseEvent(n) : t.isChannelMessage && this.channels[t.channel]._processMidiMessageEvent(n), this._forwarders.forEach((e)=>e.forward(t));
    }
    _parseEvent(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmidimessage", "songselect" === t.type && (t.song = e.data[1] + 1, t.value = e.data[1], t.rawValue = t.value), this.emit(t.type, t);
    }
    async open() {
        try {
            await this._midiInput.open();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    async close() {
        if (!this._midiInput) return Promise.resolve(this);
        try {
            await this._midiInput.close();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    getChannelModeByNumber() {
        wm.validation && console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class.");
    }
    addListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = null != t ? [].concat(t) : void 0;
            t = n, n = {
                channels: e
            };
        }
        if (Enumerations.CHANNEL_EVENTS.includes(e)) {
            void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
            let r = [];
            return Utilities.sanitizeChannels(n.channels).forEach((i)=>{
                r.push(this.channels[i].addListener(e, t, n));
            }), r;
        }
        return super.addListener(e, t, n);
    }
    addOneTimeListener(e, t, n = {}) {
        return n.remaining = 1, this.addListener(e, t, n);
    }
    on(e, t, n, r) {
        return this.addListener(e, t, n, r);
    }
    hasListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        return Enumerations.CHANNEL_EVENTS.includes(e) ? (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).every((n)=>this.channels[n].hasListener(e, t))) : super.hasListener(e, t);
    }
    removeListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        if (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), null == e) return Utilities.sanitizeChannels(n.channels).forEach((e)=>{
            this.channels[e] && this.channels[e].removeListener();
        }), super.removeListener();
        Enumerations.CHANNEL_EVENTS.includes(e) ? Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].removeListener(e, t, n);
        }) : super.removeListener(e, t, n);
    }
    addForwarder(e, t = {}) {
        let n;
        return n = e instanceof Forwarder ? e : new Forwarder(e, t), this._forwarders.push(n), n;
    }
    removeForwarder(e) {
        this._forwarders = this._forwarders.filter((t)=>t !== e);
    }
    hasForwarder(e) {
        return this._forwarders.includes(e);
    }
    get name() {
        return this._midiInput.name;
    }
    get id() {
        return this._midiInput.id;
    }
    get connection() {
        return this._midiInput.connection;
    }
    get manufacturer() {
        return this._midiInput.manufacturer;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get state() {
        return this._midiInput.state;
    }
    get type() {
        return this._midiInput.type;
    }
    get nrpnEventsEnabled() {
        return wm.validation && console.warn("The 'nrpnEventsEnabled' property has been moved to the 'InputChannel' class."), !1;
    }
}
if (Utilities.isNode) {
    try {
        window.navigator;
    } catch (err) {
        let jzz;
        eval('jzz = require("jzz")'), $parcel$global.navigator || ($parcel$global.navigator = {}), Object.assign($parcel$global.navigator, jzz);
    }
    try {
        performance;
    } catch (err) {
        let performance1;
        eval('performance = require("perf_hooks").performance'), $parcel$global.performance = performance1;
    }
}
/**
 * The `WebMidi` object makes it easier to work with the low-level Web MIDI API. Basically, it
 * simplifies sending outgoing MIDI messages and reacting to incoming MIDI messages.
 *
 * When using the WebMidi.js library, you should know that the `WebMidi` class has already been
 * instantiated. You cannot instantiate it yourself. If you use the **IIFE** version, you should
 * simply use the global object called `WebMidi`. If you use the **CJS** (CommonJS) or **ESM** (ES6
 * module) version, you get an already-instantiated object when you import the module.
 *
 * @fires WebMidi#connected
 * @fires WebMidi#disabled
 * @fires WebMidi#disconnected
 * @fires WebMidi#enabled
 * @fires WebMidi#error
 * @fires WebMidi#midiaccessgranted
 * @fires WebMidi#portschanged
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class WebMidi extends EventEmitter {
    constructor(){
        super(), this.defaults = {
            note: {
                attack: Utilities.from7bitToFloat(64),
                release: Utilities.from7bitToFloat(64),
                duration: 1 / 0
            }
        }, this.interface = null, this.validation = !0, this._inputs = [], this._disconnectedInputs = [], this._outputs = [], this._disconnectedOutputs = [], this._stateChangeQueue = [], this._octaveOffset = 0;
    }
    async enable(e = {}, t = !1) {
        if (this.validation = !1 !== e.validation, this.validation && ("function" == typeof e && (e = {
            callback: e,
            sysex: t
        }), t && (e.sysex = !0)), this.enabled) return "function" == typeof e.callback && e.callback(), Promise.resolve();
        const n = {
            timestamp: this.time,
            target: this,
            type: "error",
            error: void 0
        }, r = {
            timestamp: this.time,
            target: this,
            type: "midiaccessgranted"
        }, i = {
            timestamp: this.time,
            target: this,
            type: "enabled"
        };
        try {
            "function" == typeof e.requestMIDIAccessFunction ? this.interface = await e.requestMIDIAccessFunction({
                sysex: e.sysex,
                software: e.software
            }) : this.interface = await navigator.requestMIDIAccess({
                sysex: e.sysex,
                software: e.software
            });
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        this.emit("midiaccessgranted", r), this.interface.onstatechange = this._onInterfaceStateChange.bind(this);
        try {
            await this._updateInputsAndOutputs();
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        return this.emit("enabled", i), "function" == typeof e.callback && e.callback(), Promise.resolve(this);
    }
    async disable() {
        return this.interface && (this.interface.onstatechange = void 0), this._destroyInputsAndOutputs().then(()=>{
            navigator && "function" == typeof navigator.close && navigator.close(), this.interface = null;
            let e = {
                timestamp: this.time,
                target: this,
                type: "disabled"
            };
            this.emit("disabled", e), this.removeListener();
        });
    }
    getInputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (this._disconnectedInputs[t].id === e.toString()) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (this.inputs[t].id === e.toString()) return this.inputs[t];
    }
    getInputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (~this._disconnectedInputs[t].name.indexOf(e)) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (~this.inputs[t].name.indexOf(e)) return this.inputs[t];
    }
    getOutputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (~this._disconnectedOutputs[t].name.indexOf(e)) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (~this.outputs[t].name.indexOf(e)) return this.outputs[t];
    }
    getOutputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (this._disconnectedOutputs[t].id === e.toString()) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (this.outputs[t].id === e.toString()) return this.outputs[t];
    }
    noteNameToNumber(e) {
        return this.validation && console.warn("The noteNameToNumber() method is deprecated. Use Utilities.toNoteNumber() instead."), Utilities.toNoteNumber(e, this.octaveOffset);
    }
    getOctave(e) {
        return this.validation && (console.warn("The getOctave()is deprecated. Use Utilities.getNoteDetails() instead"), e = parseInt(e)), !isNaN(e) && e >= 0 && e <= 127 && Utilities.getNoteDetails(Utilities.offsetNumber(e, this.octaveOffset)).octave;
    }
    sanitizeChannels(e) {
        return this.validation && console.warn("The sanitizeChannels() method has been moved to the utilities class."), Utilities.sanitizeChannels(e);
    }
    toMIDIChannels(e) {
        return this.validation && console.warn("The toMIDIChannels() method has been deprecated. Use Utilities.sanitizeChannels() instead."), Utilities.sanitizeChannels(e);
    }
    guessNoteNumber(e) {
        return this.validation && console.warn("The guessNoteNumber() method has been deprecated. Use Utilities.guessNoteNumber() instead."), Utilities.guessNoteNumber(e, this.octaveOffset);
    }
    getValidNoteArray(e, t = {}) {
        return this.validation && console.warn("The getValidNoteArray() method has been moved to the Utilities.buildNoteArray()"), Utilities.buildNoteArray(e, t);
    }
    convertToTimestamp(e) {
        return this.validation && console.warn("The convertToTimestamp() method has been moved to Utilities.toTimestamp()."), Utilities.toTimestamp(e);
    }
    async _destroyInputsAndOutputs() {
        let e = [];
        return this.inputs.forEach((t)=>e.push(t.destroy())), this.outputs.forEach((t)=>e.push(t.destroy())), Promise.all(e).then(()=>{
            this._inputs = [], this._outputs = [];
        });
    }
    _onInterfaceStateChange(e) {
        this._updateInputsAndOutputs();
        let t = {
            timestamp: e.timeStamp,
            type: e.port.state,
            target: this
        };
        if ("connected" === e.port.state && "open" === e.port.connection) {
            "output" === e.port.type ? t.port = this.getOutputById(e.port.id) : "input" === e.port.type && (t.port = this.getInputById(e.port.id)), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        } else if ("disconnected" === e.port.state && "pending" === e.port.connection) {
            "input" === e.port.type ? t.port = this.getInputById(e.port.id, {
                disconnected: !0
            }) : "output" === e.port.type && (t.port = this.getOutputById(e.port.id, {
                disconnected: !0
            })), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        }
    }
    async _updateInputsAndOutputs() {
        return Promise.all([
            this._updateInputs(),
            this._updateOutputs()
        ]);
    }
    async _updateInputs() {
        if (!this.interface) return;
        for(let e = this._inputs.length - 1; e >= 0; e--){
            const t = this._inputs[e];
            Array.from(this.interface.inputs.values()).find((e)=>e === t._midiInput) || (this._disconnectedInputs.push(t), this._inputs.splice(e, 1));
        }
        let e = [];
        return this.interface.inputs.forEach((t)=>{
            if (!this._inputs.find((e)=>e._midiInput === t)) {
                let n = this._disconnectedInputs.find((e)=>e._midiInput === t);
                n || (n = new Input(t)), this._inputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    async _updateOutputs() {
        if (!this.interface) return;
        for(let e = this._outputs.length - 1; e >= 0; e--){
            const t = this._outputs[e];
            Array.from(this.interface.outputs.values()).find((e)=>e === t._midiOutput) || (this._disconnectedOutputs.push(t), this._outputs.splice(e, 1));
        }
        let e = [];
        return this.interface.outputs.forEach((t)=>{
            if (!this._outputs.find((e)=>e._midiOutput === t)) {
                let n = this._disconnectedOutputs.find((e)=>e._midiOutput === t);
                n || (n = new Output(t)), this._outputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    get enabled() {
        return null !== this.interface;
    }
    get inputs() {
        return this._inputs;
    }
    get isNode() {
        return this.validation && console.warn("WebMidi.isNode has been deprecated. Use Utilities.isNode instead."), Utilities.isNode;
    }
    get isBrowser() {
        return this.validation && console.warn("WebMidi.isBrowser has been deprecated. Use Utilities.isBrowser instead."), Utilities.isBrowser;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get outputs() {
        return this._outputs;
    }
    get supported() {
        return "undefined" != typeof navigator && !!navigator.requestMIDIAccess;
    }
    get sysexEnabled() {
        return !(!this.interface || !this.interface.sysexEnabled);
    }
    get time() {
        return performance.now();
    }
    get version() {
        return "3.1.9";
    }
    get flavour() {
        return "cjs";
    }
    get CHANNEL_EVENTS() {
        return this.validation && console.warn("The CHANNEL_EVENTS enum has been moved to Enumerations.CHANNEL_EVENTS."), Enumerations.CHANNEL_EVENTS;
    }
    get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been moved to Enumerations.SYSTEM_MESSAGES."), Enumerations.SYSTEM_MESSAGES;
    }
    get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been moved to Enumerations.CHANNEL_MODE_MESSAGES."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been replaced by the Enumerations.CONTROL_CHANGE_MESSAGES array."), Enumerations.MIDI_CONTROL_CHANGE_MESSAGES;
    }
    get MIDI_REGISTERED_PARAMETER() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETER enum has been moved to Enumerations.REGISTERED_PARAMETERS."), Enumerations.REGISTERED_PARAMETERS;
    }
    get NOTES() {
        return this.validation && console.warn("The NOTES enum has been deprecated."), [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
}
const wm = new WebMidi;
wm.constructor = null, exports.Enumerations = Enumerations, exports.Forwarder = Forwarder, exports.Input = Input, exports.InputChannel = InputChannel, exports.Message = Message, exports.Note = Note, exports.Output = Output, exports.OutputChannel = OutputChannel, exports.Utilities = Utilities, exports.WebMidi = wm;

});



parcelRegister("iKsY6", function(module, exports) {

$parcel$export(module.exports, "PianoUI", () => $49e5bcebd8e6b777$export$b7c99630d03ba3df);

var $1IdZj = parcelRequire("1IdZj");

var $ly76a = parcelRequire("ly76a");

var $5taCS = parcelRequire("5taCS");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");
const $49e5bcebd8e6b777$export$b7c99630d03ba3df = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-piano",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "pianoTimbre",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("timbre")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                className: "row-span-2",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.PianoRoll), {
                className: "row-span-5",
                instrument: instrument,
                colorNotes: instrument.metadata.color
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex gap-10 justify-between align-center",
                children: [
                    instrument.getParameterDescription("pianoRollColorCode") && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.ColorCodeSelector), {
                        instrument: instrument
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                        className: "contents",
                        instrument: instrument,
                        showAutogenerate: true
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("i5Wwc", function(module, exports) {

$parcel$export(module.exports, "Baix", () => $d2c61627839955a6$export$b5d40ba1489561c1);

var $8TVE6 = parcelRequire("8TVE6");

var $1Uc6g = parcelRequire("1Uc6g");

var $enQqi = parcelRequire("enQqi");

var $2cXDZ = parcelRequire("2cXDZ");
class $d2c61627839955a6$export$b5d40ba1489561c1 extends (0, $8TVE6.MonoSynth) {
    static metadata = {
        tipus: 'synth_bass',
        tipusDisplay: 'Synth Bass Legacy',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).violet,
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        lpf_cutoff: {
            ...super.parametersDescription.lpf_cutoff,
            initial: 500
        },
        osc_waveform: {
            ...super.parametersDescription.osc_waveform,
            initial: 'square'
        },
        env_attack: {
            ...super.parametersDescription.env_attack,
            initial: 0.01
        },
        env_decay: {
            ...super.parametersDescription.env_decay,
            initial: 3.0
        },
        env_sustain: {
            ...super.parametersDescription.env_sustain,
            initial: 0.0
        },
        env_release: {
            ...super.parametersDescription.env_release,
            initial: 0.2
        },
        osc_detune: {
            ...super.parametersDescription.osc_detune,
            initial: 1.01
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {
            min: 24,
            max: 47
        }
    };
    getUserInterfaceComponent() {
        return 0, $1Uc6g.BaixUI;
    }
}

});
parcelRegister("8TVE6", function(module, exports) {

$parcel$export(module.exports, "MonoSynth", () => $67b02d047039f592$export$319ecdcd955e80a7);

var $lQ6pU = parcelRequire("lQ6pU");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $huphW = parcelRequire("huphW");

var $enQqi = parcelRequire("enQqi");
parcelRequire("56MRX");
var $aZf7A = parcelRequire("aZf7A");

var $95CQM = parcelRequire("95CQM");
class $67b02d047039f592$export$319ecdcd955e80a7 extends (0, $lQ6pU.BaseSynth) {
    static metadata = {
        tipus: 'mono_synth',
        tipusDisplay: 'Mono Synth',
        versio: '0.1',
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        pianoRollColorCode: {
            ...super.parametersDescription.pianoRollColorCode,
            options: [
                'melodic',
                'none'
            ]
        },
        osc_portamento: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 1.0,
            initial: 0.0,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange
    };
    isMono = true;
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph({
            poly: false
        });
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "osc_portamento":
                this.audioNodes.synth.set({
                    'portamento': value
                });
                break;
            default:
                super.setParameterInAudioGraph(name, value);
        }
    }
    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.synth.triggerRelease();
    }
    onStopAllSounds() {
        // Stop all notes, and set env_release time to 0
        this.setParameterInAudioGraph('env_release', 0.0);
        this.audioNodes.synth.triggerRelease();
        this.setParameterInAudioGraph('env_release', (0, $95CQM.staticSelect)(this.getDisplayParameterSelector('env_release')));
    }
    unfinishedNotes = [];
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        pitch = this.adjustPitchToInstrumentRange(pitch);
        let soundingPitch = this.adjustPitchForWaveform(pitch);
        soundingPitch += this.getPlaybackParameterValue("osc_octave") * 12;
        if (!noteOff) {
            if (!extras.skipStack) this.unfinishedNotes.push({
                pitch: pitch,
                velocity: midiVelocity
            });
            this.audioNodes.synth.triggerAttack((0, $aZf7A.Frequency)(soundingPitch, "midi"), undefined, midiVelocity / 127);
        } else {
            const removedIndex = this.unfinishedNotes.map(({ pitch: pitch })=>pitch).indexOf(pitch);
            this.unfinishedNotes.splice(removedIndex, 1);
            const newStackLength = this.unfinishedNotes.length;
            if (removedIndex === newStackLength) {
                this.audioNodes.synth.triggerRelease(); // release it
                // ...and if there were other notes pressed, play the newest one among them
                if (newStackLength > 0) {
                    const newestOldNote = this.unfinishedNotes[newStackLength - 1];
                    this.onMidiNote(newestOldNote.pitch, newestOldNote.velocity, false, {
                        ...extras,
                        skipStack: true
                    });
                }
            }
        }
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});

parcelRegister("1Uc6g", function(module, exports) {

$parcel$export(module.exports, "BaixUI", () => $88c9eb16de36bd82$export$59ddd725153cefc0);

var $1IdZj = parcelRequire("1IdZj");

var $g8sjx = parcelRequire("g8sjx");
const $88c9eb16de36bd82$export$59ddd725153cefc0 = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $g8sjx.SynthBaseUI), {
        instrument: instrument,
        synthesisParams: [
            [
                "osc_detune",
                "osc_portamento"
            ],
            [
                "lfo_rate",
                "lfo_depth"
            ]
        ]
    });
};

});


parcelRegister("3kJKP", function(module, exports) {

$parcel$export(module.exports, "getPadParameterName", () => $26d6bb323a29d46a$export$605b2031dd2b362);
$parcel$export(module.exports, "Sampler", () => $26d6bb323a29d46a$export$322f102bec719b22);
parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");
var $82Hwq = parcelRequire("82Hwq");
var $32Bfc = parcelRequire("32Bfc");

var $hmjjw = parcelRequire("hmjjw");

var $huphW = parcelRequire("huphW");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $duvfT = parcelRequire("duvfT");
parcelRequire("i5EW2");

var $enQqi = parcelRequire("enQqi");

var $1zQag = parcelRequire("1zQag");

var $2cXDZ = parcelRequire("2cXDZ");

var $avF0V = parcelRequire("avF0V");

var $lsfK2 = parcelRequire("lsfK2");
function $26d6bb323a29d46a$export$605b2031dd2b362(padIndex, parameterType) {
    return `pad${padIndex + 1}_${parameterType}`;
}
const $26d6bb323a29d46a$var$getInitialStartValue = (numSound, totalSlices = 16)=>{
    const sliceNum = numSound % totalSlices;
    return sliceNum / totalSlices;
};
const $26d6bb323a29d46a$var$getInitialEndValue = (numSound, totalSlices = 16, sliceSpan = 1)=>{
    const sliceNum = numSound % totalSlices;
    return (sliceNum + sliceSpan) / totalSlices;
};
class $26d6bb323a29d46a$export$322f102bec719b22 extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'sampler',
        tipusDisplay: 'Sampler',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).turquoise,
        hasLogo: true,
        hasMiniature: true
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        sound: {
            type: 'text',
            initial: 'soulguitar02',
            bind: "preset"
        },
        ...Array.from({
            length: 16
        }).reduce((acc, _, i)=>({
                ...acc,
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "volume")]: {
                    type: 'float',
                    unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).decibel,
                    min: -60,
                    max: 6,
                    initial: -6,
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "pan")]: {
                    type: 'float',
                    min: -1,
                    max: 1,
                    initial: 0,
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "transpose")]: {
                    type: 'float',
                    min: -12,
                    max: 12,
                    step: 1,
                    initial: 0,
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "start")]: {
                    type: 'float',
                    min: 0,
                    max: 1,
                    initial: $26d6bb323a29d46a$var$getInitialStartValue(i, 8),
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "end")]: {
                    type: 'float',
                    min: 0,
                    max: 1,
                    initial: $26d6bb323a29d46a$var$getInitialEndValue(i, 8),
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "isReverse")]: {
                    type: 'bool',
                    initial: false,
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "envelopeMode")]: {
                    type: 'enum',
                    options: [
                        "gated",
                        "one-shot"
                    ],
                    initial: "one-shot",
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "attack")]: {
                    type: 'float',
                    unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
                    min: 0,
                    max: 2,
                    initial: 0,
                    bind: "preset"
                },
                [$26d6bb323a29d46a$export$605b2031dd2b362(i, "release")]: {
                    type: 'float',
                    unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
                    min: 0,
                    max: 4,
                    initial: 0,
                    bind: "preset"
                }
            }), {}),
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 200,
            max: 20000,
            initial: 20000,
            logarithmic: true,
            bind: "preset"
        },
        choke: {
            type: 'bool',
            initial: true,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {
            min: 0,
            max: 15
        }
    };
    usePitchShifter = true;
    getUserInterfaceComponent() {
        return 0, $duvfT.SamplerUI;
    }
    static maxPolyphony = 3;
    soundBuffers = {};
    getFreeSoundPlayer(padIndex) {
        let soundPlayer = this.audioNodes.soundPlayers.find((soundPlayer)=>soundPlayer.playingPadIndex === -1);
        // if all are busy, steal the voice from the oldest
        if (soundPlayer === undefined) soundPlayer = this.audioNodes.soundPlayers.sort((a, b)=>a.triggerTime - b.triggerTime)[0];
        return soundPlayer;
    }
    getSoundPlayersWithPadPlaying(padIndex) {
        return this.audioNodes.soundPlayers.filter((soundPlayer)=>soundPlayer.playingPadIndex === padIndex);
    }
    loadSoundInPlayers(soundName) {
        if (!this.audioNodes.hasOwnProperty('soundPlayers')) return;
        this.audioNodes.soundPlayers.forEach((soundPlayer)=>{
            soundPlayer.player.loadSound(soundName);
        });
    }
    stopAllPlayers(time) {
        if (!this.audioNodes.hasOwnProperty('soundPlayers')) return;
        this.audioNodes.soundPlayers.forEach((soundPlayer)=>{
            soundPlayer.player.fadeOut = 0; // Set fade out to 0 to avoid release time
            soundPlayer.player.stop(time);
        });
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const lpf = new $82Hwq.Filter(500, "lowpass", -24, {
            channelCount: 2
        }); // Make channel count explicit although it might not be needed (?)
        const soundPlayers = [];
        for(let i = 0; i < this.constructor.maxPolyphony; i++){
            const panner = new $32Bfc.Panner();
            const player = new (0, $avF0V.SamplePlayer)().chain(panner, lpf);
            player.stretchMode = (0, $avF0V.SamplePlayer).STRETCH_MODES.UNSTRETCHED_RESPEED;
            const soundPlayerNodes = {
                playerIdx: i,
                playingPadIndex: -1,
                player: player,
                panner: panner
            };
            player.player.onstop = ()=>{
                // After the release time, finally set the sound player as being "free"
                setTimeout(()=>{
                    (0, $lsfK2.midiHandler).dispatchBrowserMidiEvent(this.id, {
                        pitch: soundPlayerNodes.playingPadIndex,
                        type: 'noteOff'
                    });
                    soundPlayerNodes.playingPadIndex = -1;
                }, player.fadeOut);
            };
            soundPlayers.push(soundPlayerNodes);
        }
        this.audioNodes = {
            lpf: lpf,
            soundPlayers: soundPlayers
        };
        this.addEffectChainNodes(lpf, this.bus);
        this.isGraphBuilt = true;
    }
    dispose() {
        this.onStopAllSounds();
        this.bus.dispose();
        for (const key of Object.keys(this.audioNodes)){
            if (key == "effects") for (const key2 of Object.keys(this.audioNodes.effects)){
                const node = this.audioNodes.effects[key2];
                node.dispose();
            }
            else if (key == "soundPlayers") for (const key2 of Object.keys(this.audioNodes.soundPlayers)){
                const soundPlayer = this.audioNodes.soundPlayers[key2];
                soundPlayer.player.dispose();
                if (this.usePitchShifter) soundPlayer.pitchShift.dispose();
                soundPlayer.channel.dispose();
            }
            else {
                const node = this.audioNodes[key];
                node.dispose();
            }
        }
    }
    setPlayerParameter(player, type, value, time) {
        switch(type){
            case "attack":
                player.player.fadeIn = value;
                break;
            case "release":
                player.player.fadeOut = value;
                break;
            case "volume":
            case "transpose":
            case "start":
            case "end":
            case "speed":
            case "isReverse":
                player.player[type] = value;
                break;
            case "pan":
                player.panner.pan.setValueAtTime(value, time);
        }
    }
    setParameterInAudioGraph(name, value) {
        const parametersMatch = name.match(/^(start|end|attack|release|volume|pan|transpose|speed|isReverse)(\d+)$/);
        if (parametersMatch) {
            const [_, type, indexStr] = parametersMatch;
            const padIndex = parseInt(indexStr, 10) - 1;
            const affectedsoundPlayers = this.getSoundPlayersWithPadPlaying(padIndex);
            affectedsoundPlayers.forEach((soundPlayer)=>this.setPlayerParameter(soundPlayer, type, value));
        } else if (name == 'lpf_cutoff') this.audioNodes.lpf.frequency.rampTo((0, $1zQag.limitToNyquist)(value), 0.01);
        else if (name == 'sound') this.loadSoundInPlayers(value);
    }
    triggerPad(padIndex, time, normVelocity = 1) {
        // First, stop players if needed
        if (this.getPlaybackParameterValue("choke")) this.stopAllPlayers(time); // immediately stop all if choke is on, as the sampler behaves as if it was mono
        else this.stopPad(padIndex, time); // immediately stop pad if there's any player playing it
        const soundPlayer = this.getFreeSoundPlayer(padIndex); // todo: this might return unexpected results if the "time" parameter is not 0.
        if (soundPlayer === undefined) // If no sound player can be found, don't trigger the sound and return false
        return false;
        [
            "start",
            "end",
            "attack",
            "release",
            "pan",
            "transpose",
            "isReverse"
        ].forEach((parameterType)=>{
            const value = this.getPlaybackParameterValue($26d6bb323a29d46a$export$605b2031dd2b362(padIndex, parameterType));
            this.setPlayerParameter(soundPlayer, parameterType, value, time);
        });
        const gain = $bmU6v.dbToGain(this.getPlaybackParameterValue($26d6bb323a29d46a$export$605b2031dd2b362(padIndex, "volume")));
        soundPlayer.player.gain.gain.setValueAtTime(gain, time);
        // If buffer is not loaded yet, don't trigger the sound and return false
        if (!soundPlayer.player.isBufferLoaded()) return false;
        soundPlayer.triggerTime = performance.now();
        soundPlayer.playingPadIndex = padIndex;
        soundPlayer.player.play(time);
        return true;
    }
    stopPad(padIndex, time) {
        const soundPlayers = this.getSoundPlayersWithPadPlaying(padIndex);
        soundPlayers.forEach((soundPlayer)=>{
            soundPlayer.player.fadeOut = 0;
            soundPlayer.player.stop(time);
        });
    }
    triggerAttackRelease(padIndex, time, duration, normVelocity) {
        const triggered = this.triggerPad(padIndex, time, normVelocity);
        // Don't trigger stop if buffer not loaded, this could cause problems
        if (triggered) {
            const isGated = this.getPlaybackParameterValue($26d6bb323a29d46a$export$605b2031dd2b362(padIndex, "envelopeMode")) === "gated";
            // Triggering stop will add the fadeOut (release) time.
            if (isGated) this.stopPad(padIndex, time + duration);
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        let notesDueTrigger = [];
        sequence.forEach((note)=>note.onset === currentStep && notesDueTrigger.push(note));
        notesDueTrigger = notesDueTrigger.slice(-this.constructor.maxPolyphony); // only keep last maxPolyphony notes to avoid potential problems with start times
        notesDueTrigger.forEach((note)=>{
            const velocity = (note.velocity ?? 127) / 127;
            const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
            const padIndex = note.pitch % 16;
            (0, $lsfK2.midiHandler).dispatchBrowserMidiEvent(this.id, {
                pitch: padIndex,
                type: 'noteOn',
                source: 'sequencer'
            });
            this.triggerAttackRelease(padIndex, time, duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime(), velocity);
        });
    }
    onTransportStop() {
        // Stop all notes that are still playing
        this.stopAllPlayers();
    }
    onStopAllSounds() {
        // Stop all notes that are still playing
        this.stopAllPlayers();
    }
    adjustPitchToInstrumentRange(pitch) {
        return pitch % 16;
    }
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        const padIndex = pitch % 16;
        if (!noteOff) this.triggerPad(padIndex, undefined, midiVelocity / 127);
        else {
            const isGated = this.getPlaybackParameterValue($26d6bb323a29d46a$export$605b2031dd2b362(padIndex, "envelopeMode")) === "gated";
            if (isGated) this.stopPad(padIndex);
        }
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("duvfT", function(module, exports) {

$parcel$export(module.exports, "SamplerUI", () => $dfb1fb7d99bcf07b$export$683d845e0b9376d9);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $6XTNC = parcelRequire("6XTNC");

var $ly76a = parcelRequire("ly76a");

var $57GjP = parcelRequire("57GjP");

var $4SkBY = parcelRequire("4SkBY");

var $5taCS = parcelRequire("5taCS");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");

var $ip7Vd = parcelRequire("ip7Vd");

var $9veCd = parcelRequire("9veCd");

var $7Kpeg = parcelRequire("7Kpeg");

var $3kJKP = parcelRequire("3kJKP");
const $dfb1fb7d99bcf07b$export$683d845e0b9376d9 = ({ instrument: instrument })=>{
    const [selectedPad, setSelectedPad] = (0, $8NFma.useState)(0);
    const [arePadsGrouped, setArePadsGrouped] = (0, $8NFma.useState)(false);
    const arePadsGroupedRef = (0, $8NFma.useRef)();
    arePadsGroupedRef.current = arePadsGrouped;
    const dispatch = (0, $7Kpeg.useDispatch)();
    (0, $8NFma.useEffect)(()=>{
        const subscriptions = [
            "attack",
            "release",
            // no afegim "start" i "end" perquè podriem fer que un end estigués abans d'un start o viceversa
            "pan",
            "volume",
            "transpose",
            "isReverse"
        ].map((parameterType)=>{
            const handler = instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, parameterType));
            const sideEffect = (value)=>{
                if (!arePadsGroupedRef.current) return;
                Array(16).fill().map((_, i)=>i).filter((i)=>i !== selectedPad).forEach((padIndex)=>{
                    dispatch(instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(padIndex, parameterType)).updater(value));
                });
            };
            return handler.subscribeToUpdate(sideEffect);
        });
        return ()=>subscriptions.forEach((unsubscribe)=>unsubscribe());
    }, [
        selectedPad
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-sampler",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "col-span-4"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "lpfCutoff",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("lpf_cutoff")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                className: "col-span-2",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "col-span-2 flex gap-10",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4SkBY.SelectorSonsSampler), {
                        className: "flex-auto",
                        instrument: instrument,
                        parameterName: `sound`,
                        transposeSelector: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "transpose")).selector
                    }),
                    "  ",
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9veCd.ParameterToggle), {
                        "data-widget-id": "choke",
                        parameterHandler: instrument.getParameterHandler("choke")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                className: "modul-border modul-bg flex gap-10 col-span-3 row-span-2",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "flex flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                                "data-widget-id": "padAttack",
                                mida: "petit",
                                parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "attack"))
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                                "data-widget-id": "padRelease",
                                mida: "petit",
                                parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "release"))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ip7Vd.SamplerWaveform), {
                        className: "flex-auto",
                        instrument: instrument,
                        selectedPad: selectedPad
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                className: "modul-border modul-bg flex justify-between items-center col-span-2",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "padPan",
                        mida: "petit",
                        parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "pan"))
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "padVolume",
                        mida: "petit",
                        parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "volume"))
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6XTNC.SampleTransposeKnob), {
                        "data-widget-id": "padTranspose",
                        instrument: instrument,
                        parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "transpose")),
                        selectedPad: selectedPad
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9veCd.ParameterToggle), {
                        "data-widget-id": "padReverse",
                        parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "isReverse"))
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9veCd.ParameterToggle), {
                        "data-widget-id": "padEnvelopeMode",
                        parameterHandler: instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "envelopeMode")),
                        valueToBool: (v)=>v === "one-shot",
                        boolToValue: (b)=>b ? "one-shot" : "gated",
                        label: "One-shot"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $57GjP.PadGrid), {
                className: "row-span-2 col-span-2",
                instrument: instrument,
                selectedPad: selectedPad,
                setSelectedPad: setSelectedPad,
                arePadsGrouped: arePadsGrouped,
                setArePadsGrouped: setArePadsGrouped
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.PianoRoll), {
                className: "col-span-3",
                instrument: instrument,
                colorNotes: instrument.metadata.color,
                modeSampler: "true"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                className: "col-span-3 justify-self-end",
                instrument: instrument
            })
        ]
    });
};

});
parcelRegister("6XTNC", function(module, exports) {

$parcel$export(module.exports, "SampleTransposeKnob", () => $c49869c5a926ce74$export$4d046caeea440b79);

var $1IdZj = parcelRequire("1IdZj");

var $7baak = parcelRequire("7baak");

var $8LfjP = parcelRequire("8LfjP");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");

var $dkYqL = parcelRequire("dkYqL");
const $c49869c5a926ce74$export$4d046caeea440b79 = ({ instrument: instrument, parameterHandler: parameterHandler, selectedPad: selectedPad, ...props })=>{
    const tonalitat = (0, $7Kpeg.useSelector)((0, $5ICqB.selectTonality));
    const sampleOriginalScale = (0, $7Kpeg.useSelector)((0, $dkYqL.createSelector)(instrument.getDisplayParameterSelector('sound'), (sound)=>(0, $7baak.getScaleForSampleName)(sound)));
    const transpose = (0, $7Kpeg.useSelector)(parameterHandler.selector);
    const sampleTransposedScale = (0, $7baak.transposeScale)(sampleOriginalScale, transpose);
    let sliceTonalitatCorrecta = (0, $7baak.isScaleCompatibleWith)(sampleTransposedScale, tonalitat);
    if (sampleOriginalScale === undefined) sliceTonalitatCorrecta = true // Si no sabem la tonalitat del sample, no la marquem vermella mai
    ;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
        ...props,
        mida: "petit",
        parameterHandler: parameterHandler,
        label: "Pitch",
        markLabelRed: !sliceTonalitatCorrecta
    });
};

});

parcelRegister("57GjP", function(module, exports) {

$parcel$export(module.exports, "PadGrid", () => $0a6a27313213e62a$export$c378e9e049680b68);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $fITdy = parcelRequire("fITdy");
const $0a6a27313213e62a$export$c378e9e049680b68 = ({ instrument: instrument, className: className, selectedPad: selectedPad, setSelectedPad: setSelectedPad, arePadsGrouped: arePadsGrouped, setArePadsGrouped: setArePadsGrouped })=>{
    (0, $8NFma.useEffect)(()=>{
        document.addEventListener("midiNote-" + instrument.id, (evt)=>{
            if (evt.detail.source !== "user") return; // could be the sequencer
            if (evt.detail.type == 'noteOff') return;
            setSelectedPad(evt.detail.pitch % 16);
        });
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        "data-widget-id": "padGrid",
        className: `pad-grid ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                "data-widget-id": "padsGroupToggle",
                className: `col-span-full p-2 btn ${arePadsGrouped ? "active" : ""}`,
                onClick: ()=>setArePadsGrouped((v)=>!v),
                children: "GROUP"
            }),
            Array.from({
                length: 16
            }).map((_, index)=>{
                // Modifiquem la posició amb l'estil i no amb el DOM
                // Perquè el tab order es mantengui bé
                const col = index % 4 + 1;
                const row = 5 - Math.floor(index / 4);
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fITdy.MidiPad), {
                    style: {
                        gridRowStart: row,
                        gridColumnStart: col
                    },
                    className: "sampler-pad",
                    instrument: instrument,
                    pitch: index,
                    isSelected: selectedPad === index,
                    setSelected: ()=>setSelectedPad(index),
                    label: index + 1
                }, index);
            })
        ]
    });
};

});

parcelRegister("4SkBY", function(module, exports) {

$parcel$export(module.exports, "SelectorSonsSampler", () => $7ba7078b81caf518$export$647cefddc03d2bb2);
$parcel$export(module.exports, "SelectorSonsLooper", () => $7ba7078b81caf518$export$a6953aef6524f6cf);

var $1IdZj = parcelRequire("1IdZj");

var $7baak = parcelRequire("7baak");

var $9lLIM = parcelRequire("9lLIM");

var $i5EW2 = parcelRequire("i5EW2");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");

var $avF0V = parcelRequire("avF0V");

var $3kJKP = parcelRequire("3kJKP");
const $7ba7078b81caf518$export$75a5512048d5eab5 = ({ selectedSoundName: selectedSoundName = "", className: className, onChange: onChange, transpositionSemitones: transpositionSemitones = 0, ...props })=>{
    const tonalitat = (0, $7Kpeg.useSelector)((0, $5ICqB.selectTonality));
    const sampleOriginalScale = (0, $7baak.getScaleForSampleName)(selectedSoundName);
    let sampleScale = (0, $7baak.transposeScale)(sampleOriginalScale, transpositionSemitones);
    const isTransposed = transpositionSemitones !== 0;
    const options = [
        ...(0, $i5EW2.sampleLibrary).sampler.map((item)=>{
            const { name: name, scale: originalScale } = item;
            const transposedScale = (0, $7baak.transposeScale)(originalScale, transpositionSemitones);
            return {
                'label': name + ' (' + (0, $7baak.getScaleDisplayName)(originalScale) + (isTransposed ? ` \u{2192} ${(0, $7baak.getScaleDisplayName)(transposedScale)}` : '') + ')',
                'value': name,
                'scale_transposed': transposedScale
            };
        })
    ];
    const optionTemplate = (option)=>{
        const transposedScale = option.scale_transposed;
        let optionScaleCSSClass = "";
        if (!(0, $7baak.isScaleCompatibleWith)(transposedScale, tonalitat)) optionScaleCSSClass = "text-red";
        return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            className: optionScaleCSSClass,
            children: option.label
        });
    };
    let scaleCSSClass = "";
    if (!(0, $7baak.isScaleCompatibleWith)(sampleScale, tonalitat)) scaleCSSClass = "text-red";
    if (sampleScale === undefined) scaleCSSClass = "text-orange";
    if (!selectedSoundName) scaleCSSClass = "";
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9lLIM.Dropdown), {
        ...props,
        className: `${scaleCSSClass} bg-black ${className}`,
        style: {
            ...props.style,
            background: "var(--background-color )"
        },
        itemTemplate: optionTemplate,
        value: selectedSoundName,
        onChange: (evt)=>onChange(evt),
        options: options,
        placeholder: "Cap"
    });
};
const $7ba7078b81caf518$export$647cefddc03d2bb2 = ({ instrument: instrument, parameterName: parameterName, className: className, transposeSelector: transposeSelector })=>{
    const selectedSoundName = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector(parameterName));
    const transpose = (0, $7Kpeg.useSelector)(transposeSelector);
    const tonality = (0, $7Kpeg.useSelector)((0, $5ICqB.selectTonality));
    const dispatch = (0, $7Kpeg.useDispatch)();
    return /*#__PURE__*/ (0, $1IdZj.jsx)($7ba7078b81caf518$export$75a5512048d5eab5, {
        "data-widget-id": "sampleSelect",
        className: className,
        selectedSoundName: selectedSoundName,
        onChange: (evt)=>{
            instrument.updateParametreInstrument(parameterName, evt.target.value);
            const originalScale = (0, $7baak.getScaleForSampleName)(evt.target.value);
            const transposition = (0, $7baak.getTranspositionForScaleToMatchTonality)(originalScale, tonality);
            Array(16).fill().map((_, i)=>i).forEach((padIndex)=>{
                dispatch(instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(padIndex, "transpose")).updater(transposition));
            });
            instrument.updateParameter;
        },
        transpositionSemitones: transpose
    });
};
const $7ba7078b81caf518$export$a6953aef6524f6cf = ({ instrument: instrument, ...props })=>{
    const currentClip = (0, $7Kpeg.useSelector)(instrument.getDisplayClipSelector());
    const { soundName: soundName } = currentClip.sound;
    const dispatch = (0, $7Kpeg.useDispatch)();
    const transpose = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("transpose"));
    const speed = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("speed"));
    return /*#__PURE__*/ (0, $1IdZj.jsx)($7ba7078b81caf518$export$75a5512048d5eab5, {
        "data-widget-id": "sampleSelect",
        selectedSoundName: soundName,
        transpositionSemitones: transpose,
        ...props,
        onChange: (evt)=>{
            dispatch((0, $5ICqB.setClipParameter)({
                instrumentID: instrument.id,
                parameter: "soundName",
                value: evt.target.value
            }));
            (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(evt.target.value, ()=>instrument.adjustClipLengthToFit());
        }
    });
};

});

parcelRegister("ip7Vd", function(module, exports) {

$parcel$export(module.exports, "SamplerWaveform", () => $b21da928cc611a7c$export$fa295ec23560fcda);

var $1IdZj = parcelRequire("1IdZj");

var $7Kpeg = parcelRequire("7Kpeg");

var $8DNI3 = parcelRequire("8DNI3");

var $avF0V = parcelRequire("avF0V");

var $8NFma = parcelRequire("8NFma");

var $kmdF6 = parcelRequire("kmdF6");

var $32aXQ = parcelRequire("32aXQ");

var $3kJKP = parcelRequire("3kJKP");
function $b21da928cc611a7c$export$fa295ec23560fcda({ className: className, instrument: instrument, selectedPad: selectedPad }) {
    const soundName = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("sound"));
    const isReverse = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector((0, $3kJKP.getPadParameterName)(selectedPad, "isReverse")));
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        "data-widget-id": "padWaveformDisplay",
        className: `waveform-cropper ${className}`,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "stack h-full",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8DNI3.Waveform), {
                        soundName: soundName,
                        isReverse: isReverse
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)($b21da928cc611a7c$var$SamplerEnvelopeOverlay, {
                        instrument: instrument,
                        selectedPad: selectedPad
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8DNI3.PlayheadCanvas), {
                        getPlayheadPosition: ()=>instrument.getSoundPlayersWithPadPlaying(selectedPad).map((player)=>player.player.position)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $32aXQ.ParameterSliderRange), {
                pt: {
                    handle: {
                        "data-widget-id": "padSlicer"
                    }
                },
                instrument: instrument,
                parameterHandlers: [
                    instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "start")),
                    instrument.getParameterHandler((0, $3kJKP.getPadParameterName)(selectedPad, "end"))
                ],
                noLabel: true,
                noOutput: true
            })
        ]
    });
}
function $b21da928cc611a7c$var$SamplerEnvelopeOverlay({ instrument: instrument, selectedPad: selectedPad }) {
    const attack = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector((0, $3kJKP.getPadParameterName)(selectedPad, "attack")));
    const release = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector((0, $3kJKP.getPadParameterName)(selectedPad, "release")));
    const start = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector((0, $3kJKP.getPadParameterName)(selectedPad, "start")));
    const end = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector((0, $3kJKP.getPadParameterName)(selectedPad, "end")));
    const soundName = (0, $7Kpeg.useSelector)(instrument.getDisplayParameterSelector("sound"));
    const [duration, setDuration] = (0, $8NFma.useState)(0);
    (0, $8NFma.useEffect)(()=>{
        (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(soundName, (buffer)=>setDuration(buffer.duration));
    }, [
        soundName
    ]);
    const endTime = end * duration;
    let isEnvelopeCropped = false;
    const envelope = [
        {
            time: start * duration,
            value: 0
        }
    ];
    let attackEndTime = start * duration + attack;
    let attackEndValue = 1;
    if (endTime < attackEndTime) {
        isEnvelopeCropped = true;
        attackEndValue = (0, $kmdF6.normalize)(endTime, start * duration, attackEndTime);
        attackEndTime = endTime;
    }
    envelope.push({
        time: attackEndTime,
        value: attackEndValue
    });
    if (!isEnvelopeCropped) {
        let releaseStartTime = end * duration - release;
        const releaseStartValue = 1;
        if (releaseStartTime < attackEndTime) releaseStartTime = attackEndTime;
        else envelope.push({
            time: releaseStartTime,
            value: releaseStartValue
        });
        let releaseEndTime = releaseStartTime + release;
        let releaseEndValue = 0;
        if (endTime < releaseEndTime) {
            isEnvelopeCropped = true;
            releaseEndValue = 1 - (0, $kmdF6.normalize)(endTime, releaseStartTime, releaseEndTime);
            releaseEndTime = endTime;
        }
        envelope.push({
            time: releaseEndTime,
            value: releaseEndValue
        });
    }
    if (isEnvelopeCropped) envelope.push({
        time: endTime,
        value: 0
    });
    let pathString = envelope.reduce((pathString, point)=>{
        return pathString + ` L ${point.time} ${1 - point.value}`;
    }, `M ${envelope[0].time} ${envelope[0].value}`);
    envelope.toReversed().slice(1).forEach((point)=>{
        pathString += ` L ${point.time} ${1 + point.value}`;
    });
    const strokeWidthPx = 3;
    return /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
        viewBox: `0 0 ${duration} 2`,
        preserveAspectRatio: "none",
        className: "w-full h-full",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("g", {
            fill: "color-mix(in srgb, var(--accent-color) 30%, transparent)",
            stroke: "var(--accent-color)",
            strokeWidth: strokeWidthPx,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                d: pathString,
                vectorEffect: "non-scaling-stroke"
            })
        })
    });
}

});
parcelRegister("8DNI3", function(module, exports) {

$parcel$export(module.exports, "Waveform", () => $9eb991e7598dae93$export$4c2f72a4f17a358e);
$parcel$export(module.exports, "PlayheadCanvas", () => $9eb991e7598dae93$export$c529fd0ca6a429ec);
$parcel$export(module.exports, "LooperWaveform", () => $9eb991e7598dae93$export$dfe1d91ebdedaf1f);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $7Kpeg = parcelRequire("7Kpeg");

var $5ICqB = parcelRequire("5ICqB");

var $32aXQ = parcelRequire("32aXQ");

var $kmdF6 = parcelRequire("kmdF6");

var $avF0V = parcelRequire("avF0V");

var $kU8gq = parcelRequire("kU8gq");
function $9eb991e7598dae93$var$ResponsiveCanvas({ onResize: onResize = ()=>{}, ref: ref }) {
    const innerRef = (0, $8NFma.useRef)();
    ref ??= innerRef;
    function adjustSize() {
        const { width: width, height: height } = ref.current.parentElement.getBoundingClientRect();
        onResize({
            width: width,
            height: height
        });
        ref.current.width = width;
        ref.current.height = height;
    }
    (0, $8NFma.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new ResizeObserver(adjustSize);
        observer.observe(ref.current.parentElement);
        adjustSize();
        return ()=>observer.disconnect();
    }, [
        ref.current
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("canvas", {
        ref: ref,
        style: {
            width: "100%",
            height: "100%",
            display: "block"
        }
    });
}
function $9eb991e7598dae93$export$4c2f72a4f17a358e({ soundName: soundName, isReverse: isReverse, start: start = 0, end: end = 1, color: color = "white", onResize: _onResize, className: className }) {
    const canvasRef = (0, $8NFma.useRef)();
    const clear = ()=>canvasRef.current.getContext('2d').clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    function redraw(buffer, start, end, isReverse) {
        const ctx = canvasRef.current.getContext('2d');
        const { width: width, height: height } = canvasRef.current;
        let bufferData = buffer.getChannelData(0);
        bufferData = bufferData.slice(Math.floor(start * bufferData.length), Math.floor(end * bufferData.length));
        if (isReverse) bufferData = bufferData.toReversed();
        ctx.clearRect(0, 0, width, height);
        $9eb991e7598dae93$var$drawWaveform(ctx, bufferData, width, height, color);
    }
    const [dummyRedrawState, setDummyRedrawState] = (0, $8NFma.useState)(0);
    function onResize(props) {
        setDummyRedrawState((p)=>p + 1);
        _onResize && _onResize(props);
    }
    (0, $8NFma.useEffect)(()=>{
        clear();
        let cancel = false;
        (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(soundName, (buffer)=>cancel || redraw(buffer, start, end, isReverse));
        return ()=>cancel = true;
    }, [
        soundName,
        color,
        start,
        end,
        isReverse,
        dummyRedrawState
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($9eb991e7598dae93$var$ResponsiveCanvas, {
            onResize: onResize,
            ref: canvasRef
        })
    });
}
function $9eb991e7598dae93$export$c529fd0ca6a429ec({ getPlayheadPosition: getPlayheadPosition, className: className, onResize: onResize }) {
    const canvasRef = (0, $8NFma.useRef)();
    function drawPlayhead() {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let playheadPosition = getPlayheadPosition();
        if (playheadPosition == null) return;
        if (!Array.isArray(playheadPosition)) playheadPosition = [
            playheadPosition
        ];
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
        ctx.lineWidth = 2;
        ctx.shadowColor = 'rgba(255, 255, 255, 0.8)';
        ctx.shadowBlur = 4;
        playheadPosition.forEach((position)=>{
            if (position == null) return;
            const x = position * canvas.width;
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, canvas.height);
            ctx.stroke();
        });
        ctx.shadowBlur = 0;
    }
    const animationFrameIdRef = (0, $8NFma.useRef)();
    function loop() {
        drawPlayhead();
        animationFrameIdRef.current = requestAnimationFrame(loop);
    }
    const startLoop = ()=>requestAnimationFrame(loop);
    function stopLoop() {
        if (animationFrameIdRef.current == null) return;
        cancelAnimationFrame(animationFrameIdRef.current);
        animationFrameIdRef.current = null;
    }
    (0, $8NFma.useEffect)(()=>{
        // Not checking isPlaying because sampler samples can be triggered while Transport is off
        startLoop();
        return stopLoop;
    }, [
        getPlayheadPosition
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)($9eb991e7598dae93$var$ResponsiveCanvas, {
            onResize: onResize,
            ref: canvasRef
        })
    });
}
const $9eb991e7598dae93$export$dfe1d91ebdedaf1f = ({ instrument: instrument, className: className })=>{
    const currentClip = (0, $7Kpeg.useSelector)(instrument.getDisplayClipSelector());
    const { start: start, end: end, speed: speed, isReverse: isReverse, soundName: soundName } = {
        ...(0, $kU8gq.Sound).getDefaults(),
        ...currentClip.sound
    };
    const clipLength = (0, $7Kpeg.useSelector)(instrument.getDisplayClipLengthSelector());
    const isPlaying = (0, $7Kpeg.useSelector)((0, $5ICqB.selectIsPlaying));
    const bpm = (0, $7Kpeg.useSelector)((0, $5ICqB.selectBpm));
    const [buffer, setBuffer] = (0, $8NFma.useState)(undefined);
    const canvasRef = (0, $8NFma.useRef)(null);
    const animationFrameIdRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        if (!soundName) return setBuffer(undefined);
        (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(soundName, (buffer)=>setBuffer(buffer));
    }, [
        soundName,
        instrument
    ]);
    const drawWaveformOverlay = (startPosition, endPosition, showBeatPositions)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const bufferDuration = buffer?.duration ?? 0;
        const beatDurationSeconds = 60 / bpm * speed;
        const stepDurationSeconds = 60 / bpm * speed / 4;
        const pixelsPerSecond = bufferDuration > 0 ? canvas.width / bufferDuration : 0;
        const pixelsPerStep = pixelsPerSecond * stepDurationSeconds;
        // Quantize startX and endX to the nearest pixelsPerStep multiple
        const startX = (0, $kmdF6.quantizeRound)(startPosition * canvas.width, pixelsPerStep);
        const endX = (0, $kmdF6.quantizeRound)(endPosition * canvas.width, pixelsPerStep);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
        ctx.fillRect(0, 0, startX, canvas.height);
        ctx.fillRect(endX, 0, canvas.width - endX, canvas.height);
        if (showBeatPositions && bufferDuration > 0) {
            const numberOfBeats = Math.floor(bufferDuration / beatDurationSeconds);
            ctx.strokeStyle = 'rgba(160, 160, 160, 0.7)';
            ctx.lineWidth = 1;
            for(let beatIndex = 0; beatIndex <= numberOfBeats; beatIndex++){
                const beatPosition = beatIndex * beatDurationSeconds / bufferDuration;
                const beatX = beatPosition * canvas.width;
                ctx.beginPath();
                ctx.moveTo(beatX, 0);
                ctx.lineTo(beatX, canvas.height);
                ctx.stroke();
            }
            // Show the number of beats covered in the loop part at the top right corner
            const effectiveNumberOfBeats = clipLength / 4;
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.font = '14px Arial';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'top';
            ctx.fillText(`${effectiveNumberOfBeats} beats`, canvas.width - 10, 5);
        }
    };
    const [dummyRedrawState, setDummyRedrawState] = (0, $8NFma.useState)(0);
    const onResize = ()=>setDummyRedrawState((p)=>p + 1);
    (0, $8NFma.useEffect)(()=>{
        drawWaveformOverlay(start, end, true);
    }, [
        instrument,
        buffer,
        start,
        end,
        speed,
        bpm,
        dummyRedrawState
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: `modul-border ${className} flex flex-col h-full`,
        style: {
            position: 'relative',
            overflow: 'hidden'
        },
        children: buffer?.loaded && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "waveform-display flex-1 stack",
                    style: {
                        position: 'relative',
                        minHeight: 0
                    },
                    children: [
                        "  ",
                        /*#__PURE__*/ (0, $1IdZj.jsx)($9eb991e7598dae93$export$4c2f72a4f17a358e, {
                            soundName: soundName,
                            isReverse: isReverse
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)($9eb991e7598dae93$export$c529fd0ca6a429ec, {
                            getPlayheadPosition: ()=>instrument.audioNodes.samplePlayer?.position ?? 0
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)($9eb991e7598dae93$var$ResponsiveCanvas, {
                            ref: canvasRef,
                            style: {
                                pointerEvents: "none"
                            },
                            onResize: onResize
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $32aXQ.ParameterSliderRange), {
                    instrument: instrument,
                    parameterHandlers: [
                        instrument.getParameterHandler('start'),
                        instrument.getParameterHandler('end')
                    ],
                    sideEffect: ()=>instrument.adjustClipLengthToFit(),
                    noLabel: true,
                    noOutput: true,
                    style: {
                        margin: "20px 0"
                    }
                })
            ]
        })
    });
};
// Code here was inspired from: https://github.com/meandavejustice/draw-wave/blob/master/index.js
function $9eb991e7598dae93$var$drawWaveform(canvasCtx, bufferData, width, height, color) {
    canvasCtx.fillStyle = color;
    var step = Math.ceil(bufferData.length / width);
    var amp = height / 2;
    for(var i = 0; i < width; i++){
        var min = 1.0;
        var max = -1;
        for(var j = 0; j < step; j++){
            var datum = bufferData[i * step + j];
            if (datum < min) min = datum;
            if (datum > max) max = datum;
        }
        canvasCtx.fillRect(i, (1 + min) * amp, 1, Math.max(1, (max - min) * amp));
    }
}

});
parcelRegister("32aXQ", function(module, exports) {

$parcel$export(module.exports, "ParameterSliderRange", () => $8287a05493939f35$export$90ba7bf1f9087c71);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $9Vyg3 = parcelRequire("9Vyg3");

var $7Kpeg = parcelRequire("7Kpeg");
const $8287a05493939f35$export$90ba7bf1f9087c71 = ({ parameterHandlers: parameterHandlers, sideEffect: sideEffect, orientation: orientation, size: size, label: label, labelSize: labelSize = "12px", noLabel: noLabel = false, noOutput: noOutput = false, style: style = {}, ...props })=>{
    [activeThumbIndex, setActiveThumbIndex] = (0, $8NFma.useState)(0);
    const numericMinValue = Math.min(...parameterHandlers.map((handler)=>handler.getNumericMin()));
    const numericMaxValue = Math.max(...parameterHandlers.map((handler)=>handler.getNumericMax()));
    if (orientation === 'vertical') style.height = size || '80px';
    if (orientation === 'horizontal') style.width = size || '200px';
    const dispatch = (0, $7Kpeg.useDispatch)();
    const onNewValues = (newValues, parameterHandlers, oldValues)=>{
        const isReversed = newValues[0] > newValues[1];
        if (isReversed) newValues = newValues.toReversed(); // ensures the first value is always the minimum
        parameterHandlers.forEach((handler, index)=>{
            const newValue = handler.num2Real(newValues[index]);
            const oldValue = oldValues[index];
            if (newValue === oldValue) return; // No need to dispatch if the value hasn't changed
            dispatch(handler.updater(newValue));
        });
        sideEffect && sideEffect();
    };
    function resetToDefaults() {
        parameterHandlers.forEach((handler)=>{
            dispatch(handler.updater(handler.getDefaultValue()));
        });
        sideEffect && sideEffect();
    }
    const realValues = parameterHandlers.map((parameterHandler)=>(0, $7Kpeg.useSelector)(parameterHandler.selector));
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9Vyg3.Slider), {
        ...props,
        style: style,
        orientation: orientation,
        value: realValues.map((realValue, index)=>parameterHandlers[index].real2Num(realValue)),
        step: parameterHandlers[0].getStep() || 0.001,
        min: numericMinValue,
        max: numericMaxValue,
        onNewValue: onNewValues,
        label: label || parameterHandlers[0].description.label,
        output: parameterHandlers[activeThumbIndex].real2String(realValues[activeThumbIndex]),
        noLabel: noLabel,
        noOutput: noOutput,
        colorRange: true,
        isRange: true,
        throttleDeps: [
            parameterHandlers
        ],
        onDoubleClick: resetToDefaults
    });
};

});





parcelRegister("gpyea", function(module, exports) {

$parcel$export(module.exports, "SynthWam", () => $bf298804ebbe346b$export$149f5ebb63b2fd53);
parcelRequire("56MRX");
var $fDBOr = parcelRequire("fDBOr");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $1Uvh8 = parcelRequire("1Uvh8");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $huphW = parcelRequire("huphW");

var $enQqi = parcelRequire("enQqi");

var $kzCWk = parcelRequire("kzCWk");

var $kZHEO = parcelRequire("kZHEO");

var $ibyLL = parcelRequire("ibyLL");

var $2cXDZ = parcelRequire("2cXDZ");
class $bf298804ebbe346b$export$149f5ebb63b2fd53 extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'synth_wam',
        tipusDisplay: 'Synth',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).red,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        ...(0, $ibyLL.PianoRoller).parametersDescription,
        env_attack: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 2.0,
            initial: 0.1,
            bind: "preset"
        },
        env_decay: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 0.5,
            bind: "preset"
        },
        env_sustain: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.8,
            bind: "preset"
        },
        env_release: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 2.0,
            bind: "preset"
        },
        osc_waveform: {
            type: 'enum',
            options: [
                'sine',
                'triangle',
                'square',
                'sawtooth'
            ],
            initial: 'sawtooth',
            bind: "preset"
        },
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 100,
            max: 15000,
            initial: 6000,
            logarithmic: true,
            bind: "preset"
        },
        lpf_q: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.7,
            bind: "preset"
        },
        lfo_rate: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 0.1,
            max: 50.0,
            initial: 0.3,
            logarithmic: true,
            bind: "preset"
        },
        lfo_depth: {
            type: 'float',
            min: 0.0,
            max: 2000.0,
            initial: 300.0,
            bind: "preset"
        },
        osc_octave: {
            type: 'int',
            min: -2,
            max: 2,
            step: 1,
            initial: 0,
            bind: "preset"
        },
        fx_distortion_amount: {
            type: 'float',
            min: 0.0,
            max: 100.0,
            initial: 0.0,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {
            min: 60,
            max: 83
        }
    };
    getUserInterfaceComponent() {
        return 0, $kzCWk.SynthWamUI;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const wamUrl = appPrefix + '/static/dist/public/wam/PolySynth/index.js';
        const wamNode = await (0, $kZHEO.createWamNode)(wamUrl, this.id);
        //wamNode.getParameterInfo().then((params) => console.debug(params));  // Print available WAM node parameters
        const gainOutput = new $bdbZZ.Gain($bmU6v.dbToGain(-12));
        this.audioNodes = {
            gainOutput: gainOutput,
            wamNode: wamNode
        };
        $fDBOr.connect(this.audioNodes.wamNode, this.audioNodes.gainOutput);
        // Seteja gain general
        this.audioNodes.wamNode.setParameterValues({
            'volume': {
                value: -3
            }
        });
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(this.audioNodes.gainOutput, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "lpf_cutoff":
                this.audioNodes.wamNode.setParameterValues({
                    'cutoff': {
                        value: value
                    }
                });
                break;
            case "lpf_q":
                this.audioNodes.wamNode.setParameterValues({
                    'resonance': {
                        value: value
                    }
                });
                break;
            case "lfo_rate":
                this.audioNodes.wamNode.setParameterValues({
                    'lfoRate': {
                        value: value
                    }
                });
                break;
            case "lfo_depth":
                this.audioNodes.wamNode.setParameterValues({
                    'lfoAmount': {
                        value: value
                    }
                });
                break;
            case "fx_distortion_amount":
                this.audioNodes.wamNode.setParameterValues({
                    'distortionAmount': {
                        value: value
                    }
                });
                break;
            case "osc_octave":
                this.audioNodes.wamNode.setParameterValues({
                    'octave': {
                        value: value
                    }
                });
                break;
            case "env_attack":
            case "env_decay":
            case "env_sustain":
            case "env_release":
                this.audioNodes.wamNode.setParameterValues({
                    [name.replace("env_", "")]: {
                        value: value
                    }
                });
                break;
            case "osc_waveform":
                this.audioNodes.wamNode.setParameterValues({
                    'waveform': {
                        value: {
                            sawtooth: 3,
                            triangle: 1,
                            square: 2,
                            sine: 0
                        }[value]
                    }
                });
                break;
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        if (!Object.keys(this.audioNodes).length) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, note.pitch, note.velocity ?? 127, time);
                (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, note.pitch, 0, time + duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime());
            }
        }
    }
    onTransportStop() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onStopAllSounds() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onMidiNote(pitch, midiVelocity = 127, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        if (!Object.keys(this.audioNodes).length) return;
        if (!noteOff) (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        else (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("kzCWk", function(module, exports) {

$parcel$export(module.exports, "SynthWamUI", () => $0c3f9e61e987e631$export$e9df68bae7b32103);

var $1IdZj = parcelRequire("1IdZj");

var $g8sjx = parcelRequire("g8sjx");
const $0c3f9e61e987e631$export$e9df68bae7b32103 = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $g8sjx.SynthBaseUI), {
        instrument: instrument,
        synthesisParams: [
            [
                "osc_octave",
                "fx_distortion_amount"
            ],
            [
                "lfo_rate",
                "lfo_depth"
            ]
        ]
    });
};

});

parcelRegister("kZHEO", function(module, exports) {

$parcel$export(module.exports, "sendNoteOnToWamNode", () => $f48b5e92b9ad7394$export$a36903ceec623e9e);
$parcel$export(module.exports, "sendNoteOffToWamNode", () => $f48b5e92b9ad7394$export$a9758b02f46fbaa0);
$parcel$export(module.exports, "stopAllNotesForWamNode", () => $f48b5e92b9ad7394$export$7a33de33093f989d);
$parcel$export(module.exports, "createWamNode", () => $f48b5e92b9ad7394$export$316ac71b5ffec991);

var $Lbl7Y = parcelRequire("Lbl7Y");
const $f48b5e92b9ad7394$export$a36903ceec623e9e = (wamNode, note, velocity, time)=>{
    wamNode.scheduleEvents({
        type: 'wam-midi',
        time: time,
        data: {
            bytes: new Uint8Array([
                0x90,
                note,
                velocity
            ])
        }
    });
};
const $f48b5e92b9ad7394$export$a9758b02f46fbaa0 = (wamNode, note, velocity, time)=>{
    wamNode.scheduleEvents({
        type: 'wam-midi',
        time: time,
        data: {
            bytes: new Uint8Array([
                0x80,
                note,
                velocity
            ])
        }
    });
};
const $f48b5e92b9ad7394$export$7a33de33093f989d = (wamNode, time)=>{
    wamNode.clearEvents();
    // Stop all notes that are still playing
    for(let pitch = 0; pitch < 128; pitch++)$f48b5e92b9ad7394$export$a9758b02f46fbaa0(wamNode, pitch, 0, time);
};
const $f48b5e92b9ad7394$export$316ac71b5ffec991 = async (wamUrl, nomGrup)=>{
    const wamInstance = await (0, $Lbl7Y.getAudioGraphInstance)().initWamInstance(wamUrl, nomGrup);
    console.debug("WAM node created from:", wamUrl);
    // WAM nodes (in wamInstance.audioNode) have a "destroy" method, but other Tone.js nodes that we use
    // in our app have a "dispose" method. To unify the API, we can add a "dispose" method to the WAM node that 
    // calls its "destroy" method.
    wamInstance.audioNode.dispose = ()=>{
        wamInstance.audioNode.destroy();
    };
    return wamInstance.audioNode;
};

});


parcelRegister("belQo", function(module, exports) {

$parcel$export(module.exports, "SynthBassWam", () => $82d1f24a9039bd40$export$b15fdd545864bced);
parcelRequire("56MRX");
var $fDBOr = parcelRequire("fDBOr");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $1Uvh8 = parcelRequire("1Uvh8");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $huphW = parcelRequire("huphW");

var $enQqi = parcelRequire("enQqi");

var $2evbA = parcelRequire("2evbA");

var $kZHEO = parcelRequire("kZHEO");

var $ibyLL = parcelRequire("ibyLL");

var $2cXDZ = parcelRequire("2cXDZ");
class $82d1f24a9039bd40$export$b15fdd545864bced extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'synth_bass_wam',
        tipusDisplay: 'Synth Bass',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).violet,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        pianoRollColorCode: {
            ...(0, $ibyLL.PianoRoller).parametersDescription.pianoRollColorCode,
            options: [
                'melodic',
                'none'
            ]
        },
        env_attack: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 2.0,
            initial: 0.01,
            bind: "preset"
        },
        env_decay: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 1.0,
            bind: "preset"
        },
        env_sustain: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.01,
            bind: "preset"
        },
        env_release: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 5.0,
            initial: 0.6,
            bind: "preset"
        },
        osc_waveform: {
            type: 'enum',
            options: [
                'sine',
                'triangle',
                'square',
                'sawtooth'
            ],
            initial: 'square',
            bind: "preset"
        },
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 100,
            max: 15000,
            initial: 3500,
            logarithmic: true,
            bind: "preset"
        },
        lpf_q: {
            type: 'float',
            min: 0.0,
            max: 1.0,
            initial: 0.7,
            bind: "preset"
        },
        lfo_rate: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 0.1,
            max: 50.0,
            initial: 0.3,
            logarithmic: true,
            bind: "preset"
        },
        lfo_depth: {
            type: 'float',
            min: 0.0,
            max: 2000.0,
            initial: 0.0,
            bind: "preset"
        },
        osc_octave: {
            type: 'int',
            min: -2,
            max: 2,
            step: 1,
            initial: 0,
            bind: "preset"
        },
        fx_distortion_amount: {
            type: 'float',
            min: 0.0,
            max: 100.0,
            initial: 0.0,
            bind: "preset"
        },
        osc_portamento: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).second,
            min: 0.0,
            max: 2.0,
            initial: 0.01,
            logarithmic: true,
            bind: "preset"
        },
        osc_detune: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).cents,
            min: -10,
            max: 10.0,
            initial: 0.8,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {
            min: 24,
            max: 47
        }
    };
    getUserInterfaceComponent() {
        return 0, $2evbA.SynthBassWamUI;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const wamUrl = appPrefix + '/static/dist/public/wam/MonoSynth/index.js';
        const wamNode = await (0, $kZHEO.createWamNode)(wamUrl, this.id);
        //wamNode.getParameterInfo().then((params) => console.debug(params));  // Print available WAM node parameters
        const gainOutput = new $bdbZZ.Gain($bmU6v.dbToGain(-12));
        this.audioNodes = {
            gainOutput: gainOutput,
            wamNode: wamNode
        };
        $fDBOr.connect(this.audioNodes.wamNode, this.audioNodes.gainOutput);
        // Seteja gain general
        this.audioNodes.wamNode.setParameterValues({
            'volume': {
                value: -3
            },
            'resonance': {
                value: 0.2
            }
        });
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(this.audioNodes.gainOutput, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "lpf_cutoff":
                this.audioNodes.wamNode.setParameterValues({
                    'cutoff': {
                        value: value
                    }
                });
                break;
            case "lpf_q":
                this.audioNodes.wamNode.setParameterValues({
                    'resonance': {
                        value: value
                    }
                });
                break;
            case "lfo_rate":
                this.audioNodes.wamNode.setParameterValues({
                    'lfoRate': {
                        value: value
                    }
                });
                break;
            case "lfo_depth":
                this.audioNodes.wamNode.setParameterValues({
                    'lfoAmount': {
                        value: value
                    }
                });
                break;
            case "fx_distortion_amount":
                this.audioNodes.wamNode.setParameterValues({
                    'distortionAmount': {
                        value: value
                    }
                });
                break;
            case "osc_octave":
                this.audioNodes.wamNode.setParameterValues({
                    'octave': {
                        value: value
                    }
                });
                break;
            case "osc_portamento":
                this.audioNodes.wamNode.setParameterValues({
                    'glideTime': {
                        value: value
                    }
                });
                break;
            case "osc_detune":
                this.audioNodes.wamNode.setParameterValues({
                    'detune': {
                        value: value
                    }
                });
                break;
            case "env_attack":
            case "env_decay":
            case "env_sustain":
            case "env_release":
                this.audioNodes.wamNode.setParameterValues({
                    [name.replace("env_", "")]: {
                        value: value
                    }
                });
                break;
            case "osc_waveform":
                this.audioNodes.wamNode.setParameterValues({
                    'waveform': {
                        value: {
                            sawtooth: 3,
                            triangle: 1,
                            square: 2,
                            sine: 0
                        }[value]
                    }
                });
                break;
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        if (!Object.keys(this.audioNodes).length) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, note.pitch, note.velocity ?? 127, time);
                (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, note.pitch, 0, time + duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime());
            }
        }
    }
    onTransportStop() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onStopAllSounds() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onMidiNote(pitch, midiVelocity = 127, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        if (!Object.keys(this.audioNodes).length) return;
        if (!noteOff) (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        else (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("2evbA", function(module, exports) {

$parcel$export(module.exports, "SynthBassWamUI", () => $cf5d051411ee69b2$export$e3bde88d69b756d8);

var $1IdZj = parcelRequire("1IdZj");

var $g8sjx = parcelRequire("g8sjx");
const $cf5d051411ee69b2$export$e3bde88d69b756d8 = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $g8sjx.SynthBaseUI), {
        instrument: instrument,
        synthesisParams: [
            [
                "osc_detune",
                "osc_portamento"
            ],
            [
                "lfo_rate",
                "lfo_depth"
            ]
        ]
    });
};

});


parcelRegister("avlJO", function(module, exports) {

$parcel$export(module.exports, "PianoWam", () => $7a5da94dd3062781$export$8e83a477cbd4c05f);
parcelRequire("56MRX");
var $fDBOr = parcelRequire("fDBOr");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $1Uvh8 = parcelRequire("1Uvh8");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $enQqi = parcelRequire("enQqi");

var $lRhr0 = parcelRequire("lRhr0");

var $kZHEO = parcelRequire("kZHEO");

var $ibyLL = parcelRequire("ibyLL");

var $2cXDZ = parcelRequire("2cXDZ");
class $7a5da94dd3062781$export$8e83a477cbd4c05f extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'piano_wam',
        tipusDisplay: 'Piano Wam Legacy',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).orange,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        ...(0, $ibyLL.PianoRoller).parametersDescription,
        sound: {
            type: 'enum',
            options: [
                "Ac\xfastic",
                "El\xe8ctric 1",
                "El\xe8ctric 2"
            ],
            initial: "Ac\xfastic",
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {
            min: 48,
            max: 71
        }
    };
    getUserInterfaceComponent() {
        return 0, $lRhr0.PianoWamUI;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const wamUrl = 'https://www.webaudiomodules.com/community/plugins/burns-audio/soundfont/index.js';
        const wamNode = await (0, $kZHEO.createWamNode)(wamUrl, this.id);
        const gainCompensation = new $bdbZZ.Gain($bmU6v.dbToGain(12));
        // wamNode.getState().then((params) => console.debug(params));  // Print available WAM node parameters
        const gainOutput = new $bdbZZ.Gain($bmU6v.dbToGain(0));
        this.audioNodes = {
            gainOutput: gainOutput,
            gainCompensation: gainCompensation,
            wamNode: wamNode
        };
        $fDBOr.connect(this.audioNodes.wamNode, this.audioNodes.gainCompensation);
        $fDBOr.connect(this.audioNodes.gainCompensation, this.audioNodes.gainOutput);
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(this.audioNodes.gainOutput, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "sound":
                this.audioNodes.wamNode.setState({
                    'instrument': {
                        "Ac\xfastic": 'acoustic_grand_piano',
                        "El\xe8ctric 1": 'electric_piano_1',
                        "El\xe8ctric 2": 'electric_piano_2'
                    }[value]
                });
                break;
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        if (!Object.keys(this.audioNodes).length) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, note.pitch, note.velocity ?? 127, time);
                (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, note.pitch, 0, time + duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime());
            }
        }
    }
    onTransportStop() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onStopAllSounds() {
        if (!Object.keys(this.audioNodes).length) return;
        (0, $kZHEO.stopAllNotesForWamNode)(this.audioNodes.wamNode, $1Uvh8.getContext().currentTime);
    }
    onMidiNote(pitch, midiVelocity = 127, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        if (!Object.keys(this.audioNodes).length) return;
        if (!noteOff) (0, $kZHEO.sendNoteOnToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        else (0, $kZHEO.sendNoteOffToWamNode)(this.audioNodes.wamNode, pitch, midiVelocity, $1Uvh8.getContext().currentTime);
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}

});
parcelRegister("lRhr0", function(module, exports) {

$parcel$export(module.exports, "PianoWamUI", () => $c3b4e9e5b7907231$export$fc1eac2339e5d4c5);

var $1IdZj = parcelRequire("1IdZj");

var $ly76a = parcelRequire("ly76a");

var $5taCS = parcelRequire("5taCS");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");
const $c3b4e9e5b7907231$export$fc1eac2339e5d4c5 = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-piano",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "pianoSound",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("sound")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument,
                className: "square"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                className: "row-span-2",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.PianoRoll), {
                className: "row-span-5",
                instrument: instrument,
                colorNotes: instrument.metadata.color
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex gap-10 justify-between align-center",
                children: [
                    instrument.getParameterDescription("pianoRollColorCode") && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.ColorCodeSelector), {
                        instrument: instrument
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                        className: "contents",
                        instrument: instrument,
                        showAutogenerate: true
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("lx6dm", function(module, exports) {

$parcel$export(module.exports, "Looper", () => $fad1801e1941c9f3$export$d66ceb2d1ed1a313);
parcelRequire("56MRX");
var $bmU6v = parcelRequire("bmU6v");
var $82Hwq = parcelRequire("82Hwq");
var $bdbZZ = parcelRequire("bdbZZ");

var $hmjjw = parcelRequire("hmjjw");

var $huphW = parcelRequire("huphW");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $3u35s = parcelRequire("3u35s");

var $enQqi = parcelRequire("enQqi");

var $5ICqB = parcelRequire("5ICqB");

var $2cXDZ = parcelRequire("2cXDZ");

var $avF0V = parcelRequire("avF0V");

var $1zQag = parcelRequire("1zQag");
parcelRequire("7baak");

var $95CQM = parcelRequire("95CQM");
class $fad1801e1941c9f3$export$d66ceb2d1ed1a313 extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'looper',
        tipusDisplay: 'Looper',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).blue,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        transpose: {
            type: 'float',
            min: -12,
            max: 12,
            step: 1,
            initial: 0,
            bind: "clip"
        },
        start: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 0,
            bind: "clip"
        },
        end: {
            type: 'float',
            min: 0,
            max: 1,
            initial: 1,
            bind: "clip"
        },
        speed: {
            type: 'float',
            min: 0.5,
            max: 2,
            step: 0.01,
            initial: 1,
            bind: "clip"
        },
        isReverse: {
            type: 'bool',
            initial: false,
            bind: "clip"
        },
        lpf_cutoff: {
            type: 'float',
            unit: (0, (/*@__PURE__*/$parcel$interopDefault($huphW))).hertz,
            min: 400,
            max: 12000,
            initial: 12000,
            logarithmic: true,
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {
            min: 0,
            max: 0
        }
    };
    needsRetriggeringPlayer = false;
    getUserInterfaceComponent() {
        return 0, $3u35s.LooperUI;
    }
    get player() {
        return this.audioNodes.samplePlayer;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const gain = new $bdbZZ.Gain($bmU6v.dbToGain(0));
        const lpf = new $82Hwq.Filter(500, 'lowpass', -12).connect(gain);
        const samplePlayer = new (0, $avF0V.SamplePlayer)().connect(lpf);
        samplePlayer.loop = true;
        this.audioNodes = {
            gain: gain,
            samplePlayer: samplePlayer,
            lpf: lpf
        };
        this.addEffectChainNodes(gain, this.bus);
        this.isGraphBuilt = true;
        // Pre-load sound from current clip (if any)
        const { soundName: soundName } = this.getPlaybackClip().sound;
        if (soundName) this.setSound(soundName);
    }
    setParameterInAudioGraph(name, value) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        switch(name){
            case "transpose":
            case "start":
            case "end":
            case "isReverse":
            case "speed":
                this.player[name] = value;
                break;
            case "lpf_cutoff":
                this.audioNodes.lpf.frequency.rampTo((0, $1zQag.limitToNyquist)(value), 0.01);
                break;
        }
    }
    setSound = (soundName)=>this.player.loadSound(soundName);
    unsetSound = ()=>this.player.unloadSound();
    playerIsPlaying() {
        return this.player.isPlaying();
    }
    stopSound(time) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return false;
        this.player.stop(time);
    }
    adjustClipLengthToFit() {
        const start = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("start"));
        const end = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("end"));
        const clipLength = (0, $95CQM.staticSelect)(this.getDisplayClipLengthSelector());
        const unwarpedSliceSeconds = (end - start) * this.getRawDisplaySoundDuration();
        const speed = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("speed"));
        const warpedSliceSeconds = unwarpedSliceSeconds / speed;
        const newClipLength = Math.round(warpedSliceSeconds / this.getStepDuration());
        if (clipLength === newClipLength) return;
        (0, $5ICqB.default).dispatch((0, $5ICqB.setClipLength)({
            instrumentID: this.id,
            clipNumber: (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("clipNumber")),
            value: newClipLength
        }));
    // // let's calculate the speed so that it corresponds to the rounded clip length
    // const clipSeconds = newClipLength * this.getStepDuration();
    // const realSpeed = clipSeconds / unwarpedSliceSeconds;
    // store.dispatch(setClipParameter({instrumentID: this.id, parameter: "speed", value: realSpeed}));
    }
    adjustSpeedToFit() {
        const start = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("start"));
        const end = (0, $95CQM.staticSelect)(this.getDisplayParameterSelector("end"));
        const clipLength = (0, $95CQM.staticSelect)(this.getDisplayClipLengthSelector());
        const unwarpedSliceSeconds = (end - start) * this.getRawDisplaySoundDuration();
        const clipSeconds = clipLength * this.getStepDuration();
        const speed = clipSeconds / unwarpedSliceSeconds;
        (0, $5ICqB.default).dispatch((0, $5ICqB.setClipParameter)({
            instrumentID: this.id,
            parameter: "speed",
            value: speed
        }));
    }
    // not calling this.player.getUnwarpedSoundDuration because we want this function to work
    // even without audiograph built
    getRawDisplaySoundDuration() {
        const { soundName: soundName } = (0, $95CQM.staticSelect)(this.getDisplayClipSelector()).sound;
        return (0, $avF0V.getSampleLibraryManagerInstance)().getBufferForSound(soundName).duration;
    }
    onSequencerStep(currentMainSequencerStep, time) {
        const playbackClip = this.getPlaybackClip();
        if (playbackClip == null) return this.unsetSound();
        const { soundName: soundName } = playbackClip.sound;
        // If no sound name, do nothing (except stop sound if for some reason it was playing)
        if (soundName == null) return this.unsetSound();
        // If there is a clip active, but its sound is different from the current sound in buffer, change 
        // the sound and do nothing else. When the sound is loaded, it will be triggered starting at the right point
        if (soundName !== this.player.currentSoundInBufferName) return this.setSound(soundName);
        // If we reach this point, it means that the looper should be playing a sound. We trigger the sound (if not playing) an estimate
        // The position at which the playback should be triggered. Also, we adjust the clip length in case some parameters have changed that
        // would have an effect on that.
        const currentStep = currentMainSequencerStep % playbackClip.length;
        let slicePosition = currentStep / playbackClip.length;
        if (isNaN(slicePosition)) slicePosition = 0; // happens when getPlaybackClip().length is 0
        this.player.onSlicePosition(time, slicePosition);
    }
    onTransportStop() {
        this.stopSound();
    }
    onStopAllSounds() {
        this.stopSound();
    }
    adjustPitchToInstrumentRange(pitch) {
        return 0;
    }
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
    // Nothing, the looper is not triggered by MIDI notes
    }
}

});
parcelRegister("3u35s", function(module, exports) {

$parcel$export(module.exports, "LooperUI", () => $30eb80e93bdb808f$export$e2fa897314374b9b);

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("8NFma");


var $ly76a = parcelRequire("ly76a");

var $4SkBY = parcelRequire("4SkBY");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");
parcelRequire("Wh84F");

var $9veCd = parcelRequire("9veCd");

var $dq8y8 = parcelRequire("dq8y8");

var $8DNI3 = parcelRequire("8DNI3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");
const $30eb80e93bdb808f$export$e2fa897314374b9b = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-looper",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument,
                className: "col-span-2"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "col-span-3"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between col-span-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "lpfCutoff",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("lpf_cutoff")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
                className: "modul-border flex flex-col justify-around items-center gap-10",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dq8y8.ParameterSlider), {
                        "data-widget-id": "looperTranspose",
                        orientation: "vertical",
                        parameterHandler: instrument.getParameterHandler("transpose")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "looperSpeed",
                        mida: "gran",
                        knobSize: "50px",
                        parameterHandler: instrument.getParameterHandler("speed"),
                        sideEffect: ()=>instrument.adjustClipLengthToFit()
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9veCd.ParameterToggle), {
                        "data-widget-id": "looperReverse",
                        parameterHandler: instrument.getParameterHandler("isReverse")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "col-span-4 relative",
                style: {
                    minHeight: 0
                },
                children: [
                    "  ",
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8DNI3.LooperWaveform), {
                        instrument: instrument,
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4SkBY.SelectorSonsLooper), {
                        instrument: instrument,
                        className: "absolute",
                        style: {
                            top: 15,
                            left: 15
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                className: "col-span-full justify-self-end",
                instrument: instrument,
                hideLengthControls: true
            })
        ]
    });
};

});
parcelRegister("Wh84F", function(module, exports) {

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $7Kpeg = parcelRequire("7Kpeg");

var $9lLIM = parcelRequire("9lLIM");
const $e78a3329905ff6f7$export$a6fc05d3c02121ac = ({ instrument: instrument, parameterName: parameterName, label: label, width: width })=>{
    const parameterDescription = instrument.getParameterDescription(parameterName);
    const selector = parameterDescription.selector ?? instrument.getDisplayParameterSelector(parameterName);
    const currentValue = (0, $7Kpeg.useSelector)(selector);
    const dropdownOptions = (0, $8NFma.useMemo)(()=>{
        if (parameterDescription.type === 'enum') return parameterDescription.options.map((option)=>({
                label: parameterDescription.labelForOption?.[option] ?? option,
                value: option
            }));
        return [];
    }, [
        parameterDescription
    ]);
    const handleParameterChange = (e)=>{
        const newValue = e.value;
        instrument.updateParametreInstrument(parameterName, newValue);
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "flex flex-col",
        style: {
            width: width || "100%"
        },
        children: [
            label !== null && /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                htmlFor: parameterName,
                children: label || parameterDescription.label
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9lLIM.Dropdown), {
                id: parameterName,
                value: currentValue,
                options: dropdownOptions,
                onChange: handleParameterChange,
                scrollHeight: "200px"
            })
        ]
    });
};

});



parcelRegister("5RRBq", function(module, exports) {

$parcel$export(module.exports, "PianoSoundFont", () => $445b7b576a04640a$export$97adb72620190536);
parcelRequire("56MRX");
var $fDBOr = parcelRequire("fDBOr");
var $bmU6v = parcelRequire("bmU6v");
var $bdbZZ = parcelRequire("bdbZZ");
var $1Uvh8 = parcelRequire("1Uvh8");

var $hmjjw = parcelRequire("hmjjw");

var $Lbl7Y = parcelRequire("Lbl7Y");

var $enQqi = parcelRequire("enQqi");

var $d3QLB = parcelRequire("d3QLB");

var $ibyLL = parcelRequire("ibyLL");

var $2cXDZ = parcelRequire("2cXDZ");

var $a4qbN = parcelRequire("a4qbN");
class $445b7b576a04640a$export$97adb72620190536 extends (0, $hmjjw.InstrumentBase) {
    static metadata = {
        tipus: 'piano_soundfont',
        tipusDisplay: 'Piano',
        versio: '0.1',
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).orange,
        hasLogo: false,
        hasMiniature: false
    };
    static parametersDescription = (0, $enQqi.addKeysAsField)({
        ...super.parametersDescription,
        ...(0, $ibyLL.PianoRoller).parametersDescription,
        sound: {
            type: 'enum',
            label: 'Tipus de so',
            options: [
                "Ac\xfastic",
                "El\xe8ctric 1",
                "El\xe8ctric 2"
            ],
            initial: "Ac\xfastic",
            bind: "preset"
        }
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {
            min: 48,
            max: 71
        }
    };
    soundfontsInfo = {
        "Ac\xfastic": {
            'url': appPrefix + '/static/dist/public/soundfonts/0000_Full_Grand_Piano-slim.json',
            'gain': -6
        },
        "El\xe8ctric 1": {
            'url': appPrefix + '/static/dist/public/soundfonts/0380_rhodes-instrument-0-38.json',
            'gain': -9
        },
        "El\xe8ctric 2": {
            'url': appPrefix + '/static/dist/public/soundfonts/0000_Electric Piano 26.json',
            'gain': -12
        }
    };
    soundFontsData = {};
    defaultSoundFont = "El\xe8ctric 1";
    soundFontLoaded = false;
    soundFontIsLoading = false;
    currentlyPlayedNoteEvents = {};
    getUserInterfaceComponent() {
        return 0, $d3QLB.PianoSoundFontUI;
    }
    async loadSoundFont(soundFontUrl) {
        if (!Object.keys(this.audioNodes).length) return;
        this.soundFontIsLoading = true;
        let soundFont;
        if (this.soundFontsData[soundFontUrl]) soundFont = this.soundFontsData[soundFontUrl];
        else {
            const response = await fetch(soundFontUrl);
            if (!response.ok) {
                this.soundFontLoaded = false;
                this.soundFontIsLoading = false;
                throw new Error(`Unable to load soundfont: ${response.status} ${response.statusText}`);
            }
            soundFont = await response.json();
            this.soundFontsData[soundFontUrl] = soundFont;
        }
        this.audioNodes.sfPlayer.setPreset(soundFont);
        this.audioNodes.gainCompensation.gain.value = $bmU6v.dbToGain(this.soundfontsInfo[this.defaultSoundFont].gain);
        this.soundFontLoaded = true;
        this.soundFontIsLoading = false;
    }
    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        const response = await fetch(this.soundfontsInfo[this.defaultSoundFont].url);
        if (!response.ok) throw new Error(`Unable to load soundfont: ${response.status} ${response.statusText}`);
        const soundFont = await response.json();
        const gainOutput = new $bdbZZ.Gain($bmU6v.dbToGain(0));
        const gainCompensation = new $bdbZZ.Gain($bmU6v.dbToGain(this.soundfontsInfo[this.defaultSoundFont].gain));
        const player = await (0, $a4qbN.default).load(soundFont, $1Uvh8.getContext().rawContext, gainCompensation);
        this.soundFontLoaded = true;
        this.audioNodes = {
            gainOutput: gainOutput,
            gainCompensation: gainCompensation,
            sfPlayer: player
        };
        $fDBOr.connect(this.audioNodes.gainCompensation, this.audioNodes.gainOutput);
        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(this.audioNodes.gainOutput, this.bus);
    }
    setParameterInAudioGraph(name, value) {
        switch(name){
            case "sound":
                const soundFontUrl = this.soundfontsInfo[value].url;
                if (soundFontUrl) {
                    this.loadSoundFont(soundFontUrl);
                    this.audioNodes.gainCompensation.gain.value = $bmU6v.dbToGain(this.soundfontsInfo[value].gain);
                }
        }
    }
    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        if (!Object.keys(this.audioNodes).length) return;
        if (!this.soundFontLoaded) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for(let i = 0; i < sequence.length; i++){
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                this.audioNodes.sfPlayer.queueWaveTable(time, note.pitch, duration * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime(), (note.velocity ?? 127) / 127);
            }
        }
    }
    onTransportStop() {
        if (!Object.keys(this.audioNodes).length) return;
        this.audioNodes.sfPlayer.cancelQueue();
    }
    onStopAllSounds() {
        if (!Object.keys(this.audioNodes).length) return;
        this.audioNodes.sfPlayer.cancelQueue();
    }
    onMidiNote(pitch, midiVelocity = 127, noteOff, extras) {
        if (!(0, $Lbl7Y.getAudioGraphInstance)().isGraphBuilt()) return;
        if (!Object.keys(this.audioNodes).length) return;
        if (!this.soundFontLoaded) return;
        if (!noteOff) {
            this.clearNoteEventIfExisting(pitch);
            const noteEvt = this.audioNodes.sfPlayer.queueWaveTable($1Uvh8.getContext().currentTime, pitch, 36 * (0, $Lbl7Y.getAudioGraphInstance)().get16BeatTime(), (midiVelocity ?? 127) / 127);
            this.currentlyPlayedNoteEvents[pitch] = noteEvt;
        } else this.clearNoteEventIfExisting(pitch);
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
    clearNoteEventIfExisting(pitch) {
        const noteEvt = this.currentlyPlayedNoteEvents[pitch];
        if (noteEvt) {
            noteEvt.cancel();
            delete this.currentlyPlayedNoteEvents[pitch];
        }
    }
}

});
parcelRegister("d3QLB", function(module, exports) {

$parcel$export(module.exports, "PianoSoundFontUI", () => $038b95926b1d98a9$export$3e142e1177d5db3a);

var $1IdZj = parcelRequire("1IdZj");

var $ly76a = parcelRequire("ly76a");

var $5taCS = parcelRequire("5taCS");

var $9FuEs = parcelRequire("9FuEs");

var $8LfjP = parcelRequire("8LfjP");

var $1eLw3 = parcelRequire("1eLw3");

var $cITjR = parcelRequire("cITjR");

var $6NH4g = parcelRequire("6NH4g");
const $038b95926b1d98a9$export$3e142e1177d5db3a = ({ instrument: instrument })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "estacio estacio-piano",
        style: {
            "--accent-color": instrument.metadata.color
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6NH4g.PresetBankBar), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "modul-border modul-bg flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "instrumentVolume",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("gain")
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1eLw3.default), {
                        className: "h-full"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8LfjP.ParameterKnob), {
                        "data-widget-id": "pianoSound",
                        mida: "gran",
                        parameterHandler: instrument.getParameterHandler("sound")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulEQ), {
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9FuEs.GrufModulSends), {
                instrument: instrument,
                className: "square"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cITjR.HelpBox), {
                className: "row-span-2",
                instrument: instrument
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.PianoRoll), {
                className: "row-span-5",
                instrument: instrument,
                colorNotes: instrument.metadata.color
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex gap-10 justify-between align-center",
                children: [
                    instrument.getParameterDescription("pianoRollColorCode") && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5taCS.ColorCodeSelector), {
                        instrument: instrument
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ly76a.ClipControls), {
                        className: "contents",
                        instrument: instrument,
                        showAutogenerate: true
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("a4qbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $754e97c22ba7d8ce$export$2e2bcd8739ae039);
/*!

	██╗    ██╗███████╗██████╗  █████╗ ██╗   ██╗██████╗ ██╗ ██████╗ ███████╗ ██████╗ ███╗   ██╗████████╗██████╗ ██╗      █████╗ ██╗   ██╗███████╗██████╗
	██║    ██║██╔════╝██╔══██╗██╔══██╗██║   ██║██╔══██╗██║██╔═══██╗██╔════╝██╔═══██╗████╗  ██║╚══██╔══╝██╔══██╗██║     ██╔══██╗╚██╗ ██╔╝██╔════╝██╔══██╗
	██║ █╗ ██║█████╗  ██████╔╝███████║██║   ██║██║  ██║██║██║   ██║█████╗  ██║   ██║██╔██╗ ██║   ██║   ██████╔╝██║     ███████║ ╚████╔╝ █████╗  ██████╔╝
	██║███╗██║██╔══╝  ██╔══██╗██╔══██║██║   ██║██║  ██║██║██║   ██║██╔══╝  ██║   ██║██║╚██╗██║   ██║   ██╔═══╝ ██║     ██╔══██║  ╚██╔╝  ██╔══╝  ██╔══██╗
	╚███╔███╔╝███████╗██████╔╝██║  ██║╚██████╔╝██████╔╝██║╚██████╔╝██║     ╚██████╔╝██║ ╚████║   ██║   ██║     ███████╗██║  ██║   ██║   ███████╗██║  ██║
	 ╚══╝╚══╝ ╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝ ╚═════╝ ╚═╝ ╚═════╝ ╚═╝      ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚═╝     ╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═╝  ╚═╝

	Version: 1.0.2
	Build:   2026-05-31 18:43:30
	Author:  Maxime Larrivée-Roy <mlarriveeroy@gmail.com>
	Github:  https://github.com/WebAudioFonts/webaudiofontplayer
	Website: https://github.com/WebAudioFonts/webaudiofontplayer

*/ // src/webaudiofontplayer.js
var $754e97c22ba7d8ce$export$4a8742344a4ab44f = class _WebAudioFontPlayer {
    #audioCtx = null;
    #compressor = null;
    #preset = null;
    #envelopes = [];
    #afterTime = 0.05;
    #nearZero = 1e-6;
    #bendRange = 2;
    #mainGain = null;
    #volumeValue = 0.7;
    #expressionValue = 1;
    #expressionGain = null;
    #sustain = false;
    #pitchBendValue = 8192;
    #notesWaitingForSustain = /* @__PURE__ */ new Set();
    constructor(preset, audioCtx, compressor = null, callback = null){
        this.#audioCtx = audioCtx;
        this.#compressor = compressor;
        this.#mainGain = this.#audioCtx.createGain();
        this.#mainGain.gain.setValueAtTime(this.#volumeValue, this.#audioCtx.currentTime);
        this.#expressionGain = this.#audioCtx.createGain();
        this.#expressionGain.gain.setValueAtTime(this.#expressionValue, this.#audioCtx.currentTime);
        this.#mainGain.connect(this.#expressionGain);
        this.#expressionGain.connect(this.#compressor ? this.#compressor.input : this.#audioCtx.destination);
        this.setPreset(preset).then(()=>{
            if (typeof callback === "function") callback();
        });
    }
    get preset() {
        return this.#preset;
    }
    set preset(preset) {
        this.setPreset(preset);
    }
    static load(preset, audioCtx, compressor = null) {
        return new Promise((resolve)=>{
            const player = new _WebAudioFontPlayer(preset, audioCtx, compressor, ()=>resolve(player));
        });
    }
    async setPreset(preset, nonblocking = false) {
        this.#preset = preset;
        if (nonblocking) this.#preset.zones.map((zone)=>this.#adjustZone(zone));
        else await Promise.all(this.#preset.zones.map((zone)=>this.#adjustZone(zone)));
    }
    close() {
        const now = this.#audioCtx.currentTime;
        this.#envelopes.forEach((envelope)=>{
            try {
                envelope.gain.cancelScheduledValues(0);
                if (envelope.audioBufferSourceNode) {
                    envelope.audioBufferSourceNode.stop(now);
                    envelope.audioBufferSourceNode.disconnect();
                    envelope.audioBufferSourceNode = null;
                }
            } catch (e) {}
            try {
                envelope.disconnect();
            } catch (e) {}
        });
        this.#envelopes = [];
        this.#notesWaitingForSustain.clear();
        try {
            this.#mainGain.disconnect();
        } catch (e) {}
        try {
            this.#expressionGain.disconnect();
        } catch (e) {}
        this.#mainGain = null;
        this.#expressionGain = null;
        this.#preset = null;
        this.#compressor = null;
        this.#audioCtx = null;
    }
    queueWaveTable(when, pitch, duration, volume, slides) {
        if (this.#audioCtx.state === "suspended") this.#audioCtx.resume().catch(()=>{});
        const vol = this.#limitVolume(volume);
        const zone = this.#findZone(Math.round(pitch));
        if (!zone?.buffer) return null;
        const baseDetuneCents = zone.originalPitch - 100 * zone.coarseTune - zone.fineTune;
        const originalPitchCents = pitch * 100;
        const currentBendCents = (this.#pitchBendValue - 8192) / 8192 * this.#bendRange * 100;
        const totalCents = originalPitchCents - baseDetuneCents + currentBendCents;
        const playbackRate = Math.pow(2, totalCents / 1200);
        const startWhen = Math.max(when, this.#audioCtx.currentTime);
        let waveDuration = duration + this.#afterTime;
        const loop = zone.loopStart >= 1 && zone.loopStart < zone.loopEnd;
        if (!loop) waveDuration = Math.min(waveDuration, zone.buffer.duration / playbackRate);
        const envelope = this.#findEnvelope();
        this.#setupEnvelope(envelope, zone, vol, startWhen, waveDuration, duration);
        const source = this.#audioCtx.createBufferSource();
        source.buffer = zone.buffer;
        source.playbackRate.setValueAtTime(playbackRate, 0);
        if (slides?.length > 0) {
            source.playbackRate.setValueAtTime(playbackRate, startWhen);
            slides.forEach((s)=>{
                const slidePitchCents = (pitch + s.delta) * 100;
                const totalSlideCents = slidePitchCents - baseDetuneCents + currentBendCents;
                const newRate = Math.pow(2, totalSlideCents / 1200);
                source.playbackRate.linearRampToValueAtTime(newRate, startWhen + s.when);
            });
        }
        source.loop = loop;
        if (loop) {
            const d = zone.delay ?? 0;
            source.loopStart = zone.loopStart / zone.sampleRate + d;
            source.loopEnd = zone.loopEnd / zone.sampleRate + d;
        }
        source.connect(envelope);
        source.start(startWhen, zone.delay ?? 0);
        source.stop(startWhen + waveDuration);
        envelope.audioBufferSourceNode = source;
        envelope.when = startWhen;
        envelope.duration = waveDuration;
        envelope.pitch = pitch;
        envelope.baseDetune = baseDetuneCents;
        return envelope;
    }
    async cancelQueue() {
        this.#envelopes.forEach((e)=>{
            e.gain.cancelScheduledValues(0);
            e.gain.setValueAtTime(this.#nearZero, this.#audioCtx.currentTime);
            e.when = -1;
            try {
                e.audioBufferSourceNode?.disconnect();
            } catch (e2) {}
        });
    }
    isSustainActive() {
        return this.#sustain;
    }
    registerSustainNote(cancelFn) {
        this.#notesWaitingForSustain.add(cancelFn);
    }
    setPitchBend(value) {
        this.#pitchBendValue = value;
        const normalized = value - 8192;
        const semitones = normalized >= 0 ? normalized / 8191 * this.#bendRange : normalized / 8192 * this.#bendRange;
        const now = this.#audioCtx.currentTime;
        this.#envelopes.forEach((e)=>{
            if (e.audioBufferSourceNode && e.when + e.duration > now) {
                const originalPitchCents = e.pitch * 100;
                const baseDetuneCents = e.baseDetune;
                const bendCents = semitones * 100;
                const totalCents = originalPitchCents - baseDetuneCents + bendCents;
                const newRate = Math.pow(2, totalCents / 1200);
                e.audioBufferSourceNode.playbackRate.cancelScheduledValues(now);
                e.audioBufferSourceNode.playbackRate.setTargetAtTime(newRate, now, 0.015);
            }
        });
    }
    setController(number, value) {
        const now = this.#audioCtx.currentTime;
        const normalizedValue = Math.max(0, Math.min(127, value)) / 127;
        switch(number){
            case 7:
                this.#volumeValue = normalizedValue;
                this.#mainGain.gain.setTargetAtTime(this.#volumeValue, now, 0.05);
                break;
            case 11:
                this.#expressionValue = normalizedValue;
                this.#expressionGain.gain.setTargetAtTime(this.#expressionValue, now, 0.03);
                break;
            case 64:
                this.#sustain = value >= 64;
                if (!this.#sustain) {
                    this.#notesWaitingForSustain.forEach((cancelFn)=>cancelFn());
                    this.#notesWaitingForSustain.clear();
                }
                break;
        }
    }
    async #adjustZone(zone) {
        if (zone.buffer) return zone;
        zone.delay = 0;
        if (zone.file) {
            const binary = atob(zone.file);
            const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
            try {
                zone.buffer = await this.#audioCtx.decodeAudioData(bytes.buffer);
                this.#applyZoneParameters(zone);
            } catch (error) {
                console.error("Audio decoding error:", error);
                console.warn(this.#preset);
                return false;
            }
        } else this.#applyZoneParameters(zone);
        return zone;
    }
    #applyZoneParameters(zone) {
        zone.loopStart = this.#numValue(zone.loopStart, 0);
        zone.loopEnd = this.#numValue(zone.loopEnd, 0);
        zone.coarseTune = this.#numValue(zone.coarseTune, 0);
        zone.fineTune = this.#numValue(zone.fineTune, 0);
        zone.originalPitch = this.#numValue(zone.originalPitch, 6e3);
    }
    #setupEnvelope(envelope, zone, volume, when, sampleDuration, noteDuration) {
        envelope.gain.setValueAtTime(this.#nearZero, this.#audioCtx.currentTime);
        const duration = Math.min(noteDuration, sampleDuration - this.#afterTime);
        const ahdsr = zone.ahdsr && zone.ahdsr.length > 0 ? zone.ahdsr : [
            {
                duration: 0,
                volume: 1
            },
            {
                duration: duration,
                volume: 1
            }
        ];
        envelope.gain.cancelScheduledValues(when);
        const initialVol = (ahdsr[0]?.volume ?? 1) * volume;
        envelope.gain.linearRampToValueAtTime(this.#noZeroVolume(initialVol), when + 2e-3);
        let lastTime = 0;
        let lastVolume = ahdsr[0]?.volume ?? 1;
        for (const stage of ahdsr){
            const { duration: stageDuration, volume: stageVolume } = stage;
            if (stageDuration <= 0) continue;
            const remainingTime = duration - lastTime;
            if (stageDuration > remainingTime) {
                const ratio = remainingTime / stageDuration;
                const interpolatedVolume = lastVolume + ratio * (stageVolume - lastVolume);
                envelope.gain.exponentialRampToValueAtTime(this.#noZeroVolume(volume * interpolatedVolume), when + duration);
                break;
            }
            lastTime += stageDuration;
            lastVolume = stageVolume;
            envelope.gain.exponentialRampToValueAtTime(this.#noZeroVolume(volume * lastVolume), when + lastTime);
        }
        envelope.gain.exponentialRampToValueAtTime(this.#nearZero, when + duration + this.#afterTime);
    }
    #findEnvelope(destinationNode) {
        const target = destinationNode || this.#mainGain;
        const now = this.#audioCtx.currentTime;
        let envelope = this.#envelopes.find((e)=>e.target === target && now > e.when + e.duration + 0.05);
        if (!envelope && this.#envelopes.length >= 64) {
            const activeEnvelopes = this.#envelopes.filter((e)=>e.target === target);
            if (activeEnvelopes.length > 0) {
                activeEnvelopes.sort((a, b)=>a.when - b.when);
                envelope = activeEnvelopes[0];
            }
        }
        if (envelope) {
            if (envelope.audioBufferSourceNode) {
                try {
                    envelope.audioBufferSourceNode.stop(0);
                    envelope.audioBufferSourceNode.disconnect();
                } catch (e) {}
                envelope.audioBufferSourceNode = null;
            }
            envelope.gain.cancelScheduledValues(0);
            envelope.gain.setValueAtTime(this.#nearZero, now);
        } else {
            envelope = this.#audioCtx.createGain();
            envelope.gain.value = 0;
            envelope.target = target;
            envelope.connect(target);
            this.#envelopes.push(envelope);
        }
        envelope.cancel = (force = false)=>{
            const currentTime = this.#audioCtx.currentTime;
            if (force && envelope.audioBufferSourceNode) {
                try {
                    envelope.audioBufferSourceNode.stop(0);
                    envelope.audioBufferSourceNode.disconnect();
                } catch (e) {}
                envelope.audioBufferSourceNode = null;
            }
            if (envelope.when + envelope.duration > currentTime) {
                envelope.gain.cancelScheduledValues(0);
                envelope.gain.setTargetAtTime(this.#nearZero, currentTime, force ? 5e-3 : 0.02);
                envelope.when = currentTime + 1e-5;
                envelope.duration = 0;
            }
        };
        return envelope;
    }
    #findZone(pitch) {
        return this.#preset.zones.findLast((z)=>pitch >= z.keyRangeLow && pitch <= z.keyRangeHigh);
    }
    #limitVolume(v) {
        const requestedVolume = v ? 1 * v : 0.5;
        return Math.min(requestedVolume, 0.8);
    }
    #noZeroVolume(n) {
        return n > this.#nearZero ? n : this.#nearZero;
    }
    #numValue(a, b) {
        return typeof a === "number" ? a : b;
    }
};
// index.js
if (typeof window !== "undefined") window.WebAudioFontPlayer = $754e97c22ba7d8ce$export$4a8742344a4ab44f;
var $754e97c22ba7d8ce$export$2e2bcd8739ae039 = $754e97c22ba7d8ce$export$4a8742344a4ab44f;

});



var $8a6c7482e66335c8$exports = {};
$parcel$extendImportMap({
    "cgPKr": "playhead_long.6120a9a9.svg"
});

// Javascript main files
parcelRequire("iJ8Ef");
parcelRequire("Lbl7Y");

var $9xysn = parcelRequire("9xysn");
parcelRequire("avF0V");
parcelRequire("lsfK2");

var $7baak = parcelRequire("7baak");

var $2cXDZ = parcelRequire("2cXDZ");

var $kmdF6 = parcelRequire("kmdF6");
const $4b3bf5659cef0faf$var$colorMap = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).deepRed,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).orange,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).green,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).blue,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).deepViolet,
    (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).pink
];
customElements.define("gruf-pianoroll", class Pianoroll extends HTMLElement {
    constructor(){
        super();
    }
    defineprop() {
        const plist = this.module.properties;
        for(let k in plist){
            const v = plist[k];
            this["_" + k] = this.getAttr(k, v.value);
            Object.defineProperty(this, k, {
                get: ()=>{
                    return this["_" + k];
                },
                set: (val)=>{
                    this["_" + k] = val;
                    if (typeof this[v.observer] == "function") this[v.observer]();
                }
            });
        }
    }
    connectedCallback() {
        let root;
        //        if(this.attachShadow)
        //          root=this.attachShadow({mode: 'open'});
        //        else
        root = this;
        this.module = {
            is: "gruf-pianoroll",
            properties: {
                width: {
                    type: Number,
                    value: 640,
                    observer: 'layout'
                },
                height: {
                    type: Number,
                    value: 320,
                    observer: 'layout'
                },
                veledith: {
                    type: Number,
                    value: 40,
                    observer: 'layout'
                },
                timebase: {
                    type: Number,
                    value: 16,
                    observer: 'layout'
                },
                editmode: {
                    type: String,
                    value: "dragpoly"
                },
                instrumentid: {
                    type: String,
                    value: 'undefined'
                },
                colorcodemode: {
                    type: String,
                    value: "none",
                    observer: 'layout'
                },
                scaletype: {
                    type: String,
                    value: "minor",
                    observer: 'layout'
                },
                rootpc: {
                    type: Number,
                    value: 0,
                    observer: 'layout'
                },
                hovernote: {
                    type: Number,
                    value: undefined,
                    observer: 'redrawRulers'
                },
                externalnoteons: {
                    type: Set,
                    value: new Set(),
                    observer: 'layout'
                },
                xrange: {
                    type: Number,
                    value: 16,
                    observer: 'layout'
                },
                yrange: {
                    type: Number,
                    value: 16,
                    observer: 'layout'
                },
                xoffset: {
                    type: Number,
                    value: 0,
                    observer: 'layout'
                },
                yoffset: {
                    type: Number,
                    value: 60,
                    observer: 'layout'
                },
                grid: {
                    type: Number,
                    value: 4
                },
                snap: {
                    type: Number,
                    value: 1
                },
                wheelzoom: {
                    type: Number,
                    value: 0
                },
                wheelzoomx: {
                    type: Number,
                    value: 0
                },
                wheelzoomy: {
                    type: Number,
                    value: 0
                },
                xscroll: {
                    type: Number,
                    value: 0
                },
                yscroll: {
                    type: Number,
                    value: 0
                },
                xruler: {
                    type: Number,
                    value: 24,
                    observer: 'layout'
                },
                xrulerbeats: {
                    type: Boolean,
                    value: true,
                    observer: 'layout'
                },
                yruler: {
                    type: Number,
                    value: 24,
                    observer: 'layout'
                },
                octadj: {
                    type: Number,
                    value: -1
                },
                cursor: {
                    type: Number,
                    value: 0,
                    observer: 'redrawMarker'
                },
                markstart: {
                    type: Number,
                    value: 0,
                    observer: 'redrawMarker'
                },
                markend: {
                    type: Number,
                    value: 16,
                    observer: 'redrawMarker'
                },
                defvelo: {
                    type: Number,
                    value: 127
                },
                collt: {
                    type: String,
                    value: "#ccc"
                },
                coldk: {
                    type: String,
                    value: "#aaa"
                },
                colgrid: {
                    type: String,
                    value: "#666"
                },
                accentColor: {
                    type: String,
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).grey
                },
                colnotedissalowed: {
                    type: String,
                    value: "#333"
                },
                colnoteborder: {
                    type: String,
                    value: "#000"
                },
                colnoteselborder: {
                    type: String,
                    value: "#fff"
                },
                colrulerbg: {
                    type: String,
                    value: "#666"
                },
                colrulerfg: {
                    type: String,
                    value: "#fff"
                },
                colrulerborder: {
                    type: String,
                    value: "#000"
                },
                colselarea: {
                    type: String,
                    value: "rgba(0,0,0,0.3)"
                },
                bgsrc: {
                    type: String,
                    value: null,
                    observer: 'layout'
                },
                cursorsrc: {
                    type: String,
                    value: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj4NCjxwYXRoIGZpbGw9InJnYmEoMjU1LDEwMCwxMDAsMC44KSIgZD0iTTAsMSAyNCwxMiAwLDIzIHoiLz4NCjwvc3ZnPg0K"
                },
                cursoroffset: {
                    type: Number,
                    value: 0
                },
                markstartsrc: {
                    type: String,
                    value: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9IiMwYzAiIGQ9Ik0wLDEgMjQsMSAwLDIzIHoiLz4NCjwvc3ZnPg0K"
                },
                markstartoffset: {
                    type: Number,
                    value: 0
                },
                markendsrc: {
                    type: String,
                    value: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9IiMwYzAiIGQ9Ik0wLDEgMjQsMSAyNCwyMyB6Ii8+DQo8L3N2Zz4NCg=="
                },
                markendoffset: {
                    type: Number,
                    value: -24
                },
                kbsrc: {
                    type: String,
                    value: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSI0ODAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPgo8cGF0aCBmaWxsPSIjZmZmIiBzdHJva2U9IiMwMDAiIGQ9Ik0wLDAgaDI0djQ4MGgtMjR6Ii8+CjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0wLDQwIGgxMnY0MGgtMTJ6IE0wLDEyMCBoMTJ2NDBoLTEyeiBNMCwyMDAgaDEydjQwaC0xMnogTTAsMzIwIGgxMnY0MGgtMTJ6IE0wLDQwMCBoMTJ2NDBoLTEyeiIvPgo8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIGQ9Ik0wLDYwIGgyNCBNMCwxNDAgaDI0IE0wLDIyMCBoMjQgTTAsMjgwIGgyNCBNMCwzNDAgaDI0IE0wLDQyMCBoMjQiLz4KPC9zdmc+Cg==",
                    observer: 'layout'
                },
                kbwidth: {
                    type: Number,
                    value: 80
                },
                kbstyle: {
                    type: String,
                    value: "piano"
                },
                enable: {
                    type: Boolean,
                    value: true
                }
            }
        };
        this.defineprop();
        root.innerHTML = `<style>
.pianoroll{
    background:#ccc;
}
:host {
    user-select: none;
    display: inline-block;
    font-family: sans-serif;
    font-size: 11px;
    padding:0;
    margin:0;
}
#wac-body {
    position: relative;
    margin:0;
    padding:0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
#wac-pianoroll {
    cursor: pointer;
    margin:0;
    padding:0;
    width: 100%;
    height: 100%;
    background-size:100% calc(100%*12/16);
    background-position:left bottom;
    border-radius: 4px;
}
.marker{
    position: absolute;
    left:0px;
    top:0px;
    cursor:ew-resize;
}
#wac-kb{
    position:absolute;
    left:0px;
    top:0px;
    width:0px;
    height:100%;
    background: repeat-y;
    background-size:100% calc(100%*12/16);
    background-position:left bottom;
    display:none;  /* not entirely sure what happens with wac-kb object, but if we don't hide it, it intercepts wanted pointer events */
}
#wac-cursor{
    width:3px;
    }
    </style>
    <div class="wac-body" id="wac-body" touch-action="none">
    <canvas id="wac-pianoroll" touch-action="none" tabindex="0"></canvas>
    <div id="wac-kb"></div>
    <img id="wac-markstart" class="marker" src="${this.markstartsrc}"/>
    <img id="wac-markend" class="marker" src="${this.markendsrc}"/>
    <img id="wac-cursor" class="marker" src="${this.cursorsrc}"/>
    </div>`;
        this.sortSequence = function() {
            this.sequence.sort((x, y)=>{
                return x.t - y.t;
            });
        };
        this.findNextEv = function(tick) {
            for(let i = 0; i < this.sequence.length; ++i){
                const nev = this.sequence[i];
                if (nev.t >= this.markend) return {
                    t1: tick,
                    n2: this.markend,
                    dt: this.markend - tick,
                    i: -1
                };
                if (nev.t >= tick) return {
                    t1: tick,
                    t2: nev.t,
                    dt: nev.t - tick,
                    i: i
                };
            }
            return {
                t1: tick,
                t2: this.markend,
                dt: this.markend - tick,
                i: -1
            };
        };
        this.locate = function(tick) {
            this.cursor = tick;
        };
        this.setRootPC = (rootpc)=>this.rootpc = rootpc;
        this.setScaleType = (scaletype)=>this.scaletype = scaletype;
        this.setColorCodeMode = (colorcodemode)=>this.colorcodemode = colorcodemode;
        this.setXRange = (xrange)=>this.xrange = xrange;
        this.setDimensions = ({ width: width, height: height })=>{
            this.width = width;
            this.height = height;
        };
        this.hitTest = function(pos) {
            const ht = {
                i: -1,
                n: (0, $kmdF6.clamp)(this.yoffset - (pos.y - this.sheight - this.xruler) / this.steph, ...this.displayPitchRange),
                v: 127 - (pos.y - this.xruler - this.sheight) / this.veledith * 127,
                t: (0, $kmdF6.clamp)(this.xoffset + (pos.x - this.yruler - this.kbwidth) / this.swidth * this.xrange, ...this.displayTimeRange)
            };
            if (pos.y >= this.height || pos.x >= this.width) return ht;
            if (pos.y < this.xruler) {
                ht.m = "x";
                return ht;
            }
            if (pos.x < this.yruler + this.kbwidth && pos.y < this.xruler + this.sheight) {
                ht.m = "y";
                return ht;
            }
            if (this.xruler + this.sheight < pos.y) {
                if (pos.x < this.yruler + this.kbwidth) {
                    ht.m = "vx";
                    return ht;
                }
                // mouse down on the velocity section
                // first, try with circle handles
                for (const ev of this.getDisplayedSequenceSection())if (Math.abs(ev.t - ht.t) * this.stepw < 8 && Math.abs((ev.v ?? this.defvelo) - ht.v) < 10) {
                    ht.m = ev.f ? "V" : "v";
                    ht.i = this.sequence.indexOf(ev);
                    return ht;
                }
                // then, with the tails
                for (const ev of this.getDisplayedSequenceSection())if (ev.t < ht.t && ht.t < ev.t + ev.g && Math.abs((ev.v ?? this.defvelo) - ht.v) < 10) {
                    ht.m = ev.f ? "V" : "v";
                    ht.i = this.sequence.indexOf(ev);
                    return ht;
                }
                ht.m = "vs";
                return ht;
            }
            const l = this.sequence.length;
            for(let i = 0; i < l; ++i){
                const ev = this.sequence[i];
                if ((ht.n | 0) == ev.n) {
                    if (ev.f && Math.abs(ev.t - ht.t) * this.stepw < 8) {
                        ht.m = "B";
                        ht.i = i;
                        return ht;
                    }
                    if (ev.f && Math.abs(ev.t + ev.g - ht.t) * this.stepw < 8) {
                        ht.m = "E";
                        ht.i = i;
                        return ht;
                    }
                    if (ht.t >= ev.t && ht.t < ev.t + ev.g) {
                        ht.i = i;
                        if (this.sequence[i].f) ht.m = "N";
                        else ht.m = "n";
                        return ht;
                    }
                }
            }
            ht.m = "s";
            return ht;
        };
        this.triggerPostEditEvent = function() {
            const event = new CustomEvent("pianoRollEdited", {
                detail: this.sequence
            });
            this.dispatchEvent(event);
        };
        this.getNextAvailableID = function() {
            const sortedCurrentIDs = this.sequence.map((note)=>note.id).sort((a, b)=>a - b);
            for(let i = 0; i < sortedCurrentIDs.length; i++){
                if (i !== sortedCurrentIDs[i]) return i; // si hi ha un forat, l'emplenem
            }
            return sortedCurrentIDs.length; // si no, i la lista és compacta, simplement afegim un
        };
        this.addNote = function(t, n, g, v, f) {
            if (t >= 0 && n >= 0 && n < 128) {
                const ev = {
                    t: t,
                    n: n,
                    g: g,
                    v: v,
                    f: f,
                    id: this.getNextAvailableID()
                };
                this.sequence.push(ev);
                this.sortSequence();
                this.triggerPostEditEvent();
                this.redraw();
                return ev;
            }
            this.triggerPostEditEvent();
            return null;
        };
        this.selAreaNote = function(t1, t2, n1, n2) {
            let t, i = 0, e = this.sequence[i];
            if (n1 > n2) t = n1, n1 = n2, n2 = t;
            if (t1 > t2) t = t1, t1 = t2, t2 = t;
            n1 = Math.floor(n1); // Select all notes that are touching the down edge of the area
            while(e){
                if (e.t + e.g >= t1 && e.t < t2 && e.n >= n1 && e.n <= n2) this.selectNote(e);
                else this.deselectNote(e);
                e = this.sequence[++i];
            }
        };
        this.selAreaVelocity = function(t1, t2, v1, v2) {
            let tmp;
            if (v1 > v2) tmp = v1, v1 = v2, v2 = tmp;
            if (t1 > t2) tmp = t1, t1 = t2, t2 = tmp;
            this.getDisplayedSequenceSection().forEach((ev)=>{
                if (t1 <= ev.t + ev.g && ev.t <= t2 && v1 <= (ev.v ?? this.defvelo) && (ev.v ?? this.defvelo) <= v2) this.selectNote(ev);
                else this.deselectNote(ev);
            });
        };
        this.selectNote = function(e) {
            e.f = 1;
        };
        this.deselectNote = function(e) {
            e.f = 0;
        };
        this.toggleNoteSelection = function(e) {
            if (e.f === 0) this.selectNote(e);
            else this.deselectNote(e);
        };
        this.delNote = function(idx) {
            this.sequence.splice(idx, 1);
            this.triggerPostEditEvent();
            this.redraw();
        };
        this.delAreaNote = function(t, g, n) {
            const l = this.sequence.length;
            for(let i = l - 1; i >= 0; --i){
                const ev = this.sequence[i];
                if (typeof n != "undefined" && n != i) {
                    if (t <= ev.t && t + g >= ev.t + ev.g) this.sequence.splice(i, 1);
                    else if (t <= ev.t && t + g > ev.t && t + g < ev.t + ev.g) {
                        ev.g = ev.t + ev.g - (t + g);
                        ev.t = t + g;
                    } else if (t >= ev.t && t < ev.t + ev.g && t + g >= ev.t + ev.g) ev.g = t - ev.t;
                    else if (t > ev.t && t + g < ev.t + ev.g) {
                        this.addNote(t + g, ev.n, ev.t + ev.g - t - g, this.defvelo);
                        ev.g = t - ev.t;
                    }
                }
            }
            this.triggerPostEditEvent();
        };
        this.delSelectedNote = function() {
            const l = this.sequence.length;
            for(let i = l - 1; i >= 0; --i){
                const ev = this.sequence[i];
                if (ev.f) this.sequence.splice(i, 1);
            }
            this.triggerPostEditEvent();
        };
        this.moveSelectedNote = function(dt, dn) {
            const l = this.sequence.length;
            for(let i = 0; i < l; ++i){
                const ev = this.sequence[i];
                if (ev.f && ev.t + dt < 0) dt = -ev.t;
            }
            for(let i = 0; i < l; ++i){
                const ev = this.sequence[i];
                if (ev.f) {
                    ev.t = ((ev.t + dt) / this.snap + .5 | 0) * this.snap;
                    ev.n = ev.n + dn;
                }
            }
        };
        this.changeVelocityOfSelectedNote = function(dv) {
            this.sequence.forEach((ev)=>{
                if (ev.f) ev.v = (0, $kmdF6.clamp)((ev.v ?? this.defvelo) + dv, 0, 127);
            });
        };
        this.clearSel = function() {
            const l = this.sequence.length;
            for(let i = 0; i < l; ++i)this.deselectNote(this.sequence[i]);
        };
        this.selectedNotes = function() {
            let obj = [];
            for(let i = this.sequence.length - 1; i >= 0; --i){
                const ev = this.sequence[i];
                if (ev.f) obj.push({
                    i: i,
                    ev: ev,
                    t: ev.t,
                    g: ev.g
                });
            }
            return obj;
        };
        this.editDragDown = function(pos) {
            const ht = this.hitTest(pos);
            let ev;
            if (ht.m == "N") {
                ev = this.sequence[ht.i];
                this.dragging = {
                    o: "D",
                    m: "N",
                    i: ht.i,
                    t: ht.t,
                    n: ev.n,
                    dt: ht.t - ev.t + 1
                };
                this.redraw();
            } else if (ht.m == "n") {
                ev = this.sequence[ht.i];
                this.clearSel();
                this.selectNote(ev);
                this.redraw();
            } else if (ht.m == "E") {
                const ev = this.sequence[ht.i];
                this.dragging = {
                    o: "D",
                    m: "E",
                    i: ht.i,
                    t: ev.t,
                    g: ev.g,
                    ev: this.selectedNotes()
                };
            } else if (ht.m == "B") {
                const ev = this.sequence[ht.i];
                this.dragging = {
                    o: "D",
                    m: "B",
                    i: ht.i,
                    t: ev.t,
                    g: ev.g,
                    ev: this.selectedNotes()
                };
            } else if (ht.m == "s" && ht.t >= 0) {
                this.clearSel();
                var t = (ht.t / this.snap | 0) * this.snap;
                this.sequence.push({
                    t: t,
                    n: ht.n | 0,
                    g: 1,
                    f: 1,
                    id: this.getNextAvailableID()
                });
                this.dragging = {
                    o: "D",
                    m: "E",
                    i: this.sequence.length - 1,
                    t: t,
                    g: 1,
                    ev: [
                        {
                            t: t,
                            g: 1,
                            ev: this.sequence[this.sequence.length - 1]
                        }
                    ]
                };
                this.triggerPostEditEvent();
                this.redraw();
            } else if (ht.m == "v" || ht.m == "V") {
                const ev = this.sequence[ht.i];
                this.dragging = {
                    o: "D",
                    m: "V",
                    i: ht.i,
                    v: ev.v ?? this.defvelo
                };
                if (ht.m == "v") {
                    this.clearSel();
                    this.selectNote(ev);
                    this.redraw();
                }
            } else if (ht.m == "vx") this.dragging = {
                o: "static"
            };
        };
        this.editDragMove = function(pos) {
            const ht = this.hitTest(pos);
            let ev, t;
            if (this.dragging.o == "D") switch(this.dragging.m){
                case "E":
                    if (this.dragging.ev) {
                        const dt = (Math.max(0, ht.t) / this.snap + 0.9 | 0) * this.snap - this.dragging.t - this.dragging.g;
                        if (dt === 0) break;
                        const list = this.dragging.ev;
                        for(let i = list.length - 1; i >= 0; --i){
                            const ev = list[i].ev;
                            ev.g = list[i].g + dt;
                            if (ev.g <= 0) ev.g = 1;
                            if (this.editmove == "dragmono") this.delAreaNote(ev.t, ev.g);
                        }
                        this.dragging.g = this.sequence[this.dragging.i].g;
                        this.dragging.t = this.sequence[this.dragging.i].t;
                        this.dragging.ev = this.selectedNotes();
                    }
                    this.redraw();
                    this.triggerPostEditEvent();
                    break;
                case "B":
                    if (this.dragging.ev) {
                        const dt = (Math.max(0, ht.t) / this.snap + 0.9 | 0) * this.snap - this.dragging.t;
                        if (dt === 0) break;
                        const list = this.dragging.ev;
                        for(let i = list.length - 1; i >= 0; --i){
                            const ev = list[i].ev;
                            ev.t = list[i].t + dt;
                            ev.g = list[i].g - dt;
                            if (ev.g <= 0) ev.g = 1;
                            if (this.editmove == "dragmono") this.delAreaNote(ev.t, ev.g);
                        }
                        this.dragging.t = this.sequence[this.dragging.i].t;
                        this.dragging.ev = this.selectedNotes();
                    }
                    this.redraw();
                    this.triggerPostEditEvent();
                    break;
                case "N":
                    if (this.notesDueDuplicate) {
                        this.notesDueDuplicate = false;
                        const selectedNotes = this.selectedNotes();
                        this.clearSel(); // we will leave the olf notes on place
                        for (const note of selectedNotes)this.addNote(note.ev.t, note.ev.n, note.ev.g, note.ev.v, 1); // ..and select the new notes
                    }
                    ev = this.sequence[this.dragging.i];
                    const dt = ht.t - this.dragging.t | 0; // |0 is the same as Math.floor
                    const dn = (ht.n | 0) - this.dragging.n;
                    if (dt === 0 && dn === 0) break;
                    this.moveSelectedNote(dt, dn);
                    this.dragging.t = this.dragging.t + dt;
                    this.dragging.n = this.dragging.n + dn;
                    this.triggerPostEditEvent();
                    this.redraw();
                    break;
                case "V":
                    const ev1 = this.sequence[this.dragging.i];
                    const dv = ht.v - this.dragging.v | 0;
                    if (dv === 0) break;
                    this.changeVelocityOfSelectedNote(dv);
                    this.dragging.v += dv;
                    this.triggerPostEditEvent();
                    this.redraw();
                    break;
            }
        };
        this.setListener = function(el, mode) {
            this.bindcontextmenu = this.contextmenu.bind(this);
            this.bindpointermove = this.pointermove.bind(this);
            this.bindcancel = this.cancel.bind(this);
            el.addEventListener("pointerdown", this.pointerdown.bind(this), false);
            if (mode) {
                el.addEventListener("pointerover", this.pointerover.bind(this), false);
                el.addEventListener("pointerout", this.pointerout.bind(this), false);
            }
        };
        this.ready = function() {
            this.body = root.children[1];
            this.elem = root.childNodes[2];
            this.canvas = this.elem.children[0];
            this.kb = this.elem.children[1];
            this.ctx = this.canvas.getContext("2d");
            this.kbimg = this.elem.children[1];
            this.markstartimg = this.elem.children[2];
            this.markendimg = this.elem.children[3];
            this.cursorimg = this.elem.children[4];
            this.cursorimg.style.height = this.height + "px";
            this.cursorimg.style.width = '3px';
            this.rcMenu = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            this.lastx = 0;
            this.lasty = 0;
            this.canvas.addEventListener('mousemove', this.mousemove.bind(this), false);
            this.canvas.addEventListener('keydown', this.keydown.bind(this), false);
            this.canvas.addEventListener('DOMMouseScroll', this.wheel.bind(this), false);
            this.canvas.addEventListener('mousewheel', this.wheel.bind(this), false);
            this.setListener(this.canvas, true);
            this.setListener(this.markendimg, true);
            this.setListener(this.markstartimg, true);
            this.setListener(this.cursorimg, true);
            this.sequence = [];
            this.dragging = {
                o: null
            };
            this.layout();
            document.addEventListener("midiNote-" + this.instrumentid, this.onmidinote.bind(this));
            this.initialized = 1;
            this.redraw();
            this.pitchesAssignedToPointers = new Map();
        };
        this.setupImage = function() {};
        this.preventScroll = function(e) {
            if (e.preventDefault) e.preventDefault();
        };
        this.getPos = function(e) {
            let t = null;
            if (e) {
                t = e.target;
                this.lastx = e.clientX - this.rcTarget.left;
                this.lasty = e.clientY - this.rcTarget.top;
            }
            return {
                t: t,
                x: this.lastx,
                y: this.lasty
            };
        };
        this.contextmenu = function(e) {
            e.stopPropagation();
            e.preventDefault();
            window.removeEventListener("contextmenu", this.bindcontextmenu);
            return false;
        };
        this.keydown = function(e) {
            switch(e.key){
                case "Delete":
                case "Backspace":
                    this.delSelectedNote();
                    this.redraw();
                    break;
            }
        };
        this.onmidinote = function(e) {
            const pitch = e.detail.pitch;
            if (e.detail.type == 'noteOff') this.externalnoteons.delete(pitch);
            else this.externalnoteons.add(pitch);
            this.externalnoteons = new Set(this.externalnoteons);
        };
        this.longtapcountup = function() {
            if (++this.longtapcount >= 18) clearInterval(this.longtaptimer);
        };
        this.getKbTapNote = function() {
            const pos = this.downpos;
            const isInside = pos.x > this.yruler && pos.x < this.kbwidth + this.yruler && this.xruler < pos.y && pos.y <= this.xruler + this.sheight;
            if (!isInside) return null;
            const pitch = Math.round(this.downht.n);
            const velocity = Math.round((pos.x - this.yruler) / this.kbwidth * 127);
            return {
                pitch: pitch,
                velocity: velocity
            };
        };
        this.pointerdown = function(ev) {
            let e;
            if (!this.enable) return;
            if (ev.touches) e = ev.touches[0];
            else e = ev;
            const time = Date.now();
            const isDoubleClick = time - this.lastPointerDownTime < 500;
            this.lastPointerDownTime = isDoubleClick ? -1 : time;
            this.rcTarget = this.canvas.getBoundingClientRect();
            const pos = this.getPos(e);
            const ht = this.hitTest(pos);
            this.downpos = pos;
            this.downht = ht;
            // Save current data of the selected note, as it will be later used to determine if the note was dragged or not
            const selectedNoteIds = this.selectedNotes().map((note)=>note.i);
            if (selectedNoteIds.indexOf(this.downht.i) > -1) this.hitNoteInitialData = {
                idx: this.downht.i,
                seq: {
                    ...this.sequence[this.downht.i]
                },
                time: Date.now() / 1000
            };
            else this.hitNoteInitialData = undefined;
            this.longtapcount = 0;
            this.longtaptimer = setInterval(this.longtapcountup.bind(this), 100);
            this.notesDueDuplicate = e.altKey;
            window.addEventListener("pointermove", this.bindpointermove, false);
            window.addEventListener("pointerup", this.bindcancel);
            window.addEventListener("contextmenu", this.bindcontextmenu);
            if (isDoubleClick) return this.doubleclick(e);
            if (ht.m === "s") {
                this.dragging = {
                    o: "A",
                    p: this.downpos,
                    p2: this.downpos,
                    t1: this.downht.t,
                    n1: this.downht.n
                };
                ev.preventDefault();
                ev.stopPropagation();
                this.canvas.focus();
                return false;
            } else if (ht.m === "vs") {
                this.dragging = {
                    o: "vA",
                    p: this.downpos,
                    p2: this.downpos,
                    t1: this.downht.t,
                    v1: this.downht.v
                };
                ev.preventDefault();
                ev.stopPropagation();
                this.canvas.focus();
                return false;
            }
            switch(e.target){
                case this.markendimg:
                    this.dragging = {
                        o: "E",
                        x: this.downpos.x,
                        m: this.markend
                    };
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                case this.markstartimg:
                    this.dragging = {
                        o: "S",
                        x: this.downpos.x,
                        m: this.markstart
                    };
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                case this.cursorimg:
                    this.dragging = {
                        o: "P",
                        x: this.downpos.x,
                        m: this.cursor
                    };
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
            }
            this.dragging = {
                o: null,
                x: this.downpos.x,
                y: this.downpos.y,
                offsx: this.xoffset,
                offsy: this.yoffset
            };
            this.canvas.focus();
            if (ev.shiftKey && (ht.m === "n" || ht.m === "N")) return this.toggleNoteSelection(this.sequence[ht.i]);
            // If the user clicked on the keyboard, send a noteOn event
            const kbNote = this.getKbTapNote();
            if (kbNote != null) {
                const { pitch: pitch, velocity: velocity } = kbNote;
                this.pitchesAssignedToPointers.set(ev.pointerId, pitch);
                const event = new CustomEvent("pianoRollKeyboardNote", {
                    detail: {
                        pitch: pitch,
                        velocity: velocity,
                        noteOff: false
                    }
                });
                this.dispatchEvent(event);
            } else this.editDragDown(this.downpos); // named because there was an editGridDown
            this.press = 1;
            if (ev.preventDefault) ev.preventDefault();
            if (ev.stopPropagation) ev.stopPropagation();
            return false;
        };
        this.doubleclick = function(e) {
            const pos = this.getPos(e);
            if (this.getKbTapNote() != null) return;
            const ht = this.hitTest(pos);
            if (ht.m == "N") this.delNote(ht.i); // checking for ht.m equals "B" or "E" enters in drag mode, deleting it and then moving the mouse crashes the component. bitwig creates a note when double clicking even if the single clicking and dragging would change the length
            else this.editDragDown(this.downpos);
        };
        this.mousemove = function(e) {
            if (this.dragging.o == null) {
                this.rcTarget = this.canvas.getBoundingClientRect();
                const pos = this.getPos(e);
                const ht = this.hitTest(pos);
                if (!this.press) this.hovernote = Math.floor(ht.n);
                switch(ht.m){
                    case "E":
                        this.canvas.style.cursor = "e-resize";
                        break;
                    case "B":
                        this.canvas.style.cursor = "w-resize";
                        break;
                    case "N":
                        this.canvas.style.cursor = "move";
                        break;
                    case "n":
                        this.canvas.style.cursor = "pointer";
                        break;
                    case "s":
                        this.canvas.style.cursor = "pointer";
                        break;
                }
            }
        };
        this.pointermove = function(ev) {
            let e;
            this.rcTarget = this.canvas.getBoundingClientRect();
            if (ev.touches) e = ev.touches[0];
            else e = ev;
            if (this.longtaptimer) clearInterval(this.longtaptimer);
            const pos = this.getPos(e);
            const ht = this.hitTest(pos);
            if (this.dragging.o !== null) this.hovernote = Math.floor(ht.n);
            else this.hovernote = undefined; // we don't want to update when scrolling vertically because it's jittery
            switch(this.dragging.o){
                case null:
                    if (this.xscroll) this.xoffset = this.dragging.offsx + (this.dragging.x - pos.x) * (this.xrange / this.width);
                    if (this.yscroll) this.yoffset = this.dragging.offsy + (pos.y - this.dragging.y) * (this.yrange / this.height);
                    break;
                case "A":
                case "vA":
                    this.dragging.p2 = pos;
                    this.dragging.t2 = ht.t;
                    if (this.dragging.o === "A") this.dragging.n2 = ht.n;
                    else if (this.dragging.o === "vA") this.dragging.v2 = ht.v;
                    this.redraw();
                    break;
                case "E":
                    var p = Math.max(1, this.dragging.m + (pos.x - this.dragging.x) / this.stepw + .5 | 0);
                    if (this.markstart >= p) this.markstart = p - 1;
                    this.markend = p;
                    break;
                case "S":
                    var p = Math.max(0, this.dragging.m + (pos.x - this.dragging.x) / this.stepw + .5 | 0);
                    if (this.markend <= p) this.markend = p + 1;
                    this.markstart = p;
                    break;
                case "P":
                    this.cursor = Math.max(0, this.dragging.m + (pos.x - this.dragging.x) / this.stepw + .5 | 0);
                    break;
            }
            this.editDragMove(pos);
            //            ev.preventDefault();
            ev.stopPropagation();
            return false;
        };
        this.cancel = function(ev) {
            let e;
            if (ev.touches) e = null;
            else e = ev;
            if (this.longtaptimer) clearInterval(this.longtaptimer);
            const pos = this.getPos(e);
            if (this.dragging.o == "A") {
                this.selAreaNote(this.dragging.t1, this.dragging.t2, this.dragging.n1, this.dragging.n2);
                this.dragging = {
                    o: null
                };
                this.redraw();
            }
            if (this.dragging.o == "vA") {
                this.selAreaVelocity(this.dragging.t1, this.dragging.t2, this.dragging.v1, this.dragging.v2);
                this.dragging = {
                    o: null
                };
                this.redraw();
            }
            //            if(this.dragging.o=="D"){
            if (this.editmode == "dragmono") for(let ii = this.sequence.length - 1; ii >= 0; --ii){
                const ev = this.sequence[ii];
                if (ev && ev.f) this.delAreaNote(ev.t, ev.g, ii);
            }
            this.redraw();
            //            }
            this.dragging = {
                o: null
            };
            if (this.press) this.sortSequence();
            const ht = this.hitTest(pos);
            // If the pointer was bound to a piano keyboard note, send a noteOff event
            if (this.pitchesAssignedToPointers.has(ev.pointerId)) {
                const pitch = this.pitchesAssignedToPointers.get(ev.pointerId);
                this.pitchesAssignedToPointers.delete(ev.pointerId);
                const event = new CustomEvent("pianoRollKeyboardNote", {
                    detail: {
                        pitch: pitch,
                        noteOff: true
                    }
                });
                this.dispatchEvent(event);
            }
            const noteSquenceData = this.sequence[ht.i];
            if (noteSquenceData !== undefined) {
                const event = new CustomEvent("pianoRollNoteSelectedOrCreated", {
                    detail: {
                        pitch: noteSquenceData.n,
                        velocity: noteSquenceData.v ?? this.defvelo,
                        durationInBeats: noteSquenceData.g
                    }
                });
                this.dispatchEvent(event);
            }
            this.press = 0;
            //            this.mousemove(e);
            window.removeEventListener("pointermove", this.bindpointermove, false);
            window.removeEventListener("pointerup", this.bindcancel, false);
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        };
        this.pointerover = function(e) {};
        this.pointerout = function(e) {
            this.hovernote = undefined;
        };
        this.wheel = function(e) {
            let delta = 0;
            const pos = this.getPos(e);
            if (!e) e = window.event;
            if (e.wheelDelta) delta = e.wheelDelta / 120;
            else if (e.detail) delta = -e.detail / 3;
            const ht = this.hitTest(pos);
            if ((this.wheelzoomx || this.wheelzoom) && ht.m == "x") {
                if (delta > 0) {
                    this.xoffset = ht.t - (ht.t - this.xoffset) / 1.2;
                    this.xrange /= 1.2;
                } else {
                    this.xoffset = ht.t - (ht.t - this.xoffset) * 1.2;
                    this.xrange *= 1.2;
                }
            }
            if ((this.wheelzoomy || this.wheelzoom) && ht.m == "y") {
                if (delta > 0) {
                    this.yoffset = ht.n - (ht.n - this.yoffset) / 1.2;
                    this.yrange /= 1.2;
                } else {
                    this.yoffset = ht.n - (ht.n - this.yoffset) * 1.2;
                    this.yrange *= 1.2;
                }
            }
            e.preventDefault();
        };
        this.layout = function() {
            if (typeof this.kbwidth == "undefined") return;
            const canvas = this.canvas;
            const bodystyle = this.body.style;
            if (this.bgsrc) canvas.style.background = "url('" + this.bgsrc + "')";
            if (this.width) {
                canvas.width = this.width;
                bodystyle.width = canvas.style.width = this.width + "px";
            }
            if (this.height) {
                canvas.height = this.height;
                bodystyle.height = canvas.style.height = this.height + "px";
                this.cursorimg.style.height = this.height + "px";
            }
            this.swidth = canvas.width - this.yruler;
            this.swidth -= this.kbwidth;
            this.sheight = canvas.height - this.veledith - this.xruler;
            this.redraw();
        };
        this.redrawMarker = function() {
            if (!this.initialized) return;
            const cur = (this.cursor - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
            this.cursorimg.style.left = cur + this.cursoroffset + "px";
            const start = (this.markstart - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
            this.markstartimg.style.left = start + this.markstartoffset + "px";
            const end = (this.markend - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
            this.markendimg.style.left = end + this.markendoffset + "px";
        };
        this.redrawGridRow = function(pitch, color) {
            this.ctx.fillStyle = color;
            let ys = this.sheight + this.xruler - (pitch - this.yoffset) * this.steph;
            this.ctx.fillRect(this.yruler + this.kbwidth, ys | 0, this.swidth, -this.steph);
            this.ctx.fillStyle = this.colgrid;
            this.ctx.fillRect(this.yruler + this.kbwidth, ys | 0, this.swidth, 1);
        };
        this.redrawGridRows = function() {
            const scale = (0, $7baak.buildScaleFromRootPitch)(this.rootpc, this.scaletype);
            for(let y = Math.floor(this.displayPitchRange[0]); y <= this.displayPitchRange[1]; ++y){
                let color = y % 2 == 0 ? this.coldk : this.collt;
                if (this.kbstyle === "piano") {
                    const pc = y % 12;
                    const isWhiteKey = [
                        1,
                        0,
                        1,
                        0,
                        1,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1
                    ][pc] === 1;
                    color = isWhiteKey ? this.collt : this.colldk;
                    if (this.colorcodemode === "melodic") {
                        if (scale.includes(pc)) {
                            if (this.scaletype === "major") color = pc === this.rootpc ? (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).deepRed : (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).lightRed;
                            if (this.scaletype === "minor") color = pc === this.rootpc ? (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).deepViolet : (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).lightViolet;
                        } else color = this.collt;
                    } else if (this.colorcodemode === "harmonic") {
                        if (pc === this.rootpc) {
                            if (this.scaletype === "major") color = (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).lightRed;
                            if (this.scaletype === "minor") color = (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).lightViolet;
                        }
                    }
                }
                this.redrawGridRow(y, color);
            }
            if (this.kbstyle === "piano") for (const pitch of this.externalnoteons){
                if (this.colorcodemode === "melodic") this.redrawGridRow(pitch, (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow);
                else if (this.colorcodemode === "harmonic") {
                    const pc = pitch % 12;
                    let majorRootPC = this.rootpc;
                    if (this.scaletype === "minor") majorRootPC += 3;
                    const majorScale = getPCsFromScaleName(majorRootPC, "major");
                    const scalePosition = majorScale.indexOf(pc);
                    if (scalePosition > -1) {
                        const color = $4b3bf5659cef0faf$var$colorMap[scalePosition];
                        const thirdPC = majorScale[(scalePosition + 2) % 7];
                        let thirdPitch = pitch - pc + thirdPC;
                        if (pc > thirdPC) thirdPitch += 12;
                        const fifthPC = majorScale[(scalePosition + 4) % 7];
                        let fifthPitch = pitch - pc + fifthPC;
                        if (pc > fifthPC) fifthPitch += 12;
                        this.redrawGridRow(pitch, color);
                        this.redrawGridRow(thirdPitch, color);
                        this.redrawGridRow(fifthPitch, color);
                    }
                }
            }
        };
        this.redrawGridCols = function() {
            this.ctx.fillStyle = this.colgrid;
            for(let t = 0;; t += this.grid){
                let x = this.stepw * (t - this.xoffset) + this.yruler + this.kbwidth;
                this.ctx.fillRect(x | 0, this.xruler, 1, this.sheight + this.veledith);
                if (x >= this.width) break;
            }
        };
        this.redrawNote = function(ev) {
            const w = ev.g * this.stepw;
            let x = (ev.t - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
            const x2 = x + w | 0;
            x |= 0;
            let y = this.sheight + this.xruler - (ev.n - this.yoffset) * this.steph;
            const y2 = y - this.steph | 0;
            y |= 0;
            let fillColor = this.accentColor;
            if (this.colorcodemode === "melodic") fillColor = (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow;
            let borderColor = fillColor;
            if (ev.f) {
                borderColor = this.colnoteselborder;
                if (this.colorcodemode === "melodic") borderColor = (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).black;
            }
            const opacityHex = Math.floor((0, $kmdF6.scale)(ev.v ?? this.defvelo, 0, 127, 0.4, 1) * 255).toString(16).padStart(2, "0");
            this.ctx.fillStyle = fillColor + opacityHex;
            this.ctx.fillRect(x, y, x2 - x, y2 - y);
            this.ctx.fillStyle = borderColor;
            this.ctx.fillRect(x, y, 1, y2 - y);
            this.ctx.fillRect(x2, y, 1, y2 - y);
            this.ctx.fillRect(x, y, x2 - x, 1);
            this.ctx.fillRect(x, y2, x2 - x, 1);
        };
        this.semiflag = [
            6,
            1,
            0,
            1,
            0,
            2,
            1,
            0,
            1,
            0,
            1,
            0
        ];
        this.redrawXRuler = function() {
            if (!this.xruler) return;
            this.ctx.textAlign = "left";
            this.ctx.font = this.xruler / 2 + "px 'sans-serif'";
            this.ctx.fillStyle = this.colrulerbg;
            this.ctx.fillRect(0, 0, this.width, this.xruler);
            this.ctx.fillStyle = this.colrulerborder;
            this.ctx.fillRect(0, 0, this.width, 1);
            this.ctx.fillRect(0, 0, 1, this.xruler);
            this.ctx.fillRect(0, this.xruler - 1, this.width, 1);
            this.ctx.fillRect(this.width - 1, 0, 1, this.xruler);
            this.ctx.fillStyle = this.colrulerfg;
            const subdiv = this.xrulerbeats ? 4 : 1; // the 4 is because we're on 4/4. would change if the time signature was 2/4, for example
            for(let t0 = 0;; t0 += this.timebase){
                const barNumber = t0 / this.timebase + 1;
                let willBreak = false;
                for(let i = 0; i < subdiv; i++){
                    const t = i * this.timebase / subdiv + t0;
                    const x = (t - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
                    this.ctx.fillRect(x, 0, 1, this.xruler);
                    const text = i === 0 ? barNumber : `${barNumber}.${i + 1}`;
                    this.ctx.fillText(text, x + 4, this.xruler - 8);
                    if (x < this.width) continue;
                    willBreak = true;
                    break;
                }
                if (willBreak) break;
            }
        };
        this.redrawYRuler = function() {
            if (this.yruler) {
                this.ctx.textAlign = "right";
                if (this.kbstyle !== "piano") this.ctx.font = this.steph - 6 + "px Arial";
                else this.ctx.font = this.steph - 1 + "px Arial";
                this.ctx.fillStyle = this.colrulerbg;
                this.ctx.fillRect(0, this.xruler, this.yruler, this.sheight);
                this.ctx.fillStyle = this.colrulerborder;
                this.ctx.fillRect(0, this.xruler, 1, this.sheight);
                this.ctx.fillRect(this.yruler, this.xruler, 1, this.sheight);
                this.ctx.fillRect(0, this.sheight + this.xruler, 1, this.yruler, 1);
                this.ctx.fillStyle = this.colrulerfg;
                if (this.kbstyle === "piano") {
                    for(let y = this.rootpc; y < 128; y += 12){
                        const ys = this.sheight + this.xruler - this.steph * (y - this.yoffset);
                        //this.ctx.fillRect(0,ys|0,this.yruler,-1);
                        this.ctx.fillText((0, $7baak.getNoteName)(y, this.octadj), this.yruler - 2, ys - 1);
                    }
                    if (this.hovernote) {
                        const y = this.hovernote;
                        const ys = this.sheight + this.xruler - this.steph * (y - this.yoffset);
                        this.ctx.fillText((0, $7baak.getNoteName)(y, this.octadj), this.yruler - 2, ys - 1);
                    }
                } else for(let y = 0; y < 128; y += 1){
                    const ys = this.sheight + this.xruler - this.steph * (y - this.yoffset);
                    //this.ctx.fillRect(0,ys|0,this.yruler,-1);
                    this.ctx.fillText(y + 1, this.yruler - 4, ys - 4);
                }
            }
            // draw highlight in notes for sampler mode
            if (this.kbstyle === "midi") {
                this.ctx.fillStyle = this.accentColor + "7f"; // half transparency
                for (const pitch of this.externalnoteons){
                    const ys = this.sheight + this.xruler - this.steph * (pitch + 1 - this.yoffset);
                    this.ctx.fillRect(0, ys, this.yruler, this.steph);
                }
            }
            this.kbimg.style.top = this.xruler + "px";
            this.kbimg.style.left = this.yruler + "px";
            this.kbimg.style.width = this.kbwidth + "px";
        };
        this.redrawRulers = function() {
            this.redrawYRuler();
            this.redrawXRuler();
        };
        this.redrawVelocityBg = function() {
            this.ctx.fillStyle = "black";
            this.ctx.fillRect(0, this.sheight + this.xruler, this.width, this.veledith);
        };
        this.redrawVelocityRuler = function() {
            this.ctx.fillStyle = this.colrulerbg;
            this.ctx.fillRect(0, this.sheight + this.xruler, this.yruler + this.kbwidth, this.veledith);
        };
        this.redrawKey = function(pitch, color, widthMultiplier = 1) {
            const keyHeight = this.steph;
            this.ctx.fillStyle = color;
            let ys = this.sheight + this.xruler - (pitch - this.yoffset) * keyHeight;
            this.ctx.fillRect(this.yruler, ys, this.kbwidth * widthMultiplier, -keyHeight);
            this.ctx.fillStyle = this.colgrid;
            this.ctx.fillRect(this.yruler, ys, this.kbwidth * widthMultiplier, 1);
        };
        this.redrawKeyboard = function() {
            let majorRootPC = this.rootpc;
            if (this.scaletype === "minor") majorRootPC += 3;
            const majorScale = (0, $7baak.buildScaleFromRootPitch)(majorRootPC, "major");
            this.ctx.fillStyle = "white";
            this.ctx.fillRect(this.yruler, 0, this.kbwidth, this.sheight + this.xruler); // background
            for(let n = 0; n < 128; ++n){
                const pitch = n;
                const pc = pitch % 12;
                const isWhiteKey = [
                    1,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1
                ][pc] === 1;
                let color = isWhiteKey ? (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).white : (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).black;
                this.redrawKey(pitch, color);
                if (this.colorcodemode === "harmonic") {
                    const scalePosition = majorScale.indexOf(pc);
                    if (scalePosition > -1) color = $4b3bf5659cef0faf$var$colorMap[scalePosition];
                    this.redrawKey(pitch, color, 0.5);
                }
            }
            for (const pitch of this.externalnoteons){
                if (this.colorcodemode === "none") this.redrawKey(pitch, this.accentColor);
                else if (this.colorcodemode === "melodic") this.redrawKey(pitch, (0, (/*@__PURE__*/$parcel$interopDefault($2cXDZ))).yellow);
            }
        };
        this.redrawAreaSel = function() {
            if (this.dragging && this.dragging.o == "A" || this.dragging.o == "vA") {
                this.ctx.fillStyle = this.colselarea;
                const x1 = this.dragging.p.x;
                const y1 = this.dragging.p.y;
                let x2 = this.dragging.p2.x;
                x2 = (0, $kmdF6.clamp)(x2, this.yruler + this.kbwidth, this.width);
                let y2 = this.dragging.p2.y;
                if (this.dragging.o == "A") y2 = (0, $kmdF6.clamp)(y2, this.yruler, this.yruler + this.sheight);
                else if (this.dragging.o == "vA") y2 = (0, $kmdF6.clamp)(y2, this.yruler + this.sheight, this.height);
                this.ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
            }
        };
        this.getDisplayedSequenceSection = function() {
            return this.sequence.filter((ev)=>this.displayTimeRange[0] < ev.t + ev.g && ev.t < this.displayTimeRange[1] && this.displayPitchRange[0] <= ev.n && ev.n <= this.displayPitchRange[1]);
        };
        this.redrawEvents = function() {
            const selectedEvents = [];
            // first, draw not selected events
            this.getDisplayedSequenceSection().forEach((ev)=>{
                if (ev.f === 0) this.redrawEvent(ev);
                else selectedEvents.push(ev);
            });
            // then, draw selected events
            selectedEvents.forEach((ev)=>this.redrawEvent(ev));
        };
        this.redrawEvent = function(ev) {
            this.redrawNote(ev);
            this.redrawVelocity(ev);
        };
        this.redrawVelocity = function(ev) {
            const handleRadius = 5;
            const w = ev.g * this.stepw;
            let x = (ev.t - this.xoffset) * this.stepw + this.yruler + this.kbwidth;
            const x2 = x + w | 0;
            x |= 0;
            let y = this.height - this.veledith * (ev.v ?? this.defvelo) / 127;
            this.ctx.strokeStyle = this.ctx.fillStyle = this.accentColor;
            this.ctx.lineWidth = 3;
            this.ctx.beginPath();
            this.ctx.moveTo(x + handleRadius, y);
            this.ctx.lineTo(x2, y);
            this.ctx.stroke();
            this.ctx.ellipse(x, y, handleRadius, handleRadius, 0, Math.PI * 2, 0);
            this.ctx.stroke();
            if (ev.f) this.ctx.fill();
        };
        this.redrawVelocities = function() {
            const selectedEvents = [];
            // first, draw not selected events
            this.sequence.forEach((ev)=>{
                if (ev.f === 0) this.redrawVelocity(ev);
                else selectedEvents.push(ev);
            });
            // then, draw selected events
            selectedEvents.forEach((ev)=>this.redrawVelocity(ev));
        };
        this.redraw = function() {
            if (!this.ctx) return;
            // Force yoffset to be within the range of the keyboard
            const minyoffset = 0;
            const maxyoffset = 92;
            if (this.yoffset < minyoffset) this.yoffset = minyoffset;
            if (this.yoffset > maxyoffset) this.yoffset = maxyoffset;
            this.stepw = this.swidth / this.xrange;
            this.steph = this.sheight / this.yrange;
            this.displayPitchRange = [
                Math.floor(this.yoffset),
                Math.floor(this.yoffset + this.sheight / this.steph - 1)
            ];
            this.displayTimeRange = [
                Math.floor(this.xoffset),
                Math.floor(this.xoffset + this.swidth / this.stepw)
            ];
            this.ctx.clearRect(0, 0, this.width, this.height);
            this.redrawGridRows();
            this.redrawVelocityBg();
            this.redrawGridCols();
            this.redrawEvents();
            this.redrawKeyboard();
            this.redrawRulers();
            this.redrawVelocityRuler();
            this.redrawMarker();
            this.redrawAreaSel();
        };
        this.ready();
    }
    sendEvent(ev) {
        let event;
        event = document.createEvent("HTMLEvents");
        event.initEvent(ev, false, true);
        this.dispatchEvent(event);
    }
    getAttr(n, def) {
        let v = this.getAttribute(n);
        if (v == "" || v == null) return def;
        switch(typeof def){
            case "number":
                if (v == "true") return 1;
                v = +v;
                if (isNaN(v)) return 0;
                return v;
        }
        return v;
    }
    disconnectedCallback() {}
});




var $k5Mle = parcelRequire("k5Mle");
(0, $k5Mle.default).forEach((instrument)=>(0, $9xysn.registerInstrumentDisponible)(instrument));

})();
//# sourceMappingURL=index.js.map
